/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = {
  '/api/v1/identity-broker/ciba/device/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get CIBA device status
     * @description Returns whether the caller has an Auth0 Guardian push enrollment for 'Login with Heidi App'.
     */
    get: operations['get_device_status_api_v1_identity_broker_ciba_device_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/ciba/device/register': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Unregister CIBA device
     * @description Web disables 'Login with Heidi App' by deleting the caller's Guardian push authentication methods.
     */
    delete: operations['unregister_device_api_v1_identity_broker_ciba_device_register_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/ciba/device/enroll-ticket': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Guardian enrollment ticket
     * @description Return a Guardian enrollment ticket URL for the caller's own verified email, used to start Auth0-hosted QR enrollment.
     */
    post: operations['get_enrollment_ticket_api_v1_identity_broker_ciba_device_enroll_ticket_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/ciba/initiate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Initiate CIBA login
     * @description Resolve the requested email to an Auth0 user and start a CIBA login request. Auth0 owns Guardian push delivery; ml-scribe stores only the request metadata needed for completion polling.
     */
    post: operations['initiate_ciba_api_v1_identity_broker_ciba_initiate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/ciba/complete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Complete CIBA login
     * @description Poll Auth0 for the CIBA token response and return pending, slow_down, denied, expired, error, or token-bearing ok status to the frontend server.
     */
    post: operations['complete_ciba_api_v1_identity_broker_ciba_complete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/ciba/report': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Report an unrecognized CIBA login
     * @description Mobile calls this ('this wasn't me'), distinct from Deny, when the caller does not recognize a Guardian push. Feeds the same denial-streak counter as an Auth0-observed denial.
     */
    post: operations['report_ciba_api_v1_identity_broker_ciba_report_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/record-auth0-sign-in': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Track Auth0 Sign-In
     * @description Called by Auth0 post-login Action to track a successful sign-in event.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     */
    post: operations['track_sign_in_endpoint_api_v1_identity_broker_record_auth0_sign_in_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/save-identity-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Save Identity Profile
     * @description Save (create or update) an identity profile.
     *
     *         This endpoint implements an upsert pattern: if a profile exists for the given email,
     *         it updates the profile; otherwise, it creates a new one.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     *
     *         **Idempotency**: This endpoint is idempotent - sending the same request multiple times
     *         will produce the same result without creating duplicates.
     */
    post: operations['save_identity_profile_api_v1_identity_broker_save_identity_profile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/get-identity-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Identity Profile
     * @description Get an identity profile by email and region.
     *
     *         This endpoint retrieves an existing identity profile for the given email address.
     *         Used by IdP actions during login and signup flows to access authentication metadata.
     *
     *         If the profile exists but lacks a user_ref_id, this endpoint will attempt to fetch
     *         it from the regional ml-scribe server. If the regional server cannot provide the
     *         user_ref_id (user not found or server unavailable), the API will return an error.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     *
     *         **Note**: POST method is used to prevent email exposure in URLs and server logs.
     */
    post: operations['get_identity_profile_api_v1_identity_broker_get_identity_profile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/lookup-identity-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Lookup Identity Profile
     * @description Lookup an identity profile by one supported identifier.
     *
     *         **Current support**: user_ref_id only.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     */
    post: operations['lookup_identity_profile_api_v1_identity_broker_lookup_identity_profile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/bulk-lookup-identity-profiles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Bulk Lookup Identity Profiles */
    post: operations['bulk_lookup_identity_profiles_api_v1_identity_broker_bulk_lookup_identity_profiles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/get-connection-workspaces': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Connection Workspaces
     * @description Resolve the workspaces an SSO connection grants a user, given the user's IdP
     *         group IDs.
     *
     *         Called at login time by the Auth0 `set token claims` action, which turns the
     *         result into the `ent_workspaces` / `ent_only` access-token claims. The
     *         broker does the group matching and returns a flat list of workspace IDs, so
     *         the response is already claim-sized and the action needs no cache.
     *
     *         **Matching**: a linked workspace with an empty `group_ids` is open to every
     *         user on the connection; otherwise the user must hold at least one of its
     *         group IDs. `group_ids` may be omitted, in which case only unrestricted
     *         workspaces match.
     *
     *         An empty `workspaces` list means the connection grants this user nothing —
     *         either it has no linked workspaces yet (migration is manual) or none match
     *         the user's groups. An unknown connection is a 404.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     */
    post: operations['get_connection_workspaces_api_v1_identity_broker_get_connection_workspaces_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/finish-signup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Finish Signup
     * @description Finish user signup by saving region and syncing to Auth0.
     *
     *         This endpoint is called by regional ml-scribe servers after user get/create
     *         to save the user's region and sync it to Auth0 for migration preparation.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     *
     *         **Idempotency**: This endpoint is idempotent - multiple calls with the same data
     *         will produce the same result.
     */
    post: operations['finish_signup_api_v1_identity_broker_finish_signup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/sync-password-from-kinde-to-auth0': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Password from Kinde to Auth0
     * @description Sync password from Kinde to Auth0 for new user signup or password reset.
     *
     *         **For new_profile status**:
     *         - kinde_user_id and user_ref_id MUST be null
     *         - Creates new profile with generated user_ref_id
     *         - Creates Auth0 user with password
     *
     *         **For existing_profile status**:
     *         - kinde_user_id and user_ref_id are REQUIRED
     *         - Gets or creates profile with provided user_ref_id
     *         - Updates Auth0 password
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     *
     *         **Idempotency**: This endpoint is idempotent for profile creation. Password updates
     *         are re-attempted on duplicate requests.
     */
    post: operations['sync_password_from_kinde_to_auth0_api_v1_identity_broker_sync_password_from_kinde_to_auth0_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/delete-identity-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Identity Profile
     * @description Delete/retire identity profile mapping for a deleted user.
     *
     *         **Lookup keys**:
     *         - Accepts email or user_ref_id
     *         - If both are provided, user_ref_id takes priority
     *         - If both are provided and mismatch, request is rejected without changes
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     */
    post: operations['delete_identity_profile_api_v1_identity_broker_delete_identity_profile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/revoke-auth0-sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Revoke Auth0 Sessions
     * @description Revoke all Auth0 sessions and refresh tokens for a user identified by user_ref_id.
     *
     *         Used by regional ml-scribe to back the user-initiated "log out from all
     *         devices" flow. The Redis user-level blacklist (written by ml-scribe before
     *         calling this endpoint) handles in-flight access tokens; this endpoint
     *         handles Auth0-side session and refresh-token state so they cannot rotate
     *         into a new access token.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     */
    post: operations['revoke_auth0_sessions_api_v1_identity_broker_revoke_auth0_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/update-identity-profile-email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Update Identity Profile Email
     * @description Update the Auth0 user's email and the identity profile's email.
     *
     *         **Lookup**: By user_ref_id (preferred) or by current/old email when user_ref_id
     *         is not available. At least one of user_ref_id or email must be provided.
     *
     *         Used by regional ml-scribe (e.g. internal admin change-email flow) to keep
     *         Auth0 and the broker profile in sync when a user's email is changed.
     *         If the profile has no auth0_id, only the stored profile email is updated.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     */
    post: operations['update_identity_profile_email_api_v1_identity_broker_update_identity_profile_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/update-identity-profile-name': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Update Identity Profile Name
     * @description Update the identity profile's first_name / last_name and propagate the change to
     *         Kinde (when profile has kinde_id) and Auth0 (when profile has auth0_id).
     *
     *         **Lookup**: By user_ref_id (preferred), then kinde_user_id, then email. At least
     *         one lookup key must be provided.
     *
     *         **Name fields**: At least one of first_name / last_name must be provided. The
     *         other side is preserved on the broker profile and merged with existing values
     *         when pushing to Kinde (which requires both names).
     *
     *         **Partial failures**: ``kinde_synced`` and ``auth0_synced`` indicate per-IdP
     *         success so callers can decide whether to retry one side.
     *
     *         **Authentication**: Requires X-API-Key header with valid API key.
     */
    post: operations['update_identity_profile_name_api_v1_identity_broker_update_identity_profile_name_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/assign-apple-migration-ticket': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Assign Apple-Login Kinde→Auth0 Migration Ticket
     * @description Assign (or refresh) an Apple-login Kinde→Auth0 migration ticket for the
     *         calling user. Scoped to the Apple-social login migration only — non-Apple
     *         Kinde users and Auth0-authenticated callers get ``no_migration_needed``.
     *
     *         Used by the Apple-social login migration flow: the mobile client calls
     *         this endpoint while still holding a Kinde access token, then hands the
     *         returned ``ticket_id`` to the Auth0 migration handoff.
     *
     *         **Authentication**: Bearer token required (Kinde or Auth0). Auth0 callers
     *         are not blocked; they receive HTTP 200 with ``no_migration_needed`` so
     *         the client can poll this endpoint uniformly regardless of which provider
     *         issued the current access token.
     *
     *         **Response**:
     *         - ``status``: derived from the caller's persistent ``auth0_sync_state`` on
     *           ``IdentityProfile``. One of:
     *           - ``ticket_created`` — first ticket minted, or existing ticket refreshed
     *             while user is still in the "created" state. Hand ``ticket_id`` to the
     *             Auth0 redemption flow.
     *           - ``ticket_refreshed`` — original ticket expired in Redis and was
     *             re-minted (analytics signal: user needed more than one ticket). Same
     *             wire behaviour as ``ticket_created``.
     *           - ``already_migrated`` — user is already on Auth0; skip migration UI.
     *           - ``migration_in_progress`` — redemption started and Auth0 provisioning
     *             is in flight; FE should not request another ticket.
     *           - ``migration_failed`` — provisioning failed; needs manual intervention
     *             (FE should surface "contact support" rather than auto-retrying).
     *           - ``no_migration_needed`` — caller is outside the Apple-migration funnel
     *             (non-Kinde token, no profile, or non-Apple ``auth0_sync_state``).
     *         - ``ticket_id``: UUID v7. Present only for ``ticket_created`` and
     *           ``ticket_refreshed``; ``null`` for all other statuses.
     *
     *         **Idempotency**: Safe to retry. The persistent state on the user's
     *         ``IdentityProfile`` is updated by transitions (e.g. ``NEEDED`` →
     *         ``TICKET_CREATED``); repeat calls converge to the same response.
     */
    post: operations['assign_apple_migration_ticket_api_v1_identity_broker_assign_apple_migration_ticket_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/consume-apple-migration-ticket': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Consume Apple-Login Kinde→Auth0 Migration Ticket
     * @description Finalize an Apple-login Kinde→Auth0 migration. Called by the Auth0
     *         post-login Action with the ``ticket_id`` (issued by
     *         ``/assign-apple-migration-ticket``) and the freshly-provisioned
     *         ``auth0_id``.
     *
     *         The broker:
     *         1. Looks up the ticket in Redis to recover the pre-migration
     *            ``kinde_user_id``.
     *         2. Atomically ``DEL``s the ticket (race-winner gate — concurrent
     *            consumers detect a lost race via ``deleted_count == 0``).
     *         3. Writes ``auth0_id`` onto the user's ``IdentityProfile`` and sets
     *            ``auth0_sync_state = APPLE_MIGRATION_COMPLETED``.
     *         4. Returns the broker's reference ids (``kinde_user_id`` +
     *            ``user_ref_id``) so Auth0 can record them.
     *
     *         **Authentication**: X-API-Key header with the identity-broker M2M key.
     *
     *         **Idempotency**: Auth0 retries after a successful consume succeed
     *         (HTTP 200) iff the profile is already ``COMPLETED`` and the stored
     *         ``auth0_id`` matches. Mismatched ``auth0_id`` returns HTTP 409 to
     *         prevent the same ticket from being used to bind a different Auth0
     *         user to the profile.
     */
    post: operations['consume_apple_migration_ticket_api_v1_identity_broker_consume_apple_migration_ticket_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/connections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List SSO Connections
     * @description List all SSO connections from the Identity Broker database.
     */
    get: operations['list_connections_api_v1_identity_broker_internal_admin_connections_get'];
    put?: never;
    /**
     * Create SSO Connection
     * @description Create a new SSO connection with an Auth0 self-service setup ticket.
     */
    post: operations['create_connection_api_v1_identity_broker_internal_admin_connections_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/connections/{connection_name}/reissue-ticket': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Reissue Setup Ticket
     * @description Re-issue a setup ticket for a connection in SETUP state.
     */
    post: operations['reissue_ticket_api_v1_identity_broker_internal_admin_connections__connection_name__reissue_ticket_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/connections/{connection_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete SSO Connection
     * @description Delete an SSO connection. Disables in Auth0 first if enabled.
     */
    delete: operations['delete_connection_api_v1_identity_broker_internal_admin_connections__connection_name__delete'];
    options?: never;
    head?: never;
    /**
     * Update SSO Connection
     * @description Update an SSO connection's status or testing emails.
     */
    patch: operations['update_connection_api_v1_identity_broker_internal_admin_connections__connection_name__patch'];
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/connections/{connection_name}/secret-expiry': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Set SSO Secret Expiry
     * @description Record when the connection's IdP client secret expires, as an absolute date or a relative duration. Used to schedule rotation reminders/tickets.
     */
    patch: operations['set_secret_expiry_api_v1_identity_broker_internal_admin_connections__connection_name__secret_expiry_patch'];
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/connections/{connection_name}/secret-update-ticket': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Issue Secret Update Ticket
     * @description Issue a scoped Auth0 self-service ticket for client-secret rotation. Only valid for connections that are not in SETUP state. The ticket allows the customer to update only the client secret.
     */
    post: operations['issue_secret_update_ticket_api_v1_identity_broker_internal_admin_connections__connection_name__secret_update_ticket_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/users/lookup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Lookup user by single identifier
     * @description Resolve an Identity Profile by exactly one of user_ref_id, email, auth0_id, or kinde_user_id. Identifiers are accepted in the POST body so PII never appears in URL access logs.
     */
    post: operations['lookup_user_api_v1_identity_broker_internal_admin_users_lookup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/users/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get user identity profile
     * @description Return the full Identity Broker profile for the supplied user_ref_id.
     */
    get: operations['get_user_profile_api_v1_identity_broker_internal_admin_users__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/users/{user_ref_id}/auth0': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get user Auth0 diagnostic view
     * @description Return the live Auth0 view of the user — identities, blocked flag, enrolled MFA factors, app metadata.
     */
    get: operations['get_user_auth0_view_api_v1_identity_broker_internal_admin_users__user_ref_id__auth0_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/users/{user_ref_id}/kinde': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get user Kinde diagnostic view
     * @description Return the live Kinde view of the user — identities, properties, roles, organizations.
     */
    get: operations['get_user_kinde_view_api_v1_identity_broker_internal_admin_users__user_ref_id__kinde_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/users/{user_ref_id}/login-routing': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Diagnose user login routing
     * @description Explain how the user's next login attempt would route — vendor, matched SSO connection, reason, feature-flag values.
     */
    get: operations['get_user_login_routing_api_v1_identity_broker_internal_admin_users__user_ref_id__login_routing_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/users/{user_ref_id}/reset-mfa': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Reset Auth0 MFA
     * @description Delete all enrolled Auth0 MFA factors for a user identified by user_ref_id.
     */
    delete: operations['reset_auth0_mfa_api_v1_identity_broker_internal_admin_users__user_ref_id__reset_mfa_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/users/{user_ref_id}/login-brute-force-unblock': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Clear Auth0 Brute-Force Login Blocks
     * @description Clear all Auth0 brute-force login block records for a user identified by user_ref_id. Idempotent — succeeds even if the user has no active brute-force blocks.
     */
    post: operations['unblock_auth0_user_api_v1_identity_broker_internal_admin_users__user_ref_id__login_brute_force_unblock_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/internal-admin/users/{user_ref_id}/send-password-reset': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Password Reset
     * @description Trigger an Auth0 password-reset email for a user identified by user_ref_id. Auth0 emails the reset ticket directly to the user; the admin never sees or sets a password.
     */
    post: operations['send_password_reset_api_v1_identity_broker_internal_admin_users__user_ref_id__send_password_reset_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/auth-notifications/log-events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ingest a batch of Auth0 log-stream events
     * @description Auth0 HTTP log streams (JSON-array content format) POST batches of tenant log events here. The endpoint authenticates, evaluates the umbrella feature flag once, and — if on — schedules each entry for background dispatch (Auth0 Management API enrichment + regional ml-scribe fan-out). The response is sent before the background work runs, so per-entry outcomes are not in the body; they are emitted as structured log lines and counted in the ``auth_notification.dispatch`` OpenTelemetry counter (one tag per outcome). Returns HTTP 200 for every well-formed authenticated payload, regardless of per-entry outcome — fire-and-forget at the work layer so Auth0's HTTP log-stream timeout is not exceeded for large batches. Requires X-API-Key header for authentication.
     */
    post: operations['log_events_endpoint_api_v1_identity_broker_auth_notifications_log_events_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/auth-notifications/login-from-new-device': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ingest a web login for new-device detection
     * @description The scribe-fe-v2 web middleware POSTs one event per web login, carrying the authenticated ``auth0_user_id`` and the first-party ``device_id`` cookie. The broker resolves identity from its own IdentityProfile (no Auth0 Management API call), checks the device against the per-user known-device set, and — for a genuinely new device past the warm-up window — forwards to the regional ml-scribe deployment to send the confirmation email. Always returns HTTP 200 with the decision ``outcome``; the FE calls this fire-and-forget. Requires X-API-Key header for authentication.
     */
    post: operations['login_from_new_device_endpoint_api_v1_identity_broker_auth_notifications_login_from_new_device_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/identity-broker/determine-login': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Determine Login Vendor and Screen
     * @description Determine which identity provider and screen to route user to. used by db/sso email login only
     *
     *         This endpoint returns the vendor (kinde or auth0) that the user should be
     *         routed to for authentication, and a screen_hint (signin or signup) indicating
     *         whether to show the signin or signup UI.
     *
     *         **Authentication**: None required - this is a PUBLIC endpoint for frontend clients.
     *
     *         **Note**: POST method is used to prevent email exposure in URLs and server logs.
     */
    post: operations['determine_login_api_v1_identity_broker_determine_login_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/clinical-tasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Inbox Clinical Task
     * @description Materialize an inbox-linked clinical task as a real clinical
     *     task, linked to the originating message.
     *
     *     Inbox-service has already extracted and the user has already accepted the
     *     suggestion; this endpoint only persists it — no LLM calls here. Callers
     *     must send a required ``Idempotency-Key`` header (their suggestion row id
     *     is a natural choice) so a retried request with the same body never creates
     *     a duplicate, user-visible task. Reusing the same key with a different
     *     request body returns HTTP 422. Idempotency is best-effort: when Redis is
     *     unavailable, requests proceed without deduplication.
     */
    post: operations['create_inbox_clinical_task_api_internal_v1_ml_scribe_clinical_tasks_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/notifications/session-expiring': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Session Expiring Notification
     * @description Trigger push notifications for sessions that are about to expire. Used by inter-service callers.
     */
    post: operations['send_session_expiring_notification_api_internal_v1_ml_scribe_notifications_session_expiring_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/notifications/patient-expiring': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Patient Expiring Notification
     * @description Trigger push notifications for patients about to be deleted by the
     *     retention sweeper. ``expiring_patients`` maps kinde_user_id to the
     *     patient_profile_ids about to expire; names are resolved server-side.
     *     Used by the etl-airflow patient-deletion DAG.
     */
    post: operations['send_patient_expiring_notification_api_internal_v1_ml_scribe_notifications_patient_expiring_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/patient-profiles/bulk-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Delete Patient Profiles
     * @description Unlink linked sessions from each patient profile, then soft-delete the
     *     profile (cascading patient documents) for the given owning user.
     *
     *     Used by the etl-airflow patient retention DAG: Airflow decides *which*
     *     patients are expired (clock math) and calls this to do the actual
     *     unlink + delete, so the PHI-deletion logic lives in one place (the same
     *     ``delete_patient_profile_by_id`` the attended delete path uses) rather
     *     than being re-implemented in Airflow.
     *
     *     Always unlinks, never cascade-deletes sessions: sessions are clinical
     *     records kept independently of patient retention.
     */
    post: operations['bulk_delete_patient_profiles_api_internal_v1_ml_scribe_patient_profiles_bulk_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/patient-profiles/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Search Team Patient Profiles
     * @description Deterministically match extracted demographics against a team's patient
     *     roster, returning the strong match (or, when none is confident, a narrowed
     *     candidate shortlist for the caller's fuzzy/LLM match).
     *
     *     Generic and region-agnostic: matching runs over the demographics the caller
     *     supplies (name, date of birth, email, phone) against the demographics stored
     *     on the roster. Additional callers are onboarded by widening the auth gate,
     *     not by changing this handler.
     *
     *     Optional EHR handoff: when ``active_provider`` is supplied, a confident
     *     ``match`` is enriched with that profile's live-EHR link (``ehr_link``: the
     *     EHR-native patient id to push against) so the caller skips a separate live
     *     lookup. Only the confident match is enriched, never the ``candidates``
     *     shortlist; omitting ``active_provider`` yields the pure generic matcher
     *     output.
     *
     *     Optional exact-lookup mode: when ``patient_profile_id`` is supplied,
     *     identity is not in question (the caller already knows which profile this
     *     is — e.g. a clinician's manual re-link) so the roster-wide fuzzy match is
     *     skipped. Instead that single profile is fetched (still scoped to the
     *     team's roster and ``workspace_id`` — a cross-team id is rejected the same
     *     way as a cross-workspace ``team_id``, with ``404``) and verified against
     *     ``demographics``, returned as ``match`` with ``matched_fields`` /
     *     ``conflicting_fields`` populated from the comparison. ``ehr_link``
     *     enrichment is unaffected: still gated on ``active_provider`` and a live
     *     link exactly as on the fuzzy path.
     *
     *     Tenant safety: ``workspace_id`` is mandatory and validated against the team's
     *     resolved workspace (``403`` on mismatch) so a caller can never read another
     *     tenant's roster — important because inter-service traffic carries no end-user
     *     context and therefore bypasses the automatic workspace read-scoping.
     */
    post: operations['search_team_patient_profiles_api_internal_v1_ml_scribe_patient_profiles_search_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/comms-sessions/delete-expired-for-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Expired Comms Sessions For User Endpoint
     * @description Drain expired comms sessions for one user via bounded upstream batches.
     *
     *     ml-scribe loops receptionist-be until upstream ``has_more`` is false and
     *     deletes only local rows whose ``call_reference_id`` appeared in an upstream
     *     batch. ``has_more`` in the response is true when upstream work remains
     *     after a per-request batch cap, a poison upstream batch, or an upstream
     *     purge failure mid-loop — Airflow retries on the next per-user iteration.
     */
    post: operations['delete_expired_comms_sessions_for_user_endpoint_api_internal_v1_ml_scribe_comms_sessions_delete_expired_for_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/permissions/session-permissions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Session Permissions
     * @description Check if a user has access to a specific session
     */
    post: operations['session_permissions_api_internal_v1_ml_scribe_permissions_session_permissions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/apollo/repeat-scripts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Repeat Scripts Review */
    post: operations['create_repeat_scripts_review_api_internal_v1_ml_scribe_apollo_repeat_scripts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/apollo/harness/advance': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Advance Harness
     * @description Advance one patient turn and stream this turn's frames back as SSE.
     *
     *     Auth: ``ScribeOrCommsUserIdDep`` (comms JWT ``sub`` is the trusted
     *     subject). ``body.user_id`` must match the JWT ``sub`` — a mismatch is a
     *     non-retryable 400 (defence-in-depth; the JWT ``sub`` remains authoritative).
     *
     *     The stream closes at this turn's terminal: a ``turn_completed`` event for
     *     the run's latest turn once it has settled, or a terminal/missing run status
     *     (``closed`` / ``failed``) — see :func:`iter_run_llm_stream_frames`. A missing
     *     or failed run breaks the loop (the comms relay surfaces a safe retry
     *     message), it does not tail forever.
     */
    post: operations['advance_harness_api_internal_v1_ml_scribe_apollo_harness_advance_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/sessions/bulk-deleted-event': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Dispatch Sessions Bulk Deleted Event
     * @description Emit the sessions-bulk-deleted domain event for already-soft-deleted sessions.
     *
     *     Used by Airflow after it has soft-deleted the sessions out-of-band. The
     *     handler loads the soft-deleted ``Session`` snapshots and dispatches
     *     ``SessionsBulkDeletedEventPayload`` so downstream handlers (e.g. FGA
     *     cleanup) run after the response is sent.
     */
    post: operations['dispatch_sessions_bulk_deleted_event_api_internal_v1_ml_scribe_sessions_bulk_deleted_event_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/sessions/{session_id}/session-merge/merge-group': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Merge Group
     * @description Return primary and merge-group session ids for inter-service transcript aggregation.
     */
    get: operations['get_session_merge_group_api_internal_v1_ml_scribe_sessions__session_id__session_merge_merge_group_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/sessions/bulk-transcript-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Delete Session Transcripts
     * @description Purge each session's transcript via the retention path, tallying outcomes.
     *
     *     A machine caller with no end-user context, so it delegates to the same
     *     `delete_session_transcript` the user-facing route uses rather than the
     *     owner-authz'd route. Idempotent per session; the response tallies each outcome:
     *     `deleted_count`, `skipped_count` (already purged), `not_found_count`,
     *     `not_enabled_count` (owner outside the `release_transcript_deletion` cohort),
     *     and `failed_count` (unresolvable owner). Infrastructure failures propagate
     *     rather than being tallied, so the caller retries.
     */
    post: operations['bulk_delete_session_transcripts_api_internal_v1_ml_scribe_sessions_bulk_transcript_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/teams/{team_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Members
     * @description Return all joined members of a team. Used by inter-service callers (e.g. etl-airflow).
     */
    get: operations['get_team_members_api_internal_v1_ml_scribe_teams__team_id__members_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/teams/{team_id}/workspace': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Workspace Id
     * @description Resolve the workspace that owns ``team_id`` (authoritative team->workspace pointer).
     *
     *     Thin HTTP translation over ``TeamService.get_team_workspace_id_or_raise``,
     *     which owns the resolution and the broken-hierarchy guard — see its
     *     docstring for the full contract.
     *
     *     Access is currently restricted to the inbox-service inter-service token via the
     *     route's auth gate; additional consumers are onboarded by widening that gate, not
     *     by changing this handler.
     */
    get: operations['get_team_workspace_id_api_internal_v1_ml_scribe_teams__team_id__workspace_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/teams/{team_id}/notifications': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Notify Team
     * @description Fan a single team-level event out as per-member notifications.
     *
     *     Called by inbox-service on a new inbox message. Thin HTTP translation over
     *     ``TeamService.notify_team_members``, which owns the tenant check,
     *     idempotency, and member fan-out — see its docstring for the full contract.
     *     The message→team binding itself is enforced caller-side (inbox-service
     *     owns the messages).
     */
    post: operations['notify_team_api_internal_v1_ml_scribe_teams__team_id__notifications_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/usage-events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Ingest Usage Event */
    post: operations['ingest_usage_event_api_internal_v1_ml_scribe_usage_events_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/users/{kinde_user_id}/session-storage-days': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Session Storage Days
     * @description Return the effective session storage days for a user after applying any
     *     team-level retention override. Returns null when the user's retention is
     *     managed by their team (the team-level deletion job handles those users).
     *     Used by inter-service callers (e.g. etl-airflow).
     */
    get: operations['get_user_session_storage_days_api_internal_v1_ml_scribe_users__kinde_user_id__session_storage_days_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/users/{kinde_user_id}/patient-storage-days': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Patient Storage Days
     * @description Return the effective patient retention days for a user after applying any
     *     team-level override. Returns null when retention is disabled or managed by
     *     the user's team (the team-level job handles those). Mirrors
     *     session-storage-days; used by the etl-airflow patient retention DAG.
     */
    get: operations['get_user_patient_storage_days_api_internal_v1_ml_scribe_users__kinde_user_id__patient_storage_days_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/users/{kinde_user_id}/transcript-storage-days': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Transcript Storage Days
     * @description Return the effective transcript retention days for a user after applying any
     *     team-level override. Returns null when retention is disabled or managed by
     *     the user's team (the team-level job handles those). Mirrors
     *     session-storage-days; used by the etl-airflow transcript retention DAG.
     */
    get: operations['get_user_transcript_storage_days_api_internal_v1_ml_scribe_users__kinde_user_id__transcript_storage_days_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/internal/v1/ml-scribe/coding/extractions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Extract Clinical Codes
     * @description Stateless clinical coding extraction for document text.
     *
     *     SNOMED inference runs in-process (not Temporal/SCC). Callers must send a
     *     required ``Idempotency-Key`` header (opaque, caller-defined). ml-scribe owns
     *     per-document timeout, concurrency limits, and idempotency; retry on 5xx only.
     */
    post: operations['extract_clinical_codes_api_internal_v1_ml_scribe_coding_extractions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/form-files/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Files By User
     * @description get all form files by user
     */
    get: operations['get_files_by_user_api_v1_ml_scribe_form_files__get'];
    put?: never;
    /**
     * Upload Files
     * @description upload files
     */
    post: operations['upload_files_api_v1_ml_scribe_form_files__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/form-files/{file_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get File By Id
     * @description get form file by id
     */
    get: operations['get_file_by_id_api_v1_ml_scribe_form_files__file_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete File By Id
     * @description delete file by id
     */
    delete: operations['delete_file_by_id_api_v1_ml_scribe_form_files__file_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/hardware-device/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Devices
     * @description List devices for the current user.
     */
    get: operations['list_devices_api_v1_ml_scribe_hardware_device__get'];
    put?: never;
    /**
     * Link Device
     * @description Link a device to the current user.
     */
    post: operations['link_device_api_v1_ml_scribe_hardware_device__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/hardware-device/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Device
     * @description Get the given device.
     */
    get: operations['get_device_api_v1_ml_scribe_hardware_device__id__get'];
    put?: never;
    post?: never;
    /**
     * Unlink Device
     * @description Unlink the given device from the current user.
     */
    delete: operations['unlink_device_api_v1_ml_scribe_hardware_device__id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Device
     * @description Update the given device for the current user.
     */
    patch: operations['update_device_api_v1_ml_scribe_hardware_device__id__patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/openfeature': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Openfeature */
    get: operations['openfeature_api_v1_ml_scribe_openfeature_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/healthcheck': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Healthcheck */
    get: operations['healthcheck_api_v1_ml_scribe_healthcheck_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/auth-test/token-claims': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Auth Token Claims
     * @description Test endpoint to verify token claim extraction.
     *
     *     This endpoint extracts both user_ref_id and kinde_id from the auth token
     *     to verify the TokenInfoFromAuthTokenDep dependency works correctly.
     */
    get: operations['get_auth_token_claims_api_v1_ml_scribe_auth_test_token_claims_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/language/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Language List
     * @description Get Language List
     */
    get: operations['get_language_list_api_v1_ml_scribe_language__get'];
    put?: never;
    /**
     * New Language Creation
     * @description Create a new Language
     */
    post: operations['new_language_creation_api_v1_ml_scribe_language__post'];
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Language
     * @description Update Language
     */
    patch: operations['update_language_api_v1_ml_scribe_language__patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/language/default': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Default Language
     * @description Update Deafult Language
     */
    patch: operations['update_default_language_api_v1_ml_scribe_language_default_patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/language/batch/prompt-configuration': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Specialty Language Prompt Configuration
     * @description update language prompt configuration for all specialties
     */
    patch: operations['update_specialty_language_prompt_configuration_api_v1_ml_scribe_language_batch_prompt_configuration_patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/language/supported-languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Supported Languages
     * @description Get available Languages for the session
     */
    get: operations['get_supported_languages_api_v1_ml_scribe_language_supported_languages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/language/supported-output-languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Supported Output Languages
     * @description Get languages allowed for output / note language. Same catalogue as /supported-languages minus languages not supported for note generation. Use this for output pickers.
     */
    get: operations['get_supported_output_languages_api_v1_ml_scribe_language_supported_output_languages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/language/supported-input-languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Supported Input Languages
     * @description Get languages allowed for session input / transcription. Honours enterprise force-* restrictions (e.g. force-en-only) and the UK/EU validated-language gate. Use this for input pickers; keep /supported-languages for output / note language.
     */
    get: operations['get_supported_input_languages_api_v1_ml_scribe_language_supported_input_languages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/onboarding-options': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Onboarding Options
     * @description get onboarding options (specialties and EHR providers)
     */
    get: operations['get_onboarding_options_api_v1_ml_scribe_onboarding_options_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/document/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Document By Id
     * @description get document by id
     */
    get: operations['get_document_by_id_api_v1_ml_scribe_sessions__session_id__document__document_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Document
     * @description delete document
     */
    delete: operations['delete_document_api_v1_ml_scribe_sessions__session_id__document__document_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Document
     * @description update document
     */
    patch: operations['update_document_api_v1_ml_scribe_sessions__session_id__document__document_id__patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/document/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Documents
     * @description get all documents for session
     */
    get: operations['get_documents_api_v1_ml_scribe_sessions__session_id__document__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/document/create': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Document
     * @deprecated
     * @description create an empty document
     */
    post: operations['create_document_api_v1_ml_scribe_sessions__session_id__document_create_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/document/empty': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Document
     * @deprecated
     * @description create an empty document
     */
    post: operations['create_document_api_v1_ml_scribe_sessions__session_id__document_empty_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/document/{document_id}/generate-insights': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Extract Personalization Insights From Document
     * @description extract personalization insights from document
     */
    post: operations['extract_personalization_insights_from_document_api_v1_ml_scribe_sessions__session_id__document__document_id__generate_insights_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Sessions
     * @deprecated
     * @description get all sessions
     */
    get: operations['get_sessions_api_v1_ml_scribe_sessions__get'];
    put?: never;
    /**
     * Create Session
     * @description create a new session
     */
    post: operations['create_session_api_v1_ml_scribe_sessions__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session By Id
     * @description get session by id
     */
    get: operations['get_session_by_id_api_v1_ml_scribe_sessions__session_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Session
     * @description delete session by id
     */
    delete: operations['delete_session_api_v1_ml_scribe_sessions__session_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Session
     * @description update session details by id
     */
    patch: operations['update_session_api_v1_ml_scribe_sessions__session_id__patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Batch Delete Sessions
     * @description delete sessions by list of IDs
     */
    delete: operations['batch_delete_sessions_api_v1_ml_scribe_sessions_batch_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/transcript': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Submit Transcript */
    post: operations['submit_transcript_api_v1_ml_scribe_sessions__session_id__transcript_post'];
    /**
     * Delete Session Transcript
     * @description delete a session's transcript from both stores
     */
    delete: operations['delete_session_transcript_api_v1_ml_scribe_sessions__session_id__transcript_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/share-consult-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Share Consult Note */
    post: operations['share_consult_note_api_v1_ml_scribe_sessions__session_id__share_consult_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/upload-audio': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Audio
     * @description API for user to upload audio file for transcription
     */
    post: operations['upload_audio_api_v1_ml_scribe_sessions__session_id__upload_audio_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/{session_id}/supported-languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Supported Languages
     * @description Get available Languages for the session
     */
    get: operations['get_supported_languages_api_v1_ml_scribe_sessions__session_id__supported_languages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/sessions/test-duration': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Test Get Audio Duration Prod */
    post: operations['test_get_audio_duration_prod_api_v1_ml_scribe_sessions_test_duration_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialties
     * @description get specialties
     */
    get: operations['get_specialties_api_v1_ml_scribe_specialties_get'];
    put?: never;
    /**
     * Create New Specialty
     * @description create new specialty
     */
    post: operations['create_new_specialty_api_v1_ml_scribe_specialties_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties/{specialty_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialty
     * @description get specialty by id
     */
    get: operations['get_specialty_api_v1_ml_scribe_specialties__specialty_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Specialty By Id
     * @description update specialty by id
     */
    patch: operations['update_specialty_by_id_api_v1_ml_scribe_specialties__specialty_id__patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties/batch-update': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Batch Update Specialty
     * @description batch update specialties
     */
    patch: operations['batch_update_specialty_api_v1_ml_scribe_specialties_batch_update_patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties/{specialty_id}/supported-languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Supported Languages
     * @description get specialty supported languages by id
     */
    get: operations['get_supported_languages_api_v1_ml_scribe_specialties__specialty_id__supported_languages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties/{specialty_id}/prompt-configuration': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialty Prompt Configuration
     * @description get prompt configuration
     */
    get: operations['get_specialty_prompt_configuration_api_v1_ml_scribe_specialties__specialty_id__prompt_configuration_get'];
    put?: never;
    /**
     * Create Specialty Prompt Configuration
     * @description create specialty language
     */
    post: operations['create_specialty_prompt_configuration_api_v1_ml_scribe_specialties__specialty_id__prompt_configuration_post'];
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Specialty Prompt Configuration
     * @description update prompt configuration
     */
    patch: operations['update_specialty_prompt_configuration_api_v1_ml_scribe_specialties__specialty_id__prompt_configuration_patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties/{specialty_id}/onboarding-script': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Onboarding Script
     * @description get onboarding script
     */
    get: operations['onboarding_script_api_v1_ml_scribe_specialties__specialty_id__onboarding_script_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties/{specialty_id}/note-structure-options': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Note Structure Options
     * @description get specialty supported languages by id
     */
    get: operations['get_note_structure_options_api_v1_ml_scribe_specialties__specialty_id__note_structure_options_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties/transcript-by-name/{specialty_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Transcript By Specialty Name
     * @description get example transcript by specialty name
     */
    get: operations['get_transcript_by_specialty_name_api_v1_ml_scribe_specialties_transcript_by_name__specialty_name__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialties/{specialty_name}/onboarding-v2-assets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Onboarding V2 Assets
     * @description Onboarding v2 specialty assets (transcript, note, abbreviations, three evidence queries/responses, three documents). Resolves canonical FE/Mongo specialty names through an alias map; falls back to default content for specialties with no per-specialty file. For non-English locales the first evidence/document entry is localized and the two additional entries fall back to English until translated.
     */
    get: operations['get_onboarding_v2_assets_api_v1_ml_scribe_specialties__specialty_name__onboarding_v2_assets_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialty-groups': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialty Groups
     * @description Get all specialty groups
     */
    get: operations['get_specialty_groups_api_v1_ml_scribe_specialty_groups_get'];
    put?: never;
    /**
     * Create Specialty Group
     * @description Create new specialty group
     */
    post: operations['create_specialty_group_api_v1_ml_scribe_specialty_groups_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialty-groups/{group_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialty Group
     * @description Get specialty group by name
     */
    get: operations['get_specialty_group_api_v1_ml_scribe_specialty_groups__group_name__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialty-groups/{group_name}/specialties/{specialty_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Specialty To Group
     * @description Add specialty to group
     */
    post: operations['add_specialty_to_group_api_v1_ml_scribe_specialty_groups__group_name__specialties__specialty_id__post'];
    /**
     * Remove Specialty From Group
     * @description Remove specialty from group
     */
    delete: operations['remove_specialty_from_group_api_v1_ml_scribe_specialty_groups__group_name__specialties__specialty_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/specialty-groups/{group_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Update Specialty Group
     * @description Update specialty group
     */
    put: operations['update_specialty_group_api_v1_ml_scribe_specialty_groups__group_id__put'];
    post?: never;
    /**
     * Delete Specialty Group
     * @description Delete specialty group
     */
    delete: operations['delete_specialty_group_api_v1_ml_scribe_specialty_groups__group_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/user/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Or Create User
     * @description get or create user
     */
    get: operations['get_or_create_user_api_v1_ml_scribe_user__get'];
    put?: never;
    post?: never;
    /**
     * Delete User
     * @description delete user
     */
    delete: operations['delete_user_api_v1_ml_scribe_user__delete'];
    options?: never;
    head?: never;
    /**
     * Update User Attributes
     * @description update user attributes
     */
    patch: operations['update_user_attributes_api_v1_ml_scribe_user__patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/user/patient-summary-turn-off-prompt:record-dismissal': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record Patient Summary Dismissal
     * @description Atomically record one dismissal of the queued patient summary for the current user, keyed by session_id. Race-safe: the increment is a single conditional update, so concurrent dismissals (multiple tabs/devices) cannot lose a count. No-op when the prompt has already been answered (seen) or on a same-session retry. Returns the resulting tracking state plus should_prompt (dismissal_count >= threshold and not seen).
     */
    post: operations['record_patient_summary_dismissal_api_v1_ml_scribe_user_patient_summary_turn_off_prompt_record_dismissal_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/user/extend-unlimit-quota': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Extend User Unlimited Quota Until Time */
    post: operations['extend_user_unlimited_quota_until_time_api_v1_ml_scribe_user_extend_unlimit_quota_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/user/billing-portal': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Billing Portal Url
     * @description stripe billing portal
     */
    get: operations['get_billing_portal_url_api_v1_ml_scribe_user_billing_portal_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/user/logout': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Logout User
     * @description logout user and revoke token
     */
    post: operations['logout_user_api_v1_ml_scribe_user_logout_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/user/name': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Name
     * @description update user's name
     */
    patch: operations['update_name_api_v1_ml_scribe_user_name_patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/user/submit-integration-request': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Integration
     * @deprecated
     * @description submit integration request
     */
    post: operations['submit_integration_api_v1_ml_scribe_user_submit_integration_request_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/user/kinde-properties': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Idp Properties
     * @description Get user identity-provider properties in legacy kinde-properties format. When the release-auth0-migration-enforce-blocking flag is off for the user, this endpoint returns Kinde properties and asynchronously shadow-checks Identity Broker. When enabled, Identity Broker is the primary source with a graceful Kinde fallback; the response is then merged with token-info-derived properties so callers always receive a usable region claim when one is available from any source.
     */
    get: operations['get_idp_properties_api_v1_ml_scribe_user_kinde_properties_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/user/kinde-properties/region': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Kinde User Region
     * @description update user region
     */
    patch: operations['update_kinde_user_region_api_v1_ml_scribe_user_kinde_properties_region_patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/user/register-device': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Register Device
     * @description register device token for push notification
     */
    post: operations['register_device_api_v1_ml_scribe_user_register_device_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/user/onboarding-tasks/{onboarding_task}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Mark Onboarding Task As Completed
     * @description mark an onboarding task as completed
     */
    patch: operations['mark_onboarding_task_as_completed_api_v1_ml_scribe_user_onboarding_tasks__onboarding_task__patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/user/onboarding-subtasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Set Current Onboarding Sub Task
     * @description set current onboarding sub task
     */
    patch: operations['set_current_onboarding_sub_task_api_v1_ml_scribe_user_onboarding_subtasks_patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/user/profile-picture': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Profile Picture
     * @description Upload a profile picture
     */
    post: operations['upload_profile_picture_api_v1_ml_scribe_user_profile_picture_post'];
    /**
     * Remove Profile Picture
     * @description Remove user's profile picture
     */
    delete: operations['remove_profile_picture_api_v1_ml_scribe_user_profile_picture_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/stripe-webhook/all-events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Handle All Events
     * @description Unified Stripe webhook endpoint that handles all event types
     */
    post: operations['handle_all_events_api_v1_ml_scribe_stripe_webhook_all_events_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal/auth-notifications/password-changed': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Receive a forwarded password-changed event
     * @description Records the auth-notification audit timestamp on the User document and invokes the password-changed email send. Consumed by the identity-broker auth-notification dispatcher after Auth0 Management API enrichment. Requires X-API-Key header for authentication.
     */
    post: operations['password_changed_api_v1_ml_scribe_internal_auth_notifications_password_changed_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal/auth-notifications/mfa-enrolled': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Receive a forwarded MFA-enrolled event
     * @description Records the MFA-enrolled audit timestamp on the User document and invokes the MFA-enrolment confirmation email send. Consumed by the identity-broker auth-notification dispatcher after Auth0 Management API enrichment. Gated by the same umbrella feature flag as ``/password-changed``. Requires X-API-Key header for authentication.
     */
    post: operations['mfa_enrolled_api_v1_ml_scribe_internal_auth_notifications_mfa_enrolled_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal/auth-notifications/mfa-unenrolled': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Receive a forwarded MFA-unenrol event
     * @description Records the MFA-unenrol audit timestamp on the User document and invokes the MFA-unenrol confirmation email send. Consumed by the identity-broker auth-notification dispatcher after Auth0 Management API enrichment. Gated by the same umbrella feature flag as ``/password-changed`` and ``/mfa-enrolled``. Requires X-API-Key header for authentication.
     */
    post: operations['mfa_unenrolled_api_v1_ml_scribe_internal_auth_notifications_mfa_unenrolled_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal/auth-notifications/login-from-new-device': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Receive a forwarded login-from-new-device event
     * @description Records the login-from-new-device audit timestamp on the User document and invokes the new-device confirmation email send. Consumed by the identity-broker, which has already decided the login is from a device not previously seen for this user. Gated by the same umbrella feature flag as the sibling auth-notification endpoints. Requires X-API-Key header for authentication.
     */
    post: operations['login_from_new_device_api_v1_ml_scribe_internal_auth_notifications_login_from_new_device_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal/get-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get user by email
     * @description Retrieve user data by email for Identity Broker. Returns user_ref_id and email if found, or null if not found. Requires X-API-Key header for authentication.
     */
    post: operations['get_user_api_v1_ml_scribe_internal_get_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal/rebind-user-email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Rebind a user's email (broker-driven, MUL-2559)
     * @description Apply a broker-driven user-email rebind. Called by identity broker after it has rebound IdentityProfile.email (e.g. post-Apple-migration on the Auth0 side). Idempotent: same email returns status='unchanged'. Requires X-API-Key.
     */
    post: operations['rebind_user_email_api_v1_ml_scribe_internal_rebind_user_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal/get-user-mfa-config': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get user MFA configuration by user_ref_id
     * @description Retrieve user MFA configuration by user_ref_id for Identity Broker. Returns MFA configuration if found, or null if not found. Requires X-API-Key header for authentication.
     */
    post: operations['get_user_mfa_config_api_v1_ml_scribe_internal_get_user_mfa_config_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Details
     * @description get user
     */
    get: operations['get_user_details_api_v1_ml_scribe_internal_admin_user_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create New User
     * @description create user
     */
    post: operations['create_new_user_api_v1_ml_scribe_internal_admin_users_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/users/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User By Kinde User Id
     * @description get or create user by kinde id
     */
    get: operations['get_user_by_kinde_user_id_api_v1_ml_scribe_internal_admin_users__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update User Details
     * @description update user details
     */
    patch: operations['update_user_details_api_v1_ml_scribe_internal_admin_users__user_ref_id__patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/users/{user_ref_id}/is_subscribed': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Is Subscribed Status
     * @description get user is_subscribed status
     */
    get: operations['get_user_is_subscribed_status_api_v1_ml_scribe_internal_admin_users__user_ref_id__is_subscribed_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/users/{user_ref_id}/change-email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Change User Email
     * @description change user email
     */
    post: operations['change_user_email_api_v1_ml_scribe_internal_admin_users__user_ref_id__change_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Sessions */
    get: operations['get_sessions_api_v1_ml_scribe_internal_admin_sessions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Session By Id */
    get: operations['get_session_by_id_api_v1_ml_scribe_internal_admin_sessions__session_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/users/{user_ref_id}/llm-call-records/by-task': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Llm Call Records By Task */
    get: operations['get_llm_call_records_by_task_api_v1_ml_scribe_internal_admin_users__user_ref_id__llm_call_records_by_task_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/sessions/{session_id}/transcript': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Session Get Transcript */
    get: operations['session_get_transcript_api_v1_ml_scribe_internal_admin_sessions__session_id__transcript_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/sessions/{session_id}/generate-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Session Gen Notes */
    post: operations['session_gen_notes_api_v1_ml_scribe_internal_admin_sessions__session_id__generate_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/session-records': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Records
     * @deprecated
     */
    get: operations['get_session_records_api_v1_ml_scribe_internal_admin_session_records_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/prompts/{prompt_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Prompt By Prompt Id
     * @description get prompt by prompt id
     */
    get: operations['get_prompt_by_prompt_id_api_v1_ml_scribe_internal_admin_prompts__prompt_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/prompt/{prompt_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Prompt By Prompt Id
     * @deprecated
     * @description get prompt by prompt id
     */
    get: operations['get_prompt_by_prompt_id_api_v1_ml_scribe_internal_admin_prompt__prompt_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/prompts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Reload Prompts
     * @description when the server starts, it will auto load prompts into cache from prompteams
     *     any newly added prompts won't be in cache
     *     this function helps to reload all prompts into cache again
     *     if release-exp-prompts is enabled for the admin calling this function, experimental prompts will also be refreshed
     */
    patch: operations['reload_prompts_api_v1_ml_scribe_internal_admin_prompts_patch'];
    trace?: never;
  };
  '/api/v1/ml-scribe/internal-admin/session-events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Events
     * @description Get session events - super admin only endpoint
     *     Returns documents from SessionEvent collection filtered by session_id and sorted by timestamp
     */
    get: operations['get_session_events_api_v1_ml_scribe_internal_admin_session_events_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/admins/roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Roles
     * @description Get roles for internal admin user from token. Use to validate if user is internal admin to access pages without calling specific API's and provide indicator whether they are admin or super admin
     */
    get: operations['get_roles_api_v2_ml_scribe_internal_admin_admins_roles_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-maker/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start Agent Maker Run
     * @description Start a maker run as the IA operator.
     *
     *     Both the run owner and tool execution identity are the IA uid. The maker
     *     does not act on behalf of a Scribe/Kinde subject; tools that require a
     *     Scribe identity should not be bound to this config.
     */
    post: operations['start_agent_maker_run_api_v2_ml_scribe_internal_admin_agent_maker_runs_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-maker/runs/{agent_run_id}/suggested-questions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate LLM follow-up suggestions for the latest AMA reply
     * @description Suggest contextual follow-up questions for the latest AMA reply.
     *
     *     Reuses the Evidence chat's ``generate_follow_up_questions`` (Gemini
     *     2.5 Flash) with ``AMA_FOLLOW_UP_SYSTEM_PROMPT``. The last user turn
     *     and last assistant turn are derived server-side from the durable
     *     harness transcript — the client never supplies conversation content.
     *     Returns an empty list (not an error) when there's nothing to build
     *     on yet or generation soft-fails, so the FE can simply render nothing.
     */
    post: operations['get_ama_suggested_questions_api_v2_ml_scribe_internal_admin_agent_maker_runs__agent_run_id__suggested_questions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/self:resolve-subject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Resolve Self Subject
     * @description Resolve the calling IA actor's email to matching Scribe Kinde ids.
     *
     *     Returns every Scribe ``User`` whose ``email`` matches the actor's
     *     ``internaladmin|<email>`` uid (case-insensitive exact). The list may
     *     be empty (no linked Scribe account) or contain multiple ids
     *     (ambiguous email — caller picks one as ``subject_user_id`` for
     *     ``POST /runs``). Errors (only ``unparseable_actor_uid``) surface as
     *     HTTP 403 from the dependency wrapper.
     */
    get: operations['resolve_self_subject_api_v2_ml_scribe_internal_admin_agent_harness_self_resolve_subject_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Runs
     * @description List all runs across all admins, newest first.
     *
     *     By default, runs whose originating saved config has been deleted
     *     are hidden. Pass ``include_orphaned=true`` to also see those runs.
     *     Inline-config runs (no ``source_config_id``) are always returned.
     *
     *     Uses the snapshot-free ``list_run_summaries`` projection so the Mongo
     *     ``$facet`` page stays under the 16MB BSON limit (full embedded
     *     ``agent_config_snapshot`` blobs are not loaded). Detail endpoints
     *     still return the full snapshot.
     */
    get: operations['list_runs_api_v2_ml_scribe_internal_admin_agent_harness_runs_get'];
    put?: never;
    /** Start Run */
    post: operations['start_run_api_v2_ml_scribe_internal_admin_agent_harness_runs_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}/turns': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Submit Turn */
    post: operations['submit_turn_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__turns_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}/attachments/{attachment_id}/download-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Attachment Download Url
     * @description Return a presigned URL for a run attachment.
     *
     *     Shared-read: any authenticated internal admin may fetch attachments
     *     referenced by a run visible via ``GET /runs/{agent_run_id}`` and
     *     ``GET /runs/{agent_run_id}/conversation``.
     *
     *     Tool/screenshot attachments produced by a sub-agent are persisted under
     *     the sub-agent's run id but referenced in the parent transcript, so the
     *     owner run id is resolved from the run's transcript before signing rather
     *     than assuming the requested run owns the record. Cross-run resolution is
     *     bounded to the requested run's subject.
     */
    get: operations['get_attachment_download_url_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__attachments__attachment_id__download_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}/stream': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Internal Admin Agent Harness Run Scoped Stream
     * @description Tail the run-scoped LLM/tool stream.
     *
     *     Redis is only the live event buffer; Mongo remains the canonical
     *     transcript. Every turn in a run appends to the same Redis stream key
     *     (``stream_id == agent_run_id``), so FE never has to switch streams
     *     between turns.
     */
    get: operations['internal_admin_agent_harness_run_scoped_stream_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__stream_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Internal Admin Agent Harness User Events
     * @description Tail the authenticated internal admin user's agent-event bus.
     *
     *     This is the long-lived Agent Studio subscription for events whose
     *     ``subject_user_id`` is the IA uid itself. Run-scoped debug views should
     *     continue using ``/runs/{agent_run_id}/events`` because a run can target a
     *     different subject and events are routed by subject.
     *
     *     Carries the full ``AgentEvent`` envelope for admin observability. Unlike
     *     the per-run stream, this user-scoped stream is long-lived and does not
     *     terminate on a single run's ``channel.ended`` event.
     */
    get: operations['internal_admin_agent_harness_user_events_api_v2_ml_scribe_internal_admin_agent_harness_events_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}/events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Internal Admin Agent Harness Agent Events
     * @description Tail the agent-event bus, filtered to one run.
     *
     *     Sources from the canonical per-user agent-event bus
     *     (``agent_harness:events:{subject_user_id}``) — the same stream the
     *     web FE long-lived subscription consumes — and filters consumer-side
     *     to the requested ``agent_run_id`` plus the optional ``?packs=``
     *     allowlist. Carries the full ``AgentEvent`` shape (admin
     *     observability) including the terminal ``channel.ended`` event that
     *     closes the stream.
     *
     *     **Ownership**: the authenticated admin must be the run actor or
     *     subject; mismatch returns 404 (not 403) so we don't leak the
     *     existence of other admins' runs. The run's ``subject_user_id`` is
     *     used as the bus routing key. **Resume**: standard ``Last-Event-ID``
     *     is supported; consumers dedup by ``AgentEvent.event_id`` for the
     *     inevitable replay after Redis-stream TTL expiry.
     */
    get: operations['internal_admin_agent_harness_agent_events_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__events_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}/approvals/{approval_id}:resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Resolve Approval
     * @description Resolve a pending approval for a tool call.
     *
     *     The full approval sequence (ownership gate, durable persist-first,
     *     then workflow signal with recovery) is owned by
     *     ``AgentRunService.resolve_approval``.
     */
    post: operations['resolve_approval_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__approvals__approval_id__resolve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}/event-resolutions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Event Resolutions
     * @description List all FE-event lifecycle rows for an agent run.
     *
     *     Read-only — admins observe the lifecycle but cannot write verdicts
     *     on the user's behalf. Ordered by creation time.
     */
    get: operations['list_event_resolutions_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__event_resolutions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}:close': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Close Run
     * @description Close an active agent run, signalling the workflow to stop accepting work.
     */
    post: operations['close_run_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__close_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}:cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Cancel Active Turn
     * @description Cancel the active turn without closing the agent run.
     */
    post: operations['cancel_active_turn_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__cancel_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Configs */
    get: operations['list_configs_api_v2_ml_scribe_internal_admin_agent_harness_configs_get'];
    put?: never;
    /** Create Config */
    post: operations['create_config_api_v2_ml_scribe_internal_admin_agent_harness_configs_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs/{agent_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Config */
    get: operations['get_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__get'];
    /** Update Config */
    put: operations['update_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__put'];
    post?: never;
    /** Delete Config */
    delete: operations['delete_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs/{agent_id}/versions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Config Versions
     * @description List version history for a config, newest first.
     */
    get: operations['list_config_versions_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__versions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs/{agent_id}/versions/{version}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Config Version
     * @description Get a specific historical version snapshot.
     */
    get: operations['get_config_version_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__versions__version__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs/{agent_id}:rollback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Rollback Config
     * @description Roll back to a previous version by creating a new version with that content.
     */
    post: operations['rollback_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__rollback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs:render-python': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Render Config Python
     * @description Render an ``AgentConfig`` as copy-pasteable Python source.
     *
     *     Stateless — the caller sends the full config (saved or in-progress) and
     *     receives back a Python snippet that reconstructs an equal ``AgentConfig``
     *     when executed. Pydantic-default fields are elided for readability.
     */
    post: operations['render_config_python_api_v2_ml_scribe_internal_admin_agent_harness_configs_render_python_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs/{agent_id}:export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export Config
     * @description Export a config and its transitive sub-agent closure.
     */
    post: operations['export_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__export_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs:import': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Configs
     * @description Import an agent config export, creating or bumping versions for each entry.
     */
    post: operations['import_configs_api_v2_ml_scribe_internal_admin_agent_harness_configs_import_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs:recommend': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Recommend Config
     * @description Propose an ``AgentConfig`` from a free-text description.
     *
     *     Runs the planner as an agent on the harness — the returned
     *     ``agent_run_id`` can be opened in the Runs UI to inspect the
     *     planner's tool calls. Advisory only: the operator reviews and edits
     *     the ``suggested_config`` in the regular create-config form before
     *     hitting ``POST /configs``; this endpoint never persists a config.
     *
     *     Any tool names the planner hallucinates are filtered against the
     *     live ``ToolRegistry`` and surfaced in ``notes`` so the operator can
     *     see what was dropped.
     */
    post: operations['recommend_config_api_v2_ml_scribe_internal_admin_agent_harness_configs_recommend_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/configs/{agent_id}/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Config Runs
     * @description List runs that were started from a specific saved config.
     *
     *     Works even after the config has been deleted — runs are queried
     *     by ``source_config_id``, not the config record.
     */
    get: operations['list_config_runs_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__runs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/prompt-variables': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Prompt Variables
     * @description List supported prompt variables for IA prompt authoring.
     */
    get: operations['list_prompt_variables_api_v2_ml_scribe_internal_admin_agent_harness_prompt_variables_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/tools': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Tools
     * @description List all registered tools with their specs for building agent configs.
     */
    get: operations['list_tools_api_v2_ml_scribe_internal_admin_agent_harness_tools_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/hooks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Hooks
     * @description List registered lifecycle hooks for building agent configs.
     *
     *     Operators bind a hook onto ``AgentConfig.hooks`` by ``name``; the FE
     *     renders these as labeled toggles. The ``HOOKS`` registry is the single
     *     source of truth — adding a hook there auto-populates this list on the next
     *     worker restart.
     */
    get: operations['list_hooks_api_v2_ml_scribe_internal_admin_agent_harness_hooks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/models': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Models
     * @description List selectable (provider, model) pairs for the agent config UI.
     *
     *     The list is derived from ``pkg.llm.enums`` via
     *     ``domains.agent_tooling.api.internal_admin.agent_model_catalog`` — the
     *     same module the recommender uses to validate planner output. Adding a
     *     new model to the enum auto-populates the dropdown on next worker
     *     restart; the recommender picks it up for free on the same path.
     *
     *     Provider keys match the routing in
     *     ``ToolCallingLLMAdapterFactory.create_adapter`` exactly, so the ``id``
     *     emitted here can be round-tripped into ``AgentConfig.provider`` /
     *     ``AgentConfig.model`` without translation.
     *
     *     Note: only models on the three currently-supported providers are
     *     auto-populated. Adding a *new* provider (e.g. Mistral, Cohere, xAI)
     *     still requires extending both ``ToolCallingLLMAdapterFactory`` and the
     *     catalog module. The auto-population claim applies per-provider,
     *     not to the provider set itself.
     */
    get: operations['list_models_api_v2_ml_scribe_internal_admin_agent_harness_models_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Run Details
     * @description Hydrate a run: metadata, messages, approvals. Visible to all admins.
     */
    get: operations['get_run_details_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/runs/{agent_run_id}/conversation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Run Conversation Page
     * @description Paginated full-history view over the run's `ConversationView`.
     *
     *     Returns ``messages`` reconstructed from artefacts whose ``turn_id`` is in
     *     ``ConversationView.artefact_turn_ids[offset:offset+limit]``. ``offset`` past
     *     the end returns an empty list; ``limit`` past the end returns a partial
     *     slice. If the run exists but no `ConversationView` exists yet (e.g. a run
     *     started without an ``initial_turn`` and before any turn has been
     *     persisted), returns an empty page (``messages=[]``, ``total_artefacts=0``)
     *     so first-load and polling flows see a consistent shape. Returns 404 if
     *     the run itself does not exist.
     */
    get: operations['get_run_conversation_page_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__conversation_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/schedules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Schedules */
    get: operations['list_schedules_api_v2_ml_scribe_internal_admin_agent_harness_schedules_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/schedules/{schedule_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Schedule */
    get: operations['get_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__get'];
    /**
     * Update Schedule
     * @description Update schedule name / description / cadence without recreating the handle.
     */
    put: operations['update_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__put'];
    post?: never;
    /** Delete Schedule */
    delete: operations['delete_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/schedules/{schedule_id}:pause': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Pause Schedule */
    post: operations['pause_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__pause_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/schedules/{schedule_id}:unpause': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Unpause Schedule */
    post: operations['unpause_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__unpause_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/inbox/items': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Ia List Inbox Items */
    get: operations['ia_list_inbox_items_api_v2_ml_scribe_internal_admin_agent_harness_inbox_items_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/inbox/items/{approval_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Ia Get Inbox Item */
    get: operations['ia_get_inbox_item_api_v2_ml_scribe_internal_admin_agent_harness_inbox_items__approval_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/inbox/count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Ia Get Inbox Count */
    get: operations['ia_get_inbox_count_api_v2_ml_scribe_internal_admin_agent_harness_inbox_count_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/inbox/subjects': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Ia List Inbox Subjects */
    get: operations['ia_list_inbox_subjects_api_v2_ml_scribe_internal_admin_agent_harness_inbox_subjects_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Agent Harness Status */
    get: operations['get_agent_harness_status_api_v2_ml_scribe_internal_admin_agent_harness_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/event-rules/event-types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Event Types
     * @description List all available event types with human-readable labels.
     */
    get: operations['list_event_types_api_v2_ml_scribe_internal_admin_event_rules_event_types_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/event-rules/event-types/{event_type}/filter-fields': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Filter Fields
     * @description Return the payload fields available for filtering on *event_type*.
     */
    get: operations['list_filter_fields_api_v2_ml_scribe_internal_admin_event_rules_event_types__event_type__filter_fields_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/event-rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Event Rules */
    get: operations['list_event_rules_api_v2_ml_scribe_internal_admin_event_rules_get'];
    put?: never;
    /** Create Event Rule */
    post: operations['create_event_rule_api_v2_ml_scribe_internal_admin_event_rules_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/event-rules/{rule_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Event Rule */
    get: operations['get_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__get'];
    put?: never;
    post?: never;
    /** Delete Event Rule */
    delete: operations['delete_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__delete'];
    options?: never;
    head?: never;
    /** Update Event Rule */
    patch: operations['update_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/event-rules/{rule_id}:enable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Enable Event Rule */
    post: operations['enable_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__enable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/event-rules/{rule_id}:disable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Disable Event Rule */
    post: operations['disable_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__disable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/event-rules/dispatch:preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Preview Dispatch
     * @description Dry-run: evaluate which rules and agents would fire for a synthetic event.
     *
     *     Wires the real semantic evaluator and the dispatch path's own text loader, so
     *     preview is a true dry-run (including the LLM call) that cannot drift from
     *     dispatch. Admin-triggered and bounded.
     */
    post: operations['preview_dispatch_api_v2_ml_scribe_internal_admin_event_rules_dispatch_preview_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/event-rules/dispatch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Confirm Dispatch
     * @description Force-fire a synthetic event through in-process rule matching.
     *
     *     Unlike ``preview_dispatch``, this has real side-effects: it matches
     *     rules and starts ``AgentRunWorkflow`` executions for each match.
     *
     *     ``workflow_id`` in the response is the first started AgentRunWorkflow
     *     Temporal id (or ``None`` when nothing started / the harness flag is off).
     *
     *     The active-rules existence guard is intentionally skipped -- the admin
     *     has already reviewed matching rules via the preview endpoint and is
     *     choosing to force-fire.
     */
    post: operations['confirm_dispatch_api_v2_ml_scribe_internal_admin_event_rules_dispatch_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflows */
    get: operations['list_workflows_api_v2_ml_scribe_internal_admin_workflows_get'];
    put?: never;
    /** Create Workflow */
    post: operations['create_workflow_api_v2_ml_scribe_internal_admin_workflows_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows/{workflow_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow */
    get: operations['get_workflow_api_v2_ml_scribe_internal_admin_workflows__workflow_id__get'];
    put?: never;
    post?: never;
    /** Delete Workflow */
    delete: operations['delete_workflow_api_v2_ml_scribe_internal_admin_workflows__workflow_id__delete'];
    options?: never;
    head?: never;
    /** Update Workflow */
    patch: operations['update_workflow_api_v2_ml_scribe_internal_admin_workflows__workflow_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Scoped Workflow Runs
     * @description IA: list routine runs for a team or organization (stamped at dispatch).
     */
    get: operations['list_scoped_workflow_runs_api_v2_ml_scribe_internal_admin_workflows_runs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows/{workflow_id}/eval-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Eval Profile */
    get: operations['get_workflow_eval_profile_api_v2_ml_scribe_internal_admin_workflows__workflow_id__eval_profile_get'];
    /** Update Workflow Eval Profile */
    put: operations['update_workflow_eval_profile_api_v2_ml_scribe_internal_admin_workflows__workflow_id__eval_profile_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows/{workflow_id}/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Workflow Runs
     * @description List harness runs linked to this workflow (Studio Runs tab).
     */
    get: operations['list_workflow_runs_api_v2_ml_scribe_internal_admin_workflows__workflow_id__runs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows/{workflow_id}/run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Run Workflow
     * @description Dispatch a workflow run as the definition owner (same as schedule/event).
     */
    post: operations['run_workflow_api_v2_ml_scribe_internal_admin_workflows__workflow_id__run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows/{workflow_id}/schedule': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Schedule */
    get: operations['get_workflow_schedule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__schedule_get'];
    /** Set Workflow Schedule */
    put: operations['set_workflow_schedule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__schedule_put'];
    post?: never;
    /** Delete Workflow Schedule */
    delete: operations['delete_workflow_schedule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__schedule_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows/{workflow_id}/event-rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflow Event Rules */
    get: operations['list_workflow_event_rules_api_v2_ml_scribe_internal_admin_workflows__workflow_id__event_rules_get'];
    put?: never;
    /** Add Workflow Event Rule */
    post: operations['add_workflow_event_rule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__event_rules_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workflows/{workflow_id}/event-rules/{rule_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete Workflow Event Rule */
    delete: operations['delete_workflow_event_rule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__event_rules__rule_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/datasets:snapshot': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Snapshot Agent Eval Dataset
     * @description Freeze one window of sampled real runs into a new dataset.
     *
     *     The dataset id is minted here rather than by the job, so it is returned
     *     even when the start call fails ambiguously.
     */
    post: operations['snapshot_agent_eval_dataset_api_v2_ml_scribe_internal_admin_agents_evals_datasets_snapshot_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/datasets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agent Eval Datasets */
    get: operations['list_agent_eval_datasets_api_v2_ml_scribe_internal_admin_agents_evals_datasets_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/datasets/{dataset_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Agent Eval Dataset */
    get: operations['get_agent_eval_dataset_api_v2_ml_scribe_internal_admin_agents_evals_datasets__dataset_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/saved-suites': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Saved Eval Suites */
    get: operations['list_saved_eval_suites_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites_get'];
    put?: never;
    /** Create Saved Eval Suite */
    post: operations['create_saved_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/saved-suites/{suite_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Saved Eval Suite */
    get: operations['get_saved_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Saved Eval Suite
     * @description Edits are prospective: scores already written keep the revision they
     *     were graded under, and the version bump is what keeps the two apart.
     *
     *     Only what the request names is re-checked against the bundle registry and
     *     the dataset store — a suite whose bundle was retired must still be
     *     disableable.
     */
    patch: operations['update_saved_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/saved-suites/{suite_id}:score': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Score Saved Eval Suite
     * @description Start one scoring pass of this suite's dataset.
     *
     *     Every param is resolved from the stored suite, so a request cannot score a
     *     dataset under a bundle the suite does not name.
     */
    post: operations['score_saved_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__score_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/saved-suites/{suite_id}/results': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Saved Eval Suite Results
     * @description Full score rows, judge reasoning included — reasoning quotes the real
     *     trajectory it graded, so the token must name ``phi:read`` for this read
     *     alone; no Super Admin or Admin role opens it.
     *
     *     One row per dataset item: the latest scoring pass of that dataset, which
     *     each row names alongside the dataset it graded.
     */
    get: operations['list_saved_eval_suite_results_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__results_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/saved-suites/{suite_id}/summary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Saved Eval Suite Summary
     * @description Aggregates only — every point carries its segment keys rather than being
     *     split by them, so a client can overlay the whole series or cut it by any
     *     key it likes.
     */
    get: operations['get_saved_eval_suite_summary_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__summary_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/suites': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agent Eval Suites */
    get: operations['list_agent_eval_suites_api_v2_ml_scribe_internal_admin_agents_evals_suites_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/suites/{suite_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Agent Eval Suite
     * @description Everything the list gives, plus the bindings and cases behind it.
     */
    get: operations['get_agent_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_suites__suite_name__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/suites/{suite_name}:run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Run Agent Eval Suite
     * @description Plan and start one experiment over *suite_name*.
     *
     *     ``bindings`` puts saved agent configs and ``routines`` puts whole routines
     *     through the suite instead of the agents it declares; without either the
     *     suite runs exactly as coded.
     *
     *     The experiment id is minted here rather than by the job, so it is returned
     *     even when the start call fails ambiguously: a start that raised may still
     *     have planned the experiment, and this id is the only handle on it.
     */
    post: operations['run_agent_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_suites__suite_name__run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/bundles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agent Eval Bundles */
    get: operations['list_agent_eval_bundles_api_v2_ml_scribe_internal_admin_agents_evals_bundles_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/experiments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agent Eval Experiments */
    get: operations['list_agent_eval_experiments_api_v2_ml_scribe_internal_admin_agents_evals_experiments_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/experiments/{experiment_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Agent Eval Experiment */
    get: operations['get_agent_eval_experiment_api_v2_ml_scribe_internal_admin_agents_evals_experiments__experiment_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/experiments/{experiment_id}/report': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Agent Eval Experiment Report
     * @description The stored report, or 404 while the experiment has not produced one.
     */
    get: operations['get_agent_eval_experiment_report_api_v2_ml_scribe_internal_admin_agents_evals_experiments__experiment_id__report_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/experiments/{experiment_id}:retry-failed': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Retry Failed Agent Eval Units
     * @description Re-run only the units one job of this experiment failed or never reached.
     *
     *     Units that already scored are untouched, and the retry re-fires the
     *     completion hook, so the stored report is re-aggregated over every row the
     *     experiment now has.
     *
     *     Without a ``job_ref_id`` the newest run this experiment recorded is
     *     retried. The job is resolved and matched to the experiment either way, so a
     *     job that ran something else cannot be retried under this experiment's name.
     *
     *     The source job's id is recorded ahead of the retry's, because a job can be
     *     terminal before its completion hook runs; the guarded push makes that a
     *     no-op once the hook got there.
     */
    post: operations['retry_failed_agent_eval_units_api_v2_ml_scribe_internal_admin_agents_evals_experiments__experiment_id__retry_failed_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agents/evals/runs/{agent_run_id}/scores': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agent Run Scores */
    get: operations['list_agent_run_scores_api_v2_ml_scribe_internal_admin_agents_evals_runs__agent_run_id__scores_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/api-status-check-log': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Api Status Check Logs
     * @description List API status check log entries (most recent first). Each entry records who ran the check, when, and the per-domain results.
     */
    get: operations['list_api_status_check_logs_api_v2_ml_scribe_internal_admin_api_status_check_log_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/abuse-user-ref-bans': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Ref Bans
     * @description List active user_ref_id bans (capped).
     */
    get: operations['list_user_ref_bans_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_get'];
    put?: never;
    /**
     * Create User Ref Ban
     * @description Manually ban a user_ref_id.
     */
    post: operations['create_user_ref_ban_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/abuse-user-ref-bans/lookup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Lookup User Ref
     * @description Look up a user_ref_id before creating a ban.
     */
    get: operations['lookup_user_ref_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_lookup_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/abuse-user-ref-bans/logs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Ref Ban Logs
     * @description List audit log entries for a user_ref_id ban target.
     */
    get: operations['list_user_ref_ban_logs_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_logs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/abuse-user-ref-bans/revoke': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Revoke User Ref Ban
     * @description Remove a ban for a user_ref_id.
     */
    post: operations['revoke_user_ref_ban_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_revoke_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/abuse-email-bans': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Email Bans
     * @description List active email bans (capped).
     */
    get: operations['list_email_bans_api_v2_ml_scribe_internal_admin_abuse_email_bans_get'];
    put?: never;
    /**
     * Create Email Ban
     * @description Manually ban an email.
     */
    post: operations['create_email_ban_api_v2_ml_scribe_internal_admin_abuse_email_bans_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/abuse-email-bans/lookup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Lookup Email
     * @description Look up an email before creating a ban. Returns the current user (if any) with that address so admins can confirm scope. The underlying user lookup returns at most one account per email.
     */
    get: operations['lookup_email_api_v2_ml_scribe_internal_admin_abuse_email_bans_lookup_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/abuse-email-bans/logs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Email Ban Logs
     * @description List audit log entries for email bans.
     */
    get: operations['list_email_ban_logs_api_v2_ml_scribe_internal_admin_abuse_email_bans_logs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/abuse-email-bans/revoke': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Revoke Email Ban
     * @description Remove a ban for an email.
     */
    post: operations['revoke_email_ban_api_v2_ml_scribe_internal_admin_abuse_email_bans_revoke_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/audit-log/entities/query': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Query Audit Logs By Entities
     * @description Query audit log entries for one or more entities, most recent first. Returns a unified timeline: each document appears at most once even when it matches multiple of the requested entities.
     */
    post: operations['query_audit_logs_by_entities_api_v2_ml_scribe_internal_admin_audit_log_entities_query_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/backup-chunks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** S3 backup chunk availability for a session (transcription-service) */
    get: operations['get_session_backup_chunks_api_v2_ml_scribe_internal_admin_sessions__session_id__backup_chunks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/backup-recoveries': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Backup recovery attempts for a session, newest first */
    get: operations['list_session_backup_recoveries_api_v2_ml_scribe_internal_admin_sessions__session_id__backup_recoveries_get'];
    put?: never;
    /**
     * Re-transcribe a session from its S3 backup chunks
     * @description Triggers transcription-service to pull the session's stored audio chunks
     *         from S3 and re-transcribe them with the selected model/languages. The
     *         result REPLACES the transcript the clinician sees. Runs asynchronously —
     *         poll the GET endpoint for completion.
     */
    post: operations['trigger_session_backup_recovery_api_v2_ml_scribe_internal_admin_sessions__session_id__backup_recoveries_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/backup-recovery-models': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Transcription models selectable for backup recovery */
    get: operations['list_backup_recovery_models_api_v2_ml_scribe_internal_admin_backup_recovery_models_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/uploaded-audio-retranscriptions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Re-transcribe a session's user-uploaded audio
     * @description Re-runs the uploaded-audio pipeline over Session.audio with
     *         regenerate=True, rewriting each stored transcript. REPLACES the
     *         uploaded-audio portion of the merged transcript the clinician sees.
     *         Synchronous — the pipeline persists each audio doc as it goes.
     */
    post: operations['retranscribe_uploaded_audio_api_v2_ml_scribe_internal_admin_sessions__session_id__uploaded_audio_retranscriptions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/hardware-audio-retranscriptions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Re-transcribe a session's hardware (Chronicle) audio
     * @description Re-runs the hardware-audio pipeline over Session.hardware_audio with
     *         regenerate=True, rewriting each stored transcript. REPLACES the
     *         hardware-audio contribution to the merged transcript (surfaced through
     *         the backup slot at read time). Synchronous — the pipeline persists each
     *         audio doc as it goes.
     */
    post: operations['retranscribe_hardware_audio_api_v2_ml_scribe_internal_admin_sessions__session_id__hardware_audio_retranscriptions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/backup-audio-retranscriptions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Re-transcribe a session's backup audio
     * @description Re-runs the backup-audio pipeline over Session.backup_audio with
     *         regenerate=True, rewriting each stored transcript. REPLACES the
     *         ml-scribe backup-audio portion of the merged transcript (the fallback
     *         used when the live transcription-service chunk path fails). Synchronous
     *         — the pipeline persists each audio doc as it goes.
     */
    post: operations['retranscribe_backup_audio_api_v2_ml_scribe_internal_admin_sessions__session_id__backup_audio_retranscriptions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/billings/{user_ref_id}/activate-clinician-trial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Activate Clinician Trial
     * @description Activate clinician evidence trial for the given user (internal admin).
     */
    post: operations['activate_clinician_trial_api_v2_ml_scribe_internal_admin_billings__user_ref_id__activate_clinician_trial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/billings/{user_ref_id}/billing-account': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Billing Account
     * @description Get the user's BillingAccount with embedded ProductSubscriptions. Read-only. Returns billing_account=null when the user has no BillingAccountDO yet (common during the cutover from legacy fields).
     */
    get: operations['get_user_billing_account_api_v2_ml_scribe_internal_admin_billings__user_ref_id__billing_account_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/billings/{user_ref_id}/credit-allowance': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Credit Allowance
     * @description Get the user's current credit allowance in one workspace, including the pinned policy snapshot used to set its limit. Read-only.
     */
    get: operations['get_user_credit_allowance_api_v2_ml_scribe_internal_admin_billings__user_ref_id__credit_allowance_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/billings/teams/{team_id}/seats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Seat Summary
     * @description Get a team's stored paid-seat usage summary for internal diagnostics. This read remains available when seat enforcement is disabled.
     */
    get: operations['get_team_seat_summary_api_v2_ml_scribe_internal_admin_billings_teams__team_id__seats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/billings/sync-subscription': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Subscription
     * @description Re-fetch a user or team's current Stripe subscription and write the refreshed fields (stripe_subscription_id, plan dates, trial status, tier) back to the billing record. Uses the same Stripe-to-record field mapping as the webhook handler. Idempotent (last-write-wins).
     */
    post: operations['sync_subscription_api_v2_ml_scribe_internal_admin_billings_sync_subscription_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/billings/fix-stripe-customer-id': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Fix Stripe Customer Id
     * @description Repoint a user's BillingAccount at the Stripe customer id recorded on the User record, repairing the mismatch that leaves Stripe webhooks routing away from the account. Copies User -> BillingAccount only; subscription rows created under the previous customer are left alone (run Sync from Stripe afterwards to refresh those). Refuses with 409 when another BillingAccount already holds the target id.
     */
    post: operations['fix_stripe_customer_id_api_v2_ml_scribe_internal_admin_billings_fix_stripe_customer_id_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/chats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Chats
     * @description List all chats with pagination and optional filtering by session_id, user_ref_id, or user email
     */
    get: operations['list_chats_api_v2_ml_scribe_internal_admin_chats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/chats/{chat_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Chat
     * @description Get a single chat by ID with full message history
     */
    get: operations['get_chat_api_v2_ml_scribe_internal_admin_chats__chat_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-chat-retention-lineage/campaigns': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start Retention Lineage Campaign
     * @description Start one regional Evidence chat retention-lineage audit or backfill campaign. Airflow advances the returned campaign in bounded calls.
     */
    post: operations['start_retention_lineage_campaign_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_campaigns_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-chat-retention-lineage/campaigns/{campaign_id}:advance': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Advance Retention Lineage Campaign
     * @description Advance one bounded page of a regional lineage campaign. The cursor and aggregate counters are persisted before the response returns.
     */
    post: operations['advance_retention_lineage_campaign_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_campaigns__campaign_id__advance_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-chat-retention-lineage/campaigns/{campaign_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Retention Lineage Campaign
     * @description Read durable regional campaign progress and the final ready_for_phi_deletion gate.
     */
    get: operations['get_retention_lineage_campaign_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_campaigns__campaign_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-chat-retention-lineage/monitoring/campaigns': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Retention Lineage Campaigns For Monitoring
     * @description List regional retention-lineage campaigns for human operators.
     */
    get: operations['list_retention_lineage_campaigns_for_monitoring_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_monitoring_campaigns_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-chat-retention-lineage/monitoring/campaigns/{campaign_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Retention Lineage Campaign For Monitoring
     * @description Read one regional campaign without exposing raw exception text.
     */
    get: operations['get_retention_lineage_campaign_for_monitoring_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_monitoring_campaigns__campaign_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/external-org/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create External Organization */
    post: operations['create_external_organization_api_v2_ml_scribe_internal_admin_external_org__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/external-org/{org_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update External Organization
     * @description update external organization
     */
    patch: operations['update_external_organization_api_v2_ml_scribe_internal_admin_external_org__org_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Organizations
     * @description List all organizations
     */
    get: operations['list_organizations_api_v2_ml_scribe_internal_admin_organizations_get'];
    put?: never;
    /**
     * Create Organization
     * @description Create a new organization
     */
    post: operations['create_organization_api_v2_ml_scribe_internal_admin_organizations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{org_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Organization
     * @description Get organization by ID
     */
    get: operations['get_organization_api_v2_ml_scribe_internal_admin_organizations__org_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{organization_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Organization
     * @description Delete organization (soft delete)
     */
    delete: operations['delete_organization_api_v2_ml_scribe_internal_admin_organizations__organization_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Organization
     * @description Update organization details
     */
    patch: operations['update_organization_api_v2_ml_scribe_internal_admin_organizations__organization_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/audio/files': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Stored audio-file playback URLs, all sources (exclusive permission; audited)
     * @description DEV-12234: list a session's stored audio files across ALL file-backed sources — FE backup recordings, Chronicle/hardware device uploads, and user-uploaded audio — with short-lived presigned playback URLs. A session can have several overlapping sources; each item is tagged with its source so none is silently hidden. Requires the explicit session_audio:read permission (Super Admin alone is denied). Every call is audit-logged before any URL is issued.
     */
    get: operations['get_session_audio_files_api_v2_ml_scribe_internal_admin_sessions__session_id__audio_files_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/audio/chunks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Live-audio chunk playback URLs (exclusive permission; audited)
     * @description DEV-12235: list a session's live-captured audio chunks (stored by transcription-service) with short-lived presigned playback URLs, ordered by chunk index with missing chunks reported. Same exclusive session_audio:read gate and audit logging as the backup-audio endpoint.
     */
    get: operations['get_session_audio_chunks_api_v2_ml_scribe_internal_admin_sessions__session_id__audio_chunks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/ai-command/{ai_command_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Ai Command */
    get: operations['get_ai_command_api_v2_ml_scribe_internal_admin_sessions__session_id__ai_command__ai_command_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/document/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Session Documents */
    get: operations['get_session_documents_api_v2_ml_scribe_internal_admin_sessions__session_id__document__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/template/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Template */
    get: operations['get_template_api_v2_ml_scribe_internal_admin_sessions__session_id__template__template_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/templates/{template_id}/csat-sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Csat Sessions By Template Id
     * @description https://linear.app/getheidi/issue/DEV-4222/pass-csat-feedback-to-internal-admin
     */
    get: operations['get_csat_sessions_by_template_id_api_v2_ml_scribe_internal_admin_sessions_templates__template_id__csat_sessions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/overview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Session Overview for Support
     * @description SUP-7503: Get session overview information for support without revealing PII.
     *         Combines functionality of:
     *         - GET /api/v1/ml-scribe/internal-admin/sessions/{session_id}
     *         - GET /api/v2/ml-scribe/internal-admin/sessions/{session_id}/document/
     *         - GET /api/v1/ml-scribe/internal-admin/sessions/{session_id}/transcript
     *         - GET /api/v1/ml-scribe/internal-admin/session-events?session_id={session_id}
     *
     *         Returns only specified fields from session, consult note, and document collections.
     *         Absolutely NO PII/PHI data is included (no transcript content, patient info, etc.).
     */
    get: operations['get_session_overview_api_v2_ml_scribe_internal_admin_sessions__session_id__overview_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/context-documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List context documents for a session
     * @description Returns metadata and extracted text content for all context documents attached to a session.
     */
    get: operations['get_session_context_documents_api_v2_ml_scribe_internal_admin_sessions__session_id__context_documents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/external-session': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get external session linked to a Heidi session
     * @description Returns the external session (e.g. from Epic Haiku) linked to this Heidi session, if one exists.
     */
    get: operations['get_session_external_session_api_v2_ml_scribe_internal_admin_sessions__session_id__external_session_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/{session_id}/merge-group': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Inspect a session's merge-group and patient-match state
     * @description Read-only inspector for the session-merge feature: resolves the given
     *         session id to its merge group (accepts a group-container id or a member
     *         id via `merged_into_session_id`), and returns the container's merge
     *         state, per-member stored snapshots overlaid with live state, the stored
     *         patient-match candidates, and the auto-link decision.
     *
     *         Returns 200 with `group: null` for a session in no group — its own merge
     *         state, candidates, and decision are still returned ("why didn't this
     *         session group/link" is the primary support case). 404 only when the
     *         session id does not exist at all; soft-deleted sessions and members stay
     *         inspectable, with `deleted_at` exposed.
     *
     *         Recompute caveat: the auto-link decision is recomputed on read from the
     *         currently stored candidates using the same classifier as the write path
     *         (`decision_source: "recomputed"`). It is NOT a persisted historical
     *         record — candidates may have been re-ranked since the original decision
     *         (profile-create rematch overwrites in place; sub-0.7 candidates were
     *         never persisted). Datadog logs remain the historical record.
     *
     *         Access: requires `basic:read` (session-metadata scope). PHI tiering:
     *         patient name, member `session_name`/`session_gist` snapshots, candidate
     *         evidence values (`profile_value`, `transcript_support`) and
     *         `clinical_verdict_reason` are visible only when the token's permissions
     *         claim carries `phi:read`
     *         (matching the gate Scribe-Admin renders on). Other callers receive
     *         the full payload with PHI fields null and `phi_redacted: true`.
     *         No mutations.
     */
    get: operations['get_session_merge_group_api_v2_ml_scribe_internal_admin_sessions__session_id__merge_group_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/team-id-audit': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Audit Session.team_id stamp consistency for a user
     * @description Read-only audit of one user's live-session `team_id` stamps. Reports
     *         backfill coverage (`coverage_complete`) and cross-org stamp correctness
     *         (`cross_org_clean`) so operators can verify the migration without direct
     *         DB access. Identify the user with exactly one of `user_ref_id` or
     *         `kinde_user_id`. No mutations.
     */
    get: operations['get_session_team_id_audit_api_v2_ml_scribe_internal_admin_sessions_team_id_audit_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sessions/list-latency': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Replay the v2.2 session-list query for a user and report latency
     * @description Replays the real v2.2 session-list query (`SessionManager.list_sessions`)
     *         for one target user, using the same query surface and validation as
     *         `GET /api/v2-2/ml-scribe/sessions`, and reports how long it took split by
     *         phase — `context_setup_ms` (deriving the target user's flag context: a
     *         Mongo team fetch plus a Redis-cached/remote Flagsmith identity fetch) and
     *         `elapsed_ms` (the DB list query alone) — plus how many sessions came back
     *         on this page (`page_count`, not a total) and whether a next page exists
     *         (`has_next_page`). Lets operators attribute real-customer latency without
     *         prod DB access; returns no session content. Identify the user with exactly
     *         one of `user_ref_id` or `kinde_user_id`. A query that exceeds the
     *         server-side time limit returns 200 with `timed_out: true` rather than 504.
     *         No mutations.
     */
    get: operations['get_session_list_latency_api_v2_ml_scribe_internal_admin_sessions_list_latency_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/templates/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Custom Templates
     * @description Get a list of custom templates
     *
     *     When kinde_user_id is provided, only return personal templates belong to this user.
     *     When team_id is provided, only return team templates belong to this team,
     *     If both kinde_user_id and team_id are provided, return the UNION of personal and team templates.
     *     When organization_id is provided (without team_id), return all templates visible at
     *     the organization level.
     */
    get: operations['get_custom_templates_api_v2_ml_scribe_internal_admin_templates__get'];
    put?: never;
    /**
     * Create Template
     * @description Create template on behalf of a user.
     *
     *     If team_id is provided, will create team template.
     *     If kinde_user_id is provided, will create template under this user.
     *     If both kinde_user_id and team_id are provided, will create team template under this user.
     *     If team_id is provided with no kinde_user_id, the template is created ownerless
     *     (kinde_user_id == "") and attributed to the team.
     */
    post: operations['create_template_api_v2_ml_scribe_internal_admin_templates__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/templates/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Template */
    get: operations['get_template_api_v2_ml_scribe_internal_admin_templates__template_id__get'];
    put?: never;
    post?: never;
    /** Mark Template Delete */
    delete: operations['mark_template_delete_api_v2_ml_scribe_internal_admin_templates__template_id__delete'];
    options?: never;
    head?: never;
    /** Update Template */
    patch: operations['update_template_api_v2_ml_scribe_internal_admin_templates__template_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/templates/{template_id}/versions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template Versions
     * @description List the builder version history for a template (admin-authed).
     *
     *     Mirrors the public builder read, which the admin token can't call (it's a
     *     Kinde/Scribe-user route). Returns 404 when the template has no version
     *     history yet, which the client treats as an empty list.
     *
     *     The owner is best-effort: ownerless team templates (kinde_user_id == "") and
     *     templates whose owner has since been deleted still have readable history,
     *     because the record is looked up by template_id, not by owner.
     */
    get: operations['get_template_versions_api_v2_ml_scribe_internal_admin_templates__template_id__versions_get'];
    put?: never;
    /**
     * Create Template Version
     * @description Snapshot a new version for a template (admin-authed), bootstrapping the
     *     creation record for legacy templates. The caller then repoints the live
     *     template's version_control_id via PATCH.
     *
     *     The owner is best-effort, matching the PATCH route: an unresolvable owner
     *     (ownerless team template, or a deleted user) must not block versioning, so a
     *     bootstrapped record is attributed to the internal-admin principal instead.
     */
    post: operations['create_template_version_api_v2_ml_scribe_internal_admin_templates__template_id__versions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/templates/{template_id}/version-summary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template Version Summary
     * @description Active version number + count for a template, for the admin list tables.
     *     Returns zero/None (200, never 404) when the template has no history.
     */
    get: operations['get_template_version_summary_api_v2_ml_scribe_internal_admin_templates__template_id__version_summary_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/templates/version-summaries': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Template Version Summaries
     * @description Bulk active-version numbers for the admin list tables — one request for a
     *     page of templates instead of one per row.
     */
    post: operations['get_template_version_summaries_api_v2_ml_scribe_internal_admin_templates_version_summaries_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/templates/form-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Custom Form Template With Pdf
     * @description Create a custom form template with PDF upload for a specific user.
     *
     *     This endpoint allows internal admins to upload form templates (PDFs) directly
     *     into user accounts. The PDF is stored in S3 and form fields are extracted.
     *     The template becomes available to the user with a presigned URL for PDF access.
     *
     *     Args:
     *         pdf_file: The PDF file to upload
     *         kinde_user_id: The user who will own this template
     *         name: Name of the template
     *         template_visibility: Visibility setting (USER, TEAM, etc.)
     *         team_id: Optional team ID if creating a team template
     *         organization_id: Optional organization ID for ORGANIZATION visibility
     *         shared_team_ids: Optional team IDs to share with when TEAM visibility
     *         description: Optional description
     *
     *     Returns:
     *         TemplateResponseV2 with the created template including presigned URL for PDF access
     */
    post: operations['create_custom_form_template_with_pdf_api_v2_ml_scribe_internal_admin_templates_form_templates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/gallery-templates/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Gallery Templates
     * @description List templates from the gallery with optional filtering and pagination.
     *
     *     Query params:
     *         page: Page number (1-indexed)
     *         page_size: Items per page (max 100)
     *         template_category: Filter by category (CONSULT_NOTE_TEMPLATE, DOCUMENT_TEMPLATE, FORM_TEMPLATE)
     *         source_region: Filter by source region (UK, CA, US, AU, EU)
     *         country: Filter by country name
     *         specialty: Filter by specialty name
     *         author_id: Filter by author's kinde_user_id
     *         include_deleted: Include soft-deleted templates
     *         search: Search in title and description
     *         sort: Sort criteria as field:order. Valid fields: created_at, updated_at,
     *               views_count, imports_count, title, template_category. Order: 1=asc, -1=desc
     */
    get: operations['list_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates__get'];
    put?: never;
    /**
     * Create Gallery Template
     * @description Create a new template directly in the gallery.
     *
     *     This bypasses the normal template review/approval flow and creates
     *     the template directly in the gallery. Use with caution.
     *
     *     Accepts content fields either at the top level or nested inside
     *     ``template_content``.  When ``template_content`` is provided, its
     *     values take precedence over the top-level equivalents.
     */
    post: operations['create_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/gallery-templates/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Batch Create Gallery Templates
     * @description Batch create multiple templates in the gallery.
     *
     *     Returns a list of successfully created templates and any failures.
     *     Maximum 50 templates per request.
     */
    post: operations['batch_create_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_post'];
    /**
     * Batch Delete Gallery Templates
     * @description Batch soft-delete multiple templates from the gallery.
     *
     *     Returns a list of successfully deleted template IDs and any failures.
     *     Maximum 50 templates per request.
     */
    delete: operations['batch_delete_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_delete'];
    options?: never;
    head?: never;
    /**
     * Batch Update Gallery Templates
     * @description Batch update multiple templates in the gallery.
     *
     *     Each item must include template_id and the fields to update.
     *     Returns a list of successfully updated templates and any failures.
     *     Maximum 50 templates per request.
     */
    patch: operations['batch_update_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/gallery-templates/upload-pdf': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Gallery Template Pdf
     * @description Upload a PDF file for a gallery form template.
     *
     *     Extracts form fields from the PDF and uploads it to the global public S3 bucket.
     *     Returns the S3 object key and extracted form fields.
     */
    post: operations['upload_gallery_template_pdf_api_v2_ml_scribe_internal_admin_gallery_templates_upload_pdf_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/gallery-templates/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Gallery Template
     * @description Get a single template from the gallery by ID.
     *
     *     Returns the full template details including content.
     */
    get: operations['get_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__template_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Gallery Template
     * @description Soft-delete a template from the gallery.
     *
     *     The template can be restored later using the restore endpoint.
     */
    delete: operations['delete_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__template_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Gallery Template
     * @description Update an existing template in the gallery.
     *
     *     Only provided fields will be updated. Omitted fields remain unchanged.
     *     Accepts content fields either at the top level or nested inside
     *     ``template_content``.
     */
    patch: operations['update_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__template_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/gallery-templates/{template_id}/restore': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Restore Gallery Template
     * @description Restore a soft-deleted template in the gallery.
     */
    patch: operations['restore_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__template_id__restore_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/gallery-templates/batch/upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Batch Upload Gallery Templates
     * @description Batch create gallery templates from CSV or JSON file upload.
     *
     *     - **file**: CSV or JSON file containing template data
     *     - **execute**: If false (default), only validates. If true, creates templates.
     *
     *     ## CSV Format
     *     Required columns: title, template_category, source_region, country, specialty,
     *                       author_id, author_name, example_output
     *     Required for CONSULT_NOTE_TEMPLATE / DOCUMENT_TEMPLATE: structure
     *     Required for FORM_TEMPLATE: s3_object_key (the key returned by /upload-pdf)
     *     Optional columns: description, tone, url_path, html, template_json,
     *                       template_id, form_fields,
     *                       show_author_name, show_author_profile_picture, show_author_clinic,
     *                       author_profile_picture, clinic_id, clinic_name
     *
     *     ## form_fields
     *     For FORM_TEMPLATE rows: if `form_fields` is omitted, the PDF at
     *     `s3_object_key` is fetched and form_fields are extracted automatically.
     *     Provide `form_fields` to override the extractor (e.g. cleaned-up labels).
     *     In CSV, the cell must be a JSON-encoded array; in JSON, supply the array
     *     directly.
     *
     *     ## JSON Format
     *     Either an array of template objects or {"templates": [...]}
     *
     *     Returns validation results or creation results based on `execute` parameter.
     */
    post: operations['batch_upload_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/form-seo/{template_id}/seo-context:regenerate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Regenerate Seo Context */
    post: operations['regenerate_seo_context_api_v2_ml_scribe_internal_admin_form_seo__template_id__seo_context_regenerate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/form-seo/{template_id}/seo-content:regenerate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Regenerate Seo Content */
    post: operations['regenerate_seo_content_api_v2_ml_scribe_internal_admin_form_seo__template_id__seo_content_regenerate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/form-seo/{template_id}:save': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Save Form Seo */
    post: operations['save_form_seo_api_v2_ml_scribe_internal_admin_form_seo__template_id__save_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/form-seo/seo-context/bulk-upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Bulk Upload Seo Context */
    post: operations['bulk_upload_seo_context_api_v2_ml_scribe_internal_admin_form_seo_seo_context_bulk_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Teams */
    get: operations['list_teams_api_v2_ml_scribe_internal_admin_teams__get'];
    put?: never;
    /** Create Team */
    post: operations['create_team_api_v2_ml_scribe_internal_admin_teams__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/members/send-onboarding-email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Send Onboarding Email To Members */
    post: operations['send_onboarding_email_to_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_send_onboarding_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Details
     * @description get team details
     */
    get: operations['get_team_details_api_v2_ml_scribe_internal_admin_teams__team_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Team
     * @description delete team (orgs:write strict — super admin or any token with orgs:write; bare admin denied)
     */
    delete: operations['delete_team_api_v2_ml_scribe_internal_admin_teams__team_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Team Details
     * @description update team details
     */
    patch: operations['update_team_details_api_v2_ml_scribe_internal_admin_teams__team_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/member-history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Member History
     * @description Period-scoped member join/leave history ("bank statement") for a team — additions, removals, and a net-change summary. Reads audit-log member events, backfilled from historic membership records where the audit log has no coverage. Gated by basic-read (the same gate that controls viewing team members).
     */
    get: operations['get_team_member_history_api_v2_ml_scribe_internal_admin_teams__team_id__member_history_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Team Members
     * @description add team members
     */
    post: operations['add_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_post'];
    /**
     * Bulk Delete Team Members
     * @description bulk remove team members (registered users and/or invitations). Team owner is never removed.
     */
    delete: operations['bulk_delete_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/members/{member_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Team Member
     * @description delete team member (member or invitation)
     */
    delete: operations['delete_team_member_api_v2_ml_scribe_internal_admin_teams__team_id__members__member_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Team Member
     * @description update team member
     */
    patch: operations['update_team_member_api_v2_ml_scribe_internal_admin_teams__team_id__members__member_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/member/{member_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Team Member
     * @deprecated
     * @description delete team member (member or invitation)
     */
    delete: operations['delete_team_member_api_v2_ml_scribe_internal_admin_teams__team_id__member__member_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/members/move': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Move Team Members
     * @description Bulk move team members from one team to another in a single atomic operation. Team owner is never moved. If any move fails after others have already succeeded, all successfully moved members are rolled back to the source team.
     */
    post: operations['bulk_move_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_move_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/invitations/resend-all': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Resend All Pending Team Invitations
     * @description resend every pending team invitation in one pass
     */
    post: operations['resend_all_pending_team_invitations_api_v2_ml_scribe_internal_admin_teams__team_id__invitations_resend_all_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/invitations/resend': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Resend Selected Team Invitations
     * @description resend a caller-selected subset of pending team invitations
     */
    post: operations['resend_selected_team_invitations_api_v2_ml_scribe_internal_admin_teams__team_id__invitations_resend_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/mfa': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Mfa
     * @description enable/disable team MFA
     */
    patch: operations['update_team_mfa_api_v2_ml_scribe_internal_admin_teams__team_id__mfa_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/user-team-mapping/import': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Organization User Team Mapping
     * @description import organization team assignment user mapping
     */
    post: operations['import_organization_user_team_mapping_api_v2_ml_scribe_internal_admin_teams_user_team_mapping_import_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/user-team-mapping/export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Organization User Team Mapping
     * @description Export organization team assignment user mapping
     */
    get: operations['export_organization_user_team_mapping_api_v2_ml_scribe_internal_admin_teams_user_team_mapping_export_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/create-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create User
     * @description create user
     */
    post: operations['create_user_api_v2_ml_scribe_internal_admin_users_create_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/onboarding-email/send': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Onboarding Email
     * @description Send onboarding email to a user
     */
    post: operations['send_onboarding_email_api_v2_ml_scribe_internal_admin_users__user_ref_id__onboarding_email_send_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Details
     * @description Get user details
     */
    get: operations['get_user_details_api_v2_ml_scribe_internal_admin_users__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/teams': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Joined Teams
     * @description get user joined teams
     */
    get: operations['get_user_joined_teams_api_v2_ml_scribe_internal_admin_users__user_ref_id__teams_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/invitation-link': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Invitation Link
     * @description Get the user's active (non-expired, non-accepted) team invitation link for manual copy (IA-102).
     */
    get: operations['get_user_invitation_link_api_v2_ml_scribe_internal_admin_users__user_ref_id__invitation_link_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/name': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Change User Name
     * @description Change a user's first/last name (syncs to Kinde/Auth0 + Stripe)
     */
    patch: operations['change_user_name_api_v2_ml_scribe_internal_admin_users__user_ref_id__name_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/jurisdiction': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Change User Jurisdiction
     * @description Update a user's profile state/province (jurisdiction) and/or the Evidence-feature jurisdiction override (ISO 3166-2 codes). Each field is optional: omit to leave unchanged, send null/empty to clear.
     */
    patch: operations['change_user_jurisdiction_api_v2_ml_scribe_internal_admin_users__user_ref_id__jurisdiction_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/bulk-create-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Create User By Csv
     * @description create users in bulk by csv, including kinde user creation, csv need to have: email, first_name, last_name, role_id(could be null). If user already exists, this api won't update the user's attribute like first_name
     */
    post: operations['bulk_create_user_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_create_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/permanent': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete User And Data Permanently
     * @description permanently delete user and associated data
     */
    delete: operations['delete_user_and_data_permanently_api_v2_ml_scribe_internal_admin_users__user_ref_id__permanent_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/bulk-update-user-identity': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Bulk Update User Identity By Csv
     * @description bulk update user identity by csv
     */
    patch: operations['bulk_update_user_identity_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_update_user_identity_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/bulk-lookup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Lookup Users
     * @description Bulk lookup users by email. Accepts up to 1000 emails, returns one enriched result per requested email (request order preserved, duplicates deduped lowercased server-side).
     */
    post: operations['bulk_lookup_users_api_v2_ml_scribe_internal_admin_users_bulk_lookup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Users
     * @description List users with pagination and sorting, optionally filter by search keyword
     */
    get: operations['list_users_api_v2_ml_scribe_internal_admin_users_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/personalization-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Personalization Profile
     * @description Get user personalization profile
     */
    get: operations['get_user_personalization_profile_api_v2_ml_scribe_internal_admin_users__user_ref_id__personalization_profile_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/referral-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete User Referral Profile
     * @description Delete the referral profile from a user document
     */
    delete: operations['delete_user_referral_profile_api_v2_ml_scribe_internal_admin_users__user_ref_id__referral_profile_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_id}/reset-MFA': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Reset User Mfa
     * @description Reset MFA for a user by deleting their MFA from Kinde
     */
    delete: operations['reset_user_mfa_api_v2_ml_scribe_internal_admin_users__user_id__reset_MFA_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{kinde_user_id}/dictations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List a user's persisted dictation transcripts (PHI; audited)
     * @description SCR-6227: proxy a cursor page of the target user's persisted dictation transcripts from transcription-service. Requires an explicit phi:read claim; Admin and Super Admin roles do not bypass the gate. Every call is audit-logged before the upstream PHI request.
     */
    get: operations['get_user_dictations_api_v2_ml_scribe_internal_admin_users__kinde_user_id__dictations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{kinde_user_id}/dictations/{dictation_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get one dictation's diagnostic detail (PHI; audited)
     * @description Return one dictation's transcript and diagnostic events. Requires an explicit phi:read claim and audits before requesting upstream PHI.
     */
    get: operations['get_user_dictation_detail_api_v2_ml_scribe_internal_admin_users__kinde_user_id__dictations__dictation_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/migrate-to-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Trigger User To User Migration
     * @description Trigger a user-to-user migration. Migrates sessions, templates, patient profiles, and optionally team relations from one user to another within the same region. Runs the Airflow DAG by default; set use_temporal to run the equivalent Temporal workflow instead.
     */
    post: operations['trigger_user_to_user_migration_api_v2_ml_scribe_internal_admin_users_migrate_to_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/migrate-region': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Trigger User Region Migration
     * @description Trigger a user region migration. Migrates a user's entire data from one region to another. Runs the Airflow DAG by default; set use_temporal to run the equivalent Temporal workflow instead.
     */
    post: operations['trigger_user_region_migration_api_v2_ml_scribe_internal_admin_users_migrate_region_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/logout-everywhere': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Admin Logout User Everywhere
     * @description Force-log-out the target user from all devices. Revokes Auth0 sessions and refresh tokens, and marks all access tokens issued before this call as invalid.
     */
    post: operations['admin_logout_user_everywhere_api_v2_ml_scribe_internal_admin_users__user_ref_id__logout_everywhere_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workspaces': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Workspaces
     * @description List ALL workspaces globally (no current-user/workspace scoping) for support staff, with pagination, sorting, and optional keyword / member / member-count filters.
     */
    get: operations['list_workspaces_api_v2_ml_scribe_internal_admin_workspaces_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workspaces/{workspace_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Workspace Detail
     * @description Workspace detail for support staff — name, role=ADMIN members (with resolved display names), live member count, the teams that belong to the workspace, and its managed status with the key-contact emails. Those addresses are operational contact PII, not PHI, so they read on ``basic:read`` — the same tier the organisation detail route already returns them on. Editing them needs ``managed_enterprise:write``.
     */
    get: operations['get_workspace_detail_api_v2_ml_scribe_internal_admin_workspaces__workspace_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Workspace
     * @description Update a workspace's managed status and key contact emails (managed_enterprise:write). The workspace page is the only back-office place managed status is edited under the workspace-native model.
     */
    patch: operations['update_workspace_api_v2_ml_scribe_internal_admin_workspaces__workspace_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workspaces/{workspace_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Workspace Members
     * @description Paginated members of a workspace for support staff — each member's user ref, kinde id, resolved display name, workspace role, and teams. Optional ``keyword`` (name/email) and ``role`` filters narrow the list across the whole workspace before the page is sliced.
     */
    get: operations['list_workspace_members_api_v2_ml_scribe_internal_admin_workspaces__workspace_id__members_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-suspension/logs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Suspension Logs
     * @description List audit log entries for account-suspension actions.
     */
    get: operations['list_user_suspension_logs_api_v2_ml_scribe_internal_admin_user_suspension_logs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-suspension': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Suspended Users
     * @description List all currently suspended users (newest suspended first).
     */
    get: operations['list_suspended_users_api_v2_ml_scribe_internal_admin_user_suspension_get'];
    put?: never;
    /**
     * Set User Suspension
     * @description Suspend or restore a user account (account-level).
     */
    post: operations['set_user_suspension_api_v2_ml_scribe_internal_admin_user_suspension_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-suspension/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Suspension State
     * @description Get the account-suspension status (full payload incl. reason) for a user_ref_id. Requires BASIC_READ (or Super Admin / Admin via fallback).
     */
    get: operations['get_user_suspension_state_api_v2_ml_scribe_internal_admin_user_suspension__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/template-revisions/latest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Latest Template Revisions
     * @description Template revisions are snapshots of the template at a specific point in time.
     *     The latest template revision is the most recent snapshot of the template.
     *     Revisions can be filtered by review status, so admin can use this API to get all templates that require review, i.e., review_status=pending.
     */
    get: operations['get_latest_template_revisions_api_v2_ml_scribe_internal_admin_template_revisions_latest_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/template-revisions/{template_id}/revisions/{revision_number}/example-output-and-description': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Example Output
     * @description Generate example output for a template revision.
     */
    post: operations['generate_example_output_api_v2_ml_scribe_internal_admin_template_revisions__template_id__revisions__revision_number__example_output_and_description_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/template-revisions/{template_id}/revisions/{revision_number}/review-status/approve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Approve Template Revision
     * @description Approve a template revision for publishing.
     *     Better to always add example_output, description, url_path in payload.
     */
    post: operations['approve_template_revision_api_v2_ml_scribe_internal_admin_template_revisions__template_id__revisions__revision_number__review_status_approve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/template-revisions/{template_id}/revisions/{revision_number}/review-status/reject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Reject Template Revision
     * @description Reject a template revision from publishing.
     */
    post: operations['reject_template_revision_api_v2_ml_scribe_internal_admin_template_revisions__template_id__revisions__revision_number__review_status_reject_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/transcriptions-comparison': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Transcriber Comparison */
    post: operations['transcriber_comparison_api_v2_ml_scribe_internal_admin_transcriptions_comparison_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/direct-integration/user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Users With Direct Integration */
    get: operations['list_users_with_direct_integration_api_v2_ml_scribe_internal_admin_direct_integration_user_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/direct-integration/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Direct Integration Sessions By User */
    get: operations['list_direct_integration_sessions_by_user_api_v2_ml_scribe_internal_admin_direct_integration_sessions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Roles
     * @description list roles, used in IA update role
     */
    get: operations['get_roles_api_v2_ml_scribe_internal_admin_roles_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/roles/{role_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Role
     * @description update system role information
     */
    patch: operations['update_role_api_v2_ml_scribe_internal_admin_roles__role_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations-marketplace/{path}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Proxy Integrations Marketplace
     * @description Catch-all proxy endpoint that forwards all requests to the global service
     *     integrations marketplace with proper authentication.
     */
    get: operations['proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__get'];
    /**
     * Proxy Integrations Marketplace
     * @description Catch-all proxy endpoint that forwards all requests to the global service
     *     integrations marketplace with proper authentication.
     */
    put: operations['proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__put'];
    /**
     * Proxy Integrations Marketplace
     * @description Catch-all proxy endpoint that forwards all requests to the global service
     *     integrations marketplace with proper authentication.
     */
    post: operations['proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__post'];
    /**
     * Proxy Integrations Marketplace
     * @description Catch-all proxy endpoint that forwards all requests to the global service
     *     integrations marketplace with proper authentication.
     */
    delete: operations['proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__delete'];
    options?: never;
    head?: never;
    /**
     * Proxy Integrations Marketplace
     * @description Catch-all proxy endpoint that forwards all requests to the global service
     *     integrations marketplace with proper authentication.
     */
    patch: operations['proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{org_id}/teams': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Teams To Organization
     * @description Add teams to an organization
     */
    post: operations['add_teams_to_organization_api_v2_ml_scribe_internal_admin_organizations__org_id__teams_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{org_id}/teams/{team_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove Team From Organization
     * @description Remove a team from an organization
     */
    delete: operations['remove_team_from_organization_api_v2_ml_scribe_internal_admin_organizations__org_id__teams__team_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ehrlaunch-profile/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Ehrlaunch Profiles */
    get: operations['get_ehrlaunch_profiles_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__get'];
    put?: never;
    /** Create Ehrlaunch Profile */
    post: operations['create_ehrlaunch_profile_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ehrlaunch-profile/{profile_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Ehrlaunch Profile */
    get: operations['get_ehrlaunch_profile_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__profile_name__get'];
    put?: never;
    post?: never;
    /** Delete Ehrlaunch Profile */
    delete: operations['delete_ehrlaunch_profile_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__profile_name__delete'];
    options?: never;
    head?: never;
    /** Update Ehrlaunch Profile */
    patch: operations['update_ehrlaunch_profile_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__profile_name__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ehrlaunch-profile/group-profiles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Assign Profile Group */
    post: operations['assign_profile_group_api_v2_ml_scribe_internal_admin_ehrlaunch_profile_group_profiles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ehrlaunch-profile/group-profiles/list': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Profile Groups */
    get: operations['get_profile_groups_api_v2_ml_scribe_internal_admin_ehrlaunch_profile_group_profiles_list_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ehrlaunch-profile/group-profiles/{profile_group}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete Profile Group */
    delete: operations['delete_profile_group_api_v2_ml_scribe_internal_admin_ehrlaunch_profile_group_profiles__profile_group__delete'];
    options?: never;
    head?: never;
    /** Update Profile Group */
    patch: operations['update_profile_group_api_v2_ml_scribe_internal_admin_ehrlaunch_profile_group_profiles__profile_group__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{organization_id}/teams/{team_id}/members/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Member
     * @description Update team member roles
     */
    patch: operations['update_team_member_api_v2_ml_scribe_internal_admin_organizations__organization_id__teams__team_id__members__user_ref_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{organization_id}/teams/{team_id}/members/{relation_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove Member
     * @description remove team member from organization or child team
     */
    delete: operations['remove_member_api_v2_ml_scribe_internal_admin_organizations__organization_id__teams__team_id__members__relation_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{organization_id}/global-admins': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Global Admins
     * @description Add global admins to an organization
     */
    post: operations['add_global_admins_api_v2_ml_scribe_internal_admin_organizations__organization_id__global_admins_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{organization_id}/teams/{team_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Organization Members
     * @description Add members to a team of an organization
     */
    post: operations['add_organization_members_api_v2_ml_scribe_internal_admin_organizations__organization_id__teams__team_id__members_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{organization_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Organization Members
     * @description Get organization members with pagination
     */
    get: operations['list_organization_members_api_v2_ml_scribe_internal_admin_organizations__organization_id__members_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/organizations/{organization_id}/teams/{source_team_id}/members/{user_ref_id}/move': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Move Member Between Teams
     * @description Move a member from one team to another within the organization
     */
    post: operations['move_member_between_teams_api_v2_ml_scribe_internal_admin_organizations__organization_id__teams__source_team_id__members__user_ref_id__move_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/product/add-on': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Add On Products
     * @description internal admin get all add on products
     */
    get: operations['get_add_on_products_api_v2_ml_scribe_internal_admin_product_add_on_get'];
    put?: never;
    /**
     * Create Add On Product
     * @description internal admin create add on product
     */
    post: operations['create_add_on_product_api_v2_ml_scribe_internal_admin_product_add_on_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/product/add-on/{add_on_product_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Add On Product
     * @description update add on product
     */
    patch: operations['update_add_on_product_api_v2_ml_scribe_internal_admin_product_add_on__add_on_product_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/product/add-on/batch-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Batch Delete Add On Products
     * @description batch delete add on products
     */
    delete: operations['batch_delete_add_on_products_api_v2_ml_scribe_internal_admin_product_add_on_batch_delete_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-ehr-launch-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get User Ehr Launch Profiles */
    get: operations['get_user_ehr_launch_profiles_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_get'];
    put?: never;
    /** Create User Ehr Launch Profile */
    post: operations['create_user_ehr_launch_profile_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-ehr-launch-profile/import': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Create User Ehr Launch Profiles By Import
     * @description Bulk-create user EHR launch profiles (and mirror onboarding sessions) from a CSV. The CSV must have columns: 'User ID', 'Full Name', 'Position', 'Username', 'Email'. 'User ID' and 'Username' are both registered as internal IDs; 'Email' resolves the owning Heidi user. Pass execute=false to dry-run (validate only).
     */
    post: operations['bulk_create_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_import_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-ehr-launch-profile/bulk-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Delete User Ehr Launch Profiles By Import
     * @description Bulk hard-delete user EHR launch profiles (and the user's onboarding sessions for the matching provider) from a CSV. The CSV only needs an 'Email' column; 'profile_name' selects which profile/provider to delete. Only non-soft-deleted records are removed, permanently. Pass execute=false to dry-run (preview what would be deleted).
     */
    post: operations['bulk_delete_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_bulk_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-ehr-launch-profile/{user_ehr_launch_profile_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update User Ehr Launch Profile */
    patch: operations['update_user_ehr_launch_profile_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile__user_ehr_launch_profile_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-ehr-launch-profile/batch-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete User Ehr Launch Profile */
    delete: operations['delete_user_ehr_launch_profile_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_batch_delete_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-ehr-launch-profile/migration': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Migrate User Ehr Launch Profile */
    post: operations['migrate_user_ehr_launch_profile_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_migration_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/sso': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Sso Connections
     * @description List all available SSO connections
     */
    get: operations['list_sso_connections_api_v2_ml_scribe_internal_admin_sso_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/regional-sync/valid-collections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Valid Collections
     * @description Get list of collections that are valid targets for regional sync operations.
     */
    get: operations['get_valid_collections_api_v2_ml_scribe_internal_admin_regional_sync_valid_collections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/regional-sync/export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export Collection
     * @description Export the specified collection to JSON format for regional sync.
     */
    post: operations['export_collection_api_v2_ml_scribe_internal_admin_regional_sync_export_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/regional-sync/upsert': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upsert Collection
     * @description Accept JSON collection data and upsert it into the specified collection.
     */
    post: operations['upsert_collection_api_v2_ml_scribe_internal_admin_regional_sync_upsert_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/regional-sync/insert': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Insert Collection
     * @description Accept JSON collection data and insert only new documents, ignoring existing IDs.
     */
    post: operations['insert_collection_api_v2_ml_scribe_internal_admin_regional_sync_insert_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/system-template': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Template
     * @description Create a new template.
     */
    post: operations['create_template_api_v2_ml_scribe_internal_admin_system_template_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/system-template/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Update Template
     * @description Update an existing template
     */
    put: operations['update_template_api_v2_ml_scribe_internal_admin_system_template__template_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/system-template/by-tags': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Templates By Tags
     * @description Get templates by tags and experience modifiers with pagination and search.
     *
     *     This implements comprehensive tag-based template resolution logic where:
     *     - Templates are retrieved based on tag matching and experience modifiers
     *     - Experience modifiers (pinned, highlighted, featured, etc.) are applied
     *     - Templates are sorted by priority: pinned > highlighted > featured > regular
     *     - Results are paginated and can be filtered by search keyword
     */
    post: operations['get_templates_by_tags_api_v2_ml_scribe_internal_admin_system_template_by_tags_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/system-template/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Batch Delete Templates By Ids
     * @description Bulk delete multiple templates by their IDs.
     *
     *     Returns:
     *         - success_count: Number of templates successfully deleted
     *         - failed_count: Number of templates that failed to delete
     *         - failed_ids: List of template IDs that failed to delete
     *         - errors: List of error messages for failed deletions
     */
    delete: operations['batch_delete_templates_by_ids_api_v2_ml_scribe_internal_admin_system_template_batch_delete'];
    options?: never;
    head?: never;
    /**
     * Batch Update Templates By Ids
     * @description Batch update templates by their IDs with tag updates and field updates.
     *
     *     This endpoint allows updating tag connections and other fields for multiple templates at once.
     *     You can update any tag-related fields:
     *     - tags: Regular template tags
     *     - pinned_for_tags: Tags for which templates should be pinned
     *     - highlighted_for_tags: Tags for which templates should be highlighted
     *     - featured_for_tags: Tags for which templates are auto-generated
     *
     *     You can also update other fields like:
     *     - template_category: Template category
     *     - should_deduct_quota: Whether to deduct quota
     *
     *     Update types:
     *     - overwrite: Replace existing tags with new ones (default)
     *     - add: Preserve existing tags and add new ones
     *     - remove: Remove specified tags from templates without affecting other tags
     */
    patch: operations['batch_update_templates_by_ids_api_v2_ml_scribe_internal_admin_system_template_batch_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/system-template/{template_id}/versions/{version}/activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Set Active Template Version
     * @description Set a specific version as active for a template.
     */
    patch: operations['set_active_template_version_api_v2_ml_scribe_internal_admin_system_template__template_id__versions__version__activate_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/system-template/bulk-create-template': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Create Template By Csv
     * @description create templates in bulk by csv, csv needs to have: template_id, template_name, template_content, specialty_ids, languages, tiers, countries, regions, template_category. Only template_name and template_content are required. Other fields are optional and should be comma-separated values (except template_category which should be a single value). template_category defaults to CONSULT_NOTE_TEMPLATE if not provided. If template with same name already exists, this api will still create a new template.
     */
    post: operations['bulk_create_template_by_csv_api_v2_ml_scribe_internal_admin_system_template_bulk_create_template_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/system-template/form-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Form System Template
     * @description Create a new FORM system template with PDF upload.
     *
     *     This endpoint allows internal admins to create system templates with form fields
     *     extracted from uploaded PDF files. The PDF is stored in a public S3 bucket.
     */
    post: operations['create_form_system_template_api_v2_ml_scribe_internal_admin_system_template_form_templates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/specialties/with-template-counts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialties
     * @description get specialties with template counts
     */
    get: operations['get_specialties_api_v2_ml_scribe_internal_admin_specialties_with_template_counts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/specialties/by-group': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialties By Group
     * @description Get specialties organized by their specialty groups
     */
    get: operations['get_specialties_by_group_api_v2_ml_scribe_internal_admin_specialties_by_group_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/specialties/{specialty_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialty Detail
     * @description Get specialty details
     */
    get: operations['get_specialty_detail_api_v2_ml_scribe_internal_admin_specialties__specialty_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/content-translations/download': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download Content Translations
     * @description Download source strings for the translation partner — a zip with one {resource}/en.json per requested resource (all resources when omitted)
     */
    get: operations['download_content_translations_api_v2_ml_scribe_internal_admin_content_translations_download_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/content-translations/upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Content Translations
     * @description Upload translated locale files (zip built by the translation partner, entries at {resource}/{locale}.json)
     */
    post: operations['upload_content_translations_api_v2_ml_scribe_internal_admin_content_translations_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/template-mappings/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template Mappings
     * @description Get template mappings
     *
     *     If template_id is provided, returns a single mapping.
     *     If only kinde_user_id is provided, returns all mappings for that user.
     */
    get: operations['get_template_mappings_api_v2_ml_scribe_internal_admin_template_mappings__get'];
    put?: never;
    /**
     * Create Template Mapping
     * @description Create or update a template mapping
     *
     *     If a mapping already exists for the given kinde_user_id and template_id,
     *     it will be updated with the new section_mappings.
     */
    post: operations['create_template_mapping_api_v2_ml_scribe_internal_admin_template_mappings__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/onboarding-session': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Onboarding Sessions
     * @description Search onboarding sessions with pagination. `kinde_user_id` is optional: omitted lists all sessions across workspaces.
     */
    get: operations['search_onboarding_sessions_api_v2_ml_scribe_internal_admin_integrations_onboarding_session_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/onboarding-session/{onboarding_session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Onboarding Session
     * @description Get a specific onboarding session with functionality details
     */
    get: operations['get_onboarding_session_api_v2_ml_scribe_internal_admin_integrations_onboarding_session__onboarding_session_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Onboarding Session
     * @description Delete an onboarding session
     */
    delete: operations['delete_onboarding_session_api_v2_ml_scribe_internal_admin_integrations_onboarding_session__onboarding_session_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/onboarding-session/providers/all': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Providers
     * @description Get all providers
     */
    get: operations['get_providers_api_v2_ml_scribe_internal_admin_integrations_onboarding_session_providers_all_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/template-inspector/health': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Health
     * @description Health check for the template inspector scaffold.
     */
    get: operations['get_health_api_v2_ml_scribe_internal_admin_integrations_template_inspector_health_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/template-inspector/{template_id}/apply': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Post Apply
     * @description Apply a headered template migration: audit intent first, insert a pending snapshot, write through the MLS-008 dedicated conditional primitive with SHA-256 concurrency control, flip the snapshot to applied, and audit the outcome.  Returns 409 on hash mismatch or duplicate attempt_id.  Requires TEMPLATES_WRITE with allow_admin_fallback=False.
     */
    post: operations['post_apply_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__apply_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/template-inspector/example-output': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Post Example Output
     * @description Generate an example note from an inline structure_template without creating revisions or touching the gallery.  The structure_template in the request body is the source of truth. Optional template_id + kinde_user_id enable a section-destination mapping join.  Content policy: structure_template is forwarded verbatim to the LLM provider — send structural template content only, never real patient data.
     */
    post: operations['post_example_output_api_v2_ml_scribe_internal_admin_integrations_template_inspector_example_output_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/template-inspector/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Join Inspector
     * @description Get the joined inspector view for a single template: live structure_template, parser-computed sections with look-alike detection, section mappings, four-state status, content hash, and owner identity.
     */
    get: operations['get_join_inspector_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/template-inspector/{template_id}/preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Post Draft Preview
     * @description Recompute sections, status and destination names from a draft template body without writing anything.  The response content_hash is the STORED template hash, not a hash of the draft body.  Readiness is carried by status; per-heading detail by sections[].destination_name.
     */
    post: operations['post_draft_preview_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__preview_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/template-inspector': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template Inspector Queue
     * @description List every live template with page-local computed migration status. Optional cohort_kinde_user_ids narrows by owner. Omitted, every live template in this cell is listed. Search is indexed equality only (template id, clinician id, or exact email).
     */
    get: operations['get_template_inspector_queue_api_v2_ml_scribe_internal_admin_integrations_template_inspector_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/template-inspector/{template_id}/revert': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Post Revert
     * @description Revert a template migration from an applied snapshot.  Audits the intent first, inserts a pending revert attempt keyed on attempt_id, restores structure_template + template_json + template_html + mappings to the snapshot's pre-apply state via the conditional write primitive and replace_template_section_mapping, audits the outcome, then consumes the source snapshot.  Returns 409 on hash mismatch or duplicate attempt_id.  Requires TEMPLATES_WRITE with allow_admin_fallback=False.
     */
    post: operations['post_revert_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__revert_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integrations/template-inspector/{template_id}/suggest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Post Suggest
     * @description Suggest heading insertion positions for a stored template via LLMClient.  Returns insertion_points only (never a rewritten body), inserts a status=suggested snapshot, and never mutates the clinician template.  Requires TEMPLATES_WRITE with allow_admin_fallback=False.
     */
    post: operations['post_suggest_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__suggest_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/mk-template-requests/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Mk Template Requests
     * @description List all MK custom template requests with optional filtering and search.
     *
     *     Available for Internal Admin staff to view and manage template requests.
     */
    get: operations['list_mk_template_requests_api_v2_ml_scribe_internal_admin_mk_template_requests__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/mk-template-requests/{request_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Mk Template Request Admin
     * @description Get a specific MK custom template request by ID (Internal Admin).
     *
     *     Includes presigned URL for PDF viewing if available.
     */
    get: operations['get_mk_template_request_admin_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__get'];
    put?: never;
    post?: never;
    /**
     * Soft Delete Mk Template Request
     * @description Soft delete an MK custom template request.
     *
     *     The request will be marked as deleted but not removed from the database.
     */
    delete: operations['soft_delete_mk_template_request_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/mk-template-requests/{request_id}/accept': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Accept Mk Template Request
     * @description Accept an MK custom template request and assign it to the current MK staff member.
     *
     *     Changes status from PENDING to IN_PROGRESS.
     */
    post: operations['accept_mk_template_request_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__accept_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/mk-template-requests/{request_id}/complete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Complete Mk Template Request
     * @description Mark an MK custom template request as completed.
     *
     *     Changes status from IN_PROGRESS to COMPLETED and links the created template.
     */
    post: operations['complete_mk_template_request_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__complete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/mk-template-requests/{request_id}/reject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Reject Mk Template Request
     * @description Reject an MK custom template request.
     *
     *     Changes status to REJECTED. Cannot reject requests that are already COMPLETED.
     */
    post: operations['reject_mk_template_request_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__reject_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/quota/reset-user-quota': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Reset User Quota
     * @description Reset a user's quota to default values. This is an authenticated API for Airflow scheduler.
     */
    post: operations['reset_user_quota_api_v2_ml_scribe_internal_admin_quota_reset_user_quota_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/quota/reset-all-users-quota': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Reset All Users Quota
     * @description Reset every active user's quota to default values in a single bulk operation. This is an authenticated API for the Airflow scheduler's monthly quota reset, replacing the per-user reset loop.
     */
    post: operations['reset_all_users_quota_api_v2_ml_scribe_internal_admin_quota_reset_all_users_quota_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/metrics': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: list all billable metrics (active + inactive) */
    get: operations['list_billable_metrics_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics_get'];
    put?: never;
    /** Admin: register a new billable metric */
    post: operations['register_billable_metric_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/metrics/options': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: form options for registering a billable metric */
    get: operations['get_billable_metric_options_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics_options_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/metrics/{metric_key}/limits': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: list the named limits defined against a metric */
    get: operations['list_metric_limits_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__limits_get'];
    put?: never;
    /**
     * Admin: create a named limit for an existing metric
     * @description Create a **named** limit against an existing meter.
     *
     *     Two-step flow: `POST /metrics` creates the meter, then this creates a
     *     named limit referencing it. Many named limits may share one meter.
     *     POST-create semantics — 404 if the meter doesn't exist, 409 if the
     *     `limit_key` is taken (editing is a separate, deferred op), 422 if a
     *     `metered_overage` limit is requested for a meter with no active meter
     *     binding (overage with nothing to bill).
     */
    post: operations['create_metric_limit_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__limits_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/assignments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: list limit assignments (filter by scope_type / scope_id / limit_key) */
    get: operations['list_assignments_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments_get'];
    put?: never;
    /** Admin: assign a named limit to a principal */
    post: operations['create_assignment_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/assignments/{assignment_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: get a single limit assignment */
    get: operations['get_assignment_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments__assignment_id__get'];
    put?: never;
    post?: never;
    /** Admin: delete a limit assignment */
    delete: operations['delete_assignment_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments__assignment_id__delete'];
    options?: never;
    head?: never;
    /** Admin: update a limit assignment (mode / window / is_active / reason) */
    patch: operations['update_assignment_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments__assignment_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/service-meter-bindings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: list service→meter bindings (filter by product / feature) */
    get: operations['list_service_meter_bindings_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings_get'];
    put?: never;
    /** Admin: bind a (product, feature) action to meter(s) */
    post: operations['create_service_meter_binding_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/service-meter-bindings/options': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Admin: the supported (product, feature) actions a binding may target
     * @description The closed allowlist of bindable actions — the admin UI offers exactly
     *     these as one picker choice, so a binding can't name a meaningless pair.
     */
    get: operations['list_supported_service_actions_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings_options_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/service-meter-bindings/{binding_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: get a single service→meter binding */
    get: operations['get_service_meter_binding_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings__binding_id__get'];
    put?: never;
    post?: never;
    /** Admin: delete a binding (ungates the action → safe-open allow) */
    delete: operations['delete_service_meter_binding_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings__binding_id__delete'];
    options?: never;
    head?: never;
    /** Admin: replace a binding's meters / description */
    patch: operations['update_service_meter_binding_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings__binding_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/metrics/{metric_key}/meter': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: read the active meter binding for a metric */
    get: operations['get_metric_meter_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__meter_get'];
    put?: never;
    /** Admin: bind an existing Stripe meter to a metric (make billable) */
    post: operations['link_metric_meter_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__meter_post'];
    delete?: never;
    options?: never;
    head?: never;
    /** Admin: deactivate a metric's meter binding (egress kill-switch) */
    patch: operations['update_metric_meter_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__meter_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/metered-billing/enrol': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Admin: enrol a user/organization into metered billing for a metric */
    post: operations['enrol_metered_billing_api_v2_ml_scribe_internal_admin_usage_entitlements_metered_billing_enrol_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/metered-billing/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: per-target metered-item attachment status */
    get: operations['get_metered_billing_status_api_v2_ml_scribe_internal_admin_usage_entitlements_metered_billing_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/metered-billing/egress:run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Admin: run the usage→Stripe meter-events egress now */
    post: operations['run_usage_meter_event_egress_api_v2_ml_scribe_internal_admin_usage_entitlements_metered_billing_egress_run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/credit-grants/reconcile:run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Admin: run the per-cycle credit-grant reconciler now */
    post: operations['run_credit_grant_reconciler_api_v2_ml_scribe_internal_admin_usage_entitlements_credit_grants_reconcile_run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/users/{kinde_user_id}/{metric_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: usage for one user in one cycle */
    get: operations['get_user_entitlement_api_v2_ml_scribe_internal_admin_usage_entitlements_users__kinde_user_id___metric_key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/organizations/{organization_id}/{metric_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: usage for one organization in one cycle (team aggregation) */
    get: operations['get_organization_entitlement_api_v2_ml_scribe_internal_admin_usage_entitlements_organizations__organization_id___metric_key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/workspaces/{workspace_id}/{metric_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: usage for one workspace in one cycle (team aggregation) */
    get: operations['get_workspace_entitlement_api_v2_ml_scribe_internal_admin_usage_entitlements_workspaces__workspace_id___metric_key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/users/{kinde_user_id}/{metric_key}/history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: per-cycle usage history for one user */
    get: operations['get_user_entitlement_history_api_v2_ml_scribe_internal_admin_usage_entitlements_users__kinde_user_id___metric_key__history_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/organizations/{organization_id}/{metric_key}/history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: per-cycle usage history for one organization */
    get: operations['get_organization_entitlement_history_api_v2_ml_scribe_internal_admin_usage_entitlements_organizations__organization_id___metric_key__history_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/usage-entitlements/workspaces/{workspace_id}/{metric_key}/history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: per-cycle usage history for one workspace */
    get: operations['get_workspace_entitlement_history_api_v2_ml_scribe_internal_admin_usage_entitlements_workspaces__workspace_id___metric_key__history_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/wallet/provision': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Admin: provision a workspace's credit wallet (idempotent)
     * @description Create the workspace's wallet if absent, else return the existing one.
     *
     *     Rejects a workspace_id that doesn't resolve to a real workspace (malformed →
     *     400, unknown → 404) so a typo can't mint an orphan wallet. The wallet service
     *     is a pure ledger primitive that doesn't cross-check the workspace, so this
     *     guard lives at the router, resolving the workspace through `WorkspaceService`.
     *     Idempotent (twice → one wallet). `billing_account_id` is applied only on
     *     first creation; on an existing wallet it is ignored.
     */
    post: operations['provision_wallet_api_v2_ml_scribe_internal_admin_wallet_provision_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/wallet/topup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Admin: credit a wallet (top-up) */
    post: operations['topup_wallet_api_v2_ml_scribe_internal_admin_wallet_topup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/wallet/adjust': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Admin: balance adjustment (explicit credit or debit) */
    post: operations['adjust_wallet_api_v2_ml_scribe_internal_admin_wallet_adjust_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/wallet/burn:run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Admin: run the metered burn over a window (on-demand trigger)
     * @description Sweep a window of usage, price it, and post one consumption row per
     *     eligible event.
     *
     *     **Enrolment is the gate, not a feature flag.** A burn reaches the ledger only
     *     where a workspace holds an active wallet AND a contract covering the event's
     *     business time, and both are created deliberately through this same admin
     *     surface. A flag on top would be a second, weaker gate over a real one — and
     *     one more thing to remember. Every run is written to the enterprise audit log
     *     with the acting admin, which is the control that matters for a manual
     *     money-shaped action — including a run that fails part-way, which is when
     *     knowing who triggered it matters most.
     *
     *     Safe to re-run: every write dedups on the usage event's own id, so repeating
     *     a window — or overlapping one the schedule already covered — writes no second
     *     row and moves no balance. Measure-only, as everywhere else on this path.
     *
     *     Runs synchronously, so a wide window can outlast the gateway timeout. The
     *     sweep continues server-side and is idempotent, so the caller re-runs and
     *     converges rather than losing work — but prefer narrow ranges here and leave
     *     the long catch-ups to the scheduled run, which will not be bound by an HTTP
     *     request's lifetime.
     */
    post: operations['run_metered_burn_api_v2_ml_scribe_internal_admin_wallet_burn_run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/wallet/{workspace_id}/balance': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: per-currency wallet balances */
    get: operations['get_wallet_balance_api_v2_ml_scribe_internal_admin_wallet__workspace_id__balance_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/wallet/{workspace_id}/transactions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Admin: wallet ledger history (newest-first; filterable, paged)
     * @description One wallet's ledger, newest-first.
     *
     *     Every consumption row carries the stamp that explains it — the product and
     *     dimension combination that matched, the rate, what the quantity counts, the
     *     pinned card version, and whose usage it was — so a client can render *why*
     *     a burn cost what it cost without a second lookup. `rate_card_key` +
     *     `rate_card_version` address the exact pricing via
     *     `GET /rating/rate-cards/{key}/versions/{version}` when the rule itself is
     *     wanted; that version is immutable, so it caches indefinitely.
     */
    get: operations['list_wallet_transactions_api_v2_ml_scribe_internal_admin_wallet__workspace_id__transactions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/wallet/burn-stream:probe': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * DEV-ONLY: emit a synthetic usage event and report whether it reached the burn stream
     * @description Drive the real emit path once and report what reached Redis.
     *
     *     DEVELOPMENT SCAFFOLDING — delete with this module once the burn pipeline is
     *     finished. Writes a real (synthetic) usage event and a real stream entry;
     *     refuses outside development stages.
     *
     *     Deliberately goes through `UsageEmitter.emit` rather than calling the
     *     publisher directly: the open question this answers is whether the WIRING
     *     works in a deployed build, and calling the publisher alone would skip the one
     *     line that could be missing.
     *
     *     Pass `idempotency_source` to pin the transaction id — that is how the dedup
     *     short-circuit is exercised, since a repeat must write nothing and publish
     *     nothing. Omit it and each call is a fresh event.
     *
     *     `product` is required, and naming one a rate card prices is what turns this
     *     from a publish probe into an end-to-end one: the streaming worker then rates
     *     the event and writes a consumption row. Name one no card prices and the
     *     event is published and passed over, which is the other half of the demo.
     */
    post: operations['probe_burn_stream_api_v2_ml_scribe_internal_admin_wallet_burn_stream_probe_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/wallet/burn-stream:peek': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * DEV-ONLY: read the burn stream's depth and newest entries
     * @description Read the stream without touching it. Writes nothing.
     *
     *     DEVELOPMENT SCAFFOLDING — delete with this module once the burn pipeline is
     *     finished.
     *
     *     The observer half, and it earns its place twice over. Called before a probe
     *     it gives a baseline, so any growth is attributable rather than assumed;
     *     called after, it is a SEPARATE request reading the entries back, which is the
     *     only thing that distinguishes "the entry is in Redis" from "a request could
     *     see its own write". It will also be how the streaming consumer's backlog is
     *     inspected while that work is in progress.
     */
    get: operations['peek_burn_stream_api_v2_ml_scribe_internal_admin_wallet_burn_stream_peek_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rating/catalog-products': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: list catalog products */
    get: operations['list_catalog_products_api_v2_ml_scribe_internal_admin_rating_catalog_products_get'];
    put?: never;
    /** Admin: add a product to the rating catalog */
    post: operations['create_catalog_product_api_v2_ml_scribe_internal_admin_rating_catalog_products_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rating/catalog-products/options': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Admin: the dimension keys a catalog product may offer
     * @description The closed allowlist, so the admin UI offers exactly these keys.
     *
     *     Dimension *values* are deliberately not served — they are free text and the
     *     backend does not know the legal set (model ids move faster than deploys).
     */
    get: operations['list_catalog_product_options_api_v2_ml_scribe_internal_admin_rating_catalog_products_options_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rating/catalog-products/{product_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: get one catalog product */
    get: operations['get_catalog_product_api_v2_ml_scribe_internal_admin_rating_catalog_products__product_key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Admin: edit a catalog product (is_active:false deactivates it) */
    patch: operations['update_catalog_product_api_v2_ml_scribe_internal_admin_rating_catalog_products__product_key__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rating/rate-cards': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Admin: list rate cards (first N by key) at the version in effect
     * @description One row per card — the version in effect — with its pricing, ordered by
     *     key.
     *
     *     The first `limit` keys alphabetically, with no cursor: cards past the cap
     *     are not reachable here, and nothing in the response says so. That is fine
     *     while the catalogue is small and is the thing to revisit first if it is
     *     not. Bounded harder than the history read because every row's pricing
     *     travels with it. A card with no active version is absent, matching what
     *     `GET /rate-cards/{rate_card_key}` says about it. For one card's history use
     *     `GET /rate-cards/{rate_card_key}/versions`.
     */
    get: operations['list_rate_cards_api_v2_ml_scribe_internal_admin_rating_rate_cards_get'];
    put?: never;
    /** Admin: create a rate card (version 1) */
    post: operations['create_rate_card_api_v2_ml_scribe_internal_admin_rating_rate_cards_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rating/rate-cards/{rate_card_key}/versions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Admin: list one rate card's versions, newest first
     * @description The audit trail for one card. Rows are not included — a card may price
     *     thousands and this lists many versions of it; read a version for those.
     *
     *     An unknown key is an empty list, not a 404: "nothing has been published
     *     here" is the same answer either way.
     */
    get: operations['list_rate_card_versions_api_v2_ml_scribe_internal_admin_rating_rate_cards__rate_card_key__versions_get'];
    put?: never;
    /**
     * Admin: publish the next version of a rate card
     * @description Append the next version and make it the one in effect.
     *
     *     The body is the whole row set, not a patch: a version is a complete
     *     statement of the card's pricing, and every entry re-copies how its product
     *     is measured from the catalog as it stands now.
     */
    post: operations['publish_rate_card_version_api_v2_ml_scribe_internal_admin_rating_rate_cards__rate_card_key__versions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rating/rate-cards/{rate_card_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: get the rate-card version currently in effect */
    get: operations['get_latest_rate_card_api_v2_ml_scribe_internal_admin_rating_rate_cards__rate_card_key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rating/rate-cards/{rate_card_key}/versions/{version}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Admin: get one specific rate-card version
     * @description The audit view: what a consumption transaction stamped with this version
     *     was actually priced against.
     */
    get: operations['get_rate_card_version_api_v2_ml_scribe_internal_admin_rating_rate_cards__rate_card_key__versions__version__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/contracts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Admin: list contracts by workspace or by rate card
     * @description One workspace's enrolment history, or every contract on one card.
     *
     *     Exactly one filter, because the two answer different questions and there is
     *     no "all contracts" read behind them: `?workspace_id=` is the term history an
     *     admin reads before adding the next one, `?rate_card_key=` is the
     *     impact-analysis read before publishing a version that reprices a card.
     *
     *     `limit` bounds the by-card read only. A workspace holds one contract per
     *     term, so its history is small forever; a card's contracts grow with every
     *     workspace enrolled on it and have no natural ceiling. Capping the first
     *     would hide terms from the admin reading a single workspace's history —
     *     which is the one place the whole list is the answer.
     *
     *     Unlike the write routes, `workspace_id` is not resolved to a real workspace
     *     here: a read does not need the lookup, so a malformed or unknown id is an
     *     empty list rather than a 400/404.
     */
    get: operations['list_contracts_api_v2_ml_scribe_internal_admin_contracts_get'];
    put?: never;
    /**
     * Admin: enrol a workspace on a rate card (provisions its wallet)
     * @description Enrol a workspace for a term, provisioning its wallet first. This is also
     *     how a renewal is expressed — a new contract following the prior one, with
     *     both rows retained.
     *
     *     Provisioning is idempotent and takes no wallet attributes: a workspace that
     *     needs its wallet created with specific ones should go through
     *     `POST /wallet/provision` first, since that endpoint applies them on first
     *     creation only.
     */
    post: operations['create_contract_api_v2_ml_scribe_internal_admin_contracts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/contracts/{contract_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Admin: repoint or re-window a contract
     * @description Apply a partial update to an existing contract.
     *
     *     The workspace is not re-checked: the contract named in the path is the
     *     resource, and it could only exist for a workspace that resolved when it was
     *     created.
     */
    patch: operations['edit_contract_api_v2_ml_scribe_internal_admin_contracts__contract_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/contracts/{contract_id}:resync-rate-card': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Admin: move a contract to a card's latest active version
     * @description Re-pin the contract to a card's current latest active version — the card
     *     it already names, or another one named in the body.
     *
     *     The body is optional: `POST` with none means "make my current card
     *     current". This is the only gesture that takes a card without a version;
     *     `PATCH` requires the pair. Why the split exists is on
     *     `ContractService.resync_rate_card`.
     */
    post: operations['resync_rate_card_api_v2_ml_scribe_internal_admin_contracts__contract_id__resync_rate_card_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/contracts/{contract_id}:archive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Admin: void a contract (one-way; there is no un-archive)
     * @description Void a contract that should never have applied — see
     *     `ContractService.archive_contract` for why there is no route back.
     *
     *     Nothing already charged is affected: a recorded consumption transaction
     *     carries the card key and version it priced with.
     */
    post: operations['archive_contract_api_v2_ml_scribe_internal_admin_contracts__contract_id__archive_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/allowance-policies': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: list per-member credit allowance policies */
    get: operations['list_allowance_policies_api_v2_ml_scribe_internal_admin_allowance_policies_get'];
    put?: never;
    /** Admin: create a per-member credit allowance policy */
    post: operations['create_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/allowance-policies:resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Admin: resolve a per-member credit allowance policy */
    get: operations['resolve_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies_resolve_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/allowance-policies/{policy_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Admin: update a per-member credit allowance policy */
    patch: operations['update_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies__policy_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/allowance-policies/{policy_id}:enable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Admin: enable a per-member credit allowance policy */
    post: operations['enable_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies__policy_id__enable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/allowance-policies/{policy_id}:disable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Admin: disable a per-member credit allowance policy */
    post: operations['disable_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies__policy_id__disable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/template-creation-records': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Template Creation Records
     * @description List template creation records by user_ref_id
     */
    get: operations['list_template_creation_records_api_v2_ml_scribe_internal_admin_template_creation_records_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/template-creation-records/{record_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template Creation Record
     * @description Get a template creation record with its version controls by ID
     */
    get: operations['get_template_creation_record_api_v2_ml_scribe_internal_admin_template_creation_records__record_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/cqc-practices/upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Cqc Practices Csv
     * @description Upload CQC practices CSV file. Replaces all existing records.
     */
    post: operations['upload_cqc_practices_csv_api_v2_ml_scribe_internal_admin_cqc_practices_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/cqc-practices/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Cqc Practices Stats
     * @description Get statistics about the CQC practices collection.
     */
    get: operations['get_cqc_practices_stats_api_v2_ml_scribe_internal_admin_cqc_practices_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/scripts/available': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Available Scripts
     * @description List the whitelisted script names that /execute accepts, each with a blast-radius classification so operators can see which scripts fan out across all workspaces before running one. Backs the internal-admin Run Scripts UI script picker.
     */
    get: operations['list_available_scripts_api_v2_ml_scribe_internal_admin_scripts_available_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/scripts/execute': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Execute Script
     * @description Execute a whitelisted script with optional parameters. Set async_execution=true to run fire-and-forget for long scripts (returns 202 Accepted with an execution_id; result lands in logs).
     */
    post: operations['execute_script_api_v2_ml_scribe_internal_admin_scripts_execute_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/scripts/airflow-execute': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Airflow Execute Script
     * @description Execute a whitelisted verify-workspace script. Authenticated via the Airflow Auth0 M2M token (scope `migrations:export` reused as a placeholder; see TODO MUL-2100). The whitelist is the dedicated AIRFLOW_AVAILABLE_SCRIPTS subset, not the full AVAILABLE_SCRIPTS registry used by the super-admin path. Synchronous only — async execution is not supported here, and the `async_execution` field on the request body is ignored. Application-level failures (whitelist miss, script exception, partial failure) return HTTP 200 with `success=False` + `error_message` rather than raising 4xx/5xx.
     */
    post: operations['airflow_execute_script_api_v2_ml_scribe_internal_admin_scripts_airflow_execute_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-subscriptions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Evidence Subscriptions
     * @description List users with evidence subscription information.
     */
    get: operations['list_evidence_subscriptions_api_v2_ml_scribe_internal_admin_evidence_subscriptions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-subscriptions/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Update Subscription
     * @description Update evidence subscription for a user.
     */
    post: operations['update_subscription_api_v2_ml_scribe_internal_admin_evidence_subscriptions__user_ref_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/internal-test/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Internal Test User
     * @description Create a new user for internal testing with configurable subscription tier
     */
    post: operations['create_internal_test_user_api_v2_ml_scribe_internal_admin_internal_test_users_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/internal-test/users/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Internal Test User
     * @description Delete an internal test user (idempotent)
     */
    delete: operations['delete_internal_test_user_api_v2_ml_scribe_internal_admin_internal_test_users__user_ref_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Internal Test User
     * @description Adjust an internal test user's properties (tier, plan dates, quota)
     */
    patch: operations['update_internal_test_user_api_v2_ml_scribe_internal_admin_internal_test_users__user_ref_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/internal-test/users/db-only': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Internal Test User Db Only
     * @description Create an internal test user in MongoDB/Stripe only (no Kinde/Auth0). Returns a synthetic kinde_id meant to be asserted into the access token via a shared-Auth0 post-login Action for e2e impersonation.
     */
    post: operations['create_internal_test_user_db_only_api_v2_ml_scribe_internal_admin_internal_test_users_db_only_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/internal-test/provision': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Provision Test Environment
     * @description Create a team/org for already-provisioned test users (looked up by email)
     */
    post: operations['provision_test_environment_api_v2_ml_scribe_internal_admin_internal_test_provision_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/internal-test/teardown': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Teardown Test Environment
     * @description Tear down a previously provisioned test environment (idempotent)
     */
    post: operations['teardown_test_environment_api_v2_ml_scribe_internal_admin_internal_test_teardown_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/internal-test/teams/{team_id}/template/default': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Internal Test Team Default Template
     * @description Create a team template for a team created by the E2E helper.
     */
    post: operations['create_internal_test_team_default_template_api_v2_ml_scribe_internal_admin_internal_test_teams__team_id__template_default_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/internal-test/ehr/scenario': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ehr Scenario
     * @description Seed, inspect or clear a named scenario in an EHR vendor sandbox. Preview/sandbox environments only.
     */
    post: operations['ehr_scenario_api_v2_ml_scribe_internal_admin_internal_test_ehr_scenario_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/intercom/user_hash': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Intercom User Hash
     * @description Get Intercom identity verification hash for the authenticated user.
     *
     *     Uses the uid from the access token to generate the HMAC hash.
     */
    get: operations['get_intercom_user_hash_api_v2_ml_scribe_internal_admin_intercom_user_hash_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/intercom/ticket-types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Intercom Ticket Types
     * @description List all Intercom ticket types.
     */
    get: operations['get_intercom_ticket_types_api_v2_ml_scribe_internal_admin_intercom_ticket_types_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/intercom/ticket-types/{ticket_type_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Intercom Ticket Type
     * @description Get a single ticket type by ID (includes attributes for dynamic form).
     */
    get: operations['get_intercom_ticket_type_api_v2_ml_scribe_internal_admin_intercom_ticket_types__ticket_type_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/intercom/ticket-types/by-name/quality-investigation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Quality Investigation Ticket Type
     * @description Get the Quality Investigation ticket type by name.
     *     Returns the full ticket type schema for building a dynamic form.
     */
    get: operations['get_quality_investigation_ticket_type_api_v2_ml_scribe_internal_admin_intercom_ticket_types_by_name_quality_investigation_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/intercom/tickets/quality-investigation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Quality Investigation Ticket
     * @description Create a Quality Investigation ticket on behalf of a customer.
     *
     *     Uses conversation-first flow to support multiple participants:
     *     1. Create conversation with customer
     *     2. Add submitting CSM as participant (so they receive updates)
     *     3. Convert conversation to ticket with provided attributes
     *
     *     This achieves the same end state as create_ticket with multiple contacts,
     *     which the Create Ticket API does not support (only 1 contact allowed).
     */
    post: operations['create_quality_investigation_ticket_api_v2_ml_scribe_internal_admin_intercom_tickets_quality_investigation_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/collections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Collections
     * @description List all collections for a user.
     */
    get: operations['list_user_collections_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections_get'];
    put?: never;
    /**
     * Create User Collection
     * @description Create a collection on behalf of a user.
     */
    post: operations['create_user_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/collections/{collection_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Collection
     * @description Get collection details for a user.
     */
    get: operations['get_user_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete User Collection
     * @description Delete a collection on behalf of a user.
     */
    delete: operations['delete_user_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update User Collection
     * @description Update a collection on behalf of a user.
     */
    patch: operations['update_user_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/collections/{collection_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Documents To Collection
     * @description Add documents to a collection on behalf of a user.
     */
    post: operations['add_documents_to_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/collections/{collection_id}/documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove Document From Collection
     * @description Remove a document from a collection on behalf of a user.
     */
    delete: operations['remove_document_from_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__documents__document_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Documents
     * @description List all documents for a user.
     */
    get: operations['list_user_documents_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/documents-and-jobs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Documents And Jobs
     * @description List documents and active jobs for a user.
     */
    get: operations['list_user_documents_and_jobs_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_and_jobs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/documents/upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Document For User
     * @description Upload a document on behalf of a user.
     */
    post: operations['upload_document_for_user_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/documents/{document_id}/download-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Document Download Url
     * @description Get a download URL for a user's document.
     */
    get: operations['get_document_download_url_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents__document_id__download_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete User Document
     * @description Delete a document on behalf of a user.
     */
    delete: operations['delete_user_document_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents__document_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/jobs/{job_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete User Job
     * @description Delete an ingestion job (any status) on behalf of a user.
     */
    delete: operations['delete_user_job_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__jobs__job_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/source-lists': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Source Lists
     * @description List all source lists for a user.
     */
    get: operations['list_user_source_lists_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists_get'];
    put?: never;
    /**
     * Create User Source List
     * @description Create a source list on behalf of a user.
     */
    post: operations['create_user_source_list_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-library/{user_ref_id}/source-lists/{source_list_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Source List
     * @description Get a source list for a user.
     */
    get: operations['get_user_source_list_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists__source_list_id__get'];
    /**
     * Update User Source List
     * @description Update a source list on behalf of a user.
     */
    put: operations['update_user_source_list_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists__source_list_id__put'];
    post?: never;
    /**
     * Delete User Source List
     * @description Delete a source list on behalf of a user.
     */
    delete: operations['delete_user_source_list_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists__source_list_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-sync/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Partner Sync Status
     * @description Aggregate partner library sync status from evidence_sync_runs, mims_sync_jobs, and emg_sync_metadata.
     */
    get: operations['get_partner_sync_status_api_v2_ml_scribe_internal_admin_evidence_sync_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-sync/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Partner Sync Runs
     * @description Paginated partner sync run history from evidence_sync_runs. Non-partner script executions (partner null) are excluded; pass partner to filter to a single partner key.
     */
    get: operations['list_partner_sync_runs_api_v2_ml_scribe_internal_admin_evidence_sync_runs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evidence-sync/runs/{execution_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Partner Sync Run
     * @description Fetch a single partner sync run by execution_id.
     */
    get: operations['get_partner_sync_run_api_v2_ml_scribe_internal_admin_evidence_sync_runs__execution_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/summary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Migration Summary
     * @description Get migration summary for a user (counts of sessions, templates, profiles, team relations).
     */
    post: operations['get_migration_summary_api_v2_ml_scribe_internal_admin_migration_user_to_user_summary_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Sessions
     * @description Migrate all sessions from one user to another.
     */
    post: operations['migrate_sessions_api_v2_ml_scribe_internal_admin_migration_user_to_user_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Templates
     * @description Migrate all custom templates from one user to another.
     */
    post: operations['migrate_templates_api_v2_ml_scribe_internal_admin_migration_user_to_user_templates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/patient-profiles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Patient Profiles
     * @description Migrate all patient profiles from one user to another.
     */
    post: operations['migrate_patient_profiles_api_v2_ml_scribe_internal_admin_migration_user_to_user_patient_profiles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/snippets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Snippets
     * @description Migrate snippets from one user to another (target wins on shorthand conflict).
     */
    post: operations['migrate_snippets_api_v2_ml_scribe_internal_admin_migration_user_to_user_snippets_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/scribe-core': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Scribe Core
     * @description Re-key scribe-core session-attached data (clinical tasks, consult-note edit/revert audit, note suggestions, session shares) from one user to another. Idempotent: re-running re-keys the now-empty source set as a no-op.
     */
    post: operations['migrate_scribe_core_api_v2_ml_scribe_internal_admin_migration_user_to_user_scribe_core_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/team-relation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Team Relation
     * @description Migrate team relation from one user to another.
     */
    post: operations['migrate_team_relation_api_v2_ml_scribe_internal_admin_migration_user_to_user_team_relation_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/user/{user_ref_id}/mark-deleted': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark User Deleted
     * @description Mark a user as deleted after user-to-user migration.
     */
    post: operations['mark_user_deleted_api_v2_ml_scribe_internal_admin_migration_user_to_user_user__user_ref_id__mark_deleted_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/user/{user_ref_id}/retire-provider-identities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Retire Provider Identities
     * @description Retire the source user's identity records in third-party providers (Identity Broker, Auth0 via cascade, Kinde) after a user-to-user migration. Idempotent: safe to retry after a previous successful run.
     */
    post: operations['retire_provider_identities_api_v2_ml_scribe_internal_admin_migration_user_to_user_user__user_ref_id__retire_provider_identities_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/preflight': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Preflight User To User Migration
     * @description Read-only preflight for a user-to-user merge: evaluates every precondition (user existence, self-merge, source team ownership, merge stamp consistency, workspace-realign resolvability) before any data is mutated, and reports ALL failures in one response. Always 200; callers must treat ok=false as a hard stop.
     */
    post: operations['preflight_user_to_user_migration_api_v2_ml_scribe_internal_admin_migration_user_to_user_preflight_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/realign-workspace': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start Realign Workspace
     * @description Start the full-footprint workspace re-tag for a user-to-user merge: re-tag every workspace-scoped resource now owned by the target user off the source user's personal workspace onto the target's, via ``MigrateToWorkspaceWorkflow``. Returns the workflow id to poll, or a ``noop`` when source and target resolve to the same workspace. Call after all ownership re-keys and before mark-deleted (the source workspace must still resolve). 409 — never a silent skip — when the target does not have exactly one live workspace or the source workspace cannot be resolved (no personal workspace, and no single live membership matching the target's workspace).
     */
    post: operations['start_realign_workspace_api_v2_ml_scribe_internal_admin_migration_user_to_user_realign_workspace_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/realign-workspace/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Realign Workspace Status
     * @description Report the status of a merge workspace re-tag, read straight from Temporal. ``running`` is non-terminal; ``succeeded`` / ``failed`` / ``terminated`` / ``timed_out`` are terminal. 404 when no workflow with this id exists.
     */
    get: operations['get_realign_workspace_status_api_v2_ml_scribe_internal_admin_migration_user_to_user_realign_workspace_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/realign-workspace': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start Region Realign Workspace
     * @description Start the target-region workspace re-tag for a region migration: re-tag every workspace-scoped resource the migrated user owns off ``workspace_id=None`` onto their freshly provisioned personal workspace, via ``MigrateToWorkspaceWorkflow`` in backfill mode. Returns the workflow id to poll. Call on the TARGET region after all imports and before change-provider-regions. 409 — never a silent skip — when the personal workspace is unresolvable or the user is multi-workspace.
     */
    post: operations['start_region_realign_workspace_api_v2_ml_scribe_internal_admin_migration_user_region_realign_workspace_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/realign-workspace/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Region Realign Workspace Status
     * @description Report the status of a region workspace re-tag, read straight from Temporal. ``running`` is non-terminal; ``succeeded`` / ``failed`` / ``terminated`` / ``timed_out`` are terminal. 404 when no workflow with this id exists.
     */
    get: operations['get_region_realign_workspace_status_api_v2_ml_scribe_internal_admin_migration_user_region_realign_workspace_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/user/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export User
     * @description Export user record for cross-region migration.
     */
    get: operations['export_user_api_v2_ml_scribe_internal_admin_migration_user_region_user__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/session-ids/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Session Ids
     * @description Get all session IDs for a user.
     */
    get: operations['export_session_ids_api_v2_ml_scribe_internal_admin_migration_user_region_session_ids__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/templates/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Templates
     * @description Export all custom templates for a user.
     */
    get: operations['export_templates_api_v2_ml_scribe_internal_admin_migration_user_region_templates__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/patient-profiles/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Patient Profiles
     * @description Export all patient profiles for a user.
     */
    get: operations['export_patient_profiles_api_v2_ml_scribe_internal_admin_migration_user_region_patient_profiles__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/snippets/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Snippets
     * @description Export all snippets for a user.
     */
    get: operations['export_snippets_api_v2_ml_scribe_internal_admin_migration_user_region_snippets__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/personalization-profile/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Personalization Profile
     * @description Export the personalisation profile for a user.
     */
    get: operations['export_personalization_profile_api_v2_ml_scribe_internal_admin_migration_user_region_personalization_profile__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/team-relations/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Team Relations
     * @description Export all team relations for a user (for cross-region migration).
     */
    get: operations['export_team_relations_api_v2_ml_scribe_internal_admin_migration_user_region_team_relations__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/sessions/export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export Sessions Chunk
     * @description Export sessions and related data (consult notes, documents, context documents) by session IDs.
     */
    post: operations['export_sessions_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_sessions_export_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/preview/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Preview Region Migration
     * @description Per-domain counts of a user's data, for dry-run/preview before a region migration.
     */
    get: operations['preview_region_migration_api_v2_ml_scribe_internal_admin_migration_user_region_preview__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/preflight/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Preflight Region Migration
     * @description Read-only preflight for a region migration: evaluates every source-side precondition (user exists, solo user, no merge in progress, personal workspace resolvable) before any export or target write, and reports ALL failures in one response. Always 200; callers must treat ok=false as a hard stop.
     */
    get: operations['preflight_region_migration_api_v2_ml_scribe_internal_admin_migration_user_region_preflight__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/sessions/delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Sessions Chunk
     * @description Delete sessions and related data by session IDs (cleanup after migration).
     */
    post: operations['delete_sessions_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_sessions_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/user/{user_ref_id}/mark-deleted': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark User Deleted
     * @description Mark a user as deleted in the source region after migration.
     */
    post: operations['mark_user_deleted_api_v2_ml_scribe_internal_admin_migration_user_region_user__user_ref_id__mark_deleted_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import User
     * @description Import a user record into this region (idempotent — skips if user already exists).
     */
    post: operations['import_user_api_v2_ml_scribe_internal_admin_migration_user_region_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Templates
     * @description Import templates into this region (idempotent — skips templates whose _id already exists).
     */
    post: operations['import_templates_api_v2_ml_scribe_internal_admin_migration_user_region_templates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/patient-profiles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Patient Profiles
     * @description Import patient profiles into this region (idempotent, updates managed_by to target user).
     */
    post: operations['import_patient_profiles_api_v2_ml_scribe_internal_admin_migration_user_region_patient_profiles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/snippets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Snippets
     * @description Import snippets into this region (idempotent, updates user_id to target user).
     */
    post: operations['import_snippets_api_v2_ml_scribe_internal_admin_migration_user_region_snippets_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/personalization-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Personalization Profile
     * @description Import a personalisation profile into this region (idempotent by kinde_user_id).
     */
    post: operations['import_personalization_profile_api_v2_ml_scribe_internal_admin_migration_user_region_personalization_profile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Sessions Chunk
     * @description Import a chunk of sessions and related data into this region.
     */
    post: operations['import_sessions_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/team-assignment': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Assign User To Team
     * @description Assign a migrated user to a team with roles in the target region (idempotent).
     */
    post: operations['assign_user_to_team_api_v2_ml_scribe_internal_admin_migration_user_region_team_assignment_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/evidence/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Evidence
     * @description Export lightweight Evidence records for a user (cross-region migration).
     */
    get: operations['export_evidence_api_v2_ml_scribe_internal_admin_migration_user_region_evidence__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/evidence/user-documents/export-chunk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export User Documents Chunk
     * @description Export a chunk of a user's library documents, paginated by _id.
     */
    post: operations['export_user_documents_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_evidence_user_documents_export_chunk_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/evidence/user-embeddings/export-chunk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export User Embeddings Chunk
     * @description Export a chunk of a user's embedding vectors, paginated by _id.
     */
    post: operations['export_user_embeddings_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_evidence_user_embeddings_export_chunk_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/evidence': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Evidence
     * @description Import Evidence records into this region (idempotent — skips by _id).
     */
    post: operations['import_evidence_api_v2_ml_scribe_internal_admin_migration_user_region_evidence_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/evidence:delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Evidence
     * @description Delete all Evidence records for a user from this (source) region.
     */
    post: operations['delete_evidence_api_v2_ml_scribe_internal_admin_migration_user_region_evidence_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/evidence': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Evidence
     * @description Re-key all Evidence records from one user to another (idempotent).
     */
    post: operations['migrate_evidence_api_v2_ml_scribe_internal_admin_migration_user_to_user_evidence_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/ask-heidi/chat-ids/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Chat Ids
     * @description Get all Ask Heidi chat IDs for a user (paginate export by these).
     */
    get: operations['export_chat_ids_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_chat_ids__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/ask-heidi/chats/export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export Chats Chunk
     * @description Export chats (and their v2 message records) by chat IDs.
     */
    post: operations['export_chats_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_chats_export_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/ask-heidi/calls/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Calls
     * @description Export all voice calls for a user.
     */
    get: operations['export_calls_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_calls__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/ask-heidi/chats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Chats Chunk
     * @description Import a chunk of chats and their message records (idempotent).
     */
    post: operations['import_chats_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_chats_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/ask-heidi/calls': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Calls
     * @description Import voice calls into this region (idempotent — skips by _id).
     */
    post: operations['import_calls_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_calls_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/ask-heidi:delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Ask Heidi
     * @description Delete all Ask Heidi records for a user from this (source) region.
     */
    post: operations['delete_ask_heidi_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/ask-heidi': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Ask Heidi
     * @description Re-key Ask Heidi chats and calls from one user to another.
     */
    post: operations['migrate_ask_heidi_api_v2_ml_scribe_internal_admin_migration_user_to_user_ask_heidi_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/cpd/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Cpd
     * @description Export all CPD records for a user (cross-region migration).
     */
    get: operations['export_cpd_api_v2_ml_scribe_internal_admin_migration_user_region_cpd__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/cpd': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Cpd
     * @description Import CPD records into this region (idempotent — skips by _id).
     */
    post: operations['import_cpd_api_v2_ml_scribe_internal_admin_migration_user_region_cpd_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/cpd:delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Cpd
     * @description Delete all CPD records for a user from this (source) region.
     */
    post: operations['delete_cpd_api_v2_ml_scribe_internal_admin_migration_user_region_cpd_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/cpd': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate Cpd
     * @description Re-key all CPD records from one user to another (idempotent).
     */
    post: operations['migrate_cpd_api_v2_ml_scribe_internal_admin_migration_user_to_user_cpd_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/settings/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Settings
     * @description Export all per-user settings/personalisation collections for cross-region migration.
     */
    get: operations['export_settings_api_v2_ml_scribe_internal_admin_migration_user_region_settings__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/settings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Settings
     * @description Import settings/personalisation collections into this region (idempotent, skip-by-_id).
     */
    post: operations['import_settings_api_v2_ml_scribe_internal_admin_migration_user_region_settings_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/settings:delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Settings
     * @description Purge settings/personalisation collections from the source region after migration (idempotent).
     */
    post: operations['delete_settings_api_v2_ml_scribe_internal_admin_migration_user_region_settings_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/settings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Merge Settings
     * @description Merge settings collections additively (upsert-if-absent; existing target rows are kept).
     */
    post: operations['merge_settings_api_v2_ml_scribe_internal_admin_migration_user_to_user_settings_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/usage/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Usage
     * @description Export usage/gamification collections for cross-region migration (carry policy).
     */
    get: operations['export_usage_api_v2_ml_scribe_internal_admin_migration_user_region_usage__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/usage': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Usage
     * @description Import usage/gamification collections into this region (idempotent, skip-by-_id).
     */
    post: operations['import_usage_api_v2_ml_scribe_internal_admin_migration_user_region_usage_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/usage:delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Usage
     * @description Purge usage/gamification collections from the source region after migration (idempotent).
     */
    post: operations['delete_usage_api_v2_ml_scribe_internal_admin_migration_user_region_usage_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/usage': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Merge Usage
     * @description No-op: usage/gamification records are dropped on merge (not transferred).
     */
    post: operations['merge_usage_api_v2_ml_scribe_internal_admin_migration_user_to_user_usage_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/integrations/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export Integrations
     * @description Export re-keyable integration config (EHR profile/launch/linked account, hardware device).
     */
    get: operations['export_integrations_api_v2_ml_scribe_internal_admin_migration_user_region_integrations__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/integrations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Integrations
     * @description Import integration config into this region (idempotent, skip-by-_id).
     */
    post: operations['import_integrations_api_v2_ml_scribe_internal_admin_migration_user_region_integrations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/integrations:delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Integrations
     * @description Purge integration config from the source region after migration (idempotent).
     */
    post: operations['delete_integrations_api_v2_ml_scribe_internal_admin_migration_user_region_integrations_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-to-user/integrations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Merge Integrations
     * @description Re-key integration config from one user to another (upsert-if-absent on natural key).
     */
    post: operations['merge_integrations_api_v2_ml_scribe_internal_admin_migration_user_to_user_integrations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/migration/user-region/change-provider-regions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Change Provider Regions
     * @description Change a user's region across all identity and billing providers.
     */
    post: operations['change_provider_regions_api_v2_ml_scribe_internal_admin_migration_user_region_change_provider_regions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/temporal-control/workflows': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Workflows
     * @description List executions of a registered workflow type, ordered by Temporal's visibility default (start time descending; not configurable here). ``truncated`` is true when more matched than ``limit``. The visibility query is built server-side from the registry entry and the status enum — no client-supplied string reaches Temporal.
     */
    get: operations['list_workflows_api_v2_ml_scribe_internal_admin_temporal_control_workflows_get'];
    put?: never;
    /**
     * Start Workflow
     * @description Start a registered workflow type. The task queue comes from the server-side registry, never the request; ``workflow_id`` must sit in the type's id namespace (``{domain}:{key}``, e.g. ``workspace-backfill:<run-id>``); ``input`` is validated against the workflow's own input model (422 on mismatch) and passed as the workflow's single positional argument. 409 when a workflow with this id is currently running (default id-reuse policy — a closed run with the same id does not conflict).
     */
    post: operations['start_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/temporal-control/workflows/{workflow_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Describe Workflow
     * @description Describe one workflow execution. 404 when the id is unknown; 422 when the target's workflow type is not registered for temporal-control.
     */
    get: operations['describe_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/temporal-control/workflows/{workflow_id}/signal': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Signal Workflow
     * @description Send a signal to a running workflow. The signal name and args are validated against the registry's per-workflow contract (422 on an unknown name or bad args) — Temporal itself accepts any name and the backfill drops invalid tuning payloads silently, so this is the operator's guard. 204 = signal delivered and well-formed; the backfill applies tuning at the next page boundary — confirm via the ``progress`` query. 409 when the workflow is already closed.
     */
    post: operations['signal_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__signal_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/temporal-control/workflows/{workflow_id}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Cancel Workflow
     * @description Request cancellation of a workflow (Temporal cancellation — the workflow sees a CancelledError at its next await; distinct from the backfill's graceful 'stop' signal). 409 when the workflow is already closed.
     */
    post: operations['cancel_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__cancel_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/temporal-control/workflows/{workflow_id}/query': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Query Workflow
     * @description Run a workflow query (e.g. the backfill's ``progress``). 422 for a query name outside the registry contract; 400 when the query fails worker-side (the workflow's handler raised); 503 when the query could not be dispatched to a worker (none polling the task queue).
     */
    post: operations['query_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__query_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/temporal-control/workflows/{workflow_id}/result': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Workflow Result
     * @description Fetch the outcome of a workflow whose latest run has closed (a continue-as-new'd id resolves to its final run). COMPLETED → the result payload; FAILED / CANCELED / TERMINATED / TIMED_OUT → ``result: null`` with the failure cause in ``failure``. 409 while the workflow is still running.
     */
    get: operations['workflow_result_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__result_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workspace-provisioning/from-root-team': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Provision From Root Team
     * @description Provision a workspace from a root team and bulk-provision memberships for every user under the root team and its descendants. Idempotent.
     */
    post: operations['provision_from_root_team_api_v2_ml_scribe_internal_admin_workspace_provisioning_from_root_team_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/workspace-provisioning/from-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Provision From User
     * @description Provision a personal workspace + ADMIN membership for a solo user (one with no team relation). Idempotent on sequential reruns; not race-safe under concurrent first-time calls — see WorkspaceService.
     */
    post: operations['provision_from_user_api_v2_ml_scribe_internal_admin_workspace_provisioning_from_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get All Competitions
     * @description Get all competitions.
     */
    get: operations['get_all_competitions_api_v2_ml_scribe_internal_admin_competitions_get'];
    put?: never;
    /**
     * Create Competition
     * @description Create a new competition.
     */
    post: operations['create_competition_api_v2_ml_scribe_internal_admin_competitions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/metrics': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Available Metrics
     * @description Get available metrics for competition creation.
     */
    get: operations['get_available_metrics_api_v2_ml_scribe_internal_admin_competitions_metrics_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/{competition_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Competition
     * @description Get a specific competition.
     */
    get: operations['get_competition_api_v2_ml_scribe_internal_admin_competitions__competition_id__get'];
    put?: never;
    post?: never;
    /**
     * Archive Competition
     * @description Archive a competition (soft delete).
     */
    delete: operations['archive_competition_api_v2_ml_scribe_internal_admin_competitions__competition_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Competition
     * @description Update a competition.
     */
    patch: operations['update_competition_api_v2_ml_scribe_internal_admin_competitions__competition_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/{competition_id}/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Competition Status
     * @description Update a competition's status.
     */
    patch: operations['update_competition_status_api_v2_ml_scribe_internal_admin_competitions__competition_id__status_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/{competition_id}/leaderboard': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Admin Leaderboard
     * @description Get admin leaderboard for a competition.
     */
    get: operations['get_admin_leaderboard_api_v2_ml_scribe_internal_admin_competitions__competition_id__leaderboard_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/{competition_id}/exclusions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Competition Exclusions
     * @description Get all exclusions for a competition.
     */
    get: operations['get_competition_exclusions_api_v2_ml_scribe_internal_admin_competitions__competition_id__exclusions_get'];
    put?: never;
    /**
     * Exclude User
     * @description Exclude a user from a competition.
     */
    post: operations['exclude_user_api_v2_ml_scribe_internal_admin_competitions__competition_id__exclusions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/{competition_id}/exclusions/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove Exclusion
     * @description Remove an exclusion for a user.
     */
    delete: operations['remove_exclusion_api_v2_ml_scribe_internal_admin_competitions__competition_id__exclusions__user_ref_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/users/{user_ref_id}/pseudonym': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Set User Pseudonym
     * @description Set or regenerate a user's pseudonym.
     */
    patch: operations['set_user_pseudonym_api_v2_ml_scribe_internal_admin_competitions_users__user_ref_id__pseudonym_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/users/{user_ref_id}/visibility': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update User Visibility
     * @description Update a user's leaderboard visibility preference.
     */
    patch: operations['update_user_visibility_api_v2_ml_scribe_internal_admin_competitions_users__user_ref_id__visibility_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/competitions/users/{user_ref_id}/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Stats
     * @description Get detailed statistics for a user.
     */
    get: operations['get_user_stats_api_v2_ml_scribe_internal_admin_competitions_users__user_ref_id__stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/managed-user-rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Managed User Rules
     * @description Get managed user email regex rules
     */
    get: operations['get_managed_user_rules_api_v2_ml_scribe_internal_admin_managed_user_rules_get'];
    put?: never;
    /**
     * Add Managed User Rule
     * @description Add a managed user rule
     */
    post: operations['add_managed_user_rule_api_v2_ml_scribe_internal_admin_managed_user_rules_post'];
    /**
     * Delete Managed User Rule
     * @description Delete a managed user rule
     */
    delete: operations['delete_managed_user_rule_api_v2_ml_scribe_internal_admin_managed_user_rules_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/hardware-devices': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List All Devices
     * @description List all hardware devices with optional filtering and pagination.
     */
    get: operations['list_all_devices_api_v2_ml_scribe_internal_admin_hardware_devices_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/hardware-devices/export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export All Devices
     * @description Export all hardware devices matching the given filters as CSV.
     */
    get: operations['export_all_devices_api_v2_ml_scribe_internal_admin_hardware_devices_export_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/hardware-devices/{device_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Device By Id
     * @description Get a hardware device by ID.
     */
    get: operations['get_device_by_id_api_v2_ml_scribe_internal_admin_hardware_devices__device_id__get'];
    put?: never;
    post?: never;
    /**
     * Unlink Device By Id
     * @description Unlink a hardware device by ID.
     */
    delete: operations['unlink_device_by_id_api_v2_ml_scribe_internal_admin_hardware_devices__device_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Device By Id
     * @description Update a hardware device by ID.
     */
    patch: operations['update_device_by_id_api_v2_ml_scribe_internal_admin_hardware_devices__device_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/hardware-devices/{device_id}:delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Device By Id
     * @description Permanently delete a hardware device by ID. This action cannot be undone.
     */
    post: operations['delete_device_by_id_api_v2_ml_scribe_internal_admin_hardware_devices__device_id__delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/hardware-devices': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Devices
     * @description List all hardware devices for a user.
     */
    get: operations['list_user_devices_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices_get'];
    put?: never;
    /**
     * Link User Device
     * @description Link a new hardware device to a user.
     */
    post: operations['link_user_device_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/hardware-devices/{device_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Device
     * @description Get a specific hardware device for a user.
     */
    get: operations['get_user_device_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices__device_id__get'];
    put?: never;
    post?: never;
    /**
     * Unlink User Device
     * @description Unlink a hardware device from a user.
     */
    delete: operations['unlink_user_device_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices__device_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update User Device
     * @description Update a hardware device for a user.
     */
    patch: operations['update_user_device_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices__device_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/users/{user_ref_id}/hardware-device-binding-code': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Binding Code
     * @description Get user's hardware device binding code.
     */
    get: operations['get_user_binding_code_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_device_binding_code_get'];
    /**
     * Update User Binding Code
     * @description Generate or update user's hardware device binding code.
     */
    put: operations['update_user_binding_code_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_device_binding_code_put'];
    post?: never;
    /**
     * Clear User Binding Code
     * @description Clear user's hardware device binding code.
     */
    delete: operations['clear_user_binding_code_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_device_binding_code_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/source-lists': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Team Source Lists
     * @description List all source lists for a team.
     */
    get: operations['list_team_source_lists_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists_get'];
    put?: never;
    /**
     * Create Team Source List
     * @description Create a source list for a team.
     */
    post: operations['create_team_source_list_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/source-lists/{source_list_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Source List
     * @description Get a source list for a team.
     */
    get: operations['get_team_source_list_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists__source_list_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Team Source List
     * @description Delete a team source list.
     */
    delete: operations['delete_team_source_list_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists__source_list_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Team Source List
     * @description Update a team source list.
     */
    patch: operations['update_team_source_list_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists__source_list_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/collections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Team Collections
     * @description List all collections for a team.
     */
    get: operations['list_team_collections_api_v2_ml_scribe_internal_admin_teams__team_id__collections_get'];
    put?: never;
    /**
     * Create Team Collection
     * @description Create a collection for a team.
     */
    post: operations['create_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/collections/{collection_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Collection
     * @description Get collection details for a team.
     */
    get: operations['get_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Team Collection
     * @description Delete a team collection.
     */
    delete: operations['delete_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Team Collection
     * @description Update a team collection's metadata.
     */
    patch: operations['update_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/collections/{collection_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Documents To Team Collection
     * @description Add documents to a team collection.
     */
    post: operations['add_documents_to_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/collections/{collection_id}/documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove Document From Team Collection
     * @description Remove a document from a team collection.
     */
    delete: operations['remove_document_from_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__documents__document_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Team Documents
     * @description List all team-scoped documents for a team.
     */
    get: operations['list_team_documents_api_v2_ml_scribe_internal_admin_teams__team_id__documents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/workflows': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Team Workflows */
    get: operations['list_team_workflows_api_v2_ml_scribe_internal_admin_teams__team_id__workflows_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/workflows/{recording_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Team Workflow */
    get: operations['get_team_workflow_api_v2_ml_scribe_internal_admin_teams__team_id__workflows__recording_id__get'];
    put?: never;
    post?: never;
    /** Delete Team Workflow */
    delete: operations['delete_team_workflow_api_v2_ml_scribe_internal_admin_teams__team_id__workflows__recording_id__delete'];
    options?: never;
    head?: never;
    /** Rename Team Workflow */
    patch: operations['rename_team_workflow_api_v2_ml_scribe_internal_admin_teams__team_id__workflows__recording_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/workflows:promote': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Promote Team Workflow */
    post: operations['promote_team_workflow_api_v2_ml_scribe_internal_admin_teams__team_id__workflows_promote_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/workflows/{recording_id}/data': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Replace Team Workflow Data */
    put: operations['replace_team_workflow_data_api_v2_ml_scribe_internal_admin_teams__team_id__workflows__recording_id__data_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/teams/{team_id}/shortcuts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List team shortcuts (internal admin)
     * @description List all non-deleted shortcuts owned by ``team_id``.
     */
    get: operations['list_team_shortcuts_admin_api_v2_ml_scribe_internal_admin_teams__team_id__shortcuts_get'];
    put?: never;
    /**
     * Create a team shortcut (internal admin)
     * @description Create a new team shortcut on behalf of the team.
     *
     *     Workspace tagging: when the team has a non-null ``workspace_id``,
     *     establish a ``workspace_scope`` keyed on the team owner (or a member
     *     fall-back) so ``WorkspaceCollectionProxy`` auto-tags the created
     *     shortcut with the team's workspace. Legacy teams without a
     *     ``workspace_id`` keep the pre-enrolment untagged behaviour and require
     *     explicit backfill later — the list endpoint deliberately stays
     *     untouched so CS retains cross-tenant visibility.
     */
    post: operations['create_team_shortcut_admin_api_v2_ml_scribe_internal_admin_teams__team_id__shortcuts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/vidal-upload/monographs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Vidal Monographs
     * @description Upload and process a ZIP of Vidal VMP monograph HTML files.
     *
     *     Accepts a ZIP containing vmp_*.html files for one language.
     *     Converts HTML to Markdown, chunks, embeds, and stores in MongoDB.
     *
     *     Returns a compact summary with counts, duration, and sample errors.
     */
    post: operations['upload_vidal_monographs_api_v2_ml_scribe_internal_admin_vidal_upload_monographs_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/emg-upload/portfolio': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Emg Portfolio
     * @description Upload and process a single EMG portfolio JSON file.
     *
     *     The upload triggers a full re-chunk, re-embed, and atomic-replace of the
     *     portfolio's collection. Returns a compact summary on completion.
     */
    post: operations['upload_emg_portfolio_api_v2_ml_scribe_internal_admin_emg_upload_portfolio_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/formats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ticket Formats
     * @description Get all available ticket formats from all platforms.
     */
    get: operations['get_ticket_formats_api_v2_ml_scribe_internal_admin_ticket_portal_formats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Ticket
     * @description Create a ticket on the appropriate platform based on the slug.
     */
    post: operations['create_ticket_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/linear-search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Linear Issues
     * @description Search Linear issues by identifier, number, or title keywords.
     *
     *     Results are ordered by status (active first) then relevance.
     */
    get: operations['search_linear_issues_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_linear_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/linear-lookup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Lookup Linear Issue
     * @description Look up a single Linear issue by exact identifier.
     */
    get: operations['lookup_linear_issue_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_linear_lookup_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/check-duplicates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Check Duplicates
     * @description Search for semantically similar existing Linear issues before submission.
     *
     *     Call this before creating a Feature Suggestion to surface possible
     *     duplicates the submitter can review.
     */
    post: operations['check_duplicates_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_check_duplicates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/watch-issue': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Watch Linear Issue
     * @description Subscribe to a Linear issue; optionally create a HubSpot ticket with context.
     */
    post: operations['watch_linear_issue_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_watch_issue_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/unwatch-issue': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Unwatch Linear Issue
     * @description Unsubscribe from a Linear issue (remove user from subscribers).
     */
    post: operations['unwatch_linear_issue_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_unwatch_issue_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/mine': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get My Tickets
     * @description Get all tickets submitted by the given user across all platforms.
     */
    get: operations['get_my_tickets_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_mine_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/customer': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Customer Tickets
     * @description Search for all tickets associated with a customer/org across all platforms.
     */
    get: operations['get_customer_tickets_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_customer_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/hubspot/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Hubspot
     * @description Search HubSpot for companies, contacts, or deals.
     *
     *     Returns empty results when HUBSPOT_ACCESS_TOKEN is not configured so
     *     the UI degrades gracefully until the integration is enabled.
     */
    get: operations['search_hubspot_api_v2_ml_scribe_internal_admin_ticket_portal_hubspot_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/hubspot/company/{company_id}/arr': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Hubspot Company Arr
     * @description Closed-won deal ARR total for a company (post-selection; not used in search).
     */
    get: operations['get_hubspot_company_arr_api_v2_ml_scribe_internal_admin_ticket_portal_hubspot_company__company_id__arr_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/{platform}/{ticket_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ticket Detail
     * @description Get full ticket detail including conversation messages/comments.
     */
    get: operations['get_ticket_detail_api_v2_ml_scribe_internal_admin_ticket_portal_tickets__platform___ticket_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ticket-portal/tickets/{platform}/{ticket_id}/notes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Ticket Note
     * @description Add a note/comment to a ticket.
     */
    post: operations['add_ticket_note_api_v2_ml_scribe_internal_admin_ticket_portal_tickets__platform___ticket_id__notes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/orders': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Orders
     * @description List orders with optional filters and search.
     */
    get: operations['list_orders_api_v2_ml_scribe_internal_admin_orders_get'];
    put?: never;
    /**
     * Create Internal Order
     * @description Create an order by hand (OrderSource.INTERNAL_ADMIN) with a required reason (category + optional notes). No Stripe/HubSpot context needed. The order lands in 'deal_closed_won' so the existing confirm endpoint submits it to ERP. Idempotent on idempotency_key — a re-submit with the same key and payload returns the same order (200 instead of 201); reusing the key with a different payload returns 409 — device serials are excluded from that comparison, so a re-submit that adds them replays the original order and does NOT record them; use PATCH to add serials to an existing order. Serials are optional here and usually recorded later via PATCH anyway, once the warehouse has picked the units.
     */
    post: operations['create_internal_order_api_v2_ml_scribe_internal_admin_orders_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/orders/{order_id}/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Confirm Order
     * @description Confirm an order: create in Lingxing ERP and mark as erp_order_created. Only deal_closed_won orders are confirmable — already-confirmed orders return 409 'already confirmed', orders in other states return 409 'precondition not met'.
     */
    post: operations['confirm_order_api_v2_ml_scribe_internal_admin_orders__order_id__confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/orders/{order_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Edit Order
     * @description Edit an order's shipping, customer email and/or device serials (CS-usable; requires devices:write). Shipping is a REPLACE and allowed only before the order is being prepared in ERP (409 otherwise); buyer_email is editable at any status and sets a manual override so the status poll stops reverting it; serial_numbers is a REPLACE that is likewise editable at any status (including shipped and canceled — serials are usually learned after fulfilment), is never sent to ERP, and is cleared by sending []. When the order is already in ERP and still editable, the address change is pushed to Lingxing best-effort — see erp_push in the response (a failed push keeps the local edit; escalate to the ERP team). Country is normalised to ISO alpha-2 (422 on unresolvable); at least one of shipping / buyer_email / serial_numbers is required (422 otherwise). An edit is applied as a whole: serials sent alongside a shipping change that is rejected (409) are not saved either — send them on their own to be sure they land.
     */
    patch: operations['edit_order_api_v2_ml_scribe_internal_admin_orders__order_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/orders/{order_id}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Cancel Order
     * @description Cancel a pre-fulfilment order (CS-usable; requires devices:write). Allowed only before the order is being prepared/shipped (409 with current_status otherwise — use the returns flow); an already-canceled order returns 409. When the order is in ERP it is canceled in Lingxing first; a rejection returns 422 and no refund is issued. Self-serve (Stripe-paid) orders are then refunded (full); sales-led / internal orders are marked canceled with no auto-refund (Finance handles the money-back). A refund failure after the ERP cancel returns 502 — the order is already canceled in ERP and the refund is safely retryable.
     */
    post: operations['cancel_order_api_v2_ml_scribe_internal_admin_orders__order_id__cancel_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/orders/{order_id}/pilot-outcome': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record Pilot Outcome
     * @description Record the commercial outcome of a Remote Pilot as free text (requires devices:write), stamped with the admin who saved it and when. Re-posting replaces the previous note. Independent of pilot_status — an outcome can be captured while the pilot is still running or after it has ended. Orders that are not Remote Pilots return 422; unknown orders return 404.
     */
    post: operations['record_pilot_outcome_api_v2_ml_scribe_internal_admin_orders__order_id__pilot_outcome_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/orders/poll-status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Poll Order Status
     * @description Poll Lingxing ERP for order status transitions. Requires Auth0 M2M bearer token with the orders:sync scope.
     */
    post: operations['poll_order_status_api_v2_ml_scribe_internal_admin_orders_poll_status_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/orders/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Lookup Device Order Status
     * @description Look up device-order status by customer email, name, or order ID. Requires an Auth0 M2M bearer token with the device-orders:read scope. Returns only safe fields (status, ERP order ID, region, tracking number, timestamps) — never customer email, name, phone, or address.
     */
    get: operations['lookup_device_order_status_api_v2_ml_scribe_internal_admin_orders_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/office-stock/send-outs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Send Outs
     * @description List office-stock send-outs with optional status / type filters and a search across order_id and tracking_number. This list is dedicated to send-outs; they never appear in the customer orders list.
     */
    get: operations['list_send_outs_api_v2_ml_scribe_internal_admin_office_stock_send_outs_get'];
    put?: never;
    /**
     * Create Send Out
     * @description Create an office-stock send-out from selected QA-passed units. The units move to ALLOCATED and the send-out starts in REQUESTED, awaiting super-admin approval. A CUSTOMER_RESEND carries recipient details; an INTERNAL_USE carries taken_by + purpose. The order is never submitted to ERP. Idempotent on idempotency_key — a re-submit with the same key returns the same send-out (200 instead of 201). A unit that is not QA-passed or is already in an active send-out returns 409; an unknown unit returns 404.
     */
    post: operations['create_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/office-stock/send-outs/{order_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Send Out
     * @description Get a single office-stock send-out by its order_id.
     */
    get: operations['get_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs__order_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/office-stock/send-outs/{order_id}/approve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Approve Send Out
     * @description Approve a requested send-out (super admin only). REQUESTED -> APPROVED. A send-out that is not REQUESTED returns 409; an unknown send-out 404.
     */
    post: operations['approve_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs__order_id__approve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/office-stock/send-outs/{order_id}/reject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Reject Send Out
     * @description Reject or cancel a not-yet-fulfilled send-out (super admin only). Allowed from REQUESTED or APPROVED; its units return to available stock (ALLOCATED -> QA_PASSED) and the send-out link is cleared. A send-out in any other state returns 409; an unknown send-out 404.
     */
    post: operations['reject_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs__order_id__reject_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/office-stock/send-outs/{order_id}/fulfil': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Fulfil Send Out
     * @description Fulfil an approved send-out: dispatch its units and record the parcel tracking number. APPROVED -> FULFILLED. Units move ALLOCATED -> DISPATCHED (customer resend) or ALLOCATED -> DISPATCHED -> CONSUMED (internal use). A send-out that is not APPROVED returns 409; an unknown send-out 404.
     */
    post: operations['fulfil_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs__order_id__fulfil_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/office-stock': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Stock Items
     * @description List office-stock items, with an optional status filter and a search across uuid, source_order_id and device_id.
     */
    get: operations['list_stock_items_api_v2_ml_scribe_internal_admin_office_stock_get'];
    put?: never;
    /**
     * Add Stock
     * @description Register returned units into office stock. Creates one RECEIVED stock item per unit, each with its own uuid, optionally tagged with the originating order.
     */
    post: operations['add_stock_api_v2_ml_scribe_internal_admin_office_stock_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/office-stock/{stock_item_uuid}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Stock Item
     * @description Get a single office-stock item by its uuid.
     */
    get: operations['get_stock_item_api_v2_ml_scribe_internal_admin_office_stock__stock_item_uuid__get'];
    put?: never;
    post?: never;
    /**
     * Void Stock Item
     * @description Void (soft-delete) a stock item to correct an accidental or duplicate intake. The unit is retained with an audit trail (who + reason) but hidden from the default list / search / get. A unit committed to a send-out (allocated, dispatched, consumed) cannot be voided and returns 409. An unknown or already-voided uuid returns 404.
     */
    delete: operations['void_stock_item_api_v2_ml_scribe_internal_admin_office_stock__stock_item_uuid__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/office-stock/{stock_item_uuid}/qa-result': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Qa Result
     * @description Record a QA pass/fail on a stock item in one action, capturing the label, device_id and qa_notes alongside the verdict. The unit is walked through IN_QA internally (RECEIVED, QA_FAILED or QA_PASSED -> IN_QA -> verdict, or IN_QA -> verdict), so a passed unit can be reopened and re-QA'd. A unit in a status that cannot enter QA (allocated, dispatched, consumed, scrapped) returns 409.
     */
    post: operations['submit_qa_result_api_v2_ml_scribe_internal_admin_office_stock__stock_item_uuid__qa_result_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List thumbs feedback */
    get: operations['list_user_feedback_api_v2_ml_scribe_internal_admin_user_feedback_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/user-feedback/{feedback_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get thumbs feedback detail */
    get: operations['get_user_feedback_api_v2_ml_scribe_internal_admin_user_feedback__feedback_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/work-experience-feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Work experience feedback */
    get: operations['list_work_experience_feedback_api_v2_ml_scribe_internal_admin_work_experience_feedback_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/work-experience-feedback/{feedback_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Work experience feedback detail */
    get: operations['get_work_experience_feedback_api_v2_ml_scribe_internal_admin_work_experience_feedback__feedback_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/access-entitlements/bulk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Access Entitlements
     * @description Preview or apply an access entitlement to multiple targets.
     */
    post: operations['bulk_access_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_bulk_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/access-entitlements/types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Entitlement Types
     * @description List all access entitlement types.
     */
    get: operations['list_entitlement_types_api_v2_ml_scribe_internal_admin_access_entitlements_types_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/access-entitlements/users/{user_ref_id}/calculated': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get All Calculated Entitlements
     * @description List calculated entitlements for a user.
     */
    get: operations['get_all_calculated_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_users__user_ref_id__calculated_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/access-entitlements/users/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List User Entitlements
     * @description List all access entitlements assigned to a user.
     */
    get: operations['list_user_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_users__user_ref_id__get'];
    put?: never;
    /**
     * Assign User Entitlement
     * @description Assign an access entitlement to a user.
     */
    post: operations['assign_user_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements_users__user_ref_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/access-entitlements/teams/{team_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Team Entitlements
     * @description List all access entitlements assigned to a team.
     */
    get: operations['list_team_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_teams__team_id__get'];
    put?: never;
    /**
     * Assign Team Entitlement
     * @description Assign an access entitlement to a team.
     */
    post: operations['assign_team_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements_teams__team_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/access-entitlements/organisations/{org_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Org Entitlements
     * @description List all access entitlements assigned to an organisation.
     */
    get: operations['list_org_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_organisations__org_id__get'];
    put?: never;
    /**
     * Assign Org Entitlement
     * @description Assign an access entitlement to an organisation.
     */
    post: operations['assign_org_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements_organisations__org_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/access-entitlements/{entitlement_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Entitlement
     * @description Soft delete an access entitlement (sets deleted_at timestamp).
     */
    delete: operations['delete_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements__entitlement_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Entitlement
     * @description Update an access entitlement.
     */
    patch: operations['update_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements__entitlement_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/advertisers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List advertisers
     * @description Returns one page of advertisers, most recently updated first, with per-advertiser resource and campaign counts. Filter by lifecycle status and/or a case-insensitive name search.
     */
    get: operations['list_advertisers_api_v2_ml_scribe_internal_admin_advertisers_get'];
    put?: never;
    /**
     * Create an advertiser
     * @description Creates an ACTIVE advertiser. Contacts are commercial/ops contacts only; each requires a name and at least one of email or phone.
     */
    post: operations['create_advertiser_api_v2_ml_scribe_internal_admin_advertisers_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/advertisers/{advertiser_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get an advertiser
     * @description Returns an advertiser by ID, or 404 when it does not exist.
     */
    get: operations['get_advertiser_api_v2_ml_scribe_internal_admin_advertisers__advertiser_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update an advertiser
     * @description Partially updates name, kind, description, and/or contacts. Only fields present in the body are applied; contacts are replaced as a whole list. Archived advertisers are read-only (409) — restore first. Lifecycle status changes go through the archive/restore actions, not this endpoint.
     */
    patch: operations['update_advertiser_api_v2_ml_scribe_internal_admin_advertisers__advertiser_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/advertisers/{advertiser_id}:archive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Archive an advertiser
     * @description Retires an advertiser. Blocked with 409 while the advertiser still has SCHEDULED or ACTIVE campaigns. After the gate clears, every owned non-archived ad resource and campaign is bulk-archived via update_many. Returns 200 even when cascade is partial — re-archive is idempotent and retries stragglers. One ADVERTISER_ARCHIVED audit entry records aggregate counts and any failed children. This is a lifecycle action, not a delete — the record is preserved for audit and can be restored. Restoring the advertiser does not restore archived children.
     */
    post: operations['archive_advertiser_api_v2_ml_scribe_internal_admin_advertisers__advertiser_id__archive_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/advertisers/{advertiser_id}:restore': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Restore an archived advertiser
     * @description Returns an ARCHIVED advertiser to ACTIVE so it can be edited and used for new inventory. Idempotent when already active.
     */
    post: operations['restore_advertiser_api_v2_ml_scribe_internal_admin_advertisers__advertiser_id__restore_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-campaigns': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List ad campaigns
     * @description Returns one page of campaigns, most recently updated first, with the owning advertiser's name embedded. Filter by advertiser, lifecycle status, and/or a case-insensitive name search. Archived campaigns are hidden unless include_archived is set or status=ARCHIVED is requested explicitly.
     */
    get: operations['list_ad_campaigns_api_v2_ml_scribe_internal_admin_ad_campaigns_get'];
    put?: never;
    /**
     * Create an ad campaign
     * @description Creates a DRAFT campaign — there is no create-as-scheduled/active path; go-live is always an explicit reviewed transition. Criteria keys must be canonical, and a bound resource must belong to the same advertiser (it may still be unapproved — approval is enforced at go-live).
     */
    post: operations['create_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-campaigns/{campaign_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get an ad campaign
     * @description Returns a campaign by ID with its advertiser context and a bound- resource summary (including the resource's lifecycle status, so the UI can hint why go-live would fail), or 404 when it does not exist.
     */
    get: operations['get_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update an ad campaign
     * @description Partially updates name, description, flight window, target product, criteria, and/or resource binding. Only fields present in the body are applied. Edits are allowed in DRAFT / SCHEDULED / PAUSED; ACTIVE campaigns must be paused first (409), and COMPLETED / ARCHIVED are read-only (409). Lifecycle status changes go through the transition actions, not this endpoint.
     */
    patch: operations['update_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-campaigns/{campaign_id}:schedule': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Schedule an ad campaign
     * @description Moves a DRAFT campaign to SCHEDULED after checking go-live readiness: an APPROVED same-advertiser resource, a target product, an unexpired flight window, and an ACTIVE advertiser. Readiness failures and invalid source statuses return 409. Idempotent when already scheduled.
     */
    post: operations['schedule_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__schedule_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-campaigns/{campaign_id}:activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Activate an ad campaign
     * @description Moves a DRAFT, SCHEDULED, or PAUSED campaign to ACTIVE. Go-live readiness is re-checked on every activation, since the bound resource or advertiser may have changed since scheduling. ACTIVE means eligible to serve once serving exists — there is no scheduler in v1. Idempotent when already active.
     */
    post: operations['activate_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__activate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-campaigns/{campaign_id}:pause': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Pause an ad campaign
     * @description Moves a SCHEDULED or ACTIVE campaign to PAUSED. This is the per-campaign kill switch: it has no preconditions and is never blocked. Idempotent when already paused.
     */
    post: operations['pause_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__pause_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-campaigns/{campaign_id}:complete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Complete an ad campaign
     * @description Moves an ACTIVE or PAUSED campaign to COMPLETED (manual end of flight). Completed campaigns are read-only apart from archive. Idempotent when already completed.
     */
    post: operations['complete_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__complete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-campaigns/{campaign_id}:archive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Archive an ad campaign
     * @description Retires a DRAFT, PAUSED, or COMPLETED campaign. Blocked with 409 from SCHEDULED / ACTIVE — pause first, so nothing live can vanish from ops view. This is a lifecycle action, not a delete — the record is preserved for audit and can be restored. Idempotent when already archived.
     */
    post: operations['archive_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__archive_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-campaigns/{campaign_id}:restore': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Restore an archived ad campaign
     * @description Returns an ARCHIVED campaign to DRAFT — never straight back to a live status, so every return to service passes review and readiness again. Blocked with 409 while the owning advertiser is ARCHIVED — restore the advertiser first. Idempotent when already draft.
     */
    post: operations['restore_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__restore_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-resources': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List ad resources
     * @description Returns one page of ad resources, newest first. Rows carry the asset reference rather than the image; rendering a creative is the caller's own concern. Filters compose: passing both advertiser_id and status narrows to their intersection. Archived resources are excluded unless include_archived is set, or status=ARCHIVED is asked for explicitly.
     */
    get: operations['list_ad_resources_api_v2_ml_scribe_internal_admin_ad_resources_get'];
    put?: never;
    /**
     * Register an ad resource
     * @description Uploads a creative and registers it as a DRAFT resource, as multipart/form-data: the image in the `file` part, the rest as form fields. The image is required and permanent — a creative is never replaced, so correcting one means registering another resource and archiving this one, and the returned media_url is stable for the life of the resource. Format and size are read from the bytes, so a misdeclared type is rejected on its content. Approval is a separate action; this can never mint an APPROVED resource.
     */
    post: operations['create_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-resources/{resource_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get an ad resource
     * @description Returns an ad resource by ID, or 404 when it does not exist.
     */
    get: operations['get_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update an ad resource
     * @description Partially updates name, description, link, and/or ad_format. The creative itself cannot be changed here or anywhere else — register a new resource and archive this one instead. Editing a material field — link or ad_format — on an APPROVED resource returns it to DRAFT for re-review; name and description do not. Resubmitting identical values changes nothing and cannot demote. Archived resources are read-only (409) — restore first.
     */
    patch: operations['update_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-resources/{resource_id}:approve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Approve an ad resource
     * @description Marks a reviewed creative APPROVED so campaigns can bind it. Idempotent when already approved, and a same-status call is not audited. A resource with no creative is rejected (409): there is no creative for a reviewer to have cleared, and none can be added after creation, so such a resource must be registered again. Archived resources are also rejected (409) — restore first, which returns the resource to DRAFT so it goes back through review rather than being approved out of the archive.
     */
    post: operations['approve_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__approve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-resources/{resource_id}:archive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Archive an ad resource
     * @description Retires a creative from live inventory. A lifecycle action, not a delete: the record is preserved so historical references stay resolvable, and it can be restored. Stored bytes are untouched — this surface has no access to them. Idempotent when already archived, and a same-status call is not audited.
     */
    post: operations['archive_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__archive_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/ad-resources/{resource_id}:restore': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Restore an archived ad resource
     * @description Returns an ARCHIVED creative to DRAFT so it can be edited and re-reviewed. Blocked with 409 while the owning advertiser is ARCHIVED — restore the advertiser first. Never restores straight to APPROVED — that would let archive-then-restore launder a creative past review. A no-op for a resource that is not archived, and such a call is not audited.
     */
    post: operations['restore_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__restore_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/directories': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List directories for an organization
     * @description Returns DRAFT and ACTIVE directories for the requested organization by default. Pass include_archived=true to include retired ARCHIVED records for audit or debugging.
     */
    get: operations['list_directories_api_v2_ml_scribe_internal_admin_directories_get'];
    put?: never;
    /**
     * Upload a recipient directory CSV
     * @description Parses a CSV file and creates a DRAFT recipient directory for the supplied organization. The directory must be explicitly activated before its entries appear in recipient search results.
     */
    post: operations['create_directory_api_v2_ml_scribe_internal_admin_directories_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/directories/{directory_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a recipient directory
     * @description Returns a directory by ID, or 404 when it does not exist.
     */
    get: operations['get_directory_api_v2_ml_scribe_internal_admin_directories__directory_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/directories/{directory_id}:activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Activate a recipient directory
     * @description Moves a DRAFT directory to ACTIVE so its entries are included in recipient search. Multiple directories may be ACTIVE simultaneously.
     */
    post: operations['activate_directory_api_v2_ml_scribe_internal_admin_directories__directory_id__activate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/directories/{directory_id}:deactivate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Deactivate a recipient directory
     * @description Moves an ACTIVE directory back to DRAFT, removing its entries from recipient search results.
     */
    post: operations['deactivate_directory_api_v2_ml_scribe_internal_admin_directories__directory_id__deactivate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/directories/{directory_id}:archive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Archive a recipient directory
     * @description Retires a directory. Its entries are excluded from search and the directory is hidden from default list results. This is a lifecycle action, not a delete — metadata is preserved for audit.
     */
    post: operations['archive_directory_api_v2_ml_scribe_internal_admin_directories__directory_id__archive_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/letterheads': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List letterheads for an organization
     * @description Returns DRAFT and ACTIVE letterheads for the requested organization by default. Pass include_archived=true to include retired ARCHIVED records for audit or debugging. Returns 404 when the organization does not exist.
     */
    get: operations['list_org_letterheads_api_v2_ml_scribe_internal_admin_letterheads_get'];
    put?: never;
    /**
     * Upload an organization letterhead
     * @description Uploads an image asset and creates a DRAFT organization letterhead for the supplied organization_id. Creation does not change the current ACTIVE/default letterhead; admins must call POST .../{letterhead_id}:activate explicitly. Returns 404 when the organization does not exist.
     */
    post: operations['create_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/letterheads/{letterhead_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get an organization letterhead
     * @description Returns a letterhead by ID, or 404 when it does not exist.
     */
    get: operations['get_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/letterheads/{letterhead_id}/preview-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get an organization letterhead preview URL
     * @description Returns a short-lived presigned URL for previewing the letterhead asset, or 404 when the letterhead does not exist.
     */
    get: operations['get_org_letterhead_preview_url_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__preview_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/letterheads/{letterhead_id}:activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Activate an organization letterhead
     * @description POST ...:activate selects this letterhead as its organization's default. Any previously ACTIVE letterhead for that organization is moved back to DRAFT.
     */
    post: operations['activate_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__activate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/letterheads/{letterhead_id}:deactivate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Deactivate an organization letterhead
     * @description POST ...:deactivate is the inverse of activation for ACTIVE → DRAFT. It keeps the letterhead available and does not require API-level confirmation; confirmation for active/default changes is a UI responsibility. Archived letterheads cannot be deactivated.
     */
    post: operations['deactivate_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__deactivate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/letterheads/{letterhead_id}:archive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Archive an organization letterhead
     * @description POST ...:archive is an explicit lifecycle action, not DELETE. It hides/retires the letterhead without deleting metadata or S3 objects because historical letters may reference old letterhead IDs. Confirmation is a UI responsibility.
     */
    post: operations['archive_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__archive_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/process': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload a CSV of clinical questions and start the AI pipeline */
    post: operations['process_batch_api_v2_ml_scribe_internal_admin_heidi_answers_process_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List all Heidi Answers batches with status counts */
    get: operations['list_batches_api_v2_ml_scribe_internal_admin_heidi_answers_batches_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a single batch with its status counts */
    get: operations['get_batch_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}/drafts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List all drafts in a batch */
    get: operations['list_drafts_in_batch_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__drafts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/drafts/{draft_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a single draft with full AI verification detail */
    get: operations['get_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Save reviewer comments / edits / signoff for a draft */
    patch: operations['update_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/reviewers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List the approved reviewers used by the send-for-review picker */
    get: operations['list_reviewers_api_v2_ml_scribe_internal_admin_heidi_answers_reviewers_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}:send-for-review': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark ready drafts as sent for review and notify reviewers
     * @description Notification delivery is best-effort: per-recipient failures land in
     *     `notification_failures` rather than rolling back the status transition.
     *     Old clients that POST without a body still flip drafts and notify nobody.
     */
    post: operations['send_batch_for_review_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__send_for_review_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/drafts/{draft_id}/publish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Publish a reviewed draft to template-gallery */
    post: operations['publish_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__publish_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}:bulk-publish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Publish many ready-to-publish drafts in one call
     * @description Publish either every `ready_to_publish` draft in a batch (when
     *     `draft_ids` is omitted) or a specific subset (when supplied).
     *
     *     Per-draft failures are best-effort: if draft 3 of 10 is rejected
     *     by template-gallery's reviewer allowlist, drafts 4-10 still
     *     attempt. Failures are returned in the response so the UI can
     *     surface them without re-running the bulk action.
     */
    post: operations['bulk_publish_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_publish_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}:bulk-signoff': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sign off many drafts in one call
     * @description Transition either every `sent_for_review` draft (no `draft_ids`)
     *     or a specific subset to `ready_to_publish` by recording a signoff.
     *
     *     Mirrors the bulk-publish shape: per-draft failures are best-effort
     *     and surface in `failures` rather than aborting the whole call. A
     *     blanket batch-wide call only targets `sent_for_review` drafts; the
     *     multi-select path additionally accepts `ready_for_review` drafts
     *     (the lifecycle allows both, and the small-team UX skips the
     *     explicit "send for review" step).
     */
    post: operations['bulk_signoff_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_signoff_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}:bulk-reset-to-ready-for-review': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Reset many drafts back to ready_for_review in one call
     * @description Send drafts that are `sent_for_review` or `ready_to_publish`
     *     back to `ready_for_review`, clearing signoff and audit fields so
     *     they restart the review track fresh.
     *
     *     Per-draft failures are best-effort, mirroring bulk-publish /
     *     bulk-signoff. The batch-wide call (no `draft_ids`) targets every
     *     `sent_for_review` AND `ready_to_publish` draft in the batch -
     *     both are valid sources for the reset.
     */
    post: operations['bulk_reset_to_ready_for_review_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_reset_to_ready_for_review_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/drafts/{draft_id}:reject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Decline a draft whose source question is broken
     * @description Terminal "decline to review" transition.
     *
     *     Flips an active-review draft (`ready_for_review` / `sent_for_review`
     *     / `ready_to_publish`) to `rejected`, recording the required reason +
     *     reviewer email. There is no in-app un-reject; a salvageable question
     *     is re-uploaded as a new CSV row.
     */
    post: operations['reject_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__reject_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}:bulk-reject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Decline many drafts in one call
     * @description Reject every rejectable draft (no `draft_ids`) or a subset.
     *
     *     Per-draft failures are best-effort, mirroring bulk-publish /
     *     bulk-reset: prevalidation failures plus any id the CAS didn't claim
     *     (TOCTOU loser) surface in `failures`.
     */
    post: operations['bulk_reject_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_reject_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/drafts/{draft_id}:unpublish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Soft-delete a published answer from template-gallery
     * @description Tear down a published answer.
     *
     *     Calls template-gallery's `DELETE /heidi-answers/{id}` (which sets
     *     `deleted_at` so the answer is hidden from the public list /
     *     by-slug routes), then flips the local draft to `unpublished`
     *     with `unpublished_at` / `unpublished_by` audit fields.
     *
     *     Treats template-gallery 404 as success: the public-facing
     *     outcome (answer no longer reachable) is the same and the local
     *     draft transition still records who pulled it.
     *
     *     Idempotent under concurrent unpublish: if a sibling request wins
     *     the local save between our draft load and our save, the local
     *     state guard in `record_unpublish_success` raises - but at that
     *     point both halves of the operation (TG soft-delete + local
     *     transition) are at the desired end state. Returns 200 with the
     *     current draft state rather than 400, since the caller's intended
     *     outcome (`status == 'unpublished'`) is already true.
     */
    post: operations['unpublish_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__unpublish_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}:bulk-unpublish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Unpublish many published drafts in one call
     * @description Bulk companion to `:unpublish`.
     *
     *     Mirrors `:bulk-publish`: per-draft failures are best-effort and
     *     surface in `failures` rather than aborting the whole call. A
     *     blanket batch-wide call (no `draft_ids`) targets every
     *     `published` draft in the batch; multi-select scopes to the
     *     supplied subset with precise per-draft failures for ids that
     *     aren't in this batch or aren't currently `published`.
     */
    post: operations['bulk_unpublish_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_unpublish_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/drafts/{draft_id}:delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Permanently delete an unpublished answer (frees the slug)
     * @description Hard-delete the template-gallery row and flip the local draft.
     *
     *     Calls template-gallery's `DELETE /heidi-answers/{id}?hard=true`
     *     which performs a real Mongo delete - the row is gone and the
     *     `question_slug` is freed for re-publishing the same question
     *     text. The local `HeidiAnswerDraftDO` is preserved with full
     *     AI pipeline + reviewer audit, only its `status` flips to
     *     `deleted` and `deleted_at` / `deleted_by` get stamped.
     *
     *     Idempotent: if the draft is already `deleted`, returns 200 with
     *     the existing state (the upstream row is gone, the local status
     *     is correct - the operator's intended outcome is reached).
     *
     *     Treats template-gallery 404 as success at the upstream-call layer
     *     for the same reason - the row is gone either way.
     */
    post: operations['delete_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}:bulk-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Permanently delete many unpublished drafts in one call
     * @description Bulk companion to `:delete`.
     *
     *     Mirrors the bulk-unpublish shape: per-draft failures are
     *     best-effort and surface in `failures` rather than aborting the
     *     whole call. Without `draft_ids`, targets every `unpublished`
     *     draft in the batch; multi-select scopes to the supplied subset.
     */
    post: operations['bulk_delete_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_delete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/drafts/{draft_id}/retry': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Reset a failed draft back to processing for another AI run */
    post: operations['retry_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__retry_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/heidi-answers/batches/{batch_id}:retry-failed': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Retry every failed draft in a batch in a single workflow
     * @description Reset all `failed` drafts in batch -> `processing`, then start ONE workflow.
     */
    post: operations['retry_failed_drafts_in_batch_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__retry_failed_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-chat-user-ref/backfill': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Backfill Agent Chat User Ref
     * @description Backfill one keyset chunk of agent-chat owner ids (legacy Kinde uid -> canonical user_ref_id). Idempotent; dry_run defaults to True. Driven per region by the etl-airflow DAG: loop passing next_after_id as after_id until has_more is False. (AGE-491 phase 2a.)
     */
    post: operations['backfill_agent_chat_user_ref_api_v2_ml_scribe_internal_admin_agent_chat_user_ref_backfill_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-harness-user-ref/backfill': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Backfill Agent Harness User Ref
     * @description Backfill one keyset chunk of one agent-harness store's owner/subject ids (legacy Kinde uid -> canonical user_ref_id). Idempotent; dry_run defaults to True. Driven per region by the etl-airflow DAG: for each resource_type, loop passing next_after_id as after_id until has_more is False. (AGE-681 phase 2b.)
     */
    post: operations['backfill_agent_harness_user_ref_api_v2_ml_scribe_internal_admin_agent_harness_user_ref_backfill_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/cua-cloud/users/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get User Machine */
    get: operations['get_user_machine_api_v2_ml_scribe_internal_admin_rpa_recordings_cua_cloud_users__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List All Recordings */
    get: operations['list_all_recordings_api_v2_ml_scribe_internal_admin_rpa_recordings_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/{recording_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Recording Detail */
    get: operations['get_recording_detail_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update Recording */
    patch: operations['update_recording_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/{recording_id}/artifacts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Recording Artifacts */
    get: operations['list_recording_artifacts_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__artifacts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/{recording_id}/artifacts/{artifact_id}:preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Recording Artifact Preview */
    get: operations['get_recording_artifact_preview_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__artifacts__artifact_id__preview_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/{recording_id}/artifacts/{artifact_id}:download-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Recording Artifact Download Url */
    get: operations['get_recording_artifact_download_url_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__artifacts__artifact_id__download_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/users/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Recordings By User */
    get: operations['list_recordings_by_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/users/{user_ref_id}/all-workflows': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List All Workflows For User */
    get: operations['list_all_workflows_for_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__all_workflows_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/{recording_id}/data': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Recording Workflow Data */
    put: operations['update_recording_workflow_data_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__data_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/users/{user_ref_id}/upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload Recording For User */
    post: operations['upload_recording_for_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-recordings/{recording_id}:reanalyze': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Reanalyze Recording */
    post: operations['reanalyze_recording_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__reanalyze_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-ax-captures': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Ax Captures
     * @description List unexpired AX debug captures.
     */
    get: operations['list_ax_captures_api_v2_ml_scribe_internal_admin_rpa_ax_captures_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/rpa-ax-captures/{capture_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ax Capture
     * @description Create a short-lived download URL for an unexpired AX capture.
     */
    get: operations['get_ax_capture_api_v2_ml_scribe_internal_admin_rpa_ax_captures__capture_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agent-tooling/evidence-chat:run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Run Evidence Chat
     * @description Replay an evidence-chat turn through the v2 streamer in sandbox mode.
     *
     *     Returns an SSE stream (``text/event-stream``) with the same chunk shape
     *     the production v2 chat endpoint emits — callers consume it via standard
     *     SSE parsers.
     *
     *     Authorization: caller must hold the ``Super Admin`` role on an Auth0
     *     internal-admin tenant token. The admin's heidi_user_id is captured via
     *     ``admin_user_id`` for audit logging — each sandbox replay is therefore
     *     attributable to a named human, not a shared M2M client.
     */
    post: operations['run_evidence_chat_api_v2_ml_scribe_internal_admin_agent_tooling_evidence_chat_run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agentic-personalisation/batch-workflows:run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Start an agentic personalisation batch build workflow */
    post: operations['run_agentic_personalisation_batch_workflow_api_v2_ml_scribe_internal_admin_agentic_personalisation_batch_workflows_run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agentic-personalisation/batch-workflows:preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Preview enrolled users' memory state for a batch build
     * @description Classify enrolled users straight from their ``memory_context`` docs.
     *
     *     No note reads — reports how many enrolled users are empty (no rules),
     *     never built, or stale ('not refreshed', when ``stale_after_days`` is set).
     *     Counts are aggregated server-side and always returned; the per-user list is
     *     opt-in via ``include_users`` and paginated. It's an upper bound on what a
     *     run would do work for: a run still no-ops users with no new edits, which is
     *     only knowable from the notes themselves.
     */
    post: operations['preview_agentic_personalisation_batch_scope_api_v2_ml_scribe_internal_admin_agentic_personalisation_batch_workflows_preview_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/agentic-personalisation/memory:clear': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Clear production memory for some or all enrolled users
     * @description Reset (default) or delete memory_context docs for a memory_type.
     *
     *     Omitting ``user_ids`` targets every enrolled user — guarded behind
     *     ``confirm_all=true`` so a missing list can't silently wipe the cohort.
     */
    post: operations['clear_agentic_personalisation_memory_api_v2_ml_scribe_internal_admin_agentic_personalisation_memory_clear_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integration-agent/agents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Integration Agents
     * @description List Integration Agent registrations with optional filters.
     */
    get: operations['list_integration_agents_api_v2_ml_scribe_internal_admin_integration_agent_agents_get'];
    put?: never;
    /**
     * Create Integration Agent
     * @description Create an API key for a new Integration Agent installation. The raw key is returned ONCE and must be stored by the caller. It is SHA-256 hashed before persistence.
     */
    post: operations['create_integration_agent_api_v2_ml_scribe_internal_admin_integration_agent_agents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integration-agent/agents/{agent_id}:revoke': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Revoke Integration Agent
     * @description Revoke an agent's API key. The agent's next /sync call returns 401.
     */
    post: operations['revoke_integration_agent_api_v2_ml_scribe_internal_admin_integration_agent_agents__agent_id__revoke_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/translator/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Sessions */
    get: operations['list_sessions_api_v2_ml_scribe_internal_admin_translator_sessions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/translator/sessions:search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Search Sessions */
    get: operations['search_sessions_api_v2_ml_scribe_internal_admin_translator_sessions_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/translator/sessions:stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Stats */
    get: operations['get_stats_api_v2_ml_scribe_internal_admin_translator_sessions_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/translator/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Session Detail */
    get: operations['get_session_detail_api_v2_ml_scribe_internal_admin_translator_sessions__session_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/translator/sessions/{session_id}:toggle-pinned': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Toggle Pinned */
    patch: operations['toggle_pinned_api_v2_ml_scribe_internal_admin_translator_sessions__session_id__toggle_pinned_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/translator/sessions/{session_id}/audio-recordings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Audio Recordings */
    get: operations['list_audio_recordings_api_v2_ml_scribe_internal_admin_translator_sessions__session_id__audio_recordings_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/registry/models': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Models */
    get: operations['list_models_api_v2_ml_scribe_internal_admin_evaluations_registry_models_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/registry/models/health-check': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Health Check Models */
    post: operations['health_check_models_api_v2_ml_scribe_internal_admin_evaluations_registry_models_health_check_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/registry/features': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Features */
    get: operations['list_features_api_v2_ml_scribe_internal_admin_evaluations_registry_features_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Experiments */
    get: operations['list_experiments_api_v2_ml_scribe_internal_admin_evaluations_experiments__get'];
    put?: never;
    /** Create Experiment */
    post: operations['create_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/debug-variables': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Debug Variables
     * @description Debug endpoint: load sessions and resolve all variables.
     *
     *     Declared before the /{experiment_id} routes so the static path is not
     *     shadowed by the dynamic segment.
     *
     *     Returns three layers for each session:
     *     - raw: fields directly from MongoDB sampling
     *     - enriched: after VariableBuilderService processes the sample
     *     - diff: only the keys that enrichment added or changed
     */
    get: operations['debug_variables_api_v2_ml_scribe_internal_admin_evaluations_experiments_debug_variables_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/{experiment_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Experiment */
    get: operations['get_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__get'];
    put?: never;
    post?: never;
    /** Delete Experiment */
    delete: operations['delete_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__delete'];
    options?: never;
    head?: never;
    /** Update Experiment */
    patch: operations['update_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/{experiment_id}/execute': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Execute Experiment */
    post: operations['execute_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__execute_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/{experiment_id}/log-full-value': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Log Full Value
     * @description Return the full (untruncated) values for a specific execution log entry.
     */
    get: operations['get_log_full_value_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__log_full_value_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/{experiment_id}/abort': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Abort Experiment */
    post: operations['abort_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__abort_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/inspector/features': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Inspector Features
     * @description List features supported by the variable inspector.
     */
    get: operations['inspector_features_api_v2_ml_scribe_internal_admin_evaluations_experiments_inspector_features_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/inspector/me': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Inspector Me
     * @description Resolve the logged-in admin's Scribe user profile.
     *
     *     Strips the 'internaladmin|' prefix from the admin UID and looks up
     *     the corresponding Scribe User by kinde_user_id. Falls back to email
     *     if the direct ID lookup fails.
     */
    get: operations['inspector_me_api_v2_ml_scribe_internal_admin_evaluations_experiments_inspector_me_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/inspector/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Inspector Sessions
     * @description List sessions for the resolved user.
     */
    get: operations['inspector_sessions_api_v2_ml_scribe_internal_admin_evaluations_experiments_inspector_sessions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/inspector/inspect': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Inspector Inspect
     * @description Inspect all variables for a session + feature combination.
     *
     *     Returns structured variable groups (raw session data vs built prompt
     *     variables) with source metadata and a data-flow diagram.
     */
    get: operations['inspector_inspect_api_v2_ml_scribe_internal_admin_evaluations_experiments_inspector_inspect_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/judge-templates/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Judge Templates */
    get: operations['list_judge_templates_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__get'];
    put?: never;
    /** Create Judge Template */
    post: operations['create_judge_template_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/judge-templates/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Judge Template */
    get: operations['get_judge_template_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__template_id__get'];
    put?: never;
    post?: never;
    /** Delete Judge Template */
    delete: operations['delete_judge_template_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__template_id__delete'];
    options?: never;
    head?: never;
    /** Update Judge Template */
    patch: operations['update_judge_template_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__template_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/prompteams/repos': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Prompteams Repos */
    get: operations['list_prompteams_repos_api_v2_ml_scribe_internal_admin_evaluations_prompteams_repos_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/prompteams/prompts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Prompteams Prompts
     * @description Fetch all prompts for a PromptTeams branch.
     */
    get: operations['list_prompteams_prompts_api_v2_ml_scribe_internal_admin_evaluations_prompteams_prompts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/{experiment_id}/chat/history': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Chat History */
    get: operations['get_chat_history_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__chat_history_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/experiments/{experiment_id}/chat/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Chat With Experiment */
    post: operations['chat_with_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__chat__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/sample-count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Preview Sample Count */
    get: operations['preview_sample_count_api_v2_ml_scribe_internal_admin_evaluations_sample_count_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/generate-judge-prompt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Judge Prompt
     * @description Use an LLM to generate a judge prompt template from a natural-language intent.
     */
    post: operations['generate_judge_prompt_api_v2_ml_scribe_internal_admin_evaluations_generate_judge_prompt_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/evaluations/generate/output-schema': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Output Schema
     * @description Infer a JSON Schema for expected judge output from an existing judge prompt.
     */
    post: operations['generate_output_schema_api_v2_ml_scribe_internal_admin_evaluations_generate_output_schema_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integration-clients': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List integration clients */
    get: operations['list_integration_clients_api_v2_ml_scribe_internal_admin_integration_clients_get'];
    put?: never;
    /** Provision a new integration client */
    post: operations['create_integration_client_api_v2_ml_scribe_internal_admin_integration_clients_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integration-clients/{client_id}:revoke': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Revoke an integration client */
    post: operations['revoke_integration_client_api_v2_ml_scribe_internal_admin_integration_clients__client_id__revoke_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/internal-admin/integration-clients/{client_id}:disable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Disable an integration client */
    post: operations['disable_integration_client_api_v2_ml_scribe_internal_admin_integration_clients__client_id__disable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/p/{download_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Patient-summary PDF download proxy (public)
     * @description Resolve a short download token minted at ``/prepare`` time and redirect the patient to a freshly-presigned S3 URL for the encrypted visit-summary PDF. Public — the token is the auth factor.
     */
    get: operations['download_patient_summary_api_v2_ml_scribe_p__download_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/healthcheck': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Healthcheck
     * @description Health check endpoint for open-api
     */
    get: operations['healthcheck_api_v2_ml_scribe_open_api_healthcheck_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/jwt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Generate Jwt */
    get: operations['generate_jwt_api_v2_ml_scribe_open_api_jwt_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/jwt:validate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Validate Open Api Jwt */
    get: operations['validate_open_api_jwt_api_v2_ml_scribe_open_api_jwt_validate_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/org': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Open Api Access */
    post: operations['create_open_api_access_api_v2_ml_scribe_open_api_internal_admin_org_post'];
    delete?: never;
    options?: never;
    head?: never;
    /** Update Open Api Org Access */
    patch: operations['update_open_api_org_access_api_v2_ml_scribe_open_api_internal_admin_org_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/orgs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Open Api Organizations */
    get: operations['list_open_api_organizations_api_v2_ml_scribe_open_api_internal_admin_orgs_get'];
    put?: never;
    post?: never;
    /** Delete Open Api Org */
    delete: operations['delete_open_api_org_api_v2_ml_scribe_open_api_internal_admin_orgs_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/linked-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Linked Users */
    get: operations['list_linked_users_api_v2_ml_scribe_open_api_internal_admin_linked_user_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin:unlink-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Unlink Open Api User */
    delete: operations['unlink_open_api_user_api_v2_ml_scribe_open_api_internal_admin_unlink_user_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/active-user-usages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Active Users Usage By Ehr Provider */
    get: operations['list_active_users_usage_by_ehr_provider_api_v2_ml_scribe_open_api_internal_admin_active_user_usages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/get-public-s3-presigned-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get S3 Presigned Url */
    get: operations['get_s3_presigned_url_api_v2_ml_scribe_open_api_internal_admin_get_public_s3_presigned_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/chat-export-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Chat Export Presigned Url
     * @description Generate a fresh presigned URL for any chat export stored in SCRIBE_DATA_BUCKET.
     */
    get: operations['get_chat_export_presigned_url_api_v2_ml_scribe_open_api_internal_admin_chat_export_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/link-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link User To Heidi Account
     * @description link Open API User to a Heidi Account. We allow internal admin to link multiple users to one heidi account
     */
    post: operations['link_user_to_heidi_account_api_v2_ml_scribe_open_api_internal_admin_link_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/integration-partner-admin': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Integration Partner Admins
     * @description Get a list of integration partner admin records with pagination
     */
    get: operations['list_integration_partner_admins_api_v2_ml_scribe_open_api_internal_admin_integration_partner_admin_get'];
    put?: never;
    /**
     * Create Integration Partner Admin
     * @description Create a new integration partner admin record
     */
    post: operations['create_integration_partner_admin_api_v2_ml_scribe_open_api_internal_admin_integration_partner_admin_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/internal-admin/integration-partner-admin/{admin_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Integration Partner Admin
     * @description Delete an integration partner admin record
     */
    delete: operations['delete_integration_partner_admin_api_v2_ml_scribe_open_api_internal_admin_integration_partner_admin__admin_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/permissions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Open Api Session Permissions
     * @description Get user's permissions for a specific session and its resources. This may include direct-share-derived permissions, which should not be used to infer access to OpenAPI team-member routes.
     */
    get: operations['get_open_api_session_permissions_api_v2_ml_scribe_open_api_sessions__session_id__permissions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Sessions By Ehr Patient Id And Patient Profile Id
     * @description get all sessions by ehr patient id and Provider
     */
    get: operations['get_sessions_by_ehr_patient_id_and_patient_profile_id_api_v2_ml_scribe_open_api_sessions_get'];
    put?: never;
    /**
     * Create Session
     * @description create a new session
     */
    post: operations['create_session_api_v2_ml_scribe_open_api_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/linked-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Linked User Sessions */
    get: operations['get_linked_user_sessions_api_v2_ml_scribe_open_api_sessions_linked_user_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Details
     * @description get session details
     */
    get: operations['get_session_details_api_v2_ml_scribe_open_api_sessions__session_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Session By Session Id
     * @description delete session by id
     */
    delete: operations['delete_session_by_session_id_api_v2_ml_scribe_open_api_sessions__session_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Session
     * @description update session details by id
     */
    patch: operations['update_session_api_v2_ml_scribe_open_api_sessions__session_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions:batch-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Batch Delete Sessions
     * @description batch delete sessions
     */
    delete: operations['batch_delete_sessions_api_v2_ml_scribe_open_api_sessions_batch_delete_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/consult-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Consult Note
     * @description Generate a session consult note by either template, ai command or ai command text
     *     or generate a session dictation.
     *     dictation - AI cleaned up transcript
     */
    post: operations['generate_consult_note_api_v2_ml_scribe_open_api_sessions__session_id__consult_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Latest Consult Note
     * @description Edit the latest consult note associated with the session
     */
    patch: operations['update_latest_consult_note_api_v2_ml_scribe_open_api_sessions__session_id__consult_note_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/consult-note:link-section': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Consult Note Section Link
     * @description Link a consult note section with an EHR section ID.
     *     Only works with JSON format templates.
     */
    patch: operations['update_consult_note_section_link_api_v2_ml_scribe_open_api_sessions__session_id__consult_note_link_section_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/consult-note/sectional-note-conversion': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Convert Plain Text Note To Sectional Note
     * @description Convert plain text note to sectional note (JSON format)
     */
    post: operations['convert_plain_text_note_to_sectional_note_api_v2_ml_scribe_open_api_sessions__session_id__consult_note_sectional_note_conversion_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/client-customised-qa-template/answers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Client Customised Qa Template Answer
     * @description Generate answers for a client-customised QA template.
     *
     *     This endpoint processes a given client-customised QA template, using the
     *     consult note and session audio transcript to generate and populate answers
     *     for the questions in the template. The resulting answers are returned along
     *     with a summary information that does not contains in client-customized template.
     *
     *     Args:
     *         body (ClientCustomisedQATemplateAnswerRequest): The request body containing
     *             the template content as a JSON string.
     *     Path Params:
     *         session_id (str): The session ID for which the answers are to be generated.
     *
     *     Header:
     *         Authorization (str): The user's JWT
     *
     *     Returns:
     *         ClientCustomisedQATemplateAnswerResponse: The response containing the
     *         question-answer pairs and a summary.
     *
     *     Raises:
     *         HTTPException: Various HTTP exceptions are raised based on the error
     *         conditions:
     *             - 404 NOT FOUND: If the transcription failed due to missing audio.
     *             - 400 BAD REQUEST:
     *                 - If no transcripts were detected.
     *                 - If the transcripts are not ready.
     *             - 404 NOT FOUND: If the consult note is not generated.
     *             - 500 INTERNAL SERVER ERROR:
     *                 - If the answer could not be generated from
     *                   the QA template.
     *                 - If there was an error getting the transcripts.
     *
     *     The endpoint workflow:
     *     1. Get and validate that the consult note is generated for the session.
     *     2. Get and validate that the session audio transcript is generated.
     *     3. Use the consult note and transcript, input client-customised QA template
     *        and output template to generate answers for the template.
     *     4. Map the answers back to the corresponding questions in the template.
     *     5. Return the populated template with answers and a summary.
     *
     *     Note:
     *         The input JSON template is expected to be in a specific format, with placeholders
     *         for answers that will be populated based on the consult note and transcript.
     *
     *     Example Request Body:
     *         {
     *             "template_content": "{"content":"RecallExam\nMedicalHistory-<MedicalHistory>","responses":[{"questionId":"31","question":"MedicalHistory","answerType":"SingleResponse","answerOptions":["Checked-NoChanges","Updated(Pleaseprovidedetails)"]},]}"
     *         }
     *
     *     Example Response Body:
     *         {
     *             "question_answer_pairs": [
     *                 {
     *                     "question_id": "31",
     *                     "question": "Medical History",
     *                     "answer_type": "SingleResponse",
     *                     "answer_options": ["Checked - No Changes", "Updated (Please provide details)"],
     *                     "answer": ["Checked - No Changes"]
     *                 },
     *                 ...
     *             ],
     *             "summary": "Patient is healthy and has no major dental issues."
     *         }
     *
     *     API Usage:
     *     To generate the answers for a client-customised QA template, the user must call consult-note API first
     *     to generate the consult note for the session. Then, use the above input format to pass in the client-customised
     *     QA template and call this API to generate the answers.
     */
    post: operations['generate_client_customised_qa_template_answer_api_v2_ml_scribe_open_api_sessions__session_id__client_customised_qa_template_answers_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Documents
     * @description get all documents for session
     */
    get: operations['get_documents_api_v2_ml_scribe_open_api_sessions__session_id__documents_get'];
    put?: never;
    /**
     * Create Empty Document
     * @description create an empty document for the session. This document is a placeholder for the AI generation in next step.
     *     Args:
     *         session_id (str)
     *
     *     Returns:
     *         Document
     */
    post: operations['create_empty_document_api_v2_ml_scribe_open_api_sessions__session_id__documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/ask-ai': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Ask Ai */
    post: operations['ask_ai_api_v2_ml_scribe_open_api_sessions__session_id__ask_ai_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/transcript': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Transcript
     * @description get session's transcript
     */
    get: operations['get_session_transcript_api_v2_ml_scribe_open_api_sessions__session_id__transcript_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/transcript/live': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Transcript Live
     * @description get session's live transcript with chunks
     */
    get: operations['get_session_transcript_live_api_v2_ml_scribe_open_api_sessions__session_id__transcript_live_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/clinical-codes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Clinical Codes */
    get: operations['get_clinical_codes_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/clinical-codes/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Confirm Clinical Code */
    post: operations['confirm_clinical_code_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/clinical-codes/unconfirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Unconfirm Clinical Code */
    post: operations['unconfirm_clinical_code_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_unconfirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/clinical-codes/{entity_id}/reject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Reject Clinical Code */
    post: operations['reject_clinical_code_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes__entity_id__reject_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/clinical-codes/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Search Clinical Codes */
    get: operations['search_clinical_codes_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/clinical-codes/add-new-code': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Add New Code */
    post: operations['add_new_code_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_add_new_code_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/clinical-codes/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Clinical Code Feedback
     * @description Submit feedback for clinical codes
     */
    post: operations['submit_clinical_code_feedback_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/templates/consult-note-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Consult Note Templates
     * @description Get templates for consult note generation.
     *
     *     If specialty_id is provided, return note structure templates based on specialty.
     *
     *     If specialty_id is not provided, return note structure templates based on user.
     *     paid user: return all templates (note structure + document),
     *     free user/unauthorized user: return note structure templates only
     *
     *     Returns:
     *         GetTemplatesResponseV2: templates for consult note gen
     */
    get: operations['list_consult_note_templates_api_v2_ml_scribe_open_api_templates_consult_note_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/templates/document-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Document Templates
     * @description Get templates for document generation.
     *
     *     If no user provided, specialty_id will be used in demo session.
     *     Both of user and specialty_id can be none: there's no specialty selected in demo.
     *
     *     all users: return all templates (note structure + document).
     *
     *     Returns:
     *         OpenAPIGetTemplatesResponseV2: templates for document gen
     */
    get: operations['list_document_templates_api_v2_ml_scribe_open_api_templates_document_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/templates/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Template */
    get: operations['get_template_api_v2_ml_scribe_open_api_templates__template_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/templates/shared/{shared_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Shared Template
     * @description Retrieve a shared template by ID.
     *
     *     This endpoint is unauthenticated and allows anyone with the link to view
     *     the shared template data.
     *
     *     Returns 404 if the template is not found or has expired.
     */
    get: operations['get_shared_template_api_v2_ml_scribe_open_api_templates_shared__shared_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/specialties': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Specialties
     * @description get specialties
     */
    get: operations['get_specialties_api_v2_ml_scribe_open_api_specialties_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/backup-audios/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Backup Audio
     * @description Upload backup audio file to generate transcript
     */
    post: operations['upload_backup_audio_api_v2_ml_scribe_open_api_sessions__session_id__backup_audios__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/upload-audio/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Audio
     * @description Upload an audio or video file for transcription. Transcription is generated lazily on the next GET /transcript call.
     */
    post: operations['upload_audio_api_v2_ml_scribe_open_api_sessions__session_id__upload_audio__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/restful-segment-transcription': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Restful Segment Transcription
     * @description Start Recording
     */
    post: operations['create_restful_segment_transcription_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/restful-segment-transcription/{recording_id}:transcribe': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Transcribe Segment Recording
     * @description Upload chunk audio file to generate transcript during recording
     */
    post: operations['transcribe_segment_recording_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/restful-segment-transcription/{recording_id}:finish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Finish Restful Segment Transcription
     * @description Inform BE to finish recording
     */
    post: operations['finish_restful_segment_transcription_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription__recording_id__finish_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/client-customised-template/response': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Generate Open Api Client Customised Template Response */
    post: operations['generate_open_api_client_customised_template_response_api_v2_ml_scribe_open_api_sessions__session_id__client_customised_template_response_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/{session_id}/dictate/live-dictation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate live dictation content
     * @description Generate document content from live dictation text input
     */
    post: operations['generate_live_dictation_api_v2_ml_scribe_open_api__session_id__dictate_live_dictation_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/users/linked-account/access': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Validate Open Api Access
     * @description Validate Open API Access for Current User
     */
    get: operations['validate_open_api_access_api_v2_ml_scribe_open_api_users_linked_account_access_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/users/linked-account': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link Heidi Account
     * @description Create open API user linked heidi account
     */
    post: operations['link_heidi_account_api_v2_ml_scribe_open_api_users_linked_account_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/users/linked-account:unlink': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Unlink Open Api User */
    delete: operations['unlink_open_api_user_api_v2_ml_scribe_open_api_users_linked_account_unlink_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/users/linked-account/client-admin-creation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Client Admin Link Heidi Account
     * @description Client Admin Create open API user linked heidi account
     */
    post: operations['client_admin_link_heidi_account_api_v2_ml_scribe_open_api_users_linked_account_client_admin_creation_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/payments/checkout': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Checkout Session
     * @description open api create checkout session
     */
    post: operations['create_checkout_session_api_v2_ml_scribe_open_api_payments_checkout_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/payments/change-plan': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Change Subscribed Plan
     * @description open api upgrade or downgrade subscribed price
     */
    post: operations['change_subscribed_plan_api_v2_ml_scribe_open_api_payments_change_plan_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/payments/add-on-product/{add_on_product_internal_id}/update-subscription': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Append Add On Product Subscription
     * @description update add on product subscription into existing subscription
     */
    post: operations['append_add_on_product_subscription_api_v2_ml_scribe_open_api_payments_add_on_product__add_on_product_internal_id__update_subscription_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/documents/ai-commands': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Open Api List Document Suggested Ai Commands */
    get: operations['open_api_list_document_suggested_ai_commands_api_v2_ml_scribe_open_api_sessions__session_id__documents_ai_commands_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/documents/{document_id}/content': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Open Api Generate Document Content
     * @description generate the content of a document. if body is none, fetch the generation details from the document
     */
    post: operations['open_api_generate_document_content_api_v2_ml_scribe_open_api_sessions__session_id__documents__document_id__content_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Document By Id
     * @description get document details by id
     */
    get: operations['get_document_by_id_api_v2_ml_scribe_open_api_sessions__session_id__documents__document_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Document
     * @description delete document
     */
    delete: operations['delete_document_api_v2_ml_scribe_open_api_sessions__session_id__documents__document_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Document
     * @description update document
     */
    patch: operations['update_document_api_v2_ml_scribe_open_api_sessions__session_id__documents__document_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/third-party/sessions/{session_id}/consult-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Consult Note
     * @description Generate a session consult note by either template, ai command or ai command text
     *     or generate a session dictation.
     *     dictation - AI cleaned up transcript
     */
    post: operations['generate_consult_note_api_v2_ml_scribe_open_api_third_party_sessions__session_id__consult_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/users/third-party-license': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Add Third Party License */
    post: operations['add_third_party_license_api_v2_ml_scribe_open_api_users_third_party_license_post'];
    delete?: never;
    options?: never;
    head?: never;
    /** Unlink Open Api User */
    patch: operations['unlink_open_api_user_api_v2_ml_scribe_open_api_users_third_party_license_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/sessions/{session_id}/context-documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Context Documents
     * @description get session context documents
     */
    get: operations['get_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_get'];
    put?: never;
    /**
     * Upload Session Context Documents
     * @description upload session context documents
     */
    post: operations['upload_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_post'];
    /**
     * Delete Session Context Documents
     * @description delete session context documents
     */
    delete: operations['delete_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_delete'];
    options?: never;
    head?: never;
    /**
     * Update Session Context Documents
     * @description update session context documents
     */
    patch: operations['update_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/users/do-not-ask-languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Add Do Not Ask Language
     * @description Add a language to a user's *Do not ask* list
     */
    put: operations['add_do_not_ask_language_api_v2_ml_scribe_open_api_users_do_not_ask_languages_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/users/supported-languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Supported Languages
     * @description Get available Languages for the session in Open API
     */
    get: operations['get_supported_languages_api_v2_ml_scribe_open_api_users_supported_languages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Details
     * @description get linked user details if exists. Otherwise, returns org level account details
     */
    get: operations['get_user_details_api_v2_ml_scribe_open_api_user_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update User Attributes
     * @description update user attributes
     */
    patch: operations['update_user_attributes_api_v2_ml_scribe_open_api_user_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/user/quota': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Widget User Quota
     * @description Get widget user's quota information
     */
    get: operations['get_widget_user_quota_api_v2_ml_scribe_open_api_user_quota_get'];
    put?: never;
    /**
     * Use Widget Quota
     * @description Record a note push and return updated quota information
     */
    post: operations['use_widget_quota_api_v2_ml_scribe_open_api_user_quota_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/products': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Products
     * @description Open API get all products
     */
    get: operations['get_products_api_v2_ml_scribe_open_api_products_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/products/add-on': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Add On Product
     * @description Open API get add-on product details
     */
    get: operations['get_add_on_product_api_v2_ml_scribe_open_api_products_add_on_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/patient-profiles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Profiles
     * @description list patient profiles
     */
    get: operations['get_patient_profiles_api_v2_ml_scribe_open_api_patient_profiles_get'];
    put?: never;
    /**
     * Create Patient Profile
     * @description create patient profile
     */
    post: operations['create_patient_profile_api_v2_ml_scribe_open_api_patient_profiles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/patient-profiles/{patient_profile_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Profile
     * @description get a single patient profile by id
     */
    get: operations['get_patient_profile_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Patient Profile
     * @description delete patient profile
     */
    delete: operations['delete_patient_profile_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Patient Profile
     * @description update patient profile
     */
    patch: operations['update_patient_profile_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/patient-profiles/{patient_profile_id}/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link Patient Sessions
     * @description set linked sessions to patient profile
     */
    post: operations['link_patient_sessions_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__sessions_post'];
    /**
     * Unlink Patient Sessions
     * @description unlink sessions from patient profile
     */
    delete: operations['unlink_patient_sessions_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__sessions_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/patient-profiles:batch-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Patient Profiles
     * @description open api delete multiple patient profiles at once
     */
    delete: operations['delete_patient_profiles_api_v2_ml_scribe_open_api_patient_profiles_batch_delete_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/team': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Joined Teams
     * @description list joined teams
     */
    get: operations['list_joined_teams_api_v2_ml_scribe_open_api_team_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/team/{team_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Details
     * @description get team details
     */
    get: operations['get_team_details_api_v2_ml_scribe_open_api_team__team_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/teams/{team_id}/members/{member_id}/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Member Sessions
     * @description list sessions for team member
     */
    get: operations['get_team_member_sessions_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions_get'];
    put?: never;
    /**
     * Create Team Member Session
     * @description create session for team member
     */
    post: operations['create_team_member_session_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/teams/{team_id}/members/{member_id}/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Member Session By Id
     * @description get team member session details
     */
    get: operations['get_team_member_session_by_id_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions__session_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Member Session
     * @description update team member session details
     */
    patch: operations['update_team_member_session_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions__session_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/teams/{team_id}/members/{member_id}/sessions/{session_id}/transcript': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Member Session Transcript
     * @description get team member session transcript
     */
    get: operations['get_team_member_session_transcript_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions__session_id__transcript_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/teams/{team_id}/members/{member_id}/patient-profiles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Profiles For Team Member
     * @description list patient profiles for team member
     */
    get: operations['get_patient_profiles_for_team_member_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles_get'];
    put?: never;
    /**
     * Create Patient Profile For Team Member
     * @description create patient profile for team member
     */
    post: operations['create_patient_profile_for_team_member_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/teams/{team_id}/members/{member_id}/patient-profiles/{patient_profile_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Profile For Team Member
     * @description get patient profile for team member
     */
    get: operations['get_patient_profile_for_team_member_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles__patient_profile_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Patient Profile For Team Member
     * @description update patient profile for team member
     */
    patch: operations['update_patient_profile_for_team_member_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles__patient_profile_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/teams/{team_id}/members/{member_id}/patient-profiles/{patient_profile_id}/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link Sessions To Team Member Patient Profile
     * @description link sessions to team member patient profile
     */
    post: operations['link_sessions_to_team_member_patient_profile_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles__patient_profile_id__sessions_post'];
    /**
     * Unlink Sessions From Team Member Patient Profile
     * @description unlink sessions from team member patient profile
     */
    delete: operations['unlink_sessions_from_team_member_patient_profile_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles__patient_profile_id__sessions_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/client-admin/teams': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Client Admin Create Team
     * @description Create a team for a user (integration partner admin only)
     */
    post: operations['client_admin_create_team_api_v2_ml_scribe_open_api_client_admin_teams_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/client-admin/teams/{team_id}/roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Client Admin List Roles
     * @description List available roles for a team (integration partner admin only)
     */
    get: operations['client_admin_list_roles_api_v2_ml_scribe_open_api_client_admin_teams__team_id__roles_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/client-admin/teams/{team_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Client Admin Add Member
     * @description Add a user to a team (integration partner admin only)
     */
    post: operations['client_admin_add_member_api_v2_ml_scribe_open_api_client_admin_teams__team_id__members_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/client-admin/teams/{team_id}/members/{member_kinde_user_id}/roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Client Admin Assign Roles
     * @description Assign roles to a team member (integration partner admin only)
     */
    patch: operations['client_admin_assign_roles_api_v2_ml_scribe_open_api_client_admin_teams__team_id__members__member_kinde_user_id__roles_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/organization/{organization_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Organization Members
     * @description List organization members with pagination
     */
    get: operations['list_organization_members_api_v2_ml_scribe_open_api_organization__organization_id__members_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/competitions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Active Competitions
     * @description Get list of active competitions. Public endpoint, no auth required.
     */
    get: operations['get_active_competitions_api_v2_ml_scribe_open_api_competitions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/competitions/{slug}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Competition By Slug
     * @description Get a competition by slug. Public endpoint, no auth required.
     */
    get: operations['get_competition_by_slug_api_v2_ml_scribe_open_api_competitions__slug__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/competitions/{slug}/leaderboard': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Competition Leaderboard
     * @description Get leaderboard for a competition. Public endpoint, no auth required.
     */
    get: operations['get_competition_leaderboard_api_v2_ml_scribe_open_api_competitions__slug__leaderboard_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/competitions/periods/{period}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Period Leaderboard
     * @description Get leaderboard for a time period. Public endpoint, no auth required.
     */
    get: operations['get_period_leaderboard_api_v2_ml_scribe_open_api_competitions_periods__period__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/open-api/workflows/session': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Session Workflow
     * @description Ensure a session exists for a patient: declarative 'make-it-so' semantics.
     *
     *     Upserts a patient by ehr_patient_id (creating new or refreshing drifted demographics), resolves or creates a session, and links them — in one request.
     *
     *     ``patient`` is required and identifies the patient solely via ``ehr_patient_id``. The ``ehr_patient_id`` is the only reliable key for upsert; a Heidi-sourced patient with no EHR id should use ``POST /api/v2/ml-scribe/patient-profiles`` instead.
     *
     *     ``session`` is optional (all fields optional). ``session.session_id`` is a Heidi session ID from a previous response: providing the same session_id re-enters the existing session without creating a second. The session is returned unchanged; no mutations to template, timezone, or metadata occur. A session you previously created but have since deleted results in a new session being created instead — check ``session_created: true`` in the response to detect this. An unknown session_id returns 400 ``ErrSessionNotFound`` before any write occurs. A session_id whose session is linked to a *different* patient than the request's ``ehr_patient_id`` returns 400 ``ErrSessionPatientMismatch`` — the patient upsert/refresh has already run at that point, but no session is returned or created. Partners holding an existing Heidi ``patient_profile_id`` should use ``POST /api/v2/ml-scribe/open-api/sessions`` with ``patient_profile_id`` instead.
     *
     *     On a returning patient, name, date of birth, gender, email and demographic string are refreshed; a null, omitted, empty or whitespace-only value never clears a stored one. Use ``PATCH /api/v2/ml-scribe/patient-profiles/{id}`` to change phone, sex code or additional context on an existing profile.
     */
    post: operations['create_session_workflow_api_v2_ml_scribe_open_api_workflows_session_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/access-entitlements': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Access Entitlements
     * @description List all active access entitlements for the current user. Automatically includes team and org entitlements.
     */
    get: operations['list_access_entitlements_api_v2_ml_scribe_access_entitlements_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/access-entitlements/team/{team_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Team Member Access Entitlements
     * @description List effective access entitlements for each joined team member (user + team + org, same merge as GET /access-entitlements). Caller must be a team admin.
     */
    get: operations['list_team_member_access_entitlements_api_v2_ml_scribe_access_entitlements_team__team_id__members_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/access-entitlements/team/{team_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Team Access Entitlements
     * @description List effective access entitlements for the team (team + org merge). Caller must be a team admin.
     */
    get: operations['list_team_access_entitlements_api_v2_ml_scribe_access_entitlements_team__team_id__get'];
    /**
     * Upsert Team Entitlement As Team Admin
     * @description Create or update a team-level access entitlement (attachment type Team) for ``team_id``. Creates when no attachment exists; updates ``enabled`` when it does. Request must include ``entitlement_type_id`` and/or ``entitlement_type_name`` (at least one); if both are sent, ``entitlement_type_id`` is used to resolve the type. Caller must be a team admin for this team.
     */
    put: operations['upsert_team_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_team__team_id__put'];
    /**
     * Assign Team Entitlement As Team Admin
     * @description Assign a team-level access entitlement (attachment type Team) for ``team_id``. Request must include ``entitlement_type_id`` and/or ``entitlement_type_name`` (at least one); if both are sent, ``entitlement_type_id`` is used to resolve the type. Caller must be a team admin for this team.
     */
    post: operations['assign_team_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_team__team_id__post'];
    /**
     * Delete Team Entitlement As Team Admin
     * @description Soft-delete a team-level access entitlement (attachment type Team) for ``team_id``. ``entitlement_type_id`` and/or ``entitlement_type_name`` (at least one). Caller must be a team admin for this team.
     */
    delete: operations['delete_team_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_team__team_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/access-entitlements/users/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Assign User Entitlements As Team Admin
     * @description Assign or update an access entitlement for multiple users (creates new attachments or updates ``enabled`` when already assigned). Request must include ``entitlement_type_id`` and/or ``entitlement_type_name`` (at least one); if both are sent, ``entitlement_type_id`` is used to resolve the type. Caller must be a team admin; each target user must belong to the same team.
     */
    post: operations['bulk_assign_user_entitlements_as_team_admin_api_v2_ml_scribe_access_entitlements_users_batch_post'];
    /**
     * Bulk Delete User Entitlements As Team Admin
     * @description Soft-delete the same direct access entitlement for multiple users (``entitlement_type_id`` and/or ``entitlement_type_name``; at least one). Caller must be a team admin; each target user must belong to the caller's team. Per-user results are returned in ``succeeded`` and ``failed`` (same shape as bulk assign).
     */
    delete: operations['bulk_delete_user_entitlements_as_team_admin_api_v2_ml_scribe_access_entitlements_users_batch_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/access-entitlements/users/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Upsert User Entitlement As Team Admin
     * @description Create or update a user's direct access entitlement. Creates when no attachment exists; updates ``enabled`` when it does. Request must include ``entitlement_type_id`` and/or ``entitlement_type_name`` (at least one); if both are sent, ``entitlement_type_id`` is used to resolve the type. Caller must be a team admin; the target user must belong to the same team.
     */
    put: operations['upsert_user_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_users__user_ref_id__put'];
    /**
     * Assign User Entitlement As Team Admin
     * @description Assign an access entitlement to a user. Request must include ``entitlement_type_id`` and/or ``entitlement_type_name`` (at least one); if both are sent, ``entitlement_type_id`` is used to resolve the type. Caller must be a team admin; the target user must belong to the same team.
     */
    post: operations['assign_user_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_users__user_ref_id__post'];
    /**
     * Delete User Entitlement As Team Admin
     * @description Soft-delete a user's direct access entitlement for a given type (``entitlement_type_id`` and/or ``entitlement_type_name``; at least one). Caller must be a team admin; the target user must belong to the same team.
     */
    delete: operations['delete_user_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_users__user_ref_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update User Entitlement As Team Admin
     * @description Update ``enabled`` on a user's direct access entitlement. Request must include ``entitlement_type_id`` and/or ``entitlement_type_name`` (at least one); if both are sent, ``entitlement_type_id`` is used to resolve the type. Caller must be a team admin; the target user must belong to the same team.
     */
    patch: operations['update_user_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_users__user_ref_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/coding-cases/access-context': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mint Coding Case Access Context
     * @description Mint a short-lived JWT for service-clinical-coding (SCC), Heidi's clinical coding backend. TTL matches the caller's Heidi access-token expiry. Frontend bootstrap should call this after confirming coder_seat via GET /access-entitlements (token fields are not on that response).
     */
    post: operations['mint_coding_case_access_context_api_v2_ml_scribe_coding_cases_access_context_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/.well-known/scc-access-context-jwks.json': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** JWKS for service-clinical-coding (SCC) access-context JWT verification */
    get: operations['scc_access_context_jwks_api_v2_ml_scribe__well_known_scc_access_context_jwks_json_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/notifications': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Ml Scribe Agents Notifications Stream
     * @description Tail the agent-event bus for the authenticated user.
     *
     *     The primary stream key is the authenticated ``user.user_ref_id``. During
     *     migration, the authenticated user's legacy Kinde uid is also subscribed
     *     when present so old Kinde-subject runs keep delivering live events.
     *     Cross-user reads are impossible by construction because every candidate
     *     id is derived from the authenticated user, never from request input.
     *     ``Last-Event-ID`` resumption is supported (consumers dedup by
     *     ``AgentEvent.event_id`` for the inevitable replay after Redis-stream TTL
     *     expiry). Backfill entries whose ``event_id`` already has an execution
     *     receipt for this subject are filtered out so a reload doesn't re-run
     *     handlers the FE has already executed.
     *
     *     Live tail emits ``FrontendBusEvent`` (slim shape under SSE event name
     *     ``frontend.event``), ``InboxDirtyEvent`` (full envelope for inbox
     *     invalidation), ``ComputerUseTargetAssignedEvent`` (full envelope for
     *     native desktop-target assignment), and temporary legacy run-scoped
     *     mirrors such as ``RemoteToolRequestEvent`` and ``EvidenceChunkEvent``.
     *     Canonical run-scoped progress belongs on ``GET /agents/runs/{id}/stream``;
     *     the mirrors remain here only for deployed clients during rollout.
     *     Lifecycle ``ChannelEndedEvent`` is dropped — IA admin territory.
     *     Backfill is narrower: only ``FrontendBusEvent`` replays.
     *
     *     The connection ends only when the client disconnects.
     */
    get: operations['ml_scribe_agents_notifications_stream_api_v2_ml_scribe_agents_notifications_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/events/{event_id}:resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ml Scribe Agents Events Resolve
     * @description Record an approval verdict and dispatch when terminal.
     *
     *     Persist-first: the service writes the verdict to the resolution row
     *     before any workflow signal, so a denied/approved decision survives
     *     even when the live workflow is gone. Terminal-state rules live in
     *     ``FrontendEventResolutionService.record_approval_and_maybe_dispatch``.
     */
    post: operations['ml_scribe_agents_events_resolve_api_v2_ml_scribe_agents_events__event_id__resolve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/events/{event_id}:ack': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ml Scribe Agents Events Ack
     * @description Record an execution outcome and dispatch the terminal verdict.
     *
     *     A successful ack always dispatches: either the row is purely an
     *     ack-only event (no approval phase) or the approval was approved
     *     earlier and the FE has now finished running the handler. A failure
     *     ack dispatches with ``status=failure`` so the agent's tool result
     *     surfaces the error without the agent having to poll.
     */
    post: operations['ml_scribe_agents_events_ack_api_v2_ml_scribe_agents_events__event_id__ack_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Ml Scribe Agent Runs List
     * @description Subject-scoped run list for the authenticated user.
     *
     *     Designed for mobile home surfaces: call with
     *     ``?status=running&kind=computer_use`` to discover active
     *     computer-use subagent runs without polling individual parent
     *     snapshots.
     */
    get: operations['ml_scribe_agent_runs_list_api_v2_ml_scribe_agents_runs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Ml Scribe Agent Runs Details
     * @description Return a subject-owned run snapshot for stream recovery.
     */
    get: operations['ml_scribe_agent_runs_details_api_v2_ml_scribe_agents_runs__agent_run_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/turns': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ml Scribe Agent Runs Submit Turn
     * @description Submit a follow-up turn for an authenticated subject-owned run.
     */
    post: operations['ml_scribe_agent_runs_submit_turn_api_v2_ml_scribe_agents_runs__agent_run_id__turns_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/attachments/{attachment_id}/download-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Ml Scribe Agent Runs Attachment Download Url
     * @description Return a presigned attachment URL for a subject-owned run.
     */
    get: operations['ml_scribe_agent_runs_attachment_download_url_api_v2_ml_scribe_agents_runs__agent_run_id__attachments__attachment_id__download_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/stream': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Ml Scribe Agent Runs Stream
     * @description Tail one subject-owned run's raw LLM/tool transcript stream.
     *
     *     This is the FE-facing parity endpoint for IA's run-scoped messages stream.
     *     The sibling ``/agents/notifications`` route carries AgentEvent envelopes;
     *     this route carries raw ``LLMStreamEvent`` frames for the transcript UI and
     *     remote tool executors.
     *
     *     ``follow=true`` keeps the connection open across turn boundaries (until the
     *     run terminates or the client disconnects) so a mounted chat can watch for
     *     turns started on other devices — the ``turn_started`` frame is the FE's cue
     *     to refetch the snapshot for the remote turn's user message. Default (per
     *     turn) closes when the current turn completes.
     *
     *     Opt-in on purpose (not always-on): a long-lived stream holds a connection,
     *     and HTTP/1.1 caps ~6 per origin (HTTP/2+/3 multiplex past it, but proxies/VPNs
     *     can downgrade to 1.1). Only the primary open chat should follow; other per-run
     *     streams stay per-turn. See streaming.md → Follow Mode.
     */
    get: operations['ml_scribe_agent_runs_stream_api_v2_ml_scribe_agents_runs__agent_run_id__stream_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Ml Scribe Agents Runs Agent Run Id Events Stream
     * @description Tail one subject-owned run from the per-user bus.
     *
     *     Full ``AgentEvent`` shape (RPA clients need ``RemoteToolRequestEvent``
     *     envelopes); filters by ``agent_run_id`` consumer-side; ends on
     *     ``ChannelEndedEvent``. Wrong subject → 404 (no enumeration leak).
     *
     *     Backfill suppresses ``remote.tool_request`` frames whose ``tool_call_id``
     *     already has a persisted result, so a fresh executor attach (app relaunch,
     *     reload) resumes from the still-pending request only and does not
     *     physically re-run already-answered GUI actions.
     */
    get: operations['ml_scribe_agents_runs_agent_run_id_events_stream_api_v2_ml_scribe_agents_runs__agent_run_id__events_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/approvals': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Agent Run Approvals
     * @description List pending generic tool approvals for a subject-owned run.
     */
    get: operations['list_agent_run_approvals_api_v2_ml_scribe_agents_runs__agent_run_id__approvals_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/approvals/{approval_id}:resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Resolve Agent Run Approval
     * @description Resolve a generic tool approval for the authenticated run subject.
     */
    post: operations['resolve_agent_run_approval_api_v2_ml_scribe_agents_runs__agent_run_id__approvals__approval_id__resolve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/waits/{wait_id}:resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Resolve Agent Run Wait
     * @description Resolve a generic durable wait for the authenticated run subject.
     */
    post: operations['resolve_agent_run_wait_api_v2_ml_scribe_agents_runs__agent_run_id__waits__wait_id__resolve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/tool-result': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Agent Tool Result
     * @description Fulfill a remote-executed tool wait for the authenticated subject.
     */
    post: operations['submit_agent_tool_result_api_v2_ml_scribe_agents_runs__agent_run_id__tool_result_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}:cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Cancel Agent Run
     * @description Cancel only the active turn for the authenticated subject.
     */
    post: operations['cancel_agent_run_api_v2_ml_scribe_agents_runs__agent_run_id__cancel_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}/approval-mode': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Ml Scribe Agent Runs Set Approval Mode
     * @description Set the run's blanket approval mode for the authenticated subject.
     */
    patch: operations['ml_scribe_agent_runs_set_approval_mode_api_v2_ml_scribe_agents_runs__agent_run_id__approval_mode_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/agents/runs/{agent_run_id}:close': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Close Agent Run
     * @description Close an agent run for the authenticated subject.
     */
    post: operations['close_agent_run_api_v2_ml_scribe_agents_runs__agent_run_id__close_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/inbox/items': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Ml Scribe Inbox Items */
    get: operations['ml_scribe_inbox_items_api_v2_ml_scribe_inbox_items_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/inbox/items/{approval_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Ml Scribe Inbox Item Detail */
    get: operations['ml_scribe_inbox_item_detail_api_v2_ml_scribe_inbox_items__approval_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/inbox/count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Ml Scribe Inbox Count */
    get: operations['ml_scribe_inbox_count_api_v2_ml_scribe_inbox_count_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/inbox/items:bulk-resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Ml Scribe Inbox Bulk Resolve */
    post: operations['ml_scribe_inbox_bulk_resolve_api_v2_ml_scribe_inbox_items_bulk_resolve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/api-status-check-log': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Log an API status check result
     * @description Persist the outcome of an API status check run from the settings page. Captures who ran the check, when, and the per-domain results so internal admins can audit connectivity issues over time.
     */
    post: operations['log_api_status_check_api_v2_ml_scribe_api_status_check_log_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/diagnostics': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Log privacy-safe client SDK diagnostics
     * @description Log a bounded diagnostics snapshot without persisting it.
     *
     *     Healthy reports stay at info. Any Flagsmith / Datadog failure mode is logged
     *     at error so blocked-provider and unreachable-RUM cases stand out in Datadog.
     */
    post: operations['log_diagnostics_api_v2_ml_scribe_diagnostics_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/note-suggestions/adaptive-learning-popover': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Adaptive Learning Popover
     * @description Whether to offer the adaptive-learning opt-in popover to this user right now: rollout is on for them (release-scribe-adaptive-learning), they are a Labs member with learned rules waiting in memory, they haven't opted in yet, and the per-user show cap allows it. Enrolment is FE-owned (the popover's 'Turn on' sets the trait the build/apply flags key on), so this endpoint carries only the show decision.
     */
    get: operations['get_adaptive_learning_popover_api_v2_ml_scribe_note_suggestions_adaptive_learning_popover_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/note-suggestions/adaptive-learning/availability': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Adaptive Learning Availability
     * @description Whether the settings-page adaptive-learning card should be shown for this user: the master flag (release-scribe-adaptive-learning) is on for them AND they have learned rules waiting in memory. Both self-gate on the memory-build rollout, so the card appears exactly for users the funnel has reached. Separate from the offer decision — the offer is now frame-driven at note completion.
     */
    get: operations['get_adaptive_learning_availability_api_v2_ml_scribe_note_suggestions_adaptive_learning_availability_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/note-suggestions/{suggestion_id}/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record Suggestion Feedback
     * @description Record user feedback (accepted | rejected | skipped | skipped_edit) for a note suggestion emitted at the end of consult-note streaming. `skipped_edit` is the FE's auto-dismissal signal when the user edits the note before reacting (offsets become stale); it's persisted but excluded from the `max_responses` quota. One-shot — a second call returns 409.
     */
    post: operations['record_suggestion_feedback_api_v2_ml_scribe_note_suggestions__suggestion_id__feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/note-suggestions/{suggestion_id}/graduate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Graduate Note Suggestion
     * @description Graduate an `opt_in_ask` suggestion to auto-apply: re-run the suggestion's substitutions against the CURRENT consult note text (whole-word, case-sensitive — the same matching the preview highlighted, so clinician edits made after the frame are preserved) AND set the caller's `adaptive_learning` opt-in override so the next note auto-applies. Self-scoped — a suggestion owned by another user returns 404, as does a caller outside the adaptive-learning rollout or a suggestion that is not an apply-shaped emission. Idempotent: a re-tap after graduation returns 200 with `applied=false` rather than re-applying or 500ing.
     */
    post: operations['graduate_note_suggestion_api_v2_ml_scribe_note_suggestions__suggestion_id__graduate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/note-push-targets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Note Push Hints
     * @description List a template's stored hints, optionally narrowed to one EMR app.
     *
     *     ``include_structured`` WIDENS the read to both payload shapes rather than
     *     selecting one: warm apply needs a section's text and structured mappings
     *     together to plan a push, and a shape-selecting flag would cost it a second
     *     round trip on a clinical path. Off by default, so the toolbar client's
     *     response stays byte-identical to what it has always received.
     */
    get: operations['list_note_push_hints_api_v2_ml_scribe_note_push_targets_get'];
    put?: never;
    /**
     * Record Note Push Hints
     * @description Upsert per-section EMR field selectors, validated like the agent tool.
     *
     *     Validation is atomic, not the write: every grammar, heading, and
     *     record-after-verify check runs before any row is written, so an invalid
     *     call is rejected without a partial write. The per-section upserts
     *     themselves are sequential and not wrapped in a transaction.
     */
    post: operations['record_note_push_hints_api_v2_ml_scribe_note_push_targets_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/authentication/validate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Verify Token
     * @description Used to validate requests
     *     Returns:
     *         VerifyTokenResponse: True if the token is valid, False otherwise
     *     Raises:
     *         UnauthorizedAccessHTTPException: If the token is invalid
     */
    get: operations['verify_token_api_v2_ml_scribe_authentication_validate_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/billings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Billing Info
     * @description get billing info
     */
    get: operations['get_billing_info_api_v2_ml_scribe_billings_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/billings/add-on-products': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Add On Billing Info
     * @description get add-on billing info
     */
    get: operations['get_add_on_billing_info_api_v2_ml_scribe_billings_add_on_products_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/billings/activate-clinician-trial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Activate Clinician Trial
     * @description Activate clinician evidence trial based on user's current subscription tier
     */
    post: operations['activate_clinician_trial_api_v2_ml_scribe_billings_activate_clinician_trial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/billings/cancel-reverse-trial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Cancel Reverse Trial
     * @description Cancel reverse trial
     */
    post: operations['cancel_reverse_trial_api_v2_ml_scribe_billings_cancel_reverse_trial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/billings/apply-discount': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Apply Subscription Discount
     * @description Apply a configured Stripe coupon for the given discount type to the authenticated user's active Stripe subscription.
     */
    post: operations['apply_subscription_discount_api_v2_ml_scribe_billings_apply_discount_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/billings/cancellation-intent': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record Cancellation Intent
     * @description Record cancellation survey intent before Stripe cancel handoff.
     */
    post: operations['record_cancellation_intent_api_v2_ml_scribe_billings_cancellation_intent_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/credit-allowance': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get the current user's credit allowance for the current cycle */
    get: operations['get_credit_allowance_api_v2_ml_scribe_credit_allowance_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/billings/request-heidi-2-access': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Request Heidi 2 Access
     * @description Ask every admin of the current workspace, by email, to opt it in to Heidi 2.0. Heidi 1 workspace members only. A repeat request for the same workspace sends nothing and reports zero notifications.
     */
    post: operations['request_heidi_2_access_api_v2_ml_scribe_billings_request_heidi_2_access_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calculators': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List all available calculators */
    get: operations['list_calculators_api_v2_ml_scribe_calculators_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calculators/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Search calculators by query */
    get: operations['search_calculators_api_v2_ml_scribe_calculators_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calculators/{calculator_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get calculator metadata and input definitions */
    get: operations['get_calculator_api_v2_ml_scribe_calculators__calculator_key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calculators/{calculator_key}:execute': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Execute a medical calculator */
    post: operations['execute_calculator_api_v2_ml_scribe_calculators__calculator_key__execute_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/capabilities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List all capabilities
     * @description Get all available capability definitions
     */
    get: operations['get_capabilities_api_v2_ml_scribe_capabilities_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/capabilities/me': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List user's capability configs
     * @description Get all capabilities with user's connection status
     */
    get: operations['get_user_capabilities_api_v2_ml_scribe_capabilities_me_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/capabilities/{slug}/actions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update enabled actions
     * @description Update which actions are enabled for a capability
     */
    patch: operations['update_capability_actions_api_v2_ml_scribe_capabilities__slug__actions_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/capabilities/autocomplete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get capability autocomplete
     * @description Get capabilities for @mention autocomplete in SOP editor
     */
    get: operations['get_capability_autocomplete_api_v2_ml_scribe_capabilities_autocomplete_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/exports/download': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download Chat Export
     * @description Redirect to a freshly-minted presigned S3 URL for a chat export.
     *
     *     Validates that ``key`` begins with an allowed chat-export prefix and that
     *     ``token`` is a valid HMAC signature of ``key``. New-format tokens
     *     (``{expires_at}.{hmac}``, SEC-739) are always accepted when unexpired;
     *     legacy bare-hex tokens are accepted only while the
     *     ``release-chat-export-token-expiry-enforcement`` flag is off (30-day
     *     grace period). Mints a fresh short-lived S3 presigned URL and
     *     302-redirects to it.
     */
    get: operations['download_chat_export_api_v2_ml_scribe_chat_exports_download_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/sbs/setup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Setup Evidence Sbs
     * @description Pre-check and create candidates for Evidence SBS experiment.
     */
    post: operations['setup_evidence_sbs_api_v2_ml_scribe_chat_sbs_setup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/sbs/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Confirm Evidence Sbs
     * @description Confirm which candidate the user selected in an Evidence SBS experiment.
     */
    post: operations['confirm_evidence_sbs_api_v2_ml_scribe_chat_sbs_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/sbs/skip': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Skip Evidence Sbs
     * @description Record that the user dismissed the SBS overlay without picking a candidate. Writes the Redis cooldown so subsequent Evidence chats do not re-trigger SBS until the cooldown TTL expires. Does NOT call confirm semantics — the experiment row is left with is_user_selected=False to preserve win-rate metrics.
     */
    post: operations['skip_evidence_sbs_api_v2_ml_scribe_chat_sbs_skip_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/clinical-tasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Tasks */
    get: operations['get_tasks_api_v2_ml_scribe_clinical_tasks_get'];
    put?: never;
    /** Create Task */
    post: operations['create_task_api_v2_ml_scribe_clinical_tasks_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/clinical-tasks/bulk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Bulk Delete
     * @description Bulk delete multiple clinical tasks.
     *
     *     Soft deletes multiple tasks in a single request.
     *     Only tasks owned by the authenticated user will be deleted.
     *
     *     Args:
     *         body: Request containing list of task IDs to delete
     *
     *     Returns:
     *         BulkDeleteResponse with lists of deleted and failed task IDs
     */
    delete: operations['bulk_delete_api_v2_ml_scribe_clinical_tasks_bulk_delete'];
    options?: never;
    head?: never;
    /**
     * Bulk Update Status
     * @description Bulk update status for multiple clinical tasks.
     *
     *     Updates the status of multiple tasks in a single request.
     *     Only tasks owned by the authenticated user will be updated.
     *
     *     Args:
     *         body: Request containing list of task IDs and target status
     *
     *     Returns:
     *         BulkUpdateStatusResponse with lists of updated and failed task IDs
     */
    patch: operations['bulk_update_status_api_v2_ml_scribe_clinical_tasks_bulk_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/clinical-tasks/{task_id}:assign': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Assign Task */
    post: operations['assign_task_api_v2_ml_scribe_clinical_tasks__task_id__assign_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/clinical-tasks/{task_id}:unassign': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Unassign Task */
    post: operations['unassign_task_api_v2_ml_scribe_clinical_tasks__task_id__unassign_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/clinical-tasks/{task_id}:link': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link
     * @description Link to a clinical task.
     *
     *     Idempotent: if a link with the same type-specific key is already linked,
     *     returns 200 with the current task state and outcome "already_linked".
     *     New links return outcome "linked".
     */
    post: operations['link_api_v2_ml_scribe_clinical_tasks__task_id__link_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/clinical-tasks/{task_id}:unlink': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Unlink
     * @description Unlink from a clinical task.
     *
     *     Idempotent: if no link with the same type-specific key is linked,
     *     returns 200 with the current task state and outcome "not_linked".
     *     Removed links return outcome "unlinked".
     */
    post: operations['unlink_api_v2_ml_scribe_clinical_tasks__task_id__unlink_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/clinical-tasks/{task_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Task */
    get: operations['get_task_api_v2_ml_scribe_clinical_tasks__task_id__get'];
    /** Update Task */
    put: operations['update_task_api_v2_ml_scribe_clinical_tasks__task_id__put'];
    post?: never;
    /** Delete Task */
    delete: operations['delete_task_api_v2_ml_scribe_clinical_tasks__task_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/clinical-tasks/session/{session_id}/generate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Generate Session Tasks */
    post: operations['generate_session_tasks_api_v2_ml_scribe_clinical_tasks_session__session_id__generate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/homepage': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get CPD homepage data
     * @description Get all aggregated data for the CPD homepage in a single call: journals, recommended reads, recent sources, and stats.
     */
    get: operations['get_cpd_homepage_api_v2_ml_scribe_cpd_homepage_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/activities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List CPD activities with settings-aware times
     * @description Get all activities (chat sessions) with sources and times calculated per the user's time calculation settings. Single call — no client-side recalculation needed.
     */
    get: operations['list_activities_api_v2_ml_scribe_cpd_activities_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/journals': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List aggregated journals
     * @description Get journals/publishers aggregated from CPD sources, ranked by total citations. Supports search filtering.
     */
    get: operations['list_journals_api_v2_ml_scribe_cpd_journals_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get CPD statistics
     * @description Get aggregated CPD statistics including total time, sources, and period breakdown.
     */
    get: operations['get_cpd_stats_api_v2_ml_scribe_cpd_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/sources': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List CPD sources
     * @description Get paginated list of CPD sources with filtering and sorting.
     */
    get: operations['list_cpd_sources_api_v2_ml_scribe_cpd_sources_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/sources/{source_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get CPD source details
     * @description Get detailed information about a specific CPD source including all appearances.
     */
    get: operations['get_cpd_source_api_v2_ml_scribe_cpd_sources__source_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export CPD log
     * @description Export CPD sources as a flat list for a date range.
     */
    get: operations['export_cpd_log_api_v2_ml_scribe_cpd_export_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/settings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get CPD settings
     * @description Get user's CPD time calculation preferences.
     */
    get: operations['get_cpd_settings_api_v2_ml_scribe_cpd_settings_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update CPD settings
     * @description Update user's CPD time calculation preferences.
     */
    patch: operations['update_cpd_settings_api_v2_ml_scribe_cpd_settings_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/sources/{source_id}/read': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark source as read
     * @description Mark a CPD source as read/opened by the user.
     */
    post: operations['mark_source_as_read_api_v2_ml_scribe_cpd_sources__source_id__read_post'];
    /**
     * Mark source as unread
     * @description Mark a CPD source as unread (reset read status).
     */
    delete: operations['mark_source_as_unread_api_v2_ml_scribe_cpd_sources__source_id__read_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/activities/{chat_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete CPD activity
     * @description Delete a CPD activity and all its associated source appearances.
     */
    delete: operations['delete_cpd_activity_api_v2_ml_scribe_cpd_activities__chat_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/sources/{source_id}/read-status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get source read status
     * @description Get read/unread status for a CPD source.
     */
    get: operations['get_source_read_status_api_v2_ml_scribe_cpd_sources__source_id__read_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/sources/{source_id}/save': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Save/bookmark source
     * @description Save a CPD source to the user's reading list.
     */
    post: operations['save_source_api_v2_ml_scribe_cpd_sources__source_id__save_post'];
    /**
     * Unsave/unbookmark source
     * @description Remove a CPD source from the user's reading list.
     */
    delete: operations['unsave_source_api_v2_ml_scribe_cpd_sources__source_id__save_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/sources/save-by-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ensure source exists and save by URL
     * @description Ensures the CPD source for the given URL exists (creating it on-demand if needed), then saves it to the user's reading list. Designed for the chat/evidence interface where CPD processing may not have completed yet.
     */
    post: operations['save_source_by_url_api_v2_ml_scribe_cpd_sources_save_by_url_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/sources/read-by-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ensure source exists and mark as read by URL
     * @description Ensures the CPD source for the given URL exists (creating it on-demand if needed), then marks it as read. Designed for the chat/evidence interface where CPD processing may not have completed yet.
     */
    post: operations['read_source_by_url_api_v2_ml_scribe_cpd_sources_read_by_url_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/saved': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List saved sources
     * @description Get all saved/bookmarked CPD sources for the user.
     */
    get: operations['list_saved_sources_api_v2_ml_scribe_cpd_saved_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/drafts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List export drafts
     * @description Get CPD export drafts for the user, optionally filtered by draft_id or date range.
     */
    get: operations['list_drafts_api_v2_ml_scribe_cpd_drafts_get'];
    put?: never;
    /**
     * Create export draft
     * @description Create a new CPD export draft.
     */
    post: operations['create_draft_api_v2_ml_scribe_cpd_drafts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/drafts/{draft_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Update export draft
     * @description Update an existing CPD export draft.
     */
    put: operations['update_draft_api_v2_ml_scribe_cpd_drafts__draft_id__put'];
    post?: never;
    /**
     * Delete export draft
     * @description Delete a CPD export draft.
     */
    delete: operations['delete_draft_api_v2_ml_scribe_cpd_drafts__draft_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/drafts/{draft_id}/submit': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit draft
     * @description Convert a draft to a submission record and delete the draft.
     */
    post: operations['submit_draft_api_v2_ml_scribe_cpd_drafts__draft_id__submit_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/submissions/{submission_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete submission
     * @description Delete a CPD export submission record.
     */
    delete: operations['delete_submission_api_v2_ml_scribe_cpd_submissions__submission_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/submissions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List submissions
     * @description Get CPD export submission history for the user.
     */
    get: operations['list_submissions_api_v2_ml_scribe_cpd_submissions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cpd/submissions/{submission_id}/pdf': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download CPD Activity Log PDF
     * @description Download a PDF activity log for a submitted CPD draft. Gated by the release-evidence-cpd-pdf feature flag.
     */
    get: operations['download_activity_log_pdf_api_v2_ml_scribe_cpd_submissions__submission_id__pdf_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/cqc-practices/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Cqc Practices
     * @description Search CQC practices by name. Returns top matches.
     */
    get: operations['search_cqc_practices_api_v2_ml_scribe_cqc_practices_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/dictation-post-processing/desktop': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Post Process Desktop Dictation */
    post: operations['post_process_desktop_dictation_api_v2_ml_scribe_dictation_post_processing_desktop_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/dictation-post-processing/context': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Dictation Context
     * @description Serve merged dictation context terms using a rolling session window.
     */
    get: operations['get_dictation_context_api_v2_ml_scribe_dictation_post_processing_context_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/template-creation-record/dictate/live-dictation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Live Dictation For Template Creation */
    post: operations['live_dictation_for_template_creation_api_v2_ml_scribe_template_creation_record_dictate_live_dictation_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/dictation/verbal-commands-languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Verbal Commands Languages
     * @description Languages that support dictation verbal commands.
     */
    get: operations['get_verbal_commands_languages_api_v2_ml_scribe_dictation_verbal_commands_languages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/dictation/app-categories': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Dictation App Categories
     * @description Effective dictation app categories for the user (app identifiers + resolved tone).
     */
    get: operations['get_dictation_app_categories_api_v2_ml_scribe_dictation_app_categories_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/dictation/app-categories/{category_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Set Dictation App Category Tone
     * @description Set the user's tone for a category (by slug); returns the updated category.
     */
    patch: operations['set_dictation_app_category_tone_api_v2_ml_scribe_dictation_app_categories__category_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/integration-agent/register': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Register
     * @description Agent calls on startup to register hostname/version. Safe to call repeatedly.
     */
    post: operations['register_api_v2_ml_scribe_integration_agent_register_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integration-agent/sync': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync
     * @description Agent polls for pending commands and reports current status. Holds the connection for up to 30s if no commands are queued (long-poll).
     */
    post: operations['sync_api_v2_ml_scribe_integration_agent_sync_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integration-agent/commands/{request_id}/result': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Post Command Result
     * @description Agent reports the outcome of an executed command. Idempotent.
     */
    post: operations['post_command_result_api_v2_ml_scribe_integration_agent_commands__request_id__result_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integration-agent/agents/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Agent Status
     * @description Returns the online/offline state of the clinic's Integration Agent. Resolves the caller's clinic via their team memberships.
     */
    get: operations['get_agent_status_api_v2_ml_scribe_integration_agent_agents_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integration-agent/agents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Accessible Agents
     * @description Returns Integration Agents scoped to the caller's active team, plus agents scoped to the active team's root organization. Parent and sibling team-scoped agents are excluded.
     */
    get: operations['list_accessible_agents_api_v2_ml_scribe_integration_agent_agents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/authentication/authorization-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Ehr Launch Authorization Url */
    get: operations['get_ehr_launch_authorization_url_api_v2_ml_scribe_ehr_launch_authentication_authorization_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/authentication/access-token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Ehr Launch Access Token With Authorization Code */
    get: operations['get_ehr_launch_access_token_with_authorization_code_api_v2_ml_scribe_ehr_launch_authentication_access_token_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/authentication': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ehr Launch Access Token
     * @deprecated
     */
    get: operations['get_ehr_launch_access_token_api_v2_ml_scribe_ehr_launch_authentication_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/authentication/access-token-v2': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ehr Launch Access Token With Authorization Code V2
     * @description V2 parallel endpoint using centralized OAuth service.
     *     This endpoint uses the new centralized OAuth and JWT validation logic
     *     without requiring adaptor dependencies.
     */
    get: operations['get_ehr_launch_access_token_with_authorization_code_v2_api_v2_ml_scribe_ehr_launch_authentication_access_token_v2_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/patient': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Ehr Launch Patient Details */
    get: operations['get_ehr_launch_patient_details_api_v2_ml_scribe_ehr_launch_patient_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/sessions/{session_id}/consult-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Sync Consult Note To Ehr */
    post: operations['sync_consult_note_to_ehr_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/sessions/{session_id}/consult-note/sectional': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Sectional Note To Ehr
     * @description Sync sectional note to EHR
     */
    post: operations['sync_sectional_note_to_ehr_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_sectional_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/sessions/{session_id}/consult-note/sectional-standardized': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Standardized Sectional Note To Ehr
     * @description Sync standardized sectional note to EHR using SectionalNoteSection enum
     */
    post: operations['sync_standardized_sectional_note_to_ehr_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_sectional_standardized_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/sessions/{session_id}/consult-note/ehr-latest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ehr Latest Note
     * @description Get the latest note for a patient from the EHR system using session data
     */
    get: operations['get_ehr_latest_note_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_ehr_latest_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/sessions/{session_id}/consult-note/past-ehr-notes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Past Ehr Notes
     * @description Get the past notes for a patient from the EHR system using session data
     */
    get: operations['get_past_ehr_notes_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_past_ehr_notes_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/sessions/{session_id}/consult-note/past-ehr-notes-with-common': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Past Ehr Notes With Common
     * @description Get past EHR notes with commonly used note metadata
     */
    get: operations['get_past_ehr_notes_with_common_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_past_ehr_notes_with_common_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/sessions/{session_id}/consult-note/commonly-used-past-ehr-notes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Commonly Used Past Ehr Notes
     * @description Get commonly used past EHR note metadata
     */
    get: operations['get_commonly_used_past_ehr_notes_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_commonly_used_past_ehr_notes_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/sessions/{session_id}/consult-note/past-ehr-note/binary-details': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Past Ehr Note Binary Detail
     * @description Get the binary detail for a past EHR note
     */
    get: operations['get_past_ehr_note_binary_detail_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_past_ehr_note_binary_details_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/onboarding/user-ehr-launch-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Or Update User Ehr Launch Profile */
    get: operations['get_or_update_user_ehr_launch_profile_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_get'];
    put?: never;
    /** Create User Ehr Launch Profile */
    post: operations['create_user_ehr_launch_profile_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_post'];
    /**
     * Delete User Ehr Launch Profile
     * @deprecated
     * @description deprecated, use /{profile_name} instead
     */
    delete: operations['delete_user_ehr_launch_profile_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_delete'];
    options?: never;
    head?: never;
    /**
     * Update User Ehr Launch Profile
     * @deprecated
     * @description deprecated, use /{profile_name} instead
     */
    patch: operations['update_user_ehr_launch_profile_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/onboarding/user-ehr-launch-profile/v2': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get User Ehr Launch Profiles */
    get: operations['get_user_ehr_launch_profiles_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_v2_get'];
    put?: never;
    /** Create User Ehr Launch Profiles */
    post: operations['create_user_ehr_launch_profiles_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_v2_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/onboarding/user-ehr-launch-profile/{ehr_provider}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update User Ehr Launch Profile By Profile Name */
    patch: operations['update_user_ehr_launch_profile_by_profile_name_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile__ehr_provider__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/onboarding/user-ehr-launch-profile/{profile_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete User Ehr Launch Profile By Profile Name */
    delete: operations['delete_user_ehr_launch_profile_by_profile_name_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile__profile_name__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/AmbientSessionBegin': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ambient Session Begin
     * @description Begins a new ambient voice recording session for the specified mobile provider.
     *
     *     Returns:
     *         HaikuAmbientSessionBeginResponse: Contains the session ID, user ID, and any error information.
     */
    post: operations['ambient_session_begin_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__AmbientSessionBegin_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/AmbientSessionComplete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ambient Session Complete
     * @description Acknowledge completion of an ambient recording session for Haiku.
     *
     *     Only supports MobileProvider.HAIKU; for other providers the function triggers an unreachable-branch assertion.
     *
     *     Returns:
     *         HaikuGenericResponse: Success response with `error=None` when provider is HAIKU.
     */
    post: operations['ambient_session_complete_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__AmbientSessionComplete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/DocumentationUpdated': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Documentation Updated
     * @description Handle a notification from Haiku that documentation was updated.
     *
     *     Processes an incoming HaikuDocumentationUpdatedRequest and returns a HaikuGenericResponse.
     *     For MobileProvider.HAIKU this endpoint always returns HaikuGenericResponse(error=None).
     *     For any other provider the function asserts (unreachable in supported configurations).
     *
     *     Parameters:
     *         request: The Haiku-originated payload describing the documentation update.
     *
     *     Returns:
     *         HaikuGenericResponse with `error=None` on success.
     */
    post: operations['documentation_updated_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__DocumentationUpdated_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/DocumentationFeedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Documentation Feedback
     * @description Handle documentation feedback callbacks from the mobile provider and acknowledge receipt.
     *
     *     For the HAIKU provider this endpoint accepts a HaikuDocumentationFeedbackRequest and returns a HaikuGenericResponse signaling success (error=None). The function currently performs no further processing of the feedback beyond logging.
     *
     *     Parameters:
     *         provider: MobileProvider — the originating mobile provider (must be MobileProvider.HAIKU).
     *         request: HaikuDocumentationFeedbackRequest — feedback payload from the provider.
     *
     *     Raises:
     *         HTTPException: 404 if called with a provider other than MobileProvider.HAIKU.
     */
    post: operations['documentation_feedback_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__DocumentationFeedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/DeleteSession': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Delete Session
     * @description Delete or invalidate an ambient session for the given provider.
     *
     *     For MobileProvider.HAIKU this accepts a HaikuDeleteSessionRequest and returns a HaikuGenericResponse with no error. Non-Haiku providers are not supported and will trigger an assertion.
     *
     *     Parameters:
     *         provider: the MobileProvider for which the session should be deleted.
     *         request: HaikuDeleteSessionRequest identifying the session to delete.
     *
     *     Returns:
     *         HaikuGenericResponse with error=None on success for Haiku.
     */
    post: operations['delete_session_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__DeleteSession_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/RecordingAvailable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Recording Available
     * @description Acknowledge that a recording is available from the mobile provider.
     *
     *     For provider MobileProvider.HAIKU this returns a success HaikuGenericResponse (error=None).
     *     For any other provider the function raises a 404 HTTPException.
     *
     *     Parameters:
     *         request: The HaikuRecordingAvailableRequest payload notifying the service that a recording is available.
     *
     *     Returns:
     *         HaikuGenericResponse indicating success (error is None for HAIKU).
     */
    post: operations['recording_available_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__RecordingAvailable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/RecordingChunkAvailable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Recording Chunk Available
     * @description Handle a notification that an audio recording chunk is available.
     *
     *     This endpoint responds immediately after persisting the chunk, then processes
     *     transcription asynchronously in the background. This ensures the caller
     *     (Haiku) receives a timely response regardless of transcription duration.
     *
     *     Flow:
     *     1. Persist chunk immediately (with transcribed=False)
     *     2. Return 200 OK immediately
     *     3. Background task handles: token acquisition, audio retrieval, transcription,
     *        and chunk status update
     *
     *     For sentinel chunks (first chunk with no audio), no background task is spawned.
     *
     *     Behavioral notes:
     *     - Only MobileProvider.HAIKU is supported; other providers trigger an assertion.
     *     - The endpoint always returns success; transcription failures are recorded
     *       on the chunk's transcribed flag (polled via latest-finalized-recording).
     */
    post: operations['recording_chunk_available_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__RecordingChunkAvailable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/{external_session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Haiku Smart On Fhir Endpoint
     * @description Issue a Haiku JWT for a SMART on FHIR EHR launch, create or link a Heidi session, and persist related EHR launch state.
     *
     *     Processes the EHR launch response to either link an existing Heidi session (when the external session is already linked) or create a new session for the launched user (and an associated patient profile when a FHIR patient ID is present). Side effects include: creating/updating a session, linking the external session to the Heidi session, caching EHR integration data (both by Haiku JWT hash and by raw access_token so write-back endpoints can resolve it), and saving the EHR launch auth token for the user. Errors during side-effect operations are caught and logged; they do not raise exceptions from this function.
     *
     *     Returns:
     *         HaikuTokenResponse: Contains the encoded Haiku JWT (`jwt`), the created or linked Heidi session id (`session_id`, or None if no session was created), `finalized` which reflects the external session's finalized state, and the EHR launch context the Haiku frontend needs to call downstream EHR write-back endpoints (`access_token`, `profile_name`).
     */
    get: operations['haiku_smart_on_fhir_endpoint_api_v2_ml_scribe_ehr_launch_mobile_avr__provider___external_session_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/{external_session_id}/push-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Push Note
     * @description Push a consult note to the third-party ambient-audio adaptor and signal that ambient recordings have been processed.
     *
     *     This will:
     *     - Load the consult note for the given external session and, if JSON and valid, use it as a StandardizedStructuredConsultNote; otherwise create a minimal fallback note.
     *     - Obtain an Epic access token (cached or via client credentials), construct a third-party adaptor using the EHR launch profile callback URL, and call DocumentationReady if standardized sections are available.
     *     - Always call AmbientRecordingsProcessed for the external session.
     *     - If both adaptor calls succeed, finalize the external session; otherwise return any adaptor error messages concatenated in the response.
     *
     *     Parameters:
     *         provider: Mobile provider identifier used to select the third-party adaptor and relevant OAuth cache.
     *         external_session: The external session loaded via dependency injection.
     *
     *     Returns:
     *         HaikuGenericResponse with `error` set to a newline-joined string of any adaptor call errors (empty string on success).
     */
    post: operations['push_note_api_v2_ml_scribe_ehr_launch_mobile_avr__provider___external_session_id__push_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/{external_session_id}/latest-finalized-recording': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Latest Finalized Recording
     * @description Retrieve the latest finalized recording ID for an external session.
     *
     *     Returns:
     *         HaikuLatestFinalizedRecordingResponse: Contains the recording_id (or None if no finalized recording exists)
     *         and transcription_complete flag indicating whether it's safe to generate consult notes.
     */
    get: operations['latest_finalized_recording_api_v2_ml_scribe_ehr_launch_mobile_avr__provider___external_session_id__latest_finalized_recording_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr-launch/mobile/avr/{provider}/{external_session_id}/available-sections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Haiku Available Sections
     * @description Get available standardized sections for a Haiku external session.
     *
     *     Retrieves the list of available standardized note sections that can be used
     *     for note generation and syncing for the specified Haiku external session.
     *
     *     Args:
     *         provider: The mobile provider (must be HAIKU).
     *         external_session_id: The ID of the Haiku external session.
     *         external_session: The external session.
     *
     *     Returns:
     *         AvailableStandardizedSectionsResponse with list of available sections.
     *
     *     Raises:
     *         HTTPException: 404 if session not found, 400 if not a Haiku session.
     */
    get: operations['get_haiku_available_sections_api_v2_ml_scribe_ehr_launch_mobile_avr__provider___external_session_id__available_sections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/export-assets/presigned-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Export Asset Presigned Url
     * @description Get a presigned URL for uploading or downloading an export asset (logo/signature).
     *
     *     For PUT requests: Returns a presigned URL for uploading and the S3 object key to store.
     *     For GET requests: Returns a presigned URL for downloading (object_key must be provided).
     *     Optionally accepts team_id for team-scoped uploads.
     */
    post: operations['get_export_asset_presigned_url_api_v2_ml_scribe_export_assets_presigned_url_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/export-assets/presigned-url/download': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Export Asset Download Url
     * @description Get a presigned URL for downloading an existing export asset.
     *
     *     The object_key should be the S3 key stored in the user's or team's export settings.
     *     Supports both user assets (export-assets/{user_id}/...) and team assets (export-assets/team/{team_id}/...).
     */
    post: operations['get_export_asset_download_url_api_v2_ml_scribe_export_assets_presigned_url_download_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/export-docx': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export Docx
     * @description Export DOCX from content
     */
    post: operations['export_docx_api_v2_ml_scribe_export_docx_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/export-pdf': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export Pdf
     * @description Export PDF from content
     */
    post: operations['export_pdf_api_v2_ml_scribe_export_pdf_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/external-org/sessions/transcripts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Org Latest Session Transcripts
     * @description get all transcripts of an org's users created within the last X days
     */
    get: operations['get_org_latest_session_transcripts_api_v2_ml_scribe_external_org_sessions_transcripts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/external-org/jwt': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Generate Jwt
     * @description Generate jwt token for an org based on API Key
     */
    get: operations['generate_jwt_api_v2_ml_scribe_external_org_jwt_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/feature-flag': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get All Feature Flags */
    get: operations['get_all_feature_flags_api_v2_ml_scribe_feature_flag_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/available': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Available Integrations
     * @description Get the list of providers with direct backend integrations.
     */
    get: operations['get_available_integrations_api_v2_ml_scribe_integrations_available_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/capabilities/{provider}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Integration Capabilities
     * @description Get the direct backend integration capabilities for the given provider.
     */
    get: operations['get_integration_capabilities_api_v2_ml_scribe_integrations_capabilities__provider__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/allergy-intolerances': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Allergy Intolerance
     * @description Search for allergy intolerances in the EHR system of the user.
     *
     *     This returns FHIR AllergyIntolerance resources.
     */
    get: operations['search_allergy_intolerance_api_v2_ml_scribe_integrations_fhir_allergy_intolerances_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/appointments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Appointment
     * @description Search for appointments in the EHR system of the user.
     *
     *     This returns FHIR Appointment resources.
     */
    get: operations['search_appointment_api_v2_ml_scribe_integrations_fhir_appointments_get'];
    put?: never;
    /**
     * Create Appointment
     * @description Create an appointment in the EHR system of the user.
     *
     *     Accepts a FHIR Appointment resource and returns the created resource.
     */
    post: operations['create_appointment_api_v2_ml_scribe_integrations_fhir_appointments_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/appointments/{resource_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Read Appointment
     * @description Read a single appointment by ID from the EHR system of the user.
     *
     *     Returns a single FHIR Appointment resource.
     */
    get: operations['read_appointment_api_v2_ml_scribe_integrations_fhir_appointments__resource_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Appointment
     * @description Cancel/delete an appointment in the EHR system of the user.
     *
     *     Accepts an appointment ID and cancels it in the underlying EHR.
     */
    delete: operations['delete_appointment_api_v2_ml_scribe_integrations_fhir_appointments__resource_id__delete'];
    options?: never;
    head?: never;
    /**
     * Patch Appointment
     * @description Patch an appointment in the EHR system using JSON Patch (`RFC 6902 <https://datatracker.ietf.org/doc/html/rfc6902>`_).
     *
     *     Accepts an array of patch operations. Each operation specifies an ``op``
     *     (``add``, ``replace``, or ``remove``), a ``path`` (JSON Pointer to the
     *     field, e.g. ``/start``), and optionally a ``value``.
     */
    patch: operations['patch_appointment_api_v2_ml_scribe_integrations_fhir_appointments__resource_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/communications': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Communication
     * @description Create a communication in the EHR system of the user.
     *
     *     Accepts a FHIR Communication resource and returns the created resource.
     *
     *     Returns 4XX if the integration functionality is not available for the provider
     *     OR when there is an issue with the request body.
     */
    post: operations['create_communication_api_v2_ml_scribe_integrations_fhir_communications_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/compositions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Composition
     * @description Search for compositions in the EHR system of the user.
     *
     *     This returns FHIR Composition resources.
     */
    get: operations['search_composition_api_v2_ml_scribe_integrations_fhir_compositions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/conditions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Condition
     * @description Create a condition in the EHR system of the user.
     *
     *     Accepts a FHIR Condition resource and returns the created resource.
     *
     *     Returns 4XX if the integration functionality is not available for the provider
     *     OR when there is an issue with the request body.
     */
    post: operations['create_condition_api_v2_ml_scribe_integrations_fhir_conditions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/conditions/{resource_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Condition
     * @description Remove a condition in the EHR system of the user.
     *
     *     Accepts a condition resource ID OR an encoded ID (when FHIR integration layer adaptor is for a non-FHIR EHR API)
     *     and removes it in the underlying EHR.
     */
    delete: operations['delete_condition_api_v2_ml_scribe_integrations_fhir_conditions__resource_id__delete'];
    options?: never;
    head?: never;
    /**
     * Patch Condition
     * @description Patch a condition in the EHR system using JSON Patch (`RFC 6902 <https://datatracker.ietf.org/doc/html/rfc6902>`_).
     *
     *     Accepts an array of patch operations. Each operation specifies an ``op``
     *     (``add``, ``replace``, or ``remove``), a ``path`` (JSON Pointer to the
     *     field, e.g. ``/clinical_status``), and optionally a ``value``.
     *
     *     Returns 4XX if the integration functionality is not available for the provider
     *     OR when there is an issue with the request body.
     */
    patch: operations['patch_condition_api_v2_ml_scribe_integrations_fhir_conditions__resource_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/document-references': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Document Reference
     * @description Search for document references in the EHR system of the user.
     *
     *     This returns FHIR DocumentReference resources.
     */
    get: operations['search_document_reference_api_v2_ml_scribe_integrations_fhir_document_references_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/encounters': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Encounter
     * @description Search for encounters in the EHR system of the user.
     *
     *     This returns FHIR Encounter resources.
     */
    get: operations['search_encounter_api_v2_ml_scribe_integrations_fhir_encounters_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/family-member-histories': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Family Member History
     * @description Search for family member history records in the EHR system of the user.
     *
     *     This returns FHIR FamilyMemberHistory resources.
     */
    get: operations['search_family_member_history_api_v2_ml_scribe_integrations_fhir_family_member_histories_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/healthcare-services': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Healthcare Service
     * @description Search for healthcare services in the EHR system of the user.
     *
     *     This returns FHIR HealthcareService resources.
     */
    get: operations['search_healthcare_service_api_v2_ml_scribe_integrations_fhir_healthcare_services_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/immunizations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Immunization
     * @description Search for immunizations in the EHR system of the user.
     *
     *     This returns FHIR Immunization resources.
     */
    get: operations['search_immunization_api_v2_ml_scribe_integrations_fhir_immunizations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/locations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Location
     * @description Search for locations in the EHR system of the user.
     *
     *     This returns FHIR Location resources.
     */
    get: operations['search_location_api_v2_ml_scribe_integrations_fhir_locations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/measure-reports': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Measure Report
     * @description Search for measure reports in the EHR system of the user.
     *
     *     This returns FHIR MeasureReport resources.
     */
    get: operations['search_measure_report_api_v2_ml_scribe_integrations_fhir_measure_reports_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/medication-requests': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Medication Request
     * @description Search for medication requests in the EHR system of the user.
     *
     *     This returns FHIR MedicationRequest resources.
     */
    get: operations['search_medication_request_api_v2_ml_scribe_integrations_fhir_medication_requests_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/medication-statements': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Medication Statement
     * @description Search for medication statements in the EHR system of the user.
     *
     *     This returns FHIR MedicationStatement resources.
     */
    get: operations['search_medication_statement_api_v2_ml_scribe_integrations_fhir_medication_statements_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/metadata': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Capability Statement
     * @description Return a FHIR R4 CapabilityStatement describing the user's EHR capabilities.
     *
     *     The response lists which FHIR resource types and interactions (create,
     *     search-type, etc.) are supported by the user's connected EHR provider.
     */
    get: operations['get_capability_statement_api_v2_ml_scribe_integrations_fhir_metadata_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/observations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Observation
     * @description Search for observations in the EHR system of the user.
     *
     *     This returns FHIR Observation resources.
     */
    get: operations['search_observation_api_v2_ml_scribe_integrations_fhir_observations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/patients': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Patient
     * @description Search for patients in the EHR system of the user.
     *
     *     This returns a FHIR Patient resources.
     */
    get: operations['search_patient_api_v2_ml_scribe_integrations_fhir_patients_get'];
    put?: never;
    /**
     * Create Patient
     * @description Create a patient in the EHR system of the user.
     *
     *     Accepts a FHIR Patient resource and returns the created resource.
     */
    post: operations['create_patient_api_v2_ml_scribe_integrations_fhir_patients_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/patients/{resource_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Read Patient
     * @description Read a single patient by ID from the EHR system of the user.
     *
     *     Returns a single FHIR Patient resource.
     */
    get: operations['read_patient_api_v2_ml_scribe_integrations_fhir_patients__resource_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/practitioner-roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Practitioner Role
     * @description Search for practitioner roles in the EHR system of the user.
     *
     *     This returns FHIR PractitionerRole resources.
     */
    get: operations['search_practitioner_role_api_v2_ml_scribe_integrations_fhir_practitioner_roles_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/practitioners': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Practitioner
     * @description Search for practitioners in the EHR system of the user.
     *
     *     This returns FHIR Practitioner resources.
     */
    get: operations['search_practitioner_api_v2_ml_scribe_integrations_fhir_practitioners_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/practitioners/{resource_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Read Practitioner
     * @description Read a single practitioner by ID from the EHR system of the user.
     *
     *     Returns a single FHIR Practitioner resource.
     */
    get: operations['read_practitioner_api_v2_ml_scribe_integrations_fhir_practitioners__resource_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/questionnaire-responses': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Questionnaire Response
     * @description Search for questionnaire responses in the EHR system of the user.
     *
     *     This returns FHIR QuestionnaireResponse resources.
     */
    get: operations['search_questionnaire_response_api_v2_ml_scribe_integrations_fhir_questionnaire_responses_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/schedules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Schedule
     * @description Search for schedules in the EHR system of the user.
     *
     *     This returns FHIR Schedule resources.
     */
    get: operations['search_schedule_api_v2_ml_scribe_integrations_fhir_schedules_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/service-requests': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Service Request
     * @description Search for service requests in the EHR system of the user.
     *
     *     This returns FHIR ServiceRequest resources.
     */
    get: operations['search_service_request_api_v2_ml_scribe_integrations_fhir_service_requests_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/slots': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Slot
     * @description Search for slots in the EHR system of the user.
     *
     *     This returns FHIR Slot resources.
     */
    get: operations['search_slot_api_v2_ml_scribe_integrations_fhir_slots_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/fhir/tasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Task
     * @description Search for tasks in the EHR system of the user.
     *
     *     Returns FHIR ``Task`` resources (inbox-style items and patient reminders when
     *     supported by the provider).
     */
    get: operations['search_task_api_v2_ml_scribe_integrations_fhir_tasks_get'];
    put?: never;
    /**
     * Create Task
     * @description Create a task in the EHR system of the user.
     *
     *     Accepts a FHIR Task resource and returns the created resource.
     *
     *     Returns 4XX if the integration functionality is not available for the provider
     *     OR when there is an issue with the request body.
     */
    post: operations['create_task_api_v2_ml_scribe_integrations_fhir_tasks_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/schedule': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Schedule
     * @description Get appointment schedule.
     *
     *     If `connection_id` is provided, get the schedule from the corresponding integration.
     *     Otherwise, get the schedule from all integrations.
     *
     *     Optional repeatable ``filter`` query params match
     *     ``appointment.display_facets`` (AND across dimensions, OR within each). Athena
     *     derives provider-group and department facets from the corresponding provider details.
     */
    get: operations['get_schedule_api_v2_ml_scribe_integrations_schedule_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/patients:search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Search Integration Patients
     * @description Live EHR patient search for the find-or-link combobox.
     *
     *     The caller supplies explicit name, DOB, or NHS-number filters. POST keeps
     *     that PHI out of access-log query strings.
     */
    post: operations['search_integration_patients_api_v2_ml_scribe_integrations_patients_search_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/{session_id}/notes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Notes Deprecated
     * @deprecated
     * @description Deprecated, use /api/v2/integrations/session/{session_id}/notes instead
     */
    post: operations['sync_notes_deprecated_api_v2_ml_scribe_integrations__session_id__notes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/session/{session_id}/notes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Notes
     * @description Sync notes to an integrated session.
     */
    post: operations['sync_notes_api_v2_ml_scribe_integrations_session__session_id__notes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/session/{session_id}/sectional-notes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Sectional Notes
     * @description Sync sectional notes to an integrated session.
     */
    post: operations['sync_sectional_notes_api_v2_ml_scribe_integrations_session__session_id__sectional_notes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/{session_id}/notes/audit': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Audit Note
     * @description Send the original consultation note to EHR for auditing purposes.
     */
    post: operations['audit_note_api_v2_ml_scribe_integrations__session_id__notes_audit_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/standardized-sections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Standardized Sections
     * @description Get available standardized sections for an integration.
     *
     *     Uses the onboarding session ID to retrieve the integration adaptor
     *     and returns the list of available standardized note sections.
     *
     *     Args:
     *         onboarding_session_id: The onboarding session ID
     *         integrations_service: The integrations service
     *         user_id: The user ID
     *
     *     Returns:
     *         The available standardized sections
     *     Raises:
     *         IntegrationFunctionalityNotAvailableError: If the integration does not support standardized note sections
     */
    get: operations['get_standardized_sections_api_v2_ml_scribe_integrations_standardized_sections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/third-party-auth': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Third Party Auth
     * @description Mint a short-lived embed access token for a connected integration.
     *
     *     The token is opaque to Heidi — forward it to the third-party widget (e.g.
     *     Hero Health Element) verbatim. The adaptor scopes the token to the correct
     *     clinician from its onboarding configuration (e.g. Hero resolves the acting
     *     admin from the onboarding-selected practitioner's email).
     *
     *     Pass ``force_refresh=true`` to invalidate any cached token and mint afresh —
     *     use this when a previously-issued token is failing auth at the third party.
     */
    post: operations['get_third_party_auth_api_v2_ml_scribe_integrations_third_party_auth_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/documents/{document_id}/sync-options': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Sync Document Options
     * @description Return provider options for syncing a Heidi document.
     *
     *     If options are returned, the client shows a modal and sends the selected
     *     option's ``option_id`` to the sync endpoint. If options is empty, the client
     *     can sync directly without showing a modal.
     *
     *     Raises:
     *         HTTPException: 422 if the document's Heidi session is not linked to an
     *             integration appointment and ``onboarding_session_id`` was not
     *             provided to identify the provider.
     *         HTTPException: 404 if the document does not exist.
     *         HTTPException: 422 if the resolved provider does not implement
     *             ``SyncDocumentMixin``.
     *         IntegrationOnboardingSessionNotFoundForProviderError: If the user has
     *             no completed connection for the resolved provider.
     *         IntegrationOnboardingSessionNotFoundError: If ``onboarding_session_id``
     *             is provided but does not identify a completed connection for the
     *             user/provider.
     *         Exception: Provider-specific validation, authentication, or upstream
     *             EHR errors from option lookup may propagate.
     */
    get: operations['get_sync_document_options_api_v2_ml_scribe_integrations_documents__document_id__sync_options_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/documents/{document_id}/sync': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Document
     * @description Sync a Heidi document to the selected EHR destination.
     *
     *     The API layer resolves only the authenticated user and request body. The
     *     manager loads the Heidi document, resolves provider links, validates the
     *     selected option, and dispatches to the adaptor.
     *
     *     Raises:
     *         HTTPException: 422 if the document has no appointment or patient EHR
     *             context for the provider, an option is required, or the supplied
     *             ``option_id`` is not available.
     *         HTTPException: 404 if the document does not exist.
     *         HTTPException: 422 if the resolved provider does not implement
     *             ``SyncDocumentMixin``.
     *         IntegrationOnboardingSessionNotFoundForProviderError: If the user has
     *             no completed connection for the resolved provider.
     *         IntegrationOnboardingSessionNotFoundError: If ``onboarding_session_id``
     *             is provided but does not identify a completed connection for the
     *             user/provider.
     *         Exception: Provider-specific validation, authentication, destination
     *             resolution, serialization, or upstream EHR errors may propagate
     *             after failure tracking.
     */
    post: operations['sync_document_api_v2_ml_scribe_integrations_documents__document_id__sync_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/session/{session_id}/note-options': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Note Options
     * @description Return destination options for syncing a consult note.
     *
     *     If the list is non-empty the client should show a selection UI and pass the
     *     chosen ``option_id`` to ``POST /session/{session_id}/notes-with-option``.
     *     An empty list means no selection is needed.
     */
    get: operations['get_note_options_api_v2_ml_scribe_integrations_session__session_id__note_options_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/session/{session_id}/notes-with-option': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sync Notes With Option
     * @description Sync a consult note to the selected EHR destination.
     */
    post: operations['sync_notes_with_option_api_v2_ml_scribe_integrations_session__session_id__notes_with_option_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/session/{session_id}/file': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload File
     * @description Upload a file to an integrated session.
     */
    post: operations['upload_file_api_v2_ml_scribe_integrations_session__session_id__file_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/session/{session_id}/cerner/note-types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Cerner Note Types
     * @description Return the Cerner Code Set 72 note types configured on the session's EHR launch profile (sourced from internal admin's additional_details.note_types). Empty list when not configured. Returns 404 when the session is not bound to a Cerner EHR Launch integration.
     */
    get: operations['get_cerner_note_types_api_v2_ml_scribe_integrations_session__session_id__cerner_note_types_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/healthnz/questionnaire': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Registration Questionnaire
     * @description Return the static ACC 45 registration questionnaire schema. Callers do not supply a questionnaire id.
     */
    get: operations['get_registration_questionnaire_api_v2_ml_scribe_integrations_healthnz_questionnaire_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/integration-request': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Request Integration */
    post: operations['request_integration_api_v2_ml_scribe_integrations_integration_request_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/integration-request/contact-sales': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Contact Sales Request
     * @description Get whether 'Contact Sales' request has already been made for the given integration.
     */
    get: operations['get_contact_sales_request_api_v2_ml_scribe_integrations_integration_request_contact_sales_get'];
    put?: never;
    /**
     * Create Contact Sales Request
     * @description Make a 'Contact Sales' request for the given integration.
     */
    post: operations['create_contact_sales_request_api_v2_ml_scribe_integrations_integration_request_contact_sales_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/launch/medtech': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Medtech Launch
     * @description Execute Medtech launch verification.
     *
     *     Validates the HMAC signature and returns the launch context details.
     *
     *     **Request body:**
     *     - `context`: Base64-encoded launch context
     *     - `signature`: HMAC signature
     *
     *     **Error responses:**
     *     - 400: Invalid payload (missing fields, malformed data)
     *     - 401: Authentication failed (invalid signature, user not onboarded)
     *     - 403: Authorization failed (user not permitted)
     *     - 422: Context resolution failed (no appointment found, ambiguous context)
     */
    post: operations['medtech_launch_api_v2_ml_scribe_integrations_launch_medtech_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/launch/veradigm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Veradigm Launch
     * @description Execute Veradigm SSO launch verification.
     *
     *     Validates the launch SSOToken against Unity and returns the launch
     *     context details.
     *
     *     **Request payload fields:**
     *     - `sso_token`: SSOToken query parameter from the VEHR launcher
     *     - `account_id`: AccountID query parameter from the VEHR launcher
     *
     *     **Error responses:**
     *     - 400: Invalid payload (missing fields, malformed data)
     *     - 401: Authentication failed (unknown AccountID, rejected SSOToken,
     *       user not onboarded)
     *     - 403: Authorization failed (user not permitted)
     *     - 422: Context resolution failed (no onboarding session, JWT issuance)
     */
    post: operations['veradigm_launch_api_v2_ml_scribe_integrations_launch_veradigm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/launch/sgimed': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Sgimed Launch
     * @description Verify SGIMED ``app_market.context`` JWT and create or resume an integration session.
     *
     *     **Request body:** ``{ "provider": "SGIMED", "payload": { "token": "<compact JWT>" } }``
     *
     *     User identity is resolved by matching JWT ``visit.doctor.id`` to the ``doctor_id``
     *     stored in a **completed** SGIMED integration onboarding session (credentials form).
     *
     *     Configure ``SGIMED_CONTEXT_JWKS_URI`` and ``SGIMED_CONTEXT_ISSUER_ALLOWLIST`` for JWT verification.
     */
    post: operations['sgimed_launch_api_v2_ml_scribe_integrations_launch_sgimed_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/launch/t2med': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * T2Med Launch
     * @description Verify a T2med launch payload and create or resume a Heidi session.
     *
     *     **Request body:** ``{ "provider": "T2med", "payload": { "kontextId": "...",
     *     "fhirBasisUrl": "https://..." } }``
     *
     *     **Auth:** Standard Heidi (Kinde) JWT in the ``Authorization`` header — the
     *     desktop app uses the user's existing session.
     *
     *     **Error responses:**
     *     - 400: Payload missing/malformed (``kontextId`` or ``fhirBasisUrl`` invalid).
     *     - 401: Heidi JWT missing/invalid (handled by the auth dependency).
     *     - 403: T2med integration kill-switch disabled for this user.
     *     - 422: User has not completed the T2med onboarding flow.
     */
    post: operations['t2med_launch_api_v2_ml_scribe_integrations_launch_t2med_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/links/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Integration Session Link
     * @description Get a single session link by session ID and/or provider appointment ID.
     *
     *      This endpoint requires that search parameters uniquely identify exactly one session link.
     *      If no matches are found or multiple matches exist, a 422 error is returned, prompting
     *      the caller to provide more specific search criteria.
     *
     *      Args:
     *          params: Search parameters (session_id and/or provider_appointment_id)
     *          user: Authenticated user from auth header
     *          session_link_manager: Session link manager dependency
     *
     *      Returns:
     *          SearchIntegrationSessionLinkResponse: The single matching session link
     *
     *      Raises:
     *          HTTPException: 400 Bad Request if validation fails
     *          HTTPException: 422 Unprocessable Entity if no match or multiple matches found
     */
    get: operations['search_integration_session_link_api_v2_ml_scribe_integrations_links_sessions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/links/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Patch Session Link */
    patch: operations['patch_session_link_api_v2_ml_scribe_integrations_links_sessions__session_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/links/consult-note-link': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Consult Note Link
     * @description Return the consult note link for the given consult note ID.
     */
    get: operations['get_consult_note_link_api_v2_ml_scribe_integrations_links_consult_note_link_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/merge-agent-handler/link-token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Merge Link Token
     * @description Ensure Registered User + mint a short-lived Agent Handler Link token.
     */
    post: operations['create_merge_link_token_api_v2_ml_scribe_integrations_merge_agent_handler_link_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/merge-agent-handler/connections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Merge Connections
     * @description List connectors authenticated for the caller's Registered User.
     */
    get: operations['list_merge_connections_api_v2_ml_scribe_integrations_merge_agent_handler_connections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/merge-agent-handler/connections/{connector}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Merge Connection
     * @description Delete credentials for a connector owned by the authenticated Heidi user.
     */
    delete: operations['delete_merge_connection_api_v2_ml_scribe_integrations_merge_agent_handler_connections__connector__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nango/connect-session': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Nango Connect Session
     * @description Create a short-lived Nango Connect UI session token for the caller.
     */
    post: operations['create_nango_connect_session_api_v2_ml_scribe_integrations_nango_connect_session_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nango/connections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Nango Connections
     * @description List Nango connections tagged to the authenticated Heidi user.
     */
    get: operations['list_nango_connections_api_v2_ml_scribe_integrations_nango_connections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nango/connections/{connection_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Nango Connection
     * @description Delete a Nango connection owned by the authenticated Heidi user.
     */
    delete: operations['delete_nango_connection_api_v2_ml_scribe_integrations_nango_connections__connection_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/.well-known/openid-configuration': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Returns OAuth 2.0 Authorization Server Metadata (RFC 8414) */
    get: operations['openid_configuration_endpoint_api_v2_ml_scribe_integrations_nebula__well_known_openid_configuration_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/auth/token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Exchange a JWT client_assertion for a Heidi-issued access token */
    post: operations['token_endpoint_api_v2_ml_scribe_integrations_nebula_v1_auth_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/session': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create a Nebula ambient session
     * @description Persist (or surface the existing) Nebula session.
     *
     *     Returns ``200`` on both fresh creation and idempotent replay — Epic
     *     only requires "Successfully created session" on success and we do
     *     not want to fail retries.
     *
     *     Wire → domain conversion happens here (``request.to_doc()``) so the
     *     service layer below stays unaware of the API-layer wire format.
     */
    post: operations['create_session_api_v2_ml_scribe_integrations_nebula_v1_session_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/session/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete a Nebula ambient session and all related data */
    delete: operations['delete_session_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/session/{session_id}/data': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate data for a session (stub)
     * @description Stub for Epic's "Generate Data" trigger.
     *
     *     Epic uses this verb to ask Heidi to start producing derived data
     *     (notes / orders / flowsheets) for a recording. The actual pipeline
     *     integration — fanning out to transcription / consult-note / order
     *     generation managers and emitting an outbound
     *     ``com.epic.ambient.dataready`` webhook when the result is ready —
     *     is the subject of a follow-on PR.
     *
     *     For now we accept and validate the wire shape so Epic can wire the
     *     contract end-to-end; the body's ``sessionId`` must equal the path
     *     parameter (defence-in-depth against client bugs that splice the two
     *     from different sources). 400 fires before any service-layer work.
     */
    post: operations['generate_session_data_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__data_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/session/{session_id}/edited': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record edits Epic's user made to generated objects
     * @description Append a row to ``nebula_session_edit_event``.
     *
     *     These rows are read by the (deferred) outbound webhook PR for
     *     edit-suppression — once a UID has been edited by the user, Heidi
     *     must not re-emit it. Persisting in a side collection rather than
     *     embedding on ``NebulaSession`` keeps that future query cheap and
     *     indexed.
     */
    post: operations['edit_session_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__edited_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/session/{session_id}/finalized': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark a Nebula session as finalized
     * @description Transition the session's status to ``FINALIZED``.
     *
     *     Idempotent — re-finalizing is a no-op state-wise. Cross-org and
     *     missing-session both surface as Epic's 404 body, same policy as
     *     DELETE.
     */
    post: operations['finalize_session_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__finalized_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/session/{session_id}/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record Epic's filed-feedback for a session
     * @description Append a feedback row to ``nebula_session_feedback_event``.
     *
     *     Multiple feedback calls per flowsheets session are normal
     *     (validation feedback, then user-edit feedback, then scheduled
     *     feedback), so this is intentionally append-only — never an
     *     upsert-by-session-id. The body's ``sessionId`` must equal the path
     *     parameter (400 on mismatch) for the same reason as Generate Data.
     */
    post: operations['feedback_session_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/data/{event_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Retrieve a Nebula data event by event_id
     * @description Return the persisted event payload, gated by org ownership.
     *
     *     Both miss paths surface the same Epic 404 body
     *     (``{"title": "Session not found."}``) so an attacker cannot tell
     *     "event never existed" from "exists but not yours" via response
     *     shape. The exception split exists purely so the cross-org branch
     *     can fire a ``logger.warning`` for security monitoring — same
     *     policy as the session lifecycle handlers.
     */
    get: operations['retrieve_data_api_v2_ml_scribe_integrations_nebula_v1_data__event_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/nebula/v1/audio/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Receive a Nebula audio CloudEvent (chunk-ready or ready)
     * @description Persist (inline) + schedule fetch/transcribe (background task).
     *
     *     Both event types share this single endpoint per Epic's spec; the
     *     discriminated-union envelope already carries the right ``data``
     *     shape by the time we run, so this handler only needs to unwrap
     *     primitive fields and dispatch.
     *
     *     Wire → primitive unwrap happens here (rather than passing the
     *     envelope into the service) so the service stays HTTP-framework
     *     free and reusable from non-HTTP callers — same pattern as
     *     ``create_session`` calling ``request.to_doc()``.
     *
     *     The transcription pipeline is dispatched as a fire-and-forget
     *     ``asyncio.Task`` for chunkready events with ``chunk_id > 1`` so
     *     the webhook returns 200 to Epic on the order of milliseconds
     *     (just the audit-row write) regardless of how long the audio
     *     fetch + Gemini transcription takes. Mirrors Haiku AVR's
     *     ``recording_chunk_available`` once it has the async transcription
     *     flag enabled.
     */
    post: operations['receive_audio_event_api_v2_ml_scribe_integrations_nebula_v1_audio__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/onboardings/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Sessions
     * @description Search for integration onboarding sessions with optional filters.
     */
    get: operations['search_sessions_api_v2_ml_scribe_integrations_onboardings_sessions_get'];
    put?: never;
    /**
     * Create Session
     * @description Create a new integration onboarding session.
     */
    post: operations['create_session_api_v2_ml_scribe_integrations_onboardings_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/onboardings/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session
     * @description Get an integration onboarding session.
     */
    get: operations['get_session_api_v2_ml_scribe_integrations_onboardings_sessions__session_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Session
     * @description Delete an integration onboarding session by ID.
     */
    delete: operations['delete_session_api_v2_ml_scribe_integrations_onboardings_sessions__session_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/onboardings/sessions/{session_id}/step_executions/{step_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Execute Step
     * @description Execute a step in the onboarding process.
     */
    put: operations['execute_step_api_v2_ml_scribe_integrations_onboardings_sessions__session_id__step_executions__step_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/smart-on-fhir/ehr-launch/init': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Init Smart On Fhir Launch */
    get: operations['init_smart_on_fhir_launch_api_v2_ml_scribe_integrations_smart_on_fhir_ehr_launch_init_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/smart-on-fhir/ehr-launch/callback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Smart On Fhir Launch Callback */
    get: operations['smart_on_fhir_launch_callback_api_v2_ml_scribe_integrations_smart_on_fhir_ehr_launch_callback_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/t2med/sessions/{session_id}/patient-context': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Report T2Med Patient Context
     * @description Attach a resolved FHIR Patient to a launched T2med session.
     *
     *     **Auth:** Heidi (Kinde) JWT.
     *
     *     **Side effects (idempotent):**
     *     1. If no ``IntegrationPatientProfileLink`` exists for this user and the
     *        reported ``patient_fhir_id``, creates a new ``PatientProfile`` + link.
     *     2. Looks up the ``IntegrationSessionLink`` for ``session_id`` and the
     *        launching user; rejects with 404 if missing, 409 if the link is not a
     *        T2med one.
     *     3. Sets ``patient_profile_id`` on the session itself (the same
     *        ``associate_patient_to_sessions`` path the manual "Add patient" flow
     *        uses) so the consult UI shows the patient, not "Add patient".
     */
    post: operations['report_t2med_patient_context_api_v2_ml_scribe_integrations_t2med_sessions__session_id__patient_context_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/t2med/pending-writebacks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List T2Med Pending Writebacks
     * @description Return all T2med write-backs that haven't yet been committed to local FHIR.
     *
     *     **Auth:** Heidi (Kinde) JWT.
     *
     *     A link is "pending" when its ``writeback_status`` is PENDING — set by
     *     every sync, including a re-sync of a note the desktop already wrote (so
     *     edits re-enter the queue) — and its launch context is still within the
     *     APS 4-hour TTL. SUCCEEDED/FAILED links are not served. Items are
     *     returned oldest-first. Re-queued items carry the previously ACKed
     *     ``document_reference_id`` / ``condition_ids`` so the desktop can update
     *     the existing resources instead of duplicating them.
     *
     *     For each pending link, the response includes:
     *     - The consult-note id and rendered plain-text body.
     *     - The Heidi session id.
     *     - The T2med launch context (``context_id``, ``fhir_base_url``) — pulled
     *       from the corresponding ``IntegrationSessionLink``.
     *     - Clinician-CONFIRMED ICD-10-GM coded entities from the consult-note's
     *       ``SessionClinicalCodeDO`` (PENDING/REJECTED extractions are omitted).
     */
    get: operations['list_t2med_pending_writebacks_api_v2_ml_scribe_integrations_t2med_pending_writebacks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/t2med/writebacks/{consult_note_link_id}/ack': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ack T2Med Writeback
     * @description Acknowledge the outcome of a desktop write-back.
     *
     *     On **success**, persists the FHIR ``DocumentReference.id`` + ``Condition.id``
     *     list on the link's ``provider_note_details``, updates ``last_synced_at``,
     *     and clears any recorded error state from earlier failed attempts.
     *
     *     On **failure**, records the error on the link. Terminal error codes mark
     *     the writeback FAILED (it stops being served on polls); other codes leave
     *     it pending so the desktop retries on its next poll within the context TTL.
     *
     *     Both variants are **generation-fenced**: the ACK must echo the
     *     ``writeback_generation`` it polled, and only completes that exact queued
     *     version. A stale ACK (the clinician re-synced after the poll) gets a 409
     *     ``stale_writeback_ack`` and the newer version remains pending.
     */
    post: operations['ack_t2med_writeback_api_v2_ml_scribe_integrations_t2med_writebacks__consult_note_link_id__ack_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/template-section-mappings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Replace Template Section Mapping
     * @description Replace the full section_mappings list for (user, template_id).
     *
     *     Called on every template save with the complete snapshot. Headings absent
     *     from the request body are removed from storage. Resolves the full ``User``
     *     (not just the kinde id) so ``user_ref_id`` + inferred workspace are in
     *     context and the write is workspace-tagged by the proxy (MUL-2293).
     */
    post: operations['replace_template_section_mapping_api_v2_ml_scribe_integrations_template_section_mappings_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/template-section-mappings/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template Section Mapping
     * @description Return the section mappings for (user, template_id), or 404 if none.
     */
    get: operations['get_template_section_mapping_api_v2_ml_scribe_integrations_template_section_mappings__template_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Template Section Mapping
     * @description Delete the section mappings for (user, template_id).
     *
     *     Returns 204 on success, 404 if no mapping existed.
     */
    delete: operations['delete_template_section_mapping_api_v2_ml_scribe_integrations_template_section_mappings__template_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/webhooks/token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Exchange client credentials for an access token */
    post: operations['token_endpoint_api_v2_ml_scribe_integrations_webhooks_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/webhooks/healthlink': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Receive a HealthLink ACK webhook */
    post: operations['receive_healthlink_ack_api_v2_ml_scribe_integrations_webhooks_healthlink_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/workflows/session': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Session
     * @description Create a new session linked to an appointment, with optional patient profile.
     *
     *     This workflow endpoint orchestrates the creation of a session by:
     *     1. Ensuring no session already exists for the appointment (prevents duplicates, validated via dependency)
     *     2. Retrieving or creating a patient profile if patient info is provided
     *     3. Creating a new session with a link to the appointment identifier
     *
     *     Args:
     *         session_link_manager: Manager for session linking operations
     *         patient_profile_link_manager: Manager for patient profile linking operations
     *         user: Authenticated user creating the session
     *         body: Request containing appointment, session, and optional patient information
     *
     *     Returns:
     *         CreateSessionWorkflowResponse containing the newly created session ID
     *
     *     Raises:
     *         HTTPException: 409 Conflict error if a session already exists for the appointment (raised by dependency)
     */
    post: operations['create_session_api_v2_ml_scribe_integrations_workflows_session_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/.well-known/jwks.json': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Returns the JSON Web Key Set (JWKS) for public key retrieval */
    get: operations['jwks_endpoint_api_v2_ml_scribe__well_known_jwks_json_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List letters for a session
     * @description Returns all letters belonging to the session, ordered newest first by creation time with a deterministic ID tie-breaker. The list is read-only and uses session view permission.
     */
    get: operations['list_letters_for_session_api_v2_ml_scribe_sessions__session_id__letters_get'];
    put?: never;
    /**
     * Create a letter from a document
     * @description Creates a new letter for the session using a point-in-time snapshot of the source document's name and generated content, falling back to the document's original content when generated content is unavailable. It also derives the initial subject line as '{letter_name} - {patient_display}' when both are available, otherwise from the single available value. Patient display comes from the embedded session patient first, then the linked patient profile. After creation, the letter and source document are decoupled and can be updated independently. If the authenticated user's organization has an ACTIVE letterhead, the new letter snapshots that letterhead ID at creation time; existing letters are not changed by later default letterhead changes. The created letter has no primary recipient and an empty copy recipients list; recipients are configured via the PATCH endpoint. A missing session path resource returns 404; invalid source document references in the request body return 422.
     */
    post: operations['create_letter_from_document_api_v2_ml_scribe_sessions__session_id__letters_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters:search-recipients': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search for letter recipients
     * @description Searches available recipient sources for practitioners matching the query. HealthLink FHIR PractitionerRole search accepts ``name`` (practitioner name), ``city`` (location city), and/or ``postcode`` (location postal code) and returns SMD-eligible practitioners when the user has a live integration. Organisation directory search returns email and fax contact data from ACTIVE uploaded directories when the user belongs to an organisation with at least one ACTIVE directory (name only). Results are deduplicated within each source and merged with FHIR hits first. Returns an empty results list (HTTP 200) when neither source is configured for the user.
     */
    get: operations['search_recipients_api_v2_ml_scribe_sessions__session_id__letters_search_recipients_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters/{letter_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a letter
     * @description Returns one session-scoped letter by ID. Missing, malformed, and cross-session letter IDs all return 404 to avoid leaking letter existence. The endpoint is read-only and uses session view permission.
     */
    get: operations['get_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete a letter
     * @description Permanently deletes one session-scoped letter and best-effort cleans up its attachments and timeline events. Never-sent letters and letters whose latest send fully failed can be deleted; sent and partially sent letters are rejected with 409. Missing, malformed, and cross-session letter IDs all return 404 to avoid leaking letter existence.
     */
    delete: operations['delete_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update a letter
     * @description Updates patchable fields on a session-scoped letter. Omitted fields are left unchanged. Name, subject line, and message body can be set to null to clear them; body content and content type cannot be null. The message body is currently only used for email sending. The primary recipient can be set to null to clear it; copy recipients are cleared with an empty list and cannot be null. Supports name, body content, subject line, message body, content type (HTML only), primary recipient, and copy recipients updates. Configuring a fax delivery recipient requires the fax sender feature to be enabled for the user.
     */
    patch: operations['update_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters/{letter_id}/timeline-events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List letter timeline events
     * @description Returns persisted timeline events for one session-scoped letter, ordered newest first by occurred_at with timeline event record ID as the deterministic tie-breaker. Sorting is fixed by the API and no sorting query parameters are exposed. Missing, malformed, and cross-session letter IDs all return 404 to avoid leaking letter existence.
     */
    get: operations['list_letter_timeline_events_api_v2_ml_scribe_sessions__session_id__letters__letter_id__timeline_events_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters/{letter_id}/attachments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List letter attachments
     * @description Returns metadata for PDF attachments uploaded to a session-scoped letter, ordered oldest first. Attachment bytes are not returned by this endpoint. Missing, malformed, and cross-session letter IDs all return 404 to avoid leaking letter existence.
     */
    get: operations['list_letter_attachments_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments_get'];
    put?: never;
    /**
     * Upload a letter attachment
     * @description Uploads a PDF attachment for a session-scoped letter and returns its metadata. Attachments are stored separately from the letter, so letter edits can proceed independently while uploads are in progress. The endpoint accepts PDF attachments up to 3 MiB. Signed but unsent letters can still receive attachments; delivered/locked letters reject new uploads. Missing, malformed, and cross-session letter IDs all return 404 to avoid leaking letter existence.
     */
    post: operations['upload_letter_attachment_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters/{letter_id}/attachments/{attachment_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete a letter attachment
     * @description Deletes one PDF attachment from a session-scoped mutable letter, including its backing storage object and metadata record. Missing, malformed, and cross-session letter IDs all return 404 as Letter not found; missing, malformed, and wrong-letter attachment IDs return 404 as Attachment not found. Delivered/locked letters reject attachment deletion with 409. Storage or metadata cleanup failures return 502 so clients can retry the deletion.
     */
    delete: operations['delete_letter_attachment_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments__attachment_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters/{letter_id}/attachments/{attachment_id}/download-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a letter attachment download URL
     * @description Returns a short-lived presigned GET URL for downloading one PDF attachment from a session-scoped letter. Attachment bytes are not proxied by this endpoint. Missing, malformed, and cross-session letter IDs all return 404 as Letter not found; missing, malformed, and wrong-letter attachment IDs return 404 as Attachment not found.
     */
    get: operations['get_letter_attachment_download_url_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments__attachment_id__download_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters/{letter_id}:sign': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Sign a letter
     * @description Applies the first supported electronic signature variant to a session-scoped letter. The request must include the signature_type to apply; currently only electronically_signed is supported. The signature payload is derived server-side from the session owner, the authenticated user applying the signature, and the server timestamp; it is not accepted by the PATCH endpoint. Repeated calls are idempotent only for the same signature type.
     */
    put: operations['sign_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__sign_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters/{letter_id}:send': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Send a letter PDF
     * @description Submits the uploaded frontend-rendered PDF and any uploaded letter attachments for delivery to each configured recipient. The session must have patient context before delivery can start. Delivery channels must preserve patient, clinic, and clinician relationship privacy by avoiding visible cross-recipient copies. When an email message body is configured, it is escaped and rendered as HTML that preserves new lines. Any successful recipient delivery locks the letter from future edits. If no recipient receives the letter, the latest attempt is persisted with delivery_status=FAILED and the letter remains editable for retry. If the letter is already partially sent, only recipients that have not been delivered are sent again; previously delivered recipients are carried forward in delivery details. Fax delivery requires the fax sender feature to be enabled for the user. SMD upstream failures may still return a 502 after persisting the latest delivery state.
     */
    put: operations['send_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__send_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/letters/{letter_id}/letterhead': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a letter's letterhead preview
     * @description Returns a short-lived preview URL for the letterhead inherited by this letter at creation time.
     */
    get: operations['get_letterhead_preview_for_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__letterhead_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prescriptions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Prescription */
    post: operations['create_prescription_api_v2_ml_scribe_prescriptions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prescriptions/{prescription_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Prescription */
    get: operations['get_prescription_api_v2_ml_scribe_prescriptions__prescription_id__get'];
    put?: never;
    post?: never;
    /** Delete Prescription */
    delete: operations['delete_prescription_api_v2_ml_scribe_prescriptions__prescription_id__delete'];
    options?: never;
    head?: never;
    /** Update Prescription */
    patch: operations['update_prescription_api_v2_ml_scribe_prescriptions__prescription_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/mk-template-requests/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Mk Template Request
     * @description Create a new MK custom template request.
     *
     *     Users can submit requests for the Medical Knowledge team to build custom templates.
     *     Optionally attach a PDF form that should be filled.
     */
    post: operations['create_mk_template_request_api_v2_ml_scribe_mk_template_requests__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/mk-template-requests/my-requests': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get My Mk Template Requests
     * @description Get all template requests submitted by the current user.
     *
     *     Returns a paginated list of the user's own MK custom template requests.
     */
    get: operations['get_my_mk_template_requests_api_v2_ml_scribe_mk_template_requests_my_requests_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/mk-template-requests/{request_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Mk Template Request
     * @description Get a specific MK custom template request by ID.
     *
     *     Users can only view their own requests.
     */
    get: operations['get_mk_template_request_api_v2_ml_scribe_mk_template_requests__request_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/inmails': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Inmails By User
     * @description get all inmails of the user
     */
    get: operations['get_inmails_by_user_api_v2_ml_scribe_notifications_inmails_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/inmails/{inmail_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Inmail By Id
     * @description get an inmail by id
     */
    get: operations['get_inmail_by_id_api_v2_ml_scribe_notifications_inmails__inmail_id__get'];
    put?: never;
    post?: never;
    /**
     * Mark Inmail As Deleted
     * @description mark an inmail as deleted
     */
    delete: operations['mark_inmail_as_deleted_api_v2_ml_scribe_notifications_inmails__inmail_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/inmails/read': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark All Unread Inmails As Read
     * @description mark all unread inmails as read
     */
    post: operations['mark_all_unread_inmails_as_read_api_v2_ml_scribe_notifications_inmails_read_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/inmails/{inmail_id}/read': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark Inmail As Read
     * @description mark an inmail as read
     */
    post: operations['mark_inmail_as_read_api_v2_ml_scribe_notifications_inmails__inmail_id__read_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/inmails/{inmail_id}/unread': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark Inmail As Unread
     * @description mark an inmail as unread
     */
    post: operations['mark_inmail_as_unread_api_v2_ml_scribe_notifications_inmails__inmail_id__unread_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/inmails/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Inmail
     * @description Create an inmail for testing, not for production. Should be removed once done testing.
     */
    post: operations['create_inmail_api_v2_ml_scribe_notifications_inmails__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/inmails:all': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Mark All Inmails As Deleted
     * @description mark all inmails as deleted
     */
    delete: operations['mark_all_inmails_as_deleted_api_v2_ml_scribe_notifications_inmails_all_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/inmails:read': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Mark All Read Inmails As Deleted
     * @description mark all read inmails as deleted
     */
    delete: operations['mark_all_read_inmails_as_deleted_api_v2_ml_scribe_notifications_inmails_read_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/notifications/preferences': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Notification Preference */
    get: operations['get_notification_preference_api_v2_ml_scribe_notifications_preferences_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/orchestration/{patient_profile_id}/patient-summary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Summary
     * @description get all data for a patient
     */
    get: operations['get_patient_summary_api_v2_ml_scribe_orchestration__patient_profile_id__patient_summary_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/users/logout-everywhere': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Logout Members
     * @description Force log-out a batch of organization members from all devices. The user-level Redis blacklist is written synchronously (security takes effect immediately); Auth0 session + refresh-token cleanup runs in an in-process background task. Poll the returned job_id for progress.
     */
    post: operations['logout_members_api_v2_ml_scribe_organization__organization_id__users_logout_everywhere_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/users/logout-everywhere/jobs/{job_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Logout Job
     * @description Get the current status of an org-admin logout-everywhere job.
     */
    get: operations['get_logout_job_api_v2_ml_scribe_organization__organization_id__users_logout_everywhere_jobs__job_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/users/logout-everywhere/all-matching': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Logout All Matching Members
     * @description Force log-out EVERY organization member matching the given filter (search / teamIds / roleIds / specialtyIds), resolved server-side so the client sends one request instead of an id list. Pass excludedUserRefIds to opt specific members out of the matched set (the 'select all, then un-check a few' UX). Targets exclude only the caller (an admin can never log themselves out here) and pending invitations; every other member is eligible, including other org-level admins. Same async-job semantics as the explicit endpoint; poll the returned jobId. Not bound by MAX_TARGETS_PER_JOB — the resolved set can exceed it.
     */
    post: operations['logout_all_matching_members_api_v2_ml_scribe_organization__organization_id__users_logout_everywhere_all_matching_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/users/logout-everywhere/eligible-count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Logout Eligible Count
     * @description Count the members an all-matching logout call would target for the given filter, AFTER the same exclusions (only the caller and pending invitations, plus any excludedUserRefIds opt-outs). Read-only; backs the confirm dialog's "this will log out N members".
     */
    get: operations['get_logout_eligible_count_api_v2_ml_scribe_organization__organization_id__users_logout_everywhere_eligible_count_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Organization Members
     * @description Get organization members with pagination
     */
    get: operations['list_organization_members_api_v2_ml_scribe_organization__organization_id__members_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Joined Organizations
     * @description list joined Organizations
     */
    get: operations['list_joined_organizations_api_v2_ml_scribe_organization_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/members/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Organization Members
     * @description Search members within the current user's organization
     */
    get: operations['search_organization_members_api_v2_ml_scribe_organization_members_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Organization
     * @description Get organization details
     */
    get: operations['get_organization_api_v2_ml_scribe_organization__organization_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Organization
     * @description Update organization details
     */
    patch: operations['update_organization_api_v2_ml_scribe_organization__organization_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/teams': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Organization Teams
     * @description List the teams under an organization
     */
    get: operations['list_organization_teams_api_v2_ml_scribe_organization__organization_id__teams_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/session-timeout': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Clear Organization Session Timeout
     * @description Remove the organisation-level session inactivity timeout. After clearing, members of the organisation fall through to their own user-level override or the cohort default. Idempotent — calling this when no value is set still returns 204. The caller must be an admin of the root team (`team_id == organization_id`); non-admins are rejected by the `PERMISSION_TEAM_EDIT` check.
     */
    delete: operations['clear_organization_session_timeout_api_v2_ml_scribe_organization__organization_id__session_timeout_delete'];
    options?: never;
    head?: never;
    /**
     * Update Organization Session Timeout
     * @description Set the organisation-level session inactivity timeout. The value applies to every member of this organisation and overrides each member's individual `user.session_timeout_info` at resolve time (see `is_editable_by_user` on `GET /user`). The caller must be an admin of the root team (`team_id == organization_id`); non-admins are rejected by the `PERMISSION_TEAM_EDIT` check. The value is validated against the closed interval [1, 720] minutes; out-of-range values return 422.
     */
    patch: operations['update_organization_session_timeout_api_v2_ml_scribe_organization__organization_id__session_timeout_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/teams/{team_id}/members/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Member
     * @description Update team member
     */
    patch: operations['update_team_member_api_v2_ml_scribe_organization__organization_id__teams__team_id__members__user_ref_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/teams/{team_id}/members/{relation_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove Member
     * @description remove team member from organization or child team
     */
    delete: operations['remove_member_api_v2_ml_scribe_organization__organization_id__teams__team_id__members__relation_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/invitations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Invite Users To Team
     * @description Invite users to a team under organization
     */
    post: operations['invite_users_to_team_api_v2_ml_scribe_organization__organization_id__invitations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/teams/{source_team_id}/members/{user_ref_id}/move': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Move Member Between Teams
     * @description Move a member from one team to another within the organization
     */
    post: operations['move_member_between_teams_api_v2_ml_scribe_organization__organization_id__teams__source_team_id__members__user_ref_id__move_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/organization/{organization_id}/analytics-dashboard': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Org Analytics Dashboard
     * @description Get organization analytics dashboard URL
     */
    get: operations['get_org_analytics_dashboard_api_v2_ml_scribe_organization__organization_id__analytics_dashboard_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Profiles
     * @description list patient profiles with session counts
     */
    get: operations['get_patient_profiles_api_v2_ml_scribe_patient_profiles__get'];
    put?: never;
    /**
     * Create Patient Profile
     * @description create patient profile
     */
    post: operations['create_patient_profile_api_v2_ml_scribe_patient_profiles__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles:search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Search Patient Profiles
     * @description live keystroke-rate name search across the user's own patient profiles
     */
    post: operations['search_patient_profiles_api_v2_ml_scribe_patient_profiles_search_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles:import': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Import Patient Profiles
     * @description bulk-import patient profiles from a fixed-template CSV
     */
    post: operations['import_patient_profiles_api_v2_ml_scribe_patient_profiles_import_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles/{patient_profile_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Profile
     * @description get a single patient profile by id
     */
    get: operations['get_patient_profile_api_v2_ml_scribe_patient_profiles__patient_profile_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Patient Profile
     * @description delete patient profile
     */
    delete: operations['delete_patient_profile_api_v2_ml_scribe_patient_profiles__patient_profile_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Patient Profile
     * @description update patient profile
     */
    patch: operations['update_patient_profile_api_v2_ml_scribe_patient_profiles__patient_profile_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles/{patient_profile_id}/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link Patient Sessions
     * @description set linked sessions to patient profile
     */
    post: operations['link_patient_sessions_api_v2_ml_scribe_patient_profiles__patient_profile_id__sessions_post'];
    /**
     * Unlink Patient Sessions
     * @description unlink sessions from patient profile
     */
    delete: operations['unlink_patient_sessions_api_v2_ml_scribe_patient_profiles__patient_profile_id__sessions_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles:batch-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Patient Profiles
     * @description delete multiple patient profiles at once
     */
    delete: operations['delete_patient_profiles_api_v2_ml_scribe_patient_profiles_batch_delete_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles:merge-profiles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Merge Patient Profiles
     * @description merge duplicate patient profiles into one canonical profile
     */
    post: operations['merge_patient_profiles_api_v2_ml_scribe_patient_profiles_merge_profiles_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles/{patient_profile_id}/recap': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Profile Recap
     * @description get a 2-3 sentence patient recap sourced from the most recent finalised consult note
     */
    get: operations['get_patient_profile_recap_api_v2_ml_scribe_patient_profiles__patient_profile_id__recap_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles/{patient_profile_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List patient documents
     * @description List documents attached to the given patient. Most recent first. Caller must have view permission on the patient.
     */
    get: operations['list_patient_documents_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents_get'];
    put?: never;
    /**
     * Upload a patient document
     * @description Upload a file and attach it to the given patient. The file is stored in S3; metadata is persisted in Mongo. Caller must have edit permission on the patient.
     */
    post: operations['upload_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-profiles/{patient_profile_id}/documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get document metadata and a presigned download URL */
    get: operations['get_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents__document_id__get'];
    put?: never;
    post?: never;
    /** Delete a patient document (soft delete) */
    delete: operations['delete_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents__document_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-state/views': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Read a bounded patient-state view
     * @description Returns one session's current patient facts, at one state version, within the boundaries the request declares. Facts carry evidence references into pinned source revisions and never the source content.
     */
    post: operations['read_patient_state_view_api_v2_ml_scribe_patient_state_views_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/pdf-document/{document_id}/fields': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Filled Pdf Fields
     * @description Get filled PDF field values for a document
     */
    get: operations['get_filled_pdf_fields_api_v2_ml_scribe_pdf_document__document_id__fields_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Pdf Fields
     * @description Update PDF field values and regenerate the PDF
     */
    patch: operations['update_pdf_fields_api_v2_ml_scribe_pdf_document__document_id__fields_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/pdf-template': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Base Pdf Template Url */
    post: operations['get_base_pdf_template_url_api_v2_ml_scribe_pdf_template_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/pdf-template/extract-fields': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Extract Form Fields From Pdf
     * @description Extract form fields from a PDF or Word (.docx) file
     */
    post: operations['extract_form_fields_from_pdf_api_v2_ml_scribe_pdf_template_extract_fields_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/pdf-template/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Filled Pdf Template Url */
    post: operations['get_filled_pdf_template_url_api_v2_ml_scribe_pdf_template__document_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/pdf-template/{document_id}/export-docx': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Export Filled Pdf Template As Docx */
    post: operations['export_filled_pdf_template_as_docx_api_v2_ml_scribe_pdf_template__document_id__export_docx_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/xml-template/extract-fields': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Extract Form Fields From Xml
     * @description Extract fillable fields from an XML form file
     */
    post: operations['extract_form_fields_from_xml_api_v2_ml_scribe_xml_template_extract_fields_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/xml-document/{document_id}/fields': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Filled Xml Fields
     * @description Get filled XML field values for a document
     */
    get: operations['get_filled_xml_fields_api_v2_ml_scribe_xml_document__document_id__fields_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Xml Fields
     * @description Update filled XML field values for a document
     */
    patch: operations['update_xml_fields_api_v2_ml_scribe_xml_document__document_id__fields_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/xml-document/{document_id}/download': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download Filled Xml
     * @description Download the filled XML form document
     */
    get: operations['download_filled_xml_api_v2_ml_scribe_xml_document__document_id__download_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/json-template/extract-fields': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Extract Form Fields From Json
     * @description Extract fillable fields from a JSON form file
     */
    post: operations['extract_form_fields_from_json_api_v2_ml_scribe_json_template_extract_fields_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/json-document/{document_id}/download': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download Filled Json
     * @description Download the filled JSON form document
     */
    get: operations['download_filled_json_api_v2_ml_scribe_json_document__document_id__download_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/personalizations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Personalization Profile
     * @description Get the complete personalization profile for the current user.
     */
    get: operations['get_personalization_profile_api_v2_ml_scribe_personalizations_get'];
    put?: never;
    post?: never;
    /**
     * Delete Personalization Insight
     * @description Delete a single personalization insight for the current user.
     */
    delete: operations['delete_personalization_insight_api_v2_ml_scribe_personalizations_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/personalizations/toggle-insight': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Toggle Personalization Insight
     * @description Toggle a single personalization insight rule for the current user.
     */
    post: operations['toggle_personalization_insight_api_v2_ml_scribe_personalizations_toggle_insight_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/personalizations/mark-as-read': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark As Read
     * @description Mark the new insights badge as read for the current user.
     */
    post: operations['mark_as_read_api_v2_ml_scribe_personalizations_mark_as_read_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/nudges': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Nudges */
    get: operations['list_nudges_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/protocols': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Available Protocols
     * @description The full protocol library for the session's tenant, for the "All protocols"
     *     browse list. The FE filters out protocols that are already active/dismissed.
     */
    get: operations['list_available_protocols_api_v2_ml_scribe_in_session_guidance_sessions__session_id__protocols_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/nudges/detect': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Detect Nudges */
    post: operations['detect_nudges_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_detect_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/nudges/add': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add Nudge
     * @description Manually surface a protocol the clinician selected from the library. A manual
     *     add is a strong signal that auto-detection missed something, so it is tracked
     *     distinctly (nudge_card_added).
     */
    post: operations['add_nudge_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_add_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/nudges/{protocol_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Patch Card Status */
    patch: operations['patch_card_status_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges__protocol_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/nudges/{protocol_id}/items/{item_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Patch Item Checked */
    patch: operations['patch_item_checked_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges__protocol_id__items__item_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/nudges/applied': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark Orders Applied
     * @description Record which protocol orders are currently materialized in the clinician-context
     *     orders block, by reconciling each item's durable ``applied_at`` to exactly
     *     ``applied_item_ids`` across the session's cards.
     *
     *     Called by the client on every "apply" (whether or not a note exists yet), so the
     *     client can maintain the context orders block by what WE actually wrote (this durable,
     *     per-session set) instead of by catalogue text — which can't distinguish our orders from
     *     clinician-typed or pasted-from-a-prior-visit content. This is deliberately separate from
     *     note generation: the orders still live in ``clinician_notes`` so they survive a full
     *     regeneration, and feeding them to generation as STRUCTURED input instead would mean
     *     changing the shared generation contract (params + prompt variables + every note-gen
     *     prompt template) — there is no feature-contained fork for that, so it is intentionally
     *     out of scope here. This marker is also distinct from the note un-weave, which the
     *     incorporate-orders endpoint handles via ``removed``.
     */
    post: operations['mark_orders_applied_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_applied_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/note/incorporate-orders': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Incorporate Orders Into Note
     * @description Reconcile an ALREADY-GENERATED note's orders to the clinician's current selection.
     *
     *     ``orders`` are the actions the note should currently reflect; ``removed`` are actions
     *     previously folded in that the clinician has since deselected. The same orders are upserted
     *     into ``session.clinician_notes`` by the client (the canonical context that survives
     *     regeneration); this endpoint applies the delta to the current note, writing ``edited_note``
     *     only so the change is reversible. Flag-gated to ChenMed via ``RequireNudgesFeatureDep``.
     *
     *     The orchestration (prompt assembly, the ask-ai pass, the optimistic-concurrency guard and
     *     persistence) lives in ``NoteReconciler``; this handler authorizes the session and maps the
     *     reconciler's domain errors to HTTP responses.
     */
    post: operations['incorporate_orders_into_note_api_v2_ml_scribe_in_session_guidance_sessions__session_id__note_incorporate_orders_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/nudges/suggest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Suggest Nudge Items
     * @description Accuracy-first, off-critical-path pass that refreshes advisory item/branch
     *     suggestions on the session's active cards from the latest transcript.
     *
     *     The FE calls this independently of `detect` (which surfaces cards), so card surfacing
     *     stays snappy and suggestions arrive without blocking the UI. Suggestions are
     *     highlights only — they never check or select anything. Rate-limited like detect.
     *
     *     The refresh orchestration lives in NudgeSuggestionService; this handler authorizes the
     *     session, delegates, and assembles the refreshed cards into the response.
     */
    post: operations['suggest_nudge_items_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_suggest_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/sessions/{session_id}/tasks/generate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Tasks Excluding Completed
     * @description Generate clinical tasks for a nudge session, steering the model away from protocol
     *     actions the clinician already ticked off (so handled items don't resurface as phantom
     *     "open" tasks).
     *
     *     Flag-gated to ChenMed. The FE calls this for nudge sessions instead of relying on the
     *     server's background task autogen — which is disabled for the cohort via
     *     ``release_task_generation_bg_autogen`` — so the shared task-generation code stays stock.
     *     Reuses ``ClinicalTaskService.generate_tasks`` verbatim via ``NudgeAwareClinicalTaskService``
     *     (only the LLM service is swapped for the steering one). Persists tasks and returns 204; the
     *     client refetches via the clinical-tasks read endpoint.
     */
    post: operations['generate_tasks_excluding_completed_api_v2_ml_scribe_in_session_guidance_sessions__session_id__tasks_generate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Protocols */
    get: operations['list_protocols_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_get'];
    put?: never;
    /** Create Protocol */
    post: operations['create_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols:seed': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Seed Protocols */
    post: operations['seed_protocols_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_seed_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Protocol */
    get: operations['get_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__get'];
    put?: never;
    post?: never;
    /** Delete Protocol */
    delete: operations['delete_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__delete'];
    options?: never;
    head?: never;
    /** Update Protocol */
    patch: operations['update_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}/trigger-conditions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update Trigger Conditions */
    patch: operations['update_trigger_conditions_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__trigger_conditions_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}/test-cases': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update Test Cases */
    patch: operations['update_test_cases_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__test_cases_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}:revert-to-draft': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Revert Protocol To Draft */
    post: operations['revert_protocol_to_draft_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__revert_to_draft_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}:publish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Publish Protocol */
    post: operations['publish_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__publish_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}/versions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Protocol Versions */
    get: operations['list_protocol_versions_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__versions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}:rollback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Rollback Protocol */
    post: operations['rollback_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__rollback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols:parse': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Parse Protocol */
    post: operations['parse_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_parse_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols:parse-outline': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Parse Protocol Outline */
    post: operations['parse_protocol_outline_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_parse_outline_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols:edit-outline': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Edit Protocol Outline */
    post: operations['edit_protocol_outline_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_edit_outline_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}:bench': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Bench Protocol */
    post: operations['bench_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__bench_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}/triggering-codes:derive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Derive Triggering Codes */
    post: operations['derive_triggering_codes_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__triggering_codes_derive_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/in-session-guidance/nudge-settings/protocols/{doc_id}/confusable:derive': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Derive Confusable */
    post: operations['derive_confusable_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__confusable_derive_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflows */
    get: operations['list_workflows_api_v2_ml_scribe_workflows_get'];
    put?: never;
    /** Create Workflow */
    post: operations['create_workflow_api_v2_ml_scribe_workflows_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/share': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Share Workflow */
    post: operations['share_workflow_api_v2_ml_scribe_workflows__workflow_id__share_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/unshare': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Unshare Workflow */
    post: operations['unshare_workflow_api_v2_ml_scribe_workflows__workflow_id__unshare_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List All Workflow Runs
     * @description Cross-workflow run history with optional per-workflow filter.
     */
    get: operations['list_all_workflow_runs_api_v2_ml_scribe_workflows_runs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/schedules/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Workflow Schedules Batch
     * @description Batch-fetch schedules for multiple workflows in a single request.
     */
    get: operations['get_workflow_schedules_batch_api_v2_ml_scribe_workflows_schedules_batch_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow */
    get: operations['get_workflow_api_v2_ml_scribe_workflows__workflow_id__get'];
    put?: never;
    post?: never;
    /** Delete Workflow */
    delete: operations['delete_workflow_api_v2_ml_scribe_workflows__workflow_id__delete'];
    options?: never;
    head?: never;
    /** Update Workflow */
    patch: operations['update_workflow_api_v2_ml_scribe_workflows__workflow_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Run Workflow */
    post: operations['run_workflow_api_v2_ml_scribe_workflows__workflow_id__run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/run-stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Workflow Run Stats
     * @description Aggregate performance metrics for a routine's recent runs.
     */
    get: operations['get_workflow_run_stats_api_v2_ml_scribe_workflows__workflow_id__run_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/eval-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Eval Profile */
    get: operations['get_workflow_eval_profile_api_v2_ml_scribe_workflows__workflow_id__eval_profile_get'];
    /** Update Workflow Eval Profile */
    put: operations['update_workflow_eval_profile_api_v2_ml_scribe_workflows__workflow_id__eval_profile_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/runs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Workflow Runs */
    get: operations['list_workflow_runs_api_v2_ml_scribe_workflows__workflow_id__runs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/schedule': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Workflow Schedule */
    get: operations['get_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_get'];
    /** Set Workflow Schedule */
    put: operations['set_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_put'];
    post?: never;
    /** Delete Workflow Schedule */
    delete: operations['delete_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/schedule:pause': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Pause Workflow Schedule */
    post: operations['pause_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_pause_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/schedule:resume': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Resume Workflow Schedule */
    post: operations['resume_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_resume_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/event-rules': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Event Rules */
    get: operations['list_event_rules_api_v2_ml_scribe_workflows__workflow_id__event_rules_get'];
    put?: never;
    /** Add Event Rule */
    post: operations['add_event_rule_api_v2_ml_scribe_workflows__workflow_id__event_rules_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflows/{workflow_id}/event-rules/{rule_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete Event Rule */
    delete: operations['delete_event_rule_api_v2_ml_scribe_workflows__workflow_id__event_rules__rule_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflow-presets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Workflow Presets
     * @description The code-defined preset catalog the FE renders as cards.
     */
    get: operations['list_workflow_presets_api_v2_ml_scribe_workflow_presets_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflow-presets/install-for-connector/{connector}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Install Primary Presets For Connector
     * @description Idempotently install primary hidden routines for a newly linked app.
     *
     *     Unknown provider keys are a no-op (empty list) rather than an error: the FE
     *     fires this for every connector it links, and only keys an ``integration_primary``
     *     preset declares may install anything.
     */
    post: operations['install_primary_presets_for_connector_api_v2_ml_scribe_workflow_presets_install_for_connector__connector__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workflow-presets/{template_id}/install': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Install Workflow Preset
     * @description Install a preset as a user-owned workflow. Install lives on the
     *     template resource so template ids never enter the workflow namespace.
     *     Idempotent — returns the existing copy (200) when already installed,
     *     201 on create.
     */
    post: operations['install_workflow_preset_api_v2_ml_scribe_workflow_presets__template_id__install_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/settings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Read Settings
     * @description Resolve a collection of settings for the requesting user in one call.
     *
     *     With ``keys`` (comma-separated) only that subset is resolved; without it the
     *     full catalog is. Boxes are loaded once via a single ``resolve_multi`` over
     *     the whole key set. The response is a partial bulk read: resolved keys come
     *     back under ``settings``, and each requested key that did not resolve is
     *     reported under ``errors`` (``unknown_setting`` or ``resolution_error``),
     *     always under HTTP 200 — one bad key never sinks the batch.
     */
    get: operations['read_settings_api_v2_ml_scribe_settings_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Write Settings
     * @description Write the actor's setting value(s) at each setting's home layer.
     *
     *     Three-state body: a key with a value sets it, a key with explicit ``null``
     *     clears it, an absent key is unchanged. The pre-write checks are
     *     all-or-nothing — a rejected key (locked → 403, unauthorized scope → 403,
     *     invalid value/merged state → 422, unknown → 400) aborts the whole request
     *     with nothing persisted. A persist-time 409 means the actor's own scope
     *     document was concurrently deleted.
     *
     *     On success the persisted write is HTTP 200 regardless of resolution: each
     *     written key's post-write state is resolved and returned under ``settings``,
     *     and a key that fails to resolve is reported under ``errors`` — the
     *     read-after-write is a best-effort projection that never fails the write. An
     *     empty body is a 200 no-op (empty ``settings``/``errors``).
     *
     *     The active-team relation (resolved lazily, the same one the ctx is built
     *     from) is passed to the service, which authorizes a ``TEAM``-home write
     *     against it.
     */
    patch: operations['write_settings_api_v2_ml_scribe_settings_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/settings/{key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Read Setting
     * @description Resolve one setting for the requesting user.
     *
     *     Returns the effective value, its type schema, and its provenance. An unknown
     *     key surfaces the catalog's unknown-setting error as HTTP 404; every other
     *     failure propagates.
     */
    get: operations['read_setting_api_v2_ml_scribe_settings__key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/presentations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Presentations */
    get: operations['list_presentations_api_v2_ml_scribe_presentations_get'];
    put?: never;
    /** Create Presentation */
    post: operations['create_presentation_api_v2_ml_scribe_presentations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/presentations/by-chat/{chat_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Presentation By Chat */
    get: operations['get_presentation_by_chat_api_v2_ml_scribe_presentations_by_chat__chat_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/presentations/{presentation_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Presentation */
    get: operations['get_presentation_api_v2_ml_scribe_presentations__presentation_id__get'];
    put?: never;
    post?: never;
    /** Delete Presentation */
    delete: operations['delete_presentation_api_v2_ml_scribe_presentations__presentation_id__delete'];
    options?: never;
    head?: never;
    /** Update Presentation */
    patch: operations['update_presentation_api_v2_ml_scribe_presentations__presentation_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/presentations/{presentation_id}/slides': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Add Slide */
    post: operations['add_slide_api_v2_ml_scribe_presentations__presentation_id__slides_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/presentations/{presentation_id}/slides/{slide_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete Slide */
    delete: operations['delete_slide_api_v2_ml_scribe_presentations__presentation_id__slides__slide_id__delete'];
    options?: never;
    head?: never;
    /** Update Slide */
    patch: operations['update_slide_api_v2_ml_scribe_presentations__presentation_id__slides__slide_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/presentations/{presentation_id}/slides:reorder': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Reorder Slides */
    post: operations['reorder_slides_api_v2_ml_scribe_presentations__presentation_id__slides_reorder_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/presentations/{presentation_id}:export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Export Presentation
     * @description Regenerate the presentation and return a download URL.
     *
     *     Accepts an optional ``format`` field: ``"pptx"`` (default) or ``"pdf"``.
     */
    post: operations['export_presentation_api_v2_ml_scribe_presentations__presentation_id__export_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List the caller's projects (saved-first, optionally filtered) */
    get: operations['list_projects_api_v2_ml_scribe_projects_get'];
    put?: never;
    /** Create a project (saves an AgentConfig + starts a durable run) */
    post: operations['create_project_api_v2_ml_scribe_projects_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/saved': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * DEPRECATED: use ``GET /projects?saved=only``
     * @deprecated
     * @description Legacy alias for ``GET /projects?saved=only``.
     *
     *     Kept for one release so any cached/queued FE bundles keep working
     *     while clients migrate to the unified endpoint. New callers should
     *     use ``GET /projects?saved=only`` directly — it supports pagination
     *     and search, this alias does not.
     */
    get: operations['list_saved_projects_api_v2_ml_scribe_projects_saved_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Project */
    get: operations['get_project_api_v2_ml_scribe_projects__project_id__get'];
    put?: never;
    post?: never;
    /** Delete Project */
    delete: operations['delete_project_api_v2_ml_scribe_projects__project_id__delete'];
    options?: never;
    head?: never;
    /** Update Project */
    patch: operations['update_project_api_v2_ml_scribe_projects__project_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/save': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Save Project */
    post: operations['save_project_api_v2_ml_scribe_projects__project_id__save_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/unsave': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Unsave Project */
    post: operations['unsave_project_api_v2_ml_scribe_projects__project_id__unsave_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/turns': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Submit Project Turn */
    post: operations['submit_project_turn_api_v2_ml_scribe_projects__project_id__turns_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/experience-feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Work experience feedback
     * @description Submit general UMUX-Lite feedback (star ratings + optional text) for Work.
     */
    post: operations['create_work_experience_feedback_api_v2_ml_scribe_projects_experience_feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/experience-feedback/snooze': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Snooze Work experience feedback
     * @description Record that the user dismissed the Work experience feedback nudge for later.
     */
    post: operations['snooze_work_experience_feedback_api_v2_ml_scribe_projects_experience_feedback_snooze_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit thumbs feedback for an assistant reply in a project
     * @description Persist a thumbs-up / thumbs-down rating on a project reply.
     *
     *     Routed through the shared ``UserFeedbackService`` (same store the
     *     Evidence ``POST /chat/feedback`` endpoint uses) with
     *     ``target_type=PROJECT`` and ``target_id`` set to the project id.
     *     Projects aren't session-scoped, so ``session_id`` is persisted as
     *     an empty string — matching the sessionless-Evidence convention.
     *
     *     Resolving the project first enforces the same per-user ownership
     *     gate as every other route here, so a stale or hand-crafted client
     *     can't leave feedback on someone else's project.
     */
    post: operations['submit_project_feedback_api_v2_ml_scribe_projects__project_id__feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/follow-up-questions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate LLM follow-up questions for the latest project reply
     * @description Suggest contextual follow-up questions for the latest reply.
     *
     *     Reuses the Evidence chat's ``generate_follow_up_questions`` (Gemini
     *     2.5 Flash) so the two surfaces share one generator. The last user
     *     turn and last assistant turn are derived server-side from the
     *     durable transcript — the client never supplies conversation content.
     *     Returns an empty list (not an error) when there's nothing to build
     *     on yet, so the FE can simply render nothing.
     */
    post: operations['get_project_follow_up_questions_api_v2_ml_scribe_projects__project_id__follow_up_questions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/attachments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload a file attachment for the project's next turn
     * @description Pre-upload a single file and return its harness attachment ID.
     *
     *     The FE includes returned IDs in the next ``SubmitTurnRequest`` 's
     *     ``attachment_ids`` field; the harness appends them as
     *     ``AttachmentBlock``s on the user message so the Projects agent
     *     can read CSV / image / PDF / plain-text content the same way the
     *     Evidence chat does. Project creation does NOT accept attachments —
     *     the FE flow is create → upload → submit-turn-with-IDs.
     *
     *     Files exceeding the harness's per-file or per-turn caps surface as
     *     ``400``; missing/invalid project IDs surface as ``404`` so a stale
     *     FE bundle that targets a deleted project gets a clean error rather
     *     than orphaning bytes in S3.
     */
    post: operations['upload_project_attachment_api_v2_ml_scribe_projects__project_id__attachments_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/attachments/{attachment_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete a pre-uploaded attachment that hasn't been sent yet
     * @description Remove a pre-uploaded attachment from S3 + Mongo.
     *
     *     Called by the FE when the user clicks the "remove" X on a chip
     *     before sending. Idempotent — a missing record is a 204 (the
     *     attachment is gone, which is the desired post-state).
     */
    delete: operations['delete_project_attachment_api_v2_ml_scribe_projects__project_id__attachments__attachment_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/attachments/{attachment_id}/download-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Issue a presigned GET URL for an attachment in this project's run
     * @description Return a fresh presigned S3 URL for an attachment.
     *
     *     Presigned URLs returned at upload time live for
     *     ``AGENT_ATTACHMENT_PRESIGNED_TTL_SECONDS``; the FE re-mints them
     *     via this endpoint when rendering historical transcript bubbles
     *     whose original URLs have expired.
     */
    get: operations['get_project_attachment_download_url_api_v2_ml_scribe_projects__project_id__attachments__attachment_id__download_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/projects/{project_id}/messages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Fetch the project's durable conversation transcript
     * @description Returns the latest persisted transcript for the project's primary run.
     *
     *     The FE polls this endpoint to render the chat surface — both the
     *     user's submitted turns and the assistant's tool calls/text replies
     *     show up here once the harness flushes the snapshot.
     */
    get: operations['get_project_messages_api_v2_ml_scribe_projects__project_id__messages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/protocols': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List all protocols
     * @description Get all protocols available to the user (system + user's custom)
     */
    get: operations['get_protocols_api_v2_ml_scribe_protocols_get'];
    put?: never;
    /** Create a new protocol */
    post: operations['create_protocol_api_v2_ml_scribe_protocols_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/protocols/by-shorthand/{shorthand}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a protocol by shorthand
     * @description Lookup a protocol by its shorthand trigger (for chat integration)
     */
    get: operations['get_protocol_by_shorthand_api_v2_ml_scribe_protocols_by_shorthand__shorthand__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/protocols/generate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate protocol fields from natural language
     * @description Use AI to generate protocol name, shorthand, description, and SOP from a natural language description
     */
    post: operations['generate_protocol_fields_api_v2_ml_scribe_protocols_generate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/protocols/connectors': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List available connectors
     * @description Get list of available connectors that can be added to protocols
     */
    get: operations['get_available_connectors_api_v2_ml_scribe_protocols_connectors_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/protocols/{protocol_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a protocol by ID */
    get: operations['get_protocol_api_v2_ml_scribe_protocols__protocol_id__get'];
    put?: never;
    post?: never;
    /** Delete a protocol */
    delete: operations['delete_protocol_api_v2_ml_scribe_protocols__protocol_id__delete'];
    options?: never;
    head?: never;
    /** Update a protocol */
    patch: operations['update_protocol_api_v2_ml_scribe_protocols__protocol_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/protocols/{protocol_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload a reference document
     * @description Upload a reference document to a protocol (max 3, 5MB each, PDF/CSV only)
     */
    post: operations['upload_protocol_document_api_v2_ml_scribe_protocols__protocol_id__documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/protocols/{protocol_id}/documents/{document_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete a reference document */
    delete: operations['delete_protocol_document_api_v2_ml_scribe_protocols__protocol_id__documents__document_key__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/protocols/sessions/{session_id}/active-protocol': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Clear active protocol for a session
     * @description Clear the active protocol for a session (user dismisses the protocol badge).
     */
    delete: operations['clear_session_active_protocol_api_v2_ml_scribe_protocols_sessions__session_id__active_protocol_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/repeat-reviews': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Repeat Reviews */
    get: operations['list_repeat_reviews_api_v2_ml_scribe_repeat_reviews_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/repeat-reviews/{request_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Repeat Review */
    get: operations['get_repeat_review_api_v2_ml_scribe_repeat_reviews__request_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update Repeat Review Status */
    patch: operations['update_repeat_review_status_api_v2_ml_scribe_repeat_reviews__request_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/triage-reviews': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Triage Reviews */
    get: operations['list_triage_reviews_api_v2_ml_scribe_triage_reviews_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/triage-reviews/{request_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Triage Review */
    get: operations['get_triage_review_api_v2_ml_scribe_triage_reviews__request_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/roles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Roles
     * @description list roles
     */
    get: operations['get_roles_api_v2_ml_scribe_roles_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update User Roles
     * @description update user role
     */
    patch: operations['update_user_roles_api_v2_ml_scribe_roles_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/clinical-codes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Clinical Codes */
    get: operations['get_clinical_codes_api_v2_ml_scribe_sessions__session_id__clinical_codes_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/clinical-codes/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Confirm Clinical Code */
    post: operations['confirm_clinical_code_api_v2_ml_scribe_sessions__session_id__clinical_codes_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/clinical-codes/unconfirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Unconfirm Clinical Code */
    post: operations['unconfirm_clinical_code_api_v2_ml_scribe_sessions__session_id__clinical_codes_unconfirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/clinical-codes/{entity_id}/reject': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Reject Clinical Codes */
    post: operations['reject_clinical_codes_api_v2_ml_scribe_sessions__session_id__clinical_codes__entity_id__reject_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/clinical-codes/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Search Clinical Codes */
    get: operations['search_clinical_codes_api_v2_ml_scribe_sessions__session_id__clinical_codes_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/clinical-codes/add-new-code': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Add New Code */
    post: operations['add_new_code_api_v2_ml_scribe_sessions__session_id__clinical_codes_add_new_code_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/clinical-codes/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Clinical Code Feedback
     * @description Submit feedback for clinical codes
     */
    post: operations['submit_clinical_code_feedback_api_v2_ml_scribe_sessions__session_id__clinical_codes_feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/em-level-determinator/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Confirm Em Level */
    post: operations['confirm_em_level_api_v2_ml_scribe_sessions__session_id__em_level_determinator_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/em-level-determinator/remove': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Remove Em Level */
    post: operations['remove_em_level_api_v2_ml_scribe_sessions__session_id__em_level_determinator_remove_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/consult-note/ai-commands': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Note Gen Ai Commands
     * @deprecated
     * @description Use /api/v2-1/ml-scribe/sessions/{session_id}/consult-note/ai-commands instead
     */
    get: operations['list_note_gen_ai_commands_api_v2_ml_scribe_sessions__session_id__consult_note_ai_commands_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/consult-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Consult Notes
     * @description Get list of consult notes associated with the session
     */
    get: operations['get_consult_notes_api_v2_ml_scribe_sessions__session_id__consult_note_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Latest Consult Note
     * @description Edit the latest consult note associated with the session
     */
    patch: operations['update_latest_consult_note_api_v2_ml_scribe_sessions__session_id__consult_note_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/consult-note/{note_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Consult Note
     * @description Get the consult note based on note ID.
     */
    get: operations['get_consult_note_api_v2_ml_scribe_sessions__session_id__consult_note__note_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/consult-note/{note_id}/revert': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Revert Consult Note To Edit
     * @description Revert consult note to given edit ID.
     */
    patch: operations['revert_consult_note_to_edit_api_v2_ml_scribe_sessions__session_id__consult_note__note_id__revert_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/consult-note/{consult_note_id}/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Consult Note Feedback
     * @description Submit feedback for a consult note
     */
    post: operations['submit_consult_note_feedback_api_v2_ml_scribe_sessions__session_id__consult_note__consult_note_id__feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/consult-note:link-section': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Replace Consult Note Section Links
     * @description Replace all EHR section mappings on the consult note in use.
     *
     *     The request is the full set of section/heading mappings parsed from the
     *     current note content - mappings not present in the request are deleted
     *     (an empty list clears all mappings). Only works with MARKDOWN sectional
     *     notes; JSON notes are rejected.
     */
    put: operations['replace_consult_note_section_links_api_v2_ml_scribe_sessions__session_id__consult_note_link_section_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Consult Note Section Link
     * @description Link a consult note section with an EHR section ID.
     *
     *     JSON notes: embeds the linked EHR section ID inline in the note content
     *     and updates the template-level TemplateSectionMapping.
     *     MARKDOWN notes: merges the mapping into consult_note.section_mappings
     *     (per-note state) via find-or-insert.
     */
    patch: operations['update_consult_note_section_link_api_v2_ml_scribe_sessions__session_id__consult_note_link_section_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Empty Document
     * @description create an empty document for the session. This document is a placeholder for the AI generation in next step.
     *     Args:
     *         session_id (str)
     *
     *     Returns:
     *         Document
     */
    post: operations['create_empty_document_api_v2_ml_scribe_sessions__session_id__documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Documents
     * @description Update the multiple documents in a session
     */
    patch: operations['update_documents_api_v2_ml_scribe_sessions__session_id__documents_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/documents/ai-commands': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Document Suggested Ai Commands
     * @deprecated
     * @description Use /api/v2-1/ml-scribe/sessions/{session_id}/documents/ai-commands-v2 instead
     */
    get: operations['list_document_suggested_ai_commands_api_v2_ml_scribe_sessions__session_id__documents_ai_commands_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/documents/dictation-cleanup-modes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Dictation Cleanup Modes
     * @description Dictation types refer to the different levels of clean up we do with transcript.
     *     1. Simple clean up (Word-for-word): Remove filler words, false starts, repetitions and such but mostly keep the transcript as is.
     *     2. Smart clean up (Smart Dictation): Attempts to remove any unnecessary information and correct any errors.
     */
    get: operations['list_dictation_cleanup_modes_api_v2_ml_scribe_sessions__session_id__documents_dictation_cleanup_modes_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/documents/{document_id}/shares/email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Share Document Through Email */
    post: operations['share_document_through_email_api_v2_ml_scribe_sessions__session_id__documents__document_id__shares_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/documents/{document_id}/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Document Feedback
     * @description Submit feedback for a consult note
     */
    post: operations['submit_document_feedback_api_v2_ml_scribe_sessions__session_id__documents__document_id__feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/documents/pdf-document': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Document From Pdf */
    post: operations['create_document_from_pdf_api_v2_ml_scribe_sessions__session_id__documents_pdf_document_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/transcript': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Transcript
     * @deprecated
     * @description Generate or get the transcript of a session
     */
    get: operations['get_session_transcript_api_v2_ml_scribe_sessions__session_id__transcript_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/transcript/backup-transcript': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Session Backup Transcript
     * @description Generate or get the backup transcript of a session when ws recording fails
     */
    post: operations['generate_session_backup_transcript_api_v2_ml_scribe_sessions__session_id__transcript_backup_transcript_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/transcript/client-transcript': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Save Client Generated Backup Transcript
     * @description Store the backup transcript generated by the client
     */
    post: operations['save_client_generated_backup_transcript_api_v2_ml_scribe_sessions__session_id__transcript_client_transcript_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/transcript/live': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Transcript Live
     * @description Generate or get the transcript of a session
     */
    get: operations['get_session_transcript_live_api_v2_ml_scribe_sessions__session_id__transcript_live_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/backup-audios/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Backup Audio
     * @description Upload backup audio file to generate transcript
     */
    post: operations['upload_backup_audio_api_v2_ml_scribe_sessions__session_id__backup_audios__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/backup-audios': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Backup Audios
     * @description Access backup recordings associated with a session. If expiry is set, an access URL will be generated with the expiry time
     */
    get: operations['get_backup_audios_api_v2_ml_scribe_sessions__session_id__backup_audios_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/hardware-audio-transcription': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Transcribe Hardware Audio
     * @description Upload hardware device audio (MP3), transcribe immediately, return success.
     */
    post: operations['transcribe_hardware_audio_api_v2_ml_scribe_sessions__session_id__hardware_audio_transcription_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/restful-segment-transcription': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Restful Segment Transcription
     * @description Start Recording
     */
    post: operations['create_restful_segment_transcription_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/restful-segment-transcription/{recording_id}:transcribe': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Transcribe Segment Recording
     * @description Upload chunk audio file to generate transcript during recording
     */
    post: operations['transcribe_segment_recording_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/restful-segment-transcription/{recording_id}:finish': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Finish Restful Segment Transcription
     * @description Inform BE to finish recording
     */
    post: operations['finish_restful_segment_transcription_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription__recording_id__finish_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/restful-segment-transcription/transcribe-context': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Transcribe Context
     * @description GP dictates context. This API transcribe chunk by chunk. Transcript won't be saved to DB. It's returned as a string.
     */
    post: operations['transcribe_context_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription_transcribe_context_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Sessions
     * @description Search sessions with filters
     */
    get: operations['search_sessions_api_v2_ml_scribe_sessions_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Sessions
     * @description get all sessions v2
     */
    get: operations['get_sessions_api_v2_ml_scribe_sessions__get'];
    put?: never;
    /**
     * Create Session V2
     * @description create a new session (v2) that returns DetailedSessionView
     */
    post: operations['create_session_v2_api_v2_ml_scribe_sessions__post'];
    /**
     * Delete All Sessions For User
     * @description delete all sessions for a user
     */
    delete: operations['delete_all_sessions_for_user_api_v2_ml_scribe_sessions__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/status-count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Status Count
     * @description Get count of sessions by status
     */
    get: operations['get_session_status_count_api_v2_ml_scribe_sessions_status_count_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions:delete-empty': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Empty Sessions
     * @description delete all empty sessions for a user
     */
    delete: operations['delete_empty_sessions_api_v2_ml_scribe_sessions_delete_empty_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/upload-schedule': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Upload Session Schedule
     * @description Upload screenshot or CSV of daily schedule to bulk create upcoming sessions
     */
    post: operations['upload_session_schedule_api_v2_ml_scribe_sessions_upload_schedule_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Create Sessions
     * @description Bulk create upcoming sessions from a list of sessions
     */
    post: operations['bulk_create_sessions_api_v2_ml_scribe_sessions_batch_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/patient-context': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Extract Patient Context
     * @description Extract patient context information from session audio transcript
     */
    get: operations['extract_patient_context_api_v2_ml_scribe_sessions__session_id__patient_context_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/consult-note-timeline': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Consult Note Timeline
     * @description Get the consult note edit timeline based on session ID.
     */
    get: operations['get_session_consult_note_timeline_api_v2_ml_scribe_sessions__session_id__consult_note_timeline_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/permissions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Permissions
     * @description Get user's permissions for a specific session and its resources
     */
    get: operations['get_session_permissions_api_v2_ml_scribe_sessions__session_id__permissions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/upload-audios': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Uploaded Audio
     * @description Fetch all user uploaded audio files
     */
    get: operations['get_user_uploaded_audio_api_v2_ml_scribe_sessions__session_id__upload_audios_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/recordings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Recordings
     * @description Get recordings associated with a session, only user uploaded and backup is provided for now
     */
    get: operations['get_session_recordings_api_v2_ml_scribe_sessions__session_id__recordings_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/context-documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Context Documents
     * @description get session context documents
     */
    get: operations['get_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_get'];
    put?: never;
    /**
     * Upload Session Context Documents
     * @description upload session context documents
     */
    post: operations['upload_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_post'];
    /**
     * Delete Session Context Documents
     * @description delete session context documents
     */
    delete: operations['delete_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_delete'];
    options?: never;
    head?: never;
    /**
     * Update Session Context Documents
     * @description update session context documents
     */
    patch: operations['update_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/context-documents/{context_document_id}/file': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Context Document File
     * @description get the original uploaded file for a session context document
     */
    get: operations['get_session_context_document_file_api_v2_ml_scribe_sessions__session_id__context_documents__context_document_id__file_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/patient-documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Session Patient Document Links
     * @description List patient-uploaded documents currently linked to the session.
     */
    get: operations['list_session_patient_document_links_api_v2_ml_scribe_sessions__session_id__patient_documents_get'];
    put?: never;
    /**
     * Link Patient Documents To Session
     * @description Link one or more patient-uploaded documents to the session as note-gen context. Idempotent: re-linking an already-linked document is a no-op.
     */
    post: operations['link_patient_documents_to_session_api_v2_ml_scribe_sessions__session_id__patient_documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/patient-documents/{patient_document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Unlink Patient Document From Session
     * @description Soft-delete the link between this session and the given patient document. The underlying patient document is left untouched.
     */
    delete: operations['unlink_patient_document_from_session_api_v2_ml_scribe_sessions__session_id__patient_documents__patient_document_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/safety-issue-ticket': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Safety Issue Ticket Endpoint
     * @description Create an Intercom Quality Investigation ticket for a user-reported safety issue
     */
    post: operations['create_safety_issue_ticket_endpoint_api_v2_ml_scribe_sessions__session_id__safety_issue_ticket_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/dictate/live-dictation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Live Dictation
     * @description Generate the content of a document from live dictation.
     *
     *     This endpoint processes dictation text and generates structured document content
     *     using AI-powered language processing. The response is streamed as Server-Sent Events.
     *
     *     Args:
     *         scribe_session: Session and user information
     *         dictation_manager: Injected dictation manager instance
     *         body: Live dictation request containing the dictation text
     *
     *     Returns:
     *         StreamingResponse: Server-Sent Events stream with generated content
     *
     *     Raises:
     *         400: If dictation content is missing
     *         500: If content generation fails
     */
    post: operations['generate_live_dictation_api_v2_ml_scribe_sessions__session_id__dictate_live_dictation_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Feedback V2
     * @description Get latest feedbacks for a session by target type and target id
     */
    get: operations['get_feedback_v2_api_v2_ml_scribe_sessions__session_id__feedback_get'];
    put?: never;
    /**
     * Submit Feedback V2
     * @description Submit FeedbackV2 (thumb up/down) for AI-generated content
     */
    post: operations['submit_feedback_v2_api_v2_ml_scribe_sessions__session_id__feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/shares': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Shares
     * @description Get users who have direct sharing access to a session
     */
    get: operations['get_session_shares_api_v2_ml_scribe_sessions__session_id__shares_get'];
    put?: never;
    /**
     * Upsert Session Shares
     * @description Batch upsert session shares with users
     */
    post: operations['upsert_session_shares_api_v2_ml_scribe_sessions__session_id__shares_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/shares/{user_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Revoke Session Share
     * @description Revoke session share from a user
     */
    delete: operations['revoke_session_share_api_v2_ml_scribe_sessions__session_id__shares__user_ref_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/link-shares': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Link Shares
     * @description Get all link shares for a session
     */
    get: operations['get_link_shares_api_v2_ml_scribe_sessions__session_id__link_shares_get'];
    put?: never;
    /**
     * Add Link Share Recipients
     * @description Add link share recipients to a session
     */
    post: operations['add_link_share_recipients_api_v2_ml_scribe_sessions__session_id__link_shares_post'];
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Link Share Settings
     * @description Update session-level link share settings
     */
    patch: operations['update_link_share_settings_api_v2_ml_scribe_sessions__session_id__link_shares_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/link-shares/recipients/{share_token}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Revoke Link Share Recipient
     * @description Revoke a link share recipient
     */
    delete: operations['revoke_link_share_recipient_api_v2_ml_scribe_sessions__session_id__link_shares_recipients__share_token__delete'];
    options?: never;
    head?: never;
    /**
     * Update Link Share Recipient
     * @description Update an individual link share recipient
     */
    patch: operations['update_link_share_recipient_api_v2_ml_scribe_sessions__session_id__link_shares_recipients__share_token__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/link-shares:disable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Disable Link Sharing
     * @description Disable all link sharing for a session
     */
    post: operations['disable_link_sharing_api_v2_ml_scribe_sessions__session_id__link_shares_disable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/link-shares:enable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Enable Link Sharing
     * @description Re-enable link sharing for a session
     */
    post: operations['enable_link_sharing_api_v2_ml_scribe_sessions__session_id__link_shares_enable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/merged-sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Mergeable Sessions
     * @description List sessions the context session can be merged with
     */
    get: operations['get_mergeable_sessions_api_v2_ml_scribe_sessions__session_id__merged_sessions_get'];
    put?: never;
    /**
     * Merge Sessions
     * @description Group the given sessions under a single session group
     */
    post: operations['merge_sessions_api_v2_ml_scribe_sessions__session_id__merged_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/merged-sessions/patient-profile/{patient_profile_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link And Merge Sessions To Patient Profile
     * @description Link the session to a patient profile and merge same-timeframe sibling sessions
     */
    post: operations['link_and_merge_sessions_to_patient_profile_api_v2_ml_scribe_sessions__session_id__merged_sessions_patient_profile__patient_profile_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/merged-sessions:confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Confirm Patient Link Review
     * @description Confirm auto-linked patient after user review; sets patient_link_status to auto_linked
     */
    post: operations['confirm_patient_link_review_api_v2_ml_scribe_sessions__session_id__merged_sessions_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/merged-sessions:link': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link Merged Sessions
     * @description Add sessions to the merge group
     */
    post: operations['link_merged_sessions_api_v2_ml_scribe_sessions__session_id__merged_sessions_link_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/merged-sessions:unlink': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Unlink Merged Sessions
     * @description Unlink merged sessions from merge group
     */
    post: operations['unlink_merged_sessions_api_v2_ml_scribe_sessions__session_id__merged_sessions_unlink_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/merged-sessions:discard': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Discard Session Group Suggestion
     * @description Dismiss the merge suggestion for the context session; sets session_group_status to user_discarded
     */
    post: operations['discard_session_group_suggestion_api_v2_ml_scribe_sessions__session_id__merged_sessions_discard_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/shared/{share_token}:request-otp': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Request Otp
     * @description Validate share token and send OTP email to recipient.
     */
    post: operations['request_otp_api_v2_ml_scribe_sessions_shared__share_token__request_otp_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/shared/{share_token}:verify-otp': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Verify Otp
     * @description Verify OTP and return a short-lived share JWT.
     */
    post: operations['verify_otp_api_v2_ml_scribe_sessions_shared__share_token__verify_otp_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/shared/{share_token}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Link Shared Session
     * @description Return scoped session data for verified recipients.
     */
    get: operations['get_link_shared_session_api_v2_ml_scribe_sessions_shared__share_token__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/shared/{share_token}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Link Shared Documents
     * @description Return session documents for verified recipients.
     */
    get: operations['get_link_shared_documents_api_v2_ml_scribe_sessions_shared__share_token__documents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/entity-verification/analyze': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Analyze Session Note
     * @description Analyze a session's clinical note for entity verification.
     *
     *     This endpoint triggers a two-step LLM analysis:
     *     1. Extract clinical entities from the transcript
     *     2. Verify those entities against the generated clinical note
     *
     *     Returns verification results including:
     *     - Verified entities with accuracy matches
     *     - Potential hallucinations with severity levels
     *     - Summary statistics
     *
     *     The analysis is stored and can be retrieved via GET endpoint.
     */
    post: operations['analyze_session_note_api_v2_ml_scribe_sessions__session_id__entity_verification_analyze_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/entity-verification/auto-start': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start Auto Verification
     * @description Kick off an auto-mode entity verification run in the background.
     *
     *     Returns immediately with a ``pending`` analysis id. The FE is expected to
     *     poll GET /{session_id}/entity-verification/ until ``status`` becomes
     *     ``completed`` or ``failed``.
     *
     *     Idempotent: if a non-terminal analysis for this session already exists,
     *     it is returned as-is; no second run is scheduled.
     */
    post: operations['start_auto_verification_api_v2_ml_scribe_sessions__session_id__entity_verification_auto_start_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/entity-verification/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Analysis
     * @description Get the most recent entity verification analysis for a session.
     *
     *     Returns the analysis if found, or null if no analysis exists.
     */
    get: operations['get_session_analysis_api_v2_ml_scribe_sessions__session_id__entity_verification__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/entity-verification/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Entity Feedback
     * @description Get all entity verification feedback for a session's most recent analysis.
     *
     *     Returns a list of feedback records that can be used to hydrate
     *     the frontend's feedback state on page load.
     */
    get: operations['get_entity_feedback_api_v2_ml_scribe_sessions__session_id__entity_verification_feedback_get'];
    /**
     * Submit Entity Feedback
     * @description Submit or update feedback for a specific entity in an analysis.
     *
     *     This is an upsert operation keyed on (analysis_id, entity_source, entity_index).
     *     If feedback already exists for this entity, it will be updated.
     *     Otherwise, a new feedback record will be created.
     *
     *     The feedback record captures:
     *     - The user's rating (correct/incorrect)
     *     - Optional qualitative text feedback
     *     - A snapshot of the entity for RLHF training
     *     - The note generation model and original note from the consult note
     */
    put: operations['submit_entity_feedback_api_v2_ml_scribe_sessions__session_id__entity_verification_feedback_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/entity-verification/overall-feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Overall Feedback
     * @description Get overall verification feedback for a session.
     *
     *     When analysis_id is provided, returns feedback for that analysis when present.
     *     When omitted, returns the latest ENTITY_VERIFICATION feedback for the session.
     */
    get: operations['get_overall_feedback_api_v2_ml_scribe_sessions__session_id__entity_verification_overall_feedback_get'];
    /**
     * Submit Overall Feedback
     * @description Submit or update overall feedback for a verification run.
     *
     *     Uses the shared user_feedback collection with target_type=ENTITY_VERIFICATION.
     *     Upsert key: (session_id, ENTITY_VERIFICATION, target_id=analysis ObjectId).
     */
    put: operations['submit_overall_feedback_api_v2_ml_scribe_sessions__session_id__entity_verification_overall_feedback_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/verify-lite/analyze': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Analyze Session Note
     * @description Run the deterministic grounding check synchronously and return the result.
     */
    post: operations['analyze_session_note_api_v2_ml_scribe_sessions__session_id__verify_lite_analyze_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/verify-lite/auto-start': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start Auto Verify Lite
     * @description Kick off a background run; returns a ``pending`` id the FE polls on.
     *
     *     The run is in-process and not durable across a deploy or crash, so a poller
     *     must not treat ``pending`` as proof the run is still alive - see
     *     ``VerifyLiteService``'s module docstring.
     *
     *     Idempotent: if a non-terminal analysis for this session+note already
     *     exists, it is returned as-is; no second run is scheduled.
     */
    post: operations['start_auto_verify_lite_api_v2_ml_scribe_sessions__session_id__verify_lite_auto_start_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/verify-lite/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Analysis
     * @description Latest Verify Lite analysis for the session, or ``null`` if none.
     */
    get: operations['get_session_analysis_api_v2_ml_scribe_sessions__session_id__verify_lite__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/problems/stream': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Stream Session Problems
     * @description Stream problem extraction status via SSE
     */
    get: operations['stream_session_problems_api_v2_ml_scribe_sessions__session_id__problems_stream_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/problems': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Problems
     * @description Get extracted session problems for a session
     */
    get: operations['get_session_problems_api_v2_ml_scribe_sessions__session_id__problems_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/problems/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Confirm Session Problems
     * @description Confirm provider selections for session problems
     */
    post: operations['confirm_session_problems_api_v2_ml_scribe_sessions__session_id__problems_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/problems/push-codes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Push Codes To Ehr
     * @description Push diagnoses and new problems to the EHR
     */
    post: operations['push_codes_to_ehr_api_v2_ml_scribe_sessions__session_id__problems_push_codes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sessions/{session_id}/problems/regenerate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Regenerate Session Problems
     * @description Re-extract problems and codes from edited note content
     */
    post: operations['regenerate_session_problems_api_v2_ml_scribe_sessions__session_id__problems_regenerate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/snippets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get User Snippets */
    get: operations['get_user_snippets_api_v2_ml_scribe_snippets_get'];
    put?: never;
    /** Create User Snippet */
    post: operations['create_user_snippet_api_v2_ml_scribe_snippets_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/snippets/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create User Snippets Batch */
    post: operations['create_user_snippets_batch_api_v2_ml_scribe_snippets_batch_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/snippets/batch/upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload Snippets Csv */
    post: operations['upload_snippets_csv_api_v2_ml_scribe_snippets_batch_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/snippets/{snippet_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete User Snippet */
    delete: operations['delete_user_snippet_api_v2_ml_scribe_snippets__snippet_id__delete'];
    options?: never;
    head?: never;
    /** Update User Snippet */
    patch: operations['update_user_snippet_api_v2_ml_scribe_snippets__snippet_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/source-lists/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Source Lists
     * @description List all source lists accessible to the current user.
     *
     *     Args:
     *         unmigrated_only: If true, exclude source lists that have been
     *             migrated to unified collections. New FE uses this to avoid
     *             duplicates when also calling GET /collections.
     */
    get: operations['list_source_lists_api_v2_ml_scribe_source_lists__get'];
    put?: never;
    /**
     * Create Source List
     * @description Create a new source list.
     *
     *     Personal if team_id is omitted, team-visible if team_id is provided.
     */
    post: operations['create_source_list_api_v2_ml_scribe_source_lists__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/source-lists/{source_list_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Source List
     * @description Get a single source list by ID.
     */
    get: operations['get_source_list_api_v2_ml_scribe_source_lists__source_list_id__get'];
    /**
     * Update Source List
     * @description Update a source list.
     */
    put: operations['update_source_list_api_v2_ml_scribe_source_lists__source_list_id__put'];
    post?: never;
    /**
     * Delete Source List
     * @description Delete a source list (soft delete).
     */
    delete: operations['delete_source_list_api_v2_ml_scribe_source_lists__source_list_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/stand-alone-launch/authentication/endpoint': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Stand Alone Launch Authorize Endpoint */
    post: operations['get_stand_alone_launch_authorize_endpoint_api_v2_ml_scribe_stand_alone_launch_authentication_endpoint_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/stand-alone-launch/authentication/access-token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Exchange Stand Alone Launch Auth Code For Access Token */
    post: operations['exchange_stand_alone_launch_auth_code_for_access_token_api_v2_ml_scribe_stand_alone_launch_authentication_access_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/system-template': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Template
     * @description Create a new template.
     */
    post: operations['create_template_api_v2_ml_scribe_system_template_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/system-template/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /**
     * Update Template
     * @description Update an existing template
     */
    put: operations['update_template_api_v2_ml_scribe_system_template__template_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/system-template/by-tags': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Templates By Tags
     * @description Get templates by tags and experience modifiers with pagination and search.
     *
     *     This implements comprehensive tag-based template resolution logic where:
     *     - Templates are retrieved based on tag matching and experience modifiers
     *     - Experience modifiers (pinned, highlighted, featured, etc.) are applied
     *     - Templates are sorted by priority: pinned > highlighted > featured > regular
     *     - Results are paginated and can be filtered by search keyword
     */
    post: operations['get_templates_by_tags_api_v2_ml_scribe_system_template_by_tags_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/system-template/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Batch Delete Templates By Ids
     * @description Bulk delete multiple templates by their IDs.
     *
     *     Returns:
     *         - success_count: Number of templates successfully deleted
     *         - failed_count: Number of templates that failed to delete
     *         - failed_ids: List of template IDs that failed to delete
     *         - errors: List of error messages for failed deletions
     */
    delete: operations['batch_delete_templates_by_ids_api_v2_ml_scribe_system_template_batch_delete'];
    options?: never;
    head?: never;
    /**
     * Batch Update Templates By Ids
     * @description Batch update templates by their IDs with tag updates and field updates.
     *
     *     This endpoint allows updating tag connections and other fields for multiple templates at once.
     *     You can update any tag-related fields:
     *     - tags: Regular template tags
     *     - pinned_for_tags: Tags for which templates should be pinned
     *     - highlighted_for_tags: Tags for which templates should be highlighted
     *     - featured_for_tags: Tags for which templates are auto-generated
     *
     *     You can also update other fields like:
     *     - template_category: Template category
     *     - should_deduct_quota: Whether to deduct quota
     *
     *     Update types:
     *     - overwrite: Replace existing tags with new ones (default)
     *     - add: Preserve existing tags and add new ones
     *     - remove: Remove specified tags from templates without affecting other tags
     */
    patch: operations['batch_update_templates_by_ids_api_v2_ml_scribe_system_template_batch_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/system-template/{template_id}/versions/{version}/activate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Set Active Template Version
     * @description Set a specific version as active for a template.
     */
    patch: operations['set_active_template_version_api_v2_ml_scribe_system_template__template_id__versions__version__activate_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/system-template/bulk-create-template': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Create Template By Csv
     * @description create templates in bulk by csv, csv needs to have: template_id, template_name, template_content, specialty_ids, languages, tiers, countries, regions, template_category. Only template_name and template_content are required. Other fields are optional and should be comma-separated values (except template_category which should be a single value). template_category defaults to CONSULT_NOTE_TEMPLATE if not provided. If template with same name already exists, this api will still create a new template.
     */
    post: operations['bulk_create_template_by_csv_api_v2_ml_scribe_system_template_bulk_create_template_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/system-template/form-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Form System Template
     * @description Create a new FORM system template with PDF upload.
     *
     *     This endpoint allows internal admins to create system templates with form fields
     *     extracted from uploaded PDF files. The PDF is stored in a public S3 bucket.
     */
    post: operations['create_form_system_template_api_v2_ml_scribe_system_template_form_templates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Joined Teams
     * @description list joined teams
     */
    get: operations['list_joined_teams_api_v2_ml_scribe_teams__get'];
    put?: never;
    /**
     * Create Team
     * @description create new team
     */
    post: operations['create_team_api_v2_ml_scribe_teams__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Details
     * @description get team details
     */
    get: operations['get_team_details_api_v2_ml_scribe_teams__team_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team
     * @description update team
     */
    patch: operations['update_team_api_v2_ml_scribe_teams__team_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Members With Relationship
     * @description get team members with relationship
     */
    get: operations['get_team_members_with_relationship_api_v2_ml_scribe_teams__team_id__members_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/billing': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Billing Info
     * @description get team billing details
     */
    get: operations['get_team_billing_info_api_v2_ml_scribe_teams__team_id__billing_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/member/{member_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Team Member
     * @description delete team member
     */
    delete: operations['delete_team_member_api_v2_ml_scribe_teams__team_id__member__member_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/invitations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Invitation
     * @description invite team member
     */
    post: operations['create_invitation_api_v2_ml_scribe_teams__team_id__invitations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/invitations/{invitation_id}/resend': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Resend Invitation
     * @description resend a pending team invitation
     */
    post: operations['resend_invitation_api_v2_ml_scribe_teams__team_id__invitations__invitation_id__resend_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/invitations/accept': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Accept Invitation
     * @description accept invitation
     */
    post: operations['accept_invitation_api_v2_ml_scribe_teams__team_id__invitations_accept_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/mfa': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Mfa
     * @description enable/disable team MFA
     */
    patch: operations['update_team_mfa_api_v2_ml_scribe_teams__team_id__mfa_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/consent': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Consent
     * @description update team consent switcher
     */
    patch: operations['update_team_consent_api_v2_ml_scribe_teams__team_id__consent_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/review-confirmation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Review Confirmation
     * @description update team review confirmation requirement
     */
    patch: operations['update_team_review_confirmation_api_v2_ml_scribe_teams__team_id__review_confirmation_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/session-retention': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Session Retention
     * @description update team session retention settings
     */
    patch: operations['update_team_session_retention_api_v2_ml_scribe_teams__team_id__session_retention_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/patient-retention': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Patient Retention
     * @description update team patient retention settings
     */
    patch: operations['update_team_patient_retention_api_v2_ml_scribe_teams__team_id__patient_retention_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/transcript-retention': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Transcript Retention
     * @description update team transcript retention settings
     */
    patch: operations['update_team_transcript_retention_api_v2_ml_scribe_teams__team_id__transcript_retention_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/reset-and-delete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Reset And Delete Team
     * @description delete team and reset all team information (staging/dev only)
     */
    delete: operations['reset_and_delete_team_api_v2_ml_scribe_teams__team_id__reset_and_delete_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/analytics-dashboard': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Analytics Dashboard
     * @description get team analytics dashboard URL
     */
    get: operations['get_team_analytics_dashboard_api_v2_ml_scribe_teams__team_id__analytics_dashboard_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/request-evidence-access': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Request Evidence access (notify team admins)
     * @description Sends an evidence access request email to each administrator on the given team. The caller must be a non-admin member of that team.
     */
    post: operations['request_evidence_access_from_team_admins_api_v2_ml_scribe_teams__team_id__request_evidence_access_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/request-plan-upgrade': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Request plan upgrade (notify team admins)
     * @description Sends a plan upgrade request email to each administrator on the given team. The caller must be a non-admin member of that team.
     */
    post: operations['request_subscription_upgrade_from_team_admins_api_v2_ml_scribe_teams__team_id__request_plan_upgrade_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members/{member_id}/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Member Sessions
     * @description list team member sessions
     */
    get: operations['get_team_member_sessions_api_v2_ml_scribe_teams__team_id__members__member_id__sessions_get'];
    put?: never;
    /**
     * Create New Session For Team Member
     * @description create session for team member
     */
    post: operations['create_new_session_for_team_member_api_v2_ml_scribe_teams__team_id__members__member_id__sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members/{member_id}/sessions/status-count': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Member Session Status Count
     * @description Get count of sessions by status for a team member
     */
    get: operations['get_team_member_session_status_count_api_v2_ml_scribe_teams__team_id__members__member_id__sessions_status_count_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members/{member_id}/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Member Session By Id
     * @description get session by team member
     */
    get: operations['get_team_member_session_by_id_api_v2_ml_scribe_teams__team_id__members__member_id__sessions__session_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Team Member Session
     * @description update team member session
     */
    patch: operations['update_team_member_session_api_v2_ml_scribe_teams__team_id__members__member_id__sessions__session_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members/{member_id}/sessions/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bulk Create Sessions For Team Member
     * @description Bulk create upcoming sessions from a list of sessions for a team member
     */
    post: operations['bulk_create_sessions_for_team_member_api_v2_ml_scribe_teams__team_id__members__member_id__sessions_batch_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members/{member_id}/patient-profiles': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Patient Profiles For Team Member
     * @description list patient profiles for team member
     */
    get: operations['get_patient_profiles_for_team_member_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members/{member_id}/patient-profiles/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Patient Profile
     * @description create patient profile
     */
    post: operations['create_patient_profile_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members/{member_id}/patient-profiles/{patient_profile_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete Patient Profile
     * @description delete patient profile
     */
    delete: operations['delete_patient_profile_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__patient_profile_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Patient Profile
     * @description update patient profile
     */
    patch: operations['update_patient_profile_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__patient_profile_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/members/{member_id}/patient-profiles/{patient_profile_id}/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Link Patient Sessions
     * @description set linked sessions to patient profile
     */
    post: operations['link_patient_sessions_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__patient_profile_id__sessions_post'];
    /**
     * Unlink Patient Sessions
     * @description unlink sessions from patient profile
     */
    delete: operations['unlink_patient_sessions_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__patient_profile_id__sessions_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/seats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Team Seat Summary
     * @description get the team's seat usage summary
     */
    get: operations['get_team_seat_summary_api_v2_ml_scribe_teams__team_id__seats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/shortcuts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List team shortcuts
     * @description Return all non-deleted shortcuts owned by ``team_id``.
     *
     *     Any team member who can view the team may list shortcuts.
     */
    get: operations['list_team_shortcuts_api_v2_ml_scribe_teams__team_id__shortcuts_get'];
    put?: never;
    /**
     * Create a team shortcut
     * @description Create a new team shortcut. Requires team-edit permission.
     */
    post: operations['create_team_shortcut_api_v2_ml_scribe_teams__team_id__shortcuts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/teams/{team_id}/shortcuts/{shortcut_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete a team shortcut (soft delete)
     * @description Soft-delete a team shortcut. Requires team-edit permission.
     */
    delete: operations['delete_team_shortcut_api_v2_ml_scribe_teams__team_id__shortcuts__shortcut_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update a team shortcut
     * @description Patch an existing team shortcut. Requires team-edit permission.
     */
    patch: operations['update_team_shortcut_api_v2_ml_scribe_teams__team_id__shortcuts__shortcut_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/consult-note-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Consult Note Templates
     * @deprecated
     * @description Get templates for consult note generation.
     *
     *     If no token provided, specialty_id will be used in demo session.
     *     Both of user and specialty_id can be none: there's no specialty selected in demo.
     *
     *     paid user: return all templates (note structure + document),
     *     free user/unauthorized user: return note structure templates only
     *
     *     Returns:
     *         GetTemplatesResponseV2: templates for consult note gen
     */
    get: operations['list_consult_note_templates_api_v2_ml_scribe_templates_consult_note_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/document-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Document Templates
     * @description Get templates for document generation.
     *
     *     If no token provided, specialty_id will be used in demo session.
     *     Both of user and specialty_id can be none: there's no specialty selected in demo.
     *
     *     all users: return all templates (note structure + document).
     *
     *     Returns:
     *         GetTemplatesResponseV2: templates for consult note gen
     */
    get: operations['list_document_templates_api_v2_ml_scribe_templates_document_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/pinned': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Pinned Templates
     * @description Get all pinned templates for a user.
     *
     *     Returns a maximum of 5 pinned templates, sorted by most recently pinned.
     */
    get: operations['get_pinned_templates_api_v2_ml_scribe_templates_pinned_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/pinned/order': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update Pinned Template Order */
    put: operations['update_pinned_template_order_api_v2_ml_scribe_templates_pinned_order_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Templates
     * @description Search and list templates with advanced filtering, search, ordering, and pagination.
     *     Access is permission-based; users only see templates they are allowed to access.
     *     Global admins can see all templates in their organization.
     */
    get: operations['search_templates_api_v2_ml_scribe_templates_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/search/filter-metadata': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Search Filter Metadata
     * @description Get filter metadata for template search.
     *     This endpoint returns creator_user_id: creator_name and team_id: team_name mappings,
     *     used for template search filter,
     *     so FE can display the filter options in the search template page.
     */
    get: operations['get_search_filter_metadata_api_v2_ml_scribe_templates_search_filter_metadata_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/initial-pinned-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Initial Pinned Templates
     * @description Get initial pinned templates for a user based on their attributes/tags.
     *
     *     If authenticated, returns templates that would be auto-pinned based on user attributes.
     *     If unauthenticated, returns all active system templates (for onboarding).
     */
    get: operations['get_initial_pinned_templates_api_v2_ml_scribe_templates_initial_pinned_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/recommended-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Recommended Templates
     * @description Get recommended system templates for a specialty.
     *
     *     Queries `tags.specialty_ids` on system templates so results vary per specialty.
     *     Read-only — does not pin or favourite anything.
     *     Used during onboarding when the user profile is not yet persisted.
     */
    get: operations['get_recommended_templates_api_v2_ml_scribe_templates_recommended_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Template */
    get: operations['get_template_api_v2_ml_scribe_templates__template_id__get'];
    put?: never;
    post?: never;
    /** Mark Template Delete */
    delete: operations['mark_template_delete_api_v2_ml_scribe_templates__template_id__delete'];
    options?: never;
    head?: never;
    /** Update Template */
    patch: operations['update_template_api_v2_ml_scribe_templates__template_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/{template_id}/xml-source': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template Xml Source
     * @description XML sources are excluded from template list/detail responses to keep
     *     them lightweight; clients fetch the source here when they need it.
     */
    get: operations['get_template_xml_source_api_v2_ml_scribe_templates__template_id__xml_source_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/{template_id}/json-source': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Template Json Source
     * @description JSON sources are excluded from template list/detail responses.
     */
    get: operations['get_template_json_source_api_v2_ml_scribe_templates__template_id__json_source_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/system/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get System Template
     * @description Get a system template by ID.
     */
    get: operations['get_system_template_api_v2_ml_scribe_templates_system__template_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Templates
     * @deprecated
     * @description THIS ENDPOINT EXISTS FOR BACKWARD COMPATIBILITY ONLY.
     *     It is used in IOS mobile app versions pre v1.2.0.
     *     Avoid altering it as much as possible.
     */
    get: operations['list_templates_api_v2_ml_scribe_templates__get'];
    put?: never;
    /**
     * Create Template
     * @description Template can be created in a few different ways:
     *     1. user create a template from scratch
     *     2. user create a template from ai command
     *     3. user create a template from an existing document
     *     4. user create a template from an existing template in their library (heidi, user, team)
     *     5. user create a template via import from gallery
     *     6. user create a form template from a PDF file
     *     We use dedicated request type and process function for each of them, to extract data and create template
     *
     *     NOTE:
     *     - optional template_visibility can be provided to override default visibility
     *     - team template can be created by team admin via providing a team_id
     *     - leave team_id to null unless creating a team template
     */
    post: operations['create_template_api_v2_ml_scribe_templates__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/{template_id}/favour': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Template Favorite Status */
    post: operations['update_template_favorite_status_api_v2_ml_scribe_templates__template_id__favour_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/{template_id}/pin': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Template Pinned Status */
    post: operations['update_template_pinned_status_api_v2_ml_scribe_templates__template_id__pin_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/set-initial-pinned-templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Set Initial Pinned Templates
     * @description Set initial pinned templates for a user based on their attributes/tags.
     *
     *     This endpoint triggers the auto-pin system templates logic that was previously
     *     executed during user creation. It can be called to initialize or refresh
     *     pinned templates for a user.
     */
    post: operations['set_initial_pinned_templates_api_v2_ml_scribe_templates_set_initial_pinned_templates_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/share-email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Share Template Email
     * @description Send emails to share a template with multiple users.
     *
     *     This endpoint triggers Braze campaigns to send template sharing emails
     *     to the specified recipients with details about the shared template.
     *     Supports sending to 1-10 email addresses in a single request.
     */
    post: operations['send_share_template_email_api_v2_ml_scribe_templates_share_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/dictate/live-dictation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Live Dictation For Template Creation */
    post: operations['live_dictation_for_template_creation_api_v2_ml_scribe_templates_template_creation_record_dictate_live_dictation_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Template Creation Record */
    get: operations['get_template_creation_record_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update Template Creation Record */
    patch: operations['update_template_creation_record_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/template/{template_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Template Creation Record By Template Id */
    get: operations['get_template_creation_record_by_template_id_api_v2_ml_scribe_templates_template_creation_record_template__template_id__get'];
    put?: never;
    /** Create Template Creation Record By Template Id */
    post: operations['create_template_creation_record_by_template_id_api_v2_ml_scribe_templates_template_creation_record_template__template_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Template Creation Record */
    post: operations['create_template_creation_record_api_v2_ml_scribe_templates_template_creation_record_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/generate-initial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Initial Template Structure
     * @deprecated
     * @description **DEPRECATED**: Use POST /{template_creation_record_id}/version-control/{target_version_control_id}/generate-initial instead.
     */
    post: operations['generate_initial_template_structure_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__generate_initial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/version-control/{target_version_control_id}/generate-initial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Generate Initial Template Structure To Version Control */
    post: operations['generate_initial_template_structure_to_version_control_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control__target_version_control_id__generate_initial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/version-control/example-note/structure': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Template Version Control Via Example Note
     * @deprecated
     * @description **DEPRECATED**: This endpoint is not in use. Use alternative version control endpoints instead.
     */
    post: operations['create_template_version_control_via_example_note_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control_example_note_structure_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/{version_control_id}/example-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Generate Example Note */
    post: operations['generate_example_note_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id___version_control_id__example_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/version-control/{target_version_control_id}/chat/structure': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Template Version Control Via Chat */
    post: operations['update_template_version_control_via_chat_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control__target_version_control_id__chat_structure_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/version-control/{target_version_control_id}/chat/example-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Example Via Chat */
    post: operations['update_example_via_chat_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control__target_version_control_id__chat_example_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/version-control/structure': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Template Version Control Via Structure
     * @deprecated
     * @description **DEPRECATED**: This endpoint is not in use. Use alternative version control endpoints instead.
     */
    post: operations['create_template_version_control_via_structure_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control_structure_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/version-control/{target_version_control_id}/example-note/structure': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update Structure From Note */
    post: operations['update_structure_from_note_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control__target_version_control_id__example_note_structure_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/{template_creation_record_id}/version-control': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Latest Version Control
     * @description Create a latest version control for a template creation record.
     *
     *     This endpoint creates a new version control record without requiring a base version,
     *     allowing direct creation of version snapshots for template creation records.
     */
    post: operations['create_latest_version_control_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/suggestions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Template Suggestions */
    post: operations['get_template_suggestions_api_v2_ml_scribe_templates_template_creation_record_suggestions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/suggestions/public': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Public Template Suggestions
     * @description Get template suggestions without authentication.
     *     Used during onboarding when user is not yet logged in.
     */
    post: operations['get_public_template_suggestions_api_v2_ml_scribe_templates_template_creation_record_suggestions_public_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/generate/public': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Template Public
     * @description Generate a template without authentication.
     *     Used during onboarding when user is not yet logged in.
     *     Returns generated template name and structure without persisting to database.
     */
    post: operations['generate_template_public_api_v2_ml_scribe_templates_template_creation_record_generate_public_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/edit/public': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Edit Template Public
     * @description Edit a template without authentication.
     *     Used during onboarding when user is not yet logged in.
     *     Returns edited template structure without persisting to database.
     */
    post: operations['edit_template_public_api_v2_ml_scribe_templates_template_creation_record_edit_public_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/example-note/public': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Example Note Public
     * @description Generate an example note from a transcript and template without authentication.
     *     Used during onboarding when user is not yet logged in.
     *     Returns a filled-in note without persisting to database.
     */
    post: operations['generate_example_note_public_api_v2_ml_scribe_templates_template_creation_record_example_note_public_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/process-uploaded-document': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Process Uploaded Document */
    post: operations['process_uploaded_document_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/process-uploaded-document/public': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Process Uploaded Document Public
     * @description Process uploaded documents for onboarding users.
     *
     *     Validates the Kinde JWT but does not require a persisted User document — the
     *     Scribe User record is only created at the final onboarding step, so pre-signup
     *     users need to upload reference documents before that record exists. The JWT
     *     validation mirrors the companion WebSocket endpoint and prevents anonymous
     *     callers from consuming LLM resources.
     */
    post: operations['process_uploaded_document_public_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_public_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/template-creation-record/version-control/{version_control_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Template Version Control By Id */
    get: operations['get_template_version_control_by_id_api_v2_ml_scribe_templates_template_creation_record_version_control__version_control_id__get'];
    put?: never;
    post?: never;
    /** Delete Template Version Control */
    delete: operations['delete_template_version_control_api_v2_ml_scribe_templates_template_creation_record_version_control__version_control_id__delete'];
    options?: never;
    head?: never;
    /** Update Template Version Control */
    patch: operations['update_template_version_control_api_v2_ml_scribe_templates_template_creation_record_version_control__version_control_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/templates/shared': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Shared Template
     * @description Create a shared template record and return a short URL.
     *
     *     This endpoint copies the template data to a shared_templates collection
     *     and returns a short, URL-safe ID that can be used to access the template
     *     without authentication.
     */
    post: operations['create_shared_template_api_v2_ml_scribe_templates_shared_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/audio/upload-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Request Upload Url */
    post: operations['request_upload_url_api_v2_ml_scribe_translator_audio_upload_url_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/audio/{storage_id}/download-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Download Url */
    get: operations['get_download_url_api_v2_ml_scribe_translator_audio__storage_id__download_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/debug-events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Log Debug Event */
    post: operations['log_debug_event_api_v2_ml_scribe_translator_debug_events_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/languages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Languages */
    get: operations['list_languages_api_v2_ml_scribe_translator_languages_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Sessions */
    get: operations['list_sessions_api_v2_ml_scribe_translator_sessions_get'];
    put?: never;
    /** Create Session */
    post: operations['create_session_api_v2_ml_scribe_translator_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/sessions/{session_id}/evaluation-summary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Evaluation Summary */
    get: operations['get_evaluation_summary_api_v2_ml_scribe_translator_sessions__session_id__evaluation_summary_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/sessions/{session_id}/evaluation': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update Evaluation */
    patch: operations['update_evaluation_api_v2_ml_scribe_translator_sessions__session_id__evaluation_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/sessions/{session_id}/evaluation-export': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Export Evaluation */
    get: operations['export_evaluation_api_v2_ml_scribe_translator_sessions__session_id__evaluation_export_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/sessions/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Session */
    get: operations['get_session_api_v2_ml_scribe_translator_sessions__session_id__get'];
    put?: never;
    post?: never;
    /** Delete Session */
    delete: operations['delete_session_api_v2_ml_scribe_translator_sessions__session_id__delete'];
    options?: never;
    head?: never;
    /** Update Session */
    patch: operations['update_session_api_v2_ml_scribe_translator_sessions__session_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/sessions/{session_id}:onboarding-complete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Set Onboarding Complete */
    post: operations['set_onboarding_complete_api_v2_ml_scribe_translator_sessions__session_id__onboarding_complete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/sessions/{session_id}:track-bulk-upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Track Bulk Upload */
    post: operations['track_bulk_upload_api_v2_ml_scribe_translator_sessions__session_id__track_bulk_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/sessions/{session_id}/messages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Messages */
    get: operations['list_messages_api_v2_ml_scribe_translator_sessions__session_id__messages_get'];
    put?: never;
    /** Add Message */
    post: operations['add_message_api_v2_ml_scribe_translator_sessions__session_id__messages_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/messages/{message_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete Message */
    delete: operations['delete_message_api_v2_ml_scribe_translator_messages__message_id__delete'];
    options?: never;
    head?: never;
    /** Update Message */
    patch: operations['update_message_api_v2_ml_scribe_translator_messages__message_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/messages/{message_id}:submit-feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Submit Feedback */
    post: operations['submit_feedback_api_v2_ml_scribe_translator_messages__message_id__submit_feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/messages/{message_id}/feedback-errors': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Log Evaluation Error
     * @description Add one error to a message's evaluation log.
     *
     *     Send only the error being logged: the ones already in the log stay put, and
     *     each call is the single event behind ``translator_evaluation_error_logged``.
     */
    post: operations['log_evaluation_error_api_v2_ml_scribe_translator_messages__message_id__feedback_errors_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/messages/{message_id}/feedback-errors/{stage}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Remove Evaluation Error */
    delete: operations['remove_evaluation_error_api_v2_ml_scribe_translator_messages__message_id__feedback_errors__stage__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/messages/{message_id}:mark-autoplayed': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Mark Autoplayed */
    post: operations['mark_autoplayed_api_v2_ml_scribe_translator_messages__message_id__mark_autoplayed_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/messages/{message_id}:track-audio-playback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Track Audio Playback */
    post: operations['track_audio_playback_api_v2_ml_scribe_translator_messages__message_id__track_audio_playback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/translator/users/preferences': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Preferences */
    get: operations['get_preferences_api_v2_ml_scribe_translator_users_preferences_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update Preferences */
    patch: operations['update_preferences_api_v2_ml_scribe_translator_users_preferences_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/transcript-chips/suggest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate suggested Evidence queries from transcript
     * @description Generate suggested Evidence query chips based on transcript content.
     *
     *     This endpoint analyzes the provided transcript chunk and returns up to
     *     5 suggested queries that would help the clinician during the consultation.
     *
     *     The response includes:
     *     - chips: List of suggested query chips with labels and categories
     *     - has_update: Whether the suggestions changed from the previous call
     *     - chips_hash: Hash for client-side deduplication
     *
     *     Categories:
     *     - suggested_question: Questions to ask the patient
     *     - examination: Physical exam suggestions
     *     - investigation: Tests/investigations to consider
     *     - condition: Relevant conditions/diagnoses
     *     - symptom_exploration: Symptom-led differential and distinguishing features
     *     - plan: Treatment/management queries
     *     - red_flag: Safety-critical red flag queries
     *     - clinical_review: Clinical review and trajectory patterns
     */
    post: operations['suggest_chips_api_v2_ml_scribe_transcript_chips_suggest_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/transcript-chips/session/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Clear transcript chips context for a session
     * @description Clear the transcript chips context for a session.
     *
     *     Call this when the recording session ends to clean up resources.
     */
    delete: operations['clear_session_context_api_v2_ml_scribe_transcript_chips_session__session_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/transcript-chips/config': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Auto-Evidence configuration
     * @description Get the user's Auto-Evidence configuration.
     *
     *     Returns the current settings including:
     *     - enabled: Whether auto-evidence mode is on
     *     - enabled_categories: Which categories of suggestions to show
     *     - pinned_queries: Effective pinned queries (system defaults + user-defined
     *       personal pins)
     */
    get: operations['get_auto_evidence_config_api_v2_ml_scribe_transcript_chips_config_get'];
    /**
     * Update Auto-Evidence configuration
     * @description Update the user's Auto-Evidence configuration.
     *
     *     Supports partial updates - only provided fields will be updated.
     *     Returns the full updated configuration including merged effective
     *     pinned queries.
     */
    put: operations['update_auto_evidence_config_api_v2_ml_scribe_transcript_chips_config_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/usability-feedback/{feature}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit usability feedback
     * @description Submit UMUX-Lite feedback (ease + usefulness ratings + optional comment) for a feature.
     */
    post: operations['submit_usability_feedback_api_v2_ml_scribe_usability_feedback__feature__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/usability-feedback/{feature}/snooze': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Snooze usability feedback
     * @description Record that user clicked 'Maybe later' on the usability feedback nudge.
     */
    post: operations['snooze_usability_feedback_api_v2_ml_scribe_usability_feedback__feature__snooze_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/usage-entitlements/{metric_key}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get usage and limit for a single billable metric
     * @description Returns the authed user's current usage, limit, remaining quota, and over-limit status for the given `metric_key` over the current quota window. Identifier and subscription tier are derived from the authed user — callers cannot specify either. Pass `?scope=team` (team admins only) to receive the team total and a per-member breakdown alongside the caller's personal slice. Pass `?period=weekly|monthly` to choose the quota window. A capped user's window comes from their assigned limit's period; `?period=` is the uncapped fallback and defaults to `monthly`.
     */
    get: operations['get_usage_entitlement_api_v2_ml_scribe_usage_entitlements__metric_key__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/email-change/verify-current-email/request': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Verify Current Email Request
     * @description Send verification code to current email address
     */
    post: operations['verify_current_email_request_api_v2_ml_scribe_user_email_change_verify_current_email_request_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/email-change/verify-current-email/check': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Verify Current Email Check
     * @description Verify the code sent to current email address
     */
    post: operations['verify_current_email_check_api_v2_ml_scribe_user_email_change_verify_current_email_check_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/email-change/request': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Request Email Change
     * @description Request email change by sending verification code to new email
     */
    post: operations['request_email_change_api_v2_ml_scribe_user_email_change_request_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/email-change/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Confirm Email Change
     * @description Confirm email change with verification code
     */
    post: operations['confirm_email_change_api_v2_ml_scribe_user_email_change_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/gamify-trial-extension': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Gamify Trial Extension Progress
     * @description Get the user's gamify trial extension progress
     */
    get: operations['get_gamify_trial_extension_progress_api_v2_ml_scribe_user_gamify_trial_extension_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/gamify-trial-extension/record-template-selected': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record Template Selected
     * @description Record that the user selected a note template for the gamify trial extension
     */
    post: operations['record_template_selected_api_v2_ml_scribe_user_gamify_trial_extension_record_template_selected_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/gamify-trial-extension/record-source-control-used': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record Source Control Used
     * @description Record that the user used source control for the gamify trial extension
     */
    post: operations['record_source_control_used_api_v2_ml_scribe_user_gamify_trial_extension_record_source_control_used_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/ehr-profile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Ehr Profile */
    get: operations['get_ehr_profile_api_v2_ml_scribe_user_ehr_profile_get'];
    put?: never;
    /** Create Ehr Profile */
    post: operations['create_ehr_profile_api_v2_ml_scribe_user_ehr_profile_post'];
    /** Delete Ehr Profile */
    delete: operations['delete_ehr_profile_api_v2_ml_scribe_user_ehr_profile_delete'];
    options?: never;
    head?: never;
    /** Update Ehr Profile */
    patch: operations['update_ehr_profile_api_v2_ml_scribe_user_ehr_profile_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/user/linked-account': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User Linked Account
     * @description Get the authenticated user's linked EHR account from Open API integrations.
     *
     *     Returns the linked account details if the user has connected their Heidi account
     *     to an EHR system via an Open API integration partner.
     *
     *     Raises:
     *         HTTPException 404: If the user has no linked account
     */
    get: operations['get_user_linked_account_api_v2_ml_scribe_user_linked_account_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/self-onboard/joinable-teams': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Joinable Teams
     * @description Get all joinable teams based on user's SSO connection and group claims
     */
    get: operations['get_joinable_teams_api_v2_ml_scribe_user_self_onboard_joinable_teams_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/self-onboard/candidate-teams': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Joinable Teams
     * @description Get all candidate teams based on user's SSO connection and group claims
     */
    get: operations['get_joinable_teams_api_v2_ml_scribe_user_self_onboard_candidate_teams_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/self-onboard': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Self Onboard
     * @description Self-onboard for enterprise users with optional team joining and profile updates
     */
    post: operations['self_onboard_api_v2_ml_scribe_user_self_onboard_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/mfa': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update User Mfa */
    patch: operations['update_user_mfa_api_v2_ml_scribe_user_mfa_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/user/post-note-quality/tasks/{task_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Mark Post Note Quality Task Completed
     * @description Mark a post-note quality 'Improve your notes' task as completed. Idempotent — re-marking an already-completed task is a no-op.
     */
    patch: operations['mark_post_note_quality_task_completed_api_v2_ml_scribe_user_post_note_quality_tasks__task_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/user/post-note-quality:dismiss': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Dismiss Post Note Quality Panel
     * @description Permanently dismiss the post-note quality 'Improve your notes' panel. Idempotent — the original dismissal timestamp is preserved.
     */
    post: operations['dismiss_post_note_quality_panel_api_v2_ml_scribe_user_post_note_quality_dismiss_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/post-note-quality:mark-seen': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Mark Post Note Quality Panel Seen
     * @description Mark the post-note quality 'Improve your notes' panel as seen. Idempotent — drives the `first_view` analytics signal so only the user's first ever view reports first_view=true.
     */
    post: operations['mark_post_note_quality_panel_seen_api_v2_ml_scribe_user_post_note_quality_mark_seen_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/extend-reverse-trial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Extend Reverse Trial
     * @description Extend reverse trial period
     */
    post: operations['extend_reverse_trial_api_v2_ml_scribe_user_extend_reverse_trial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/revert-reverse-trial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Revert Reverse Trial
     * @description Revert reverse trial and return user to free tier
     */
    post: operations['revert_reverse_trial_api_v2_ml_scribe_user_revert_reverse_trial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/quota/clinical-code-auto-gen/reset': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Reset Clinical Code Auto Gen Quota
     * @description Reset clinical code auto-generation quota to default for current user
     */
    post: operations['reset_clinical_code_auto_gen_quota_api_v2_ml_scribe_user_quota_clinical_code_auto_gen_reset_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/session-revocation/logout-everywhere': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Logout Everywhere
     * @description Log out the calling user from all devices. Revokes Auth0 sessions and refresh tokens, and marks all access tokens issued before this call as invalid.
     */
    post: operations['logout_everywhere_api_v2_ml_scribe_user_session_revocation_logout_everywhere_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get User
     * @description get user
     */
    get: operations['get_user_api_v2_ml_scribe_user_get'];
    put?: never;
    /**
     * Create User
     * @description create user
     */
    post: operations['create_user_api_v2_ml_scribe_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/modal-view': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Record Modal View
     * @description Record that a user has seen a modal
     */
    post: operations['record_modal_view_api_v2_ml_scribe_user_modal_view_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user/auto-link-intent': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Auto Link Intent
     * @description Set the caller's auto-link-sessions intent flag. Bidirectional — send True to record opt-in, False to record opt-out. Modal-view recording remains an FE concern via POST /user/modal-view.
     */
    patch: operations['update_auto_link_intent_api_v2_ml_scribe_user_auto_link_intent_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/user/auto-extract-intent': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Auto Extract Intent
     * @description Set the caller's patient-context auto-extract intent flag. Bidirectional — send True to keep the post-session auto-extract popup, False to record an opt-out. Modal-view recording remains an FE concern via POST /user/modal-view.
     */
    patch: operations['update_auto_extract_intent_api_v2_ml_scribe_user_auto_extract_intent_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/user/session-timeout': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Disable Session Timeout
     * @description Disable the caller's session inactivity timeout. Clears any stored `session_timeout_info` and sets `session_timeout_disabled = True`, so the resolver returns `USER_DISABLED` (no enforcement) on subsequent reads. Refused with 409 when any organisation the caller belongs to has `session_timeout_info` set — the org override wins and the user cannot disable into something the org has set. Idempotent: calling DELETE on an already-disabled user still returns 204. To re-enable, call PATCH with a value; the PATCH endpoint clears the `disabled` flag automatically.
     */
    delete: operations['disable_session_timeout_api_v2_ml_scribe_user_session_timeout_delete'];
    options?: never;
    head?: never;
    /**
     * Set Session Timeout
     * @description Set the caller's per-user session inactivity timeout. The value is validated against the closed interval [1, 720] minutes server-side; out-of-range values return 422. The write is refused with 409 when any organisation the caller belongs to has set the timeout (org precedence applies and the user UI should render the input as read-only — see `is_editable_by_user` on `GET /user`). The response is the resolved `EffectiveSessionTimeout` after the write — which is `null` when the caller is out of cohort (Flagsmith flag off).
     */
    patch: operations['set_session_timeout_api_v2_ml_scribe_user_session_timeout_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/user/get-mobile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Get Mobile Email
     * @description Send an email to the user with a link to get Heidi for mobile
     */
    post: operations['send_get_mobile_email_api_v2_ml_scribe_user_get_mobile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user-activity/evidence': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get evidence usage stats for the current user
     * @description Return per-user evidence chat usage stats computed on the fly.
     *
     *     Counts are aggregated from the ``chat`` collection in a single pass and
     *     cover only non-deleted, evidence-mode chats owned by the authenticated
     *     user. Per-user-message session-linked query counts and totals of non-user
     *     (AI) message turns across all evidence chats are computed in that pass. This is
     *     intentionally different from the per-message
     *     ``EVIDENCE_CHAT_QUERY`` / ``EVIDENCE_SOURCE_CONTROL`` counters tracked
     *     elsewhere on ``UserActivityService``. CPD citation counts
     *     (``references_used``) come from the CPD ``cpd_source_appearances``
     *     collection, not the chat aggregation.
     */
    get: operations['get_evidence_usage_stats_api_v2_ml_scribe_user_activity_evidence_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/user-activity/team/{team_id}/evidence': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get aggregated evidence usage stats for a team (team admin only)
     * @description Return team-wide evidence usage stats computed on the fly.
     *
     *     Sums per-user-message counters across every joined team member's non-deleted,
     *     evidence-mode chats, including non-user (AI) message totals and CPD
     *     ``references_used`` across members. Caller must be an admin of ``team_id``.
     *
     *     Authorization is enforced by ``is_user_team_admin`` only — no separate
     *     team-existence probe runs first. Non-admins (including for non-existent
     *     team ids) get the same 403 so an authenticated caller cannot enumerate
     *     valid team ids by diffing 404 vs 403 responses.
     */
    get: operations['get_team_evidence_usage_stats_api_v2_ml_scribe_user_activity_team__team_id__evidence_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workspaces': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Workspaces
     * @description List the current user's workspaces.
     */
    get: operations['list_workspaces_api_v2_ml_scribe_workspaces_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workspaces/invitations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Workspace Invitations
     * @description List the current user's pending workspace invitations.
     */
    get: operations['list_workspace_invitations_api_v2_ml_scribe_workspaces_invitations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/workspaces/{workspace_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Workspace
     * @description Get workspace details with the teams that belong to it.
     */
    get: operations['get_workspace_api_v2_ml_scribe_workspaces__workspace_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/partner-content-sync/configuration': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Partner Upload Configuration
     * @description Return the authenticated partner's upload capabilities.
     */
    get: operations['get_partner_upload_configuration_api_v2_ml_scribe_integrations_partner_content_sync_configuration_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/partner-content-sync/upload-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Upload Url
     * @description Issue a short-lived presigned PUT URL bound to the partner's OWN key.
     *
     *     The browser uploads straight to S3 with this URL. The key is computed
     *     server-side from the partner's prefix and the presigned URL is bound to
     *     exactly that key, so a partner can only ever write inside their own prefix -
     *     the URL can't be repointed elsewhere. File type/size validation happens
     *     client-side before the PUT (the backend never sees the bytes); the ingester
     *     is the server-side backstop for anything malformed.
     */
    post: operations['create_upload_url_api_v2_ml_scribe_integrations_partner_content_sync_upload_url_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/partner-content-sync/sync': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Trigger Partner Sync
     * @description Sync the partner's whole prefix; call after the upload(s) finish.
     *
     *     ``plan`` re-lists the entire prefix, so this ingests every file currently
     *     there - which is exactly what makes a missed trigger self-healing (the next
     *     trigger sweeps up any orphaned upload). Concurrent triggers for the same
     *     scope coalesce into one run via the scope mutex, so it's always safe to call.
     */
    post: operations['trigger_partner_sync_api_v2_ml_scribe_integrations_partner_content_sync_sync_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/partner-content-sync/sync-jobs/{job_ref_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Sync Job */
    get: operations['get_sync_job_api_v2_ml_scribe_integrations_partner_content_sync_sync_jobs__job_ref_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/partner-content-sync/sync-jobs/{job_ref_id}/failed-tasks': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Sync Job Failures */
    get: operations['list_sync_job_failures_api_v2_ml_scribe_integrations_partner_content_sync_sync_jobs__job_ref_id__failed_tasks_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/integrations/partner-content-sync/sync-jobs/{job_ref_id}/retry': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Retry Sync Job */
    post: operations['retry_sync_job_api_v2_ml_scribe_integrations_partner_content_sync_sync_jobs__job_ref_id__retry_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/onboarding/guid': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search Guid
     * @deprecated
     * @description deprecated, use guid-matching instead. This was the old Best Practice Onboarding API
     */
    get: operations['search_guid_api_v2_ml_scribe_ehr_onboarding_guid_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/onboarding/guid-matching': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Search And Compare Guid */
    get: operations['search_and_compare_guid_api_v2_ml_scribe_ehr_onboarding_guid_matching_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/onboarding/bp-pair-site': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Pair Bp Site
     * @description Pair a Best Practice site using a pairing code (new Halo Connect onboarding flow).
     */
    get: operations['pair_bp_site_api_v2_ml_scribe_ehr_onboarding_bp_pair_site_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/onboarding/cliniko': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Cliniko Practitioner Details */
    get: operations['get_cliniko_practitioner_details_api_v2_ml_scribe_ehr_onboarding_cliniko_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/onboarding/pairing-code': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Magentus Tenant Id
     * @description Get the tenant ID from the pairing code.
     */
    get: operations['get_magentus_tenant_id_api_v2_ml_scribe_ehr_onboarding_pairing_code_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/onboarding/mindbody-site-access': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Check Mindbody Site Access
     * @description Check whether the given Mindbody site is accessible via the integration.
     *
     *     If the site is not accessible, return a link to activate the integration.
     */
    get: operations['check_mindbody_site_access_api_v2_ml_scribe_ehr_onboarding_mindbody_site_access_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Search Ehr Internal User By Name */
    get: operations['search_ehr_internal_user_by_name_api_v2_ml_scribe_ehr_users_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/users/v2': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Search Staff Endpoint */
    post: operations['search_staff_endpoint_api_v2_ml_scribe_ehr_users_v2_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/appointments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Search Appointments */
    get: operations['search_appointments_api_v2_ml_scribe_ehr_appointments_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/uploader/{session_id}/notes': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Sync Notes To Ehr */
    post: operations['sync_notes_to_ehr_api_v2_ml_scribe_ehr_uploader__session_id__notes_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/uploader/available-sections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Available Sections */
    get: operations['get_available_sections_api_v2_ml_scribe_ehr_uploader_available_sections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/uploader/available-standardized-sections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Available Standardized Sections */
    get: operations['get_available_standardized_sections_api_v2_ml_scribe_ehr_uploader_available_standardized_sections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/letter/templates': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Letter Templates */
    get: operations['list_letter_templates_api_v2_ml_scribe_ehr_letter_templates_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/ehr/letter/session/{session_id}/outgoing-correspondence': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Send Outgoing Correspondence With Letter Template */
    post: operations['send_outgoing_correspondence_with_letter_template_api_v2_ml_scribe_ehr_letter_session__session_id__outgoing_correspondence_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/hubspot-webhook': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Handle Hubspot Webhook
     * @description Receive and process HubSpot Closed Won deal events.
     */
    post: operations['handle_hubspot_webhook_api_v2_ml_scribe_hubspot_webhook_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/hubspot-webhook/deal-paid': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Handle Hubspot Deal Paid Webhook
     * @description Receive HubSpot deal_paid events and confirm the corresponding order.
     *
     *     On payment_status == "paid", look up the order by `hubspot-{deal_id}` and
     *     run the confirm flow (ERP submission + status transition). Non-paid events
     *     are silently ignored. Idempotent and tolerant of HubSpot redeliveries.
     */
    post: operations['handle_hubspot_deal_paid_webhook_api_v2_ml_scribe_hubspot_webhook_deal_paid_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/hubspot-webhook/smb-deal': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Handle Hubspot Deal Intake Webhook
     * @description Provision individual deals and record structurally consistent team deals.
     *
     *     Team deals are logged without line-item product validation or user, team,
     *     workspace, billing, or Stripe side effects. Individual redeliveries remain
     *     idempotent via Stripe metadata.
     */
    post: operations['handle_hubspot_deal_intake_webhook_api_v2_ml_scribe_hubspot_webhook_smb_deal_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/payments/checkout': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Checkout Session
     * @description create checkout session
     */
    post: operations['create_checkout_session_api_v2_ml_scribe_payments_checkout_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/payments/change-plan': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Change Subscribed Plan
     * @description upgrade or downgrade subscribed price
     */
    post: operations['change_subscribed_plan_api_v2_ml_scribe_payments_change_plan_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/payments/add-on-product/checkout/{add_on_product_internal_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Add On Checkout Session
     * @description add on product checkout API
     */
    post: operations['create_add_on_checkout_session_api_v2_ml_scribe_payments_add_on_product_checkout__add_on_product_internal_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/payments/add-on-product/{add_on_product_internal_id}/update-subscription': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Append Add On Product Subscription
     * @description update add on product subscription into existing subscription
     */
    post: operations['append_add_on_product_subscription_api_v2_ml_scribe_payments_add_on_product__add_on_product_internal_id__update_subscription_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/payments/activate-promoted-free-trial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Activate Promoted Free Trial
     * @description activate promoted free trial
     */
    post: operations['activate_promoted_free_trial_api_v2_ml_scribe_payments_activate_promoted_free_trial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/payments/deactivate-promoted-free-trial': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Deactivate Promoted Free Trial
     * @description deactivate promoted free trial
     */
    post: operations['deactivate_promoted_free_trial_api_v2_ml_scribe_payments_deactivate_promoted_free_trial_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/orders/draft': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Draft Order
     * @description Create a pre-payment guest checkout order draft.
     */
    post: operations['create_draft_order_api_v2_ml_scribe_orders_draft_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/orders/draft/{order_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Draft Order
     * @description Public, unauthenticated guest-checkout draft lookup by order ID. The unguessable order ID acts as the bearer token. Returns a safe summary (line items, normalized shipping, currency, status) for drafts in the pending-payment, paid, or payment-expired lifecycle; 404 for unknown IDs and for any order outside the guest-checkout draft flow.
     */
    get: operations['get_draft_order_api_v2_ml_scribe_orders_draft__order_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/orders/status/{erp_order_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Public Order Status
     * @description Public, unauthenticated order status lookup by ERP order ID. Returns 404 for unknown IDs and for orders that have not yet been confirmed in the ERP.
     */
    get: operations['get_public_order_status_api_v2_ml_scribe_orders_status__erp_order_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/products': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Products
     * @description get all products
     */
    get: operations['get_products_api_v2_ml_scribe_products_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v3/ml-scribe/products': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Products
     * @description Get the Heidi 2.0 Products
     */
    get: operations['get_products_api_v3_ml_scribe_products_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/products/add-on-products': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Add On Products
     * @description get add-on product details
     */
    get: operations['get_add_on_products_api_v2_ml_scribe_products_add_on_products_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/nav-graphs:lookup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Lookup Nav Graph
     * @description Return the curated navigation graph for the EHR matching ``term``.
     *
     *     ``term`` must be a clean bridge-reported app identity (frontmost app
     *     name, omnibox host, or process name) — normalizing a decorated window
     *     title is the caller's duty. The body is a ``{schemaVersion, graph}``
     *     envelope in the alias-only wire dialect; clients treat an unknown
     *     ``schemaVersion`` as fallback. Responses carry a strong ``ETag`` the
     *     client echoes via ``If-None-Match`` (RFC 7232 weak comparison) for a
     *     304. 404 means no curated graph exists: the desktop falls back, never
     *     invents navigation.
     */
    get: operations['lookup_nav_graph_api_v2_ml_scribe_rpa_nav_graphs_lookup_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/recordings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload Rpa Recording */
    post: operations['upload_rpa_recording_api_v2_ml_scribe_rpa_recordings_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/recordings/all-workflows': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Rpa Recording Workflows */
    get: operations['list_rpa_recording_workflows_api_v2_ml_scribe_rpa_recordings_all_workflows_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/recordings/{recording_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Rpa Recording Status */
    get: operations['get_rpa_recording_status_api_v2_ml_scribe_rpa_recordings__recording_id__get'];
    put?: never;
    post?: never;
    /** Delete Rpa Recording */
    delete: operations['delete_rpa_recording_api_v2_ml_scribe_rpa_recordings__recording_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/recordings-upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Initiate Rpa Recording Upload */
    post: operations['initiate_rpa_recording_upload_api_v2_ml_scribe_rpa_recordings_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/recordings-upload/{upload_id}/parts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Rpa Recording Part Urls */
    post: operations['create_rpa_recording_part_urls_api_v2_ml_scribe_rpa_recordings_upload__upload_id__parts_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/recordings-upload/{upload_id}:complete': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Complete Rpa Recording Upload */
    post: operations['complete_rpa_recording_upload_api_v2_ml_scribe_rpa_recordings_upload__upload_id__complete_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/desktop-targets/{instance_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Upsert Desktop Target */
    put: operations['upsert_desktop_target_api_v2_ml_scribe_rpa_desktop_targets__instance_id__put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/desktop-targets': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Desktop Targets */
    get: operations['list_desktop_targets_api_v2_ml_scribe_rpa_desktop_targets_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/desktop-targets/{target_id}/runs/{agent_run_id}:resolve': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Resolve Desktop Target Run */
    post: operations['resolve_desktop_target_run_api_v2_ml_scribe_rpa_desktop_targets__target_id__runs__agent_run_id__resolve_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/cua-cloud/machine': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Machine */
    get: operations['get_machine_api_v2_ml_scribe_rpa_cua_cloud_machine_get'];
    /** Ensure Machine */
    put: operations['ensure_machine_api_v2_ml_scribe_rpa_cua_cloud_machine_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/cua-cloud/machine:vnc-session': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create Vnc Session */
    post: operations['create_vnc_session_api_v2_ml_scribe_rpa_cua_cloud_machine_vnc_session_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/rpa/ax/assist': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Rpa Ax Assist
     * @description Single-shot LLM validation of a deterministic AX-tree decision.
     *
     *     Request payloads carry unredacted PHI — recorded decision in
     *     ``domains/rpa/ax_assist/AGENTS.md``. Residency/unavailability failures
     *     return 503; other LLM failures return 502 so the client falls back to its
     *     deterministic-only behaviour.
     */
    post: operations['rpa_ax_assist_api_v2_ml_scribe_rpa_ax_assist_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/sales-booking/{form_name}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Sales Booking Form
     * @description Submit a sales-booking form. ``form_name`` is a ``SalesBookingFormName`` value, validated by FastAPI against the server-side enum and mapped to a registered HubSpot form id and post-submit handler. The caller only supplies the form fields and optional HubSpot tracking context (hutk, page_uri, page_name); the portal id and form id are held server-side. Each form may run a pre-submit eligibility check (rejected as 400) and a post-submit side effect whose result is returned in ``result``. Unknown form names are rejected by FastAPI with 422 before reaching the handler.
     */
    post: operations['submit_sales_booking_form_api_v2_ml_scribe_sales_booking__form_name__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/kinde-webhook/authenticate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Kinde Authenticate
     * @description kinde sign-up or sign-in
     */
    post: operations['kinde_authenticate_api_v2_ml_scribe_kinde_webhook_authenticate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agent-memories': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agent Memories */
    get: operations['list_agent_memories_api_v2_ml_scribe_agent_memories_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/agent-memories/{memory_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Agent Memory */
    get: operations['get_agent_memory_api_v2_ml_scribe_agent_memories__memory_id__get'];
    put?: never;
    post?: never;
    /** Delete Agent Memory */
    delete: operations['delete_agent_memory_api_v2_ml_scribe_agent_memories__memory_id__delete'];
    options?: never;
    head?: never;
    /** Update Agent Memory */
    patch: operations['update_agent_memory_api_v2_ml_scribe_agent_memories__memory_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-summary-delivery/prepare': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Prepare Patient Summary Delivery
     * @description Prepare the v2 send-to-patient flow: validate inputs, generate a DOB-derived PDF password, and return the SMS body + clinician instructions the chat composer will pre-fill.
     */
    post: operations['prepare_patient_summary_delivery_api_v2_ml_scribe_patient_summary_delivery_prepare_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-summary-delivery/send': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Patient Summary Delivery
     * @description Re-validate inputs server-side, then drive SendSmsCallerWorkflow (Temporal -> Nexus -> comms -> Twilio). Returns the dispatch outcome inline so the FE can toast + close the confirm dialog.
     */
    post: operations['send_patient_summary_delivery_api_v2_ml_scribe_patient_summary_delivery_send_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-summary-delivery/send-email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Patient Summary Email
     * @description Render the patient-summary PDF and email the patient a secure download link (document name in the subject + body). Reuses the prepare pipeline (PDF + DOB password + short link). Returns the send outcome inline.
     */
    post: operations['send_patient_summary_email_api_v2_ml_scribe_patient_summary_delivery_send_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-summary-delivery/{document_id}/preview-pdf': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Preview Patient Summary Pdf
     * @description Render and stream the patient-summary PDF inline for the owning clinician's preview. Unencrypted (no password) because the caller is authenticated and is the document's author/sender; the patient-facing email link stays password-protected. Authorized against the document's session ownership.
     */
    get: operations['preview_patient_summary_pdf_api_v2_ml_scribe_patient_summary_delivery__document_id__preview_pdf_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-summary-delivery/note/{session_id}/preview-pdf': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Preview Patient Summary Note Pdf
     * @description Note-sourced sibling of ``/{document_id}/preview-pdf``: renders the session's consult note instead of a saved document. Same unencrypted-preview rationale, authorized against session ownership.
     */
    get: operations['preview_patient_summary_note_pdf_api_v2_ml_scribe_patient_summary_delivery_note__session_id__preview_pdf_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-summary-delivery/{document_id}/email-preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Preview Patient Summary Email
     * @description Render the patient email subject + plain-text body for the owning clinician's in-modal preview, localised to the request locale. Uses the same copy as the sent email (single source of truth); the link is a placeholder since no PDF is prepared just to preview. Authorized against the document's session ownership.
     */
    get: operations['preview_patient_summary_email_api_v2_ml_scribe_patient_summary_delivery__document_id__email_preview_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/patient-summary-delivery/note/{session_id}/email-preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Preview Patient Summary Note Email
     * @description Note-sourced sibling of ``/{document_id}/email-preview``: previews the email for a send of the session's consult note. Same copy and placeholder link, authorized against session ownership.
     */
    get: operations['preview_patient_summary_note_email_api_v2_ml_scribe_patient_summary_delivery_note__session_id__email_preview_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/airflow/trigger-enqueue': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Run Prechart
     * @description Kick off a queue tick and return immediately (AGE-1437).
     *
     *     The batch used to be awaited inline, holding the DAG's HTTP request open
     *     for the whole run — with the client timeout and the schedule interval both
     *     at 600s and batches running close to that, retries and overlap were
     *     routine. Idempotency against retried POSTs now lives in
     *     ``PrechartService.queue_precharts`` (Redis lock + processing-count guard),
     *     so ``queued_count`` in the response is always 0, mirroring
     *     ``trigger-enqueue-by-user``.
     */
    post: operations['run_prechart_api_v2_ml_scribe_prechart_airflow_trigger_enqueue_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/trigger-enqueue-by-user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Trigger Enqueue By User */
    post: operations['trigger_enqueue_by_user_api_v2_ml_scribe_prechart_trigger_enqueue_by_user_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/toggle-is-precharting-enabled': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Toggle Is Precharting Enabled */
    post: operations['toggle_is_precharting_enabled_api_v2_ml_scribe_prechart_toggle_is_precharting_enabled_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/is-precharting-enabled': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Is Precharting Enabled */
    get: operations['is_precharting_enabled_api_v2_ml_scribe_prechart_is_precharting_enabled_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/instructions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Prechart Instructions */
    get: operations['get_prechart_instructions_api_v2_ml_scribe_prechart_instructions_get'];
    /** Update Prechart Instructions */
    put: operations['update_prechart_instructions_api_v2_ml_scribe_prechart_instructions_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/instructions/edit': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Edit Prechart Instructions */
    post: operations['edit_prechart_instructions_api_v2_ml_scribe_prechart_instructions_edit_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/{session_id}/prechart': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Get Prechart */
    post: operations['get_prechart_api_v2_ml_scribe_prechart__session_id__prechart_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/{session_id}/generate-prechart-document': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Prechart Document
     * @description Generate a prechart for a session and create a PRECHART Document.
     *
     *     Returns the existing prechart document if one already exists.
     *     Otherwise generates content via ADK and creates a new Document.
     */
    post: operations['generate_prechart_document_api_v2_ml_scribe_prechart__session_id__generate_prechart_document_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/{session_id}/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Prechart Feedback
     * @description Forward a beta clinician's pre-chart thumbs feedback to Slack.
     *
     *     Fire-and-forget: the Slack post runs as a background task so the client gets
     *     an immediate ack and a Slack outage never fails the request.
     */
    post: operations['submit_prechart_feedback_api_v2_ml_scribe_prechart__session_id__feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/admin/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Prechart Admin Stats */
    get: operations['get_prechart_admin_stats_api_v2_ml_scribe_prechart_admin_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/admin/by-session/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Precharts By Session
     * @description Resolve a Heidi session id to its pre-chart runs, for debugging.
     *
     *     Read-only. The two generation endpoints trigger work, so there was previously no
     *     way to read the row, which left a Slack feedback alert (which carries only the
     *     session id) with no route to the Agent Engine run. Scheduled pre-charts are named
     *     after the Prechart row rather than the session, so a display-name lookup in the
     *     GCP console fails for exactly the runs clinicians report on.
     *
     *     Deliberately a tighter gate than the sibling ``/admin`` routes: those return
     *     aggregate counts, this returns per-patient identifiers for a caller-supplied
     *     session, so the ``prechart-internal-admin`` flag is not sufficient on its own.
     */
    get: operations['get_precharts_by_session_api_v2_ml_scribe_prechart_admin_by_session__session_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/prechart/admin/enable': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Enable Prechart For User */
    post: operations['enable_prechart_for_user_api_v2_ml_scribe_prechart_admin_enable_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/voice/health': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Voice Health
     * @description Lightweight capability probe for the frontend.
     */
    get: operations['voice_health_api_v2_ml_scribe_voice_health_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/voice/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit thumbs feedback for Talk to Heidi
     * @description Persist thumbs feedback via ``UserFeedbackService`` (``target_type=VOICE``).
     *
     *     When ``voice_session_id`` is set, ownership is checked against the caller's
     *     recorded sessions so a hand-crafted id cannot attribute feedback to someone
     *     else's conversation.
     */
    post: operations['submit_voice_feedback_api_v2_ml_scribe_voice_feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/voice/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Voice Sessions
     * @description The caller's recorded voice sessions, newest first.
     *
     *     ``before`` (a ``started_at`` upper bound) pages backwards through
     *     history without offsets.
     */
    get: operations['list_voice_sessions_api_v2_ml_scribe_voice_sessions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/voice/sessions/{voice_session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Voice Session
     * @description One session's *operational* timeline, ordered by ``seq``.
     *
     *     Conversation lines live as harness artifacts on the session's
     *     ``conversation_agent_run_id`` run, not here, so returned ``seq``
     *     values are a sparse subset of the timeline's seq space.
     *
     *     ``after_seq`` + ``limit`` cursor through long timelines; a page is full
     *     when ``len(events) == limit`` and the next page starts after the last
     *     returned ``seq``.
     */
    get: operations['get_voice_session_api_v2_ml_scribe_voice_sessions__voice_session_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create a new chat with generated title
     * @description Create a new chat and generate its title synchronously.
     *     Returns the chat_id and generated title immediately.
     *
     *     A chat can be linked to either a session_id OR a patient_profile_id (not both).
     */
    post: operations['create_chat_api_v2_ml_scribe_chat_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/{chat_id}/continue': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Continue a chat that has reached capacity
     * @description Create a new chat as a continuation of one that has reached document capacity.
     *
     *     Copies the last few messages from the source chat as seed context and
     *     links the new chat back via continued_from_chat_id.
     *
     *     Gated by ``release-evidence-chat-capacity-guard``.
     */
    post: operations['continue_chat_api_v2_ml_scribe_chat__chat_id__continue_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/migrate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Store chats from client localStorage after signup
     * @description Store chats that were saved in client localStorage while unauthenticated.
     *
     *     After signup, frontend can send chats from localStorage so they are saved
     *     against the new user ID. Requires authentication.
     *
     *     When the secure-migration flag is enabled (SEC-340), assistant messages
     *     must carry a valid ``message_mac`` HMAC signature.  User messages have
     *     their metadata stripped.
     */
    post: operations['store_chats_from_local_storage_api_v2_ml_scribe_chat_migrate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/attachments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Pre-upload a chat attachment
     * @description Pre-upload a single file for use in chat messages.
     *
     *     Upload files before sending the chat message to enable loading state UX.
     *     The returned attachment ID can be used in the /completions endpoint via the
     *     attachmentIds parameter.
     *
     *     Supported file types: JPEG, PNG, GIF, WebP, PDF
     *     Maximum file size: 10MB
     *
     *     Files not used within 24 hours are automatically deleted.
     */
    post: operations['upload_chat_attachment_api_v2_ml_scribe_chat_attachments_post'];
    /**
     * Delete a pre-uploaded attachment
     * @description Delete a pre-uploaded attachment before sending the message.
     *
     *     Use this when the user clicks 'x' on an attachment in the chat UI
     *     before sending their message.
     */
    delete: operations['delete_chat_attachment_api_v2_ml_scribe_chat_attachments_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/completions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Completions
     * @description Completions endpoint for Ask AI.
     *
     *     Supports optional file uploads:
     *     - Without files: Send as application/json with ChatRequest in body (backward compatible)
     *     - With files: Send as multipart/form-data with:
     *         - 'request': JSON string of ChatRequest
     *         - 'files': List of files to attach (can be multiple with same name 'files')
     *
     *     Args:
     *         request: FastAPI Request object
     *         user: Authenticated or temporary user
     *         chat_manager: Chat manager dependency
     */
    post: operations['completions_api_v2_ml_scribe_chat_completions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/chats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List user's chats
     * @description Get all chats for the authenticated or anonymous user.
     */
    get: operations['list_chats_api_v2_ml_scribe_chat_chats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/sessions/{session_id}/chats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List chats for a session
     * @description Get all chats linked to a specific session.
     *
     *     Returns chats that were created within or linked to the given session,
     *     ordered by creation date (newest first). Only returns chats owned by
     *     the requesting user.
     */
    get: operations['list_session_chats_api_v2_ml_scribe_chat_sessions__session_id__chats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/chats/search': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Search standalone chats
     * @description Search standalone chats (session_id is None) by user message content.
     */
    get: operations['search_standalone_chats_api_v2_ml_scribe_chat_chats_search_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/chats/saved': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List user's saved (starred) chats
     * @description Get all saved (starred) chats for the authenticated or anonymous user.
     */
    get: operations['list_saved_chats_api_v2_ml_scribe_chat_chats_saved_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/chats/{chat_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a specific chat
     * @description Get a specific chat by ID.
     *
     *     Returns the chat with optional context information:
     *     - If chat has session_id: includes session_context with session name and patient info
     *     - If chat has patient_profile_id: includes patient_context with patient details
     */
    get: operations['get_chat_api_v2_ml_scribe_chat_chats__chat_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Rename a chat
     * @description Rename a chat owned by the authenticated or anonymous user.
     */
    patch: operations['rename_chat_api_v2_ml_scribe_chat_chats__chat_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/chats/{chat_id}/save': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Save (star) a chat
     * @description Mark a chat as saved (starred) for the authenticated user.
     */
    post: operations['save_chat_api_v2_ml_scribe_chat_chats__chat_id__save_post'];
    /**
     * Unsave (unstar) a chat
     * @description Remove saved (starred) status from a chat for the authenticated user.
     */
    delete: operations['unsave_chat_api_v2_ml_scribe_chat_chats__chat_id__save_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/chats/bulk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Bulk delete chats
     * @description Bulk soft-delete multiple chats owned by the authenticated user.
     *
     *     Returns lists of successfully deleted and failed chat IDs.
     *     Chats that don't exist or aren't owned by the caller appear in the
     *     failed list — no error is raised for individual items.
     */
    delete: operations['bulk_delete_chats_api_v2_ml_scribe_chat_chats_bulk_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/{chat_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete a specific chat
     * @description Soft delete a chat owned by the authenticated or anonymous user.
     */
    delete: operations['delete_chat_api_v2_ml_scribe_chat__chat_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/sources': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get all available sources
     * @description Get all available medical web domain sources from the static JSON file.
     *     Returns a list of sources with domain, regions, website type, specialty, website name, and description.
     */
    get: operations['get_sources_api_v2_ml_scribe_chat_sources_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/blocked-domains': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get content-safety blocked domains
     * @description Return the content-safety denied domains.
     *
     *     The FE uses this to reject blocked domains/URLs inline when a clinician
     *     tries to add a source. The server (write-blocks) remains the source of
     *     truth; this is a UX convenience.
     *
     *     Gated behind the optional user/temp-user dependency (consistent with the
     *     sibling chat routes) so the curated harmful-domain list isn't served to
     *     anonymous scrapers.
     */
    get: operations['get_blocked_domains_api_v2_ml_scribe_chat_blocked_domains_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/jurisdictions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get jurisdiction options by country */
    get: operations['get_jurisdictions_api_v2_ml_scribe_chat_jurisdictions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/follow-up-questions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate follow-up questions for a chat
     * @description Generate contextual follow-up questions based on a chat conversation.
     *
     *     Uses Gemini 2.5 Flash to analyze the user's query and assistant's response,
     *     then suggests relevant follow-up questions the user might want to ask.
     *
     *     Cloud: always enabled (PostHog gate removed). On-prem: still reads the baked
     *     flag bundle so deployments can keep the endpoint off.
     *
     *     Security (SEC-304 follow-on):
     *     - Prompt injection checks run on both userQuery and assistantResponse.
     *     - When a valid chat exists in the database, the server-stored assistant
     *       response is used instead of the caller-supplied value (provenance).
     */
    post: operations['get_follow_up_questions_api_v2_ml_scribe_chat_follow_up_questions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/suggestions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get autocomplete suggestions for chat input
     * @description Generate autocomplete suggestions based on partial text input.
     *
     *     This endpoint provides suggestions for what the user might want to search,
     *     based on the text they've typed so far and their specialty context.
     *
     *     For context-aware follow-up questions after a conversation, use
     *     /follow-up-questions instead.
     */
    post: operations['get_suggestions_api_v2_ml_scribe_chat_suggestions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/personalized-suggestions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Personalized evidence suggestions from recent clinical context (experiment-gated)
     * @description Targeted suggestion starters informed by recent sessions and consult notes
     *     (GRO-2896). Rollout gated by PostHog ``exp-evidence-document-suggestion``;
     *     control users receive null ``suggestion`` / ``category`` / ``cta`` / ``title`` with no model call.
     *
     *     Uses the authenticated user's profile specialty and their 10 most recent sessions.
     *
     *     Returns at most one suggestion (top pick across categories) as a flat object with a
     *     short ``title`` headline, stable ``category`` slug, and short ``cta`` label (unlike ``POST /chat/suggestions``).
     */
    get: operations['personalized_evidence_suggestions_api_v2_ml_scribe_chat_personalized_suggestions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/document-export-suggestions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Experimental export CTA hint for one session document (PDF/Word, GRO-2885)
     * @description Returns PDF/Word export CTA copy and an inferred category slug for one document.
     *
     *     A single Gemini call produces category plus personalized headline and subcopy
     *     from truncated title, prompts, and body excerpt.
     *
     *     Gated by the export CTA PostHog flag; control users receive ``suggestion: null``.
     *     Handler name is prefixed with ``exp_`` for experiment visibility.
     */
    get: operations['exp_document_export_suggestions_api_v2_ml_scribe_chat_document_export_suggestions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/chats/{chat_id}/share': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Share an Evidence chat
     * @description Create a shareable link for an Evidence chat.
     *
     *     The share link never expires. Recipients opening the link get a full copy
     *     of the original chat that they can continue independently.
     *
     *     If the chat has already been shared, returns the existing share token.
     */
    post: operations['share_chat_api_v2_ml_scribe_chat_chats__chat_id__share_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/shared/{share_token}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a shared chat (creates a copy for recipient)
     * @description Fetch a shared chat by its share token.
     *
     *     By default, creates a full copy of the original chat for the recipient so they
     *     can view all messages and continue the conversation independently.
     *
     *     When create_copy=False, returns the chat data without creating a copy. This is
     *     used for cross-region access: the viewer's local backend doesn't hold the
     *     shared_chat record, so the frontend fetches from the origin region with
     *     create_copy=False, then posts the data to their local backend to create the copy.
     *
     *     Works for both authenticated and anonymous users.
     */
    get: operations['get_shared_chat_api_v2_ml_scribe_chat_shared__share_token__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/shared/{share_token}/copy': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create a local copy of a cross-region shared chat
     * @description Create a local copy of a shared chat from data fetched from the origin region.
     *
     *     Used for cross-region sharing: when the viewer's local region doesn't hold the
     *     shared_chat record, the frontend fetches the chat data from the origin (AU) with
     *     create_copy=False, then calls this endpoint to store the copy in their local region.
     *
     *     Authenticated users are deduplicated: if they've already opened the same link before,
     *     the existing copy is returned instead of creating another one.
     */
    post: operations['create_shared_chat_copy_api_v2_ml_scribe_chat_shared__share_token__copy_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/chat/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit feedback for Evidence chat
     * @description Submit feedback for Evidence (chat) responses.
     *
     *     This endpoint works for both sessionless and in-session chats:
     *     - For sessionless chats: Only chat_id is required, session_id is optional
     *     - For in-session chats: Both chat_id and session_id can be provided
     *
     *     The feedback is stored in the user_feedback collection with:
     *     - target_type: EVIDENCE
     *     - target_id: The chat ID (for linking feedback to specific chat)
     *     - session_id: Provided session_id, or empty string "" for sessionless chats
     *
     *     Note: The mode field in feedback should be the resolved mode ('legacy' or 'evidence'),
     *     not the original mode ('auto').
     */
    post: operations['submit_evidence_feedback_api_v2_ml_scribe_chat_feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List user documents
     * @description List all completed documents accessible to the current user.
     */
    get: operations['list_documents_api_v2_ml_scribe_evidence_user_documents_get'];
    put?: never;
    /**
     * Upload a document for embedding
     * @description Upload a document (PDF, DOCX, TXT, MD, ZIP, JPEG, or PNG) to be processed and embedded for search.
     */
    post: operations['upload_document_api_v2_ml_scribe_evidence_user_documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/jobs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List active jobs
     * @description List active (pending/processing/failed) ingestion jobs.
     */
    get: operations['list_jobs_api_v2_ml_scribe_evidence_user_documents_jobs_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/jobs/{job_id}/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get job processing status
     * @description Check the processing status of an upload job.
     */
    get: operations['get_job_status_api_v2_ml_scribe_evidence_user_documents_jobs__job_id__status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/jobs/{job_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete a job
     * @description Delete a job (any status) and any partial data.
     */
    delete: operations['delete_job_api_v2_ml_scribe_evidence_user_documents_jobs__job_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/jobs/{job_id}/retry': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Retry a failed job
     * @description Retry processing a failed job. Only works if the S3 file still exists.
     */
    post: operations['retry_job_api_v2_ml_scribe_evidence_user_documents_jobs__job_id__retry_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/all': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List documents and jobs
     * @description List both active jobs and completed documents for the modal UI.
     */
    get: operations['list_documents_and_jobs_api_v2_ml_scribe_evidence_user_documents_all_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/{document_id}/download-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get download URL
     * @description Generate a presigned S3 URL for downloading a document.
     */
    get: operations['get_download_url_api_v2_ml_scribe_evidence_user_documents__document_id__download_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/{document_id}/preview-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get inline preview URL (FDE-8)
     * @description Generate a presigned S3 URL with ``Content-Disposition: inline`` so browsers render the file in place (e.g. native PDF viewer) instead of downloading it. Used by the library-grounded chip source drawer to show where each suggestion came from.
     */
    get: operations['get_preview_url_api_v2_ml_scribe_evidence_user_documents__document_id__preview_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/{document_id}:share-email': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Share document via email
     * @description Share a document from the evidence library with a recipient via email.
     */
    post: operations['share_document_via_email_api_v2_ml_scribe_evidence_user_documents__document_id__share_email_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/user-documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Delete a document
     * @description Delete a document and all its embeddings.
     */
    delete: operations['delete_document_api_v2_ml_scribe_evidence_user_documents__document_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update document
     * @description Update a document's properties. Only provided fields will be updated.
     */
    patch: operations['update_document_api_v2_ml_scribe_evidence_user_documents__document_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/collections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List collections
     * @description List all collections accessible to the current user.
     */
    get: operations['list_collections_api_v2_ml_scribe_evidence_collections_get'];
    put?: never;
    /**
     * Create a collection
     * @description Create a new collection. Personal if team_id is omitted, team-visible if team_id is provided.
     */
    post: operations['create_collection_api_v2_ml_scribe_evidence_collections_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/collections/{collection_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get collection details
     * @description Get a collection with full details including document IDs.
     */
    get: operations['get_collection_api_v2_ml_scribe_evidence_collections__collection_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete collection
     * @description Delete a collection. Documents are not deleted.
     */
    delete: operations['delete_collection_api_v2_ml_scribe_evidence_collections__collection_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update collection
     * @description Update a collection's mutable fields. Supports renaming, editing description / icon, replacing domain filters, and promoting a personal collection to team scope by setting team_id (team-to-team transfers are not supported).
     */
    patch: operations['update_collection_api_v2_ml_scribe_evidence_collections__collection_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/collections/{collection_id}/documents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Add documents to collection
     * @description Add one or more documents to a collection.
     */
    post: operations['add_documents_api_v2_ml_scribe_evidence_collections__collection_id__documents_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/collections/{collection_id}/documents/{document_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Remove document from collection
     * @description Remove a document from a collection.
     */
    delete: operations['remove_document_api_v2_ml_scribe_evidence_collections__collection_id__documents__document_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/collections:import-source-list/{source_list_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Migrate a legacy source list into a unified collection
     * @description Migrates a single legacy source list into a unified collection. Idempotent: returns existing collection if already migrated.
     */
    post: operations['import_source_list_api_v2_ml_scribe_evidence_collections_import_source_list__source_list_id__post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/sharepoint/oauth/start': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Start Sharepoint Oauth Url
     * @description Start SharePoint OAuth setup and return Microsoft consent redirect URL.
     */
    get: operations['start_sharepoint_oauth_url_api_v2_ml_scribe_evidence_sharepoint_oauth_start_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/sharepoint/oauth/callback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Sharepoint Oauth Callback
     * @description Handle OAuth callback and exchange authorization code for delegated tokens.
     */
    get: operations['sharepoint_oauth_callback_api_v2_ml_scribe_evidence_sharepoint_oauth_callback_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/sharepoint/config': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Sharepoint Sync Config
     * @description Get persisted SharePoint sync configuration for the current team.
     */
    get: operations['get_sharepoint_sync_config_api_v2_ml_scribe_evidence_sharepoint_config_get'];
    put?: never;
    post?: never;
    /**
     * Delete Sharepoint Config
     * @description Delete team-level SharePoint setup configuration (disconnect).
     *
     *     Cascades to every SharePoint-derived row for the team — see
     *     ``SharepointIngestionService.disconnect_team`` for the full
     *     contract. In summary: setup tokens + sync config wiped, all
     *     SharePoint UserDocuments soft-deleted, embeddings hard-deleted,
     *     managed Collections hard-deleted. Prior to this contract a
     *     DELETE only wiped the setup row, leaving every previously-
     *     ingested document orphaned in the FE library.
     */
    delete: operations['delete_sharepoint_config_api_v2_ml_scribe_evidence_sharepoint_config_delete'];
    options?: never;
    head?: never;
    /**
     * Update Sharepoint Sync Config
     * @description Update enabled SharePoint sites/folders and refresh snapshot metadata.
     */
    patch: operations['update_sharepoint_sync_config_api_v2_ml_scribe_evidence_sharepoint_config_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/sharepoint/config:resync': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Resync Sharepoint Sync Config
     * @description Refresh document-count and sync-time snapshots for persisted selections.
     */
    post: operations['resync_sharepoint_sync_config_api_v2_ml_scribe_evidence_sharepoint_config_resync_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/sharepoint/sites': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Sharepoint Sites
     * @description List SharePoint sites accessible by team-level delegated token.
     */
    get: operations['list_sharepoint_sites_api_v2_ml_scribe_evidence_sharepoint_sites_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/sharepoint/site-contents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Sharepoint Site Contents
     * @description List root-level content in a selected SharePoint site's default drive.
     */
    get: operations['list_sharepoint_site_contents_api_v2_ml_scribe_evidence_sharepoint_site_contents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/sharepoint/site-folder-contents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Sharepoint Site Folder Contents
     * @description List content inside a folder under a selected SharePoint site's default drive.
     */
    get: operations['list_sharepoint_site_folder_contents_api_v2_ml_scribe_evidence_sharepoint_site_folder_contents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/sharepoint/site-file-content': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download Sharepoint Site File Content
     * @description Download file content by drive item id from a selected SharePoint site.
     */
    get: operations['download_sharepoint_site_file_content_api_v2_ml_scribe_evidence_sharepoint_site_file_content_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/source-recommendations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Source Recommendations
     * @description Get recommended evidence sources based on user's country and specialty.
     */
    get: operations['get_source_recommendations_api_v2_ml_scribe_evidence_source_recommendations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/source-recommendations/catalog': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Browse Source Catalog
     * @description Browse source catalog entries for Evidence Library selection.
     */
    get: operations['browse_source_catalog_api_v2_ml_scribe_evidence_source_recommendations_catalog_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/{session_id}/summary-suggestion': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Evidence Summary Suggestion
     * @description GRO-2767: Analyze note content for clinical signals and return scoring for evidence summary suggestion banner.
     */
    get: operations['get_evidence_summary_suggestion_api_v2_ml_scribe_evidence__session_id__summary_suggestion_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/integration-partners/{partner}/{content_id}/html': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Partner Html
     * @description Serve embeddable partner HTML through a Heidi-domain endpoint.
     */
    get: operations['get_partner_html_api_v2_ml_scribe_evidence_integration_partners__partner___content_id__html_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/integrations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Integrations
     * @description List available evidence integrations with availability status.
     */
    get: operations['get_integrations_api_v2_ml_scribe_evidence_integrations_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/feedback': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Submit Evidence general feedback
     * @description Submit general feedback (star rating and optional text) for the Evidence feature.
     */
    post: operations['create_evidence_feedback_api_v2_ml_scribe_evidence_feedback_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/feedback/snooze': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Snooze Evidence experience feedback
     * @description Record that user clicked 'Maybe later' on the experience feedback nudge.
     */
    post: operations['snooze_evidence_feedback_api_v2_ml_scribe_evidence_feedback_snooze_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence/healthpathways/setup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Setup HealthPathways zone
     * @description Resolve the user's postcode to a HealthPathways zone ID and store it. This is a one-time setup — subsequent evidence searches will use the stored zone_id automatically.
     */
    post: operations['setup_healthpathways_api_v2_ml_scribe_evidence_healthpathways_setup_post'];
    /**
     * Remove HealthPathways zone
     * @description Remove the user's HealthPathways zone configuration.
     */
    delete: operations['remove_healthpathways_api_v2_ml_scribe_evidence_healthpathways_setup_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence-referrals/g2-review-url': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get G2 Review Url
     * @description Generate a G2 Review Form URL for the current user.
     */
    get: operations['get_g2_review_url_api_v2_ml_scribe_evidence_referrals_g2_review_url_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence-referrals/link': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Referral Link
     * @description Generate or get the user's referral link.
     */
    post: operations['generate_referral_link_api_v2_ml_scribe_evidence_referrals_link_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence-referrals/my-referrals': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get My Referrals
     * @description Get the list of users referred by the current user.
     */
    get: operations['get_my_referrals_api_v2_ml_scribe_evidence_referrals_my_referrals_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence-referrals/stats': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get My Stats
     * @description Get the current user's leaderboard statistics.
     */
    get: operations['get_my_stats_api_v2_ml_scribe_evidence_referrals_stats_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/evidence-referrals/settings': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Leaderboard Settings
     * @description Update leaderboard settings (visibility preference).
     */
    patch: operations['update_leaderboard_settings_api_v2_ml_scribe_evidence_referrals_settings_patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/pdf-template-demo/fill-form-from-upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Fill public template from uploaded content
     * @description Processes one uploaded audio or document file and fills a public form template.
     *
     *     ### Client compliance requirement
     *     Before calling this endpoint, the frontend MUST obtain explicit user agreement to the Terms of Service and Privacy Policy. Do not submit clinical or identifying content unless the user has accepted those terms.
     */
    post: operations['fill_form_from_upload_api_v2_ml_scribe_pdf_template_demo_fill_form_from_upload_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/pdf-template-demo/fill-form': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Fill public template from transcript
     * @description Fills a public form template using a supplied transcript and form-field list.
     *
     *     ### Client compliance requirement
     *     Before calling this endpoint, the frontend MUST obtain explicit user agreement to the Terms of Service and Privacy Policy. Do not submit clinical or identifying content unless the user has accepted those terms.
     */
    post: operations['fill_form_api_v2_ml_scribe_pdf_template_demo_fill_form_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/referrals/referral-links': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Referral Link
     * @description create referral profile and link for the user. get the referral link if it already exists
     */
    post: operations['create_referral_link_api_v2_ml_scribe_referrals_referral_links_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/template-gallery/templates/likes/batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Batch Like Status
     * @description Get like status for multiple templates
     */
    get: operations['get_batch_like_status_api_v2_ml_scribe_template_gallery_templates_likes_batch_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/template-gallery/templates/{template_id}/like': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Like Status
     * @description Check if user has liked a template
     */
    get: operations['get_like_status_api_v2_ml_scribe_template_gallery_templates__template_id__like_get'];
    put?: never;
    /**
     * Like Template
     * @description Like a community template
     */
    post: operations['like_template_api_v2_ml_scribe_template_gallery_templates__template_id__like_post'];
    /**
     * Unlike Template
     * @description Unlike a community template
     */
    delete: operations['unlike_template_api_v2_ml_scribe_template_gallery_templates__template_id__like_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/argmax/v1/proxy': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Proxy Argmax SDK API request
     * @description Forwards Argmax SDK license API calls (e.g. license-token create/refresh) to api.argmaxinc.com. Mobile clients implement ApiRequestHandler / APIRequestHandler by POSTing the SDK request here instead of calling Argmax directly.
     */
    post: operations['proxy_argmax_request_api_v2_ml_scribe_argmax_v1_proxy_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Agents */
    get: operations['list_agents_api_v2_ml_scribe_calls_agents_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Agent
     * @description Return the call agent as-is without clinical-task prediction augmentation.
     */
    get: operations['get_agent_api_v2_ml_scribe_calls_agents__agent_id__get'];
    put?: never;
    post?: never;
    /** Delete Agent */
    delete: operations['delete_agent_api_v2_ml_scribe_calls_agents__agent_id__delete'];
    options?: never;
    head?: never;
    /** Update Agent */
    patch: operations['update_agent_api_v2_ml_scribe_calls_agents__agent_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/phone-number': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Purchase Agent Phone Number
     * @description Purchase and link an SMS-enabled number for a self-serve inbound agent.
     */
    post: operations['purchase_agent_phone_number_api_v2_ml_scribe_calls_agents__agent_id__phone_number_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/webrtc-token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Get Webrtc Token
     * @description Generate a Twilio WebRTC token for the Talk-to-Agent preview.
     */
    post: operations['get_webrtc_token_api_v2_ml_scribe_calls_agents__agent_id__webrtc_token_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/predicted-parameters': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Predicted Parameters */
    get: operations['get_predicted_parameters_api_v2_ml_scribe_calls_agents__agent_id__predicted_parameters_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/guardrails/check': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Check Guardrail
     * @description Pre-validate a single field against content-safety policies (v1).
     */
    post: operations['check_guardrail_api_v2_ml_scribe_calls_agents_guardrails_check_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/recompile': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Recompile Agent
     * @description Regenerate the agent's system_instruction via the prompt compiler and save it.
     */
    post: operations['recompile_agent_api_v2_ml_scribe_calls_agents__agent_id__recompile_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/v2/guardrails/check': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Check Guardrail V2
     * @description v2 pre-check for a single field. Returns the richer per-violation shape
     *     (``triggered_text`` + ``user_message``) so the FE can highlight the
     *     offending substring and render a category-aware message.
     */
    post: operations['check_guardrail_v2_api_v2_ml_scribe_calls_agents_v2_guardrails_check_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/v2/guardrails/check-batch': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Check Guardrail Batch V2
     * @description v2 batch pre-check — validate multiple fields in one round-trip so the
     *     FE can pre-flight a whole form before submit. Field-name allowlist + size
     *     caps are enforced upstream.
     */
    post: operations['check_guardrail_batch_v2_api_v2_ml_scribe_calls_agents_v2_guardrails_check_batch_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/commit': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Commit Agent */
    post: operations['commit_agent_api_v2_ml_scribe_calls_agents_commit_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/seed': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Seed Agents */
    post: operations['seed_agents_api_v2_ml_scribe_calls_agents_seed_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agent-builder/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Session
     * @description Create a new agent builder session for config editing.
     */
    post: operations['create_session_api_v2_ml_scribe_calls_agent_builder_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agent-builder/sessions/{session_id}/chat': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Chat Message
     * @description Send a chat message to an agent builder session.
     */
    post: operations['send_chat_message_api_v2_ml_scribe_calls_agent_builder_sessions__session_id__chat_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agent-builder/agents/{agent_config_id}/latest-session': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Latest Session
     * @description Get or resume the latest agent builder session for an agent.
     */
    get: operations['get_latest_session_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__latest_session_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agent-builder/agents/{agent_config_id}/scenarios/refresh': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Refresh Agent Scenarios
     * @description Regenerate scenarios for an agent from its config.
     */
    post: operations['refresh_agent_scenarios_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__scenarios_refresh_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agent-builder/agents/{agent_config_id}/qa/run': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Run Agent Qa
     * @description Run QA evaluation on an agent's scenarios.
     */
    post: operations['run_agent_qa_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__qa_run_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agent-builder/agents/{agent_config_id}/qa/runs/{run_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Agent Qa Run
     * @description Get full details of a QA run including per-scenario evaluations.
     */
    get: operations['get_agent_qa_run_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__qa_runs__run_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agent-builder/agents/{agent_config_id}/preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Agent Preview
     * @description Generate a preview conversation for an agent configuration.
     */
    post: operations['generate_agent_preview_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__preview_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/blocked-numbers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List blocked numbers */
    get: operations['list_blocked_numbers_api_v2_ml_scribe_calls_blocked_numbers_get'];
    put?: never;
    /** Block a phone number */
    post: operations['create_blocked_number_api_v2_ml_scribe_calls_blocked_numbers_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/blocked-numbers/check': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Check whether a phone number is blocked */
    get: operations['check_blocked_api_v2_ml_scribe_calls_blocked_numbers_check_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/blocked-numbers/bulk': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Block multiple phone numbers at once */
    post: operations['bulk_create_blocked_numbers_api_v2_ml_scribe_calls_blocked_numbers_bulk_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/blocked-numbers/{doc_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Unblock a phone number */
    delete: operations['delete_blocked_number_api_v2_ml_scribe_calls_blocked_numbers__doc_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/chat/agents/{agent_name}/greeting': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Greeting
     * @description Get the greeting message for a text chat agent.
     */
    get: operations['get_greeting_api_v2_ml_scribe_calls_chat_agents__agent_name__greeting_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/chat/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Session
     * @description Create a new text chat session.
     *
     *     Text chat is a PHI-free config preview tool — no patient data is
     *     collected or forwarded. The session is ephemeral and not tied to a
     *     real caller.
     */
    post: operations['create_session_api_v2_ml_scribe_calls_chat_sessions_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/chat/sessions/{session_id}/messages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Send Message
     * @description Send a message and stream the response as SSE.
     *
     *     Authentication is enforced here and forwarded to the upstream Calls
     *     service for audit attribution. Session-level access control is owned
     *     by the Calls service via session_id — it validates that the session
     *     exists and rejects unknown IDs. Text chat sessions are ephemeral
     *     previews with no PHI, so base URL routing remains unchanged.
     */
    post: operations['send_message_api_v2_ml_scribe_calls_chat_sessions__session_id__messages_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/appointment-types': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ehr Appointment Types
     * @description Get cached EHR appointment types for the authenticated user.
     */
    get: operations['get_ehr_appointment_types_api_v2_ml_scribe_calls_ehr_appointment_types_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/appointment-types/refresh': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Refresh Ehr Appointment Types
     * @description Refresh EHR appointment types from the EHR system and return updated types.
     */
    post: operations['refresh_ehr_appointment_types_api_v2_ml_scribe_calls_ehr_appointment_types_refresh_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/appointment-types/{ehr_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Appointment Type
     * @description Update appointment type properties (enabled status and/or additional info).
     */
    patch: operations['update_appointment_type_api_v2_ml_scribe_calls_ehr_appointment_types__ehr_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/clinicians': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ehr Clinicians
     * @description Get cached EHR clinicians for the user.
     */
    get: operations['get_ehr_clinicians_api_v2_ml_scribe_calls_ehr_clinicians_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/clinicians/refresh': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Refresh Ehr Clinicians
     * @description Refresh EHR clinicians from the EHR system and return updated clinicians.
     */
    post: operations['refresh_ehr_clinicians_api_v2_ml_scribe_calls_ehr_clinicians_refresh_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/clinicians/{ehr_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Clinician
     * @description Update clinician properties (enabled status and/or additional info).
     */
    patch: operations['update_clinician_api_v2_ml_scribe_calls_ehr_clinicians__ehr_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/clinics': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ehr Clinics
     * @description Get cached EHR clinics for the user.
     */
    get: operations['get_ehr_clinics_api_v2_ml_scribe_calls_ehr_clinics_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/clinics/refresh': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Refresh Ehr Clinics
     * @description Refresh EHR clinics from the EHR system and return updated clinics.
     */
    post: operations['refresh_ehr_clinics_api_v2_ml_scribe_calls_ehr_clinics_refresh_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/clinics/{ehr_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Clinic
     * @description Update clinic properties (enabled, additional info, and/or email override).
     */
    patch: operations['update_clinic_api_v2_ml_scribe_calls_ehr_clinics__ehr_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/ehr/credentials': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Ehr Credentials
     * @description Get credential for a user.
     */
    get: operations['get_ehr_credentials_api_v2_ml_scribe_calls_ehr_credentials_get'];
    put?: never;
    /**
     * Create Ehr Credentials
     * @description Create new EHR credentials for a user.
     */
    post: operations['create_ehr_credentials_api_v2_ml_scribe_calls_ehr_credentials_post'];
    /**
     * Delete Ehr Credentials
     * @description Delete user's EHR credential.
     */
    delete: operations['delete_ehr_credentials_api_v2_ml_scribe_calls_ehr_credentials_delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List conversations */
    get: operations['list_conversations_api_v2_ml_scribe_calls_inbox_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox/by-id/{patient_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get conversation detail */
    get: operations['get_conversation_detail_api_v2_ml_scribe_calls_inbox_by_id__patient_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox/calls/{session_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get voice call detail */
    get: operations['get_call_detail_api_v2_ml_scribe_calls_inbox_calls__session_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox/calls/{session_id}/translations/{language_code}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get or generate a call translation */
    get: operations['get_call_translation_api_v2_ml_scribe_calls_inbox_calls__session_id__translations__language_code__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox/{phone_number}/messages': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Send a message */
    post: operations['send_message_api_v2_ml_scribe_calls_inbox__phone_number__messages_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox/{phone_number}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update conversation status/mode */
    patch: operations['update_conversation_api_v2_ml_scribe_calls_inbox__phone_number__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox/{patient_id}/read': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Mark conversation as read */
    post: operations['mark_conversation_read_api_v2_ml_scribe_calls_inbox__patient_id__read_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox/{phone_number}/media': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload media attachment */
    post: operations['upload_media_api_v2_ml_scribe_calls_inbox__phone_number__media_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/inbox/ws/ticket': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Mint short-lived inbox WebSocket ticket */
    post: operations['mint_inbox_ws_ticket_http_api_v2_ml_scribe_calls_inbox_ws_ticket_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/patients': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List patients */
    get: operations['list_patients_api_v2_ml_scribe_calls_patients_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/patients/{patient_id}/appointments': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List appointments for a patient */
    get: operations['get_patient_appointments_api_v2_ml_scribe_calls_patients__patient_id__appointments_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/patients/{patient_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete a patient and their appointments */
    delete: operations['delete_patient_api_v2_ml_scribe_calls_patients__patient_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/patients/upload-csv': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload patient/appointment CSV */
    post: operations['upload_csv_api_v2_ml_scribe_calls_patients_upload_csv_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/reminders': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List reminder configurations */
    get: operations['list_reminder_configs_api_v2_ml_scribe_calls_reminders_get'];
    put?: never;
    /** Create a reminder configuration */
    post: operations['create_reminder_config_api_v2_ml_scribe_calls_reminders_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/reminders/{config_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update a reminder configuration */
    put: operations['update_reminder_config_api_v2_ml_scribe_calls_reminders__config_id__put'];
    post?: never;
    /** Delete a reminder configuration */
    delete: operations['delete_reminder_config_api_v2_ml_scribe_calls_reminders__config_id__delete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/reminders/{config_id}/toggle': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Toggle a reminder configuration on/off */
    put: operations['toggle_reminder_config_api_v2_ml_scribe_calls_reminders__config_id__toggle_put'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/reminders/appointments/{appointment_id}/retry': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Retry/send reminder for a specific appointment */
    post: operations['retry_reminder_api_v2_ml_scribe_calls_reminders_appointments__appointment_id__retry_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/reminders/process': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Manually trigger reminder processing */
    post: operations['process_reminders_api_v2_ml_scribe_calls_reminders_process_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/stats/operational/summary': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Operational Summary
     * @description ROI dashboard KPI cards. Forwards verbatim to Comms ``GET /stats/operational/summary``. ``user_id`` is always taken from the auth context — any client-supplied value is ignored.
     */
    get: operations['operational_summary_api_v2_ml_scribe_calls_stats_operational_summary_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/stats/operational/breakdowns': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Operational Breakdowns
     * @description ROI dashboard breakdowns: channel, outcome, type (coarse + granular flow), duration histogram, sentiment, CSAT, per-user, escalation reasons, failure-stage reasons. Forwards verbatim to Comms ``GET /stats/operational/breakdowns``.
     *
     *     Notes on overlapping fields (driven by Comms's ROI dashboard contract):
     *     - ``call_type_breakdown`` is the coarse 3-bucket view (``appointment_booking`` / ``general_information`` / ``other``).
     *     - ``flow_type_breakdown`` is the granular per-flow view (``book_appointment``, ``reschedule_appointment``, ``general_inquiry``, ``faq_handling``, ``cancel_appointment``, …) — preferred for the 'Call types' widget.
     *     - ``escalation_reasons`` covers calls where ``escalated_to_human=True`` (sums to ``escalation_breakdown.total_escalations``). Buckets are a mix of free-text caller-supplied reasons (e.g. 'billing', 'ask about a medication refill') and three slugs: ``caller_requested``, ``escalation_rule_triggered``, ``other``.
     *     - ``failure_stage_reasons`` covers any call with a ``failure_stage_reason`` set (escalated or not). Older Comms revisions returned the failure-stage data under ``escalation_reasons`` — this BFF passthrough surfaces whatever Comms ships.
     */
    get: operations['operational_breakdowns_api_v2_ml_scribe_calls_stats_operational_breakdowns_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/stats/operational/daily': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Operational Daily
     * @description ROI dashboard time-series: per-day call counts + KPIs. Forwards verbatim to Comms ``GET /stats/operational/daily``.
     */
    get: operations['operational_daily_api_v2_ml_scribe_calls_stats_operational_daily_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/stats/operational/flow': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Operational Flow
     * @description ROI dashboard funnel + flow tree. Forwards verbatim to Comms ``GET /stats/operational/flow``.
     */
    get: operations['operational_flow_api_v2_ml_scribe_calls_stats_operational_flow_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/stats/operational/tool-analysis': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Operational Tool Analysis
     * @description ROI dashboard tool sequence patterns + per-tool success rates. Forwards verbatim to Comms ``GET /stats/operational/tool-analysis``.
     */
    get: operations['operational_tool_analysis_api_v2_ml_scribe_calls_stats_operational_tool_analysis_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/stats/operational/calls': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Operational Calls
     * @description ROI dashboard drill-down: filtered call rows joined to sessions. Forwards verbatim to Comms ``POST /stats/operational/calls``. Optional JSON body carries the richer filter shape; standard query params (``days`` / ``start_date`` / ``end_date`` / ``channel`` / ``integration_filter``) are sent as query string.
     */
    post: operations['operational_calls_api_v2_ml_scribe_calls_stats_operational_calls_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/voices': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List the voice & language catalog
     * @description Return the curated catalog grouped by language (read-only).
     *
     *     Each entry carries the language code/name plus its enabled voices and
     *     runtime defaults, so the FE can render both the language selector and the
     *     per-language voice picker from a single call.
     */
    get: operations['list_voice_catalog_api_v2_ml_scribe_calls_voices_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/voices/preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Synthesise a short WAV preview for a voice
     * @description Return a short ``audio/wav`` sample for ``voice_id`` + ``language``.
     *
     *     Catalog membership is not required upstream — any catalog voice id can be
     *     previewed. Bad input (unsupported language/voice) surfaces as the upstream
     *     4xx; transport/synthesis failures collapse to 502.
     */
    post: operations['preview_voice_api_v2_ml_scribe_calls_voices_preview_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Calls
     * @description Get all calls for a given user
     */
    get: operations['get_calls_api_v2_ml_scribe_calls_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/create': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Call
     * @description Create a new call
     */
    post: operations['create_call_api_v2_ml_scribe_calls_create_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/bulk-create': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Create Calls
     * @description Bulk create calls
     */
    post: operations['create_calls_api_v2_ml_scribe_calls_bulk_create_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/by-reference/{call_reference_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Call By Reference Id
     * @description Retrieve a call by call_reference_id (comms join key)
     */
    get: operations['get_call_by_reference_id_api_v2_ml_scribe_calls_by_reference__call_reference_id__get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/{call_id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Call By Id
     * @description Retrieve a call
     */
    get: operations['get_call_by_id_api_v2_ml_scribe_calls__call_id__get'];
    put?: never;
    post?: never;
    /**
     * Delete Call
     * @description Delete a call. Purges PHI in ai-receptionist-be before removing the local Call document (fail-closed). Returns 502 when upstream purge fails; the call remains until purge succeeds and the client retries.
     */
    delete: operations['delete_call_api_v2_ml_scribe_calls__call_id__delete'];
    options?: never;
    head?: never;
    /**
     * Update Call
     * @description Update a call (e.g. read receipt)
     */
    patch: operations['update_call_api_v2_ml_scribe_calls__call_id__patch'];
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/webhook': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Update Webhook
     * @description Webhook endpoint for the call service
     */
    post: operations['update_webhook_api_v2_ml_scribe_calls_webhook_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/knowledge-base/generate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Knowledge Base From Url
     * @description Generate structured knowledge base from a clinic website.
     */
    post: operations['generate_knowledge_base_from_url_api_v2_ml_scribe_calls_knowledge_base_generate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/simulate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ml Scribe Calls Simulate Agent
     * @description Stream a self-serve simulation as SSE.
     *
     *     Pipes the receptionist's ``/self-serve/eval/agents/{agent_id}/simulate``
     *     SSE response straight back to the FE — each chunk is re-emitted without
     *     being parsed, so event-id / event-name / data framing is preserved.
     *
     *     Optional body is forwarded to the receptionist; today it carries a
     *     ``{"persona": ...}`` object selected from ``GET /scenarios``. When
     *     absent the upstream falls back to the canned happy-path persona.
     */
    post: operations['ml_scribe_calls_simulate_agent_api_v2_ml_scribe_calls_agents__agent_id__simulate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/runs/last': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Ml Scribe Calls Get Last Agent Simulation Run
     * @description Return the most-recent persisted simulator run for ``(user, agent, persona)``.
     *
     *     Used by the FE to rehydrate the test transcript when the user
     *     navigates back to the test tab. Returns ``null`` when nothing
     *     exists yet — matches the receptionist's ``LastRunResponse | None``
     *     response model so FastAPI doesn't 500 on the empty case.
     */
    get: operations['ml_scribe_calls_get_last_agent_simulation_run_api_v2_ml_scribe_calls_agents__agent_id__runs_last_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/scenarios/regenerate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ml Scribe Calls Regenerate Agent Scenarios
     * @description Force an LLM-driven scenarios regenerate; overwrites the cache.
     *
     *     Proxies the receptionist's
     *     ``POST /self-serve/eval/agents/{id}/scenarios/regenerate``.
     *     Synchronous (~2-5s). FE uses this when the user clicks Generate or
     *     Regenerate from the scenarios panel.
     */
    post: operations['ml_scribe_calls_regenerate_agent_scenarios_api_v2_ml_scribe_calls_agents__agent_id__scenarios_regenerate_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/scenarios/custom': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ml Scribe Calls Add Custom Agent Scenario
     * @description Append a user-authored persona to the cached scenarios list.
     *
     *     Proxies the receptionist's
     *     ``POST /self-serve/eval/agents/{id}/scenarios/custom``.
     */
    post: operations['ml_scribe_calls_add_custom_agent_scenario_api_v2_ml_scribe_calls_agents__agent_id__scenarios_custom_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/agents/{agent_id}/scenarios': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Ml Scribe Calls List Agent Scenarios
     * @description List candidate caller scenarios (personas) for the agent.
     *
     *     Proxies the receptionist's ``GET /self-serve/eval/agents/{id}/scenarios``.
     *     Synchronous (~2-5s for one Gemini call). Each entry is a persona
     *     with ``{name, goal, style_prompt, success_criteria, category}`` —
     *     pass the chosen persona back as the body of ``POST /simulate``.
     */
    get: operations['ml_scribe_calls_list_agent_scenarios_api_v2_ml_scribe_calls_agents__agent_id__scenarios_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/calls/knowledge-base/search-clinics': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Search Clinics By Name
     * @description Search web for clinics by name and return structured results.
     */
    post: operations['search_clinics_by_name_api_v2_ml_scribe_calls_knowledge_base_search_clinics_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/comms/objectives/config-learning/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Config-learning status: cursor + pending gaps + active preview */
    get: operations['get_config_learning_status_api_v2_ml_scribe_comms_objectives_config_learning_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/comms/objectives/config-learning/scan': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Run a config-learning scan across the user's agents */
    post: operations['run_config_learning_scan_api_v2_ml_scribe_comms_objectives_config_learning_scan_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/comms/objectives/config-learning/preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Preview answers / dismissals (LLM rewrite + guardrails) */
    post: operations['preview_config_learning_api_v2_ml_scribe_comms_objectives_config_learning_preview_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/comms/objectives/config-learning/apply': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Apply staged previews to each agent's config */
    post: operations['apply_config_learning_api_v2_ml_scribe_comms_objectives_config_learning_apply_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/comms/objectives/config-learning/preview/discard': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Discard any active config-learning preview staging for the user */
    post: operations['discard_config_learning_preview_api_v2_ml_scribe_comms_objectives_config_learning_preview_discard_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/comms/objectives/config-learning/dismiss': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Dismiss surfaced gaps without staging a rewrite */
    post: operations['dismiss_config_learning_gaps_api_v2_ml_scribe_comms_objectives_config_learning_dismiss_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/telehealth/calls': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Bootstrap Telehealth Call
     * @description Bootstrap a mobile telehealth call: return a short-lived Telnyx WebRTC JWT for the mobile SDK and a client_state the app attaches to the SDK dial. Requires a session_id linking the call to a Heidi session (every telehealth call is session-linked). Returns 409 when the user has no verified caller number yet (route them to the verify-number flow) and 404 when the session does not exist or is not the caller's.
     */
    post: operations['bootstrap_telehealth_call_api_v2_ml_scribe_telehealth_calls_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/telehealth/recordings/ingest': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Ingest Telehealth Recording
     * @description Comms-facing webhook (X-Api-Key, not Heidi bearer): ingest a finished telehealth call recording onto its linked session. The file is copied into the standard user-upload location and registered as USER_UPLOAD audio, so the existing lazy transcription pipeline produces the transcript and note. Idempotent per telehealth_call_id (retries get already_ingested). 404 when the session does not exist or is not owned by the claimed user; 403 when the recording's source_region does not match this cell (terminal, do not retry); 413 when the recording exceeds the ingest size cap and 422 when recording_url is not an S3 endpoint (both terminal); 502 on transient download/storage failures or while another delivery is in progress (comms retries).
     */
    post: operations['ingest_telehealth_recording_api_v2_ml_scribe_telehealth_recordings_ingest_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/telehealth/verify-number/start': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start Number Verification
     * @description Send a one-time code (voice call or SMS) to a clinic number so it can be verified as the outbound telehealth caller ID.
     */
    post: operations['start_number_verification_api_v2_ml_scribe_telehealth_verify_number_start_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/telehealth/verify-number/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Confirm Number Verification
     * @description Submit the one-time code to complete caller-ID verification.
     */
    post: operations['confirm_number_verification_api_v2_ml_scribe_telehealth_verify_number_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/telehealth/verified-numbers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Verified Numbers
     * @description List the clinic's verified telehealth caller-ID numbers.
     */
    get: operations['list_verified_numbers_api_v2_ml_scribe_telehealth_verified_numbers_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/hcp-verifications:lookup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Lookup Hcp Verification
     * @description Preview what a registry holds for an identifier without persisting anything.
     */
    post: operations['lookup_hcp_verification_api_v2_ml_scribe_hcp_verifications_lookup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/hcp-verifications': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Hcp Verifications
     * @description The caller's own current verification records, one per registry.
     *
     *     Scoped by the token's ``user_ref_id`` with no way to name another user, and
     *     empty rather than 404 when the caller has never verified.
     */
    get: operations['list_hcp_verifications_api_v2_ml_scribe_hcp_verifications_get'];
    put?: never;
    /**
     * Confirm Hcp Verification
     * @description Re-look up an identifier and persist the user's attestation that it is theirs.
     */
    post: operations['confirm_hcp_verification_api_v2_ml_scribe_hcp_verifications_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/hcp-verifications:request-review': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Request Hcp Review
     * @description Raise a review case the user cannot resolve through self-service.
     */
    post: operations['request_hcp_review_api_v2_ml_scribe_hcp_verifications_request_review_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/hcp-verifications:status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Hcp Verification Status
     * @description The caller's own records ranked into the one status the badge renders.
     *
     *     Same owner as the full read-back, and a null status rather than 404 when
     *     the caller has never verified. Carries no registry or record field, so a
     *     chrome fetch does not either.
     *
     *     Also the trigger for the daily "verify your clinician profile" inmail: the
     *     clients call this on every load, so the first eligible call of a UTC day
     *     writes today's reminder. The write is a side effect the reminder's own
     *     idempotency bounds; it never changes the returned status. A send failure
     *     is the same catalogued verification error as every other route here.
     */
    get: operations['get_hcp_verification_status_api_v2_ml_scribe_hcp_verifications_status_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/ask-ai': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Ask Ai */
    post: operations['ask_ai_api_v2_1_ml_scribe_sessions__session_id__ask_ai_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/consult-note/ai-commands': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Note Gen Ai Commands V2 */
    get: operations['list_note_gen_ai_commands_v2_api_v2_1_ml_scribe_sessions__session_id__consult_note_ai_commands_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/consult-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Consult Note
     * @description Generate a consult note for the session
     */
    post: operations['generate_consult_note_api_v2_1_ml_scribe_sessions__session_id__consult_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/consult-note/{note_id}/regenerate': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Regenerate Consult Note
     * @description Regenerate a consult note based on the note ID
     */
    get: operations['regenerate_consult_note_api_v2_1_ml_scribe_sessions__session_id__consult_note__note_id__regenerate_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/consult-note/{consult_note_id}/sectional-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Sectional Note
     * @description generate a session sectional note by either consult note
     */
    post: operations['generate_sectional_note_api_v2_1_ml_scribe_sessions__session_id__consult_note__consult_note_id__sectional_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/consult-note/stop': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Stop Consult Note Generation
     * @description stop a session consult note generation
     */
    post: operations['stop_consult_note_generation_api_v2_1_ml_scribe_sessions__session_id__consult_note_stop_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/consult-note/generate-insights': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Insights
     * @description generate insights for the latest consult note
     */
    post: operations['generate_insights_api_v2_1_ml_scribe_sessions__session_id__consult_note_generate_insights_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/consult-note/sectional-note-conversion': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Convert Plain Text Note To Sectional Note
     * @description Convert plain text note to sectional note (JSON format) using LLM service.
     *     This endpoint first generates a plain text note, then converts it to JSON sectional format.
     */
    post: operations['convert_plain_text_note_to_sectional_note_api_v2_1_ml_scribe_sessions__session_id__consult_note_sectional_note_conversion_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/consult-note/generate-markdown-or-sectional-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Markdown Or Sectional Note
     * @description Generate a consult note. For legacy-JSON-flow sectional-sync integrated sessions, the generated note is converted to a structured sectional note and returned as JSON; otherwise the markdown note is streamed as SSE. The client must branch on the response Content-Type.
     */
    post: operations['generate_markdown_or_sectional_note_api_v2_1_ml_scribe_sessions__session_id__consult_note_generate_markdown_or_sectional_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/documents/ai-commands': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List Document Suggested Ai Commands V2 */
    get: operations['list_document_suggested_ai_commands_v2_api_v2_1_ml_scribe_sessions__session_id__documents_ai_commands_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/documents/{document_id}/content': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Document Content
     * @description generate the content of a document. if body is none, fetch the generation details from the document
     */
    post: operations['generate_document_content_api_v2_1_ml_scribe_sessions__session_id__documents__document_id__content_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/sessions/{session_id}/documents/{document_id}/stop': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Stop Document Content Generation */
    post: operations['stop_document_content_generation_api_v2_1_ml_scribe_sessions__session_id__documents__document_id__stop_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/teams/{team_id}/invitations': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Invite Users To Team
     * @description Invite users to a team
     */
    post: operations['invite_users_to_team_api_v2_1_ml_scribe_teams__team_id__invitations_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/templates/ai-gen-content': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Generate Template Content Using Ai */
    post: operations['generate_template_content_using_ai_api_v2_1_ml_scribe_templates_ai_gen_content_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/templates/build': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Build Consult Template From Document
     * @description build a template from generated document
     */
    post: operations['build_consult_template_from_document_api_v2_1_ml_scribe_templates_build_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/templates/doc-extract': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Extract Content From Document
     * @description Extract content from a document
     */
    post: operations['extract_content_from_document_api_v2_1_ml_scribe_templates_doc_extract_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-1/ml-scribe/integrations/standardized-sections': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Standardized Sections
     * @description Get available template-field section ids for an integration (v2.1).
     *
     *     Uses ``SyncSectionalNotesMixin.get_available_template_field_section_ids``, which a
     *     provider overrides to expose its template fields as opaque free-string keys
     *     (currently AdvancedMD is the only implementor). Providers that do not override that
     *     method receive a functionality-not-available error. Production Heidi
     *     ``SectionalNoteSection`` catalogues remain on
     *     ``GET /api/v2/ml-scribe/integrations/standardized-sections``.
     *
     *     The frontend should call this endpoint only when a provider's markdown sectional
     *     editor feature flag is enabled (currently AdvancedMD).
     */
    get: operations['get_standardized_sections_api_v2_1_ml_scribe_integrations_standardized_sections_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-2/ml-scribe/sessions/{session_id}/consult-note/setup': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Setup Consult Note Generation
     * @description Setup endpoint before side-by-side consult note generation.
     */
    post: operations['setup_consult_note_generation_api_v2_2_ml_scribe_sessions__session_id__consult_note_setup_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-2/ml-scribe/sessions/{session_id}/consult-note': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Generate Consult Note
     * @description Generate content for a given consult note
     */
    post: operations['generate_consult_note_api_v2_2_ml_scribe_sessions__session_id__consult_note_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-2/ml-scribe/sessions/{session_id}/consult-note/confirm': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Confirm Note Selection
     * @description Confirm selection of a specific candidate consult note as the final note for the session.
     */
    post: operations['confirm_note_selection_api_v2_2_ml_scribe_sessions__session_id__consult_note_confirm_post'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-2/ml-scribe/sessions': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Sessions
     * @description List sessions across visibility scopes with cursor-based pagination.
     */
    get: operations['list_sessions_api_v2_2_ml_scribe_sessions_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2-2/ml-scribe/sessions/status-counts': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Session Status Counts
     * @description Per-status session counts for the All Sessions view. Counts your own and your team's sessions (de-duplicated); direct-shared sessions are excluded. Whole-scope: not affected by date, search, or other filters.
     */
    get: operations['get_session_status_counts_api_v2_2_ml_scribe_sessions_status_counts_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/xfa-document/{document_id}/download': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download Filled Xfa Pdf
     * @description Download the filled XFA PDF form document
     */
    get: operations['download_filled_xfa_pdf_api_v2_ml_scribe_xfa_document__document_id__download_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/v2/ml-scribe/xfa-document/{document_id}/fields': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Filled Xfa Fields
     * @description Get filled field values for an XFA PDF form document
     */
    get: operations['get_filled_xfa_fields_api_v2_ml_scribe_xfa_document__document_id__fields_get'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update Xfa Fields
     * @description Update filled field values for an XFA PDF form document
     */
    patch: operations['update_xfa_fields_api_v2_ml_scribe_xfa_document__document_id__fields_patch'];
    trace?: never;
  };
};
export type webhooks = Record<string, never>;
export type components = {
  schemas: {
    /** ACHI13AUCodeConcept */
    ACHI13AUCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** AICommandResponseV2 */
    AICommandResponseV2: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Title */
      title: string;
      /** Session Id */
      session_id: string;
      generation_use: components['schemas']['GenerationUse'];
    };
    /**
     * AbuseBanAction
     * @enum {string}
     */
    AbuseBanAction: AbuseBanAction;
    /** AbuseBanLogListResponse */
    AbuseBanLogListResponse: {
      /** Logs */
      logs: components['schemas']['AbuseBanLogRecord'][];
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
      /** Has More */
      has_more: boolean;
    };
    /** AbuseBanLogRecord */
    AbuseBanLogRecord: {
      /** Identifier Type */
      identifier_type: string;
      /** Identifier */
      identifier: string;
      /** Effected Services */
      effected_services: string[];
      action: components['schemas']['AbuseBanAction'];
      /** Admin Id */
      admin_id: string;
      /** Admin Email */
      admin_email?: string | null;
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp: string;
      /**
       * Reason
       * @default
       */
      reason: string;
      /** Full Name */
      full_name?: string | null;
    };
    /**
     * Acc45RegistrationLinkId
     * @description Stable linkId values for ACC 45 registration questionnaire items.
     * @enum {string}
     */
    Acc45RegistrationLinkId: Acc45RegistrationLinkId;
    /**
     * AcceptMKCustomTemplateRequestBody
     * @description Request body for accepting an MK custom template request
     */
    AcceptMKCustomTemplateRequestBody: Record<string, never>;
    /** AccessEntitlementListResponse */
    AccessEntitlementListResponse: {
      /** Entitlements */
      entitlements: components['schemas']['AccessEntitlementView'][];
    };
    /** AccessEntitlementTypeListResponse */
    AccessEntitlementTypeListResponse: {
      /** Entitlement Types */
      entitlement_types: components['schemas']['AccessEntitlementTypeView'][];
    };
    /** AccessEntitlementTypeView */
    AccessEntitlementTypeView: {
      /** Id */
      id: string;
      /** Display Name */
      display_name: string;
      /** Is Active */
      is_active: boolean;
      /** Default Enabled */
      default_enabled: boolean;
      availability: components['schemas']['EntitlementTypeAvailability'];
    };
    /** AccessEntitlementView */
    AccessEntitlementView: {
      /** Id */
      id: string;
      /** Entitlement Type Id */
      entitlement_type_id: string;
      /** Entitlement Type Name */
      entitlement_type_name?: string | null;
      /** Attachment Type */
      attachment_type: string;
      /** Attachment Id */
      attachment_id: string;
      /** Enabled */
      enabled: boolean;
      /** Deleted At */
      deleted_at: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * AccessEntitlementsResponse
     * @description Effective entitlements for the current user (feature flags by attachment).
     */
    AccessEntitlementsResponse: {
      /** Entitlements */
      entitlements: components['schemas']['UserEntitlementView'][];
    };
    /** AccessRestrictedBackupAudio */
    AccessRestrictedBackupAudio: {
      /**
       * Expiry
       * @default 0
       */
      expiry: number;
      /** Access Url */
      access_url: string | null;
      status: components['schemas']['BackupAudioTranscriptionStatus'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** AccessRestrictedUploadedAudio */
    AccessRestrictedUploadedAudio: {
      /**
       * Expiry
       * @default 0
       */
      expiry: number;
      /** Access Url */
      access_url: string | null;
      /** Id */
      id: string;
      /** Index */
      index: number;
      status: components['schemas']['ProcessStatus'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** AccessRestrictedUserUploadedAudio */
    AccessRestrictedUserUploadedAudio: {
      /**
       * Expiry
       * @default 0
       */
      expiry: number;
      /** Access Url */
      access_url: string | null;
      status: components['schemas']['ProcessStatus'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** AccessRestrictedUserUploadedAudioList */
    AccessRestrictedUserUploadedAudioList: {
      /** Uploaded Audios */
      uploaded_audios: components['schemas']['AccessRestrictedUserUploadedAudio'][];
    };
    /**
     * AccessTier
     * @description Access tier for product features.
     * @enum {string}
     */
    AccessTier: AccessTier;
    /** AccuroEHRLaunchProfileAdditionalDetails */
    AccuroEHRLaunchProfileAdditionalDetails: {
      /**
       * Tenant Id
       * Format: uuid
       */
      tenant_id: string;
      /** Tenant Name */
      tenant_name: string;
      /** Qhr Subscription Key */
      qhr_subscription_key: string;
    };
    /**
     * AckFrontendEventRequest
     * @description Execution outcome for a frontend event.
     *
     *     Posted by the FE when the registered handler has finished (success
     *     OR failure). ``resolved_by`` is NOT exposed — set from the
     *     authenticated run subject in the router.
     */
    AckFrontendEventRequest: {
      /**
       * Outcome
       * @enum {string}
       */
      outcome: AckFrontendEventRequestOutcome;
      /** Error */
      error?: string | null;
    };
    /**
     * ActionType
     * @description The task's CTA button type.
     * @enum {string}
     */
    ActionType: ActionType;
    /**
     * ActivateClinicianTrialResponse
     * @description Response for activating clinician evidence trial.
     */
    ActivateClinicianTrialResponse: {
      /** Success */
      success: boolean;
      /** Trial End Date */
      trial_end_date?: string | null;
      /** Subscription Id */
      subscription_id?: string | null;
      /** Message */
      message: string;
      billing_info?: components['schemas']['BillingInfoResponseView'] | null;
    };
    /** ActivatePromotedFreeTrialRequest */
    ActivatePromotedFreeTrialRequest: {
      /**
       * Promoted Free Trial Token
       * @description Token to activate the promoted free trial
       */
      promoted_free_trial_token: string;
    };
    /** ActiveUserUsage */
    ActiveUserUsage: {
      /** Ehr Email */
      ehr_email: string;
      /** Session Count */
      session_count: number;
    };
    /**
     * Actor
     * @description The entity that executed the action.
     *
     *     ``type="User"`` — a real authenticated principal; ``id`` is the
     *     JWT-resolved user identifier (an internal admin for
     *     :class:`InternalAdminAuditEvent`, the calling end user for
     *     :class:`UserSelfServiceAuditEvent`).
     *     ``type="System"`` — a platform-driven action (e.g. a Temporal workflow);
     *     ``id`` is the originating workflow / workflow-family identifier (not a
     *     per-run id; per-run identifiers live inside ``AuditLogEvent.details``).
     */
    Actor: {
      /**
       * Type
       * @enum {string}
       */
      type: ActorType;
      /** Id */
      id: string | null;
    };
    /** AdCampaignDetailResponse */
    AdCampaignDetailResponse: {
      /**
       * Id
       * @description Campaign record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Advertiser Id
       * @description Owning advertiser record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      advertiser_id: string;
      /**
       * Name
       * @description Campaign / flight name.
       */
      name: string;
      /** @description Lifecycle status. */
      status: components['schemas']['AdCampaignStatus'];
      /**
       * Start At
       * Format: date-time
       * @description Inclusive start of the flight window.
       */
      start_at: string;
      /**
       * End At
       * Format: date-time
       * @description End of the flight window.
       */
      end_at: string;
      /** @description Heidi product surface; null while unset (DRAFT / ARCHIVED). */
      target_product: components['schemas']['AdTargetProduct'] | null;
      /**
       * Criteria
       * @description Audience match map; empty means no audience restriction.
       */
      criteria: {
        [key: string]: string[];
      };
      /**
       * Resource Id
       * @description Bound creative resource ID, if any.
       */
      resource_id: string | null;
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description: string | null;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the record was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the record was last updated.
       */
      updated_at: string;
      /** @description Author that created the record. */
      created_by: components['schemas']['Author'];
      /** @description Author of the last update, if any. */
      updated_by: components['schemas']['Author'] | null;
      /**
       * Advertiser Name
       * @description Owning advertiser's display name.
       */
      advertiser_name: string;
      /** @description Owning advertiser's lifecycle status; an ARCHIVED advertiser blocks go-live. */
      advertiser_status: components['schemas']['AdvertiserStatus'];
      /** @description Bound creative summary; null when no resource is bound. */
      resource: components['schemas']['AdCampaignResourceSummary'] | null;
    };
    /** AdCampaignListItemResponse */
    AdCampaignListItemResponse: {
      /**
       * Id
       * @description Campaign record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Advertiser Id
       * @description Owning advertiser record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      advertiser_id: string;
      /**
       * Name
       * @description Campaign / flight name.
       */
      name: string;
      /** @description Lifecycle status. */
      status: components['schemas']['AdCampaignStatus'];
      /**
       * Start At
       * Format: date-time
       * @description Inclusive start of the flight window.
       */
      start_at: string;
      /**
       * End At
       * Format: date-time
       * @description End of the flight window.
       */
      end_at: string;
      /** @description Heidi product surface; null while unset (DRAFT / ARCHIVED). */
      target_product: components['schemas']['AdTargetProduct'] | null;
      /**
       * Criteria
       * @description Audience match map; empty means no audience restriction.
       */
      criteria: {
        [key: string]: string[];
      };
      /**
       * Resource Id
       * @description Bound creative resource ID, if any.
       */
      resource_id: string | null;
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description: string | null;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the record was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the record was last updated.
       */
      updated_at: string;
      /** @description Author that created the record. */
      created_by: components['schemas']['Author'];
      /** @description Author of the last update, if any. */
      updated_by: components['schemas']['Author'] | null;
      /**
       * Advertiser Name
       * @description Owning advertiser's display name; null when the advertiser record cannot be resolved.
       */
      advertiser_name: string | null;
    };
    /**
     * AdCampaignResourceSummary
     * @description Bound-creative summary for the campaign detail view.
     *
     *     Carries the resource's lifecycle status so the UI can hint why go-live
     *     would fail (e.g. a DRAFT resource must be approved first).
     */
    AdCampaignResourceSummary: {
      /**
       * Id
       * @description Resource record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Name
       * @description Resource name.
       */
      name: string;
      /** @description Resource lifecycle status. */
      status: components['schemas']['AdResourceStatus'];
      /** @description Placement the creative is built for; null when unclassified. */
      ad_format: components['schemas']['AdFormat'] | null;
    };
    /** AdCampaignResponse */
    AdCampaignResponse: {
      /**
       * Id
       * @description Campaign record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Advertiser Id
       * @description Owning advertiser record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      advertiser_id: string;
      /**
       * Name
       * @description Campaign / flight name.
       */
      name: string;
      /** @description Lifecycle status. */
      status: components['schemas']['AdCampaignStatus'];
      /**
       * Start At
       * Format: date-time
       * @description Inclusive start of the flight window.
       */
      start_at: string;
      /**
       * End At
       * Format: date-time
       * @description End of the flight window.
       */
      end_at: string;
      /** @description Heidi product surface; null while unset (DRAFT / ARCHIVED). */
      target_product: components['schemas']['AdTargetProduct'] | null;
      /**
       * Criteria
       * @description Audience match map; empty means no audience restriction.
       */
      criteria: {
        [key: string]: string[];
      };
      /**
       * Resource Id
       * @description Bound creative resource ID, if any.
       */
      resource_id: string | null;
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description: string | null;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the record was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the record was last updated.
       */
      updated_at: string;
      /** @description Author that created the record. */
      created_by: components['schemas']['Author'];
      /** @description Author of the last update, if any. */
      updated_by: components['schemas']['Author'] | null;
    };
    /**
     * AdCampaignStatus
     * @description Lifecycle status for a schedulable ad campaign / flight.
     * @enum {string}
     */
    AdCampaignStatus: AdCampaignStatus;
    /**
     * AdFormat
     * @description Banner placement a creative is built for on a Heidi product surface.
     *
     *     What the creative *does*, as opposed to ``AdResourceType``'s what it *is*.
     *     Distinct from campaign ``target_product``, which governs scheduling — this
     *     field tags which surface's banner slot the creative was reviewed for.
     * @enum {string}
     */
    AdFormat: AdFormat;
    /**
     * AdResourceDetailResponse
     * @description The single-resource projection, with the advertiser name guaranteed.
     */
    AdResourceDetailResponse: {
      /**
       * Id
       * @description Ad resource record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Advertiser Id
       * @description Owning advertiser.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      advertiser_id: string;
      /**
       * Name
       * @description Operator-facing resource name.
       */
      name: string;
      /** @description Lifecycle status: DRAFT, APPROVED, or ARCHIVED. */
      status: components['schemas']['AdResourceStatus'];
      /** @description Media type of the creative. */
      type: components['schemas']['AdResourceType'];
      /** @description Placement this creative is built for; null means unclassified. */
      ad_format: components['schemas']['AdFormat'] | null;
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description: string | null;
      /**
       * Link
       * @description Click-through landing URL, if any.
       */
      link: string | null;
      /**
       * Media Url
       * @description Public CDN URL of the creative. Null for a resource with no stored creative, or on a deployment with no CDN configured. The underlying storage key is never exposed; this URL is stable for the life of the resource, since a creative is never replaced.
       */
      media_url: string | null;
      /**
       * Content Type
       * @description MIME type of the creative, detected from its bytes.
       */
      content_type: string | null;
      /**
       * Original Filename
       * @description The file's own name, for operator recognition.
       */
      original_filename: string | null;
      /**
       * Size Bytes
       * @description Size of the stored asset in bytes.
       */
      size_bytes: number | null;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the record was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the record was last updated.
       */
      updated_at: string;
      /** @description Author that created the record. */
      created_by: components['schemas']['Author'];
      /** @description Author of the last update, if any. */
      updated_by: components['schemas']['Author'] | null;
      /**
       * Advertiser Name
       * @description Owning advertiser's display name.
       */
      advertiser_name: string;
      /** @description Owning advertiser's lifecycle status; an ARCHIVED advertiser blocks create and approval. */
      advertiser_status: components['schemas']['AdvertiserStatus'];
      /**
       * Live Campaigns
       * @description Campaigns in SCHEDULED or ACTIVE status that bind this resource.
       */
      live_campaigns: components['schemas']['AdResourceLiveCampaignSummary'][];
    };
    /**
     * AdResourceListItemResponse
     * @description A list row, carrying the owning advertiser's display name.
     */
    AdResourceListItemResponse: {
      /**
       * Id
       * @description Ad resource record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Advertiser Id
       * @description Owning advertiser.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      advertiser_id: string;
      /**
       * Name
       * @description Operator-facing resource name.
       */
      name: string;
      /** @description Lifecycle status: DRAFT, APPROVED, or ARCHIVED. */
      status: components['schemas']['AdResourceStatus'];
      /** @description Media type of the creative. */
      type: components['schemas']['AdResourceType'];
      /** @description Placement this creative is built for; null means unclassified. */
      ad_format: components['schemas']['AdFormat'] | null;
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description: string | null;
      /**
       * Link
       * @description Click-through landing URL, if any.
       */
      link: string | null;
      /**
       * Media Url
       * @description Public CDN URL of the creative. Null for a resource with no stored creative, or on a deployment with no CDN configured. The underlying storage key is never exposed; this URL is stable for the life of the resource, since a creative is never replaced.
       */
      media_url: string | null;
      /**
       * Content Type
       * @description MIME type of the creative, detected from its bytes.
       */
      content_type: string | null;
      /**
       * Original Filename
       * @description The file's own name, for operator recognition.
       */
      original_filename: string | null;
      /**
       * Size Bytes
       * @description Size of the stored asset in bytes.
       */
      size_bytes: number | null;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the record was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the record was last updated.
       */
      updated_at: string;
      /** @description Author that created the record. */
      created_by: components['schemas']['Author'];
      /** @description Author of the last update, if any. */
      updated_by: components['schemas']['Author'] | null;
      /**
       * Advertiser Name
       * @description Owning advertiser's display name; null when the advertiser record cannot be resolved.
       */
      advertiser_name: string | null;
    };
    /**
     * AdResourceResponse
     * @description The base projection, returned by every write path.
     */
    AdResourceResponse: {
      /**
       * Id
       * @description Ad resource record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Advertiser Id
       * @description Owning advertiser.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      advertiser_id: string;
      /**
       * Name
       * @description Operator-facing resource name.
       */
      name: string;
      /** @description Lifecycle status: DRAFT, APPROVED, or ARCHIVED. */
      status: components['schemas']['AdResourceStatus'];
      /** @description Media type of the creative. */
      type: components['schemas']['AdResourceType'];
      /** @description Placement this creative is built for; null means unclassified. */
      ad_format: components['schemas']['AdFormat'] | null;
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description: string | null;
      /**
       * Link
       * @description Click-through landing URL, if any.
       */
      link: string | null;
      /**
       * Media Url
       * @description Public CDN URL of the creative. Null for a resource with no stored creative, or on a deployment with no CDN configured. The underlying storage key is never exposed; this URL is stable for the life of the resource, since a creative is never replaced.
       */
      media_url: string | null;
      /**
       * Content Type
       * @description MIME type of the creative, detected from its bytes.
       */
      content_type: string | null;
      /**
       * Original Filename
       * @description The file's own name, for operator recognition.
       */
      original_filename: string | null;
      /**
       * Size Bytes
       * @description Size of the stored asset in bytes.
       */
      size_bytes: number | null;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the record was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the record was last updated.
       */
      updated_at: string;
      /** @description Author that created the record. */
      created_by: components['schemas']['Author'];
      /** @description Author of the last update, if any. */
      updated_by: components['schemas']['Author'] | null;
    };
    /**
     * AdResourceStatus
     * @description Lifecycle status for a reusable creative resource (any format).
     * @enum {string}
     */
    AdResourceStatus: AdResourceStatus;
    /**
     * AdResourceType
     * @description Media type discriminator for ``AdResource.data``.
     *
     *     What the creative *is* (an image, later perhaps HTML). Distinct from
     *     ``AdFormat``, which is where and how it renders.
     * @enum {string}
     */
    AdResourceType: AdResourceType;
    /**
     * AdTargetProduct
     * @description Heidi product surfaces where a campaign may be shown.
     * @enum {string}
     */
    AdTargetProduct: AdTargetProduct;
    /**
     * AdaptiveLearningAvailabilityResponse
     * @description Whether the settings-page adaptive-learning card should be shown:
     *     the master flag is on for this user AND they have learned rules in
     *     memory (a cheap Mongo read).
     */
    AdaptiveLearningAvailabilityResponse: {
      /** Available */
      available: boolean;
    };
    /** AdaptiveLearningPopoverResponse */
    AdaptiveLearningPopoverResponse: {
      /** Should Show Popover */
      should_show_popover: boolean;
    };
    /**
     * AdaptiveThinking
     * @description Anthropic adaptive thinking (``thinking.type == "adaptive"``).
     *
     *     ``effort`` pins ``output_config.effort`` for the call; ``None`` leaves
     *     the provider default. Setting an effort therefore always implies
     *     adaptive thinking — the historical flat-field precedence rule, now
     *     carried by the type itself.
     */
    AdaptiveThinking: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: AdaptiveThinkingKind;
      /** Effort */
      effort?: AdaptiveThinkingEffortAnyOf0 | null;
    };
    /** AddCardRequestSchema */
    AddCardRequestSchema: {
      /** Protocol Id */
      protocol_id: string;
      /** Visit Summary */
      visit_summary?: string | null;
      /** Transcript Chunk */
      transcript_chunk?: string | null;
    };
    /**
     * AddDocumentsRequest
     * @description Request model for adding documents to a collection.
     */
    AddDocumentsRequest: {
      /**
       * Document Ids
       * @description List of document IDs to add
       */
      document_ids: string[];
    };
    /** AddEventRuleRequest */
    AddEventRuleRequest: {
      event_type: components['schemas']['EventType'];
      /** Filters */
      filters?: {
        [key: string]: unknown;
      };
      /** Delay Seconds */
      delay_seconds?: number | null;
      /** Conditions */
      conditions?: (
        | components['schemas']['PayloadCondition']
        | components['schemas']['SemanticCondition']
      )[];
      delivery_policy?: components['schemas']['DeliveryPolicy'] | null;
    };
    /**
     * AddLinkShareRecipientsRequest
     * @description Request body for adding link share recipients.
     */
    AddLinkShareRecipientsRequest: {
      /**
       * Recipients
       * @description List of recipients to add
       */
      recipients: components['schemas']['LinkShareRecipientInput'][];
      /** @description Default sharing scope for the session */
      default_scope: components['schemas']['SharedSessionScope'];
      /** @description Optional time-to-live for the share link (e.g. '1h', '24h', '7d', '14d', '30d'). Server computes the expiration from this value. Omitted or null falls back to '14d'. */
      ttl?: components['schemas']['LinkShareTTL'] | null;
    };
    /**
     * AddLinkShareRecipientsResponse
     * @description Response for add link share recipients.
     */
    AddLinkShareRecipientsResponse: {
      /** Session Id */
      session_id: string;
      default_scope: components['schemas']['SharedSessionScope'];
      /** Recipients */
      recipients: components['schemas']['LinkShareRecipientResponse'][];
    };
    /** AddMessageRequest */
    AddMessageRequest: {
      speaker: components['schemas']['Speaker'];
      /** Originaltext */
      originalText: string;
      /** Translatedtext */
      translatedText: string;
      /** Originallanguage */
      originalLanguage: string;
      /** Targetlanguage */
      targetLanguage: string;
      /** Sttmodel */
      sttModel?: string | null;
      /** Translationmodel */
      translationModel?: string | null;
      /** Ttsmodel */
      ttsModel?: string | null;
      /** Alternatetranscription */
      alternateTranscription?: string | null;
      /** Autoplayedat */
      autoplayedAt?: string | null;
      /** Audiostorageid */
      audioStorageId?: string | null;
      /** Ttsstorageid */
      ttsStorageId?: string | null;
      /** @default live */
      source: components['schemas']['MessageSource'];
      /** Bulkuploadid */
      bulkUploadId?: string | null;
      recordingMode?: components['schemas']['RecordingMode'] | null;
      /** Sttdurationms */
      sttDurationMs?: number | null;
      /** Translationdurationms */
      translationDurationMs?: number | null;
      /** Ttsdurationms */
      ttsDurationMs?: number | null;
    };
    /** AddNewCodeRequest */
    AddNewCodeRequest: {
      /** Code */
      code: string;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * AddNoteRequest
     * @description Request to add a note/comment to a ticket.
     */
    AddNoteRequest: {
      /** Body */
      body: string;
      /**
       * User Email
       * Format: email
       */
      user_email: string;
    };
    /** AddOnBillingInfoResponse */
    AddOnBillingInfoResponse: {
      /** Add On Billing Infos */
      add_on_billing_infos: components['schemas']['AddOnBillingInfoResponseView'][];
    };
    /** AddOnBillingInfoResponseView */
    AddOnBillingInfoResponseView: {
      /** Stripe Subscription Id */
      stripe_subscription_id: string | null;
      /** Plan Start Date */
      plan_start_date: string | null;
      /** Plan End Date */
      plan_end_date: string | null;
      /** Trial End Date */
      trial_end_date: string | null;
      /** Next Billing Date */
      next_billing_date: string | null;
      /** Is In Free Trial */
      is_in_free_trial: boolean;
      plan_cycle: components['schemas']['shared__enums__enums__Period'] | null;
      add_on_details: components['schemas']['IntegrationDetails'];
      category: components['schemas']['AddOnCategory'];
    };
    /**
     * AddOnCategory
     * @enum {string}
     */
    AddOnCategory: AddOnCategory;
    /**
     * AddOnMetadata
     * @description Type-specific metadata for ADDON_INTEGRATION subscriptions.
     */
    AddOnMetadata: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: AddOnMetadataKind;
      /** Add On Product Id */
      add_on_product_id: string;
      /** Ehr Provider */
      ehr_provider: string;
      /** Widget Note Push Limit */
      widget_note_push_limit?: number | null;
    };
    /** AddOnPriceView */
    AddOnPriceView: {
      /** Id */
      id: string;
      /** Type */
      type: string;
      /** Unit Amount */
      unit_amount: number;
      period: components['schemas']['shared__enums__enums__Period'];
      /** Currency */
      currency: string;
    };
    /** AddOnProduct */
    AddOnProduct: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      category: components['schemas']['AddOnCategory'];
      /** Vendor Products */
      vendor_products: components['schemas']['VendorProduct'][];
      /** @default TESTING */
      status: components['schemas']['AddOnProductStatus'];
      add_on_details: components['schemas']['IntegrationDetails'];
      /**
       * Free Trial Days
       * @default 14
       */
      free_trial_days: number;
      /** @default FREE */
      minimum_eligible_purchase_tier: components['schemas']['SubscriptionTier'];
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
      /** Deleted At */
      deleted_at?: string | null;
    };
    /**
     * AddOnProductStatus
     * @enum {string}
     */
    AddOnProductStatus: AddOnProductStatus;
    /** AddOnProductView */
    AddOnProductView: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      add_on_details: components['schemas']['IntegrationDetails'];
      /** Prices */
      prices: components['schemas']['AddOnPriceView'][];
      /** Free Trial Days */
      free_trial_days: number;
      /** @default FREE */
      minimum_eligible_purchase_tier: components['schemas']['SubscriptionTier'];
    };
    /**
     * AddStockRequest
     * @description Register returned units into office stock (intake).
     *
     *     Stock is tracked serial-level: each physical unit becomes its own stock
     *     item, so ``quantity`` units create ``quantity`` items, each in RECEIVED.
     */
    AddStockRequest: {
      /**
       * Quantity
       * @description Number of physical units received; one stock item is created per unit.
       */
      quantity: number;
      /**
       * Source Order Id
       * @description Order this return originated from, when known.
       */
      source_order_id?: string | null;
      /** Notes */
      notes?: string | null;
    };
    /** AddStockResponse */
    AddStockResponse: {
      /**
       * Data
       * @description The stock items created by this intake, one per unit.
       */
      data: components['schemas']['StockItemView'][];
    };
    /** AddTeamsToOrganizationRequest */
    AddTeamsToOrganizationRequest: {
      /** Team Ids */
      team_ids: string[];
    };
    /** AdditionalContext */
    AdditionalContext: {
      /** @description The type of note to be created. */
      noteType?: components['schemas']['ClinicalNoteTypeCodingSystem'] | null;
      /** @description JSON object of additional user context values. */
      user: components['schemas']['UserContext'];
      /** @description JSON object of additional note context values. */
      notes: components['schemas']['NoteContext'];
    };
    AdditionalDetailsType:
      | components['schemas']['AccuroEHRLaunchProfileAdditionalDetails']
      | components['schemas']['AlayaCareEHRLaunchProfileAdditionalDetails']
      | components['schemas']['MedtechEHRLaunchProfileAdditionalDetails']
      | components['schemas']['CernerEHRLaunchProfileAdditionalDetails']
      | components['schemas']['VeradigmEHRLaunchProfileAdditionalDetails']
      | null;
    /**
     * AdditionalInformationView
     * @description Potential hallucination or unsupported inference.
     */
    AdditionalInformationView: {
      /** Output Entity */
      output_entity: string;
      /** Output Quotes */
      output_quotes: string[];
      /** Category */
      category: string;
      /** Classification */
      classification: string;
      /** Severity */
      severity: string;
      /** Justification */
      justification: string;
      /** Suggested Fix */
      suggested_fix?: string | null;
      /**
       * Related Entities
       * @default []
       */
      related_entities: number[];
      /** Feedback Id */
      feedback_id?: string | null;
    };
    /**
     * Address
     * @description An address expressed using postal conventions (as opposed to GPS or other location definition formats).
     *
     *     This data type may be used to convey addresses for use in delivering mail as well as
     *     for visiting locations which might not be valid for mail delivery. There are a variety
     *     of postal address formats defined around the world.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Address
     */
    Address: {
      /**
       * home | work | temp | old | billing - purpose of this address
       * @description The purpose of this address.
       */
      use?: components['schemas']['AddressUse'] | null;
      /**
       * postal | physical | both
       * @description Distinguishes between physical addresses (those you can visit) and mailing addresses (e.g. PO Boxes and care-of addresses). Most addresses are both.
       */
      type?: components['schemas']['AddressType'] | null;
      /**
       * Text representation of the address
       * @description Specifies the entire address as it should be displayed e.g. on a postal label. This may be provided instead of or as well as the specific parts.
       */
      text?: string | null;
      /**
       * Street name, number, direction & P.O. Box etc.
       * @description This component contains the house number, apartment number, street name, street direction, P.O. Box number, delivery hints, and similar address information.
       */
      line?: string[] | null;
      /**
       * Name of city, town etc.
       * @description The name of the city, town, suburb, village or other community or delivery center.
       */
      city?: string | null;
      /**
       * District name (aka county)
       * @description The name of the administrative area (county).
       */
      district?: string | null;
      /**
       * Sub-unit of country (abbreviations ok)
       * @description Sub-unit of a country with limited sovereignty in a federally organized country. A code may be used if codes are in common use (e.g. US 2 letter state codes).
       */
      state?: string | null;
      /**
       * Postal code for area
       * @description A postal code designating a region defined by the postal service.
       */
      postalCode?: string | null;
      /**
       * Country (e.g. can be ISO 3166 2 or 3 letter code)
       * @description Country - a nation as commonly understood or generally accepted.
       */
      country?: string | null;
      /** Time period when address was/is in use */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
    };
    /**
     * AddressType
     * @description The type of an address (physical / postal).
     *
     *     https://hl7.org/fhir/R4/valueset-address-type.html
     * @enum {string}
     */
    AddressType: AddressType;
    /**
     * AddressUse
     * @description The use of an address.
     *
     *     https://hl7.org/fhir/R4/valueset-address-use.html
     * @enum {string}
     */
    AddressUse: AddressUse;
    /** AdjustRequest */
    AdjustRequest: {
      /** Workspace Id */
      workspace_id: string;
      transaction_type: components['schemas']['TransactionType'];
      /** Amount */
      amount: number | string;
      /**
       * Currency
       * @default heidi_credit
       */
      currency: string;
      /** Reason */
      reason?: string | null;
    };
    /** AdminAudioRecordingListResponse */
    AdminAudioRecordingListResponse: {
      /** Items */
      items: components['schemas']['AdminAudioRecordingResponse'][];
    };
    /** AdminAudioRecordingResponse */
    AdminAudioRecordingResponse: {
      /** Id */
      id: string;
      /** Chat Session Id */
      chat_session_id: string;
      /** Storage Id */
      storage_id: string;
      kind: components['schemas']['TranslatorAudioKind'];
      /** Message Id */
      message_id?: string | null;
      /**
       * Occurred At
       * Format: date-time
       */
      occurred_at: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Storage Deleted At */
      storage_deleted_at?: string | null;
    };
    /** AdminCreateWorkflowRequest */
    AdminCreateWorkflowRequest: {
      /** Owner User Id */
      owner_user_id: string;
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      /** Instructions */
      instructions: string;
      /**
       * Source
       * @default instructed
       * @enum {string}
       */
      source: AdminCreateWorkflowRequestSource;
      /** Source Recording Id */
      source_recording_id?: string | null;
      /** Agent Config Id */
      agent_config_id?: string | null;
      /** Agent Config Version */
      agent_config_version?: number | null;
      /**
       * Product Surface
       * @enum {string}
       */
      product_surface: AdminCreateWorkflowRequestProduct_surface;
    };
    /**
     * AdminLeaderboardEntry
     * @description Admin view of a leaderboard entry with additional details.
     */
    AdminLeaderboardEntry: {
      /** Rank */
      rank: number;
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Display Name */
      display_name: string;
      /** Email */
      email?: string | null;
      /** Count */
      count: number;
      /** Region */
      region: string;
      /** Country */
      country?: string | null;
      /**
       * Excluded
       * @default false
       */
      excluded: boolean;
      exclusion_scope?: components['schemas']['ExclusionScope'] | null;
      /** Pseudonym */
      pseudonym?: string | null;
      /** Visibility */
      visibility?: string | null;
    };
    /**
     * AdminLeaderboardResponse
     * @description Admin response for leaderboard with full user details.
     */
    AdminLeaderboardResponse: {
      /** Entries */
      entries: components['schemas']['AdminLeaderboardEntry'][];
      competition: components['schemas']['CompetitionResponse'];
      /** Total Entries */
      total_entries: number;
      /** Page */
      page: number;
      /** Limit */
      limit: number;
      /**
       * Generated At
       * Format: date-time
       */
      generated_at: string;
    };
    /**
     * AdminLogoutEverywhereResponse
     * @description Response payload for the admin logout-everywhere endpoint.
     */
    AdminLogoutEverywhereResponse: {
      /** Status */
      status: string;
      /** Affected Count */
      affected_count: number;
    };
    /** AdminPatientResponse */
    AdminPatientResponse: {
      /** Name */
      name?: string | null;
      /** Dob */
      dob?: string | null;
      /** Age */
      age?: string | null;
      gender?: components['schemas']['domains__translator__models__enums__Gender'] | null;
    };
    /** AdminSessionDetailResponse */
    AdminSessionDetailResponse: {
      /** Id */
      id: string;
      /** User Ref Id */
      user_ref_id: string;
      /** Title */
      title: string;
      /** Patient Language */
      patient_language: string;
      /** Clinician Language */
      clinician_language: string;
      patient?: components['schemas']['AdminPatientResponse'] | null;
      /** Reason For Visit */
      reason_for_visit?: string | null;
      patient_onboarding_status?: components['schemas']['OnboardingStatus'] | null;
      /** Pinned */
      pinned?: boolean | null;
      /** Last Activity At */
      last_activity_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Message Count */
      message_count: number;
    };
    /** AdminSessionListResponse */
    AdminSessionListResponse: {
      /** Items */
      items: components['schemas']['AdminSessionResponse'][];
      /** Total */
      total: number;
    };
    /** AdminSessionResponse */
    AdminSessionResponse: {
      /** Id */
      id: string;
      /** User Ref Id */
      user_ref_id: string;
      /** Title */
      title: string;
      /** Patient Language */
      patient_language: string;
      /** Clinician Language */
      clinician_language: string;
      patient?: components['schemas']['AdminPatientResponse'] | null;
      /** Reason For Visit */
      reason_for_visit?: string | null;
      patient_onboarding_status?: components['schemas']['OnboardingStatus'] | null;
      /** Pinned */
      pinned?: boolean | null;
      /** Last Activity At */
      last_activity_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** AdminSessionStatsResponse */
    AdminSessionStatsResponse: {
      /** Total Sessions */
      total_sessions: number;
      /** Sessions Today */
      sessions_today: number;
      /** Distinct Users */
      distinct_users: number;
    };
    /** AdminSimpleSpecialtyResponse */
    AdminSimpleSpecialtyResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Is Live */
      is_live: boolean;
      /** Groups */
      groups?: components['schemas']['SpecialtyGroupInfo'][];
      /** Template Count */
      template_count?: number | null;
      /** Pinned Template Count */
      pinned_template_count?: number | null;
      /** Country Codes */
      country_codes?: components['schemas']['CountryCode'][];
    };
    /** AdminSpecialtiesResponse */
    AdminSpecialtiesResponse: {
      /** Specialties */
      specialties: components['schemas']['AdminSimpleSpecialtyResponse'][];
      /** Total */
      total: number;
    };
    /** AdminUpdateUserRequest */
    AdminUpdateUserRequest: {
      /** Country */
      country?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      /** Practitioner Type */
      practitioner_type?: string | null;
      /** Specialty Id */
      specialty_id?: string | null;
      default_note_structure?: components['schemas']['NoteStructure'] | null;
      writing_style?: components['schemas']['VoiceStyle'] | null;
      /** Phone Number */
      phone_number?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Journey */
      journey?: {
        [key: string]: components['schemas']['JourneyStatus'];
      } | null;
      /** Is Demo On Desktop Completed */
      is_demo_on_desktop_completed?: boolean | null;
      default_language_code?: components['schemas']['LanguageCode'] | null;
      /** Other Specialty */
      other_specialty?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      title?: components['schemas']['TitleCode'] | null;
      session_settings?: components['schemas']['SessionSettingsRequest'] | null;
      dictation?: components['schemas']['DictationSettingsRequest'] | null;
      organisation_info?: components['schemas']['OrganisationInfo'] | null;
      research_profile?: components['schemas']['ClinicianResearchProfile'] | null;
      /** Should Hide Sensitive Info From Sidebar */
      should_hide_sensitive_info_from_sidebar?: boolean | null;
      /** Is Ask Heidi Disclaimer Showed */
      is_ask_heidi_disclaimer_showed?: boolean | null;
      /** Is Default Note Warning Off */
      is_default_note_warning_off?: boolean | null;
      /** Unsubscribed Notification Channels */
      unsubscribed_notification_channels?:
        | components['schemas']['NotificationChannel'][]
        | null;
      /** Notification Preferences */
      notification_preferences?: {
        [key: string]: components['schemas']['NotificationChannel'][];
      } | null;
      /** Is Tutorial Pane Opened */
      is_tutorial_pane_opened?: boolean | null;
      /** Enabled Code Systems */
      enabled_code_systems?:
        | components['schemas']['domains__coding__pkg__enums__CodeSystem'][]
        | null;
      /** Show Hcc Badges */
      show_hcc_badges?: boolean | null;
      /** Has Shown Codes Warning */
      has_shown_codes_warning?: boolean | null;
      /** Has Shown Sectional Note Info Modal */
      has_shown_sectional_note_info_modal?: boolean | null;
      /** Has Shown Push Sectional Note Instruction */
      has_shown_push_sectional_note_instruction?: boolean | null;
      /** Should Show Section Highlight In Template */
      should_show_section_highlight_in_template?: boolean | null;
      /** Has Seen Live Transcription Split View Modal */
      has_seen_live_transcription_split_view_modal?: boolean | null;
      /** Is Live Transcription Split View */
      is_live_transcription_split_view?: boolean | null;
      /** Has Seen Bbe Modal */
      has_seen_bbe_modal?: boolean | null;
      /** Is Bbe Enabled */
      is_bbe_enabled?: boolean | null;
      /** Has Seen Research Tooltip */
      has_seen_research_tooltip?: boolean | null;
      /** Hide Clinical Task Gen Doc Nux Tooltip */
      hide_clinical_task_gen_doc_nux_tooltip?: boolean | null;
      /** Default Export Email */
      default_export_email?: string | null;
      /** Self Defined Disclaimer */
      self_defined_disclaimer?: string | null;
      language_time_settings?: components['schemas']['LanguageTimeSettings'] | null;
      /** Has Shown New Brain Setting */
      has_shown_new_brain_setting?: boolean | null;
      /** Practice Name */
      practice_name?: string | null;
      /** Practice Address */
      practice_address?: string | null;
      practice_country?: components['schemas']['CallsAvailableCountry'] | null;
      /** Handoff Phone */
      handoff_phone?: string | null;
      /** Calls Terms Agreed On */
      calls_terms_agreed_on?: string | null;
      /** Work Research Terms Agreed On */
      work_research_terms_agreed_on?: string | null;
      /** Labs Experimental Terms Agreed On */
      labs_experimental_terms_agreed_on?: string | null;
      /** Do Not Show Telehealth Sharing Tab Modal */
      do_not_show_telehealth_sharing_tab_modal?: boolean | null;
      /** Has Seen Create From Context Tooltip */
      has_seen_create_from_context_tooltip?: boolean | null;
      /** Has Seen Sessionless Evidence */
      has_seen_sessionless_evidence?: boolean | null;
      /** Has Seen Sessionless Evidence Reminder Tooltip */
      has_seen_sessionless_evidence_reminder_tooltip?: boolean | null;
      /** Has Seen Evidence Onboarding For Scribe */
      has_seen_evidence_onboarding_for_scribe?: boolean | null;
      /** Has Used Evidence In Session */
      has_used_evidence_in_session?: boolean | null;
      /** Has Seen Try Source Control During Trial Banner */
      has_seen_try_source_control_during_trial_banner?: boolean | null;
      /** Has Seen Evidence Source Control Coachmark */
      has_seen_evidence_source_control_coachmark?: boolean | null;
      /** Has Seen Billing Plan Renamed Banner */
      has_seen_billing_plan_renamed_banner?: boolean | null;
      /** Should Show Try Scribe Tooltip */
      should_show_try_scribe_tooltip?: boolean | null;
      /** Evidence Discovery Modal Seen At */
      evidence_discovery_modal_seen_at?: string | null;
      /** Calls Send Summary Email */
      calls_send_summary_email?: string | null;
      /** Calls Send Summary Email Enabled */
      calls_send_summary_email_enabled?: boolean | null;
      comms_session_retention_settings?:
        | components['schemas']['RetentionSettings']
        | null;
      /** Default Consult Note Edit Display */
      default_consult_note_edit_display?: boolean | null;
      /** Is Auto Verify Enabled */
      is_auto_verify_enabled?: boolean | null;
      /** Auto Verify Preference Set */
      auto_verify_preference_set?: boolean | null;
      /** Is Auto Verify Lite Enabled */
      is_auto_verify_lite_enabled?: boolean | null;
      /** Auto Verify Lite Preference Set */
      auto_verify_lite_preference_set?: boolean | null;
      theme?: components['schemas']['Theme'] | null;
      /** Affiliate Code */
      affiliate_code?: string | null;
      /** Ref Code */
      ref_code?: string | null;
      referral_campaign?: components['schemas']['ReferralCampaign'] | null;
      signup_source?: components['schemas']['SignupSource'] | null;
      /** Is New User After Evidence Launch */
      is_new_user_after_evidence_launch?: boolean | null;
      evidence_settings?: components['schemas']['EvidenceSettingsRequest'] | null;
      template_creation_record?:
        | components['schemas']['TemplateCreationRecordSettingsRequest']
        | null;
      patient_summary_turn_off_prompt?:
        | components['schemas']['PatientSummaryTurnOffPromptRequest']
        | null;
      /**
       * Hardware Device Binding Code
       * @description Code used to authenticate to hardware devices during bluetooth binding
       */
      hardware_device_binding_code?: string | null;
      /** Stripe Customer Id */
      stripe_customer_id?: string | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Next Billing Date */
      next_billing_date?: string | null;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /** Direct Integration Attempts Count */
      direct_integration_attempts_count?: number | null;
      evidence_billing?: components['schemas']['EvidenceSubscriptionBillingInfo'] | null;
    };
    /**
     * AdminUpdateWorkflowRequest
     * @description Studio/admin update — includes agent pin fields (not on public Work API).
     */
    AdminUpdateWorkflowRequest: {
      /** Name */
      name?: string | null;
      /** Description */
      description?: string | null;
      /** Instructions */
      instructions?: string | null;
      /** Enabled */
      enabled?: boolean | null;
      /** Setup Values */
      setup_values?: {
        [key: string]: string;
      } | null;
      /** Shortcut */
      shortcut?: string | null;
      /** Agent Config Id */
      agent_config_id?: string | null;
      /** Agent Config Version */
      agent_config_version?: number | null;
      /** Product Surface */
      product_surface?: AdminUpdateWorkflowRequestProduct_surfaceAnyOf0 | null;
    };
    /**
     * AdminUserStatsResponse
     * @description Admin view of a user's evidence stats.
     */
    AdminUserStatsResponse: {
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Email */
      email: string | null;
      /** Display Name */
      display_name: string;
      /** Query Count */
      query_count: number;
      /** Referral Count */
      referral_count: number;
      /** Query Rank */
      query_rank: number | null;
      /** Referral Rank */
      referral_rank: number | null;
      /** Opt Out */
      opt_out: boolean;
      /** Region */
      region: string;
      /** Referral Code */
      referral_code: string | null;
      /** Referred By Code */
      referred_by_code: string | null;
      /** Referrals */
      referrals: components['schemas']['ReferralInfo'][];
      /** Pseudonym */
      pseudonym?: string | null;
      /** Visibility */
      visibility?: string | null;
    };
    /** AdminWorkspaceMembership */
    AdminWorkspaceMembership: {
      /** Workspace Id */
      workspace_id: string;
      /** Name */
      name?: string | null;
      role: components['schemas']['WorkspaceRole'];
    };
    /**
     * AdministrativeGender
     * @description The gender of a person used for administrative purposes.
     *
     *     https://hl7.org/fhir/R4/valueset-administrative-gender.html
     * @enum {string}
     */
    AdministrativeGender: AdministrativeGender;
    /**
     * AdvanceHarnessRequest
     * @description One patient turn pushed by the comms relay.
     *
     *     ``user_id`` is the clinician Kinde id; it MUST equal the comms-JWT ``sub``
     *     (the handler rejects a mismatch non-retryably). ``turn_id`` is caller-minted
     *     and stable across transport retries; on the FIRST turn it is folded with
     *     ``request_id`` into the deterministic ``agent_run_id``. ``run_handle`` is
     *     ``None`` on the first turn and the ``agent_run_id`` thereafter.
     */
    AdvanceHarnessRequest: {
      /** Request Id */
      request_id: string;
      /** Comms Session Id */
      comms_session_id: string;
      /** Agent Config Id */
      agent_config_id: string;
      /** User Id */
      user_id: string;
      /** Patient Message */
      patient_message: string;
      /** Turn Id */
      turn_id: string;
      /** Run Handle */
      run_handle?: string | null;
    };
    /**
     * AdvertiserContact
     * @description Advertiser commercial/ops contact — not clinician PII from profiling.
     *
     *     Requires a non-empty name and at least one of email or phone so the
     *     contact is actually reachable. ``phone`` is E.164 via ``PhoneNumber``.
     */
    AdvertiserContact: {
      /**
       * Name
       * @description Display name for the advertiser contact
       */
      name: string;
      /** Email */
      email?: string | null;
      /** Phone */
      phone?: string | null;
      role?: components['schemas']['AdvertiserContactRole'] | null;
    };
    /**
     * AdvertiserContactRole
     * @description What an advertiser contact is for.
     *
     *     Deliberately minimal: compliance roles (regulatory / pharmacovigilance)
     *     are added when that contact taxonomy is agreed — growing the enum is
     *     additive, renaming values after data exists is not.
     * @enum {string}
     */
    AdvertiserContactRole: AdvertiserContactRole;
    /**
     * AdvertiserKind
     * @description House (Heidi-owned) vs external sponsor advertiser.
     *
     *     Rollout starts with house content only, so the first advertiser record is
     *     Heidi itself. Policy branches on this later (house creative is exempt from
     *     sponsor-MLR gates), so it is stored rather than inferred by name. Unset
     *     means unclassified; policy code should treat that as external.
     * @enum {string}
     */
    AdvertiserKind: AdvertiserKind;
    /** AdvertiserListItemResponse */
    AdvertiserListItemResponse: {
      /**
       * Id
       * @description Advertiser record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Name
       * @description Display / ops name for the advertiser.
       */
      name: string;
      /** @description HOUSE vs EXTERNAL; null means not yet classified. */
      kind: components['schemas']['AdvertiserKind'] | null;
      /** @description Lifecycle status: ACTIVE or ARCHIVED (retired, read-only). */
      status: components['schemas']['AdvertiserStatus'];
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description: string | null;
      /**
       * Contacts
       * @description Commercial/ops contacts for the advertiser.
       */
      contacts: components['schemas']['AdvertiserContact'][];
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the record was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the record was last updated.
       */
      updated_at: string;
      /** @description Author that created the record. */
      created_by: components['schemas']['Author'];
      /** @description Author of the last update, if any. */
      updated_by: components['schemas']['Author'] | null;
      /**
       * Ad Resource Count
       * @description Total ad resources owned by this advertiser.
       */
      ad_resource_count: number;
      /**
       * Ad Campaign Count
       * @description Total ad campaigns owned by this advertiser.
       */
      ad_campaign_count: number;
    };
    /** AdvertiserResponse */
    AdvertiserResponse: {
      /**
       * Id
       * @description Advertiser record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Name
       * @description Display / ops name for the advertiser.
       */
      name: string;
      /** @description HOUSE vs EXTERNAL; null means not yet classified. */
      kind: components['schemas']['AdvertiserKind'] | null;
      /** @description Lifecycle status: ACTIVE or ARCHIVED (retired, read-only). */
      status: components['schemas']['AdvertiserStatus'];
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description: string | null;
      /**
       * Contacts
       * @description Commercial/ops contacts for the advertiser.
       */
      contacts: components['schemas']['AdvertiserContact'][];
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the record was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the record was last updated.
       */
      updated_at: string;
      /** @description Author that created the record. */
      created_by: components['schemas']['Author'];
      /** @description Author of the last update, if any. */
      updated_by: components['schemas']['Author'] | null;
    };
    /**
     * AdvertiserStatus
     * @description Lifecycle status for an advertiser account.
     *
     *     v1 keeps this minimal: create as ACTIVE, retire via ARCHIVED.
     *     Suspend / draft workflows can land later if ops needs them.
     * @enum {string}
     */
    AdvertiserStatus: AdvertiserStatus;
    /**
     * Age
     * @description A duration of time during which an organism (or a process) has existed.
     *
     *     Age is a constrained Quantity where value must be positive and the code
     *     must be a UCUM time unit (a, mo, wk, d, h, min).
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Age
     */
    Age: {
      /**
       * Numerical value (with implicit precision)
       * @description The value of the measured amount. The value includes an implicit precision in the presentation of the value.
       */
      value?: number | null;
      /**
       * < | <= | >= | > - how to understand the value
       * @description How the value should be understood and represented - whether the actual value is greater or less than the stated value due to measurement issues; e.g. if the comparator is '<', then the real value is < stated value.
       */
      comparator?: string | null;
      /**
       * Unit representation
       * @description A human-readable form of the unit.
       */
      unit?: string | null;
      /**
       * System that defines coded unit form
       * @description The identification of the system that provides the coded form of the unit.
       */
      system?: string | null;
      /**
       * Coded form of the unit
       * @description A computer processable form of the unit in some unit representation system.
       */
      code?: string | null;
    };
    /**
     * Agent
     * @description Model representing an AI agent.
     */
    Agent: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Phone Number */
      phone_number?: string | null;
      /** Display Name */
      display_name?: string | null;
      /** Description */
      description?: string | null;
      /** @default outbound */
      direction: components['schemas']['CallDirection'] | null;
      /** Objective */
      objective?: string | null;
      /** Redirect Phone Number */
      redirect_phone_number?: string | null;
      config?: components['schemas']['pkg__calls__models__AgentConfig'] | null;
    } & {
      [key: string]: unknown;
    };
    /** AgentChatBackfillRequest */
    AgentChatBackfillRequest: {
      /**
       * Dry Run
       * @description When True (default), resolve and count but write nothing.
       * @default true
       */
      dry_run: boolean;
      /**
       * Limit
       * @description Max agent-chat rows to process in this chunk.
       * @default 1000
       */
      limit: number;
      /**
       * After Id
       * @description Keyset cursor: process rows with _id greater than this hex ObjectId. Pass the previous response's next_after_id; omit on the first call.
       */
      after_id?: string | null;
    };
    /** AgentChatBackfillResponse */
    AgentChatBackfillResponse: {
      /** Dry Run */
      dry_run: boolean;
      /** Scanned */
      scanned: number;
      /** Skipped Canonical */
      skipped_canonical: number;
      /** Skipped Invalid */
      skipped_invalid: number;
      /** Resolved */
      resolved: number;
      /** Written */
      written: number;
      /** Failed */
      failed: number;
      /** Orphaned */
      orphaned: number;
      /** Orphan Owner Ids Sample */
      orphan_owner_ids_sample: string[];
      /** Next After Id */
      next_after_id: string | null;
      /** Has More */
      has_more: boolean;
    };
    /**
     * AgentConfigExport
     * @description Portable snapshot of an agent config and its transitive sub-agent closure.
     *
     *     Entries are topologically sorted: leaves (no sub-agent config_id refs) first,
     *     root last. Version pins on SubAgentBinding are stripped — the import path
     *     pins at import time.
     */
    AgentConfigExport: {
      /** Entries */
      entries: components['schemas']['AgentConfigExportEntry'][];
    };
    /**
     * AgentConfigExportEntry
     * @description One node in a portable agent config export.
     */
    AgentConfigExportEntry: {
      /** Agent Id */
      agent_id: string;
      agent: components['schemas']['pkg__agent_harness__core__config__AgentConfig'];
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
    };
    /** AgentConfigResponse */
    AgentConfigResponse: {
      /** Agent Id */
      agent_id: string;
      /** Version */
      version: number;
      agent: components['schemas']['pkg__agent_harness__core__config__AgentConfig'];
      /** Name */
      name: string;
      /** Description */
      description: string;
      /**
       * Change Message
       * @default
       */
      change_message: string;
      /** Created By */
      created_by: string;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /**
       * Run Count
       * @default 0
       */
      run_count: number;
    };
    /**
     * AgentConfigVersionResponse
     * @description Lightweight version entry for history listings.
     */
    AgentConfigVersionResponse: {
      /** Agent Id */
      agent_id: string;
      /** Version */
      version: number;
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Change Message
       * @default
       */
      change_message: string;
      /** Created By */
      created_by: string;
      /** Created At */
      created_at?: string | null;
    };
    /** AgentHarnessBackfillRequest */
    AgentHarnessBackfillRequest: {
      /** @description Which harness store to backfill in this chunk. The DAG loops over all resource types in one run. */
      resource_type: components['schemas']['HarnessBackfillResource'];
      /**
       * Dry Run
       * @description When True (default), resolve and count but write nothing.
       * @default true
       */
      dry_run: boolean;
      /**
       * Limit
       * @description Max rows to process in this chunk.
       * @default 1000
       */
      limit: number;
      /**
       * After Id
       * @description Keyset cursor: process rows with _id greater than this hex ObjectId. Pass the previous response's next_after_id; omit on the first call for this resource_type.
       */
      after_id?: string | null;
    };
    /** AgentHarnessBackfillResponse */
    AgentHarnessBackfillResponse: {
      resource_type: components['schemas']['HarnessBackfillResource'];
      /** Dry Run */
      dry_run: boolean;
      /** Scanned */
      scanned: number;
      /** Skipped Canonical */
      skipped_canonical: number;
      /** Skipped Invalid */
      skipped_invalid: number;
      /** Skipped Foreign */
      skipped_foreign: number;
      /** Resolved */
      resolved: number;
      /** Written */
      written: number;
      /** Failed */
      failed: number;
      /** Orphaned */
      orphaned: number;
      /** Orphan Owner Ids Sample */
      orphan_owner_ids_sample: string[];
      /** Next After Id */
      next_after_id: string | null;
      /** Has More */
      has_more: boolean;
    };
    /** AgentHarnessStatusResponse */
    AgentHarnessStatusResponse: {
      /**
       * Enabled
       * @description Whether the agent harness is enabled at runtime. May be False even when the release flag is on if Temporal startup failed — operators use this to alert on flag/runtime mismatch.
       */
      enabled: boolean;
    };
    /**
     * AgentMemoryStatus
     * @enum {string}
     */
    AgentMemoryStatus: AgentMemoryStatus;
    /** AgentMemoryView */
    AgentMemoryView: {
      /** Id */
      id: string;
      /** User Id */
      user_id: string;
      /** Domains */
      domains: string[];
      /** Applies When */
      applies_when: string;
      /** Not Applies When */
      not_applies_when: string | null;
      /** Content */
      content:
        | string
        | {
            [key: string]: unknown;
          };
      /** Examples */
      examples: string[] | null;
      /** Type */
      type: string;
      /** Source */
      source: string;
      /** Owner */
      owner: string;
      /** Status */
      status: string;
      evidence_cache: components['schemas']['EvidenceCacheView'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Last Used At */
      last_used_at: string | null;
    };
    /**
     * AgentResponse
     * @description Response model for agent operations.
     */
    AgentResponse: {
      /** Agents */
      agents: components['schemas']['Agent'][];
      /**
       * Total Count
       * @default 0
       */
      total_count: number;
    };
    /**
     * AgentRunDetailsResponse
     * @description Subject-owned run snapshot for FE stream recovery.
     *
     *     Excludes actor ids, runtime context, Temporal URLs, and config snapshots.
     *     ``prompt_context_failures`` is also omitted — an IA-admin-only diagnostic.
     */
    AgentRunDetailsResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Title */
      title?: string | null;
      /**
       * Status
       * @enum {string}
       */
      status: AgentRunDetailsResponseStatus;
      /** Kind */
      kind?: string | null;
      /** Source Config Id */
      source_config_id?: string | null;
      /** Source Config Version */
      source_config_version?: number | null;
      /** Source Schedule Id */
      source_schedule_id?: string | null;
      /** Parent Agent Run Id */
      parent_agent_run_id?: string | null;
      /** Latest Turn Id */
      latest_turn_id?: string | null;
      /**
       * Input State
       * @enum {string}
       */
      input_state: AgentRunDetailsResponseInput_state;
      /** Can Submit */
      can_submit: boolean;
      /** @default manual */
      approval_mode: components['schemas']['ApprovalMode'];
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Messages */
      messages: components['schemas']['pkg__agent_harness__core__llm_contracts__Message'][];
      /** Artifacts */
      artifacts?: components['schemas']['ArtifactViewV1'][];
      /** Stream Cursor */
      stream_cursor?: string | null;
      /** Approvals */
      approvals: components['schemas']['ToolApprovalRequestPublic'][];
      usage?: components['schemas']['PublicRunUsageSummary'] | null;
      /** Child Runs */
      child_runs?: components['schemas']['ChildRunSummary'][];
    };
    /**
     * AgentRunResponse
     * @description Product-facing run record.
     *
     *     Two identities are exposed:
     *
     *     - ``actor_user_id``: internal-admin uid that started the run. Used for
     *       run/config scoping. Mutating endpoints (close / submit / cancel)
     *       accept either this actor or ``subject_user_id`` when the subject is
     *       also an IA uid.
     *     - ``subject_user_id``: identity the run acts on behalf of (Scribe/Kinde
     *       or another IA uid). Tools see this as ``ctx.user_id``.
     *
     *     Semantic notes and known gaps:
     *
     *     - **Eventually consistent relative to ``POST /turns``.**
     *       ``input_state`` updates asynchronously once the workflow activity
     *       that marks the turn active runs. Use ``SubmitTurnResponse`` to
     *       attach immediately after submit.
     *     - **Best-effort write.** The workflow logs and swallows failures
     *       on the turn-start write so a transient store problem cannot fail
     *       a real turn. The turn-complete clear is part of the
     *       persist-turn transaction and is authoritative.
     *     - **Queued turns are intentionally invisible.** If a turn is
     *       submitted while another is in flight, the second one sits in the
     *       workflow's pending queue. This contract answers "can the user
     *       submit now?", not "how many turns are queued?".
     *     - **SSE does not self-terminate.** The run-scoped SSE stream at
     *       ``/agent-harness/runs/{agent_run_id}/stream`` (constructed
     *       client-side from ``agent_run_id``)
     *       does not emit a terminator or close naturally; it relies on
     *       client disconnect. The run state is the correct reconnect /
     *       unlock signal — clients that only wait for the SSE stream to end
     *       on its own will still hang. Clients should use ``input_state`` /
     *       ``can_submit`` to decide when to unlock input.
     */
    AgentRunResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Title */
      title?: string | null;
      /** Actor User Id */
      actor_user_id: string;
      /** Subject User Id */
      subject_user_id: string;
      /** Parent Agent Run Id */
      parent_agent_run_id?: string | null;
      /**
       * Status
       * @enum {string}
       */
      status: AgentRunResponseStatus;
      /** Kind */
      kind?: string | null;
      agent_config_snapshot: components['schemas']['pkg__agent_harness__core__config__AgentConfig'];
      /** Source Config Id */
      source_config_id?: string | null;
      /** Source Config Version */
      source_config_version?: number | null;
      /** Source Schedule Id */
      source_schedule_id?: string | null;
      trigger_ref?: components['schemas']['WorkflowTriggerRef'] | null;
      /** Latest Turn Id */
      latest_turn_id?: string | null;
      approval_mode?: components['schemas']['ApprovalMode'] | null;
      /**
       * Input State
       * @enum {string}
       */
      input_state: AgentRunResponseInput_state;
      /** Can Submit */
      can_submit: boolean;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Temporal Workflow Url */
      temporal_workflow_url?: string | null;
      usage?: components['schemas']['RunUsageSummary'] | null;
    };
    /** AgentScheduleResponse */
    AgentScheduleResponse: {
      /** Schedule Id */
      schedule_id: string;
      /** Temporal Schedule Id */
      temporal_schedule_id: string;
      /** Actor User Id */
      actor_user_id: string;
      /** Subject User Id */
      subject_user_id: string;
      dispatch_action: components['schemas']['ScheduleDispatchActionResponse'];
      target_context?: components['schemas']['AgentTargetContext'] | null;
      /** Display Name */
      display_name: string;
      /** Description */
      description: string;
      spec: components['schemas']['ScheduleSpecModel'];
      /** Paused */
      paused: boolean;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Temporal Schedule Url */
      temporal_schedule_url?: string | null;
      latest_run?: components['schemas']['LatestRunSummaryResponse'] | null;
      /** Workflow Id */
      workflow_id?: string | null;
      /** Workflow Display Name */
      workflow_display_name?: string | null;
      /** Product Surface */
      product_surface?: string | null;
    };
    /** AgentSummaryView */
    AgentSummaryView: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Display Name */
      display_name?: string | null;
    };
    /**
     * AgentTargetContext
     * @description Validated product/domain target values for an agent run.
     *
     *     These values may originate from a request (e.g. IA selecting a session),
     *     but once accepted they are frozen as part of the harness-owned runtime
     *     context. Identity fields intentionally live on ``AgentRuntimeContext``.
     */
    AgentTargetContext: {
      /** Team Id */
      team_id?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      /** Session Id */
      session_id?: string | null;
      /** Note Id */
      note_id?: string | null;
    };
    /**
     * AgentToolConfig
     * @description One tool entry in an agent's tool list.
     *
     *     ``name`` is the registered ``ToolSpec`` name. ``as_name`` is the
     *     optional LLM-facing binding name; when omitted, the registry name is
     *     also exposed to the LLM. This keeps existing configs
     *     (``AgentToolConfig(name="search")``) valid while allowing callers to
     *     bind the same registry tool multiple times under different names.
     *
     *     ``fixed_input`` binds static values for a subset of the tool's input
     *     arguments at config time. Keys present here are removed from the
     *     ``ToolDefinition.input_schema`` exposed to the LLM (so the LLM does
     *     not generate them) and overwrite any same-key values the LLM tries
     *     to produce at the workflow merge site. Precedence is
     *     ``approval modified_input > fixed_input > LLM tool_call.input``; an
     *     operator ``modified_input`` is a full replacement, not a per-key
     *     merge.
     *
     *     ``fixed_input`` is a binding concern, not a runtime concern — it
     *     lives here rather than on ``AgentToolPolicy`` so "how a tool runs"
     *     stays separate from "what input it runs with".
     *
     *     Multi-binding note: ``ToolSpec.max_calls_per_session`` is enforced
     *     per exposed binding name, not per backing registry tool. Two
     *     bindings to the same ``ToolSpec`` get independent per-session call
     *     budgets; ``N`` aliases of a tool with limit ``L`` allow ``N*L``
     *     total invocations against the underlying spec. Tighten the limit
     *     at the spec level if a registry-wide cap is needed.
     */
    AgentToolConfig: {
      /** Name */
      name: string;
      /** As Name */
      as_name?: string | null;
      /** Description */
      description?: string | null;
      /**
       * Enabled
       * @default true
       */
      enabled: boolean;
      policy?: components['schemas']['AgentToolPolicy'];
      /** Fixed Input */
      fixed_input?: {
        [key: string]: unknown;
      };
      /** Llm Presentation */
      llm_presentation?: string | null;
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      };
    };
    /**
     * AgentToolPolicy
     * @description Per-tool overrides applied at resolution time.
     *
     *     ``None`` for ``timeout_seconds`` / ``max_retries`` means inherit from
     *     the registered ``ToolSpec``. ``approval_mode="inherit"`` falls back to
     *     the spec's risk-tier rule.
     *
     *     ``timeout_seconds`` must be strictly positive (Temporal rejects a non-
     *     positive ``start_to_close_timeout``) and ``max_retries`` must be non-
     *     negative (the workflow derives ``maximum_attempts = max_retries + 1``,
     *     so a negative value would produce an invalid ``RetryPolicy``). Pydantic
     *     validates both at the contract boundary so an API caller cannot smuggle
     *     a bad value through to Temporal scheduling.
     *
     *     ``extra_scopes`` is recorded in the contract for forward compatibility
     *     but is rejected at resolution time — the FGA seam is not yet wired.
     */
    AgentToolPolicy: {
      /** Timeout Seconds */
      timeout_seconds?: number | null;
      /** Max Retries */
      max_retries?: number | null;
      /**
       * Approval Mode
       * @default inherit
       * @enum {string}
       */
      approval_mode: AgentToolPolicyApproval_mode;
      /** Approval Kind */
      approval_kind?: string | null;
      /**
       * Auto Mode Bypassable
       * @default true
       */
      auto_mode_bypassable: boolean;
      /** Extra Scopes */
      extra_scopes?: string[];
      /** Publish Frontend Event Packs */
      publish_frontend_event_packs?: string[] | null;
    };
    /**
     * AgentVoiceSpec
     * @description A per-language voice pick on an agent's ``voices_by_language`` map.
     *
     *     Mirrors the provider-discriminated ``VoiceSpec`` on ai-receptionist-be
     *     (``CartesiaVoice`` / ``ElevenLabsVoice``). ``provider`` is modeled as a
     *     plain ``str`` — not a ``Literal``/enum — so a new upstream provider
     *     degrades to passthrough instead of a Pydantic ``ValidationError`` at the
     *     BFF; ``extra = "allow"`` keeps any provider-specific knobs we don't model
     *     here. Voices are pinned by raw ``voice_id`` (no label indirection).
     */
    AgentVoiceSpec: {
      /** Provider */
      provider: string;
      /** Voice Id */
      voice_id: string;
      /** Speed */
      speed?: number | null;
      /** Model Id */
      model_id?: string | null;
    } & {
      [key: string]: unknown;
    };
    /**
     * AlayaCareEHRLaunchProfileAdditionalDetails
     * @description Additional details specific to AlayaCare EHR launch profiles.
     *
     *     Allows admin-curated subsets of clinical note types and upload folder
     *     destinations to be configured per launch profile rather than hard-coded.
     */
    AlayaCareEHRLaunchProfileAdditionalDetails: {
      /** Permitted Note Types */
      permitted_note_types?: string[];
      /**
       * Permitted Upload Folders
       * @default []
       */
      permitted_upload_folders: string[];
    };
    /**
     * AllergyIntolerance
     * @description Risk of harmful or undesirable physiological response which is unique to an individual
     *     and associated with exposure to a substance.
     *
     *     A record of a clinical assessment of an allergy or intolerance; a propensity, or a
     *     potential risk to an individual, to have an adverse reaction on future exposure to the
     *     specified substance, or class of substance.
     *
     *     https://hl7.org/fhir/R4/allergyintolerance-definitions.html
     */
    AllergyIntolerance: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * External ids for this item
       * @description Business identifiers assigned to this AllergyIntolerance by the performer or other systems which remain constant as the resource is updated and propagates from server to server.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * active | inactive | resolved
       * @description The clinical status of the allergy or intolerance.
       */
      clinicalStatus?: components['schemas']['CodeableConcept'] | null;
      /**
       * unconfirmed | confirmed | refuted | entered-in-error
       * @description Assertion about certainty associated with the propensity, or potential risk, of a reaction to the identified substance (including pharmaceutical product).
       */
      verificationStatus?: components['schemas']['CodeableConcept'] | null;
      /**
       * allergy | intolerance - Underlying mechanism (if known)
       * @description Identification of the underlying physiological mechanism for the reaction risk.
       */
      type?: components['schemas']['AllergyIntoleranceType'] | null;
      /**
       * food | medication | environment | biologic
       * @description Category of the identified substance.
       */
      category?: components['schemas']['AllergyIntoleranceCategory'][] | null;
      /**
       * low | high | unable-to-assess
       * @description Estimate of the potential clinical harm, or seriousness, of the reaction to the identified substance.
       */
      criticality?: components['schemas']['AllergyIntoleranceCriticality'] | null;
      /**
       * Code that identifies the allergy or intolerance
       * @description Code for an allergy or intolerance statement (either a positive or a negated/excluded statement). This may be a code for a substance or pharmaceutical product that is considered to be responsible for the adverse reaction risk.
       */
      code?: components['schemas']['CodeableConcept'] | null;
      /**
       * Who the sensitivity is for
       * @description The patient who has the allergy or intolerance.
       */
      patient: components['schemas']['Reference'];
      /**
       * Encounter when the allergy or intolerance was asserted
       * @description The encounter when the allergy or intolerance was asserted.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * When allergy or intolerance was identified (dateTime)
       * @description Estimated or actual date, date-time, or age when allergy or intolerance was identified.
       */
      onsetDateTime?: string | null;
      /**
       * When allergy or intolerance was identified (string)
       * @description Estimated or actual date, date-time, or age when allergy or intolerance was identified.
       */
      onsetString?: string | null;
      /**
       * When allergy or intolerance was identified (Age)
       * @description Estimated or actual date, date-time, or age when allergy or intolerance was identified.
       */
      onsetAge?: components['schemas']['Age'] | null;
      /**
       * When allergy or intolerance was identified (Period)
       * @description Estimated or actual date, date-time, or age when allergy or intolerance was identified.
       */
      onsetPeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * When allergy or intolerance was identified (Range)
       * @description Estimated or actual date, date-time, or age when allergy or intolerance was identified.
       */
      onsetRange?: components['schemas']['Range'] | null;
      /**
       * Date first version of the resource instance was recorded
       * @description The recordedDate represents when this particular AllergyIntolerance record was created in the system, which is often a system-generated date.
       */
      recordedDate?: string | null;
      /**
       * Who recorded the sensitivity
       * @description Individual who recorded the record and takes responsibility for its content.
       */
      recorder?: components['schemas']['Reference'] | null;
      /**
       * Source of the information about the allergy
       * @description The source of the information about the allergy that is recorded.
       */
      asserter?: components['schemas']['Reference'] | null;
      /**
       * Date(/time) of last known occurrence of a reaction
       * @description Represents the date and/or time of the last known occurrence of a reaction event.
       */
      lastOccurrence?: string | null;
      /**
       * Additional text not captured in other fields
       * @description Additional narrative about the propensity for the Adverse Reaction, not captured in other fields.
       */
      note?: components['schemas']['Annotation'][] | null;
      /**
       * Adverse Reaction Events linked to exposure to substance
       * @description Details about each adverse reaction event linked to exposure to the identified substance.
       */
      reaction?: components['schemas']['AllergyIntoleranceReaction'][] | null;
    };
    /**
     * AllergyIntoleranceCategory
     * @description Category of the identified substance associated with allergies or intolerances.
     *
     *     https://hl7.org/fhir/R4/valueset-allergy-intolerance-category.html
     * @enum {string}
     */
    AllergyIntoleranceCategory: AllergyIntoleranceCategory;
    /**
     * AllergyIntoleranceClinicalStatusCodes
     * @description Preferred value set for AllergyIntolerance clinical status.
     *
     *     Used to construct CodeableConcept values with the correct coding system.
     *     System: :data:`ALLERGY_INTOLERANCE_CLINICAL_STATUS_SYSTEM`
     *
     *     https://hl7.org/fhir/R4/valueset-allergyintolerance-clinical.html
     * @enum {string}
     */
    AllergyIntoleranceClinicalStatusCodes: AllergyIntoleranceClinicalStatusCodes;
    /**
     * AllergyIntoleranceCriticality
     * @description Estimate of the potential clinical harm, or seriousness, of a reaction to an identified substance.
     *
     *     https://hl7.org/fhir/R4/valueset-allergy-intolerance-criticality.html
     * @enum {string}
     */
    AllergyIntoleranceCriticality: AllergyIntoleranceCriticality;
    /**
     * AllergyIntoleranceReaction
     * @description Adverse reaction events linked to exposure to substance.
     *
     *     https://hl7.org/fhir/R4/allergyintolerance-definitions.html#AllergyIntolerance.reaction
     */
    AllergyIntoleranceReaction: {
      /**
       * Specific substance or pharmaceutical product considered to be responsible for event
       * @description Identification of the specific substance (or pharmaceutical product) considered to be responsible for the Adverse Reaction event.
       */
      substance?: components['schemas']['CodeableConcept'] | null;
      /**
       * Clinical symptoms/signs associated with the Event
       * @description Clinical symptoms and/or signs that are observed or associated with the adverse reaction event.
       */
      manifestation: components['schemas']['CodeableConcept'][];
      /**
       * Description of the event as a whole
       * @description Text description about the reaction as a whole, including details of the manifestation if required.
       */
      description?: string | null;
      /**
       * Date(/time) when manifestations showed
       * @description Record of the date and/or time of the onset of the Reaction.
       */
      onset?: string | null;
      /**
       * mild | moderate | severe (of event as a whole)
       * @description Clinical assessment of the severity of the reaction event as a whole.
       */
      severity?: components['schemas']['AllergyIntoleranceSeverity'] | null;
      /**
       * How the subject was exposed to the substance
       * @description Identification of the route by which the subject was exposed to the substance.
       */
      exposureRoute?: components['schemas']['CodeableConcept'] | null;
      /**
       * Text about event not captured in other fields
       * @description Additional text about the adverse reaction event not captured in other fields.
       */
      note?: components['schemas']['Annotation'][] | null;
    };
    /**
     * AllergyIntoleranceSeverity
     * @description Clinical assessment of the severity of a reaction event as a whole.
     *
     *     https://hl7.org/fhir/R4/valueset-reaction-event-severity.html
     * @enum {string}
     */
    AllergyIntoleranceSeverity: AllergyIntoleranceSeverity;
    /**
     * AllergyIntoleranceType
     * @description Identification of the underlying physiological mechanism for a reaction risk.
     *
     *     https://hl7.org/fhir/R4/valueset-allergy-intolerance-type.html
     * @enum {string}
     */
    AllergyIntoleranceType: AllergyIntoleranceType;
    /**
     * AmaSuggestedQuestionsRequest
     * @description Client hints for generating AMA follow-up suggestions.
     *
     *     The user/assistant turns are derived server-side from the agent-run
     *     transcript (the server is authoritative — the client never supplies
     *     conversation content), so the body only carries presentation hints.
     */
    AmaSuggestedQuestionsRequest: {
      /**
       * Display Language
       * @description Display language code (e.g. 'en', 'es') for the generated questions. Defaults to English when omitted.
       */
      display_language?: string | null;
    };
    /**
     * AnaccFindingDO
     * @description One AN-ACC reassessment flag. NOT a score - evidence + rationale only.
     */
    AnaccFindingDO: {
      /** Domain */
      domain: string;
      /** Signal */
      signal: string;
      /** Implied Higher Need */
      implied_higher_need: boolean;
      /** Severity */
      severity: string;
      /** Rationale */
      rationale: string;
      /** Note Excerpt */
      note_excerpt: string;
      /**
       * Suggested Action
       * @default consider reassessment
       */
      suggested_action: string;
    };
    /**
     * AnaccFindingsData
     * @description AN-ACC pass output.
     *
     *     None on ClinicalNotesAnalysis.anacc_findings means the pass did not run or
     *     failed. A present object with findings=[] means the pass ran successfully and
     *     found no valid findings.
     */
    AnaccFindingsData: {
      /** Findings */
      findings?: components['schemas']['AnaccFindingDO'][];
    };
    /**
     * AnalysisSource
     * @description Trigger that produced the analysis.
     * @enum {string}
     */
    AnalysisSource: AnalysisSource;
    /**
     * AnalysisStatus
     * @description Lifecycle state of a ClinicalNotesAnalysis document.
     *
     *     Manual runs insert with `completed` (single synchronous call produces a
     *     terminal document). Auto runs progress through
     *     pending -> extracting -> awaiting_note -> verifying -> completed,
     *     with `failed` as a terminal error state at any stage.
     * @enum {string}
     */
    AnalysisStatus: AnalysisStatus;
    /**
     * AnalysisTimings
     * @description Step-level timing data for the analysis pipeline.
     */
    AnalysisTimings: {
      /** Extraction Ms */
      extraction_ms: number;
      /** Verification Ms */
      verification_ms: number;
      /** Total Ms */
      total_ms: number;
    };
    /** AnalyticsDashboardResponse */
    AnalyticsDashboardResponse: {
      /** Url */
      url: string;
    };
    /**
     * AnalyzeNoteResponse
     * @description Response schema for analyze note endpoint.
     */
    AnalyzeNoteResponse: {
      analysis: components['schemas']['ClinicalNotesAnalysisResponse'];
      /**
       * Message
       * @default Analysis completed successfully
       */
      message: string;
      timings?: components['schemas']['AnalysisTimings'] | null;
    };
    /** AndroidApp */
    AndroidApp: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: AndroidAppType;
      /** @default Native */
      recording_source: components['schemas']['AppRecordingSource'];
    };
    /**
     * Annotation
     * @description A text note which also contains information about who made the statement and when.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Annotation
     */
    Annotation: {
      /**
       * Individual responsible for the annotation
       * @description The individual responsible for making the annotation.
       */
      authorString?: string | null;
      /**
       * When the annotation was made
       * @description Indicates when this particular annotation was made.
       */
      time?: string | null;
      /**
       * The annotation - text content
       * @description The text of the annotation in markdown format.
       */
      text: string;
    };
    /** Answer */
    Answer: {
      /** Value */
      value?: string | null;
      /** Additionaldetails */
      additionalDetails?: string | null;
    };
    /** AnswerOption */
    AnswerOption: {
      /** Value */
      value: string;
      /** Metadata */
      metadata?: {
        [key: string]: string;
      } | null;
    };
    /** ApiRequestInfo */
    ApiRequestInfo: {
      /**
       * Request Id
       * Format: uuid
       * @description api request_id, if a api call have multiple llm call, the request_id will be the same.
       */
      request_id?: string;
      /** Request Path */
      request_path: string;
      /**
       * Request Method
       * @description HTTP method of the request (GET, POST, PATCH, DELETE, etc.)
       */
      request_method?: string | null;
    };
    /**
     * ApiStatusCheckLog
     * @description A record of a single API status check run by a user from the settings page.
     */
    ApiStatusCheckLog: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      _id?: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
      /**
       * Kinde User Id
       * @description Kinde user ID of the user who ran the check.
       */
      kinde_user_id: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp?: string;
      /**
       * Results
       * @description Per-domain probe results captured at run time.
       */
      results?: components['schemas']['DomainCheckResult'][];
    };
    /** ApiStatusCheckLogListResponse */
    ApiStatusCheckLogListResponse: {
      /** Logs */
      logs: components['schemas']['ApiStatusCheckLog'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
      /** Total Pages */
      total_pages: number;
      /** Has Next Page */
      has_next_page: boolean;
    };
    /**
     * AppRecordingSource
     * @description Where the client app is sourcing the recording from.
     * @enum {string}
     */
    AppRecordingSource: AppRecordingSource;
    /**
     * AppleMigrationStatus
     * @description Outcome of an ``assign-apple-migration-ticket`` call.
     *
     *     Scoped to the Apple-social login Kinde→Auth0 migration. The value is
     *     derived from the user's persistent ``auth0_sync_state`` plus (for active
     *     ticket states) whether the Redis ticket is still alive. See the use
     *     case for the full state→response mapping.
     *
     *     - ``TICKET_CREATED``: user is in the ``APPLE_MIGRATION_TICKET_CREATED``
     *       persistent state — i.e. their current ticket is the FIRST one minted
     *       for them and hasn't yet been replaced after a Redis expiry. The
     *       returned ``ticket_id`` is the one to hand to the Auth0 redemption
     *       flow. (Note: this is a persistent-state signal, not a per-call action
     *       signal — repeat calls during the lifetime of the original ticket
     *       return this same value even though the server is internally just
     *       extending the TTL.)
     *     - ``TICKET_REFRESHED``: user is in the
     *       ``APPLE_MIGRATION_TICKET_REFRESHED`` persistent state — i.e. at least
     *       one prior ticket already expired in Redis and they've been issued a
     *       replacement (analytics signal: "user needed more than one ticket").
     *       Identical wire behaviour to ``TICKET_CREATED`` — same ``ticket_id``
     *       field, redeemed the same way.
     *     - ``ALREADY_MIGRATED``: caller's Apple identity has already been migrated
     *       to Auth0 (persistent state is COMPLETED). No ticket returned.
     *     - ``MIGRATION_IN_PROGRESS``: client started redemption (state is INITIATED)
     *       and Auth0 provisioning is in flight. FE should not request a new ticket.
     *       No ticket returned.
     *     - ``MIGRATION_FAILED``: Auth0 provisioning failed (state is FAILED).
     *       Needs manual intervention; FE should surface a "contact support"
     *       affordance rather than auto-retrying via this endpoint. No ticket
     *       returned.
     *     - ``NO_MIGRATION_NEEDED``: caller is not eligible for the Apple-login
     *       Kinde→Auth0 migration. Covers (a) non-Kinde tokens, (b) Kinde users
     *       with no identity profile, and (c) Kinde users whose ``auth0_sync_state``
     *       is a non-Apple-migration value (e.g. ``PENDING``, ``IDENTITY_SYNC_*``).
     *       No ticket returned.
     * @enum {string}
     */
    AppleMigrationStatus: AppleMigrationStatus;
    /**
     * ApplySubscriptionDiscountRequest
     * @description Apply the retention Stripe coupon to the current user's subscription.
     */
    ApplySubscriptionDiscountRequest: {
      discount: components['schemas']['AvailableDiscounts'];
    };
    /** ApplySubscriptionDiscountResponse */
    ApplySubscriptionDiscountResponse: {
      /** Subscription Id */
      subscription_id: string;
    };
    /**
     * Appointment
     * @description A booking of a healthcare event among patient(s), practitioner(s), related person(s) and/or device(s) for a specific date/time. This may result in one or more Encounter(s).
     *
     *     https://hl7.org/fhir/R4/appointment-definitions.html
     */
    Appointment: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * External Ids for this item
       * @description This records identifiers associated with this appointment concern that are defined by business processes and/or used to refer to it when a direct URL reference to the resource itself is not appropriate (e.g. in CDA documents, or in written / printed documentation).
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * proposed | pending | booked | arrived | fulfilled | cancelled | noshow | entered-in-error | checked-in | waitlist
       * @description The overall status of the Appointment. Each of the participants has their own participation status which indicates their involvement in the process, however this status indicates the shared status. None when the status cannot be determined from the source system.
       */
      status?: components['schemas']['AppointmentStatus'] | null;
      /**
       * The specific service that is to be performed during this appointment
       * @description The specific service that is to be performed during this appointment.
       */
      serviceType?: components['schemas']['CodeableConcept'][] | null;
      /**
       * The style of appointment or patient that has been booked in the slot
       * @description The style of appointment or patient that has been booked in the slot (not service type).
       */
      appointmentType?: components['schemas']['CodeableConcept'] | null;
      /**
       * Coded reason this appointment is scheduled
       * @description The coded reason that this appointment is being scheduled. This is more clinical than administrative.
       */
      reasonCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Shown on a subject line in a meeting request, or appointment list
       * @description The brief description of the appointment as would be shown on a subject line in a meeting request, or appointment list. Detailed or expanded information should be put in the comment field.
       */
      description?: string | null;
      /**
       * Additional information to support the appointment
       * @description Additional information to support the appointment provided when making the appointment.
       */
      supportingInformation?: components['schemas']['Reference'][] | null;
      /**
       * When appointment is to take place
       * @description Date/Time that the appointment is to take place.
       */
      start?: string | null;
      /**
       * When appointment is to conclude
       * @description Date/Time that the appointment is to conclude.
       */
      end?: string | null;
      /**
       * Can be less than start/end (e.g. estimate)
       * @description Number of minutes that the appointment is to take. This can be less than the duration between the start and end times.
       */
      minutesDuration?: number | null;
      /**
       * The date that this appointment was initially created
       * @description The date that this appointment was initially created. This could be different to the meta.lastModified value on the initial entry, as this could have been before the resource was created on the FHIR server, and should remain unchanged over the lifespan of the appointment.
       */
      created?: string | null;
      /**
       * Additional comments
       * @description Additional comments about the appointment.
       */
      comment?: string | null;
      /**
       * Detailed information and instructions for the patient
       * @description While Appointment.comment contains information for internal use, Appointment.patientInstruction is used to capture patient facing information about the Appointment (e.g. please bring your referral or fast from 8pm night before).
       */
      patientInstruction?: string | null;
      /**
       * Participants involved in appointment
       * @description List of participants involved in the appointment.
       */
      participant: components['schemas']['AppointmentParticipant_Union_Practitioner__Patient__Location__'][];
    };
    /** AppointmentParticipant[Union[Practitioner, Patient, Location]] */
    AppointmentParticipant_Union_Practitioner__Patient__Location__: {
      /**
       * Role of participant in the appointment
       * @description Role of participant in the appointment.
       */
      type?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Person, Location/HealthcareService or Device
       * @description A Person, Location/HealthcareService or Device that is participating in the appointment.
       */
      actor?: components['schemas']['Reference'] | null;
      /**
       * required | optional | information-only
       * @description Whether this participant is required to be present at the meeting. This covers a use-case where two doctors need to meet to discuss a case, and one of the doctors is optional.
       */
      required?: components['schemas']['ParticipantRequired'] | null;
      /**
       * accepted | declined | tentative | needs-action
       * @description Participation status of the actor.
       */
      status: components['schemas']['ParticipationStatus'];
      /**
       * Participation period of the actor
       * @description Participation period of the actor.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
    };
    /**
     * AppointmentStatus
     * @description Values and descriptions are sourced from
     *     https://hl7.org/fhir/codesystem-appointmentstatus.html
     * @enum {string}
     */
    AppointmentStatus: AppointmentStatus;
    /**
     * AppointmentTranscriptMatch
     * @description Ranked EHR appointment row aligned to the session transcript.
     */
    AppointmentTranscriptMatch: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      entity_type: AppointmentTranscriptMatchEntity_type;
      /**
       * Confidence
       * @description Weighted mean of per-field fuzzy scores over the extracted attributes this candidate can answer (comparable fields); 1.0 when every comparable field fully matches this candidate.
       */
      confidence: number;
      /**
       * Corroborated Field Names
       * @description Extracted field names that fully matched this candidate's stored data — field names only, never values. None on candidates stored before this detail existed.
       */
      corroborated_field_names?: string[] | null;
      /**
       * Conflicting Field Names
       * @description Comparable extracted field names that disagreed with this candidate's stored data — field names only, never values. None on candidates stored before this detail existed.
       */
      conflicting_field_names?: string[] | null;
      /**
       * Evidence Weight
       * @description Cumulative importance-weighted fuzzy score over comparable fields; breaks ties between equal-confidence candidates. None on legacy stored candidates.
       */
      evidence_weight?: number | null;
      /** @description Whether this candidate's stored clinical data agrees with the transcript. Only set when identity evidence left a tie the evidence-weight margin could not break; None everywhere else, which reads the same as a comparison that never ran. */
      clinical_verdict?: components['schemas']['ClinicalComparisonVerdict'] | null;
      /**
       * Clinical Verdict Field Names
       * @description Stored profile fields that drove the clinical verdict — field names only, never values.
       */
      clinical_verdict_field_names?: string[] | null;
      /**
       * Clinical Verdict Reason
       * @description One short sentence explaining the clinical verdict. May name conditions or medications, so it is PHI: persisted and shown on the PHI tier of the admin inspector, never logged.
       */
      clinical_verdict_reason?: string | null;
      /** Appointment Record Id */
      appointment_record_id: string;
    };
    /** ApprovalResponse */
    ApprovalResponse: {
      /** Approval Id */
      approval_id: string;
      /** Agent Run Id */
      agent_run_id: string;
      /** Turn Id */
      turn_id: string;
      /** Tool Call Id */
      tool_call_id: string;
      /** Tool Name */
      tool_name: string;
      /** Tool Input */
      tool_input: {
        [key: string]: unknown;
      };
      tool_input_merge?: components['schemas']['ToolInputMerge'] | null;
      /**
       * Status
       * @enum {string}
       */
      status: ApprovalResponseStatus;
      /** Reason */
      reason: string;
      /** Modified Input */
      modified_input?: {
        [key: string]: unknown;
      } | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Resolved At */
      resolved_at?: string | null;
      /** Resolved By */
      resolved_by?: string | null;
      /**
       * Approval Kind
       * @default default
       */
      approval_kind: string;
      /** Available Override Scopes */
      available_override_scopes?: ApprovalResponseAvailable_override_scopes[];
    };
    /** ApprovedReviewerListResponse */
    ApprovedReviewerListResponse: {
      /** Items */
      items: components['schemas']['ApprovedReviewerResponse'][];
    };
    /** ApprovedReviewerResponse */
    ApprovedReviewerResponse: {
      /** Email */
      email: string;
      /** Name */
      name: string;
    };
    /**
     * ArgmaxProxyRequestSchema
     * @description Mirrors Argmax SDK ApiRequest / APIRequest fields for JSON transport.
     */
    ArgmaxProxyRequestSchema: {
      /**
       * Url
       * @description Full Argmax API URL, e.g. https://api.argmaxinc.com/v1/license-token/create
       */
      url: string;
      /**
       * Method
       * @description HTTP method (POST, GET, etc.)
       */
      method: string;
      /**
       * Headers
       * @description Request headers from the SDK (including AX-API-KEY).
       */
      headers?: {
        [key: string]: string;
      };
      /**
       * Body
       * @description Optional request body, base64-encoded.
       */
      body?: string | null;
    };
    /**
     * ArgmaxProxyResponseSchema
     * @description Mirrors Argmax SDK ApiResponse / APIResponse fields for JSON transport.
     */
    ArgmaxProxyResponseSchema: {
      /** Status Code */
      status_code: number;
      /** Headers */
      headers: {
        [key: string]: string;
      };
      /**
       * Body
       * @description Response body, base64-encoded.
       */
      body: string;
    };
    /** AskAIRequestV2 */
    AskAIRequestV2: {
      /** Ai Command Text */
      ai_command_text?: string | null;
      /** Content */
      content: string;
      content_type?: components['schemas']['ContentType'] | null;
    };
    /** AssignAccessEntitlementRequest */
    AssignAccessEntitlementRequest: {
      /**
       * Entitlement Type Id
       * @description ID of the AccessEntitlementType to assign. If both id and name are sent, id is used to resolve the type.
       */
      entitlement_type_id?: string | null;
      /**
       * Entitlement Type Name
       * @description Unique name of the AccessEntitlementType (e.g. genie_integration). Used when entitlement_type_id is omitted or empty.
       */
      entitlement_type_name?: string | null;
      /**
       * Enabled
       * @description Whether this entitlement should be enabled
       * @default true
       */
      enabled: boolean;
    };
    /**
     * AssignAppleMigrationTicketResponse
     * @description Response payload for ``POST /assign-apple-migration-ticket``.
     *
     *     Scoped to the Apple-social login Kinde→Auth0 migration. The ``status``
     *     is derived from the calling user's persistent ``auth0_sync_state`` on
     *     ``IdentityProfile`` (and, for active ticket states, whether the Redis
     *     ticket is still alive). ``ticket_id`` is present only when ``status`` is
     *     ``TICKET_CREATED`` or ``TICKET_REFRESHED``; ``null`` for all other
     *     statuses.
     * @example {
     *       "status": "ticket_created",
     *       "ticket_id": "01939d8e-7c4a-7b3f-9c2d-1a2b3c4d5e6f"
     *     }
     * @example {
     *       "status": "ticket_refreshed",
     *       "ticket_id": "01939d8e-9a1b-7c2d-8e3f-4a5b6c7d8e9f"
     *     }
     * @example {
     *       "status": "already_migrated"
     *     }
     * @example {
     *       "status": "migration_in_progress"
     *     }
     * @example {
     *       "status": "migration_failed"
     *     }
     * @example {
     *       "status": "no_migration_needed"
     *     }
     */
    AssignAppleMigrationTicketResponse: {
      /**
       * @description Outcome of the assign-apple-migration-ticket call. One of:
       *
       *     - ``ticket_created``: hand ``ticket_id`` to the Auth0 redemption flow.
       *     - ``ticket_refreshed``: same as above; the original ticket expired in Redis and was re-minted.
       *     - ``already_migrated``: this user is already on Auth0; skip migration.
       *     - ``migration_in_progress``: redemption has started and Auth0 provisioning is in flight; don't request another ticket.
       *     - ``migration_failed``: provisioning failed; needs manual intervention.
       *     - ``no_migration_needed``: caller is outside the Apple-migration funnel (non-Kinde token, or Kinde user with no Apple identity).
       * @example ticket_created
       */
      status: components['schemas']['AppleMigrationStatus'];
      /**
       * Ticket Id
       * @description UUID v7 Apple migration ticket identifier (canonical 36-char hyphenated string). Present when status is ``ticket_created`` or ``ticket_refreshed``; ``null`` for all other statuses. Validated as a real UUIDv7 server-side.
       * @example 01939d8e-7c4a-7b3f-9c2d-1a2b3c4d5e6f
       */
      ticket_id?: string | null;
    };
    /** AssignProfileGroupRequest */
    AssignProfileGroupRequest: {
      /** Profile Names */
      profile_names: string[];
      /** Profile Group */
      profile_group: string;
    };
    /** AssignProfileGroupResponse */
    AssignProfileGroupResponse: {
      /** Profiles */
      profiles: components['schemas']['EHRLaunchProfile'][];
    };
    /** AssignTaskRequest */
    AssignTaskRequest: {
      /** Assignee Id */
      assignee_id: string;
      /** @default user */
      assignee_type: components['schemas']['AssigneeType'];
    };
    /**
     * AssigneeType
     * @enum {string}
     */
    AssigneeType: AssigneeType;
    /** AssigneeView */
    AssigneeView: {
      /** Id */
      id: string;
      type: components['schemas']['AssigneeType'];
    };
    /**
     * AssignmentFilter
     * @enum {string}
     */
    AssignmentFilter: AssignmentFilter;
    /**
     * Association
     * @description Links a generated object to related objects by UID.
     */
    Association: {
      type: components['schemas']['AssociationType'];
      /** Objectids */
      objectIds: string[];
    };
    /**
     * AssociationType
     * @example diagnosis
     * @example notesection
     */
    AssociationType: string;
    /**
     * AsyncExecuteScriptResponse
     * @description Response schema for fire-and-forget async script execution.
     *
     *     Returned with HTTP 202 Accepted when the request specifies
     *     `async_execution=True`. The script continues running server-side after
     *     the response is sent; correlate by `execution_id` in application logs.
     */
    AsyncExecuteScriptResponse: {
      /**
       * Execution Id
       * @description UUID identifying this run; appears on every log line emitted by the background task
       */
      execution_id: string;
      /**
       * Script Name
       * @description Name of the script that was scheduled
       */
      script_name: string;
      /**
       * Executed At
       * Format: date-time
       * @description Timestamp when the script was scheduled
       */
      executed_at: string;
      /**
       * Params Received
       * @description Parameters that were passed to the script
       */
      params_received: {
        [key: string]: unknown;
      };
      /**
       * Status
       * @description Lifecycle marker; always 'scheduled' on the 202 response
       * @default scheduled
       * @constant
       */
      status: 'scheduled';
    };
    /** AthenaCreateAdaptorRequest */
    AthenaCreateAdaptorRequest: {
      /**
       * Ehr Provider
       * @default athenahealth
       * @constant
       */
      ehr_provider: 'athenahealth';
      /** Practice Id */
      practice_id: string;
    };
    /**
     * Attachment
     * @description Content in a format defined elsewhere.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Attachment
     */
    Attachment: {
      /**
       * Mime type of the content, with charset etc.
       * @description Identifies the type of the data in the attachment and allows a method to be chosen to interpret or render the data. Includes mime type parameters such as charset where appropriate.
       */
      contentType?: string | null;
      /**
       * Human language of the content (BCP-47)
       * @description The human language of the content. The value can be any valid value according to BCP 47.
       */
      language?: string | null;
      /**
       * Data inline, base64ed
       * @description The actual data of the attachment - a sequence of bytes, base64 encoded.
       */
      data?: string | null;
      /**
       * Uri where the data can be found
       * @description A location where the data can be accessed.
       */
      url?: string | null;
      /**
       * Number of bytes of content (if url provided)
       * @description The number of bytes of data that make up this attachment (before base64 encoding, if that is done).
       */
      size?: number | null;
      /**
       * Hash of the data (sha-1, base64ed)
       * @description The calculated hash of the data using SHA-1. Represented using base64.
       */
      hash?: string | null;
      /**
       * Label to display in place of the data
       * @description A label or set of text to display in place of the data.
       */
      title?: string | null;
      /**
       * Date attachment was first created
       * @description The date that the attachment was first created.
       */
      creation?: string | null;
    };
    /**
     * AttachmentBlock
     * @description A reference to a user-supplied file stored outside the transcript.
     */
    AttachmentBlock: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: AttachmentBlockKind;
      /** Attachment Id */
      attachment_id: string;
      /** Filename */
      filename: string;
      /** Mime Type */
      mime_type: string;
      /**
       * Attachment Type
       * @enum {string}
       */
      attachment_type: AttachmentBlockAttachment_type;
      /** Size Bytes */
      size_bytes?: number | null;
      /** Provider Metadata */
      provider_metadata?: {
        [key: string]: unknown;
      };
      /** Hydrated Source */
      hydrated_source?: {
        [key: string]: unknown;
      } | null;
      /** Owner Agent Run Id */
      owner_agent_run_id?: string | null;
    };
    /**
     * AttachmentInput
     * @description A file attachment supplied at ticket creation time.
     */
    AttachmentInput: {
      /** Filename */
      filename: string;
      /** Content Type */
      content_type: string;
      /** Data */
      data: string;
    };
    /**
     * AttachmentProjectionConfig
     * @description Provider-facing attachment projection knobs.
     *
     *     Attachment projection does not mutate canonical artefacts or view
     *     membership. It only controls how active messages are projected for one
     *     provider call after ``LLMView`` has already been loaded.
     *
     *     The projection runs unconditionally (no token-pressure trigger), mirroring
     *     Anthropic's computer-use ``only_n_most_recent_images`` filter: older
     *     tool-result attachments are replaced with recoverable refs while the most
     *     recent ones stay inline. Removal is chunked in multiples of
     *     ``retain_recent_attachments`` to protect the provider prompt cache, so the
     *     live prompt carries between N and ``2 * N - 1`` attachments.
     */
    AttachmentProjectionConfig: {
      /**
       * Retain Recent Attachments
       * @default 1
       */
      retain_recent_attachments: number;
    };
    /**
     * AudioChunkOverviewInfo
     * @description Audio chunk information for overview endpoint.
     *     Unified format for both V1 (audio_transcript collection) and V2 (external transcription service events).
     *     Contains metadata about each audio chunk without transcript content (PII).
     */
    AudioChunkOverviewInfo: {
      /**
       * Recording Id
       * @description Recording ID matching live_transcripts.stream_id (V1) or event recording_id (V2)
       */
      recording_id: string;
      /**
       * Chunk Index
       * @description Chunk index (V2) or fragment_id (V1)
       */
      chunk_index?: number | null;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when chunk was created/transcribed
       */
      created_at: string;
      /**
       * Status
       * @description Status: 'COMPLETED' or 'ERROR'/'FAILED'
       */
      status: string;
      /**
       * Duration
       * @description Duration of audio chunk in seconds
       */
      duration?: number | null;
      /**
       * Model
       * @description Transcription model used
       */
      model?: string | null;
      /**
       * Confidence
       * @description Confidence score of transcription
       */
      confidence?: number | null;
      /**
       * Version
       * @description 'v1' for audio_transcript collection, 'v2' for external service events
       */
      version: string;
    };
    /**
     * AudioRecordingOverviewInfo
     * @description Audio recording metadata without transcript content (non-PII).
     *     Covers both backup_audio and hardware_audio entries.
     */
    AudioRecordingOverviewInfo: {
      /** Id */
      id: string;
      /**
       * Source
       * @description Recording source: 'BACKUP' or 'HARDWARE'
       */
      source: string;
      status: components['schemas']['BackupAudioTranscriptionStatus'];
      /** Content Type */
      content_type?: string | null;
      /** Starttime */
      starttime?: string | null;
      /** Endtime */
      endtime?: string | null;
      /**
       * Duration
       * @description Duration in seconds (calculated from endtime - starttime)
       */
      duration?: number | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /**
       * Is Audio Retained In S3
       * @description Whether the audio file is still available in S3
       */
      is_audio_retained_in_s3: boolean;
    };
    /** AudioResponse */
    AudioResponse: {
      /** Url */
      url?: string | null;
      /** Transcript */
      transcript?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** AudioSourceRetranscriptionResponse */
    AudioSourceRetranscriptionResponse: {
      /** Session Id */
      session_id: string;
      /**
       * Source
       * @enum {string}
       */
      source: AudioSourceRetranscriptionResponseSource;
      /** Languages */
      languages: string[];
      /** Audio Count */
      audio_count: number;
      /** Transcribed Count */
      transcribed_count: number;
      /** Changed Count */
      changed_count: number;
    };
    /** AudioSourceTranscriptResponse */
    AudioSourceTranscriptResponse: {
      /** Start Time */
      start_time: string;
      /** End Time */
      end_time: string | null;
      /** Transcript */
      transcript: string;
      transcript_v2: components['schemas']['TranscriptResponse'];
    };
    /**
     * AuditEntityType
     * @enum {string}
     */
    AuditEntityType: AuditEntityType;
    /** AuditLogEvent */
    AuditLogEvent: {
      /** Event Name */
      event_name:
        | components['schemas']['InternalAdminAuditEvent']
        | components['schemas']['UserSelfServiceAuditEvent']
        | components['schemas']['OrgAdminAuditEvent']
        | components['schemas']['SensitiveActionRevocationAuditEvent']
        | components['schemas']['CibaAuditEvent'];
      /** Details */
      details: {
        [key: string]: unknown;
      };
      request?: components['schemas']['ApiRequestInfo'] | null;
    };
    /** AuditLogQueryRequest */
    AuditLogQueryRequest: {
      /**
       * Entities
       * @description One or more (id, type) pairs to query. Results are the union of all matching documents, sorted newest-first. Each document appears exactly once even if it matches multiple entities.
       */
      entities: components['schemas']['Entity'][];
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Page
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @default 40
       */
      page_size: number;
    };
    /** AuditLogResponse */
    AuditLogResponse: {
      /** Logs */
      logs: components['schemas']['EnterpriseAuditLog'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
      /** Total Pages */
      total_pages: number;
      /** Has Next Page */
      has_next_page: boolean;
    };
    /**
     * Auth0AuthenticationMethodDTO
     * @description Single enrolled MFA authentication method (Auth0).
     */
    Auth0AuthenticationMethodDTO: {
      /** Id */
      id: string;
      /** Type */
      type: string;
      /** Name */
      name?: string | null;
      /** Confirmed */
      confirmed?: boolean | null;
      /** Created At */
      created_at?: string | null;
    };
    /**
     * Auth0IdentityDTO
     * @description A single Auth0 identity entry for diagnostic display.
     */
    Auth0IdentityDTO: {
      /** Connection */
      connection: string;
      /** Is Social */
      is_social: boolean;
      /** Provider */
      provider: string;
      /** User Id */
      user_id?: string | null;
    };
    /**
     * Auth0MFADTO
     * @description Auth0 MFA enrollment summary.
     */
    Auth0MFADTO: {
      /** Enrolled Factors */
      enrolled_factors?: components['schemas']['Auth0AuthenticationMethodDTO'][];
    };
    /**
     * Auth0UserDiagnosticDTO
     * @description Live Auth0 view of a user for customer-support diagnostics.
     */
    Auth0UserDiagnosticDTO: {
      /**
       * User Id
       * @description Auth0 user identifier
       */
      user_id: string;
      /** Email */
      email: string;
      /** Email Verified */
      email_verified: boolean;
      /**
       * Blocked
       * @description Whether the Auth0 user is blocked (None if Auth0 omits the field)
       */
      blocked?: boolean | null;
      /**
       * Login Brute Force Blocked
       * @description Whether Auth0 has active brute-force login blocks for this user. True if get_user_blocks returns at least one entry. None if the Auth0 user-blocks lookup failed (transient error).
       */
      login_brute_force_blocked?: boolean | null;
      /** Identities */
      identities?: components['schemas']['Auth0IdentityDTO'][];
      /** Last Login */
      last_login?: string | null;
      /** Last Ip */
      last_ip?: string | null;
      /** Logins Count */
      logins_count?: number | null;
      /** Given Name */
      given_name?: string | null;
      /** Family Name */
      family_name?: string | null;
      /**
       * Groups
       * @description Groups from the Auth0 user profile (e.g. SAML/SSO group claims). Null if none.
       */
      groups?: string[] | null;
      mfa?: components['schemas']['Auth0MFADTO'];
      /**
       * App Metadata
       * @description Allowlisted subset of Auth0 app_metadata. See APP_METADATA_ALLOWLIST.
       */
      app_metadata?: {
        [key: string]: unknown;
      } | null;
    };
    /** AuthContext */
    AuthContext: {
      failed_reason?: components['schemas']['AuthenticationFailedReason'] | null;
      /** User Id */
      user_id?: string | null;
    };
    /** AuthTokenClaimsResponse */
    AuthTokenClaimsResponse: {
      token_info: components['schemas']['TokenInfo'];
    };
    /**
     * AuthVendor
     * @description Identity provider vendors.
     *
     *     Members:
     *     - KINDE: Kinde identity provider (standard Kinde email/SSO user flows).
     *     - AUTH0: Auth0 identity provider (Auth0 DB or social connections).
     *     - INTERNAL_ADMIN: Internal-admin bulk CSV import flow. Caller identity used
     *       when bulk-importing SSO users via the internal-admin API. Auth0 user
     *       creation is deferred to JIT (just-in-time) on the user's first SSO login.
     *       There is no provider-specific id field for this vendor on IdentityProfile.
     *     - UNKNOWN: Unrecognised or missing IdP name; treated as a fallback.
     * @enum {string}
     */
    AuthVendor: AuthVendor;
    /**
     * AuthenticationFailedReason
     * @enum {string}
     */
    AuthenticationFailedReason: AuthenticationFailedReason;
    /**
     * AuthenticationMethod
     * @description Authentication method used for login.
     *
     *     NOTE: DB is deprecated. Use NON_SSO for new code.
     * @enum {string}
     */
    AuthenticationMethod: AuthenticationMethod;
    /** AuthenticationResponse */
    AuthenticationResponse: {
      /** Is Authorized */
      is_authorized: boolean;
      context: components['schemas']['AuthContext'];
    };
    /**
     * Author
     * @description Audit author for inventory mutations.
     *
     *     ``kind`` disambiguates the ``id`` namespace so internal-admin portal writes
     *     and a future advertiser self-serve portal can share the same fields without
     *     colliding ids.
     *
     *     v1: always ``INTERNAL_ADMIN``; ``id`` is Auth0 internal-admin token ``uid``
     *     (``InternalAdminUserIdDep``). Not a Scribe ``User`` Mongo id, clinician
     *     ``kinde_user_id``, or email.
     *
     *     Future: ``ADVERTISER_USER`` with that portal's auth subject id (shape TBD
     *     when self-serve lands).
     */
    Author: {
      kind: components['schemas']['AuthorKind'];
      /**
       * Id
       * @description Author id within the kind's namespace
       */
      id: string;
    };
    /**
     * AuthorKind
     * @description Who performed an inventory create/update.
     *
     *     v1 writes are always ``INTERNAL_ADMIN`` via the internal-admin portal.
     *     ``ADVERTISER_USER`` is reserved for a future self-serve advertiser surface
     *     so stored audit records stay unambiguous across id namespaces.
     * @enum {string}
     */
    AuthorKind: AuthorKind;
    /**
     * AuthoringMode
     * @description How a protocol's clinical content was authored.
     *
     *     ``manual`` — a human typed/pasted it into the dashboard, or it was migrated from the
     *     file catalogue. ``llm_generated_candidate`` — the raw-text→JSON parse produced it and
     *     a human has not yet confirmed the structure.
     *
     *     Orthogonal to ``ProtocolModel.status`` (draft/published) and to clinical sign-off: an
     *     LLM-generated candidate is still a *draft* until a manager publishes it, and publishing
     *     still requires sign-off.
     * @enum {string}
     */
    AuthoringMode: AuthoringMode;
    /**
     * AutoCompactionConfig
     * @description Retrieval-first token-pressure driven auto-compaction config.
     *
     *     Old artefact turn ids are removed from ``LLMView`` but remain available
     *     through ``ConversationView``, ``CompactionEvent``, and archive search.
     */
    AutoCompactionConfig: {
      /**
       * Strategy
       * @default archive_only
       * @constant
       */
      strategy: 'archive_only';
      /** Context Window Tokens */
      context_window_tokens: number;
      /**
       * Compression Threshold Ratio
       * @default 0.5
       */
      compression_threshold_ratio: number;
      /**
       * Max Consecutive Failures
       * @default 3
       */
      max_consecutive_failures: number;
      /**
       * Preserve Recent Artefacts
       * @default 10
       */
      preserve_recent_artefacts: number;
      /**
       * Keep Initial Task Text
       * @default true
       */
      keep_initial_task_text: boolean;
    };
    /**
     * AutoEvidenceConfigSchema
     * @description Schema for Auto-Evidence user configuration.
     */
    AutoEvidenceConfigSchema: {
      /**
       * Enabled
       * @description Whether auto-evidence mode is enabled
       * @default false
       */
      enabled: boolean;
      /**
       * Enabled Categories
       * @description Categories of suggestions to show
       */
      enabled_categories?: components['schemas']['SuggestedChipCategory'][];
      /**
       * Pinned Queries
       * @description Effective pinned queries (system defaults + user-defined pins)
       */
      pinned_queries?: components['schemas']['EffectivePinnedQuerySchema'][];
      /**
       * Dismissed Default Ids
       * @description IDs of default pins the user has dismissed
       */
      dismissed_default_ids?: string[];
      /**
       * Library Grounding Enabled
       * @description FDE-8: user-level opt-in to library-grounded chip suggestions. Takes effect only when both the Flagsmith release flag (release-ml-scribe-library-grounded-chips) and the team opt-in (Team.library_grounded_chips_enabled) are also true. Defaults to true so the user experiences grounded chips as soon as org/flag rollout reaches them, without an extra opt-in click.
       * @default true
       */
      library_grounding_enabled: boolean;
      /**
       * Library Grounding Collection Ids
       * @description FDE-8: optional scoping of library grounding to a subset of collections the user has access to. Null means 'search everything'.
       */
      library_grounding_collection_ids?: string[] | null;
    };
    /**
     * AutoEvidenceConfigUpdateSchema
     * @description Schema for updating Auto-Evidence configuration (partial update).
     */
    AutoEvidenceConfigUpdateSchema: {
      /**
       * Enabled
       * @description Whether auto-evidence mode is enabled
       */
      enabled?: boolean | null;
      /**
       * Enabled Categories
       * @description Categories of suggestions to show
       */
      enabled_categories?: components['schemas']['SuggestedChipCategory'][] | null;
      /**
       * Pinned Queries
       * @description User-defined queries that always appear
       */
      pinned_queries?: components['schemas']['PinnedQuerySchema'][] | null;
      /**
       * Dismissed Default Ids
       * @description IDs of default pins to dismiss
       */
      dismissed_default_ids?: string[] | null;
      /**
       * Library Grounding Enabled
       * @description FDE-8: toggle library-grounded chip suggestions for the user.
       */
      library_grounding_enabled?: boolean | null;
      /**
       * Library Grounding Collection Ids
       * @description FDE-8: restrict library grounding to these collection ids. Pass an empty list (or null) to reset to 'search everything'.
       */
      library_grounding_collection_ids?: string[] | null;
    };
    /** @constant */
    AutoModeSentinel: 'AUTO_MODE';
    /**
     * AvailableDiscounts
     * @enum {string}
     */
    AvailableDiscounts: AvailableDiscounts;
    /** AvailableLDAGroupRequest */
    AvailableLDAGroupRequest: {
      /** Groupid */
      groupId: components['schemas']['IDTypeRequest'][];
    };
    /**
     * AvailableMetricsResponse
     * @description Response listing available metrics.
     */
    AvailableMetricsResponse: {
      /** Metrics */
      metrics: components['schemas']['MetricConfig'][];
    };
    /**
     * AvailableScriptsResponse
     * @description Response schema listing the whitelisted scripts with blast-radius labels.
     *
     *     Backs the internal-admin Run Scripts UI so the script picker stays in
     *     lock-step with the backend whitelist instead of hardcoding the names, and
     *     shows the operator which scripts fan out across all workspaces before they
     *     confirm a run.
     *
     *     ``scripts`` keeps its original shape (plain script names); blast-radius
     *     labels live in the additive ``classifications`` map so a consumer that
     *     reads ``scripts`` as a list of strings keeps working unchanged.
     */
    AvailableScriptsResponse: {
      /**
       * Scripts
       * @description Sorted list of whitelisted script names accepted by /execute
       */
      scripts: string[];
      /**
       * Classifications
       * @description Blast-radius classification per script name; scripts without a label are absent from the map
       */
      classifications?: {
        [key: string]: components['schemas']['ScriptClassification'];
      };
    };
    /** AvailableSection */
    AvailableSection: {
      /** Name */
      name: string;
      /** Section Id */
      section_id: string;
    };
    /** AvailableSectionsResponse */
    AvailableSectionsResponse: {
      /** Available Sections */
      available_sections: components['schemas']['AvailableSection'][];
    };
    /** AxAssistAppointment */
    AxAssistAppointment: {
      /** Patient Name */
      patient_name: string;
      /** Time */
      time?: string | null;
      /** Appointment Type */
      appointment_type?: string | null;
    };
    /** AxAssistCandidateAppointment */
    AxAssistCandidateAppointment: {
      /** Patient Name */
      patient_name: string;
      /** Time */
      time?: string | null;
      /** Appointment Type */
      appointment_type?: string | null;
    };
    /**
     * AxAssistContext
     * @description Task-specific deterministic priors (never treated as ground truth).
     */
    AxAssistContext: {
      /**
       * Candidate Appointments
       * @description extract_schedule: deterministic parseSchedule output.
       */
      candidate_appointments?: components['schemas']['AxAssistCandidateAppointment'][];
      /**
       * Patient
       * @description verify_patient / extract_chart_context: expected patient name from Heidi.
       */
      patient?: string | null;
      /**
       * Name Candidates
       * @description verify_patient: FE-filtered name-like strings from the AX tree (prior for the LLM; not ground truth).
       */
      name_candidates?: string[];
      /**
       * Note Text
       * @description parse_note_sections: plain Heidi consult-note text to split into heading→body sections.
       * @default
       */
      note_text: string;
      /**
       * Known Headings
       * @description parse_note_sections: stored mapping / template section headings (prior for mapped fields; response may also include other structural headings found in the note).
       */
      known_headings?: string[];
    };
    /**
     * AxAssistElement
     * @description One accessibility element, in the FE's native camelCase shape.
     *
     *     The FE ships its ``AccessibilityElement`` bindings verbatim; aliases map
     *     the camelCase keys and ``extra="ignore"`` drops fields the assist tasks
     *     don't need (bounds, actions, windowHandle, …).
     */
    AxAssistElement: {
      /** Id */
      id: string;
      /** Labelid */
      labelId?: string | null;
      /**
       * Role
       * @default
       */
      role: string;
      /** Name */
      name?: string | null;
      /** Value */
      value?: string | null;
      /**
       * Enabled
       * @default true
       */
      enabled: boolean;
      /**
       * Offscreen
       * @default false
       */
      offscreen: boolean;
    };
    /** AxAssistRequest */
    AxAssistRequest: {
      /**
       * Task
       * @enum {string}
       */
      task: AxAssistRequestTask;
      snapshot: components['schemas']['AxAssistSnapshot'];
      context?: components['schemas']['AxAssistContext'];
    };
    /** AxAssistSnapshot */
    AxAssistSnapshot: {
      target?: components['schemas']['AxAssistTarget'];
      /**
       * Tree
       * @default
       */
      tree: string;
      /** Elements */
      elements?: components['schemas']['AxAssistElement'][];
    };
    /** AxAssistTarget */
    AxAssistTarget: {
      /** Title */
      title?: string | null;
      /** Processid */
      processId?: number | null;
    };
    /** BackupAudioResponse */
    BackupAudioResponse: {
      backup_audio: components['schemas']['AccessRestrictedBackupAudio'];
    };
    /**
     * BackupAudioTranscriptionStatus
     * @description Enum for Backup Audio Transcription Status
     * @enum {string}
     */
    BackupAudioTranscriptionStatus: BackupAudioTranscriptionStatus;
    /** BackupChunkObject */
    BackupChunkObject: {
      /** Chunk Index */
      chunk_index: number;
      /** Key */
      key: string;
      /** Size Bytes */
      size_bytes: number;
      /**
       * Stored At
       * Format: date-time
       */
      stored_at: string;
      /**
       * Expires At
       * Format: date-time
       */
      expires_at: string;
    };
    /** BackupRecoveryAttemptResponse */
    BackupRecoveryAttemptResponse: {
      /** Recovery Id */
      recovery_id: string;
      /** Session Id */
      session_id: string;
      /** Requested By */
      requested_by: string;
      /** Model */
      model?: string | null;
      /** Languages */
      languages: string[];
      /** Status */
      status: string;
      /** Error */
      error?: string | null;
      /** Recordings */
      recordings: components['schemas']['BackupRecoveryRecordingResult'][];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Completed At */
      completed_at?: string | null;
    };
    /** BackupRecoveryListResponse */
    BackupRecoveryListResponse: {
      /** Session Id */
      session_id: string;
      /** Attempts */
      attempts: components['schemas']['BackupRecoveryAttemptResponse'][];
    };
    /** BackupRecoveryModel */
    BackupRecoveryModel: {
      /** Name */
      name: string;
      /** Client Id */
      client_id: string;
      /** Model Id */
      model_id: string;
      /** Multilingual */
      multilingual: boolean;
      /** Languages */
      languages: string[];
    };
    /** BackupRecoveryModelsResponse */
    BackupRecoveryModelsResponse: {
      /** Models */
      models: components['schemas']['BackupRecoveryModel'][];
    };
    /** BackupRecoveryRecordingResult */
    BackupRecoveryRecordingResult: {
      /** Recording Id */
      recording_id: string;
      /** Chunks Found */
      chunks_found: number;
      /**
       * Chunks Transcribed
       * @default 0
       */
      chunks_transcribed: number;
      /**
       * Chunks Failed
       * @default 0
       */
      chunks_failed: number;
    };
    /**
     * BalanceMovementResponse
     * @description The new balance in one currency after a credit/debit movement.
     */
    BalanceMovementResponse: {
      /** Workspace Id */
      workspace_id: string;
      transaction_type: components['schemas']['TransactionType'];
      /** Currency */
      currency: string;
      /** Balance */
      balance: number | string;
    };
    /** BaseCodeConcept */
    BaseCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** BaseModel */
    BaseModel: Record<string, never>;
    /**
     * BaseNoteOption
     * @description Base selectable destination shown before syncing a consult note.
     *
     *     Provider-specific subclasses may add fields the adaptor needs after an
     *     option is selected. Clients should treat any provider-specific fields as
     *     opaque and should only send ``option_id`` back to the sync endpoint.
     */
    BaseNoteOption: {
      /** Label */
      label?: string | null;
      /** Description */
      description?: string | null;
      option_id: components['schemas']['NoteOptionEhrId'];
    };
    /**
     * BaseStatus
     * @enum {string}
     */
    BaseStatus: BaseStatus;
    /**
     * BaseSyncDocumentOption
     * @description Base selectable option shown in the client's sync-document popup.
     *
     *     Frontend clients can rely on ``option_id``, ``label``, and ``description``.
     *     ``option_id`` is required for sync-document option selection: the service
     *     matches the request ``option_id`` against provider-generated options before
     *     passing the selected option object to the adaptor.
     *
     *     Each option should describe one destination or behavior the user can choose
     *     in the modal, such as "Letters - Specialist", "Letters - GP", or "Referral
     *     template".
     *
     *     Provider-specific subclasses may add fields the adaptor needs after an
     *     option is selected. Clients should treat any provider-specific fields as
     *     opaque and should only send ``option_id`` back to the sync endpoint.
     */
    BaseSyncDocumentOption: {
      option_id: components['schemas']['SyncDocumentOptionId'];
      /** Label */
      label: string;
      /** Description */
      description?: string | null;
    };
    /**
     * BatchCreateGalleryTemplatesRequest
     * @description Request to batch create templates in the gallery.
     */
    BatchCreateGalleryTemplatesRequest: {
      /** Templates */
      templates: components['schemas']['CreateGalleryTemplateRequest'][];
    };
    /**
     * BatchCreateResponse
     * @description Response for batch creating templates.
     */
    BatchCreateResponse: {
      /** Created */
      created: components['schemas']['GalleryTemplateBasicInfo'][];
      /** Failed */
      failed: {
        [key: string]: unknown;
      }[];
    };
    /**
     * BatchDeleteGalleryTemplatesRequest
     * @description Request to batch delete templates from the gallery.
     */
    BatchDeleteGalleryTemplatesRequest: {
      /** Template Ids */
      template_ids: string[];
    };
    /**
     * BatchDeleteResponse
     * @description Response for batch deleting templates.
     */
    BatchDeleteResponse: {
      /** Deleted */
      deleted: string[];
      /** Failed */
      failed: {
        [key: string]: unknown;
      }[];
    };
    /** BatchDeleteSessionRequest */
    BatchDeleteSessionRequest: {
      /** Session Id List */
      session_id_list: string[];
    };
    /** BatchDeleteUserEHRLaunchProfileRequest */
    BatchDeleteUserEHRLaunchProfileRequest: {
      /** User Ehr Launch Profile Ids */
      user_ehr_launch_profile_ids: string[];
    };
    /**
     * BatchJobProgress
     * @description Read view over a job: rollup counts once terminal, live ledger counts
     *     while running. ``succeeded + failed + pending == total_tasks`` for every
     *     terminal job.
     */
    BatchJobProgress: {
      /** Job Ref Id */
      job_ref_id: string;
      /** Job Type */
      job_type: string;
      status: components['schemas']['BatchJobStatus'];
      /** Total Tasks */
      total_tasks: number;
      /** Succeeded */
      succeeded: number;
      /** Failed */
      failed: number;
      /** Pending */
      pending: number;
      /** Followup Requested */
      followup_requested: boolean;
      /** Is Terminal */
      is_terminal: boolean;
      /** Started At */
      started_at?: string | null;
      /** Completed At */
      completed_at?: string | null;
    };
    /**
     * BatchJobStatus
     * @enum {string}
     */
    BatchJobStatus: BatchJobStatus;
    /**
     * BatchLikeStatusResponse
     * @description Response for batch checking like status.
     */
    BatchLikeStatusResponse: {
      /** Statuses */
      statuses: {
        [key: string]: boolean;
      };
    };
    /** BatchListResponse */
    BatchListResponse: {
      /** Items */
      items: components['schemas']['BatchSummaryResponse'][];
    };
    /** BatchScheduleResponse */
    BatchScheduleResponse: {
      /** Schedules */
      schedules: {
        [key: string]: components['schemas']['ScheduleResponse'];
      };
    };
    /** BatchStatusCounts */
    BatchStatusCounts: {
      /**
       * Processing
       * @default 0
       */
      processing: number;
      /**
       * Ready For Review
       * @default 0
       */
      ready_for_review: number;
      /**
       * Sent For Review
       * @default 0
       */
      sent_for_review: number;
      /**
       * Ready To Publish
       * @default 0
       */
      ready_to_publish: number;
      /**
       * Published
       * @default 0
       */
      published: number;
      /**
       * Unpublished
       * @default 0
       */
      unpublished: number;
      /**
       * Deleted
       * @default 0
       */
      deleted: number;
      /**
       * Rejected
       * @default 0
       */
      rejected: number;
      /**
       * Failed
       * @default 0
       */
      failed: number;
    };
    /** BatchSummaryResponse */
    BatchSummaryResponse: {
      /** Batch Id */
      batch_id: string;
      /** Set Name */
      set_name: string | null;
      /** Total */
      total: number;
      status_counts: components['schemas']['BatchStatusCounts'];
      /** Created At */
      created_at: string | null;
      /** Updated At */
      updated_at: string | null;
    };
    /**
     * BatchTemplateUpdateType
     * @enum {string}
     */
    BatchTemplateUpdateType: BatchTemplateUpdateType;
    /**
     * BatchUpdateResponse
     * @description Response for batch updating templates.
     */
    BatchUpdateResponse: {
      /** Updated */
      updated: components['schemas']['GalleryTemplateBasicInfo'][];
      /** Failed */
      failed: {
        [key: string]: unknown;
      }[];
    };
    /**
     * BatchUpdateTemplateItem
     * @description Single template item for batch update.
     */
    BatchUpdateTemplateItem: {
      /** Template Id */
      template_id: string;
      template_category?: components['schemas']['GalleryTemplateCategory'] | null;
      /** Specialty */
      specialty?: string | null;
      /** Country */
      country?: string | null;
      /** Author Name */
      author_name?: string | null;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
      template_content?: components['schemas']['GalleryTemplateContentUpdate'] | null;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Url Path */
      url_path?: string | null;
    };
    /**
     * BatchUpdateTemplatesByIdRequest
     * @example {
     *       "tag_updates": {
     *         "pinned_for_tags": {
     *           "countries": [
     *             "AUSTRALIA"
     *           ],
     *           "languages": [
     *             "en"
     *           ],
     *           "region": [
     *             "AU"
     *           ],
     *           "specialty_ids": [
     *             "specialty_id_1"
     *           ],
     *           "tier": [
     *             "PRO"
     *           ]
     *         },
     *         "tags": {
     *           "countries": [
     *             "AUSTRALIA"
     *           ],
     *           "languages": [
     *             "en"
     *           ],
     *           "region": [
     *             "AU"
     *           ],
     *           "specialty_ids": [
     *             "specialty_id_1"
     *           ],
     *           "tier": [
     *             "PRO"
     *           ]
     *         }
     *       },
     *       "template_ids": [
     *         "template_id_1",
     *         "template_id_2"
     *       ],
     *       "update_type": "overwrite"
     *     }
     */
    BatchUpdateTemplatesByIdRequest: {
      /**
       * Template Ids
       * @description Template IDs to update
       */
      template_ids: string[];
      /**
       * Tag Updates
       * @description Tag field updates to apply
       */
      tag_updates: {
        [key: string]: components['schemas']['Tags'];
      };
      /**
       * @description Update type
       * @default OVERWRITE
       */
      update_type: components['schemas']['BatchTemplateUpdateType'];
      field_updates?: components['schemas']['SystemTemplateFieldUpdates'] | null;
    };
    /**
     * BatchUpdateTemplatesResponse
     * @example {
     *       "message": "Successfully updated 5 templates",
     *       "updated_count": 5
     *     }
     */
    BatchUpdateTemplatesResponse: {
      /**
       * Updated Count
       * @description Number of templates updated
       */
      updated_count: number;
      /**
       * Message
       * @description Success message
       */
      message: string;
    };
    /** BenchCaseResultResponse */
    BenchCaseResultResponse: {
      /** Case Id */
      case_id: string;
      /** Expect */
      expect: string;
      /** Fired */
      fired: boolean;
      /** Passed */
      passed: boolean;
    };
    /**
     * BenchResultResponse
     * @description Result of running the real code-mediated detector over a protocol's test_cases — the
     *     dashboard's "X/N passed". Runs regardless of the engine flag (always exercises the
     *     code-mediated path); useful for FDE iteration pre-publish.
     */
    BenchResultResponse: {
      /** Protocol Id */
      protocol_id: string;
      /** Passed */
      passed: number;
      /** Total */
      total: number;
      /** Cases */
      cases: components['schemas']['BenchCaseResultResponse'][];
    };
    /** BestPracticeCreateRequest */
    BestPracticeCreateRequest: {
      /**
       * Ehr Provider
       * @default Best Practice
       * @constant
       */
      ehr_provider: 'Best Practice';
      /** Guid */
      guid: string;
    };
    /**
     * BillableEventType
     * @enum {string}
     */
    BillableEventType: BillableEventType;
    /**
     * BillableMetricResponse
     * @description Wire shape for the **meter** (list + create endpoints).
     *
     *     Meter-only: a meter can have many named limits, so its
     *     caps are not embedded here — they're served by the limit endpoints
     *     (`LimitResponse`).
     */
    BillableMetricResponse: {
      /** Metric Key */
      metric_key: string;
      /** Description */
      description?: string | null;
      /**
       * Aggregation Mode
       * @enum {string}
       */
      aggregation_mode: BillableMetricResponseAggregation_mode;
      /** Sum Field */
      sum_field?: BillableMetricResponseSum_fieldAnyOf0 | null;
      /** Filter Groups */
      filter_groups: {
        [key: string]: string;
      }[];
      /** Is Active */
      is_active: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** BillingInfo */
    BillingInfo: {
      /** Stripe Subscription Id */
      stripe_subscription_id: string;
      /** Subscription Status */
      subscription_status: string;
      /** Currency */
      currency: string;
      /** Total Items */
      total_items: number;
      /** Total Price */
      total_price: number;
      /** Unit Price */
      unit_price: number;
      /** Interval */
      interval: string;
      /** Next Billing Date */
      next_billing_date: string | null;
    };
    /** BillingInfoResponse */
    BillingInfoResponse: {
      billing_info: components['schemas']['BillingInfoResponseView'];
    };
    /** BillingInfoResponseView */
    BillingInfoResponseView: {
      /** Stripe Subscription Id */
      stripe_subscription_id: string | null;
      /** Plan Start Date */
      plan_start_date: string | null;
      /** Plan End Date */
      plan_end_date: string | null;
      /** Trial End Date */
      trial_end_date: string | null;
      /** Next Billing Date */
      next_billing_date: string | null;
      /** Is In Free Trial */
      is_in_free_trial: boolean;
      tier: components['schemas']['SubscriptionTier'];
      plan_cycle: components['schemas']['shared__enums__enums__Period'] | null;
      scribe_access: components['schemas']['AccessTier'];
      evidence_access: components['schemas']['AccessTier'];
      new_product_tier: components['schemas']['SubscriptionTier'];
      /** @default STANDARD */
      seat_type: components['schemas']['BillingSeatType'];
      third_party_license?: components['schemas']['ThirdPartyLicenceDetails'] | null;
      /**
       * Is In Reverse Free Trial
       * @default false
       */
      is_in_reverse_free_trial: boolean;
      /**
       * Is Reverse Trial Extendable
       * @default false
       */
      is_reverse_trial_extendable: boolean;
      /**
       * Is Fake Clinician Trial
       * @default false
       */
      is_fake_clinician_trial: boolean;
      /**
       * Is Promoted Free Trial
       * @default false
       */
      is_promoted_free_trial: boolean;
      evidence_billing?:
        | components['schemas']['domains__billing__api__billing_schema__EvidenceBillingInfoResponseView']
        | null;
      /** Clinician Trial End Date Overwrite */
      clinician_trial_end_date_overwrite?: string | null;
      previous_status_before_clinician_trial?:
        | components['schemas']['SubscriptionStatus']
        | null;
      /** Redeemed Discounts */
      redeemed_discounts?: components['schemas']['AvailableDiscounts'][];
      cancellation_intent?:
        | components['schemas']['CancellationIntentResponseView']
        | null;
      evidence_billing_state?: components['schemas']['EvidenceBillingStateResponseView'];
      stripe_account_region?: components['schemas']['Region'] | null;
      /** @default 1 */
      heidi_version: components['schemas']['HeidiVersion'];
    };
    /**
     * BillingPaymentVendor
     * @enum {string}
     */
    BillingPaymentVendor: BillingPaymentVendor;
    /** BillingPortalSessionResponse */
    BillingPortalSessionResponse: {
      /** Billing Portal Url */
      billing_portal_url: string;
    };
    /**
     * BillingSubscriptionStatus
     * @description Lifecycle status for a ProductSubscription record.
     * @enum {string}
     */
    BillingSubscriptionStatus: BillingSubscriptionStatus;
    /**
     * BirthSex
     * @description Values and descriptions are sourced from
     *     https://hl7.org/fhir/us/cdmh/ValueSet-pcornet-birth-sex.html
     * @enum {string}
     */
    BirthSex: BirthSex;
    /**
     * BlockedDomainsResponse
     * @description Content-safety denied domains the FE must reject in source pickers.
     */
    BlockedDomainsResponse: {
      /**
       * Domains
       * @description Sorted bare hosts that may not be added to source collections
       */
      domains?: string[];
    };
    /** BlockedNumberListView */
    BlockedNumberListView: {
      /** Items */
      items: components['schemas']['BlockedNumberView'][];
      /** Total */
      total: number;
    };
    /** BlockedNumberView */
    BlockedNumberView: {
      /** Id */
      id: string;
      /** Phone */
      phone: string;
      /** Patient Name */
      patient_name?: string | null;
      /** Reason */
      reason?: string | null;
      /**
       * Blocked Via
       * @enum {string}
       */
      blocked_via: BlockedNumberViewBlocked_via;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Last Attempt At */
      last_attempt_at?: string | null;
      /**
       * Attempt Count
       * @default 0
       */
      attempt_count: number;
    };
    /** Body_add_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_post */
    Body_add_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_post: {
      /**
       * Csv File
       * Format: binary
       */
      csv_file: string;
      add_member_method: components['schemas']['TeamAddMemberMethod'];
      /** Role Ids */
      role_ids?: string[] | null;
      display_language?: components['schemas']['LanguageCode'] | null;
      /** Send Onboarding Email */
      send_onboarding_email?: boolean | null;
    };
    /** Body_batch_upload_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_upload_post */
    Body_batch_upload_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_upload_post: {
      /**
       * File
       * Format: binary
       * @description CSV or JSON file containing template data
       */
      file: string;
    };
    /** Body_bulk_create_template_by_csv_api_v2_ml_scribe_internal_admin_system_template_bulk_create_template_post */
    Body_bulk_create_template_by_csv_api_v2_ml_scribe_internal_admin_system_template_bulk_create_template_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_bulk_create_template_by_csv_api_v2_ml_scribe_system_template_bulk_create_template_post */
    Body_bulk_create_template_by_csv_api_v2_ml_scribe_system_template_bulk_create_template_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_bulk_create_user_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_create_user_post */
    Body_bulk_create_user_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_create_user_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_bulk_create_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_import_post */
    Body_bulk_create_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_import_post: {
      /** Profile Name */
      profile_name: string;
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_bulk_delete_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_bulk_delete_post */
    Body_bulk_delete_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_bulk_delete_post: {
      /** Profile Name */
      profile_name: string;
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_bulk_update_user_identity_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_update_user_identity_patch */
    Body_bulk_update_user_identity_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_update_user_identity_patch: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_bulk_upload_seo_context_api_v2_ml_scribe_internal_admin_form_seo_seo_context_bulk_upload_post */
    Body_bulk_upload_seo_context_api_v2_ml_scribe_internal_admin_form_seo_seo_context_bulk_upload_post: {
      /**
       * File
       * Format: binary
       * @description CSV file with url_path plus all 5 context columns and/or seo_content
       */
      file: string;
    };
    /** Body_create_custom_form_template_with_pdf_api_v2_ml_scribe_internal_admin_templates_form_templates_post */
    Body_create_custom_form_template_with_pdf_api_v2_ml_scribe_internal_admin_templates_form_templates_post: {
      /**
       * Pdf File
       * Format: binary
       * @description PDF file for the form template
       */
      pdf_file: string;
      /**
       * Kinde User Id
       * @description User ID who will own this template
       */
      kinde_user_id: string;
      /**
       * Name
       * @description Template name
       */
      name: string;
      /**
       * @description Template visibility
       * @default User
       */
      template_visibility: components['schemas']['TemplateVisibility'];
      /**
       * Team Id
       * @description Team ID if creating a team template
       */
      team_id?: string | null;
      /**
       * Organization Id
       * @description Organization ID for organization visibility
       */
      organization_id?: string | null;
      /**
       * Shared Team Ids
       * @description Team IDs to share with for team visibility
       */
      shared_team_ids?: string[] | null;
      /**
       * Description
       * @description Template description
       * @default
       */
      description: string;
    };
    /** Body_create_form_system_template_api_v2_ml_scribe_internal_admin_system_template_form_templates_post */
    Body_create_form_system_template_api_v2_ml_scribe_internal_admin_system_template_form_templates_post: {
      /**
       * Pdf File
       * Format: binary
       * @description PDF file for the form template
       */
      pdf_file: string;
      /**
       * Name
       * @description Template name
       */
      name: string;
      /**
       * @description Template category
       * @default DOCUMENT_TEMPLATE
       */
      template_category: components['schemas']['TemplateCategory'];
      /**
       * Tags
       * @description Tags as JSON string
       * @default {}
       */
      tags: string;
      /**
       * Pinned For Tags
       * @description Pinned for tags as JSON string
       * @default {}
       */
      pinned_for_tags: string;
      /**
       * Highlighted For Tags
       * @description Highlighted for tags as JSON string
       * @default {}
       */
      highlighted_for_tags: string;
      /**
       * Featured For Tags
       * @description Featured for tags as JSON string
       * @default {}
       */
      featured_for_tags: string;
      /**
       * Auto Generated For Tags
       * @description Auto generated for tags as JSON string
       * @default {}
       */
      auto_generated_for_tags: string;
      /**
       * Should Deduct Quota
       * @description Should deduct quota
       * @default false
       */
      should_deduct_quota: boolean;
      /**
       * List Order Priority
       * @description List order priority
       */
      list_order_priority?: number | null;
      /**
       * Structure Template
       * @description Structure template content
       * @default
       */
      structure_template: string;
    };
    /** Body_create_form_system_template_api_v2_ml_scribe_system_template_form_templates_post */
    Body_create_form_system_template_api_v2_ml_scribe_system_template_form_templates_post: {
      /**
       * Pdf File
       * Format: binary
       * @description PDF file for the form template
       */
      pdf_file: string;
      /**
       * Name
       * @description Template name
       */
      name: string;
      /**
       * @description Template category
       * @default DOCUMENT_TEMPLATE
       */
      template_category: components['schemas']['TemplateCategory'];
      /**
       * Tags
       * @description Tags as JSON string
       * @default {}
       */
      tags: string;
      /**
       * Pinned For Tags
       * @description Pinned for tags as JSON string
       * @default {}
       */
      pinned_for_tags: string;
      /**
       * Highlighted For Tags
       * @description Highlighted for tags as JSON string
       * @default {}
       */
      highlighted_for_tags: string;
      /**
       * Featured For Tags
       * @description Featured for tags as JSON string
       * @default {}
       */
      featured_for_tags: string;
      /**
       * Auto Generated For Tags
       * @description Auto generated for tags as JSON string
       * @default {}
       */
      auto_generated_for_tags: string;
      /**
       * Should Deduct Quota
       * @description Should deduct quota
       * @default false
       */
      should_deduct_quota: boolean;
      /**
       * List Order Priority
       * @description List order priority
       */
      list_order_priority?: number | null;
      /**
       * Structure Template
       * @description Structure template content
       * @default
       */
      structure_template: string;
    };
    /** Body_create_mk_template_request_api_v2_ml_scribe_mk_template_requests__post */
    Body_create_mk_template_request_api_v2_ml_scribe_mk_template_requests__post: {
      /**
       * Template Name
       * @description Name for the requested template
       */
      template_name: string;
      /**
       * Description
       * @description Description of what you want in the template
       */
      description: string;
      /**
       * Existing Template Id
       * @description Optional ID of existing template to modify
       */
      existing_template_id?: string | null;
      /**
       * Additional Notes
       * @description Optional additional notes
       */
      additional_notes?: string | null;
      /**
       * Pdf File
       * @description Optional PDF file to upload
       */
      pdf_file?: string | null;
    };
    /** Body_exchange_stand_alone_launch_auth_code_for_access_token_api_v2_ml_scribe_stand_alone_launch_authentication_access_token_post */
    Body_exchange_stand_alone_launch_auth_code_for_access_token_api_v2_ml_scribe_stand_alone_launch_authentication_access_token_post: {
      request: components['schemas']['StandAloneLaunchExchangeAccessTokenRequest'];
      /** @description EHR provider details required for search */
      ehr_details: components['schemas']['EpicCreateStandAloneLaunchAdaptorRequest'];
    };
    /** Body_extract_content_from_document_api_v2_1_ml_scribe_templates_doc_extract_post */
    Body_extract_content_from_document_api_v2_1_ml_scribe_templates_doc_extract_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_extract_form_fields_from_pdf_api_v2_ml_scribe_pdf_template_extract_fields_post */
    Body_extract_form_fields_from_pdf_api_v2_ml_scribe_pdf_template_extract_fields_post: {
      /**
       * Pdf File
       * Format: binary
       * @description PDF or Word (.docx) file to extract fields from
       */
      pdf_file: string;
    };
    /** Body_fill_form_from_upload_api_v2_ml_scribe_pdf_template_demo_fill_form_from_upload_post */
    Body_fill_form_from_upload_api_v2_ml_scribe_pdf_template_demo_fill_form_from_upload_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
      /**
       * Source
       * @enum {string}
       */
      source: Body_fill_form_from_upload_api_v2_ml_scribe_pdf_template_demo_fill_form_from_upload_postSource;
      /** S3 Object Key */
      s3_object_key: string;
      /** Form Fields */
      form_fields: string;
      /** Specialty Name */
      specialty_name?: string | null;
      /** Country */
      country?: string | null;
      /** Language */
      language?: string | null;
    };
    /** Body_get_webrtc_token_api_v2_ml_scribe_calls_agents__agent_id__webrtc_token_post */
    Body_get_webrtc_token_api_v2_ml_scribe_calls_agents__agent_id__webrtc_token_post: {
      /** Agent Name */
      agent_name?: string | null;
    };
    /** Body_import_organization_user_team_mapping_api_v2_ml_scribe_internal_admin_teams_user_team_mapping_import_post */
    Body_import_organization_user_team_mapping_api_v2_ml_scribe_internal_admin_teams_user_team_mapping_import_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_import_patient_profiles_api_v2_ml_scribe_patient_profiles_import_post */
    Body_import_patient_profiles_api_v2_ml_scribe_patient_profiles_import_post: {
      /**
       * File
       * Format: binary
       * @description Filled patient-import CSV template
       */
      file: string;
    };
    /** Body_process_batch_api_v2_ml_scribe_internal_admin_heidi_answers_process_post */
    Body_process_batch_api_v2_ml_scribe_internal_admin_heidi_answers_process_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_process_uploaded_document_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_post */
    Body_process_uploaded_document_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_post: {
      /** Files */
      files: string[];
    };
    /** Body_process_uploaded_document_public_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_public_post */
    Body_process_uploaded_document_public_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_public_post: {
      /** Files */
      files: string[];
    };
    /** Body_search_staff_endpoint_api_v2_ml_scribe_ehr_users_v2_post */
    Body_search_staff_endpoint_api_v2_ml_scribe_ehr_users_v2_post: {
      /**
       * First Name
       * @description First name of the staff member
       */
      first_name: string;
      /**
       * Last Name
       * @description Last name of the staff member
       */
      last_name: string;
      /** Ehr Details */
      ehr_details?:
        | components['schemas']['AthenaCreateAdaptorRequest']
        | components['schemas']['BestPracticeCreateRequest']
        | components['schemas']['ClinikoCreateAdaptorRequest']
        | components['schemas']['EpicCreateAdaptorRequest']
        | components['schemas']['MagentusCreateAdaptorRequest']
        | components['schemas']['MeditechEhrLaunchCreateAdaptorRequest']
        | components['schemas']['MindbodyCreateAdaptorRequest']
        | components['schemas']['VeradigmCreateAdaptorRequest']
        | null;
    };
    /** Body_test_get_audio_duration_prod_api_v1_ml_scribe_sessions_test_duration_post */
    Body_test_get_audio_duration_prod_api_v1_ml_scribe_sessions_test_duration_post: {
      /**
       * Upload File
       * Format: binary
       */
      upload_file: string;
    };
    /** Body_transcribe_context_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription_transcribe_context_post */
    Body_transcribe_context_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription_transcribe_context_post: {
      /**
       * File
       * Format: binary
       * @description Audio file chunk to be transcribed
       */
      file: string;
    };
    /** Body_transcribe_hardware_audio_api_v2_ml_scribe_sessions__session_id__hardware_audio_transcription_post */
    Body_transcribe_hardware_audio_api_v2_ml_scribe_sessions__session_id__hardware_audio_transcription_post: {
      /**
       * File
       * Format: binary
       * @description Hardware audio file (MP3) to be transcribed
       */
      file: string;
      /**
       * Extension
       * @default
       */
      extension: string;
      /** Start Time */
      start_time?: string | null;
      /** End Time */
      end_time?: string | null;
    };
    /** Body_transcribe_segment_recording_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post */
    Body_transcribe_segment_recording_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post: {
      /**
       * File
       * Format: binary
       * @description Audio file chunk to be transcribed
       */
      file: string;
      /** Index */
      index: number;
      /**
       * Duration
       * @default 0
       */
      duration: number;
    };
    /** Body_transcribe_segment_recording_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post */
    Body_transcribe_segment_recording_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post: {
      /**
       * File
       * Format: binary
       * @description Audio file chunk to be transcribed
       */
      file: string;
      /** Index */
      index: number;
      /**
       * Duration
       * @default 0
       */
      duration: number;
    };
    /** Body_transcriber_comparison_api_v2_ml_scribe_internal_admin_transcriptions_comparison_post */
    Body_transcriber_comparison_api_v2_ml_scribe_internal_admin_transcriptions_comparison_post: {
      /** Audio File */
      audio_file?: string | null;
      /** Audio Url */
      audio_url?: string | null;
      /** @default en */
      language_code: components['schemas']['LanguageCode'];
      /**
       * Transcriber Configs
       * @default [
       *       "Whisper:whisper-1",
       *       "Gemini:flash-1.5",
       *       "Deepgram:nova-2-medical",
       *       "Deepgram:nova-2-heidihealth_farfield_v4",
       *       "Deepgram:nova-2",
       *       "Deepgram:nova-3"
       *     ]
       */
      transcriber_configs: components['schemas']['TranscriberConfigForInternalAdmin'][];
    };
    /** Body_upload_audio_api_v1_ml_scribe_sessions__session_id__upload_audio_post */
    Body_upload_audio_api_v1_ml_scribe_sessions__session_id__upload_audio_post: {
      /**
       * Upload File
       * Format: binary
       */
      upload_file: string;
      /** Starttime */
      starttime?: string | null;
      /** Endtime */
      endtime?: string | null;
    };
    /** Body_upload_audio_api_v2_ml_scribe_open_api_sessions__session_id__upload_audio__post */
    Body_upload_audio_api_v2_ml_scribe_open_api_sessions__session_id__upload_audio__post: {
      /**
       * File
       * Format: binary
       * @description Audio or video file to be transcribed
       */
      file: string;
      /** Start Time */
      start_time?: string | null;
      /** End Time */
      end_time?: string | null;
    };
    /** Body_upload_backup_audio_api_v2_ml_scribe_open_api_sessions__session_id__backup_audios__post */
    Body_upload_backup_audio_api_v2_ml_scribe_open_api_sessions__session_id__backup_audios__post: {
      /**
       * File
       * Format: binary
       * @description Backup audio file to be transcribed
       */
      file: string;
      /**
       * Extension
       * @default
       */
      extension: string;
      /** Start Time */
      start_time?: string | null;
      /** End Time */
      end_time?: string | null;
    };
    /** Body_upload_backup_audio_api_v2_ml_scribe_sessions__session_id__backup_audios__post */
    Body_upload_backup_audio_api_v2_ml_scribe_sessions__session_id__backup_audios__post: {
      /**
       * File
       * Format: binary
       * @description Backup audio file to be transcribed
       */
      file: string;
      /**
       * Extension
       * @default
       */
      extension: string;
      /** Start Time */
      start_time?: string | null;
      /** End Time */
      end_time?: string | null;
    };
    /** Body_upload_chat_attachment_api_v2_ml_scribe_chat_attachments_post */
    Body_upload_chat_attachment_api_v2_ml_scribe_chat_attachments_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_upload_cqc_practices_csv_api_v2_ml_scribe_internal_admin_cqc_practices_upload_post */
    Body_upload_cqc_practices_csv_api_v2_ml_scribe_internal_admin_cqc_practices_upload_post: {
      /**
       * File
       * Format: binary
       * @description CQC practices CSV file
       */
      file: string;
    };
    /** Body_upload_document_api_v2_ml_scribe_evidence_user_documents_post */
    Body_upload_document_api_v2_ml_scribe_evidence_user_documents_post: {
      /**
       * File
       * Format: binary
       * @description Document file to upload
       */
      file: string;
      /**
       * @description Access scope: 'user' for private, 'team' for team-shared
       * @default user
       */
      scope: components['schemas']['DocumentScope'];
      /**
       * Metadata
       * @description Optional JSON metadata string
       */
      metadata?: string | null;
      /**
       * Collection Id
       * @description Optional collection ID to auto-add document to after processing
       */
      collection_id?: string | null;
      /**
       * Client Upload Id
       * @description Client-generated UUID for idempotent uploads. If a job with this ID already exists for the same user, the existing job is returned.
       */
      client_upload_id?: string | null;
    };
    /** Body_upload_document_for_user_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_upload_post */
    Body_upload_document_for_user_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_upload_post: {
      /**
       * File
       * Format: binary
       * @description Document file to upload
       */
      file: string;
      /**
       * @description Access scope: 'user' for private, 'team' for team-shared
       * @default user
       */
      scope: components['schemas']['DocumentScope'];
      /**
       * Metadata
       * @description Optional JSON metadata string
       */
      metadata?: string | null;
      /**
       * Collection Id
       * @description Optional collection ID to auto-add document to after processing
       */
      collection_id?: string | null;
    };
    /** Body_upload_emg_portfolio_api_v2_ml_scribe_internal_admin_emg_upload_portfolio_post */
    Body_upload_emg_portfolio_api_v2_ml_scribe_internal_admin_emg_upload_portfolio_post: {
      /**
       * File
       * Format: binary
       * @description JSON dump for the portfolio (aims.json or guidelines.json)
       */
      file: string;
    };
    /** Body_upload_files_api_v1_ml_scribe_form_files__post */
    Body_upload_files_api_v1_ml_scribe_form_files__post: {
      /** Upload Files */
      upload_files: string[];
    };
    /** Body_upload_gallery_template_pdf_api_v2_ml_scribe_internal_admin_gallery_templates_upload_pdf_post */
    Body_upload_gallery_template_pdf_api_v2_ml_scribe_internal_admin_gallery_templates_upload_pdf_post: {
      /**
       * Pdf File
       * Format: binary
       * @description PDF file for the form template
       */
      pdf_file: string;
    };
    /** Body_upload_letter_attachment_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments_post */
    Body_upload_letter_attachment_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_upload_media_api_v2_ml_scribe_calls_inbox__phone_number__media_post */
    Body_upload_media_api_v2_ml_scribe_calls_inbox__phone_number__media_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_upload_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents_post */
    Body_upload_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents_post: {
      /**
       * File
       * Format: binary
       * @description Document file to upload
       */
      file: string;
      /**
       * Description
       * @description Optional free-text note about the document
       */
      description?: string | null;
      /**
       * Session Id
       * @description Optional session_id if the document was uploaded during a session
       */
      session_id?: string | null;
    };
    /** Body_upload_profile_picture_api_v1_ml_scribe_user_profile_picture_post */
    Body_upload_profile_picture_api_v1_ml_scribe_user_profile_picture_post: {
      /**
       * Upload File
       * Format: binary
       */
      upload_file: string;
    };
    /** Body_upload_project_attachment_api_v2_ml_scribe_projects__project_id__attachments_post */
    Body_upload_project_attachment_api_v2_ml_scribe_projects__project_id__attachments_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_upload_protocol_document_api_v2_ml_scribe_protocols__protocol_id__documents_post */
    Body_upload_protocol_document_api_v2_ml_scribe_protocols__protocol_id__documents_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_upload_recording_for_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__upload_post */
    Body_upload_recording_for_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__upload_post: {
      /**
       * Upload
       * Format: binary
       */
      upload: string;
      /** Name */
      name?: string | null;
      /** Team Id */
      team_id?: string | null;
      /** Analysis Model */
      analysis_model?: string | null;
      /** Synthesis Model */
      synthesis_model?: string | null;
    };
    /** Body_upload_rpa_recording_api_v2_ml_scribe_rpa_recordings_post */
    Body_upload_rpa_recording_api_v2_ml_scribe_rpa_recordings_post: {
      /**
       * Upload
       * Format: binary
       */
      upload: string;
      /** Name */
      name: string;
      /** App Version */
      app_version?: string | null;
    };
    /** Body_upload_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_post */
    Body_upload_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_post: {
      /** Context Documents */
      context_documents: string[];
      /**
       * Meta Data
       * @default []
       */
      meta_data: components['schemas']['OpenAPISessionContextDocumentMetaData'][] | null;
    };
    /** Body_upload_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_post */
    Body_upload_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_post: {
      /** Context Documents */
      context_documents: string[];
      /**
       * Meta Data
       * @default []
       */
      meta_data: components['schemas']['SessionContextDocumentMetaData'][] | null;
    };
    /** Body_upload_session_schedule_api_v2_ml_scribe_sessions_upload_schedule_post */
    Body_upload_session_schedule_api_v2_ml_scribe_sessions_upload_schedule_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_upload_snippets_csv_api_v2_ml_scribe_snippets_batch_upload_post */
    Body_upload_snippets_csv_api_v2_ml_scribe_snippets_batch_upload_post: {
      /**
       * File
       * Format: binary
       */
      file: string;
    };
    /** Body_upload_vidal_monographs_api_v2_ml_scribe_internal_admin_vidal_upload_monographs_post */
    Body_upload_vidal_monographs_api_v2_ml_scribe_internal_admin_vidal_upload_monographs_post: {
      /**
       * File
       * Format: binary
       * @description ZIP file containing vmp_*.html files
       */
      file: string;
    };
    /**
     * BootstrapCallRequest
     * @description Bootstrap body. Every telehealth call links to a Heidi session, so
     *     ``session_id`` is required; the response carries a ``client_state`` the app
     *     attaches to the SDK dial.
     */
    BootstrapCallRequest: {
      /**
       * Session Id
       * @description Heidi session to link this call to. Must exist and belong to the caller. The response carries a client_state the app attaches to the SDK dial.
       */
      session_id: string;
    };
    /**
     * BootstrapCallResponse
     * @description Flat, extensible mobile contract. ``token`` is the short-lived Telnyx
     *     WebRTC JWT. Every telehealth call links to a Heidi session, so ``session_id``
     *     and ``client_state`` are always present: ``client_state`` is the opaque token
     *     the app attaches to the SDK dial (as the ``X-Heidi-Client-State`` custom
     *     header) so comms links the call, its recording, and its transcript back to
     *     the session.
     *
     *     The server selects the From number and puts it on the PSTN leg; the app never
     *     sends or displays it, so it is not returned here (a user with no verified
     *     number gets a 409 before this response). A verified-numbers list can be added
     *     later if the app needs to show or switch caller IDs.
     *
     *     ``region`` is the Telnyx SDK edge region comms picks for this cell, so the
     *     app pins the WebRTC edge server-side. For a PSTN-bridged call this edge is
     *     where the media actually transits, so it is a data-routing decision, not
     *     just a latency hint; the value is not client-supplied and is constrained to
     *     comms' own cell-to-edge mapping (our approved deployment regions). Always
     *     present: defaults to ``"auto"`` (the SDK's auto-select sentinel) when comms
     *     has not mapped this cell or is an older build without the field, so the app
     *     always gets a concrete value to pass to the SDK and never a null branch.
     */
    BootstrapCallResponse: {
      /** Token */
      token: string;
      /** Session Id */
      session_id: string;
      /** Client State */
      client_state: string;
      /**
       * Region
       * @default auto
       */
      region: string;
    };
    /**
     * Brain
     * @description Brain enum for different AI model configurations.
     *
     *     Each brain represents a different AI model configuration with specific characteristics:
     *     - LEFT: Fast and simple model
     *     - RIGHT: Creative and artistic model
     *     - FREE: Basic model for free users. DO NOT USE THIS BRAIN FOR NOW
     *     - PRO: Advanced model for paid users (previously left brain). DO NOT USE THIS BRAIN FOR NOW
     *     - REASONING: Advanced reasoning model for paid users (previously right brain). DO NOT USE THIS BRAIN FOR NOW
     * @enum {string}
     */
    Brain: Brain;
    /** BranchItem */
    BranchItem: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: BranchItemKind;
      /** Item Id */
      item_id: string;
      /** Label */
      label: string;
      /** Hint */
      hint?: string | null;
      /** Options */
      options: components['schemas']['BranchOption'][];
    };
    /** BranchOption */
    BranchOption: {
      /** Option Id */
      option_id: string;
      /** Label */
      label: string;
      /** Items */
      items: (
        | components['schemas']['CheckItem']
        | components['schemas']['InfoItem']
        | components['schemas']['ChoiceItem']
        | components['schemas']['CondItem']
        | components['schemas']['ForkItem']
        | components['schemas']['BranchItem']
      )[];
    };
    /**
     * BudgetThinking
     * @description Legacy fixed-token extended thinking (``thinking.type == "enabled"``).
     */
    BudgetThinking: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: BudgetThinkingKind;
      /** Budget Tokens */
      budget_tokens: number;
    };
    /** BuildCustomTemplateRequest */
    BuildCustomTemplateRequest: {
      /** Name */
      name?: string | null;
      /** Description */
      description?: string | null;
      /** Document */
      document: string;
      /**
       * Is Private
       * @default true
       */
      is_private: boolean;
      content_type?: components['schemas']['ContentType'] | null;
    };
    /**
     * BulkAssignAccessEntitlementRequest
     * @description Assign or update the same entitlement for many users (team-admin web API).
     */
    BulkAssignAccessEntitlementRequest: {
      /**
       * User Ref Ids
       * @description Target users' user_ref_id values (duplicates are applied once)
       */
      user_ref_ids: string[];
      /**
       * Entitlement Type Id
       * @description ID of the AccessEntitlementType to assign or update. If both id and name are sent, id is used to resolve the type.
       */
      entitlement_type_id?: string | null;
      /**
       * Entitlement Type Name
       * @description Unique name of the AccessEntitlementType. Used when entitlement_type_id is omitted or empty.
       */
      entitlement_type_name?: string | null;
      /**
       * Enabled
       * @description Whether this entitlement should be enabled
       * @default true
       */
      enabled: boolean;
    };
    /** BulkAssignUserEntitlementFailure */
    BulkAssignUserEntitlementFailure: {
      /** User Ref Id */
      user_ref_id: string;
      /**
       * Code
       * @enum {string}
       */
      code: BulkAssignUserEntitlementFailureCode;
      /** Detail */
      detail: string;
    };
    /** BulkAssignUserEntitlementSuccess */
    BulkAssignUserEntitlementSuccess: {
      /** User Ref Id */
      user_ref_id: string;
      /**
       * Action
       * @enum {string}
       */
      action: BulkAssignUserEntitlementSuccessAction;
      entitlement: components['schemas']['AccessEntitlementView'];
    };
    /** BulkAssignUserEntitlementsResponse */
    BulkAssignUserEntitlementsResponse: {
      /** Succeeded */
      succeeded: components['schemas']['BulkAssignUserEntitlementSuccess'][];
      /** Failed */
      failed: components['schemas']['BulkAssignUserEntitlementFailure'][];
    };
    /** BulkCreateBlockedNumberRequest */
    BulkCreateBlockedNumberRequest: {
      /** Entries */
      entries: components['schemas']['CreateBlockedNumberRequest'][];
    };
    /** BulkCreateBlockedNumberView */
    BulkCreateBlockedNumberView: {
      /** Added */
      added: components['schemas']['BlockedNumberView'][];
      /** Duplicates */
      duplicates: components['schemas']['BlockedNumberView'][];
      /**
       * Invalid
       * @default []
       */
      invalid: string[];
    };
    /** BulkCreateCallPayload */
    BulkCreateCallPayload: {
      /** Calls */
      calls: components['schemas']['CallCreate'][];
    };
    /** BulkCreateCallResult */
    BulkCreateCallResult: {
      /** Success Count */
      success_count: number;
      /** Errors */
      errors: number;
    };
    /** BulkCreateSessionParams */
    BulkCreateSessionParams: {
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      /** Ehr Appointment Id */
      ehr_appointment_id?: string | null;
      /** Created Time Local */
      created_time_local?: string | null;
      session_status?: components['schemas']['SessionStatus'] | null;
      /** Patient Name */
      patient_name?: string | null;
      timezone?: components['schemas']['TimeZones'] | null;
      /**
       * Context
       * @description Pre-session context (reason for visit etc.) persisted onto Session.clinician_notes.
       */
      context?: string | null;
    };
    /** BulkCreateTemplateCSVFileUploadResult */
    BulkCreateTemplateCSVFileUploadResult: {
      /** Error Rows */
      error_rows?: components['schemas']['FileUploadRow'][];
      /** Skip Rows */
      skip_rows?: components['schemas']['FileUploadRow'][];
      /** Inserted Rows */
      inserted_rows?: components['schemas']['FileUploadRow'][];
      /** Updated Rows */
      updated_rows?: components['schemas']['FileUploadRow'][];
    };
    /** BulkCreateTemplateCSVFileValidateResult */
    BulkCreateTemplateCSVFileValidateResult: {
      /** Error Rows */
      error_rows?: components['schemas']['FileUploadRow'][];
      /** Skip Rows */
      skip_rows?: components['schemas']['FileUploadRow'][];
      /** New Rows */
      new_rows?: components['schemas']['FileUploadRow'][];
      /** Update Rows */
      update_rows?: components['schemas']['FileUploadRow'][];
    };
    /** BulkCreateUserCSVFileInsertedRow */
    BulkCreateUserCSVFileInsertedRow: {
      /**
       * Row
       * @description row number, start from 2 (the same as csv row number, skip header and start from 1)
       */
      row: number;
      /**
       * Msg
       * @description validate message
       */
      msg: string;
      /**
       * Data
       * @description data of the row
       */
      data: {
        [key: string]: unknown;
      };
      model?: components['schemas']['UserResponse'] | null;
    };
    /** BulkCreateUserCSVFileUploadResult */
    BulkCreateUserCSVFileUploadResult: {
      /** Error Rows */
      error_rows?: components['schemas']['BulkCreateUserCSVFileValidateRow'][];
      /** Skip Rows */
      skip_rows?: components['schemas']['BulkCreateUserCSVFileValidateRow'][];
      /** Inserted Rows */
      inserted_rows?: components['schemas']['BulkCreateUserCSVFileInsertedRow'][];
      /** Updated Rows */
      updated_rows?: components['schemas']['FileUploadRow'][];
    };
    /** BulkCreateUserCSVFileValidateResult */
    BulkCreateUserCSVFileValidateResult: {
      /** Error Rows */
      error_rows?: components['schemas']['BulkCreateUserCSVFileValidateRow'][];
      /** Skip Rows */
      skip_rows?: components['schemas']['BulkCreateUserCSVFileValidateRow'][];
      /** New Rows */
      new_rows?: components['schemas']['BulkCreateUserCSVFileValidateRow'][];
      /** Update Rows */
      update_rows?: components['schemas']['FileUploadRow'][];
    };
    /** BulkCreateUserCSVFileValidateRow */
    BulkCreateUserCSVFileValidateRow: {
      /**
       * Row
       * @description row number, start from 2 (the same as csv row number, skip header and start from 1)
       */
      row: number;
      /**
       * Msg
       * @description validate message
       */
      msg: string;
      /**
       * Data
       * @description data of the row
       */
      data: {
        [key: string]: unknown;
      };
      model?: components['schemas']['BulkCreateUserCSVRow'] | null;
    };
    /** BulkCreateUserCSVRow */
    BulkCreateUserCSVRow: {
      /** User Email */
      user_email: string;
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      region: components['schemas']['Region'];
      country: components['schemas']['Country'];
      /** Specialty Name */
      specialty_name?: string | null;
      /** Specialty Id */
      specialty_id?: string | null;
      specialty?: components['schemas']['Specialty'] | null;
      /**
       * Sso
       * @description The SSO enterprise connection name on Kinde
       */
      sso?: string | null;
    };
    /**
     * BulkDeleteChatsRequest
     * @description Request schema for bulk deleting chats.
     */
    BulkDeleteChatsRequest: {
      /** Ids */
      ids: string[];
    };
    /**
     * BulkDeleteChatsResponse
     * @description Response schema for bulk delete on chats.
     */
    BulkDeleteChatsResponse: {
      /**
       * Deleted
       * @default []
       */
      deleted: string[];
      /**
       * Failed
       * @default []
       */
      failed: string[];
    };
    /**
     * BulkDeleteDraftsRequest
     * @description Body for `POST /batches/{batch_id}:bulk-delete`.
     *
     *     Same shape as `:bulk-unpublish`. Without `draft_ids`, targets
     *     every `unpublished` draft in the batch; with explicit ids,
     *     validates each individually so a wrong-batch or wrong-status id
     *     surfaces as a precise per-draft failure.
     */
    BulkDeleteDraftsRequest: {
      /**
       * Deleted By
       * Format: email
       */
      deleted_by: string;
      /** Draft Ids */
      draft_ids?: string[] | null;
    };
    /** BulkDeleteDraftsResponse */
    BulkDeleteDraftsResponse: {
      /** Batch Id */
      batch_id: string;
      /** Requested Count */
      requested_count: number;
      /** Deleted Count */
      deleted_count: number;
      /** Failed Count */
      failed_count: number;
      /** Failures */
      failures?: components['schemas']['BulkDeleteFailure'][];
      /**
       * Message
       * @default Bulk delete completed
       */
      message: string;
    };
    /** BulkDeleteFailure */
    BulkDeleteFailure: {
      /** Draft Id */
      draft_id: string;
      /** Reason */
      reason: string;
    };
    /** BulkDeletePatientProfilesRequest */
    BulkDeletePatientProfilesRequest: {
      /** Patient Profile Ids */
      patient_profile_ids: string[];
      /** Kinde User Id */
      kinde_user_id: string;
    };
    /** BulkDeletePatientProfilesResponse */
    BulkDeletePatientProfilesResponse: {
      /** Deleted Count */
      deleted_count: number;
      /** Unlinked Session Count */
      unlinked_session_count: number;
    };
    /**
     * BulkDeleteRequest
     * @description Request schema for bulk deleting clinical tasks.
     */
    BulkDeleteRequest: {
      /** Ids */
      ids: string[];
    };
    /**
     * BulkDeleteResponse
     * @description Response schema for bulk delete on clinical tasks.
     */
    BulkDeleteResponse: {
      /**
       * Deleted
       * @default []
       */
      deleted: string[];
      /**
       * Failed
       * @default []
       */
      failed: string[];
    };
    /** BulkDeleteSessionTranscriptsRequest */
    BulkDeleteSessionTranscriptsRequest: {
      /** Session Ids */
      session_ids: string[];
      /** Operator */
      operator: string;
    };
    /** BulkDeleteSessionTranscriptsResponse */
    BulkDeleteSessionTranscriptsResponse: {
      /** Deleted Count */
      deleted_count: number;
      /** Skipped Count */
      skipped_count: number;
      /** Not Found Count */
      not_found_count: number;
      /** Not Enabled Count */
      not_enabled_count: number;
      /** Failed Count */
      failed_count: number;
    };
    /**
     * BulkDeleteUserAccessEntitlementRequest
     * @description Soft-delete the same direct user entitlement for many users (team-admin web API).
     */
    BulkDeleteUserAccessEntitlementRequest: {
      /**
       * User Ref Ids
       * @description Target users' user_ref_id values (duplicates are applied once)
       */
      user_ref_ids: string[];
      /**
       * Entitlement Type Id
       * @description ID of the AccessEntitlementType to revoke. If both id and name are sent, id is used to resolve the type.
       */
      entitlement_type_id?: string | null;
      /**
       * Entitlement Type Name
       * @description Unique name of the AccessEntitlementType. Used when entitlement_type_id is omitted or empty.
       */
      entitlement_type_name?: string | null;
    };
    /**
     * BulkDeleteUserEHRLaunchProfilesResult
     * @description Result of executing the bulk hard-delete CSV.
     */
    BulkDeleteUserEHRLaunchProfilesResult: {
      /**
       * Error Rows
       * @default []
       */
      error_rows: components['schemas']['FileUploadRow'][];
      /**
       * Skip Rows
       * @default []
       */
      skip_rows: components['schemas']['FileUploadRow'][];
      /**
       * Deleted Rows
       * @default []
       */
      deleted_rows: components['schemas']['FileUploadRow'][];
      /**
       * Deleted Profile Count
       * @default 0
       */
      deleted_profile_count: number;
      /**
       * Deleted Session Count
       * @default 0
       */
      deleted_session_count: number;
    };
    /**
     * BulkDeleteUserEHRLaunchProfilesValidateResult
     * @description Dry-run preview for the bulk hard-delete CSV.
     */
    BulkDeleteUserEHRLaunchProfilesValidateResult: {
      /**
       * Error Rows
       * @default []
       */
      error_rows: components['schemas']['FileUploadRow'][];
      /**
       * Skip Rows
       * @default []
       */
      skip_rows: components['schemas']['FileUploadRow'][];
      /**
       * Delete Rows
       * @default []
       */
      delete_rows: components['schemas']['FileUploadRow'][];
    };
    /** BulkDeleteUserEntitlementFailure */
    BulkDeleteUserEntitlementFailure: {
      /** User Ref Id */
      user_ref_id: string;
      /**
       * Code
       * @enum {string}
       */
      code: BulkDeleteUserEntitlementFailureCode;
      /** Detail */
      detail: string;
    };
    /** BulkDeleteUserEntitlementSuccess */
    BulkDeleteUserEntitlementSuccess: {
      /** User Ref Id */
      user_ref_id: string;
      /** Entitlement Id */
      entitlement_id: string;
    };
    /** BulkDeleteUserEntitlementsResponse */
    BulkDeleteUserEntitlementsResponse: {
      /** Succeeded */
      succeeded: components['schemas']['BulkDeleteUserEntitlementSuccess'][];
      /** Failed */
      failed: components['schemas']['BulkDeleteUserEntitlementFailure'][];
    };
    /** BulkMoveMemberResult */
    BulkMoveMemberResult: {
      /** Member Id */
      member_id: string;
      /**
       * Status
       * @enum {string}
       */
      status: BulkMoveMemberResultStatus;
      /** Error */
      error?: string | null;
    };
    /**
     * BulkPublishDraftsRequest
     * @description Body for `POST /batches/{batch_id}:bulk-publish`.
     *
     *     `draft_ids` is optional:
     *     - omitted / null -> publish every draft in the batch that is in
     *       `ready_to_publish` (the "publish all ready" UX path).
     *     - non-empty list -> publish exactly those drafts (the multi-select
     *       UX path). Each id must belong to the batch and be in
     *       `ready_to_publish`; mismatched ids are recorded as per-draft
     *       failures rather than aborting the whole call.
     */
    BulkPublishDraftsRequest: {
      /** Draft Ids */
      draft_ids?: string[] | null;
    };
    /** BulkPublishDraftsResponse */
    BulkPublishDraftsResponse: {
      /** Batch Id */
      batch_id: string;
      /** Requested Count */
      requested_count: number;
      /** Published Count */
      published_count: number;
      /** Failed Count */
      failed_count: number;
      /** Failures */
      failures?: components['schemas']['BulkPublishFailure'][];
      /**
       * Message
       * @default Bulk publish completed
       */
      message: string;
    };
    /** BulkPublishFailure */
    BulkPublishFailure: {
      /** Draft Id */
      draft_id: string;
      /** Reason */
      reason: string;
    };
    /**
     * BulkRejectDraftsRequest
     * @description Body for `POST /batches/{batch_id}:bulk-reject`.
     *
     *     Mirrors the other bulk actions: `draft_ids` omitted targets every
     *     rejectable draft (`ready_for_review` / `sent_for_review` /
     *     `ready_to_publish`) in the batch, a list scopes to that subset.
     *     `reason` is required and stamped on every rejected draft;
     *     `rejected_by` validated as an email at deserialization.
     */
    BulkRejectDraftsRequest: {
      /** Reason */
      reason: string;
      /**
       * Rejected By
       * Format: email
       */
      rejected_by: string;
      /** Draft Ids */
      draft_ids?: string[] | null;
    };
    /** BulkRejectDraftsResponse */
    BulkRejectDraftsResponse: {
      /** Batch Id */
      batch_id: string;
      /** Requested Count */
      requested_count: number;
      /** Rejected Count */
      rejected_count: number;
      /** Failed Count */
      failed_count: number;
      /** Failures */
      failures?: components['schemas']['BulkRejectFailure'][];
      /**
       * Message
       * @default Bulk reject completed
       */
      message: string;
    };
    /** BulkRejectFailure */
    BulkRejectFailure: {
      /** Draft Id */
      draft_id: string;
      /** Reason */
      reason: string;
    };
    /** BulkRemoveMemberResult */
    BulkRemoveMemberResult: {
      /** Member Id */
      member_id: string;
      /**
       * Status
       * @enum {string}
       */
      status: BulkRemoveMemberResultStatus;
      /** Error */
      error?: string | null;
    };
    /** BulkResetFailure */
    BulkResetFailure: {
      /** Draft Id */
      draft_id: string;
      /** Reason */
      reason: string;
    };
    /**
     * BulkResetQuotaRequest
     * @description Request schema for resetting every active user's quota in bulk.
     */
    BulkResetQuotaRequest: {
      /**
       * Dry Run
       * @description When True, count the active users that would be reset and perform no write.
       * @default false
       */
      dry_run: boolean;
      /**
       * Month Start
       * @description Start of the current month in the caller's schedule timezone. Used as the created_at / quota_last_reset_at boundary: users created on or after it (this month's signups) and users already reset on or after it (idempotency) are excluded. The Airflow scheduler passes this so the boundary follows the per-region schedule timezone rather than server UTC. If omitted, the server uses the current UTC calendar-month start.
       */
      month_start?: string | null;
    };
    /**
     * BulkResetQuotaResponse
     * @description Response schema for the bulk reset-all-users quota operation.
     */
    BulkResetQuotaResponse: {
      /**
       * Matched Count
       * @description Number of active users matched by the reset filter.
       */
      matched_count: number;
      /**
       * Modified Count
       * @description Number of users actually modified (0 on a dry run).
       */
      modified_count: number;
      /**
       * Dry Run
       * @description Whether the request was a dry run (no write performed).
       */
      dry_run: boolean;
      /**
       * Excluded Created On Or After
       * @description Current-month start boundary (UTC). Users created on or after this instant are excluded from the reset because they received a fresh quota at sign-up. Provided so callers can log the exclusion.
       */
      excluded_created_on_or_after?: string | null;
    };
    /**
     * BulkResetToReadyForReviewRequest
     * @description Body for `POST /batches/{batch_id}:bulk-reset-to-ready-for-review`.
     *
     *     `draft_ids` is optional with the same semantics as the other bulk
     *     actions: omit to target every `sent_for_review` and
     *     `ready_to_publish` draft in the batch, or supply a list to target
     *     a subset.
     */
    BulkResetToReadyForReviewRequest: {
      /** Draft Ids */
      draft_ids?: string[] | null;
    };
    /** BulkResetToReadyForReviewResponse */
    BulkResetToReadyForReviewResponse: {
      /** Batch Id */
      batch_id: string;
      /** Requested Count */
      requested_count: number;
      /** Reset Count */
      reset_count: number;
      /** Failed Count */
      failed_count: number;
      /** Failures */
      failures?: components['schemas']['BulkResetFailure'][];
      /**
       * Message
       * @default Bulk reset to ready_for_review completed
       */
      message: string;
    };
    /** BulkResolveItemResult */
    BulkResolveItemResult: {
      /** Approval Id */
      approval_id: string;
      /** Agent Run Id */
      agent_run_id?: string | null;
      /** Status */
      status: number;
      /** Detail */
      detail?: string | null;
      /**
       * Terminal
       * @default true
       */
      terminal: boolean;
    };
    /** BulkResolveRequest */
    BulkResolveRequest: {
      /** Items */
      items: string[];
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /** BulkResolveResponse */
    BulkResolveResponse: {
      /** Results */
      results: components['schemas']['BulkResolveItemResult'][];
    };
    /**
     * BulkSignoffDraftsRequest
     * @description Body for `POST /batches/{batch_id}:bulk-signoff`.
     *
     *     `reviewed_by` is required - signoff stamps it on every transitioned
     *     draft. `draft_ids` is optional with the same semantics as
     *     bulk-publish: omit to target every `sent_for_review` draft in the
     *     batch, or supply a list to target a subset.
     */
    BulkSignoffDraftsRequest: {
      /** Reviewed By */
      reviewed_by: string;
      /** Draft Ids */
      draft_ids?: string[] | null;
    };
    /** BulkSignoffDraftsResponse */
    BulkSignoffDraftsResponse: {
      /** Batch Id */
      batch_id: string;
      /** Requested Count */
      requested_count: number;
      /** Signed Off Count */
      signed_off_count: number;
      /** Failed Count */
      failed_count: number;
      /** Failures */
      failures?: components['schemas']['BulkSignoffFailure'][];
      /**
       * Message
       * @default Bulk signoff completed
       */
      message: string;
    };
    /** BulkSignoffFailure */
    BulkSignoffFailure: {
      /** Draft Id */
      draft_id: string;
      /** Reason */
      reason: string;
    };
    /**
     * BulkUnpublishDraftsRequest
     * @description Body for `POST /batches/{batch_id}:bulk-unpublish`.
     *
     *     Mirrors the bulk-publish/bulk-signoff shape: `draft_ids` omitted
     *     targets every `published` draft in the batch, a list scopes to
     *     that subset. `unpublished_by` is stamped on every transitioned
     *     draft and validated as an email at deserialization time via
     *     Pydantic's `EmailStr`.
     */
    BulkUnpublishDraftsRequest: {
      /**
       * Unpublished By
       * Format: email
       */
      unpublished_by: string;
      /** Draft Ids */
      draft_ids?: string[] | null;
    };
    /** BulkUnpublishDraftsResponse */
    BulkUnpublishDraftsResponse: {
      /** Batch Id */
      batch_id: string;
      /** Requested Count */
      requested_count: number;
      /** Unpublished Count */
      unpublished_count: number;
      /** Failed Count */
      failed_count: number;
      /** Failures */
      failures?: components['schemas']['BulkUnpublishFailure'][];
      /**
       * Message
       * @default Bulk unpublish completed
       */
      message: string;
    };
    /** BulkUnpublishFailure */
    BulkUnpublishFailure: {
      /** Draft Id */
      draft_id: string;
      /** Reason */
      reason: string;
    };
    /**
     * BulkUpdateStatusRequest
     * @description Request schema for bulk updating clinical task status.
     */
    BulkUpdateStatusRequest: {
      /** Ids */
      ids: string[];
      status: components['schemas']['ClinicalTaskStatus'];
    };
    /**
     * BulkUpdateStatusResponse
     * @description Response schema for bulk status update on clinical tasks.
     */
    BulkUpdateStatusResponse: {
      /**
       * Updated
       * @default []
       */
      updated: string[];
      /**
       * Failed
       * @default []
       */
      failed: string[];
    };
    /** BulkUpdateUserIdentityCSVFileUploadResult */
    BulkUpdateUserIdentityCSVFileUploadResult: {
      /** Error Rows */
      error_rows?: components['schemas']['BulkUpdateUserIdentityCSVFileValidateRow'][];
      /** Skip Rows */
      skip_rows?: components['schemas']['BulkUpdateUserIdentityCSVFileValidateRow'][];
      /** Inserted Rows */
      inserted_rows?: components['schemas']['FileUploadRow'][];
      /** Updated Rows */
      updated_rows?: components['schemas']['BulkUpdateUserIdentityCSVFileValidateRow'][];
    };
    /** BulkUpdateUserIdentityCSVFileValidateResult */
    BulkUpdateUserIdentityCSVFileValidateResult: {
      /** Error Rows */
      error_rows?: components['schemas']['BulkUpdateUserIdentityCSVFileValidateRow'][];
      /** Skip Rows */
      skip_rows?: components['schemas']['BulkUpdateUserIdentityCSVFileValidateRow'][];
      /** New Rows */
      new_rows?: components['schemas']['BulkUpdateUserIdentityCSVFileValidateRow'][];
      /** Update Rows */
      update_rows?: components['schemas']['FileUploadRow'][];
    };
    /** BulkUpdateUserIdentityCSVFileValidateRow */
    BulkUpdateUserIdentityCSVFileValidateRow: {
      /**
       * Row
       * @description row number, start from 2 (the same as csv row number, skip header and start from 1)
       */
      row: number;
      /**
       * Msg
       * @description validate message
       */
      msg: string;
      /**
       * Data
       * @description data of the row
       */
      data: {
        [key: string]: unknown;
      };
      model?: components['schemas']['BulkUpdateUserIdentityCSVRow'] | null;
    };
    /** BulkUpdateUserIdentityCSVRow */
    BulkUpdateUserIdentityCSVRow: {
      /** User Email */
      user_email: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Sso */
      sso: string;
    };
    /**
     * BulkUploadErrorCode
     * @enum {string}
     */
    BulkUploadErrorCode: BulkUploadErrorCode;
    /**
     * BulkUploadFailedStage
     * @enum {string}
     */
    BulkUploadFailedStage: BulkUploadFailedStage;
    /** CIE10ESCodeConcept */
    CIE10ESCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** CIM10FRCodeConcept */
    CIM10FRCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** CIM10MCCodeConcept */
    CIM10MCCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** CIM10SCPCodeConcept */
    CIM10SCPCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * CPDActivitiesResponse
     * @description Response for GET /cpd/activities — all activities with settings-aware times.
     */
    CPDActivitiesResponse: {
      /**
       * Total Time Minutes
       * @default 0
       */
      total_time_minutes: number;
      /**
       * Total Activities
       * @default 0
       */
      total_activities: number;
      /**
       * Total Sources
       * @default 0
       */
      total_sources: number;
      /** @default content_based */
      time_calculation_method: components['schemas']['CPDTimeCalculationMethodResponse'];
      /** Activities */
      activities?: components['schemas']['CPDActivityResponse'][];
    };
    /**
     * CPDActivityResponse
     * @description A single activity (chat session) with pre-calculated times.
     */
    CPDActivityResponse: {
      /** Chat Id */
      chat_id: string;
      /** Chat Title */
      chat_title: string;
      /**
       * Date
       * @description ISO date string of when this activity occurred
       */
      date: string;
      /**
       * Total Time Minutes
       * @description Total time for this activity, calculated per user settings
       */
      total_time_minutes: number;
      /** Source Count */
      source_count: number;
      /** Sources */
      sources?: components['schemas']['CPDActivitySourceResponse'][];
    };
    /**
     * CPDActivitySourceResponse
     * @description A source within an activity, with time calculated per user's settings.
     */
    CPDActivitySourceResponse: {
      /** Id */
      id: string;
      /** Url */
      url: string;
      /** Title */
      title: string;
      /** Domain */
      domain: string;
      /** Source Name */
      source_name: string;
      /** Icon Url */
      icon_url: string;
      /**
       * Time Minutes
       * @description Time for this source in this activity, calculated per user settings
       */
      time_minutes: number;
      /**
       * Is Read
       * @default false
       */
      is_read: boolean;
      /**
       * Is Saved
       * @default false
       */
      is_saved: boolean;
    };
    /**
     * CPDDeleteActivityResponse
     * @description Response for DELETE /cpd/activities/{chat_id}.
     */
    CPDDeleteActivityResponse: {
      /** Chat Id */
      chat_id: string;
      /** Deleted */
      deleted: boolean;
      /** Message */
      message: string;
    };
    /**
     * CPDDraftCreateRequest
     * @description Request for POST /cpd/drafts.
     */
    CPDDraftCreateRequest: {
      /**
       * Start Date
       * @description Export period start (ISO date)
       */
      start_date: string;
      /**
       * End Date
       * @description Export period end (ISO date)
       */
      end_date: string;
      /**
       * Preset Index
       * @description Quick date range preset index
       */
      preset_index?: number | null;
      /**
       * Removed Chat Ids
       * @description Chat IDs to exclude
       */
      removed_chat_ids?: string[];
    };
    /**
     * CPDDraftResponse
     * @description Response for draft endpoints.
     */
    CPDDraftResponse: {
      /** Id */
      id: string;
      /** Start Date */
      start_date: string;
      /** End Date */
      end_date: string;
      /** Preset Index */
      preset_index?: number | null;
      /** Removed Chat Ids */
      removed_chat_ids?: string[];
      /**
       * Activity Count
       * @default 0
       */
      activity_count: number;
      /**
       * Total Minutes
       * @default 0
       */
      total_minutes: number;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * CPDDraftSubmitRequest
     * @description Request for POST /cpd/drafts/{id}/submit.
     */
    CPDDraftSubmitRequest: {
      /**
       * Activity Count
       * @description Number of activities in export
       */
      activity_count: number;
      /**
       * Source Count
       * @description Number of unique sources
       */
      source_count: number;
      /**
       * Total Minutes
       * @description Total CPD time in minutes
       */
      total_minutes: number;
    };
    /**
     * CPDDraftUpdateRequest
     * @description Request for PUT /cpd/drafts/{id}.
     */
    CPDDraftUpdateRequest: {
      /**
       * Start Date
       * @description New export period start (ISO date). Clears removed_chat_ids when changed.
       */
      start_date?: string | null;
      /**
       * End Date
       * @description New export period end (ISO date). Clears removed_chat_ids when changed.
       */
      end_date?: string | null;
      /**
       * Preset Index
       * @description Quick date range preset index
       */
      preset_index?: number | null;
      /**
       * Removed Chat Ids
       * @description Chat IDs to exclude. Ignored when start_date or end_date is also provided (date changes reset exclusions).
       */
      removed_chat_ids?: string[] | null;
      /** Activity Count */
      activity_count?: number | null;
      /** Total Minutes */
      total_minutes?: number | null;
    };
    /**
     * CPDExportPeriodResponse
     * @description Period information for export.
     */
    CPDExportPeriodResponse: {
      /** Start */
      start: string;
      /** End */
      end: string;
    };
    /**
     * CPDExportResponse
     * @description Response for GET /cpd/export.
     */
    CPDExportResponse: {
      period: components['schemas']['CPDExportPeriodResponse'];
      /** Total Time Minutes */
      total_time_minutes: number;
      /** Total Sources */
      total_sources: number;
      /** Sources */
      sources: components['schemas']['CPDExportSourceResponse'][];
    };
    /**
     * CPDExportSourceResponse
     * @description Single source in export - flat list of all sources.
     */
    CPDExportSourceResponse: {
      /** Title */
      title: string;
      /** Url */
      url: string;
      /** Domain */
      domain: string;
      /** Source Name */
      source_name: string;
      /** Specialty */
      specialty: string[];
      /** Time Minutes */
      time_minutes: number;
      /**
       * First Accessed At
       * Format: date-time
       */
      first_accessed_at: string;
      /**
       * Last Accessed At
       * Format: date-time
       */
      last_accessed_at: string;
      /** Access Count */
      access_count: number;
    };
    /**
     * CPDGoalModeResponse
     * @description Goal tracking mode for CPD.
     * @enum {string}
     */
    CPDGoalModeResponse: CPDGoalModeResponse;
    /**
     * CPDHomepageResponse
     * @description Response for GET /cpd/homepage — all homepage data in one call.
     */
    CPDHomepageResponse: {
      /**
       * Total Time Minutes
       * @default 0
       */
      total_time_minutes: number;
      /**
       * Total Sources
       * @default 0
       */
      total_sources: number;
      /**
       * Chat Thread Count
       * @default 0
       */
      chat_thread_count: number;
      source_filter_counts?: components['schemas']['CPDSourceFilterCounts'];
      /** Journals */
      journals?: components['schemas']['CPDJournalResponse'][];
      /** Recommended */
      recommended?: components['schemas']['CPDRecommendedSourceResponse'][];
      /** Recent */
      recent?: components['schemas']['CPDRecentSourceResponse'][];
    };
    /**
     * CPDJournalListResponse
     * @description Response for GET /cpd/journals.
     */
    CPDJournalListResponse: {
      /** Journals */
      journals: components['schemas']['CPDJournalResponse'][];
      /** Total */
      total: number;
    };
    /**
     * CPDJournalResponse
     * @description Aggregated journal/publisher data.
     */
    CPDJournalResponse: {
      /** Source Name */
      source_name: string;
      /** Icon Url */
      icon_url: string;
      /** Domain */
      domain: string;
      /** Article Count */
      article_count: number;
      /** Total Citations */
      total_citations: number;
      /** Total Time Minutes */
      total_time_minutes: number;
    };
    /**
     * CPDMarkAsReadRequest
     * @description Request for POST /cpd/sources/{id}/read.
     */
    CPDMarkAsReadRequest: {
      /**
       * Chat Id
       * @description Optional - only mark read in this specific chat/activity
       */
      chat_id?: string | null;
      /**
       * Actual Read Time Seconds
       * @description Actual time the user spent reading this source (from viewer timer), in seconds
       */
      actual_read_time_seconds?: number | null;
    };
    /**
     * CPDMarkAsReadResponse
     * @description Response for POST /cpd/sources/{id}/read.
     */
    CPDMarkAsReadResponse: {
      /** Source Id */
      source_id: string;
      /** Appearances Marked */
      appearances_marked: number;
      /** Message */
      message: string;
    };
    /**
     * CPDMarkAsUnreadResponse
     * @description Response for DELETE /cpd/sources/{id}/read.
     */
    CPDMarkAsUnreadResponse: {
      /** Source Id */
      source_id: string;
      /** Appearances Unmarked */
      appearances_unmarked: number;
      /** Message */
      message: string;
    };
    /**
     * CPDPeriodBreakdownResponse
     * @description Time breakdown by period.
     */
    CPDPeriodBreakdownResponse: {
      /**
       * Today
       * @default 0
       */
      today: number;
      /**
       * This Week
       * @default 0
       */
      this_week: number;
      /**
       * This Month
       * @default 0
       */
      this_month: number;
    };
    /**
     * CPDReadSourceByUrlRequest
     * @description Request for POST /cpd/sources/read-by-url.
     */
    CPDReadSourceByUrlRequest: {
      /**
       * Url
       * @description Source URL to mark as read
       */
      url: string;
      /**
       * Title
       * @description Source title (for enrichment fallback)
       */
      title: string;
      /**
       * Actual Read Time Seconds
       * @description Actual time the user spent reading (from viewer timer)
       */
      actual_read_time_seconds?: number | null;
    };
    /**
     * CPDReadSourceByUrlResponse
     * @description Response for POST /cpd/sources/read-by-url.
     */
    CPDReadSourceByUrlResponse: {
      /** Source Id */
      source_id: string;
      /** Marked Read */
      marked_read: boolean;
      /**
       * Created
       * @description True if the source was created on-demand (didn't exist yet)
       */
      created: boolean;
      /** Message */
      message: string;
    };
    /**
     * CPDReadStatusResponse
     * @description Response for GET /cpd/sources/{id}/read-status.
     */
    CPDReadStatusResponse: {
      /** Source Id */
      source_id: string;
      /** Is Read */
      is_read: boolean;
      /** Read At */
      read_at?: string | null;
      /**
       * Appearances Read
       * @default 0
       */
      appearances_read: number;
      /**
       * Appearances Total
       * @default 0
       */
      appearances_total: number;
    };
    /**
     * CPDRecentSourceResponse
     * @description A recently accessed source.
     */
    CPDRecentSourceResponse: {
      /** Id */
      id: string;
      /** Url */
      url: string;
      /** Title */
      title: string;
      /** Domain */
      domain: string;
      /** Source Name */
      source_name: string;
      /** Icon Url */
      icon_url: string;
      /** Access Count */
      access_count: number;
      /** Estimated Time Minutes */
      estimated_time_minutes: number;
      /**
       * Last Accessed At
       * Format: date-time
       */
      last_accessed_at: string;
      /**
       * Is Read
       * @default false
       */
      is_read: boolean;
      /**
       * Is Saved
       * @default false
       */
      is_saved: boolean;
    };
    /**
     * CPDRecommendedSourceResponse
     * @description A recommended source with reason.
     */
    CPDRecommendedSourceResponse: {
      /** Id */
      id: string;
      /** Url */
      url: string;
      /** Title */
      title: string;
      /** Domain */
      domain: string;
      /** Source Name */
      source_name: string;
      /** Icon Url */
      icon_url: string;
      /** Access Count */
      access_count: number;
      /** Estimated Time Minutes */
      estimated_time_minutes: number;
      /** Recommendation Reason */
      recommendation_reason: string;
      /**
       * Is Read
       * @default false
       */
      is_read: boolean;
      /**
       * Is Saved
       * @default false
       */
      is_saved: boolean;
    };
    /**
     * CPDSaveSourceByUrlRequest
     * @description Request for POST /cpd/sources/save-by-url.
     */
    CPDSaveSourceByUrlRequest: {
      /**
       * Url
       * @description Source URL to save
       */
      url: string;
      /**
       * Title
       * @description Source title (for enrichment fallback)
       */
      title: string;
    };
    /**
     * CPDSaveSourceByUrlResponse
     * @description Response for POST /cpd/sources/save-by-url.
     */
    CPDSaveSourceByUrlResponse: {
      /** Source Id */
      source_id: string;
      /** Saved */
      saved: boolean;
      /**
       * Created
       * @description True if the source was created on-demand (didn't exist yet)
       */
      created: boolean;
      /** Message */
      message: string;
    };
    /**
     * CPDSaveSourceResponse
     * @description Response for POST /cpd/sources/{id}/save.
     */
    CPDSaveSourceResponse: {
      /** Source Id */
      source_id: string;
      /** Saved */
      saved: boolean;
      /** Message */
      message: string;
    };
    /**
     * CPDSavedSourceListResponse
     * @description Response for GET /cpd/saved.
     */
    CPDSavedSourceListResponse: {
      /** Sources */
      sources: components['schemas']['CPDSourceResponse'][];
      /** Total */
      total: number;
    };
    /**
     * CPDSettingsResponse
     * @description Response for GET /cpd/settings.
     */
    CPDSettingsResponse: {
      /** @default content_based */
      time_calculation_method: components['schemas']['CPDTimeCalculationMethodResponse'];
      /**
       * Fixed Minutes Per Activity
       * @default 5
       */
      fixed_minutes_per_activity: number;
      /**
       * Fixed Minutes Per Source
       * @default 3
       */
      fixed_minutes_per_source: number;
      /** @default goal */
      goal_mode: components['schemas']['CPDGoalModeResponse'];
      /**
       * Goal Hours
       * @default 50
       */
      goal_hours: number;
      /** Goal Deadline */
      goal_deadline?: string | null;
    };
    /**
     * CPDSettingsUpdateRequest
     * @description Request for PATCH /cpd/settings.
     */
    CPDSettingsUpdateRequest: {
      time_calculation_method?:
        | components['schemas']['CPDTimeCalculationMethodResponse']
        | null;
      /**
       * Fixed Minutes Per Activity
       * @description Fixed minutes per activity (1-120)
       */
      fixed_minutes_per_activity?: number | null;
      /**
       * Fixed Minutes Per Source
       * @description Fixed minutes per source (1-60)
       */
      fixed_minutes_per_source?: number | null;
      goal_mode?: components['schemas']['CPDGoalModeResponse'] | null;
      /**
       * Goal Hours
       * @description Annual target hours (1-500)
       */
      goal_hours?: number | null;
      /**
       * Goal Deadline
       * @description ISO date string for CPD year end (e.g., 2026-12-31)
       */
      goal_deadline?: string | null;
    };
    /**
     * CPDSourceAppearanceResponse
     * @description Appearance summary in list/detail views.
     */
    CPDSourceAppearanceResponse: {
      /** Chat Id */
      chat_id: string;
      /** Chat Title */
      chat_title?: string | null;
      /**
       * Accessed At
       * Format: date-time
       */
      accessed_at: string;
      /** Estimated Time Minutes */
      estimated_time_minutes: number;
      /**
       * Is Read
       * @default false
       */
      is_read: boolean;
      /** Read At */
      read_at?: string | null;
    };
    /**
     * CPDSourceFilterCounts
     * @description Per-filter source counts for the homepage filter pills.
     */
    CPDSourceFilterCounts: {
      /**
       * Total
       * @default 0
       */
      total: number;
      /**
       * Unread
       * @default 0
       */
      unread: number;
      /**
       * Read
       * @default 0
       */
      read: number;
    };
    /**
     * CPDSourceListResponse
     * @description Response for GET /cpd/sources.
     */
    CPDSourceListResponse: {
      /** Sources */
      sources: components['schemas']['CPDSourceResponse'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
    };
    /**
     * CPDSourceResponse
     * @description Source in list view.
     */
    CPDSourceResponse: {
      /** Id */
      id: string;
      /** Url */
      url: string;
      /** Title */
      title: string;
      /** Domain */
      domain: string;
      /** Source Name */
      source_name: string;
      /** Specialty */
      specialty: string[];
      /** Website Type */
      website_type: string[];
      /** Icon Url */
      icon_url: string;
      /** Total Estimated Time Minutes */
      total_estimated_time_minutes: number;
      /**
       * Calculated Time Minutes
       * @description Time calculated using the user's time_calculation_method. None when content_based (same as total_estimated_time_minutes).
       */
      calculated_time_minutes?: number | null;
      /** Access Count */
      access_count: number;
      /**
       * Is Read
       * @default false
       */
      is_read: boolean;
      /**
       * First Accessed At
       * Format: date-time
       */
      first_accessed_at: string;
      /**
       * Last Accessed At
       * Format: date-time
       */
      last_accessed_at: string;
      /** Appearances */
      appearances?: components['schemas']['CPDSourceAppearanceResponse'][];
    };
    /**
     * CPDStatsResponse
     * @description Response for GET /cpd/stats.
     */
    CPDStatsResponse: {
      /**
       * Total Time Minutes
       * @default 0
       */
      total_time_minutes: number;
      /**
       * Total Sources
       * @default 0
       */
      total_sources: number;
      /**
       * Total Appearances
       * @default 0
       */
      total_appearances: number;
      period_breakdown?: components['schemas']['CPDPeriodBreakdownResponse'];
    };
    /**
     * CPDSubmissionResponse
     * @description Response for submission endpoints.
     */
    CPDSubmissionResponse: {
      /** Id */
      id: string;
      /** Start Date */
      start_date: string;
      /** End Date */
      end_date: string;
      /**
       * Activity Count
       * @default 0
       */
      activity_count: number;
      /**
       * Source Count
       * @default 0
       */
      source_count: number;
      /**
       * Total Minutes
       * @default 0
       */
      total_minutes: number;
      /**
       * Submitted At
       * Format: date-time
       */
      submitted_at: string;
    };
    /**
     * CPDTimeCalculationMethodResponse
     * @description Methods for calculating CPD reading time.
     * @enum {string}
     */
    CPDTimeCalculationMethodResponse: CPDTimeCalculationMethodResponse;
    /**
     * CPDUnsaveSourceResponse
     * @description Response for DELETE /cpd/sources/{id}/save.
     */
    CPDUnsaveSourceResponse: {
      /** Source Id */
      source_id: string;
      /** Removed */
      removed: boolean;
      /** Message */
      message: string;
    };
    /**
     * CPTCode
     * @description CPT code with metadata.
     */
    CPTCode: {
      /** Code */
      code: string;
      /** Description */
      description: string;
      /** Rationale */
      rationale?: string | null;
      /** Transcript Excerpt */
      transcript_excerpt?: string | null;
    };
    /** CPTCodeConcept */
    CPTCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** CPTQACodeConcept */
    CPTQACodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * CQCPracticeSearchResponse
     * @description Response for CQC practice search.
     */
    CQCPracticeSearchResponse: {
      /**
       * Results
       * @description List of matching practices
       */
      results?: components['schemas']['CQCPracticeSearchResult'][];
      /**
       * Total
       * @description Total number of matches (may be capped)
       */
      total: number;
    };
    /**
     * CQCPracticeSearchResult
     * @description A single CQC practice search result.
     */
    CQCPracticeSearchResult: {
      /**
       * Id
       * @description Practice document ID
       */
      id: string;
      /**
       * Name
       * @description Practice name
       */
      name: string;
      /**
       * Also Known As
       * @description Also known as
       */
      also_known_as?: string | null;
      /**
       * Address
       * @description Practice address
       */
      address?: string | null;
      /**
       * Postcode
       * @description Practice postcode
       */
      postcode?: string | null;
      /**
       * Phone Number
       * @description Practice phone number
       */
      phone_number?: string | null;
      /**
       * Region
       * @description Region
       */
      region?: string | null;
    };
    /**
     * CQCPracticeStats
     * @description Response schema for CQC practices collection stats.
     */
    CQCPracticeStats: {
      /**
       * Total Count
       * @description Total number of practices in collection
       */
      total_count: number;
    };
    /**
     * CQCPracticeUploadResponse
     * @description Response schema for CQC practices CSV upload.
     */
    CQCPracticeUploadResponse: {
      /**
       * Total Rows Processed
       * @description Total number of rows processed from CSV
       */
      total_rows_processed: number;
      /**
       * Records Inserted
       * @description Number of records inserted into database
       */
      records_inserted: number;
      /**
       * Records Deleted
       * @description Number of existing records deleted before insert
       */
      records_deleted: number;
      /**
       * Errors
       * @description List of errors encountered during processing
       */
      errors?: {
        [key: string]: unknown;
      }[];
    };
    /**
     * CSATRating
     * @enum {integer}
     */
    CSATRating: CSATRating;
    /**
     * CalculatorDetail
     * @description Full calculator metadata including input definitions.
     */
    CalculatorDetail: {
      /** Key */
      key: string;
      /**
       * Formula
       * @default
       */
      formula: string;
      /**
       * Formula Human
       * @default
       */
      formula_human: string;
      /**
       * Formula Machine
       * @default
       */
      formula_machine: string;
      /** Category */
      category?: string | null;
      /** Reference */
      reference?:
        | components['schemas']['CalculatorReference']
        | {
            [key: string]: unknown;
          }
        | string
        | null;
      /** Inputs */
      inputs?: components['schemas']['CalculatorInputDefinition'][];
      /** Terms */
      terms?: components['schemas']['CalculatorTermDefinition'][];
    };
    /** CalculatorInputDefinition */
    CalculatorInputDefinition: {
      /** Variable */
      variable: string;
      /** Label */
      label: string;
      /**
       * Label Key
       * @default
       */
      label_key: string;
      /** Unit */
      unit?: string | null;
      /**
       * Type
       * @default continuous
       */
      type: string;
      /** Options */
      options?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Conditionality */
      conditionality?: string | null;
      /** Ordinal Ranges */
      ordinal_ranges?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Scoring Ranges */
      scoring_ranges?:
        | {
            [key: string]: unknown;
          }[]
        | null;
    };
    /** CalculatorListResponse */
    CalculatorListResponse: {
      /** Total */
      total: number;
      /** Categories */
      categories: {
        [key: string]: string[];
      };
      /** Calculators */
      calculators: components['schemas']['CalculatorSummary'][];
    };
    /** CalculatorReference */
    CalculatorReference: {
      /**
       * Citation
       * @default
       */
      citation: string;
      /**
       * Url
       * @default
       */
      url: string;
      /**
       * Doi
       * @default
       */
      doi: string;
    };
    /** CalculatorSearchResponse */
    CalculatorSearchResponse: {
      /** Query */
      query: string;
      /** Num Results */
      num_results: number;
      /** Total Matched */
      total_matched: number;
      /** Results */
      results: components['schemas']['CalculatorSummary'][];
    };
    /**
     * CalculatorSummary
     * @description Lightweight representation for list/search results.
     */
    CalculatorSummary: {
      /** Key */
      key: string;
      /**
       * Formula
       * @default
       */
      formula: string;
      /** Category */
      category?: string | null;
      /** Reference */
      reference?:
        | components['schemas']['CalculatorReference']
        | {
            [key: string]: unknown;
          }
        | string
        | null;
      /**
       * Parameter Count
       * @default 0
       */
      parameter_count: number;
      /**
       * Display Name
       * @default
       */
      display_name: string;
      /**
       * Subtitle
       * @default
       */
      subtitle: string;
      /**
       * Unified Type
       * @default formula
       */
      unified_type: string;
      /**
       * Section
       * @default other
       */
      section: string;
      /** Conversion Units */
      conversion_units?: string[] | null;
      /** Dose Unit */
      dose_unit?: string | null;
    };
    /** CalculatorTermDefinition */
    CalculatorTermDefinition: {
      /** Variable */
      variable: string;
      /** Label */
      label: string;
      /**
       * Label Key
       * @default
       */
      label_key: string;
      /** Coefficient */
      coefficient?: number | null;
      /** Type */
      type?: string | null;
    };
    /**
     * CallBucket
     * @description High-level inbox grouping for GET /calls.
     *
     *     Mutually exclusive — every call maps to exactly one of ``needs_attention``,
     *     ``in_progress`` or ``resolved``. Omitting the bucket query parameter means
     *     no bucket filter.
     *
     *     Rules (must stay in sync with ``compute_call_bucket`` + the Mongo
     *     predicate in ``CallsRepo._bucket_predicate`` + the frontend grouping):
     *
     *     - ``in_progress``: ``status == "in_progress"`` (call is currently live).
     *       Always wins, regardless of ``read`` or ``outcome``.
     *     - ``resolved``: NOT ``in_progress`` AND
     *       (``call_classification.outcome == "met"`` OR ``read == true``).
     *     - ``needs_attention``: everything else (scheduled, completed with
     *       not_met/partially_met/unclassified, failed, machine_detected — as
     *       long as the user hasn't marked it read).
     * @enum {string}
     */
    CallBucket: CallBucket;
    /**
     * CallChannel
     * @enum {string}
     */
    CallChannel: CallChannel;
    /**
     * CallClassification
     * @description Mirror of Comms CallSession.call_classification.
     *
     *     Populated post-call by the receptionist classification pipeline and delivered
     *     to ml-scribe via CallWebhookUpdate. `null` on the Call document means either a
     *     legacy call or classification still in flight.
     */
    CallClassification: {
      intent: components['schemas']['CallIntent'];
      outcome: components['schemas']['CallOutcome'];
      outcome_reason: components['schemas']['CallOutcomeReason'];
      /** Short Summary */
      short_summary: string;
      /** Confidence */
      confidence: number;
      /** Classifier Version */
      classifier_version: string;
      /**
       * Classified At
       * Format: date-time
       */
      classified_at: string;
    };
    /**
     * CallContextValue
     * @description Model representing a call context parameter key-value pair.
     */
    CallContextValue: {
      /** Parameter Key */
      parameter_key: string;
      /** Predicted Value */
      predicted_value: string;
    };
    /**
     * CallContextValues
     * @description Response model for call context parameter predictions.
     */
    CallContextValues: {
      /** Parameters */
      parameters: components['schemas']['CallContextValue'][];
    };
    /** CallCreate */
    CallCreate: {
      patient: components['schemas']['CallPatient'];
      /** Scheduled Time */
      scheduled_time: string;
      /** Call Context */
      call_context: string;
      /** Agent Id */
      agent_id: string;
      /** Agent Name */
      agent_name: string;
      call_direction: components['schemas']['CallDirection'];
      /** Task Id */
      task_id?: string | null;
      channel?: components['schemas']['CallChannel'] | null;
    };
    /**
     * CallDirection
     * @enum {string}
     */
    CallDirection: CallDirection;
    /**
     * CallIntent
     * @enum {string}
     */
    CallIntent: CallIntent;
    /**
     * CallOutcome
     * @enum {string}
     */
    CallOutcome: CallOutcome;
    /**
     * CallOutcomeReason
     * @enum {string}
     */
    CallOutcomeReason: CallOutcomeReason;
    /** CallPatient */
    CallPatient: {
      /** Full Name */
      full_name: string | null;
      /** Phone */
      phone: string | null;
      /** Birth Date */
      birth_date: string | null;
    };
    /**
     * CallStatus
     * @enum {string}
     */
    CallStatus: CallStatus;
    /** CallSummaryView */
    CallSummaryView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      patient?: components['schemas']['CallPatient'] | null;
      status: components['schemas']['CallStatus'];
      /** Scheduled Time */
      scheduled_time: string | null;
      call_direction: components['schemas']['CallDirection'];
      /** Agent Name */
      agent_name: string | null;
      channel?: components['schemas']['CallChannel'] | null;
      /** Call Date */
      call_date: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Read
       * @default false
       */
      read: boolean;
      /** Summary Header */
      summary_header?: string | null;
      call_classification?: components['schemas']['CallClassification'] | null;
      /**
       * @description Inbox grouping derived from status + read + classification outcome. Drives the Needs Attention / In Progress / Resolved groupings on the frontend. Always present in responses.
       * @default needs_attention
       */
      bucket: components['schemas']['CallBucket'];
    };
    /** CallToolConfig */
    CallToolConfig: {
      /** Name */
      name: string;
      /** Enabled */
      enabled: boolean;
    };
    /** CallTranslationTurnView */
    CallTranslationTurnView: {
      /** Speaker */
      speaker: string;
      /** Start Time */
      start_time?: number | string | null;
      /** End Time */
      end_time?: number | string | null;
      /** Text */
      text: string;
    };
    /**
     * CallTranslationView
     * @description On-demand translation of a voice call's summary + transcript.
     */
    CallTranslationView: {
      /** Language Code */
      language_code: string;
      /** Summary Header */
      summary_header?: string | null;
      /** Summary */
      summary?: string | null;
      /** Transcript */
      transcript?: components['schemas']['CallTranslationTurnView'][] | null;
    };
    /**
     * CallUpdateRequest
     * @description Request body for PATCH /calls/{call_id} (read receipt and future fields).
     */
    CallUpdateRequest: {
      /** Read */
      read: boolean;
    };
    /** CallViewPaginated */
    CallViewPaginated: {
      /** Total Count */
      total_count: number;
      /** Calls */
      calls: components['schemas']['CallSummaryView'][];
    };
    /** CallWebhookUpdate */
    CallWebhookUpdate: {
      /** Call Reference Id */
      call_reference_id: string;
      /** User Id */
      user_id: string;
      /** Agent Display Name */
      agent_display_name?: string | null;
      /** Agent Id */
      agent_id: string;
      channel?: components['schemas']['CallChannel'] | null;
      status: components['schemas']['CallStatus'];
      /** Call Date */
      call_date?: string | null;
      /** Status Updated At */
      status_updated_at?: string | null;
      /** Summary Header */
      summary_header?: string | null;
      /** Summary */
      summary?: string | null;
      /** Transcript */
      transcript?: components['schemas']['domainmodel__calls__models__Message'][] | null;
      /** Duration Seconds */
      duration_seconds?: number | null;
      /** S3 Location */
      s3_location?: string | null;
      /** Failure Reason */
      failure_reason?: string | null;
      call_direction: components['schemas']['CallDirection'];
      /** Phone Number */
      phone_number?: string | null;
      /** Summary Email To */
      summary_email_to?: string | null;
      /** Patient Name */
      patient_name?: string | null;
      /** Patient Dob */
      patient_dob?: string | null;
      call_classification?: components['schemas']['CallClassification'] | null;
    };
    /**
     * CallsAvailableCountry
     * @enum {string}
     */
    CallsAvailableCountry: CallsAvailableCountry;
    /**
     * CancelAction
     * @description Immediately revoke all access.
     */
    CancelAction: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      action: CancelActionAction;
    };
    /**
     * CancelErpResult
     * @description Outcome of the ERP (Lingxing) cancel leg. `attempted` is False when the
     *     order never reached ERP (no erp_order_id).
     */
    CancelErpResult: {
      /** Attempted */
      attempted: boolean;
      /**
       * Succeeded
       * @default false
       */
      succeeded: boolean;
    };
    /** CancelOrderRequest */
    CancelOrderRequest: {
      reason_category: components['schemas']['CancellationReasonCategory'];
      /** Reason */
      reason?: string | null;
    };
    /** CancelOrderResponse */
    CancelOrderResponse: {
      /** Order Id */
      order_id: string;
      status: components['schemas']['OrderStatus'];
      /** Canceled By */
      canceled_by?: string | null;
      /** Canceled At */
      canceled_at?: string | null;
      cancel_reason_category?: components['schemas']['CancellationReasonCategory'] | null;
      /** Cancel Reason */
      cancel_reason?: string | null;
      erp_cancel: components['schemas']['CancelErpResult'];
      refund: components['schemas']['CancelRefundResult'];
    };
    /**
     * CancelRefundResult
     * @description Outcome of the Stripe refund leg. `refunded` is False for orders with no
     *     Stripe charge (sales-led / internal) — money-back is handled by Finance.
     */
    CancelRefundResult: {
      /** Refunded */
      refunded: boolean;
      /** Stripe Refund Id */
      stripe_refund_id?: string | null;
      /** Amount */
      amount?: number | null;
      /** Currency */
      currency?: string | null;
      /** Status */
      status?: string | null;
    };
    /**
     * CancelReverseTrialResponse
     * @description Response for cancelling reverse trial from billing page.
     */
    CancelReverseTrialResponse: {
      /** Cancelled Subscription Id */
      cancelled_subscription_id?: string | null;
      /** Success */
      success: boolean;
      /** Message */
      message?: string | null;
    };
    /** CancelTurnResponse */
    CancelTurnResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Turn Id */
      turn_id?: string | null;
      /** Cancel Requested */
      cancel_requested: boolean;
      /**
       * Accepted
       * @default true
       */
      accepted: boolean;
    };
    /**
     * CancellationReasonCategory
     * @description Why an order was canceled. Recorded on cancellation so each one is
     *     explainable and reportable.
     * @enum {string}
     */
    CancellationReasonCategory: CancellationReasonCategory;
    /**
     * CapabilityActionResponse
     * @description Single capability action response.
     */
    CapabilityActionResponse: {
      /** Slug */
      slug: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Is Default Enabled */
      is_default_enabled: boolean;
    };
    /**
     * CapabilityAutocompleteItem
     * @description Single item in capability autocomplete list.
     */
    CapabilityAutocompleteItem: {
      /** Slug */
      slug: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Icon */
      icon: string;
      /** Type */
      type: string;
      /** Is Connected */
      is_connected: boolean;
      /** Actions */
      actions: {
        [key: string]: string;
      }[];
    };
    /**
     * CapabilityAutocompleteResponse
     * @description Response for capability autocomplete.
     */
    CapabilityAutocompleteResponse: {
      /** Items */
      items: components['schemas']['CapabilityAutocompleteItem'][];
    };
    /**
     * CapabilityListResponse
     * @description Response containing list of capabilities.
     */
    CapabilityListResponse: {
      /** Capabilities */
      capabilities: components['schemas']['CapabilityResponse'][];
    };
    /**
     * CapabilityResponse
     * @description Single capability definition response.
     */
    CapabilityResponse: {
      /** Id */
      id: string;
      /** Slug */
      slug: string;
      /** Name */
      name: string;
      /** Type */
      type: string;
      /** Provider */
      provider: string;
      /** Icon */
      icon: string;
      /** Description */
      description: string;
      /** Actions */
      actions: components['schemas']['CapabilityActionResponse'][];
      /** Is Active */
      is_active: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * CapabilityStatement
     * @description A Capability Statement documents a set of capabilities (behaviors) of a FHIR Server or Client.
     *
     *     https://hl7.org/fhir/R4/capabilitystatement-definitions.html
     */
    CapabilityStatement: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * draft | active | retired | unknown
       * @description The status of this capability statement. Enables tracking the life-cycle of the content.
       */
      status: components['schemas']['PublicationStatus'];
      /**
       * Date last changed
       * @description The date (and optionally time) when the capability statement was published. The date must change when the business version changes and it must change if the status code changes.
       */
      date?: string | null;
      /**
       * instance | capability | requirements
       * @description The way that this statement is intended to be used.
       */
      kind: components['schemas']['CapabilityStatementKind'];
      /**
       * FHIR Version the system supports
       * @description The version of the FHIR specification that this CapabilityStatement describes.
       */
      fhirVersion: components['schemas']['FHIRVersion'];
      /**
       * formats supported (xml | json)
       * @description A list of the formats supported by this implementation using their content types.
       */
      format: components['schemas']['Format'][];
      /**
       * If the endpoint is a RESTful one
       * @description A definition of the restful capabilities of the solution, if any.
       */
      rest?: components['schemas']['CapabilityStatementRest'][] | null;
    };
    /**
     * CapabilityStatementKind
     * @description How a capability statement is intended to be used.
     *
     *     https://hl7.org/fhir/R4/valueset-capability-statement-kind.html
     * @enum {string}
     */
    CapabilityStatementKind: CapabilityStatementKind;
    /**
     * CapabilityStatementRest
     * @description A definition of the restful capabilities of the solution.
     *
     *     https://hl7.org/fhir/R4/capabilitystatement-definitions.html#CapabilityStatement.rest
     */
    CapabilityStatementRest: {
      /**
       * client | server
       * @description Identifies whether this portion of the statement is describing the ability to initiate or receive restful operations.
       */
      mode: components['schemas']['RestfulCapabilityMode'];
      /**
       * Resource served on the REST interface
       * @description A specification of the restful capabilities of the solution for a specific resource type.
       */
      resource?: components['schemas']['CapabilityStatementRestResource'][] | null;
    };
    /**
     * CapabilityStatementRestResource
     * @description A specification of the restful capabilities of the solution for a specific resource type.
     *
     *     https://hl7.org/fhir/R4/capabilitystatement-definitions.html#CapabilityStatement.rest.resource
     */
    CapabilityStatementRestResource: {
      /**
       * A resource type that is supported
       * @description A type of resource exposed via the restful interface.
       */
      type: unknown;
      /**
       * What operations are supported?
       * @description Identifies a restful operation supported by the solution.
       */
      interaction?:
        | components['schemas']['CapabilityStatementRestResourceInteraction'][]
        | null;
      /**
       * Search parameters supported by implementation
       * @description Search parameters for implementations to support and/or make use of - either references to ones defined in the specification, or additional ones defined for/by the implementation.
       */
      searchParam?:
        | {
            [key: string]: string;
          }[]
        | null;
    };
    /**
     * CapabilityStatementRestResourceInteraction
     * @description Identifies a restful operation supported by the solution.
     *
     *     https://hl7.org/fhir/R4/capabilitystatement-definitions.html#CapabilityStatement.rest.resource.interaction
     */
    CapabilityStatementRestResourceInteraction: {
      /**
       * Coded identifier of the operation
       * @description Coded identifier of the operation, supported by the system resource.
       */
      code: components['schemas']['TypeRestfulInteraction'];
      /**
       * Anything special about operation behavior
       * @description Guidance specific to the implementation of this operation, such as 'delete is a logical delete' or 'updates are only allowed with version id' or 'creates permitted from pre-authorized certificates only'.
       */
      documentation?: string | null;
    };
    /**
     * CapabilityWithUserConfigListResponse
     * @description Response containing list of capabilities with user configs.
     */
    CapabilityWithUserConfigListResponse: {
      /** Capabilities */
      capabilities: components['schemas']['CapabilityWithUserConfigResponse'][];
    };
    /**
     * CapabilityWithUserConfigResponse
     * @description Capability with user's configuration status.
     */
    CapabilityWithUserConfigResponse: {
      capability: components['schemas']['CapabilityResponse'];
      user_config: components['schemas']['UserCapabilityConfigResponse'] | null;
      /** Is Connected */
      is_connected: boolean;
      /** Enabled Action Slugs */
      enabled_action_slugs: string[];
    };
    /**
     * CapacityStatus
     * @enum {string}
     */
    CapacityStatus: CapacityStatus;
    /**
     * CareContext
     * @enum {string}
     */
    CareContext: CareContext;
    /**
     * CascadeSummary
     * @description Per-request summary of a document-scope cascade.
     *
     *     Populated by `PATCH /collections/{id}` on the response when the request
     *     triggered a personal -> team scope cascade over the collection's
     *     documents. Lets the client honestly report partial failure to the user
     *     (e.g. "Moved, but 2 of 50 documents could not be re-scoped — try
     *     again."), instead of silently lying after a 200 OK.
     *
     *     Absent (None) when the PATCH did not move the collection into a team
     *     (e.g. a rename) -- callers should treat its absence as "no cascade
     *     happened, ignore", not as "cascade succeeded with zero work".
     */
    CascadeSummary: {
      /**
       * Total
       * @description Number of documents the cascade considered
       */
      total: number;
      /**
       * Cascaded
       * @description Number of documents successfully re-scoped
       */
      cascaded: number;
      /**
       * Skipped Already Team
       * @description Documents skipped because they were already on the target team
       * @default 0
       */
      skipped_already_team: number;
      /**
       * Skipped Not Owned
       * @description Documents skipped because they were owned by another user
       * @default 0
       */
      skipped_not_owned: number;
      /**
       * Skipped Missing
       * @description Documents skipped because they were missing in storage
       * @default 0
       */
      skipped_missing: number;
      /**
       * Failed Count
       * @description Documents whose re-scope write raised. The full ID list is in the server logs only (PHI safety).
       * @default 0
       */
      failed_count: number;
    };
    /**
     * CatalogProductOptionsResponse
     * @description The closed vocabularies the catalog form may offer, served so the admin
     *     UI can't hard-code a copy that drifts.
     *
     *     Wrapped rather than returned bare so a second vocabulary (currencies, sum
     *     fields) is an added key rather than a new endpoint — the same shape the
     *     usage-entitlements options endpoint settled on.
     */
    CatalogProductOptionsResponse: {
      /** Dimension Keys */
      dimension_keys: string[];
    };
    /** CatalogProductResponse */
    CatalogProductResponse: {
      /** Product Key */
      product_key: string;
      /**
       * Aggregation Mode
       * @enum {string}
       */
      aggregation_mode: CatalogProductResponseAggregation_mode;
      /** Sum Field */
      sum_field: CatalogProductResponseSum_fieldAnyOf0 | null;
      /** Dimensions */
      dimensions: string[];
      /** Is Active */
      is_active: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * CernerEHRLaunchProfileAdditionalDetails
     * @description Additional details specific to Cerner EHR launch profiles.
     *
     *     This configuration allows clinic-specific section mappings AND the list of
     *     selectable note types to be stored in the database rather than hard-coded,
     *     enabling configuration changes without code deployments.
     *
     *     Section types are discriminated unions:
     *     - StandardCernerSection: Uses predefined Cerner codes (e.g., "HPI", "HC", "AP")
     *     - CustomCernerSection: Uses Source Concept CKI (e.g., "CERNER!<UUID>")
     *
     *     ``writeback_target`` selects where sectional notes are written. The default
     *     ``POWER_CHART`` posts components to ``/api/v2/documentComponents``;
     *     ``POWER_NOTE`` posts to ``/api/v2/observations`` keyed by each section's
     *     ``observation_type_code``.
     */
    CernerEHRLaunchProfileAdditionalDetails: {
      /**
       * Sections
       * @default []
       */
      sections: (
        | components['schemas']['StandardCernerSection']
        | components['schemas']['CustomCernerSection']
      )[];
      /** @default power_chart */
      writeback_target: components['schemas']['CernerWritebackTarget'];
      /**
       * Note Types
       * @default []
       */
      note_types: components['schemas']['CernerNoteTypeOption'][];
      /** Default Note Type Event Code */
      default_note_type_event_code?: string | null;
      /**
       * Patient Identifier Rules
       * @default []
       */
      patient_identifier_rules: components['schemas']['CernerPatientIdentifierRule'][];
    };
    /**
     * CernerNoteType
     * @description Cerner Code Set 72 note type chosen at push time.
     */
    CernerNoteType: {
      /** Event Code */
      event_code: string;
      /** Display */
      display: string;
    };
    /**
     * CernerNoteTypeOption
     * @description A single Cerner note type the picker can offer at push time.
     *
     *     Cerner Code Set 72 (Event Codes) is the only coding system used here —
     *     LOINC is intentionally not supported per ticket scope (INT-4503).
     */
    CernerNoteTypeOption: {
      /** Event Code */
      event_code: string;
      /** Display */
      display: string;
    };
    /**
     * CernerNoteTypesResponse
     * @description Configured Cerner note types for the active session's launch profile.
     *
     *     Sourced from the EHRLaunchProfile ``additional_details.note_types`` field,
     *     so this is per-clinic configurable from internal admin without code changes.
     */
    CernerNoteTypesResponse: {
      /** Note Types */
      note_types: components['schemas']['CernerNoteTypeOption'][];
      /** Default Note Type Event Code */
      default_note_type_event_code?: string | null;
    };
    /**
     * CernerObservationCode
     * @description One allowed code/value pair for a coded Cerner observation field.
     *
     *     Cerner exposes some PowerNote fields as code sets rather than free text: the
     *     observation must carry the numeric code, not the human-readable label. The
     *     pairs are configured per launch profile because each Cerner environment
     *     mints its own code values for the same logical field.
     */
    CernerObservationCode: {
      /** Code */
      code: string;
      /** Value */
      value: string;
    };
    /**
     * CernerPatientIdentifierRule
     * @description Profile-specific mapping from a Cerner patient alias pool to Heidi display.
     *
     *     Cerner RedRover patient payloads can contain multiple site-specific aliases
     *     for the same patient, such as ChelWest MRN, Imperial MRN, and NHS Number.
     *     Each launch profile configures the alias pool it wants to surface in Heidi.
     *     Rules are evaluated in order; the first matching alias with a value becomes
     *     the patient's display identifier.
     */
    CernerPatientIdentifierRule: {
      /** Heidi Display Label */
      heidi_display_label: string;
      /** Cerner Alias Pool Display */
      cerner_alias_pool_display: string;
    };
    /**
     * CernerSectionType
     * @description Discriminator for Cerner section types.
     * @enum {string}
     */
    CernerSectionType: CernerSectionType;
    /**
     * CernerWritebackTarget
     * @description Destination Cerner surface for sectional-note writeback.
     *
     *     A clinic's launch profile selects one target for all its sections.
     * @enum {string}
     */
    CernerWritebackTarget: CernerWritebackTarget;
    /** ChangeProviderRegionsRequest */
    ChangeProviderRegionsRequest: {
      /**
       * User Ref Id
       * @description Target user's unique reference ID
       */
      user_ref_id: string;
      /** @description Target region to move the user to */
      to_region: components['schemas']['Region'];
    };
    /** ChangeProviderRegionsResponse */
    ChangeProviderRegionsResponse: {
      /**
       * From Region
       * @description User's region before the move
       */
      from_region: string;
      /**
       * To Region
       * @description User's region after the move
       */
      to_region: string;
      /**
       * Migrated Data
       * @description Per-service update results
       */
      migrated_data: components['schemas']['ServiceMigrationResult'][];
    };
    /** ChangeSubscriptionPlanRequest */
    ChangeSubscriptionPlanRequest: {
      /**
       * Vendor
       * @default stripe
       * @constant
       */
      vendor: 'stripe';
      period: components['schemas']['shared__enums__enums__Period'];
      tier: components['schemas']['SubscriptionTier'];
      free_trial_days?: components['schemas']['StripeFreeTrialDays'] | null;
    };
    /** ChangeUserEmailRequest */
    ChangeUserEmailRequest: {
      /**
       * Email
       * Format: email
       */
      email: string;
    };
    /**
     * ChartContextNextTarget
     * @description A clickable AX destination that may reveal more clinical context.
     *
     *     Labels must be grounded in the snapshot tree; the FE resolves them to
     *     pressable elements and hops (cap managed client-side).
     */
    ChartContextNextTarget: {
      /**
       * Purpose
       * @enum {string}
       */
      purpose: ChartContextNextTargetPurpose;
      /** Label */
      label: string;
      /** Role */
      role?: string | null;
    };
    /**
     * ChatEvidenceSubscriptionTier
     * @description Evidence subscription tiers for chat context.
     * @enum {string}
     */
    ChatEvidenceSubscriptionTier: ChatEvidenceSubscriptionTier;
    /** ChatExportUrlResponse */
    ChatExportUrlResponse: {
      /** Url */
      url: string;
    };
    /**
     * ChatListItem
     * @description Simplified model for chat list view.
     *
     *     The ``version`` discriminator tells the FE which detail endpoint to
     *     open: ``1`` => legacy ``/v2/chat/*`` (embedded messages, in-process
     *     Evidence LLM loop); ``2`` => harness-backed ``/v2/projects/*``
     *     (agent-chat with the Evidence sub-agent + optional desktop tools).
     *
     *     For ``version == 2`` the row also carries ``tool_profile`` (so the
     *     card can show "Evidence-only" vs "Clinician + desktop"). Absent on
     *     v1 rows.
     */
    ChatListItem: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Session Id */
      session_id?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      mode: components['schemas']['ChatMode'];
      /**
       * Is Saved
       * @default false
       */
      is_saved: boolean;
      /** Created At */
      created_at: string;
      /** Updated At */
      updated_at: string;
      /** Preview */
      preview?: string | null;
      /**
       * Version
       * @default 1
       * @enum {integer}
       */
      version: ChatListItemVersion;
      /** Tool Profile */
      tool_profile?: string | null;
    };
    /**
     * ChatListResponse
     * @description Pagination response for listing chats.
     */
    ChatListResponse: {
      /**
       * Chats
       * @default []
       */
      chats: components['schemas']['ChatListItem'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
    };
    /**
     * ChatMessageAttachment
     * @description Attachment metadata for chat messages.
     *
     *     TODO(EVI-XXX): Once legacy inline uploads are deprecated:
     *     - Make attachment_id required (non-optional)
     *     - Consider removing file_key (use attachment_id for lookups, store S3 key separately)
     */
    ChatMessageAttachment: {
      /** Attachment Id */
      attachment_id?: string | null;
      /** File Key */
      file_key: string;
      /** File Name */
      file_name: string;
      /** Content Type */
      content_type?: string | null;
      /** File Size */
      file_size?: number | null;
      /** Text Snippet */
      text_snippet?: string | null;
      /** Document Title */
      document_title?: string | null;
      /** Page Count */
      page_count?: number | null;
      /** Text Content */
      text_content?: string | null;
      /** Has Visual Content */
      has_visual_content?: boolean | null;
      /** Inlined Content */
      inlined_content?: string | null;
      /** Inlined Content Original Chars */
      inlined_content_original_chars?: number | null;
      /** Token Count */
      token_count?: number | null;
    };
    /**
     * ChatMessageAttachmentResponse
     * @description Response model for chat message attachments.
     *
     *     TODO(EVI-XXX): Once FE migrates to use attachment_id/source_id:
     *     - Remove file_key from response (keep url for display, attachment_id for correlation)
     *     - Make attachment_id required
     */
    ChatMessageAttachmentResponse: {
      /** Attachment Id */
      attachment_id?: string | null;
      /** File Name */
      file_name: string;
      /** Content Type */
      content_type?: string | null;
      /** File Key */
      file_key?: string | null;
      /** Url */
      url?: string | null;
    };
    /**
     * ChatMessageMetadataResponse
     * @description Metadata for chat messages in product API responses.
     *
     *     This is a slim response that only includes fields used by the frontend.
     *     Admin API uses the full domain model with additional debugging fields.
     *
     *     Fields intentionally excluded (not used by frontend):
     *     - citations: Legacy field, replaced by structured_citations
     *
     *     additional_metadata is filtered to only include:
     *     - evidence_chunks: Critical for EVIDENCE mode rendering (text chunks + ordering)
     *       NOTE: Citation URLs in evidence_chunks are regenerated via CitationAssembler
     *     - thinking_duration_ms: TTFT for reasoning/web search display
     *     - ehr_tool_calls: EHR FHIR tool call results for reload persistence (EVI-1408)
     *
     *     Excluded from additional_metadata (internal metrics):
     *     - time_to_first_text_ms, time_to_first_reasoning_ms, llm_message_id
     */
    ChatMessageMetadataResponse: {
      /** Sources */
      sources?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Web Search Query */
      web_search_query?: string | null;
      /** Reasoning */
      reasoning?: string | null;
      /** Thinking */
      thinking?: string | null;
      /** Thinking Duration Ms */
      thinking_duration_ms?: number | null;
      /** Annotations */
      annotations?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Additional Metadata */
      additional_metadata?: {
        [key: string]: unknown;
      } | null;
      /** Structured Citations */
      structured_citations?: components['schemas']['StructuredCitationResponse'][] | null;
    };
    /** ChatMessageRequest */
    ChatMessageRequest: {
      /** Message */
      message: string;
    };
    /**
     * ChatMessageResponse
     * @description Response model for a chat message.
     */
    ChatMessageResponse: {
      /** Role */
      role: string;
      /** Content */
      content: string;
      /** Timestamp */
      timestamp?: string | null;
      /** Message Id */
      message_id?: string | null;
      mode?: components['schemas']['ChatMode'] | null;
      original_mode?: components['schemas']['ChatMode'] | null;
      metadata?: components['schemas']['ChatMessageMetadataResponse'] | null;
      /** Attachments */
      attachments?: components['schemas']['ChatMessageAttachmentResponse'][] | null;
      /** Message Mac */
      message_mac?: string | null;
    };
    /**
     * ChatMessageSource
     * @description Client-asserted initiation metadata for a user message.
     *
     *     See domains.chat.models.chat.ChatMessageSourceDO — this is the domain
     *     mirror. Treat all fields as untrusted client input. `max_length` caps
     *     on the free-text fields mirror the API and DB layers (defence-in-depth
     *     for any code that constructs this directly without going through the
     *     request schema).
     */
    ChatMessageSource: {
      /** Entry Method */
      entry_method?: ChatMessageSourceEntry_methodAnyOf0 | null;
      /** Chip Label */
      chip_label?: string | null;
      /** Chip Category */
      chip_category?: string | null;
      /** Origin */
      origin?: ChatMessageSourceOriginAnyOf0 | null;
      /** Surface */
      surface?: ChatMessageSourceSurfaceAnyOf0 | null;
      /** Queued */
      queued?: boolean | null;
      /** Queue Duration Ms */
      queue_duration_ms?: number | null;
    };
    /**
     * ChatMode
     * @enum {string}
     */
    ChatMode: ChatMode;
    /**
     * ChatOrderBy
     * @description Allowed fields for ordering chats.
     * @enum {string}
     */
    ChatOrderBy: ChatOrderBy;
    /** ChatRequest */
    ChatRequest: {
      /** Message */
      message: string;
    };
    /**
     * ChatResponse
     * @description Response model for a single chat.
     */
    ChatResponse: {
      /** Id */
      id: string;
      /** User Ref Id */
      user_ref_id: string;
      /** Session Id */
      session_id?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      /** Title */
      title: string;
      /**
       * Messages
       * @default []
       */
      messages: components['schemas']['ChatMessageResponse'][];
      mode: components['schemas']['ChatMode'];
      /**
       * Is Saved
       * @default false
       */
      is_saved: boolean;
      /**
       * Completion In Progress
       * @default false
       */
      completion_in_progress: boolean;
      /** Continued From Chat Id */
      continued_from_chat_id?: string | null;
      /** Created At */
      created_at: string;
      /** Updated At */
      updated_at: string;
      patient_context?: components['schemas']['PatientContextInfo'] | null;
      session_context?: components['schemas']['SessionContextInfo'] | null;
      /** Document Size Bytes */
      document_size_bytes?: number | null;
      capacity_status?: components['schemas']['CapacityStatus'] | null;
    };
    /** CheckBlockedView */
    CheckBlockedView: {
      /** Blocked */
      blocked: boolean;
      item?: components['schemas']['BlockedNumberView'] | null;
    };
    /**
     * CheckCurrentEmailRequest
     * @description Request schema for checking current email verification code.
     */
    CheckCurrentEmailRequest: {
      /** Nonce */
      nonce: string;
      /** Timestamp */
      timestamp: string;
      /** Verification Code */
      verification_code: string;
    };
    /**
     * CheckCurrentEmailResponse
     * @description Response schema for current email verification check.
     */
    CheckCurrentEmailResponse: {
      /** Status */
      status: string;
    };
    /** CheckItem */
    CheckItem: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: CheckItemKind;
      /** Item Id */
      item_id: string;
      /** Text */
      text: string;
      /** Detail */
      detail?: string | null;
      /** Ctx */
      ctx?: string | null;
    };
    /**
     * ChildRunSummary
     * @description Subject-safe child-run projection for parent run hydration.
     */
    ChildRunSummary: {
      /** Agent Run Id */
      agent_run_id: string;
      /**
       * Status
       * @enum {string}
       */
      status: ChildRunSummaryStatus;
      /** Kind */
      kind?: string | null;
      /** Parent Agent Run Id */
      parent_agent_run_id: string;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
    };
    /**
     * ChipShowPhase
     * @description When to show a chip relative to session lifecycle.
     * @enum {string}
     */
    ChipShowPhase: ChipShowPhase;
    /** ChoiceItem */
    ChoiceItem: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: ChoiceItemKind;
      /** Item Id */
      item_id: string;
      /** Label */
      label: string;
      /** Options */
      options: components['schemas']['ChoiceOption'][];
      override?: components['schemas']['ChoiceOverride'] | null;
    };
    /**
     * ChoiceOption
     * @description A single selectable arm of a CHOOSE-ONE group. Checkable (lands in the note).
     */
    ChoiceOption: {
      /** Item Id */
      item_id: string;
      /** Text */
      text: string;
      /** Detail */
      detail?: string | null;
      tag?: components['schemas']['ChoiceTag'] | null;
    };
    /**
     * ChoiceOverride
     * @description A condition that, when answered ``yes``, supersedes the whole choice list with
     *     a single "use instead" option (e.g. MDR organism → Fosfomycin).
     */
    ChoiceOverride: {
      /** Cond Id */
      cond_id: string;
      /** Question */
      question: string;
      /** Hint */
      hint?: string | null;
      option: components['schemas']['ChoiceOption'];
    };
    /**
     * ChoiceTag
     * @enum {string}
     */
    ChoiceTag: ChoiceTag;
    /** Chunk */
    Chunk: {
      /** Id */
      id: number;
      status: components['schemas']['TranscriptionFeedbackStatus'];
      /** Transcript */
      transcript: string | null;
      /** Duration */
      duration: number;
    };
    /** ChunkedRecordingWithTranscript */
    ChunkedRecordingWithTranscript: {
      /** Id */
      id: string;
      /** Chunks */
      chunks: components['schemas']['Chunk'][];
      /** Created At */
      created_at?: string | null;
      /**
       * Starttime
       * Format: date-time
       */
      starttime: string;
      /** Endtime */
      endtime?: string | null;
      /** Transcript */
      transcript?: string | null;
    };
    /**
     * CibaAuditEvent
     * @description CIBA ("Login with Heidi App") anti-fatigue events.
     *
     *     Kept as its own family (rather than folded into
     *     :class:`UserSelfServiceAuditEvent` / :class:`SensitiveActionRevocationAuditEvent`)
     *     so a future MFA/step-up push product doesn't inherit CIBA-specific event
     *     names. ``Actor.type`` is ``"User"`` for the caller-initiated report and
     *     ``"System"`` for streak detection, since a streak is, by design, evidence
     *     the requests may not be the account owner's.
     * @enum {string}
     */
    CibaAuditEvent: CibaAuditEvent;
    /**
     * CitedSourceRecord
     * @description A source that was cited in the response.
     */
    CitedSourceRecord: {
      /**
       * Source Id
       * @description Source ID (url hash, integration:<partner>:<id>, doc ID, etc.)
       */
      source_id: string;
      /**
       * Source Type
       * @description 'web', 'integration_partner', 'user_doc', 'attachment'
       */
      source_type: string;
      /**
       * Partner Type
       * @description If integration_partner: 'bmj', 'vidal', etc.
       */
      partner_type?: string | null;
      /** Title */
      title?: string | null;
      /** Url */
      url?: string | null;
      /** Display Name */
      display_name?: string | null;
      /**
       * Citation Count
       * @description How many times cited in response text
       * @default 0
       */
      citation_count: number;
    };
    /** ClearMemoryRequest */
    ClearMemoryRequest: {
      /** @default agent_extracted_word_substitutions */
      memory_type: components['schemas']['MemoryType'];
      /**
       * User Ids
       * @description Users to clear. Omit (null) to clear every enrolled user.
       */
      user_ids?: string[] | null;
      /**
       * @description reset = wipe rules/metadata but keep the user enrolled (next build re-seeds); delete = remove the doc entirely (un-enrol).
       * @default reset
       */
      mode: components['schemas']['ClearMode'];
      /**
       * Confirm All
       * @description Required to be true when user_ids is omitted (clear-all guard).
       * @default false
       */
      confirm_all: boolean;
    };
    /** ClearMemoryResponse */
    ClearMemoryResponse: {
      memory_type: components['schemas']['MemoryType'];
      mode: components['schemas']['ClearMode'];
      /** Scope */
      scope: string;
      /** Affected Count */
      affected_count: number;
    };
    /**
     * ClearMode
     * @description How :meth:`AgenticPersonalisationAdminService.clear_memory` clears.
     * @enum {string}
     */
    ClearMode: ClearMode;
    /**
     * ClientAccessibilityToolsCapability
     * @description Accessibility tool shapes the connected desktop client can parse.
     *
     *     This is a fleet-skew hint, not an entitlement. An absent capability means
     *     the backend must expose only the legacy accessibility contract.
     */
    ClientAccessibilityToolsCapability: {
      /** Perform Action Batch Steps */
      perform_action_batch_steps?: string[];
      semantic_set_value?:
        | components['schemas']['ClientSemanticSetValueCapability']
        | null;
    };
    /**
     * ClientAdminAddMemberRequest
     * @description Request to add a user to a team.
     */
    ClientAdminAddMemberRequest: {
      /** Kinde User Id */
      kinde_user_id: string;
      /** Role Ids */
      role_ids: string[];
    };
    /** ClientAdminAddMemberResponse */
    ClientAdminAddMemberResponse: {
      /** Kinde User Id */
      kinde_user_id: string;
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /** Role Ids */
      role_ids: string[];
    };
    /**
     * ClientAdminAssignRolesRequest
     * @description Request to assign roles to a team member.
     */
    ClientAdminAssignRolesRequest: {
      /** Role Ids */
      role_ids: string[];
    };
    /** ClientAdminAssignRolesResponse */
    ClientAdminAssignRolesResponse: {
      /** Role Ids */
      role_ids: string[];
    };
    /**
     * ClientAdminCreateTeamRequest
     * @description Request to create a team for a linked user.
     */
    ClientAdminCreateTeamRequest: {
      /** Name */
      name: string;
      /** Owner Kinde User Id */
      owner_kinde_user_id: string;
      /**
       * Is Stripe Managed
       * @default false
       */
      is_stripe_managed: boolean;
      /**
       * Charge Future Members
       * @default false
       */
      charge_future_members: boolean;
      /** @default ENTERPRISE */
      subscribed_plan: components['schemas']['SubscriptionTier'];
    };
    /** ClientAdminCreateTeamResponse */
    ClientAdminCreateTeamResponse: {
      team: components['schemas']['TeamModel'];
    };
    /** ClientAdminLinkHeidiAccountRequest */
    ClientAdminLinkHeidiAccountRequest: {
      /** Ehr User Id */
      ehr_user_id: string;
      /** Ehr Email */
      ehr_email: string;
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** Email */
      email?: string | null;
    };
    /** ClientAdminListRolesResponse */
    ClientAdminListRolesResponse: {
      /** Roles */
      roles: components['schemas']['RoleModel'][];
    };
    /**
     * ClientBuildDiagnostics
     * @description Safe build dimensions for correlating client diagnostics.
     */
    ClientBuildDiagnostics: {
      /** Environment */
      environment: string;
      /** Release */
      release: string;
      /**
       * Platform
       * @enum {string}
       */
      platform: ClientBuildDiagnosticsPlatform;
      /** Installer Type */
      installer_type: string;
      /** Build Id */
      build_id?: string | null;
    };
    /**
     * ClientCapabilities
     * @description Rendering hint reported by the client (platform + screen geometry).
     *
     *     **NOT an entitlement.** Tool availability is gated by ``tool_profile``,
     *     ``tool_approval_overrides``, and FGA — never by anything in this struct.
     *     Lying in this payload only degrades the computer-use sub-agent's
     *     coordinate scaling; it cannot escalate privileges.
     *
     *     ``file_tools``, ``accessibility_tools``, and ``remote_tools`` are exceptions
     *     in spirit but not in mechanism: they are *fleet-skew* hints describing wire
     *     shapes the client can parse, NOT entitlements. Release flags remain the
     *     entitlement gates. Lying in a capability can only narrow the model's tool
     *     shape or hand it input the client rejects; it cannot grant additional
     *     authority.
     *
     *     Pydantic's default ``extra="ignore"`` is intentional: the model backs
     *     the projects ``submit_turn``/``create_project`` request bodies, and
     *     forward-deployed desktop clients may
     *     ship new optional capability fields ahead of a backend redeploy.
     *     Per ``AGENTS.md`` Mobile Client Safety, request schemas are public
     *     contracts and must degrade gracefully across version skew — silently
     *     dropping unknown fields here is the right default. The runtime
     *     consumer (``parse_rpa_computer_runtime_context``) re-validates the
     *     typed field set anyway, so extra keys never reach the tool layer.
     */
    ClientCapabilities: {
      platform_system: components['schemas']['ClientPlatformSystem'];
      /** Screen Width */
      screen_width: number;
      /** Screen Height */
      screen_height: number;
      /** Scale Factor */
      scale_factor: number;
      file_tools?: components['schemas']['ClientFileToolsCapability'] | null;
      accessibility_tools?:
        | components['schemas']['ClientAccessibilityToolsCapability']
        | null;
      remote_tools?: components['schemas']['ClientRemoteToolsCapability'] | null;
    };
    /** ClientCustomisedQATemplateAnswerRequest */
    ClientCustomisedQATemplateAnswerRequest: {
      /** Template Content */
      template_content: string;
    };
    /** ClientCustomisedQATemplateAnswerResponse */
    ClientCustomisedQATemplateAnswerResponse: {
      /** Content */
      content: string;
      /** Question Answer Pairs */
      question_answer_pairs: components['schemas']['QuestionAnswerPair'][];
      /** Summary */
      summary: string;
    };
    /**
     * ClientFileToolsCapability
     * @description Fleet-skew handshake for the computer-use file tools.
     *
     *     Reported by the desktop client so the backend advertises to the model only
     *     the file *actions* the connected client can serve (design §8, Q5). Read at
     *     project creation / run start — the same read-point as the
     *     ``run_computer_use_task`` gating.
     *
     *     ``actions`` lists the tool names the client serves (e.g.
     *     ``["list_directory", "read_file", "search_files", "stat_file"]``). The
     *     backend registers the *intersection* of this list with its own catalog, so
     *     the advertised list is the sole capability truth — a client stale on one
     *     tool loses that one tool, not the whole surface.
     *
     *     Additive request fields that an older ``deny_unknown_fields`` Rust client
     *     cannot parse need an explicit capability bit. ``read_file_attachment_delivery``
     *     selects the enriched backend schema while preserving the single LLM- and
     *     executor-facing ``read_file`` wire name. It defaults false so old clients
     *     receive the text-only schema during fleet skew.
     *
     *     ``read_file_attachment_media_types`` lists the media types this client can
     *     return as a whole-file ``delivery='attachment'`` result. It defaults empty
     *     so a client that cannot deliver attachments — or one predating the field —
     *     advertises no attachable catalog, and the backend steers the model to text
     *     paging only. The backend intersects it with the harness-ingestible set, so a
     *     type the harness cannot hydrate is never advertised to the model.
     *
     *     ``pick_file_clarification`` marks a client whose clarification card
     *     renders the ``ask_user`` kind ``pick_file``. Defaults false: an older
     *     client's inline card shows only Skip for an unknown kind (a stalled run),
     *     so without the bit the backend omits the file-pick steering rather than
     *     falling back to the memory-eligible ``choice`` (PHI filenames).
     *
     *     Staleness is safe-direction only (an upgraded client lags until a new
     *     project is created); the unsafe direction — the model calling a tool the
     *     client lacks — is caught by the client's headless unknown-tool backstop.
     */
    ClientFileToolsCapability: {
      /** Actions */
      actions?: string[];
      /**
       * Read File Attachment Delivery
       * @default false
       */
      read_file_attachment_delivery: boolean;
      /** Read File Attachment Media Types */
      read_file_attachment_media_types?: string[];
      /**
       * Pick File Clarification
       * @default false
       */
      pick_file_clarification: boolean;
    };
    /**
     * ClientPlatformSystem
     * @enum {string}
     */
    ClientPlatformSystem: ClientPlatformSystem;
    /**
     * ClientRemoteToolsCapability
     * @description Internal remote-tool actions the connected desktop client can serve.
     */
    ClientRemoteToolsCapability: {
      /** Actions */
      actions?: string[];
    };
    /**
     * ClinicIdType
     * @description Whether the clinic_id in CreateIntegrationAgentRequest refers to an org or a team.
     * @enum {string}
     */
    ClinicIdType: ClinicIdType;
    /**
     * ClinicInfo
     * @description Model representing clinic information from search.
     */
    ClinicInfo: {
      /** Name */
      name: string;
      /** Website */
      website?: string | null;
      /** Address */
      address?: string | null;
      /** Description */
      description?: string | null;
    };
    /** ClinicalCodeConfirmation */
    ClinicalCodeConfirmation: {
      /**
       * Entity Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      entity_id: string;
      /** Code */
      code: string;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** ClinicalCodingExtractionCode */
    ClinicalCodingExtractionCode: {
      /** Code */
      code: string;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
      /** Code Name */
      code_name: string;
      /**
       * Page
       * @description 1-based page number when ``text`` uses ``### Page N`` fences and the code anchor falls after a fence; ``null`` when no fence precedes the anchor.
       */
      page?: number | null;
      /** Document Index */
      document_index: number;
      /** Text Start */
      text_start?: number | null;
      /** Text End */
      text_end?: number | null;
      relevance: components['schemas']['ClinicalCodingExtractionCodeRelevance'];
      /** Relevance Score */
      relevance_score: number;
    };
    /**
     * ClinicalCodingExtractionCodeRelevance
     * @enum {string}
     */
    ClinicalCodingExtractionCodeRelevance: ClinicalCodingExtractionCodeRelevance;
    /** ClinicalCodingExtractionError */
    ClinicalCodingExtractionError: {
      type: components['schemas']['ClinicalCodingExtractionErrorType'];
      details: components['schemas']['ClinicalCodingExtractionErrorDetails'];
    };
    /** ClinicalCodingExtractionErrorDetails */
    ClinicalCodingExtractionErrorDetails: {
      /** Message */
      message: string;
    };
    /**
     * ClinicalCodingExtractionErrorType
     * @enum {string}
     */
    ClinicalCodingExtractionErrorType: ClinicalCodingExtractionErrorType;
    /** ClinicalCodingExtractionFailure */
    ClinicalCodingExtractionFailure: {
      /** Document Index */
      document_index: number;
      error: components['schemas']['ClinicalCodingExtractionError'];
    };
    /** ClinicalCodingExtractionRequest */
    ClinicalCodingExtractionRequest: {
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /** Documents */
      documents: components['schemas']['ExtractionDocumentInput'][];
      target_code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** ClinicalCodingExtractionResponse */
    ClinicalCodingExtractionResponse: {
      /** Codes */
      codes?: components['schemas']['ClinicalCodingExtractionCode'][];
      /** Failed */
      failed?: components['schemas']['ClinicalCodingExtractionFailure'][];
    };
    /**
     * ClinicalNoteTypeCodingSystem
     * @description LOINC document-type codes for clinical notes (DocumentReference.type).
     *
     *     Use these in DocumentReference.type.coding with system "http://loinc.org".
     *     CONSULT_NOTE is the primary type used when syncing scribe consult notes
     *     into EHRs (ECW, Cerner, Medtech).
     * @enum {string}
     */
    ClinicalNoteTypeCodingSystem: ClinicalNoteTypeCodingSystem;
    /**
     * ClinicalNotesAnalysisResponse
     * @description Response schema for clinical notes analysis.
     */
    ClinicalNotesAnalysisResponse: {
      /** Id */
      id: string;
      /** Session Id */
      session_id: string;
      /** Note Id */
      note_id: string | null;
      /** User Id */
      user_id: string | null;
      /** Clinical Note */
      clinical_note: string;
      entity_verification_data: components['schemas']['EntityVerificationDataView'];
      anacc_findings?: components['schemas']['AnaccFindingsData'] | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      status: components['schemas']['AnalysisStatus'];
      source: components['schemas']['AnalysisSource'];
      /** Started At */
      started_at?: string | null;
      /** Completed At */
      completed_at?: string | null;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Pinned Note Updated At */
      pinned_note_updated_at?: string | null;
    };
    /** ClinicalSignOffModel */
    ClinicalSignOffModel: {
      /** Reviewer */
      reviewer: string;
      /** Reviewer Role */
      reviewer_role: string;
      /** Reviewed At */
      reviewed_at: string;
      /** Version Signed */
      version_signed: string;
      /** Signature */
      signature?: string | null;
    };
    /**
     * ClinicalTaskCategory
     * @enum {string}
     */
    ClinicalTaskCategory: ClinicalTaskCategory;
    /**
     * ClinicalTaskCompletedBy
     * @enum {string}
     */
    ClinicalTaskCompletedBy: ClinicalTaskCompletedBy;
    /** ClinicalTaskDebug */
    ClinicalTaskDebug: {
      /**
       * Ambiguity Markers
       * @default []
       */
      ambiguity_markers: string[];
      /** Completion Evidence */
      completion_evidence?: string | null;
      /** Category Rationale */
      category_rationale?: string | null;
    };
    /**
     * ClinicalTaskLink
     * @description Link from a clinical task to another resource.
     *
     *     Uses ``extra="ignore"`` instead of ``extra="forbid"`` because these models
     *     are stored in MongoDB. Old deploys reading docs with new fields would crash
     *     if we used forbid.
     */
    ClinicalTaskLink: {
      type: components['schemas']['ClinicalTaskLinkType'];
      /** Id */
      id: string;
    };
    /** ClinicalTaskLinkInfo */
    ClinicalTaskLinkInfo: {
      outcome: components['schemas']['ClinicalTaskLinkOutcome'];
    };
    /**
     * ClinicalTaskLinkOutcome
     * @description Outcome of a link/unlink operation for idempotent responses.
     * @enum {string}
     */
    ClinicalTaskLinkOutcome: ClinicalTaskLinkOutcome;
    /**
     * ClinicalTaskLinkType
     * @enum {string}
     */
    ClinicalTaskLinkType: ClinicalTaskLinkType;
    /**
     * ClinicalTaskOrigin
     * @enum {string}
     */
    ClinicalTaskOrigin: ClinicalTaskOrigin;
    /** ClinicalTaskResponse */
    ClinicalTaskResponse: {
      task: components['schemas']['ClinicalTaskView'];
    };
    /**
     * ClinicalTaskStatus
     * @enum {string}
     */
    ClinicalTaskStatus: ClinicalTaskStatus;
    /**
     * ClinicalTaskView
     * @description Model representing a clinical_task identified from a clinical encounter.
     */
    ClinicalTaskView: {
      /** Id */
      id: string;
      /** User Id */
      user_id: string;
      /** Session Id */
      session_id?: string | null;
      /** Title */
      title?: string | null;
      /** Short Title */
      short_title?: string | null;
      /** Doc Suggestion Cta */
      doc_suggestion_cta?: string | null;
      /** Chip Label */
      chip_label?: string | null;
      /**
       * Is Suggestion Dismissed
       * @default false
       */
      is_suggestion_dismissed: boolean;
      /** Description */
      description?: string | null;
      category?: components['schemas']['ClinicalTaskCategory'] | null;
      status: components['schemas']['ClinicalTaskStatus'];
      /**
       * Is Conditional
       * @default false
       */
      is_conditional: boolean;
      /** Source Quote */
      source_quote?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Completed At */
      completed_at?: string | null;
      /** Archived At */
      archived_at?: string | null;
      completed_by?: components['schemas']['ClinicalTaskCompletedBy'] | null;
      /** Session Name */
      session_name?: string | null;
      /** Patient Name */
      patient_name?: string | null;
      /** Call Id */
      call_id?: string | null;
      call_status?: components['schemas']['CallStatus'] | null;
      /** Scheduled Time */
      scheduled_time?: string | null;
      debug?: components['schemas']['ClinicalTaskDebug'] | null;
      /** Is Potentially Patient Task */
      is_potentially_patient_task?: boolean | null;
      /** Dedupe Group Id */
      dedupe_group_id?: number | null;
      /** Due Date */
      due_date?: string | null;
      /** Links */
      links?: components['schemas']['ClinicalTaskLink'][];
      /** Assignee Id */
      assignee_id?: string | null;
      assignee?: components['schemas']['AssigneeView'] | null;
      /** Assignee Name */
      assignee_name?: string | null;
      /** Assignee Avatar Url */
      assignee_avatar_url?: string | null;
      /** Assigner Id */
      assigner_id?: string | null;
      /** Assigned At */
      assigned_at?: string | null;
      /** Creator Name */
      creator_name?: string | null;
      /** Creator Avatar Url */
      creator_avatar_url?: string | null;
    };
    /**
     * ClinicianAvailabilities
     * @description Represents a clinician's daily availability window.
     */
    ClinicianAvailabilities: {
      /** Start Time */
      start_time: string;
      /** Finish Time */
      finish_time: string;
      /** Day Of The Week */
      day_of_the_week: string;
    };
    /** ClinicianResearchProfile */
    ClinicianResearchProfile: {
      /** Age */
      age?: number | null;
      /** Sex */
      sex?: string | null;
      /** Years Of Clinical Practice */
      years_of_clinical_practice?: number | null;
      /** Role */
      role?: string | null;
      /** First Language */
      first_language?: string | null;
      /** Accent */
      accent?: string | null;
      /** Completed At */
      completed_at?: string | null;
    };
    /** ClinikoCreateAdaptorRequest */
    ClinikoCreateAdaptorRequest: {
      /**
       * Ehr Provider
       * @default Cliniko
       * @constant
       */
      ehr_provider: 'Cliniko';
      /** Api Key */
      api_key: string;
      /** Practitioner Id */
      practitioner_id?: string | null;
      user_timezone?: components['schemas']['TimeZones'] | null;
    };
    /** ClinikoPractitionerDetails */
    ClinikoPractitionerDetails: {
      /** Practitioner Id */
      practitioner_id: string;
      time_zone_identifier?: components['schemas']['TimeZones'] | null;
    };
    /** CloseRunResponse */
    CloseRunResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /**
       * Accepted
       * @default true
       */
      accepted: boolean;
    };
    /** CodeSystemPreference */
    CodeSystemPreference: {
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
      /** Enabled */
      enabled: boolean;
    };
    /**
     * CodeableConcept
     * @description Concept - reference to a terminology or just text.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#CodeableConcept
     */
    CodeableConcept: {
      /**
       * Code defined by a terminology system
       * @description A reference to a code defined by a terminology system.
       */
      coding?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding'][]
        | null;
      /**
       * Plain text representation of the concept
       * @description A human language representation of the concept as seen/selected/uttered by the user who entered the data and/or which represents the intended meaning of the user.
       */
      text?: string | null;
    };
    /** CodedClinicalEntity */
    CodedClinicalEntity: {
      /**
       * Entity Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      entity_id?: string;
      /** Entity */
      entity?: string[] | null;
      /** Location In Note */
      location_in_note?: components['schemas']['InTextLocation'][] | null;
      /** Reference In Transcript */
      reference_in_transcript?: components['schemas']['TranscriptReference'][] | null;
      /** Reference In Context */
      reference_in_context?: components['schemas']['ContextReference'][] | null;
      /** Primary Code */
      primary_code:
        | components['schemas']['SNOMEDCodeConcept']
        | components['schemas']['ICD10CodeConcept']
        | components['schemas']['MBSAUCodeConcept']
        | components['schemas']['CPTCodeConcept']
        | components['schemas']['ICD10UKCodeConcept']
        | components['schemas']['ICD9CMCodeConcept']
        | components['schemas']['ICD9CACodeConcept']
        | components['schemas']['OPCS410CodeConcept']
        | components['schemas']['ICD10AMCodeConcept']
        | components['schemas']['ACHI13AUCodeConcept']
        | components['schemas']['ICD10GMCodeConcept']
        | components['schemas']['CIM10FRCodeConcept']
        | components['schemas']['CIE10ESCodeConcept']
        | components['schemas']['ICD10ZACodeConcept']
        | components['schemas']['OrphaCodeConcept']
        | components['schemas']['CIM10MCCodeConcept']
        | components['schemas']['CIM10SCPCodeConcept']
        | components['schemas']['OHIPDXCodeConcept']
        | components['schemas']['CPTQACodeConcept']
        | components['schemas']['ICD10QACodeConcept']
        | components['schemas']['ICD10ITCodeConcept']
        | components['schemas']['BaseCodeConcept'];
      /**
       * Similar Codes
       * @default []
       */
      similar_codes: (
        | components['schemas']['SNOMEDCodeConcept']
        | components['schemas']['ICD10CodeConcept']
        | components['schemas']['MBSAUCodeConcept']
        | components['schemas']['CPTCodeConcept']
        | components['schemas']['ICD10UKCodeConcept']
        | components['schemas']['ICD9CMCodeConcept']
        | components['schemas']['ICD9CACodeConcept']
        | components['schemas']['OPCS410CodeConcept']
        | components['schemas']['ICD10AMCodeConcept']
        | components['schemas']['ACHI13AUCodeConcept']
        | components['schemas']['ICD10GMCodeConcept']
        | components['schemas']['CIM10FRCodeConcept']
        | components['schemas']['CIE10ESCodeConcept']
        | components['schemas']['ICD10ZACodeConcept']
        | components['schemas']['OrphaCodeConcept']
        | components['schemas']['CIM10MCCodeConcept']
        | components['schemas']['CIM10SCPCodeConcept']
        | components['schemas']['OHIPDXCodeConcept']
        | components['schemas']['CPTQACodeConcept']
        | components['schemas']['ICD10QACodeConcept']
        | components['schemas']['ICD10ITCodeConcept']
        | components['schemas']['BaseCodeConcept']
      )[];
      /** @default PENDING */
      status: components['schemas']['CodedClinicalEntityStatus'];
      /**
       * Relevance Score
       * @default 0.5
       */
      relevance_score: number;
      /** @default LOW */
      relevance: components['schemas']['CodedClinicalEntityRelevance'];
      snomed_uk_gp_context?: components['schemas']['SnomedUkGpContext'] | null;
    };
    /**
     * CodedClinicalEntityRelevance
     * @enum {string}
     */
    CodedClinicalEntityRelevance: CodedClinicalEntityRelevance;
    /**
     * CodedClinicalEntityStatus
     * @enum {string}
     */
    CodedClinicalEntityStatus: CodedClinicalEntityStatus;
    /**
     * CollectionCreate
     * @description Request model for creating a collection.
     */
    CollectionCreate: {
      /**
       * Name
       * @description Collection name
       */
      name: string;
      /**
       * Description
       * @description Collection description
       */
      description?: string | null;
      /**
       * Icon
       * @description Collection icon (emoji or icon name)
       */
      icon?: string | null;
      /**
       * Team Id
       * @description Team ID to make collection team-visible; omit for personal
       */
      team_id?: string | null;
      /**
       * Domains
       * @description URL domain filters for web search (e.g., ['uptodate.com', 'bmj.com/guidelines'])
       */
      domains?: string[] | null;
    };
    /** CollectionDeleteRequest */
    CollectionDeleteRequest: {
      /** User Ref Id */
      user_ref_id: string;
    };
    /** CollectionDeleteResponse */
    CollectionDeleteResponse: {
      /** Deleted */
      deleted?: {
        [key: string]: number;
      };
    };
    /**
     * CollectionDetailResponse
     * @description Response model for collection with document IDs.
     */
    CollectionDetailResponse: {
      /** Collection Id */
      collection_id: string;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      /** Icon */
      icon?: string | null;
      /** Owner Id */
      owner_id: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Team Id */
      team_id?: string | null;
      /**
       * Document Count
       * @default 0
       */
      document_count: number;
      /**
       * Domain Count
       * @default 0
       */
      domain_count: number;
      /** Domains */
      domains?: string[];
      /**
       * Source
       * @description Mirrors `Collection.source`. The FE relies on this to render SharePoint-managed collections with the SharePoint logo and to hide rename/edit/delete affordances (T8 / T9). Defaults to `user` so pre-source-field collections behave unchanged.
       * @default user
       * @enum {string}
       */
      source: CollectionDetailResponseSource;
      /**
       * Kind
       * @description Mirrors `Collection.kind`. `artifacts` collections render as Work outputs in the library UI.
       * @default input
       * @enum {string}
       */
      kind: CollectionDetailResponseKind;
      /**
       * Is Web Collection
       * @description True when this collection was migrated from a legacy web source list (`Collection.legacy_source_list_id` is set). These collections cannot accept document additions — `POST /collections/{id}/documents` returns 400 for them. The FE uses this flag to disable such rows in the Add to / Edit collections picker instead of letting the user trigger a guaranteed-to-fail request (EVI-1758). Defaults to False so natively-created collections behave unchanged.
       * @default false
       */
      is_web_collection: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** @description Only set on PATCH responses where the request promoted a personal collection into a team and the cascade ran. Absent on every other endpoint (list / get / create / rename) so existing clients are unaffected. */
      cascade_summary?: components['schemas']['CascadeSummary'] | null;
      /** Document Ids */
      document_ids?: string[];
    };
    /**
     * CollectionExportResponse
     * @description Per-collection rows plus a count map, keyed by ``SatelliteCollectionSpec.key``.
     */
    CollectionExportResponse: {
      /** Collections */
      collections?: {
        [key: string]: {
          [key: string]: unknown;
        }[];
      };
      /** Counts */
      counts?: {
        [key: string]: number;
      };
    };
    /** CollectionImportRequest */
    CollectionImportRequest: {
      /** Collections */
      collections?: {
        [key: string]: {
          [key: string]: unknown;
        }[];
      };
      /** Target User Mongo Id */
      target_user_mongo_id?: string | null;
      /** Target Workspace Id */
      target_workspace_id?: string | null;
    };
    /** CollectionImportResponse */
    CollectionImportResponse: {
      /** Inserted */
      inserted?: {
        [key: string]: number;
      };
      /**
       * Skipped Count
       * @default 0
       */
      skipped_count: number;
    };
    /**
     * CollectionListResponse
     * @description Response model for listing collections.
     */
    CollectionListResponse: {
      /** Collections */
      collections: components['schemas']['CollectionResponse'][];
      /** Total */
      total: number;
    };
    /** CollectionMergeRequest */
    CollectionMergeRequest: {
      /** From User Ref Id */
      from_user_ref_id: string;
      /** To User Ref Id */
      to_user_ref_id: string;
    };
    /** CollectionMergeResponse */
    CollectionMergeResponse: {
      /** Results */
      results?: {
        [key: string]: components['schemas']['CollectionMergeResult'];
      };
    };
    /** CollectionMergeResult */
    CollectionMergeResult: {
      /**
       * Transferred
       * @default 0
       */
      transferred: number;
      /**
       * Skipped
       * @default 0
       */
      skipped: number;
    };
    /**
     * CollectionResponse
     * @description Response model for collection operations.
     */
    CollectionResponse: {
      /** Collection Id */
      collection_id: string;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      /** Icon */
      icon?: string | null;
      /** Owner Id */
      owner_id: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Team Id */
      team_id?: string | null;
      /**
       * Document Count
       * @default 0
       */
      document_count: number;
      /**
       * Domain Count
       * @default 0
       */
      domain_count: number;
      /** Domains */
      domains?: string[];
      /**
       * Source
       * @description Mirrors `Collection.source`. The FE relies on this to render SharePoint-managed collections with the SharePoint logo and to hide rename/edit/delete affordances (T8 / T9). Defaults to `user` so pre-source-field collections behave unchanged.
       * @default user
       * @enum {string}
       */
      source: CollectionResponseSource;
      /**
       * Kind
       * @description Mirrors `Collection.kind`. `artifacts` collections render as Work outputs in the library UI.
       * @default input
       * @enum {string}
       */
      kind: CollectionResponseKind;
      /**
       * Is Web Collection
       * @description True when this collection was migrated from a legacy web source list (`Collection.legacy_source_list_id` is set). These collections cannot accept document additions — `POST /collections/{id}/documents` returns 400 for them. The FE uses this flag to disable such rows in the Add to / Edit collections picker instead of letting the user trigger a guaranteed-to-fail request (EVI-1758). Defaults to False so natively-created collections behave unchanged.
       * @default false
       */
      is_web_collection: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** @description Only set on PATCH responses where the request promoted a personal collection into a team and the cascade ran. Absent on every other endpoint (list / get / create / rename) so existing clients are unaffected. */
      cascade_summary?: components['schemas']['CascadeSummary'] | null;
    };
    /**
     * CollectionUpdate
     * @description Request model for updating a collection.
     *
     *     For domains: None means unchanged, [] means clear all domains.
     */
    CollectionUpdate: {
      /**
       * Name
       * @description New collection name
       */
      name?: string | null;
      /**
       * Description
       * @description New collection description
       */
      description?: string | null;
      /**
       * Icon
       * @description New collection icon
       */
      icon?: string | null;
      /**
       * Domains
       * @description URL domain filters. None = unchanged, [] = clear all.
       */
      domains?: string[] | null;
      /**
       * Team Id
       * @description Move collection to a team by setting team_id. Omit to leave unchanged.
       */
      team_id?: string | null;
    };
    /**
     * CommitRequest
     * @description Request model for committing agent templates.
     */
    CommitRequest: {
      /** Goal */
      goal: string;
      /** Context */
      context?: string | null;
      /** Knowledge Base */
      knowledge_base?: string | null;
      /** Practice Name */
      practice_name?: string | null;
      /** Practice Address */
      practice_address?: string | null;
      /** Practice Country */
      practice_country?: string | null;
      /** Handoff Phone */
      handoff_phone?: string | null;
      /** Direction */
      direction: string;
      /** User Id */
      user_id?: string | null;
      /** Source */
      source?: string | null;
      /** Config Overrides */
      config_overrides?: {
        [key: string]: unknown;
      } | null;
    };
    /** CommonlyUsedPastEHRNote */
    CommonlyUsedPastEHRNote: {
      /** Binary Id */
      binary_id: string;
      /** Note Content */
      note_content?: string | null;
      /** Note Type Display */
      note_type_display?: string | null;
      /** Encounter Time */
      encounter_time?: string | null;
      /** Author */
      author?: string | null;
      /** Specialty */
      specialty?: string | null;
    };
    /**
     * Communication
     * @description An occurrence of information being transmitted; e.g. an alert that was sent to a responsible provider, a public health agency that was notified about a reportable condition.
     *
     *     https://hl7.org/fhir/R4/communication-definitions.html
     */
    Communication: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Unique identifier
       * @description Business identifiers assigned to this communication by the performer or other systems which remain constant as the resource is updated and propagates from server to server.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Instantiates FHIR protocol or definition
       * @description The URL pointing to a FHIR-defined protocol, guideline, orderset or other definition that is adhered to in whole or in part by this Communication.
       */
      instantiatesCanonical?: string[] | null;
      /**
       * Instantiates external protocol or definition
       * @description The URL pointing to an externally maintained protocol, guideline, orderset or other definition that is adhered to in whole or in part by this Communication.
       */
      instantiatesUri?: string[] | null;
      /**
       * Request fulfilled by this communication
       * @description An order, proposal or plan fulfilled in whole or in part by this Communication.
       */
      basedOn?: components['schemas']['Reference'][] | null;
      /**
       * Part of this action
       * @description Part of this action.
       */
      partOf?: components['schemas']['Reference'][] | null;
      /**
       * Reply to
       * @description Prior communication that this communication is in response to.
       */
      inResponseTo?: components['schemas']['Reference'][] | null;
      /**
       * preparation | in-progress | not-done | on-hold | stopped | completed | entered-in-error | unknown
       * @description The status of the transmission.
       */
      status: components['schemas']['EventStatus'];
      /**
       * Reason for current status
       * @description Captures the reason for the current state of the Communication. Generally only used for 'not-done', 'suspended', or 'aborted' statuses. Example value set: CommunicationNotDoneReason (http://hl7.org/fhir/ValueSet/communication-not-done-reason).
       */
      statusReason?: components['schemas']['CodeableConcept'] | null;
      /**
       * Message category
       * @description The type of message conveyed such as alert, notification, reminder, instruction, etc. Example value set: CommunicationCategory (http://hl7.org/fhir/ValueSet/communication-category).
       */
      category?: components['schemas']['CodeableConcept'][] | null;
      /**
       * routine | urgent | asap | stat
       * @description Characterizes how quickly the planned or in progress communication must be addressed. Includes concepts such as stat, urgent, routine. If missing, this communication should be treated with normal priority.
       */
      priority?: components['schemas']['RequestPriority'] | null;
      /**
       * A channel of communication
       * @description A channel that was used for this communication (e.g. email, fax). Example value set: v3.ParticipationMode (http://terminology.hl7.org/ValueSet/v3-ParticipationMode).
       */
      medium?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Focus of message
       * @description The patient or group that was the focus of this communication.
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * Description of the purpose/content
       * @description Description of the purpose/content, similar to a subject line in an email. Example value set: CommunicationTopic (http://hl7.org/fhir/ValueSet/communication-topic).
       */
      topic?: components['schemas']['CodeableConcept'] | null;
      /**
       * Resources that pertain to this communication
       * @description Other resources that pertain to this communication and to which this communication is a response.
       */
      about?: components['schemas']['Reference'][] | null;
      /**
       * Encounter created as part of
       * @description The Encounter during which this Communication was created or to which the creation of this record is tightly associated.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * When sent
       * @description The time when this communication was sent.
       */
      sent?: string | null;
      /**
       * When received
       * @description The time when this communication arrived at the destination.
       */
      received?: string | null;
      /**
       * Message recipient
       * @description The entity (e.g. person, organization, clinical information system, care team or device) which was the target of the communication. If receipts need to be tracked by an individual, a separate resource instance will need to be created for each recipient. Multiple recipient communications are intended where either receipts are not tracked (e.g. a mass mail-out) or a receipt is captured in aggregate (all combinerecipients combineconfirmed).
       */
      recipient?: components['schemas']['Reference'][] | null;
      /**
       * Message sender
       * @description The entity (e.g. person, organization, clinical information system, or device) which was the source of the communication.
       */
      sender?: components['schemas']['Reference'] | null;
      /**
       * Indication for message
       * @description The reason or justification for the communication. Example value set: SNOMED CT Clinical Findings (http://hl7.org/fhir/ValueSet/clinical-findings).
       */
      reasonCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Why was communication done?
       * @description Indicates another resource whose existence justifies this communication.
       */
      reasonReference?: components['schemas']['Reference'][] | null;
      /**
       * Message payload
       * @description Text, attachment(s), or resource(s) that was communicated to the recipient.
       */
      payload?: components['schemas']['CommunicationPayload'][] | null;
      /**
       * Comments made about the communication
       * @description Additional notes or commentary about the communication by the sender, receiver or other interested parties.
       */
      note?: components['schemas']['Annotation'][] | null;
    };
    /**
     * CommunicationPayload
     * @description Text, attachment(s), or resource(s) that was communicated to the recipient.
     *
     *     https://hl7.org/fhir/R4/communication-definitions.html#Communication.payload
     */
    CommunicationPayload: {
      /**
       * Message part content
       * @description A communicated content (or for multi-part communications, one portion of the communication) as a simple string.
       */
      contentString?: string | null;
      /**
       * Message part content
       * @description A communicated content (or for multi-part communications, one portion of the communication) as an attachment.
       */
      contentAttachment?: components['schemas']['Attachment'] | null;
      /**
       * Message part content
       * @description A communicated content (or for multi-part communications, one portion of the communication) as a reference to any resource.
       */
      contentReference?: components['schemas']['Reference'] | null;
    };
    /**
     * CompetitionActionResponse
     * @description Response after modifying a competition.
     */
    CompetitionActionResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
      /** Competition Id */
      competition_id?: string | null;
    };
    /**
     * CompetitionResponse
     * @description Response for a single competition.
     */
    CompetitionResponse: {
      /** Competition Id */
      competition_id: string;
      /** Slug */
      slug: string;
      /** Series Slug */
      series_slug?: string | null;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      /**
       * Start Date
       * Format: date-time
       */
      start_date: string;
      /**
       * End Date
       * Format: date-time
       */
      end_date: string;
      status: components['schemas']['CompetitionStatus'];
      metric: components['schemas']['MetricConfig'];
      recurrence: components['schemas']['RecurrencePattern'];
      /** Regions */
      regions?: string[] | null;
      /** Countries */
      countries?: string[] | null;
      /** Campaigns */
      campaigns?: string[] | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * CompetitionStatus
     * @description Status of a competition.
     * @enum {string}
     */
    CompetitionStatus: CompetitionStatus;
    /**
     * CompleteMKCustomTemplateRequestBody
     * @description Request body for completing an MK custom template request
     */
    CompleteMKCustomTemplateRequestBody: {
      /**
       * Created Template Id
       * @description ID of the template that was created
       */
      created_template_id: string;
    };
    /**
     * CompletedIntegrationOnboardingExecutionStep
     * @description Integration onboarding step with a completed status.
     *
     *     In this state there is no error and result will be based on the step type.
     */
    CompletedIntegrationOnboardingExecutionStep: {
      /** Step Id */
      step_id: string;
      step_type: components['schemas']['StepType'];
      /** Step Number */
      step_number: number;
      /** Details */
      details: {
        [key: string]: unknown;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /** Payload */
      payload?: {
        [key: string]: unknown;
      } | null;
      /** Result */
      result?: {
        [key: string]: unknown;
      } | null;
      /** Internal Result */
      internal_result?: {
        [key: string]: unknown;
      } | null;
      /**
       * Status
       * @default completed
       * @constant
       */
      status: 'completed';
    };
    /**
     * ComponentError
     * @description Validation error for a flowsheet row/component.
     */
    ComponentError: {
      /** Rowid */
      rowId?: components['schemas']['dataclass__nebula_session__models__IDType'][] | null;
      /** Value */
      value?: string | null;
      /** Error */
      error: string;
      /** Errorcode */
      errorCode?: string | null;
    };
    /**
     * Composition
     * @description A set of healthcare-related information assembled into a single logical package.
     *
     *     A set of healthcare-related information that is assembled together into a
     *     single logical package that provides a single coherent statement of
     *     meaning, establishes its own context and that has clinical attestation
     *     with regard to who is making the statement. A Composition defines the
     *     structure and narrative content necessary for a document. However, a
     *     Composition alone does not constitute a document. Rather, the
     *     Composition must be the first entry in a Bundle where
     *     Bundle.type=document, and any other resources referenced from
     *     Composition must be included as subsequent entries in the Bundle (for
     *     example Patient, Practitioner, Encounter, etc.).
     *
     *     https://hl7.org/fhir/R4/composition-definitions.html
     */
    Composition: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Version-independent identifier for the Composition
       * @description A version-independent identifier for the Composition. This identifier stays constant as the composition is changed over time.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * preliminary | final | amended | entered-in-error
       * @description The workflow/clinical status of this composition. The status is a marker for the clinical standing of the document.
       */
      status: components['schemas']['CompositionStatus'];
      /**
       * Kind of composition (LOINC if possible)
       * @description Specifies the particular kind of composition (e.g. History and Physical, Discharge Summary, Progress Note). This usually equates to the purpose of making the composition.
       */
      type: components['schemas']['CodeableConcept'];
      /**
       * Categorization of Composition
       * @description A categorization for the type of the composition - helps for indexing and searching. This may be implied by or derived from the code specified in the Composition Type.
       */
      category?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Who and/or what the composition is about
       * @description Who or what the composition is about. The composition can be about a person, (patient or healthcare practitioner), a device (e.g. a machine) or even a group of subjects (such as a document about a herd of livestock, or a set of patients that share a common exposure).
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * Context of the Composition
       * @description Describes the clinical encounter or type of care this documentation is associated with.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * Composition editing time
       * @description The composition editing time, when the composition was last logically changed by the author.
       */
      date: string;
      /**
       * Who and/or what authored the composition
       * @description Identifies who is responsible for the information in the composition, not necessarily who typed it in.
       */
      author: components['schemas']['Reference'][];
      /**
       * Human Readable name/title
       * @description Official human-readable label for the composition.
       */
      title: string;
      /**
       * As defined by affinity domain
       * @description The code specifying the level of confidentiality of the Composition.
       */
      confidentiality?: components['schemas']['ConfidentialityClassification'] | null;
      /**
       * Attests to accuracy of composition
       * @description A participant who has attested to the accuracy of the composition/document.
       */
      attester?: components['schemas']['CompositionAttester'][] | null;
      /**
       * Organization which maintains the composition
       * @description Identifies the organization or group who is responsible for ongoing maintenance of and access to the composition/document information.
       */
      custodian?: components['schemas']['Reference'] | null;
      /**
       * Relationships to other compositions/documents
       * @description Relationships that this composition has with other compositions or documents that already exist.
       */
      relatesTo?: components['schemas']['CompositionRelatesTo'][] | null;
      /**
       * The clinical service(s) being documented
       * @description The clinical service, such as a colonoscopy or an appendectomy, being documented.
       */
      event?: components['schemas']['CompositionEvent'][] | null;
      /**
       * Composition is broken into sections
       * @description The root of the sections that make up the composition.
       */
      section?: components['schemas']['CompositionSection'][] | null;
    };
    /**
     * CompositionAttestationMode
     * @description The way in which a person authenticated a composition.
     *
     *     Used for ``Composition.attester.mode`` (Required binding).
     *
     *     https://hl7.org/fhir/R4/valueset-composition-attestation-mode.html
     * @enum {string}
     */
    CompositionAttestationMode: CompositionAttestationMode;
    /**
     * CompositionAttester
     * @description Attests to accuracy of composition.
     *
     *     A participant who has attested to the accuracy of the composition/document.
     *
     *     https://hl7.org/fhir/R4/composition-definitions.html#Composition.attester
     */
    CompositionAttester: {
      /**
       * personal | professional | legal | official
       * @description The type of attestation the authenticator offers.
       */
      mode: components['schemas']['CompositionAttestationMode'];
      /**
       * When the composition was attested
       * @description When the composition was attested by the party.
       */
      time?: string | null;
      /**
       * Who attested the composition
       * @description Who attested the composition in the specified way.
       */
      party?: components['schemas']['Reference'] | null;
    };
    /**
     * CompositionEvent
     * @description The clinical service(s) being documented.
     *
     *     The clinical service, such as a colonoscopy or an appendectomy, being
     *     documented.
     *
     *     https://hl7.org/fhir/R4/composition-definitions.html#Composition.event
     */
    CompositionEvent: {
      /**
       * Code(s) that apply to the event being documented
       * @description This list of codes represents the main clinical acts, such as a colonoscopy or an appendectomy, being documented.
       */
      code?: components['schemas']['CodeableConcept'][] | null;
      /**
       * The period covered by the documentation
       * @description The period of time covered by the documentation. There is no assertion that the documentation is a complete representation for this period, only that it documents events during this time.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * The event(s) being documented
       * @description The description and/or reference of the event(s) being documented. For example, this could be used to document such a colonoscopy or an appendectomy.
       */
      detail?: components['schemas']['Reference'][] | null;
    };
    /**
     * CompositionRelatesTo
     * @description Relationships to other compositions/documents.
     *
     *     Relationships that this composition has with other compositions or
     *     documents that already exist.
     *
     *     https://hl7.org/fhir/R4/composition-definitions.html#Composition.relatesTo
     */
    CompositionRelatesTo: {
      /**
       * replaces | transforms | signs | appends
       * @description The type of relationship that this composition has with another composition or document.
       */
      code: components['schemas']['DocumentRelationshipType'];
      /**
       * Target of the relationship (as Identifier)
       * @description The target composition/document of this relationship.
       */
      targetIdentifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * Target of the relationship (as Reference)
       * @description The target composition/document of this relationship.
       */
      targetReference?: components['schemas']['Reference'] | null;
    };
    /**
     * CompositionSection
     * @description Composition is broken into sections.
     *
     *     The root of the sections that make up the composition.
     *
     *     https://hl7.org/fhir/R4/composition-definitions.html#Composition.section
     */
    CompositionSection: {
      /**
       * Label for section (e.g. for ToC)
       * @description The label for this particular section. This will be part of the rendered content for the document, and is often used to build a table of contents.
       */
      title?: string | null;
      /**
       * Classification of section (recommended)
       * @description A code identifying the kind of content contained within the section. This must be consistent with the section title.
       */
      code?: components['schemas']['CodeableConcept'] | null;
      /**
       * Who and/or what authored the section
       * @description Identifies who is responsible for the information in this section, not necessarily who typed it in.
       */
      author?: components['schemas']['Reference'][] | null;
      /**
       * Who/what the section is about, when it is not about the subject of composition
       * @description The actual focus of the section when it is not the subject of the composition, but instead represents something or someone associated with the subject such as (for a patient subject) a spouse, parent, fetus, or donor.
       */
      focus?: components['schemas']['Reference'] | null;
      /**
       * Text summary of the section, for human interpretation
       * @description A human-readable narrative that contains the attested content of the section, used to represent the content of the resource to a human.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * working | snapshot | changes
       * @description How the entry list was prepared - whether it is a working list that is suitable for being maintained on an ongoing basis, or if it represents a snapshot of a list of items from another source, or whether it is a prepared list where items may be marked as added, modified or deleted.
       */
      mode?: components['schemas']['ListMode'] | null;
      /**
       * Order of section entries
       * @description Specifies the order applied to the items in the section entries.
       */
      orderedBy?: components['schemas']['CodeableConcept'] | null;
      /**
       * A reference to data that supports this section
       * @description A reference to the actual resource from which the narrative in the section is derived.
       */
      entry?: components['schemas']['Reference'][] | null;
      /**
       * Why the section is empty
       * @description If the section is empty, why the list is empty. An empty section typically has some text explaining the empty reason.
       */
      emptyReason?: components['schemas']['CodeableConcept'] | null;
      /**
       * Nested Section
       * @description A nested sub-section within this section.
       */
      section?: components['schemas']['CompositionSection'][] | null;
    };
    /**
     * CompositionStatus
     * @description The workflow/clinical status of a composition.
     *
     *     Used for ``Composition.status`` (Required binding) and
     *     ``DocumentReference.docStatus``.
     *
     *     https://hl7.org/fhir/R4/valueset-composition-status.html
     * @enum {string}
     */
    CompositionStatus: CompositionStatus;
    /**
     * CondAuto
     * @description A THEN follow-up: the condition resolves to ``yes`` automatically when any of
     *     the referenced source action ``item_id``s are checked, rather than via a manual
     *     answer.
     */
    CondAuto: {
      /** Sources */
      sources: string[];
      /** Label */
      label: string;
    };
    /** CondItem */
    CondItem: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: CondItemKind;
      /** Item Id */
      item_id: string;
      /** Question */
      question: string;
      /** Hint */
      hint?: string | null;
      /**
       * When
       * @default yes
       * @enum {string}
       */
      when: CondItemWhen;
      auto?: components['schemas']['CondAuto'] | null;
      /** Items */
      items: (
        | components['schemas']['CheckItem']
        | components['schemas']['InfoItem']
        | components['schemas']['ChoiceItem']
        | components['schemas']['CondItem']
        | components['schemas']['ForkItem']
        | components['schemas']['BranchItem']
      )[];
    };
    /**
     * Condition
     * @description A clinical condition, problem, diagnosis, or other event, situation, issue, or clinical concept that has risen to a level of concern.
     *
     *     Used to record detailed information about a condition, problem, diagnosis, or other
     *     event, situation, issue, or clinical concept that has risen to a level of concern.
     *
     *     https://hl7.org/fhir/R4/condition-definitions.html
     */
    Condition: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * External Ids for this condition
       * @description This records identifiers associated with this condition that are defined by business processes and/or used to refer to it when a direct URL reference to the resource itself is not appropriate.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * active | recurrence | relapse | inactive | remission | resolved
       * @description The clinical status of the condition.
       */
      clinicalStatus?: components['schemas']['CodeableConcept'] | null;
      /**
       * unconfirmed | provisional | differential | confirmed | refuted | entered-in-error
       * @description Verification status describing how the condition was verified.
       */
      verificationStatus?: components['schemas']['CodeableConcept'] | null;
      /**
       * problem-list-item | encounter-diagnosis | health-concern
       * @description A category assigned to the condition.
       */
      category?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Subjective severity of condition
       * @description A subjective assessment of the severity of the condition as experienced by the patient.
       */
      severity?: components['schemas']['CodeableConcept'] | null;
      /**
       * Identification of the condition, problem or diagnosis
       * @description Identification of the condition, problem or diagnosis.
       */
      code?: components['schemas']['CodeableConcept'] | null;
      /**
       * Anatomical location
       * @description The anatomical location where this condition manifests itself.
       */
      bodySite?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Who has the condition?
       * @description Indicates the patient or group who the condition record is associated with.
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * Encounter created as part of
       * @description The Encounter during which this Condition was created.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * Estimated or actual date, date-time, or age (dateTime)
       * @description Estimated or actual date or date-time the condition began, in the opinion of the clinician.
       */
      onsetDateTime?: string | null;
      /**
       * Estimated or actual date, date-time, or age (Age)
       * @description Estimated or actual date or date-time the condition began, in the opinion of the clinician.
       */
      onsetAge?: components['schemas']['Age'] | null;
      /**
       * Estimated or actual date, date-time, or age (Period)
       * @description Estimated or actual date or date-time the condition began, in the opinion of the clinician.
       */
      onsetPeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Estimated or actual date, date-time, or age (Range)
       * @description Estimated or actual date or date-time the condition began, in the opinion of the clinician.
       */
      onsetRange?: components['schemas']['Range'] | null;
      /**
       * Estimated or actual date, date-time, or age (string)
       * @description Estimated or actual date or date-time the condition began, in the opinion of the clinician.
       */
      onsetString?: string | null;
      /**
       * When in resolution/remission (dateTime)
       * @description The date or estimated date that the condition resolved or went into remission. This is called abatement because of the many overloaded connotations associated with remission or resolution.
       */
      abatementDateTime?: string | null;
      /**
       * When in resolution/remission (Age)
       * @description The date or estimated date that the condition resolved or went into remission.
       */
      abatementAge?: components['schemas']['Age'] | null;
      /**
       * When in resolution/remission (Period)
       * @description The date or estimated date that the condition resolved or went into remission.
       */
      abatementPeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * When in resolution/remission (Range)
       * @description The date or estimated date that the condition resolved or went into remission.
       */
      abatementRange?: components['schemas']['Range'] | null;
      /**
       * When in resolution/remission (string)
       * @description The date or estimated date that the condition resolved or went into remission.
       */
      abatementString?: string | null;
      /**
       * Date record was first recorded
       * @description The recordedDate represents when this particular Condition record was created in the system.
       */
      recordedDate?: string | null;
      /**
       * Additional information about the Condition
       * @description Additional information about the Condition. This is a general notes/comments entry for description of the Condition, its diagnosis and prognosis.
       */
      note?: components['schemas']['Annotation'][] | null;
    };
    /**
     * ConfidentialityClassification
     * @description The level of confidentiality of a composition.
     *
     *     Used for ``Composition.confidentiality`` (Required binding).
     *
     *     https://hl7.org/fhir/R4/v3/Confidentiality/vs.html
     * @enum {string}
     */
    ConfidentialityClassification: ConfidentialityClassification;
    /**
     * ConfigLearningAgentGaps
     * @description Pending gaps grouped under their owning agent.
     *
     *     BE returns a list of these (one per agent) — keyed access on the FE is
     *     achieved by iterating, not by indexing into a dict.
     */
    ConfigLearningAgentGaps: {
      /** Agent Id */
      agent_id: string;
      /** Agent Name */
      agent_name: string;
      /**
       * Agent Objective
       * @default
       */
      agent_objective: string;
      /** Gaps */
      gaps?: components['schemas']['ConfigLearningGap'][];
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningAgentPreview
     * @description Per-agent preview result from POST ``/config-learning/preview``.
     *
     *     Also embedded in :class:`ConfigLearningStatusResult` via ``active_preview``.
     *
     *     The diff fields are target-generic (D3): ``current_value`` / ``proposed_value``
     *     are the LEFT / RIGHT sides of the FE diff; ``base_field_digest`` is the
     *     digest of the field captured at preview time (re-checked on apply).
     */
    ConfigLearningAgentPreview: {
      /** Agent Id */
      agent_id: string;
      /** Agent Name */
      agent_name: string;
      /** Base Field Digest */
      base_field_digest: string;
      /**
       * Current Value
       * @default
       */
      current_value: string;
      /**
       * Proposed Value
       * @default
       */
      proposed_value: string;
      /**
       * Change Summary
       * @default
       */
      change_summary: string;
      /**
       * Diff Unified
       * @default
       */
      diff_unified: string;
      /**
       * Guardrail Status
       * @default pass
       */
      guardrail_status: string;
      /** Guardrail Violations */
      guardrail_violations?: components['schemas']['ConfigLearningGuardrailViolation'][];
      /** Gap Ids Included */
      gap_ids_included?: string[];
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningAgentPreviewFailure
     * @description A per-agent preview that did not produce an applyable field rewrite.
     */
    ConfigLearningAgentPreviewFailure: {
      /** Agent Id */
      agent_id: string;
      /** Agent Name */
      agent_name: string;
      /** Reason */
      reason: string;
      /** Gap Ids */
      gap_ids?: string[];
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningAnswer
     * @description A user-supplied answer to a surfaced gap.
     *
     *     ``text`` bounds mirror the ai-receptionist-be contract
     *     (``min_length=1, max_length=4000``). Request-side validation, so the
     *     bounds stay strict (no enum-widening concern here).
     */
    ConfigLearningAnswer: {
      /** Gap Id */
      gap_id: string;
      /** Text */
      text: string;
    };
    /**
     * ConfigLearningApplyAgentResult
     * @description A per-agent field rewrite that was committed by apply.
     */
    ConfigLearningApplyAgentResult: {
      /** Agent Id */
      agent_id: string;
      /** Agent Name */
      agent_name: string;
      /**
       * Change Summary
       * @default
       */
      change_summary: string;
      /**
       * Gaps Applied
       * @default 0
       */
      gaps_applied: number;
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningApplyConflict
     * @description A per-agent rewrite that apply could NOT commit.
     *
     *     Surfaced in the 200 body — apply never raises an HTTP error for these.
     *     ``reason`` is a response-side enum → ``str`` (see the section note).
     *     Documented values today: ``guardrail_violations``, ``agent_not_found``,
     *     ``base_field_digest_mismatch``.
     */
    ConfigLearningApplyConflict: {
      /** Agent Id */
      agent_id: string;
      /** Agent Name */
      agent_name: string;
      /** Reason */
      reason: string;
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningApplyResult
     * @description Response model for POST ``/config-learning/apply``.
     *
     *     Apply ALWAYS returns 200. Agents that couldn't be committed appear in
     *     ``conflicts`` (NOT via an HTTP error). There is no ``results`` field.
     */
    ConfigLearningApplyResult: {
      /**
       * Agents Applied
       * @default 0
       */
      agents_applied: number;
      /**
       * Gaps Applied
       * @default 0
       */
      gaps_applied: number;
      /** Agents */
      agents?: components['schemas']['ConfigLearningApplyAgentResult'][];
      /** Conflicts */
      conflicts?: components['schemas']['ConfigLearningApplyConflict'][];
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningDismissRequest
     * @description Request body for POST ``/config-learning/dismiss``.
     *
     *     A direct dismissal of surfaced gaps, outside the preview flow. Mirrors the
     *     ai-receptionist-be contract (``{gap_ids: [...]}``).
     */
    ConfigLearningDismissRequest: {
      /** Gap Ids */
      gap_ids?: string[];
    };
    /**
     * ConfigLearningDismissResult
     * @description Response model for POST ``/config-learning/dismiss`` (``{dismissed: int}``).
     */
    ConfigLearningDismissResult: {
      /**
       * Dismissed
       * @default 0
       */
      dismissed: number;
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningGap
     * @description A surfaced gap in an agent's config.
     *
     *     ``severity`` / ``status`` are *response*-side enums, relaxed to ``str`` so
     *     a future BE enum-widening degrades to passthrough instead of a proxy 500.
     */
    ConfigLearningGap: {
      /** Id */
      id: string;
      /** Agent Id */
      agent_id: string;
      /** Agent Name */
      agent_name: string;
      /**
       * Agent Objective
       * @default
       */
      agent_objective: string;
      /** Question */
      question: string;
      /**
       * Rationale
       * @default
       */
      rationale: string;
      /**
       * Severity
       * @default medium
       */
      severity: string;
      /** Source Refs */
      source_refs?: components['schemas']['ConfigLearningGapSourceRef'][];
      /**
       * Status
       * @default pending
       */
      status: string;
      /** Answer Text */
      answer_text?: string | null;
      /**
       * Scan Id
       * @default
       */
      scan_id: string;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Applied At */
      applied_at?: string | null;
      /** Ignored At */
      ignored_at?: string | null;
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningGapSourceRef
     * @description Pointer to the signal that surfaced a gap.
     *
     *     ``type`` is a *response*-side field, so it's typed ``str`` (not
     *     ``Literal``): if BE ever widens the source-ref enum the proxy should pass
     *     the new value through, not 500 with a ``ValidationError``. Documented
     *     values today: ``call``, ``unanswered_q``, ``diagnostic``.
     */
    ConfigLearningGapSourceRef: {
      /** Type */
      type: string;
      /** Id */
      id: string;
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningGuardrailViolation
     * @description Structured guardrail violation surfaced on a preview.
     *
     *     Carries the customer-safe ``user_message`` (templated per guardrails-v2
     *     category); the FE renders it verbatim. The LLM ``reasoning`` is
     *     intentionally NOT on the wire — it can paraphrase attacker-controlled
     *     field content.
     */
    ConfigLearningGuardrailViolation: {
      /** Field */
      field: string;
      /** Category */
      category: string;
      /**
       * Triggered Text
       * @default
       */
      triggered_text: string;
      /**
       * User Message
       * @default
       */
      user_message: string;
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningPreviewRequest
     * @description Request body for POST ``/config-learning/preview``.
     *
     *     Dismissals are accepted as plain ``gap_id`` strings to match the
     *     ai-receptionist-be contract (``dismissals: [gap_id]``).
     */
    ConfigLearningPreviewRequest: {
      /** Answers */
      answers?: components['schemas']['ConfigLearningAnswer'][];
      /** Dismissals */
      dismissals?: string[];
    };
    /**
     * ConfigLearningPreviewResult
     * @description Response model for POST ``/config-learning/preview``.
     */
    ConfigLearningPreviewResult: {
      /** Scan Id */
      scan_id: string;
      /** Dismissed Gap Ids */
      dismissed_gap_ids?: string[];
      /** Agents */
      agents?: components['schemas']['ConfigLearningAgentPreview'][];
      /** Failed Agents */
      failed_agents?: components['schemas']['ConfigLearningAgentPreviewFailure'][];
      /**
       * Guardrail Violations Count
       * @default 0
       */
      guardrail_violations_count: number;
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningScanCursor
     * @description Per-user config-learning watermark + mutex state.
     */
    ConfigLearningScanCursor: {
      /** User Id */
      user_id: string;
      /** Last Scanned At */
      last_scanned_at?: string | null;
      /** Last Applied At */
      last_applied_at?: string | null;
      /** In Flight Scan Id */
      in_flight_scan_id?: string | null;
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningScanResult
     * @description Response model for POST ``/config-learning/scan``.
     *
     *     Per-agent gaps live in ``agents`` (a ``List[ConfigLearningScanResultAgent]``).
     *     There is no ``pending_gaps_by_agent`` here — that field belongs to the
     *     STATUS response (:class:`ConfigLearningStatusResult`), not scan.
     */
    ConfigLearningScanResult: {
      /** Scan Id */
      scan_id: string;
      /**
       * Agents Scanned
       * @default 0
       */
      agents_scanned: number;
      /**
       * Gaps Surfaced
       * @default 0
       */
      gaps_surfaced: number;
      /**
       * Calls Dropped For Budget
       * @default 0
       */
      calls_dropped_for_budget: number;
      /** Agents */
      agents?: components['schemas']['ConfigLearningScanResultAgent'][];
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningScanResultAgent
     * @description Per-agent gaps surfaced by a scan, in ``ConfigLearningScanResult.agents``.
     */
    ConfigLearningScanResultAgent: {
      /** Agent Id */
      agent_id: string;
      /** Agent Name */
      agent_name: string;
      /**
       * Agent Objective
       * @default
       */
      agent_objective: string;
      /**
       * Calls Dropped For Budget
       * @default 0
       */
      calls_dropped_for_budget: number;
      /** Gaps */
      gaps?: components['schemas']['ConfigLearningGap'][];
    } & {
      [key: string]: unknown;
    };
    /**
     * ConfigLearningStatusResult
     * @description Response model for GET ``/config-learning/status``.
     *
     *     ``pending_gaps_by_agent`` (grouped pending gaps) lives HERE — not on the
     *     scan result. When BE builds ``active_preview`` here it populates ``agents``
     *     + ``guardrail_violations_count`` but leaves ``failed_agents`` /
     *     ``dismissed_gap_ids`` empty; clients must not depend on ``failed_agents``
     *     being present inside ``status.active_preview``.
     */
    ConfigLearningStatusResult: {
      cursor: components['schemas']['ConfigLearningScanCursor'];
      /** Pending Gaps By Agent */
      pending_gaps_by_agent?: components['schemas']['ConfigLearningAgentGaps'][];
      active_preview?: components['schemas']['ConfigLearningPreviewResult'] | null;
    } & {
      [key: string]: unknown;
    };
    /** ConfirmClinicalCodeRequest */
    ConfirmClinicalCodeRequest: {
      /** Codes */
      codes: components['schemas']['ClinicalCodeConfirmation'][];
    };
    /** ConfirmEmLevelRequest */
    ConfirmEmLevelRequest: {
      patient_type: components['schemas']['EmPatientType'];
      /** Code */
      code?: string | null;
      /** @default mdm */
      determination_method: components['schemas']['EmDeterminationMethod'];
    };
    /**
     * ConfirmEmailChangeRequest
     * @description Request schema for confirming email change with verification code.
     *
     *     Uses the same nonce/timestamp from the original verify-current-email step.
     */
    ConfirmEmailChangeRequest: {
      /** Nonce */
      nonce: string;
      /** Timestamp */
      timestamp: string;
      /** Verification Code */
      verification_code: string;
      /**
       * New Email
       * Format: email
       */
      new_email: string;
    };
    /**
     * ConfirmEmailChangeResponse
     * @description Response schema for email change confirmation.
     */
    ConfirmEmailChangeResponse: {
      /** Status */
      status: string;
      /** New Email */
      new_email: string;
    };
    /** ConfirmOrderResponse */
    ConfirmOrderResponse: {
      /** Order Id */
      order_id: string;
      status: components['schemas']['OrderStatus'];
      /** Payment Confirmed By */
      payment_confirmed_by?: string | null;
      /** Confirmed At */
      confirmed_at?: string | null;
      /** Erp Order Id */
      erp_order_id?: string | null;
    };
    /**
     * ConfirmProblemRequest
     * @description Provider's confirmation selections for a single problem.
     */
    ConfirmProblemRequest: {
      /** Problem Id */
      problem_id: string;
      /** Include In Assessment */
      include_in_assessment: boolean;
      /** Add As Diagnosis */
      add_as_diagnosis: boolean;
      /** Add To Problem List */
      add_to_problem_list: boolean;
      /**
       * Icd10 Codes
       * @description Optional provider-selected ICD-10 codes; defaults to pipeline suggestions
       */
      icd10_codes?: string[] | null;
    };
    /**
     * ConfirmProblemResponse
     * @description Response for POST /sessions/{session_id}/problems/confirm.
     */
    ConfirmProblemResponse: {
      /** Confirmed Count */
      confirmed_count: number;
      /** Success */
      success: boolean;
    };
    /**
     * ConfirmProblemsRequest
     * @description Request body for POST /sessions/{session_id}/problems/confirm.
     */
    ConfirmProblemsRequest: {
      /** Problems */
      problems: components['schemas']['ConfirmProblemRequest'][];
    };
    /**
     * ConnectorListResponse
     * @description Response containing available connectors.
     */
    ConnectorListResponse: {
      /** Connectors */
      connectors: components['schemas']['ConnectorResponse'][];
    };
    /**
     * ConnectorResponse
     * @description Single connector response.
     */
    ConnectorResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Icon */
      icon?: string | null;
    };
    /** ConsultNoteAICommandsResponseV2 */
    ConsultNoteAICommandsResponseV2: {
      /** Ai Commands */
      ai_commands: components['schemas']['AICommandResponseV2'][];
    };
    /** ConsultNoteModel */
    ConsultNoteModel: {
      /** @default CREATED */
      status: components['schemas']['ConsultNoteStatus'];
      /** Result */
      result?: string | null;
      /** Title */
      title?: string | null;
      /**
       * Heading
       * @default Note
       */
      heading: string;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      /** Args */
      args?: unknown;
      /** @default TEMPLATE */
      generation_method: components['schemas']['GenerationMethod'];
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      /** Third Party Template */
      third_party_template?: string | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
    };
    /**
     * ConsultNotePermissions
     * @description Permissions for a specific consult note.
     */
    ConsultNotePermissions: {
      /**
       * Consult Note Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      consult_note_id: string;
      /** Permissions */
      permissions: string[];
    };
    /** ConsultNoteResponseV2 */
    ConsultNoteResponseV2: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      status: components['schemas']['ConsultNoteStatus'];
      brain: components['schemas']['Brain'];
      /**
       * Heading
       * @default Note
       */
      heading: string;
      /** Note */
      note: string;
      /**
       * Original Note
       * @default
       */
      original_note: string;
      /** Edited Note */
      edited_note?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      generation_method: components['schemas']['GenerationMethod'];
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      /** Template Id */
      template_id?: string | null;
      /** Additions */
      additions?: string | null;
      feedback?: components['schemas']['Feedback'] | null;
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      /** Created At */
      created_at: string | null;
      /** Updated At */
      updated_at: string | null;
      content_type: components['schemas']['ContentType'] | null;
      /**
       * Should Retry
       * @default false
       */
      should_retry: boolean;
      failure_reason?: components['schemas']['UserFriendlyNoteFailedReason'] | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Used Experimental Transcript */
      used_experimental_transcript?: boolean | null;
      /** Original Note Word Count */
      original_note_word_count?: number | null;
      /** Current Note Word Count */
      current_note_word_count?: number | null;
      /** Section Mappings */
      section_mappings?: components['schemas']['SectionLink'][];
      /** Word Diff */
      word_diff?: number | null;
      /** Edit Rate */
      edit_rate?: number | null;
    };
    /**
     * ConsultNoteStatus
     * @enum {string}
     */
    ConsultNoteStatus: ConsultNoteStatus;
    /**
     * ConsultStorageDays
     * @enum {string}
     */
    ConsultStorageDays: ConsultStorageDays;
    /**
     * ConsumeAppleMigrationTicketRequest
     * @description Request payload for ``POST /consume-apple-migration-ticket``.
     *
     *     Issued by the Auth0 post-login Action once it has provisioned the user
     *     on the Auth0 side. The broker uses ``ticket_id`` to look up the
     *     pre-migration Kinde identity (via the Redis ticket store), then writes
     *     ``auth0_id`` (and optionally merges the supplied Auth0-side
     *     ``identities``) onto the resulting ``IdentityProfile`` and marks the
     *     Apple-migration flow ``COMPLETED``.
     */
    ConsumeAppleMigrationTicketRequest: {
      /**
       * Ticket Id
       * @description UUID v7 ticket id that was issued by /assign-apple-migration-ticket. Validated server-side as a real UUIDv7.
       * @example 01939d8e-7c4a-7b3f-9c2d-1a2b3c4d5e6f
       */
      ticket_id: string;
      /**
       * Auth0 Id
       * @description Auth0 user id in canonical ``connection|sub`` form (e.g. ``auth0|abc123`` or ``apple|001234.…``). This is written onto the broker's ``IdentityProfile.auth0_id`` so subsequent lookups by Auth0 id resolve to the same user.
       * @example auth0|689fa1081a7c86402da02c85
       */
      auth0_id: string;
      /**
       * Identities
       * @description Identities the Auth0 post-login Action observed for the newly-provisioned Auth0 user. When supplied, merged into the profile's existing identities by ``(provider, user_id)`` on the race-winning consume; identities the Kinde side already recorded are preserved. Optional during the Auth0-Action rollout — older Action versions that omit this field continue to work and skip the identities merge.
       */
      identities?: components['schemas']['Identity'][] | null;
      /**
       * Email
       * @description Email Auth0 reports for the newly-provisioned user. When supplied and different from the profile's stored email, the broker rebinds ``IdentityProfile.email`` to this value as part of the same atomic write that records ``auth0_id`` and flips ``auth0_sync_state`` to ``APPLE_MIGRATION_COMPLETED``. This exists because Apple's Hide-My-Email issues a new private-relay address bound to the Auth0 Services ID, so the Auth0-side email no longer matches the Kinde-era value on the profile. Optional during the Auth0-Action rollout — older Action versions that omit this field leave the persisted email untouched.
       * @example user@privaterelay.appleid.com
       */
      email?: string | null;
    };
    /**
     * ConsumeAppleMigrationTicketResponse
     * @description Wrapper response for ``POST /consume-apple-migration-ticket``.
     *
     *     Returns the post-migration ``IdentityProfile`` so the Auth0 post-login
     *     Action can verify the bind happened (``auth0_id``, ``auth0_sync_state``)
     *     and record any of the profile's fields it needs without a second
     *     round-trip.
     *
     *     Shape matches ``GetIdentityProfileResponse`` and
     *     ``SaveIdentityProfileResponse`` — every mutation-or-read endpoint on
     *     the identity broker returns the canonical profile under the
     *     ``identity_profile`` key, so callers can reuse a single deserialisation
     *     code path.
     * @example {
     *       "identity_profile": {
     *         "auth0_id": "auth0|689fa1081a7c86402da02c85",
     *         "auth0_sync_state": "apple_migration_completed",
     *         "created_at": "2026-06-09T12:00:00Z",
     *         "email": "user@example.com",
     *         "email_verified": true,
     *         "identities": [
     *           {
     *             "connection": "Sign in with Apple",
     *             "is_social": true,
     *             "provider": "apple",
     *             "user_id": "apple|001234.abcdef.1234"
     *           }
     *         ],
     *         "kinde_id": "kp_efa1081a7c86402da02c85cbdad0e428",
     *         "kinde_sync_state": "identity_create_completed",
     *         "last_routed_vendor": "auth0",
     *         "profile_source": "kinde",
     *         "updated_at": "2026-06-11T14:30:00Z",
     *         "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *       }
     *     }
     */
    ConsumeAppleMigrationTicketResponse: {
      /** @description The post-consume identity profile, with ``auth0_id`` bound to the supplied value and ``auth0_sync_state`` advanced to ``apple_migration_completed``. */
      identity_profile: components['schemas']['domains__identity_broker__dto__responses__identity_profile_dto__IdentityProfileDTO'];
    };
    /**
     * ContactDetail
     * @description Contact information for a person or organization.
     *
     *     https://hl7.org/fhir/R4/metadatatypes-definitions.html#ContactDetail
     */
    ContactDetail: {
      /**
       * Name of an individual to contact
       * @description The name of an individual to contact.
       */
      name?: string | null;
      /**
       * Contact details for individual or organization
       * @description The contact details for the individual (if a name was provided) or the organization.
       */
      telecom?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint'][]
        | null;
    };
    /**
     * ContactPointSystem
     * @description Telecommunications form for contact point.
     *
     *     https://hl7.org/fhir/R4/valueset-contact-point-system.html
     * @enum {string}
     */
    ContactPointSystem: ContactPointSystem;
    /**
     * ContactPointUse
     * @description Use of contact point.
     *
     *     https://hl7.org/fhir/R4/valueset-contact-point-use.html
     * @enum {string}
     */
    ContactPointUse: ContactPointUse;
    /** ContactSalesRequest */
    ContactSalesRequest: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Integration Name */
      integration_name: string;
      /**
       * Email
       * Format: email
       */
      email: string;
      /** Message */
      message: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /** User Id */
      user_id: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
    };
    /** ContactSalesRequestBase */
    ContactSalesRequestBase: {
      /** Integration Name */
      integration_name: string;
      /**
       * Email
       * Format: email
       */
      email: string;
      /** Message */
      message: string;
    };
    /**
     * ContentType
     * @enum {string}
     */
    ContentType: ContentType;
    /**
     * ContextCode
     * @description Identifies a flowsheet row by code system and identifier.
     */
    ContextCode: {
      system: components['schemas']['ContextCodeSystem'];
      /** Identifier */
      identifier: string;
    };
    /**
     * ContextCodeSystem
     * @example RowId
     */
    ContextCodeSystem: string;
    /**
     * ContextDocumentStatus
     * @enum {string}
     */
    ContextDocumentStatus: ContextDocumentStatus;
    /** ContextReference */
    ContextReference: {
      /** Context Text */
      context_text: string;
      location_in_context: components['schemas']['InTextLocation'];
    };
    /**
     * ContinueChatResponse
     * @description Response model for continuing a chat that has reached capacity.
     */
    ContinueChatResponse: {
      /** Chat Id */
      chat_id: string;
      /** Title */
      title: string;
      /** Continued From Chat Id */
      continued_from_chat_id: string;
      /** Session Id */
      session_id?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
    };
    /** ConversationDetailView */
    ConversationDetailView: {
      /** Id */
      id: string;
      /** Phone Number */
      phone_number: string;
      /**
       * Mode
       * @enum {string}
       */
      mode: ConversationDetailViewMode;
      /**
       * Status
       * @enum {string}
       */
      status: ConversationDetailViewStatus;
      /** Unread Count */
      unread_count: number;
      /** Last Activity At */
      last_activity_at: string;
      patient_match?: components['schemas']['PatientMatchView'] | null;
      /** Created At */
      created_at: string;
      /** Messages */
      messages: components['schemas']['MessageView'][];
      /** Upcoming Appointments */
      upcoming_appointments?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Past Appointments */
      past_appointments?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Available Agents
       * @default []
       */
      available_agents: components['schemas']['AgentSummaryView'][];
    };
    /** ConversationListView */
    ConversationListView: {
      /** Conversations */
      conversations: components['schemas']['ConversationSummaryView'][];
      /** Total */
      total: number;
      /** Has More */
      has_more: boolean;
    };
    /**
     * ConversationMessageView
     * @description Read view of a conversation message with block-level timing.
     *
     *     Same shape as the canonical ``Message`` — ``role`` / ``blocks`` /
     *     ``event_type`` / ``system_generated`` — with ``tool_call`` and
     *     ``tool_result`` blocks additionally carrying ``created_at``.
     */
    ConversationMessageView: {
      /**
       * Role
       * @enum {string}
       */
      role: ConversationMessageViewRole;
      /** Blocks */
      blocks?: (
        | components['schemas']['TextBlock']
        | components['schemas']['ThinkingBlock']
        | components['schemas']['ToolCallBlockView']
        | components['schemas']['ToolResultBlockView']
        | components['schemas']['AttachmentBlock']
      )[];
      /** Event Type */
      event_type?: string | null;
      /** System Generated */
      system_generated?: boolean | null;
    };
    /**
     * ConversationPageResponse
     * @description Paginated slice of a run's conversation (full history, not LLM-active view).
     *
     *     Reads ``ConversationView.artefact_turn_ids[offset:offset+limit]``, fetches
     *     the referenced artefacts, and concatenates their ``messages_delta`` for
     *     return. Suited to FE timeline rendering of long runs.
     */
    ConversationPageResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Offset */
      offset: number;
      /** Limit */
      limit: number;
      /** Total Artefacts */
      total_artefacts: number;
      /** Messages */
      messages: components['schemas']['ConversationMessageView'][];
    };
    /** ConversationSummaryView */
    ConversationSummaryView: {
      /** Id */
      id: string;
      /** Phone Number */
      phone_number: string;
      /**
       * Mode
       * @enum {string}
       */
      mode: ConversationSummaryViewMode;
      /**
       * Status
       * @enum {string}
       */
      status: ConversationSummaryViewStatus;
      /** Unread Count */
      unread_count: number;
      last_message?: components['schemas']['LastMessageView'] | null;
      /** Last Activity At */
      last_activity_at: string;
      patient_match?: components['schemas']['PatientMatchView'] | null;
      /** Created At */
      created_at: string;
    };
    /**
     * ConvertPlainTextNoteToSectionalNoteResponse
     * @description Response model for converting plain text note to sectional note
     */
    ConvertPlainTextNoteToSectionalNoteResponse: {
      /**
       * Clinical Note
       * @description The structured clinical note with sections that can be linked to EHR or use standardized format
       */
      clinical_note: {
        [key: string]:
          | string
          | components['schemas']['LinkedSectionContent']
          | components['schemas']['StandardizedSectionalNote'];
      };
    };
    /** CopySettings */
    CopySettings: {
      /**
       * Headings
       * @default false
       */
      headings: boolean;
      /**
       * Bold And Italics
       * @default true
       */
      bold_and_italics: boolean;
      /**
       * Bullet Points
       * @default true
       */
      bullet_points: boolean;
      /**
       * Tables
       * @default true
       */
      tables: boolean;
    };
    /**
     * CopyType
     * @description Type of copy operation
     * @enum {string}
     */
    CopyType: CopyType;
    /**
     * CorrespondenceContentType
     * @enum {string}
     */
    CorrespondenceContentType: CorrespondenceContentType;
    /**
     * Country
     * @enum {string}
     */
    Country: Country;
    /**
     * CountryCode
     * @description ISO 3166-1 alpha-2 country codes
     * @enum {string}
     */
    CountryCode: CountryCode;
    /**
     * CountryCodeDefaultView
     * @description One bucket of English country-code → default-voice routing.
     */
    CountryCodeDefaultView: {
      /** Country Codes */
      country_codes: string[];
      /** Voice Id */
      voice_id: string;
    };
    /** CoveredWindowSchema */
    CoveredWindowSchema: {
      /**
       * From Ts
       * Format: date-time
       */
      from_ts: string;
      /**
       * To Ts
       * Format: date-time
       */
      to_ts: string;
      /** Earliest Audit Event */
      earliest_audit_event?: string | null;
      /** Latest Audit Event */
      latest_audit_event?: string | null;
      /** Audit Covers Full Range */
      audit_covers_full_range: boolean;
    };
    /**
     * CreateAdCampaignRequest
     * @description Campaigns are always created DRAFT; go-live is an explicit transition.
     */
    CreateAdCampaignRequest: {
      /**
       * Advertiser Id
       * @description Owning advertiser record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      advertiser_id: string;
      /**
       * Name
       * @description Campaign / flight name.
       */
      name: string;
      /**
       * Start At
       * Format: date-time
       * @description Inclusive start of the flight window (timezone-aware, UTC).
       */
      start_at: string;
      /**
       * End At
       * Format: date-time
       * @description End of the flight window; must be strictly after start_at.
       */
      end_at: string;
      /** @description Heidi product surface; optional while DRAFT, required for go-live. */
      target_product?: components['schemas']['AdTargetProduct'] | null;
      /**
       * Criteria
       * @description Audience match map (AND across keys, OR within a key's values). Keys must be canonical criteria keys; empty means no audience restriction.
       */
      criteria?: {
        [key: string]: string[];
      };
      /**
       * Resource Id
       * @description Bound creative resource; must belong to the same advertiser. An unapproved resource may be bound — approval is enforced at go-live.
       */
      resource_id?: string | null;
      /**
       * Description
       * @description Optional internal description for ads operations.
       */
      description?: string | null;
    };
    /**
     * CreateAdResourceRequest
     * @description A new creative: the image itself plus the fields describing it.
     *
     *     Sent as multipart/form-data. Always yields a DRAFT resource: approval is an
     *     explicit action, not something a create can assert. Nothing derived from
     *     the image is declarable — its content type and size are read from the bytes
     *     — so a caller cannot choose how its own upload is later interpreted.
     *
     *     ``file`` is a model field rather than a separate endpoint parameter so that
     *     ``extra: forbid`` still sees the whole form; split across the two, FastAPI
     *     expects the model itself as one named part.
     */
    CreateAdResourceRequest: {
      /**
       * File
       * Format: binary
       * @description Image creative to store. Required.
       */
      file: string;
      /**
       * Advertiser Id
       * @description Owning advertiser.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      advertiser_id: string;
      /**
       * Name
       * @description Operator-facing resource name.
       */
      name: string;
      /**
       * Description
       * @description Internal description for ads operations.
       */
      description?: string | null;
      /**
       * Link
       * @description Click-through landing URL.
       */
      link?: string | null;
      /** @description Placement this creative is built for. Omit to leave it unclassified; it can be set later via PATCH. */
      ad_format?: components['schemas']['AdFormat'] | null;
    };
    /** CreateAddOnCheckoutRequest */
    CreateAddOnCheckoutRequest: {
      /**
       * Vendor
       * @default stripe
       * @constant
       */
      vendor: 'stripe';
      /** Fe Endpoint */
      fe_endpoint: string;
      /** Client Reference Id */
      client_reference_id?: string | null;
      /** Coupon Id */
      coupon_id?: string | null;
      /**
       * Free Trial Days
       * @description Free trial days, must be between 0 and 30 days
       * @default 0
       */
      free_trial_days: number | components['schemas']['StripeFreeTrialDays'] | null;
      /**
       * Credit Card Required
       * @default true
       */
      credit_card_required: boolean | null;
      /** Amplitude Device Id */
      amplitude_device_id?: string | null;
      /** Amplitude Session Id */
      amplitude_session_id?: number | null;
    };
    /** CreateAdvertiserRequest */
    CreateAdvertiserRequest: {
      /**
       * Name
       * @description Display / ops name for the advertiser.
       */
      name: string;
      /** @description HOUSE (Heidi-owned) vs EXTERNAL sponsor; omit when not yet classified. */
      kind?: components['schemas']['AdvertiserKind'] | null;
      /**
       * Description
       * @description Optional internal description for ads operations.
       */
      description?: string | null;
      /**
       * Contacts
       * @description Commercial/ops contacts; each requires a name and at least one of email or phone.
       */
      contacts?: components['schemas']['AdvertiserContact'][];
    };
    /** CreateAgentConfigRequest */
    CreateAgentConfigRequest: {
      agent: components['schemas']['pkg__agent_harness__core__config__AgentConfig'];
      /**
       * Description
       * @default
       */
      description: string;
    };
    /** CreateBlockedNumberRequest */
    CreateBlockedNumberRequest: {
      /**
       * Phone
       * @description Phone number to block (any common format)
       */
      phone: string;
      /** Patient Name */
      patient_name?: string | null;
      /** Reason */
      reason?: string | null;
      /** Blocked Via */
      blocked_via?: CreateBlockedNumberRequestBlocked_viaAnyOf0 | null;
    };
    /** CreateBlockedNumberView */
    CreateBlockedNumberView: {
      item: components['schemas']['BlockedNumberView'];
      /** Created */
      created: boolean;
    };
    /** CreateCatalogProductRequest */
    CreateCatalogProductRequest: {
      /** Product Key */
      product_key: string;
      /**
       * Aggregation Mode
       * @enum {string}
       */
      aggregation_mode: CreateCatalogProductRequestAggregation_mode;
      /** Sum Field */
      sum_field?: CreateCatalogProductRequestSum_fieldAnyOf0 | null;
      /** Dimensions */
      dimensions?: string[];
    };
    /**
     * CreateChatRequest
     * @description Request model for creating a new chat.
     */
    CreateChatRequest: {
      /**
       * Chatid
       * @description Optional client-generated MongoDB ObjectId (24 hex characters)
       */
      chatId?: string | null;
      /**
       * Firstmessage
       * @description First user message for the chat
       */
      firstMessage: string;
      /**
       * Sessionid
       * @description Optional session ID to associate with chat (mutually exclusive with patient_profile_id)
       */
      sessionId?: string | null;
      /**
       * Patientprofileid
       * @description Optional patient profile ID to associate with chat (mutually exclusive with session_id)
       */
      patientProfileId?: string | null;
    };
    /**
     * CreateChatResponse
     * @description Response model for creating a new chat.
     */
    CreateChatResponse: {
      /** Chat Id */
      chat_id: string;
      /** Title */
      title: string;
      /** Temp User Id */
      temp_user_id?: string | null;
      /** Session Id */
      session_id?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
    };
    /** CreateCheckoutRequest */
    CreateCheckoutRequest: {
      /**
       * Vendor
       * @default stripe
       * @constant
       */
      vendor: 'stripe';
      period?: components['schemas']['shared__enums__enums__Period'] | null;
      tier?: components['schemas']['SubscriptionTier'] | null;
      /**
       * Price Id
       * @description Target price directly instead of deriving it from `tier`; accepted only for Clinician Max prices. Mutually exclusive with `tier`.
       */
      price_id?: string | null;
      /** Fe Endpoint */
      fe_endpoint: string;
      /**
       * Fe Return Endpoint
       * @default https://scribe.dev.heidihealth.com/
       */
      fe_return_endpoint: string | null;
      /** Client Reference Id */
      client_reference_id?: string | null;
      /** Coupon Id */
      coupon_id?: string | null;
      /**
       * Free Trial Days
       * @description Free trial days, must be between 0 and 30 days
       */
      free_trial_days?: number | components['schemas']['StripeFreeTrialDays'] | null;
      /**
       * Cc Required
       * @default true
       */
      cc_required: boolean | null;
      /** Amplitude Device Id */
      amplitude_device_id?: string | null;
      /** Amplitude Session Id */
      amplitude_session_id?: number | null;
    };
    /** CreateCheckoutSessionResponse */
    CreateCheckoutSessionResponse: {
      /** Checkout Session Url */
      checkout_session_url: string;
    };
    /** CreateClinicalTaskRequest */
    CreateClinicalTaskRequest: {
      /** Title */
      title: string;
      /** Short Title */
      short_title?: string | null;
      /** Doc Suggestion Cta */
      doc_suggestion_cta?: string | null;
      /** Chip Label */
      chip_label?: string | null;
      /**
       * Is Suggestion Dismissed
       * @default false
       */
      is_suggestion_dismissed: boolean;
      /** Description */
      description?: string | null;
      category?: components['schemas']['ClinicalTaskCategory'] | null;
      /** @default todo */
      status: components['schemas']['ClinicalTaskStatus'];
      /**
       * Is Conditional
       * @default false
       */
      is_conditional: boolean;
      /** Session Id */
      session_id?: string | null;
      /** Source Quote */
      source_quote?: string | null;
      /** Due Date */
      due_date?: string | null;
      /** Links */
      links?: components['schemas']['ClinicalTaskLink'][];
      /** Assignee Id */
      assignee_id?: string | null;
      /** @default user */
      assignee_type: components['schemas']['AssigneeType'];
    };
    /**
     * CreateCompetitionRequest
     * @description Request to create a new competition.
     */
    CreateCompetitionRequest: {
      /** Name */
      name: string;
      /** Slug */
      slug: string;
      /** Series Slug */
      series_slug?: string | null;
      /** Description */
      description?: string | null;
      /**
       * Start Date
       * Format: date-time
       */
      start_date: string;
      /**
       * End Date
       * Format: date-time
       */
      end_date: string;
      /**
       * Metric Key
       * @default evidence_queries
       */
      metric_key: string;
      /** @default none */
      recurrence: components['schemas']['RecurrencePattern'];
      /** Regions */
      regions?: string[] | null;
      /** Countries */
      countries?: string[] | null;
      /** Campaigns */
      campaigns?: string[] | null;
    };
    /**
     * CreateConnectionRequest
     * @description Request to create a new SSO connection.
     */
    CreateConnectionRequest: {
      /**
       * Connection Name
       * @description Unique connection name (kebab-case)
       */
      connection_name: string;
      /**
       * Display Name
       * @description Human-readable display name
       */
      display_name: string;
      /**
       * Domains
       * @description Email domains for SSO routing
       */
      domains: string[];
      /**
       * Region
       * @description Region code (e.g., AU, US, EU, UK, CA)
       */
      region: string;
      /**
       * Testing Emails
       * @description Testing email addresses for TESTING state (max 10)
       */
      testing_emails?: string[];
      /**
       * Workspaces
       * @description Workspaces this connection's users self-onboard into
       */
      workspaces?: components['schemas']['LinkedWorkspaceRequest'][];
      /**
       * Enforce Linked Workspaces
       * @description Restrict this connection's users to the linked workspaces only
       * @default false
       */
      enforce_linked_workspaces: boolean;
    };
    /** CreateContactSalesRequestResponse */
    CreateContactSalesRequestResponse: {
      /** Has Already Been Requested */
      has_already_been_requested: boolean;
      contact_sales_request: components['schemas']['ContactSalesRequest'];
    };
    /** CreateDirectoryRequest */
    CreateDirectoryRequest: {
      /**
       * Organization Id
       * @description Organization that will own this directory.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      organization_id: string;
      /**
       * Display Name
       * @description Internal admin-facing display name.
       */
      display_name: string;
      /**
       * File
       * Format: binary
       * @description CSV file containing recipient data.
       */
      file: string;
    };
    /**
     * CreateDocumentPages
     * @enum {string}
     */
    CreateDocumentPages: CreateDocumentPages;
    /** CreateDocumentRequest */
    CreateDocumentRequest: {
      generation_type: components['schemas']['DocumentGenType'];
      /** Template Id */
      template_id?: string | null;
      /** Question */
      question?: string | null;
      /** Index */
      index?: number | null;
    };
    /** CreateDraftOrderRequest */
    CreateDraftOrderRequest: {
      /** Order Id */
      order_id: string;
      /** Milestone Product */
      milestone_product: string;
      /** Quantity */
      quantity: number;
      shipping: components['schemas']['CreateDraftOrderShippingDetails'];
      /** Currency */
      currency: string;
    };
    /** CreateDraftOrderResponse */
    CreateDraftOrderResponse: {
      /** Order Id */
      order_id: string;
    };
    /**
     * CreateDraftOrderShippingDetails
     * @description Guest shipping details, shaped 1:1 to the `ShippingDetails` domain model
     *     (mirrors `CreateInternalOrderShippingDetails`).
     *
     *     Deliverability is gated on the website (its Google Address Validation call);
     *     here we enforce only lightweight format hygiene — required contact/address
     *     fields, a valid ISO country code, a postcode — and trim/normalize.
     */
    CreateDraftOrderShippingDetails: {
      /** Contact Name */
      contact_name: string;
      /**
       * Contact Email
       * Format: email
       */
      contact_email: string;
      /** Contact Phone */
      contact_phone: string;
      /** Street Address */
      street_address: string;
      /** City */
      city?: string | null;
      /** State */
      state?: string | null;
      /** Postcode */
      postcode: string;
      /** Country */
      country: string;
    };
    /** CreateEHRLaunchProfileInput */
    CreateEHRLaunchProfileInput: {
      ehr_provider: components['schemas']['EHRProvider'];
      /** Profile Name */
      profile_name: string;
      /** Authorization Endpoint */
      authorization_endpoint: string;
      /** Token Endpoint */
      token_endpoint: string;
      /** Base Url */
      base_url: string;
      /** Client Id */
      client_id: string;
      /** Client Secret */
      client_secret: string;
      /** Password */
      password?: string | null;
      /** Iss */
      iss?: string | null;
      /** Refresh Token Endpoint */
      refresh_token_endpoint?: string | null;
      ehrlaunch_app?: components['schemas']['EHRLaunchApp'] | null;
      /** Connection Id */
      connection_id?: string | null;
      /** Jwks Uri */
      jwks_uri?: string | null;
      /** Issuer */
      issuer?: string | null;
      /** Callback Url */
      callback_url?: string | null;
      /** Scope */
      scope?: string | null;
      additional_details?: components['schemas']['AdditionalDetailsType'];
      timezone?: components['schemas']['TimeZones'] | null;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /** CreateEHRProfileAPIRequest */
    CreateEHRProfileAPIRequest: {
      ehr_provider: components['schemas']['EHRProvider'];
      /** Ehr User Id */
      ehr_user_id?: string | null;
      /** Ehr Clinic Name */
      ehr_clinic_name?: string | null;
      /** Clinic Id */
      clinic_id?: string | null;
      /** Guid */
      guid?: string | null;
      /** Api Key */
      api_key?: string | null;
      timezone?: components['schemas']['TimeZones'] | null;
      /** Username */
      username?: string | null;
      /** Password */
      password?: string | null;
      /** Unity Base Url */
      unity_base_url?: string | null;
      /** Ubiquity Id */
      ubiquity_id?: string | null;
      /** Is Precharting Enabled */
      is_precharting_enabled?: boolean | null;
    };
    /**
     * CreateEventRuleRequest
     * @description Internal-admin create — caller supplies scope explicitly.
     */
    CreateEventRuleRequest: {
      /**
       * Scope Type
       * @enum {string}
       */
      scope_type: CreateEventRuleRequestScope_type;
      /** Scope Id */
      scope_id: string;
      event_type: components['schemas']['EventType'];
      /** Filters */
      filters?: {
        [key: string]: string;
      };
      /** Workflow Id */
      workflow_id: string;
      /** Delay Seconds */
      delay_seconds?: number | null;
      /**
       * Enabled
       * @default true
       */
      enabled: boolean;
      /**
       * Description
       * @default
       */
      description: string;
      /** Conditions */
      conditions?: (
        | components['schemas']['PayloadCondition']
        | components['schemas']['SemanticCondition']
      )[];
      delivery_policy?: components['schemas']['DeliveryPolicy'] | null;
    };
    /**
     * CreateEvidenceFeedbackRequest
     * @description Request schema for creating evidence general feedback.
     *
     *     Supports both legacy single-star format and UMUX-Lite two-rating format.
     */
    CreateEvidenceFeedbackRequest: {
      /**
       * Ease Stars
       * @description Ease rating (UMUX-Lite) from 1 to 5
       */
      ease_stars?: number | null;
      /**
       * Usefulness Stars
       * @description Usefulness rating (UMUX-Lite) from 1 to 5
       */
      usefulness_stars?: number | null;
      /**
       * Stars
       * @description Legacy single star rating from 1 to 5
       */
      stars?: number | null;
      /**
       * Feedback
       * @description Optional text feedback from the user
       */
      feedback?: string | null;
    };
    /**
     * CreateEvidenceFeedbackResponse
     * @description Response schema for creating evidence general feedback.
     */
    CreateEvidenceFeedbackResponse: {
      /**
       * Success
       * @description Whether the feedback was saved successfully
       */
      success: boolean;
      /**
       * Feedback Id
       * @description ID of the created feedback record
       */
      feedback_id: string;
      /**
       * Evidence General Feedback Count
       * @description Updated count of feedback submissions for the user
       */
      evidence_general_feedback_count: number;
    };
    /**
     * CreateExampleViaChatRequest
     * @description Request body for updating an example note via chat.
     */
    CreateExampleViaChatRequest: {
      /** Current Example */
      current_example: string;
      /** User Request */
      user_request: string;
    };
    /**
     * CreateExclusionRequest
     * @description Request to create an exclusion.
     */
    CreateExclusionRequest: {
      /** User Ref Id */
      user_ref_id: string;
      /** @default competition */
      scope: components['schemas']['ExclusionScope'];
      /** Reason */
      reason?: string | null;
    };
    /** CreateExperimentRequest */
    CreateExperimentRequest: {
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Experiment Type
       * @description 'production_eval' or 'prompt_testing'
       */
      experiment_type: string;
      /** Workflow */
      workflow?: {
        [key: string]: unknown;
      };
      /** Config */
      config?: {
        [key: string]: unknown;
      };
    };
    /**
     * CreateGalleryTemplateRequest
     * @description Request to create a template directly in the gallery.
     */
    CreateGalleryTemplateRequest: {
      /** Template Id */
      template_id?: string | null;
      template_category: components['schemas']['GalleryTemplateCategory'];
      source_region: components['schemas']['GalleryTemplateRegion'];
      /** Country */
      country: string;
      /** Specialty */
      specialty: string;
      /** Author Id */
      author_id: string;
      /** Author Name */
      author_name: string;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /**
       * Clinic Id
       * @default
       */
      clinic_id: string;
      /**
       * Clinic Name
       * @default
       */
      clinic_name: string;
      /**
       * Preference Show Name
       * @default true
       */
      preference_show_name: boolean;
      /**
       * Preference Show Clinic
       * @default false
       */
      preference_show_clinic: boolean;
      /**
       * Preference Show Profile Picture
       * @default true
       */
      preference_show_profile_picture: boolean;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /**
       * Structure
       * @default
       */
      structure: string;
      /** Html */
      html?: string | null;
      /** Tone */
      tone?: string | null;
      /**
       * Example Output
       * @default
       */
      example_output: string;
      /** Url Path */
      url_path?: string | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      template_content?: components['schemas']['GalleryTemplateContentPayload'] | null;
    };
    /** CreateInboxClinicalTaskRequest */
    CreateInboxClinicalTaskRequest: {
      /** User Id */
      user_id: string;
      /**
       * Workspace Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      workspace_id: string;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      category?: components['schemas']['ClinicalTaskCategory'] | null;
      /** Due Date */
      due_date?: string | null;
      /** Source Quote */
      source_quote?: string | null;
      /**
       * Is Conditional
       * @default false
       */
      is_conditional: boolean;
      /** @default model */
      origin: components['schemas']['ClinicalTaskOrigin'];
      /** Links */
      links: components['schemas']['InboxMessageLink'][];
    };
    /** CreateInboxClinicalTaskResponse */
    CreateInboxClinicalTaskResponse: {
      /** Task Id */
      task_id: string;
      status: components['schemas']['ClinicalTaskStatus'];
      /** Links */
      links: components['schemas']['ClinicalTaskLink'][];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** CreateIntegrationAgentRequest */
    CreateIntegrationAgentRequest: {
      ehr_system: components['schemas']['IntegrationAgentProvider'];
      /**
       * Clinic Id
       * @description org_id or team_id as a string
       */
      clinic_id: string;
      clinic_id_type: components['schemas']['ClinicIdType'];
      /**
       * Label
       * @description Optional location label, e.g. 'Building A Reception'. Only needed when a clinic has multiple agents.
       */
      label?: string | null;
    };
    /** CreateIntegrationAgentResponse */
    CreateIntegrationAgentResponse: {
      agent: components['schemas']['IntegrationAgentPublic'];
      /**
       * Api Key
       * @description Raw API key - shown ONCE, never stored. Share with clinic IT admin via 1Password.
       */
      api_key: string;
    };
    /** CreateIntegrationClientRequest */
    CreateIntegrationClientRequest: {
      /**
       * Display Name
       * @description Human-readable label for the integration client.
       */
      display_name: string;
      /**
       * Provider
       * @description Integration partner identifier (e.g. 'HealthLink').
       */
      provider: string;
    };
    /** CreateIntegrationOnboardingSessionRequest */
    CreateIntegrationOnboardingSessionRequest: {
      /**
       * Provider
       * @description EHR provider type for this integration onboarding
       */
      provider: string;
    };
    /** CreateIntegrationOnboardingSessionResponse */
    CreateIntegrationOnboardingSessionResponse: {
      /**
       * Id
       * @description Identifier for the onboarding session
       */
      id: string;
      /**
       * User Id
       * @description ID of the user associated with this onboarding session
       */
      user_id: string;
      /**
       * Provider
       * @description EHR provider type for this integration onboarding
       */
      provider: string;
      /** @description Current status of the onboarding session */
      status: components['schemas']['OnboardingSessionStatus'];
      /**
       * Expires At
       * Format: date-time
       * @description Timestamp when this onboarding session expires
       */
      expires_at: string;
      /**
       * Current Step Number
       * @description Current step number in the onboarding process
       */
      current_step_number: number | null;
      /**
       * Steps
       * @description List of onboarding steps for this session
       */
      steps: components['schemas']['IntegrationOnboardingExecutionStep'][];
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when this onboarding session was created
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when this onboarding session was last updated
       */
      updated_at: string;
    };
    /** CreateIntegrationPartnerAdminRequest */
    CreateIntegrationPartnerAdminRequest: {
      /** Ehr User Id */
      ehr_user_id: string;
      /** Ehr Email */
      ehr_email: string;
      /** Ehr Provider */
      ehr_provider: string;
    };
    /** CreateIntegrationPartnerAdminResponse */
    CreateIntegrationPartnerAdminResponse: {
      admin_record: components['schemas']['IntegrationPartnerAdmin'];
    };
    /** CreateInternalOrderRequest */
    CreateInternalOrderRequest: {
      /** Idempotency Key */
      idempotency_key: string;
      /**
       * Milestone Product
       * @description Product name; must map to an ERP SKU
       */
      milestone_product: string;
      /** Quantity */
      quantity: number;
      reason_category: components['schemas']['InternalOrderReasonCategory'];
      /** Reason Notes */
      reason_notes?: string | null;
      shipping: components['schemas']['CreateInternalOrderShippingDetails'];
      /**
       * Amount Total
       * @default 0
       */
      amount_total: number;
      /**
       * Currency
       * @default aud
       */
      currency: string;
      /**
       * Serial Numbers
       * @description Serials of the units this order ships. Send an array; a raw string is also accepted and split on commas/newlines. Entries are trimmed, blanks and duplicates dropped, order and case preserved.
       */
      serial_numbers?: string[];
    };
    /** CreateInternalOrderShippingDetails */
    CreateInternalOrderShippingDetails: {
      /** Contact Name */
      contact_name: string;
      /** Street Address */
      street_address: string;
      /** Contact Email */
      contact_email?: string | null;
      /** Contact Phone */
      contact_phone?: string | null;
      /** City */
      city?: string | null;
      /** State */
      state?: string | null;
      /** Postcode */
      postcode?: string | null;
      /** Country */
      country?: string | null;
    };
    /** CreateInvitationRequest */
    CreateInvitationRequest: {
      /** Name */
      name?: string | null;
      /**
       * Email
       * Format: email
       */
      email: string;
      /** Role Ids */
      role_ids?: string[] | null;
    };
    /** CreateInvitationResponse */
    CreateInvitationResponse: {
      /** Invitation Link */
      invitation_link: string;
    };
    /** CreateJudgeTemplateRequest */
    CreateJudgeTemplateRequest: {
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      /** Prompt Template */
      prompt_template: string;
      /** Model */
      model: string;
      /** Output Schema */
      output_schema?: {
        [key: string]: unknown;
      } | null;
      /**
       * Is Shared
       * @default false
       */
      is_shared: boolean;
    };
    /**
     * CreateLatestVersionControlRequest
     * @description Request body for creating a latest version control for a template creation record.
     *
     *     All fields are optional. If template_structure is not provided, an empty string
     *     will be used as the default.
     */
    CreateLatestVersionControlRequest: {
      /** Template Structure */
      template_structure?: string | null;
      /** Chat Query */
      chat_query?: string | null;
      /** Example Note */
      example_note?: string | null;
      /** Use Sections */
      use_sections?: boolean | null;
    };
    /**
     * CreateLetterFromDocumentRequest
     * @description Request body for creating a letter from a session document.
     */
    CreateLetterFromDocumentRequest: {
      /**
       * Source Document Id
       * @description ID of the session document to use as source content for the new letter.
       */
      source_document_id: string;
    };
    /**
     * CreateLimitAssignmentRequest
     * @description HTTP body for `POST /assignments`.
     *
     *     Assigns a named `Limit` (`limit_key`) to a principal. The meter is
     *     implied by the limit's `metric_key`, denormalized onto the row
     *     server-side at write time — callers never send `metric_key`.
     *     `created_by` is likewise taken server-side from the authenticated
     *     internal-admin claims, never from the wire.
     */
    CreateLimitAssignmentRequest: {
      /**
       * Scope Type
       * @enum {string}
       */
      scope_type: CreateLimitAssignmentRequestScope_type;
      /** Scope Id */
      scope_id?: string | null;
      /** Limit Key */
      limit_key: string;
      /**
       * Mode
       * @default enroll
       * @enum {string}
       */
      mode: CreateLimitAssignmentRequestMode;
      /** Starts At */
      starts_at?: string | null;
      /** Expires At */
      expires_at?: string | null;
      /** Reason */
      reason?: string | null;
    };
    /**
     * CreateLimitRequest
     * @description HTTP body for `POST /metrics/{metric_key}/limits`.
     *
     *     Creates a **named** limit against an existing meter. `metric_key` is
     *     taken from the path (the FE picks the meter, e.g. from `GET /metrics`);
     *     `limit_key` is the new limit's own name. The whole `{tier: cap}` map
     *     is supplied in one call; a tier omitted (or set to `null`) is
     *     UNLIMITED. Many named limits may reference the same meter.
     *
     *     `period` is **required**: a cap is only meaningful next to
     *     a window (*"50 per week"*). Two limits on one meter may carry
     *     different periods (e.g. `weekly` and `monthly`) — both are creatable
     *     (N:1); which one is *assigned* per principal is the assignment
     *     layer's concern. Validated against the `Period` literal (the
     *     `PERIODS` allowlist).
     *
     *     `enforcement_mode` is optional (default `hard_cap`): `hard_cap` makes
     *     the number a gate ceiling; `metered_overage` makes it an included
     *     allowance (gate allows, Stripe bills the excess). Creating a
     *     `metered_overage` limit requires the meter to have an active price
     *     binding (validated in the service) — otherwise it's allow-past-the-
     *     allowance-but-never-bill, i.e. free-unlimited.
     */
    CreateLimitRequest: {
      /** Limit Key */
      limit_key: string;
      /** Description */
      description?: string | null;
      /**
       * Period
       * @enum {string}
       */
      period: CreateLimitRequestPeriod;
      /**
       * Enforcement Mode
       * @default hard_cap
       * @enum {string}
       */
      enforcement_mode: CreateLimitRequestEnforcement_mode;
      /** Plan Limits */
      plan_limits?: {
        [key: string]: number | null;
      };
    };
    /** CreateLiveTranscriptionResponse */
    CreateLiveTranscriptionResponse: {
      /** Recording Id */
      recording_id: string;
    };
    /**
     * CreateMetricRequest
     * @description HTTP body for `POST /metrics` — the **meter** only.
     *
     *     Limits are NOT set here: a metric is created meter-first, then its
     *     per-tier caps are created separately via
     *     `POST /metrics/{metric_key}/limits` (`CreateLimitRequest`). A
     *     meter with no limit rows yet resolves every tier to UNLIMITED (the
     *     permissive default) until its limits are created. Enforces all the
     *     validation invariants described in
     *     `domains/usage_entitlements/AGENTS.md`.
     */
    CreateMetricRequest: {
      /** Metric Key */
      metric_key: string;
      /** Description */
      description?: string | null;
      /**
       * Aggregation Mode
       * @enum {string}
       */
      aggregation_mode: CreateMetricRequestAggregation_mode;
      /** Sum Field */
      sum_field?: CreateMetricRequestSum_fieldAnyOf0 | null;
      /** Filter Groups */
      filter_groups: {
        [key: string]: string;
      }[];
    };
    /** CreateNewIntegrationRequestResponse */
    CreateNewIntegrationRequestResponse: {
      /** Is New Integration */
      is_new_integration: boolean;
      integration: components['schemas']['database__mongo__models__integrations__integration_request__IntegrationRequest'];
    };
    /** CreateOpenAPIRequest */
    CreateOpenAPIRequest: {
      /** Third Party */
      third_party: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /**
       * Is Reseller Model
       * @default false
       */
      is_reseller_model: boolean;
      /**
       * Is Reseller Org Requires Link Account
       * @default false
       */
      is_reseller_org_requires_link_account: boolean;
      /**
       * Is Freemium Model
       * @default false
       */
      is_freemium_model: boolean;
      /**
       * Is Widget Enabled
       * @default false
       */
      is_widget_enabled: boolean;
      /**
       * Is Open Api Enabled
       * @default false
       */
      is_open_api_enabled: boolean;
      /**
       * Is Link With Email Enabled
       * @default false
       */
      is_link_with_email_enabled: boolean;
      /** Description */
      description?: string | null;
      /** Contact Email */
      contact_email?: string | null;
      /** Created By Email */
      created_by_email?: string | null;
    };
    /** CreateOrgLetterheadRequest */
    CreateOrgLetterheadRequest: {
      /**
       * Organization Id
       * @description Organization that will own this letterhead.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      organization_id: string;
      /**
       * Display Name
       * @description Internal admin-facing display name.
       */
      display_name: string;
      /**
       * File
       * Format: binary
       * @description Letterhead image asset to upload.
       */
      file: string;
    };
    /** CreatePatientProfileRequest */
    CreatePatientProfileRequest: {
      ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Patient Sex Code */
      patient_sex_code?: number | null;
      /** Birth Date */
      birth_date?: string | null;
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Demographic String */
      demographic_string?: string | null;
      /** Remember Consent */
      remember_consent?: boolean | null;
      /** Additional Context */
      additional_context?: string | null;
      /** Current Medications */
      current_medications?: string | null;
      /** Allergies */
      allergies?: string | null;
      /** Past Medical History */
      past_medical_history?: string | null;
      /** Ethnicity */
      ethnicity?: string | null;
      /** First Language */
      first_language?: string | null;
      /** Accent */
      accent?: string | null;
      /** Postcode Prefix */
      postcode_prefix?: string | null;
    };
    /** CreatePatientProfileResponse */
    CreatePatientProfileResponse: {
      data: components['schemas']['PatientProfileModel'];
    };
    /** CreatePrescriptionRequest */
    CreatePrescriptionRequest: {
      /** Drug */
      drug: string;
      /** Dose */
      dose: string;
      /** Frequency */
      frequency: string;
      /** Duration */
      duration: string;
      /** Route */
      route: string;
      /** Indication */
      indication?: string | null;
      /** Formulation */
      formulation?: string | null;
      /** Brand Name */
      brand_name?: string | null;
      /** N Repeats */
      n_repeats?: number | null;
      /** Quantity */
      quantity?: string | null;
      /**
       * Allergy Checked
       * @default false
       */
      allergy_checked: boolean;
      /** Session Id */
      session_id?: string | null;
    };
    /** CreatePresentationRequest */
    CreatePresentationRequest: {
      /**
       * Title
       * @default
       */
      title: string;
      /** Chat Id */
      chat_id?: string | null;
    };
    /** CreateProjectRequest */
    CreateProjectRequest: {
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /**
       * Tool Profile
       * @default clinician_desktop
       * @enum {string}
       */
      tool_profile: CreateProjectRequestTool_profile;
      /** Tool Approvals */
      tool_approvals?: components['schemas']['ProjectToolApproval'][] | null;
      /** Run Flags */
      run_flags?: {
        [key: string]: boolean;
      };
      /** @description Screen dimensions + scaling from the desktop client. Required for the agent's `computer*` tools to resolve coordinates correctly. Omit for evidence-only projects or when no desktop client is attached. */
      client_capabilities?: components['schemas']['ClientCapabilities'] | null;
      /**
       * Patient Profile Id
       * @description Heidi patient profile id linked at project start. Seeds the run's runtime target so patient-scoped tools resolve the patient without an explicit lookup.
       */
      patient_profile_id?: string | null;
      /**
       * Session Id
       * @description Heidi clinical session id linked at project start. Seeds the run's runtime target so session-scoped tools resolve the session without an explicit lookup.
       */
      session_id?: string | null;
      /**
       * Run Tag
       * @description Telemetry cohort tag (e.g. 'ambient-validation') stamped into the run config metadata so backend telemetry can slice this cohort. Omit for normal projects.
       */
      run_tag?: string | null;
    };
    /**
     * CreateProtocolRequest
     * @description Request to create a new protocol.
     */
    CreateProtocolRequest: {
      /** Name */
      name: string;
      /** Shorthand */
      shorthand: string;
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Standard Operating Procedure
       * @default
       */
      standard_operating_procedure: string;
      /** Output Template Id */
      output_template_id?: string | null;
      /** Connector Ids */
      connector_ids?: string[];
    };
    /**
     * CreatePublicTemplateSuggestionsRequest
     * @description Request for unauthenticated template suggestions during onboarding.
     */
    CreatePublicTemplateSuggestionsRequest: {
      /** Text */
      text?: string | null;
      /** Specialty Name */
      specialty_name?: string | null;
      /** Country */
      country?: string | null;
      /** Language */
      language?: string | null;
    };
    /** CreateQualityInvestigationTicketRequest */
    CreateQualityInvestigationTicketRequest: {
      /**
       * Customer Email
       * Format: email
       * @description Customer's email address
       */
      customer_email: string;
      /**
       * Customer Name
       * @description Customer's name (optional)
       */
      customer_name?: string | null;
      /**
       * Ticket Attributes
       * @description Ticket attributes (title, description, custom fields)
       */
      ticket_attributes?: {
        [key: string]: unknown;
      };
      /**
       * Submitting User Email
       * @description Email of the CSM submitting the ticket; added as participant to receive updates
       */
      submitting_user_email?: string | null;
    };
    /** CreateRateCardRequest */
    CreateRateCardRequest: {
      /** Entries */
      entries: components['schemas']['RateCardEntryInput'][];
      /** Rate Card Key */
      rate_card_key: string;
    };
    /** CreateReferralLinkRequest */
    CreateReferralLinkRequest: {
      /**
       * Paypal Email
       * Format: email
       */
      paypal_email: string;
    };
    /** CreateReferralLinkResponse */
    CreateReferralLinkResponse: {
      /** Referral Link */
      referral_link: string;
    };
    /** CreateReminderConfigRequest */
    CreateReminderConfigRequest: {
      /** Name */
      name: string;
      /** Appointment Type */
      appointment_type?: string | null;
      /**
       * Days Offset
       * @default 7
       */
      days_offset: number;
      /**
       * Time Of Day
       * @default 09:00
       */
      time_of_day: string;
      /**
       * Send Sms
       * @default true
       */
      send_sms: boolean;
      /**
       * Send Email
       * @default false
       */
      send_email: boolean;
      /** Sms Template */
      sms_template?: string | null;
      /** Email Subject Template */
      email_subject_template?: string | null;
      /** Email Body Template */
      email_body_template?: string | null;
      /**
       * Enable Magic Link
       * @default false
       */
      enable_magic_link: boolean;
      /** Magic Link Agent */
      magic_link_agent?: string | null;
      /**
       * Magic Link Expires Days
       * @default 7
       */
      magic_link_expires_days: number;
      /**
       * Enabled
       * @default true
       */
      enabled: boolean;
    };
    /**
     * CreateSendOutRequest
     * @description Create an office-stock send-out from selected QA-passed units.
     *
     *     A CUSTOMER_RESEND requires `recipient`; an INTERNAL_USE requires `taken_by`
     *     and `purpose`. The wrong-shape fields must be omitted for each type.
     */
    CreateSendOutRequest: {
      /** Idempotency Key */
      idempotency_key: string;
      send_out_type: components['schemas']['SendOutType'];
      /**
       * Stock Item Uuids
       * @description UUIDs of the QA-passed units to send out (must be unique).
       */
      stock_item_uuids: string[];
      recipient?: components['schemas']['SendOutRecipientDetails'] | null;
      /** Taken By */
      taken_by?: string | null;
      /** Purpose */
      purpose?: string | null;
    };
    /**
     * CreateServiceMeterBindingRequest
     * @description HTTP body for `POST /service-meter-bindings`.
     *
     *     Binds a `(product, feature)` action to the meter(s) it counts toward.
     *     `created_by` is taken server-side from the authenticated internal-admin
     *     claims, never from the wire. The supported-action check here gives a clean
     *     422 at the boundary (FastAPI maps the request `ValidationError`); the model
     *     re-asserts it as the source of truth.
     */
    CreateServiceMeterBindingRequest: {
      /** Product */
      product: string;
      /** Feature */
      feature: string;
      /** Metric Keys */
      metric_keys: string[];
      /** Description */
      description?: string | null;
    };
    /**
     * CreateSessionPatientDocumentLinksRequest
     * @description Link one or more patient documents to a session as note-gen context.
     */
    CreateSessionPatientDocumentLinksRequest: {
      /**
       * Patient Document Ids
       * @description IDs of patient documents to link. Must all belong to the session's patient.
       */
      patient_document_ids: string[];
    };
    /** CreateSessionWorkflowRequest */
    CreateSessionWorkflowRequest: {
      session: components['schemas']['domains__sessions__schemas__CreateSessionRequest'];
      appointment: components['schemas']['IntegrationAppointment'];
      patient?: components['schemas']['IntegrationPatient'] | null;
    };
    /** CreateSessionWorkflowResponse */
    CreateSessionWorkflowResponse: {
      session: components['schemas']['CreateSessionWorkflowSessionResponse'];
    };
    /** CreateSessionWorkflowSessionResponse */
    CreateSessionWorkflowSessionResponse: {
      /** Session Id */
      session_id: string;
    };
    /**
     * CreateSharedTemplateRequest
     * @description Request schema for creating a shared template.
     */
    CreateSharedTemplateRequest: {
      /**
       * Template Id
       * @description The template ID to share (copy the data)
       */
      template_id: string;
      /**
       * Shared By
       * @description Name of the person sharing
       */
      shared_by?: string | null;
      /**
       * Example Note
       * @description Optional example note for preview
       */
      example_note?: string | null;
    };
    /**
     * CreateSharedTemplateResponse
     * @description Response schema for creating a shared template.
     */
    CreateSharedTemplateResponse: {
      /**
       * Id
       * @description Unique ID (short, URL-safe)
       */
      id: string;
      /**
       * Url
       * @description Full URL to access the shared template (e.g., https://scribe.heidihealth.com/shared/templates/abc123)
       */
      url: string;
      /**
       * Expires At
       * @description ISO date string if links expire
       */
      expires_at?: string | null;
    };
    /** CreateSlideRequest */
    CreateSlideRequest: {
      /**
       * Title
       * @default
       */
      title: string;
      /** Index */
      index?: number | null;
    };
    /** CreateSnippetRequest */
    CreateSnippetRequest: {
      /** Shorthand */
      shorthand: string;
      /** Content */
      content: string;
      /** Trigger Phrase */
      trigger_phrase?: string | null;
      /** Is Verbal Trigger */
      is_verbal_trigger?: boolean | null;
    };
    /** CreateSnippetsBatchRequest */
    CreateSnippetsBatchRequest: {
      /** Snippets */
      snippets: components['schemas']['CreateSnippetRequest'][];
    };
    /**
     * CreateSourceListRequest
     * @description Request to create a new source list.
     */
    CreateSourceListRequest: {
      /** Name */
      name: string;
      /** Domains */
      domains?: string[];
      /**
       * Team Id
       * @description Team ID to create a team-visible source list. Must match the user's team. Omit for a personal list.
       */
      team_id?: string | null;
    };
    /** CreateTeamRequest */
    CreateTeamRequest: {
      /** Name */
      name: string;
    };
    /**
     * CreateTeamShortcutRequest
     * @description Request schema for creating a team shortcut.
     */
    CreateTeamShortcutRequest: {
      /**
       * Label
       * @description Short display label
       */
      label: string;
      /**
       * Query
       * @description Query sent to Evidence
       */
      query: string;
      /**
       * Description
       * @description Optional longer description
       */
      description?: string | null;
    };
    /** CreateTemplateCreationRecordFromChatRequest */
    CreateTemplateCreationRecordFromChatRequest: {
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_chat';
      /** Request */
      request: string;
    };
    /** CreateTemplateCreationRecordFromFileUploadRequest */
    CreateTemplateCreationRecordFromFileUploadRequest: {
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_file_upload';
      /** File Contents */
      file_contents: string;
      /** User Prompt */
      user_prompt?: string | null;
    };
    /**
     * CreateTemplateCreationRecordTrigger
     * @enum {string}
     */
    CreateTemplateCreationRecordTrigger: CreateTemplateCreationRecordTrigger;
    /** CreateTemplateFormFromPDF */
    CreateTemplateFormFromPDF: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Template Creation Record Id */
      template_creation_record_id?: string | null;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_pdf';
      /** S3 Object Key */
      s3_object_key: string;
      /**
       * Source Template Id
       * @description When copying a form template, the source template id used to resolve and duplicate the PDF.
       */
      source_template_id?: string | null;
      /**
       * Form Fields
       * @description Optional form fields from the PDF editor. If provided, these will be used instead of extracting from the PDF.
       */
      form_fields?: components['schemas']['FormField'][] | null;
    };
    /** CreateTemplateFromAICommandRequest */
    CreateTemplateFromAICommandRequest: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Template Creation Record Id */
      template_creation_record_id?: string | null;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_ai';
    };
    /** CreateTemplateFromDocumentRequest */
    CreateTemplateFromDocumentRequest: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Template Creation Record Id */
      template_creation_record_id?: string | null;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_document';
      /** Document Id */
      document_id: string;
    };
    /** CreateTemplateFromExistingTemplateRequest */
    CreateTemplateFromExistingTemplateRequest: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Template Creation Record Id */
      template_creation_record_id?: string | null;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_existing_template';
      /** Source Template Id */
      source_template_id: string;
    };
    /** CreateTemplateFromScratchRequest */
    CreateTemplateFromScratchRequest: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Template Creation Record Id */
      template_creation_record_id?: string | null;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_scratch';
    };
    /** CreateTemplateFromTemplateGalleryRequest */
    CreateTemplateFromTemplateGalleryRequest: {
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_template_gallery';
      /** Source Template Id */
      source_template_id: string;
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
    };
    /** CreateTemplateMappingRequest */
    CreateTemplateMappingRequest: {
      /** Kinde User Id */
      kinde_user_id: string;
      /** Template Id */
      template_id: string;
      /** Section Mappings */
      section_mappings: components['schemas']['SectionMappingRequest'][];
    };
    /**
     * CreateTemplatePages
     * @enum {string}
     */
    CreateTemplatePages: CreateTemplatePages;
    /** CreateTemplateRequest */
    CreateTemplateRequest: {
      /** Name */
      name: string;
      /** Content */
      content: string;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      tags?: components['schemas']['Tags'];
      /** Template Families */
      template_families?: string[];
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      /**
       * Should Deduct Quota
       * @default true
       */
      should_deduct_quota: boolean;
      pinned_for_tags?: components['schemas']['Tags'] | null;
      highlighted_for_tags?: components['schemas']['Tags'] | null;
      featured_for_tags?: components['schemas']['Tags'] | null;
      auto_generated_for_tags?: components['schemas']['Tags'] | null;
      /** Prompteams Id */
      prompteams_id?: string | null;
      /** List Order Priority */
      list_order_priority?: number | null;
    };
    /** CreateTemplateSuggestionsRequest */
    CreateTemplateSuggestionsRequest: {
      /** Text */
      text?: string | null;
      /** Specialty Group Id */
      specialty_group_id?: string | null;
    };
    /** CreateTemplateSuggestionsResponse */
    CreateTemplateSuggestionsResponse: {
      /** Suggestions */
      suggestions: string[];
    };
    /** CreateTemplateVersionControlManualRequest */
    CreateTemplateVersionControlManualRequest: {
      /**
       * Base Template Version Control Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      base_template_version_control_id: string;
      /** Template Structure */
      template_structure: string;
    };
    /** CreateTextChatSessionRequest */
    CreateTextChatSessionRequest: {
      /** Agent Name */
      agent_name: string;
    };
    /** CreateThirdPartyLicenseRequest */
    CreateThirdPartyLicenseRequest: {
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /**
       * Free Trial Days
       * @deprecated
       * @description Deprecated. Use trial_end_date. Ignored at write time.
       */
      free_trial_days?: number | null;
      /** Trial End Date */
      trial_end_date?: string | null;
      /** @default PRO_PLUS */
      latest_tier: components['schemas']['SubscriptionTier'];
      /** @default FREE */
      evidence_tier: components['schemas']['EvidenceSubscriptionTier'];
    };
    /** CreateTicketRequest */
    CreateTicketRequest: {
      /** Slug */
      slug: string;
      /** Field Values */
      field_values: {
        [key: string]: unknown;
      };
      /**
       * Submitting User Email
       * Format: email
       */
      submitting_user_email: string;
      hubspot_entity_ids?: components['schemas']['HubSpotEntityIds'] | null;
      /**
       * Is Blocking Deal
       * @default false
       */
      is_blocking_deal: boolean;
      /**
       * Attachments
       * @default []
       */
      attachments: components['schemas']['AttachmentInput'][];
      /**
       * Cc Submitter
       * @default true
       */
      cc_submitter: boolean;
      /**
       * Additional Ccs
       * @default []
       */
      additional_ccs: string[];
    };
    /** CreateUserEHRLaunchProfileAPIRequest */
    CreateUserEHRLaunchProfileAPIRequest: {
      ehr_provider: components['schemas']['EHRProvider'];
      /** Internal Id */
      internal_id: string;
      /** Profile Name */
      profile_name?: string | null;
      /** Connection Id */
      connection_id?: string | null;
      /**
       * Is Auto Created
       * @default false
       */
      is_auto_created: boolean;
    };
    /** CreateUserEHRLaunchProfileAPIResponse */
    CreateUserEHRLaunchProfileAPIResponse: {
      user_ehr_launch_profile: components['schemas']['UserEHRLaunchProfile'];
    };
    /** CreateUserEHRLaunchProfileAPIV2Request */
    CreateUserEHRLaunchProfileAPIV2Request: {
      ehr_provider: components['schemas']['EHRProvider'];
      /** Internal Id */
      internal_id: string;
      /** Profile Names */
      profile_names?: string[];
      /** Connection Id */
      connection_id?: string | null;
      /**
       * Is Auto Created
       * @default false
       */
      is_auto_created: boolean;
    };
    /** CreateUserEHRLaunchProfileAPIV2Response */
    CreateUserEHRLaunchProfileAPIV2Response: {
      /** User Ehr Launch Profiles */
      user_ehr_launch_profiles?: components['schemas']['UserEHRLaunchProfile'][];
    };
    /** CreateUserEHRLaunchProfileRequest */
    CreateUserEHRLaunchProfileRequest: {
      /** Ehr Provider */
      ehr_provider: components['schemas']['EHRProvider'] | string;
      /** Profile Name */
      profile_name: string;
      /** Internal Id */
      internal_id: string;
      /** User Id */
      user_id: string;
      /**
       * Is Auto Created
       * @default false
       */
      is_auto_created: boolean;
    };
    /** CreateUserInmailRequest */
    CreateUserInmailRequest: {
      /** Notification Name */
      notification_name: string;
      notification_group: components['schemas']['NotificationGroup'];
      /** Title */
      title: string;
      /** Content */
      content: string;
      status: components['schemas']['NotificationStatus'];
    };
    /** CreateUserRequest */
    CreateUserRequest: {
      country: components['schemas']['Country'];
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Specialty Id */
      specialty_id?: string | null;
      /** Other Specialty */
      other_specialty?: string | null;
      /**
       * Apply Reverse Trial
       * @default true
       */
      apply_reverse_trial: boolean;
      /** Affiliate Code */
      affiliate_code?: string | null;
      /** Evidence Ref */
      evidence_ref?: string | null;
    };
    /**
     * CreateVersionControlFromExampleRequest
     * @description Request body for creating a version control from an edited example note.
     */
    CreateVersionControlFromExampleRequest: {
      /**
       * Base Template Version Control Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      base_template_version_control_id: string;
      /** Current Template Structure */
      current_template_structure: string;
      /** Edited Example Note */
      edited_example_note: string;
    };
    /**
     * CreateWorkflowRequest
     * @description Heidi Work create — agent / product_surface are Studio-only (admin API).
     */
    CreateWorkflowRequest: {
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      /** Instructions */
      instructions: string;
      /**
       * Source
       * @default instructed
       * @enum {string}
       */
      source: CreateWorkflowRequestSource;
      /** Source Recording Id */
      source_recording_id?: string | null;
    };
    /** CreatedDocumentView */
    CreatedDocumentView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /** Creator Kinde Id */
      creator_kinde_id?: string | null;
      /** @default DOCUMENT */
      document_tab_type: components['schemas']['DocumentTabType'] | null;
      /** Index */
      index?: number | null;
      /** Name */
      name?: string | null;
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      /** Question */
      question?: string | null;
      /** Original Content */
      original_content?: string | null;
      /**
       * Content
       * @default
       */
      content: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
      /** Deleted At */
      deleted_at?: string | null;
      /** @default TEMPLATE */
      generation_type: components['schemas']['DocumentGenType'] | null;
      /** @default LEFT */
      brain: components['schemas']['Brain'];
      feedback?: components['schemas']['Feedback'] | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** @default MARKDOWN */
      content_type: components['schemas']['ContentType'] | null;
      /**
       * Generation Time
       * @description successful note generation time string in utc timezone, iso8601 format
       */
      generation_time?: string | null;
      /**
       * Has Deducted Quota
       * @description Tracks whether quota has been deducted for this document. Prevents multiple quota deductions on regeneration. Resets on template ID change.
       * @default false
       */
      has_deducted_quota: boolean;
      /** Task Id */
      task_id?: string | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
    };
    /**
     * CreditGrantResult
     * @description One (customer, metric) reconcile outcome, surfaced in the run summary.
     *
     *     ``detail`` carries a short human reason (e.g. why a row was skipped or
     *     failed) so the per-row outcome reads clearly in the Temporal result, the
     *     on-demand HTTP response, and the logs without cross-referencing the code.
     */
    CreditGrantResult: {
      /** User Ref Id */
      user_ref_id: string;
      /** Metric Key */
      metric_key?: string | null;
      status: components['schemas']['CreditGrantStatus'];
      /** Stripe Credit Grant Id */
      stripe_credit_grant_id?: string | null;
      /** Credit Value */
      credit_value?: number | null;
      /** Currency */
      currency?: string | null;
      /** Detail */
      detail?: string | null;
    };
    /**
     * CreditGrantRunSummary
     * @description Aggregate outcome of one ``run`` — the single readable visibility surface
     *     (alongside the Stripe dashboard and Temporal run history; there is no admin
     *     UI).
     *
     *     ``message`` is a human one-line headline (e.g. "Credit-grant reconcile
     *     (scope=user): granted 1, already-granted 0, skipped 0, failed 0 over 1
     *     principal(s)") so the Temporal workflow result and the on-demand response
     *     both lead with a glanceable summary; the counts and ``results`` carry the
     *     detail.
     */
    CreditGrantRunSummary: {
      /**
       * Message
       * @default
       */
      message: string;
      /** Granted */
      granted: number;
      /** Already Granted */
      already_granted: number;
      /** Skipped */
      skipped: number;
      /** Failed */
      failed: number;
      /** Results */
      results: components['schemas']['CreditGrantResult'][];
    };
    /**
     * CreditGrantStatus
     * @description Per-(customer, metric) outcome of a reconcile pass.
     * @enum {string}
     */
    CreditGrantStatus: CreditGrantStatus;
    /** CronFrequency */
    CronFrequency: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: CronFrequencyKind;
      /** Cron Expression */
      cron_expression: string;
    };
    /** CsvUploadRequest */
    CsvUploadRequest: {
      /** Csv Text */
      csv_text: string;
    };
    /** CsvUploadResult */
    CsvUploadResult: {
      /** Patients Created */
      patients_created: number;
      /** Patients Updated */
      patients_updated: number;
      /** Appointments Created */
      appointments_created: number;
      /** Appointments Updated */
      appointments_updated: number;
      /** Errors */
      errors: string[];
      /**
       * Phone Normalization Failures
       * @default 0
       */
      phone_normalization_failures: number;
    };
    /**
     * Currency
     * @description ISO 4217 currency codes for Stripe and other payment processors
     * @enum {string}
     */
    Currency: Currency;
    /** CurrencyOption */
    CurrencyOption: {
      /** Unit Amount */
      unit_amount: number;
      /** Unit Amount Decimal */
      unit_amount_decimal: string;
      currency: components['schemas']['Currency'];
      /** Tax Behavior */
      tax_behavior?: string | null;
    };
    /**
     * CustomCernerSection
     * @description Custom component section using Source Concept CKI.
     *
     *     Format: "CERNER!<UUID>" (e.g., "CERNER!9DDA9196-B37D-4149-84A7-24DA72E27318")
     *
     *     How to Obtain a Source Concept CKI
     *     ----------------------------------
     *     Standard components (like "HPI" for History of Present Illness) use predefined
     *     Cerner codes. However, custom components require obtaining the "Source Concept CKI"
     *     value specific to the clinic's Cerner environment.
     *
     *     **Method 1: componentReference API (requires API connectivity)**
     *
     *     Execute a GET request to the componentReference endpoint:
     *
     *         GET {{baseUrl}}/api/v2/componentReference?viewNames=<ViewName>&layoutTypes=1&includeSettings=true&maxResults=2000
     *
     *     Example for RedRover sandbox:
     *
     *         GET {{baseUrl}}/api/v2/componentReference?viewNames=Workflow - AMB Family Medicine&layoutTypes=1&includeSettings=true&maxResults=2000
     *
     *     In the response, locate the desired component by its `componentName` (e.g.,
     *     "Generic Dynamic Doc 1" in sandbox, or "Generic Dynamic Doc 4" for Chelwest).
     *     The CKI value is found in `setting.display` under "Source Concept CKI".
     *
     *     **Method 2: Cerner Bedrock Tool (requires Cerner system access)**
     *
     *     If API access is not yet available, someone with access to the clinic's Cerner
     *     system can find the Source Concept CKI using the "MPage Setup Wizard" in the
     *     Cerner Bedrock tool.
     *
     *     Notes
     *     -----
     *     - Standard components (AP, HPI, PE, ROS, CC, HC, PI) do not need CKI lookup;
     *       use `StandardCernerSection` with the predefined code instead.
     *     - Each clinic/environment may have different CKI values for the same logical
     *       component, so CKIs must be obtained per-environment.
     */
    CustomCernerSection: {
      /** @default custom */
      section_type: components['schemas']['CernerSectionType'];
      section: components['schemas']['SectionalNoteSection'];
      /** Display Name */
      display_name: string;
      /** Observation Type Code */
      observation_type_code?: string | null;
      /**
       * Codes
       * @default []
       */
      codes: components['schemas']['CernerObservationCode'][];
      /** Source Concept Cki */
      source_concept_cki: string;
    };
    /** CustomStyle */
    CustomStyle: {
      /** @description The level of detail for the note */
      level_of_detail: components['schemas']['LevelOfDetail'];
      /**
       * Bullet Points Preference
       * @description Whether to use bullet points in the note
       * @default false
       */
      bullet_points_preference: boolean;
      /**
       * Patient Quotes Preference
       * @description Whether to include patient quotes in the note
       * @default false
       */
      patient_quotes_preference: boolean;
      /**
       * Abbreviations Preference
       * @description Whether to use abbreviations in the note
       * @default false
       */
      abbreviations_preference: boolean;
    };
    /** CustomisedTemplateRequest */
    CustomisedTemplateRequest: {
      /** Template */
      template: string;
      /** Questions */
      questions: components['schemas']['Question'][];
      /** Summaryrequired */
      summaryRequired: boolean;
      /** Metadata */
      metadata?: string[] | null;
    };
    /** CustomisedTemplateResponse */
    CustomisedTemplateResponse: {
      /** Content */
      content?: string | null;
      /** Questionanswers */
      questionAnswers: components['schemas']['QuestionAnswer'][];
      /** Summary */
      summary?: string | null;
    };
    /**
     * CycleSummary
     * @description One natural metric cycle's rollup numbers for the history endpoint.
     *
     *     Lightweight by design — breakdown[], user_usage/user_limit, and the
     *     static metric-context fields (metric_key, product, etc.) all live on
     *     the wrapper or aren't returned at all. FE drills into a specific
     *     cycle by re-passing this entry's (period_start, period_end) to the
     *     single-target endpoint for the full response with breakdown.
     */
    CycleSummary: {
      /**
       * Period Start
       * Format: date-time
       */
      period_start: string;
      /**
       * Period End
       * Format: date-time
       */
      period_end: string;
      /** Usage */
      usage: number;
      /** Limit */
      limit: number | null;
      /** Remaining */
      remaining: number | null;
      /** Is Over Limit */
      is_over_limit: boolean;
    };
    /** DailyFrequency */
    DailyFrequency: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: DailyFrequencyKind;
    };
    /**
     * DatadogDiagnostics
     * @description Local Datadog SDK state; not an ingest-side delivery guarantee.
     */
    DatadogDiagnostics: {
      /** Configured */
      configured: boolean;
      /** Rum Initialized */
      rum_initialized: boolean;
      /** Logs Initialized */
      logs_initialized: boolean;
      /** Rum Action Queued */
      rum_action_queued: boolean;
      /**
       * Transport Probe
       * @enum {string}
       */
      transport_probe: DatadogDiagnosticsTransport_probe;
    };
    /**
     * DateFormat
     * @enum {string}
     */
    DateFormat: DateFormat;
    /**
     * DateParameterOperator
     * @description FHIR R4 date search parameter prefix operators.
     *
     *     https://hl7.org/fhir/R4/search.html#prefix
     * @enum {string}
     */
    DateParameterOperator: DateParameterOperator;
    /**
     * DateParameterValue
     * @description A parsed FHIR R4 date search parameter.
     *
     *     Contains the structured ``operator`` and ``date`` extracted from a raw
     *     string like ``"eq2013-01-14"``.
     */
    DateParameterValue: {
      operator: components['schemas']['DateParameterOperator'];
      /** Date */
      date: string;
    };
    /**
     * DayOfWeek
     * @description The days of the week.
     *
     *     https://hl7.org/fhir/R4/valueset-days-of-week.html
     * @enum {string}
     */
    DayOfWeek: DayOfWeek;
    /**
     * DaysOfWeek
     * @description The days of the week.
     *
     *     https://hl7.org/fhir/R4/valueset-days-of-week.html
     * @enum {string}
     */
    DaysOfWeek: DaysOfWeek;
    /**
     * DebugEventSeverity
     * @description Severity of a pipeline debug event, mapped to a Python log level.
     * @enum {string}
     */
    DebugEventSeverity: DebugEventSeverity;
    /**
     * DebugEventType
     * @description Categories of diagnostic events emitted by the translator pipeline.
     * @enum {string}
     */
    DebugEventType: DebugEventType;
    /** DefaultLanguageUpdateRequest */
    DefaultLanguageUpdateRequest: {
      default_language_code: components['schemas']['LanguageCode'];
    };
    /** DeidentifiedDataUseSettingsRequest */
    DeidentifiedDataUseSettingsRequest: {
      /** Opt Out De Identified Data Use */
      opt_out_de_identified_data_use: boolean;
      /**
       * Update Time
       * Format: date-time
       */
      update_time?: string;
    };
    /** DeidentifiedDataUseSettingsResponse */
    DeidentifiedDataUseSettingsResponse: {
      /** Opt Out De Identified Data Use */
      opt_out_de_identified_data_use: boolean;
    };
    /** DeleteAccessEntitlementResponse */
    DeleteAccessEntitlementResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
    };
    /** DeleteAskHeidiRequest */
    DeleteAskHeidiRequest: {
      /** User Ref Id */
      user_ref_id: string;
    };
    /** DeleteAskHeidiResponse */
    DeleteAskHeidiResponse: {
      /** Deleted Count */
      deleted_count: number;
      /** Message */
      message: string;
    };
    /** DeleteBlockedNumberView */
    DeleteBlockedNumberView: {
      /** Deleted */
      deleted: boolean;
    };
    /** DeleteCPDRequest */
    DeleteCPDRequest: {
      /** User Ref Id */
      user_ref_id: string;
    };
    /** DeleteCPDResponse */
    DeleteCPDResponse: {
      /** Deleted Count */
      deleted_count: number;
      /** Message */
      message: string;
    };
    /**
     * DeleteConnectionResponse
     * @description Response DTO for delete connection.
     */
    DeleteConnectionResponse: {
      /** Deleted */
      deleted: boolean;
    };
    /**
     * DeleteDraftRequest
     * @description Body for `POST /drafts/{draft_id}:delete`.
     *
     *     Hard-deletes the underlying template-gallery row (frees the
     *     `question_slug` for re-publishing) and flips the local draft to
     *     `deleted`. Only fires from the `unpublished` lifecycle state -
     *     direct `published -> deleted` is not supported because the
     *     irreversibility deserves explicit confirmation via the two-step
     *     Unpublish -> Delete workflow.
     *
     *     `deleted_by` is required for the audit trail; validated as an
     *     email at deserialization time via Pydantic's `EmailStr`.
     */
    DeleteDraftRequest: {
      /**
       * Deleted By
       * Format: email
       */
      deleted_by: string;
    };
    /** DeleteDraftResponse */
    DeleteDraftResponse: {
      /** Draft Id */
      draft_id: string;
      /** Status */
      status: string;
      /** Published Answer Id */
      published_answer_id: string | null;
      /**
       * Message
       * @default Permanently deleted from template-gallery
       */
      message: string;
    };
    /** DeleteEmptySessionsResponse */
    DeleteEmptySessionsResponse: {
      /** Num Deleted */
      num_deleted: number;
    };
    /** DeleteEvidenceRequest */
    DeleteEvidenceRequest: {
      /** User Ref Id */
      user_ref_id: string;
    };
    /** DeleteEvidenceResponse */
    DeleteEvidenceResponse: {
      /** Deleted Count */
      deleted_count: number;
      /** Message */
      message: string;
    };
    /** DeleteExpiredForUserRequest */
    DeleteExpiredForUserRequest: {
      /** Kinde User Id */
      kinde_user_id: string;
      /**
       * Created Before
       * Format: date-time
       * @description Inclusive upper bound on Call.created_at. Offset-bearing values are converted to UTC; a naive value is read as UTC.
       */
      created_before: string;
      /**
       * Limit
       * @description Maximum number of comms sessions to purge in this batch. Server caps at 100.
       */
      limit: number;
    };
    /** DeleteExpiredForUserResponse */
    DeleteExpiredForUserResponse: {
      /** Deleted Count */
      deleted_count: number;
      /** Failed Count */
      failed_count: number;
      /** Has More */
      has_more: boolean;
    };
    /**
     * DeleteIdentityProfileRequest
     * @description Request DTO for deleting an identity profile mapping.
     *
     *     This is intended for internal use (regional ml-scribe → identity broker) when a
     *     user account is deleted and the deleted identity must become non-reusable.
     * @example {
     *       "delete_reason": "user_requested_account_deletion",
     *       "email": "user@example.com"
     *     }
     * @example {
     *       "delete_reason": "user_requested_account_deletion",
     *       "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *     }
     * @example {
     *       "delete_reason": "user_requested_account_deletion",
     *       "email": "user@example.com",
     *       "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *     }
     */
    DeleteIdentityProfileRequest: {
      /**
       * Email
       * @description User email address whose identity mapping should be deleted/retired
       */
      email?: string | null;
      /**
       * User Ref Id
       * @description User reference ID whose identity mapping should be deleted/retired
       */
      user_ref_id?: string | null;
      /**
       * Delete Reason
       * @description Optional deletion reason for audit/diagnostics
       */
      delete_reason?: string | null;
    };
    /**
     * DeleteIdentityProfileResponse
     * @description Wrapper response for delete identity profile endpoint.
     * @example {
     *       "result": {
     *         "auth0_user_deleted": true,
     *         "identity_profile_deleted": true,
     *         "message": "Identity profile deleted and Auth0 user deleted",
     *         "success": true
     *       }
     *     }
     */
    DeleteIdentityProfileResponse: {
      /** @description Deletion outcomes across identity systems */
      result: components['schemas']['DeleteIdentityProfileResult'];
    };
    /**
     * DeleteIdentityProfileResult
     * @description Result payload describing identity deletion outcomes.
     *
     *     This result is designed to be idempotent-friendly:
     *     - If the identity profile mapping does not exist, that outcome is reported
     *       without treating the request as a failure.
     *     - Auth0 deletion may be skipped when not configured or not applicable.
     * @example {
     *       "auth0_user_deleted": true,
     *       "identity_profile_deleted": true,
     *       "message": "Identity profile deleted and Auth0 user deleted",
     *       "success": true
     *     }
     * @example {
     *       "auth0_user_deleted": false,
     *       "identity_profile_deleted": false,
     *       "message": "Identity profile already absent",
     *       "success": true
     *     }
     * @example {
     *       "auth0_user_deleted": false,
     *       "identity_profile_deleted": false,
     *       "message": "Auth0 deletion failed; identity profile retained for retry",
     *       "success": false
     *     }
     */
    DeleteIdentityProfileResult: {
      /**
       * Success
       * @description True if the deletion contract was satisfied; False if partial failure occurred
       */
      success: boolean;
      /**
       * Identity Profile Deleted
       * @description True if an identity profile mapping was deleted; False if it was already absent
       */
      identity_profile_deleted: boolean;
      /**
       * Auth0 User Deleted
       * @description True if an Auth0 user was deleted; False if none existed, deletion was skipped, or failed
       */
      auth0_user_deleted: boolean;
      /**
       * Message
       * @description Optional human-readable message for diagnostics (non-sensitive)
       */
      message?: string | null;
    };
    /** DeleteIntegrationPartnerAdminResponse */
    DeleteIntegrationPartnerAdminResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /** DeleteOpenAPIOrgsRequest */
    DeleteOpenAPIOrgsRequest: {
      /** Api Keys */
      api_keys: string[];
    };
    /** DeletePatientProfilesRequest */
    DeletePatientProfilesRequest: {
      /** Patient Profile Ids */
      patient_profile_ids: string[];
      /**
       * Delete Linked Sessions
       * @default true
       */
      delete_linked_sessions: boolean;
    };
    /**
     * DeletePersonalizationInsightRequest
     * @description Request to delete a single personalization insight.
     */
    DeletePersonalizationInsightRequest: {
      category: components['schemas']['PersonalizationCategory'];
      /** Rule */
      rule: string;
    };
    /** DeleteProfileGroupResponse */
    DeleteProfileGroupResponse: {
      /** Profile Group */
      profile_group: string;
      /** Profiles */
      profiles: components['schemas']['EHRLaunchProfile'][];
    };
    /** DeleteReferralProfileResponse */
    DeleteReferralProfileResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
    };
    /** DeleteRpaRecordingResponse */
    DeleteRpaRecordingResponse: {
      /** Recording Id */
      recording_id: string;
    };
    /** DeleteSessionContextDocumentsRequest */
    DeleteSessionContextDocumentsRequest: {
      /** Ids */
      ids: string[];
    };
    /** DeleteSessionContextDocumentsResponse */
    DeleteSessionContextDocumentsResponse: {
      /** Success */
      success: boolean;
    };
    /** DeleteSessionsChunkRequest */
    DeleteSessionsChunkRequest: {
      /** Session Ids */
      session_ids: string[];
      /** User Ref Id */
      user_ref_id: string;
      /** User Kinde Id */
      user_kinde_id?: string | null;
    };
    /** DeleteSessionsChunkResponse */
    DeleteSessionsChunkResponse: {
      /** Message */
      message: string;
    };
    /** DeleteSnippetResponse */
    DeleteSnippetResponse: {
      /** Success */
      success: boolean;
    };
    /**
     * DeleteSourceListResponse
     * @description Response for source list deletion.
     */
    DeleteSourceListResponse: {
      /** Id */
      id: string;
      /**
       * Deleted At
       * Format: date-time
       */
      deleted_at: string;
    };
    /** DeleteTeamWorkflowResponse */
    DeleteTeamWorkflowResponse: {
      /** Recording Id */
      recording_id: string;
      /**
       * Deleted At
       * Format: date-time
       */
      deleted_at: string;
    };
    /**
     * DeleteUserAccessEntitlementRequest
     * @description Identify which entitlement type to revoke for a user (team-admin web API).
     */
    DeleteUserAccessEntitlementRequest: {
      /**
       * Entitlement Type Id
       * @description ID of the AccessEntitlementType to revoke. If both id and name are sent, id is used to resolve the type.
       */
      entitlement_type_id?: string | null;
      /**
       * Entitlement Type Name
       * @description Unique name of the AccessEntitlementType. Used when entitlement_type_id is omitted or empty.
       */
      entitlement_type_name?: string | null;
    };
    /** DeleteUserRequest */
    DeleteUserRequest: {
      reason?: components['schemas']['UserDeleteReason'] | null;
      /** Details */
      details?: string | null;
    };
    /** DeleteUserResponse */
    DeleteUserResponse: {
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      platforms: components['schemas']['PlatformDeletionStatusResponse'];
      /** Message */
      message: string;
    };
    /** DeliveryPolicy */
    DeliveryPolicy: {
      /** Cooldown Seconds */
      cooldown_seconds?: number | null;
      /**
       * Cooldown Key
       * @default session_id
       */
      cooldown_key: string;
      /** Session Eval Cap */
      session_eval_cap?: number | null;
      /**
       * Failure Behavior
       * @default skip
       * @enum {string}
       */
      failure_behavior: DeliveryPolicyFailure_behavior;
    };
    /**
     * DeriveConfusableResponse
     * @description Suggested confusable near-neighbour protocol_ids for the admin to accept/reject.
     */
    DeriveConfusableResponse: {
      /** Confusable With */
      confusable_with: string[];
    };
    /**
     * DeriveTriggeringCodesResponse
     * @description Grounded triggering-code suggestions (from the coding index) for the admin to accept/trim.
     */
    DeriveTriggeringCodesResponse: {
      /** Triggering Codes */
      triggering_codes: components['schemas']['TriggeringCodeModel'][];
    };
    /** DesktopApp */
    DesktopApp: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: DesktopAppType;
      /** @default Native */
      recording_source: components['schemas']['AppRecordingSource'];
    };
    /** DesktopDictationPostProcessingRequest */
    DesktopDictationPostProcessingRequest: {
      /** Text */
      text: string;
    };
    /**
     * DesktopTargetAssignmentStatus
     * @enum {string}
     */
    DesktopTargetAssignmentStatus: DesktopTargetAssignmentStatus;
    /**
     * DesktopTargetFailureCode
     * @enum {string}
     */
    DesktopTargetFailureCode: DesktopTargetFailureCode;
    /** DesktopTargetListResponse */
    DesktopTargetListResponse: {
      /** Targets */
      targets: components['schemas']['DesktopTargetResponse'][];
    };
    /** DesktopTargetResponse */
    DesktopTargetResponse: {
      /** Target Id */
      target_id: string;
      /** Instance Id */
      instance_id: string;
      /** Display Name */
      display_name: string;
      /** App Version */
      app_version: string;
      capabilities: components['schemas']['ClientCapabilities'];
      /**
       * Last Seen At
       * Format: date-time
       */
      last_seen_at: string;
      /** Is Available */
      is_available: boolean;
    };
    /** DetailedSessionView */
    DetailedSessionView: {
      /** Session Id */
      session_id: string;
      /** Kinde Gp Id */
      kinde_gp_id: string;
      /**
       * Clinician Name
       * @description Full name of the session owner (the user behind kinde_gp_id), not the caller. Empty when the owner has no name on file; null when the owner user cannot be found.
       */
      clinician_name?: string | null;
      /** Session Name */
      session_name?: string | null;
      /** Session Gist */
      session_gist?: string | null;
      patient?: components['schemas']['PatientModel'] | null;
      /** Audio */
      audio?: components['schemas']['AudioResponse'][] | null;
      /** Clinician Notes */
      clinician_notes: string[];
      /**
       * Duration
       * @default 0
       */
      duration: number;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /**
       * Is Consent
       * @default false
       */
      is_consent: boolean | null;
      /**
       * Is Review Modal Confirmed
       * @default false
       */
      is_review_modal_confirmed: boolean;
      language_code?: components['schemas']['LanguageCode'] | null;
      /** Language Code List */
      language_code_list?: components['schemas']['LanguageCode'][] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Documents */
      documents?: components['schemas']['DocumentView'][] | null;
      transcribe_mode?: components['schemas']['TranscribeMode'] | null;
      /** Is Tab Sharing */
      is_tab_sharing?: boolean | null;
      /** Transcript */
      transcript?: string | null;
      /**
       * Transcript Deleted At
       * @description The deletion time once the transcript has been hard-deleted; None otherwise.
       */
      transcript_deleted_at?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /** Is Reviewed */
      is_reviewed?: boolean | null;
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Ehr Appt Contact Id */
      ehr_appt_contact_id?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Encounter Id */
      ehr_encounter_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Is Demo */
      is_demo: boolean;
      /** Is Consumed Quota */
      is_consumed_quota: boolean;
      /** Had Ws Recording Failure */
      had_ws_recording_failure: boolean;
      /** Latest Consult Note Id */
      latest_consult_note_id?: string | null;
      /** Client Customized Qa Template Answer */
      client_customized_qa_template_answer?: string | null;
      /**
       * Do Recording Playback
       * @default false
       */
      do_recording_playback: boolean;
      /** Created Time Local */
      created_time_local?: string | null;
      /** Created Time Local With Offset */
      created_time_local_with_offset?: string | null;
      /** @default EMPTY */
      session_status: components['schemas']['SessionStatus'] | null;
      /**
       * Is Urgent
       * @default false
       */
      is_urgent: boolean;
      patient_profile?: components['schemas']['PatientProfileModel'] | null;
      consult_note: components['schemas']['SimpleConsultNoteView'];
      language: components['schemas']['LanguageView'];
      /** Languages */
      languages: components['schemas']['LanguageView'][];
      /**
       * Generate Output Without Recording
       * @default false
       */
      generate_output_without_recording: boolean | null;
      recording_status?: components['schemas']['RecordingStatus'] | null;
      /** Linked Sessions For Context */
      linked_sessions_for_context?: string[];
      /** Linked Sessions For Context Fallback */
      linked_sessions_for_context_fallback?: boolean | null;
      /** Past Ehr Notes */
      past_ehr_notes?: components['schemas']['EHRNote'][];
      extracted_patient_context?: components['schemas']['PatientContextResponse'] | null;
      /** Used Experimental Transcript */
      used_experimental_transcript?: boolean | null;
      research_metadata?: components['schemas']['SessionResearchMetadata'] | null;
      /** Research Clinician Note */
      research_clinician_note?: string | null;
      patient_profile_appointment_candidates?:
        | components['schemas']['PatientProfileAppointmentCandidates']
        | null;
      /** Creation Platform */
      creation_platform?:
        | (
            | components['schemas']['WebApp']
            | components['schemas']['DesktopApp']
            | components['schemas']['IOSApp']
            | components['schemas']['AndroidApp']
            | components['schemas']['RemoteApp']
          )
        | null;
      patient_link_status?: components['schemas']['PatientLinkStatus'] | null;
      /** @default no_action */
      session_group_status: components['schemas']['SessionGroupStatus'];
      session_merge_group?: components['schemas']['MergeableSessions'];
      /** Needs Resync */
      needs_resync?: boolean | null;
    };
    /** DetectRequestSchema */
    DetectRequestSchema: {
      /** Transcript Chunk */
      transcript_chunk: string;
      /** Visit Summary */
      visit_summary?: string | null;
      /**
       * Is Session End
       * @default false
       */
      is_session_end: boolean;
    };
    /**
     * DetermineLoginRequestDTO
     * @description Request DTO for determining login vendor and screen hint.
     *
     *     Used by frontend clients to determine which identity provider
     *     (Kinde or Auth0) a user should be routed to for authentication,
     *     and whether to show a signin or signup screen.
     *
     *     This is a public API - no authentication required.
     * @example {
     *       "email": "user@example.com"
     *     }
     */
    DetermineLoginRequestDTO: {
      /**
       * Email
       * Format: email
       * @description User email address to determine login routing
       */
      email: string;
    };
    /**
     * DetermineLoginResponseDTO
     * @description Response DTO for determine login endpoint.
     *
     *     Returns the vendor to route the user to and, for non-SSO connections,
     *     a screen hint indicating whether to show signin or signup UI.
     *     SSO/Enterprise connections omit the screen hint as the IdP handles authentication flows.
     * @example {
     *       "authentication_method": "SSO",
     *       "connection": "au-acme-entra",
     *       "vendor": "auth0"
     *     }
     * @example {
     *       "authentication_method": "DB",
     *       "connection": "Username-Password-Authentication",
     *       "screen_hint": "signup",
     *       "vendor": "auth0"
     *     }
     * @example {
     *       "screen_hint": "signin",
     *       "vendor": "kinde"
     *     }
     */
    DetermineLoginResponseDTO: {
      /** @description Identity provider to route user to (kinde or auth0) */
      vendor: components['schemas']['AuthVendor'];
      /** @description UI hint for frontend (signin or signup). Omitted for SSO/Enterprise connections where the IdP handles authentication flows. */
      screen_hint?: components['schemas']['ScreenHint'] | null;
      /** @description Authentication method used for login (SSO or NON_SSO) */
      authentication_method?: components['schemas']['AuthenticationMethod'] | null;
      /**
       * Connection
       * @description Auth0 connection name for IdP redirect. Set to 'Username-Password-Authentication' for DB users, an ent connection for SSO, None to let Auth0 decide
       */
      connection?: string | null;
    };
    /**
     * DeviceOrderStatusItem
     * @description PII-minimized view of a device order for headless consumers (Remote Bot).
     *
     *     Deliberately excludes all raw customer PII (email, name, phone, and full
     *     shipping address). ``region`` is the destination country only — coarse
     *     geography for regional delivery timelines, not an address.
     */
    DeviceOrderStatusItem: {
      /** Order Id */
      order_id: string;
      /** @description Order lifecycle stage (paid, erp_order_shipped, etc.). */
      status: components['schemas']['OrderStatus'];
      /**
       * Erp Order Id
       * @description Lingxing ERP order id once the order is pushed.
       */
      erp_order_id?: string | null;
      /**
       * Region
       * @description Destination country (coarse region), not a full address.
       */
      region?: string | null;
      /**
       * Tracking Number
       * @description Carrier tracking number once shipped.
       */
      tracking_number?: string | null;
      /**
       * Created At
       * Format: date-time
       * @description When the order was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description When the order was last updated.
       */
      updated_at: string;
    };
    /** DeviceOrderStatusLookupResponse */
    DeviceOrderStatusLookupResponse: {
      /** Data */
      data: components['schemas']['DeviceOrderStatusItem'][];
      /**
       * Total
       * @description Total matching orders (may exceed len(data)).
       */
      total: number;
    };
    /**
     * Diagnosis
     * @description A generated diagnosis suggestion.
     */
    Diagnosis: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: DiagnosisType;
      /** Uid */
      uid: string;
      definition: components['schemas']['DiagnosisDefinition'];
      /** Ischronic */
      isChronic?: boolean | null;
      /** Associations */
      associations?: components['schemas']['Association'][] | null;
    };
    /** DiagnosisCode */
    DiagnosisCode: string;
    /**
     * DiagnosisCodeSystem
     * @example 2.16.840.1.113883.6.90
     * @example 2.16.840.1.113883.6.96
     * @example 2.16.840.1.113883.6.94
     * @example 2.16.840.1.113883.6.135
     * @example 2.16.840.1.113883.6.3
     * @example 2.16.840.1.113883.6.3.2
     * @example 2.16.840.1.113883.6.103
     * @example 1.2.246.537.6.31.2007
     */
    DiagnosisCodeSystem: string;
    /**
     * DiagnosisCoding
     * @description Coding with diagnosis codes (ICD-10, SNOMED, etc.).
     */
    DiagnosisCoding: {
      code: components['schemas']['DiagnosisCode'];
      codeSystem?: components['schemas']['DiagnosisCodeSystem'] | null;
      /** Display */
      display?: string | null;
    };
    /**
     * DiagnosisDefinition
     * @description Coded definition for a diagnosis.
     */
    DiagnosisDefinition: {
      /** Coding */
      coding: components['schemas']['DiagnosisCoding'][];
      /** Text */
      text: string;
      /** Genericname */
      genericName?: string | null;
      /** Topic */
      topic?: string | null;
    };
    /**
     * DictationAppCategoriesResponse
     * @description Public catalog response: the merged categories the client resolves against.
     */
    DictationAppCategoriesResponse: {
      /** Categories */
      categories?: components['schemas']['EffectiveDictationCategory'][];
    };
    /** DictationCleanupModeListReponse */
    DictationCleanupModeListReponse: {
      /** Dictation Cleanup Modes */
      dictation_cleanup_modes: components['schemas']['DictationCleanupModeResponse'][];
    };
    /** DictationCleanupModeResponse */
    DictationCleanupModeResponse: {
      mode: components['schemas']['DictationCleanupModes'];
      /** Name */
      name: string;
      /** Title */
      title: string;
      generation_use: components['schemas']['GenerationUse'];
    };
    /**
     * DictationCleanupModes
     * @enum {string}
     */
    DictationCleanupModes: DictationCleanupModes;
    /** DictationContextResponse */
    DictationContextResponse: {
      /** Terms */
      terms: string[];
    };
    /** DictationEnabledSettingsRequest */
    DictationEnabledSettingsRequest: {
      /** Value */
      value?: boolean | null;
    };
    /** DictationEnabledSettingsResponse */
    DictationEnabledSettingsResponse: {
      /**
       * Value
       * @default true
       */
      value: boolean;
      /** Updated At */
      updated_at?: string | null;
    };
    /** DictationPostProcessingResponse */
    DictationPostProcessingResponse: {
      /** Processed */
      processed: string;
    };
    /** DictationSettingsRequest */
    DictationSettingsRequest: {
      /** Input Languages */
      input_languages?: components['schemas']['LanguageCode'][] | null;
      /** Output Languages */
      output_languages?: components['schemas']['LanguageCode'][] | null;
      /**
       * Hotkeys
       * @description Webapp dictation shortcut; ordered list of key names. Send [] to clear.
       */
      hotkeys?: string[] | null;
      /**
       * Mac Hotkeys
       * @description Desktop dictation on macOS shortcut; ordered list of key names. Send [] to clear.
       */
      mac_hotkeys?: string[] | null;
      /**
       * Windows Hotkeys
       * @description Desktop dictation on Windows shortcut; ordered list of key names. Send [] to clear.
       */
      windows_hotkeys?: string[] | null;
      enabled?: components['schemas']['DictationEnabledSettingsRequest'] | null;
      /** Log Dictations Enabled */
      log_dictations_enabled?: boolean | null;
      /** Verbal Commands Enabled */
      verbal_commands_enabled?: boolean | null;
      verbal_commands_language?: components['schemas']['LanguageCode'] | null;
      /** Sound Enabled */
      sound_enabled?: boolean | null;
      /** Cursor Awareness Enabled */
      cursor_awareness_enabled?: boolean | null;
      spelling_preference?: components['schemas']['SpellingPreference'] | null;
    };
    /** DictationSettingsResponse */
    DictationSettingsResponse: {
      /** Input Languages */
      input_languages?: components['schemas']['LanguageCode'][];
      /** Output Languages */
      output_languages?: components['schemas']['LanguageCode'][];
      /**
       * Hotkeys
       * @description Keyboard shortcut for webapp dictation (ordered list of key names).
       */
      hotkeys?: string[];
      /**
       * Mac Hotkeys
       * @description Keyboard shortcut for desktop dictation on macOS (ordered list of key names).
       */
      mac_hotkeys?: string[];
      /**
       * Windows Hotkeys
       * @description Keyboard shortcut for desktop dictation on Windows (ordered list of key names).
       */
      windows_hotkeys?: string[];
      enabled?: components['schemas']['DictationEnabledSettingsResponse'];
      /**
       * Log Dictations Enabled
       * @description Whether dictation audio/transcripts are logged in transcription-service for analytics/QA/user reviewing.
       * @default true
       */
      log_dictations_enabled: boolean;
      /**
       * Verbal Commands Enabled
       * @description Whether verbal commands are enabled during dictation.
       * @default true
       */
      verbal_commands_enabled: boolean;
      /** @description Effective language verbal commands are recognised in during dictation. Null when none of the user's input_languages support verbal commands (English still works as a baseline regardless). */
      verbal_commands_language?: components['schemas']['LanguageCode'] | null;
      /**
       * Sound Enabled
       * @description Whether dictation audio cues (start/stop sounds) play during dictation. Default on; users can mute the cues via the dictation settings toggle.
       * @default true
       */
      sound_enabled: boolean;
      /**
       * Cursor Awareness Enabled
       * @description Whether desktop Dictate cursor awareness is enabled. When disabled, clients stop reading/sending surrounding cursor context for dictation.
       * @default true
       */
      cursor_awareness_enabled: boolean;
      /** @description Dictation spelling (AU/CA/UK/US); null unless output is English. */
      spelling_preference?: components['schemas']['SpellingPreference'] | null;
    };
    /**
     * DictationTone
     * @description Tone of post-processed dictation; mirrors transcription-service. FORMAL is the no-op default.
     * @enum {string}
     */
    DictationTone: DictationTone;
    /** DirectoryListResponse */
    DirectoryListResponse: {
      /**
       * Directories
       * @description Directories visible to internal admins.
       */
      directories: components['schemas']['DirectoryResponse'][];
    };
    /**
     * DirectoryRecipientSearchResultResponse
     * @description API representation of a directory recipient search hit.
     */
    DirectoryRecipientSearchResultResponse: {
      /**
       * Practitioner Display
       * @description Display name of the practitioner.
       */
      practitioner_display: string;
      /**
       * Organization Display
       * @description Display name of the practitioner's organization.
       */
      organization_display?: string | null;
      /**
       * Specialty Display
       * @description Display text of the practitioner's first specialty.
       */
      specialty_display?: string | null;
      /**
       * Location Display
       * @description City and state of the practitioner's first location (e.g. 'Flemington, VIC').
       */
      location_display?: string | null;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: DirectoryRecipientSearchResultResponseType;
      /**
       * Email Address
       * @description Email address for directory-based letter delivery, when supplied.
       */
      email_address?: string | null;
      /**
       * Fax Number
       * @description Normalized E.164 fax number from the directory entry, when supplied. Clients may use this to create a fax recipient from the search hit.
       */
      fax_number?: string | null;
      /**
       * Directory Entry Id
       * @description Persisted directory entry ID for stable recipient identity when PATCHing onto a letter.
       */
      directory_entry_id: string;
    };
    /** DirectoryResponse */
    DirectoryResponse: {
      /**
       * Id
       * @description Directory record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Organization Id
       * @description Organization that owns this directory.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      organization_id: string;
      /**
       * Display Name
       * @description Internal admin-facing display name.
       */
      display_name: string;
      /**
       * Original Filename
       * @description Filename supplied by the uploader.
       */
      original_filename: string | null;
      /**
       * Entry Count
       * @description Number of recipient entries parsed from the CSV.
       */
      entry_count: number;
      /** @description Lifecycle status: DRAFT is uploaded but not searchable, ACTIVE entries are included in recipient search, ARCHIVED is retired. */
      status: components['schemas']['DirectoryStatus'];
      /**
       * Created By
       * @description Internal admin user ID that uploaded the directory.
       */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the directory was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the directory was last updated.
       */
      updated_at: string;
    };
    /**
     * DirectoryStatus
     * @description Lifecycle status for organization recipient directories.
     *
     *     DRAFT directories are uploaded and visible to internal admins but their
     *     entries are not included in recipient search results. ACTIVE directories
     *     have their entries included in recipient search results; an organization
     *     may have zero or many ACTIVE directories simultaneously. ARCHIVED
     *     directories are retired, hidden from default list results, and their
     *     entries are excluded from search.
     * @enum {string}
     */
    DirectoryStatus: DirectoryStatus;
    /** DirectoryUploadResponse */
    DirectoryUploadResponse: {
      /** @description The created directory. */
      directory: components['schemas']['DirectoryResponse'];
      /**
       * Warnings
       * @description Non-fatal data quality warnings from CSV parsing.
       */
      warnings?: components['schemas']['DirectoryWarningResponse'][];
    };
    /** DirectoryWarningResponse */
    DirectoryWarningResponse: {
      /**
       * Row
       * @description 1-based CSV row number where the issue occurred.
       */
      row: number;
      /**
       * Field
       * @description Field name that triggered the warning.
       */
      field: string;
      /**
       * Message
       * @description Human-readable description of the issue.
       */
      message: string;
    };
    /**
     * DispatchConfirmResponse
     * @description ``workflow_id`` is the first started AgentRunWorkflow Temporal id.
     */
    DispatchConfirmResponse: {
      /** Workflow Id */
      workflow_id?: string | null;
    };
    /**
     * DispatchEventRequest
     * @description Shared body for both the preview and confirm dispatch endpoints.
     */
    DispatchEventRequest: {
      event_type: components['schemas']['EventType'];
      /** Payload */
      payload: {
        [key: string]: unknown;
      };
      /** User Id */
      user_id: string;
      /** Team Id */
      team_id?: string | null;
      /** Org Id */
      org_id?: string | null;
      /** Idempotency Key */
      idempotency_key?: string | null;
    };
    /** DispatchPreviewResponse */
    DispatchPreviewResponse: {
      /** Event Type */
      event_type: string;
      /** Rules Evaluated */
      rules_evaluated: number;
      /** Matched Rules */
      matched_rules: components['schemas']['MatchedRulePreview'][];
      /** Unmatched Rules */
      unmatched_rules?: components['schemas']['UnmatchedRulePreview'][];
      /** Payload Validation Errors */
      payload_validation_errors?: string[] | null;
    };
    /** DispatchSessionsBulkDeletedEventRequest */
    DispatchSessionsBulkDeletedEventRequest: {
      /** Session Ids */
      session_ids: string[];
      /** Operator User Id */
      operator_user_id: string;
    };
    /** DocumentAICommandsResponseV2 */
    DocumentAICommandsResponseV2: {
      /**
       * Ai Commands
       * @default []
       */
      ai_commands: components['schemas']['AICommandResponseV2'][];
    };
    /**
     * DocumentExportSuggestionItem
     * @description Export CTA payload for one session document.
     */
    DocumentExportSuggestionItem: {
      /**
       * Document Id
       * @description MongoDB document id string.
       */
      document_id: string;
      /**
       * Headline
       * @description Short banner title. HTML metacharacters are entity-escaped server-side for safe embedding in HTML; clients may still treat the value as plain text.
       */
      headline: string;
      /**
       * Subcopy
       * @description Supporting line for the CTA; escaped the same way as headline.
       */
      subcopy: string;
      /** @description Inferred document purpose category. */
      category: components['schemas']['ExportDocumentCtaCategory'];
    };
    /**
     * DocumentExportSuggestionResponse
     * @description Export CTA for a single document; ``suggestion`` is null when the experiment is off.
     */
    DocumentExportSuggestionResponse: {
      /** @description CTA payload when the experiment is on and the document exists. */
      suggestion?: components['schemas']['DocumentExportSuggestionItem'] | null;
    };
    /**
     * DocumentGenType
     * @enum {string}
     */
    DocumentGenType: DocumentGenType;
    /**
     * DocumentMetadataResponse
     * @description Response model for extracted document metadata.
     */
    DocumentMetadataResponse: {
      /**
       * Title
       * @description Document title
       */
      title?: string | null;
      /**
       * Author
       * @description Document author
       */
      author?: string | null;
      /**
       * Page Count
       * @description Number of pages (PDF and DOCX)
       */
      page_count?: number | null;
      /**
       * Word Count
       * @description Estimated word count
       */
      word_count?: number | null;
      /**
       * Keywords
       * @description Keywords from metadata
       */
      keywords?: string[];
      /**
       * Description
       * @description Subject/description from metadata
       */
      description?: string | null;
      /**
       * Document Created At
       * @description Document creation date from metadata
       */
      document_created_at?: string | null;
      /**
       * Document Modified At
       * @description Document modification date from metadata
       */
      document_modified_at?: string | null;
      /**
       * Source Format
       * @description Original file format
       */
      source_format?: string | null;
      /** @description Text-extraction quality recorded at ingestion (EVI-1625). Absent for documents uploaded before this feature shipped. */
      ocr_quality?: components['schemas']['OcrQualityResponse'] | null;
    };
    /**
     * DocumentPermissions
     * @description Permissions for a specific document.
     */
    DocumentPermissions: {
      /**
       * Document Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      document_id: string;
      /** Permissions */
      permissions: string[];
    };
    /**
     * DocumentReference
     * @description A reference to a document of any kind for any purpose.
     *
     *     Provides metadata about the document so that the document can be discovered
     *     and managed. The scope of a document is any serialized object with a
     *     mime-type, so includes formal patient centric documents (CDA), clinical
     *     notes, scanned paper, and non-patient specific documents like policy text.
     *
     *     https://hl7.org/fhir/R4/documentreference-definitions.html
     */
    DocumentReference: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Master Version Specific Identifier
       * @description Document identifier as assigned by the source of the document. This identifier is specific to this version of the document.
       */
      masterIdentifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * Other identifiers for the document
       * @description Other identifiers associated with the document, including version independent identifiers.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * current | superseded | entered-in-error
       * @description The status of this document reference.
       */
      status: components['schemas']['DocumentReferenceStatus'];
      /**
       * preliminary | final | amended | entered-in-error
       * @description The status of the underlying document.
       */
      docStatus?: components['schemas']['CompositionStatus'] | null;
      /**
       * Kind of document (LOINC if possible)
       * @description Specifies the particular kind of document referenced (e.g. History and Physical, Discharge Summary, Progress Note).
       */
      type?: components['schemas']['CodeableConcept'] | null;
      /**
       * Categorization of document
       * @description A categorization for the type of document referenced - helps for indexing and searching.
       */
      category?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Who/what is the subject of the document
       * @description Who or what the document is about. The document can be about a person, (patient or healthcare practitioner), a device (e.g. a machine) or even a group of subjects.
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * When this document reference was created
       * @description When the document reference was created.
       */
      date?: string | null;
      /**
       * Who and/or what authored the document
       * @description Identifies who is responsible for adding the information to the document.
       */
      author?: components['schemas']['Reference'][] | null;
      /**
       * Who/what authenticated the document
       * @description Which person or organization authenticates that this document is valid.
       */
      authenticator?: components['schemas']['Reference'] | null;
      /**
       * Organization which maintains the document
       * @description Identifies the organization or group who is responsible for ongoing maintenance of and access to the document.
       */
      custodian?: components['schemas']['Reference'] | null;
      /**
       * Relationships to other documents
       * @description Relationships that this document has with other document references that already exist.
       */
      relatesTo?: components['schemas']['DocumentReferenceRelatesTo'][] | null;
      /**
       * Human-readable description
       * @description Human-readable description of the source document.
       */
      description?: string | null;
      /**
       * Document security-tags
       * @description A set of Security-Tag codes specifying the level of privacy/security of the Document.
       */
      securityLabel?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Document referenced
       * @description The document and format referenced. There may be multiple content element repetitions, each with a different format.
       */
      content: components['schemas']['DocumentReferenceContent'][];
      /**
       * Clinical context of document
       * @description The clinical context in which the document was prepared.
       */
      context?: components['schemas']['DocumentReferenceContext'] | null;
    };
    /**
     * DocumentReferenceContent
     * @description Document referenced.
     *
     *     The document and format referenced. There may be multiple content element
     *     repetitions, each with a different format.
     *
     *     https://hl7.org/fhir/R4/documentreference-definitions.html#DocumentReference.content
     */
    DocumentReferenceContent: {
      /**
       * Where to access the document
       * @description The document or URL of the document along with critical metadata to prove content has integrity.
       */
      attachment: components['schemas']['Attachment'];
      /**
       * Format/content rules for the document
       * @description An identifier of the document encoding, structure, and template that the document conforms to beyond the base format indicated in the mimeType.
       */
      format?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding']
        | null;
    };
    /**
     * DocumentReferenceContext
     * @description Clinical context of document.
     *
     *     The clinical context in which the document was prepared.
     *
     *     https://hl7.org/fhir/R4/documentreference-definitions.html#DocumentReference.context
     */
    DocumentReferenceContext: {
      /**
       * Context of the document content
       * @description Describes the clinical encounter or type of care that the document content is associated with.
       */
      encounter?: components['schemas']['Reference'][] | null;
      /**
       * Main clinical acts documented
       * @description This list of codes represents the main clinical acts, such as a colonoscopy or an appendectomy, being documented.
       */
      event?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Time of service that is being documented
       * @description The time period over which the service that is described by the document was provided.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Kind of facility where patient was seen
       * @description The kind of facility where the patient was seen.
       */
      facilityType?: components['schemas']['CodeableConcept'] | null;
      /**
       * Additional details about where the content was created
       * @description This property may convey specifics about the practice setting where the content was created, often reflecting the clinical specialty.
       */
      practiceSetting?: components['schemas']['CodeableConcept'] | null;
      /**
       * Patient demographics from source
       * @description The Patient Information as known when the document was published. May be a reference to a version specific, or contained.
       */
      sourcePatientInfo?: components['schemas']['Reference'] | null;
      /**
       * Related identifiers or resources
       * @description Related identifiers or resources associated with the DocumentReference.
       */
      related?: components['schemas']['Reference'][] | null;
    };
    /**
     * DocumentReferenceRelatesTo
     * @description Relationships to other documents.
     *
     *     Relationships that this document has with other document references that
     *     already exist.
     *
     *     https://hl7.org/fhir/R4/documentreference-definitions.html#DocumentReference.relatesTo
     */
    DocumentReferenceRelatesTo: {
      /**
       * replaces | transforms | signs | appends
       * @description The type of relationship that this document has with another document.
       */
      code: components['schemas']['DocumentReferenceRelatesToCode'];
      /**
       * Target of the relationship
       * @description The target document of this relationship.
       */
      target: components['schemas']['Reference'];
    };
    /**
     * DocumentReferenceRelatesToCode
     * @description The type of relationship between documents.
     *
     *     https://hl7.org/fhir/R4/valueset-document-relationship-type.html
     * @enum {string}
     */
    DocumentReferenceRelatesToCode: DocumentReferenceRelatesToCode;
    /**
     * DocumentReferenceStatus
     * @description The status of the document reference.
     *
     *     https://hl7.org/fhir/R4/valueset-document-reference-status.html
     * @enum {string}
     */
    DocumentReferenceStatus: DocumentReferenceStatus;
    /**
     * DocumentRelationshipType
     * @description The type of relationship between compositions/documents.
     *
     *     Used for ``Composition.relatesTo.code`` (Required binding). Same
     *     valueset as
     *     :class:`~pkg.integrations.fhir.models.document_reference.DocumentReferenceRelatesToCode`
     *     (used for ``DocumentReference.relatesTo.code``); kept as a separate enum
     *     to avoid coupling the two resources' models together.
     *
     *     https://hl7.org/fhir/R4/valueset-document-relationship-type.html
     * @enum {string}
     */
    DocumentRelationshipType: DocumentRelationshipType;
    /**
     * DocumentScope
     * @description Scope of document access.
     * @enum {string}
     */
    DocumentScope: DocumentScope;
    /**
     * DocumentSortBy
     * @enum {string}
     */
    DocumentSortBy: DocumentSortBy;
    /**
     * DocumentTabType
     * @enum {string}
     */
    DocumentTabType: DocumentTabType;
    /** DocumentTemplate */
    DocumentTemplate: {
      /** Document Id */
      document_id: string;
      /** Name */
      name: string;
    };
    /**
     * DocumentType
     * @enum {string}
     */
    DocumentType: DocumentType;
    /** DocumentView */
    DocumentView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /** Creator Kinde Id */
      creator_kinde_id?: string | null;
      /** Index */
      index?: number | null;
      /** @default DOCUMENT */
      document_tab_type: components['schemas']['DocumentTabType'] | null;
      /** Name */
      name?: string | null;
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Question */
      question?: string | null;
      /** Content */
      content?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      generation_type?: components['schemas']['DocumentGenType'] | null;
      /** @default LEFT */
      brain: components['schemas']['Brain'];
      voice_style?: components['schemas']['VoiceStyle'] | null;
      content_type?: components['schemas']['ContentType'] | null;
      /** Generation Time */
      generation_time?: string | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
    };
    /**
     * DocumentedLDAInstance
     * @description An LDA instance with feedback about what was filed.
     */
    DocumentedLDAInstance: {
      /** Voiceldainstanceid */
      voiceLdaInstanceId?: string | null;
      /** Ldainstanceid */
      ldaInstanceId?: string | null;
      /** Proxyldainstanceid */
      proxyLdaInstanceId?: string | null;
      /** Ldagroupid */
      ldaGroupId?:
        | components['schemas']['dataclass__nebula_session__models__IDType'][]
        | null;
      /** Observations */
      observations?: components['schemas']['FlowsheetRow'][] | null;
      /** Valuesaccepted */
      valuesAccepted?: string | null;
      /** Discarded */
      discarded?: boolean | null;
      /** Discardedat */
      discardedAt?: string | null;
    };
    /**
     * DomainCheckResult
     * @description Outcome of probing a single API domain during a status check.
     */
    DomainCheckResult: {
      /**
       * Url
       * @description Full URL that was probed (GET request).
       */
      url: string;
      /**
       * Ok
       * @description Whether the domain responded with a 2xx status.
       */
      ok: boolean;
      /**
       * Status
       * @description HTTP status code returned, if the request completed.
       */
      status?: number | null;
      /**
       * Error
       * @description Error message when the request failed (e.g. timeout, network error).
       */
      error?: string | null;
    };
    /**
     * DomainResource
     * @description A resource that includes narrative, extensions, and contained resources.
     *
     *     https://hl7.org/fhir/R4/domainresource-definitions.html
     */
    DomainResource: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
    };
    /**
     * Dosage
     * @description How the medication is/was taken or should be taken.
     *
     *     https://hl7.org/fhir/R4/dosage-definitions.html#Dosage
     */
    Dosage: {
      /**
       * The order of the dosage instructions
       * @description Indicates the order in which the dosage instructions should be applied or interpreted.
       */
      sequence?: number | null;
      /**
       * Free text dosage instructions e.g. SIG
       * @description Free text dosage instructions e.g. SIG.
       */
      text?: string | null;
      /**
       * Supplemental instruction or warnings to the patient
       * @description Supplemental instructions to the patient on how to take the medication (e.g. 'with meals' or 'may cause drowsiness') or warnings about hazardous side effects.
       */
      additionalInstruction?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Patient or consumer oriented instructions
       * @description Instructions in terms that are understood by the patient or consumer.
       */
      patientInstruction?: string | null;
      /**
       * When medication should be administered
       * @description When medication should be administered.
       */
      timing?: components['schemas']['Timing'] | null;
      /**
       * Take "as needed" (for x)
       * @description Indicates whether the Medication is only taken when needed, within a specific dosing schedule.
       */
      asNeededBoolean?: boolean | null;
      /**
       * Take "as needed" (for x)
       * @description Indicates whether the Medication is only taken when needed, within a specific dosing schedule.
       */
      asNeededCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Body site to administer to
       * @description Body site to administer to.
       */
      site?: components['schemas']['CodeableConcept'] | null;
      /**
       * How drug should enter body
       * @description How drug should enter body.
       */
      route?: components['schemas']['CodeableConcept'] | null;
      /**
       * Technique for administering medication
       * @description Technique for administering medication.
       */
      method?: components['schemas']['CodeableConcept'] | null;
      /**
       * Amount of medication administered
       * @description The amount of medication administered.
       */
      doseAndRate?: components['schemas']['DoseAndRate'][] | null;
      /**
       * Upper limit on medication per unit of time
       * @description Upper limit on medication per unit of time.
       */
      maxDosePerPeriod?: components['schemas']['Ratio'] | null;
      /**
       * Upper limit on medication per administration
       * @description Upper limit on medication per administration.
       */
      maxDosePerAdministration?: components['schemas']['Quantity'] | null;
      /**
       * Upper limit on medication per lifetime of the patient
       * @description Upper limit on medication per lifetime of the patient.
       */
      maxDosePerLifetime?: components['schemas']['Quantity'] | null;
    };
    /**
     * DoseAndRate
     * @description Amount of medication administered.
     *
     *     https://hl7.org/fhir/R4/dosage-definitions.html#Dosage.doseAndRate
     */
    DoseAndRate: {
      /**
       * The kind of dose or rate specified
       * @description The kind of dose or rate specified, for example, ordered or calculated.
       */
      type?: components['schemas']['CodeableConcept'] | null;
      /**
       * Amount of medication per dose
       * @description Amount of medication per dose.
       */
      doseRange?: components['schemas']['Range'] | null;
      /**
       * Amount of medication per dose
       * @description Amount of medication per dose.
       */
      doseQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Amount of medication per unit of time
       * @description Amount of medication per unit of time.
       */
      rateRatio?: components['schemas']['Ratio'] | null;
      /**
       * Amount of medication per unit of time
       * @description Amount of medication per unit of time.
       */
      rateRange?: components['schemas']['Range'] | null;
      /**
       * Amount of medication per unit of time
       * @description Amount of medication per unit of time.
       */
      rateQuantity?: components['schemas']['Quantity'] | null;
    };
    /** DraftDetailResponse */
    DraftDetailResponse: {
      /** Id */
      id: string;
      /** Batch Id */
      batch_id: string;
      /** Set Name */
      set_name: string | null;
      /** Question */
      question: string;
      /** Category */
      category: string | null;
      /** Topic */
      topic: string | null;
      /** Priority */
      priority: string | null;
      /** Suggested Validator Name */
      suggested_validator_name?: string | null;
      /** Suggested Validator Specialty */
      suggested_validator_specialty?: string | null;
      /** Suggested Validator Credentials */
      suggested_validator_credentials?: string | null;
      /** Status */
      status: string;
      /** Failure Reason */
      failure_reason: string | null;
      /** Raw Content */
      raw_content: string | null;
      /** Edited Content */
      edited_content: string | null;
      /** Verifications */
      verifications: {
        [key: string]: unknown;
      }[];
      /** Quality Assessment */
      quality_assessment: {
        [key: string]: unknown;
      } | null;
      /** Verdict Summary */
      verdict_summary: {
        [key: string]: unknown;
      } | null;
      /** Sources */
      sources: {
        [key: string]: unknown;
      }[];
      /** Evidence Chat Id */
      evidence_chat_id: string | null;
      /** General Comment */
      general_comment: string | null;
      /** Global Signoff */
      global_signoff: boolean;
      /** Reviewed By */
      reviewed_by: string | null;
      /** Reviewed At */
      reviewed_at: string | null;
      /** Assigned Reviewer Emails */
      assigned_reviewer_emails?: string[];
      /** Published At */
      published_at: string | null;
      /** Published Answer Id */
      published_answer_id: string | null;
      /** Unpublished At */
      unpublished_at?: string | null;
      /** Unpublished By */
      unpublished_by?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      /** Deleted By */
      deleted_by?: string | null;
      /** Rejected At */
      rejected_at?: string | null;
      /** Rejected By */
      rejected_by?: string | null;
      /** Rejection Reason */
      rejection_reason?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** DraftListResponse */
    DraftListResponse: {
      /** Items */
      items: components['schemas']['DraftSummaryResponse'][];
    };
    /** DraftSummaryResponse */
    DraftSummaryResponse: {
      /** Id */
      id: string;
      /** Batch Id */
      batch_id: string;
      /** Question */
      question: string;
      /** Category */
      category: string | null;
      /** Topic */
      topic: string | null;
      /** Priority */
      priority: string | null;
      /** Suggested Validator Name */
      suggested_validator_name?: string | null;
      /** Suggested Validator Specialty */
      suggested_validator_specialty?: string | null;
      /** Suggested Validator Credentials */
      suggested_validator_credentials?: string | null;
      /** Status */
      status: string;
      /** Quality Score */
      quality_score?: number | null;
      /** Quality Label */
      quality_label?: string | null;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Rejection Reason */
      rejection_reason?: string | null;
      /** Assigned Reviewer Emails */
      assigned_reviewer_emails?: string[];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** DuplicateCheckRequest */
    DuplicateCheckRequest: {
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
    };
    /** DuplicateCheckResponse */
    DuplicateCheckResponse: {
      /** Duplicates */
      duplicates: components['schemas']['DuplicateTicket'][];
    };
    /**
     * DuplicateTicket
     * @description A potentially duplicate Linear issue surfaced before submission.
     */
    DuplicateTicket: {
      /** Id */
      id: string;
      /** Identifier */
      identifier: string;
      /** Title */
      title: string;
      /** Status */
      status?: string | null;
      /** Team */
      team?: string | null;
      /** Assignee */
      assignee?: string | null;
      /** Description */
      description?: string | null;
      /** Url */
      url?: string | null;
      /** Similarity Hint */
      similarity_hint?: string | null;
    };
    /**
     * Duration
     * @description A length of time.
     *
     *     Duration is a constrained Quantity where the code must be a UCUM time
     *     unit (s, min, h, d, wk, mo, a).
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Duration
     */
    Duration: {
      /**
       * Numerical value (with implicit precision)
       * @description The value of the measured amount. The value includes an implicit precision in the presentation of the value.
       */
      value?: number | null;
      /**
       * < | <= | >= | > - how to understand the value
       * @description How the value should be understood and represented - whether the actual value is greater or less than the stated value due to measurement issues; e.g. if the comparator is '<', then the real value is < stated value.
       */
      comparator?: string | null;
      /**
       * Unit representation
       * @description A human-readable form of the unit.
       */
      unit?: string | null;
      /**
       * System that defines coded unit form
       * @description The identification of the system that provides the coded form of the unit.
       */
      system?: string | null;
      /**
       * Coded form of the unit
       * @description A computer processable form of the unit in some unit representation system.
       */
      code?: string | null;
    };
    /** EHRAppointment */
    EHRAppointment: {
      /** Record Id */
      record_id: string;
      /** Patient Id */
      patient_id: string;
      /** User Id */
      user_id: string;
      /** Location Id */
      location_id?: string | null;
      /** Appointment Time */
      appointment_time: number;
      /** Appointment Date */
      appointment_date?: string | null;
      /** Appointment Length */
      appointment_length?: number | null;
      /** Appointment Date Time */
      appointment_date_time?: string | null;
      /** Patient Dob */
      patient_dob?: string | null;
      /** Patient Sex Code */
      patient_sex_code?: number | null;
      /** Patient First Name */
      patient_first_name?: string | null;
      /** Patient Last Name */
      patient_last_name?: string | null;
      /** Session Id */
      session_id?: string | null;
    };
    /**
     * EHRAppointmentType
     * @description Model representing an EHR appointment type.
     */
    EHRAppointmentType: {
      /** Ehr Id */
      ehr_id: string;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      /** Duration In Minutes */
      duration_in_minutes?: number | null;
      /** Additional Info */
      additional_info?: string | null;
      /**
       * Enabled
       * @default true
       */
      enabled: boolean;
      /**
       * Clinicians
       * @default []
       */
      clinicians: components['schemas']['EHRClinician'][];
    };
    /**
     * EHRAppointmentTypesResponse
     * @description Response model for EHR appointment types.
     */
    EHRAppointmentTypesResponse: {
      /** Appointment Types */
      appointment_types: components['schemas']['EHRAppointmentType'][];
      /**
       * Total Count
       * @default 0
       */
      total_count: number;
      /** Last Updated */
      last_updated?: string | null;
    };
    /**
     * EHRClinic
     * @description Model representing an EHR clinic.
     */
    EHRClinic: {
      /** Ehr Id */
      ehr_id: string;
      /** Name */
      name: string;
      /** Address */
      address?: string | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Email Override */
      email_override?: string | null;
      /** Effective Email */
      effective_email?: string | null;
      /** Timezone */
      timezone?: string | null;
      /** Additional Info */
      additional_info?: string | null;
      /**
       * Enabled
       * @default true
       */
      enabled: boolean;
      /** Business Hours Config */
      business_hours_config?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * EHRClinician
     * @description Model representing an EHR clinician.
     */
    EHRClinician: {
      /** Ehr Id */
      ehr_id: string;
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /**
       * Specialty
       * @default
       */
      specialty: string;
      /** Gender */
      gender?: string | null;
      /** Additional Info */
      additional_info?: string | null;
      /**
       * Enabled
       * @default true
       */
      enabled: boolean;
      /**
       * Appointment Types
       * @default []
       */
      appointment_types: components['schemas']['EHRAppointmentType'][];
      /**
       * Availabilities
       * @default []
       */
      availabilities: components['schemas']['ClinicianAvailabilities'][];
    };
    /**
     * EHRCliniciansResponse
     * @description Response model for EHR clinicians.
     */
    EHRCliniciansResponse: {
      /** Clinicians */
      clinicians: components['schemas']['EHRClinician'][];
      /**
       * Total Count
       * @default 0
       */
      total_count: number;
      /** Last Updated */
      last_updated?: string | null;
    };
    /**
     * EHRClinicsResponse
     * @description Response model for EHR clinics.
     */
    EHRClinicsResponse: {
      /** Clinics */
      clinics: components['schemas']['EHRClinic'][];
      /**
       * Total Count
       * @default 0
       */
      total_count: number;
      /** Last Updated */
      last_updated?: string | null;
    };
    /**
     * EHRCredentialsRequest
     * @description Request model for creating EHR credentials.
     */
    EHRCredentialsRequest: {
      /**
       * Provider
       * @description EHR provider type (e.g., 'cliniko', 'Nookal', 'Halaxy')
       */
      provider: string;
      /**
       * Api Key
       * @description API key for the EHR system
       */
      api_key?: string | null;
      /**
       * Base Url
       * @description Base URL for the EHR API
       */
      base_url: string;
      /**
       * Practice Id
       * @description Practice id for the EHR system
       */
      practice_id?: string | null;
      /**
       * Client Id
       * @description OAuth client id (e.g. Halaxy)
       */
      client_id?: string | null;
      /**
       * Client Secret
       * @description OAuth client secret (e.g. Halaxy)
       */
      client_secret?: string | null;
    };
    /**
     * EHRCredentialsResponse
     * @description Response model for EHR credentials operations.
     */
    EHRCredentialsResponse: {
      /** Id */
      id: string | null;
      /** Provider */
      provider: string | null;
      /** Practice Id */
      practice_id: string | null;
      /** Base Url */
      base_url: string | null;
    };
    /**
     * EHRIntegrationStatus
     * @description Lifecycle state for EHR connectivity on a per-agent basis.
     * @enum {string}
     */
    EHRIntegrationStatus: EHRIntegrationStatus;
    /** EHRLaunchAccessTokenDetails */
    EHRLaunchAccessTokenDetails: {
      /** Access Token */
      access_token: string;
      /** Patient Identifier */
      patient_identifier?: string | null;
      /** Appointment Id */
      appointment_id?: string | null;
      /** Encounter Id */
      encounter_id?: string | null;
      /** Expires In */
      expires_in?: number | null;
      /** Id Token */
      id_token?: string | null;
    };
    /**
     * EHRLaunchApp
     * @enum {string}
     */
    EHRLaunchApp: EHRLaunchApp;
    /**
     * EHRLaunchProfile
     * @description EHR launch profile to store configuration for auth adaptors and data communication adaptors.
     */
    EHRLaunchProfile: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      ehr_provider: components['schemas']['EHRProvider'];
      /** Profile Name */
      profile_name: string;
      /** Profile Group */
      profile_group?: string | null;
      /** Iss */
      iss?: string | null;
      /** Authorization Endpoint */
      authorization_endpoint: string;
      /** Token Endpoint */
      token_endpoint: string;
      /** Refresh Token Endpoint */
      refresh_token_endpoint?: string | null;
      ehrlaunch_app?: components['schemas']['EHRLaunchApp'] | null;
      /** Base Url */
      base_url: string;
      /** Client Id */
      client_id: string;
      /** Client Secret */
      client_secret: string;
      /** Password */
      password?: string | null;
      /** Jwks Uri */
      jwks_uri?: string | null;
      /** Issuer */
      issuer?: string | null;
      /** Connection Id */
      connection_id?: string | null;
      /** Scope */
      scope?: string | null;
      /** Callback Url */
      callback_url?: string | null;
      additional_details?: components['schemas']['AdditionalDetailsType'];
      timezone?: components['schemas']['TimeZones'] | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
    };
    /** EHRLaunchProfileDeleteResponse */
    EHRLaunchProfileDeleteResponse: {
      profile: components['schemas']['EHRLaunchProfile'];
      /**
       * Deleted At
       * Format: date-time
       */
      deleted_at: string;
    };
    /** EHRLaunchProfileListResponse */
    EHRLaunchProfileListResponse: {
      /** Profiles */
      profiles: components['schemas']['EHRLaunchProfile'][];
    };
    /** EHRLaunchProfileResponse */
    EHRLaunchProfileResponse: {
      profile: components['schemas']['EHRLaunchProfile'];
    };
    /** EHRNote */
    EHRNote: {
      /** Binary Id */
      binary_id: string;
      /** Note Content */
      note_content?: string | null;
      /** Note Type Display */
      note_type_display?: string | null;
      /** Encounter Time */
      encounter_time?: string | null;
      /** Author */
      author?: string | null;
      /** Specialty */
      specialty?: string | null;
    };
    /**
     * EHRProfile
     * @description user's profile to store ehr configuration. also contains some clinic config
     */
    EHRProfile: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** User Ref Id */
      user_ref_id?: string | null;
      /** Kinde User Id */
      kinde_user_id: string;
      ehr_provider: components['schemas']['EHRProvider'];
      /** Ehr User Id */
      ehr_user_id?: string | null;
      /** Ehr Clinic Name */
      ehr_clinic_name?: string | null;
      /** Halo Guid */
      halo_guid?: string | null;
      /** Api Key */
      api_key?: string | null;
      timezone?: components['schemas']['TimeZones'] | null;
      /** Clinic Id */
      clinic_id?: string | null;
      /** Username */
      username?: string | null;
      /** Password */
      password?: string | null;
      /** Unity Base Url */
      unity_base_url?: string | null;
      /** Ubiquity Id */
      ubiquity_id?: string | null;
      /** Is Precharting Enabled */
      is_precharting_enabled?: boolean | null;
      /** Repair Required At */
      repair_required_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
      /** Ehr Migrated At */
      ehr_migrated_at?: string | null;
    };
    /** EHRProfileResponse */
    EHRProfileResponse: {
      ehr_profile: components['schemas']['EHRProfile'] | null;
    };
    /**
     * EHRProvider
     * @enum {string}
     */
    EHRProvider: EHRProvider;
    /** EditEvent */
    EditEvent: {
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Consult Note Id */
      consult_note_id: string;
      /** User Name */
      user_name?: string | null;
      /** Template Name */
      template_name?: string | null;
      /**
       * Type
       * @default edit
       * @constant
       */
      type: 'edit';
      /** Edit Id */
      edit_id: string;
      /** Patches */
      patches: string;
      /** Edit Index Within Note */
      edit_index_within_note: number;
      /** @default manual */
      source: components['schemas']['EditSource'];
    };
    /** EditOrderRequest */
    EditOrderRequest: {
      shipping?: components['schemas']['EditOrderShippingDetails'] | null;
      /** Buyer Email */
      buyer_email?: string | null;
      /**
       * Serial Numbers
       * @description Serials of the units this order ships. Send an array; a raw string is also accepted and split on commas/newlines. Entries are trimmed, blanks and duplicates dropped, order and case preserved. Omit (or send null) to leave the stored serials unchanged; send [] to clear them.
       */
      serial_numbers?: string[] | null;
    };
    /** EditOrderResponse */
    EditOrderResponse: {
      /** Order Id */
      order_id: string;
      status: components['schemas']['OrderStatus'];
      shipping?: components['schemas']['EditOrderShippingDetails'] | null;
      /** Shipping Edited By */
      shipping_edited_by?: string | null;
      /** Shipping Edited At */
      shipping_edited_at?: string | null;
      /** Buyer Email */
      buyer_email?: string | null;
      /** Buyer Email Overridden By */
      buyer_email_overridden_by?: string | null;
      /** Buyer Email Overridden At */
      buyer_email_overridden_at?: string | null;
      /** Serial Numbers */
      serial_numbers?: string[];
      /** Serial Numbers Updated By */
      serial_numbers_updated_by?: string | null;
      /** Serial Numbers Updated At */
      serial_numbers_updated_at?: string | null;
      erp_push: components['schemas']['ErpPushResult'];
    };
    /** EditOrderShippingDetails */
    EditOrderShippingDetails: {
      /** Contact Name */
      contact_name?: string | null;
      /** Contact Email */
      contact_email?: string | null;
      /** Contact Phone */
      contact_phone?: string | null;
      /** Street Address */
      street_address?: string | null;
      /** City */
      city?: string | null;
      /** State */
      state?: string | null;
      /** Postcode */
      postcode?: string | null;
      /** Country */
      country?: string | null;
    };
    /**
     * EditOutlineChatMessage
     * @description One turn of the AI-edit conversation. ``role`` is the author; ``content`` the message.
     */
    EditOutlineChatMessage: {
      /**
       * Role
       * @enum {string}
       */
      role: EditOutlineChatMessageRole;
      /** Content */
      content: string;
    };
    /**
     * EditOutlineRequest
     * @description A conversational edit of a protocol's outline. The model rewrites the outline text per the
     *     conversation and returns the whole thing; the client then feeds it through ``:parse-outline``
     *     (preview) and the update endpoint (draft-only save), so id-prefixing, structure, and every
     *     non-content field are preserved by that existing pipeline. ``current_outline`` may be empty
     *     for a brand-new protocol.
     */
    EditOutlineRequest: {
      /**
       * Current Outline
       * @default
       */
      current_outline: string;
      /** Messages */
      messages: components['schemas']['EditOutlineChatMessage'][];
    };
    /**
     * EditOutlineResponse
     * @description The full updated outline text, for the editor to preview + save.
     */
    EditOutlineResponse: {
      /** Outline */
      outline: string;
    };
    /** EditPrechartInstructionsRequest */
    EditPrechartInstructionsRequest: {
      /** Rules Text */
      rules_text: string;
      /** User Message */
      user_message: string;
    };
    /** EditPrechartInstructionsResponse */
    EditPrechartInstructionsResponse: {
      /** Rules Text */
      rules_text: string;
      /** Suggested Actions */
      suggested_actions?: string[];
    };
    /**
     * EditSource
     * @enum {string}
     */
    EditSource: EditSource;
    /**
     * EditTemplatePublicRequest
     * @description Request for unauthenticated template editing during onboarding.
     */
    EditTemplatePublicRequest: {
      /**
       * Existing Template
       * @description Current template structure to edit
       */
      existing_template: string;
      /**
       * Edit Request
       * @description User's change request (e.g., 'Make history section longer')
       */
      edit_request: string;
      /** Specialty Name */
      specialty_name?: string | null;
      /** Country */
      country?: string | null;
      /** Language */
      language?: string | null;
    };
    /**
     * EditTemplatePublicResponse
     * @description Response for unauthenticated template editing.
     */
    EditTemplatePublicResponse: {
      /** Template Structure */
      template_structure: string;
    };
    /**
     * EffectiveDictationCategory
     * @description Merged, client-facing category: catalog ∪ user-added identifiers, with both the
     *     catalog's ``default_tone`` and the resolved ``tone`` (user override or the default).
     */
    EffectiveDictationCategory: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** App Identifiers */
      app_identifiers?: string[];
      /** @default formal */
      default_tone: components['schemas']['DictationTone'];
      /** @default formal */
      tone: components['schemas']['DictationTone'];
    };
    /**
     * EffectivePinnedQuerySchema
     * @description Schema for an effective pinned query (includes defaults + custom).
     */
    EffectivePinnedQuerySchema: {
      /**
       * Id
       * @description Unique identifier for the pinned query
       */
      id: string;
      /**
       * Label
       * @description Short display label for the chip
       */
      label: string;
      /**
       * Query
       * @description Full query to send to Evidence
       */
      query: string;
      /**
       * Description
       * @description Optional longer description (user shortcuts only; null for system defaults)
       */
      description?: string | null;
      /** @description Category (only for default pins) */
      category?: components['schemas']['SuggestedChipCategory'] | null;
      /**
       * Show Phases
       * @description When this chip should be shown (before_session, in_session, after_session)
       */
      show_phases?: components['schemas']['ChipShowPhase'][];
      /**
       * Is Default
       * @description True if this is a system default, False if user-created
       */
      is_default: boolean;
      /**
       * Team Shortcut Id
       * @description Team shortcut id backing this pin when it is team-managed.
       */
      team_shortcut_id?: string | null;
      /**
       * Origin
       * @description Origin bucket: 'default' (Heidi preset), 'library' (installed from marketplace, incl. team shortcuts), 'custom' (user-authored). Always forced to 'default' when is_default is True.
       * @default custom
       * @enum {string}
       */
      origin: EffectivePinnedQuerySchemaOrigin;
    };
    /**
     * EffectiveSessionTimeout
     * @description Resolver output attached to the `/me` response.
     *
     *     `source` distinguishes which layer provided the value:
     *     - `ORGANIZATION`: an org-level override; `is_editable_by_user` is False.
     *     - `USER`: the user's own override; editable.
     *     - `COHORT_DEFAULT`: the Flagsmith payload default (or the hardcoded fallback).
     *     - `OPT_IN_AVAILABLE`: in cohort but the Flagsmith payload's
     *       `enforce_default` is false AND the user has no explicit state. The
     *       user sees the settings UI but no enforcement happens. `minutes`
     *       is `None`. Saving a value transitions to `source=USER`.
     *     - `USER_DISABLED`: the user has explicitly opted out via the
     *       `DELETE /user/session-timeout` endpoint. Sticky across tier changes
     *       until the user re-enables by setting a value (which transitions to
     *       `source=USER`). An org override wins over this state.
     *
     *     `minutes` is `None` only for `OPT_IN_AVAILABLE` and `USER_DISABLED`
     *     (the two not-enforced sources). All other sources carry a positive
     *     integer within `[1, 720]`.
     */
    EffectiveSessionTimeout: {
      /** Minutes */
      minutes: number | null;
      /**
       * Source
       * @enum {string}
       */
      source: EffectiveSessionTimeoutSource;
      /** Is Editable By User */
      is_editable_by_user: boolean;
    };
    /**
     * EhrLink
     * @description The matched profile's link to a live EHR, for the caller's push handoff.
     *
     *     ``provider_unique_identifier`` is the EHR-native patient id (e.g. the Hero /
     *     EMIS patient id) the caller pushes documents/codes against. Populated by the
     *     service layer on the confident ``match`` only — never on ``candidates`` — and
     *     only when the caller names an ``active_provider``.
     */
    EhrLink: {
      /** Provider */
      provider: string;
      /** Provider Unique Identifier */
      provider_unique_identifier: string;
    };
    /** EligibleCountResponse */
    EligibleCountResponse: {
      /** Eligiblecount */
      eligibleCount: number;
    };
    /** EmCodeDetail */
    EmCodeDetail: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
    };
    /** EmCodeOption */
    EmCodeOption: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Patient Type */
      patient_type: string;
      /** Min Time Minutes */
      min_time_minutes: number;
      /** Max Time Minutes */
      max_time_minutes?: number | null;
    };
    /**
     * EmDeterminationMethod
     * @enum {string}
     */
    EmDeterminationMethod: EmDeterminationMethod;
    /** EmMdmElement */
    EmMdmElement: {
      complexity_level: components['schemas']['MdmComplexityLevel'];
      /** References */
      references: string[];
      /** Classification */
      classification?: string | null;
    };
    /** EmMdmElementResponse */
    EmMdmElementResponse: {
      /** Level */
      level: string;
      /** Classification */
      classification?: string | null;
      /** Supporting Evidence */
      supporting_evidence: string[];
    };
    /** EmMdmResponse */
    EmMdmResponse: {
      /** Level */
      level?: string | null;
      problem: components['schemas']['EmMdmElementResponse'];
      data: components['schemas']['EmMdmElementResponse'];
      risk: components['schemas']['EmMdmElementResponse'];
      /** Modifier */
      modifier?: EmMdmResponseModifierAnyOf0 | null;
    };
    /**
     * EmPatientType
     * @enum {string}
     */
    EmPatientType: EmPatientType;
    /** EmailBanCreateRequest */
    EmailBanCreateRequest: {
      /**
       * Email
       * Format: email
       * @description Email address to block
       */
      email: string;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /** EmailBanListResponse */
    EmailBanListResponse: {
      /** Bans */
      bans: components['schemas']['EmailBanRecord'][];
    };
    /** EmailBanLookupMatch */
    EmailBanLookupMatch: {
      /** Email */
      email?: string | null;
      /** Full Name */
      full_name?: string | null;
      /** Country */
      country?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      /** Billing Plan */
      billing_plan?: string | null;
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
    };
    /** EmailBanLookupResponse */
    EmailBanLookupResponse: {
      /** Email */
      email: string;
      /** Match Count */
      match_count: number;
      /** Matches */
      matches: components['schemas']['EmailBanLookupMatch'][];
    };
    /** EmailBanRecord */
    EmailBanRecord: {
      /** Email */
      email: string;
      /** Reason */
      reason: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Full Name */
      full_name?: string | null;
    };
    /** EmailBanRevokeRequest */
    EmailBanRevokeRequest: {
      /**
       * Email
       * Format: email
       * @description Email address to unblock
       */
      email: string;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /**
     * EmailPreviewResponseBody
     * @description FE-shaped preview of the patient email — keep in sync with
     *     ``PatientSummaryEmailPreviewResponse`` in
     *     ``scribe-fe-v2/src/types/patient-summary.types.ts``.
     *
     *     ``body_text`` is the localised plain-text body the FE renders read-only;
     *     ``link_placeholder`` is the token inside it the FE turns into the clickable
     *     "Open document" preview link. The backend is the single source of truth for
     *     this copy — the same renderers produce the actually-sent email.
     */
    EmailPreviewResponseBody: {
      /** Subject */
      subject: string;
      /** Body Text */
      body_text: string;
      /** Link Placeholder */
      link_placeholder: string;
    };
    /**
     * Encounter
     * @description An interaction during which services are provided to the patient.
     *
     *     https://hl7.org/fhir/R4/encounter-definitions.html
     */
    Encounter: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Identifier(s) by which this encounter is known
       * @description Identifier(s) by which this encounter is known.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * planned | arrived | triaged | in-progress | onleave | finished | cancelled | entered-in-error | unknown
       * @description Current state of the encounter.
       */
      status: components['schemas']['EncounterStatus'];
      /**
       * List of past encounter statuses
       * @description The status history permits the encounter resource to contain the status history without needing to read through the historical versions of the resource, or even have the server store them.
       */
      statusHistory?: components['schemas']['EncounterStatusHistory'][] | null;
      /**
       * Classification of patient encounter
       * @description Concepts representing classification of patient encounter such as ambulatory (outpatient), inpatient, emergency, home health or others due to local variations.
       */
      class: components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding'];
      /**
       * List of past encounter classes
       * @description The class history permits the tracking of the encounters transitions without needing to go through the resource history.
       */
      classHistory?: components['schemas']['EncounterClassHistory'][] | null;
      /**
       * Specific type of encounter
       * @description Specific type of encounter (e.g. e-mail consultation, surgical day-care, skilled nursing, rehabilitation).
       */
      type?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Specific type of service
       * @description Broad categorization of the service that is to be provided (e.g. cardiology).
       */
      serviceType?: components['schemas']['CodeableConcept'] | null;
      /**
       * Indicates the urgency of the encounter
       * @description Indicates the urgency of the encounter.
       */
      priority?: components['schemas']['CodeableConcept'] | null;
      /**
       * The patient or group present at the encounter
       * @description The patient or group present at the encounter.
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * Episode(s) of care that this encounter should be recorded against
       * @description Where a specific encounter should be classified as a part of a specific episode(s) of care this field should be used.
       */
      episodeOfCare?: components['schemas']['Reference'][] | null;
      /**
       * The ServiceRequest that initiated this encounter
       * @description The request this encounter satisfies (e.g. incoming referral or procedure request).
       */
      basedOn?: components['schemas']['Reference'][] | null;
      /**
       * List of participants involved in the encounter
       * @description The list of people responsible for providing the service.
       */
      participant?: components['schemas']['EncounterParticipant'][] | null;
      /**
       * The appointment that scheduled this encounter
       * @description The appointment that scheduled this encounter.
       */
      appointment?: components['schemas']['Reference'][] | null;
      /**
       * The start and end time of the encounter
       * @description The start and end time of the encounter.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Quantity of time the encounter lasted (less time absent)
       * @description Quantity of time the encounter lasted. This excludes the time during leaves of absence.
       */
      length?: components['schemas']['Duration'] | null;
      /**
       * Coded reason the encounter takes place
       * @description Reason the encounter takes place, expressed as a code. For admissions, this can be used for a coded admission diagnosis.
       */
      reasonCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Reason the encounter takes place (reference)
       * @description Reason the encounter takes place, expressed as a reference to another resource. For admissions, this is the admission diagnosis.
       */
      reasonReference?: components['schemas']['Reference'][] | null;
      /**
       * The list of diagnosis relevant to this encounter
       * @description The list of diagnosis relevant to this encounter.
       */
      diagnosis?: components['schemas']['EncounterDiagnosis'][] | null;
      /**
       * The set of accounts that may be used for billing for this Encounter
       * @description The set of accounts that may be used for billing for this Encounter.
       */
      account?: components['schemas']['Reference'][] | null;
      /**
       * Details about the admission to a healthcare service
       * @description Details about the admission to a healthcare service.
       */
      hospitalization?: components['schemas']['EncounterHospitalization'] | null;
      /**
       * List of locations where the patient has been
       * @description List of locations where the patient has been during this encounter.
       */
      location?: components['schemas']['EncounterLocation'][] | null;
      /**
       * The organization (facility) responsible for this encounter
       * @description The organization that is primarily responsible for this Encounter's services. This MAY be the same as the organization on the Patient record, however it could be different, such as if the actor performing the services was from an external organization (which may be billed separately) for an external consultation.
       */
      serviceProvider?: components['schemas']['Reference'] | null;
      /**
       * Another Encounter this encounter is part of
       * @description Another Encounter of which this encounter is a part of (administratively or in time).
       */
      partOf?: components['schemas']['Reference'] | null;
    };
    /**
     * EncounterClassHistory
     * @description Past list of class of the encounter.
     *
     *     https://hl7.org/fhir/R4/encounter-definitions.html#Encounter.classHistory
     */
    EncounterClassHistory: {
      /**
       * inpatient | outpatient | ambulatory | emergency +
       * @description The class of the encounter during this period.
       */
      class: components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding'];
      /**
       * The time that the episode was in the specified class
       * @description The time that the episode was in the specified class.
       */
      period: components['schemas']['pkg__integrations__fhir__models__data_types__period__Period'];
    };
    /**
     * EncounterDiagnosis
     * @description The list of diagnosis relevant to this encounter.
     *
     *     https://hl7.org/fhir/R4/encounter-definitions.html#Encounter.diagnosis
     */
    EncounterDiagnosis: {
      /**
       * The diagnosis or procedure relevant to the encounter
       * @description Reason the encounter takes place, as specified using information from another resource. For admissions, this is the admission diagnosis. The indication will typically be a Condition (with other resources referenced in the evidence.detail), or a Procedure.
       */
      condition: components['schemas']['Reference'];
      /**
       * Role that this diagnosis has within the encounter (e.g. admission, billing, discharge ...)
       * @description Role that this diagnosis has within the encounter (e.g. admission, billing, discharge ...).
       */
      use?: components['schemas']['CodeableConcept'] | null;
      /**
       * Ranking of the diagnosis (for each role type)
       * @description Ranking of the diagnosis (for each role type).
       */
      rank?: number | null;
    };
    /**
     * EncounterHospitalization
     * @description Details about the admission to a healthcare service.
     *
     *     https://hl7.org/fhir/R4/encounter-definitions.html#Encounter.hospitalization
     */
    EncounterHospitalization: {
      /**
       * Pre-admission identifier
       * @description Pre-admission identifier.
       */
      preAdmissionIdentifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * The location/organization from which the patient came before admission
       * @description The location/organization from which the patient came before admission.
       */
      origin?: components['schemas']['Reference'] | null;
      /**
       * From where patient was admitted (physician referral, transfer)
       * @description From where patient was admitted (physician referral, transfer).
       */
      admitSource?: components['schemas']['CodeableConcept'] | null;
      /**
       * The type of hospital re-admission that has occurred (if any)
       * @description Whether this hospitalization is a readmission and why if known.
       */
      reAdmission?: components['schemas']['CodeableConcept'] | null;
      /**
       * Diet preferences reported by the patient
       * @description Diet preferences reported by the patient.
       */
      dietPreference?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Special courtesies (VIP, board member)
       * @description Special courtesies (VIP, board member).
       */
      specialCourtesy?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Wheelchair, translator, stretcher, etc.
       * @description Any special requests that have been made for this hospitalization encounter, such as the provision of specific equipment or other things.
       */
      specialArrangement?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Location/organization to which the patient is discharged
       * @description Location/organization to which the patient is discharged.
       */
      destination?: components['schemas']['Reference'] | null;
      /**
       * Category or kind of location after discharge
       * @description Category or kind of location after discharge.
       */
      dischargeDisposition?: components['schemas']['CodeableConcept'] | null;
    };
    /**
     * EncounterLocation
     * @description Details about a location where the encounter took place.
     *
     *     https://hl7.org/fhir/R4/encounter-definitions.html#Encounter.location
     */
    EncounterLocation: {
      /**
       * Location the encounter takes place
       * @description The location where the encounter takes place.
       */
      location: components['schemas']['Reference'];
      /**
       * planned | active | reserved | completed
       * @description The status of the participants' presence at the specified location during the period specified.
       */
      status?: components['schemas']['EncounterLocationStatus'] | null;
      /**
       * The physical type of the location (usually the level in the location hierachy - bed room ward etc.)
       * @description This will be used to specify the required levels (bed/ward/room/etc.) desired to be recorded to simplify either messaging or query.
       */
      physicalType?: components['schemas']['CodeableConcept'] | null;
      /**
       * Time period during which the patient was present at the location
       * @description Time period during which the patient was present at the location.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
    };
    /**
     * EncounterLocationStatus
     * @description The status of the location.
     *
     *     https://hl7.org/fhir/R4/valueset-encounter-location-status.html
     * @enum {string}
     */
    EncounterLocationStatus: EncounterLocationStatus;
    /**
     * EncounterParticipant
     * @description List of participants involved in the encounter.
     *
     *     https://hl7.org/fhir/R4/encounter-definitions.html#Encounter.participant
     */
    EncounterParticipant: {
      /**
       * Role of participant in encounter
       * @description Role of participant in encounter.
       */
      type?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Period of time during the encounter that the participant participated
       * @description The period of time that the specified participant participated in the encounter. These can overlap or be sub-sets of the overall encounter's period.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Persons involved in the encounter other than the patient
       * @description Persons involved in the encounter other than the patient.
       */
      individual?: components['schemas']['Reference'] | null;
    };
    /**
     * EncounterStatus
     * @description Current state of the encounter.
     *
     *     https://hl7.org/fhir/R4/valueset-encounter-status.html
     * @enum {string}
     */
    EncounterStatus: EncounterStatus;
    /**
     * EncounterStatusHistory
     * @description Past list of status of the encounter.
     *
     *     https://hl7.org/fhir/R4/encounter-definitions.html#Encounter.statusHistory
     */
    EncounterStatusHistory: {
      /**
       * planned | arrived | triaged | in-progress | onleave | finished | cancelled | entered-in-error | unknown
       * @description The status of the encounter during this period.
       */
      status: components['schemas']['EncounterStatus'];
      /**
       * The time that the episode was in the specified status
       * @description The time that the episode was in the specified status.
       */
      period: components['schemas']['pkg__integrations__fhir__models__data_types__period__Period'];
    };
    /** EndAfterN */
    EndAfterN: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: EndAfterNKind;
      /** Max Actions */
      max_actions: number;
    };
    /** EndAt */
    EndAt: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: EndAtKind;
      /**
       * End At
       * Format: date-time
       */
      end_at: string;
    };
    /**
     * EndpointParams
     * @description Maximal R4 ``endpoint.*`` chained search surface.
     */
    EndpointParams: {
      /**
       * Connection-Type
       * @description The kind of channel (token search). Accepts ``system|code`` syntax.
       */
      'connection-type'?: string | null;
    };
    /** EnrichedTemplateRevision */
    EnrichedTemplateRevision: {
      /**
       * Is Private
       * @default true
       */
      is_private: boolean;
      /** Team Id */
      team_id?: string | null;
      /** @default User */
      template_author_group: components['schemas']['TemplateAuthorGroup'] | null;
      /** @default User */
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Source Template Id */
      source_template_id?: string | null;
      /**
       * Template Gallery Sharing Preference Show Name
       * @default true
       */
      template_gallery_sharing_preference_show_name: boolean;
      /**
       * Template Gallery Sharing Preference Show Clinic
       * @default true
       */
      template_gallery_sharing_preference_show_clinic: boolean;
      /**
       * Template Gallery Sharing Preference Show Profile Picture
       * @default true
       */
      template_gallery_sharing_preference_show_profile_picture: boolean;
      /**
       * Shared Team Ids
       * @description An array of team_ids that the template is shared with
       */
      shared_team_ids?: string[] | null;
      /** Name */
      name: string;
      /**
       * Structure Template
       * @default
       */
      structure_template: string;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** @default pdf */
      form_format: components['schemas']['FormFormat'];
      /** Xml Source */
      xml_source?: string | null;
      /** Json Source */
      json_source?: string | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /** List Order Priority */
      list_order_priority?: number | null;
      /**
       * Should Deduct Quota
       * @default true
       */
      should_deduct_quota: boolean;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Template Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Revision */
      revision: number;
      /** Updated Time */
      updated_time?: string | null;
      /** Reviewed Time */
      reviewed_time?: string | null;
      /** Reviewer Id */
      reviewer_id?: string | null;
      review_status?: components['schemas']['TemplateReviewStatus'] | null;
      /**
       * Workspace Id
       * @description The workspace_id the template belongs to
       */
      workspace_id?: string | null;
      /**
       * Author Name
       * @default
       */
      author_name: string;
      /**
       * Specialty
       * @default
       */
      specialty: string;
      /**
       * Region
       * @default
       */
      region: string;
      /** Country */
      country?: string | null;
      /** Submitted At */
      submitted_at?: string | null;
      /**
       * Url Path
       * @default
       */
      url_path: string;
      /** @default FREE */
      user_tier: components['schemas']['SubscriptionTier'];
      /** Pdf Url */
      pdf_url?: string | null;
    };
    /**
     * EnrolMeteredBillingRequest
     * @description HTTP body for `POST /metered-billing/enrol`.
     *
     *     Enrols a target into metered billing for `metric_key` by attaching the
     *     supplied metered `stripe_price_id` to the target's existing subscription.
     *
     *     The target is addressed by `scope` — every addressing resolves to the same
     *     underlying unit, a billing account (one Stripe customer):
     *
     *     - `scope="user"` (default) — the cohort is `user_ref_ids`; each resolves to
     *       its own (or, for a team member, the owner's) billing account. This is the
     *       original contract — `scope` defaults to `user`, so callers that send only
     *       `user_ref_ids` keep working unchanged.
     *     - `scope="organization"` — `scope_id` is the organization id; it resolves to
     *       the org **owner's** billing account, so the metered item attaches to the
     *       owner's subscription and captures the whole org's usage.
     *     - `scope="workspace"` — `scope_id` is the workspace id; for an org
     *       `workspace_id == org_id`, so it resolves to the same billing account.
     *
     *     `scope="global"` is not offered (absent from the scope literal → 422).
     *     Because provisioning is keyed on the resolved billing account, addressing an
     *     org (or its workspace) and addressing the owner-as-user land on the same
     *     account and are idempotent (no second metered item).
     *
     *     One price per request: the metered price carries the currency and must match
     *     each customer's subscription currency, so a cohort is expected to be
     *     currency-homogeneous. A customer whose subscription is in a different
     *     currency is skipped (`skipped_currency_mismatch`); split mixed-currency
     *     cohorts into one enrol per currency with the matching price.
     */
    EnrolMeteredBillingRequest: {
      /** Metric Key */
      metric_key: string;
      /** Stripe Price Id */
      stripe_price_id: string;
      /**
       * Scope
       * @default user
       * @enum {string}
       */
      scope: EnrolMeteredBillingRequestScope;
      /** Scope Id */
      scope_id?: string | null;
      /** User Ref Ids */
      user_ref_ids?: string[] | null;
    };
    /** EnterpriseAuditLog */
    EnterpriseAuditLog: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      actor: components['schemas']['Actor'];
      event: components['schemas']['AuditLogEvent'];
      entity: components['schemas']['Entity'];
      /** Related Entities */
      related_entities?: components['schemas']['Entity'][];
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp?: string;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /**
     * EntitlementHistoryResponse
     * @description Per-cycle history response for the internal-admin history endpoints.
     *
     *     Constants that don't vary between cycles (metric identity, the
     *     request's resolved tier, team_scope, source) live on the wrapper;
     *     the per-cycle list carries only the time bounds and the headline
     *     rollup numbers. The list is always non-empty for a valid request
     *     (default is the current cycle as a length-1 list), oldest cycle
     *     first, and capped server-side at 53 entries.
     */
    EntitlementHistoryResponse: {
      /** Metric Key */
      metric_key: string;
      /** Product */
      product?: string | null;
      /** Feature */
      feature?: string | null;
      /** Filter Groups */
      filter_groups?:
        | {
            [key: string]: string;
          }[]
        | null;
      /** Subscription Tier */
      subscription_tier: string;
      /** Team Scope */
      team_scope?: EntitlementHistoryResponseTeam_scopeAnyOf0 | null;
      /**
       * Source
       * @enum {string}
       */
      source: EntitlementHistoryResponseSource;
      /** Cycles */
      cycles: components['schemas']['CycleSummary'][];
    };
    /** EntitlementResponse */
    EntitlementResponse: {
      /** Metric Key */
      metric_key: string;
      /** Product */
      product?: string | null;
      /** Feature */
      feature?: string | null;
      /** Filter Groups */
      filter_groups?:
        | {
            [key: string]: string;
          }[]
        | null;
      /** Subscription Tier */
      subscription_tier: string;
      /**
       * Period Start
       * Format: date-time
       */
      period_start: string;
      /**
       * Period End
       * Format: date-time
       */
      period_end: string;
      /** Usage */
      usage: number;
      /** Limit */
      limit: number | null;
      /** Remaining */
      remaining: number | null;
      /** Is Over Limit */
      is_over_limit: boolean;
      /** Limit Key */
      limit_key?: string | null;
      /** User Usage */
      user_usage: number;
      /** User Limit */
      user_limit: number | null;
      /** Team Scope */
      team_scope?: EntitlementResponseTeam_scopeAnyOf0 | null;
      /** Team Usage */
      team_usage?: number | null;
      /** Team Limit */
      team_limit?: number | null;
      /** Team Remaining */
      team_remaining?: number | null;
      /** Team Is Over Limit */
      team_is_over_limit?: boolean | null;
      /** Breakdown */
      breakdown?: components['schemas']['UsageBreakdownEntry'][] | null;
      /**
       * Source
       * @enum {string}
       */
      source: EntitlementResponseSource;
    };
    /**
     * EntitlementTypeAvailability
     * @description Who may see this type in catalog APIs and who may assign via team-admin web APIs.
     * @enum {string}
     */
    EntitlementTypeAvailability: EntitlementTypeAvailability;
    /**
     * Entity
     * @description The entity that was acted upon.
     */
    Entity: {
      type: components['schemas']['AuditEntityType'];
      /** Id */
      id: string;
    };
    /**
     * EntitySource
     * @enum {string}
     */
    EntitySource: EntitySource;
    /**
     * EntityVerificationDataView
     * @description Container for all entity verification results.
     */
    EntityVerificationDataView: {
      /** Entity Verification */
      entity_verification: components['schemas']['EntityVerificationView'][];
      /** Additional Information */
      additional_information: components['schemas']['AdditionalInformationView'][];
      verification_summary: components['schemas']['VerificationSummaryView'];
    };
    /**
     * EntityVerificationFeedbackView
     * @description Response schema for a single entity verification feedback record.
     */
    EntityVerificationFeedbackView: {
      /** Feedback Id */
      feedback_id: string;
      /** Analysis Id */
      analysis_id: string;
      /** Entity Source */
      entity_source: string;
      /** Entity Index */
      entity_index: number;
      /** Analysis Marked Correct */
      analysis_marked_correct: boolean;
      /** Qualitative Feedback */
      qualitative_feedback?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * EntityVerificationView
     * @description A verified entity from the clinical note.
     */
    EntityVerificationView: {
      /** Input Entity */
      input_entity: string;
      /**
       * Input Entity Exact Quotes
       * @default []
       */
      input_entity_exact_quotes: string[];
      /** Output Entity */
      output_entity?: string | null;
      /** Output Quotes */
      output_quotes: string[];
      /** Category */
      category: string;
      /** Relevance */
      relevance: string;
      /** Source */
      source: string;
      /** Present In Output */
      present_in_output: boolean;
      /** Accuracy Match */
      accuracy_match: string;
      /** Details */
      details: string;
      /** Notes */
      notes?: string | null;
      /** Suggested Fix */
      suggested_fix?: string | null;
      /** Feedback Id */
      feedback_id?: string | null;
    };
    /** Entry[AllergyIntolerance] */
    Entry_AllergyIntolerance_: {
      resource: components['schemas']['AllergyIntolerance'];
    };
    /** Entry[Appointment] */
    Entry_Appointment_: {
      resource: components['schemas']['Appointment'];
    };
    /** Entry[Composition] */
    Entry_Composition_: {
      resource: components['schemas']['Composition'];
    };
    /** Entry[DocumentReference] */
    Entry_DocumentReference_: {
      resource: components['schemas']['DocumentReference'];
    };
    /** Entry[Encounter] */
    Entry_Encounter_: {
      resource: components['schemas']['Encounter'];
    };
    /** Entry[FamilyMemberHistory] */
    Entry_FamilyMemberHistory_: {
      resource: components['schemas']['FamilyMemberHistory'];
    };
    /** Entry[HealthcareService] */
    Entry_HealthcareService_: {
      resource: components['schemas']['HealthcareService'];
    };
    /** Entry[Immunization] */
    Entry_Immunization_: {
      resource: components['schemas']['Immunization'];
    };
    /** Entry[Location] */
    Entry_Location_: {
      resource: components['schemas']['Location'];
    };
    /** Entry[MedicationRequest] */
    Entry_MedicationRequest_: {
      resource: components['schemas']['MedicationRequest'];
    };
    /** Entry[MedicationStatement] */
    Entry_MedicationStatement_: {
      resource: components['schemas']['MedicationStatement'];
    };
    /** Entry[Observation] */
    Entry_Observation_: {
      resource: components['schemas']['pkg__integrations__fhir__models__observation__Observation'];
    };
    /** Entry[Patient] */
    Entry_Patient_: {
      resource: components['schemas']['Patient'];
    };
    /** Entry[PractitionerRole] */
    Entry_PractitionerRole_: {
      resource: components['schemas']['PractitionerRole'];
    };
    /** Entry[Practitioner] */
    Entry_Practitioner_: {
      resource: components['schemas']['Practitioner'];
    };
    /** Entry[QuestionnaireResponse] */
    Entry_QuestionnaireResponse_: {
      resource: components['schemas']['QuestionnaireResponse'];
    };
    /** Entry[Schedule] */
    Entry_Schedule_: {
      resource: components['schemas']['Schedule'];
    };
    /** Entry[Slot] */
    Entry_Slot_: {
      resource: components['schemas']['Slot'];
    };
    /** Entry[Task] */
    Entry_Task_: {
      resource: components['schemas']['Task'];
    };
    /**
     * EpicCategory
     * @description An Epic internal category value (e.g. doc source, doc method).
     */
    EpicCategory: {
      /** Id */
      id: string;
      /** Title */
      title: string;
    };
    /**
     * EpicCreateAdaptorRequest
     * @description Create Request schema for Epic Adapter.
     */
    EpicCreateAdaptorRequest: {
      /**
       * Ehr Provider
       * @default Epic Systems
       * @constant
       */
      ehr_provider: 'Epic Systems';
      access_token_response: components['schemas']['EHRLaunchAccessTokenDetails'];
      ehrlaunch_profile: components['schemas']['EHRLaunchProfile'];
    };
    /**
     * EpicCreateStandAloneLaunchAdaptorRequest
     * @description Create Request schema for Epic Stand Alone Adapter.
     */
    EpicCreateStandAloneLaunchAdaptorRequest: {
      /**
       * Ehr Provider
       * @default Epic Systems
       * @constant
       */
      ehr_provider: 'Epic Systems';
    };
    /**
     * ErpPushResult
     * @description Outcome of the best-effort push of this edit into Lingxing (ERP).
     *
     *     `attempted` is False when there was nothing to push (pre-ERP order, or past
     *     Lingxing's edit window). On `attempted=True, succeeded=False` the local edit
     *     still persisted — CS should escalate to the ERP team. `verified` is the
     *     post-push re-list check (null when it couldn't run).
     */
    ErpPushResult: {
      /** Attempted */
      attempted: boolean;
      /**
       * Succeeded
       * @default false
       */
      succeeded: boolean;
      /** Verified */
      verified?: boolean | null;
      /** Detail */
      detail?: string | null;
    };
    /** ErrorDetail */
    ErrorDetail: {
      /** Msg */
      msg: string;
      /** Type */
      type: string;
    };
    /** ErrorResponse */
    ErrorResponse: {
      /**
       * Status Code
       * @default 400
       */
      status_code: number;
      detail: components['schemas']['ErrorDetail'];
    };
    /**
     * ErrorResponseDTO
     * @description Error response DTO for API errors.
     *
     *     Provides a consistent error response format with code, message, and optional details.
     * @example {
     *       "code": "INVALID_EMAIL",
     *       "details": {
     *         "field": "email",
     *         "value": "invalid-email"
     *       },
     *       "message": "Email format is invalid"
     *     }
     * @example {
     *       "code": "UNAUTHORIZED",
     *       "message": "Missing or invalid API key"
     *     }
     */
    ErrorResponseDTO: {
      /**
       * Code
       * @description Error code (e.g., 'INVALID_EMAIL', 'UNAUTHORIZED')
       */
      code: string;
      /**
       * Message
       * @description Human-readable error message
       */
      message: string;
      /**
       * Details
       * @description Additional error details
       */
      details?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * EvaluationErrorSeverity
     * @description Rubric severity for a translator evaluation error.
     * @enum {string}
     */
    EvaluationErrorSeverity: EvaluationErrorSeverity;
    /**
     * EvaluationErrorStage
     * @description Pipeline stage an evaluation error is attributed to.
     * @enum {string}
     */
    EvaluationErrorStage: EvaluationErrorStage;
    /**
     * EvaluationErrorType
     * @description Specific error types from the rubric, scoped to a ``EvaluationErrorStage``.
     *
     *     Values are stage-prefixed wherever the same rubric label appears under more
     *     than one stage (Omission and Addition each appear under three), so a value
     *     identifies a row of the rubric on its own without needing the stage
     *     alongside it. ``STAGE_EVALUATION_ERROR_TYPES`` holds the stage-to-type mapping.
     * @enum {string}
     */
    EvaluationErrorType: EvaluationErrorType;
    /**
     * EvaluationUiVariant
     * @description Which per-message feedback form the rater was shown.
     *
     *     The client sends this rather than the service inferring it: a rating from
     *     the categories form that selected no categories is indistinguishable on the
     *     wire from a rubric one, and guessing would bias any comparison between them.
     * @enum {string}
     */
    EvaluationUiVariant: EvaluationUiVariant;
    /** EventRuleListResponse */
    EventRuleListResponse: {
      /** Event Rules */
      event_rules: components['schemas']['apis__v2__workflows__schema__EventRuleResponse'][];
      /** Total */
      total: number;
    };
    /**
     * EventStatus
     * @description The status of the communication.
     *
     *     https://hl7.org/fhir/R4/valueset-event-status.html
     * @enum {string}
     */
    EventStatus: EventStatus;
    /**
     * EventTiming
     * @description Real world event relating to the schedule.
     *
     *     https://hl7.org/fhir/R4/valueset-event-timing.html
     * @enum {string}
     */
    EventTiming: EventTiming;
    /**
     * EventType
     * @enum {string}
     */
    EventType: EventType;
    /** EventTypeInfo */
    EventTypeInfo: {
      /** Value */
      value: string;
      /** Label */
      label: string;
      /** Target Context Projection */
      target_context_projection?: {
        [key: string]: string;
      };
      /** Semantic Text Source */
      semantic_text_source?: string | null;
    };
    /**
     * EvidenceBillingInfoResponseView
     * @description Response view for evidence product billing information.
     */
    EvidenceBillingInfoResponseView: {
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Trial End Date */
      trial_end_date?: string | null;
      /** Next Billing Date */
      next_billing_date?: string | null;
      /** Canceled At */
      canceled_at?: string | null;
      /** @deprecated */
      third_party_license?: components['schemas']['ThirdPartyLicenceDetails'] | null;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /**
       * Free Trial History
       * @default {}
       */
      free_trial_history: {
        [key: string]: components['schemas']['FreeTrialHistory'];
      };
      /**
       * Is In Free Trial
       * @default false
       */
      is_in_free_trial: boolean;
      /** @default free */
      tier: components['schemas']['ChatEvidenceSubscriptionTier'];
      /**
       * Is Stripe Managed
       * @default true
       */
      is_stripe_managed: boolean;
    };
    /**
     * EvidenceBillingSnapshot
     * @description Snapshot of evidence_billing after update.
     */
    EvidenceBillingSnapshot: {
      /** Trial End Date */
      trial_end_date?: string | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Canceled At */
      canceled_at?: string | null;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
    };
    /**
     * EvidenceBillingSource
     * @description Source of evidence billing - whether from user's own subscription or team.
     * @enum {string}
     */
    EvidenceBillingSource: EvidenceBillingSource;
    /**
     * EvidenceBillingStateResponseView
     * @description Backend-owned evidence trial/history state booleans.
     *
     *     Replaces frontend derivation off ``evidence_billing`` presence and raw
     *     trial history. Always present — placed at the billing-info level, not
     *     nested in ``evidence_billing``, because the projection can be null while
     *     these booleans (e.g. prior trial history) still need to be expressed.
     *     All-False is the safe degraded default: no trial UI is offered.
     *
     *     ``evidence_trial_expired`` materializes the FE's ``hasTrialExpired`` so it
     *     no longer has to be derived from the (nullable) ``evidence_billing``
     *     projection's source/tier.
     */
    EvidenceBillingStateResponseView: {
      /**
       * Can Start Evidence Trial
       * @default false
       */
      can_start_evidence_trial: boolean;
      /**
       * Has Had Evidence Trial
       * @default false
       */
      has_had_evidence_trial: boolean;
      /**
       * Evidence Trial Ended By User
       * @default false
       */
      evidence_trial_ended_by_user: boolean;
      /**
       * Has Evidence Billing History
       * @default false
       */
      has_evidence_billing_history: boolean;
      /**
       * Evidence Trial Expired
       * @default false
       */
      evidence_trial_expired: boolean;
    };
    /** EvidenceCacheView */
    EvidenceCacheView: {
      /** Count */
      count: number;
      /** Accepts */
      accepts: number;
      /** Rejects */
      rejects: number;
    };
    /**
     * EvidenceFeedbackRequest
     * @description Request model for submitting Evidence (chat) feedback.
     *
     *     This endpoint works for both sessionless and in-session chats.
     *     For sessionless chats, session_id should be omitted or None.
     */
    EvidenceFeedbackRequest: {
      /**
       * Target Id
       * @description Chat ID for the feedback (stored as target_id in database)
       */
      target_id: string;
      /**
       * Session Id
       * @description Session ID if this is an in-session chat (optional)
       */
      session_id?: string | null;
      /**
       * Message Id
       * @description ID of the specific chat message the feedback refers to (from streaming message_info chunk)
       */
      message_id?: string | null;
      /** @description FeedbackV2 rating with thumb up or down and optional mode */
      feedback: components['schemas']['FeedbackV2'];
      /**
       * Content Snapshot
       * @description Snapshot of the chat content at time of feedback
       */
      content_snapshot?: string | null;
    };
    /**
     * EvidenceFeedbackResponse
     * @description Response model for Evidence feedback submission.
     */
    EvidenceFeedbackResponse: {
      /**
       * Feedback Id
       * @description ID of the created feedback record
       */
      feedback_id: string;
    };
    /**
     * EvidenceLinkResponse
     * @description Evidence linking a problem to a verbatim text excerpt from a data source.
     *
     *     The frontend uses text-match anchoring to find `text` in the ProseMirror
     *     document and render highlights as decorations (no document mutation).
     */
    EvidenceLinkResponse: {
      /**
       * Source
       * @description Data source: 'note', 'transcript', or 'context_tab'
       */
      source: string;
      /**
       * Section
       * @description Note section name for scoping text search
       */
      section?: string | null;
      /**
       * Text
       * @description Verbatim excerpt to match in the document
       */
      text: string;
      /**
       * Problem Id
       * @description Which problem this evidence supports
       */
      problem_id: string;
      /**
       * Is Primary
       * @description True for note-based evidence
       * @default false
       */
      is_primary: boolean;
      /**
       * Meat Category
       * @description MEAT criteria category: monitor, evaluate, assess, treat
       */
      meat_category?: string | null;
    };
    /**
     * EvidenceRenderPayload
     * @description Durable renderer input for a completed or partial Evidence run.
     */
    EvidenceRenderPayload: {
      /**
       * Version
       * @default 1
       */
      version: number;
      /** Evidence Chunks */
      evidence_chunks?: {
        [key: string]: unknown;
      }[];
      /** Sources */
      sources?: {
        [key: string]: unknown;
      }[];
      /** Structured Citations */
      structured_citations?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Annotations */
      annotations?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Web Search Query */
      web_search_query?: string | null;
      /**
       * Truncated
       * @default false
       */
      truncated: boolean;
      /** Truncation Reason */
      truncation_reason?: string | null;
      /**
       * Partial
       * @default false
       */
      partial: boolean;
      /** Error */
      error?: string | null;
    };
    /**
     * EvidenceSBSCandidatePosition
     * @description Position of the candidate the user selected in the SBS UI.
     *
     *     A = left (out-of-session) / option 1 (in-session)
     *     B = right (out-of-session) / option 2 (in-session)
     * @enum {string}
     */
    EvidenceSBSCandidatePosition: EvidenceSBSCandidatePosition;
    /** EvidenceSBSCandidateView */
    EvidenceSBSCandidateView: {
      /**
       * Candidate Id
       * @description Public UUID for this candidate
       */
      candidate_id: string;
      /**
       * Is Default
       * @description True for the user's normal model
       */
      is_default: boolean;
    };
    /** EvidenceSBSConfirmRequest */
    EvidenceSBSConfirmRequest: {
      /**
       * Chat Id
       * @description Chat conversation ID
       */
      chat_id: string;
      /**
       * Selected Candidate Id
       * @description UUID of the candidate the user selected
       */
      selected_candidate_id: string;
      /** @description UI position of the selected candidate: A = left (out-of-session) / option 1 (in-session), B = right (out-of-session) / option 2 (in-session) */
      selected_candidate_position?:
        | components['schemas']['EvidenceSBSCandidatePosition']
        | null;
      /**
       * Displayed At
       * @description When both candidates were shown
       */
      displayed_at?: string | null;
      /**
       * Selected At
       * @description When the user made their selection
       */
      selected_at?: string | null;
    };
    /** EvidenceSBSConfirmResponse */
    EvidenceSBSConfirmResponse: {
      /**
       * Success
       * @default true
       */
      success: boolean;
    };
    /** EvidenceSBSSetupRequest */
    EvidenceSBSSetupRequest: {
      /**
       * Chat Id
       * @description Chat conversation ID
       */
      chat_id: string;
      /**
       * Message Index
       * @description 0-based index of the user message triggering SBS
       */
      message_index: number;
      /**
       * Session Id
       * @description Session ID if in-session
       */
      session_id?: string | null;
      /** @description Where the chat was triggered from */
      evidence_trigger_location: components['schemas']['EvidenceTriggerLocation'];
      /**
       * Country
       * @description Country name from the frontend
       */
      country?: string | null;
      /**
       * Region
       * @description Region code from the frontend
       */
      region?: string | null;
    };
    /** EvidenceSBSSetupResponse */
    EvidenceSBSSetupResponse: {
      /**
       * Candidates
       * @description List of candidates to generate (length 1 = normal, 2 = SBS)
       */
      candidates: components['schemas']['EvidenceSBSCandidateView'][];
      /**
       * Generation Mode
       * @description Experiment mode: 'normal' or 'model_comparison'
       * @default normal
       */
      generation_mode: string;
    };
    /**
     * EvidenceSBSSkipReason
     * @description Reasons why an Evidence SBS experiment was skipped.
     * @enum {string}
     */
    EvidenceSBSSkipReason: EvidenceSBSSkipReason;
    /** EvidenceSBSSkipRequest */
    EvidenceSBSSkipRequest: {
      /**
       * Chat Id
       * @description Chat conversation ID
       */
      chat_id: string;
      /**
       * Candidate Id
       * @description UUID of a candidate from the SBS round (used to look up the experiment). When skip_reason is 'midstream_selection', this MUST be the candidate the user selected — it is recorded as the selected candidate.
       */
      candidate_id: string;
      /**
       * @description Why SBS was skipped: 'skip' = user dismissed the overlay, 'midstream_selection' = user picked while a candidate was still streaming. Optional; defaults to 'skip'.
       * @default skip
       */
      skip_reason: components['schemas']['EvidenceSBSSkipReason'] | null;
      /**
       * Displayed At
       * @description When both candidates were shown
       */
      displayed_at?: string | null;
      /**
       * Skipped At
       * @description When the user dismissed the SBS overlay
       */
      skipped_at?: string | null;
    };
    /** EvidenceSBSSkipResponse */
    EvidenceSBSSkipResponse: {
      /**
       * Success
       * @default true
       */
      success: boolean;
    };
    /**
     * EvidenceSearchContextDO
     * @description Full search context for an evidence chat turn.
     *
     *     Captures what was configured, what was searched, and what was cited.
     *     Stored on ChatMessageMetadataDO for data lake export.
     */
    EvidenceSearchContextDO: {
      /**
       * Evidence Source Filters Applied
       * @description Filters applied: 'local_guidelines', 'primary_evidence'
       */
      evidence_source_filters_applied?: string[];
      /**
       * Include Web Search
       * @default true
       */
      include_web_search: boolean;
      /**
       * Source List Ids
       * @description Web collection IDs used
       */
      source_list_ids?: string[];
      /**
       * User Doc Collection Ids
       * @description Library collection IDs used
       */
      user_doc_collection_ids?: string[];
      /** Integration Partners */
      integration_partners?: components['schemas']['IntegrationPartnerUsageRecord'][];
      /** Web Search Groups */
      web_search_groups?: components['schemas']['WebSearchGroupRecord'][];
      /**
       * Total Sources Returned
       * @default 0
       */
      total_sources_returned: number;
      /**
       * Total Sources Cited
       * @default 0
       */
      total_sources_cited: number;
      /** Cited Sources */
      cited_sources?: components['schemas']['CitedSourceRecord'][];
      /** User Country Code */
      user_country_code?: string | null;
      /**
       * Region
       * @description 'AU', 'US', 'UK', 'EU', 'CA'
       */
      region?: string | null;
      /** Team Id */
      team_id?: string | null;
      /** Evidence Tier */
      evidence_tier?: string | null;
    };
    /**
     * EvidenceSettingsRequest
     * @description Request schema for updating Evidence (clinical search) preferences.
     */
    EvidenceSettingsRequest: {
      /** Hide Suggestions */
      hide_suggestions?: boolean | null;
      /** Has Seen Evidence Onboarding */
      has_seen_evidence_onboarding?: boolean | null;
      /** Has Seen Evidence Disclaimer */
      has_seen_evidence_disclaimer?: boolean | null;
      /** Library Upload Risk Accepted At */
      library_upload_risk_accepted_at?: string | null;
      /** Has Contacted Sales For Evidence */
      has_contacted_sales_for_evidence?: boolean | null;
      /** Has Contacted Admin For Evidence */
      has_contacted_admin_for_evidence?: boolean | null;
      /** Country */
      country?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      source_control?: components['schemas']['EvidenceSourceControlSelections'] | null;
    };
    /**
     * EvidenceSettingsResponse
     * @description Response schema for Evidence (clinical search) preferences.
     */
    EvidenceSettingsResponse: {
      /**
       * Hide Suggestions
       * @default false
       */
      hide_suggestions: boolean;
      /**
       * Has Seen Evidence Onboarding
       * @default false
       */
      has_seen_evidence_onboarding: boolean;
      /**
       * Has Seen Evidence Disclaimer
       * @default false
       */
      has_seen_evidence_disclaimer: boolean;
      /** Library Upload Risk Accepted At */
      library_upload_risk_accepted_at?: string | null;
      /**
       * Has Contacted Sales For Evidence
       * @default false
       */
      has_contacted_sales_for_evidence: boolean;
      /**
       * Has Contacted Admin For Evidence
       * @default false
       */
      has_contacted_admin_for_evidence: boolean;
      /**
       * Evidence General Feedback Count
       * @default 0
       */
      evidence_general_feedback_count: number;
      /** Country */
      country?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      source_control?: components['schemas']['EvidenceSourceControlSelections'] | null;
      default_source_control?:
        | components['schemas']['EvidenceSourceControlSelections']
        | null;
    };
    /**
     * EvidenceSourceControlSelections
     * @description User's persisted source-control + integration toggles (EVI-1324).
     *
     *     Mirrors the FE `SourceControlToggleState` (chatAtoms.ts) 1:1 in snake_case.
     *     Replaces the prior localStorage-only persistence under
     *     'heidi:source-control-toggle' so selections follow the user across devices.
     *
     *     On EvidenceSettings, `source_control` is None until the user first changes
     *     a toggle; the FE falls back to its SOURCE_CONTROL_DEFAULTS in that case.
     *
     *     Persistence contract (Option A): the FE always sends the full blob - the
     *     upstream PATCH /v1/user/ merge replaces this nested object wholesale, so
     *     partial blobs would silently drop fields. Keep both sides aligned.
     */
    EvidenceSourceControlSelections: {
      /**
       * Local Guidelines
       * @default false
       */
      local_guidelines: boolean;
      /**
       * Primary Evidence
       * @default false
       */
      primary_evidence: boolean;
      /**
       * My Library
       * @default false
       */
      my_library: boolean;
      /**
       * Library Mode
       * @default all
       * @enum {string}
       */
      library_mode: EvidenceSourceControlSelectionsLibrary_mode;
      /** Selected Collection Ids */
      selected_collection_ids?: string[];
      /**
       * Web Collections
       * @default false
       */
      web_collections: boolean;
      /**
       * Web Collections Mode
       * @default all
       * @enum {string}
       */
      web_collections_mode: EvidenceSourceControlSelectionsWeb_collections_mode;
      /** Selected Web Collection Ids */
      selected_web_collection_ids?: string[];
      /** Integration Partners */
      integration_partners?: {
        [key: string]: boolean;
      };
      /**
       * Web Search
       * @default true
       */
      web_search: boolean;
      /**
       * Include Uncollected
       * @default false
       */
      include_uncollected: boolean;
    };
    /**
     * EvidenceSourceFilter
     * @description Individual evidence source filter values for v3 completions.
     *
     *     Used in an array to control which search backends are enabled:
     *     - [] = web search (all sources)
     *     - ['local_guidelines'] = vector search only
     *     - ['primary_evidence'] = primary evidence web search only
     *     - ['local_guidelines', 'primary_evidence'] = both vector and web search
     * @enum {string}
     */
    EvidenceSourceFilter: EvidenceSourceFilter;
    /** EvidenceSubscriptionBillingInfo */
    EvidenceSubscriptionBillingInfo: {
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Trial End Date */
      trial_end_date?: string | null;
      /** Next Billing Date */
      next_billing_date?: string | null;
      /** Canceled At */
      canceled_at?: string | null;
      third_party_license?: components['schemas']['ThirdPartyLicenceDetails'] | null;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /**
       * Free Trial History
       * @default {}
       */
      free_trial_history: {
        [key: string]: components['schemas']['FreeTrialHistory'];
      };
      /**
       * Is Stripe Managed
       * @default true
       */
      is_stripe_managed: boolean;
    };
    /**
     * EvidenceSubscriptionListResponse
     * @description Pagination response for listing evidence subscriptions.
     */
    EvidenceSubscriptionListResponse: {
      /** Users */
      users?: components['schemas']['EvidenceSubscriptionUserView'][];
      /**
       * Total
       * @description Total number of users matching the criteria
       * @default 0
       */
      total: number;
      /**
       * Page
       * @description Current page number
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @description Number of users per page
       * @default 20
       */
      page_size: number;
    };
    /**
     * EvidenceSubscriptionOrderBy
     * @description Allowed fields for ordering evidence subscriptions.
     * @enum {string}
     */
    EvidenceSubscriptionOrderBy: EvidenceSubscriptionOrderBy;
    /**
     * EvidenceSubscriptionState
     * @description Evidence subscription states for filtering and display.
     * @enum {string}
     */
    EvidenceSubscriptionState: EvidenceSubscriptionState;
    /**
     * EvidenceSubscriptionTier
     * @description Evidence product subscription tiers.
     * @enum {string}
     */
    EvidenceSubscriptionTier: EvidenceSubscriptionTier;
    /**
     * EvidenceSubscriptionUserView
     * @description Response model for a user with evidence subscription info.
     */
    EvidenceSubscriptionUserView: {
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Email */
      email?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Country */
      country?: string | null;
      /** Created At */
      created_at?: string | null;
      state: components['schemas']['EvidenceSubscriptionState'];
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Trial End Date */
      trial_end_date?: string | null;
      /** Next Billing Date */
      next_billing_date?: string | null;
      /** Canceled At */
      canceled_at?: string | null;
      /**
       * Is In Free Trial
       * @default false
       */
      is_in_free_trial: boolean;
    };
    /** EvidenceSummarySuggestionResponse */
    EvidenceSummarySuggestionResponse: {
      /** Should Show */
      should_show: boolean;
      /** Score */
      score: number;
      /**
       * Signals
       * @default []
       */
      signals: string[];
    };
    /**
     * EvidenceTriggerLocation
     * @description Where the Evidence chat was triggered from.
     * @enum {string}
     */
    EvidenceTriggerLocation: EvidenceTriggerLocation;
    /**
     * EvidenceUsageResponse
     * @description API response shape for evidence usage; mirrors EvidenceUsage with
     *     response-only derived fields on its scoped sub-models.
     */
    EvidenceUsageResponse: {
      in_session?: components['schemas']['InSessionEvidenceUsageResponse'];
    };
    /**
     * EvidenceUsageStatsResponse
     * @description Evidence usage counters from live ``chat`` and CPD data.
     *
     *     Returned by both ``GET /user-activity/evidence`` (scoped to the current user)
     *     and ``GET /user-activity/team/{team_id}/evidence`` (aggregated across joined
     *     team members; team admin only).
     *
     *     ``evidence_queries_in_session`` counts only user-authored turns
     *     (``messages.role == "user"``) in session-linked evidence chats.
     *     ``answers_from_evidence`` counts every non-user message (assistant, system,
     *     summary, etc.) across all of the user's or team's evidence chats.
     *     ``sessions_with_evidence_queries`` is the distinct ``session_id`` count
     *     across session-linked evidence chats with at least one user-authored query
     *     (the session-grouped counterpart of ``evidence_queries_in_session``).
     */
    EvidenceUsageStatsResponse: {
      /**
       * Evidence Queries In Session
       * @description Per-message count of user-authored turns in non-deleted evidence-mode chats whose ``session_id`` is linked to a consult session (not null). Per-user endpoint: this user only. Team endpoint: summed across all joined members.
       */
      evidence_queries_in_session: number;
      /**
       * Answers From Evidence
       * @description Per-message count of non-user chat turns (``messages.role != "user"``) — assistant, system, summary, etc. — across all non-deleted evidence-mode chats. Per-user endpoint: this user's chats only. Team endpoint: summed across all joined members' chats.
       */
      answers_from_evidence: number;
      /**
       * References Used
       * @description CPD source-appearance rows in ``cpd_source_appearances``. Per-user endpoint: this user's ``user_ref_id`` only. Team endpoint: sum across joined members' ``user_ref_id`` values.
       */
      references_used: number;
      /**
       * Sessions With Evidence Queries
       * @description Distinct count of consult ``session_id`` values across non-deleted evidence-mode chats that have at least one user-authored query (``messages.role == "user"``) and a non-null ``session_id``. A session that is linked from multiple evidence chats is counted once. Per-user endpoint: this user's chats only. Team endpoint: de-duped across all joined members' chats.
       */
      sessions_with_evidence_queries: number;
    };
    /**
     * ExclusionActionResponse
     * @description Response after modifying an exclusion.
     */
    ExclusionActionResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
      /** User Ref Id */
      user_ref_id: string;
      scope?: components['schemas']['ExclusionScope'] | null;
      /** Target Id */
      target_id?: string | null;
    };
    /**
     * ExclusionResponse
     * @description Response for an exclusion.
     */
    ExclusionResponse: {
      /** User Ref Id */
      user_ref_id: string;
      scope: components['schemas']['ExclusionScope'];
      /** Target Id */
      target_id: string;
      /** Reason */
      reason?: string | null;
      /** Excluded By */
      excluded_by?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * ExclusionScope
     * @description Scope of a competition exclusion.
     * @enum {string}
     */
    ExclusionScope: ExclusionScope;
    /**
     * ExclusionsListResponse
     * @description Response listing exclusions.
     */
    ExclusionsListResponse: {
      /** Exclusions */
      exclusions: components['schemas']['ExclusionResponse'][];
      /** Total */
      total: number;
    };
    /** ExecuteCalculatorRequest */
    ExecuteCalculatorRequest: {
      /**
       * Parameters
       * @description Calculator-specific input parameters
       */
      parameters: {
        [key: string]: unknown;
      };
    };
    /** ExecuteCalculatorResponse */
    ExecuteCalculatorResponse: {
      /** Success */
      success: boolean;
      /** Calculator */
      calculator?: string | null;
      /** Score */
      score?: number | null;
      /** Unit */
      unit?: string | null;
      /** Category */
      category?: string | null;
      /** Risk Category */
      risk_category?: string | null;
      /** Interpretation */
      interpretation?: string | null;
      /** Formula */
      formula?: string | null;
      /** Formula Human */
      formula_human?: string | null;
      /** Formula Machine */
      formula_machine?: string | null;
      /** Reference */
      reference?: {
        [key: string]: unknown;
      } | null;
      /** Criteria Breakdown */
      criteria_breakdown?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Evaluated Inputs */
      evaluated_inputs?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Evaluated Terms */
      evaluated_terms?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Error */
      error?: string | null;
      /** Is Retryable */
      is_retryable?: boolean | null;
    };
    /** ExecuteExperimentResponse */
    ExecuteExperimentResponse: {
      /** Id */
      id: string;
      /** Status */
      status: string;
      /** Total Samples */
      total_samples: number;
      /** Successful */
      successful: number;
      /** Failed */
      failed: number;
      /** Elapsed Seconds */
      elapsed_seconds: number;
      /** Results */
      results: {
        [key: string]: unknown;
      }[];
      /** Execution Log */
      execution_log?: {
        [key: string]: unknown;
      }[];
      /** Note */
      note?: string | null;
    };
    /**
     * ExecuteScriptRequest
     * @description Request schema for executing a script.
     */
    ExecuteScriptRequest: {
      /**
       * Script Name
       * @description Name of the script to execute (must be in whitelist)
       * @example migrate_organization_sso_connections
       */
      script_name: string;
      /**
       * Params
       * @description Parameters to pass to the script (key-value pairs)
       * @example {
       *       "dry_run": true
       *     }
       */
      params?: {
        [key: string]: unknown;
      };
      /**
       * Async Execution
       * @description If True, run the script fire-and-forget and return 202 Accepted with an execution_id. Use for scripts that may exceed the upstream load balancer idle timeout (~15 min on dev). The script's result lands in logs keyed by execution_id rather than in the HTTP response.
       * @default false
       */
      async_execution: boolean;
    };
    /**
     * ExecuteScriptResponse
     * @description Response schema for successful synchronous script execution.
     *
     *     Note: Errors are returned as HTTP 400/500 with ErrorResponse model.
     */
    ExecuteScriptResponse: {
      /**
       * Success
       * @description Whether the script executed successfully
       */
      success: boolean;
      /**
       * Script Name
       * @description Name of the executed script
       */
      script_name: string;
      /**
       * Error Message
       * @description Error message if execution failed
       */
      error_message?: string | null;
      /**
       * Executed At
       * Format: date-time
       * @description Timestamp when the script was executed
       */
      executed_at: string;
      /**
       * Params Received
       * @description Parameters that were passed to the script
       */
      params_received: {
        [key: string]: unknown;
      };
      /**
       * Result
       * @description Optional output data from the script
       */
      result?: unknown;
    };
    /** ExpandableFact */
    ExpandableFact: {
      /** Id */
      id: string;
      /** Search Text */
      search_text: string;
      /** Detail */
      detail: string;
      /** Source Label */
      source_label: string;
    };
    /** ExperimentListResponse */
    ExperimentListResponse: {
      /** Experiments */
      experiments: components['schemas']['ExperimentResponse'][];
      /** Total */
      total: number;
    };
    /** ExperimentResponse */
    ExperimentResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      /** Experiment Type */
      experiment_type: string;
      /** Status */
      status: string;
      /** Created By */
      created_by: string;
      /** Workflow */
      workflow: {
        [key: string]: unknown;
      };
      /** Config */
      config: {
        [key: string]: unknown;
      };
      /** Results */
      results: {
        [key: string]: unknown;
      }[];
      /** Summary */
      summary: {
        [key: string]: unknown;
      } | null;
      /** Runs */
      runs?: {
        [key: string]: unknown;
      }[];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * ExportAssetType
     * @description Type of export asset (header logo, footer logo, signature).
     * @enum {string}
     */
    ExportAssetType: ExportAssetType;
    /**
     * ExportAssetUrlRequest
     * @description Request for getting a presigned URL for export asset upload/download.
     */
    ExportAssetUrlRequest: {
      asset_type: components['schemas']['ExportAssetType'];
      /** @default put_object */
      method: components['schemas']['S3PresignedUrlMethod'];
      /**
       * Content Type
       * @default image/png
       */
      content_type: string;
      /** Team Id */
      team_id?: string | null;
    };
    /**
     * ExportAssetUrlResponse
     * @description Response containing the presigned URL and S3 object key.
     */
    ExportAssetUrlResponse: {
      /** Presigned Url */
      presigned_url: string;
      /** Object Key */
      object_key: string;
    };
    /** ExportCPDResponse */
    ExportCPDResponse: {
      /** Cpd Sources */
      cpd_sources: {
        [key: string]: unknown;
      }[];
      /** Cpd Source Appearances */
      cpd_source_appearances: {
        [key: string]: unknown;
      }[];
      /** Cpd Drafts */
      cpd_drafts: {
        [key: string]: unknown;
      }[];
      /** Cpd Submissions */
      cpd_submissions: {
        [key: string]: unknown;
      }[];
      /** Cpd Saved Sources */
      cpd_saved_sources: {
        [key: string]: unknown;
      }[];
      /** Total Count */
      total_count: number;
    };
    /** ExportCallsResponse */
    ExportCallsResponse: {
      /** Calls */
      calls: {
        [key: string]: unknown;
      }[];
      /** Total Count */
      total_count: number;
    };
    /** ExportChatIdsResponse */
    ExportChatIdsResponse: {
      /** Chat Ids */
      chat_ids: string[];
      /** Total Count */
      total_count: number;
    };
    /** ExportChatsChunkRequest */
    ExportChatsChunkRequest: {
      /** Chat Ids */
      chat_ids: string[];
    };
    /** ExportChatsChunkResponse */
    ExportChatsChunkResponse: {
      /** Chats */
      chats: {
        [key: string]: unknown;
      }[];
      /** Chat Message Records */
      chat_message_records: {
        [key: string]: unknown;
      }[];
    };
    /** ExportCollectionRequest */
    ExportCollectionRequest: {
      collection_type: components['schemas']['ValidRegionSyncCollectionTypes'];
    };
    /** ExportCollectionResponse */
    ExportCollectionResponse: {
      collection_type: components['schemas']['ValidRegionSyncCollectionTypes'];
      /** Data */
      data: unknown[];
      /** Export Count */
      export_count: number;
    };
    /**
     * ExportDocumentCtaCategory
     * @description Stable slug for API clients (OpenAPI enum).
     * @enum {string}
     */
    ExportDocumentCtaCategory: ExportDocumentCtaCategory;
    /** ExportDocxRequest */
    ExportDocxRequest: {
      /** Content */
      content: string;
      content_type: components['schemas']['ContentType'];
      /** File Name */
      file_name: string;
      /** Session Id */
      session_id?: string | null;
      /** Font Family */
      font_family?: string | null;
      /** Font Size */
      font_size?: number | null;
      /**
       * Use Letterhead Editor
       * @default false
       */
      use_letterhead_editor: boolean;
    };
    /** ExportEvidenceResponse */
    ExportEvidenceResponse: {
      /** Shared Chats */
      shared_chats: {
        [key: string]: unknown;
      }[];
      /** Source Lists */
      source_lists: {
        [key: string]: unknown;
      }[];
      /** Presentations */
      presentations: {
        [key: string]: unknown;
      }[];
      /** Collections */
      collections: {
        [key: string]: unknown;
      }[];
      /** Document Ingestion Jobs */
      document_ingestion_jobs: {
        [key: string]: unknown;
      }[];
      /** Total Count */
      total_count: number;
    };
    /**
     * ExportHeaderFooterContent
     * @description Content settings for export header or footer.
     *
     *     Note: logo_url and signature_url store S3 object keys, not full URLs.
     *     Use the presigned URL endpoint to get temporary access URLs.
     */
    ExportHeaderFooterContent: {
      /** Logo Url */
      logo_url?: string | null;
      /**
       * Logo Alignment
       * @default left
       */
      logo_alignment: ExportHeaderFooterContentLogo_alignmentAnyOf0 | null;
      /** Text */
      text?: string | null;
      /**
       * Text Alignment
       * @default left
       */
      text_alignment: ExportHeaderFooterContentText_alignmentAnyOf0 | null;
      /** Signature Url */
      signature_url?: string | null;
      /**
       * Signature Alignment
       * @default left
       */
      signature_alignment: ExportHeaderFooterContentSignature_alignmentAnyOf0 | null;
      /** Signature Text */
      signature_text?: string | null;
      /** Signature Font */
      signature_font?: ExportHeaderFooterContentSignature_fontAnyOf0 | null;
      layout?: components['schemas']['ExportLayout'] | null;
    };
    /**
     * ExportLayout
     * @description v2 grid layout for export header/footer content.
     *
     *     When present it is the source of truth: the export renderer serializes this
     *     grid to nested tables and clients render it in place of the flat
     *     logo/text/signature fields (which stay dual-written for pre-v2 clients).
     */
    ExportLayout: {
      /**
       * Version
       * @default 2
       * @constant
       */
      version: 2;
      /** Rows */
      rows?: components['schemas']['ExportLayoutRow'][];
      /** Region Height Px */
      region_height_px?: number | null;
    };
    /**
     * ExportLayoutBlock
     * @description A single block inside a v2 export layout column (image/text/signature/spacer).
     */
    ExportLayoutBlock: {
      /**
       * Type
       * @enum {string}
       */
      type: ExportLayoutBlockType;
      /** Asset Key */
      asset_key?: string | null;
      /**
       * Align
       * @default left
       */
      align: ExportLayoutBlockAlignAnyOf0 | null;
      /** Max Height Px */
      max_height_px?: number | null;
      /** Width Pct */
      width_pct?: number | null;
      /** Offset X Pct */
      offset_x_pct?: number | null;
      /** Html */
      html?: string | null;
      /** Text */
      text?: string | null;
      /** Font */
      font?: ExportLayoutBlockFontAnyOf0 | null;
      /** Bold */
      bold?: boolean | null;
      /** Italic */
      italic?: boolean | null;
      /** Underline */
      underline?: boolean | null;
      /** Height Px */
      height_px?: number | null;
    };
    /**
     * ExportLayoutColumn
     * @description A column within a layout row, sized as a percentage of the row width.
     */
    ExportLayoutColumn: {
      /** Id */
      id: string;
      /** Width Pct */
      width_pct: number;
      block: components['schemas']['ExportLayoutBlock'];
    };
    /**
     * ExportLayoutRow
     * @description A single row in the v2 export layout grid.
     */
    ExportLayoutRow: {
      /** Id */
      id: string;
      /**
       * Vertical Align
       * @default top
       */
      vertical_align: ExportLayoutRowVertical_alignAnyOf0 | null;
      /** Columns */
      columns?: components['schemas']['ExportLayoutColumn'][];
    };
    /** ExportPatientProfilesResponse */
    ExportPatientProfilesResponse: {
      /** Patient Profiles */
      patient_profiles: {
        [key: string]: unknown;
      }[];
      /** Total Count */
      total_count: number;
      /** Patient Documents */
      patient_documents?: {
        [key: string]: unknown;
      }[];
    };
    /** ExportPdfRequest */
    ExportPdfRequest: {
      /** Content */
      content: string;
      content_type: components['schemas']['ContentType'];
      /** File Name */
      file_name: string;
      /** Session Id */
      session_id?: string | null;
      /**
       * Apply Letterhead Layout
       * @default false
       */
      apply_letterhead_layout: boolean;
    };
    /** ExportPersonalizationProfileResponse */
    ExportPersonalizationProfileResponse: {
      /** Personalization Profile */
      personalization_profile: {
        [key: string]: unknown;
      } | null;
    };
    /** ExportPresentationRequest */
    ExportPresentationRequest: {
      /**
       * Format
       * @default pptx
       */
      format: string;
    };
    /** ExportPresentationResponse */
    ExportPresentationResponse: {
      /** Download Url */
      download_url: string;
      /**
       * Format
       * @default pptx
       */
      format: string;
    };
    /** ExportRawChunkRequest */
    ExportRawChunkRequest: {
      /** User Ref Id */
      user_ref_id: string;
      /** Cursor */
      cursor?: string | null;
      /**
       * Limit
       * @default 500
       */
      limit: number;
    };
    /** ExportRawChunkResponse */
    ExportRawChunkResponse: {
      /** Records */
      records: {
        [key: string]: unknown;
      }[];
      /** Next Cursor */
      next_cursor?: string | null;
    };
    /** ExportSessionIdsResponse */
    ExportSessionIdsResponse: {
      /** Session Ids */
      session_ids: string[];
      /** Total Count */
      total_count: number;
    };
    /** ExportSessionsChunkRequest */
    ExportSessionsChunkRequest: {
      /** Session Ids */
      session_ids: string[];
      /** User Kinde Id */
      user_kinde_id?: string | null;
    };
    /** ExportSessionsChunkResponse */
    ExportSessionsChunkResponse: {
      /** Sessions */
      sessions: {
        [key: string]: unknown;
      }[];
      /** Consult Notes */
      consult_notes: {
        [key: string]: unknown;
      }[];
      /** Documents */
      documents: {
        [key: string]: unknown;
      }[];
      /** Context Documents */
      context_documents: {
        [key: string]: unknown;
      }[];
      /** Audio Transcripts */
      audio_transcripts: {
        [key: string]: unknown;
      }[];
      /** Consult Note Edits */
      consult_note_edits?: {
        [key: string]: unknown;
      }[];
      /** Consult Note Reverts */
      consult_note_reverts?: {
        [key: string]: unknown;
      }[];
      /** Clinical Tasks */
      clinical_tasks?: {
        [key: string]: unknown;
      }[];
      /** Session Shares */
      session_shares?: {
        [key: string]: unknown;
      }[];
      /** Note Suggestions */
      note_suggestions?: {
        [key: string]: unknown;
      }[];
      /** Recording Bundles */
      recording_bundles?: {
        [key: string]: unknown;
      }[];
    };
    /** ExportSnippetsResponse */
    ExportSnippetsResponse: {
      /** Snippets */
      snippets: {
        [key: string]: unknown;
      }[];
      /** Total Count */
      total_count: number;
    };
    /** ExportTeamRelationsResponse */
    ExportTeamRelationsResponse: {
      /** Team Relations */
      team_relations: components['schemas']['TeamRelationExport'][];
      /** Total Count */
      total_count: number;
    };
    /** ExportTemplatesResponse */
    ExportTemplatesResponse: {
      /** Templates */
      templates: {
        [key: string]: unknown;
      }[];
      /** Total Count */
      total_count: number;
      /** Shared Templates */
      shared_templates?: {
        [key: string]: unknown;
      }[];
    };
    /** ExportUserResponse */
    ExportUserResponse: {
      /** User */
      user: {
        [key: string]: unknown;
      };
    };
    /**
     * ExtendFreeTrialHours
     * @enum {integer}
     */
    ExtendFreeTrialHours: ExtendFreeTrialHours;
    /** ExtendFreeTrialRequest */
    ExtendFreeTrialRequest: {
      extend_hours: components['schemas']['ExtendFreeTrialHours'];
    };
    /** ExtendReverseTrialRequest */
    ExtendReverseTrialRequest: {
      /**
       * Hours
       * @description Number of hours to extend the trial by
       */
      hours: number;
    };
    /**
     * ExtendTrialAction
     * @description Add days to an existing trial.
     */
    ExtendTrialAction: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      action: ExtendTrialActionAction;
      /**
       * Additional Days
       * @default 7
       */
      additional_days: number;
    };
    /**
     * ExtendedSimpleTeam
     * @description Extends SimpleTeam with additional information including
     *     owner_email, created_at timestamp, and member_count
     */
    ExtendedSimpleTeam: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Country */
      country: string;
      /** Owner Kinde Id */
      owner_kinde_id?: string | null;
      /** Kinde Org Code */
      kinde_org_code?: string | null;
      mfa_info?: components['schemas']['TeamMFAInfo'] | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Custom Consent Text */
      custom_consent_text?: string | null;
      /** Hide Remember Consent Checkbox */
      hide_remember_consent_checkbox?: boolean | null;
      /** Require Review Confirmation */
      require_review_confirmation?: boolean | null;
      /**
       * Enable Patient Summary Generation
       * @default true
       */
      enable_patient_summary_generation: boolean;
      /**
       * Disable Auto Extract
       * @default false
       */
      disable_auto_extract: boolean;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      /** Onboarding Free Text */
      onboarding_free_text?: string | null;
      /** Go Live Time Stamp */
      go_live_time_stamp?: string | null;
      /** Parent Id */
      parent_id?: string | null;
      /** Org Id */
      org_id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Org Override Fields */
      org_override_fields?:
        | components['schemas']['OrganizationOverrideTeamSettingField'][]
        | null;
      /**
       * Is Stripe Managed
       * @default true
       */
      is_stripe_managed: boolean;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[];
      /**
       * Enable Export Header
       * @default false
       */
      enable_export_header: boolean;
      export_header_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /**
       * Enable Export Footer
       * @default false
       */
      enable_export_footer: boolean;
      export_footer_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /** @default FREE */
      evidence_tier: components['schemas']['EvidenceSubscriptionTier'];
      /**
       * Evidence Is Stripe Managed
       * @default false
       */
      evidence_is_stripe_managed: boolean;
      /** Evidence Plan End Date */
      evidence_plan_end_date?: string | null;
      /**
       * Evidence Access
       * @default false
       */
      evidence_access: boolean;
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
      /** Owner Email */
      owner_email?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Member Count */
      member_count?: number | null;
    };
    /** ExtensionTask */
    ExtensionTask: {
      /** @description Task identifier */
      id: components['schemas']['ExtensionTaskId'];
      /**
       * Title
       * @description Display title
       */
      title: string;
      /** @description Icon identifier for the task */
      icon: components['schemas']['TaskIcon'];
      /** @description Type of task (boolean or counter) */
      task_type: components['schemas']['TaskType'];
      /**
       * Current
       * @description Current progress
       */
      current: number;
      /**
       * Target
       * @description Target value to complete
       */
      target: number;
      /**
       * Completed
       * @description Whether task is complete
       */
      completed: boolean;
      action_type?: components['schemas']['ActionType'] | null;
      /** Action Url */
      action_url?: string | null;
    };
    /**
     * ExtensionTaskId
     * @description Task identifiers for trial extension tasks.
     * @enum {string}
     */
    ExtensionTaskId: ExtensionTaskId;
    /** ExternalOrgGenerateJWTResponse */
    ExternalOrgGenerateJWTResponse: {
      /** Token */
      token: string;
      /**
       * Expiration Time
       * Format: date-time
       */
      expiration_time: string;
    };
    /** ExternalOrganization */
    ExternalOrganization: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Api Key */
      api_key: string;
      /** Team Ids */
      team_ids: string[];
      /** Is Active */
      is_active: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** ExternalOrganizationResponse */
    ExternalOrganizationResponse: {
      external_organization: components['schemas']['ExternalOrganization'];
    };
    /** ExternalOrganizationSessionView */
    ExternalOrganizationSessionView: {
      /** User Email */
      user_email: string;
      /** Session Id */
      session_id: string;
      /**
       * Session Created At
       * Format: date-time
       */
      session_created_at: string;
      /** Transcript */
      transcript: string;
    };
    /** ExternalSessionChunkSummary */
    ExternalSessionChunkSummary: {
      /** Total */
      total: number;
      /** Transcribed */
      transcribed: number;
    };
    /** ExternalSessionResponse */
    ExternalSessionResponse: {
      /** External Session Id */
      external_session_id: string;
      /** Ehr Provider */
      ehr_provider: string;
      /** Mobile Provider */
      mobile_provider: string;
      /** Status */
      status: string;
      /** Linked Session Id */
      linked_session_id?: string | null;
      /** Linked User Id */
      linked_user_id?: string | null;
      /** Patient Id */
      patient_id?: string | null;
      /** Encounter Id */
      encounter_id?: string | null;
      /** Appointment Id */
      appointment_id?: string | null;
      /** User Id */
      user_id?: string | null;
      /** Profile Name */
      profile_name?: string | null;
      /** Latest Finalized Recording Id */
      latest_finalized_recording_id?: number | null;
      chunks_summary: components['schemas']['ExternalSessionChunkSummary'];
      /** Note Type */
      note_type?: string | null;
      /** Available Note Sections */
      available_note_sections?: string[] | null;
      /** Care Context */
      care_context?: string | null;
      /** Patient Mrn */
      patient_mrn?: string | null;
      /** Encounter Csn */
      encounter_csn?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
    };
    /** ExternalSource */
    ExternalSource: {
      source_name: components['schemas']['ExternalSourceName'];
      /** Id */
      id: string;
    };
    /**
     * ExternalSourceName
     * @enum {string}
     */
    ExternalSourceName: ExternalSourceName;
    /**
     * ExtractChartContextResponse
     * @description Clinical context scraped from the *current* EHR chart snapshot.
     *
     *     Identity is verified separately via ``verify_patient``. This task only
     *     copies visible clinical text and suggests ``next_targets`` (tabs/nav) for
     *     fields not on this snapshot. Empty ``patient`` (or failed grounding) means
     *     the chart could not be read — callers should escalate.
     */
    ExtractChartContextResponse: {
      /**
       * Patient
       * @default
       */
      patient: string;
      /**
       * History
       * @default
       */
      history: string;
      /**
       * Medications
       * @default
       */
      medications: string;
      /**
       * Allergies
       * @default
       */
      allergies: string;
      /** Next Targets */
      next_targets?: components['schemas']['ChartContextNextTarget'][];
    };
    /** ExtractDocumentContentResponse */
    ExtractDocumentContentResponse: {
      /** Content */
      content: string;
    };
    /**
     * ExtractFormFieldsResponse
     * @description Response from PDF form field extraction
     */
    ExtractFormFieldsResponse: {
      /** Success */
      success: boolean;
      /** Fields */
      fields: components['schemas']['FormField'][];
      /** @default pdf */
      form_format: components['schemas']['FormFormat'];
      /** Page Count */
      page_count: number;
      /** Updated Pdf Base64 */
      updated_pdf_base64?: string | null;
      /** Xml Source */
      xml_source?: string | null;
    };
    /**
     * ExtractScheduleResponse
     * @description Validated/corrected appointment list; empty when not a schedule.
     */
    ExtractScheduleResponse: {
      /** Appointments */
      appointments?: components['schemas']['AxAssistAppointment'][];
    };
    /** ExtractedPatientProfileField[EmailStr] */
    ExtractedPatientProfileField_EmailStr_: {
      /** Value */
      value?: string | null;
      /** Source Quotes */
      source_quotes?: string[] | null;
      /** @default pending */
      status: components['schemas']['FieldStatus'] | null;
    };
    /** ExtractedPatientProfileField[Gender] */
    ExtractedPatientProfileField_Gender_: {
      value?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** Source Quotes */
      source_quotes?: string[] | null;
      /** @default pending */
      status: components['schemas']['FieldStatus'] | null;
    };
    /** ExtractedPatientProfileField[PhoneNumber] */
    ExtractedPatientProfileField_PhoneNumber_: {
      /** Value */
      value?: string | null;
      /** Source Quotes */
      source_quotes?: string[] | null;
      /** @default pending */
      status: components['schemas']['FieldStatus'] | null;
    };
    /** ExtractedPatientProfileField[date] */
    ExtractedPatientProfileField_date_: {
      /** Value */
      value?: string | null;
      /** Source Quotes */
      source_quotes?: string[] | null;
      /** @default pending */
      status: components['schemas']['FieldStatus'] | null;
    };
    /** ExtractedPatientProfileField[str] */
    ExtractedPatientProfileField_str_: {
      /** Value */
      value?: string | null;
      /** Source Quotes */
      source_quotes?: string[] | null;
      /** @default pending */
      status: components['schemas']['FieldStatus'] | null;
    };
    /** ExtractionDocumentInput */
    ExtractionDocumentInput: {
      /** Document Index */
      document_index: number;
      /**
       * Text
       * @description Document body sent to clinical coding inference. May include ``### Page N`` line fences (one per line) for page attribution; fence lines are passed to the model as-is. Returned ``text_start`` / ``text_end`` offsets are in this submitted string's coordinate space when anchoring succeeds; omitted when provenance cannot be mapped.
       */
      text: string;
    };
    /**
     * FHIRVersion
     * @description All published FHIR versions.
     *
     *     https://hl7.org/fhir/R4/valueset-FHIR-version.html
     * @enum {string}
     */
    FHIRVersion: FHIRVersion;
    /**
     * FailedIntegrationOnboardingExecutionStep
     * @description Integration onboarding step with a failed status.
     *
     *     In this state there is error and no result.
     */
    FailedIntegrationOnboardingExecutionStep: {
      /** Step Id */
      step_id: string;
      step_type: components['schemas']['StepType'];
      /** Step Number */
      step_number: number;
      /** Details */
      details: {
        [key: string]: unknown;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /** Payload */
      payload?: {
        [key: string]: unknown;
      } | null;
      /** Result */
      result?: {
        [key: string]: unknown;
      } | null;
      /** Internal Result */
      internal_result?: {
        [key: string]: unknown;
      } | null;
      /**
       * Status
       * @default failed
       * @constant
       */
      status: 'failed';
      /** Error */
      error: {
        [key: string]: unknown;
      };
    };
    /** FailedTaskItem */
    FailedTaskItem: {
      /** Task Key */
      task_key: string;
      /** Error Code */
      error_code: string | null;
      /** Error Message */
      error_message: string | null;
      /** Attempts */
      attempts: number | null;
    };
    /**
     * FamilyHistoryStatus
     * @description A code that identifies the status of the family history record.
     *
     *     https://hl7.org/fhir/R4/valueset-history-status.html
     * @enum {string}
     */
    FamilyHistoryStatus: FamilyHistoryStatus;
    /**
     * FamilyMemberHistory
     * @description Significant health conditions for a person related to the patient relevant in the context of care for the patient.
     *
     *     https://hl7.org/fhir/R4/familymemberhistory-definitions.html
     */
    FamilyMemberHistory: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * External Id(s) for this record
       * @description Business identifiers assigned to this family member history by the performer or other systems which remain constant as the resource is updated and propagates from server to server.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Instantiates FHIR protocol or definition
       * @description The URL pointing to a FHIR-defined protocol, guideline, orderset or other definition that is adhered to in whole or in part by this FamilyMemberHistory.
       */
      instantiatesCanonical?: string[] | null;
      /**
       * Instantiates external protocol or definition
       * @description The URL pointing to an externally maintained protocol, guideline, orderset or other definition that is adhered to in whole or in part by this FamilyMemberHistory.
       */
      instantiatesUri?: string[] | null;
      /**
       * partial | completed | entered-in-error | health-unknown
       * @description A code specifying the status of the record of the family history of a specific family member.
       */
      status: components['schemas']['FamilyHistoryStatus'];
      /**
       * subject-unknown | withheld | unable-to-obtain | deferred
       * @description Describes why the family member's history is not available.
       */
      dataAbsentReason?: components['schemas']['CodeableConcept'] | null;
      /**
       * Patient history is about
       * @description The person who this history concerns.
       */
      patient: components['schemas']['Reference'];
      /**
       * When history was recorded or last updated
       * @description The date (and possibly time) when the family member history was recorded or last updated.
       */
      date?: string | null;
      /**
       * The family member described
       * @description This will either be a name or a description; e.g. "Aunt Susan", "my cousin with the red hair".
       */
      name?: string | null;
      /**
       * Relationship to the subject
       * @description The type of relationship this person has to the patient (father, mother, brother etc.).
       */
      relationship: components['schemas']['CodeableConcept'];
      /**
       * male | female | other | unknown
       * @description The birth sex of the family member.
       */
      sex?: components['schemas']['CodeableConcept'] | null;
      /**
       * (approximate) date of birth
       * @description The actual or approximate date of birth of the relative.
       */
      bornPeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * (approximate) date of birth
       * @description The actual or approximate date of birth of the relative.
       */
      bornDate?: string | null;
      /**
       * (approximate) date of birth
       * @description The actual or approximate date of birth of the relative.
       */
      bornString?: string | null;
      /**
       * (approximate) age
       * @description The age of the relative at the time the family member history is recorded.
       */
      ageAge?: components['schemas']['Age'] | null;
      /**
       * (approximate) age
       * @description The age of the relative at the time the family member history is recorded.
       */
      ageRange?: components['schemas']['Range'] | null;
      /**
       * (approximate) age
       * @description The age of the relative at the time the family member history is recorded.
       */
      ageString?: string | null;
      /**
       * Age is estimated?
       * @description If true, indicates that the age value specified is an estimated value.
       */
      estimatedAge?: boolean | null;
      /**
       * Dead? How old/when?
       * @description Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record.
       */
      deceasedBoolean?: boolean | null;
      /**
       * Dead? How old/when?
       * @description Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record.
       */
      deceasedAge?: components['schemas']['Age'] | null;
      /**
       * Dead? How old/when?
       * @description Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record.
       */
      deceasedRange?: components['schemas']['Range'] | null;
      /**
       * Dead? How old/when?
       * @description Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record.
       */
      deceasedDate?: string | null;
      /**
       * Dead? How old/when?
       * @description Deceased flag or the actual or approximate age of the relative at the time of death for the family member history record.
       */
      deceasedString?: string | null;
      /**
       * Why was family member history performed?
       * @description Describes why the family member history occurred in coded or textual form.
       */
      reasonCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Why was family member history performed?
       * @description Indicates a Condition, Observation, AllergyIntolerance, or QuestionnaireResponse that justifies this family member history event.
       */
      reasonReference?: components['schemas']['Reference'][] | null;
      /**
       * General note about related person
       * @description This property allows a non coded note to the name of the relation.
       */
      note?: components['schemas']['Annotation'][] | null;
      /**
       * Condition that the related person had
       * @description The significant Conditions (or condition) that the family member had. This is a repeating section to allow a system to represent more than one condition per resource, though there is nothing stopping multiple resources - one per condition.
       */
      condition?: components['schemas']['FamilyMemberHistoryCondition'][] | null;
    };
    /**
     * FamilyMemberHistoryCondition
     * @description The significant Conditions (or condition) that the family member had.
     *
     *     https://hl7.org/fhir/R4/familymemberhistory-definitions.html#FamilyMemberHistory.condition
     */
    FamilyMemberHistoryCondition: {
      /**
       * Condition suffered by relation
       * @description The actual condition specified. Could be a coded condition (like MI orEli) a partially described condition or even just a general condition.
       */
      code: components['schemas']['CodeableConcept'];
      /**
       * deceased | permanent disability | etc.
       * @description Indicates what happened following the condition. If the condition resulted in death, deceased date is captured on the relation.
       */
      outcome?: components['schemas']['CodeableConcept'] | null;
      /**
       * Whether the condition contributed to the cause of death
       * @description This condition contributed to the cause of death of the related person. If contributedToDeath is not populated, then it is unknown.
       */
      contributedToDeath?: boolean | null;
      /**
       * When condition first manifested
       * @description Either the age of onset, range of approximate age or descriptive string can be recorded. For conditions with multiple occurrences, this describes the first known occurrence.
       */
      onsetAge?: components['schemas']['Age'] | null;
      /**
       * When condition first manifested
       * @description Either the age of onset, range of approximate age or descriptive string can be recorded. For conditions with multiple occurrences, this describes the first known occurrence.
       */
      onsetRange?: components['schemas']['Range'] | null;
      /**
       * When condition first manifested
       * @description Either the age of onset, range of approximate age or descriptive string can be recorded. For conditions with multiple occurrences, this describes the first known occurrence.
       */
      onsetPeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * When condition first manifested
       * @description Either the age of onset, range of approximate age or descriptive string can be recorded. For conditions with multiple occurrences, this describes the first known occurrence.
       */
      onsetString?: string | null;
      /**
       * Extra information about condition
       * @description An area where general notes can be placed about this specific condition.
       */
      note?: components['schemas']['Annotation'][] | null;
    };
    /** FeatureDefinitionSchema */
    FeatureDefinitionSchema: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Prompt Variables */
      prompt_variables: components['schemas']['PromptVariableSchema'][];
      /** Session Data */
      session_data: components['schemas']['SessionDataFieldSchema'][];
    };
    /** FeatureFlagDomainModel */
    FeatureFlagDomainModel: {
      name: components['schemas']['FeatureFlagKey'];
      /** Is Enabled */
      is_enabled: boolean;
      /** Value */
      value?: string | null;
    };
    /**
     * FeatureFlagKey
     * @enum {string}
     */
    FeatureFlagKey: FeatureFlagKey;
    /** FeatureRegistryResponse */
    FeatureRegistryResponse: {
      /** Features */
      features: components['schemas']['FeatureDefinitionSchema'][];
    };
    /** Feedback */
    Feedback: {
      rating: components['schemas']['CSATRating'];
      /** Feedback */
      feedback?: components['schemas']['FeedbackRatingReason'][];
      /**
       * Detail
       * @default
       */
      detail: string;
      /**
       * Updated
       * Format: date-time
       */
      updated?: string;
    };
    /**
     * FeedbackCategory
     * @description Flat reason taxonomy collected by the categories feedback form.
     * @enum {string}
     */
    FeedbackCategory: FeedbackCategory;
    /** FeedbackFormRequest */
    FeedbackFormRequest: {
      rating: components['schemas']['CSATRating'];
      /** Feedback */
      feedback?: components['schemas']['FeedbackRatingReason'][];
      /**
       * Detail
       * @default
       */
      detail: string;
      /**
       * Updated
       * Format: date-time
       */
      updated?: string;
    };
    /**
     * FeedbackRating
     * @enum {string}
     */
    FeedbackRating: FeedbackRating;
    /** FeedbackRatingReason */
    FeedbackRatingReason: {
      /** Reason */
      reason: string;
    };
    /**
     * FeedbackTargetType
     * @enum {string}
     */
    FeedbackTargetType: FeedbackTargetType;
    /**
     * FeedbackType
     * @example flowsheetsUpdated
     * @example scheduled
     */
    FeedbackType: string;
    /** FeedbackV2 */
    FeedbackV2: {
      rating: components['schemas']['ThumbRating'];
      /** User Feedback */
      user_feedback?: string | null;
      /** Reasons */
      reasons?: components['schemas']['FeedbackRatingReason'][];
      /**
       * Mode
       * @description Resolved chat mode: legacy or evidence (not auto)
       */
      mode?: FeedbackV2ModeAnyOf0 | null;
      /**
       * Is Safety Issue
       * @default false
       */
      is_safety_issue: boolean;
      /** Safety Issue Ticket Reference */
      safety_issue_ticket_reference?: string | null;
    };
    /**
     * FhirClinicalDocStatus
     * @enum {string}
     */
    FhirClinicalDocStatus: FhirClinicalDocStatus;
    /**
     * FhirClinicalNoteTypes
     * @enum {string}
     */
    FhirClinicalNoteTypes: FhirClinicalNoteTypes;
    /**
     * FieldStatus
     * @enum {string}
     */
    FieldStatus: FieldStatus;
    /**
     * FieldUpdate
     * @description A single field update request.
     */
    FieldUpdate: {
      /**
       * Id
       * @description Field ID to update (field_name)
       */
      id: string;
      /**
       * Field Value
       * @description New value for the field
       */
      field_value: string;
      /** @description Optional per-document field type override; must be a valid PdfFieldType value */
      field_type?: components['schemas']['PdfFieldType'] | null;
      /**
       * Choice Values
       * @description Optional per-document choice values override for validation/rendering
       */
      choice_values?: string[] | null;
      /**
       * Font Size
       * @description Optional per-document font size override in points. 0 means Auto; omit/None means no change to any existing override
       */
      font_size?: number | null;
    };
    /** FileUploadResult */
    FileUploadResult: {
      /** Error Rows */
      error_rows?: components['schemas']['FileUploadRow'][];
      /** Skip Rows */
      skip_rows?: components['schemas']['FileUploadRow'][];
      /** Inserted Rows */
      inserted_rows?: components['schemas']['FileUploadRow'][];
      /** Updated Rows */
      updated_rows?: components['schemas']['FileUploadRow'][];
    };
    /** FileUploadRow */
    FileUploadRow: {
      /**
       * Row
       * @description row number, start from 2 (the same as csv row number, skip header and start from 1)
       */
      row: number;
      /**
       * Msg
       * @description validate message
       */
      msg: string;
      /**
       * Data
       * @description data of the row
       */
      data: {
        [key: string]: unknown;
      };
      /** @description pydantic model validated from data */
      model?: components['schemas']['BaseModel'] | null;
    };
    /** FileValidateResult */
    FileValidateResult: {
      /** Error Rows */
      error_rows?: components['schemas']['FileUploadRow'][];
      /** Skip Rows */
      skip_rows?: components['schemas']['FileUploadRow'][];
      /** New Rows */
      new_rows?: components['schemas']['FileUploadRow'][];
      /** Update Rows */
      update_rows?: components['schemas']['FileUploadRow'][];
    };
    /**
     * FiledTemplate
     * @description A flowsheet template that was filed by the user.
     */
    FiledTemplate: {
      /** Templateid */
      templateId?:
        | components['schemas']['dataclass__nebula_session__models__IDType'][]
        | null;
      /** Valuesaccepted */
      valuesAccepted?: string | null;
      /** Filingcolumn */
      filingColumn?: string | null;
      /** Discarded */
      discarded?: boolean | null;
      /** Discardedat */
      discardedAt?: string | null;
    };
    /**
     * FillFormDemoRequest
     * @description Request for unauthenticated PDF form-template fill demo on the community details page.
     *
     *     The s3_object_key MUST point to a PDF in the public template-gallery bucket
     *     (system-template-pdfs/ or template-gallery-pdfs/ prefix). The endpoint will
     *     reject keys outside that allow-list to prevent arbitrary read access.
     *
     *     The transcript is sent verbatim to the LLM; only structured identity
     *     placeholders in the prompt are cleared for this path—not the transcript text.
     */
    FillFormDemoRequest: {
      /**
       * S3 Object Key
       * @description S3 object key for the form-template PDF. Must reside in the public template-gallery bucket (system-template-pdfs/ or template-gallery-pdfs/ prefix).
       */
      s3_object_key: string;
      /**
       * Form Fields
       * @description Form fields detected on the template (passed through from FE).
       */
      form_fields: components['schemas']['FormField'][];
      /**
       * Transcript
       * @description Consultation transcript to extract field values from. Passed verbatim to the LLM (not anonymised); may contain identifiable or sensitive content.
       */
      transcript: string;
      /**
       * Specialty Name
       * @description Specialty context reserved for future form filling prompt improvements.
       */
      specialty_name?: string | null;
      /**
       * Country
       * @description Country code/context used for form filling prompt context.
       */
      country?: string | null;
      /**
       * Language
       * @description Language code/context used for form filling prompt context.
       */
      language?: string | null;
    };
    /**
     * FillFormDemoResponse
     * @description Response for PDF form-template fill demo endpoints.
     */
    FillFormDemoResponse: {
      /**
       * Filled Pdf Base64
       * @description Base64-encoded filled PDF content for immediate inline preview.
       */
      filled_pdf_base64: string;
      /**
       * Filled Pdf Mime Type
       * @description MIME type for the filled PDF payload.
       * @default application/pdf
       */
      filled_pdf_mime_type: string;
    };
    /**
     * FillJsonFormDemoRequest
     * @description Request for the unauthenticated JSON form-template fill demo.
     *
     *     The document lives in ``json_source`` (there is no S3 object). The
     *     transcript is sent verbatim to the LLM.
     */
    FillJsonFormDemoRequest: {
      /**
       * Json Source
       * @description JSON form document published on the template gallery.
       */
      json_source: string;
      /**
       * Form Fields
       * @description Form fields detected on the template (passed through from FE).
       */
      form_fields: components['schemas']['FormField'][];
      /**
       * Transcript
       * @description Consultation transcript to extract field values from. Passed verbatim to the LLM (not anonymised); may contain identifiable or sensitive content.
       */
      transcript: string;
      /**
       * Specialty Name
       * @description Specialty context reserved for future form filling prompt improvements.
       */
      specialty_name?: string | null;
      /**
       * Country
       * @description Country code/context used for form filling prompt context.
       */
      country?: string | null;
      /**
       * Language
       * @description Language code/context used for form filling prompt context.
       */
      language?: string | null;
    };
    /**
     * FillJsonFormDemoResponse
     * @description Filled JSON plus the field values used to render the community preview.
     */
    FillJsonFormDemoResponse: {
      /**
       * Filled Json
       * @description JSON document with extracted values written onto each field.
       */
      filled_json: string;
      /**
       * Field Values
       * @description Filled values keyed by form field name, for the on-page preview.
       */
      field_values: {
        [key: string]: string;
      };
    };
    /**
     * FilledPdfField
     * @description A single field in a filled PDF document.
     */
    FilledPdfField: {
      /**
       * Id
       * @description Unique field identifier (field_name)
       */
      id: string;
      /**
       * Field Name
       * @description Internal field name
       */
      field_name: string;
      /**
       * Field Label
       * @description Human-readable label for display
       */
      field_label: string;
      /**
       * Field Type
       * @description PyMuPDF field type: Text, CheckBox, RadioButton, ComboBox, ListBox, Signature, Button
       */
      field_type: string;
      /**
       * Field Value
       * @description Current field value
       */
      field_value: string;
      /**
       * Choice Values
       * @description Available options for dropdown/choice fields
       */
      choice_values?: string[] | null;
      /**
       * Font Size
       * @description Per-document font size override in points when set. 0 means Auto. Template defaults are not returned here.
       */
      font_size?: number | null;
      /**
       * Page
       * @description Page number where field appears (1-indexed)
       */
      page: number;
      /** @description Position on PDF page in points (x0, y0, x1, y1) */
      rect?: components['schemas']['PdfFormFieldRect'] | null;
    };
    /** FilterDimension */
    FilterDimension: {
      /** Field */
      field: string;
      /** Values */
      values: string[];
    };
    /** FilterFieldInfo */
    FilterFieldInfo: {
      /** Key */
      key: string;
      /** Type */
      type: string;
    };
    /** FindandReplaceRequest */
    FindandReplaceRequest: {
      scope: components['schemas']['FindandReplaceScope'];
      /** Find And Replace */
      find_and_replace: {
        [key: string]: string;
      };
      /**
       * Ignore Case
       * @default true
       */
      ignore_case: boolean;
      /**
       * Partial Match
       * @default false
       */
      partial_match: boolean;
    };
    /**
     * FindandReplaceScope
     * @enum {string}
     */
    FindandReplaceScope: FindandReplaceScope;
    /** FinishRecordingResponse */
    FinishRecordingResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /**
     * FinishSignupRequestDTO
     * @description Request DTO for finish signup endpoint.
     *
     *     This DTO is used by regional ml-scribe servers to call the identity broker
     *     finish signup API after user get/create.
     * @example {
     *       "region": "EU",
     *       "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *     }
     */
    FinishSignupRequestDTO: {
      /**
       * User Ref Id
       * @description User's unique identifier (from token claims)
       */
      user_ref_id: string;
      /**
       * Region
       * @description Region code for verification (e.g., 'EU', 'US', 'AU')
       */
      region: string;
      /**
       * Skip Drift Check
       * @description Opt-out for the observational region-drift check. Deliberate region migrations (e.g. /change-provider-regions) intentionally set the region to a new value, so emitting REGION_DRIFT_DETECTED for those calls would generate false-positive alerts. Defaults to False (drift check runs).
       * @default false
       */
      skip_drift_check: boolean;
    };
    /**
     * FinishSignupResponseDTO
     * @description Response DTO for finish signup endpoint.
     *
     *     Contains the result of the finish signup operation including the updated
     *     identity profile if successful.
     * @example {
     *       "identity_profile": {
     *         "auth0_sync_state": "region_sync_completed",
     *         "email": "user@example.com",
     *         "region": "eu",
     *         "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *       },
     *       "success": true
     *     }
     * @example {
     *       "message": "Identity profile not found for user_ref_id",
     *       "success": false
     *     }
     */
    FinishSignupResponseDTO: {
      /**
       * Success
       * @description Whether the operation succeeded
       */
      success: boolean;
      /** @description Updated identity profile (present on success) */
      identity_profile?: components['schemas']['SaveIdentityProfileResponseDTO'] | null;
      /**
       * Message
       * @description Optional message with additional details (e.g., error reason)
       */
      message?: string | null;
    };
    /**
     * FlagsmithDiagnostics
     * @description Bounded Flagsmith provider state reported by the authenticated client.
     */
    FlagsmithDiagnostics: {
      /** Provider Status */
      provider_status: string;
      /** Resolved */
      resolved: boolean;
    };
    /**
     * Flowsheet
     * @description A generated flowsheet object.
     *
     *     Uses ``extra="allow"`` because the spec states
     *     "Unspecified GeneratedObject properties are expected."
     */
    Flowsheet: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: FlowsheetType;
      /** Uid */
      uid: string;
      data: components['schemas']['FlowsheetData'];
    } & {
      [key: string]: unknown;
    };
    /**
     * FlowsheetData
     * @description Container for all flowsheet data types.
     */
    FlowsheetData: {
      session: components['schemas']['FlowsheetSession'];
      transcript?: components['schemas']['Transcript'] | null;
      /** Observation */
      observation?:
        | components['schemas']['dataclass__nebula_session__generated_data__flowsheet__Observation'][]
        | null;
      /** Macro */
      macro?: components['schemas']['Macro'][] | null;
      /** Lda */
      lda?: components['schemas']['FlowsheetLDA'][] | null;
    };
    /**
     * FlowsheetFeedback
     * @description Flowsheet validation error feedback from Epic.
     *
     *     Uses ``extra="allow"`` per spec: "Unspecified GeneratedObject
     *     properties are expected."
     */
    FlowsheetFeedback: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: FlowsheetFeedbackType;
      /** Uid */
      uid: string;
      /** Sessionid */
      sessionId: string;
      /** Licensekey */
      licenseKey: string;
      data: components['schemas']['FlowsheetFeedbackData'];
    } & {
      [key: string]: unknown;
    };
    /**
     * FlowsheetFeedbackData
     * @description Container for flowsheet validation error details.
     *
     *     The ``is_recording_complete`` / ``is_available_for_review`` /
     *     ``latest_recording_id`` triplet was added in Epic's May 2026
     *     release. They are all optional so older organisations (which
     *     won't send them) keep validating cleanly.
     */
    FlowsheetFeedbackData: {
      /** Specversion */
      specVersion: string;
      /** Componenterrors */
      componentErrors?: components['schemas']['ComponentError'][] | null;
      /** Macroerrors */
      macroErrors?: components['schemas']['MacroError'][] | null;
      /** Ldaerrors */
      ldaErrors?: components['schemas']['LDAError'][] | null;
      /** Isrecordingcomplete */
      isRecordingComplete?: boolean | null;
      /** Isavailableforreview */
      isAvailableForReview?: boolean | null;
      /** Latestrecordingid */
      latestRecordingId?: string | null;
    };
    /**
     * FlowsheetLDA
     * @description An instance of an LDA group in generated flowsheet data.
     *
     *     Either ``lda_instance_id`` (existing LDA) or
     *     ``proxy_lda_instance_id`` (new LDA) should be provided.
     *     When ``lda_instance_id`` is absent, ``lda_group_id`` is required.
     *
     *     ``lda_instance_id`` and ``lda_group_id`` must be Epic INTERNAL id
     *     type values. How to verify this at runtime is unclear — the spec
     *     provides no mechanism to distinguish ID types from the string alone.
     *     TODO(INT): clarify ID type verification with Epic.
     */
    FlowsheetLDA: {
      /** Ldainstanceid */
      ldaInstanceId?: string | null;
      /** Proxyldainstanceid */
      proxyLdaInstanceId?: string | null;
      /** Ldagroupid */
      ldaGroupId?: string | null;
      /** Observation */
      observation?:
        | components['schemas']['dataclass__nebula_session__generated_data__flowsheet__Observation'][]
        | null;
      /** Macro */
      macro?: components['schemas']['Macro'][] | null;
    };
    /**
     * FlowsheetRow
     * @description A single flowsheet row with its filed value and metadata.
     */
    FlowsheetRow: {
      /** Rowid */
      rowId?: components['schemas']['dataclass__nebula_session__models__IDType'][] | null;
      /** Finalvalue */
      finalValue: string;
      /** Unit */
      unit?: string | null;
      /** Finalcomment */
      finalComment?: string | null;
      /**
       * Lastupdatedinstant
       * Format: date-time
       */
      lastUpdatedInstant: string;
      docSource: components['schemas']['EpicCategory'];
      docMethod?: components['schemas']['EpicCategory'] | null;
      /** Macroid */
      macroId?:
        | components['schemas']['dataclass__nebula_session__models__IDType'][]
        | null;
      /** Isvaluefromvoice */
      isValueFromVoice?: boolean | null;
      /** Lastupdatebyanotheruser */
      lastUpdateByAnotherUser?: boolean | null;
      /** Templateid */
      templateId?:
        | components['schemas']['dataclass__nebula_session__models__IDType'][]
        | null;
      ldaRowType?: components['schemas']['LDARowType'] | null;
      ldaActionType?: components['schemas']['LDAActionType'] | null;
    };
    /**
     * FlowsheetSession
     * @description Session metadata embedded in a flowsheet data response.
     */
    FlowsheetSession: {
      /** Sessionid */
      sessionId: string;
      /** Recordingid */
      recordingId?: string | null;
      status?: components['schemas']['FlowsheetSessionStatus'] | null;
    };
    /**
     * FlowsheetSessionStatus
     * @description Status values for a flowsheet session.
     *
     *     Set by Heidi when no data could be processed so that an error can be
     *     shown to the user.
     * @enum {string}
     */
    FlowsheetSessionStatus: FlowsheetSessionStatus;
    /** FlowsheetTemplateRequest */
    FlowsheetTemplateRequest: {
      /** Templateid */
      templateId: components['schemas']['IDTypeRequest'][];
      templateSource: components['schemas']['NebulaTemplateSource'];
      /** Isfiltered */
      isFiltered?: boolean | null;
    };
    /**
     * FlowsheetUpdated
     * @description Flowsheet feedback from Epic describing what was filed.
     *
     *     Uses ``extra="allow"`` per spec: "Unspecified GeneratedObject
     *     properties are expected."
     */
    FlowsheetUpdated: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: FlowsheetUpdatedType;
      /** Uid */
      uid: string;
      /** Sessionid */
      sessionId: string;
      /** Licensekey */
      licenseKey: string;
      data: components['schemas']['FlowsheetUpdatedData'];
    } & {
      [key: string]: unknown;
    };
    /**
     * FlowsheetUpdatedData
     * @description Container for flowsheet feedback details.
     *
     *     ``reviewed_version`` was added in Epic's May 2026 release. It is
     *     optional so older organisations that don't send it still validate.
     */
    FlowsheetUpdatedData: {
      feedbackType: components['schemas']['FeedbackType'];
      /** Specversion */
      specVersion?: string | null;
      /** Filingcolumn */
      filingColumn?: string | null;
      /** Templatesfiled */
      templatesFiled?: components['schemas']['FiledTemplate'][] | null;
      /** Documentedcomponents */
      documentedComponents?: components['schemas']['FlowsheetRow'][] | null;
      /** Documentedldas */
      documentedLdas?: components['schemas']['DocumentedLDAInstance'][] | null;
      /** Reviewedversion */
      reviewedVersion?: number | null;
    };
    /**
     * FlowsheetsContextRequest
     * @description PascalCase block. Each field overrides the camelCase alias_generator.
     */
    FlowsheetsContextRequest: {
      /** Environmentid */
      EnvironmentId: string;
      /** Templates */
      Templates?: components['schemas']['FlowsheetTemplateRequest'][] | null;
      /** Departmentid */
      DepartmentId?: components['schemas']['IDTypeRequest'][] | null;
      /** Patientldarecords */
      PatientLdaRecords?: components['schemas']['LDAInstanceRequest'][] | null;
      /** Availableldagroups */
      AvailableLdaGroups?: components['schemas']['AvailableLDAGroupRequest'][] | null;
      /** Timezone */
      Timezone: string;
      /** Exportversion */
      ExportVersion: string;
    };
    /**
     * FollowUpMetadata
     * @description Provenance for the follow-up questions shown on an assistant message.
     *
     *     In-memory mirror of ``FollowUpMetadataDO`` (``domains.chat.models.chat``)
     *     used by the internal-admin response schema. Field shapes match the DO so
     *     ``InternalAdminChatMessageMetadataResponse.model_validate(do.model_dump())``
     *     round-trips without losing follow-up provenance. Admin / observability
     *     only; never exposed via the product API.
     */
    FollowUpMetadata: {
      /** Model */
      model?: string | null;
      /** Provider */
      provider?: string | null;
      /** Usage */
      usage?: {
        [key: string]: number | null;
      } | null;
      /** Config */
      config?: {
        [key: string]: unknown;
      } | null;
      /** Response */
      response?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Submitted At */
      submitted_at?: string | null;
      /** Responded At */
      responded_at?: string | null;
      /** Time Taken Ms */
      time_taken_ms?: number | null;
    };
    /**
     * FollowUpQuestion
     * @description A single follow-up question suggestion.
     */
    FollowUpQuestion: {
      /**
       * Question
       * @description The follow-up question text
       */
      question: string;
      /**
       * Type
       * @description Type of follow-up: 'action', 'clarification', 'tool_suggestion', 'workflow_capture', 'workflow_update', or 'general'
       * @default general
       */
      type: string;
    };
    /**
     * FollowUpQuestionsRequest
     * @description Request model for generating follow-up questions.
     */
    FollowUpQuestionsRequest: {
      /**
       * Chatid
       * @description The chat ID
       */
      chatId: string;
      /**
       * Userquery
       * @description The user's query
       */
      userQuery: string;
      /**
       * Assistantresponse
       * @description The assistant's response
       */
      assistantResponse: string;
      /**
       * Toolcalls
       * @description List of tool call names that were made (e.g., 'web_search', 'evidence_search')
       */
      toolCalls?: string[] | null;
      /**
       * Specialty
       * @description User's medical specialty for context
       */
      specialty?: string | null;
      /**
       * Displaylanguage
       * @description User's display language code (e.g., 'en', 'es', 'fr') for generating questions in their preferred language
       */
      displayLanguage?: string | null;
    };
    /**
     * FollowUpQuestionsResponse
     * @description Response model for follow-up questions.
     */
    FollowUpQuestionsResponse: {
      /**
       * Questions
       * @description List of suggested follow-up questions
       */
      questions?: components['schemas']['FollowUpQuestion'][];
    };
    /** ForkArm */
    ForkArm: {
      /** Items */
      items: (
        | components['schemas']['CheckItem']
        | components['schemas']['InfoItem']
        | components['schemas']['ChoiceItem']
        | components['schemas']['CondItem']
        | components['schemas']['ForkItem']
        | components['schemas']['BranchItem']
      )[];
    };
    /** ForkItem */
    ForkItem: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: ForkItemKind;
      /** Item Id */
      item_id: string;
      /** Question */
      question: string;
      /** Hint */
      hint?: string | null;
      yes: components['schemas']['ForkArm'];
      no: components['schemas']['ForkArm'];
    };
    /** FormField */
    FormField: {
      /** Page */
      page: number;
      /** Field Name */
      field_name: string;
      /** Field Label */
      field_label?: string | null;
      /** Field Type */
      field_type?: string | null;
      /** Field Value */
      field_value?: string | null;
      /** Font Size */
      font_size?: number | null;
      /** Choice Values */
      choice_values?: string[] | null;
      rect?: components['schemas']['PdfFormFieldRect'] | null;
      /** Event */
      event?: string[] | null;
      /** Javascript */
      javascript?: string[] | null;
      /** Max Len */
      max_len?: number | null;
      /** Radio Button Value */
      radio_button_value?: string | null;
      /**
       * Exclude From Fill
       * @default false
       */
      exclude_from_fill: boolean;
    };
    /**
     * FormSeoCsvMatchedRow
     * @description A matched CSV row that import will update.
     */
    FormSeoCsvMatchedRow: {
      /** Url Path */
      url_path: string;
      /** Template Id */
      template_id: string;
      /** Title */
      title: string;
    };
    /**
     * Format
     * @description FHIR content format codes.
     *
     *     https://hl7.org/fhir/R4/valueset-mimetypes.html
     * @enum {string}
     */
    Format: Format;
    /** FreeTrialHistory */
    FreeTrialHistory: {
      /** Subscription Id */
      subscription_id: string;
      /**
       * Free Trial Start Date
       * Format: date-time
       */
      free_trial_start_date: string;
      /**
       * Free Trial End Date
       * Format: date-time
       */
      free_trial_end_Date: string;
      previous_status?: components['schemas']['SubscriptionStatus'] | null;
      /**
       * Ended By User
       * @default false
       */
      ended_by_user: boolean;
    };
    /**
     * FrontendEventLifecycleResponse
     * @description Returned from both ``:resolve`` and ``:ack``.
     *
     *     ``terminal`` indicates whether the FE has finished its lifecycle for
     *     this event — i.e. a ``WorkflowEvent`` was dispatched to unblock the
     *     waiting agent. False means another phase is still expected (e.g.
     *     approval succeeded but ``wait_for_ack`` is True and the FE has not
     *     posted ``:ack`` yet).
     */
    FrontendEventLifecycleResponse: {
      /** Event Id */
      event_id: string;
      /** Terminal */
      terminal: boolean;
      /**
       * Accepted
       * @default true
       */
      accepted: boolean;
    };
    /**
     * FrontendEventResolutionView
     * @description Read-only lifecycle snapshot for a frontend-event resolution row.
     *
     *     Surfaces the per-event approval/execution state to the admin UI so
     *     operators can debug "agent emitted, did the user approve, did the
     *     handler run, how long did each phase take?" without needing access
     *     to Mongo. Admin write affordances are intentionally absent — only
     *     the subject can resolve their own events.
     */
    FrontendEventResolutionView: {
      /** Event Id */
      event_id: string;
      /** Subject User Id */
      subject_user_id: string;
      /** Agent Run Id */
      agent_run_id: string;
      /** Workflow Id */
      workflow_id: string;
      /** Event Type */
      event_type: string;
      /** Requires Approval */
      requires_approval: boolean;
      /** Wait For Ack */
      wait_for_ack: boolean;
      /** Approval Expires At */
      approval_expires_at?: string | null;
      /** Ack Expires At */
      ack_expires_at?: string | null;
      /** Approval */
      approval?: {
        [key: string]: unknown;
      } | null;
      /** Execution */
      execution?: {
        [key: string]: unknown;
      } | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * FulfilSendOutRequest
     * @description Body for fulfilling a send-out.
     *
     *     `tracking_number` is the single parcel tracking number for a customer
     *     resend; it is omitted for internal-use send-outs.
     */
    FulfilSendOutRequest: {
      /** Tracking Number */
      tracking_number?: string | null;
    };
    /**
     * FulfillmentStage
     * @description Customer-facing fulfillment stage.
     *
     *     Collapses internal `OrderStatus` values into a smaller, stable set so
     *     that adding new internal states does not break the public contract.
     *     Pre-ERP statuses are intentionally not represented here — the endpoint
     *     returns 404 for those orders.
     * @enum {string}
     */
    FulfillmentStage: FulfillmentStage;
    /**
     * G2ReviewUrlResponse
     * @description Review Form URL the client should redirect to.
     */
    G2ReviewUrlResponse: {
      /** Url */
      url: string;
    };
    /**
     * GallerySeoContext
     * @description The five context points a form's SEO content was generated from.
     */
    GallerySeoContext: {
      /** Form Purpose */
      form_purpose: string;
      /** Who Fills It */
      who_fills_it: string;
      /** Required Information Categories */
      required_information_categories: string;
      /** Friction Points */
      friction_points: string;
      /** Heidi Value */
      heidi_value: string;
    };
    /** GalleryTemplateBasicInfo */
    GalleryTemplateBasicInfo: {
      /**
       * Template Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_id: string;
      /** Title */
      title: string;
      /** Description */
      description: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Deleted At */
      deleted_at?: string | null;
      template_category: components['schemas']['GalleryTemplateCategory'];
      source_region: components['schemas']['GalleryTemplateRegion'];
      /** Country */
      country: string;
      /** Specialty */
      specialty: string;
      /** Author Id */
      author_id: string;
      /** Author Name */
      author_name: string;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Clinic Id */
      clinic_id: string;
      /** Clinic Name */
      clinic_name: string;
      /** Views Count */
      views_count: number;
      /** Imports Count */
      imports_count: number;
      /** Url Path */
      url_path: string;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
    };
    /**
     * GalleryTemplateBatchUploadResponse
     * @description Response for batch file upload operations.
     */
    GalleryTemplateBatchUploadResponse: {
      /** Success Count */
      success_count: number;
      /** Failed Count */
      failed_count: number;
      /** Failed Ids */
      failed_ids: string[];
      /** Errors */
      errors: string[];
      /** Message */
      message: string;
    };
    /**
     * GalleryTemplateCategory
     * @enum {string}
     */
    GalleryTemplateCategory: GalleryTemplateCategory;
    /**
     * GalleryTemplateContentPayload
     * @description Nested template content payload from the frontend.
     */
    GalleryTemplateContentPayload: {
      /** Title */
      title?: string | null;
      /** Description */
      description?: string | null;
      /** Structure */
      structure?: string | null;
      /** Html */
      html?: string | null;
      /** Tone */
      tone?: string | null;
      /** Example Output */
      example_output?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
    };
    /** GalleryTemplateContentUpdate */
    GalleryTemplateContentUpdate: {
      /** Title */
      title?: string | null;
      /** Description */
      description?: string | null;
      /** Structure */
      structure?: string | null;
      /** Html */
      html?: string | null;
      /** Tone */
      tone?: string | null;
      /** Example Output */
      example_output?: string | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** Json Source */
      json_source?: string | null;
      /** Seo Content */
      seo_content?: string | null;
      seo_context?: components['schemas']['GallerySeoContext'] | null;
    };
    /** GalleryTemplateContentV1 */
    GalleryTemplateContentV1: {
      /** Title */
      title: string;
      /** Description */
      description: string | null;
      /** Structure */
      structure: string;
      /** Html */
      html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Tone */
      tone: string | null;
      /** Example Output */
      example_output: string;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** Json Source */
      json_source?: string | null;
      /** Seo Content */
      seo_content?: string | null;
      seo_context?: components['schemas']['GallerySeoContext'] | null;
    };
    /** GalleryTemplateDetail */
    GalleryTemplateDetail: {
      /**
       * Template Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_id: string;
      /** Title */
      title: string;
      /** Description */
      description: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Deleted At */
      deleted_at?: string | null;
      template_category: components['schemas']['GalleryTemplateCategory'];
      source_region: components['schemas']['GalleryTemplateRegion'];
      /** Country */
      country: string;
      /** Specialty */
      specialty: string;
      /** Author Id */
      author_id: string;
      /** Author Name */
      author_name: string;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Clinic Id */
      clinic_id: string;
      /** Clinic Name */
      clinic_name: string;
      /** Views Count */
      views_count: number;
      /** Imports Count */
      imports_count: number;
      /** Url Path */
      url_path: string;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
      template_content: components['schemas']['GalleryTemplateContentV1'];
      /** Searching Text */
      searching_text?: string | null;
    };
    /**
     * GalleryTemplateListResponse
     * @description Response for listing gallery templates.
     */
    GalleryTemplateListResponse: {
      /** Templates */
      templates: components['schemas']['GalleryTemplateBasicInfo'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
      /** Pages */
      pages: number;
    };
    /**
     * GalleryTemplateRegion
     * @enum {string}
     */
    GalleryTemplateRegion: GalleryTemplateRegion;
    /** GamifyTrialExtensionResponse */
    GamifyTrialExtensionResponse: {
      /** Eligible */
      eligible: boolean;
      /** Tasks */
      tasks?: components['schemas']['ExtensionTask'][];
      /**
       * All Tasks Complete
       * @default false
       */
      all_tasks_complete: boolean;
      /**
       * Trial Extended
       * @default false
       */
      trial_extended: boolean;
      /**
       * Trial Extension Days
       * @default 14
       */
      trial_extension_days: number;
      /**
       * Tier
       * @description Subscription tier for this progress (e.g. PRO_PLUS, CLINICIAN_PRO)
       */
      tier?: string | null;
    };
    /**
     * GenderIdentity
     * @description Values and descriptions are sourced from
     *     https://hl7.org/fhir/us/cdmh/ValueSet-pcornet-gender-identity.html
     * @enum {string}
     */
    GenderIdentity: GenderIdentity;
    /** GenerateBackupTranscriptResponseV2 */
    GenerateBackupTranscriptResponseV2: {
      /** Transcript */
      transcript: string;
    };
    /**
     * GenerateConsultNoteRequest
     * @description template_id, ai_command_id, command_text are mutually exclusive
     */
    GenerateConsultNoteRequest: {
      generation_method: components['schemas']['GenerationMethod'];
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      /**
       * Addition
       * @default
       */
      addition: string;
      voice_style: components['schemas']['VoiceStyle'];
      /** @default LEFT */
      brain: components['schemas']['Brain'];
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      content_type?: components['schemas']['ContentType'] | null;
      platform?: components['schemas']['HeidiPlatforms'] | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
      generation_mode?: components['schemas']['GenerationMode'] | null;
      /**
       * Ignore Backup
       * @default false
       */
      ignore_backup: boolean;
      /** Demo Mode */
      demo_mode?: string | null;
      /** Client Capabilities */
      client_capabilities?: string[];
    };
    /** GenerateDocumentContentRequestV2 */
    GenerateDocumentContentRequestV2: {
      /** @default DOCUMENT */
      document_tab_type: components['schemas']['DocumentTabType'] | null;
      generation_method: components['schemas']['GenerationMethod'];
      /** Template Id */
      template_id?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      /** @default LEFT */
      brain: components['schemas']['Brain'];
      /** Index */
      index?: number | null;
      content_type?: components['schemas']['ContentType'] | null;
      /** Live Dictation Text */
      live_dictation_text?: string | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
      /** Is Not Regeneration */
      is_not_regeneration?: boolean | null;
      /** Task Id */
      task_id?: string | null;
    };
    /**
     * GenerateExampleNotePublicRequest
     * @description Request for unauthenticated example note generation during onboarding.
     */
    GenerateExampleNotePublicRequest: {
      /**
       * Transcript
       * @description Consultation transcript to generate note from
       */
      transcript: string;
      /**
       * Template Structure
       * @description Template structure to fill in with transcript content
       */
      template_structure: string;
      /** Specialty Name */
      specialty_name?: string | null;
      /** Country */
      country?: string | null;
      /** Language */
      language?: string | null;
      /**
       * Abbreviations Preference
       * @description Instruct the LLM to use standard medical abbreviations in the generated note (e.g. Pt, FHx, ECG).
       * @default false
       */
      abbreviations_preference: boolean;
    };
    /**
     * GenerateExampleNotePublicResponse
     * @description Response for unauthenticated example note generation.
     */
    GenerateExampleNotePublicResponse: {
      /** Example Note */
      example_note: string;
    };
    /** GenerateJWTResponse */
    GenerateJWTResponse: {
      /** Token */
      token: string;
      /**
       * Expiration Time
       * Format: date-time
       */
      expiration_time: string;
    };
    /** GenerateJudgePromptRequest */
    GenerateJudgePromptRequest: {
      /**
       * Intent
       * @description What the judge should evaluate
       */
      intent: string;
      /**
       * Output Structure
       * @description Comma-separated list of desired output fields/metrics
       * @default
       */
      output_structure: string;
      /**
       * Available Variables
       * @description Variable names available for interpolation (e.g. transcript, edited_note)
       */
      available_variables?: string[];
    };
    /**
     * GenerateJudgePromptResponse
     * @description Response from the generate-judge-prompt endpoint.
     *
     *     output_schema_fields is a proper JSON Schema object describing the expected
     *     judge output structure, e.g.:
     *     {
     *         "type": "object",
     *         "properties": {
     *             "accuracy_score": {"type": "number", "description": "..."},
     *             "reasoning": {"type": "string", "description": "..."}
     *         },
     *         "required": ["accuracy_score", "reasoning"]
     *     }
     */
    GenerateJudgePromptResponse: {
      /** Prompt Template */
      prompt_template: string;
      /** Output Schema Fields */
      output_schema_fields: {
        [key: string]: unknown;
      };
    };
    /**
     * GenerateKnowledgeBaseRequest
     * @description Request model for generating knowledge base from URL.
     */
    GenerateKnowledgeBaseRequest: {
      /** Website Url */
      website_url: string;
    };
    /**
     * GenerateKnowledgeBaseResponse
     * @description Response model for knowledge base generation.
     */
    GenerateKnowledgeBaseResponse: {
      /** Knowledge Base */
      knowledge_base: string;
      /** Source Url */
      source_url: string;
    };
    /**
     * GenerateOutputSchemaRequest
     * @description Generate a JSON Schema from an existing judge prompt.
     */
    GenerateOutputSchemaRequest: {
      /**
       * Judge Prompt
       * @description The judge prompt to infer output schema from
       */
      judge_prompt: string;
      /**
       * User Intent
       * @description Optional description of what the judge evaluates
       * @default
       */
      user_intent: string;
      /**
       * Desired Output Fields
       * @description Comma-separated field names the user wants in the output
       * @default
       */
      desired_output_fields: string;
    };
    /** GenerateOutputSchemaResponse */
    GenerateOutputSchemaResponse: {
      /** Output Schema */
      output_schema: {
        [key: string]: unknown;
      };
    };
    /** GeneratePrechartDocumentRequest */
    GeneratePrechartDocumentRequest: {
      /** Template Id */
      template_id?: string | null;
    };
    /** GeneratePrechartDocumentResponse */
    GeneratePrechartDocumentResponse: {
      /** Document Id */
      document_id: string;
      /** Content */
      content: string;
      /** Template Id */
      template_id?: string | null;
    };
    /** GeneratePrechartRequest */
    GeneratePrechartRequest: {
      /** Additional Instructions */
      additional_instructions?: string | null;
      /** Template Id */
      template_id?: string | null;
    };
    /** GeneratePreviewRequest */
    GeneratePreviewRequest: {
      /**
       * Scenario
       * @default auto
       */
      scenario: string;
      /** Recent Changes */
      recent_changes?: string[] | null;
      /** Scenario Hints */
      scenario_hints?: string | null;
    };
    /**
     * GenerateProtocolRequest
     * @description Request to generate protocol fields from natural language.
     */
    GenerateProtocolRequest: {
      /**
       * Prompt
       * @description Natural language description of the desired protocol
       */
      prompt: string;
      /** @description Existing field values (for edit mode) */
      current_values?: components['schemas']['ProtocolDraft'] | null;
    };
    /**
     * GenerateProtocolResponse
     * @description Generated protocol fields.
     */
    GenerateProtocolResponse: {
      /** Name */
      name: string;
      /** Shorthand */
      shorthand: string;
      /** Description */
      description: string;
      /** Standard Operating Procedure */
      standard_operating_procedure: string;
    };
    /** GenerateSectionalNoteResponse */
    GenerateSectionalNoteResponse: {
      /** Sectional Notes */
      sectional_notes: components['schemas']['SectionalNote'][];
    };
    /** GenerateTemplateContentUsingAIRequestV2 */
    GenerateTemplateContentUsingAIRequestV2: {
      /** Ai Command Text */
      ai_command_text: string;
      content_type?: components['schemas']['ContentType'] | null;
    };
    /**
     * GenerateTemplatePublicRequest
     * @description Request for unauthenticated template generation during onboarding.
     */
    GenerateTemplatePublicRequest: {
      /** Description */
      description: string;
      /** Specialty Name */
      specialty_name?: string | null;
      /** Country */
      country?: string | null;
      /** Language */
      language?: string | null;
      /** File Contents */
      file_contents?: string[] | null;
    };
    /**
     * GenerateTemplatePublicResponse
     * @description Response for unauthenticated template generation.
     */
    GenerateTemplatePublicResponse: {
      /** Template Name */
      template_name: string;
      /** Template Structure */
      template_structure: string;
    };
    /** GenerateTranscriptResponseV2 */
    GenerateTranscriptResponseV2: {
      /** Transcript */
      transcript: string;
      multi_source_transcript_data?:
        | components['schemas']['MultiSourceTranscriptData']
        | null;
    };
    /**
     * GenerationConfig
     * @description Per-request generation controls for the sandbox evidence-chat runner.
     *
     *     A single flat config covering two independent concerns:
     *
     *     * **Sampling** (``temperature`` / ``top_p`` / ``top_k`` / ``max_tokens``):
     *       applied on the OpenAI-compatible adapter path for every LLM call of the
     *       agentic tool loop. Sampling-only configs (no ``base_url``, no
     *       ``enable_token_tracing``) apply to normal server routing and place no
     *       restriction on ``model``.
     *
     *     * **Endpoint override** (``base_url`` + ``enable_token_tracing``):
     *       ``base_url`` sends the agent's LLM calls to an alternate
     *       OpenAI-compatible endpoint instead of the default;
     *       ``enable_token_tracing`` asks that endpoint to return per-token ids and
     *       log-probabilities with each response. Either only works on the
     *       chat-completions OpenAI-compatible path, so the request is rejected (422)
     *       for incompatible models.
     *
     *     The API key is never accepted from the request; the streamer resolves it
     *     server-side. Only honored on this sandbox route; the streamer additionally
     *     rejects an endpoint override unless it runs with ``sandbox=True``.
     */
    GenerationConfig: {
      /**
       * Base Url
       * @description Alternate OpenAI-compatible base URL the agent's LLM calls are sent to. None uses normal server routing.
       */
      base_url?: string | null;
      /**
       * Temperature
       * @description Sampling temperature applied on every LLM call.
       */
      temperature?: number | null;
      /**
       * Top P
       * @description Nucleus-sampling top_p applied on every LLM call.
       */
      top_p?: number | null;
      /**
       * Top K
       * @description top_k applied on every LLM call. Rides in extra_body on the OpenAI-compatible (fireworks) path — no native chat-completions param exists.
       */
      top_k?: number | null;
      /**
       * Max Tokens
       * @description Overrides the streamer's model-derived output cap on every LLM call.
       */
      max_tokens?: number | null;
      /**
       * Enable Token Tracing
       * @description When True, ask the endpoint to return per-token ids and log-probabilities with each response. Requires base_url.
       * @default false
       */
      enable_token_tracing: boolean;
    };
    /**
     * GenerationMethod
     * @enum {string}
     */
    GenerationMethod: GenerationMethod;
    /**
     * GenerationMode
     * @enum {string}
     */
    GenerationMode: GenerationMode;
    /**
     * GenerationUse
     * @enum {string}
     */
    GenerationUse: GenerationUse;
    /** GetAddOnProductsResponse */
    GetAddOnProductsResponse: {
      /** Products */
      products: components['schemas']['AddOnProductView'][];
      /** Total Pages */
      total_pages: number;
    };
    /** GetAllFeatureFlagsResponse */
    GetAllFeatureFlagsResponse: {
      /** Feature Flags */
      feature_flags: components['schemas']['FeatureFlagDomainModel'][];
    };
    /** GetAllProductsResponse */
    GetAllProductsResponse: {
      /** Products */
      products: components['schemas']['ProductView'][];
    };
    /** GetHeidi2ProductsResponse */
    GetHeidi2ProductsResponse: {
      /** Products */
      products: components['schemas']['Heidi2ProductView'][];
    };
    /** GetClinicalTasksResponse */
    GetClinicalTasksResponse: {
      /** Tasks */
      tasks: components['schemas']['ClinicalTaskView'][];
      /** Total */
      total: number;
      /** Skip */
      skip: number;
      /** Limit */
      limit: number;
      /**
       * Has Tasks
       * @default false
       */
      has_tasks: boolean;
      /**
       * Completed All Tasks
       * @default false
       */
      completed_all_tasks: boolean;
    };
    /** GetCommonlyUsedPastEHRNotesResponse */
    GetCommonlyUsedPastEHRNotesResponse: {
      /** Commonly Used Past Notes */
      commonly_used_past_notes?: components['schemas']['CommonlyUsedPastEHRNote'][];
    };
    /** GetConsultNoteResponse */
    GetConsultNoteResponse: {
      consult_note: components['schemas']['ConsultNoteResponseV2'];
    };
    /** GetConsultNoteTimelineResponse */
    GetConsultNoteTimelineResponse: {
      /** Timeline */
      timeline: (
        | components['schemas']['NoteCreatedEvent']
        | components['schemas']['NoteRegeneratedEvent']
        | components['schemas']['TemplateChangedEvent']
        | components['schemas']['VoiceChangedEvent']
        | components['schemas']['ScribeChangedEvent']
        | components['schemas']['NoteRevertedEvent']
        | components['schemas']['EditEvent']
      )[];
    };
    /** GetConsultNotesResponse */
    GetConsultNotesResponse: {
      /** Consult Notes */
      consult_notes: components['schemas']['ConsultNoteResponseV2'][];
    };
    /** GetContactSalesRequestResponse */
    GetContactSalesRequestResponse: {
      /** Has Already Been Requested */
      has_already_been_requested: boolean;
    };
    /** GetDocumentsResponse */
    GetDocumentsResponse: {
      /** Documents */
      documents: components['schemas']['DocumentView'][];
      /** Total */
      total: number;
    };
    /**
     * GetEHRLatestNoteResponse
     * @description Response model for getting the latest note from EHR.
     */
    GetEHRLatestNoteResponse: {
      ehr_note?: components['schemas']['EHRNote'] | null;
    };
    /** GetEHRLaunchAccessTokenDetailsResponse */
    GetEHRLaunchAccessTokenDetailsResponse: {
      /** Access Token */
      access_token: string;
      /** Id Token */
      id_token?: string | null;
      /** Patient Identifier */
      patient_identifier?: string | null;
      /** Encounter Id */
      encounter_id?: string | null;
      /** Appointment Id */
      appointment_id?: string | null;
      /** Appointment Contact Id */
      appointment_contact_id?: string | null;
      /** Expires At */
      expires_at?: number | null;
    };
    /** GetEHRLaunchAuthorizationURLResponse */
    GetEHRLaunchAuthorizationURLResponse: {
      /** Authorization Url */
      authorization_url: string;
      /** Client Id */
      client_id: string;
      /**
       * Response Type
       * @default code
       * @constant
       */
      response_type: 'code';
      /**
       * Scope
       * @default fhirUser openid launch launch/patient
       */
      scope: string;
    };
    /** GetEHRLaunchPatientDetailsResponse */
    GetEHRLaunchPatientDetailsResponse: {
      /** Identifier */
      identifier: string;
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      /** Gender */
      gender: string;
      /** Birth Date */
      birth_date: string;
      /** Telephone */
      telephone?: string | null;
      /** Email */
      email?: string | null;
      /** Identifier List */
      identifier_list?: components['schemas']['PatientIdentifier'][] | null;
    };
    /**
     * GetEntityFeedbackListResponse
     * @description Response schema for getting all entity verification feedback for a session.
     */
    GetEntityFeedbackListResponse: {
      /** Feedbacks */
      feedbacks: components['schemas']['EntityVerificationFeedbackView'][];
    };
    /**
     * GetFilledPdfFieldsResponse
     * @description Response for GET /pdf-document/{document_id}/fields.
     */
    GetFilledPdfFieldsResponse: {
      /**
       * Document Id
       * @description The ID of the PDF document
       */
      document_id: string;
      /**
       * Template Id
       * @description The ID of the source template
       */
      template_id: string;
      /**
       * Fields
       * @description List of form fields with current values
       */
      fields?: components['schemas']['FilledPdfField'][];
    };
    /**
     * GetIdentityProfileRequestDTO
     * @description Request DTO for getting identity profile by email and/or kinde_user_id.
     *
     *     Used by IdP actions to retrieve user identity profiles during login and
     *     signup flows. The region is required to enable regional server lookup for
     *     user_ref_id if not present. At least one of ``email`` or ``kinde_user_id``
     *     must be supplied; both may be supplied, in which case ``kinde_user_id``
     *     selects the kinde-keyed lookup path.
     * @example {
     *       "email": "user@example.com",
     *       "region": "EU"
     *     }
     * @example {
     *       "kinde_user_id": "kp_abc123",
     *       "region": "EU"
     *     }
     * @example {
     *       "email": "user@example.com",
     *       "kinde_user_id": "kp_abc123",
     *       "region": "EU"
     *     }
     */
    GetIdentityProfileRequestDTO: {
      /**
       * Email
       * @description User email address to look up (optional if kinde_user_id is supplied)
       */
      email?: string | null;
      /**
       * Kinde User Id
       * @description Kinde-minted user id to look up (optional if email is supplied). When present, the kinde-keyed lookup path is taken.
       * @example kp_abc123
       */
      kinde_user_id?: string | null;
      /**
       * Region
       * @description Region code for regional server lookup (e.g., 'EU', 'US', 'AU', 'CA', 'UK')
       */
      region: string;
    };
    /**
     * GetIdentityProfileResponse
     * @description Wrapper response for get identity profile endpoint.
     *
     *     This wrapper allows for future expansion with metadata, pagination, etc.
     * @example {
     *       "identity_profile": {
     *         "auth0_id": "auth0|123456789",
     *         "auth0_sync_state": "identity_create_completed",
     *         "created_at": "2024-01-15T10:30:00Z",
     *         "email": "user@example.com",
     *         "email_verified": true,
     *         "identities": [
     *           {
     *             "connection": "Username-Password-Authentication",
     *             "is_social": false,
     *             "provider": "auth0",
     *             "user_id": "auth0|123456789"
     *           }
     *         ],
     *         "kinde_sync_state": "pending",
     *         "last_routed_vendor": "auth0",
     *         "profile_source": "auth0",
     *         "updated_at": "2024-01-15T10:30:00Z",
     *         "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *       }
     *     }
     */
    GetIdentityProfileResponse: {
      /** @description The retrieved identity profile data */
      identity_profile: components['schemas']['domains__identity_broker__dto__responses__identity_profile_dto__IdentityProfileDTO'];
    };
    /** GetInmailsResponse */
    GetInmailsResponse: {
      /** Inmails */
      inmails: components['schemas']['UserInmailResponse'][];
    };
    /**
     * GetJoinableTeamsResponse
     * @description Response model for getting joinable teams.
     */
    GetJoinableTeamsResponse: {
      /** Joinable Teams */
      joinable_teams: components['schemas']['JoinableTeamView'][];
      /** Total */
      total: number;
    };
    /**
     * GetLinkSharesResponse
     * @description Response for getting all link shares for a session.
     */
    GetLinkSharesResponse: {
      default_scope?: components['schemas']['SharedSessionScope'] | null;
      /** Expires At */
      expires_at?: string | null;
      /** Disabled At */
      disabled_at?: string | null;
      /** Recipients */
      recipients?: components['schemas']['LinkShareRecipientResponse'][];
    };
    /**
     * GetMobileRequest
     * @description Request model for sending get mobile email.
     */
    GetMobileRequest: {
      /** Link */
      link: string;
    };
    /**
     * GetNoteOptionsResponse
     * @description Response for the option-selection step of the note sync flow.
     *
     *     Empty ``options`` means no selection is required and the caller can
     *     proceed directly.  Non-empty ``options`` means the user must choose one
     *     before calling ``sync_notes_with_option``.
     */
    GetNoteOptionsResponse: {
      /** Options */
      options?: components['schemas']['BaseNoteOption'][];
    };
    /** GetOrchestrationPatientSummaryResponse */
    GetOrchestrationPatientSummaryResponse: {
      /** Data */
      data: components['schemas']['OrchestrationPatientSummaryView'][];
    };
    /**
     * GetOverallFeedbackResponse
     * @description Response schema for getting overall verification feedback.
     */
    GetOverallFeedbackResponse: {
      feedback: components['schemas']['OverallFeedbackView'] | null;
    };
    /**
     * GetPastEHRNoteBinaryDetailResponse
     * @description Response model for getting the binary detail of a past EHR note.
     */
    GetPastEHRNoteBinaryDetailResponse: {
      ehr_note: components['schemas']['EHRNote'];
    };
    /**
     * GetPastEHRNotesResponse
     * @description Response model for getting the past notes from EHR with pagination.
     */
    GetPastEHRNotesResponse: {
      /** Ehr Notes */
      ehr_notes?: components['schemas']['EHRNote'][];
      /**
       * Total
       * @description Total number of notes available
       */
      total: number;
      /**
       * Page
       * @description Current page number
       */
      page: number;
      /**
       * Page Size
       * @description Number of notes per page
       */
      page_size: number;
      /**
       * Next Page Url
       * @description Cursor URL for the next page when provided by EHR
       */
      next_page_url?: string | null;
    };
    /** GetPastEHRNotesWithCommonlyUsedResponse */
    GetPastEHRNotesWithCommonlyUsedResponse: {
      /** Ehr Notes */
      ehr_notes?: components['schemas']['EHRNote'][];
      /**
       * Total
       * @description Total number of notes available
       */
      total: number;
      /**
       * Page
       * @description Current page number
       */
      page: number;
      /**
       * Page Size
       * @description Number of notes per page
       */
      page_size: number;
      /**
       * Next Page Url
       * @description Cursor URL for the next page when provided by EHR
       */
      next_page_url?: string | null;
      /** Commonly Used Past Notes */
      commonly_used_past_notes?: components['schemas']['CommonlyUsedPastEHRNote'][];
    };
    /** GetPatientProfileRecapResponse */
    GetPatientProfileRecapResponse: {
      data?: components['schemas']['PatientRecapModel'] | null;
      error?: components['schemas']['PatientRecapErrorEnvelope'] | null;
    };
    /** GetPatientProfileResponse */
    // COLAB-406 (ml-scribe PR 19221): GET /patient-profiles/{id} now returns
    // the enriched model — session_count + last_session_created_at, mirrored
    // from the list endpoint. Hand-applied on the colab-395 branch; a full
    // env regen (`pnpm schema-ml-scribe`) reproduces it once 19221 merges.
    GetPatientProfileResponse: {
      data: components['schemas']['PatientProfileWithSessionCount'];
    };
    /** GetPatientProfilesResponse */
    GetPatientProfilesResponse: {
      /** Data */
      data: (
        | components['schemas']['PatientProfileWithSessionCount']
        | components['schemas']['PatientProfileModel']
      )[];
      /** Total Pages */
      total_pages?: number | null;
    };
    /** GetPrechartInstructionsResponse */
    GetPrechartInstructionsResponse: {
      /** Rules Text */
      rules_text: string;
    };
    /** GetPrechartResponse */
    GetPrechartResponse: {
      /** Prechart */
      prechart: string;
      /**
       * Template Id
       * @default
       */
      template_id: string;
      /**
       * Expandable Facts
       * @default []
       */
      expandable_facts: components['schemas']['ExpandableFact'][];
    };
    /** GetRecordingsResponse */
    GetRecordingsResponse: {
      recordings: components['schemas']['Recordings'];
    };
    /** GetRolesResponse */
    GetRolesResponse: {
      /** Data */
      data: components['schemas']['RoleModel'][];
    };
    /**
     * GetScheduleResponse
     * @description Response for GET /schedule.
     */
    GetScheduleResponse: {
      /** Schedule */
      schedule: components['schemas']['GetScheduleResponseScheduleItem'][];
    };
    /** GetScheduleResponseScheduleItem */
    GetScheduleResponseScheduleItem: {
      appointment: components['schemas']['ScheduleItemAppointment'];
      patient?: components['schemas']['IntegrationPatient'] | null;
    };
    /** GetSessionLiveTranscriptResponse */
    GetSessionLiveTranscriptResponse: {
      response: components['schemas']['LiveTranscriptResponse'];
    };
    /**
     * GetSessionSharesResponse
     * @description Response for getting session shares.
     */
    GetSessionSharesResponse: {
      /** @description The session owner */
      owner: components['schemas']['SessionOwner'];
      /**
       * Members
       * @description List of users with direct sharing access
       */
      members?: components['schemas']['SharedMember'][];
    };
    /**
     * GetSharedTemplateResponse
     * @description Response schema for retrieving a shared template.
     */
    GetSharedTemplateResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      /** Structure Template */
      structure_template?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      template_category?: components['schemas']['TemplateCategory'] | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /**
       * Is Structured Template
       * @default false
       */
      is_structured_template: boolean;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** @default pdf */
      form_format: components['schemas']['FormFormat'];
      /** Xml Source */
      xml_source?: string | null;
      /** Json Source */
      json_source?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /** Shared By */
      shared_by?: string | null;
      /**
       * Shared At
       * @description ISO date string
       */
      shared_at: string;
      /** Example Note */
      example_note?: string | null;
    };
    /** GetSyncDocumentOptionsResponse[BaseSyncDocumentOption] */
    GetSyncDocumentOptionsResponse_BaseSyncDocumentOption_: {
      /** Options */
      options?: components['schemas']['BaseSyncDocumentOption'][];
    };
    /** GetTemplateCreationRecordResponse */
    GetTemplateCreationRecordResponse: {
      template_creation_record: components['schemas']['TemplateCreationRecordResponse'];
      /** Version Controls */
      version_controls: components['schemas']['TemplateVersionControlResponse'][];
    };
    /** GetTemplatesByUserAttributesRequest */
    GetTemplatesByUserAttributesRequest: {
      /** @description User attribute tags */
      tags?: components['schemas']['Tags'] | null;
      /** @description Tags for pinned templates */
      pinned_for_tags?: components['schemas']['Tags'] | null;
      /** @description Tags for highlighted templates */
      highlighted_for_tags?: components['schemas']['Tags'] | null;
      /** @description Tags for featured templates */
      featured_for_tags?: components['schemas']['Tags'] | null;
      /** @description Tags for auto-generated templates */
      auto_generated_for_tags?: components['schemas']['Tags'] | null;
      /**
       * Template Families
       * @description List of template family tags
       */
      template_families?: string[] | null;
      /**
       * @description Tag matching strategy
       * @default PARTIAL
       */
      match: components['schemas']['TemplateMatchType'] | null;
    };
    /** GetTemplatesResponseV2 */
    GetTemplatesResponseV2: {
      /** Templates */
      templates: components['schemas']['TemplateResponseV2'][];
    };
    /**
     * GetThirdPartyAuthResponse
     * @description Provider auth payload returned to the caller verbatim.
     */
    GetThirdPartyAuthResponse: {
      third_party_auth: components['schemas']['BaseModel'];
    };
    /** GetUserEHRLaunchProfileResponse */
    GetUserEHRLaunchProfileResponse: {
      /** User Ehr Launch Profiles */
      user_ehr_launch_profiles?: components['schemas']['UserEHRLaunchProfile'][];
    };
    /** GetUserEHRLaunchProfileV2Response */
    GetUserEHRLaunchProfileV2Response: {
      /** User Ehr Launch Profiles */
      user_ehr_launch_profiles?: components['schemas']['UserEHRLaunchProfile'][];
    };
    /**
     * GetUserFeedbackListResponse
     * @description Response model for getting UserFeedback
     */
    GetUserFeedbackListResponse: {
      /** Feedbacks */
      feedbacks: components['schemas']['UserFeedbackView'][];
    };
    /**
     * GetUserMFAConfigRequest
     * @description Request schema for getting user MFA configuration by user_ref_id.
     *
     *     Used by Identity Broker to retrieve user MFA settings from regional servers.
     */
    GetUserMFAConfigRequest: {
      /**
       * User Ref Id
       * @description Global unique identifier for the user (UUID7)
       * @example 01912345-6789-7abc-def0-123456789abc
       */
      user_ref_id: string;
    };
    /**
     * GetUserMFAConfigResponse
     * @description Response schema for the get-user-mfa-config endpoint.
     *
     *     Returns MFA configuration. If user not found or MFA is disabled,
     *     is_mfa_enabled will be False.
     */
    GetUserMFAConfigResponse: {
      /** @description User MFA configuration (is_mfa_enabled will be False if user not found or MFA disabled) */
      mfa_config: components['schemas']['UserMFAConfigData'];
    };
    /** GetUserNotificationPreferencesResponse */
    GetUserNotificationPreferencesResponse: {
      /** Subscribed Notification Channels */
      subscribed_notification_channels: components['schemas']['NotificationChannel'][];
      /** Notification Preferences */
      notification_preferences: components['schemas']['UserNotificationPreference'][];
    };
    /**
     * GetUserRequest
     * @description Request schema for getting a user by email.
     *
     *     Used by Identity Broker to retrieve user_ref_id from regional servers.
     */
    GetUserRequest: {
      /**
       * Email
       * Format: email
       * @description Email address of the user to look up
       * @example user@example.com
       */
      email: string;
    };
    /**
     * GetUserResponse
     * @description Response schema for the get-user endpoint.
     *
     *     Returns user data if found, or null if not found.
     *     The null case is a valid response (not an error) indicating
     *     the user does not exist in this regional server.
     */
    GetUserResponse: {
      /** @description User data if found, null if user not found */
      user?: components['schemas']['UserData'] | null;
    };
    /**
     * GraduateSuggestionResponse
     * @description Result of graduating an ``opt_in_ask`` suggestion to auto-apply.
     *
     *     ``applied`` is ``True`` when this call re-applied the suggestion's
     *     substitutions to the CURRENT note text and saved the result — matching is
     *     by text, not the stored offsets, so clinician edits made after the frame
     *     are preserved. ``False`` when it was already graduated (idempotent
     *     re-tap), no substitution matched the current text (every original edited
     *     away), or the note save failed (the graduation stamp is withheld in the
     *     latter two cases so a re-tap can retry). The opt-in override is set
     *     regardless, so the next note auto-applies.
     */
    GraduateSuggestionResponse: {
      /** Suggestion Id */
      suggestion_id: string;
      /** Applied */
      applied: boolean;
    };
    /**
     * GrantTrialAction
     * @description Grant a new trial starting from now.
     */
    GrantTrialAction: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      action: GrantTrialActionAction;
      /**
       * Trial Days
       * @default 14
       */
      trial_days: number;
    };
    /**
     * GuardrailCheckBatchRequest
     * @description Request body for ``POST /v2/guardrails/check-batch``.
     *
     *     Upstream is the canonical validator (field-name allowlist + per-value size
     *     caps); the bounds enforced here are defence-in-depth so a malformed request
     *     fails fast at the BFF instead of after a network hop. Keep
     *     ``GUARDRAIL_BATCH_MAX_*`` in lockstep with ``services.guardrails.models``
     *     on ai-receptionist-be.
     */
    GuardrailCheckBatchRequest: {
      /** Fields */
      fields: {
        [key: string]: string;
      };
    };
    /**
     * GuardrailCheckRequest
     * @description Request model for pre-validating a single instruction field.
     *
     *     Reused by both v1 and v2 single-field pre-check endpoints — the wire shape
     *     is identical; only the response differs. Do NOT mark this for deprecation
     *     along with the v1 response model.
     */
    GuardrailCheckRequest: {
      /** Field */
      field: string;
      /** Value */
      value: string;
    };
    /**
     * GuardrailCheckResponse
     * @description Response model for guardrail pre-check (v1 — minimal shape).
     */
    GuardrailCheckResponse: {
      /** Passed */
      passed: boolean;
      /** Category */
      category?: string | null;
    };
    /**
     * GuardrailCheckResponseV2
     * @description Response shape for v2 guardrails endpoints. Same model is used for
     *     single-field, batch, and the 422 ``detail`` body on save endpoints when the
     *     caller opts in via ``X-Guardrails-API-Version: 2``.
     *
     *     ``checked_at`` is left ``None`` when upstream omits it so latency
     *     observability isn't misled by a fabricated BFF-side timestamp.
     */
    GuardrailCheckResponseV2: {
      /** Passed */
      passed: boolean;
      /**
       * Violations
       * @default []
       */
      violations: components['schemas']['GuardrailViolationV2'][];
      /** Checked At */
      checked_at?: string | null;
    };
    /**
     * GuardrailViolationV2
     * @description One per-field violation in the v2 guardrails response.
     */
    GuardrailViolationV2: {
      /** Field */
      field: string;
      /** Category */
      category: string;
      /** Triggered Text */
      triggered_text: string;
      /** User Message */
      user_message: string;
    };
    /** HTTPValidationError */
    HTTPValidationError: {
      /** Detail */
      detail?: components['schemas']['ValidationError'][];
    };
    /** HaikuAmbientSessionBeginRequest */
    HaikuAmbientSessionBeginRequest: {
      /**
       * Sessionid
       * @description The unique ID for the ambient session.
       */
      sessionID: string;
      /**
       * Userid
       * @description The unique external ID for identifying the user.
       */
      userID: string;
      /**
       * Patientid
       * @description Array of IDType objects of the patient for the ambient session.
       */
      patientID: components['schemas']['apis__v2__ehrlaunch__mobile__avr__avr_schema__haiku__models__IDType'][];
      /**
       * Encounterid
       * @description Array of IDType objects of the encounter for the ambient session.
       */
      encounterID: components['schemas']['apis__v2__ehrlaunch__mobile__avr__avr_schema__haiku__models__IDType'][];
      /**
       * Customerid
       * @description The unique ID that can be used for identifying the customer/organization.
       */
      customerID?: string | null;
      /**
       * Customersecret
       * @description Secret that can be given to customers and used to authenticate the customer/organization.
       */
      customerSecret?: string | null;
      /**
       * Callbackurl
       * @description The URL to which the vendor should send the callback.
       */
      callbackUrl: string;
      /** @description JSON object of additional context values for ambient services. */
      data?: components['schemas']['AdditionalContext'] | null;
    };
    /** HaikuAmbientSessionBeginResponse */
    HaikuAmbientSessionBeginResponse: {
      /**
       * Session Id
       * @description The unique ID for the ambient session.
       */
      session_id: string;
      /**
       * User Id
       * @description The unique external ID for identifying the user.
       */
      user_id: string;
      /**
       * Error
       * @description Error message if the session could not be created.
       */
      error?: string | null;
    };
    /** HaikuAmbientSessionCompleteRequest */
    HaikuAmbientSessionCompleteRequest: {
      /**
       * Sessionid
       * @description The unique ID for the ambient session.
       */
      sessionID: string;
    };
    /** HaikuDeleteSessionRequest */
    HaikuDeleteSessionRequest: {
      /**
       * Sessionid
       * @description The unique ID for the ambient session.
       */
      sessionID: string;
    };
    /** HaikuDocumentationFeedbackRequest */
    HaikuDocumentationFeedbackRequest: {
      /**
       * Sessionid
       * @description The unique ID for the ambient session.
       */
      sessionID: string;
      /**
       * Notesections
       * @description The array of Note Section Return Objects created from the ambient session.
       */
      noteSections: components['schemas']['NoteSectionReturnObject'][];
    };
    /** HaikuDocumentationUpdatedRequest */
    HaikuDocumentationUpdatedRequest: {
      /**
       * Sessionid
       * @description The unique ID for the ambient session.
       */
      sessionID: string;
      /**
       * Updatedsections
       * @description The array of note section IDs that have been manually updated by the user.
       */
      updatedSections: string[];
    };
    /** HaikuGenericResponse */
    HaikuGenericResponse: {
      /**
       * Error
       * @description Error message or null if the request was processed successfully.
       */
      error?: string | null;
    };
    /** HaikuLatestFinalizedRecordingResponse */
    HaikuLatestFinalizedRecordingResponse: {
      /** Recording Id */
      recording_id: number | null;
      /**
       * Transcription Complete
       * @default false
       */
      transcription_complete: boolean;
    };
    /** HaikuRecordingAvailableRequest */
    HaikuRecordingAvailableRequest: {
      /**
       * Recording
       * @description The recording ID. RM: I believe that this is the recording number rather than an ID eg the first recording is 1, the second is 2, etc.
       */
      recording: number;
      /**
       * Sessionid
       * @description The unique ID for the ambient session.
       */
      sessionID: string;
      /**
       * Totalchunks
       * @description The total number of chunks in the recording.
       */
      totalChunks?: number | null;
      /**
       * Lastrecording
       * @description The recording ID of the last recording for this session. Will be 0 if the session is not finalized.
       */
      lastRecording?: number | null;
    };
    /** HaikuRecordingChunkAvailableRequest */
    HaikuRecordingChunkAvailableRequest: {
      /**
       * Recording
       * @description The recording ID. RM: I believe that this is the recording number rather than an ID eg the first recording is 1, the second is 2, etc.
       */
      recording: number;
      /**
       * Sessionid
       * @description The unique ID for the ambient session.
       */
      sessionID: string;
      /**
       * Chunk
       * @description The chunk ID
       */
      chunk: number;
    };
    /** HaikuTokenResponse */
    HaikuTokenResponse: {
      /** Jwt */
      jwt: string;
      /** Session Id */
      session_id: string | null;
      /** Finalized */
      finalized: boolean;
      /** Access Token */
      access_token?: string | null;
      /** Profile Name */
      profile_name?: string | null;
    };
    /**
     * HardwareAudioTranscriptionResponse
     * @description Response after uploading and transcribing hardware audio.
     */
    HardwareAudioTranscriptionResponse: {
      /** Is Success */
      is_success: boolean;
      /** Recording Id */
      recording_id: string;
      /** Message */
      message: string;
    };
    /** HardwareDeviceResponse */
    HardwareDeviceResponse: {
      /** Id */
      id: string;
      /**
       * Device Id
       * Format: uuid
       * @deprecated
       */
      device_id: string;
      /** Serial Number */
      serial_number?: string | null;
      /** User Id */
      user_id: string;
      /** Device Name */
      device_name: string;
      /** Device Model */
      device_model: string;
      /** Firmware Version */
      firmware_version: string;
      /**
       * Linked At
       * Format: date-time
       */
      linked_at: string;
      /** Last Seen At */
      last_seen_at: string | null;
      status: components['schemas']['HardwareDeviceStatus'];
    };
    /**
     * HardwareDeviceStatus
     * @enum {string}
     */
    HardwareDeviceStatus: HardwareDeviceStatus;
    /**
     * HarnessBackfillResource
     * @description The harness stores backfilled by phase 2b. The DAG loops over all of these.
     * @enum {string}
     */
    HarnessBackfillResource: HarnessBackfillResource;
    /**
     * HealthAccId
     * @description Canonical Health NZ ACC questionnaire identifiers.
     * @enum {string}
     */
    HealthAccId: HealthAccId;
    /**
     * HealthNzAcc45Questionnaire
     * @description ACC 45 registration questionnaire with Health NZ identifiers and typed items.
     */
    HealthNzAcc45Questionnaire: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: components['schemas']['HealthAccId'] | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Canonical identifier for this questionnaire, represented as a URI (globally unique)
       * @description An absolute URI that is used to identify this questionnaire when it is referenced in a specification, model, design or an instance.
       */
      url?: string | null;
      /**
       * Additional identifier for the questionnaire
       * @description A formal identifier that is used to identify this questionnaire when it is represented in other formats, or referenced in a specification, model, design or an instance.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Business version of the questionnaire
       * @description The identifier that is used to identify this version of the questionnaire when it is referenced in a specification, model, design or instance.
       */
      version?: string | null;
      /**
       * Name for this questionnaire (computer friendly)
       * @description A natural language name identifying the questionnaire. This name should be usable as an identifier for the module by machine processing applications such as code generation.
       */
      name?: string | null;
      /**
       * Name for this questionnaire (human friendly)
       * @description A short, descriptive, user-friendly title for the questionnaire.
       */
      title?: string | null;
      /**
       * Instantiates protocol or definition
       * @description The URL of a Questionnaire that this Questionnaire is based on.
       */
      derivedFrom?: string[] | null;
      /**
       * draft | active | retired | unknown
       * @description The status of this questionnaire. Enables tracking the life-cycle of the content.
       */
      status: components['schemas']['QuestionnaireStatus'];
      /**
       * For testing purposes, not real usage
       * @description A Boolean value to indicate that this questionnaire is authored for testing purposes and is not intended to be used for genuine usage.
       */
      experimental?: boolean | null;
      /**
       * Resource that can be subject of QuestionnaireResponse
       * @description The types of subjects that can be the subject of responses created for the questionnaire.
       */
      subjectType?: string[] | null;
      /**
       * Date last changed
       * @description The date (and optionally time) when the questionnaire was published.
       */
      date?: string | null;
      /**
       * Name of the publisher (organization or individual)
       * @description The name of the organization or individual that published the questionnaire.
       */
      publisher?: string | null;
      /**
       * Contact details for the publisher
       * @description Contact details to assist a user in finding and communicating with the publisher.
       */
      contact?: components['schemas']['ContactDetail'][] | null;
      /**
       * Natural language description of the questionnaire
       * @description A free text natural language description of the questionnaire from a consumer's perspective.
       */
      description?: string | null;
      /**
       * The context that the content is intended to support
       * @description The content was developed with a focus and intent of supporting the contexts that are listed.
       */
      useContext?: components['schemas']['UsageContext'][] | null;
      /**
       * Intended jurisdiction for questionnaire (if applicable)
       * @description A legal or geographic region in which the questionnaire is intended to be used.
       */
      jurisdiction?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Why this questionnaire is defined
       * @description Explanation of why this questionnaire is needed and why it has been designed as it has.
       */
      purpose?: string | null;
      /**
       * Use and/or publishing restrictions
       * @description A copyright statement relating to the questionnaire and/or its contents.
       */
      copyright?: string | null;
      /**
       * When the questionnaire was approved by publisher
       * @description The date on which the resource content was approved by the publisher.
       */
      approvalDate?: string | null;
      /**
       * When the questionnaire was last reviewed
       * @description The date on which the resource content was last reviewed.
       */
      lastReviewDate?: string | null;
      /**
       * When the questionnaire is expected to be used
       * @description The period during which the questionnaire content was or is planned to be in active use.
       */
      effectivePeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Concept that represents the overall questionnaire
       * @description An identifier for this question or group of questions in a particular terminology such as LOINC.
       */
      code?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding'][]
        | null;
      /**
       * Questions and sections within the Questionnaire
       * @description A particular question, question grouping or display text that is part of the questionnaire.
       */
      item?: components['schemas']['HealthNzAcc45QuestionnaireItem'][] | null;
    };
    /**
     * HealthNzAcc45QuestionnaireItem
     * @description ACC 45 registration questionnaire item with typed link identifiers.
     */
    HealthNzAcc45QuestionnaireItem: {
      linkId: components['schemas']['Acc45RegistrationLinkId'];
      /**
       * ElementDefinition - details for the item
       * @description This element is a URI that refers to an ElementDefinition that provides information about this item.
       */
      definition?: string | null;
      /**
       * Corresponding concept for this item in a terminology
       * @description A terminology code that corresponds to this group or question (e.g. a code from LOINC, which defines many questions and answers).
       */
      code?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding'][]
        | null;
      /**
       * E.g. "1(a)", "2.5.3"
       * @description A short label for a particular group, question or set of display text within the questionnaire used for reference by the individual completing the questionnaire.
       */
      prefix?: string | null;
      /**
       * Primary text for the item
       * @description The name of a section, the text of a question or text content for a display item.
       */
      text?: string | null;
      type: components['schemas']['QuestionnaireItemType'];
      /**
       * Only allow data when
       * @description A constraint indicating that this item should only be enabled when the specified condition is true.
       */
      enableWhen?: components['schemas']['QuestionnaireItemEnableWhen'][] | null;
      /**
       * all | any
       * @description Controls how multiple enableWhen values are interpreted - whether all or any must be true.
       */
      enableBehavior?: components['schemas']['QuestionnaireItemEnableBehavior'] | null;
      /**
       * Whether the item must be included in data results
       * @description An indication, if true, that the item must be present in a "completed" QuestionnaireResponse.
       */
      required?: boolean | null;
      /**
       * Whether the item may repeat
       * @description An indication, if true, that the item may occur multiple times in the response.
       */
      repeats?: boolean | null;
      /**
       * Don't allow human editing
       * @description An indication, when true, that the value cannot be changed by a human respondent to the Questionnaire.
       */
      readOnly?: boolean | null;
      /**
       * No more than this many characters
       * @description The maximum number of characters that are permitted in the answer to be considered a "valid" QuestionnaireResponse.
       */
      maxLength?: number | null;
      /**
       * Valueset containing permitted answers
       * @description A reference to a value set containing a list of codes representing permitted answers for a "choice" or "open-choice" question.
       */
      answerValueSet?: string | null;
      /**
       * Permitted answer
       * @description One of the permitted answers for a "choice" or "open-choice" question.
       */
      answerOption?: components['schemas']['QuestionnaireItemAnswerOption'][] | null;
      /**
       * Initial value(s) when item is first rendered
       * @description One or more values that should be pre-populated in the answer when initially rendering the questionnaire for user input.
       */
      initial?: components['schemas']['QuestionnaireItemInitial'][] | null;
      /**
       * Nested questionnaire items
       * @description Text, questions and other groups to be nested beneath a question or group.
       */
      item?: components['schemas']['HealthNzAcc45QuestionnaireItem'][] | null;
    };
    /**
     * HealthcareService
     * @description The details of a healthcare service available at a location.
     *
     *     https://hl7.org/fhir/R4/healthcareservice-definitions.html
     */
    HealthcareService: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** External identifiers for this item */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Whether this HealthcareService record is in active use
       * @description This flag is used to mark the record to not be used. This is not used when a center is closed for maintenance, or for holidays, the notAvailable period is to be used for this.
       */
      active?: boolean | null;
      /**
       * Organization that provides this service
       * @description The organization that provides this healthcare service.
       */
      providedBy?: components['schemas']['Reference'] | null;
      /**
       * Broad category of service being performed or delivered
       * @description Identifies the broad category of service being performed or delivered.
       */
      category?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Type of service that may be delivered or performed
       * @description The specific type of service that may be delivered or performed.
       */
      type?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Specialties handled by the HealthcareService
       * @description Collection of specialties handled by the service site. This is more of a medical term.
       */
      specialty?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Location(s) where service may be provided
       * @description The location(s) where this healthcare service may be provided.
       */
      location?: components['schemas']['Reference'][] | null;
      /**
       * Description of service as presented to a consumer while searching
       * @description Further description of the service as it would be presented to a consumer while searching.
       */
      name?: string | null;
      /**
       * Additional description and/or any specific issues not covered elsewhere
       * @description Any additional description of the service and/or any specific issues not covered by the other attributes, which can be displayed as further detail under the serviceName.
       */
      comment?: string | null;
      /** Extra details about the service that can't be placed in the other fields */
      extraDetails?: string | null;
      /**
       * Facilitates quick identification of the service
       * @description If there is a photo/symbol associated with this HealthcareService, it may be included here to facilitate quick identification of the service in a list.
       */
      photo?: components['schemas']['Attachment'] | null;
      /**
       * Contacts related to the healthcare service
       * @description List of contacts related to this specific healthcare service.
       */
      telecom?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint'][]
        | null;
      /**
       * Location(s) service is intended for/available to
       * @description The location(s) that this service is available to (not where the service is provided).
       */
      coverageArea?: components['schemas']['Reference'][] | null;
      /**
       * Conditions under which service is available/offered
       * @description The code(s) that detail the conditions under which the healthcare service is available/offered.
       */
      serviceProvisionCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Specific eligibility requirements required to use the service
       * @description Does this service have specific eligibility requirements that need to be met in order to use the service?
       */
      eligibility?: components['schemas']['HealthcareServiceEligibility'][] | null;
      /** Programs that this service is applicable to */
      program?: components['schemas']['CodeableConcept'][] | null;
      /** Collection of characteristics (attributes) */
      characteristic?: components['schemas']['CodeableConcept'][] | null;
      /**
       * The language that this service is offered in
       * @description Some services are specifically made available in multiple languages, this property permits a directory to declare the languages this is offered in. Typically this is only provided where a service operates in communities with mixed languages used.
       */
      communication?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Ways that the service accepts referrals
       * @description Ways that the service accepts referrals, if this is not provided then it is implied that no referral is required.
       */
      referralMethod?: components['schemas']['CodeableConcept'][] | null;
      /**
       * If an appointment is required for access to this service
       * @description Indicates whether or not a prospective consumer will require an appointment for a particular service at a site to be provided by the Organization. Indicates if an appointment is required for access to this service.
       */
      appointmentRequired?: boolean | null;
      /**
       * Times the Service Site is available
       * @description A collection of times that the Service Site is available.
       */
      availableTime?: components['schemas']['HealthcareServiceAvailableTime'][] | null;
      /**
       * Not available during this time due to provided reason
       * @description The HealthcareService is not available during this period of time due to the provided reason.
       */
      notAvailable?: components['schemas']['HealthcareServiceNotAvailable'][] | null;
      /**
       * Description of availability exceptions
       * @description A description of site availability exceptions, e.g. public holiday availability. Succinctly describing all possible exceptions to normal site availability as details in the available Times and not available Times.
       */
      availabilityExceptions?: string | null;
      /**
       * Technical endpoints providing access to electronic services operated for the healthcare service
       * @description Technical endpoints providing access to services operated for the specific healthcare services defined at this resource.
       */
      endpoint?: components['schemas']['Reference'][] | null;
    };
    /** HealthcheckResponse */
    HealthcheckResponse: {
      /** Success */
      success: boolean;
      /** Open Ai Status */
      open_ai_status: boolean;
      /** General Status */
      general_status: boolean;
    };
    /** HeidiEpicJWTSigningJWKPublic */
    HeidiEpicJWTSigningJWKPublic: {
      /**
       * Use
       * @default sig
       * @constant
       */
      use: 'sig';
      /**
       * Alg
       * @default RS256
       * @constant
       */
      alg: 'RS256';
      /**
       * Kty
       * @default RSA
       * @constant
       */
      kty: 'RSA';
      /**
       * N
       * @description RSA public key modulus. This large integer is base64url-encoded when serialized to JSON.
       */
      n: number;
      /**
       * E
       * @description RSA public key exponent. This integer is base64url-encoded when serialized to JSON.
       */
      e: number;
      /**
       * Kid
       * @default heidi-epic-jwt-signing-key
       * @constant
       */
      kid: 'heidi-epic-jwt-signing-key';
    };
    /**
     * HeidiJWKSet
     * @description Pydantic model representing a JSON Web Key Set (JWKS) document provided by Heidi.
     *     This document contains all public keys that Heidi uses for various
     *     cryptographic purposes (e.g., JWT signing for different partners, encryption).
     */
    HeidiJWKSet: {
      /**
       * Keys
       * @description A list of public JSON Web Key (JWK) objects, each containing details of a public key provided by Heidi.
       */
      keys: (
        | components['schemas']['HeidiEpicJWTSigningJWKPublic']
        | components['schemas']['HeidiNebulaJWTSigningJWKPublic']
        | components['schemas']['HeidiTelusJWTSigningJWKPublic']
      )[];
    };
    /**
     * HeidiNebulaJWTSigningJWKPublic
     * @description Public RS384 JWK that Heidi advertises for verifying Nebula
     *     ``client_assertion`` JWTs.
     *
     *     The ``kid`` is bound to ``NEBULA_SIGNING_KEY_ID``; Epic looks up our
     *     signing key by this identifier when validating assertions fetched
     *     from the JKU URL configured against our Nebula client registration.
     */
    HeidiNebulaJWTSigningJWKPublic: {
      /**
       * Use
       * @default sig
       * @constant
       */
      use: 'sig';
      /**
       * Alg
       * @default RS384
       * @constant
       */
      alg: 'RS384';
      /**
       * Kty
       * @default RSA
       * @constant
       */
      kty: 'RSA';
      /**
       * N
       * @description RSA public key modulus. This large integer is base64url-encoded when serialized to JSON.
       */
      n: number;
      /**
       * E
       * @description RSA public key exponent. This integer is base64url-encoded when serialized to JSON.
       */
      e: number;
      /**
       * Kid
       * @default
       * @constant
       */
      kid: '';
    };
    /**
     * HeidiPlatforms
     * @enum {string}
     */
    HeidiPlatforms: HeidiPlatforms;
    /**
     * HeidiTelusJWTSigningJWKPublic
     * @description Public RS256 JWK that Heidi advertises for verifying Telus CHR
     *     ``client_assertion`` JWTs (SMART-on-FHIR ``private_key_jwt``).
     *
     *     Telus CHR fetches this key from Heidi's hosted JWKS (``jwks_uri``
     *     registered on the Doorkeeper client) and looks it up by the ``kid``
     *     carried in the assertion's JWS header. Unlike Epic/Nebula, the ``kid``
     *     is environment-configured (``TELUS_CLIENT_KID``) so it can rotate
     *     without a code change.
     */
    HeidiTelusJWTSigningJWKPublic: {
      /**
       * Use
       * @default sig
       * @constant
       */
      use: 'sig';
      /**
       * Alg
       * @default RS256
       * @constant
       */
      alg: 'RS256';
      /**
       * Kty
       * @default RSA
       * @constant
       */
      kty: 'RSA';
      /**
       * N
       * @description RSA public key modulus. This large integer is base64url-encoded when serialized to JSON.
       */
      n: number;
      /**
       * E
       * @description RSA public key exponent. This integer is base64url-encoded when serialized to JSON.
       */
      e: number;
      /**
       * Kid
       * @description Key ID registered with Telus CHR (TELUS_CLIENT_KID).
       */
      kid: string;
    };
    /**
     * HeidiVersion
     * @description Which product generation a workspace member is on.
     *
     *     An int, not a StrEnum, because clients compare and order it.
     * @enum {integer}
     */
    HeidiVersion: HeidiVersion;
    /**
     * HookBinding
     * @description Declares one registered hook this agent (or sub-agent) opts into.
     *
     *     Mirrors the tool model: ``HOOKS`` is the global catalog of hook
     *     implementations keyed by ``Hook.name``; this binding is a reference by
     *     name. A sub-agent is its own ``AgentConfig``, so binding hooks here
     *     yields per-agent and per-sub-agent scoping from a single field.
     *
     *     An unknown ``name`` (no registered hook) is skipped gracefully at
     *     dispatch time (logged + metered, never raised) — hooks are usually
     *     non-critical side effects.
     */
    HookBinding: {
      /** Name */
      name: string;
    };
    /**
     * HookSpecResponse
     * @description One registered lifecycle hook, for the agent-config UI.
     *
     *     Operators opt an agent into a hook by adding ``HookBinding(name=...)`` to
     *     ``AgentConfig.hooks``; the FE renders these as labeled toggles. ``label``
     *     and ``description`` are operator-facing copy; ``name`` is the binding key.
     */
    HookSpecResponse: {
      /** Name */
      name: string;
      /** Label */
      label: string;
      /** Description */
      description: string;
      /** Blocking */
      blocking: boolean;
      /** Kinds */
      kinds: string[];
    };
    /** HourlyFrequency */
    HourlyFrequency: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: HourlyFrequencyKind;
    };
    /**
     * HubSpotCompanyArrResponse
     * @description Closed-won deal revenue total for a HubSpot company (Linear sync logic).
     */
    HubSpotCompanyArrResponse: {
      /** Arr Usd */
      arr_usd: number;
    };
    /**
     * HubSpotEntity
     * @description A resolved HubSpot entity (company, contact, or deal).
     */
    HubSpotEntity: {
      /** Id */
      id: string;
      /**
       * Entity Type
       * @enum {string}
       */
      entity_type: HubSpotEntityEntity_type;
      /** Label */
      label: string;
      /** Sublabel */
      sublabel?: string | null;
      /**
       * Properties
       * @default {}
       */
      properties: {
        [key: string]: string | null;
      };
    };
    /**
     * HubSpotEntityIds
     * @description HubSpot entity IDs attached to a ticket at creation time.
     */
    HubSpotEntityIds: {
      /** Company Id */
      company_id?: string | null;
      /** Contact Id */
      contact_id?: string | null;
      /** Deal Id */
      deal_id?: string | null;
    };
    /**
     * HubSpotFormField
     * @description Single field forwarded to the HubSpot Forms submission API.
     */
    HubSpotFormField: {
      /** Name */
      name: string;
      /** Value */
      value: string;
    };
    /**
     * HubSpotFormSubmissionContext
     * @description Optional context forwarded with a HubSpot form submission.
     *
     *     Mirrors the frontend ``HubSpotFormContext`` shape; the wire format uses
     *     HubSpot's camelCase keys, applied via ``to_hubspot_dict``.
     */
    HubSpotFormSubmissionContext: {
      /** Hutk */
      hutk?: string | null;
      /** Page Uri */
      page_uri?: string | null;
      /** Page Name */
      page_name?: string | null;
    };
    /**
     * HubSpotSearchResult
     * @description Response from the HubSpot entity search endpoint.
     */
    HubSpotSearchResult: {
      /** Results */
      results: components['schemas']['HubSpotEntity'][];
    };
    /**
     * HumanNameUse
     * @description The use of a human name.
     *
     *     https://hl7.org/fhir/R4/valueset-name-use.html
     * @enum {string}
     */
    HumanNameUse: HumanNameUse;
    /** IAAddGlobalAdminRequest */
    IAAddGlobalAdminRequest: {
      /** User Emails */
      user_emails: string[];
    };
    /** IAAddOrganizationMembersRequest */
    IAAddOrganizationMembersRequest: {
      /** User Emails */
      user_emails: string[];
      /** Role Ids */
      role_ids?: string[];
      /** @default DIRECT_ADD */
      method: components['schemas']['TeamAddMemberMethod'];
      display_language?: components['schemas']['LanguageCode'] | null;
      /** Send Onboarding Email */
      send_onboarding_email?: boolean | null;
    };
    /** IAAddOrganizationMembersResponse */
    IAAddOrganizationMembersResponse: {
      /** Success Emails */
      success_emails: string[];
      /** Failed Emails Data */
      failed_emails_data: {
        [key: string]: string;
      };
    };
    /**
     * IABindingCodeResponse
     * @description Response model for user's hardware binding code.
     */
    IABindingCodeResponse: {
      /** User Ref Id */
      user_ref_id: string;
      /** Binding Code */
      binding_code: string | null;
    };
    /**
     * IADeleteDeviceResponse
     * @description Response model after deleting a device.
     */
    IADeleteDeviceResponse: {
      /** Id */
      id: string;
      /**
       * Deleted
       * @default true
       */
      deleted: boolean;
    };
    /**
     * IAHardwareDeviceResponse
     * @description Response model for a hardware device in internal admin context.
     */
    IAHardwareDeviceResponse: {
      /** Id */
      id: string;
      /** Serial Number */
      serial_number?: string | null;
      /** User Id */
      user_id: string;
      /** Device Name */
      device_name: string;
      /** Device Model */
      device_model: string;
      /** Firmware Version */
      firmware_version: string;
      /**
       * Linked At
       * Format: date-time
       */
      linked_at: string;
      /** Unlinked At */
      unlinked_at?: string | null;
      /** Last Seen At */
      last_seen_at?: string | null;
      status: components['schemas']['HardwareDeviceStatus'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * IALinkDeviceRequest
     * @description Request model for linking a new device to a user.
     */
    IALinkDeviceRequest: {
      /**
       * Serial Number
       * @description Hardware serial number
       */
      serial_number: string;
      /**
       * Device Name
       * @description Friendly name for device
       */
      device_name: string;
      /**
       * Device Model
       * @description Device model identifier
       */
      device_model: string;
      /**
       * Firmware Version
       * @description Firmware version on device
       */
      firmware_version: string;
    };
    /**
     * IAListDevicesResponse
     * @description Response model for listing devices.
     */
    IAListDevicesResponse: {
      /** Devices */
      devices: components['schemas']['IAHardwareDeviceResponse'][];
      /** Total */
      total: number;
    };
    /** IAOrganizationResponse */
    IAOrganizationResponse: {
      organization: components['schemas']['OrganizationView'];
      /** Onboarding Email Status */
      onboarding_email_status?: string | null;
    };
    /** IAOrganizationWithTeamsResponse */
    IAOrganizationWithTeamsResponse: {
      organization: components['schemas']['IAOrganizationWithTeamsView'];
    };
    /** IAOrganizationWithTeamsView */
    IAOrganizationWithTeamsView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Owner Kinde Id */
      owner_kinde_id: string;
      /** Name */
      name: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Hide Remember Consent Checkbox */
      hide_remember_consent_checkbox?: boolean | null;
      /** Require Review Confirmation */
      require_review_confirmation?: boolean | null;
      mfa_info?: components['schemas']['TeamMFAInfo'] | null;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      /** Is Pilot */
      is_pilot?: boolean | null;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[];
      /** Is Allow Self Onboard */
      is_allow_self_onboard: boolean;
      /** Self Onboard Default Role Id */
      self_onboard_default_role_id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Sso Connection Ids
       * @description List of SSO connection IDs for enterprise SSO integration.
       */
      sso_connection_ids?: string[];
      /**
       * Sso Group
       * @description SSO group identifier. Field omitted if not configured, string value if group is configured.
       */
      sso_group?: string | null;
      /**
       * Allow Direct Session Sharing
       * @description When False, direct session sharing is disabled org-wide.
       * @default true
       */
      allow_direct_session_sharing: boolean;
      /**
       * Allow Session Link Sharing
       * @description When False, session link sharing is disabled org-wide.
       * @default false
       */
      allow_session_link_sharing: boolean;
      /**
       * Coding Case Creation Enabled
       * @description When True, completed sessions in this org are eligible to become clinical-coding cases (opt-in, set by internal admins).
       * @default false
       */
      coding_case_creation_enabled: boolean;
      /** @description Organisation-level session-inactivity-timeout override. When set, members of this organisation are signed out automatically after `minutes` of inactivity and cannot override the value for themselves. `None` when no override is configured. */
      session_timeout_info?: components['schemas']['SessionTimeoutInfo'] | null;
      /** @description Organisation-level Evidence settings that cascade to child teams. */
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
      /**
       * Disable Auto Extract
       * @description When True, the post-session patient-context auto-extract review popup is disabled org-wide (cascades to teams and members).
       * @default false
       */
      disable_auto_extract: boolean;
      /** Teams */
      teams?: components['schemas']['SimpleTeamView'][];
    };
    /**
     * IAPaginatedDevicesResponse
     * @description Response model for paginated device list.
     */
    IAPaginatedDevicesResponse: {
      /** Devices */
      devices: components['schemas']['IAHardwareDeviceResponse'][];
      /** Total */
      total: number;
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
    };
    /** IATeamAssignmentListItem */
    IATeamAssignmentListItem: {
      /** User Email */
      user_email: string;
      /** Team Name */
      team_name: string | null;
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /** User Exists */
      user_exists: boolean;
      /** User Current Team Name */
      user_current_team_name: string | null;
    };
    /** IATeamAssignmentListResponse */
    IATeamAssignmentListResponse: {
      /** Mappings */
      mappings: components['schemas']['IATeamAssignmentListItem'][];
    };
    /**
     * IAUnlinkDeviceResponse
     * @description Response model after unlinking a device.
     */
    IAUnlinkDeviceResponse: {
      /** Id */
      id: string;
      /**
       * Unlinked At
       * Format: date-time
       */
      unlinked_at: string;
    };
    /**
     * IAUpdateBindingCodeRequest
     * @description Request model for updating user's binding code.
     */
    IAUpdateBindingCodeRequest: {
      /**
       * Binding Code
       * @description 16-character alphanumeric binding code
       */
      binding_code: string;
    };
    /**
     * IAUpdateDeviceRequest
     * @description Request model for updating device details.
     */
    IAUpdateDeviceRequest: {
      /**
       * Device Name
       * @description Updated device name
       */
      device_name?: string | null;
      /**
       * Firmware Version
       * @description Updated firmware version
       */
      firmware_version?: string | null;
    };
    /** ICD10AMCodeConcept */
    ICD10AMCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * ICD10Code
     * @description ICD-10 code with metadata.
     */
    ICD10Code: {
      /** Code */
      code: string;
      /** Description */
      description: string;
      /** Confidence */
      confidence: number;
      /** Rationale */
      rationale?: string | null;
      /** Transcript Excerpt */
      transcript_excerpt?: string | null;
    };
    /** ICD10CodeConcept */
    ICD10CodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
      /** Billable */
      billable: boolean;
      /** Hcc Code */
      hcc_code?: number | null;
    };
    /** ICD10GMCodeConcept */
    ICD10GMCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** ICD10ITCodeConcept */
    ICD10ITCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** ICD10QACodeConcept */
    ICD10QACodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** ICD10UKCodeConcept */
    ICD10UKCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
      /** Billable */
      billable: boolean;
    };
    /** ICD10ZACodeConcept */
    ICD10ZACodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** ICD9CACodeConcept */
    ICD9CACodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** ICD9CMCodeConcept */
    ICD9CMCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * IDTypeRequest
     * @description Typed identifier (id, category) carried on userId / patientId / etc.
     *
     *     The wire field is ``type`` (Epic's spec), but the Mongo doc field is
     *     ``category`` (renamed to dodge the Python ``type`` builtin). The
     *     ``Field(alias="type")`` keeps the wire contract intact.
     */
    IDTypeRequest: {
      /** Id */
      id: string;
      type: components['schemas']['NebulaIDCategory'];
    };
    /**
     * IDTypes
     * @enum {string}
     */
    IDTypes: IDTypes;
    /** IOSApp */
    IOSApp: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: IOSAppType;
      /** @default Native */
      recording_source: components['schemas']['AppRecordingSource'];
    };
    /**
     * IdentifierUse
     * @description Identifies the purpose for this identifier, if known.
     *
     *     https://hl7.org/fhir/R4/valueset-identifier-use.html
     * @enum {string}
     */
    IdentifierUse: IdentifierUse;
    /**
     * Identity
     * @description Value object representing a single identity from an auth provider.
     * @example {
     *       "connection": "Username-Password-Authentication",
     *       "email": "user@example.com",
     *       "is_social": false,
     *       "provider": "auth0",
     *       "user_id": "auth0|123456789"
     *     }
     * @example {
     *       "connection": "google-oauth2",
     *       "email": "user@gmail.com",
     *       "is_social": true,
     *       "provider": "google-oauth2"
     *     }
     */
    Identity: {
      /**
       * Connection
       * @description The name of the connection (e.g., kerry_sso)
       */
      connection: string;
      /**
       * Is Social
       * @description Whether this is a social provider
       */
      is_social: boolean;
      /**
       * Provider
       * @description The provider of the connection (e.g., google, facebook, etc.)
       */
      provider: string;
      /**
       * User Id
       * @description User ID from the IdP provider(google, sso, etc.), not the vendor id
       */
      user_id?: string | null;
      /**
       * Email
       * @description Email address associated with this identity
       */
      email: string;
    };
    /**
     * IdentityProviderSyncState
     * @description state for identity provider sync.
     *     goal: sanity check, integrity check
     *     requirement:
     *       each communication with a vendor should have a state
     *       both auth0 and kinde should have their own state
     * @enum {string}
     */
    IdentityProviderSyncState: IdentityProviderSyncState;
    /**
     * Immunization
     * @description Describes the event of a patient being administered a vaccine.
     *
     *     A record of an immunization as reported by a patient, a clinician or
     *     another party.
     *
     *     https://hl7.org/fhir/R4/immunization-definitions.html
     */
    Immunization: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Business identifiers for this immunization record
       * @description A unique identifier assigned to this immunization record.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * completed | entered-in-error | not-done
       * @description Indicates the current status of the immunization event. Required by FHIR R4.
       */
      status: components['schemas']['ImmunizationStatus'];
      /**
       * Reason the immunization event was not performed
       * @description Indicates the reason the immunization event was not performed (generally only used for status of "not-done").
       */
      statusReason?: components['schemas']['CodeableConcept'] | null;
      /**
       * Vaccine that was administered or was to be administered
       * @description Vaccine that was administered or was to be administered. Required by FHIR R4.
       */
      vaccineCode: components['schemas']['CodeableConcept'];
      /**
       * The patient who received (or did not receive) the immunization
       * @description The patient who either received or did not receive the immunization. Required by FHIR R4.
       */
      patient: components['schemas']['Reference'];
      /**
       * Encounter the immunization was performed as part of
       * @description The visit or admission or other contact between patient and health care provider the immunization was performed as part of.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * Date vaccine administered or was to be administered
       * @description Date vaccine administered or was to be administered (exact dateTime preferred).
       */
      occurrenceDateTime?: string | null;
      /**
       * Date vaccine administered or was to be administered (string)
       * @description Date vaccine administered or was to be administered, as free text when an exact date is not known.
       */
      occurrenceString?: string | null;
      /**
       * Date the immunization was first captured in the record
       * @description The date the occurrence of the immunization was first captured in the record - potentially significantly after the occurrence of the event.
       */
      recorded?: string | null;
      /**
       * Content based on information from the vaccine administrator
       * @description An indication that the content of the record is based on information from the person who administered the vaccine.
       */
      primarySource?: boolean | null;
      /**
       * Source of the data when not from the vaccine administrator
       * @description The source of the data when the report of the immunization event is not based on information from the person who administered the vaccine.
       */
      reportOrigin?: components['schemas']['CodeableConcept'] | null;
      /**
       * Where the vaccine administration occurred
       * @description The service delivery location where the vaccine administration occurred.
       */
      location?: components['schemas']['Reference'] | null;
      /**
       * Name of vaccine manufacturer
       * @description Name of vaccine manufacturer.
       */
      manufacturer?: components['schemas']['Reference'] | null;
      /**
       * Lot number of the vaccine product
       * @description Lot number of the vaccine product.
       */
      lotNumber?: string | null;
      /**
       * Date vaccine batch expires
       * @description Date vaccine batch expires.
       */
      expirationDate?: string | null;
      /**
       * Body site where vaccine was administered
       * @description Body site where vaccine was administered.
       */
      site?: components['schemas']['CodeableConcept'] | null;
      /**
       * Path by which the vaccine product is taken into the body
       * @description The path by which the vaccine product is taken into the body.
       */
      route?: components['schemas']['CodeableConcept'] | null;
      /**
       * Quantity of vaccine product that was administered
       * @description The quantity of vaccine product that was administered.
       */
      doseQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Who performed the immunization event
       * @description Indicates who performed the immunization event.
       */
      performer?: components['schemas']['ImmunizationPerformer'][] | null;
      /**
       * Extra information about the immunization
       * @description Extra information about the immunization that is not conveyed by the other attributes.
       */
      note?: components['schemas']['Annotation'][] | null;
      /**
       * Reasons why the vaccine was administered
       * @description Reasons why the vaccine was administered.
       */
      reasonCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Condition/Observation/DiagnosticReport supporting the immunization
       * @description Condition, Observation or DiagnosticReport that supports why the immunization was administered.
       */
      reasonReference?: components['schemas']['Reference'][] | null;
      /**
       * Whether the dose is considered subpotent
       * @description Indication if a dose is considered to be subpotent. By default, a dose should be considered to be potent.
       */
      isSubpotent?: boolean | null;
      /**
       * Reason why a dose is considered subpotent
       * @description Reason why a dose is considered to be subpotent.
       */
      subpotentReason?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Educational material presented to the patient (or guardian)
       * @description Educational material presented to the patient (or guardian) at the time of vaccine administration.
       */
      education?: components['schemas']['ImmunizationEducation'][] | null;
      /**
       * Patient's eligibility for a funding program
       * @description Indicates a patient's eligibility for a funding program.
       */
      programEligibility?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Source of the vaccine actually administered
       * @description Indicates the source of the vaccine actually administered (may differ from patient eligibility).
       */
      fundingSource?: components['schemas']['CodeableConcept'] | null;
      /**
       * Adverse event associated in time to the immunization
       * @description Categorical data indicating that an adverse event is associated in time to an immunization.
       */
      reaction?: components['schemas']['ImmunizationReaction'][] | null;
      /**
       * Protocol (set of recommendations) followed for the dose
       * @description The protocol (set of recommendations) being followed by the provider who administered the dose.
       */
      protocolApplied?: components['schemas']['ImmunizationProtocolApplied'][] | null;
    };
    /**
     * ImmunizationEducation
     * @description Educational material presented to the patient (or guardian).
     *
     *     https://hl7.org/fhir/R4/immunization-definitions.html#Immunization.education
     */
    ImmunizationEducation: {
      /**
       * Identifier of the educational material
       * @description Identifier of the material presented to the patient.
       */
      documentType?: string | null;
      /**
       * Online reference to the educational material
       * @description Reference pointer to the educational material given to the patient if the information was on line.
       */
      reference?: string | null;
      /**
       * Date the educational material was published
       * @description Date the educational material was published.
       */
      publicationDate?: string | null;
      /**
       * Date the educational material was given to the patient
       * @description Date the educational material was given to the patient.
       */
      presentationDate?: string | null;
    };
    /**
     * ImmunizationFunction
     * @description The function a practitioner or organization played in an immunization event.
     *
     *     Used for ``Immunization.performer.function`` (Extensible binding), drawn
     *     from the HL7 v2-0443 code system.
     *
     *     https://hl7.org/fhir/R4/valueset-immunization-function.html
     * @enum {string}
     */
    ImmunizationFunction: ImmunizationFunction;
    /**
     * ImmunizationPerformer
     * @description Who performed the immunization event.
     *
     *     https://hl7.org/fhir/R4/immunization-definitions.html#Immunization.performer
     */
    ImmunizationPerformer: {
      /**
       * OP | AP - what type of performance was done
       * @description Describes the type of performance (e.g. ordering provider, administering provider, etc.).
       */
      function?: components['schemas']['ImmunizationFunction'] | null;
      /**
       * Who performed the immunization
       * @description The practitioner or organization who performed the action.
       */
      actor: components['schemas']['Reference'];
    };
    /**
     * ImmunizationProtocolApplied
     * @description The protocol (set of recommendations) followed for the dose.
     *
     *     https://hl7.org/fhir/R4/immunization-definitions.html#Immunization.protocolApplied
     */
    ImmunizationProtocolApplied: {
      /**
       * Name of the immunization series
       * @description One possible path to achieve presumed immunity against a disease - within the context of an authority.
       */
      series?: string | null;
      /**
       * Who published the protocol
       * @description Indicates the authority who published the protocol (e.g. ACIP) that is being followed.
       */
      authority?: components['schemas']['Reference'] | null;
      /**
       * Vaccine preventable disease
       * @description The vaccine preventable disease the dose is being administered against.
       */
      targetDisease?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Dose number within series (integer)
       * @description Nominal position in a series.
       */
      doseNumberPositiveInt?: number | null;
      /**
       * Dose number within series (string)
       * @description Nominal position in a series (used when an integer is not available, e.g. recurring booster).
       */
      doseNumberString?: string | null;
      /**
       * Recommended number of doses (integer)
       * @description The recommended number of doses to achieve immunity.
       */
      seriesDosesPositiveInt?: number | null;
      /**
       * Recommended number of doses (string)
       * @description The recommended number of doses to achieve immunity (used when an integer is not available).
       */
      seriesDosesString?: string | null;
    };
    /**
     * ImmunizationReaction
     * @description An adverse event associated in time to an immunization.
     *
     *     https://hl7.org/fhir/R4/immunization-definitions.html#Immunization.reaction
     */
    ImmunizationReaction: {
      /**
       * Date of reaction
       * @description Date of reaction to the immunization.
       */
      date?: string | null;
      /**
       * Details of the reaction
       * @description Details of the reaction.
       */
      detail?: components['schemas']['Reference'] | null;
      /**
       * Self-reported indicator
       * @description Self-reported indicator.
       */
      reported?: boolean | null;
    };
    /**
     * ImmunizationStatus
     * @description The status of an immunization event.
     *
     *     Used for ``Immunization.status`` (Required binding). Drawn from the
     *     ``event-status`` code system, but scoped to the three codes that are valid
     *     for immunization records (unlike :class:`ProcedureStatus` / ``EventStatus``,
     *     which include preparation/in-progress/on-hold/stopped/unknown).
     *
     *     https://hl7.org/fhir/R4/valueset-immunization-status.html
     * @enum {string}
     */
    ImmunizationStatus: ImmunizationStatus;
    /** ImportCPDRequest */
    ImportCPDRequest: {
      /**
       * Cpd Sources
       * @default []
       */
      cpd_sources: {
        [key: string]: unknown;
      }[];
      /**
       * Cpd Source Appearances
       * @default []
       */
      cpd_source_appearances: {
        [key: string]: unknown;
      }[];
      /**
       * Cpd Drafts
       * @default []
       */
      cpd_drafts: {
        [key: string]: unknown;
      }[];
      /**
       * Cpd Submissions
       * @default []
       */
      cpd_submissions: {
        [key: string]: unknown;
      }[];
      /**
       * Cpd Saved Sources
       * @default []
       */
      cpd_saved_sources: {
        [key: string]: unknown;
      }[];
      /** Target Workspace Id */
      target_workspace_id?: string | null;
    };
    /** ImportCPDResponse */
    ImportCPDResponse: {
      /** Inserted Count */
      inserted_count: number;
      /** Skipped Count */
      skipped_count: number;
    };
    /** ImportCallsRequest */
    ImportCallsRequest: {
      /**
       * Calls
       * @default []
       */
      calls: {
        [key: string]: unknown;
      }[];
      /** Target Workspace Id */
      target_workspace_id?: string | null;
    };
    /** ImportCallsResponse */
    ImportCallsResponse: {
      /** Inserted Count */
      inserted_count: number;
      /** Skipped Count */
      skipped_count: number;
    };
    /** ImportChatsChunkRequest */
    ImportChatsChunkRequest: {
      /**
       * Chats
       * @default []
       */
      chats: {
        [key: string]: unknown;
      }[];
      /**
       * Chat Message Records
       * @default []
       */
      chat_message_records: {
        [key: string]: unknown;
      }[];
      /** Target Workspace Id */
      target_workspace_id?: string | null;
    };
    /** ImportChatsChunkResponse */
    ImportChatsChunkResponse: {
      /** Chats Inserted */
      chats_inserted: number;
      /** Chat Message Records Inserted */
      chat_message_records_inserted: number;
      /** Skipped Count */
      skipped_count: number;
    };
    /** ImportConfigEntryResult */
    ImportConfigEntryResult: {
      /** Agent Id */
      agent_id: string;
      /** Version */
      version: number;
      /** Created */
      created: boolean;
    };
    /**
     * ImportConfigResult
     * @description Result of importing an agent config export into the current environment.
     */
    ImportConfigResult: {
      /** Results */
      results: components['schemas']['ImportConfigEntryResult'][];
    };
    /** ImportEvidenceRequest */
    ImportEvidenceRequest: {
      /**
       * Shared Chats
       * @default []
       */
      shared_chats: {
        [key: string]: unknown;
      }[];
      /**
       * Source Lists
       * @default []
       */
      source_lists: {
        [key: string]: unknown;
      }[];
      /**
       * Presentations
       * @default []
       */
      presentations: {
        [key: string]: unknown;
      }[];
      /**
       * Collections
       * @default []
       */
      collections: {
        [key: string]: unknown;
      }[];
      /**
       * User Documents
       * @default []
       */
      user_documents: {
        [key: string]: unknown;
      }[];
      /**
       * User Embeddings
       * @default []
       */
      user_embeddings: {
        [key: string]: unknown;
      }[];
      /**
       * Document Ingestion Jobs
       * @default []
       */
      document_ingestion_jobs: {
        [key: string]: unknown;
      }[];
      /** Target Workspace Id */
      target_workspace_id?: string | null;
    };
    /** ImportEvidenceResponse */
    ImportEvidenceResponse: {
      /** Inserted Count */
      inserted_count: number;
      /** Skipped Count */
      skipped_count: number;
    };
    /** ImportPatientProfilesRequest */
    ImportPatientProfilesRequest: {
      /** Patient Profiles */
      patient_profiles: {
        [key: string]: unknown;
      }[];
      /** Target User Mongo Id */
      target_user_mongo_id: string;
      /** Patient Documents */
      patient_documents?: {
        [key: string]: unknown;
      }[];
      /** Target Workspace Id */
      target_workspace_id?: string | null;
      /** User Ref Id */
      user_ref_id?: string | null;
    };
    /** ImportPatientProfilesSkippedRow */
    ImportPatientProfilesSkippedRow: {
      /** Row */
      row: number;
      /** Column */
      column?: string | null;
      /** Code */
      code: string;
      /** Reason */
      reason: string;
      /**
       * Raw Values
       * @default {}
       */
      raw_values: {
        [key: string]: string;
      };
    };
    /** ImportPersonalizationProfileRequest */
    ImportPersonalizationProfileRequest: {
      /** Personalization Profile */
      personalization_profile: {
        [key: string]: unknown;
      };
    };
    /** ImportPersonalizationProfileResponse */
    ImportPersonalizationProfileResponse: {
      /** Inserted */
      inserted: boolean;
    };
    /** ImportSessionsChunkRequest */
    ImportSessionsChunkRequest: {
      /** Sessions */
      sessions: {
        [key: string]: unknown;
      }[];
      /** Consult Notes */
      consult_notes: {
        [key: string]: unknown;
      }[];
      /** Documents */
      documents: {
        [key: string]: unknown;
      }[];
      /** Context Documents */
      context_documents: {
        [key: string]: unknown;
      }[];
      /** Audio Transcripts */
      audio_transcripts: {
        [key: string]: unknown;
      }[];
      /** Target User Mongo Id */
      target_user_mongo_id?: string | null;
      /** User Ref Id */
      user_ref_id?: string | null;
      /** Consult Note Edits */
      consult_note_edits?: {
        [key: string]: unknown;
      }[];
      /** Consult Note Reverts */
      consult_note_reverts?: {
        [key: string]: unknown;
      }[];
      /** Clinical Tasks */
      clinical_tasks?: {
        [key: string]: unknown;
      }[];
      /** Session Shares */
      session_shares?: {
        [key: string]: unknown;
      }[];
      /** Note Suggestions */
      note_suggestions?: {
        [key: string]: unknown;
      }[];
      /** Recording Bundles */
      recording_bundles?: {
        [key: string]: unknown;
      }[];
      /** Target Workspace Id */
      target_workspace_id?: string | null;
    };
    /** ImportSessionsChunkResponse */
    ImportSessionsChunkResponse: {
      /** Sessions Inserted */
      sessions_inserted: number;
      /** Consult Notes Inserted */
      consult_notes_inserted: number;
      /** Documents Inserted */
      documents_inserted: number;
      /** Context Documents Inserted */
      context_documents_inserted: number;
      /** Audio Transcripts Inserted */
      audio_transcripts_inserted: number;
      /**
       * Consult Note Edits Inserted
       * @default 0
       */
      consult_note_edits_inserted: number;
      /**
       * Consult Note Reverts Inserted
       * @default 0
       */
      consult_note_reverts_inserted: number;
      /**
       * Clinical Tasks Inserted
       * @default 0
       */
      clinical_tasks_inserted: number;
      /**
       * Session Shares Inserted
       * @default 0
       */
      session_shares_inserted: number;
      /**
       * Note Suggestions Inserted
       * @default 0
       */
      note_suggestions_inserted: number;
      /**
       * Recording Bundles Inserted
       * @default 0
       */
      recording_bundles_inserted: number;
    };
    /** ImportSnippetsRequest */
    ImportSnippetsRequest: {
      /** Snippets */
      snippets: {
        [key: string]: unknown;
      }[];
      /**
       * Target User Mongo Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      target_user_mongo_id: string;
      /** Target Workspace Id */
      target_workspace_id?: string | null;
    };
    /** ImportSnippetsResponse */
    ImportSnippetsResponse: {
      /** Inserted Count */
      inserted_count: number;
      /** Skipped Count */
      skipped_count: number;
    };
    /** ImportTemplatesRequest */
    ImportTemplatesRequest: {
      /** Templates */
      templates: {
        [key: string]: unknown;
      }[];
      /** Shared Templates */
      shared_templates?: {
        [key: string]: unknown;
      }[];
      /** Target Workspace Id */
      target_workspace_id?: string | null;
    };
    /** ImportTemplatesResponse */
    ImportTemplatesResponse: {
      /** Inserted Count */
      inserted_count: number;
      /** Skipped Count */
      skipped_count: number;
      /**
       * Shared Templates Inserted
       * @default 0
       */
      shared_templates_inserted: number;
      /**
       * Shared Templates Skipped
       * @default 0
       */
      shared_templates_skipped: number;
    };
    /** ImportUserRequest */
    ImportUserRequest: {
      /** User */
      user: {
        [key: string]: unknown;
      };
    };
    /** ImportUserResponse */
    ImportUserResponse: {
      /** Created */
      created: boolean;
      /** Message */
      message: string;
      /** User Mongo Id */
      user_mongo_id: string;
      /** User Workspace Id */
      user_workspace_id?: string | null;
    };
    /**
     * InSessionEvidenceUsageResponse
     * @description API response shape for in-session evidence usage.
     *
     *     Fields are declared explicitly rather than inherited from
     *     InSessionEvidenceUsage so persistence-only fields can never leak into
     *     the public response by accident.
     *
     *     current_period_end is derived at the response boundary via
     *     UserRepo.compute_expected_period_end (DST-correct, not persisted).
     *
     *     When adding a field, also update
     *     tests/schemas/test_evidence_usage_response.py.
     */
    InSessionEvidenceUsageResponse: {
      /**
       * Basic Used
       * @default 0
       */
      basic_used: number;
      /**
       * Advanced Used
       * @default 0
       */
      advanced_used: number;
      /** Current Period Start */
      current_period_start?: string | null;
      /** Current Period End */
      current_period_end?: string | null;
    };
    /** InTextLocation */
    InTextLocation: {
      /** Start */
      start: number;
      /** End */
      end: number;
    };
    /** InboxCountResponse */
    InboxCountResponse: {
      /** Pending */
      pending: number;
      /** Oldest Pending At */
      oldest_pending_at?: string | null;
    };
    /**
     * InboxDomainContext
     * @description Domain context — lets the UI reason about patient/session scope.
     */
    InboxDomainContext: {
      /** Patient Id */
      patient_id?: string | null;
      /** Patient Label */
      patient_label?: string | null;
      /** Session Id */
      session_id?: string | null;
      /** Session Label */
      session_label?: string | null;
      /** Agent Name */
      agent_name?: string | null;
      /** Agent Run Id */
      agent_run_id: string;
      /** Root Agent Run Id */
      root_agent_run_id?: string | null;
      /** Project Id */
      project_id?: string | null;
    };
    /**
     * InboxItem
     * @description Single inbox item projected from an ``ApprovalRecord``.
     */
    InboxItem: {
      /** Approval Id */
      approval_id: string;
      /** Subject User Id */
      subject_user_id?: string | null;
      status: components['schemas']['InboxItemStatus'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Updated At */
      updated_at?: string | null;
      /** Expires At */
      expires_at?: string | null;
      /** Resolved At */
      resolved_at?: string | null;
      /** Resolved By */
      resolved_by?: string | null;
      render: components['schemas']['InboxRenderContext'];
      actions: components['schemas']['InboxItemActions'];
      /** Tool Input Projection */
      tool_input_projection?: {
        [key: string]: unknown;
      } | null;
      /** Redacted Keys */
      redacted_keys?: string[];
      /**
       * Approval Kind
       * @default default
       */
      approval_kind: string;
      /** Resolution Reason */
      resolution_reason?: string | null;
      /** Response Schema */
      response_schema?: {
        [key: string]: unknown;
      } | null;
      /** Display */
      display?: {
        [key: string]: unknown;
      };
    };
    /**
     * InboxItemActions
     * @description Server-composed action URLs — clients never hard-code routing.
     */
    InboxItemActions: {
      /** Resolve Url */
      resolve_url: string;
      /** Supported Verdicts */
      supported_verdicts: string[];
      /** Available Override Scopes */
      available_override_scopes?: InboxItemActionsAvailable_override_scopes[];
    };
    /**
     * InboxItemStatus
     * @enum {string}
     */
    InboxItemStatus: InboxItemStatus;
    /** InboxListResponse */
    InboxListResponse: {
      /** Items */
      items: components['schemas']['InboxItem'][];
      /** Total */
      total: number;
      /** Total Pending */
      total_pending: number;
      /**
       * Fetched At
       * Format: date-time
       */
      fetched_at: string;
    };
    /** InboxMessageLink */
    InboxMessageLink: {
      /**
       * Type
       * @constant
       */
      type: 'INBOX_MESSAGE';
      /** Id */
      id: string;
    };
    /**
     * InboxRenderContext
     * @description Presentation context projected from privileged source records.
     */
    InboxRenderContext: {
      /** Headline */
      headline: string;
      /** Summary */
      summary?: string | null;
      /** Tool Label */
      tool_label?: string | null;
      /**
       * Risk
       * @default write
       * @enum {string}
       */
      risk: InboxRenderContextRisk;
      /** Icons */
      icons?: string[];
      domain: components['schemas']['InboxDomainContext'];
    };
    /** InboxSubjectsResponse */
    InboxSubjectsResponse: {
      /** Subject User Ids */
      subject_user_ids: string[];
    };
    /**
     * InboxWebSocketTicketView
     * @description Short-lived opaque ticket for WebSocket ``/calls/inbox/ws``.
     */
    InboxWebSocketTicketView: {
      /** Ticket */
      ticket: string;
      /** Expires In */
      expires_in: number;
    };
    /** IncorporateOrdersResponseSchema */
    IncorporateOrdersResponseSchema: {
      /** Note */
      note: string;
      content_type: components['schemas']['ContentType'];
    };
    /** IncorporateOrdersSchema */
    IncorporateOrdersSchema: {
      /** Orders */
      orders?: string[];
      /** Removed */
      removed?: string[];
      content_type?: components['schemas']['ContentType'] | null;
    };
    /** InfoItem */
    InfoItem: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: InfoItemKind;
      /** Item Id */
      item_id: string;
      /** Text */
      text: string;
    };
    /** IngestUsageEventRequest */
    IngestUsageEventRequest: {
      event_type: components['schemas']['BillableEventType'];
      /** Idempotency Source */
      idempotency_source: string;
      /**
       * User Ref Id
       * Format: uuid
       */
      user_ref_id: string;
      /** Product */
      product: string;
      /** Feature */
      feature?: string | null;
      /** Unit Type */
      unit_type: string;
      /** Quantity */
      quantity: number;
      /**
       * Occurred At
       * Format: date-time
       */
      occurred_at: string;
      /** Workspace Id */
      workspace_id: string;
      /** Billing Account Id */
      billing_account_id?: string | null;
      /**
       * Properties
       * @description Freeform product metadata — no PHI. Scalars only.
       */
      properties?: {
        [key: string]: unknown;
      };
      /** Token Count */
      token_count?: number | null;
      outcome?: components['schemas']['UsageOutcome'] | null;
      /** Model */
      model?: string | null;
    };
    /** InsertCollectionRequest */
    InsertCollectionRequest: {
      collection_type: components['schemas']['ValidRegionSyncCollectionTypes'];
      /** Data */
      data: unknown[];
    };
    /** InsertCollectionResponse */
    InsertCollectionResponse: {
      collection_type: components['schemas']['ValidRegionSyncCollectionTypes'];
      /** Inserted Count */
      inserted_count: number;
      /** Skipped Count */
      skipped_count: number;
      /** Skipped Existing Count */
      skipped_existing_count: number;
      /** Skipped Error Count */
      skipped_error_count: number;
      /** Errors */
      errors: string[];
    };
    /** IntegrationAgentCommandErrorDetail */
    IntegrationAgentCommandErrorDetail: {
      /** Code */
      code: string;
      /** Message */
      message: string;
      /**
       * Retryable
       * @default false
       */
      retryable: boolean;
    };
    /** IntegrationAgentCommandPayload */
    IntegrationAgentCommandPayload: {
      /**
       * Request Id
       * @description Idempotency key - agent checks this before executing
       */
      request_id: string;
      /**
       * Action
       * @description EHR action to perform, e.g. 'search_patients'
       */
      action: string;
      /**
       * Params
       * @description Action-specific parameters
       */
      params?: {
        [key: string]: unknown;
      };
      /**
       * Ehr Context
       * @description EHR credentials (ehr_system, sender, password, instance_url). Decrypted from EncryptedDict in MongoDB and transmitted to the agent over the authenticated HTTPS /sync channel. ml-scribe does not log response bodies on this endpoint - configure APM agents accordingly.
       */
      ehr_context: {
        [key: string]: unknown;
      };
    };
    /** IntegrationAgentCommandResultRequest */
    IntegrationAgentCommandResultRequest: {
      status: components['schemas']['IntegrationAgentCommandResultStatus'];
      /**
       * Completed At
       * Format: date-time
       */
      completed_at?: string;
      /** Data */
      data?: {
        [key: string]: unknown;
      } | null;
      error?: components['schemas']['IntegrationAgentCommandErrorDetail'] | null;
    };
    /** IntegrationAgentCommandResultResponse */
    IntegrationAgentCommandResultResponse: {
      /**
       * Acknowledged
       * @default true
       */
      acknowledged: boolean;
    };
    /**
     * IntegrationAgentCommandResultStatus
     * @description Terminal statuses an agent can self-report for a completed command attempt.
     * @enum {string}
     */
    IntegrationAgentCommandResultStatus: IntegrationAgentCommandResultStatus;
    /**
     * IntegrationAgentOnlineStatus
     * @description Runtime connectivity status of an Integration Agent as seen by the web app.
     * @enum {string}
     */
    IntegrationAgentOnlineStatus: IntegrationAgentOnlineStatus;
    /**
     * IntegrationAgentProvider
     * @description EHR system a Rust Integration Agent is connected to.
     *
     *     Represents WHAT EHR the agent talks to. The agent only handles web-initiated
     *     requests — the desktop Tauri path is a completely separate workflow that does
     *     not involve the Integration Agent at all.
     *
     *     Note: intentionally distinct from EHRProvider in utils/enums.py, which uses
     *     title/upper-case values and covers the full EHR profile
     *     feature. Do not merge the two enums.
     * @enum {string}
     */
    IntegrationAgentProvider: IntegrationAgentProvider;
    /** IntegrationAgentPublic */
    IntegrationAgentPublic: {
      /** Id */
      id: string;
      ehr_system: components['schemas']['IntegrationAgentProvider'];
      /** Clinic Name */
      clinic_name: string | null;
      /** Label */
      label: string | null;
      status: components['schemas']['IntegrationAgentStatus'];
      /** Hostname */
      hostname: string | null;
      /** Agent Version */
      agent_version: string | null;
      /** Ehr Connected */
      ehr_connected: boolean;
      /** Ehr Version */
      ehr_version: string | null;
      /** Last Seen */
      last_seen: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** IntegrationAgentRegisterRequest */
    IntegrationAgentRegisterRequest: {
      /**
       * Hostname
       * @description Machine hostname
       */
      hostname: string;
      /**
       * Version
       * @description Agent binary version
       * @example 1.2.0
       */
      version: string;
      /**
       * Supported Ehr
       * @description EHR systems this binary supports - compile-time knowledge, always known
       * @example [
       *       "genie"
       *     ]
       */
      supported_ehr: string[];
      /**
       * Rpa Target
       * @description Whether this agent is an RPA target instance.
       * @default false
       */
      rpa_target: boolean;
    };
    /** IntegrationAgentRegisterResponse */
    IntegrationAgentRegisterResponse: {
      /** Clinic Name */
      clinic_name: string | null;
      /** Ehr System */
      ehr_system: string;
      /** Label */
      label?: string | null;
    };
    /**
     * IntegrationAgentStatus
     * @description Provisioning status of an Integration Agent key.
     * @enum {string}
     */
    IntegrationAgentStatus: IntegrationAgentStatus;
    /** IntegrationAgentStatusResponse */
    IntegrationAgentStatusResponse: {
      /** Agent Id */
      agent_id: string;
      /** Clinic Name */
      clinic_name: string | null;
      /** Ehr System */
      ehr_system: string;
      /** Label */
      label?: string | null;
      status: components['schemas']['IntegrationAgentOnlineStatus'];
      /** Agent Version */
      agent_version?: string | null;
      /** Ehr Connected */
      ehr_connected: boolean;
      /** Ehr Version */
      ehr_version?: string | null;
      /** Last Seen */
      last_seen?: string | null;
      /** Last Error */
      last_error?: string | null;
      /** Hostname */
      hostname?: string | null;
      /**
       * Rpa Target
       * @default false
       */
      rpa_target: boolean;
    };
    /** IntegrationAgentSyncRequest */
    IntegrationAgentSyncRequest: {
      /**
       * Uptime Secs
       * @description Agent process uptime in seconds
       */
      uptime_secs: number;
      /**
       * Ehr Connected
       * @description Whether the agent has an active EHR connection
       */
      ehr_connected: boolean;
      /**
       * Ehr Version
       * @description EHR software version. Required when ehr_connected is True.
       */
      ehr_version?: string | null;
      /**
       * Last Error
       * @description Last error string from the agent, or None if healthy.
       */
      last_error?: string | null;
      /**
       * Rpa Target
       * @description Whether this agent is an RPA target instance. Re-asserted on every sync heartbeat; omitted field defaults to false.
       * @default false
       */
      rpa_target: boolean;
    };
    /** IntegrationAgentSyncResponse */
    IntegrationAgentSyncResponse: {
      /** Commands */
      commands: components['schemas']['IntegrationAgentCommandPayload'][];
      /**
       * Server Time
       * Format: date-time
       */
      server_time: string;
    };
    /** IntegrationAgentsResponse */
    IntegrationAgentsResponse: {
      /** Agents */
      agents: components['schemas']['IntegrationAgentStatusResponse'][];
    };
    /**
     * IntegrationAppointment
     * @description Appointment class with provider details for integration types.
     */
    IntegrationAppointment: {
      provider_details: components['schemas']['IntegrationAppointmentProviderDetails'];
      /**
       * Start
       * Format: date-time
       */
      start: string;
      /**
       * End
       * Format: date-time
       */
      end: string;
      status?: components['schemas']['AppointmentStatus'] | null;
      /**
       * Display Facets
       * @description Provider-agnostic schedule facets. Omitted when the adaptor has none; when present the list is non-empty.
       *
       *     FE must be dynamic — do not hardcode ``facet`` string checks. Row labels: facets with ``show_in_row: true``, text = ``display`` if set else ``value``. Filter UI: collect unique ``(facet, value, display)`` tuples from the schedule response; send ``filter={facet}:{value}`` when filtering.
       *
       *     Example Athena row (``East Clinic · Group One`` inline; provider hidden because ``show_in_row: false``)::
       *
       *         display_facets: [
       *           {facet: department, value: "196", display: "East Clinic", show_in_row: true},
       *           {facet: provider_group, value: "1", display: "Group One", show_in_row: true},
       *           {facet: provider, value: "123", show_in_row: false}
       *         ]
       */
      display_facets?: components['schemas']['IntegrationDisplayFacet'][] | null;
    };
    /**
     * BaseAppointmentProviderDetails
     * @description Base model for provider-specific appointment details.
     *
     *     Frozen by default — all fields are immutable after construction.
     *     Subclasses that need patchable fields must override with
     *     ``model_config = ConfigDict(frozen=False, validate_assignment=True)``
     *     and explicitly re-freeze identity fields via ``Field(frozen=True)``.
     *     Any field left unfrozen is considered patchable and will be accepted
     *     by ``IntegrationSessionLinkService.update_provider_appointment_details``.
     */
    IntegrationAppointmentProviderDetails: {
      /** Provider */
      provider: string;
      /** Unique Identifier */
      unique_identifier: string;
    };
    /**
     * IntegrationCapabilities
     * @description Response schema for provider capabilities.
     */
    IntegrationCapabilities: {
      /** Provider */
      provider: string;
      /** Supports Get Patient */
      supports_get_patient: boolean;
      /** Supports Get Practitioner */
      supports_get_practitioner: boolean;
      /** Supports Get Schedule */
      supports_get_schedule: boolean;
      /** Supports Search Patient */
      supports_search_patient: boolean;
      /** Supports Sync Notes */
      supports_sync_notes: boolean;
      /** Supports Sync Sectional Notes */
      supports_sync_sectional_notes: boolean;
      /** Supports Sync Letter */
      supports_sync_letter: boolean;
      /** Supports Sync Document */
      supports_sync_document: boolean;
      /** Supports Sync Notes With Options */
      supports_sync_notes_with_options: boolean;
      /** Supports Create Patient */
      supports_create_patient: boolean;
      /** Supports Search Practitioner */
      supports_search_practitioner: boolean;
      /** Supports Search Location */
      supports_search_location: boolean;
      /** Supports Search Appointment */
      supports_search_appointment: boolean;
      /** Supports Upload File */
      supports_upload_file: boolean;
    };
    /**
     * IntegrationClientAuthType
     * @description Authentication mechanism the client uses at the token endpoint.
     * @enum {string}
     */
    IntegrationClientAuthType: IntegrationClientAuthType;
    /**
     * IntegrationClientCreatedResponse
     * @description Returned once at creation time — the only time the secret is visible.
     */
    IntegrationClientCreatedResponse: {
      /** Client Id */
      client_id: string;
      /** Client Secret */
      client_secret: string;
      /** Display Name */
      display_name: string;
      /** Provider */
      provider: string;
      status: components['schemas']['IntegrationClientStatus'];
      /** Created By */
      created_by: string;
    };
    /**
     * IntegrationClientResponse
     * @description Public representation of an integration client (no secret).
     *
     *     Inherits all public fields from ``IntegrationClientBase``.
     */
    IntegrationClientResponse: {
      /** Client Id */
      client_id: string;
      /** Display Name */
      display_name: string;
      status: components['schemas']['IntegrationClientStatus'];
      /** @default BEARER */
      auth_type: components['schemas']['IntegrationClientAuthType'];
      /** Provider */
      provider: string;
      /** Created By */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Revoked At */
      revoked_at?: string | null;
    };
    /**
     * IntegrationClientStatus
     * @enum {string}
     */
    IntegrationClientStatus: IntegrationClientStatus;
    /** IntegrationConsultNoteLinkResponse */
    IntegrationConsultNoteLinkResponse: {
      provider_note_details: components['schemas']['IntegrationConsultNoteProviderDetails'];
      /** Last Synced At */
      last_synced_at?: string | null;
    };
    /**
     * BaseConsultNoteProviderDetails
     * @description Abstract base for provider-specific consult-note details.
     *
     *     Every integration provider must define its own concrete subclass
     *     (e.g. ``NookalConsultNoteProviderDetails``).  Direct instantiation of
     *     this base class is prevented at runtime via ``__init__``.
     */
    IntegrationConsultNoteProviderDetails: {
      /** Provider */
      provider: string;
      /** Unique Identifier */
      unique_identifier: string;
    };
    /** IntegrationDetails */
    IntegrationDetails: {
      /** Ehr Provider */
      ehr_provider: string;
      /** Widget Note Push Limit */
      widget_note_push_limit?: number | null;
    };
    /**
     * IntegrationDisplayFacet
     * @description A single integration display facet on a schedule appointment.
     *
     *     FE should treat the list as provider-agnostic: do not hardcode checks on
     *     ``facet`` (e.g. ``facet === 'provider_group'``). Use ``show_in_row`` for
     *     inline schedule labels, ``display`` (else ``value``) for visible text, and
     *     ``facet`` + ``value`` as the stable key pair for filter query params.
     */
    IntegrationDisplayFacet: {
      /** Facet */
      facet: string;
      /** Value */
      value: string;
      /** Display */
      display?: string | null;
      /**
       * Show In Row
       * @default false
       */
      show_in_row: boolean;
    };
    /**
     * IntegrationInfo
     * @description Single integration entry returned by the integrations list endpoint.
     */
    IntegrationInfo: {
      /**
       * Key
       * @description Integration identifier
       * @enum {string}
       */
      key: IntegrationInfoKey;
      /**
       * Name
       * @description Human-readable display name
       */
      name: string;
      /**
       * Use Tavily
       * @description Pass this value in the selected partner's search configuration.
       * @default false
       */
      use_tavily: boolean;
      /**
       * Is Available
       * @description Whether this integration is configured and available in the requested region
       */
      is_available: boolean;
      /**
       * Logo Url
       * @description URL to the integration logo asset
       */
      logo_url: string;
      /**
       * Brand Color
       * @description Brand hex colour (e.g. '#1B4B8A')
       */
      brand_color: string;
      /**
       * Requires Setup
       * @description Whether this integration requires user-level setup before use
       * @default false
       */
      requires_setup: boolean;
      /**
       * Setup Config
       * @description User's stored setup config when requires_setup=True. Presence indicates setup is complete; null means not yet configured.
       */
      setup_config?: {
        [key: string]: unknown;
      } | null;
      /**
       * Last Updated
       * @description When this partner's data was last successfully refreshed by our sync pipeline. Null when no sync has completed yet, when the partner has no sync (e.g. real-time API), or when we cannot determine it.
       */
      last_updated?: string | null;
      /**
       * Data Version
       * @description Partner-published version string for the data we currently hold (e.g. 'February 2026' for MIMS). Distinct from last_updated, which is when we last refreshed. Null when the partner has no equivalent concept.
       */
      data_version?: string | null;
    };
    IntegrationOnboardingExecutionStep:
      | components['schemas']['CompletedIntegrationOnboardingExecutionStep']
      | components['schemas']['FailedIntegrationOnboardingExecutionStep']
      | components['schemas']['PendingIntegrationOnboardingExecutionStep'];
    /** IntegrationOnboardingStepExecutionRequest */
    IntegrationOnboardingStepExecutionRequest: {
      /**
       * Payload
       * @description Input data for step execution
       */
      payload: {
        [key: string]: unknown;
      };
    };
    /** IntegrationOnboardingStepExecutionResponse */
    IntegrationOnboardingStepExecutionResponse: {
      /**
       * Step Id
       * @description Unique identifier of the step executed
       */
      step_id: string;
      /**
       * Step Result
       * @description Result of the step execution if successful
       */
      step_result: {
        [key: string]: unknown;
      } | null;
      /**
       * Step Error
       * @description Error information if step execution failed
       */
      step_error: {
        [key: string]: unknown;
      } | null;
      /** @description Execution status of the step */
      step_status: components['schemas']['StepExecutionStatus'];
      /** @description Updated session after step execution */
      updated_session: components['schemas']['CreateIntegrationOnboardingSessionResponse'];
    };
    /**
     * IntegrationOption
     * @enum {string}
     */
    IntegrationOption: IntegrationOption;
    /**
     * IntegrationPartnerAdmin
     * @description Stores admin details for integration partners including EHR information
     */
    IntegrationPartnerAdmin: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Ehr User Id */
      ehr_user_id: string;
      /** Ehr Email */
      ehr_email: string;
      /** Ehr Provider */
      ehr_provider: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
    };
    /**
     * IntegrationPartnerConfig
     * @description Configuration for a single integration partner search.
     */
    IntegrationPartnerConfig: {
      /**
       * Partner
       * @description Integration partner identifier
       * @enum {string}
       */
      partner: IntegrationPartnerConfigPartner;
      /**
       * Enabled
       * @description Whether to include this partner in search
       * @default true
       */
      enabled: boolean;
      /**
       * Max Results
       * @description Maximum results from this partner
       * @default 10
       */
      max_results: number;
      /**
       * Region
       * @description ISO 3166-1 alpha-2 country code to filter results by region (e.g., 'FR', 'DE'). Partners with regional support will filter accordingly.
       */
      region?: string | null;
      /**
       * Zone Id
       * @description Zone identifier for partners requiring zone-based search (e.g., HealthPathways zone_id resolved from the user's postcode). When omitted the orchestrator auto-fills from the user's stored config.
       */
      zone_id?: string | null;
      /**
       * Enable Structured Cds
       * @description Elsevier-only: route interaction/allergy/ADR/disease intents to structured GSDD CDS endpoints. Set from PostHog release-partner-elsevier-structured-cds before search.
       * @default false
       */
      enable_structured_cds: boolean;
      /**
       * Use Cortex
       * @description CKS-only: when True, search via Agilio Cortex instead of Mongo vector. Set server-side from release-partner-cks-cortex; clients should leave this unset.
       * @default false
       */
      use_cortex: boolean;
      /**
       * Use Tavily
       * @description Add domain-restricted Tavily retrieval for Wiley or NEJM alongside native search when configured and permitted. Publishers without a native adapter always use Tavily.
       * @default false
       */
      use_tavily: boolean;
    };
    /**
     * IntegrationPartnerUsageRecord
     * @description Per-partner usage record for a single evidence chat turn.
     */
    IntegrationPartnerUsageRecord: {
      /**
       * Partner
       * @description Partner key, e.g. 'bmj', 'healthpathways'
       */
      partner: string;
      /**
       * Enabled
       * @description Was the partner toggled on for this request
       */
      enabled: boolean;
      /**
       * Searched
       * @description Did we actually execute a search against this partner
       * @default false
       */
      searched: boolean;
      /**
       * Results Returned
       * @description Number of results returned from the partner
       * @default 0
       */
      results_returned: number;
      /**
       * Results Cited
       * @description Number of partner results cited in the response
       * @default 0
       */
      results_cited: number;
      /**
       * Cited Item Ids
       * @description Specific partner item IDs that were cited
       */
      cited_item_ids?: string[];
      /**
       * Region
       * @description Region/locale used for this partner search
       */
      region?: string | null;
    };
    /**
     * IntegrationPatient
     * @description Patient class with provider details for integration types.
     */
    IntegrationPatient: {
      provider_details: components['schemas']['IntegrationPatientProviderDetails'];
      /** Name */
      name?: components['schemas']['fhir__resources__humanname__HumanName'][] | null;
      gender: components['schemas']['GenderIdentity'];
      /** Birthdate */
      birthDate?: string | null;
      /** Telecom */
      telecom?:
        | components['schemas']['fhir__resources__contactpoint__ContactPoint'][]
        | null;
      sex: components['schemas']['BirthSex'];
      /** Identifiers */
      identifiers?: components['schemas']['dataclass__patient_profile__Identifier'][];
    };
    /** BasePatientProviderDetails */
    IntegrationPatientProviderDetails: {
      /** Provider */
      provider: string;
      /** Unique Identifier */
      unique_identifier: string;
    };
    /** IntegrationRequestBase */
    IntegrationRequestBase: {
      /** Integration Name */
      integration_name: string;
      /** Email */
      email: string;
      /**
       * Is Clinician Decision Maker
       * @default false
       */
      is_clinician_decision_maker: boolean;
    };
    /**
     * IntegrationsListResponse
     * @description Response for GET /evidence/integrations.
     */
    IntegrationsListResponse: {
      /** Integrations */
      integrations: components['schemas']['IntegrationInfo'][];
    };
    /** IntercomUserHashResponse */
    IntercomUserHashResponse: {
      /** User Hash */
      user_hash: string | null;
    };
    /** InternalAdminAICommandResponse */
    InternalAdminAICommandResponse: {
      /** Name */
      name: string;
      /** Title */
      title: string;
      generation_use: components['schemas']['GenerationUse'];
    };
    /** InternalAdminAddOnProductView */
    InternalAdminAddOnProductView: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      add_on_details: components['schemas']['IntegrationDetails'];
      status: components['schemas']['AddOnProductStatus'];
      /** Vendor Products */
      vendor_products: components['schemas']['InternalAdminStripeProductView'][];
      /** Free Trial Days */
      free_trial_days: number;
      /** @default FREE */
      minimum_eligible_purchase_tier: components['schemas']['SubscriptionTier'];
    };
    /** InternalAdminApproveTemplateRevisionRequest */
    InternalAdminApproveTemplateRevisionRequest: {
      /** Name */
      name?: string | null;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      template_category?: components['schemas']['TemplateCategory'] | null;
      /** Problem Based Charting Enabled */
      problem_based_charting_enabled?: boolean | null;
      /** Use Sections */
      use_sections?: boolean | null;
      /** Example Output */
      example_output?: string | null;
      /** Url Path */
      url_path: string;
    };
    /**
     * InternalAdminAuditEvent
     * @description Events triggered by internal-admin tooling or platform/system actors.
     *
     *     For events triggered by end users acting on their own account, use
     *     :class:`UserSelfServiceAuditEvent` instead.
     * @enum {string}
     */
    InternalAdminAuditEvent: InternalAdminAuditEvent;
    /** InternalAdminBatchDeleteAddOnProductRequest */
    InternalAdminBatchDeleteAddOnProductRequest: {
      /** Add On Product Ids */
      add_on_product_ids: string[];
    };
    /**
     * InternalAdminBillingAccountResponse
     * @description Response wrapper. `billing_account` is null when the user has no
     *     `BillingAccountDO` yet (common during the legacy→BillingAccount cutover).
     */
    InternalAdminBillingAccountResponse: {
      billing_account?: components['schemas']['InternalAdminBillingAccountView'] | null;
    };
    /**
     * InternalAdminBillingAccountView
     * @description Internal-admin read-only projection of a `BillingAccountDO`.
     *
     *     `trial_history` is exposed at the account level (the model stores it there).
     *     Per-subscription `free_trial_history` is intentionally not surfaced —
     *     callers can index `trial_history` by `product_type` if needed.
     */
    InternalAdminBillingAccountView: {
      /** Id */
      id: string;
      owner_type?: components['schemas']['OwnerType'] | null;
      /** Owner Id */
      owner_id?: string | null;
      /** Stripe Customer Id */
      stripe_customer_id?: string | null;
      stripe_account_region?: components['schemas']['Region'] | null;
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      };
      /** Subscriptions */
      subscriptions?: components['schemas']['InternalAdminProductSubscriptionView'][];
      /** Redeemed Discounts */
      redeemed_discounts?: components['schemas']['AvailableDiscounts'][];
      /** Trial History */
      trial_history?: {
        [key: string]: components['schemas']['TrialRecord'];
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** InternalAdminBulkMoveTeamMembersResponse */
    InternalAdminBulkMoveTeamMembersResponse: {
      /** Results */
      results: components['schemas']['BulkMoveMemberResult'][];
      /** Total */
      total: number;
      /** Moved */
      moved: number;
      /** Skipped Owners */
      skipped_owners: number;
      /** Failed */
      failed: number;
      /** Rolled Back */
      rolled_back: number;
      /** Rollback Failed */
      rollback_failed: number;
    };
    /** InternalAdminBulkMoveTeamMembersSchema */
    InternalAdminBulkMoveTeamMembersSchema: {
      /** Member Ids */
      member_ids: string[];
      /**
       * Target Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      target_team_id: string;
    };
    /** InternalAdminBulkRemoveTeamMembersResponse */
    InternalAdminBulkRemoveTeamMembersResponse: {
      /** Results */
      results: components['schemas']['BulkRemoveMemberResult'][];
      /** Total */
      total: number;
      /** Removed */
      removed: number;
      /** Skipped Owners */
      skipped_owners: number;
      /** Failed */
      failed: number;
    };
    /** InternalAdminBulkRemoveTeamMembersSchema */
    InternalAdminBulkRemoveTeamMembersSchema: {
      /** Member Ids */
      member_ids: string[];
    };
    /** InternalAdminBulkUploadSeoContextResponse */
    InternalAdminBulkUploadSeoContextResponse: {
      /** Rows */
      rows: number;
      /** Matched */
      matched: number;
      /** Matched Rows */
      matched_rows: components['schemas']['FormSeoCsvMatchedRow'][];
      /** Updated */
      updated: string[];
      /** Not Found */
      not_found: string[];
      /** Failed */
      failed: {
        [key: string]: string;
      }[];
    };
    /**
     * InternalAdminChangeUserJurisdictionRequest
     * @description Admin request to update a user's state/province jurisdiction(s).
     *
     *     Two independent, optional fields — both ISO 3166-2 subdivision codes (e.g.
     *     "AU-NSW", "NZ-AUK", "US-CA"), the same format signup stores:
     *
     *     - ``jurisdiction`` — the user's **profile** state/province. Validated
     *       against the user's persisted ``country`` in the router; an invalid pairing
     *       is rejected with a 400 (rather than silently dropped like the self-service
     *       ``UpdateUserRequest`` path).
     *     - ``evidence_jurisdiction`` — the **Evidence-feature override**
     *       (``evidence_settings.jurisdiction``) that selects which regional clinical
     *       guidelines the Evidence product surfaces. Only checked to be a real ISO
     *       3166-2 code; NOT constrained to the profile country, because a clinician
     *       may legitimately want another region's guidelines (this mirrors the
     *       self-service path, which stores the override unconstrained). When cleared
     *       it falls back to the profile jurisdiction via
     *       ``User.get_evidence_jurisdiction()``.
     *
     *     Per-field semantics — the field's *presence* is what matters, not its value:
     *
     *     - **Omit the field entirely** → leave that field unchanged.
     *     - **Provide a non-empty value** → set it (validated + normalised).
     *     - **Provide ``null`` or an empty/whitespace string** → clear it to ``None``
     *       (the evidence override then inherits the profile jurisdiction).
     *
     *     At least one of the two fields must be present (enforced in the router).
     */
    InternalAdminChangeUserJurisdictionRequest: {
      /** Jurisdiction */
      jurisdiction?: string | null;
      /** Evidence Jurisdiction */
      evidence_jurisdiction?: string | null;
    };
    /**
     * InternalAdminChangeUserNameRequest
     * @description Admin request to change a user's first/last name.
     *
     *     Mirrors the self-service ``UpdateUserNameRequest`` cleaning
     *     (``sanitize_profile_free_text``, 50-char cap) but additionally rejects a
     *     blank first/last name: an admin correcting a wrong name would never mean to
     *     clear it, so a blank is treated as operator error rather than silently
     *     wiping the field.
     */
    InternalAdminChangeUserNameRequest: {
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
    };
    /**
     * InternalAdminChatListItem
     * @description Simplified model for chat list view in admin.
     */
    InternalAdminChatListItem: {
      /** Id */
      id: string;
      /** User Ref Id */
      user_ref_id: string;
      /** Session Id */
      session_id?: string | null;
      /** Title */
      title: string;
      mode: components['schemas']['ChatMode'];
      /**
       * Is Authenticated
       * @default true
       */
      is_authenticated: boolean;
      /**
       * Message Count
       * @default 0
       */
      message_count: number;
      /** Created At */
      created_at?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Updated At */
      updated_at?: string | null;
      user_info?: components['schemas']['InternalAdminUserInfo'] | null;
    };
    /**
     * InternalAdminChatListResponse
     * @description Pagination response for listing chats in admin.
     */
    InternalAdminChatListResponse: {
      /** Chats */
      chats?: components['schemas']['InternalAdminChatListItem'][];
      /**
       * Total
       * @description Total number of chats matching the criteria
       * @default 0
       */
      total: number;
      /**
       * Page
       * @description Current page number
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @description Number of chats per page
       * @default 20
       */
      page_size: number;
    };
    /**
     * InternalAdminChatMessageAttachmentResponse
     * @description Attachment metadata for display in admin view.
     */
    InternalAdminChatMessageAttachmentResponse: {
      /** Attachment Id */
      attachment_id?: string | null;
      /** File Key */
      file_key: string;
      /** File Name */
      file_name: string;
      /** Content Type */
      content_type?: string | null;
      /** File Size */
      file_size?: number | null;
      /** Text Snippet */
      text_snippet?: string | null;
      /** Document Title */
      document_title?: string | null;
      /** Page Count */
      page_count?: number | null;
      /** Inlined Content */
      inlined_content?: string | null;
      /** Inlined Content Original Chars */
      inlined_content_original_chars?: number | null;
      /** Token Count */
      token_count?: number | null;
    };
    /**
     * InternalAdminChatMessageMetadataResponse
     * @description Response model for chat message metadata in admin view.
     *
     *     Inherits all fields from ChatMessageMetadata including admin-only fields
     *     (system_instructions, raw_chunks, timing_info, user_country_code, allowed_domains).
     */
    InternalAdminChatMessageMetadataResponse: {
      /** Sources */
      sources?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Citations */
      citations?: string[] | null;
      /** Structured Citations */
      structured_citations?: components['schemas']['StructuredCitation'][] | null;
      /** Web Search Query */
      web_search_query?: string | null;
      /** Reasoning */
      reasoning?: string | null;
      /** Thinking */
      thinking?: string | null;
      /** Thinking Duration Ms */
      thinking_duration_ms?: number | null;
      /** Annotations */
      annotations?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Additional Metadata */
      additional_metadata?: {
        [key: string]: unknown;
      } | null;
      source?: components['schemas']['ChatMessageSource'] | null;
      /** Stripped Reasoning */
      stripped_reasoning?: string | null;
      /** System Instructions */
      system_instructions?: string | null;
      /** Full System Instructions */
      full_system_instructions?: string | null;
      /** Raw Content */
      raw_content?: string | null;
      /** System Instructions Name */
      system_instructions_name?: string | null;
      /** System Instructions Version */
      system_instructions_version?: string | null;
      /** System Instructions Commit Message */
      system_instructions_commit_message?: string | null;
      /** System Instructions Created On */
      system_instructions_created_on?: string | null;
      /** Evidence Version */
      evidence_version?: number | null;
      llm_metadata?: components['schemas']['LLMMetadata'] | null;
      follow_up_metadata?: components['schemas']['FollowUpMetadata'] | null;
      /** Raw Chunks */
      raw_chunks?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Timing Info */
      timing_info?: {
        [key: string]: unknown;
      } | null;
      /** User Country Code */
      user_country_code?: string | null;
      /** Allowed Domains */
      allowed_domains?: string[] | null;
      /** Evidence Source Filters */
      evidence_source_filters?: string[] | null;
      evidence_search_context?: components['schemas']['EvidenceSearchContextDO'] | null;
      /** Clinician Type */
      clinician_type?: string | null;
      /** Clinical Note */
      clinical_note?: string | null;
      /** Transcript */
      transcript?: string | null;
      /** Contextual Notes */
      contextual_notes?: string | null;
      /** Country */
      country?: string | null;
      /** Patient Info */
      patient_info?: string | null;
      /** Previous Notes */
      previous_notes?: string | null;
      /** User Query */
      user_query?: string | null;
      /** Document Content */
      document_content?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      /** Evidence Sources Description */
      evidence_sources_description?: string | null;
      /** Clinical Note Token Count */
      clinical_note_token_count?: number | null;
      /** Contextual Notes Token Count */
      contextual_notes_token_count?: number | null;
      /** Transcript Token Count */
      transcript_token_count?: number | null;
      /** Document Content Token Count */
      document_content_token_count?: number | null;
      /** Previous Notes Token Count */
      previous_notes_token_count?: number | null;
      /** Contextual Note Attachments */
      contextual_note_attachments?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Client Platform */
      client_platform?: string | null;
      /** Window Width */
      window_width?: number | null;
      /** Window Height */
      window_height?: number | null;
      /** Panel Width */
      panel_width?: number | null;
      /** Panel Height */
      panel_height?: number | null;
      /** X Forwarded For */
      x_forwarded_for?: string[] | null;
      /** Socket Client Host */
      socket_client_host?: string | null;
    };
    /**
     * InternalAdminChatMessageResponse
     * @description Response model for a chat message in admin view.
     */
    InternalAdminChatMessageResponse: {
      /** Role */
      role: string;
      /** Content */
      content: string;
      /** Timestamp */
      timestamp?: string | null;
      /** Message Id */
      message_id?: string | null;
      mode?: components['schemas']['ChatMode'] | null;
      original_mode?: components['schemas']['ChatMode'] | null;
      metadata?: components['schemas']['InternalAdminChatMessageMetadataResponse'] | null;
      /** Attachments */
      attachments?:
        | components['schemas']['InternalAdminChatMessageAttachmentResponse'][]
        | null;
      /** Content Token Count */
      content_token_count?: number | null;
    };
    /**
     * InternalAdminChatResponse
     * @description Response model for a single chat in admin view.
     */
    InternalAdminChatResponse: {
      /** Id */
      id: string;
      /** User Ref Id */
      user_ref_id: string;
      /** Session Id */
      session_id?: string | null;
      /** Title */
      title: string;
      /**
       * Messages
       * @default []
       */
      messages: components['schemas']['InternalAdminChatMessageResponse'][];
      mode: components['schemas']['ChatMode'];
      /**
       * Is Authenticated
       * @default true
       */
      is_authenticated: boolean;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      user_info?: components['schemas']['InternalAdminUserInfo'] | null;
    };
    /**
     * InternalAdminContextDocumentResponse
     * @description Individual context document metadata and content for admin view.
     */
    InternalAdminContextDocumentResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Type */
      type?: string | null;
      /** Status */
      status?: string | null;
      /** Content */
      content?: string | null;
      /**
       * Number Of Tokens
       * @default 0
       */
      number_of_tokens: number;
    };
    /**
     * InternalAdminContextDocumentsListResponse
     * @description Response for listing context documents attached to a session.
     */
    InternalAdminContextDocumentsListResponse: {
      /** Documents */
      documents: components['schemas']['InternalAdminContextDocumentResponse'][];
      /**
       * Total
       * @default 0
       */
      total: number;
    };
    /** InternalAdminCreateAddOnProductRequest */
    InternalAdminCreateAddOnProductRequest: {
      /** Name */
      name: string;
      category: components['schemas']['AddOnCategory'];
      /** Vendor Products */
      vendor_products: components['schemas']['VendorProductPair'][];
      add_on_details: components['schemas']['IntegrationDetails'];
      /** Description */
      description?: string | null;
      /**
       * Free Trial Days
       * @default 14
       */
      free_trial_days: number;
      /** @default FREE */
      minimum_eligible_purchase_tier: components['schemas']['SubscriptionTier'];
    };
    /** InternalAdminCreateAddOnProductResponse */
    InternalAdminCreateAddOnProductResponse: {
      product: components['schemas']['AddOnProduct'];
    };
    /** InternalAdminCreateExternalOrganizationRequest */
    InternalAdminCreateExternalOrganizationRequest: {
      /** Name */
      name: string;
      /** Team Ids */
      team_ids: string[];
      /**
       * Is Active
       * @default true
       */
      is_active: boolean;
    };
    /**
     * InternalAdminCreateOrganizationRequest
     * @description Request schema for creating an organization.
     */
    InternalAdminCreateOrganizationRequest: {
      /** Name */
      name: string;
      /** Owner Kinde Id */
      owner_kinde_id: string;
      /**
       * Is Pilot
       * @default false
       */
      is_pilot: boolean;
      /**
       * Send Onboarding Email
       * @default true
       */
      send_onboarding_email: boolean;
    };
    /** InternalAdminCreateTeamRequest */
    InternalAdminCreateTeamRequest: {
      /** Owner Kinde Id */
      owner_kinde_id?: string | null;
      /** Team Name */
      team_name: string;
      /** Is Stripe Managed */
      is_stripe_managed: boolean;
      /** Charge Future Members */
      charge_future_members: boolean;
      /** Allow To Add Team Members */
      allow_to_add_team_members: boolean;
      subscribed_plan: components['schemas']['SubscriptionTier'];
      /**
       * Admin Session Review Toggle
       * @default false
       */
      admin_session_review_toggle: boolean | null;
      /** Onboarding Free Text */
      onboarding_free_text?: string | null;
      /** Go Live Time Stamp */
      go_live_time_stamp?: string | null;
      /**
       * Is Pilot
       * @default false
       */
      is_pilot: boolean;
      /** Country */
      country?: string | null;
      /** @default FREE */
      evidence_tier: components['schemas']['EvidenceSubscriptionTier'] | null;
      /**
       * Evidence Is Stripe Managed
       * @default false
       */
      evidence_is_stripe_managed: boolean | null;
      /** Evidence Plan End Date */
      evidence_plan_end_date?: string | null;
      /**
       * Evidence Access
       * @default false
       */
      evidence_access: boolean | null;
      /**
       * Send Onboarding Email
       * @default true
       */
      send_onboarding_email: boolean;
    };
    /** InternalAdminCreateTemplateRequest */
    InternalAdminCreateTemplateRequest: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Template Creation Record Id */
      template_creation_record_id?: string | null;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_scratch';
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** Organization Id */
      organization_id?: string | null;
    };
    /** InternalAdminCreateUserRequest */
    InternalAdminCreateUserRequest: {
      /** Kinde User Id */
      kinde_user_id: string;
      /**
       * Apply Reverse Trial
       * @default true
       */
      apply_reverse_trial: boolean;
      /**
       * Dismiss Org Survey
       * @description Dismiss the organisation survey, enterprise users don't need the org survey modal
       * @default true
       */
      dismiss_org_survey: boolean;
    };
    /** InternalAdminCreateUserRequestV2 */
    InternalAdminCreateUserRequestV2: {
      /** User Email */
      user_email: string;
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
      country: components['schemas']['Country'];
      /**
       * Send Onboarding Email
       * @default true
       */
      send_onboarding_email: boolean;
    };
    /** InternalAdminDeleteUserPermanentlyRequest */
    InternalAdminDeleteUserPermanentlyRequest: {
      /**
       * Preview
       * @description If true, only preview the deletion without actually deleting
       * @default false
       */
      preview: boolean;
      /** Delete Reason */
      delete_reason?: string | null;
    };
    /** InternalAdminDocumentResponse */
    InternalAdminDocumentResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name?: string | null;
      /** Session Id */
      session_id: string;
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      /** Question */
      question?: string | null;
      /** Content */
      content: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Updated At */
      updated_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      generation_type: components['schemas']['DocumentGenType'];
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      brain: components['schemas']['Brain'];
      feedback?: components['schemas']['Feedback'] | null;
    };
    /**
     * InternalAdminEvidenceChatRunRequest
     * @description Replay an evidence-chat turn through the v2 streamer in sandbox mode.
     *
     *     Calling this endpoint is equivalent to invoking
     *     ``stream_anthropic_with_evidence_tool(sandbox=True, ...)`` with chat-state
     *     fields supplied by the caller and user-state fields derived server-side
     *     from the acting user (resolved by ``acting_user_ref_id``).
     *
     *     Sandbox semantics (enforced by the streamer's ``sandbox=True`` parameter):
     *       * Write tools route to inline synthetic-result helpers — no S3 PUTs,
     *         no email sends, no print jobs, no clinical-task Mongo writes.
     *       * Tool-result truncation is disabled so the captured ``tool_interactions``
     *         SSE chunk preserves full-length results for the external replay caller.
     *       * Tavily archival callback is suppressed (``skip_persist=True``).
     *       * The full-fidelity background tool-call trace write is skipped.
     *
     *     Intended for offline replay of captured chats by internal admin clients;
     *     it is not a substitute for the production
     *     ``/api/v2/ml-scribe/chat/completions`` endpoint.
     */
    InternalAdminEvidenceChatRunRequest: {
      /**
       * Acting User Ref Id
       * @description user_ref_id the streamer should act as. When it matches a User, the endpoint loads that User (by ``user_ref_id``) to derive country, region, team, and flag context, and acts as that user's ``kinde_user_id`` downstream. When supplied but no User matches, the supplied value is reused as the temp user's identity key so flag/config bucketing stays deterministic across calls; only when omitted entirely does the endpoint mint a random UUID7 temp-user id. In both temp cases the endpoint falls back to anonymous-chat semantics: country defaults to Australia, no team, all user-scoped flags resolve to defaults. Mirrors the production behaviour for unauthenticated chats (see ``apis/utils/temp_user.py``).
       *
       *     Note: replay callers carry the chat's ``user_ref_id`` (a UUID7), NOT the ``kinde_user_id`` — the two are distinct fields on the ``User`` model. Resolving by ``user_ref_id`` lets in-session replays act as the real session owner so session-scoped read tools (``get_sessions_by_date``, session documents/notes) resolve.
       */
      acting_user_ref_id?: string | null;
      /**
       * Messages
       * @description Anthropic-shaped message list passed to the streamer verbatim. May contain prior tool_use / tool_result content blocks captured from a real chat.
       */
      messages: {
        [key: string]: unknown;
      }[];
      /**
       * System Instructions
       * @description Pre-tool-appends system prompt. Should be the value captured on ``ChatMessageMetadata.system_instructions`` for the original turn — the streamer re-applies its capability-block appends on top, so feeding back the post-append ``full_system_instructions`` would cause double-appending.
       */
      system_instructions: string;
      /**
       * Model
       * @description Model id the original turn used (e.g. ``claude-sonnet-4-...``).
       */
      model: string;
      /**
       * Is Authenticated
       * @description Whether the captured chat ran as an authenticated user. Required — wrong default silently corrupts the unauthed tool whitelist for temp-user chats. Note this is captured state, not current-user state — a user who upgraded from temp to authed since the chat was created should still be replayed with the captured value.
       */
      is_authenticated: boolean;
      /**
       * Is Mobile
       * @description Whether the captured chat was issued from a mobile client. Affects which tools the streamer exposes (mobile gets a trimmed surface).
       * @default false
       */
      is_mobile: boolean;
      /**
       * Is In Session
       * @description Whether the captured chat was in-session (linked to a real consultation Session). When True, ``effective_region`` is resolved from the user's Heidi region; when False, region is forced empty to route through Anthropic Direct.
       * @default false
       */
      is_in_session: boolean;
      /**
       * Patient Profile Id
       * @description Patient profile id if the chat is patient-linked.
       */
      patient_profile_id?: string | null;
      /**
       * Attachments
       * @description Attachments captured on the original message. Affects the attachment-context system-prompt append in the streamer.
       */
      attachments?: components['schemas']['ChatMessageAttachment'][] | null;
      /**
       * Evidence Source Filters
       * @description Source filters that were enabled at capture time (LOCAL_GUIDELINES / PRIMARY_EVIDENCE / MY_LIBRARY). Drives which web search groups Tavily queries. Captured on ``ChatMessageMetadata.evidence_source_filters``.
       */
      evidence_source_filters?: components['schemas']['EvidenceSourceFilter'][] | null;
      /**
       * Source List Ids
       * @description Source-list IDs (web collections) selected at capture time. Becomes the Web Collections group in the streamer's search.
       */
      source_list_ids?: string[] | null;
      /**
       * User Doc Collection Ids
       * @description User-document collection IDs to scope library search to. Captured on ``ChatMessageMetadata.evidence_search_context``.
       */
      user_doc_collection_ids?: string[] | null;
      /**
       * Collection Ids
       * @description Unified collection IDs captured at chat time. When supplied, these supersede ``source_list_ids`` and ``user_doc_collection_ids`` the same way production ``ChatRequest.collection_ids`` does.
       */
      collection_ids?: string[] | null;
      /**
       * Include Uncollected Documents
       * @description Whether to include documents not in any collection. When true and collection/user-document IDs are present, the backend adds the ``__uncollected__`` sentinel before user-document search.
       */
      include_uncollected_documents?: boolean | null;
      /**
       * Include User Docs
       * @description Whether library search was enabled at capture time. Production default is False; team enforcement may override.
       * @default false
       */
      include_user_docs: boolean;
      /**
       * Include Web Search
       * @description Whether unrestricted web search was enabled at capture time. Production default is True; team enforcement may override.
       * @default true
       */
      include_web_search: boolean;
      /**
       * Integration Partners
       * @description Integration partner configs (DynaMed, BMJ, etc.) enabled at capture time. Captured on ``ChatMessageMetadata.evidence_search_context.integration_partners``.
       */
      integration_partners?: components['schemas']['IntegrationPartnerConfig'][] | null;
      /**
       * Session Id
       * @description Original session_id when the chat was in-session. Used by create_clinical_task (links tasks to session) and get_sessions_by_date (current-session awareness).
       */
      session_id?: string | null;
      /**
       * Session Date
       * @description Date of the captured session in YYYY-MM-DD format. Threaded into get_sessions_by_date tool context.
       */
      session_date?: string | null;
      /**
       * Session Time
       * @description Time of the captured session in HH:MM format.
       */
      session_time?: string | null;
      /**
       * Slide Context
       * @description Slide / presentation UI state at capture time. Controls whether the slide-edit tools are exposed and enforces single-target edits in the streamer.
       */
      slide_context?: {
        [key: string]: unknown;
      } | null;
      /**
       * Active Tab
       * @description Active client tab at capture time (e.g. document type).
       */
      active_tab?: string | null;
      /**
       * Active Document Id
       * @description Active document id (e.g. consult-note draft) at capture time.
       */
      active_document_id?: string | null;
      /**
       * Form Template Id
       * @description Pre-selected fill_pdf_form template id, if the client picked one via the template picker UI. Triggers the form-template-pin system-prompt append (line ~3543 in anthropic_evidence_tool.py).
       */
      form_template_id?: string | null;
      /**
       * Historical Sources
       * @description Per-prior-assistant-message source lists for multi-turn citation continuity. Keys are assistant-message indices (0-indexed), values are the ``ChatMessageMetadata.sources`` lists from those messages. Production rebuilds this from ``chat.messages`` (see chat_manager.py:2524-2546).
       */
      historical_sources?: {
        [key: string]: {
          [key: string]: unknown;
        }[];
      } | null;
      /**
       * Historical Cited References
       * @description De-duplicated citation list from prior assistant turns, used for multi-turn citation index continuity.
       */
      historical_cited_references?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** @description Per-request generation controls (sampling params, optional alternate endpoint, and optional per-token detail) applied on the agent's LLM calls. When ``base_url`` is set or ``enable_token_tracing`` is True, ``model`` must carry an OpenAI-compatible provider prefix (``openai:`` / ``fireworks:`` / ``baseten:`` / ``modal:``) and must not be a Responses-API model — rejected (422) otherwise. Sampling-only configs apply to normal routing with no model restriction. */
      generation_config?: components['schemas']['GenerationConfig'] | null;
      /**
       * Allowed Tools
       * @description Caller-side restriction on which tools are exposed to the LLM. Intersected with the streamer's naturally-built tool list after construction; tools outside this set are removed and an info-level log is emitted. ``None`` means no extra restriction beyond what the streamer would build.
       */
      allowed_tools?: string[] | null;
    };
    /** InternalAdminGenerateTemplateExampleOutputAndDescriptionRequest */
    InternalAdminGenerateTemplateExampleOutputAndDescriptionRequest: {
      /** Name */
      name?: string | null;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      template_category?: components['schemas']['TemplateCategory'] | null;
      /** Problem Based Charting Enabled */
      problem_based_charting_enabled?: boolean | null;
      /** Use Sections */
      use_sections?: boolean | null;
    };
    /** InternalAdminGenerateTemplateExampleOutputAndDescriptionResponse */
    InternalAdminGenerateTemplateExampleOutputAndDescriptionResponse: {
      /** Example Output */
      example_output: string;
      /** Description */
      description: string;
    };
    /** InternalAdminGetAddOnProductsResponse */
    InternalAdminGetAddOnProductsResponse: {
      /** Products */
      products: components['schemas']['InternalAdminAddOnProductView'][];
      /** Total Pages */
      total_pages: number;
    };
    /** InternalAdminGetTemplateRevisionsResponse */
    InternalAdminGetTemplateRevisionsResponse: {
      /** Templates */
      templates: components['schemas']['EnrichedTemplateRevision'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
    };
    /** InternalAdminLinkUserToHeidiAccountRequest */
    InternalAdminLinkUserToHeidiAccountRequest: {
      /** Ehr Provider */
      ehr_provider: string;
      /** Ehr User Id */
      ehr_user_id: string;
      /** Ehr Email */
      ehr_email: string;
      /** Kinde User Id */
      kinde_user_id: string;
    };
    /** InternalAdminLinkUserToHeidiAccountResponse */
    InternalAdminLinkUserToHeidiAccountResponse: {
      linked_account: components['schemas']['OpenAPILinkedAccount'];
    };
    /**
     * InternalAdminListUserView
     * @description Minimal user view for internal admin list API.
     */
    InternalAdminListUserView: {
      /** User Id */
      user_id: string;
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Email */
      email?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Tier */
      tier: string;
      /** Is In Free Trial */
      is_in_free_trial: boolean;
      /** Country */
      country?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Team Id */
      team_id?: string | null;
      /** Team Name */
      team_name?: string | null;
      /** Org Id */
      org_id?: string | null;
      /** Org Name */
      org_name?: string | null;
      third_party_license?: components['schemas']['ThirdPartyLicenceDetails'] | null;
    };
    /** InternalAdminOrganizationMFARequest */
    InternalAdminOrganizationMFARequest: {
      /** Enable Mfa */
      enable_mfa: boolean;
      /**
       * Org Id
       * @description internal admin directly passes org id (currently kinde) with MFA enabled
       */
      org_id?: string | null;
      /** @description prefer to use method instead of org_id, because org_id input could be wrong. if both are provided, org_id will be ignored */
      mfa_method?: components['schemas']['MFAMethod'] | null;
    };
    /**
     * InternalAdminProductSubscriptionView
     * @description Internal-admin read-only projection of a `ProductSubscription` sub-document.
     *
     *     Fields are a straight passthrough of the model — no derivations. Field
     *     names match `domains/billing/models/billing_account.py` so callers can
     *     map directly to the persisted document.
     */
    InternalAdminProductSubscriptionView: {
      /** Id */
      id: string;
      product_type: components['schemas']['ProductSubscriptionType'];
      payment_vendor: components['schemas']['BillingPaymentVendor'];
      status: components['schemas']['BillingSubscriptionStatus'];
      plan_cycle?: components['schemas']['shared__enums__enums__Period'] | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Trial End Date */
      trial_end_date?: string | null;
      /** Next Billing Date */
      next_billing_date?: string | null;
      /**
       * Is Reverse Trial
       * @default false
       */
      is_reverse_trial: boolean;
      /**
       * Is Promoted Free Trial
       * @default false
       */
      is_promoted_free_trial: boolean;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /** Stripe Subscription Item Id */
      stripe_subscription_item_id?: string | null;
      /** Attached To Stripe Sub */
      attached_to_stripe_sub?: string | null;
      /** Type Metadata */
      type_metadata:
        | components['schemas']['AddOnMetadata']
        | components['schemas']['ThirdPartyLicenseMetadata']
        | components['schemas']['MeterMetadata']
        | components['schemas']['NoMetadata'];
      cancellation_intent?: components['schemas']['CancellationIntent'] | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** InternalAdminRegenerateSeoContentRequest */
    InternalAdminRegenerateSeoContentRequest: {
      seo_context?: components['schemas']['GallerySeoContext'] | null;
    };
    /** InternalAdminRegenerateSeoContentResponse */
    InternalAdminRegenerateSeoContentResponse: {
      /** Seo Content */
      seo_content: string;
    };
    /** InternalAdminRegenerateSeoContextResponse */
    InternalAdminRegenerateSeoContextResponse: {
      seo_context: components['schemas']['GallerySeoContext'];
    };
    /** InternalAdminResendInvitationsResponse */
    InternalAdminResendInvitationsResponse: {
      /** Results */
      results: components['schemas']['ResendInvitationsResultItem'][];
      /** Total */
      total: number;
      /** Succeeded */
      succeeded: number;
      /** Failed */
      failed: number;
    };
    /** InternalAdminResendSelectedInvitationsSchema */
    InternalAdminResendSelectedInvitationsSchema: {
      /** Invitation Ids */
      invitation_ids: string[];
    };
    /** InternalAdminRpaRecordingArtifactInventoryAffordance */
    InternalAdminRpaRecordingArtifactInventoryAffordance: {
      /** Source */
      source: string;
      /** Href */
      href: string;
      /** Stages */
      stages: components['schemas']['RpaArtifactStage'][];
    };
    /** InternalAdminRpaRecordingCrossUserListResponse */
    InternalAdminRpaRecordingCrossUserListResponse: {
      /** Recordings */
      recordings: components['schemas']['InternalAdminRpaRecordingCrossUserSummary'][];
      /** Total */
      total: number;
    };
    /** InternalAdminRpaRecordingCrossUserSummary */
    InternalAdminRpaRecordingCrossUserSummary: {
      /** Recording Id */
      recording_id: string;
      /** Name */
      name: string;
      /** Workflow Name */
      workflow_name?: string | null;
      /**
       * State
       * @enum {string}
       */
      state: InternalAdminRpaRecordingCrossUserSummaryState;
      /** Error Code */
      error_code?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Completed At */
      completed_at?: string | null;
      /** Pending Team Id */
      pending_team_id?: string | null;
      usage?: components['schemas']['RpaAnalysisUsageResponse'] | null;
      /** Queue Duration Ms */
      queue_duration_ms?: number | null;
      /** Processing Duration Ms */
      processing_duration_ms?: number | null;
      /** Analysis Run Count */
      analysis_run_count?: number | null;
      /** Owner User Ref Id */
      owner_user_ref_id: string;
      /** Owner Name */
      owner_name?: string | null;
      /** Owner Email */
      owner_email?: string | null;
    };
    /** InternalAdminRpaRecordingListResponse */
    InternalAdminRpaRecordingListResponse: {
      /** Recordings */
      recordings: components['schemas']['InternalAdminRpaRecordingSummary'][];
      /** Total */
      total: number;
    };
    /** InternalAdminRpaRecordingResponse */
    InternalAdminRpaRecordingResponse: {
      /** Recording Id */
      recording_id: string;
      /** Name */
      name: string;
      /** User Id */
      user_id: string;
      /** Idempotency Key */
      idempotency_key?: string | null;
      /**
       * State
       * @enum {string}
       */
      state: InternalAdminRpaRecordingResponseState;
      /** Raw Zip S3 Key */
      raw_zip_s3_key: string;
      /** App Version */
      app_version?: string | null;
      workflow_data?: components['schemas']['WorkflowDataResponse'] | null;
      /** Error Code */
      error_code?: string | null;
      /** Error Message */
      error_message?: string | null;
      /** Uploaded At */
      uploaded_at?: string | null;
      /** Completed At */
      completed_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Pending Team Id */
      pending_team_id?: string | null;
      /** Warnings */
      warnings?: components['schemas']['WorkflowDataWarning'][] | null;
      /** Analysis Model */
      analysis_model?: string | null;
      /** Synthesis Model */
      synthesis_model?: string | null;
      usage?: components['schemas']['RpaAnalysisUsageResponse'] | null;
      /** Queue Duration Ms */
      queue_duration_ms?: number | null;
      /** Processing Duration Ms */
      processing_duration_ms?: number | null;
      /** Analysis Run Count */
      analysis_run_count?: number | null;
      artifact_inventory?:
        | components['schemas']['InternalAdminRpaRecordingArtifactInventoryAffordance']
        | null;
    };
    /** InternalAdminRpaRecordingSummary */
    InternalAdminRpaRecordingSummary: {
      /** Recording Id */
      recording_id: string;
      /** Name */
      name: string;
      /** Workflow Name */
      workflow_name?: string | null;
      /**
       * State
       * @enum {string}
       */
      state: InternalAdminRpaRecordingSummaryState;
      /** Error Code */
      error_code?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Completed At */
      completed_at?: string | null;
      /** Pending Team Id */
      pending_team_id?: string | null;
      usage?: components['schemas']['RpaAnalysisUsageResponse'] | null;
      /** Queue Duration Ms */
      queue_duration_ms?: number | null;
      /** Processing Duration Ms */
      processing_duration_ms?: number | null;
      /** Analysis Run Count */
      analysis_run_count?: number | null;
    };
    /** InternalAdminSaveFormSeoRequest */
    InternalAdminSaveFormSeoRequest: {
      seo_context?: components['schemas']['GallerySeoContext'] | null;
      /** Seo Content */
      seo_content?: string | null;
    };
    /** InternalAdminSaveFormSeoResponse */
    InternalAdminSaveFormSeoResponse: {
      seo_context?: components['schemas']['GallerySeoContext'] | null;
      /** Seo Content */
      seo_content?: string | null;
    };
    /** InternalAdminSessionDocumentsResponse */
    InternalAdminSessionDocumentsResponse: {
      /** Documents */
      documents: components['schemas']['InternalAdminDocumentResponse'][];
      /** Total */
      total: number;
    };
    /** InternalAdminSessionResponse */
    InternalAdminSessionResponse: {
      /** Session Id */
      session_id: string;
      /** Session Name */
      session_name?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Session Gist */
      session_gist?: string | null;
      patient?: components['schemas']['PatientModel'] | null;
      language: components['schemas']['Language'] | null;
      status: components['schemas']['BaseStatus'];
      /** Clinician Notes */
      clinician_notes: string[];
      consult_note: components['schemas']['SimpleConsultNoteView'];
      /**
       * Duration
       * @default 0
       */
      duration: number;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Is Consent */
      is_consent: boolean | null;
      language_code?: components['schemas']['LanguageCode'] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Documents */
      documents?: components['schemas']['DocumentView'][] | null;
      transcribe_mode?: components['schemas']['TranscribeMode'] | null;
      /** Is Tab Sharing */
      is_tab_sharing?: boolean | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /** Is Reviewed */
      is_reviewed?: boolean | null;
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Ehr Appt Contact Id */
      ehr_appt_contact_id?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Encounter Id */
      ehr_encounter_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      patient_profile?: components['schemas']['PatientProfileModel'] | null;
      /** Is Demo */
      is_demo: boolean;
      /** Is Consumed Quota */
      is_consumed_quota: boolean;
      transcript_service_details:
        | components['schemas']['TranscriptServiceDetails']
        | null;
      /** Llm Call Records */
      llm_call_records?: components['schemas']['LLMCallRecord'][] | null;
      /** Chat Ids */
      chat_ids?: string[] | null;
      /** Linked Sessions For Context */
      linked_sessions_for_context?: string[];
      /** Linked Sessions For Context Fallback */
      linked_sessions_for_context_fallback?: boolean | null;
      /** Past Ehr Notes */
      past_ehr_notes?: components['schemas']['EHRNote'][];
    };
    /** InternalAdminStripeProductView */
    InternalAdminStripeProductView: {
      /** Product Id */
      product_id: string;
      /** Price Id */
      price_id: string;
      period: components['schemas']['shared__enums__enums__Period'];
      vendor: components['schemas']['PaymentVendor'];
      /** Type */
      type: string;
    };
    /** InternalAdminTeamMFARequest */
    InternalAdminTeamMFARequest: {
      /** Enable Mfa */
      enable_mfa: boolean;
      /** Org Id */
      org_id?: string | null;
      mfa_method?: components['schemas']['MFAMethod'] | null;
    };
    /** InternalAdminTeamsResponse */
    InternalAdminTeamsResponse: {
      /** Teams */
      teams: components['schemas']['ExtendedSimpleTeam'][];
      /**
       * Total
       * @default 0
       */
      total: number;
      /**
       * Page
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @default 20
       */
      page_size: number;
    };
    /** InternalAdminTemplateResponse */
    InternalAdminTemplateResponse: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template: string;
      /** Description */
      description?: string | null;
      template_category: components['schemas']['TemplateCategory'];
      /** Template Html */
      template_html?: string | null;
    };
    /** InternalAdminTranscriberComparisonResponse */
    InternalAdminTranscriberComparisonResponse: {
      /** Transcripts */
      transcripts: components['schemas']['InternalAdminTranscript'][];
    };
    /** InternalAdminTranscript */
    InternalAdminTranscript: {
      provider: components['schemas']['Providers'];
      /** Model */
      model: string;
      /** Transcript */
      transcript: string;
    };
    /** InternalAdminUpdateAddOnProductRequest */
    InternalAdminUpdateAddOnProductRequest: {
      /** Name */
      name?: string | null;
      status?: components['schemas']['AddOnProductStatus'] | null;
      /** Vendor Products */
      vendor_products?: components['schemas']['VendorProductPair'][] | null;
      /** Free Trial Days */
      free_trial_days?: number | null;
      add_on_details?: components['schemas']['UpdateIntegrationDetails'] | null;
      minimum_eligible_purchase_tier?: components['schemas']['SubscriptionTier'] | null;
    };
    /** InternalAdminUpdateAddOnProductResponse */
    InternalAdminUpdateAddOnProductResponse: {
      product: components['schemas']['AddOnProduct'];
    };
    /** InternalAdminUpdateExternalOrganizationRequest */
    InternalAdminUpdateExternalOrganizationRequest: {
      /** Team Ids */
      team_ids?: string[] | null;
      /**
       * Is Active
       * @default true
       */
      is_active: boolean | null;
    };
    /**
     * InternalAdminUpdateOrganizationRequest
     * @description Request schema for updating an organization.
     */
    InternalAdminUpdateOrganizationRequest: {
      /** Name */
      name?: string | null;
      mfa?: components['schemas']['InternalAdminOrganizationMFARequest'] | null;
      /** Admin Session Review Toggle */
      admin_session_review_toggle?: boolean | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Hide Remember Consent Checkbox */
      hide_remember_consent_checkbox?: boolean | null;
      /** Require Review Confirmation */
      require_review_confirmation?: boolean | null;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      /** Is Pilot */
      is_pilot?: boolean | null;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[] | null;
      /** Is Allow Self Onboard */
      is_allow_self_onboard?: boolean | null;
      /**
       * Self Onboard Default Role Id
       * @description Default role ID for new users in the organization
       */
      self_onboard_default_role_id?: string | null;
      /**
       * Sso Group
       * @description Kinde SSO group identifier. None means no change or clear group, string value means set this group.
       */
      sso_group?: string | null;
      /**
       * Sso Connection Ids
       * @description List of SSO connection IDs for the organization. Supports multiple SSO connections per organization. Empty list clears all SSO connections.
       */
      sso_connection_ids?: string[] | null;
      /** Allow Direct Session Sharing */
      allow_direct_session_sharing?: boolean | null;
      /** Allow Session Link Sharing */
      allow_session_link_sharing?: boolean | null;
      /** Coding Case Creation Enabled */
      coding_case_creation_enabled?: boolean | null;
      /** Disable Auto Extract */
      disable_auto_extract?: boolean | null;
    };
    /** InternalAdminUpdateTeamMemberSchema */
    InternalAdminUpdateTeamMemberSchema: {
      user_role?: components['schemas']['UserRole'] | null;
      /** Role Ids */
      role_ids?: string[] | null;
    };
    /** InternalAdminUpdateTeamRequest */
    InternalAdminUpdateTeamRequest: {
      /** Name */
      name?: string | null;
      /** Is Stripe Managed */
      is_stripe_managed?: boolean | null;
      /** Charge Future Members */
      charge_future_members?: boolean | null;
      /** Allow To Add Team Members */
      allow_to_add_team_members?: boolean | null;
      subscribed_plan?: components['schemas']['SubscriptionTier'] | null;
      /** Onboarding Free Text */
      onboarding_free_text?: string | null;
      /** Go Live Time Stamp */
      go_live_time_stamp?: string | null;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Hide Remember Consent Checkbox */
      hide_remember_consent_checkbox?: boolean | null;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      /** Owner Kinde Id */
      owner_kinde_id?: string | null;
      /** Is Pilot */
      is_pilot?: boolean | null;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[] | null;
      /** External Sources */
      external_sources?: components['schemas']['ExternalSource'][] | null;
      /** Country */
      country?: string | null;
      evidence_tier?: components['schemas']['EvidenceSubscriptionTier'] | null;
      /** Evidence Is Stripe Managed */
      evidence_is_stripe_managed?: boolean | null;
      /** Evidence Plan End Date */
      evidence_plan_end_date?: string | null;
      /** Evidence Access */
      evidence_access?: boolean | null;
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      /** Disable Auto Extract */
      disable_auto_extract?: boolean | null;
    };
    /** InternalAdminUpdateTemplateRevisionReviewStatusResponse */
    InternalAdminUpdateTemplateRevisionReviewStatusResponse: {
      template_revision: components['schemas']['EnrichedTemplateRevision'];
      template_in_gallery?: components['schemas']['GalleryTemplateBasicInfo'] | null;
    };
    /**
     * InternalAdminUserInfo
     * @description User information for admin view.
     */
    InternalAdminUserInfo: {
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** Email */
      email?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
    };
    /**
     * InternalAdminUserResponse
     * @description Extended UserResponse that includes EHR profile information.
     */
    InternalAdminUserResponse: {
      /** User Ref Id */
      user_ref_id: string;
      /**
       * User Id
       * @deprecated
       * @default
       */
      user_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Is Newly Created
       * @default false
       */
      is_newly_created: boolean;
      /** Stripe Customer Id */
      stripe_customer_id: string;
      /**
       * Had Free Trial
       * @default false
       */
      had_free_trial: boolean | null;
      default_language_code?: components['schemas']['LanguageCode'] | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Is In Free Trial */
      is_in_free_trial: boolean;
      /**
       * Is In Reverse Free Trial
       * @default false
       */
      is_in_reverse_free_trial: boolean;
      /** Trial End Date */
      trial_end_date?: string | null;
      tier: components['schemas']['SubscriptionTier'];
      scribe_access?: components['schemas']['AccessTier'] | null;
      evidence_access?: components['schemas']['AccessTier'] | null;
      new_product_tier?: components['schemas']['SubscriptionTier'] | null;
      plan_cycle?: components['schemas']['shared__enums__enums__Period'] | null;
      /** Next Billing Date */
      next_billing_date?: string | null;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /** Redeemed Discounts */
      redeemed_discounts?: components['schemas']['AvailableDiscounts'][];
      /** Plan Upgradable */
      plan_upgradable?: boolean | null;
      /** Is Allowed */
      is_allowed?: boolean | null;
      /** Country */
      country?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      /** Practitioner Type */
      practitioner_type?: string | null;
      /** Onboarding Email Status */
      onboarding_email_status?: string | null;
      /** Specialty Id */
      specialty_id?: string | null;
      /** Other Specialty */
      other_specialty?: string | null;
      default_note_structure?: components['schemas']['NoteStructure'] | null;
      writing_style?: components['schemas']['VoiceStyle'] | null;
      /** Has Phone Number */
      has_phone_number?: boolean | null;
      /** Phone Number */
      phone_number?: string | null;
      /** Journey */
      journey?: {
        [key: string]: components['schemas']['JourneyStatus'];
      } | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      title?: components['schemas']['TitleCode'] | null;
      session_settings?: components['schemas']['SessionSettingsResponse'] | null;
      dictation?: components['schemas']['DictationSettingsResponse'] | null;
      quota: components['schemas']['Quota'];
      evidence_usage?: components['schemas']['EvidenceUsageResponse'] | null;
      /** Currency */
      currency: string;
      /** Is Subscribed */
      is_subscribed: boolean;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Is Demo On Desktop Completed */
      is_demo_on_desktop_completed?: boolean | null;
      /** User Activity */
      user_activity?: {
        [key: string]: number;
      } | null;
      /** Integration Requests */
      integration_requests?:
        | components['schemas']['database__mongo__base__IntegrationRequest'][]
        | null;
      referral_profile?: components['schemas']['ReferralProfile'] | null;
      organisation_info?: components['schemas']['OrganisationInfo'] | null;
      research_profile?: components['schemas']['ClinicianResearchProfile'] | null;
      /** Revenuecat User Id */
      revenuecat_user_id?: string | null;
      billing_managed_by?: components['schemas']['RevenueCatStore'] | null;
      /** Revenuecat Entitlement Id */
      revenuecat_entitlement_id?: string | null;
      /**
       * Admin Session Review Toggle
       * @default false
       */
      admin_session_review_toggle: boolean;
      /** Created At */
      created_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      user_mfa_info?: components['schemas']['UserMFAInfo'] | null;
      session_timeout?: components['schemas']['EffectiveSessionTimeout'] | null;
      /** Warn Pro Action */
      warn_pro_action: boolean;
      /**
       * Free Trial History Tiers
       * @default []
       */
      free_trial_history_tiers: components['schemas']['SubscriptionTier'][];
      /**
       * Should Hide Sensitive Info From Sidebar
       * @default false
       */
      should_hide_sensitive_info_from_sidebar: boolean;
      /**
       * Is Ask Heidi Disclaimer Showed
       * @default false
       */
      is_ask_heidi_disclaimer_showed: boolean;
      /**
       * Is Default Note Warning Off
       * @default false
       */
      is_default_note_warning_off: boolean;
      /**
       * Pending Onboarding Tasks
       * @default [
       *       "find_template",
       *       "start_session",
       *       "review_note",
       *       "create_document",
       *       "create_template"
       *     ]
       */
      pending_onboarding_tasks: components['schemas']['OnboardingTask'][];
      current_onboarding_sub_task?: components['schemas']['PendingSubStep'] | null;
      /** Onboarding Tasks Completed At */
      onboarding_tasks_completed_at?: string | null;
      /**
       * Post Note Quality Completed Tasks
       * @description Completed task ids for the post-note quality 'Improve your notes' panel
       */
      post_note_quality_completed_tasks?: components['schemas']['PostNoteQualityTask'][];
      /** Post Note Quality Panel Dismissed At */
      post_note_quality_panel_dismissed_at?: string | null;
      /**
       * Post Note Quality Reward Milestones Granted
       * @description Task-count milestones for which the post-note quality trial-day reward was granted
       */
      post_note_quality_reward_milestones_granted?: number[];
      /**
       * Has Seen Improve Notes Panel
       * @default false
       */
      has_seen_improve_notes_panel: boolean;
      /**
       * Is Tutorial Pane Opened
       * @default false
       */
      is_tutorial_pane_opened: boolean;
      /** Email */
      email?: string | null;
      /**
       * Enabled Code Systems
       * @default []
       */
      enabled_code_systems: components['schemas']['CodeSystemPreference'][];
      /**
       * Show Hcc Badges
       * @default false
       */
      show_hcc_badges: boolean;
      /**
       * Has Shown Codes Warning
       * @default false
       */
      has_shown_codes_warning: boolean;
      /**
       * Has Shown Sectional Note Info Modal
       * @default false
       */
      has_shown_sectional_note_info_modal: boolean;
      /**
       * Has Shown Push Sectional Note Instruction
       * @default false
       */
      has_shown_push_sectional_note_instruction: boolean;
      /**
       * Should Show Section Highlight In Template
       * @default false
       */
      should_show_section_highlight_in_template: boolean;
      /**
       * Has Seen Live Transcription Split View Modal
       * @default false
       */
      has_seen_live_transcription_split_view_modal: boolean;
      /**
       * Do Not Show Telehealth Sharing Tab Modal
       * @default false
       */
      do_not_show_telehealth_sharing_tab_modal: boolean;
      /**
       * Has Seen Create From Context Tooltip
       * @default false
       */
      has_seen_create_from_context_tooltip: boolean;
      /**
       * Should Show Try Scribe Tooltip
       * @default true
       */
      should_show_try_scribe_tooltip: boolean;
      /** Evidence Discovery Modal Seen At */
      evidence_discovery_modal_seen_at?: string | null;
      /**
       * Is Live Transcription Split View
       * @default true
       */
      is_live_transcription_split_view: boolean;
      /**
       * Has Seen Bbe Modal
       * @default false
       */
      has_seen_bbe_modal: boolean;
      /**
       * Is Bbe Enabled
       * @default true
       */
      is_bbe_enabled: boolean;
      /**
       * Has Seen Research Tooltip
       * @default false
       */
      has_seen_research_tooltip: boolean;
      /**
       * Has Seen Sessionless Evidence
       * @default false
       */
      has_seen_sessionless_evidence: boolean;
      /**
       * Has Seen Sessionless Evidence Reminder Tooltip
       * @default false
       */
      has_seen_sessionless_evidence_reminder_tooltip: boolean;
      /**
       * Has Seen Evidence Onboarding For Scribe
       * @default false
       */
      has_seen_evidence_onboarding_for_scribe: boolean;
      /**
       * Has Used Evidence In Session
       * @default false
       */
      has_used_evidence_in_session: boolean;
      /**
       * Has Seen Try Source Control During Trial Banner
       * @default false
       */
      has_seen_try_source_control_during_trial_banner: boolean;
      /**
       * Has Seen Evidence Source Control Coachmark
       * @default false
       */
      has_seen_evidence_source_control_coachmark: boolean;
      /**
       * Has Seen Billing Plan Renamed Banner
       * @default false
       */
      has_seen_billing_plan_renamed_banner: boolean;
      /**
       * Hide Clinical Task Gen Doc Nux Tooltip
       * @default false
       */
      hide_clinical_task_gen_doc_nux_tooltip: boolean;
      /**
       * Direct Integration Attempts Count
       * @default 0
       */
      direct_integration_attempts_count: number;
      /**
       * Has Created Template
       * @default true
       */
      has_created_template: boolean;
      /** Default Export Email */
      default_export_email?: string | null;
      /** Self Defined Disclaimer */
      self_defined_disclaimer?: string | null;
      language_time_settings?: components['schemas']['LanguageTimeSettings'] | null;
      /** Profile Picture Url */
      profile_picture_url?: string | null;
      /**
       * Has Shown New Brain Setting
       * @default false
       */
      has_shown_new_brain_setting: boolean;
      /**
       * Can Self Onboard Team
       * @default false
       */
      can_self_onboard_team: boolean;
      /**
       * Contacted Admin For Subscription Upgrade Team Ids
       * @description Team IDs for which this user has already triggered the subscription upgrade admin email flow
       */
      contacted_admin_for_subscription_upgrade_team_ids?: string[];
      /**
       * Is Promoted Free Trial
       * @default false
       */
      is_promoted_free_trial: boolean;
      /** Practice Name */
      practice_name?: string | null;
      /** Practice Address */
      practice_address?: string | null;
      practice_country?: components['schemas']['CallsAvailableCountry'] | null;
      /** Handoff Phone */
      handoff_phone?: string | null;
      /** Calls Terms Agreed On */
      calls_terms_agreed_on?: string | null;
      /** Work Research Terms Agreed On */
      work_research_terms_agreed_on?: string | null;
      /** Labs Experimental Terms Agreed On */
      labs_experimental_terms_agreed_on?: string | null;
      /** Calls Send Summary Email */
      calls_send_summary_email?: string | null;
      /**
       * Calls Send Summary Email Enabled
       * @default false
       */
      calls_send_summary_email_enabled: boolean;
      /**
       * @default {
       *       "enabled": false
       *     }
       */
      comms_session_retention_settings: components['schemas']['RetentionSettings'];
      /**
       * Default Consult Note Edit Display
       * @default false
       */
      default_consult_note_edit_display: boolean;
      /**
       * Is Auto Verify Enabled
       * @default false
       */
      is_auto_verify_enabled: boolean;
      /**
       * Auto Verify Preference Set
       * @default false
       */
      auto_verify_preference_set: boolean;
      /**
       * Is Auto Verify Lite Enabled
       * @default false
       */
      is_auto_verify_lite_enabled: boolean;
      /**
       * Auto Verify Lite Preference Set
       * @default false
       */
      auto_verify_lite_preference_set: boolean;
      /** @default light */
      theme: components['schemas']['Theme'] | null;
      /**
       * Scribe Session Page V2 Enabled
       * @default false
       */
      scribe_session_page_v2_enabled: boolean;
      /** Intercom User Id */
      intercom_user_id?: string | null;
      /** Intercom User Hash */
      intercom_user_hash?: string | null;
      /** Intercom User Jwt */
      intercom_user_jwt?: string | null;
      /**
       * Seen Modals
       * @description Tracks which modals the user has seen, keyed by modal_id
       */
      seen_modals?: {
        [key: string]: components['schemas']['ModalView'];
      };
      /**
       * Sales Booking Forms Submitted
       * @description Tracks successful sales-booking form submissions per form_name
       */
      sales_booking_forms_submitted?: {
        [key: string]: components['schemas']['SalesBookingFormSubmission'];
      };
      /** Affiliate Signup Code */
      affiliate_signup_code?: string | null;
      signup_source?: components['schemas']['SignupSource'] | null;
      /**
       * Is New User After Evidence Launch
       * @default false
       */
      is_new_user_after_evidence_launch: boolean;
      evidence_billing?: components['schemas']['EvidenceBillingInfoResponseView'] | null;
      evidence_settings?: components['schemas']['EvidenceSettingsResponse'];
      /** Heidi Referral Code */
      heidi_referral_code?: string | null;
      /** Heidi Referred By Code */
      heidi_referred_by_code?: string | null;
      /**
       * Heidi 2 Access Requested Workspace Ids
       * @description Workspace IDs for which this user has already asked the workspace admins for Heidi 2.0
       */
      heidi_2_access_requested_workspace_ids?: string[];
      /**
       * Heidi Leaderboard Opt Out
       * @default false
       */
      heidi_leaderboard_opt_out: boolean;
      /** Leaderboard Pseudonym */
      leaderboard_pseudonym?: string | null;
      /** @default pseudonym */
      leaderboard_visibility: components['schemas']['LeaderboardVisibility'];
      template_creation_record?: components['schemas']['TemplateCreationRecordSettingsResponse'];
      patient_summary_turn_off_prompt?: components['schemas']['PatientSummaryTurnOffPrompt'];
      /** Chats Migrated Count */
      chats_migrated_count?: number | null;
      /** Last Migrated Chat Id */
      last_migrated_chat_id?: string | null;
      /** Hardware Device Binding Code */
      hardware_device_binding_code?: string | null;
      /** Is Sso Login */
      is_sso_login?: boolean | null;
      /** Is Social Login */
      is_social_login?: boolean | null;
      /**
       * Is Managed
       * @default false
       */
      is_managed: boolean;
      /**
       * Is Evidence Activated
       * @default false
       */
      is_evidence_activated: boolean;
      ehr_profile?: components['schemas']['EHRProfile'] | null;
      /**
       * Is In Fake Clinician Trial
       * @default false
       */
      is_in_fake_clinician_trial: boolean;
      third_party_license?: components['schemas']['ThirdPartyLicenceDetails'] | null;
      /** Workspaces */
      workspaces?: components['schemas']['AdminWorkspaceMembership'][];
      in_session_evidence_quota?:
        | components['schemas']['InternalAdminInSessionEvidenceQuotaResponse']
        | null;
    };
    /**
     * InternalAdminUserRoles
     * @enum {string}
     */
    InternalAdminUserRoles: InternalAdminUserRoles;
    /** InternalAdminUserRolesResponse */
    InternalAdminUserRolesResponse: {
      /** Roles */
      roles: components['schemas']['InternalAdminUserRoles'][];
    };
    /** InternalAdminUserWorkflowsResponse */
    InternalAdminUserWorkflowsResponse: {
      /** Personal Recordings */
      personal_recordings: components['schemas']['InternalAdminRpaRecordingSummary'][];
      /** Team Workflows */
      team_workflows: components['schemas']['TeamWorkflowSummaryResponse'][];
    };
    /**
     * InternalOrderReasonCategory
     * @description Why an internal-admin order was raised. Required on every INTERNAL_ADMIN
     *     order so each one is explainable and reportable.
     * @enum {string}
     */
    InternalOrderReasonCategory: InternalOrderReasonCategory;
    /** InternalSessionTranscriptsResponse */
    InternalSessionTranscriptsResponse: {
      /** Transcript */
      transcript: string;
    };
    /**
     * InternalTemplateResponse
     * @description Template response for internal APIs with experience modifier flags.
     */
    InternalTemplateResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Content */
      content: components['schemas']['VersionedTemplateContentResponse'][];
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      template_category: components['schemas']['TemplateCategory'];
      /** Template Families */
      template_families: string[];
      /** Deleted At */
      deleted_at?: string | null;
      /**
       * Should Deduct Quota
       * @default false
       */
      should_deduct_quota: boolean;
      /** Prompteams Id */
      prompteams_id?: string | null;
      /** List Order Priority */
      list_order_priority?: number | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /**
       * Pinned
       * @default false
       */
      pinned: boolean;
      /**
       * Highlighted
       * @default false
       */
      highlighted: boolean;
      /**
       * Featured
       * @default false
       */
      featured: boolean;
      /**
       * Auto Generated
       * @default false
       */
      auto_generated: boolean;
    };
    /**
     * InternalTestCreateDbOnlyUserRequest
     * @description Request schema for creating a DB-only internal test user.
     *
     *     Mirrors ``InternalTestCreateUserRequest`` but is the input to the
     *     ``POST /internal-admin/internal-test/users/db-only`` endpoint, which
     *     creates the user in MongoDB/Stripe only and skips Kinde/Auth0 account
     *     creation. The user is meant to be impersonated at sign-in via a shared
     *     Auth0 account that asserts the synthetic ``kinde_id`` as a token claim.
     */
    InternalTestCreateDbOnlyUserRequest: {
      /** @description Subscription tier to assign to the user */
      latest_tier?: components['schemas']['SubscriptionTier'] | null;
      /**
       * Skip Onboarding
       * @description If true, marks all onboarding/trial modals as seen
       * @default false
       */
      skip_onboarding: boolean;
      /**
       * Dismiss Org Survey
       * @description If true (default), sets organisation_info. Set false to leave it empty so the onboarding modal shows.
       * @default true
       */
      dismiss_org_survey: boolean;
      /**
       * @description Country to assign to the user. Defaults to Australia. Set null to leave empty (e.g. for onboarding tests).
       * @default Australia
       */
      country: components['schemas']['Country'] | null;
    };
    /** InternalTestCreateUserRequest */
    InternalTestCreateUserRequest: {
      /** @description Subscription tier to assign to the user */
      latest_tier?: components['schemas']['SubscriptionTier'] | null;
      /**
       * Skip Onboarding
       * @description If true, marks all onboarding/trial modals as seen
       * @default false
       */
      skip_onboarding: boolean;
      /**
       * Dismiss Org Survey
       * @description If true (default), sets organisation_info. Set false to leave it empty so the onboarding modal shows.
       * @default true
       */
      dismiss_org_survey: boolean;
      /**
       * @description Country to assign to the user. Defaults to Australia. Set null to leave empty (e.g. for onboarding tests).
       * @default Australia
       */
      country: components['schemas']['Country'] | null;
    };
    /**
     * InternalTestDbOnlyUserCreatedResponse
     * @description Response schema for DB-only internal test user creation.
     *
     *     Carries the identity the caller needs for shared-Auth0 impersonation:
     *     ``user.kinde_user_id`` (carries the ``db_only_`` prefix) and
     *     ``user.user_ref_id``. NO login credentials are returned — DB-only
     *     users have no Kinde/Auth0 account, so the caller must authenticate as
     *     a separate shared Auth0 user and override the access-token claims via
     *     the post-login Action.
     *
     *     The top-level ``email`` is the generated ``@test-user.heidihealth.com``
     *     address stored in MongoDB. It is NOT a login credential — the actual
     *     Auth0 login email is the shared user's address, which lives in the
     *     caller's environment. ``email`` is provided here for parity with the
     *     regular create response (debuggability, log correlation, and the
     *     deletion-endpoint email-domain guard).
     */
    InternalTestDbOnlyUserCreatedResponse: {
      user: components['schemas']['UserResponse'];
      /**
       * Email
       * @description The DB-only user's generated email (stored in MongoDB, @test-user.heidihealth.com). Not a login credential — see class docstring.
       */
      email: string;
    };
    /**
     * InternalTestProvisionOrganizationSpec
     * @description Specification for an organization to be created during provisioning.
     */
    InternalTestProvisionOrganizationSpec: {
      /**
       * Name
       * @description Organization name. Auto-generated as e2e-test-{uuid} if omitted.
       */
      name?: string | null;
      /**
       * Users
       * @description Org-level admin users (added to the organization's root team)
       */
      users: components['schemas']['InternalTestProvisionUserRef'][];
      /**
       * Teams
       * @description Child teams under this organization
       */
      teams?: components['schemas']['InternalTestProvisionTeamSpec'][];
    };
    /**
     * InternalTestProvisionRequest
     * @description Request body for the atomic provision endpoint.
     *
     *     Three mutually exclusive modes:
     *
     *     1. **Solo users** — provide ``users`` only (no team/org created).
     *     2. **Standalone team** — provide ``team`` with nested users.
     *     3. **Organization** — provide ``organization`` with nested users and
     *        optional child teams.
     */
    InternalTestProvisionRequest: {
      /**
       * Users
       * @description Solo users to resolve (no team/org). Must be empty when team or organization is set.
       */
      users?: components['schemas']['InternalTestProvisionUserRef'][];
      /** @description Standalone team to create (mutually exclusive with organization). */
      team?: components['schemas']['InternalTestProvisionTeamSpec'] | null;
      /** @description Organization to create (mutually exclusive with team). */
      organization?:
        | components['schemas']['InternalTestProvisionOrganizationSpec']
        | null;
    };
    /**
     * InternalTestProvisionResponse
     * @description Response body for the atomic provision endpoint.
     */
    InternalTestProvisionResponse: {
      /**
       * Users
       * @description List of all resolved users with their assigned roles
       */
      users: components['schemas']['InternalTestProvisionedUser'][];
      /**
       * Teams
       * @description List of all created teams (includes org root team if applicable)
       */
      teams: components['schemas']['InternalTestProvisionedTeam'][];
      /** @description Provisioned organization details */
      organization?: components['schemas']['InternalTestProvisionedOrganization'] | null;
    };
    /**
     * InternalTestProvisionTeamSpec
     * @description Specification for a team to be created during provisioning.
     */
    InternalTestProvisionTeamSpec: {
      /**
       * Team Name
       * @description Team name. Auto-generated as e2e-test-{uuid} if omitted.
       */
      team_name?: string | null;
      /**
       * @description Subscription tier for the team
       * @default FREE
       */
      subscribed_plan: components['schemas']['SubscriptionTier'];
      /**
       * Is Stripe Managed
       * @description Whether the team uses Stripe-managed billing
       * @default false
       */
      is_stripe_managed: boolean;
      /**
       * Charge Future Members
       * @description Whether to charge future members automatically
       * @default false
       */
      charge_future_members: boolean;
      /**
       * Allow To Add Team Members
       * @description Whether team members can be added
       * @default true
       */
      allow_to_add_team_members: boolean;
      /**
       * Users
       * @description Users to add to this team
       */
      users: components['schemas']['InternalTestProvisionUserRef'][];
    };
    /**
     * InternalTestProvisionUserRef
     * @description Reference to an existing user (looked up by email) during provisioning.
     */
    InternalTestProvisionUserRef: {
      /**
       * Email
       * @description Email of an already-provisioned test user
       */
      email: string;
      /** @description Team ownership: 'owner' or 'member'. */
      role?: components['schemas']['TeamMembershipRole'] | null;
      /** @description Business role name (e.g. 'Administrator', 'Clinician', 'Assistant'). When set, the user is assigned the matching system role. Requires system roles to be seeded in the database. */
      role_name?: components['schemas']['Role'] | null;
    };
    /**
     * InternalTestProvisionedOrganization
     * @description An organization that was created during provisioning.
     */
    InternalTestProvisionedOrganization: {
      /**
       * Organization Id
       * @description Organization ID
       */
      organization_id: string;
      /**
       * Name
       * @description Organization name
       */
      name: string;
    };
    /**
     * InternalTestProvisionedTeam
     * @description A team that was created during provisioning.
     */
    InternalTestProvisionedTeam: {
      /**
       * Team Id
       * @description Team ID
       */
      team_id: string;
      /**
       * Team Name
       * @description Team name
       */
      team_name: string;
    };
    /**
     * InternalTestProvisionedUser
     * @description A user that was looked up during provisioning.
     */
    InternalTestProvisionedUser: {
      /**
       * User Ref Id
       * @description User reference ID
       */
      user_ref_id: string;
      /**
       * Kinde User Id
       * @description Kinde user ID
       */
      kinde_user_id: string;
      /**
       * Email
       * @description User email address
       */
      email: string;
      /** @description Role within the team: 'owner' or 'member' */
      role?: components['schemas']['TeamMembershipRole'] | null;
    };
    /**
     * InternalTestTeardownRequest
     * @description Request body for the atomic teardown endpoint.
     */
    InternalTestTeardownRequest: {
      /**
       * Team Ids
       * @description Team IDs to delete
       */
      team_ids?: string[];
      /**
       * Organization Id
       * @description Organization ID to delete
       */
      organization_id?: string | null;
    };
    /**
     * InternalTestUpdateUserRequest
     * @description Request schema for adjusting internal test user properties.
     */
    InternalTestUpdateUserRequest: {
      /** @description Subscription tier to assign to the user */
      latest_tier?: components['schemas']['SubscriptionTier'] | null;
      /**
       * Plan Start Date
       * @description Plan start date
       */
      plan_start_date?: string | null;
      /**
       * Plan End Date
       * @description Plan end date
       */
      plan_end_date?: string | null;
      /** @description Plan billing cycle (MONTHLY or YEARLY) */
      plan_cycle?: components['schemas']['shared__enums__enums__Period'] | null;
      /** @description Quota adjustments */
      quota?: components['schemas']['Quota'] | null;
      /**
       * Specialty Id
       * @description User's medical specialty ID
       */
      specialty_id?: string | null;
      /**
       * Practice Name
       * @description Name of the medical practice
       */
      practice_name?: string | null;
      /**
       * Reverse Trial
       * @description Whether user is in reverse trial
       */
      reverse_trial?: boolean | null;
      /**
       * Is Reverse Trial Extendable
       * @description Whether the user can extend the reverse trial
       */
      is_reverse_trial_extendable?: boolean | null;
      /**
       * Trial End Date
       * @description Trial end date
       */
      trial_end_date?: string | null;
      /**
       * Next Billing Date
       * @description Next billing date
       */
      next_billing_date?: string | null;
    };
    /**
     * InternalTestUserCreatedResponse
     * @description Response schema for internal test user creation with credentials.
     */
    InternalTestUserCreatedResponse: {
      user: components['schemas']['UserResponse'];
      /**
       * Email
       * @description The user's email address
       */
      email: string;
      /**
       * Password
       * @description The user's password (only returned on creation)
       */
      password: string;
    };
    /** InviteUsersToOrgTeamRequest */
    InviteUsersToOrgTeamRequest: {
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /** User Emails */
      user_emails: string[];
      /** Role Ids */
      role_ids: string[];
    };
    /** InviteUsersToOrgTeamResponse */
    InviteUsersToOrgTeamResponse: {
      /** Success Emails */
      success_emails: string[];
      /** Failed Emails Data */
      failed_emails_data: {
        [key: string]: string;
      };
    };
    /** InviteUsersToTeamRequest */
    InviteUsersToTeamRequest: {
      /** User Emails */
      user_emails: string[];
      /** Role Ids */
      role_ids: string[];
    };
    /** InviteUsersToTeamResponse */
    InviteUsersToTeamResponse: {
      /** Success Emails */
      success_emails: {
        [key: string]: string;
      };
      /** Failed Emails Data */
      failed_emails_data: {
        [key: string]: string;
      };
    };
    /** ItemStateView */
    ItemStateView: {
      /**
       * Checked
       * @default false
       */
      checked: boolean;
      /** Checked At */
      checked_at?: string | null;
      /** Applied At */
      applied_at?: string | null;
    };
    /**
     * ItemSuggestionView
     * @description Advisory, transcript-derived highlight for one item/branch. The FE renders it as
     *     a "suggested" visual + hover rationale; it never implies the item is checked.
     *
     *     ``kind == "item_action"`` targets a checkable item; ``kind == "branch_answer"``
     *     targets a decision (``suggest_value`` = "yes"/"no" for fork/cond, or an option_id
     *     for a branch).
     */
    ItemSuggestionView: {
      /** Item Id */
      item_id: string;
      /** Kind */
      kind: string;
      /** Suggest Value */
      suggest_value?: string | null;
      /** Quote */
      quote: string;
      /** Rationale */
      rationale: string;
      /** Confidence */
      confidence: number;
    };
    /**
     * IterationUsage
     * @description Token usage for one LLM call within the tool loop.
     *
     *     ``context_cost_tokens`` estimates the full prompt growth attributable to
     *     tool results from the previous iteration. Fresh, cache-read, and
     *     cache-creation input buckets are summed before subtracting the previous
     *     full prompt and output. The result is clamped to zero because context
     *     trimming can make the raw delta negative. ``None`` on the first iteration.
     */
    IterationUsage: {
      /** Iteration */
      iteration: number;
      usage: components['schemas']['TokenUsage'];
      /** Tool Calls */
      tool_calls?: string[];
      /** Context Cost Tokens */
      context_cost_tokens?: number | null;
      /** Effective Provider */
      effective_provider?: string | null;
      /** Effective Model */
      effective_model?: string | null;
    };
    /**
     * JobListResponse
     * @description Response model for listing jobs.
     */
    JobListResponse: {
      /** Jobs */
      jobs: components['schemas']['JobResponse'][];
      /** Total */
      total: number;
    };
    /**
     * JobResponse
     * @description Response model for an ingestion job.
     */
    JobResponse: {
      /** Job Id */
      job_id: string;
      /** Filename */
      filename: string;
      scope: components['schemas']['DocumentScope'];
      /** Team Id */
      team_id?: string | null;
      /** Client Upload Id */
      client_upload_id?: string | null;
      status: components['schemas']['JobStatus'];
      /** Error Message */
      error_message?: string | null;
      /** Uploaded By */
      uploaded_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Retryable
       * @description Whether this job can be retried (failed with s3_key)
       * @default false
       */
      retryable: boolean;
    };
    /**
     * JobStatus
     * @description Processing status of an ingestion job.
     * @enum {string}
     */
    JobStatus: JobStatus;
    /**
     * JobStatusResponse
     * @description Response model for job processing status with detailed progress.
     */
    JobStatusResponse: {
      /** Job Id */
      job_id: string;
      /** Filename */
      filename: string;
      scope: components['schemas']['DocumentScope'];
      status: components['schemas']['JobStatus'];
      progress: components['schemas']['ProcessingProgress'];
      /** Error Message */
      error_message?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Processing Log */
      processing_log?: components['schemas']['ProcessingLogEntry'][];
    };
    /**
     * JoinableTeamView
     * @description Response model for joinable team information.
     */
    JoinableTeamView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /**
       * Organization Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      organization_id: string;
      /** Organization Name */
      organization_name: string;
    };
    /** JoinedOrganizationRelation */
    JoinedOrganizationRelation: {
      /**
       * Org Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      org_id: string;
      /** Org Name */
      org_name: string;
      user_role: components['schemas']['UserRole'];
      /** User Role List */
      user_role_list?: components['schemas']['RoleModel'][];
      /**
       * Is In Org Team
       * @description Indicates if the user is a direct member of the organization's top-level team
       * @default false
       */
      is_in_org_team: boolean;
      /**
       * Allow Direct Session Sharing
       * @description Whether the organization allows direct session sharing between members
       * @default true
       */
      allow_direct_session_sharing: boolean;
      /**
       * Allow Session Link Sharing
       * @description Whether the organization allows session link sharing with external recipients
       * @default false
       */
      allow_session_link_sharing: boolean;
    };
    /** JoinedOrganizationsResponse */
    JoinedOrganizationsResponse: {
      /** Organizations */
      organizations: components['schemas']['JoinedOrganizationRelation'][];
    };
    /** JoinedTeamRelation */
    JoinedTeamRelation: {
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /** Team Name */
      team_name: string;
      user_role: components['schemas']['UserRole'];
      /** Free Trial End Date */
      free_trial_end_date?: string | null;
      /** Joined At */
      joined_at?: string | null;
      /** User Role List */
      user_role_list?: components['schemas']['RoleModel'][];
      /** Member Count */
      member_count?: number | null;
      /**
       * Is Managed
       * @default false
       */
      is_managed: boolean;
    };
    /** JoinedTeamsResponse */
    JoinedTeamsResponse: {
      /** Joined Teams */
      joined_teams: components['schemas']['JoinedTeamRelation'][];
    };
    /**
     * JoinedWorkspaceRelation
     * @description One entry in the user's workspace list — workspace identity plus
     *     the caller's role in it.
     *
     *     ``icon_url`` and ``plan`` are reserved-shape fields: the contract
     *     surface ships ahead of the data so mobile clients can wire the UI
     *     once. Both always return ``null`` until the icon upload flow and
     *     billing-domain plan resolution land in follow-up changes. ``plan``
     *     is intentionally typed as ``str`` (not ``SubscriptionTier``) so the
     *     workspace-plan label can evolve independently of the user-billing
     *     enum; the follow-up wiring PR will introduce a dedicated
     *     ``WorkspacePlan`` enum once the value set is concrete.
     *     ``WorkspaceDO`` (the minimal workspace DB schema) is intentionally
     *     not extended.
     */
    JoinedWorkspaceRelation: {
      /**
       * Workspace Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      workspace_id: string;
      /** Workspace Name */
      workspace_name: string;
      user_role: components['schemas']['WorkspaceRole'];
      /** Icon Url */
      icon_url?: string | null;
      /** Plan */
      plan?: string | null;
      /**
       * Is Managed
       * @default false
       */
      is_managed: boolean;
    };
    /**
     * JourneyStatus
     * @enum {string}
     */
    JourneyStatus: JourneyStatus;
    JsonValue: unknown;
    /** JudgeTemplateListResponse */
    JudgeTemplateListResponse: {
      /** Templates */
      templates: components['schemas']['JudgeTemplateResponse'][];
      /** Total */
      total: number;
    };
    /** JudgeTemplateResponse */
    JudgeTemplateResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Prompt Template */
      prompt_template: string;
      /** Model */
      model: string;
      /** Output Schema */
      output_schema: {
        [key: string]: unknown;
      } | null;
      /** Is Shared */
      is_shared: boolean;
      /** Created By */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** JurisdictionOptionResponse */
    JurisdictionOptionResponse: {
      /** Code */
      code: string;
      /** Name */
      name: string;
      /** Type */
      type?: string | null;
    };
    /**
     * KindeIdentityDTO
     * @description A single Kinde identity entry, schematized for the CS diagnostic surface.
     *
     *     Surfaces only the fields CS legitimately needs (provider type, identifier
     *     string, primary flag). Raw provider tokens, linkage metadata, and
     *     timestamps from Kinde are intentionally NOT exposed.
     */
    KindeIdentityDTO: {
      /**
       * Id
       * @description Kinde identity id
       */
      id?: string | null;
      /**
       * Type
       * @description Identity provider type (e.g. 'email', 'username', 'oauth2:google')
       */
      type?: string | null;
      /**
       * Identifier
       * @description Provider-specific identifier (e.g. email or username string)
       */
      identifier?: string | null;
      /** Is Primary */
      is_primary?: boolean | null;
    };
    /**
     * KindeProfileStatus
     * @description Status indicating whether this is a new or existing profile.
     * @enum {string}
     */
    KindeProfileStatus: KindeProfileStatus;
    /**
     * KindePropertyDTO
     * @description Single Kinde user property for diagnostic display.
     */
    KindePropertyDTO: {
      /** Id */
      id: string;
      /** Key */
      key: string;
      /** Value */
      value?: string | null;
      /** Name */
      name?: string | null;
    };
    /**
     * KindeUserDiagnosticDTO
     * @description Live Kinde view of a user for customer-support diagnostics.
     */
    KindeUserDiagnosticDTO: {
      /**
       * Kinde User Id
       * @description Kinde user identifier
       */
      kinde_user_id: string;
      /** Email */
      email: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Is Suspended */
      is_suspended?: boolean | null;
      /** Organisations */
      organisations?: string[];
      /** Properties */
      properties?: components['schemas']['KindePropertyDTO'][];
      /**
       * Identities
       * @description Schematized subset of Kinde provider identities
       */
      identities?: components['schemas']['KindeIdentityDTO'][];
    };
    /**
     * KindeUserStatus
     * @description User status in Kinde - matches frontend type.
     * @enum {string}
     */
    KindeUserStatus: KindeUserStatus;
    /**
     * LDAActionType
     * @example removal date
     * @example removal time
     * @example placement date
     * @example placement time
     * @example earliest known
     * @example last known present
     */
    LDAActionType: string;
    /**
     * LDAError
     * @description Validation error for an LDA instance or a row within it.
     */
    LDAError: {
      /** Ldainstanceid */
      ldaInstanceId?: string | null;
      /** Proxyldainstanceid */
      proxyLdaInstanceId?: string | null;
      /** Rowid */
      rowId?: components['schemas']['dataclass__nebula_session__models__IDType'][] | null;
      /** Value */
      value?: string | null;
      /** Error */
      error: string;
      /** Errorcode */
      errorCode?: string | null;
    };
    /** LDAInstanceRequest */
    LDAInstanceRequest: {
      /** Ldainstanceid */
      ldaInstanceId: components['schemas']['IDTypeRequest'][];
      /** Ldagroupid */
      ldaGroupId: components['schemas']['IDTypeRequest'][];
      /** Displayname */
      displayName: string;
    };
    /**
     * LDARowType
     * @example assessment
     * @example property
     */
    LDARowType: string;
    /** LLMCallMessage */
    LLMCallMessage: {
      role: components['schemas']['LLMMessageRole'];
      /** Content */
      content: string;
    };
    /** LLMCallRecord */
    LLMCallRecord: {
      /** @description api request info, will be the same if there are multiple llm calls within a api request */
      api_request?: components['schemas']['ApiRequestInfo'] | null;
      /**
       * User Id
       * @description kinde user id
       */
      user_id: string;
      /** Session Id */
      session_id?: string | null;
      /** Country */
      country: string;
      /** Model */
      model: string;
      provider?: components['schemas']['LLMProviders'] | null;
      /**
       * Mask Messages
       * @description mask_messages = null if mask_messages == unmask_messages
       */
      mask_messages?: components['schemas']['LLMCallMessage'][] | null;
      /** Unmask Messages */
      unmask_messages?: components['schemas']['LLMCallMessage'][];
      /**
       * Created Time
       * Format: date-time
       */
      created_time?: string;
      /** Response */
      response?: string | null;
      /** Error Type */
      error_type?: string | null;
      /** Error Msg */
      error_msg?: string | null;
      /** Id */
      id?: string | null;
      task_info?: components['schemas']['LLMTaskInfo'] | null;
      task?: components['schemas']['LLMTask'] | null;
    };
    /**
     * LLMConfig
     * @description Per-call LLM configuration.
     *
     *     ``model`` and ``provider`` default to ``""`` because per-contract
     *     requiredness differs (required on ``AgentConfig``/``ResolvedAgentConfig``,
     *     optional on the request DTOs) and is enforced by each contract's flat
     *     field for the life of the dual-shape transition. The follow-up that
     *     removes the flat mirrors must add explicit non-empty validation where
     *     required.
     */
    LLMConfig: {
      /**
       * Provider
       * @default
       */
      provider: string;
      /**
       * Model
       * @default
       */
      model: string;
      /** Max Tokens Per Turn */
      max_tokens_per_turn?: number | null;
      /** Thinking */
      thinking?:
        | (
            | components['schemas']['BudgetThinking']
            | components['schemas']['AdaptiveThinking']
          )
        | null;
      /**
       * Cache Strategy
       * @default off
       * @enum {string}
       */
      cache_strategy: LLMConfigCache_strategy;
      /**
       * Fast Mode
       * @default false
       */
      fast_mode: boolean;
      /** Provider Extra Headers */
      provider_extra_headers?: {
        [key: string]: string;
      };
      /** Provider Extra Body */
      provider_extra_body?: {
        [key: string]: unknown;
      };
      frozen_transport?: components['schemas']['FrozenLlmTransport'] | null;
    };
    /**
     * LLMMessageRole
     * @enum {string}
     */
    LLMMessageRole: LLMMessageRole;
    /**
     * LLMMetadata
     * @description LLM call metadata for observability and debugging (admin-only).
     *
     *     Contains details about the Anthropic API call including request parameters,
     *     response info, and usage statistics.
     */
    LLMMetadata: {
      /** Model */
      model?: string | null;
      /** Max Tokens */
      max_tokens?: number | null;
      /** Thinking Type */
      thinking_type?: string | null;
      /** Thinking Budget */
      thinking_budget?: number | null;
      /** Tool Names */
      tool_names?: string[] | null;
      /** Message Count */
      message_count?: number | null;
      /** Llm Message Id */
      llm_message_id?: string | null;
      /** Tools Called */
      tools_called?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Iteration Count */
      iteration_count?: number | null;
      /** Iterations */
      iterations?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Stop Reason */
      stop_reason?: string | null;
      /** Stop Sequence */
      stop_sequence?: string | null;
      /** Usage */
      usage?: {
        [key: string]: unknown;
      } | null;
      /** Tavily Search Count */
      tavily_search_count?: number | null;
      /** Anthropic Search Count */
      anthropic_search_count?: number | null;
      /** Tavily Http Request Count */
      tavily_http_request_count?: number | null;
    };
    /**
     * LLMModels
     * @description LLM model names used for note generation.
     * @enum {string}
     */
    LLMModels: LLMModels;
    /**
     * LLMTask
     * @enum {string}
     */
    LLMTask: LLMTask;
    /** LLMTaskInfo */
    LLMTaskInfo: {
      task_name?: components['schemas']['LLMTaskName'] | null;
      /** Step */
      step?: string | null;
      /** Note Id */
      note_id?: string | null;
      /** Doc Id */
      doc_id?: string | null;
      /** Session Id */
      session_id?: string | null;
      notegen_model_override?: components['schemas']['LLMModels'] | null;
      notegen_override_source_model?: components['schemas']['LLMModels'] | null;
    };
    /**
     * LLMTaskName
     * @enum {string}
     */
    LLMTaskName: LLMTaskName;
    /** Language */
    Language: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Name */
      name: string;
      code: components['schemas']['LanguageCode'];
      /**
       * Is Scribe Default Language
       * @default false
       */
      is_scribe_default_language: boolean;
      /** Generate Consult Note Language Prompt Id */
      generate_consult_note_language_prompt_id?: string | null;
      /** Ask Ai Language Prompt Id */
      ask_ai_language_prompt_id?: string | null;
      /** Disclaimer */
      disclaimer?: string | null;
      /**
       * Is Live
       * @default false
       */
      is_live: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
      /**
       * Is Beta
       * @default false
       */
      is_beta: boolean | null;
    };
    /**
     * LanguageCode
     * @enum {string}
     */
    LanguageCode: LanguageCode;
    /** LanguageCreateRequest */
    LanguageCreateRequest: {
      /** Name */
      name: string;
      language_code: components['schemas']['LanguageCode'];
      /** Generate Consult Note Language Prompt Id */
      generate_consult_note_language_prompt_id?: string | null;
      /** Ask Ai Language Prompt Id */
      ask_ai_language_prompt_id?: string | null;
      /** Disclaimer */
      disclaimer?: string | null;
      /**
       * Is Beta
       * @default false
       */
      is_beta: boolean | null;
    };
    /** LanguageListResponse */
    LanguageListResponse: {
      /** Language List */
      language_list: components['schemas']['LanguageView'][];
      /** Count */
      count: number;
    };
    /** LanguageTimeSettings */
    LanguageTimeSettings: {
      /** @default en */
      display_language: components['schemas']['LanguageCode'] | null;
    };
    /** LanguageUpdateRequest */
    LanguageUpdateRequest: {
      language_code: components['schemas']['LanguageCode'];
      /** Generate Consult Note Language Prompt Id */
      generate_consult_note_language_prompt_id?: string | null;
      /** Ask Ai Language Prompt Id */
      ask_ai_language_prompt_id?: string | null;
      /** Disclaimer */
      disclaimer?: string | null;
      /** Is Live */
      is_live: boolean;
      /**
       * Is Beta
       * @default false
       */
      is_beta: boolean | null;
    };
    /** LanguageView */
    LanguageView: {
      /** Name */
      name: string;
      code: components['schemas']['LanguageCode'];
      /** Generate Consult Note Language Prompt Id */
      generate_consult_note_language_prompt_id?: string | null;
      /** Ask Ai Language Prompt Id */
      ask_ai_language_prompt_id?: string | null;
      /** Disclaimer */
      disclaimer?: string | null;
      /** Is Scribe Default Language */
      is_scribe_default_language: boolean;
      /** Is Live */
      is_live: boolean;
      /**
       * Is Beta
       * @default false
       */
      is_beta: boolean | null;
      /**
       * Is Available For Dictation
       * @default false
       */
      is_available_for_dictation: boolean;
    };
    /**
     * LanguageVoicesView
     * @description All selectable voices for one supported language.
     *
     *     ``default_voice_id`` is the runtime fallback used when an agent pins no
     *     voice for this language. ``country_code_defaults`` is populated for
     *     English only (US/UK/AU accent routing).
     *
     *     Brazilian (``pt-BR``) and European (``pt-PT``) Portuguese are separate
     *     languages — each is its own entry with its own voice list and default;
     *     there is no collapsed ``pt`` bucket.
     */
    LanguageVoicesView: {
      /** Code */
      code: string;
      /** Name */
      name: string;
      /** Preview Text */
      preview_text: string;
      /** Voices */
      voices: components['schemas']['VoiceOptionView'][];
      /** Default Voice Id */
      default_voice_id?: string | null;
      /** Country Code Defaults */
      country_code_defaults?: components['schemas']['CountryCodeDefaultView'][];
    };
    /** LastMessageView */
    LastMessageView: {
      /** Content */
      content: string;
      /**
       * Direction
       * @enum {string}
       */
      direction: LastMessageViewDirection;
      /**
       * Sender Type
       * @enum {string}
       */
      sender_type: LastMessageViewSender_type;
      /** Created At */
      created_at: string;
    };
    /** LatestRunSummaryResponse */
    LatestRunSummaryResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /**
       * Status
       * @enum {string}
       */
      status: LatestRunSummaryResponseStatus;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Created At */
      created_at?: string | null;
    };
    /**
     * LeaderboardEntry
     * @description A single entry on the leaderboard.
     */
    LeaderboardEntry: {
      /** Rank */
      rank: number;
      /** Display Name */
      display_name: string;
      /** Count */
      count: number;
    };
    /**
     * LeaderboardPeriodType
     * @description Time period types for leaderboard aggregation.
     * @enum {string}
     */
    LeaderboardPeriodType: LeaderboardPeriodType;
    /**
     * LeaderboardResponse
     * @description Response for leaderboard endpoints.
     */
    LeaderboardResponse: {
      /** Entries */
      entries: components['schemas']['LeaderboardEntry'][];
      competition: components['schemas']['CompetitionResponse'];
      /** Total Entries */
      total_entries: number;
      /** Page */
      page: number;
      /** Limit */
      limit: number;
      /**
       * Generated At
       * Format: date-time
       */
      generated_at: string;
    };
    /**
     * LeaderboardType
     * @description Types of metrics that can be tracked in a leaderboard competition.
     * @enum {string}
     */
    LeaderboardType: LeaderboardType;
    /**
     * LeaderboardVisibility
     * @description User's visibility preference on the public leaderboard.
     * @enum {string}
     */
    LeaderboardVisibility: LeaderboardVisibility;
    /**
     * LetterAttachmentDownloadUrlResponse
     * @description Short-lived download URL for a letter attachment.
     */
    LetterAttachmentDownloadUrlResponse: {
      /**
       * Attachment Id
       * @description Attachment ID serialized as a string.
       */
      attachment_id: string;
      /**
       * Download Url
       * @description Short-lived presigned GET URL for downloading the attachment bytes. Absolute on cloud; a host-relative /storage path on-prem (served by the ingress). String rather than a strict URL so the relative form is valid.
       */
      download_url: string;
    };
    /**
     * LetterAttachmentListResponse
     * @description API representation of a letter attachment metadata collection.
     */
    LetterAttachmentListResponse: {
      /**
       * Attachments
       * @description Attachments for the letter, ordered oldest first by upload time.
       */
      attachments: components['schemas']['LetterAttachmentResponse'][];
    };
    /**
     * LetterAttachmentMimeType
     * @description Supported MIME types for letter attachments.
     * @enum {string}
     */
    LetterAttachmentMimeType: LetterAttachmentMimeType;
    /**
     * LetterAttachmentResponse
     * @description API representation of a letter attachment metadata record.
     */
    LetterAttachmentResponse: {
      /**
       * Id
       * @description Attachment ID serialized as a string.
       */
      id: string;
      /**
       * Letter Id
       * @description Letter ID serialized as a string.
       */
      letter_id: string;
      /**
       * File Name
       * @description Original filename supplied by the client.
       */
      file_name: string;
      /** @description Attachment MIME type. Currently only application/pdf is supported. */
      mime_type: components['schemas']['LetterAttachmentMimeType'];
      /**
       * Size Bytes
       * @description Attachment size in bytes.
       */
      size_bytes: number;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the attachment was uploaded.
       */
      created_at: string;
    };
    /**
     * LetterContent
     * @description Point-in-time snapshot of timeline-visible letter content.
     */
    LetterContent: {
      /** Body Content */
      body_content: string;
      content_type: components['schemas']['LetterContentType'];
      /** Content Type Version */
      content_type_version: number;
    };
    /**
     * LetterContentSnapshotTimelineEventResponse
     * @description API representation of a letter content snapshot timeline event.
     */
    LetterContentSnapshotTimelineEventResponse: {
      /**
       * @description Timeline event discriminator for content snapshots. (enum property replaced by openapi-typescript)
       * @enum {string}
       */
      type: LetterContentSnapshotTimelineEventResponseType;
      /** @description Point-in-time letter body content snapshot. */
      content: components['schemas']['LetterContent'];
    };
    /**
     * LetterContentType
     * @description Supported stored body formats for letters.
     *
     *     The value controls how editors and renderers interpret ``body_content``.
     *     API responses expose it directly so clients can choose the correct content
     *     conversion path without inspecting the body string.
     * @enum {string}
     */
    LetterContentType: LetterContentType;
    /**
     * LetterDeliveryDetails
     * @description Latest persisted delivery-state snapshot for a letter.
     *
     *     ``recipient_results`` preserves recipient order: the primary recipient
     *     appears first when present, followed by copy recipients in their configured
     *     order. ``last_attempted_at`` records when that latest state was persisted.
     *     This snapshot may reference recipients from a failed send attempt even if
     *     the editable recipient fields are changed afterwards; timeline events remain
     *     the append-only history. Partial retries carry forward previously sent
     *     recipients while attempting only recipients that were not delivered.
     */
    LetterDeliveryDetails: {
      /** Recipient Results */
      recipient_results: components['schemas']['LetterSendRecipientResult'][];
      /**
       * Last Attempted At
       * Format: date-time
       */
      last_attempted_at: string;
    };
    /**
     * LetterDeliveryStatus
     * @description Latest overall delivery state for a letter.
     * @enum {string}
     */
    LetterDeliveryStatus: LetterDeliveryStatus;
    /**
     * LetterDirectoryRecipient
     * @description Discriminated wrapper for a directory-sourced recipient.
     *
     *     The wrapper preserves that the contact methods came from Heidi's directory
     *     so API serialization, duplicate validation, and send deduplication can apply
     *     directory-specific semantics.
     */
    LetterDirectoryRecipient: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LetterDirectoryRecipientType;
      recipient: components['schemas']['LetterDirectoryRecipientDetails'];
    };
    /**
     * LetterDirectoryRecipientDetails
     * @description Directory recipient address and creation-time display snapshot.
     *
     *     ``directory_entry_id`` is required. ``email_address`` and ``fax_number`` are
     *     optional contact snapshots, but at least one must be present so a selected
     *     directory recipient always has a usable delivery channel.
     */
    LetterDirectoryRecipientDetails: {
      /** Practitioner Display */
      practitioner_display?: string | null;
      /** Organization Display */
      organization_display?: string | null;
      /** Specialty Display */
      specialty_display?: string | null;
      /** Location Display */
      location_display?: string | null;
      /** Email Address */
      email_address?: string | null;
      /** Fax Number */
      fax_number?: string | null;
      /** Directory Entry Id */
      directory_entry_id: string;
    };
    /**
     * LetterEditableStatus
     * @description Whether a letter is still editable by users.
     * @enum {string}
     */
    LetterEditableStatus: LetterEditableStatus;
    /**
     * LetterElectronicallySignedSignature
     * @description Discriminated wrapper for the electronic-signature variant.
     *
     *     Keeping the variant payload under ``properties`` mirrors the public API shape
     *     and leaves room for future variants with different property schemas.
     */
    LetterElectronicallySignedSignature: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LetterElectronicallySignedSignatureType;
      properties: components['schemas']['LetterElectronicallySignedSignatureProperties'];
    };
    /**
     * LetterElectronicallySignedSignatureProperties
     * @description Properties for an electronically signed letter signature.
     *
     *     ``signed_by`` is the clinician/session owner whose signature appears on the
     *     letter. ``applied_by`` is the authenticated user who clicked sign; this may
     *     differ from ``signed_by`` for helper/assistant/delegated workflows.
     *     Human-readable signature display text is intentionally not stored; clients
     *     should generate it from these fields and render ``signed_at`` in the viewer's
     *     local timezone.
     */
    LetterElectronicallySignedSignatureProperties: {
      /**
       * Signed At
       * Format: date-time
       */
      signed_at: string;
      signed_by: components['schemas']['LetterSignatureUser'];
      applied_by: components['schemas']['LetterSignatureUser'];
    };
    /**
     * LetterEmailRecipient
     * @description Discriminated wrapper for an email recipient.
     *
     *     The wrapper keeps the recipient channel explicit so validation, API
     *     serialization, and send logic can branch exhaustively on recipient type.
     */
    LetterEmailRecipient: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LetterEmailRecipientType;
      recipient: components['schemas']['LetterEmailRecipientDetails'];
    };
    /**
     * LetterEmailRecipientDetails
     * @description Direct email recipient address.
     *
     *     No display field is captured for direct email recipients in this
     *     implementation.
     */
    LetterEmailRecipientDetails: {
      /**
       * Email Address
       * Format: email
       */
      email_address: string;
    };
    /**
     * LetterFaxRecipient
     * @description Discriminated wrapper for a fax recipient.
     *
     *     The wrapper keeps the recipient channel explicit so validation, API
     *     serialization, and send logic can branch exhaustively on recipient type.
     */
    LetterFaxRecipient: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LetterFaxRecipientType;
      recipient: components['schemas']['LetterFaxRecipientDetails'];
    };
    /**
     * LetterFaxRecipientDetails
     * @description Fax recipient address and creation-time display snapshot.
     *
     *     ``fax_number`` is required and stored in E.164 format. Display snapshots
     *     are optional and can be supplied from recipient search so clients can render
     *     the selected recipient without re-querying the source.
     */
    LetterFaxRecipientDetails: {
      /** Practitioner Display */
      practitioner_display?: string | null;
      /** Organization Display */
      organization_display?: string | null;
      /** Specialty Display */
      specialty_display?: string | null;
      /** Location Display */
      location_display?: string | null;
      /**
       * Fax Number
       * Format: phone
       */
      fax_number: string;
    };
    /**
     * LetterListResponse
     * @description API representation of a session-scoped letter collection.
     */
    LetterListResponse: {
      /**
       * Letters
       * @description Letters for the session, ordered newest first by creation time.
       */
      letters: components['schemas']['LetterResponse'][];
    };
    /**
     * LetterResponse
     * @description API representation of a letter.
     */
    LetterResponse: {
      /**
       * Id
       * @description Letter ID serialized as a string.
       */
      id: string;
      /**
       * Session Id
       * @description Public session ID that owns the letter.
       */
      session_id: string;
      /**
       * Source Document Id
       * @description Source document ID serialized as a string.
       */
      source_document_id: string;
      /**
       * Name
       * @description Editable letter display name snapshotted from the source document name at creation. Null represents an absent or intentionally cleared name.
       */
      name?: string | null;
      /**
       * Letterhead Id
       * @description Creation-time snapshot of the inherited active letterhead ID, or null when no active organization letterhead was available.
       */
      letterhead_id?: string | null;
      /**
       * Body Content
       * @description Letter body content snapshotted at creation.
       */
      body_content: string;
      /**
       * Subject Line
       * @description Editable letter subject line derived at creation as '{letter_name} - {patient_display}' when both are available, otherwise from the single available value, and patchable after creation. Patient display comes from the embedded session patient first, then the linked patient profile. Null represents a deleted or intentionally absent subject line.
       */
      subject_line: string | null;
      /**
       * Message Body
       * @description Optional editable message body to include when sending the letter. Currently only supported for email sending. Null represents an absent or intentionally cleared message body.
       */
      message_body?: string | null;
      /** @description Stored letter body format. */
      content_type: components['schemas']['LetterContentType'];
      /**
       * Content Type Version
       * @description Letter content contract version. Currently only 1 is supported.
       */
      content_type_version: number;
      /**
       * Primary Recipient
       * @description Optional primary recipient the letter is configured to be sent to. Null when no primary recipient is configured. Sending is not performed by this endpoint.
       */
      primary_recipient?:
        | (
            | components['schemas']['LetterSealedMessageDeliveryRecipient']
            | components['schemas']['LetterEmailRecipient']
            | components['schemas']['LetterDirectoryRecipient']
            | components['schemas']['LetterFaxRecipient']
          )
        | null;
      /**
       * Copy Recipients
       * @description Copy recipients the letter is configured to be sent to in addition to the primary recipient. Defaults to an empty list. Capped at 50 entries.
       */
      copy_recipients?: (
        | components['schemas']['LetterSealedMessageDeliveryRecipient']
        | components['schemas']['LetterEmailRecipient']
        | components['schemas']['LetterDirectoryRecipient']
        | components['schemas']['LetterFaxRecipient']
      )[];
      /**
       * @description Whether the letter can still be edited. Sent letters are locked.
       * @default FREE
       */
      editable_status: components['schemas']['LetterEditableStatus'];
      /** @description Latest overall delivery state: SENT when every recipient has received the letter, PARTIALLY_SENT when at least one recipient has and at least one has not, FAILED when no recipient did in the latest attempt, or null before any persisted send attempt. */
      delivery_status?: components['schemas']['LetterDeliveryStatus'] | null;
      /** @description Latest persisted delivery state details, or null before any send attempt. This is a current snapshot; timeline events are the append-only history. Partial retries carry forward previously delivered recipients without sending them again. */
      delivery_details?: components['schemas']['LetterDeliveryDetails'] | null;
      /**
       * Signature
       * @description Signature applied to the letter, or null before signing.
       */
      signature?: components['schemas']['LetterElectronicallySignedSignature'] | null;
      /**
       * Created By
       * @description User ID of the letter creator.
       */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the letter was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the letter was last updated.
       */
      updated_at: string;
    };
    /**
     * LetterSealedMessageDeliveryRecipient
     * @description Discriminated wrapper for a sealed message delivery recipient.
     *
     *     The wrapper keeps the recipient channel explicit so validation, API
     *     serialization, and send logic can branch exhaustively on recipient type.
     */
    LetterSealedMessageDeliveryRecipient: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: LetterSealedMessageDeliveryRecipientType;
      recipient: components['schemas']['LetterSealedMessageDeliveryRecipientDetails'];
    };
    /**
     * LetterSealedMessageDeliveryRecipientDetails
     * @description Sealed message delivery recipient address and creation-time display snapshot.
     *
     *     ``endpoint_id`` is the only required field and is stored stripped of
     *     surrounding whitespace. Display snapshots are inherited from
     *     ``LetterRecipientDisplayFields``.
     */
    LetterSealedMessageDeliveryRecipientDetails: {
      /** Practitioner Display */
      practitioner_display?: string | null;
      /** Organization Display */
      organization_display?: string | null;
      /** Specialty Display */
      specialty_display?: string | null;
      /** Location Display */
      location_display?: string | null;
      /** Endpoint Id */
      endpoint_id: string;
      /** Practitioner Provider Number */
      practitioner_provider_number?: string | null;
    };
    /**
     * LetterSendRecipientDeliveryStatus
     * @description Per-recipient delivery outcome for a letter-send result.
     *
     *     Values feed overall ``LetterDeliveryStatus`` invariants: at least one
     *     ``SENT`` locks a successful or partial send, while all-unsent outcomes keep
     *     the letter editable as a failed attempt.
     * @enum {string}
     */
    LetterSendRecipientDeliveryStatus: LetterSendRecipientDeliveryStatus;
    /**
     * LetterSendRecipientResult
     * @description Delivery outcome for one configured letter recipient.
     *
     *     These records make the current delivery snapshot explainable to clients and
     *     are validated together to keep aggregate delivery state consistent.
     */
    LetterSendRecipientResult: {
      /** Recipient */
      recipient:
        | components['schemas']['LetterSealedMessageDeliveryRecipient']
        | components['schemas']['LetterEmailRecipient']
        | components['schemas']['LetterDirectoryRecipient']
        | components['schemas']['LetterFaxRecipient'];
      role: components['schemas']['LetterSendRecipientRole'];
      delivery_status: components['schemas']['LetterSendRecipientDeliveryStatus'];
    };
    /**
     * LetterSendRecipientRole
     * @description Configured recipient position for a letter-send result.
     *
     *     The role preserves whether a delivery outcome came from the primary
     *     recipient slot or from the copy-recipient list, which keeps latest delivery
     *     details aligned with the recipient configuration shown by clients.
     * @enum {string}
     */
    LetterSendRecipientRole: LetterSendRecipientRole;
    /**
     * LetterSendTimelineEventResponse
     * @description API representation of a letter-send timeline event.
     */
    LetterSendTimelineEventResponse: {
      /**
       * @description Timeline event discriminator for letter-send events. (enum property replaced by openapi-typescript)
       * @enum {string}
       */
      type: LetterSendTimelineEventResponseType;
      /** @description Per-recipient delivery outcomes. */
      send: components['schemas']['LetterSendTimelinePayload'];
    };
    /**
     * LetterSendTimelinePayload
     * @description Per-recipient delivery metadata stored on a letter-send timeline event.
     *
     *     ``recipient_results`` preserves the attempted recipient order. For a
     *     partially sent retry, recipients that were already delivered are omitted
     *     because they are not sent again.
     */
    LetterSendTimelinePayload: {
      /** Recipient Results */
      recipient_results: components['schemas']['LetterSendRecipientResult'][];
    };
    /**
     * LetterSignatureType
     * @description Supported signature variant discriminator values.
     *
     *     The string values are persisted and exposed through the public API response,
     *     so renaming an existing value would be a contract and data migration change.
     * @enum {string}
     */
    LetterSignatureType: LetterSignatureType;
    /**
     * LetterSignatureUser
     * @description Point-in-time user snapshot stored inside a letter signature.
     *
     *     Signatures should remain renderable even if a user later changes their name
     *     or account details. For that reason this model stores the stable user ID plus
     *     the name fields needed for display generation, rather than only storing a
     *     foreign-key-like user ID.
     */
    LetterSignatureUser: {
      /** User Id */
      user_id: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
    };
    /**
     * LetterTimelineActorResponse
     * @description Point-in-time actor snapshot for a letter timeline event.
     */
    LetterTimelineActorResponse: {
      /**
       * User Id
       * @description User ID snapshotted when the event occurred.
       */
      user_id: string;
      /**
       * Display Name
       * @description Display name snapshotted when the event occurred, if available.
       */
      display_name?: string | null;
      /**
       * Email
       * @description Email snapshotted when the event occurred, if available.
       */
      email?: string | null;
    };
    /**
     * LetterTimelineEventListResponse
     * @description API representation of a letter timeline event collection.
     */
    LetterTimelineEventListResponse: {
      /**
       * Events
       * @description Timeline events for the letter, ordered newest first by occurred_at with record ID as the deterministic tie-breaker.
       */
      events: components['schemas']['LetterTimelineEventRecordResponse'][];
    };
    /**
     * LetterTimelineEventRecordResponse
     * @description API representation of one persisted letter timeline event record.
     */
    LetterTimelineEventRecordResponse: {
      /**
       * Id
       * @description Timeline event record ID serialized as a string.
       */
      id: string;
      /**
       * Letter Id
       * @description Letter ID serialized as a string.
       */
      letter_id: string;
      /**
       * Occurred At
       * Format: date-time
       * @description Timestamp when the timeline event occurred.
       */
      occurred_at: string;
      /** @description Point-in-time actor snapshot for the event. */
      actor: components['schemas']['LetterTimelineActorResponse'];
      /**
       * Event
       * @description Discriminated timeline event payload.
       */
      event:
        | components['schemas']['LetterContentSnapshotTimelineEventResponse']
        | components['schemas']['LetterSendTimelineEventResponse'];
    };
    /** LetterheadListResponse */
    LetterheadListResponse: {
      /**
       * Letterheads
       * @description Letterheads visible to internal admins.
       */
      letterheads: components['schemas']['LetterheadResponse'][];
    };
    /**
     * LetterheadPreviewResponse
     * @description Renderable asset reference for a letter's inherited letterhead.
     */
    LetterheadPreviewResponse: {
      /**
       * Letterhead Id
       * @description Letterhead ID snapshotted by the letter at creation time.
       */
      letterhead_id: string;
      /**
       * Preview Url
       * Format: uri
       * @description Short-lived presigned URL for frontend letterhead rendering.
       */
      preview_url: string;
    };
    /** LetterheadPreviewUrlResponse */
    LetterheadPreviewUrlResponse: {
      /**
       * Letterhead Id
       * @description Letterhead record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      letterhead_id: string;
      /**
       * Preview Url
       * Format: uri
       * @description Short-lived presigned URL for internal admin preview.
       */
      preview_url: string;
    };
    /** LetterheadResponse */
    LetterheadResponse: {
      /**
       * Id
       * @description Letterhead record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Organization Id
       * @description Organization that owns this letterhead.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      organization_id: string;
      /**
       * Display Name
       * @description Internal admin-facing display name.
       */
      display_name: string;
      /**
       * Original Filename
       * @description Filename supplied by the uploader.
       */
      original_filename: string;
      /**
       * Content Type
       * @description Validated MIME type of the uploaded asset.
       */
      content_type: string;
      /**
       * Size Bytes
       * @description Uploaded asset size in bytes.
       */
      size_bytes: number;
      /** @description Lifecycle status: DRAFT is available but not selected, ACTIVE is the organization default, ARCHIVED is retired. */
      status: components['schemas']['LetterheadStatus'];
      /**
       * Asset Key
       * @description Private S3 object key; not directly fetchable by clients.
       */
      asset_key: string;
      /**
       * Created By
       * @description Internal admin user ID that uploaded the letterhead.
       */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       * @description Timestamp when the letterhead metadata was created.
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Timestamp when the letterhead metadata was last updated.
       */
      updated_at: string;
    };
    /**
     * LetterheadStatus
     * @description Lifecycle status for organization letterheads.
     *
     *     DRAFT letterheads are uploaded and available to internal admins but are not
     *     selected for new letters. ACTIVE letterheads are the current organization
     *     default for new letters; at most one letterhead per organization may be
     *     ACTIVE. ARCHIVED letterheads are retired, hidden from default list results,
     *     and cannot be selected for future letters.
     * @enum {string}
     */
    LetterheadStatus: LetterheadStatus;
    /**
     * LevelOfDetail
     * @enum {string}
     */
    LevelOfDetail: LevelOfDetail;
    /**
     * LikeResponse
     * @description Response for like/unlike operations.
     */
    LikeResponse: {
      /** Liked */
      liked: boolean;
      /** Likes Count */
      likes_count: number;
    };
    /**
     * LikeStatusResponse
     * @description Response for checking like status.
     */
    LikeStatusResponse: {
      /** Liked */
      liked: boolean;
    };
    /** LimitAssignmentResponse */
    LimitAssignmentResponse: {
      /** Id */
      id: string;
      /**
       * Scope Type
       * @enum {string}
       */
      scope_type: LimitAssignmentResponseScope_type;
      /** Scope Id */
      scope_id: string | null;
      /** Limit Key */
      limit_key: string;
      /** Metric Key */
      metric_key: string;
      /**
       * Mode
       * @enum {string}
       */
      mode: LimitAssignmentResponseMode;
      /** Starts At */
      starts_at: string | null;
      /** Expires At */
      expires_at: string | null;
      /** Is Active */
      is_active: boolean;
      /** Created By */
      created_by: string;
      /** Reason */
      reason: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Warnings */
      warnings?: string[];
    };
    /**
     * LimitResponse
     * @description Wire shape for a **named limit** (create + per-meter list).
     */
    LimitResponse: {
      /** Limit Key */
      limit_key: string;
      /** Metric Key */
      metric_key: string;
      /** Description */
      description?: string | null;
      /**
       * Period
       * @enum {string}
       */
      period: LimitResponsePeriod;
      /**
       * Enforcement Mode
       * @enum {string}
       */
      enforcement_mode: LimitResponseEnforcement_mode;
      /** Plan Limits */
      plan_limits: {
        [key: string]: number | null;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * LinearIssueLookup
     * @description Preview of a Linear issue returned by the lookup endpoint.
     */
    LinearIssueLookup: {
      /** Id */
      id: string;
      /** Identifier */
      identifier: string;
      /** Title */
      title: string;
      /** Status */
      status?: string | null;
      /** Team */
      team?: string | null;
      /** Assignee */
      assignee?: string | null;
      /** Url */
      url?: string | null;
      /** Description */
      description?: string | null;
    };
    /** LinkClinicalTaskRequest */
    LinkClinicalTaskRequest: {
      link: components['schemas']['ClinicalTaskLink'];
    };
    /** LinkClinicalTaskResponse */
    LinkClinicalTaskResponse: {
      task: components['schemas']['ClinicalTaskView'];
      link_info: components['schemas']['ClinicalTaskLinkInfo'];
    };
    /** LinkHardwareDeviceRequest */
    LinkHardwareDeviceRequest: {
      /** Serial Number */
      serial_number?: string | null;
      /**
       * Device Id
       * @deprecated
       */
      device_id?: string | null;
      /** Device Name */
      device_name: string;
      /** Device Model */
      device_model: string;
      /** Firmware Version */
      firmware_version: string;
    };
    /** LinkHeidiAccountRequest */
    LinkHeidiAccountRequest: {
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** Email */
      email?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /** LinkHeidiAccountResponse */
    LinkHeidiAccountResponse: {
      account: components['schemas']['OpenAPILinkedAccount'];
    };
    /** LinkMergedSessionsRequest */
    LinkMergedSessionsRequest: {
      /**
       * Session Ids
       * @description Session ids to add to the merge group
       */
      session_ids: string[];
    };
    /** LinkMergedSessionsResponse */
    LinkMergedSessionsResponse: {
      /** @description Updated merge group after linking the sessions */
      session_merge_group?: components['schemas']['MergeableSessions'];
    };
    /**
     * LinkMeterRequest
     * @description HTTP body for `POST /metrics/{metric_key}/meter` — *bind* an existing
     *     Stripe Billing meter to a metric (make it billable).
     *
     *     Admins author the Stripe meter in the Stripe dashboard (the source of
     *     truth for fidelity + audit); this binds it by id. The service retrieves
     *     the meter and validates it is active and its aggregation is `sum`,
     *     capturing `event_name` from Stripe (not client-supplied, so the binding
     *     can never disagree with Stripe). No Stripe objects are created, and **no
     *     price is bound** — the price is supplied per customer at enrol.
     */
    LinkMeterRequest: {
      /** Stripe Meter Id */
      stripe_meter_id: string;
    };
    /** LinkPatientSessionsRequest */
    LinkPatientSessionsRequest: {
      /** Session Ids */
      session_ids: string[];
    };
    /** LinkPatientSessionsResponse */
    LinkPatientSessionsResponse: {
      /** Data */
      data: components['schemas']['MinimumSessionView'][];
    };
    /**
     * LinkShareDocumentView
     * @description A shared-session document plus a presigned URL to its filled PDF.
     *
     *     The URL is populated only for PDF/form documents. Kept on this link-share
     *     subclass rather than the base ``DocumentView`` so the PHI-bearing URL can
     *     never be populated on the app's other document serialization paths.
     */
    LinkShareDocumentView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /** Creator Kinde Id */
      creator_kinde_id?: string | null;
      /** Index */
      index?: number | null;
      /** @default DOCUMENT */
      document_tab_type: components['schemas']['DocumentTabType'] | null;
      /** Name */
      name?: string | null;
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Question */
      question?: string | null;
      /** Content */
      content?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      generation_type?: components['schemas']['DocumentGenType'] | null;
      /** @default LEFT */
      brain: components['schemas']['Brain'];
      voice_style?: components['schemas']['VoiceStyle'] | null;
      content_type?: components['schemas']['ContentType'] | null;
      /** Generation Time */
      generation_time?: string | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
      /** Filled Pdf Url */
      filled_pdf_url?: string | null;
    };
    /**
     * LinkShareRecipientInput
     * @description A single recipient to add to a link share.
     */
    LinkShareRecipientInput: {
      /**
       * Email
       * Format: email
       * @description Recipient email address
       */
      email: string;
      /** @description Optional scope override for this recipient */
      scope_override?: components['schemas']['SharedSessionScope'] | null;
    };
    /**
     * LinkShareRecipientResponse
     * @description Response model for a single link share recipient.
     */
    LinkShareRecipientResponse: {
      /** Email */
      email: string;
      /** Share Token */
      share_token: string;
      scope_override?: components['schemas']['SharedSessionScope'] | null;
      effective_scope: components['schemas']['SharedSessionScope'];
      /** Share Url */
      share_url: string;
      /**
       * Added At
       * Format: date-time
       */
      added_at: string;
      status: components['schemas']['LinkShareRecipientStatus'];
      /**
       * Otp Verified
       * @default false
       */
      otp_verified: boolean;
      /**
       * Access Count
       * @default 0
       */
      access_count: number;
      /** Last Accessed At */
      last_accessed_at?: string | null;
    };
    /**
     * LinkShareRecipientStatus
     * @enum {string}
     */
    LinkShareRecipientStatus: LinkShareRecipientStatus;
    /**
     * LinkShareTTL
     * @description Time-to-live choices for a link share.
     *
     *     A ``StrEnum`` (not a ``Literal``) so it can serve as a settings-catalog
     *     ``value_type``, which must be a real class.
     * @enum {string}
     */
    LinkShareTTL: LinkShareTTL;
    /** LinkSharedDocumentsResponse */
    LinkSharedDocumentsResponse: {
      /** Documents */
      documents: components['schemas']['LinkShareDocumentView'][];
    };
    /** LinkSharedSessionResponse */
    LinkSharedSessionResponse: {
      session: components['schemas']['SimpleSessionViewV2'];
      scope: components['schemas']['SharedSessionScope'];
      /** Sharer Display Name */
      sharer_display_name?: string | null;
      /** Sharer Profile Picture Url */
      sharer_profile_picture_url?: string | null;
      /** Clinician Notes */
      clinician_notes?: string | null;
      /** Consult Notes */
      consult_notes?: components['schemas']['SimpleConsultNoteView'][] | null;
    };
    /**
     * LinkType
     * @description The type of link between this patient resource and another patient resource.
     *
     *     https://hl7.org/fhir/R4/valueset-link-type.html
     * @enum {string}
     */
    LinkType: LinkType;
    /** LinkedAccount */
    LinkedAccount: {
      /** User Id */
      user_id: string;
      /** Ehr Provider */
      ehr_provider: string;
      /** Ehr Email */
      ehr_email: string;
      /** Ehr User Id */
      ehr_user_id: string;
    };
    /**
     * LinkedSectionContent
     * @description Model for section content that is linked to an EHR section
     */
    LinkedSectionContent: {
      /**
       * Content
       * @description The actual content of the section
       */
      content: string;
      /**
       * Linked Ehr Section Id
       * @description The EHR section ID this content is linked to
       */
      linked_ehr_section_id: string;
    };
    /** ListActiveUserUsageResponse */
    ListActiveUserUsageResponse: {
      /** Active User Usages */
      active_user_usages: components['schemas']['ActiveUserUsage'][];
      /** Total Pages */
      total_pages: number;
    };
    /** ListAdCampaignsResponse */
    ListAdCampaignsResponse: {
      /**
       * Campaigns
       * @description Campaigns on this page, most recently updated first.
       */
      campaigns: components['schemas']['AdCampaignListItemResponse'][];
      /**
       * Total
       * @description Total campaigns matching the filters.
       */
      total: number;
      /**
       * Page
       * @description Current page number (1-based).
       */
      page: number;
      /**
       * Page Size
       * @description Number of campaigns per page.
       */
      page_size: number;
    };
    /** ListAdResourcesResponse */
    ListAdResourcesResponse: {
      /**
       * Ad Resources
       * @description Ad resources on this page, newest first.
       */
      ad_resources: components['schemas']['AdResourceListItemResponse'][];
      /**
       * Total
       * @description Total ad resources matching the filters.
       */
      total: number;
      /**
       * Page
       * @description Current page number (1-based).
       */
      page: number;
      /**
       * Page Size
       * @description Number of ad resources per page.
       */
      page_size: number;
    };
    /** ListAdvertisersResponse */
    ListAdvertisersResponse: {
      /**
       * Advertisers
       * @description Advertisers on this page, most recently updated first.
       */
      advertisers: components['schemas']['AdvertiserListItemResponse'][];
      /**
       * Total
       * @description Total advertisers matching the filters.
       */
      total: number;
      /**
       * Page
       * @description Current page number (1-based).
       */
      page: number;
      /**
       * Page Size
       * @description Number of advertisers per page.
       */
      page_size: number;
    };
    /** ListAgentMemoriesResponse */
    ListAgentMemoriesResponse: {
      /** Memories */
      memories: components['schemas']['AgentMemoryView'][];
      /** Total */
      total: number;
      /** Skip */
      skip: number;
      /** Limit */
      limit: number;
    };
    /** ListBackupAudiosResponse */
    ListBackupAudiosResponse: {
      /** Backup Audios */
      backup_audios: components['schemas']['AccessRestrictedBackupAudio'][];
    };
    /** ListConfigsResponse */
    ListConfigsResponse: {
      /** Configs */
      configs: components['schemas']['AgentConfigResponse'][];
      /** Total */
      total: number;
    };
    /** ListDirectIntegrationSessionsByUserResponse */
    ListDirectIntegrationSessionsByUserResponse: {
      /** Sessions */
      sessions: components['schemas']['SimpleSessionViewV2'][];
      /** Total Pages */
      total_pages: number;
    };
    /** ListEventRulesResponse */
    ListEventRulesResponse: {
      /** Rules */
      rules: components['schemas']['pkg__event_triggers__schemas__EventRuleResponse'][];
      /** Total */
      total: number;
    };
    /** ListIntegrationAgentsResponse */
    ListIntegrationAgentsResponse: {
      /** Agents */
      agents: components['schemas']['IntegrationAgentPublic'][];
    };
    /** ListIntegrationPartnerAdminResponse */
    ListIntegrationPartnerAdminResponse: {
      /** Admin Records */
      admin_records: components['schemas']['IntegrationPartnerAdmin'][];
      /** Total Pages */
      total_pages: number;
    };
    /** ListLetterTemplatesResponse */
    ListLetterTemplatesResponse: {
      /** Templates */
      templates: components['schemas']['DocumentTemplate'][];
    };
    /**
     * ListMode
     * @description The processing mode that applies to a list/section.
     *
     *     Used for ``Composition.section.mode`` (Required binding).
     *
     *     https://hl7.org/fhir/R4/valueset-list-mode.html
     * @enum {string}
     */
    ListMode: ListMode;
    /** ListOpenAPILinkedUsersResponse */
    ListOpenAPILinkedUsersResponse: {
      /** Linked Users */
      linked_users: components['schemas']['LinkedAccount'][];
      /** Total Pages */
      total_pages: number;
    };
    /** ListOpenAPIOrgnizationsResponse */
    ListOpenAPIOrgnizationsResponse: {
      /** Open Api Orgnizations */
      open_api_orgnizations: components['schemas']['OpenAPIOrganization'][];
      /** Total Pages */
      total_pages: number;
    };
    /** ListOrdersMeta */
    ListOrdersMeta: {
      /** Total */
      total: number;
      /** Offset */
      offset: number;
      /** Limit */
      limit: number;
    };
    /** ListOrdersResponse */
    ListOrdersResponse: {
      /** Data */
      data: components['schemas']['OrderListItem'][];
      /** @description Pagination metadata */
      meta: components['schemas']['ListOrdersMeta'];
    };
    /**
     * ListOrganizationResponse
     * @description Response schema for listing organizations.
     */
    ListOrganizationResponse: {
      /** Organizations */
      organizations: components['schemas']['OrganizationView'][];
      /** Total */
      total: number;
    };
    /** ListRunsResponse */
    ListRunsResponse: {
      /** Runs */
      runs: components['schemas']['AgentRunResponse'][];
      /** Total */
      total: number;
    };
    /**
     * ListSSOResponse
     * @description Response model for listing SSO connections.
     */
    ListSSOResponse: {
      /** Connections */
      connections: components['schemas']['SSOConnection'][];
    };
    /** ListSchedulesResponse */
    ListSchedulesResponse: {
      /** Schedules */
      schedules: components['schemas']['AgentScheduleResponse'][];
      /** Total */
      total: number;
    };
    /** ListSendOutsMeta */
    ListSendOutsMeta: {
      /** Total */
      total: number;
      /** Offset */
      offset: number;
      /** Limit */
      limit: number;
    };
    /** ListSendOutsResponse */
    ListSendOutsResponse: {
      /** Data */
      data: components['schemas']['SendOutView'][];
      /** @description Pagination metadata */
      meta: components['schemas']['ListSendOutsMeta'];
    };
    /** ListStockItemsMeta */
    ListStockItemsMeta: {
      /** Total */
      total: number;
      /** Offset */
      offset: number;
      /** Limit */
      limit: number;
    };
    /** ListStockItemsResponse */
    ListStockItemsResponse: {
      /** Data */
      data: components['schemas']['StockItemView'][];
      /** @description Pagination metadata */
      meta: components['schemas']['ListStockItemsMeta'];
    };
    /** ListTeamShortcutsResponse */
    ListTeamShortcutsResponse: {
      /** Shortcuts */
      shortcuts?: components['schemas']['TeamShortcutSchema'][];
    };
    /** ListToolApprovalsResponse */
    ListToolApprovalsResponse: {
      /** Approvals */
      approvals: components['schemas']['ToolApprovalRequestPublic'][];
    };
    /**
     * ListUsersResponse
     * @description Response schema for user search results.
     */
    ListUsersResponse: {
      /**
       * Users
       * @description List of users matching the search criteria
       */
      users?: components['schemas']['InternalAdminListUserView'][];
      /**
       * Total
       * @description Total number of users matching the search criteria
       * @default 0
       */
      total: number;
      /**
       * Page
       * @description Current page number
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @description Number of users per page
       * @default 20
       */
      page_size: number;
    };
    /** ListUsersWithDirectIntegrationResponse */
    ListUsersWithDirectIntegrationResponse: {
      /** Ehr Profiles */
      ehr_profiles: components['schemas']['EHRProfile'][];
      /** Total Pages */
      total_pages: number;
    };
    /** ListWorkflowsResponse */
    ListWorkflowsResponse: {
      /** Executions */
      executions: components['schemas']['WorkflowSummary'][];
      /**
       * Truncated
       * @default false
       */
      truncated: boolean;
    };
    /** ListWorkspaceInvitationsResponse */
    ListWorkspaceInvitationsResponse: {
      /** Invitations */
      invitations: components['schemas']['WorkspaceInvitationView'][];
    };
    /**
     * ListWorkspaceMembersResponse
     * @description Response schema for the paginated workspace-members list.
     */
    ListWorkspaceMembersResponse: {
      /** Members */
      members?: components['schemas']['WorkspaceMemberView'][];
      /**
       * Total
       * @description Total live members of the workspace
       * @default 0
       */
      total: number;
      /**
       * Page
       * @description Current page number
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @description Number of members per page
       * @default 20
       */
      page_size: number;
    };
    /** LiveDictationRequest */
    LiveDictationRequest: {
      /** Dictation Content */
      dictation_content: string;
      /** Preceding Text */
      preceding_text?: string | null;
    };
    /**
     * LiveRecordingStatus
     * @enum {string}
     */
    LiveRecordingStatus: LiveRecordingStatus;
    /** LiveTranscriptResponse */
    LiveTranscriptResponse: {
      /** User Uploaded */
      user_uploaded?: components['schemas']['ChunkedRecordingWithTranscript'][];
      /** Live */
      live?: components['schemas']['ChunkedRecordingWithTranscript'][];
      /** Backup */
      backup?: components['schemas']['ChunkedRecordingWithTranscript'][];
      transcript_in_use?: components['schemas']['TranscriptInUse'] | null;
      /** Transcript */
      transcript?: string | null;
    };
    /**
     * LocalStorageChatMessageRequest
     * @description Single message for a chat being migrated from localStorage.
     *
     *     Matches ChatMessageResponse shape: role, content, message_id, mode, metadata
     *     (full rendering subset), attachments (if any), optionally timestamp.
     */
    LocalStorageChatMessageRequest: {
      /**
       * Role
       * @description Message role (user or assistant only)
       * @enum {string}
       */
      role: LocalStorageChatMessageRequestRole;
      /**
       * Content
       * @description Message content
       */
      content: string;
      /**
       * Message Id
       * @description Client message ID (preserved for same rendering)
       */
      message_id?: string | null;
      /**
       * Timestamp
       * @description Message timestamp (optional)
       */
      timestamp?: string | null;
      /** @description Rendering metadata: sources, web_search_query, reasoning, thinking, thinking_duration_ms, annotations, additional_metadata, structured_citations */
      metadata?: components['schemas']['ChatMessageMetadataResponse'] | null;
      /** @description Mode used for this message (e.g. evidence, legacy) */
      mode?: components['schemas']['ChatMode'] | null;
      /** @description Original mode before classification (e.g. auto) */
      original_mode?: components['schemas']['ChatMode'] | null;
      /**
       * Attachments
       * @description Message attachments (if any)
       */
      attachments?: components['schemas']['ChatMessageAttachmentResponse'][] | null;
      /**
       * Message Mac
       * @description HMAC-SHA256 integrity signature for assistant messages (SEC-340). Required for assistant messages when secure migration is enabled.
       */
      message_mac?: string | null;
    };
    /**
     * LocalStorageChatRequest
     * @description One chat to store from localStorage.
     *
     *     Minimal ChatResponse shape: title, messages, updated_at, session_id?,
     *     patient_profile_id?, mode?, is_saved, completion_in_progress: false, created_at?.
     */
    LocalStorageChatRequest: {
      /**
       * Id
       * @description Client/temp chat ID (ignored on create; new ID returned)
       */
      id?: string | null;
      /**
       * Title
       * @description Chat title
       */
      title: string;
      /** Messages */
      messages: components['schemas']['LocalStorageChatMessageRequest'][];
      /**
       * Updated At
       * @description Last updated (ISO string)
       */
      updated_at?: string | null;
      /**
       * Session Id
       * @description Session ID if in-session
       */
      session_id?: string | null;
      /**
       * Patient Profile Id
       * @description Patient profile ID if linked
       */
      patient_profile_id?: string | null;
      /** @description Chat mode */
      mode?: components['schemas']['ChatMode'] | null;
      /**
       * Is Saved
       * @description Whether chat is saved/starred
       * @default false
       */
      is_saved: boolean;
      /**
       * Completion In Progress
       * @description Always false for migrated chats
       * @default false
       */
      completion_in_progress: boolean;
      /**
       * Created At
       * @description Created at (ISO string)
       */
      created_at?: string | null;
    };
    /**
     * Location
     * @description Details and position information for a physical place.
     *
     *     Details and position information for a physical place where services are
     *     provided and resources and participants may be stored, found, contained, or
     *     accommodated.
     *
     *     https://hl7.org/fhir/R4/location-definitions.html
     */
    Location: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Unique code or number identifying the location to its users */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * active | suspended | inactive
       * @description The status property covers the general availability of the resource, not the current value which may be covered by the operationStatus, or by a schedule/slots if they are configured for the location.
       */
      status?: components['schemas']['LocationStatus'] | null;
      /**
       * The operational status of the location (typically only for a bed/room)
       * @description The operational status covers operation values most relevant to beds (but can also apply to rooms/units/chairs/etc. such as an isolation unit/dialysis chair).
       */
      operationalStatus?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding']
        | null;
      /**
       * Name of the location as used by humans
       * @description Name of the location as used by humans. Does not need to be unique.
       */
      name?: string | null;
      /** A list of alternate names that the location is known as, or was known as, in the past */
      alias?: string[] | null;
      /**
       * Additional details about the location that could be displayed as further information to identify the location beyond its name
       * @description Description of the Location, which helps in finding or referencing the place.
       */
      description?: string | null;
      /**
       * instance | kind
       * @description Indicates whether a resource instance represents a specific location or a class of locations.
       */
      mode?: components['schemas']['LocationMode'] | null;
      /**
       * Type of function performed
       * @description Indicates the type of function performed at the location.
       */
      type?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Contact details of the location
       * @description The contact details of communication devices available at the location. This can include phone numbers, fax numbers, mobile numbers, email addresses and web sites.
       */
      telecom?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint'][]
        | null;
      /** Physical location */
      address?: components['schemas']['Address'] | null;
      /**
       * Physical form of the location
       * @description Physical form of the location, e.g. building, room, vehicle, road.
       */
      physicalType?: components['schemas']['CodeableConcept'] | null;
      /**
       * The absolute geographic location
       * @description The absolute geographic location of the Location, expressed using the WGS84 datum (This is the same co-ordinate system used in KML).
       */
      position?: components['schemas']['LocationPosition'] | null;
      /**
       * Organization responsible for provisioning and upkeep
       * @description The organization responsible for the provisioning and upkeep of the location.
       */
      managingOrganization?: components['schemas']['Reference'] | null;
      /**
       * Another Location this one is physically a part of
       * @description Another Location of which this Location is physically a part of.
       */
      partOf?: components['schemas']['Reference'] | null;
    };
    /**
     * LocationInfo
     * @description Geo-IP fields forwarded from Auth0's ``location_info`` block.
     *
     *     Every field is optional because Auth0 occasionally omits parts of the
     *     geoip block (anonymising proxies, missing data). Callers should not
     *     assume any field is populated.
     */
    LocationInfo: {
      /**
       * City Name
       * @description City name resolved from the source IP, e.g. 'Sydney'.
       */
      city_name?: string | null;
      /**
       * Country Code
       * @description ISO-3166 alpha-2 country code, e.g. 'AU'.
       */
      country_code?: string | null;
      /**
       * Country Name
       * @description Country name in English, e.g. 'Australia'.
       */
      country_name?: string | null;
      /**
       * Time Zone
       * @description IANA timezone name resolved from the source IP, e.g. 'Australia/Sydney'. Used to render the email's date/time in the location where the change actually occurred.
       */
      time_zone?: string | null;
    };
    /**
     * LocationMode
     * @description Indicates whether a resource instance represents a specific location or a class of locations.
     *
     *     https://hl7.org/fhir/R4/valueset-location-mode.html
     * @enum {string}
     */
    LocationMode: LocationMode;
    /**
     * LocationParams
     * @description Maximal R4 Location search (direct + ``location.*`` chains).
     *
     *     Superset of chain suffixes for generic FHIR ingress. Provider models are
     *     import-time validated against this contract and declare supported fields only.
     *
     *     All string parameters use **case-insensitive substring matching** per the
     *     FHIR ``string`` search type (https://hl7.org/fhir/R4/search.html#string).
     *     The ``status`` parameter uses exact token matching.
     *
     *     https://hl7.org/fhir/R4/location.html#search
     */
    LocationParams: {
      /**
       * Elements
       * @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements
       */
      _elements?: string[] | string | null;
      /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
      _summary?: components['schemas']['SummaryParameter'] | null;
      /**
       * Name
       * @description A portion of the location's name or alias (case-insensitive substring match)
       */
      name?: string | null;
      /**
       * Address
       * @description A (part of the) address of the location — matches against street, city, and postal code (case-insensitive substring match)
       */
      address?: string | null;
      /**
       * Address-City
       * @description A city specified in an address (case-insensitive substring match)
       */
      'address-city'?: string | null;
      /**
       * Address-State
       * @description A state specified in an address (case-insensitive substring match)
       */
      'address-state'?: string | null;
      /**
       * Address-Postalcode
       * @description A postal code specified in an address (case-insensitive substring match)
       */
      'address-postalcode'?: string | null;
      /**
       * Address-Country
       * @description A country specified in an address (case-insensitive substring match)
       */
      'address-country'?: string | null;
      /** @description Searches for locations with a specific kind of status (exact token match) */
      status?: components['schemas']['LocationStatus'] | null;
    };
    /**
     * LocationPosition
     * @description The absolute geographic location of the Location.
     *
     *     https://hl7.org/fhir/R4/location-definitions.html#Location.position
     */
    LocationPosition: {
      /**
       * Longitude with WGS84 datum
       * @description Longitude. The value domain and the interpretation are the same as for the text of the longitude element in KML.
       */
      longitude: number;
      /**
       * Latitude with WGS84 datum
       * @description Latitude. The value domain and the interpretation are the same as for the text of the latitude element in KML.
       */
      latitude: number;
      /**
       * Altitude with WGS84 datum
       * @description Altitude. The value domain and the interpretation are the same as for the text of the altitude element in KML.
       */
      altitude?: number | null;
    };
    /**
     * LocationStatus
     * @description Indicates whether the location is still in use.
     *
     *     https://hl7.org/fhir/R4/valueset-location-status.html
     * @enum {string}
     */
    LocationStatus: LocationStatus;
    /**
     * LogApiStatusCheckRequest
     * @description Body submitted by the frontend after running an API status check.
     */
    LogApiStatusCheckRequest: {
      /**
       * Results
       * @description Per-domain results from the most recent status check.
       */
      results: components['schemas']['DomainCheckResult'][];
    };
    /** LogApiStatusCheckResponse */
    LogApiStatusCheckResponse: {
      /** Success */
      success: boolean;
      /** Log Id */
      log_id: string;
    };
    /** LogDebugEventRequest */
    LogDebugEventRequest: {
      /** Chatsessionid */
      chatSessionId?: string | null;
      /** Messageid */
      messageId?: string | null;
      type: components['schemas']['DebugEventType'];
      /** Message */
      message: string;
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      } | null;
      severity: components['schemas']['DebugEventSeverity'];
    };
    /**
     * LogDiagnosticsRequest
     * @description Privacy-safe client SDK diagnostics submitted after authenticated startup.
     */
    LogDiagnosticsRequest: {
      /**
       * Report Version
       * @constant
       */
      report_version: 1;
      /** Webview Origin */
      webview_origin: string;
      /** Page Path */
      page_path: string;
      flagsmith: components['schemas']['FlagsmithDiagnostics'];
      datadog: components['schemas']['DatadogDiagnostics'];
      build: components['schemas']['ClientBuildDiagnostics'];
    };
    /** LogDiagnosticsResponse */
    LogDiagnosticsResponse: {
      /** Success */
      success: boolean;
    };
    /**
     * LogEventData
     * @description The event content nested under each entry's ``data`` key.
     *
     *     The dispatcher reads ``type`` to route to the right handler, then
     *     consumes the fields each handler needs. Unrecognised fields are
     *     silently ignored so Auth0 schema additions don't break this
     *     endpoint.
     */
    LogEventData: {
      /**
       * Date
       * Format: date-time
       * @description ISO-8601 timestamp of the event.
       */
      date: string;
      /**
       * Type
       * @description Auth0 event code, e.g. ``scp``.
       */
      type: string;
      /**
       * User Id
       * @description Auth0 sub (e.g. ``auth0|abc123``). Required for handled types.
       */
      user_id?: string | null;
      /** Ip */
      ip?: string | null;
      /** User Agent */
      user_agent?: string | null;
      location_info?: components['schemas']['LogLocationInfo'] | null;
      /** Description */
      description?: string | null;
      /** Connection */
      connection?: string | null;
    };
    /**
     * LogEventEntry
     * @description A single Auth0 webhook envelope: ``{log_id, data: {...event...}}``.
     *
     *     See the module docstring for why the event content is nested under
     *     ``data`` instead of flat on the envelope.
     */
    LogEventEntry: {
      /**
       * Log Id
       * @description Unique Auth0 log event id; echoed in error logs.
       */
      log_id: string;
      /** @description The actual tenant log content (date, type, user_id, etc.). */
      data: components['schemas']['LogEventData'];
    };
    /**
     * LogEventsResponse
     * @description Acknowledgement payload for a batched ingestion request.
     *
     *     The endpoint runs per-entry work in the background, so per-entry
     *     outcomes (dispatched / dropped / failed) cannot be known at the
     *     time the response is sent. They are emitted as structured log
     *     lines and counted in the ``auth_notification.dispatch`` OpenTelemetry
     *     counter (one tag per outcome value) by the dispatcher instead.
     *
     *     Only the batch ``received`` count is returned. Auth0 ignores
     *     response bodies on log-stream HTTP sinks, so this field exists
     *     purely for tests and manual debugging.
     */
    LogEventsResponse: {
      /**
       * Received
       * @description Number of log entries in the batch.
       */
      received: number;
    };
    /** LogFullValueResponse */
    LogFullValueResponse: {
      /** Experiment Id */
      experiment_id: string;
      /** Entry Index */
      entry_index: number;
      /** Full Values */
      full_values: {
        [key: string]: unknown;
      };
    };
    /**
     * LogLocationInfo
     * @description Auth0 ``location_info`` block — geo-IP enrichment.
     *
     *     Every field is optional because Auth0 occasionally omits parts of
     *     geoip (anonymising proxies, missing data). Callers should not assume
     *     any field is populated.
     */
    LogLocationInfo: {
      /** City Name */
      city_name?: string | null;
      /** Country Code */
      country_code?: string | null;
      /** Country Name */
      country_name?: string | null;
      /** Time Zone */
      time_zone?: string | null;
    };
    /**
     * LoginFromNewDeviceIngestionRequest
     * @description Body POSTed by the scribe-fe-v2 web middleware on a web login.
     *
     *     Unlike the Auth0 log-stream batch, this is a single event carrying the
     *     authenticated identity (``auth0_user_id``) and the first-party device
     *     cookie (``device_id``) the FE already holds — so the broker resolves
     *     identity from its own ``IdentityProfileDO`` with no Auth0 Management
     *     API call. Geo / user-agent are display context for the email, not
     *     matched on.
     */
    LoginFromNewDeviceIngestionRequest: {
      /**
       * Auth0 User Id
       * @description Auth0 sub (e.g. ``auth0|abc123``) from the FE session.
       */
      auth0_user_id: string;
      /**
       * Device Id
       * @description Opaque UUID from the first-party ``heidi_device_id`` cookie.
       */
      device_id: string;
      /**
       * Ip
       * @description Client IP captured at login.
       */
      ip: string;
      /**
       * Occurred At
       * Format: date-time
       * @description ISO-8601 timestamp of the login.
       */
      occurred_at: string;
      /** User Agent */
      user_agent?: string | null;
      /** Country Code */
      country_code?: string | null;
      /** Country Name */
      country_name?: string | null;
      /** City Name */
      city_name?: string | null;
      /** Time Zone */
      time_zone?: string | null;
    };
    /**
     * LoginFromNewDeviceIngestionResponse
     * @description Acknowledgement for a login-from-new-device ingestion request.
     *
     *     ``outcome`` is an opaque observability string (mirrors the dispatcher
     *     outcome taxonomy), not part of any public contract — the FE calls this
     *     fire-and-forget. Returned so tests and the FE's optional logging can
     *     see what the broker decided.
     */
    LoginFromNewDeviceIngestionResponse: {
      /**
       * Outcome
       * @description One of: identity_unresolved, known_device, recorded_silent_warmup, recorded_silent_first_device, forwarded, forward_failed, client_unconfigured.
       */
      outcome: string;
    };
    /**
     * LoginFromNewDeviceRequest
     * @description Forwarded login-from-new-device event payload. Sibling of the MFA
     *     request schemas — identical shape.
     *
     *     The broker decides device novelty (via its ``known_login_device``
     *     collection) before forwarding, so this endpoint receives only logins
     *     that are genuinely from a new device. ``device_id`` itself is not
     *     forwarded — the regional endpoint only needs the User-facing display
     *     fields to render the email.
     */
    LoginFromNewDeviceRequest: {
      /**
       * User Ref Id
       * @description Global unique identifier for the user (UUID7).
       * @example 01912345-6789-7abc-def0-123456789abc
       */
      user_ref_id: string;
      /**
       * Email
       * Format: email
       * @description Recipient email forwarded by the broker. The regional endpoint still consults the User document for the authoritative address; this field is forwarded for cross-reference and logging.
       */
      email: string;
      /**
       * Ip
       * @description Source IP captured at the time of the login.
       */
      ip: string;
      /**
       * User Agent
       * @description Raw User-Agent string captured at login. The regional endpoint parses this into a display string via ``utils.user_agent``.
       */
      user_agent?: string | null;
      /** @description Geo-IP enrichment for the login. Any field may be missing. */
      location_info?: components['schemas']['LocationInfo'] | null;
      /**
       * Occurred At
       * Format: date-time
       * @description ISO-8601 timestamp of the login event.
       */
      occurred_at: string;
      /**
       * Log Id
       * @description Correlation id echoed back in the response for tracing. Not used for deduplication in this version.
       */
      log_id: string;
    };
    /**
     * LoginFromNewDeviceResponse
     * @description Outcome of a single forwarded login-from-new-device event.
     */
    LoginFromNewDeviceResponse: {
      /**
       * Status
       * @description ``sent`` when the regional endpoint wrote the audit timestamp and invoked the email send. ``skipped_flag_off`` when the umbrella feature flag was off — no audit write, no email. ``skipped_no_recipient`` when the resolved user has no email address — nothing to send, not an error.
       * @enum {string}
       */
      status: LoginFromNewDeviceResponseStatus;
      /**
       * Log Id
       * @description Echo of the inbound ``log_id`` for tracing.
       */
      log_id: string;
    };
    /**
     * LoginRoutingDTO
     * @description Diagnostic explanation of how a user's next login would route.
     */
    LoginRoutingDTO: {
      /** @description Resolved auth vendor */
      vendor: components['schemas']['AuthVendor'];
      /** @description SSO or NON_SSO */
      authentication_method: components['schemas']['AuthenticationMethod'];
      /**
       * Reason
       * @description Human-readable routing reason
       */
      reason: string;
      /** Screen Hint */
      screen_hint?: string | null;
      /** Connection Name */
      connection_name?: string | null;
      matched_sso_connection?: components['schemas']['MatchedSSOConnectionDTO'] | null;
      /** Flags */
      flags?: {
        [key: string]: unknown;
      };
    };
    /**
     * LogoutAllMatchingRequest
     * @description Filter-based "log out every matching member" request. Carries the SAME
     *     filter set as GET /members (search / teamIds / roleIds / specialtyIds)
     *     instead of an explicit id list; all fields optional → an empty body means
     *     "all members in the org". ``show_pending_invitations_only`` is intentionally
     *     absent: pending invitations have no session to revoke.
     *
     *     ``excluded_user_ref_ids`` is a post-resolution opt-out list: the frontend's
     *     "select all, then un-check a few" UX. These ids are subtracted from the
     *     matched set AFTER filtering, alongside the built-in exclusions (caller, org
     *     admins, pending). It can only ever shrink the target set — an id that does
     *     not match the filter is a harmless no-op — so no cross-org validation is
     *     needed.
     */
    LogoutAllMatchingRequest: {
      /** Search */
      search?: string | null;
      /** Teamids */
      teamIds?: string[] | null;
      /** Roleids */
      roleIds?: string[] | null;
      /** Specialtyids */
      specialtyIds?: string[] | null;
      /** Excludeduserrefids */
      excludedUserRefIds?: string[] | null;
    };
    /** LogoutAllMatchingResponse */
    LogoutAllMatchingResponse: {
      /** Status */
      status: string;
      /** Jobid */
      jobId: string;
      /** Affectedcount */
      affectedCount: number;
    };
    /**
     * LogoutEverywhereResponse
     * @description Response payload for the user logout-everywhere endpoint.
     */
    LogoutEverywhereResponse: {
      /** Status */
      status: string;
      /** Affected Count */
      affected_count: number;
    };
    /**
     * LogoutJobFailureView
     * @description Per-user Auth0-revocation failure detail, surfaced so the cause is
     *     diagnosable from the API instead of only the logs.
     */
    LogoutJobFailureView: {
      /** User Ref Id */
      user_ref_id: string;
      /** Status Code */
      status_code?: number | null;
      /** Error Type */
      error_type?: string | null;
    };
    /**
     * LogoutJobStatus
     * @enum {string}
     */
    LogoutJobStatus: LogoutJobStatus;
    /** LogoutJobStatusResponse */
    LogoutJobStatusResponse: {
      /** Job Id */
      job_id: string;
      /** Organization Id */
      organization_id: string;
      status: components['schemas']['LogoutJobStatus'];
      /** Target Count */
      target_count: number;
      /** Success Count */
      success_count: number;
      /** Failed Count */
      failed_count: number;
      /** Failed User Ref Ids */
      failed_user_ref_ids: string[];
      /** Failures */
      failures?: components['schemas']['LogoutJobFailureView'][];
    };
    /** LogoutMembersRequest */
    LogoutMembersRequest: {
      /** User Ref Ids */
      user_ref_ids: string[];
    };
    /** LogoutMembersResponse */
    LogoutMembersResponse: {
      /** Status */
      status: string;
      /** Job Id */
      job_id: string;
      /** Affected Count */
      affected_count: number;
    };
    /**
     * LoincDocumentCategoryClassCode
     * @description LOINC codes suitable for FHIR ``DocumentReference.category`` / ``Composition.category``
     *     (document class).
     *
     *     Bind ``Coding.system`` to :attr:`~pkg.integrations.fhir.models.enums.observation_codes.LoincCodingSystem.URI`.
     *     Displays follow LOINC long/short names (see :data:`LOINC_DOCUMENT_CATEGORY_DISPLAY`).
     *
     *     Full expansion of the ``document-classcodes`` valueset (Example binding),
     *     shared by ``DocumentReference.category`` and ``Composition.category``, plus
     *     ``LABORATORY_REPORT`` (not part of the official valueset expansion, kept
     *     for backward compatibility with existing Veradigm mappings).
     *
     *     https://loinc.org/
     *     https://hl7.org/fhir/R4/valueset-document-classcodes.html
     * @enum {string}
     */
    LoincDocumentCategoryClassCode: LoincDocumentCategoryClassCode;
    /**
     * LookupIdentityProfileRequest
     * @description Request DTO for lookup identity profile by one identifier.
     *
     *     Exactly one of user_ref_id, email, auth0_id, kinde_user_id must be set.
     */
    LookupIdentityProfileRequest: {
      /**
       * User Ref Id
       * @description Internal stable user reference ID
       */
      user_ref_id?: string | null;
      /**
       * Email
       * @description User primary email
       */
      email?: string | null;
      /**
       * Auth0 Id
       * @description Auth0 user ID (e.g. auth0|abc123)
       */
      auth0_id?: string | null;
      /**
       * Kinde User Id
       * @description Kinde user ID
       */
      kinde_user_id?: string | null;
    };
    /**
     * LookupIdentityProfileResponse
     * @description Wrapper response for lookup identity profile endpoint.
     */
    LookupIdentityProfileResponse: {
      /** @description The looked-up identity profile data */
      identity_profile?:
        | components['schemas']['domains__identity_broker__dto__responses__identity_profile_dto__IdentityProfileDTO']
        | null;
    };
    /** MBSAUCodeConcept */
    MBSAUCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * MDCClassification
     * @description Result of MDC (Medical Device Complaint) classification from LLM
     */
    MDCClassification: {
      /** Is Mdc */
      is_mdc: boolean;
      /** Draft Message */
      draft_message?: string | null;
    };
    /**
     * MFAMethod
     * @enum {string}
     */
    MFAMethod: MFAMethod;
    /**
     * MFAScope
     * @enum {string}
     */
    MFAScope: MFAScope;
    /**
     * MFASetBY
     * @enum {string}
     */
    MFASetBY: MFASetBY;
    /**
     * MKCustomTemplateRequestResponse
     * @description Response model for MK custom template requests
     */
    MKCustomTemplateRequestResponse: {
      /**
       * Id
       * @description Request ID
       */
      id: string;
      /**
       * Kinde User Id
       * @description User who submitted the request
       */
      kinde_user_id: string;
      /**
       * Existing Template Id
       * @description ID of existing template if modifying
       */
      existing_template_id?: string | null;
      /**
       * Template Name
       * @description Requested template name
       */
      template_name: string;
      /**
       * Description
       * @description Request description
       */
      description: string;
      /**
       * Pdf S3 Key
       * @description S3 key for uploaded PDF
       */
      pdf_s3_key?: string | null;
      /**
       * Pdf Presigned Url
       * @description Presigned URL for viewing PDF (only for Internal Admin)
       */
      pdf_presigned_url?: string | null;
      /**
       * Additional Notes
       * @description Additional notes
       */
      additional_notes?: string | null;
      /** @description Request status */
      status: components['schemas']['MKCustomTemplateRequestStatus'];
      /**
       * Accepted By Kinde User Id
       * @description MK staff member who accepted the request
       */
      accepted_by_kinde_user_id?: string | null;
      /**
       * Accepted At
       * @description When the request was accepted
       */
      accepted_at?: string | null;
      /**
       * Created Template Id
       * @description ID of created template once fulfilled
       */
      created_template_id?: string | null;
      /**
       * Created At
       * Format: date-time
       * @description When the request was created
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description When the request was last updated
       */
      updated_at: string;
    };
    /**
     * MKCustomTemplateRequestStatus
     * @description Status of MK custom template requests
     * @enum {string}
     */
    MKCustomTemplateRequestStatus: MKCustomTemplateRequestStatus;
    /**
     * Macro
     * @description A flowsheet macro for template-based observation entry.
     */
    Macro: {
      /** Macroid */
      macroId: string;
      provenance?: components['schemas']['Provenance'] | null;
    };
    /**
     * MacroError
     * @description Validation error for a flowsheet macro.
     */
    MacroError: {
      /** Macroid */
      macroId?:
        | components['schemas']['dataclass__nebula_session__models__IDType'][]
        | null;
      /** Ldainstanceid */
      ldaInstanceId?: string | null;
      /** Proxyldainstanceid */
      proxyLdaInstanceId?: string | null;
      /** Error */
      error: string;
      /** Errorcode */
      errorCode?: string | null;
    };
    /** MagentusCreateAdaptorRequest */
    MagentusCreateAdaptorRequest: {
      /**
       * Ehr Provider
       * @default Magentus
       * @constant
       */
      ehr_provider: 'Magentus';
      /** Tenant Id */
      tenant_id: string;
      time_zone?: components['schemas']['TimeZones'] | null;
    };
    /** MagentusOnboardingTenantDetails */
    MagentusOnboardingTenantDetails: {
      /** Tenant Id */
      tenant_id: string;
      time_zone: components['schemas']['TimeZones'];
    };
    /**
     * ManagedRunLifecycleBinding
     * @description Declares one registered guard around a managed run's lifecycle.
     *
     *     ``name`` selects a workflow-safe guard from the managed-run lifecycle
     *     registry. ``config`` is owned and validated by that guard when the run is
     *     launched.
     */
    ManagedRunLifecycleBinding: {
      /** Name */
      name: string;
      /** Config */
      config?: {
        [key: string]: unknown;
      };
    };
    /** ManagedUserRuleRequest */
    ManagedUserRuleRequest: {
      /**
       * Rule Type
       * @constant
       */
      rule_type: 'regex';
      /** Value */
      value: string;
    };
    /** ManagedUserRulesResponse */
    ManagedUserRulesResponse: {
      /** Regex Rules */
      regex_rules?: string[];
    };
    /** MarkAppliedSchema */
    MarkAppliedSchema: {
      /** Applied Item Ids */
      applied_item_ids?: string[];
    };
    /** MarkSentForReviewResponse */
    MarkSentForReviewResponse: {
      /** Batch Id */
      batch_id: string;
      /** Marked Count */
      marked_count: number;
      /**
       * Requested Count
       * @default 0
       */
      requested_count: number;
      /**
       * Notified Count
       * @default 0
       */
      notified_count: number;
      /** Notification Failures */
      notification_failures?: components['schemas']['NotificationFailureResponse'][];
    };
    /** MarkUserDeletedRequest */
    MarkUserDeletedRequest: {
      /** Delete Reason */
      delete_reason: string;
    };
    /** MarkUserDeletedResponse */
    MarkUserDeletedResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
    };
    /**
     * MatchConfidence
     * @enum {string}
     */
    MatchConfidence: MatchConfidence;
    /**
     * MatchDemographics
     * @description Caller-supplied signals to match on. Every field is optional — send
     *     whatever the extractor produced; absent signals are simply skipped.
     */
    MatchDemographics: {
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Birth Date */
      birth_date?: string | null;
      /** Email */
      email?: string | null;
      /** Phone */
      phone?: string | null;
      /** Identifiers */
      identifiers?:
        | components['schemas']['dataclass__patient_profile__Identifier'][]
        | null;
    };
    /** MatchResult */
    MatchResult: {
      match?: components['schemas']['ProfileMatch'] | null;
      /**
       * Candidates
       * @default []
       */
      candidates: components['schemas']['ProfileMatch'][];
    };
    /**
     * MatchType
     * @description Fixed categorical match types.
     *
     *     Roster-scan hits may also use dynamic ``+``-joined signal combos (e.g.
     *     ``email+name``, ``identifier:nhs``) — those stay as plain strings.
     * @enum {string}
     */
    MatchType: MatchType;
    /** MatchedRulePreview */
    MatchedRulePreview: {
      /** Rule Id */
      rule_id: string;
      /** Description */
      description: string;
      /** Workflow Id */
      workflow_id: string;
      /** Agent Name */
      agent_name: string;
      /** Product Surface */
      product_surface?: string | null;
      /** Delay Seconds */
      delay_seconds?: number | null;
      /** Filters */
      filters: {
        [key: string]: unknown;
      };
      /** Conditions */
      conditions?: {
        [key: string]: unknown;
      }[];
      /** Evidence */
      evidence?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * MatchedSSOConnectionDTO
     * @description Snapshot of an SSO connection that matched a login-routing diagnostic.
     */
    MatchedSSOConnectionDTO: {
      /** Connection Name */
      connection_name: string;
      /** Sso State */
      sso_state: string;
      /** Is Testing Email */
      is_testing_email: boolean;
    };
    /**
     * MdmComplexityLevel
     * @enum {string}
     */
    MdmComplexityLevel: MdmComplexityLevel;
    /** MediaUploadView */
    MediaUploadView: {
      /** Url */
      url: string;
      /** S3 Key */
      s3_key: string;
      /** Content Type */
      content_type: string;
      /** Filename */
      filename: string;
      /** Size Bytes */
      size_bytes: number;
    };
    /**
     * Medication
     * @description A generated medication order with dosing details.
     */
    Medication: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: MedicationType;
      /** Uid */
      uid: string;
      definition: components['schemas']['OrderDefinition'];
      action: components['schemas']['MedicationAction'];
      /** Associations */
      associations?: components['schemas']['Association'][] | null;
      dose?: components['schemas']['OrderDose'] | null;
      /** Prn */
      prn?: boolean | null;
      frequency?: components['schemas']['OrderFrequency'] | null;
      route?: components['schemas']['OrderRoute'] | null;
    };
    /**
     * MedicationAction
     * @example new
     * @example reorder
     * @example change
     * @example discontinue
     */
    MedicationAction: string;
    /**
     * MedicationRequest
     * @description An order or request for both supply of the medication and the instructions for administration of the medication to a patient.
     *
     *     https://hl7.org/fhir/R4/medicationrequest-definitions.html
     */
    MedicationRequest: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * External ids for this request
       * @description Identifiers associated with this medication request that are defined by business processes and/or used to refer to it when a direct URL reference to the resource itself is not appropriate.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * active | on-hold | cancelled | completed | entered-in-error | stopped | draft | unknown
       * @description A code specifying the current state of the order. Generally, this will be active or completed state.
       */
      status: components['schemas']['MedicationRequestStatus'];
      /**
       * Reason for current status
       * @description Captures the reason for the current state of the MedicationRequest.
       */
      statusReason?: components['schemas']['CodeableConcept'] | null;
      /**
       * proposal | plan | order | original-order | reflex-order | filler-order | instance-order | option
       * @description Whether the request is a proposal, plan, or an original order.
       */
      intent: components['schemas']['MedicationRequestIntent'];
      /**
       * Type of medication usage
       * @description Indicates the type of medication request (for example, where the medication is expected to be consumed or administered (i.e. inpatient or outpatient)).
       */
      category?: components['schemas']['CodeableConcept'][] | null;
      /**
       * routine | urgent | asap | stat
       * @description Indicates how quickly the Medication Request should be addressed with respect to other requests.
       */
      priority?: components['schemas']['MedicationRequestPriority'] | null;
      /**
       * True if request is prohibiting action
       * @description If true indicates that the provider is asking for the medication request not to occur.
       */
      doNotPerform?: boolean | null;
      /**
       * Reported rather than primary record
       * @description Indicates if this record was captured as a secondary 'reported' record rather than as an original primary source-of-truth record.
       */
      reportedBoolean?: boolean | null;
      /**
       * Reported rather than primary record
       * @description Indicates if this record was captured as a secondary 'reported' record rather than as an original primary source-of-truth record. It may also indicate the source of the report.
       */
      reportedReference?: components['schemas']['Reference'] | null;
      /**
       * Medication to be taken
       * @description Identifies the medication being requested. This is a link to a resource that represents the medication which may be the details of the medication or simply an attribute carrying a code that identifies the medication from a known list of medications.
       */
      medicationCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Medication to be taken
       * @description Identifies the medication being requested. This is a link to a resource that represents the medication which may be the details of the medication or simply an attribute carrying a code that identifies the medication from a known list of medications.
       */
      medicationReference?: components['schemas']['Reference'] | null;
      /**
       * Who or group medication request is for
       * @description A link to a resource representing the person or set of individuals to whom the medication will be given.
       */
      subject: components['schemas']['Reference'];
      /**
       * Encounter created as part of encounter/admission/stay
       * @description The Encounter during which this MedicationRequest was created or to which the creation of this record is tightly associated.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * Information to support ordering of the medication
       * @description Include additional information (for example, patient height and weight) that supports the ordering of the medication.
       */
      supportingInformation?: components['schemas']['Reference'][] | null;
      /**
       * When request was initially authored
       * @description The date (and perhaps time) when the prescription was initially written or authored on.
       */
      authoredOn?: string | null;
      /**
       * Who/What requested the Request
       * @description The individual, organization, or device that initiated the request and has responsibility for its activation.
       */
      requester?: components['schemas']['Reference'] | null;
      /**
       * Intended performer of administration
       * @description The specified desired performer of the medication treatment (e.g. the performer of the medication administration).
       */
      performer?: components['schemas']['Reference'] | null;
      /**
       * Desired kind of performer of the medication administration
       * @description Indicates the type of performer of the administration of the medication.
       */
      performerType?: components['schemas']['CodeableConcept'] | null;
      /**
       * Person who entered the request
       * @description The person who entered the order on behalf of another individual for example in the case of a verbal or a telephone order.
       */
      recorder?: components['schemas']['Reference'] | null;
      /**
       * Reason or indication for ordering or not ordering the medication
       * @description The reason or the indication for ordering or not ordering the medication.
       */
      reasonCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Condition or observation that supports why the prescription is being written
       * @description Condition or observation that supports why the medication was ordered.
       */
      reasonReference?: components['schemas']['Reference'][] | null;
      /**
       * Instantiates FHIR protocol or definition
       * @description The URL pointing to a protocol, guideline, orderset, or other definition that is adhered to in whole or in part by this MedicationRequest.
       */
      instantiatesCanonical?: string[] | null;
      /**
       * Instantiates external protocol or definition
       * @description The URL pointing to an externally maintained protocol, guideline, orderset or other definition that is adhered to in whole or in part by this MedicationRequest.
       */
      instantiatesUri?: string[] | null;
      /**
       * What request fulfills
       * @description A plan or request that is fulfilled in whole or in part by this medication request.
       */
      basedOn?: components['schemas']['Reference'][] | null;
      /**
       * Composite request this is part of
       * @description A shared identifier common to all requests that were authorized more or less simultaneously by a single author, representing the identifier of the requisition or prescription.
       */
      groupIdentifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * Overall pattern of medication administration
       * @description The description of the overall pattern of the administration of the medication to the patient.
       */
      courseOfTherapyType?: components['schemas']['CodeableConcept'] | null;
      /**
       * Associated insurance coverage
       * @description Insurance plans, coverage extensions, pre-authorizations and/or pre-determinations that may be required for delivering the requested service.
       */
      insurance?: components['schemas']['Reference'][] | null;
      /**
       * Information about the prescription
       * @description Extra information about the prescription that could not be conveyed by the other attributes.
       */
      note?: components['schemas']['Annotation'][] | null;
      /**
       * How the medication should be taken
       * @description Indicates how the medication is to be used by the patient.
       */
      dosageInstruction?: components['schemas']['Dosage'][] | null;
      /**
       * Medication supply authorization
       * @description Indicates the specific details for the dispense or medication supply part of a medication request (also known as a Medication Prescription or Medication Order).
       */
      dispenseRequest?: components['schemas']['MedicationRequestDispenseRequest'] | null;
      /**
       * Any restrictions on medication substitution
       * @description Indicates whether or not substitution can or should be part of the dispense.
       */
      substitution?: components['schemas']['MedicationRequestSubstitution'] | null;
      /**
       * An order/prescription that is being replaced
       * @description A link to a resource representing an earlier order related order or prescription.
       */
      priorPrescription?: components['schemas']['Reference'] | null;
      /**
       * Clinical Issue with action
       * @description Indicates an actual or potential clinical issue with or between one or more active or proposed clinical actions for a patient; e.g. Drug-drug interaction, duplicate therapy, dosage alert etc.
       */
      detectedIssue?: components['schemas']['Reference'][] | null;
      /**
       * A list of events of interest in the lifecycle
       * @description Links to Provenance records for past versions of this resource or fulfilling request or event resources that identify key state transitions or updates that are likely to be relevant to a user looking at the current version of the resource.
       */
      eventHistory?: components['schemas']['Reference'][] | null;
    };
    /**
     * MedicationRequestDispenseRequest
     * @description Medication supply authorization.
     *
     *     https://hl7.org/fhir/R4/medicationrequest-definitions.html#MedicationRequest.dispenseRequest
     */
    MedicationRequestDispenseRequest: {
      /**
       * First fill details
       * @description Indicates the quantity or duration for the first dispense of the medication.
       */
      initialFill?: components['schemas']['MedicationRequestInitialFill'] | null;
      /**
       * Minimum period of time between dispenses
       * @description The minimum period of time that must occur between dispenses of the medication.
       */
      dispenseInterval?: components['schemas']['Duration'] | null;
      /**
       * Time period supply is authorized for
       * @description This indicates the validity period of a prescription (stale dating the Prescription).
       */
      validityPeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Number of refills authorized
       * @description An integer indicating the number of times, in addition to the original dispense, (aka refills or repeats) that the patient can receive the prescribed medication. Usage Notes: This integer does not include the original order dispense. This means that if an order indicates dispense 30 tablets plus '3 repeats', then the order can be dispensed a total of 4 times and the patient can receive a total of 120 tablets.
       */
      numberOfRepeatsAllowed?: number | null;
      /**
       * Amount of medication to supply per dispense
       * @description The amount that is to be dispensed for one fill.
       */
      quantity?: components['schemas']['Quantity'] | null;
      /**
       * Number of days supply per dispense
       * @description Identifies the period time over which the supplied product is expected to be used, or the length of time the dispense is expected to last.
       */
      expectedSupplyDuration?: components['schemas']['Duration'] | null;
      /**
       * Intended dispenser
       * @description Indicates the intended dispensing Organization specified by the prescriber.
       */
      performer?: components['schemas']['Reference'] | null;
    };
    /**
     * MedicationRequestInitialFill
     * @description First fill details for the dispense request.
     *
     *     https://hl7.org/fhir/R4/medicationrequest-definitions.html#MedicationRequest.dispenseRequest.initialFill
     */
    MedicationRequestInitialFill: {
      /**
       * First fill quantity
       * @description The amount or quantity to provide as part of the first dispense.
       */
      quantity?: components['schemas']['Quantity'] | null;
      /**
       * First fill duration
       * @description The length of time that the first dispense is expected to last.
       */
      duration?: components['schemas']['Duration'] | null;
    };
    /**
     * MedicationRequestIntent
     * @description The kind of medication order.
     *
     *     https://hl7.org/fhir/R4/valueset-medicationrequest-intent.html
     * @enum {string}
     */
    MedicationRequestIntent: MedicationRequestIntent;
    /**
     * MedicationRequestPriority
     * @description Identifies the level of importance to be assigned to actioning the request.
     *
     *     https://hl7.org/fhir/R4/valueset-request-priority.html
     * @enum {string}
     */
    MedicationRequestPriority: MedicationRequestPriority;
    /**
     * MedicationRequestStatus
     * @description A coded concept specifying the state of the prescribing event.
     *
     *     https://hl7.org/fhir/R4/valueset-medicationrequest-status.html
     * @enum {string}
     */
    MedicationRequestStatus: MedicationRequestStatus;
    /**
     * MedicationRequestSubstitution
     * @description Any restrictions on medication substitution.
     *
     *     https://hl7.org/fhir/R4/medicationrequest-definitions.html#MedicationRequest.substitution
     */
    MedicationRequestSubstitution: {
      /**
       * Whether substitution is allowed or not
       * @description True if the prescriber allows a different drug to be dispensed from what was prescribed.
       */
      allowedBoolean?: boolean | null;
      /**
       * Whether substitution is allowed or not
       * @description True if the prescriber allows a different drug to be dispensed from what was prescribed.
       */
      allowedCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Why should (not) substitution be made
       * @description Indicates the reason for the substitution, or why substitution must or must not be performed.
       */
      reason?: components['schemas']['CodeableConcept'] | null;
    };
    /** MedicationReviewTaskResponse */
    MedicationReviewTaskResponse: {
      /** Task Id */
      task_id: string;
      /** Title */
      title: string;
      /** Status */
      status: string;
      /** Category */
      category: string | null;
      /**
       * Task Type
       * @default medication_review
       * @constant
       */
      task_type: 'medication_review';
    };
    /**
     * MedicationStatement
     * @description A record of a medication that is being consumed by a patient.
     *
     *     A MedicationStatement may indicate that the patient may be taking the
     *     medication now or has taken the medication in the past or will be taking
     *     the medication in the future.
     *
     *     https://hl7.org/fhir/R4/medicationstatement-definitions.html
     */
    MedicationStatement: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * External identifier
       * @description Identifiers associated with this Medication Statement.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * active | completed | entered-in-error | intended | stopped | on-hold | unknown | not-taken
       * @description A code representing the patient or other source's judgment about the state of the medication used.
       */
      status: components['schemas']['MedicationStatementStatus'];
      /**
       * Reason for current status
       * @description Captures the reason for the current status of the MedicationStatement.
       */
      statusReason?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Type of medication usage
       * @description Indicates where the medication is expected to be consumed or administered.
       */
      category?: components['schemas']['CodeableConcept'] | null;
      /**
       * What medication was taken
       * @description Identifies the medication being administered. This is either a link to a resource representing the details of the medication or a simple attribute carrying a code that identifies the medication from a known list of medications.
       */
      medication:
        | components['schemas']['CodeableConcept']
        | components['schemas']['Reference'];
      /**
       * Who is/was taking the medication
       * @description The person, animal or group who is/was taking the medication.
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * Encounter / Episode associated with MedicationStatement
       * @description The encounter or episode of care that establishes the context for this MedicationStatement.
       */
      context?: components['schemas']['Reference'] | null;
      /**
       * The date/time or interval when the medication is/was/will be taken
       * @description The interval of time during which it is being asserted that the patient is/was/will be taking the medication (or was not taking, when the MedicationStatement.taken element is No).
       */
      effective?: string | null;
      /**
       * When the statement was asserted?
       * @description The date when the medication statement was asserted by the information source.
       */
      dateAsserted?: string | null;
      /**
       * Person or organization that provided the information
       * @description The person or organization that provided the information about the taking of this medication.
       */
      informationSource?: components['schemas']['Reference'] | null;
      /**
       * Reason for why the medication is being/was taken
       * @description A reason for why the medication is being/was taken.
       */
      reasonCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Further information about the statement
       * @description Provides extra information about the medication statement that is not conveyed by the other attributes.
       */
      note?: components['schemas']['Annotation'][] | null;
      /**
       * Details of how medication is/was taken or should be taken
       * @description Indicates how the medication is/was or should be taken by the patient.
       */
      dosage?: components['schemas']['Dosage'][] | null;
    };
    /**
     * MedicationStatementStatus
     * @description A coded concept indicating the current status of a MedicationStatement.
     *
     *     https://hl7.org/fhir/R4/valueset-medication-statement-status.html
     * @enum {string}
     */
    MedicationStatementStatus: MedicationStatementStatus;
    /** MeditechEhrLaunchCreateAdaptorRequest */
    MeditechEhrLaunchCreateAdaptorRequest: {
      /**
       * Ehr Provider
       * @default Meditech Expanse
       * @constant
       */
      ehr_provider: 'Meditech Expanse';
      access_token_response: components['schemas']['EHRLaunchAccessTokenDetails'];
      ehrlaunch_profile: components['schemas']['EHRLaunchProfile'];
    };
    /** MedtechEHRLaunchProfileAdditionalDetails */
    MedtechEHRLaunchProfileAdditionalDetails: {
      /** Facility Id */
      facility_id: string;
    };
    /**
     * MedtechLaunchErrorResponse
     * @description Error response for failed Medtech launch verification.
     */
    MedtechLaunchErrorResponse: {
      /** Code */
      code: string;
      /** Message */
      message: string;
      /** Step Id */
      step_id?: string | null;
    };
    /**
     * MedtechLaunchResponse
     * @description Response for successful Medtech launch verification.
     */
    MedtechLaunchResponse: {
      /** Access Token */
      access_token?: string | null;
      /** Provider */
      provider: string;
      /** Session Id */
      session_id: string;
      /** Onboarding Session Id */
      onboarding_session_id: string;
    };
    /** MemberHistoryEntrySchema */
    MemberHistoryEntrySchema: {
      /** User Ref Id */
      user_ref_id?: string | null;
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** Email */
      email?: string | null;
      /** Display Name */
      display_name?: string | null;
      /** Direction */
      direction: string;
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp: string;
      /** Source */
      source: string;
      /** Detail */
      detail?: string | null;
    };
    /** MemberHistoryResponse */
    MemberHistoryResponse: {
      /** Additions */
      additions: components['schemas']['MemberHistoryEntrySchema'][];
      /** Removals */
      removals: components['schemas']['MemberHistoryEntrySchema'][];
      summary: components['schemas']['MemberHistorySummarySchema'];
      covered_window: components['schemas']['CoveredWindowSchema'];
    };
    /** MemberHistorySummarySchema */
    MemberHistorySummarySchema: {
      /** Start Count */
      start_count: number;
      /** Added */
      added: number;
      /** Removed */
      removed: number;
      /** End Count */
      end_count: number;
    };
    /**
     * MemberSearchResult
     * @description Individual member result for organization member search API.
     */
    MemberSearchResult: {
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** Email */
      email?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Profile Picture Url */
      profile_picture_url?: string | null;
    };
    /**
     * MemoryType
     * @description ``AGENT_EXTRACTED_WORD_SUBSTITUTIONS`` is the only type with a
     *     registered strategy. The first three are legacy values kept so
     *     persisted ``memory_context`` / ``note_suggestion`` rows still hydrate.
     * @enum {string}
     */
    MemoryType: MemoryType;
    /** MergeConnection */
    MergeConnection: {
      /** Connector */
      connector: string;
      /** Connector Name */
      connector_name?: string | null;
      /** Connection Id */
      connection_id?: string | null;
      /** Created At */
      created_at?: string | null;
      /**
       * Always Available
       * @default false
       */
      always_available: boolean;
      /** Auth Mode */
      auth_mode?: string | null;
    };
    /** MergeConnectionsResponse */
    MergeConnectionsResponse: {
      /** Connections */
      connections: components['schemas']['MergeConnection'][];
      /** Registered User Id */
      registered_user_id: string;
      /** Authenticated Connectors */
      authenticated_connectors: string[];
      /** Always Available Connectors */
      always_available_connectors?: string[];
    };
    /** MergeLinkTokenRequest */
    MergeLinkTokenRequest: {
      /**
       * Connector
       * @description Optional Agent Handler connector slug (e.g. gmail, outlook). Omit to open Link with the Tool Pack picker when supported.
       */
      connector?: string | null;
    };
    /** MergeLinkTokenResponse */
    MergeLinkTokenResponse: {
      /** Link Token */
      link_token: string;
      /** Magic Link Url */
      magic_link_url?: string | null;
      /** Registered User Id */
      registered_user_id: string;
    };
    /** MergePatientProfilesRequest */
    MergePatientProfilesRequest: {
      /**
       * Target Patient Profile Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      target_patient_profile_id: string;
      /** Source Patient Profile Ids */
      source_patient_profile_ids: string[];
    };
    /** MergePatientProfilesResponse */
    MergePatientProfilesResponse: {
      /** Target Patient Profile Id */
      target_patient_profile_id: string;
      /** Merged Source Ids */
      merged_source_ids: string[];
      /** Moved Session Count */
      moved_session_count: number;
    };
    /**
     * MergePreflightResponse
     * @description Report-mode result of every user-to-user merge precondition.
     *
     *     Always HTTP 200; ``ok`` is the aggregate. ``target_workspace_status``
     *     classifies why the target's destination workspace (their single live
     *     workspace, any role) is unresolvable so the operator can tell "solo user,
     *     provision and retry" (``missing_provisionable``) apart from "ambiguous or
     *     orphaned memberships — needs support intervention" (``missing_blocked``).
     */
    MergePreflightResponse: {
      /** Ok */
      ok: boolean;
      /** Checks */
      checks: components['schemas']['PreflightCheck'][];
      /** Target Workspace Status */
      target_workspace_status?: MergePreflightResponseTarget_workspace_statusAnyOf0 | null;
      /**
       * Would Noop
       * @default false
       */
      would_noop: boolean;
    };
    /** MergeSessionsRequest */
    MergeSessionsRequest: {
      /**
       * Session Ids
       * @description Session ids to merge with the context session
       */
      session_ids: string[];
    };
    /** MergeSessionsResponse */
    MergeSessionsResponse: {
      /** Primary Session Id */
      primary_session_id: string;
      session_merge_group: components['schemas']['MergeableSessions'];
    };
    /**
     * MergeableSessions
     * @description Secondary sessions merged into the primary; extensible for future fields.
     */
    MergeableSessions: {
      /** Members */
      members?: components['schemas']['SessionMergeGroupMember'][];
    };
    /** MergeableSessionsResponse */
    MergeableSessionsResponse: {
      /** @description Sessions the context session can be merged with, as merge-group members with link_status=unmerged */
      mergeable_sessions?: components['schemas']['MergeableSessions'];
    };
    /**
     * MessageResponse
     * @description Full message representation returned to the frontend.
     */
    MessageResponse: {
      /** Id */
      id: string;
      /** Chatsessionid */
      chatSessionId: string;
      /** Userrefid */
      userRefId: string;
      speaker: components['schemas']['Speaker'];
      /** Originaltext */
      originalText: string;
      /** Translatedtext */
      translatedText: string;
      /** Originallanguage */
      originalLanguage: string;
      /** Targetlanguage */
      targetLanguage: string;
      /**
       * Occurredat
       * Format: date-time
       */
      occurredAt: string;
      /**
       * Createdat
       * Format: date-time
       */
      createdAt: string;
      /**
       * Updatedat
       * Format: date-time
       */
      updatedAt: string;
      /** Alternatetranscription */
      alternateTranscription?: string | null;
      /** Editedat */
      editedAt?: string | null;
      /** Autoplayedat */
      autoplayedAt?: string | null;
      /** Audiostorageid */
      audioStorageId?: string | null;
      /** Ttsstorageid */
      ttsStorageId?: string | null;
      feedbackRating?: components['schemas']['FeedbackRating'] | null;
      /** Feedbackerrors */
      feedbackErrors?: components['schemas']['TranslatorEvaluationErrorPayload'][] | null;
      /** Feedbackcategories */
      feedbackCategories?: components['schemas']['FeedbackCategory'][] | null;
      /** Feedbacktext */
      feedbackText?: string | null;
      /** Feedbackat */
      feedbackAt?: string | null;
    };
    /**
     * MessageSource
     * @enum {string}
     */
    MessageSource: MessageSource;
    /** MessageView */
    MessageView: {
      /** Id */
      id: string;
      /** Patient Id */
      patient_id: string;
      /** Content */
      content: string;
      /**
       * Direction
       * @enum {string}
       */
      direction: MessageViewDirection;
      /**
       * Sender Type
       * @enum {string}
       */
      sender_type: MessageViewSender_type;
      /** Sender User Id */
      sender_user_id?: string | null;
      /**
       * Channel
       * @enum {string}
       */
      channel: MessageViewChannel;
      /** Media */
      media?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Created At */
      created_at: string;
      /** Delivered At */
      delivered_at?: string | null;
      /** Read At */
      read_at?: string | null;
      /** Is Internal Note */
      is_internal_note?: boolean | null;
      /** Duration Seconds */
      duration_seconds?: number | null;
      /** Summary */
      summary?: string | null;
      /** Session Id */
      session_id?: string | null;
    };
    /**
     * Meta
     * @description Metadata about a resource.
     *
     *     https://hl7.org/fhir/R4/resource-definitions.html#Meta
     */
    Meta: {
      /**
       * Version specific identifier
       * @description The version specific identifier, as it appears in the version portion of the URL. This value changes when the resource is created, updated, or deleted.
       */
      versionId?: string | null;
      /**
       * When the resource version last changed
       * @description When the resource last changed - e.g. when the version changed.
       */
      lastUpdated?: string | null;
      /**
       * Identifies where the resource comes from
       * @description A uri that identifies the source system of the resource. This provides a minimal amount of Provenance information that can be used to track or differentiate the source of information in the resource.
       */
      source?: string | null;
      /**
       * Profiles this resource claims to conform to
       * @description A list of profiles (references to StructureDefinition resources) that this resource claims to conform to.
       */
      profile?: string[] | null;
      /**
       * Security Labels applied to this resource
       * @description Security labels applied to this resource. These tags connect specific resources to the overall security policy and infrastructure.
       */
      security?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding'][]
        | null;
      /**
       * Tags applied to this resource
       * @description Tags applied to this resource. Tags are intended to be used to identify and relate resources to process and workflow, and applications are not required to consider the tags when interpreting the meaning of a resource.
       */
      tag?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding'][]
        | null;
    };
    /**
     * MeterBindingResponse
     * @description Wire shape for the `MeterBinding` (make-billable + read endpoints).
     *
     *     Mirrors the binding: the durable Stripe meter id + its event name +
     *     `is_active`. Price-agnostic — the price (and its currency) is supplied per
     *     customer at enrol and lives on the Stripe `SubscriptionItem`.
     */
    MeterBindingResponse: {
      /** Metric Key */
      metric_key: string;
      /** Stripe Meter Id */
      stripe_meter_id: string;
      /** Event Name */
      event_name: string;
      /** Is Active */
      is_active: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * MeterMetadata
     * @description Type-specific metadata for METERED subscriptions.
     *
     *     A METERED row represents a usage-billing metered Stripe SubscriptionItem
     *     attached to the seat's subscription (an additional item on the SAME
     *     subscription, so usage bills on the same invoice + cycle as the seat). The
     *     row is keyed like any other Stripe row by its own
     *     `stripe_subscription_item_id`; this metadata records which billable meter it
     *     rates. A customer may carry several METERED rows, one per usage dimension,
     *     each with a distinct `metered_metric_key`.
     *
     *     `stripe_price_id` is the per-customer metered price the item was attached on
     *     (the registry binds only the currency-agnostic meter; the price is chosen
     *     per customer at enrol). Recording it here lets the credit-grant path read
     *     the customer's price without a live Stripe lookup. It is **optional** so
     *     rows written before the price-at-enrol pivot (which carried only
     *     `metered_metric_key`) still deserialise; every new enrol records it, and the
     *     reader falls back to a live Stripe lookup when it is absent.
     *
     *     `unit_amount` / `currency` / `billing_period` are the price's facts captured
     *     at enrol (provisioning already retrieves the price there), so the credit-grant
     *     reconciler computes the grant from local data with no per-run Stripe call.
     *     `billing_period` is the price's recurring interval — Stripe metered prices
     *     bill `monthly` or `yearly`, never weekly — used as a defensive check that the
     *     assigned overage limit's period matches what actually invoices (the
     *     fail-fast guard lives at limit assignment). All optional: rows written before
     *     this was recorded fall back to a live price lookup.
     *
     *     `last_granted_period_start` / `last_granted_grant_id` are the credit-grant
     *     reconciler's watermark: the cycle (period start, unix secs) it last granted
     *     this row for, and the resulting Stripe grant id. Written only after a
     *     confirmed grant; on a later same-cycle run the reconciler reads this off the
     *     already-loaded account and skips the per-customer Stripe `list_credit_grants`
     *     round-trip. It is a skip-only optimisation — the create path still lists
     *     Stripe before creating, so a stale/absent watermark can never double-grant.
     */
    MeterMetadata: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: MeterMetadataKind;
      /** Metered Metric Key */
      metered_metric_key: string;
      /** Stripe Price Id */
      stripe_price_id?: string | null;
      /** Unit Amount */
      unit_amount?: number | null;
      /** Currency */
      currency?: string | null;
      /** Billing Period */
      billing_period?: MeterMetadataBilling_periodAnyOf0 | null;
      /** Last Granted Period Start */
      last_granted_period_start?: number | null;
      /** Last Granted Grant Id */
      last_granted_grant_id?: string | null;
    };
    /**
     * MeteredBillingProvisioningResponse
     * @description Cohort-level enrol/status result.
     *
     *     Echoes the `scope` that addressed the request (and `scope_id` for an
     *     org/workspace) so the result is self-describing. For an org/workspace there
     *     is exactly one entry in `results`, carrying the `billing_account_id` the
     *     scope resolved to (the account the whole org bills to).
     */
    MeteredBillingProvisioningResponse: {
      /** Metric Key */
      metric_key: string;
      /**
       * Scope
       * @enum {string}
       */
      scope: MeteredBillingProvisioningResponseScope;
      /** Scope Id */
      scope_id?: string | null;
      /** Results */
      results: components['schemas']['MeteredProvisioningTargetResult'][];
    };
    /**
     * MeteredProvisioningStatus
     * @description Per-target outcome of an enrol (write) or a status (read) request.
     * @enum {string}
     */
    MeteredProvisioningStatus: MeteredProvisioningStatus;
    /**
     * MeteredProvisioningTargetResult
     * @description One target's provisioning/status outcome.
     *
     *     `user_ref_id` is set when the target was addressed by user (`scope=user`)
     *     and empty for an org/workspace addressing (which resolves straight to a
     *     billing account with no single backing user). `billing_account_id` names the
     *     account the target landed on — the stable identifier for an org result.
     */
    MeteredProvisioningTargetResult: {
      /** User Ref Id */
      user_ref_id: string;
      /** Billing Account Id */
      billing_account_id?: string | null;
      status: components['schemas']['MeteredProvisioningStatus'];
      /** Stripe Metered Item Id */
      stripe_metered_item_id?: string | null;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /** Detail */
      detail?: string | null;
    };
    /**
     * MetricConfig
     * @description Defines the ranking metric for a competition.
     */
    MetricConfig: {
      /** Key */
      key: string;
      /** Field Name */
      field_name: string;
      /** Display Name */
      display_name: string;
      /**
       * Sort Order
       * @default desc
       * @enum {string}
       */
      sort_order: MetricConfigSort_order;
    };
    /**
     * MetricOptionsResponse
     * @description Form options returned by `GET /metrics/options`.
     *
     *     Sourced from `domains/usage_entitlements/registry/options.py` —
     *     closed allowlist for the POC (see plan + AGENTS.md).
     */
    MetricOptionsResponse: {
      /** Periods */
      periods: string[];
      /** Aggregation Modes */
      aggregation_modes: string[];
      /** Sum Fields */
      sum_fields: string[];
      /** Enforcement Modes */
      enforcement_modes: string[];
      /** Filter Dimensions */
      filter_dimensions: components['schemas']['FilterDimension'][];
      /** Tiers */
      tiers: string[];
    };
    /**
     * MfaEnrolledRequest
     * @description Forwarded ``gd_enrollment_complete`` (Guardian MFA factor enrolment)
     *     event payload. Sibling of ``PasswordChangedRequest`` — identical shape.
     *
     *     The Auth0 source event carries a ``details.authenticator.type``
     *     (``"sms"`` / ``"otp"`` / ``"push"`` / etc.), but the regional
     *     confirmation email is intentionally factor-agnostic; the factor type
     *     is not forwarded across regions.
     */
    MfaEnrolledRequest: {
      /**
       * User Ref Id
       * @description Global unique identifier for the user (UUID7).
       * @example 01912345-6789-7abc-def0-123456789abc
       */
      user_ref_id: string;
      /**
       * Email
       * Format: email
       * @description Auth0-derived recipient email. The regional endpoint still consults the User document for the authoritative address; this field is forwarded for cross-reference and logging.
       */
      email: string;
      /**
       * Ip
       * @description Source IP captured by Auth0 at the time of the enrolment.
       */
      ip: string;
      /**
       * User Agent
       * @description Raw User-Agent string captured by Auth0. The regional endpoint parses this into a display string via ``utils.user_agent``; Auth0 does not pre-parse the UA.
       */
      user_agent?: string | null;
      /** @description Geo-IP enrichment from Auth0. Any field may be missing. */
      location_info?: components['schemas']['LocationInfo'] | null;
      /**
       * Occurred At
       * Format: date-time
       * @description ISO-8601 timestamp of the MFA-enrolment event.
       */
      occurred_at: string;
      /**
       * Log Id
       * @description Auth0 log event id, echoed back in the response for tracing. Not used for deduplication in this version.
       */
      log_id: string;
    };
    /**
     * MfaEnrolledResponse
     * @description Outcome of a single forwarded MFA-enrolled event.
     */
    MfaEnrolledResponse: {
      /**
       * Status
       * @description ``sent`` when the regional endpoint wrote the audit timestamp and invoked the email send. ``skipped_flag_off`` when the umbrella feature flag was off — no audit write, no email. ``skipped_no_recipient`` when the resolved user has no email address — nothing to send, not an error.
       * @enum {string}
       */
      status: MfaEnrolledResponseStatus;
      /**
       * Log Id
       * @description Echo of the inbound ``log_id`` for tracing.
       */
      log_id: string;
    };
    /**
     * MfaUnenrolledRequest
     * @description Forwarded ``gd_unenroll`` (Guardian MFA factor removal) event
     *     payload. Sibling of ``MfaEnrolledRequest`` — identical shape.
     *
     *     Auth0's ``details.authenticator.type`` is not forwarded across regions
     *     (same decision as the enrolment endpoint: the confirmation email is
     *     factor-agnostic).
     */
    MfaUnenrolledRequest: {
      /**
       * User Ref Id
       * @description Global unique identifier for the user (UUID7).
       * @example 01912345-6789-7abc-def0-123456789abc
       */
      user_ref_id: string;
      /**
       * Email
       * Format: email
       * @description Auth0-derived recipient email. The regional endpoint still consults the User document for the authoritative address; this field is forwarded for cross-reference and logging.
       */
      email: string;
      /**
       * Ip
       * @description Source IP captured by Auth0 at the time of the unenrol.
       */
      ip: string;
      /**
       * User Agent
       * @description Raw User-Agent string captured by Auth0. The regional endpoint parses this into a display string via ``utils.user_agent``; Auth0 does not pre-parse the UA.
       */
      user_agent?: string | null;
      /** @description Geo-IP enrichment from Auth0. Any field may be missing. */
      location_info?: components['schemas']['LocationInfo'] | null;
      /**
       * Occurred At
       * Format: date-time
       * @description ISO-8601 timestamp of the MFA-unenrol event.
       */
      occurred_at: string;
      /**
       * Log Id
       * @description Auth0 log event id, echoed back in the response for tracing. Not used for deduplication in this version.
       */
      log_id: string;
    };
    /**
     * MfaUnenrolledResponse
     * @description Outcome of a single forwarded MFA-unenrol event.
     */
    MfaUnenrolledResponse: {
      /**
       * Status
       * @description ``sent`` when the regional endpoint wrote the audit timestamp and invoked the email send. ``skipped_flag_off`` when the umbrella feature flag was off — no audit write, no email. ``skipped_no_recipient`` when the resolved user has no email address — nothing to send, not an error.
       * @enum {string}
       */
      status: MfaUnenrolledResponseStatus;
      /**
       * Log Id
       * @description Echo of the inbound ``log_id`` for tracing.
       */
      log_id: string;
    };
    /** MigrateAskHeidiRequest */
    MigrateAskHeidiRequest: {
      /** From User Ref Id */
      from_user_ref_id: string;
      /** To User Ref Id */
      to_user_ref_id: string;
    };
    /** MigrateAskHeidiResponse */
    MigrateAskHeidiResponse: {
      /** Chats Matched */
      chats_matched: number;
      /** Chats Modified */
      chats_modified: number;
      /** Calls Matched */
      calls_matched: number;
      /** Calls Modified */
      calls_modified: number;
    };
    /** MigrateCPDRequest */
    MigrateCPDRequest: {
      /** From User Ref Id */
      from_user_ref_id: string;
      /** To User Ref Id */
      to_user_ref_id: string;
    };
    /** MigrateCPDResponse */
    MigrateCPDResponse: {
      /** Matched Count */
      matched_count: number;
      /** Modified Count */
      modified_count: number;
      /**
       * Overlapping Deleted
       * @default 0
       */
      overlapping_deleted: number;
    };
    /** MigrateEvidenceRequest */
    MigrateEvidenceRequest: {
      /** From User Ref Id */
      from_user_ref_id: string;
      /** To User Ref Id */
      to_user_ref_id: string;
    };
    /** MigrateEvidenceResponse */
    MigrateEvidenceResponse: {
      /** Matched Count */
      matched_count: number;
      /** Modified Count */
      modified_count: number;
      /**
       * Overlapping Deleted
       * @default 0
       */
      overlapping_deleted: number;
    };
    /** MigrateSnippetsResponse */
    MigrateSnippetsResponse: {
      /** Matched Count */
      matched_count: number;
      /** Modified Count */
      modified_count: number;
      /**
       * Overlapping Deleted
       * @default 0
       */
      overlapping_deleted: number;
    };
    /** MigrateTeamRelationResponse */
    MigrateTeamRelationResponse: {
      /** Matched Count */
      matched_count: number;
      /** Modified Count */
      modified_count: number;
      /**
       * Overlapping Deleted
       * @default 0
       */
      overlapping_deleted: number;
    };
    /**
     * MigrateUserEHRLaunchProfileRequest
     * @description Migrate user EHR launch profile Based on Profile Name
     */
    MigrateUserEHRLaunchProfileRequest: {
      /** Original Profile Name */
      original_profile_name: string;
      /** Destination Profile Name */
      destination_profile_name: string;
    };
    /** MigrateUserEHRLaunchProfileResponse */
    MigrateUserEHRLaunchProfileResponse: {
      /** Profiles */
      profiles: components['schemas']['UserEHRLaunchProfile'][];
    };
    /** MigrationSummaryResponse */
    MigrationSummaryResponse: {
      /** User Ref Id */
      user_ref_id: string;
      /** Session Count */
      session_count: number;
      /** Template Count */
      template_count: number;
      /** Patient Profile Count */
      patient_profile_count: number;
      /**
       * Snippet Count
       * @default 0
       */
      snippet_count: number;
      /** Team Relations */
      team_relations?: {
        [key: string]: unknown;
      }[];
      /**
       * Clinical Task Count
       * @default 0
       */
      clinical_task_count: number;
      /**
       * Consult Note Edit Count
       * @default 0
       */
      consult_note_edit_count: number;
      /**
       * Consult Note Revert Count
       * @default 0
       */
      consult_note_revert_count: number;
      /**
       * Session Share Count
       * @default 0
       */
      session_share_count: number;
      /**
       * Note Suggestion Count
       * @default 0
       */
      note_suggestion_count: number;
    };
    /** MindbodyCreateAdaptorRequest */
    MindbodyCreateAdaptorRequest: {
      /**
       * Ehr Provider
       * @default Mindbody
       * @constant
       */
      ehr_provider: 'Mindbody';
      /** Username */
      username: string;
      /** Password */
      password: string;
      /** Site Id */
      site_id: number;
    };
    /** MindbodySiteAccessResponse */
    MindbodySiteAccessResponse: {
      /** Site Id */
      site_id: number;
      /** Active */
      active: boolean;
      /** Activation Link */
      activation_link?: string | null;
    };
    /** MinimalTeamMember */
    MinimalTeamMember: {
      /** Kinde User Id */
      kinde_user_id: string;
    };
    /** MinimumSessionView */
    MinimumSessionView: {
      /** Session Id */
      session_id: string;
    };
    /** MintAccessContextResponse */
    MintAccessContextResponse: {
      /**
       * Access Token
       * @description RS256 JWT for service-clinical-coding (SCC). Send as Authorization: Bearer on SCC coding-case requests.
       */
      access_token: string;
      /**
       * Expires At
       * @description Unix epoch seconds when the token expires
       */
      expires_at: number;
      /**
       * Token Type
       * @default Bearer
       */
      token_type: string;
      /**
       * Capabilities
       * @description coding_case.* capabilities encoded in the token
       */
      capabilities: string[];
      /** Workspace Id */
      workspace_id: string;
      /** Team Ids */
      team_ids: string[];
      /**
       * Region
       * @description Deployment region that minted the token (e.g. AU, US)
       */
      region: string;
    };
    /**
     * MobileProvider
     * @description Provider discriminator for AVR integrations.
     *
     *     Despite the name, this enum covers both Epic mobile apps (Haiku, Canto, Rover)
     *     and Epic-managed cloud services (Nebula) within the ambient voice recognition
     *     workflow. The name is retained for backward compatibility with existing
     *     registries and database documents.
     * @enum {string}
     */
    MobileProvider: MobileProvider;
    /**
     * ModalId
     * @description Enum for modal identifiers used in the modal tracking system.
     * @enum {string}
     */
    ModalId: ModalId;
    /**
     * ModalView
     * @description Tracks when and how often a user has seen a specific modal.
     */
    ModalView: {
      /** @description Unique identifier for the modal */
      modal_id: components['schemas']['ModalId'];
      /**
       * First Seen At
       * Format: date-time
       * @description When the user first saw this modal
       */
      first_seen_at?: string;
      /**
       * Last Seen At
       * Format: date-time
       * @description When the user last saw this modal
       */
      last_seen_at?: string;
      /**
       * View Count
       * @description Number of times user has seen this modal
       * @default 1
       */
      view_count: number;
      /**
       * Engage Count
       * @description Total number of times the user engaged with this modal
       * @default 0
       */
      engage_count: number | null;
      /**
       * Last Engaged At
       * @description When the user last engaged with this modal
       */
      last_engaged_at?: string | null;
      /**
       * Consecutive Dismiss Count
       * @description Number of consecutive dismissals since last engagement. Resets on engage.
       * @default 0
       */
      consecutive_dismiss_count: number | null;
      /**
       * Hide Forever
       * @description When True, the modal is permanently dismissed and should not be shown again.
       * @default false
       */
      hide_forever: boolean;
    };
    /**
     * ModalViewAction
     * @description Action type for modal view tracking.
     * @enum {string}
     */
    ModalViewAction: ModalViewAction;
    /** ModelDefinitionSchema */
    ModelDefinitionSchema: {
      /** Id */
      id: string;
      /** Display Name */
      display_name: string;
      /** Provider */
      provider: string;
      /**
       * Enum Name
       * @default
       */
      enum_name: string;
      parameters: components['schemas']['ModelParametersSchema'];
      /** Is Default */
      is_default: boolean;
      /** Recent Endpoint */
      recent_endpoint?: string | null;
      /** Last Used At */
      last_used_at?: string | null;
      /**
       * Status
       * @default ok
       */
      status: string;
    };
    /** ModelHealthCheckResponse */
    ModelHealthCheckResponse: {
      /** Results */
      results: components['schemas']['ModelHealthResultSchema'][];
      /** Total */
      total: number;
      /** Passed */
      passed: number;
    };
    /** ModelHealthResultSchema */
    ModelHealthResultSchema: {
      /** Model Id */
      model_id: string;
      /** Enum Name */
      enum_name: string;
      /** Provider */
      provider: string;
      /** Ok */
      ok: boolean;
      /**
       * Latency Ms
       * @default 0
       */
      latency_ms: number;
      /**
       * Response Preview
       * @default
       */
      response_preview: string;
      /**
       * Error
       * @default
       */
      error: string;
    };
    /** ModelParametersSchema */
    ModelParametersSchema: {
      /** Max Tokens */
      max_tokens: number;
      /** Temperature */
      temperature: number;
      /** Top P */
      top_p: number;
    };
    /** ModelRegistryResponse */
    ModelRegistryResponse: {
      /** Models */
      models: components['schemas']['ModelDefinitionSchema'][];
    };
    /** MoveMemberToTeamRequest */
    MoveMemberToTeamRequest: {
      /**
       * Team Id
       * @description ID of the destination team
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /**
       * Role Ids
       * @description List of role IDs for the destination team
       */
      role_ids: string[];
    };
    /** MultiSourceTranscriptData */
    MultiSourceTranscriptData: {
      /** User Uploaded */
      user_uploaded?: components['schemas']['AudioSourceTranscriptResponse'][];
      /** V2 */
      v2?: components['schemas']['AudioSourceTranscriptResponse'][];
      /** Live */
      live?: components['schemas']['AudioSourceTranscriptResponse'][];
      /** Backup */
      backup?: components['schemas']['AudioSourceTranscriptResponse'][];
    };
    /**
     * MyReferralEntry
     * @description A single entry in the user's referrals list.
     */
    MyReferralEntry: {
      /** Display Name */
      display_name: string;
      /** Masked Email */
      masked_email: string;
      /**
       * Referred At
       * Format: date-time
       */
      referred_at: string;
    };
    /**
     * MyReferralsResponse
     * @description Response for the my-referrals endpoint.
     */
    MyReferralsResponse: {
      /** Referrals */
      referrals: components['schemas']['MyReferralEntry'][];
      /** Total */
      total: number;
      /** Referral Code */
      referral_code: string | null;
    };
    /** NangoConnectSessionRequest */
    NangoConnectSessionRequest: {
      /**
       * Allowed Integrations
       * @description Nango integration IDs the user may connect (e.g. microsoft, outlook).
       */
      allowed_integrations?: string[] | null;
    };
    /** NangoConnectSessionResponse */
    NangoConnectSessionResponse: {
      /** Session Token */
      session_token: string;
    };
    /** NangoConnection */
    NangoConnection: {
      /** Connection Id */
      connection_id: string;
      /** Provider Config Key */
      provider_config_key: string;
      /** Created At */
      created_at?: string | null;
      end_user?: components['schemas']['NangoConnectionEndUser'] | null;
    };
    /** NangoConnectionEndUser */
    NangoConnectionEndUser: {
      /** Id */
      id?: string | null;
      /** Email */
      email?: string | null;
    };
    /** NangoConnectionsResponse */
    NangoConnectionsResponse: {
      /** Connections */
      connections: components['schemas']['NangoConnection'][];
    };
    /**
     * Narrative
     * @description Human-readable summary of the resource (essential clinical and business information).
     *
     *     A human-readable summary of the resource conveying the essential clinical and business
     *     information for the resource.
     *
     *     https://hl7.org/fhir/R4/narrative-definitions.html#Narrative
     */
    Narrative: {
      /**
       * generated | extensions | additional | empty
       * @description The status of the narrative - whether it's entirely generated (from just the defined data or the extensions too), or whether a human authored it and it may contain additional data.
       */
      status: components['schemas']['NarrativeStatus'];
      /**
       * Limited xhtml content
       * @description The actual narrative content, a stripped down version of XHTML.
       */
      div: string;
    };
    /**
     * NarrativeStatus
     * @description The status of a resource narrative.
     *
     *     https://hl7.org/fhir/R4/valueset-narrative-status.html
     * @enum {string}
     */
    NarrativeStatus: NarrativeStatus;
    /** NebulaAccessTokenResponse */
    NebulaAccessTokenResponse: {
      /** Access Token */
      access_token: string;
      /**
       * Token Type
       * @default Bearer
       * @constant
       */
      token_type: 'Bearer';
      /** Expires In */
      expires_in: number;
    };
    /**
     * NebulaAudioChunkReadyEnvelope
     * @description Full envelope for ``com.epic.ambient.audiochunkready``.
     */
    NebulaAudioChunkReadyEnvelope: {
      /** Id */
      id: string;
      /** Source */
      source: string;
      /**
       * Specversion
       * @constant
       */
      specversion: '1.0';
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: NebulaAudioChunkReadyEnvelopeType;
      data: components['schemas']['NebulaAudioChunkReadyEventData'];
    };
    /**
     * NebulaAudioChunkReadyEventData
     * @description ``data`` shape for ``com.epic.ambient.audiochunkready`` events.
     *
     *     Per Epic spec ``chunkId`` is documented as Optional, though every
     *     example includes it. We follow the spec table and accept
     *     ``None`` so a stripped-down event still parses (we still record
     *     the row — the future fetch PR can decide whether a missing
     *     chunkId is actionable).
     */
    NebulaAudioChunkReadyEventData: {
      /** Sessionid */
      sessionId: string;
      /** Recordingid */
      recordingId: number;
      /** Chunkid */
      chunkId?: number | null;
    };
    /**
     * NebulaAudioReadyEnvelope
     * @description Full envelope for ``com.epic.ambient.audioready``.
     */
    NebulaAudioReadyEnvelope: {
      /** Id */
      id: string;
      /** Source */
      source: string;
      /**
       * Specversion
       * @constant
       */
      specversion: '1.0';
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: NebulaAudioReadyEnvelopeType;
      data: components['schemas']['NebulaAudioReadyEventData'];
    };
    /**
     * NebulaAudioReadyEventData
     * @description ``data`` shape for ``com.epic.ambient.audioready`` events.
     *
     *     ``totalChunks`` is documented Optional — Epic may emit the event
     *     before chunk count is finalised in degenerate cases.
     */
    NebulaAudioReadyEventData: {
      /** Sessionid */
      sessionId: string;
      /** Recordingid */
      recordingId: number;
      /** Totalchunks */
      totalChunks?: number | null;
    };
    /**
     * NebulaCareContext
     * @example OP
     * @example IP
     * @example ED
     * @example HOV
     */
    NebulaCareContext: string;
    /** NebulaContextRequest */
    NebulaContextRequest: {
      /** Features */
      features?: components['schemas']['NebulaFeature'][] | null;
      notes?: components['schemas']['NoteContextRequest'] | null;
      user?: components['schemas']['UserContextRequest'] | null;
      flowsheetsContext?: components['schemas']['FlowsheetsContextRequest'] | null;
      /** Othercontext */
      otherContext?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * NebulaFeature
     * @example noteSections
     * @example orders
     * @example diagnoses
     * @example flowsheets
     */
    NebulaFeature: string;
    /**
     * NebulaGenerateDataRequest
     * @description ``POST /v1/session/{session_id}/data`` body — Generate Data.
     *
     *     Spec fields:
     *     - ``sessionId``: redundant copy of the path parameter; we reject
     *       mismatches at the router with 400 since the redundancy is begging
     *       to be exploited otherwise.
     *     - ``lastRecording``: 1-based index of the last completed recording
     *       that this generation request should cover. The integration with
     *       Heidi's note/order pipeline is deferred — this PR only validates
     *       the wire shape so Epic can integration-test against the verb.
     */
    NebulaGenerateDataRequest: {
      /** Sessionid */
      sessionId: string;
      /** Lastrecording */
      lastRecording: number;
    };
    /**
     * NebulaIDCategory
     * @example EXTERNAL
     * @example INTERNAL
     * @example FHIR
     * @example FHIR STU3
     * @example CID
     */
    NebulaIDCategory: string;
    /**
     * NebulaNoteSectionCode
     * @example 10164-2
     * @example 51847-2
     * @example 29545-1
     * @example 30954-2
     * @example 86467-8
     * @example 96335-5
     */
    NebulaNoteSectionCode: string;
    /**
     * NebulaNoteTypeCode
     * @example 11506-3
     * @example 34117-2
     * @example 11488-4
     */
    NebulaNoteTypeCode: string;
    /**
     * NebulaRetrieveDataResponse
     * @description 200 body for ``GET /v1/data/{event_id}``.
     *
     *     ``populate_by_name=True`` keeps direct construction from snake_case
     *     Python keywords ergonomic; ``alias_generator`` produces the
     *     camelCase wire keys (``sessionId``) when the router calls
     *     ``model_dump(by_alias=True)``.
     */
    NebulaRetrieveDataResponse: {
      /** Sessionid */
      sessionId: string;
      /** Version */
      version: number;
      /** Objects */
      objects: (
        | components['schemas']['dataclass__nebula_session__generated_data__note_section__NoteSection']
        | components['schemas']['Order']
        | components['schemas']['Medication']
        | components['schemas']['Diagnosis']
        | components['schemas']['Flowsheet']
        | components['schemas']['FlowsheetUpdated']
        | components['schemas']['FlowsheetFeedback']
      )[];
    };
    /**
     * NebulaSessionCreateRequest
     * @description ``POST /v1/session`` body per Epic's Create Session spec.
     *
     *     ``from_prod`` is shown in Epic's example but missing from the spec
     *     table; we accept it as optional (default False) to match what real
     *     requests send without rejecting the call.
     */
    NebulaSessionCreateRequest: {
      /** Sessionid */
      sessionId: string;
      /** Userid */
      userId: components['schemas']['IDTypeRequest'][];
      /** Patientid */
      patientId: components['schemas']['IDTypeRequest'][];
      /** Encounterid */
      encounterId: components['schemas']['IDTypeRequest'][];
      /** Licensekey */
      licenseKey: string;
      /** Interconnecturl */
      interconnectUrl: string;
      context?: components['schemas']['NebulaContextRequest'] | null;
      /**
       * Fromprod
       * @default false
       */
      fromProd: boolean;
    };
    /**
     * NebulaSessionEditedRequest
     * @description ``POST /v1/session/{session_id}/edited`` body — Session Data Edited.
     *
     *     Spec only specifies ``editedIds``: the list of GeneratedObject UIDs
     *     the user has edited (currently always NoteSection UIDs per Epic's
     *     integration guide). The session_id arrives only via the path —
     *     there is no body-level redundant copy to validate against.
     */
    NebulaSessionEditedRequest: {
      /** Editedids */
      editedIds: string[];
    };
    /**
     * NebulaSessionEmptyResponse
     * @description Empty success body for ``POST /v1/session`` and ``DELETE /v1/session/{id}``.
     *
     *     Epic's spec only documents the success status codes (200) with no
     *     response schema. We serialize an empty JSON object (``{}``) so a
     *     client that does parse the body always gets well-formed JSON, and
     *     the explicit Pydantic model gives OpenAPI / type-checkers something
     *     concrete to point at instead of bare ``dict``.
     */
    NebulaSessionEmptyResponse: Record<string, never>;
    /**
     * NebulaSessionFeedbackRequest
     * @description ``POST /v1/session/{session_id}/feedback`` body — Session Feedback Data.
     *
     *     ``sessionId`` is again a redundant copy of the path parameter and
     *     cross-validated by the handler. ``version`` and ``objects`` are the
     *     full final state of the session per Epic's spec — for flowsheets
     *     sessions, ``objects`` may include ``FlowsheetUpdated`` and
     *     ``FlowsheetFeedback`` rows alongside the regular generated objects.
     */
    NebulaSessionFeedbackRequest: {
      /** Sessionid */
      sessionId: string;
      /** Version */
      version: number;
      /** Objects */
      objects: (
        | components['schemas']['dataclass__nebula_session__generated_data__note_section__NoteSection']
        | components['schemas']['Order']
        | components['schemas']['Medication']
        | components['schemas']['Diagnosis']
        | components['schemas']['Flowsheet']
        | components['schemas']['FlowsheetUpdated']
        | components['schemas']['FlowsheetFeedback']
      )[];
    };
    /**
     * NebulaSessionFinalizedRequest
     * @description ``POST /v1/session/{session_id}/finalized`` body — Session Finalized.
     *
     *     Epic's spec body is empty (the path parameter alone identifies
     *     the session being finalized). Defining an explicit empty model
     *     keeps the OpenAPI schema honest and lets future spec additions
     *     (e.g. a finalization timestamp) extend this class without changing
     *     the handler signature.
     */
    NebulaSessionFinalizedRequest: Record<string, never>;
    /**
     * NebulaSessionNotFoundResponse
     * @description Spec-mandated 404 body for ``DELETE /v1/session/{sessionId}``.
     *
     *     Epic's docs require the literal payload ``{"title": "Session not found."}``;
     *     locking the value with ``Literal`` makes that contract explicit.
     *     Used as the OpenAPI response model in ``responses=`` and as the
     *     runtime body inside ``NebulaSessionNotFoundJSONResponse``.
     */
    NebulaSessionNotFoundResponse: {
      /**
       * Title
       * @default Session not found.
       * @constant
       */
      title: 'Session not found.';
    };
    /**
     * NebulaTemplateSource
     * @example grid
     * @example mobile
     */
    NebulaTemplateSource: string;
    /** NeverEnd */
    NeverEnd: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: NeverEndKind;
    };
    /**
     * NoMetadata
     * @description Sentinel metadata for subscription types that carry no extra data.
     */
    NoMetadata: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: NoMetadataKind;
    };
    /** NoteContext */
    NoteContext: {
      /**
       * Notesections
       * @description Returns which note sections are available to be written to
       */
      noteSections: components['schemas']['pkg__ehr__third_party_ambient_audio__haiku__models__note_sections__NoteSection'][];
    };
    /** NoteContextRequest */
    NoteContextRequest: {
      type?: components['schemas']['NebulaNoteTypeCode'] | null;
      /** Notesections */
      noteSections?: components['schemas']['NebulaNoteSectionCode'][] | null;
    };
    /** NoteCreatedEvent */
    NoteCreatedEvent: {
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Consult Note Id */
      consult_note_id: string;
      /** User Name */
      user_name?: string | null;
      /** Template Name */
      template_name?: string | null;
      /** Original Note */
      original_note: string;
      /** Patches */
      patches?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      brain?: components['schemas']['Brain'] | null;
      /**
       * Type
       * @default note_created
       * @constant
       */
      type: 'note_created';
    };
    NoteOptionEhrId: string;
    /**
     * NuhFeedbackArea
     * @enum {string}
     */
    NuhFeedbackArea: NuhFeedbackArea;
    /**
     * NuhFeedbackPrompt
     * @enum {string}
     */
    NuhFeedbackPrompt: NuhFeedbackPrompt;
    /**
     * NuhFeedbackScore
     * @description 1–5 rating on the template's scale (1 Poor … 5 Excellent).
     */
    NuhFeedbackScore: 1 | 2 | 3 | 4 | 5;
    /**
     * NuhFeedbackStatus
     * @enum {string}
     */
    NuhFeedbackStatus: NuhFeedbackStatus;
    /**
     * NotePages
     * @enum {string}
     */
    NotePages: NotePages;
    /**
     * NotePushExecutionPlan
     * @description FE-authored canonical note-push plan — identity + confirmed mapping only.
     *
     *     Carries NO clinical content: the note text is fetched server-side by
     *     ``session_id`` and never rides in this object.
     */
    NotePushExecutionPlan: {
      /** Workspace Id */
      workspace_id: string;
      /** Session Id */
      session_id: string;
      /** App Name */
      app_name: string;
      /** Template Id */
      template_id?: string | null;
      /** Note Revision */
      note_revision?: string | null;
      /** Placements */
      placements: components['schemas']['NotePushPlacement'][];
      /** Already Placed Selectors */
      already_placed_selectors?: string[];
    };
    /**
     * NotePushHintRow
     * @description One stored ``section -> single EMR field selector`` mapping.
     *
     *     ``ui_targets`` is a length-1 list (kept a list for wire compatibility):
     *     a Heidi section maps to at most one EMR field. Several sections sharing
     *     one field are separate rows repeating that one selector.
     *
     *     A structured row carries ``mapping`` instead — the cases a note is
     *     classified into and the control state each wants. Exactly one of the two is
     *     populated, mirroring the row itself.
     */
    NotePushHintRow: {
      /** Section Heading */
      section_heading: string;
      /** Ui Targets */
      ui_targets?: string[] | null;
      mapping?: components['schemas']['StructuredMapping'] | null;
      /** App Name */
      app_name: string | null;
    };
    /**
     * NotePushHintsResponse
     * @description The shared read-after-write envelope returned by GET and POST.
     */
    NotePushHintsResponse: {
      /** Rows */
      rows: components['schemas']['NotePushHintRow'][];
    };
    /**
     * NotePushPlacement
     * @description One confirmed ``section -> single EMR selector`` mapping.
     */
    NotePushPlacement: {
      /** Section Heading */
      section_heading: string;
      /** Selector */
      selector: string;
    };
    /** NotePushQuotaView */
    NotePushQuotaView: {
      /** Current Count */
      current_count: number;
      /** Remaining */
      remaining: number;
      /** Is Quota Enabled */
      is_quota_enabled: boolean;
    };
    /** NoteRegeneratedEvent */
    NoteRegeneratedEvent: {
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Consult Note Id */
      consult_note_id: string;
      /** User Name */
      user_name?: string | null;
      /** Template Name */
      template_name?: string | null;
      /** Original Note */
      original_note: string;
      /** Patches */
      patches?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      brain?: components['schemas']['Brain'] | null;
      /**
       * Type
       * @default note_regenerated
       * @constant
       */
      type: 'note_regenerated';
    };
    /** NoteRevertedEvent */
    NoteRevertedEvent: {
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Consult Note Id */
      consult_note_id: string;
      /** User Name */
      user_name?: string | null;
      /** Template Name */
      template_name?: string | null;
      /**
       * Type
       * @default note_reverted
       * @constant
       */
      type: 'note_reverted';
      /** Revert Id */
      revert_id: string;
      /** From Consult Note Id */
      from_consult_note_id: string;
      /** To Consult Note Id */
      to_consult_note_id: string;
      /** Original Note */
      original_note: string;
    };
    /**
     * NoteSectionCode
     * @example 10164-2
     * @example 51847-2
     * @example 29545-1
     * @example 30954-2
     * @example 86467-8
     * @example 96335-5
     */
    NoteSectionCode: string;
    /**
     * NoteSectionCoding
     * @description Coding with LOINC note section codes.
     */
    NoteSectionCoding: {
      code?: components['schemas']['NoteSectionCode'] | null;
      codeSystem?:
        | components['schemas']['dataclass__nebula_session__generated_data__common__CodeSystem']
        | null;
      /** Display */
      display?: string | null;
    };
    /** NoteSectionReturnObject */
    NoteSectionReturnObject: {
      /**
       * Sectionid
       * @description The unique ID for the section.
       */
      sectionID: string;
      /**
       * Text
       * @description The text of the section.
       */
      text: string;
    };
    /**
     * NoteStructure
     * @description this enum is for Note Structure Options
     * @enum {string}
     */
    NoteStructure: NoteStructure;
    /** NoteStructureOptionsResponse */
    NoteStructureOptionsResponse: {
      /** Note Structure Options */
      note_structure_options: components['schemas']['NoteStructure'][];
    };
    /**
     * NotificationChannel
     * @enum {string}
     */
    NotificationChannel: NotificationChannel;
    /** NotificationFailureResponse */
    NotificationFailureResponse: {
      /** Email */
      email: string;
      /** Reason */
      reason: string;
    };
    /**
     * NotificationGroup
     * @enum {string}
     */
    NotificationGroup: NotificationGroup;
    /**
     * NotificationStatus
     * @enum {string}
     */
    NotificationStatus: NotificationStatus;
    /** NotifyTeamRequest */
    NotifyTeamRequest: {
      /**
       * Workspace Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      workspace_id: string;
      /**
       * Notification Name
       * @constant
       */
      notification_name: 'inbox_new_message';
      /** Message Id */
      message_id: string;
    };
    /** NotifyTeamResponse */
    NotifyTeamResponse: {
      /** Notified Count */
      notified_count: number;
    };
    /** NudgeCardView */
    NudgeCardView: {
      /** Protocol Id */
      protocol_id: string;
      /** Display Name */
      display_name: string;
      /** Summary */
      summary?: string | null;
      /** Catalogue Version */
      catalogue_version: string;
      /** Status */
      status: string;
      /** Source */
      source: string;
      /**
       * Surfaced At
       * Format: date-time
       */
      surfaced_at: string;
      /** Dismissed At */
      dismissed_at?: string | null;
      /** Sections */
      sections: components['schemas']['SectionModel'][];
      /** Special Notes */
      special_notes: components['schemas']['SpecialNoteView'][];
      trigger: components['schemas']['TriggerView'];
      /** Item States */
      item_states: {
        [key: string]: components['schemas']['ItemStateView'];
      };
      /** Suggestions */
      suggestions?: components['schemas']['ItemSuggestionView'][];
      /** Trigger Evidence */
      trigger_evidence: string;
    };
    /** NudgeListView */
    NudgeListView: {
      /** Cards */
      cards: components['schemas']['NudgeCardView'][];
    };
    /** NudgeProtocolListResponse */
    NudgeProtocolListResponse: {
      /** Protocols */
      protocols: components['schemas']['NudgeProtocolResponse'][];
    };
    /**
     * NudgeProtocolResponse
     * @description The WORKING DRAFT (always editable) plus its live-version state. What fires is the
     *     separate frozen live version, summarised by the ``is_live`` / ``live_*`` /
     *     ``has_unpublished_changes`` fields; clients must read those, not ``protocol.status``
     *     (always ``draft`` on the working doc, except legacy pre-migration documents).
     */
    NudgeProtocolResponse: {
      /** Id */
      id: string;
      /** Org Id */
      org_id: string;
      protocol: components['schemas']['ProtocolModel'];
      /** Outline */
      outline: string;
      /** Triggering Codes */
      triggering_codes: components['schemas']['TriggeringCodeModel'][];
      /** Confusable With */
      confusable_with: string[];
      surfacing_config: components['schemas']['SurfacingConfigModel'];
      /** Test Cases */
      test_cases: components['schemas']['ProtocolTestCaseModel'][];
      authoring_mode: components['schemas']['AuthoringMode'];
      /**
       * Safety Critical
       * @default false
       */
      safety_critical: boolean;
      /** Source Raw Text */
      source_raw_text?: string | null;
      /**
       * Is Live
       * @default false
       */
      is_live: boolean;
      /** Live Version */
      live_version?: number | null;
      /** Live Published By */
      live_published_by?: string | null;
      /** Live Published At */
      live_published_at?: string | null;
      /**
       * Has Unpublished Changes
       * @default false
       */
      has_unpublished_changes: boolean;
      /** Created By */
      created_by: string;
      /** Updated By */
      updated_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * NudgeProtocolUpsertRequest
     * @description Full protocol payload from the dashboard editor (or the raw-text→JSON parser). Used for
     *     create and full-replace update — both write ONLY the working draft; a live protocol keeps
     *     firing its last-published version unchanged until an explicit re-publish. Server-managed
     *     fields (org_id, audit, timestamps) are NOT accepted from the client; going live is the
     *     separate ``:publish`` action.
     */
    NudgeProtocolUpsertRequest: {
      protocol: components['schemas']['ProtocolModel'];
      /** Triggering Codes */
      triggering_codes?: components['schemas']['TriggeringCodeModel'][];
      /** Confusable With */
      confusable_with?: string[];
      surfacing_config?: components['schemas']['SurfacingConfigModel'];
      /** Test Cases */
      test_cases?: components['schemas']['ProtocolTestCaseModel'][];
      /** @default manual */
      authoring_mode: components['schemas']['AuthoringMode'];
      /**
       * Safety Critical
       * @default false
       */
      safety_critical: boolean;
      /** Source Raw Text */
      source_raw_text?: string | null;
    };
    /** NudgeProtocolVersionListResponse */
    NudgeProtocolVersionListResponse: {
      /** Versions */
      versions: components['schemas']['NudgeProtocolVersionSummaryResponse'][];
    };
    /**
     * NudgeProtocolVersionSummaryResponse
     * @description One entry in a protocol's published-version history (for the history / rollback UI).
     */
    NudgeProtocolVersionSummaryResponse: {
      /** Version */
      version: number;
      /** Published By */
      published_by: string;
      /**
       * Published At
       * Format: date-time
       */
      published_at: string;
      /** Is Live */
      is_live: boolean;
    };
    /**
     * OAuthErrorResponse
     * @description RFC 6749 Section 5.2 error response.
     */
    OAuthErrorResponse: {
      /**
       * Error
       * @description OAuth 2.0 error code (e.g. 'invalid_request', 'invalid_client', 'invalid_grant', 'unsupported_grant_type').
       */
      error: string;
      /** Error Description */
      error_description?: string | null;
    };
    /** OHIPDXCodeConcept */
    OHIPDXCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /** OPCS410CodeConcept */
    OPCS410CodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * ObservationCategory
     * @description Codes for high level observation categories.
     *
     *     https://hl7.org/fhir/R4/valueset-observation-category.html
     * @enum {string}
     */
    ObservationCategory: ObservationCategory;
    /**
     * ObservationComponent
     * @description Component results.
     *
     *     Some observations have multiple component observations. These component
     *     observations are expressed as separate code value pairs that share the same
     *     attributes. Examples include systolic and diastolic component observations
     *     for blood pressure measurement.
     *
     *     https://hl7.org/fhir/R4/observation-definitions.html#Observation.component
     */
    ObservationComponent: {
      /**
       * Type of component observation (code / type)
       * @description Describes what was observed. Sometimes this is called the observation "code".
       */
      code: components['schemas']['CodeableConcept'];
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueString?: string | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueBoolean?: boolean | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueInteger?: number | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueRange?: components['schemas']['Range'] | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueRatio?: components['schemas']['Ratio'] | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueSampledData?: components['schemas']['SampledData'] | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueTime?: string | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueDateTime?: string | null;
      /**
       * Actual component result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valuePeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Why the component result is missing
       * @description Provides a reason why the expected value in the element Observation.component.value[x] is missing.
       */
      dataAbsentReason?: components['schemas']['CodeableConcept'] | null;
      /**
       * High, low, normal, etc.
       * @description A categorical assessment of an observation value. For example, high, low, normal.
       */
      interpretation?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Provides guide for interpretation of component result
       * @description Guidance on how to interpret the value by comparison to a normal or recommended range.
       */
      referenceRange?: components['schemas']['ObservationReferenceRange'][] | null;
    };
    /**
     * ObservationContext
     * @description Context to help identify where an observation value belongs.
     */
    ObservationContext: {
      code: components['schemas']['ContextCode'];
    };
    /**
     * ObservationReferenceRange
     * @description Provides guide for interpretation of component result.
     *
     *     Guidance on how to interpret the value by comparison to a normal or
     *     recommended range. Multiple reference ranges are interpreted as an "OR".
     *
     *     https://hl7.org/fhir/R4/observation-definitions.html#Observation.referenceRange
     */
    ObservationReferenceRange: {
      /**
       * Low Range, if relevant
       * @description The value of the low bound of the reference range. The low bound of the reference range endpoint is inclusive of the value (e.g. reference range is >=5 - <=9). If the low bound is omitted, it is assumed to be meaningless (e.g. reference range is <=2.3).
       */
      low?: components['schemas']['Quantity'] | null;
      /**
       * High Range, if relevant
       * @description The value of the high bound of the reference range. The high bound of the reference range endpoint is inclusive of the value (e.g. reference range is >=5 - <=9). If the high bound is omitted, it is assumed to be meaningless (e.g. reference range is >= 2.3).
       */
      high?: components['schemas']['Quantity'] | null;
      /**
       * Reference range qualifier
       * @description Codes to indicate the what part of the targeted reference population it applies to. For example, the normal or therapeutic range.
       */
      type?: components['schemas']['CodeableConcept'] | null;
      /**
       * Reference range population
       * @description Codes to indicate the target population this reference range applies to. For example, a reference range may be based on the normal population or a particular sex or race.
       */
      appliesTo?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Applicable age range, if relevant
       * @description The age at which this reference range is applicable. This is a neonatal age (e.g. number of weeks at term) if the meaning says so.
       */
      age?: components['schemas']['Range'] | null;
      /**
       * Text based reference range in an observation
       * @description Text based reference range in an observation which may be used when a quantitative range is not appropriate for an observation. An example would be a reference value of "Negative" or a list or table of "normals".
       */
      text?: string | null;
    };
    /**
     * ObservationStatus
     * @description Codes providing the status of an observation.
     *
     *     https://hl7.org/fhir/R4/valueset-observation-status.html
     * @enum {string}
     */
    ObservationStatus: ObservationStatus;
    /**
     * OcrQualityResponse
     * @description Coarse OCR text-extraction quality surfaced to the FE (EVI-1625).
     *
     *     Mirrors the ``label`` recorded in ``UserDocument.document_metadata["ocr_quality"]``
     *     at ingestion. Only the coarse label is exposed — the underlying score / signal
     *     stay server-side. Absent on documents uploaded before this feature shipped
     *     (backfilled later via a separate job), so the FE treats a missing field as
     *     "no badge".
     *
     *     ``extra="ignore"`` so the richer stored shape (score, signal) is
     *     silently dropped when validating the persisted dict.
     */
    OcrQualityResponse: {
      /**
       * Label
       * @description Coarse text-extraction quality outcome for the document.
       * @enum {string}
       */
      label: OcrQualityResponseLabel;
    };
    /** OkResponse */
    OkResponse: {
      /**
       * Ok
       * @default true
       */
      ok: boolean;
    };
    /** OnboardingOptionsResponse */
    OnboardingOptionsResponse: {
      /** Specialties */
      specialties: components['schemas']['schemas__response__SimpleSpecialtyResponse'][];
      /** Ehr Providers */
      ehr_providers: components['schemas']['EHRProvider'][];
    };
    /**
     * OnboardingOutcome
     * @enum {string}
     */
    OnboardingOutcome: OnboardingOutcome;
    /** OnboardingScriptResponse */
    OnboardingScriptResponse: {
      /** Onboarding Script */
      onboarding_script?: string | null;
    };
    /**
     * OnboardingSessionDeleteResponse
     * @description Response model for deleted onboarding session.
     */
    OnboardingSessionDeleteResponse: {
      /** Id */
      _id: string;
      /** Deleted At */
      deleted_at?: string | null;
    };
    /**
     * OnboardingSessionListItemResponse
     * @description Response model for an onboarding session list item.
     */
    OnboardingSessionListItemResponse: {
      /** Id */
      _id: string;
      /** User Id */
      user_id: string;
      /** Provider */
      provider: string;
      status: components['schemas']['OnboardingSessionStatus'];
      /**
       * Expires At
       * Format: date-time
       */
      expires_at: string;
      /** Current Step Number */
      current_step_number: number | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
    };
    /**
     * OnboardingSessionListResponse
     * @description Response model for paginated onboarding session list.
     */
    OnboardingSessionListResponse: {
      /** Sessions */
      sessions: components['schemas']['OnboardingSessionListItemResponse'][];
      /** Total Count */
      total_count: number;
      /** Limit */
      limit: number;
      /** Skip */
      skip: number;
      /** Has More */
      has_more: boolean;
    };
    /**
     * OnboardingSessionResponse
     * @description Response model for an onboarding session.
     */
    OnboardingSessionResponse: {
      /** Id */
      _id: string;
      /** User Id */
      user_id: string;
      /** Provider */
      provider: string;
      status: components['schemas']['OnboardingSessionStatus'];
      /**
       * Expires At
       * Format: date-time
       */
      expires_at: string;
      /** Current Step Number */
      current_step_number: number | null;
      /** Steps */
      steps: components['schemas']['OnboardingSessionStepResponse'][];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
    };
    /**
     * OnboardingSessionSortBy
     * @description Sort field options for onboarding session queries.
     * @enum {string}
     */
    OnboardingSessionSortBy: OnboardingSessionSortBy;
    /**
     * OnboardingSessionStatus
     * @description Status values for an integration onboarding session.
     * @enum {string}
     */
    OnboardingSessionStatus: OnboardingSessionStatus;
    /**
     * OnboardingSessionStepResponse
     * @description Response model for an onboarding session step.
     */
    OnboardingSessionStepResponse: {
      /** Step Id */
      step_id: string;
      /** Step Type */
      step_type: string;
      /** Step Number */
      step_number: number;
      /** Status */
      status: string;
      /** Details */
      details: {
        [key: string]: unknown;
      };
      /** Payload */
      payload?: {
        [key: string]: unknown;
      } | null;
      /** Result */
      result?: {
        [key: string]: unknown;
      } | null;
      /** Error */
      error?: {
        [key: string]: unknown;
      } | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * OnboardingSessionWithFunctionalityDetailsResponse
     * @description Response model for an onboarding session with adaptor functionality details.
     */
    OnboardingSessionWithFunctionalityDetailsResponse: {
      session: components['schemas']['OnboardingSessionResponse'];
      /** Functionality Details */
      functionality_details?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * OnboardingStatus
     * @enum {string}
     */
    OnboardingStatus: OnboardingStatus;
    /**
     * OnboardingTask
     * @enum {string}
     */
    OnboardingTask: OnboardingTask;
    /**
     * OnboardingV2AssetsResponse
     * @description Batch payload of onboarding-v2 specialty assets.
     *
     *     ``transcript``/``note``/``abbreviations`` are single localized strings.
     *     ``evidence_queries``/``evidence_responses``/``documents`` are parallel lists
     *     (three suggested evidence questions + their answers, and three suggested
     *     documents). For non-English locales the first element stays localized while
     *     the two additional elements fall back to English until translated.
     */
    OnboardingV2AssetsResponse: {
      /** Transcript */
      transcript: string;
      /** Note */
      note: string;
      /** Abbreviations */
      abbreviations: string;
      /** Evidence Queries */
      evidence_queries: string[];
      /** Evidence Responses */
      evidence_responses: string[];
      /** Documents */
      documents: components['schemas']['OnboardingV2DocumentField'][];
    };
    /**
     * OnboardingV2DocumentField
     * @description `document_type` + body parsed from documents/<slug>.md frontmatter.
     */
    OnboardingV2DocumentField: {
      /** Type */
      type: string;
      /** Body */
      body: string;
    };
    /** OpenAPIAddDoNotAskLanguageResponse */
    OpenAPIAddDoNotAskLanguageResponse: {
      /** Do Not Ask Languages */
      do_not_ask_languages: components['schemas']['LanguageCode'][];
    };
    /** OpenAPIAddNewCodeRequest */
    OpenAPIAddNewCodeRequest: {
      /** Code */
      code: string;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
      /** Enabled Code Systems */
      enabled_code_systems?:
        | components['schemas']['domains__coding__pkg__enums__CodeSystem'][]
        | null;
    };
    /** OpenAPIAskAIRequestV2 */
    OpenAPIAskAIRequestV2: {
      /** Ai Command Text */
      ai_command_text?: string | null;
      /** Content */
      content: string;
      content_type?: components['schemas']['ContentType'] | null;
    };
    /** OpenAPIBatchDeleteSessionRequest */
    OpenAPIBatchDeleteSessionRequest: {
      /** Session Id List */
      session_id_list: string[];
    };
    /** OpenAPIChangeSubscriptionPlanRequest */
    OpenAPIChangeSubscriptionPlanRequest: {
      /**
       * Vendor
       * @default stripe
       * @constant
       */
      vendor: 'stripe';
      period: components['schemas']['shared__enums__enums__Period'];
      tier: components['schemas']['SubscriptionTier'];
      free_trial_days?: components['schemas']['StripeFreeTrialDays'] | null;
    };
    /** OpenAPIConfirmClinicalCodeRequest */
    OpenAPIConfirmClinicalCodeRequest: {
      /** Codes */
      codes: components['schemas']['ClinicalCodeConfirmation'][];
    };
    /**
     * OpenAPIConvertPlainTextNoteToSectionalNoteResponse
     * @description Response model for converting plain text note to sectional note
     */
    OpenAPIConvertPlainTextNoteToSectionalNoteResponse: {
      /**
       * Clinical Note
       * @description The structured clinical note with sections that can be linked to EHR or use standardized format
       */
      clinical_note: {
        [key: string]:
          | string
          | components['schemas']['LinkedSectionContent']
          | components['schemas']['StandardizedSectionalNote'];
      };
    };
    /** OpenAPICreateCheckoutRequest */
    OpenAPICreateCheckoutRequest: {
      /**
       * Vendor
       * @default stripe
       * @constant
       */
      vendor: 'stripe';
      period: components['schemas']['shared__enums__enums__Period'];
      tier: components['schemas']['SubscriptionTier'];
      /** Fe Endpoint */
      fe_endpoint: string;
      /** Fe Return Endpoint */
      fe_return_endpoint?: string | null;
      /** Client Reference Id */
      client_reference_id?: string | null;
      /** Coupon Id */
      coupon_id?: string | null;
      /**
       * Free Trial Days
       * @description Free trial days, must be between 0 and 30 days
       */
      free_trial_days?: number | components['schemas']['StripeFreeTrialDays'] | null;
      /**
       * Cc Required
       * @default false
       */
      cc_required: boolean;
      /** Amplitude Device Id */
      amplitude_device_id?: string | null;
      /** Amplitude Session Id */
      amplitude_session_id?: number | null;
    };
    /** OpenAPICreateCheckoutSessionResponse */
    OpenAPICreateCheckoutSessionResponse: {
      /** Checkout Session Url */
      checkout_session_url: string;
    };
    /** OpenAPICreateLiveTranscriptionResponse */
    OpenAPICreateLiveTranscriptionResponse: {
      /** Recording Id */
      recording_id: string;
    };
    /** OpenAPICreatePatientProfileRequest */
    OpenAPICreatePatientProfileRequest: {
      ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Patient Sex Code */
      patient_sex_code?: number | null;
      /** Birth Date */
      birth_date?: string | null;
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Demographic String */
      demographic_string?: string | null;
      /** Additional Context */
      additional_context?: string | null;
    };
    /** OpenAPICreatePatientProfileResponse */
    OpenAPICreatePatientProfileResponse: {
      data: components['schemas']['PatientProfileModel'];
    };
    /**
     * OpenAPICreateSessionRequest
     * @description Create-session body for Open API partners.
     *
     *     Declares only the fields the Open API create handler actually wires.
     *     Unused shared ``CreateSessionRequest`` fields (``is_auto_mode``,
     *     ``session_status``, ``creation_platform``) are intentionally omitted so
     *     they do not appear in the partner OpenAPI docs as if they were supported.
     *
     *     ``template_id`` is a per-session override stamped onto
     *     ``session.consult_note`` at create time (user preferences are never
     *     modified). Omit / ``null`` keeps the user's saved default template —
     *     that is not the same as ``"AUTO_MODE"``, which selects automatic
     *     template selection for this session only. An unknown or inaccessible
     *     ObjectId returns 4xx and never silently falls back.
     *
     *     ``patient_profile_id``, ``ehr_patient_id``, ``ehr_appt_id``, and
     *     ``created_time_local`` collapse the create-session +
     *     update-session-metadata + link-patient call sequence into this single
     *     request: ``patient_profile_id`` must belong to the resolved active user
     *     (same ownership check as ``POST /patient-profiles/{id}/sessions``) or
     *     the request fails with 400; ``ehr_patient_id``/``ehr_appt_id`` are
     *     applied in the same internal metadata write that already stamps
     *     ``is_open_api_session``/``ehr_provider``; a tz-aware
     *     ``created_time_local`` is normalized to a naive local wall-clock value
     *     before it is stored (see ``shared.timezone.to_naive_local_wall_clock``), the
     *     same convention ``Session.created_time_local`` uses everywhere else. All
     *     four are optional and additive — omitting them leaves behavior
     *     unchanged.
     */
    OpenAPICreateSessionRequest: {
      /** Timezone */
      timezone?: string | null;
      language_code?: components['schemas']['LanguageCode'] | null;
      /** Language Code List */
      language_code_list?: components['schemas']['LanguageCode'][] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Template Id */
      template_id?: string | 'AUTO_MODE' | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Created Time Local */
      created_time_local?: string | null;
    };
    /** OpenAPICreateSessionResponse */
    OpenAPICreateSessionResponse: {
      /** Session Id */
      session_id: string;
      /**
       * Is Consent
       * @default false
       */
      is_consent: boolean | null;
    };
    /** OpenAPIDeleteDocumentResponse */
    OpenAPIDeleteDocumentResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /** OpenAPIDeletePatientProfilesRequest */
    OpenAPIDeletePatientProfilesRequest: {
      /** Patient Profile Ids */
      patient_profile_ids: string[];
    };
    /** OpenAPIDeleteSessionContextDocumentsRequest */
    OpenAPIDeleteSessionContextDocumentsRequest: {
      /** Ids */
      ids: string[];
    };
    /** OpenAPIDeleteSessionContextDocumentsResponse */
    OpenAPIDeleteSessionContextDocumentsResponse: {
      /** Success */
      success: boolean;
    };
    /** OpenAPIDeleteSessionResponse */
    OpenAPIDeleteSessionResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /** OpenAPIDocumentAICommandsResponseV2 */
    OpenAPIDocumentAICommandsResponseV2: {
      /**
       * Ai Commands
       * @default []
       */
      ai_commands: components['schemas']['AICommandResponseV2'][];
    };
    /** OpenAPIDocumentResponse */
    OpenAPIDocumentResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /** Index */
      index?: number | null;
      /** Name */
      name?: string | null;
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Question */
      question?: string | null;
      /** Content */
      content?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      generation_type?: components['schemas']['DocumentGenType'] | null;
      /** @default LEFT */
      brain: components['schemas']['Brain'];
    };
    /** OpenAPIDocumentResponseV2 */
    OpenAPIDocumentResponseV2: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /** Index */
      index?: number | null;
      /** Name */
      name?: string | null;
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Question */
      question?: string | null;
      /** Content */
      content?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      generation_type?: components['schemas']['DocumentGenType'] | null;
      /** @default LEFT */
      brain: components['schemas']['Brain'];
    };
    /** OpenAPIDocumentView */
    OpenAPIDocumentView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /** Creator Kinde Id */
      creator_kinde_id?: string | null;
      /** Index */
      index?: number | null;
      /** Name */
      name?: string | null;
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Question */
      question?: string | null;
      /** Original Content */
      original_content?: string | null;
      /** Content */
      content?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      generation_type?: components['schemas']['DocumentGenType'] | null;
      /** @default LEFT */
      brain: components['schemas']['Brain'];
      voice_style?: components['schemas']['VoiceStyle'] | null;
      content_type?: components['schemas']['ContentType'] | null;
      /** Generation Time */
      generation_time?: string | null;
    };
    /** OpenAPIFinishRecordingResponse */
    OpenAPIFinishRecordingResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /**
     * OpenAPIGenerateConsultNoteRequest
     * @description template_id, third_party_template are mutually exclusive
     */
    OpenAPIGenerateConsultNoteRequest: {
      generation_method: components['schemas']['GenerationMethod'];
      /** Template Id */
      template_id?: string | null;
      /** Third Party Template */
      third_party_template?: string | null;
      /**
       * Addition
       * @default
       */
      addition: string;
      voice_style: components['schemas']['VoiceStyle'];
      brain?: components['schemas']['Brain'] | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      content_type?: components['schemas']['ContentType'] | null;
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      /**
       * Ignore Backup
       * @default false
       */
      ignore_backup: boolean;
      generation_mode?: components['schemas']['GenerationMode'] | null;
    };
    /** OpenAPIGenerateDocumentContentRequestV2 */
    OpenAPIGenerateDocumentContentRequestV2: {
      /** @default DOCUMENT */
      document_tab_type: components['schemas']['DocumentTabType'] | null;
      generation_method: components['schemas']['GenerationMethod'];
      /** Template Id */
      template_id?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      brain?: components['schemas']['Brain'] | null;
      /** Index */
      index?: number | null;
      content_type?: components['schemas']['ContentType'] | null;
      /** Live Dictation Text */
      live_dictation_text?: string | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
      /** Is Not Regeneration */
      is_not_regeneration?: boolean | null;
      /** Task Id */
      task_id?: string | null;
    };
    /** OpenAPIGetAddOnProductsResponse */
    OpenAPIGetAddOnProductsResponse: {
      /** Products */
      products: components['schemas']['AddOnProductView'][];
      /** Total Pages */
      total_pages: number;
    };
    /** OpenAPIGetAllProductsResponse */
    OpenAPIGetAllProductsResponse: {
      /** Products */
      products: components['schemas']['ProductView'][];
    };
    /** OpenAPIGetDocumentsResponseV2 */
    OpenAPIGetDocumentsResponseV2: {
      /** Documents */
      documents: components['schemas']['OpenAPIDocumentResponseV2'][];
    };
    /** OpenAPIGetPatientProfileResponse */
    OpenAPIGetPatientProfileResponse: {
      data: components['schemas']['PatientProfileModel'];
    };
    /** OpenAPIGetPatientProfilesResponse */
    OpenAPIGetPatientProfilesResponse: {
      /** Data */
      data: components['schemas']['PatientProfileWithSessionCount'][];
      /** Total Pages */
      total_pages?: number | null;
    };
    /** OpenAPIGetSupportedLanguageResponse */
    OpenAPIGetSupportedLanguageResponse: {
      /** Supported Languages */
      supported_languages: components['schemas']['LanguageView'][];
    };
    /** OpenAPIGetTemplatesResponseV2 */
    OpenAPIGetTemplatesResponseV2: {
      /** Templates */
      templates: components['schemas']['OpenAPITemplateResponseV2'][];
    };
    /** OpenAPIJoinedTeamsResponse */
    OpenAPIJoinedTeamsResponse: {
      /** Joined Teams */
      joined_teams: components['schemas']['JoinedTeamRelation'][];
    };
    /** OpenAPILinkPatientSessionsRequest */
    OpenAPILinkPatientSessionsRequest: {
      /** Session Ids */
      session_ids: string[];
    };
    /** OpenAPILinkPatientSessionsResponse */
    OpenAPILinkPatientSessionsResponse: {
      /** Data */
      data: components['schemas']['MinimumSessionView'][];
    };
    /** OpenAPILinkedAccount */
    OpenAPILinkedAccount: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** User Id */
      user_id: string;
      /** Ehr Provider */
      ehr_provider: string;
      /** Ehr Email */
      ehr_email: string;
      /** Ehr User Id */
      ehr_user_id: string;
      /** Deleted At */
      deleted_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
    };
    /** OpenAPIOrganization */
    OpenAPIOrganization: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Key */
      key: string;
      /** Third Party */
      third_party: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /**
       * Is Active
       * @default true
       */
      is_active: boolean;
      /**
       * Is Reseller Model
       * @default false
       */
      is_reseller_model: boolean;
      /**
       * Is Reseller Org Requires Link Account
       * @default false
       */
      is_reseller_org_requires_link_account: boolean;
      /**
       * Is Freemium Model
       * @default false
       */
      is_freemium_model: boolean;
      /**
       * Is Widget Enabled
       * @default false
       */
      is_widget_enabled: boolean;
      /**
       * Is Open Api Enabled
       * @default false
       */
      is_open_api_enabled: boolean;
      /**
       * Is Link With Email Enabled
       * @default false
       */
      is_link_with_email_enabled: boolean;
      /** Description */
      description?: string | null;
      /** Contact Email */
      contact_email?: string | null;
      /** Created By Email */
      created_by_email?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /**
     * OpenAPIOrganizationMembersResponse
     * @description Response schema for listing organization members in Open API.
     */
    OpenAPIOrganizationMembersResponse: {
      /** Members */
      members?: components['schemas']['OrganizationMembersView'][];
      /**
       * Total
       * @description Total number of members
       * @default 0
       */
      total: number;
      /**
       * Page
       * @description Current page number
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @description Number of members per page
       * @default 10
       */
      page_size: number;
    };
    /** OpenAPIPatientUpdate */
    OpenAPIPatientUpdate: {
      /** Name */
      name?: string | null;
      /** Gender */
      gender?: string | null;
      /** Dob */
      dob?: string | null;
      /** Demographic Details */
      demographic_details?: string | null;
    };
    /** OpenAPIResponse */
    OpenAPIResponse: {
      open_api: components['schemas']['OpenAPIOrganization'] | null;
    };
    /** OpenAPISearchClinicalCodesResponse */
    OpenAPISearchClinicalCodesResponse: {
      /** Codes */
      codes: (
        | components['schemas']['SNOMEDCodeConcept']
        | components['schemas']['ICD10CodeConcept']
        | components['schemas']['MBSAUCodeConcept']
        | components['schemas']['CPTCodeConcept']
        | components['schemas']['ICD10UKCodeConcept']
        | components['schemas']['ICD9CMCodeConcept']
        | components['schemas']['ICD9CACodeConcept']
        | components['schemas']['OPCS410CodeConcept']
        | components['schemas']['ICD10AMCodeConcept']
        | components['schemas']['ACHI13AUCodeConcept']
        | components['schemas']['ICD10GMCodeConcept']
        | components['schemas']['CIM10FRCodeConcept']
        | components['schemas']['CIE10ESCodeConcept']
        | components['schemas']['ICD10ZACodeConcept']
        | components['schemas']['OrphaCodeConcept']
        | components['schemas']['CIM10MCCodeConcept']
        | components['schemas']['CIM10SCPCodeConcept']
        | components['schemas']['OHIPDXCodeConcept']
        | components['schemas']['CPTQACodeConcept']
        | components['schemas']['ICD10QACodeConcept']
        | components['schemas']['ICD10ITCodeConcept']
        | components['schemas']['BaseCodeConcept']
      )[];
    };
    /** OpenAPISessionClinicalCodeResponse */
    OpenAPISessionClinicalCodeResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /**
       * Consult Note Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      consult_note_id: string;
      /** Clinical Entities */
      clinical_entities: components['schemas']['CodedClinicalEntity'][];
      /** Collections Used */
      collections_used?: {
        [key: string]: string;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Generation Completed At */
      generation_completed_at?: string | null;
      feedback?: components['schemas']['Feedback'] | null;
      em_level?: components['schemas']['SessionEmLevel'] | null;
    };
    /** OpenAPISessionClinicalCodeResponseWithSuccess */
    OpenAPISessionClinicalCodeResponseWithSuccess: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /**
       * Consult Note Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      consult_note_id: string;
      /** Clinical Entities */
      clinical_entities: components['schemas']['CodedClinicalEntity'][];
      /** Collections Used */
      collections_used?: {
        [key: string]: string;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Generation Completed At */
      generation_completed_at?: string | null;
      feedback?: components['schemas']['Feedback'] | null;
      em_level?: components['schemas']['SessionEmLevel'] | null;
      /** Success */
      success: boolean[];
    };
    /** OpenAPISessionContextDocumentMetaData */
    OpenAPISessionContextDocumentMetaData: {
      /** Name */
      name?: string | null;
      /** Date */
      date?: string | null;
      /** Additional Context */
      additional_context?: string | null;
      /** Unstructured */
      unstructured?: boolean | null;
    };
    /** OpenAPISessionResponseV2 */
    OpenAPISessionResponseV2: {
      /** Sessions */
      sessions: components['schemas']['SimpleSessionViewV2'][];
      /** Count */
      count: number;
      /** Total Count */
      total_count?: number | null;
      /**
       * Next Page
       * @deprecated
       */
      next_page?: number | null;
      /** Has Next Page */
      has_next_page: boolean;
    };
    /** OpenAPISubmitClinicalCodeFeedbackRequest */
    OpenAPISubmitClinicalCodeFeedbackRequest: {
      feedback: components['schemas']['FeedbackFormRequest'];
      /** Enabled Code Systems */
      enabled_code_systems?:
        | components['schemas']['domains__coding__pkg__enums__CodeSystem'][]
        | null;
    };
    /** OpenAPITemplateResponseV2 */
    OpenAPITemplateResponseV2: {
      /**
       * Is Private
       * @default true
       */
      is_private: boolean;
      /** Team Id */
      team_id?: string | null;
      /** @default User */
      template_author_group: components['schemas']['TemplateAuthorGroup'] | null;
      /** @default User */
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Source Template Id */
      source_template_id?: string | null;
      /**
       * Template Gallery Sharing Preference Show Name
       * @default true
       */
      template_gallery_sharing_preference_show_name: boolean;
      /**
       * Template Gallery Sharing Preference Show Clinic
       * @default true
       */
      template_gallery_sharing_preference_show_clinic: boolean;
      /**
       * Template Gallery Sharing Preference Show Profile Picture
       * @default true
       */
      template_gallery_sharing_preference_show_profile_picture: boolean;
      /**
       * Shared Team Ids
       * @description An array of team_ids that the template is shared with
       */
      shared_team_ids?: string[] | null;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Created Time */
      created_time?: string | null;
      /** Updated Time */
      updated_time?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      /** Template Gallery Url Path */
      template_gallery_url_path?: string | null;
      /**
       * Is Structured Template
       * @default false
       */
      is_structured_template: boolean;
      /**
       * Global Last Used
       * @description Last time the template was used by any user (global usage timestamp)
       */
      global_last_used?: string | null;
      /**
       * Global Usage
       * @description Total number of times the template has been used across all users (global usage counter)
       * @default 0
       */
      global_usage: number;
      /** Last Modified Ia Feedback Loop */
      last_modified_ia_feedback_loop?: string | null;
      /** Name */
      name: string;
      /**
       * Structure Template
       * @default
       */
      structure_template: string;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** @default pdf */
      form_format: components['schemas']['FormFormat'];
      /** Xml Source */
      xml_source?: string | null;
      /** Json Source */
      json_source?: string | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /** List Order Priority */
      list_order_priority?: number | null;
      /**
       * Should Deduct Quota
       * @default true
       */
      should_deduct_quota: boolean;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Organization Id
       * @description The organization_id the template belongs to
       */
      organization_id?: string | null;
      /**
       * Workspace Id
       * @description The workspace_id the template belongs to
       */
      workspace_id?: string | null;
      /** Is Well Formatted */
      is_well_formatted?: boolean | null;
      /** Llm Eval */
      llm_eval?: string | null;
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Usage
       * @default 0
       */
      usage: number;
      /**
       * Is Favorite
       * @default false
       */
      is_favorite: boolean;
      /** Added To Favorite At */
      added_to_favorite_at?: string | null;
      /**
       * Is Pinned
       * @default false
       */
      is_pinned: boolean;
      /** Added To Pinned At */
      added_to_pinned_at?: string | null;
      /** Pinned Sort Order */
      pinned_sort_order?: number | null;
      /** Last Used */
      last_used?: string | null;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /**
       * Is Publishable
       * @default false
       */
      is_publishable: boolean;
      /**
       * Author Name
       * @default
       */
      author_name: string;
      review_status?: components['schemas']['TemplateReviewStatus'] | null;
    };
    /** OpenAPITranscribeChunkResponse */
    OpenAPITranscribeChunkResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /** OpenAPIUnconfirmClinicalCodeRequest */
    OpenAPIUnconfirmClinicalCodeRequest: {
      /** Entity Ids */
      entity_ids: string[];
    };
    /** OpenAPIUnlinkPatientSessionsRequest */
    OpenAPIUnlinkPatientSessionsRequest: {
      /** Session Ids */
      session_ids: string[];
    };
    /** OpenAPIUnlinkPatientSessionsResponse */
    OpenAPIUnlinkPatientSessionsResponse: {
      /** Data */
      data: components['schemas']['MinimumSessionView'][];
    };
    /** OpenAPIUpdateConsultNoteRequest */
    OpenAPIUpdateConsultNoteRequest: {
      /** Result */
      result: string;
    };
    /**
     * OpenAPIUpdateConsultNoteSectionLinkRequest
     * @description Request model for linking consult note sections with EHR section IDs
     */
    OpenAPIUpdateConsultNoteSectionLinkRequest: {
      /** Section Heading */
      section_heading: string;
      /** Linked Ehr Section Id */
      linked_ehr_section_id: string;
    };
    /** OpenAPIUpdateConsultNoteSectionLinkResponse */
    OpenAPIUpdateConsultNoteSectionLinkResponse: {
      consult_note: components['schemas']['ConsultNoteResponseV2'];
    };
    /** OpenAPIUpdateDocumentRequest */
    OpenAPIUpdateDocumentRequest: {
      /** Content */
      content?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      generation_type?: components['schemas']['DocumentGenType'] | null;
      /** Name */
      name?: string | null;
    };
    /** OpenAPIUpdatePatientProfileRequest */
    OpenAPIUpdatePatientProfileRequest: {
      /** Birth Date */
      birth_date?: string | null;
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Demographic String */
      demographic_string?: string | null;
      /** Remember Consent */
      remember_consent?: boolean | null;
      /** Additional Context */
      additional_context?: string | null;
      /** An Acc Class */
      an_acc_class?: string | null;
    };
    /** OpenAPIUpdatePatientProfileResponse */
    OpenAPIUpdatePatientProfileResponse: {
      data: components['schemas']['PatientProfileModel'];
    };
    /** OpenAPIUpdateSessionContextDocumentsRequest */
    OpenAPIUpdateSessionContextDocumentsRequest: {
      /** Context Documents */
      context_documents: components['schemas']['OpenAPIUpdateSingleSessionContextDocument'][];
    };
    /** OpenAPIUpdateSessionRequest */
    OpenAPIUpdateSessionRequest: {
      language_code?: components['schemas']['LanguageCode'] | null;
      /** Language Code List */
      language_code_list?: components['schemas']['LanguageCode'][] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Duration */
      duration?: number | null;
      transcribe_mode?: components['schemas']['TranscribeMode'] | null;
      /** Is Tab Sharing */
      is_tab_sharing?: boolean | null;
      patient?: components['schemas']['OpenAPIPatientUpdate'] | null;
      /** Clinician Notes */
      clinician_notes?: string[] | null;
      consult_note?: components['schemas']['OpenAPIUpdateConsultNoteRequest'] | null;
      /** Latest Consult Note Id */
      latest_consult_note_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Client Customized Qa Template Answer */
      client_customized_qa_template_answer?: string | null;
      /** Generate Output Without Recording */
      generate_output_without_recording?: boolean | null;
      recording_status?: components['schemas']['RecordingStatus'] | null;
      session_status?: components['schemas']['SessionStatus'] | null;
      /** Is Consent */
      is_consent?: boolean | null;
      /** Created Time Local */
      created_time_local?: string | null;
      /** Linked Sessions For Context */
      linked_sessions_for_context?: string[] | null;
      /** Linked Sessions For Context Fallback */
      linked_sessions_for_context_fallback?: boolean | null;
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
    };
    /** OpenAPIUpdateSingleSessionContextDocument */
    OpenAPIUpdateSingleSessionContextDocument: {
      /** Id */
      id: string;
      /** Name */
      name?: string | null;
      /** Date */
      date?: string | null;
      /** Additional Context */
      additional_context?: string | null;
    };
    /** OpenAPIUpdateUserRequest */
    OpenAPIUpdateUserRequest: {
      theme?: components['schemas']['Theme'] | null;
    };
    /**
     * OpenIDProviderMetadata
     * @description OAuth 2.0 Authorization Server Metadata (RFC 8414).
     *
     *     Returned at ``{issuer}/.well-known/openid-configuration`` per OIDC
     *     Discovery 1.0 Section 4.  The ``issuer`` value MUST exactly match
     *     the URL prefix used to fetch this document (Section 4.3).
     */
    OpenIDProviderMetadata: {
      /** Issuer */
      issuer: string;
      /** Token Endpoint */
      token_endpoint: string;
      /** Jwks Uri */
      jwks_uri: string;
      /** Grant Types Supported */
      grant_types_supported: string[];
      /** Token Endpoint Auth Methods Supported */
      token_endpoint_auth_methods_supported: string[];
      /** Token Endpoint Auth Signing Alg Values Supported */
      token_endpoint_auth_signing_alg_values_supported: string[];
    };
    /** OrchestrationCallView */
    OrchestrationCallView: {
      /** Id */
      id: string;
      /** Phone Number */
      phone_number: string;
      /** Start Time */
      start_time: string;
      /** Transcript */
      transcript: string;
      /** Summary */
      summary: string;
      /** Duration Seconds */
      duration_seconds: number;
    };
    /** OrchestrationClinicalTaskView */
    OrchestrationClinicalTaskView: {
      /** Id */
      id: string;
      /** Session Id */
      session_id?: string | null;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      status: components['schemas']['ClinicalTaskStatus'];
      category?: components['schemas']['ClinicalTaskCategory'] | null;
      /**
       * Is Conditional
       * @default false
       */
      is_conditional: boolean;
      /** Source Quote */
      source_quote?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Completed At */
      completed_at?: string | null;
    };
    /** OrchestrationConsultNoteView */
    OrchestrationConsultNoteView: {
      /** Id */
      id: string;
      /** Heading */
      heading: string;
      /** Context */
      context: string;
      /** Transcript */
      transcript: string;
      /** Note */
      note: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** OrchestrationDocumentView */
    OrchestrationDocumentView: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Content */
      content: string;
      /** Template Id */
      template_id?: string | null;
    };
    /** OrchestrationPatientSummaryView */
    OrchestrationPatientSummaryView: {
      /** Patient Profile Id */
      patient_profile_id: string;
      patient_profile: components['schemas']['PatientProfileModel'];
      /** Sessions */
      sessions: components['schemas']['OrchestrationSessionView'][];
      /** Calls */
      calls: components['schemas']['OrchestrationCallView'][];
    };
    /** OrchestrationSessionView */
    OrchestrationSessionView: {
      /** Session Id */
      session_id: string;
      /** Session Name */
      session_name?: string | null;
      /** Session Gist */
      session_gist?: string | null;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /**
       * Duration
       * @default 0
       */
      duration: number;
      /** Consult Notes */
      consult_notes: components['schemas']['OrchestrationConsultNoteView'][];
      /** Clinical Tasks */
      clinical_tasks: components['schemas']['OrchestrationClinicalTaskView'][];
      /** Documents */
      documents: components['schemas']['OrchestrationDocumentView'][];
    };
    /**
     * Order
     * @description A generated order suggestion.
     */
    Order: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: OrderType;
      /** Uid */
      uid: string;
      definition: components['schemas']['OrderDefinition'];
      action: components['schemas']['MedicationAction'];
      /** Associations */
      associations?: components['schemas']['Association'][] | null;
    };
    /**
     * OrderDefinition
     * @description Fallback textual representation for order search.
     */
    OrderDefinition: {
      /** Text */
      text: string;
    };
    /** OrderDose */
    OrderDose: {
      /** Value */
      value: string;
      unit: components['schemas']['OrderUnit'];
    };
    /**
     * OrderFrequency
     * @description How often a medication should be taken.
     *
     *     Example: '2 times per 1 day' -> frequency=2, period=1, period_unit='d'.
     */
    OrderFrequency: {
      /** Frequency */
      frequency?: number | null;
      /** Period */
      period?: number | null;
      periodUnit?: components['schemas']['UCUMTimeUnit'] | null;
    };
    /** OrderListItem */
    OrderListItem: {
      /** Order Id */
      order_id: string;
      /** Hubspot Deal Id */
      hubspot_deal_id?: string | null;
      /** Deal Name */
      deal_name?: string | null;
      /** Customer Name */
      customer_name?: string | null;
      /** Milestone Product */
      milestone_product?: string | null;
      /** Deal Owner */
      deal_owner?: string | null;
      /** Shipping Contact Name */
      shipping_contact_name?: string | null;
      /** Shipping Contact Email */
      shipping_contact_email?: string | null;
      /** Shipping Contact Phone */
      shipping_contact_phone?: string | null;
      /** Shipping Street Address */
      shipping_street_address?: string | null;
      /** Shipping City */
      shipping_city?: string | null;
      /** Shipping State */
      shipping_state?: string | null;
      /** Shipping Postcode */
      shipping_postcode?: string | null;
      /** Shipping Country */
      shipping_country?: string | null;
      /** Amount Total */
      amount_total: number;
      /** Currency */
      currency: string;
      /** Quantity */
      quantity: number;
      status: components['schemas']['OrderStatus'];
      source: components['schemas']['OrderSource'];
      /** Billing System */
      billing_system?: string | null;
      /** Payment Confirmed By */
      payment_confirmed_by?: string | null;
      /** Confirmed At */
      confirmed_at?: string | null;
      /** Erp Order Id */
      erp_order_id?: string | null;
      /** Erp Shipped At */
      erp_shipped_at?: string | null;
      /** Shipping Edited By */
      shipping_edited_by?: string | null;
      /** Shipping Edited At */
      shipping_edited_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Tracking Number */
      tracking_number?: string | null;
      /** Tracking Url */
      tracking_url?: string | null;
      reason_category?: components['schemas']['InternalOrderReasonCategory'] | null;
      /** Reason Notes */
      reason_notes?: string | null;
      /** Created By */
      created_by?: string | null;
      /** Serial Numbers */
      serial_numbers?: string[];
      /** Serial Numbers Updated By */
      serial_numbers_updated_by?: string | null;
      /** Serial Numbers Updated At */
      serial_numbers_updated_at?: string | null;
      /** Deal Category */
      deal_category?: string | null;
      pilot_status?: components['schemas']['PilotStatus'] | null;
      /** Pilot Ended At */
      pilot_ended_at?: string | null;
      /** Pilot Outcome Notes */
      pilot_outcome_notes?: string | null;
      /** Pilot Outcome Recorded By */
      pilot_outcome_recorded_by?: string | null;
      /** Pilot Outcome Recorded At */
      pilot_outcome_recorded_at?: string | null;
    };
    /**
     * OrderRoute
     * @description NCIT codes for route of administration.
     */
    OrderRoute: {
      /** Coding */
      coding: components['schemas']['dataclass__nebula_session__generated_data__common__Coding'][];
    };
    /**
     * OrderSource
     * @enum {string}
     */
    OrderSource: OrderSource;
    /**
     * OrderStatus
     * @enum {string}
     */
    OrderStatus: OrderStatus;
    /**
     * OrderUnit
     * @description UCUM codes for unit of measure.
     */
    OrderUnit: {
      /** Coding */
      coding: components['schemas']['dataclass__nebula_session__generated_data__common__Coding'][];
    };
    /**
     * OrgAdminAuditEvent
     * @description Events triggered by an authenticated org admin acting on members of
     *     their own organization (not by internal admins or platform/system actors).
     *
     *     ``Actor.type`` is ``"User"`` and ``Actor.id`` is the admin's
     *     ``user_ref_id``.
     * @enum {string}
     */
    OrgAdminAuditEvent: OrgAdminAuditEvent;
    /** OrganisationInfo */
    OrganisationInfo: {
      /** Name */
      name?: string | null;
      role?: components['schemas']['OrganisationRole'] | null;
      size?: components['schemas']['OrganisationSize'] | null;
      /** Is Org Survey Dismissed */
      is_org_survey_dismissed?: boolean | null;
    };
    /**
     * OrganisationRole
     * @enum {string}
     */
    OrganisationRole: OrganisationRole;
    /**
     * OrganisationSize
     * @enum {string}
     */
    OrganisationSize: OrganisationSize;
    /**
     * OrganizationBranding
     * @description Organization branding settings for white-labeling the UI.
     */
    OrganizationBranding: {
      /** Domain */
      domain?: string | null;
      /** Organization Name */
      organization_name?: string | null;
      /** Organization Logo Url */
      organization_logo_url?: string | null;
      /** Primary Color */
      primary_color?: string | null;
      /** Secondary Color */
      secondary_color?: string | null;
    };
    /** OrganizationMFARequest */
    OrganizationMFARequest: {
      /** Enable Mfa */
      enable_mfa: boolean;
      /**
       * Org Id
       * @description internal admin directly passes org id (currently kinde) with MFA enabled
       */
      org_id?: string | null;
      /** @description prefer to use method instead of org_id, because org_id input could be wrong. if both are provided, org_id will be ignored */
      mfa_method?: components['schemas']['MFAMethod'] | null;
    };
    /**
     * OrganizationMemberOrdering
     * @enum {string}
     */
    OrganizationMemberOrdering: OrganizationMemberOrdering;
    /**
     * OrganizationMembersResponse
     * @description Response schema for listing organization members.
     */
    OrganizationMembersResponse: {
      /** Members */
      members?: components['schemas']['OrganizationMembersView'][];
      /**
       * Total
       * @description Total number of members
       * @default 0
       */
      total: number;
      /**
       * Page
       * @description Current page number
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @description Number of members per page
       * @default 10
       */
      page_size: number;
    };
    /** OrganizationMembersView */
    OrganizationMembersView: {
      /**
       * Id
       * @description team relation or team invitation database id, used in remove member
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /** Team Name */
      team_name: string;
      user_role: components['schemas']['UserRole'];
      /** User Role List */
      user_role_list: components['schemas']['RoleModel'][];
      /** Kinde User Id */
      kinde_user_id: string;
      /** User Ref Id */
      user_ref_id?: string | null;
      /** Name */
      name: string;
      /** Email */
      email: string | null;
      /** Specialty */
      specialty: string;
      /** Specialty Id */
      specialty_id: string | null;
      /** Country */
      country: string | null;
      /** Invitation Accepted */
      invitation_accepted: boolean;
      /**
       * Is Team Owner
       * @default false
       */
      is_team_owner: boolean;
      kinde_status?: components['schemas']['KindeUserStatus'] | null;
      /** Invitation Expire At */
      invitation_expire_at?: string | null;
      display_language?: components['schemas']['LanguageCode'] | null;
    };
    /**
     * OrganizationOverrideTeamSettingField
     * @description fields that can be overridden by organization setting
     * @enum {string}
     */
    OrganizationOverrideTeamSettingField: OrganizationOverrideTeamSettingField;
    /** OrganizationResponse */
    OrganizationResponse: {
      organization: components['schemas']['OrganizationView'];
    };
    /**
     * OrganizationTeamSummaryView
     * @description Minimal team projection for the list-organization-teams endpoint.
     */
    OrganizationTeamSummaryView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
    };
    /**
     * OrganizationTeamsResponse
     * @description Response schema for listing the teams under an organization.
     */
    OrganizationTeamsResponse: {
      /** Teams */
      teams?: components['schemas']['OrganizationTeamSummaryView'][];
    };
    /** OrganizationView */
    OrganizationView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Owner Kinde Id */
      owner_kinde_id: string;
      /** Name */
      name: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Custom Consent Text */
      custom_consent_text?: string | null;
      /** Hide Remember Consent Checkbox */
      hide_remember_consent_checkbox?: boolean | null;
      /** Require Review Confirmation */
      require_review_confirmation?: boolean | null;
      mfa_info?: components['schemas']['TeamMFAInfo'] | null;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      /** Is Pilot */
      is_pilot?: boolean | null;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[];
      /** Is Allow Self Onboard */
      is_allow_self_onboard: boolean;
      /** Self Onboard Default Role Id */
      self_onboard_default_role_id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Sso Connection Ids
       * @description List of SSO connection IDs for enterprise SSO integration.
       */
      sso_connection_ids?: string[];
      /**
       * Sso Group
       * @description SSO group identifier. Field omitted if not configured, string value if group is configured.
       */
      sso_group?: string | null;
      /**
       * Allow Direct Session Sharing
       * @description When False, direct session sharing is disabled org-wide.
       * @default true
       */
      allow_direct_session_sharing: boolean;
      /**
       * Allow Session Link Sharing
       * @description When False, session link sharing is disabled org-wide.
       * @default false
       */
      allow_session_link_sharing: boolean;
      /**
       * Coding Case Creation Enabled
       * @description When True, completed sessions in this org are eligible to become clinical-coding cases (opt-in, set by internal admins).
       * @default false
       */
      coding_case_creation_enabled: boolean;
      /** @description Organisation-level session-inactivity-timeout override. When set, members of this organisation are signed out automatically after `minutes` of inactivity and cannot override the value for themselves. `None` when no override is configured. */
      session_timeout_info?: components['schemas']['SessionTimeoutInfo'] | null;
      /** @description Organisation-level Evidence settings that cascade to child teams. */
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
      /**
       * Disable Auto Extract
       * @description When True, the post-session patient-context auto-extract review popup is disabled org-wide (cascades to teams and members).
       * @default false
       */
      disable_auto_extract: boolean;
    };
    /** OrganizationWithTeamsResponse */
    OrganizationWithTeamsResponse: {
      organization: components['schemas']['OrganizationWithTeamsView'];
      /**
       * Has Regulation Locked Member
       * @default false
       */
      has_regulation_locked_member: boolean;
    };
    /** OrganizationWithTeamsView */
    OrganizationWithTeamsView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Owner Kinde Id */
      owner_kinde_id: string;
      /** Name */
      name: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Custom Consent Text */
      custom_consent_text?: string | null;
      /** Hide Remember Consent Checkbox */
      hide_remember_consent_checkbox?: boolean | null;
      /** Require Review Confirmation */
      require_review_confirmation?: boolean | null;
      mfa_info?: components['schemas']['TeamMFAInfo'] | null;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      /** Is Pilot */
      is_pilot?: boolean | null;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[];
      /** Is Allow Self Onboard */
      is_allow_self_onboard: boolean;
      /** Self Onboard Default Role Id */
      self_onboard_default_role_id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Sso Connection Ids
       * @description List of SSO connection IDs for enterprise SSO integration.
       */
      sso_connection_ids?: string[];
      /**
       * Sso Group
       * @description SSO group identifier. Field omitted if not configured, string value if group is configured.
       */
      sso_group?: string | null;
      /**
       * Allow Direct Session Sharing
       * @description When False, direct session sharing is disabled org-wide.
       * @default true
       */
      allow_direct_session_sharing: boolean;
      /**
       * Allow Session Link Sharing
       * @description When False, session link sharing is disabled org-wide.
       * @default false
       */
      allow_session_link_sharing: boolean;
      /**
       * Coding Case Creation Enabled
       * @description When True, completed sessions in this org are eligible to become clinical-coding cases (opt-in, set by internal admins).
       * @default false
       */
      coding_case_creation_enabled: boolean;
      /** @description Organisation-level session-inactivity-timeout override. When set, members of this organisation are signed out automatically after `minutes` of inactivity and cannot override the value for themselves. `None` when no override is configured. */
      session_timeout_info?: components['schemas']['SessionTimeoutInfo'] | null;
      /** @description Organisation-level Evidence settings that cascade to child teams. */
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
      /**
       * Disable Auto Extract
       * @description When True, the post-session patient-context auto-extract review popup is disabled org-wide (cascades to teams and members).
       * @default false
       */
      disable_auto_extract: boolean;
      /** Teams */
      teams?: components['schemas']['SimpleTeamView'][];
    };
    /** OrphaCodeConcept */
    OrphaCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * OutlineErrorResponse
     * @description A single line-anchored problem in the edited outline, surfaced inline in the editor.
     */
    OutlineErrorResponse: {
      /** Line */
      line: number;
      /** Message */
      message: string;
    };
    /**
     * OverallFeedbackView
     * @description Response schema for overall verification feedback.
     *
     *     Uses the shared user_feedback collection with target_type=ENTITY_VERIFICATION.
     */
    OverallFeedbackView: {
      /** Id */
      id: string;
      /** Session Id */
      session_id: string;
      /** Analysis Id */
      analysis_id: string;
      rating: components['schemas']['ThumbRating'];
      /** Qualitative Feedback */
      qualitative_feedback?: string | null;
      /** Reasons */
      reasons?: components['schemas']['FeedbackRatingReason'][];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * OwnerType
     * @enum {string}
     */
    OwnerType: OwnerType;
    /** PDFTemplateUrlRequest */
    PDFTemplateUrlRequest: {
      /** Object Key */
      object_key: string;
      /** @default put_object */
      method: components['schemas']['S3PresignedUrlMethod'];
      /** Template Id */
      template_id?: string | null;
    };
    /**
     * PaginatedMKCustomTemplateRequestResponse
     * @description Paginated response for MK custom template requests
     */
    PaginatedMKCustomTemplateRequestResponse: {
      /**
       * Items
       * @description List of requests
       */
      items: components['schemas']['MKCustomTemplateRequestResponse'][];
      /**
       * Total
       * @description Total number of requests
       */
      total: number;
      /**
       * Page
       * @description Current page number
       */
      page: number;
      /**
       * Page Size
       * @description Number of items per page
       */
      page_size: number;
      /**
       * Total Pages
       * @description Total number of pages
       */
      total_pages: number;
    };
    /**
     * PaginatedTicketResponse
     * @description Paginated wrapper for ticket list endpoints.
     */
    PaginatedTicketResponse: {
      /** Total Count */
      total_count: number;
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
      /** Results */
      results: components['schemas']['TicketSummary'][];
    };
    /**
     * ParseNoteSectionsResponse
     * @description Heading→body slices of a Heidi note for warm note-fill.
     */
    ParseNoteSectionsResponse: {
      /** Sections */
      sections?: components['schemas']['ParsedNoteSection'][];
    };
    /**
     * ParseOutlineRequest
     * @description Outline text the admin edited. The backend parses it back into the protocol's section tree for
     *     live preview + validation — no JSON is shown to the admin. ``protocol_id`` scopes the generated
     *     item ids to this protocol.
     */
    ParseOutlineRequest: {
      /** Outline */
      outline: string;
      /** Protocol Id */
      protocol_id: string;
    };
    /**
     * ParseOutlineResponse
     * @description Parsed sections for the WYSIWYG preview plus any line-anchored errors. An empty ``errors``
     *     list means the outline is valid and safe to save.
     */
    ParseOutlineResponse: {
      /** Sections */
      sections: components['schemas']['SectionModel'][];
      /** Errors */
      errors: components['schemas']['OutlineErrorResponse'][];
    };
    /**
     * ParseProtocolRequest
     * @description Free text the manager pasted into the editor; the backend parses it into a draft protocol
     *     for preview (no JSON is shown to the admin).
     */
    ParseProtocolRequest: {
      /** Raw Text */
      raw_text: string;
      /** Display Name */
      display_name?: string | null;
    };
    /**
     * ParseProtocolResponse
     * @description The parsed draft protocol, for the editor's WYSIWYG preview. The admin reviews/tweaks it,
     *     then creates it via the create endpoint.
     */
    ParseProtocolResponse: {
      protocol: components['schemas']['ProtocolModel'];
    };
    /** ParsedNoteSection */
    ParsedNoteSection: {
      /** Heading */
      heading: string;
      /** Body */
      body: string;
    };
    /**
     * ParticipantRequired
     * @description Is the Participant required to attend the appointment.
     *
     *     https://hl7.org/fhir/R4/valueset-participantrequired.html
     * @enum {string}
     */
    ParticipantRequired: ParticipantRequired;
    /**
     * ParticipationStatus
     * @description The Participation status of an appointment.
     *
     *     https://hl7.org/fhir/R4/valueset-participationstatus.html
     * @enum {string}
     */
    ParticipationStatus: ParticipationStatus;
    /** PartnerPortfolioStatus */
    PartnerPortfolioStatus: {
      /** Portfolio */
      portfolio: string;
      /** Last Completed At */
      last_completed_at: string | null;
      /** Content Version */
      content_version: string | null;
      /** Document Counts */
      document_counts: {
        [key: string]: number;
      } | null;
      /** Content Last Changed At */
      content_last_changed_at?: string | null;
      /** S3 Last Modified */
      s3_last_modified?: string | null;
    };
    /** PartnerSyncStatusListResponse */
    PartnerSyncStatusListResponse: {
      /** Partners */
      partners: components['schemas']['PartnerSyncStatusResponse'][];
    };
    /** PartnerSyncStatusResponse */
    PartnerSyncStatusResponse: {
      /** Partner */
      partner: string;
      /** Last Completed At */
      last_completed_at: string | null;
      /** Content Version */
      content_version: string | null;
      /** Document Counts */
      document_counts: {
        [key: string]: number;
      } | null;
      /** Sync Status */
      sync_status: string | null;
      /** Portfolios */
      portfolios?: components['schemas']['PartnerPortfolioStatus'][] | null;
      latest_run?: components['schemas']['SyncRunResponse'] | null;
      /** Content Last Changed At */
      content_last_changed_at?: string | null;
      /** S3 Last Modified */
      s3_last_modified?: string | null;
      /** Days Since Content Change */
      days_since_content_change?: number | null;
    };
    /** PartnerUploadConfigurationResponse */
    PartnerUploadConfigurationResponse: {
      /** Partner */
      partner: string;
      /** Sync Enabled */
      sync_enabled: boolean;
    };
    /**
     * PasswordChangedRequest
     * @description Forwarded ``scp`` (Successfully Changed Password) event payload.
     *
     *     The dispatcher in identity_broker constructs this from a single
     *     Auth0 log entry plus the user object it fetched via Management API
     *     enrichment.
     */
    PasswordChangedRequest: {
      /**
       * User Ref Id
       * @description Global unique identifier for the user (UUID7).
       * @example 01912345-6789-7abc-def0-123456789abc
       */
      user_ref_id: string;
      /**
       * Email
       * Format: email
       * @description Auth0-derived recipient email. The regional endpoint still consults the User document for the authoritative address; this field is forwarded for cross-reference and logging.
       */
      email: string;
      /**
       * Ip
       * @description Source IP captured by Auth0 at the time of the change.
       */
      ip: string;
      /**
       * User Agent
       * @description Raw User-Agent string captured by Auth0. The regional endpoint parses this into a display string via ``utils.user_agent``; Auth0 does not pre-parse the UA.
       */
      user_agent?: string | null;
      /** @description Geo-IP enrichment from Auth0. Any field may be missing. */
      location_info?: components['schemas']['LocationInfo'] | null;
      /**
       * Occurred At
       * Format: date-time
       * @description ISO-8601 timestamp of the password change event.
       */
      occurred_at: string;
      /**
       * Log Id
       * @description Auth0 log event id, echoed back in the response for tracing. Not used for deduplication in this version — see design.md Decision 5.
       */
      log_id: string;
    };
    /**
     * PasswordChangedResponse
     * @description Outcome of a single forwarded password-changed event.
     */
    PasswordChangedResponse: {
      /**
       * Status
       * @description ``sent`` when the regional endpoint wrote the audit timestamp and invoked the email send. ``skipped_flag_off`` when the umbrella feature flag was off — no audit write, no email. ``skipped_no_recipient`` when the resolved user has no email address — nothing to send, not an error.
       * @enum {string}
       */
      status: PasswordChangedResponseStatus;
      /**
       * Log Id
       * @description Echo of the inbound ``log_id`` for tracing.
       */
      log_id: string;
    };
    /** PatchCardStatusSchema */
    PatchCardStatusSchema: {
      /**
       * Status
       * @enum {string}
       */
      status: PatchCardStatusSchemaStatus;
      /** Reason */
      reason?: string | null;
    };
    /** PatchItemCheckedSchema */
    PatchItemCheckedSchema: {
      /** Checked */
      checked: boolean;
    };
    /**
     * PatchOp
     * @description Supported JSON Patch operation types (`RFC 6902 <https://datatracker.ietf.org/doc/html/rfc6902>`_).
     * @enum {string}
     */
    PatchOp: PatchOp;
    /**
     * PatchOperation
     * @description A single JSON Patch operation (`RFC 6902 <https://datatracker.ietf.org/doc/html/rfc6902>`_).
     *
     *     Attributes
     *     ----------
     *     op
     *         The operation type: ``add``, ``replace``, or ``remove``.
     *     path
     *         JSON Pointer (`RFC 6901 <https://datatracker.ietf.org/doc/html/rfc6901>`_) to the target field — e.g. ``/start``.
     *         Only single-segment top-level paths are supported.
     *     value
     *         The value to set. Required for ``add`` and ``replace``;
     *         must be absent for ``remove``.
     */
    PatchOperation: {
      op: components['schemas']['PatchOp'];
      /** Path */
      path: string;
      /** Value */
      value?: unknown;
    };
    /** PatchProviderAppointmentDetails */
    PatchProviderAppointmentDetails: {
      /** Selected Document Id */
      selected_document_id?: string | null;
      /** Selected Note Type */
      selected_note_type?: string | null;
      /** Selected Upload Folder */
      selected_upload_folder?: string | null;
    };
    /** PatchSessionLinkRequest */
    PatchSessionLinkRequest: {
      provider_appointment_details?:
        | components['schemas']['PatchProviderAppointmentDetails']
        | null;
    };
    /**
     * Patient
     * @description Information about an individual or animal receiving health care services.
     *
     *     Demographics and other administrative information about an individual or animal
     *     receiving care or other health-related services.
     *
     *     https://hl7.org/fhir/R4/patient-definitions.html
     */
    Patient: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** An identifier for this patient */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Whether this patient's record is in active use
       * @description Whether this patient record is in active use. Many systems use this property to mark as non-current patients, such as those that have not been seen for a period of time based on an organization's business rules. It is often used to filter patient lists to exclude inactive patients. Deceased patients may also be marked as inactive for the same reasons, but may be active for some time after death.
       */
      active?: boolean | null;
      /**
       * A name associated with the patient
       * @description A name associated with the individual.
       */
      name?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__human_name__HumanName'][]
        | null;
      /**
       * A contact detail for the individual
       * @description A contact detail (e.g. a telephone number or an email address) by which the individual may be contacted.
       */
      telecom?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint'][]
        | null;
      /**
       * male | female | other | unknown
       * @description Administrative Gender - the gender that the patient is considered to have for administration and record keeping purposes.
       */
      gender?: components['schemas']['AdministrativeGender'] | null;
      /** The date of birth for the individual */
      birthDate?: string | null;
      /** Indicates if the individual is deceased or not */
      deceasedBoolean?: boolean | null;
      /** Indicates if the individual is deceased or not */
      deceasedDateTime?: string | null;
      /** An address for the individual */
      address?: components['schemas']['Address'][] | null;
      /**
       * Marital (civil) status of a patient
       * @description This field contains a patient's most recent marital (civil) status.
       */
      maritalStatus?: components['schemas']['CodeableConcept'] | null;
      /**
       * Whether patient is part of a multiple birth
       * @description Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer).
       */
      multipleBirthBoolean?: boolean | null;
      /**
       * Whether patient is part of a multiple birth
       * @description Indicates whether the patient is part of a multiple (boolean) or indicates the actual birth order (integer).
       */
      multipleBirthInteger?: number | null;
      /** Image of the patient */
      photo?: components['schemas']['Attachment'][] | null;
      /** A contact party (e.g. guardian, partner, friend) for the patient */
      contact?: components['schemas']['PatientContact'][] | null;
      /** A language which may be used to communicate with the patient about his or her health */
      communication?: components['schemas']['PatientCommunication'][] | null;
      /**
       * Patient's nominated primary care provider
       * @description Patient's nominated care provider.
       */
      generalPractitioner?: components['schemas']['Reference'][] | null;
      /** Organization that is the custodian of the patient record */
      managingOrganization?: components['schemas']['Reference'] | null;
      /**
       * Link to another patient resource that concerns the same actual person
       * @description Link to another patient resource that concerns the same actual patient.
       */
      link?: components['schemas']['PatientLink'][] | null;
    };
    /** PatientAppointmentView */
    PatientAppointmentView: {
      /** Id */
      id: string;
      /** Appointment Date */
      appointment_date: string;
      /** Appointment Time */
      appointment_time?: string | null;
      /** Appointment Type */
      appointment_type?: string | null;
      /** Status */
      status: string;
      /**
       * Reminders
       * @default []
       */
      reminders: components['schemas']['ReminderRecordView'][];
      /** Created At */
      created_at?: string | null;
    };
    /** PatientCodeableConcept */
    PatientCodeableConcept: {
      /** Text */
      text?: string | null;
    };
    /**
     * PatientCommunication
     * @description A language which may be used to communicate with the patient about his or her health.
     *
     *     https://hl7.org/fhir/R4/patient-definitions.html#Patient.communication
     */
    PatientCommunication: {
      /**
       * The language which can be used to communicate with the patient about his or her health
       * @description The ISO-639-1 alpha 2 code in lower case for the language, optionally followed by a hyphen and the ISO-3166-1 alpha 2 code for the region in upper case; e.g. "en" for English, or "en-US" for American English versus "en-EN" for England English.
       */
      language: components['schemas']['CodeableConcept'];
      /**
       * Language preference indicator
       * @description Indicates whether or not the patient prefers this language (over other languages he masters up a certain level).
       */
      preferred?: boolean | null;
    };
    /**
     * PatientContact
     * @description A contact party (e.g. guardian, partner, friend) for the patient.
     *
     *     https://hl7.org/fhir/R4/patient-definitions.html#Patient.contact
     */
    PatientContact: {
      /**
       * The kind of relationship
       * @description The nature of the relationship between the patient and the contact person.
       */
      relationship?: components['schemas']['CodeableConcept'][] | null;
      /**
       * A name associated with the contact person
       * @description A name associated with the contact person.
       */
      name?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__human_name__HumanName']
        | null;
      /**
       * A contact detail for the person
       * @description A contact detail for the person, e.g. a telephone number or an email address.
       */
      telecom?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint'][]
        | null;
      /**
       * Address for the contact person
       * @description Address for the contact person.
       */
      address?: components['schemas']['Address'] | null;
      /**
       * male | female | other | unknown
       * @description Administrative Gender - the gender that the contact person is considered to have for administration and record keeping purposes.
       */
      gender?: components['schemas']['AdministrativeGender'] | null;
      /**
       * Organization that is associated with the contact
       * @description Organization on behalf of which the contact is acting or for which the contact is working.
       */
      organization?: components['schemas']['Reference'] | null;
      /** The period during which this contact person or organization is valid to be contacted relating to this patient */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
    };
    /**
     * PatientContextInfo
     * @description Patient context information returned with chat.
     */
    PatientContextInfo: {
      /** Patient Profile Id */
      patient_profile_id: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Birth Date */
      birth_date?: string | null;
      /** Gender */
      gender?: string | null;
      /** Patient Info */
      patient_info?: string | null;
    };
    /**
     * PatientContextLLMResponse
     * @description Extracted patient context information from session transcript including source quotes.
     */
    PatientContextLLMResponse: {
      first_name?: components['schemas']['ExtractedPatientProfileField_str_'] | null;
      last_name?: components['schemas']['ExtractedPatientProfileField_str_'] | null;
      birth_date?: components['schemas']['ExtractedPatientProfileField_date_'] | null;
      gender?: components['schemas']['ExtractedPatientProfileField_Gender_'] | null;
      phone?: components['schemas']['ExtractedPatientProfileField_PhoneNumber_'] | null;
      email?: components['schemas']['ExtractedPatientProfileField_EmailStr_'] | null;
      current_medications?:
        | components['schemas']['ExtractedPatientProfileField_str_']
        | null;
      allergies?: components['schemas']['ExtractedPatientProfileField_str_'] | null;
      past_medical_history?:
        | components['schemas']['ExtractedPatientProfileField_str_']
        | null;
    };
    /**
     * PatientContextResponse
     * @description Simplified response model for api response
     */
    PatientContextResponse: {
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Birth Date */
      birth_date?: string | null;
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Current Medications */
      current_medications?: string | null;
      /** Allergies */
      allergies?: string | null;
      /** Past Medical History */
      past_medical_history?: string | null;
      /** Ethnicity */
      ethnicity?: string | null;
      /** First Language */
      first_language?: string | null;
      /** Accent */
      accent?: string | null;
      /** Postcode Prefix */
      postcode_prefix?: string | null;
    };
    /** PatientDetailsRequest */
    PatientDetailsRequest: {
      /** Name */
      name?: string | null;
      /** Dob */
      dob?: string | null;
      /** Age */
      age?: string | null;
      gender?: components['schemas']['domains__translator__models__enums__Gender'] | null;
    };
    /** PatientDetailsResponse */
    PatientDetailsResponse: {
      /** Name */
      name?: string | null;
      /** Dob */
      dob?: string | null;
      /** Age */
      age?: string | null;
      gender?: components['schemas']['domains__translator__models__enums__Gender'] | null;
    };
    /**
     * PatientDocumentListResponse
     * @description Paginated list of patient documents.
     */
    PatientDocumentListResponse: {
      /** Items */
      items: components['schemas']['PatientDocumentResponse'][];
      /** Total */
      total: number;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
    };
    /**
     * PatientDocumentResponse
     * @description Public representation of a patient document — metadata only.
     */
    PatientDocumentResponse: {
      /** Id */
      id: string;
      /** Patient Profile Id */
      patient_profile_id: string;
      /** Uploaded By */
      uploaded_by: string;
      /** File Name */
      file_name: string;
      /** Mime Type */
      mime_type: string;
      /** Size Bytes */
      size_bytes: number;
      /** Description */
      description: string | null;
      /** Session Id */
      session_id: string | null;
      /** Summary */
      summary: string | null;
      /** Is Ready */
      is_ready: boolean;
      /** Failure Reason */
      failure_reason: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * PatientDocumentWithDownloadUrlResponse
     * @description Document metadata plus a short-lived presigned download URL.
     */
    PatientDocumentWithDownloadUrlResponse: {
      /** Id */
      id: string;
      /** Patient Profile Id */
      patient_profile_id: string;
      /** Uploaded By */
      uploaded_by: string;
      /** File Name */
      file_name: string;
      /** Mime Type */
      mime_type: string;
      /** Size Bytes */
      size_bytes: number;
      /** Description */
      description: string | null;
      /** Session Id */
      session_id: string | null;
      /** Summary */
      summary: string | null;
      /** Is Ready */
      is_ready: boolean;
      /** Failure Reason */
      failure_reason: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Download Url */
      download_url: string;
      /**
       * Download Url Expires At
       * Format: date-time
       */
      download_url_expires_at: string;
    };
    /** PatientExpiringRequest */
    PatientExpiringRequest: {
      /** Expiring Patients */
      expiring_patients: {
        [key: string]: string[];
      };
    };
    /** PatientIdentifier */
    PatientIdentifier: {
      /** System */
      system?: string | null;
      type?: components['schemas']['PatientCodeableConcept'] | null;
      /** Use */
      use?: string | null;
      /** Value */
      value?: string | null;
    };
    /**
     * PatientLink
     * @description Link to another patient resource that concerns the same actual person.
     *
     *     https://hl7.org/fhir/R4/patient-definitions.html#Patient.link
     */
    PatientLink: {
      /**
       * The other patient or related person resource that the link refers to
       * @description The other patient resource that the link refers to.
       */
      other: components['schemas']['Reference'];
      /**
       * replaced-by | replaces | refer | seealso
       * @description The type of link between this patient resource and another patient resource.
       */
      type?: components['schemas']['LinkType'] | null;
    };
    /**
     * PatientLinkStatus
     * @description How a session's patient link was established (provenance).
     *
     *     ``AUTO_LINKED`` and ``MANUALLY_LINKED`` are the live values, stamped by
     *     ``associate_patient_to_sessions`` in the same write that sets
     *     ``patient_profile_id`` and cleared on unlink. Discarding a merge suggestion
     *     only unlinks the patient when the value is ``AUTO_LINKED``.
     *
     *     The other three members are legacy session-merge v1 states with no live
     *     writers — kept only so historical documents deserialize. Delete them once
     *     the legacy session-merge code is removed and stored values are migrated.
     * @enum {string}
     */
    PatientLinkStatus: PatientLinkStatus;
    /** PatientMatchView */
    PatientMatchView: {
      /** Patient Id */
      patient_id: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Date Of Birth */
      date_of_birth?: string | null;
      /**
       * Confidence
       * @enum {string}
       */
      confidence: PatientMatchViewConfidence;
      /** Last Appointment Date */
      last_appointment_date?: string | null;
      /** Sms Agent Id */
      sms_agent_id?: string | null;
    };
    /**
     * PatientModel
     * @description a model runs in parallel with PatientProfileModel when user choose to not create a patient profile.
     */
    PatientModel: {
      /** Name */
      name?: string | null;
      /** Gender */
      gender?: string | null;
      /** Dob */
      dob?: string | null;
      /** Demographic Details */
      demographic_details?: string | null;
      /** Additional Context */
      additional_context?: string | null;
    };
    /**
     * PatientProfileAppointmentCandidates
     * @description List of Heidi patient profiles and/or EHR appointments that can be linked to the session.
     */
    PatientProfileAppointmentCandidates: {
      /**
       * Extracted Field Matches
       * @description One LLM extraction for this ranking pass; verbatim clinical excerpts stored once.
       */
      extracted_field_matches?: components['schemas']['ProfileFieldMatchEvidence'][];
      /**
       * Ranked Patient Profile Or Appointment
       * @description Sorted by confidence (desc). Discriminate with entity_type (patient_profile vs appointment).
       */
      ranked_patient_profile_or_appointment?: (
        | components['schemas']['PatientTranscriptMatch']
        | components['schemas']['AppointmentTranscriptMatch']
      )[];
    };
    /**
     * PatientProfileMatchableField
     * @description PatientProfileModel field names allowed in alignment output.
     *
     *     Values match attribute identifiers on the profile model so structured LLM
     *     output lines up with getattr(profile, field.value).
     * @enum {string}
     */
    PatientProfileMatchableField: PatientProfileMatchableField;
    /** PatientProfileModel */
    PatientProfileModel: {
      /** Id */
      id?: string | null;
      source: components['schemas']['PatientSource'];
      /** Ehr */
      ehr?: components['schemas']['EHRProvider'] | string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /**
       * Managed By
       * @example 5eb7cf5a86d9755df3a6c593
       */
      managed_by: string;
      /** Identifiers */
      identifiers?:
        | components['schemas']['dataclass__patient_profile__Identifier'][]
        | null;
      /** Birth Date */
      birth_date?: string | null;
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Demographic String */
      demographic_string: string;
      /** Remember Consent */
      remember_consent?: boolean | null;
      /** Additional Context */
      additional_context?: string | null;
      /** An Acc Class */
      an_acc_class?: string | null;
      /** Current Medications */
      current_medications?: string | null;
      /** Allergies */
      allergies?: string | null;
      /** Past Medical History */
      past_medical_history?: string | null;
      /** Dictation Context */
      dictation_context?: string[] | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Ethnicity */
      ethnicity?: string | null;
      /** First Language */
      first_language?: string | null;
      /** Accent */
      accent?: string | null;
      /** Postcode Prefix */
      postcode_prefix?: string | null;
      /** Use In Doc And Note Gen */
      use_in_doc_and_note_gen?: boolean | null;
    };
    /**
     * PatientProfileSearchResult
     * @description Slim projection returned by the live find-or-link search endpoint.
     *
     *     Deliberately does NOT inherit from `PatientProfileModel`. The
     *     parent model carries the full clinical record (medications,
     *     allergies, past medical history, phone, email, additional
     *     context). Returning that at keystroke rate from a combobox
     *     autocomplete violates HIPAA's minimum-necessary standard
     *     (§164.502(b)) — the dropdown UI only needs identity-and-recency
     *     fields to disambiguate between candidates.
     *
     *     Fields:
     *     - `id`              — profile id; the only thing the FE needs to
     *                           POST a link.
     *     - `first_name` /
     *       `last_name`       — primary display.
     *     - `demographic_string` — fallback display for legacy profiles
     *                           that pre-date split first/last fields. See
     *                           note below — kept under minimum-necessary
     *                           because there is no other identifier on
     *                           legacy profiles.
     *     - `birth_date`      — secondary disambiguation line for
     *                           like-named patients (date only, no time).
     *     - `ehr` /
     *       `ehr_patient_id`  — surfaced so EHR-linked profiles render
     *                           a provenance badge in the dropdown; both
     *                           are public identifiers, not clinical data.
     *     - `last_seen_at`    — created_at of the most recent non-deleted
     *                           session linked to this profile.
     *     - `session_count`   — total non-deleted sessions for this user.
     *
     *     Clinical fields and contact PII (medications, allergies, history,
     *     additional_context, phone, email) are intentionally excluded.
     *     The repo-layer aggregation pipeline `$project`s only these fields
     *     so they never leave Mongo.
     *
     *     Note on `demographic_string`: this is a free-form field that
     *     pre-dates the split first_name/last_name/birth_date columns. For
     *     legacy profiles created before the split, it is the *only*
     *     identity attribute the profile carries — dropping it would render
     *     those profiles as blank rows in the dropdown and make the
     *     find-or-link UX unusable for clinicians on long-lived accounts.
     *     HIPAA §164.502(b) minimum-necessary asks that disclosure be
     *     limited to what is needed for the stated purpose; for legacy
     *     rows, identity disambiguation *is* that purpose and this field is
     *     the only thing that satisfies it. New profiles are created via
     *     the structured first/last/dob path and tend to leave this field
     *     empty, so it is mostly a non-issue going forward. If/when the
     *     legacy backfill lands and this field can be retired, drop it
     *     here as well.
     */
    PatientProfileSearchResult: {
      /** Id */
      id?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Demographic String */
      demographic_string?: string | null;
      /** Birth Date */
      birth_date?: string | null;
      /** Ehr */
      ehr?: components['schemas']['EHRProvider'] | string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Last Seen At */
      last_seen_at?: string | null;
      /**
       * Session Count
       * @default 0
       */
      session_count: number;
      /** Managed By User Ref Id */
      // COLAB-411 (ml-scribe PR 19411), same field as on the list row but
      // OPTIONAL here: the search repo validates this model straight off the
      // aggregation document, before the manager has resolved, so the backend
      // gives it a default rather than requiring it. `managed_by` itself stays
      // absent — it is carried for resolution only and excluded from every
      // serialisation of this row.
      //
      // Hand-applied on the COLAB-409 branch; `pnpm run schema:dev` reproduces
      // it once 19411 merges. If 19411 lands differently, drop the patch.
      managed_by_user_ref_id?: string | null;
    };
    /**
     * PatientProfileUpdateSource
     * @enum {string}
     */
    PatientProfileUpdateSource: PatientProfileUpdateSource;
    /** PatientProfileWithSessionCount */
    PatientProfileWithSessionCount: {
      /** Id */
      id?: string | null;
      source: components['schemas']['PatientSource'];
      /** Ehr */
      ehr?: components['schemas']['EHRProvider'] | string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /**
       * Managed By
       * @example 5eb7cf5a86d9755df3a6c593
       */
      managed_by: string;
      /** Identifiers */
      identifiers?:
        | components['schemas']['dataclass__patient_profile__Identifier'][]
        | null;
      /** Birth Date */
      birth_date?: string | null;
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Demographic String */
      demographic_string: string;
      /** Remember Consent */
      remember_consent?: boolean | null;
      /** Additional Context */
      additional_context?: string | null;
      /** An Acc Class */
      an_acc_class?: string | null;
      /** Current Medications */
      current_medications?: string | null;
      /** Allergies */
      allergies?: string | null;
      /** Past Medical History */
      past_medical_history?: string | null;
      /** Dictation Context */
      dictation_context?: string[] | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Ethnicity */
      ethnicity?: string | null;
      /** First Language */
      first_language?: string | null;
      /** Accent */
      accent?: string | null;
      /** Postcode Prefix */
      postcode_prefix?: string | null;
      /** Use In Doc And Note Gen */
      use_in_doc_and_note_gen?: boolean | null;
      /**
       * Session Count
       * @default 0
       */
      session_count: number;
      /** Last Session Created At */
      last_session_created_at?: string | null;
      /** Managed By User Ref Id */
      // COLAB-411 (ml-scribe PR 19411): `managed_by` resolved into the
      // auth-facing id space clients actually hold. Required, not optional —
      // the backend declares it without a default so the key is always
      // present, letting a client tell "manager unknown" (null) from "field
      // not supported" (absent). Never an authorization input.
      //
      // Hand-applied on the COLAB-409 branch, in the position the generator
      // emits it (subclass fields last); `pnpm run schema:dev` reproduces it
      // once 19411 merges. If 19411 lands differently, drop the patch.
      managed_by_user_ref_id: string | null;
    };
    /** PatientRecapErrorEnvelope */
    PatientRecapErrorEnvelope: {
      /** Code */
      code: string;
    };
    /**
     * PatientRecapModel
     * @description Patient-level recap blurb sourced from the most recent finalised consult note.
     */
    PatientRecapModel: {
      /** Blurb */
      blurb: string;
      /** Source Session Id */
      source_session_id: string;
      /**
       * Source Session Date
       * Format: date-time
       */
      source_session_date: string;
      /**
       * Generated At
       * Format: date-time
       */
      generated_at: string;
    };
    /**
     * PatientSource
     * @enum {string}
     */
    PatientSource: PatientSource;
    /** PatientStorageDaysResponse */
    PatientStorageDaysResponse: {
      /** Patient Storage Days */
      patient_storage_days: number | null;
    };
    /**
     * PatientSummaryTurnOffPrompt
     * @description Per-user tracking state for the one-time "turn off automatic patient
     *     summaries" prompt.
     *
     *     Pure tracking state, deliberately kept off the settings catalog (this is
     *     not a user-configurable setting). Always-present default so existing
     *     documents read back as ``dismissal_count=0`` / ``last_dismissed_session_id=None``
     *     / ``seen=False`` without a backfill.
     */
    PatientSummaryTurnOffPrompt: {
      /**
       * Dismissal Count
       * @default 0
       */
      dismissal_count: number;
      /** Last Dismissed Session Id */
      last_dismissed_session_id?: string | null;
      /**
       * Seen
       * @default false
       */
      seen: boolean;
    };
    /**
     * PatientSummaryTurnOffPromptRequest
     * @description Request schema for the patient-summary turn-off prompt tracking state.
     *
     *     All sub-fields are optional so a PATCH /user can update any subset; only
     *     fields explicitly sent are merged into the stored value (the upstream
     *     user PATCH does a shallow merge on the top-level dict, so a partial blob
     *     would otherwise replace the whole embedded object and drop the untouched
     *     sub-fields).
     */
    PatientSummaryTurnOffPromptRequest: {
      /** Dismissal Count */
      dismissal_count?: number | null;
      /** Last Dismissed Session Id */
      last_dismissed_session_id?: string | null;
      /** Seen */
      seen?: boolean | null;
    };
    /**
     * PatientTranscriptMatch
     * @description Ranked Heidi patient profile aligned to the session transcript.
     */
    PatientTranscriptMatch: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      entity_type: PatientTranscriptMatchEntity_type;
      /**
       * Confidence
       * @description Weighted mean of per-field fuzzy scores over the extracted attributes this candidate can answer (comparable fields); 1.0 when every comparable field fully matches this candidate.
       */
      confidence: number;
      /**
       * Corroborated Field Names
       * @description Extracted field names that fully matched this candidate's stored data — field names only, never values. None on candidates stored before this detail existed.
       */
      corroborated_field_names?: string[] | null;
      /**
       * Conflicting Field Names
       * @description Comparable extracted field names that disagreed with this candidate's stored data — field names only, never values. None on candidates stored before this detail existed.
       */
      conflicting_field_names?: string[] | null;
      /**
       * Evidence Weight
       * @description Cumulative importance-weighted fuzzy score over comparable fields; breaks ties between equal-confidence candidates. None on legacy stored candidates.
       */
      evidence_weight?: number | null;
      /** @description Whether this candidate's stored clinical data agrees with the transcript. Only set when identity evidence left a tie the evidence-weight margin could not break; None everywhere else, which reads the same as a comparison that never ran. */
      clinical_verdict?: components['schemas']['ClinicalComparisonVerdict'] | null;
      /**
       * Clinical Verdict Field Names
       * @description Stored profile fields that drove the clinical verdict — field names only, never values.
       */
      clinical_verdict_field_names?: string[] | null;
      /**
       * Clinical Verdict Reason
       * @description One short sentence explaining the clinical verdict. May name conditions or medications, so it is PHI: persisted and shown on the PHI tier of the admin inspector, never logged.
       */
      clinical_verdict_reason?: string | null;
      /**
       * Patient Profile Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      patient_profile_id: string;
    };
    /**
     * PatientType
     * @enum {string}
     */
    PatientType: PatientType;
    /** PatientUpdate */
    PatientUpdate: {
      /** Name */
      name?: string | null;
      /** Gender */
      gender?: string | null;
      /** Dob */
      dob?: string | null;
      /** Demographic Details */
      demographic_details?: string | null;
    };
    /** PatientView */
    PatientView: {
      /** Id */
      id: string;
      /** Patient No */
      patient_no?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Mobile Phone */
      mobile_phone?: string | null;
      /** Email */
      email?: string | null;
      /** Date Of Birth */
      date_of_birth?: string | null;
      /** Last Appointment Date */
      last_appointment_date?: string | null;
      /** Created At */
      created_at?: string | null;
      /**
       * Appointment Count
       * @default 0
       */
      appointment_count: number;
      /** Next Appointment Date */
      next_appointment_date?: string | null;
      /**
       * Reminders
       * @default []
       */
      reminders: components['schemas']['ReminderRecordView'][];
    };
    /** PayloadCondition */
    PayloadCondition: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: PayloadConditionKind;
      config: components['schemas']['PayloadConditionConfig'];
    };
    /** PayloadConditionConfig */
    PayloadConditionConfig: {
      /** Path */
      path: string;
      /** Equals */
      equals: unknown;
    };
    /**
     * PaymentVendor
     * @enum {string}
     */
    PaymentVendor: PaymentVendor;
    /**
     * PdfFieldType
     * @enum {string}
     */
    PdfFieldType: PdfFieldType;
    /** PdfFormFieldRect */
    PdfFormFieldRect: {
      /** X0 */
      x0: number;
      /** Y0 */
      y0: number;
      /** X1 */
      x1: number;
      /** Y1 */
      y1: number;
    };
    /**
     * PendingChatAttachmentResponse
     * @description Response model for a pending chat attachment (returned to frontend).
     */
    PendingChatAttachmentResponse: {
      /**
       * Id
       * @description Attachment ID for later reference
       */
      id: string;
      /**
       * Name
       * @description Original filename
       */
      name: string;
      /**
       * Type
       * @description MIME type
       */
      type?: string | null;
      /**
       * Size
       * @description File size in bytes
       */
      size?: number | null;
      /**
       * Url
       * @description Presigned S3 URL for preview
       */
      url?: string | null;
    };
    /**
     * PendingIntegrationOnboardingExecutionStep
     * @description Integration onboarding step with a pending status.
     *
     *     Steps can be executed and rename in Pending state. Results will be saved
     *
     *     In this state there is no error and no result.
     */
    PendingIntegrationOnboardingExecutionStep: {
      /** Step Id */
      step_id: string;
      step_type: components['schemas']['StepType'];
      /** Step Number */
      step_number: number;
      /** Details */
      details: {
        [key: string]: unknown;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /** Payload */
      payload?: {
        [key: string]: unknown;
      } | null;
      /** Result */
      result?: {
        [key: string]: unknown;
      } | null;
      /** Internal Result */
      internal_result?: {
        [key: string]: unknown;
      } | null;
      /**
       * Status
       * @default pending
       * @constant
       */
      status: 'pending';
    };
    /** PendingSubStep */
    PendingSubStep: {
      step: components['schemas']['TutorialSteps'] | null;
      /** Page */
      page:
        | components['schemas']['SessionPages']
        | components['schemas']['TemplatePages']
        | components['schemas']['NotePages']
        | components['schemas']['CreateDocumentPages']
        | components['schemas']['CreateTemplatePages']
        | null;
    };
    /**
     * PendingWriteback
     * @description One ready-to-write item the desktop should commit to local FHIR.
     */
    PendingWriteback: {
      /**
       * Consult Note Link Id
       * @description ID of the ``IntegrationConsultNoteLink``. Pass this back on the ACK endpoint to mark the writeback complete.
       */
      consult_note_link_id: string;
      /** Consult Note Id */
      consult_note_id: string;
      /** Session Id */
      session_id: string;
      /**
       * Context Id
       * @description Launch context id (``kontextId`` on the wire — use as ``identifier.value`` on every context-bound resource).
       */
      context_id: string;
      /**
       * Fhir Base Url
       * Format: uri
       * @description Local FHIR base URL from the launch payload — base for the DocumentReference/Condition POSTs.
       */
      fhir_base_url: string;
      note: components['schemas']['PendingWritebackNote'];
      /**
       * Sections
       * @description Per-section payloads for a sectional write-back (structured note with headings mapped to provider-supported sections). When non-empty the desktop should write one resource per section INSTEAD of a whole-note DocumentReference from ``note.text``. Empty for whole-note writes.
       */
      sections?: components['schemas']['PendingWritebackSection'][];
      /**
       * Diagnoses
       * @description Coded entities extracted by Heidi. Empty list means the desktop should write only the DocumentReference.
       */
      diagnoses?: components['schemas']['PendingWritebackDiagnosis'][];
      /**
       * Document Reference Id
       * @description FHIR ``DocumentReference.id`` ACKed by a previous write of this note, if any. Present when the item was re-queued because the clinician edited and re-synced — the desktop should update the existing resource (or clearly surface that the EHR copy is stale) instead of creating a duplicate.
       */
      document_reference_id?: string | null;
      /**
       * Condition Ids
       * @description FHIR ``Condition.id`` list ACKed by a previous write of this note. Empty on first-time writes.
       */
      condition_ids?: string[];
      /**
       * Writeback Generation
       * @description Fencing token for the ACK. Incremented by every (re-)sync that queues the link; echo it verbatim on the ACK. An ACK whose generation no longer matches (the note was re-synced after this poll) is rejected with 409 so the newer version stays queued.
       * @default 0
       */
      writeback_generation: number;
    };
    /**
     * PendingWritebackDiagnosis
     * @description Coded diagnosis to write as a ``Condition`` resource.
     *
     *     The desktop is responsible for assembling the final ``Condition``
     *     resource; this payload is purely the data.
     */
    PendingWritebackDiagnosis: {
      /**
       * Code
       * @description Diagnosis code (e.g. ICD-10-GM ``J06.9``).
       */
      code: string;
      /**
       * Version
       * @description Optional code-system version (e.g. ``"2026"``).
       */
      version?: string | null;
      /**
       * Display
       * @description Human-readable description for ``Condition.code.text`` / ``Condition.code.coding[0].display``.
       */
      display?: string | null;
      /**
       * Certainty
       * @description KBV diagnosis-certainty code (``V`` = suspected, ``G`` = confirmed, ``A`` = excluded, ``Z`` = status post).
       */
      certainty?: string | null;
      /**
       * Side
       * @description KBV side-localisation code (``L`` = left, ``R`` = right, ``B`` = both sides).
       */
      side?: string | null;
      /**
       * Relevance
       * @description Diagnosis-relevance code (``akut`` = acute, ``dauerhaft`` = permanent, ``anamnestisch`` = historical).
       */
      relevance?: string | null;
    };
    /**
     * PendingWritebackNote
     * @description Rendered plain-text consult note for the DocumentReference.
     */
    PendingWritebackNote: {
      /**
       * Text
       * @description The rendered consult-note body (plain text).
       */
      text: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * PeriodLeaderboardResponse
     * @description Response for period-based leaderboard endpoints.
     */
    PeriodLeaderboardResponse: {
      /** Entries */
      entries: components['schemas']['LeaderboardEntry'][];
      /** Period */
      period: string;
      /** Region */
      region: string | null;
      /** Leaderboard Type */
      leaderboard_type: string;
      /** Campaign */
      campaign?: string | null;
      /**
       * Generated At
       * Format: date-time
       */
      generated_at: string;
    };
    /** PermissionValue */
    PermissionValue: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Code */
      code: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Is Deleted */
      is_deleted: boolean;
    };
    /**
     * PersonalizationCategory
     * @enum {string}
     */
    PersonalizationCategory: PersonalizationCategory;
    /**
     * PersonalizationData
     * @description Complete personalization data for a user, structured by category.
     */
    PersonalizationData: {
      /** Language Tone */
      language_tone?: components['schemas']['PersonalizationInsight'][];
      /** Syntax Grammar */
      syntax_grammar?: components['schemas']['PersonalizationInsight'][];
      /** Content Phrasing */
      content_phrasing?: components['schemas']['PersonalizationInsight'][];
      /** Medical Terms */
      medical_terms?: components['schemas']['PersonalizationInsight'][];
      /** Format Layout */
      format_layout?: components['schemas']['PersonalizationInsight'][];
    };
    /**
     * PersonalizationDataResponse
     * @description Response for complete personalization data.
     */
    PersonalizationDataResponse: {
      personalization_data: components['schemas']['PersonalizationData'];
      /**
       * Total Count
       * @default 0
       */
      total_count: number;
      /**
       * Show New Insights Badge
       * @default false
       */
      show_new_insights_badge: boolean;
      /**
       * Sessions Threshold Reached
       * @default false
       */
      sessions_threshold_reached: boolean;
      /** @default completed */
      generating_status: components['schemas']['PersonalizationProfileGeneratingStatus'];
    };
    /**
     * PersonalizationInsight
     * @description A single personalization insight extracted from a user's edit.
     */
    PersonalizationInsight: {
      /**
       * Rule
       * @description A short, plain-English statement of the stylistic preference.
       */
      rule: string;
      /**
       * Evidence
       * @description Direct quote(s) from the user's edit that support the rule.
       */
      evidence: string[];
      /**
       * Applies To
       * @description The types of documents this rule applies to.
       */
      applies_to?: string[];
      /**
       * Confidence
       * @description The AI's confidence in the extracted insight (0-1).
       */
      confidence: number;
      /**
       * Conflict
       * @description Flag to indicate if this insight conflicts with another.
       * @default false
       */
      conflict: boolean | null;
      /**
       * Should Use
       * @description Flag to indicate if this insight should be used in the LLM prompt.
       * @default true
       */
      should_use: boolean | null;
      /**
       * Created At
       * @description When this insight was first extracted or created.
       */
      created_at?: string | null;
      /**
       * Source
       * @description Pipeline that produced this insight (e.g. 'v1', 'v1_denoised').
       */
      source?: string | null;
      /**
       * Observation Count
       * @description Number of times this rule has been observed. None for legacy insights pre-denoised.
       */
      observation_count?: number | null;
      /**
       * Last Observed At
       * @description When this rule was last reinforced by a duplicate observation.
       */
      last_observed_at?: string | null;
    };
    /**
     * PersonalizationProfileGeneratingStatus
     * @enum {string}
     */
    PersonalizationProfileGeneratingStatus: PersonalizationProfileGeneratingStatus;
    /**
     * PersonalizedEvidenceSuggestionCategory
     * @description Stable category slug for API clients (OpenAPI enum).
     * @enum {string}
     */
    PersonalizedEvidenceSuggestionCategory: PersonalizedEvidenceSuggestionCategory;
    /**
     * PersonalizedEvidenceSuggestionsResponse
     * @description Response for personalized (recent-work–informed) suggestions.
     */
    PersonalizedEvidenceSuggestionsResponse: {
      /**
       * Title
       * @description Short engaging headline for UI (typically 3–4 words) when a suggestion is present.
       */
      title?: string | null;
      /**
       * Suggestion
       * @description At most one suggestion text: the top pick across research, planning, documentation, and reflection.
       */
      suggestion?: string | null;
      /** @description Stable category slug when a suggestion is present. */
      category?: components['schemas']['PersonalizedEvidenceSuggestionCategory'] | null;
      /**
       * Cta
       * @description Short button-style CTA when present; null if omitted (client may localize).
       */
      cta?: string | null;
    };
    /**
     * PilotStatus
     * @description Lifecycle of a Remote Pilot order.
     *
     *     Carried in its own field rather than the order status enum so pilots never
     *     touch the public/mobile fulfilment-status contract (mirrors send_out_status).
     *     ACTIVE once the pilot deal closes; ENDED once the post-ship pilot window has
     *     lapsed.
     * @enum {string}
     */
    PilotStatus: PilotStatus;
    /**
     * PinnedQuerySchema
     * @description Schema for a user-defined pinned query.
     */
    PinnedQuerySchema: {
      /**
       * Label
       * @description Short display label for the chip
       */
      label: string;
      /**
       * Query
       * @description Full query to send to Evidence
       */
      query: string;
      /**
       * Description
       * @description Optional longer description for the shortcut (UI only; not sent as the query)
       */
      description?: string | null;
      /**
       * Team Shortcut Id
       * @description Optional reference to a team shortcut id. Accepts either raw `{shortcut_id}` or `team-{shortcut_id}`.
       */
      team_shortcut_id?: string | null;
      /**
       * Origin
       * @description Shortcut origin for analytics. Accepts only 'library' (installed from shortcut marketplace) or 'custom' (user-authored); omitted/null defaults to 'custom' server-side. 'default' is reserved for Heidi presets and is rejected here (422) — it is force-set on the read path.
       */
      origin?: PinnedQuerySchemaOriginAnyOf0 | null;
    };
    /** PlatformDeletionStatusResponse */
    PlatformDeletionStatusResponse: {
      db: components['schemas']['PlatformStatusResponse'];
      kinde: components['schemas']['PlatformStatusResponse'];
      identity_broker: components['schemas']['PlatformStatusResponse'];
    };
    /** PlatformStatusResponse */
    PlatformStatusResponse: {
      /** Status */
      status: string;
      /** Error */
      error?: string | null;
    };
    /**
     * PollOrderStatusResponse
     * @description Response schema for order status polling.
     */
    PollOrderStatusResponse: {
      /**
       * Transition
       * @description The transition that was polled
       * @example prepared
       * @example shipped
       */
      transition: string;
      /**
       * Total
       * @description Total orders checked
       */
      total: number;
      /**
       * Updated
       * @description Orders successfully transitioned
       */
      updated: number;
      /**
       * Skipped
       * @description Orders already at or past target status
       */
      skipped: number;
      /**
       * Failed
       * @description Orders that failed to update
       */
      failed: number;
    };
    /**
     * PostNoteQualityTask
     * @description GRO-3268/GRO-3270: task ids for the "Improve your notes" panel.
     *
     *     Values match the FE ``ImproveNotesTaskId`` union in scribe-fe-v2
     *     (``src/features/post-note-quality/improve-notes-panel/tasks.config.ts``).
     * @enum {string}
     */
    PostNoteQualityTask: PostNoteQualityTask;
    /**
     * Practitioner
     * @description A person who is directly or indirectly involved in the provisioning of healthcare.
     *
     *     https://hl7.org/fhir/R4/practitioner-definitions.html
     */
    Practitioner: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** An identifier for the person as this agent */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /** Whether this practitioner's record is in active use */
      active?: boolean | null;
      /** The name(s) associated with the practitioner */
      name?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__human_name__HumanName'][]
        | null;
      /**
       * A contact detail for the practitioner (that apply to all roles)
       * @description A contact detail for the practitioner, e.g. a telephone number or an email address.
       */
      telecom?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint'][]
        | null;
      /** Address(es) of the practitioner that are not role specific (typically home address) */
      address?: components['schemas']['Address'][] | null;
      /**
       * male | female | other | unknown
       * @description Administrative Gender - the gender that the practitioner is considered to have for administration and record keeping purposes.
       */
      gender?: components['schemas']['AdministrativeGender'] | null;
      /** The date on which the practitioner was born */
      birthDate?: string | null;
      /** Image of the person */
      photo?: components['schemas']['Attachment'][] | null;
      /** Certification, licenses, or training pertaining to the provision of care */
      qualification?: components['schemas']['PractitionerQualification'][] | null;
      /** A language the practitioner can use in patient communication */
      communication?: components['schemas']['CodeableConcept'][] | null;
    };
    /**
     * PractitionerParams
     * @description Maximal R4 Practitioner search (direct + ``practitioner.*`` chains).
     *
     *     https://hl7.org/fhir/R4/practitioner.html#search
     */
    PractitionerParams: {
      /**
       * Elements
       * @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements
       */
      _elements?: string[] | string | null;
      /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
      _summary?: components['schemas']['SummaryParameter'] | null;
      /**
       * Family
       * @description The practitioner's family name
       */
      family?: string | null;
      /**
       * Given
       * @description The practitioner's given name
       */
      given?: string | null;
      /**
       * Name
       * @description A server defined search that may match any of the string fields in the HumanName
       */
      name?: string | null;
    };
    /**
     * PractitionerQualification
     * @description A qualification obtained by the practitioner.
     *
     *     https://hl7.org/fhir/R4/practitioner-definitions.html#Practitioner.qualification
     */
    PractitionerQualification: {
      /** An identifier for this qualification for the practitioner */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /** Coded representation of the qualification */
      code: components['schemas']['CodeableConcept'];
      /** Period during which the qualification is valid */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /** Organization that regulates and issues the qualification */
      issuer?: components['schemas']['Reference'] | null;
    };
    /**
     * PractitionerRole
     * @description Roles/organizations the practitioner is associated with.
     *
     *     https://hl7.org/fhir/R4/practitionerrole-definitions.html
     */
    PractitionerRole: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Business Identifiers that are specific to a role/location
       * @description Business Identifiers that are specific to a role/location that are assigned and used for purposes of tracking and identification.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Whether this practitioner role record is in active use
       * @description Whether this practitioner role record is in active use.
       */
      active?: boolean | null;
      /**
       * The period during which the practitioner is authorized to perform in these role(s)
       * @description The period during which the person is authorized to act as a practitioner in these role(s) for the organization.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Practitioner that is able to provide the defined services for the organization
       * @description Practitioner that is able to provide the defined services for the organization.
       */
      practitioner?: components['schemas']['Reference'] | null;
      /**
       * Organization where the roles are available
       * @description The organization where the Practitioner performs the roles associated.
       */
      organization?: components['schemas']['Reference'] | null;
      /**
       * Roles which this practitioner may perform
       * @description Roles which this practitioner is authorized to perform for the organization.
       */
      code?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Specific specialty of the practitioner
       * @description Specific specialty of the practitioner.
       */
      specialty?: components['schemas']['CodeableConcept'][] | null;
      /**
       * The location(s) at which this practitioner provides care
       * @description The location(s) at which this practitioner provides care.
       */
      location?: components['schemas']['Reference'][] | null;
      /**
       * The list of healthcare services that this worker provides for this role's Organization/Location(s)
       * @description The list of healthcare services that this worker provides for this role's Organization/Location(s).
       */
      healthcareService?: components['schemas']['Reference'][] | null;
      /**
       * Contact details that are specific to the role/location/service
       * @description Contact details that are specific to the role/location/service.
       */
      telecom?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint'][]
        | null;
      /**
       * Times the Service Site is available
       * @description A collection of times the practitioner is available or performing this role at the location and/or healthcareservice.
       */
      availableTime?: components['schemas']['PractitionerRoleAvailableTime'][] | null;
      /**
       * Not available during this time due to provided reason
       * @description The practitioner is not available or performing this role during this period of time due to the provided reason.
       */
      notAvailable?: components['schemas']['PractitionerRoleNotAvailable'][] | null;
      /**
       * Description of availability exceptions
       * @description A description of site availability exceptions, e.g. public holiday availability. Succinctly describing all possible exceptions to normal site availability as details in the available Times and not available Times.
       */
      availabilityExceptions?: string | null;
      /**
       * Technical endpoints providing access to services operated for the practitioner with this role
       * @description Technical endpoints providing access to services operated for the practitioner with this role.
       */
      endpoint?: components['schemas']['Reference'][] | null;
    };
    /**
     * PractitionerRoleAvailableTime
     * @description Times during which this service/site is available.
     *
     *     https://hl7.org/fhir/R4/practitionerrole-definitions.html#PractitionerRole.availableTime
     */
    PractitionerRoleAvailableTime: {
      /**
       * mon | tue | wed | thu | fri | sat | sun
       * @description Indicates which days of the week are available between the start and end Times.
       */
      daysOfWeek?: components['schemas']['DaysOfWeek'][] | null;
      /**
       * Always available? e.g. 24 hour service
       * @description Is this always available? (hence times are irrelevant) e.g. 24 hour service.
       */
      allDay?: boolean | null;
      /**
       * Opening time of day (ignored if allDay = true)
       * @description The opening time of day. Note: If the AllDay flag is set, then this time is ignored.
       */
      availableStartTime?: string | null;
      /**
       * Closing time of day (ignored if allDay = true)
       * @description The closing time of day. Note: If the AllDay flag is set, then this time is ignored.
       */
      availableEndTime?: string | null;
    };
    /**
     * PractitionerRoleInclude
     * @description Allowed ``_include`` values for PractitionerRole searches.
     *
     *     Typed contract for the per-resource ``_include`` parameter declared on
     *     :class:`PractitionerRoleSearchParameters`.
     * @enum {string}
     */
    PractitionerRoleInclude: PractitionerRoleInclude;
    PractitionerRoleIncludeParam:
      | components['schemas']['PractitionerRoleInclude'][]
      | components['schemas']['PractitionerRoleInclude']
      | null;
    /**
     * PractitionerRoleNotAvailable
     * @description Not available during this time due to provided reason.
     *
     *     https://hl7.org/fhir/R4/practitionerrole-definitions.html#PractitionerRole.notAvailable
     */
    PractitionerRoleNotAvailable: {
      /**
       * Reason presented to the user explaining why time not available
       * @description The reason that can be presented to the user as to why this time is not available.
       */
      description: string;
      /**
       * Service not available from this date
       * @description Service is not available (seasonally or for a public holiday) from this date.
       */
      during?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
    };
    /** PrechartAdminEnableRequest */
    PrechartAdminEnableRequest: {
      /** Email */
      email: string;
    };
    /** PrechartAdminEnableResponse */
    PrechartAdminEnableResponse: {
      /** Is Precharting Enabled */
      is_precharting_enabled: boolean;
      /** Email */
      email: string;
    };
    /**
     * PrechartFeedbackRating
     * @enum {string}
     */
    PrechartFeedbackRating: PrechartFeedbackRating;
    /** PrechartFeedbackRequest */
    PrechartFeedbackRequest: {
      rating: components['schemas']['PrechartFeedbackRating'];
      /** Comment */
      comment?: string | null;
    };
    /** PrechartStatsBucket */
    PrechartStatsBucket: {
      /**
       * Hour
       * Format: date-time
       */
      hour: string;
      /** Clinic Id */
      clinic_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Counts */
      counts?: {
        [key: string]: number;
      };
    };
    /** PrechartStatsResponse */
    PrechartStatsResponse: {
      /** Buckets */
      buckets: components['schemas']['PrechartStatsBucket'][];
    };
    /**
     * PreferencesResponse
     * @description User preferences with backend defaults applied to unset fields, excluding clinician gender
     */
    PreferencesResponse: {
      recordingMode: components['schemas']['RecordingMode'];
      patientType: components['schemas']['PatientType'];
      /** Clinicianlanguage */
      clinicianLanguage: string;
      clinicianGender?:
        | components['schemas']['domains__translator__models__enums__Gender']
        | null;
      translationModel: components['schemas']['TranslationModel'];
      /** Autoreadtranslations */
      autoReadTranslations: boolean;
    };
    /** PreflightCheck */
    PreflightCheck: {
      /** Name */
      name: string;
      /** Ok */
      ok: boolean;
      /** Detail */
      detail?: string | null;
    };
    /**
     * PrepareRequestBody
     * @description FE-shaped body — names and casing must mirror
     *     ``PreparePatientSummaryDeliveryRequest`` in
     *     ``scribe-fe-v2/src/types/patient-summary.types.ts``.
     */
    PrepareRequestBody: {
      /**
       * Document Id
       * @description Patient summary document ID.
       */
      document_id: string;
      /**
       * Patient Profile Id
       * @description Patient profile ID.
       */
      patient_profile_id: string;
      /**
       * Delivery Phone
       * @description E.164 phone number the SMS will go to (e.g. '+447933994683'). Optional: when omitted the service falls back to the patient profile's stored number. ``prepare`` is preview-only and tolerates neither being present; ``send`` requires a resolved number.
       */
      delivery_phone?: string | null;
      /**
       * Patient Message
       * @description Optional clinician-authored intro prepended to the SMS body. Capped at 480 chars (3 SMS segments of 160) by the FE composer; mirrored on the BE.
       */
      patient_message?: string | null;
    };
    /**
     * PrepareResponseBody
     * @description FE-shaped response — keep field order/names in sync with
     *     ``PreparePatientSummaryDeliveryResponse``.
     */
    PrepareResponseBody: {
      /** Delivery Token */
      delivery_token: string;
      /** Delivery Token Expires At */
      delivery_token_expires_at: string;
      /** Download Url */
      download_url: string;
      /** Preview Pdf Url */
      preview_pdf_url: string;
      /** File Key */
      file_key: string;
      /** Pdf Expires At */
      pdf_expires_at: string;
      /** Password */
      password: string | null;
      /** Password Hint */
      password_hint: string;
      /** Instructions For Clinician */
      instructions_for_clinician: string;
      /** Sms Body Preview */
      sms_body_preview: string;
      /** Editable Message */
      editable_message: string;
      /** Sms Short Url */
      sms_short_url: string;
      /** Delivery Phone */
      delivery_phone: string;
      /** Patient Name */
      patient_name: string;
      /** Clinician Name */
      clinician_name: string;
    };
    /** PrescriptionResponse */
    PrescriptionResponse: {
      prescription: components['schemas']['PrescriptionView'];
    };
    /** PrescriptionView */
    PrescriptionView: {
      /** Id */
      id: string;
      /** Created By */
      created_by: string;
      /** Session Id */
      session_id: string | null;
      /** Drug */
      drug: string;
      /** Dose */
      dose: string;
      /** Frequency */
      frequency: string;
      /** Duration */
      duration: string;
      /** Route */
      route: string;
      /** Indication */
      indication: string | null;
      /** Formulation */
      formulation: string | null;
      /** Brand Name */
      brand_name: string | null;
      /** N Repeats */
      n_repeats: number | null;
      /** Quantity */
      quantity: string | null;
      /** Allergy Checked */
      allergy_checked: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** PresentationListItem */
    PresentationListItem: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Slide Count */
      slide_count: number;
      /** Created At */
      created_at: string;
      /** Updated At */
      updated_at: string;
    };
    /** PresentationResponse */
    PresentationResponse: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Slides */
      slides: components['schemas']['SlideResponse'][];
      /** Chat Id */
      chat_id?: string | null;
      /** Pptx Url */
      pptx_url?: string | null;
      /** Preview Url */
      preview_url?: string | null;
      /** Source Type */
      source_type?: string | null;
      /** Available Layouts */
      available_layouts?: unknown[] | null;
      /** Created At */
      created_at: string;
      /** Updated At */
      updated_at: string;
    };
    /** PresignRequest */
    PresignRequest: {
      /** Filename */
      filename: string;
      /** Content Type */
      content_type?: string | null;
    };
    /** PresignedUploadResponse */
    PresignedUploadResponse: {
      /** Upload Url */
      upload_url: string;
      /** S3 Key */
      s3_key: string;
      /** Sync Enabled */
      sync_enabled: boolean;
      /**
       * Method
       * @default PUT
       */
      method: string;
      /**
       * Expires In Seconds
       * @default 3600
       */
      expires_in_seconds: number;
    };
    /** PreviewBatchScopeRequest */
    PreviewBatchScopeRequest: {
      /** @default agent_extracted_word_substitutions */
      memory_type: components['schemas']['MemoryType'];
      /**
       * Target User Ids
       * @description Optional subset to preview (the same cohort you'd pass to batch-workflows:run). Omit to preview all enrolled users.
       */
      target_user_ids?: string[] | null;
      /**
       * Empty Only
       * @description When include_users, restrict the page to users with no rules.
       * @default false
       */
      empty_only: boolean;
      /**
       * Stale After Days
       * @description When set, flags built users whose last successful build is older than this many days as stale ('not refreshed'), and returns a count.
       */
      stale_after_days?: number | null;
      /**
       * Include Users
       * @description Return a page of per-user rows. Counts are always returned; the per-user list is opt-in to keep large cohorts cheap.
       * @default false
       */
      include_users: boolean;
      /**
       * Limit
       * @description Max per-user rows when include_users.
       * @default 200
       */
      limit: number;
      /**
       * Offset
       * @description Pagination offset for the per-user rows.
       * @default 0
       */
      offset: number;
    };
    /** PreviewBatchScopeResponse */
    PreviewBatchScopeResponse: {
      memory_type: components['schemas']['MemoryType'];
      /** Total Enrolled */
      total_enrolled: number;
      /** Empty Count */
      empty_count: number;
      /** Never Built Count */
      never_built_count: number;
      /** Populated Count */
      populated_count: number;
      /** Stale Count */
      stale_count?: number | null;
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
      /** Users */
      users: components['schemas']['PreviewUserScope'][];
    };
    /** PreviewSampleCountResponse */
    PreviewSampleCountResponse: {
      /** Feature Id */
      feature_id: string;
      /** Count */
      count: number;
    };
    /** PreviewUserScope */
    PreviewUserScope: {
      /** User Id */
      user_id: string;
      /** N Rules */
      n_rules: number;
      /** Never Built */
      never_built: boolean;
      /** Is Empty */
      is_empty: boolean;
      /** Is Stale */
      is_stale?: boolean | null;
      /** Last Successful Build At */
      last_successful_build_at?: string | null;
      /** Source */
      source: string;
    };
    /** PriceView */
    PriceView: {
      /** Id */
      id: string;
      /** Type */
      type: string;
      /** Unit Amount */
      unit_amount: number;
      period: components['schemas']['shared__enums__enums__Period'];
      /** Currency */
      currency: string;
      /** Saved Percentage */
      saved_percentage?: number | null;
      /** Saved Period Count */
      saved_period_count?: number | null;
    };
    /** ProcessBatchResponse */
    ProcessBatchResponse: {
      /** Batch Id */
      batch_id: string;
      /** Question Count */
      question_count: number;
      /**
       * Message
       * @default Batch created. AI processing will begin shortly.
       */
      message: string;
    };
    /** ProcessRemindersResponse */
    ProcessRemindersResponse: {
      /** Configs Processed */
      configs_processed: number;
      /** Appointments Checked */
      appointments_checked: number;
      /** Reminders Sent */
      reminders_sent: number;
      /** Reminders Failed */
      reminders_failed: number;
      /**
       * Sms Sent
       * @default 0
       */
      sms_sent: number;
      /**
       * Emails Sent
       * @default 0
       */
      emails_sent: number;
      /**
       * Magic Links Created
       * @default 0
       */
      magic_links_created: number;
      /** Errors */
      errors: string[];
    };
    /**
     * ProcessStatus
     * @enum {string}
     */
    ProcessStatus: ProcessStatus;
    /** ProcessUploadedDocumentResponse */
    ProcessUploadedDocumentResponse: {
      /** File Contents */
      file_contents: string;
    };
    /**
     * ProcessingLogEntry
     * @description A single entry in the processing log for tracking job progress.
     */
    ProcessingLogEntry: {
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp?: string;
      stage: components['schemas']['JobStatus'];
      /** Message */
      message: string;
      /** Duration Ms */
      duration_ms?: number | null;
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      };
    };
    /**
     * ProcessingProgress
     * @description Progress information for document processing.
     */
    ProcessingProgress: {
      /** @default pending */
      stage: components['schemas']['JobStatus'];
      /**
       * Chunks Processed
       * @default 0
       */
      chunks_processed: number;
      /**
       * Chunks Total
       * @default 0
       */
      chunks_total: number;
      /** Message */
      message?: string | null;
    };
    /**
     * ProductSubscriptionType
     * @description Product subscription types aligned with Stripe subscriptions and
     *     enterprise sales-managed subscriptions.
     * @enum {string}
     */
    ProductSubscriptionType: ProductSubscriptionType;
    /**
     * ProductType
     * @enum {string}
     */
    ProductType: ProductType;
    /** ProductView */
    ProductView: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      tier: components['schemas']['SubscriptionTier'];
      new_product_tier: components['schemas']['SubscriptionTier'];
      type: components['schemas']['ProductType'];
      /** Prices */
      prices: components['schemas']['PriceView'][];
    };
    /** Heidi2ProductView */
    Heidi2ProductView: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      tier: components['schemas']['SubscriptionTier'];
      new_product_tier: components['schemas']['SubscriptionTier'];
      type: components['schemas']['ProductType'];
      /** Prices */
      prices: components['schemas']['PriceView'][];
      seat_type: components['schemas']['BillingSeatType'];
    };
    /**
     * ProfileFieldMatchEvidence
     * @description One profile attribute with a value drawn from clinical text and a supporting excerpt.
     */
    ProfileFieldMatchEvidence: {
      /** @description Must be exactly one PatientProfileModel field name from the schema enum (e.g. first_name, birth_date, ehr_patient_id). */
      profile_attribute: components['schemas']['PatientProfileMatchableField'];
      /**
       * Profile Value
       * @description Short value taken from the clinical text for this attribute (normalized when helpful); when scoring against candidates, compared to the stored patient profile field.
       */
      profile_value: string;
      /**
       * Transcript Support
       * @description Short verbatim or near-verbatim excerpt from the provided clinical text.
       */
      transcript_support: string;
    };
    /** ProfileGroupItem */
    ProfileGroupItem: {
      /** Profile Group */
      profile_group: string;
      /** Profile Names */
      profile_names: string[];
    };
    /** ProfileGroupListResponse */
    ProfileGroupListResponse: {
      /** Groups */
      groups: components['schemas']['ProfileGroupItem'][];
    };
    /** ProfileMatch */
    ProfileMatch: {
      /** Id */
      id: string;
      confidence: components['schemas']['MatchConfidence'];
      /** Match Type */
      match_type: components['schemas']['MatchType'] | string;
      /** Matched Fields */
      matched_fields: string[];
      /** Conflicting Fields */
      conflicting_fields: string[];
      /** Demographic String */
      demographic_string: string;
      /** First Name */
      first_name: string | null;
      /** Last Name */
      last_name: string | null;
      /** Birth Date */
      birth_date: string | null;
      /** Email */
      email: string | null;
      ehr_link?: components['schemas']['EhrLink'] | null;
    };
    /** ProjectAttachmentDownloadUrlResponse */
    ProjectAttachmentDownloadUrlResponse: {
      /** Url */
      url: string;
    };
    /**
     * ProjectAttachmentResponse
     * @description Pre-uploaded attachment metadata returned to the FE composer.
     *
     *     Mirrors ``apis/v2/chat/schema.PendingChatAttachmentResponse`` field
     *     names so the same FE chip components can render either surface.
     *     The ``url`` is a presigned S3 GET, valid for the harness presigned
     *     TTL — the FE uses it for inline previews (image thumbs, PDF viewer)
     *     and for download chips on completed messages.
     */
    ProjectAttachmentResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Type */
      type: string;
      /** Size */
      size?: number | null;
      /** Url */
      url: string;
    };
    /** ProjectDetail */
    ProjectDetail: {
      /** Project Id */
      project_id: string;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /** Is Saved */
      is_saved: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Agent Config Id */
      agent_config_id: string;
      /** Agent Run Id */
      agent_run_id: string;
      /**
       * Recording Eligible
       * @default false
       */
      recording_eligible: boolean;
      /** Session Id */
      session_id?: string | null;
      /**
       * Tool Profile
       * @enum {string}
       */
      tool_profile: ProjectDetailTool_profile;
      /** Tool Approvals */
      tool_approvals?: components['schemas']['ProjectToolApproval'][];
      /** Run Flags */
      run_flags?: {
        [key: string]: boolean;
      };
      /**
       * Title Is Custom
       * @default false
       */
      title_is_custom: boolean;
      /** Desktop Target Enabled */
      desktop_target_enabled: boolean;
    };
    /**
     * ProjectFeedbackRequest
     * @description Thumbs feedback on a single assistant reply in a project chat.
     *
     *     Stored in the shared ``user_feedback`` collection with
     *     ``target_type=PROJECT`` and ``target_id`` set to the project id, so
     *     project feedback flows through the same pipeline as Evidence chat
     *     feedback (``POST /chat/feedback``).
     */
    ProjectFeedbackRequest: {
      /** @description ``thumb_up`` or ``thumb_down`` for the assistant reply. */
      rating: components['schemas']['ThumbRating'];
      /**
       * Message Id
       * @description Identifier for the specific assistant reply the feedback refers to. The FE sends the reply's transcript position; null is allowed for project-level feedback.
       */
      message_id?: string | null;
      /**
       * User Feedback
       * @description Optional free-text comment accompanying the rating.
       */
      user_feedback?: string | null;
      /**
       * Content Snapshot
       * @description Snapshot of the rated content at the time of feedback.
       */
      content_snapshot?: string | null;
    };
    /** ProjectFeedbackResponse */
    ProjectFeedbackResponse: {
      /** Feedback Id */
      feedback_id: string;
    };
    /**
     * ProjectFollowUpQuestionsRequest
     * @description Client hints for generating Project follow-up questions.
     *
     *     The user/assistant turns are derived server-side from the project
     *     transcript (the server is authoritative — the client never supplies
     *     conversation content), so the body only carries presentation hints.
     */
    ProjectFollowUpQuestionsRequest: {
      /**
       * Display Language
       * @description Display language code (e.g. 'en', 'es') for the generated questions. Defaults to English when omitted.
       */
      display_language?: string | null;
    };
    /** ProjectListItem */
    ProjectListItem: {
      /** Project Id */
      project_id: string;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /** Is Saved */
      is_saved: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * ProjectListResponse
     * @description Paginated list of the caller's projects.
     *
     *     Sort order is fixed by the server: ``is_saved DESC, updated_at DESC``.
     *     Saved projects always float to the top so a single list call can
     *     feed both the sidebar (which wants saved-first) and the landing
     *     page (which renders them under a "Saved" header) without the FE
     *     having to merge two requests.
     *
     *     ``next_cursor`` is the ``project_id`` (24-char hex) of the last
     *     item in the current page; pass it back as the ``cursor`` query
     *     param to fetch the next page. Absent when there are no more rows.
     */
    ProjectListResponse: {
      /** Items */
      items: components['schemas']['ProjectListItem'][];
      /** Next Cursor */
      next_cursor?: string | null;
    };
    /** ProjectMessage */
    ProjectMessage: {
      /**
       * Role
       * @enum {string}
       */
      role: ProjectMessageRole;
      /** Blocks */
      blocks?: components['schemas']['ProjectMessageBlock'][];
      /**
       * Artifact Id
       * @description Id of the artefact this message was persisted as — the same id the run's stream events carry for these rows, so a live card and a reloaded transcript key on one identity. Opaque: join on it, never parse it. Null for transcripts persisted before artefact identity was carried through the read path.
       */
      artifact_id?: string | null;
      /**
       * Turn Id
       * @description Turn this message belongs to.
       */
      turn_id?: string | null;
      /**
       * Message Index
       * @description Position of this message within its artefact. Always 0 except on a multi-message user turn.
       */
      message_index?: number | null;
    };
    /**
     * ProjectMessageBlock
     * @description UI-projection of a conversation block.
     *
     *     We collapse provider-specific metadata and only surface the
     *     fields needed to render a transcript: text content, tool usage,
     *     tool results, and attachment references. Anything we can't render
     *     is omitted.
     */
    ProjectMessageBlock: {
      /**
       * Kind
       * @enum {string}
       */
      kind: ProjectMessageBlockKind;
      /** Text */
      text?: string | null;
      /** Tool Name */
      tool_name?: string | null;
      /** Tool Call Id */
      tool_call_id?: string | null;
      /** Tool Input */
      tool_input?: {
        [key: string]: unknown;
      } | null;
      /** @description User-facing display metadata for tool_call blocks. Always present on kind == 'tool_call': the persisted tool_call_display when available, otherwise the server-side humanized fallback derived from tool_name — so clients never need to derive a display name from the raw tool_name. */
      tool_call_display?: components['schemas']['ToolCallDisplay'] | null;
      /** Tool Result Text */
      tool_result_text?: string | null;
      /** Filename */
      filename?: string | null;
      /** Attachment Id */
      attachment_id?: string | null;
      /** Mime Type */
      mime_type?: string | null;
      /** Attachment Type */
      attachment_type?: ProjectMessageBlockAttachment_typeAnyOf0 | null;
      /** Size Bytes */
      size_bytes?: number | null;
      /** Is Error */
      is_error?: boolean | null;
      evidence?: components['schemas']['EvidenceRenderPayload'] | null;
      /**
       * Source Citations
       * @description Verified citations emitted by the render_sources tool. None for all other tool results, legacy transcripts, and malformed payloads.
       */
      source_citations?: components['schemas']['ProjectSourceCitation'][] | null;
      /** @description The run's todo list as of this tool result. Populated on tool_result blocks from the todo tools; None everywhere else, including on results persisted before this payload shipped. */
      todo_state?: components['schemas']['AgentTodoStatePayload'] | null;
      /**
       * Created At
       * @description Timestamp of the artefact this block was persisted in — the assistant artefact for text/thinking/tool_call blocks, the tool-execution artefact for tool_result blocks. Every block from one artefact shares it, so the FE derives durations from deltas between consecutive artefacts. Null for transcripts persisted before artefact timestamps were carried through the read path.
       */
      created_at?: string | null;
    };
    /** ProjectMessagesResponse */
    ProjectMessagesResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Status */
      status: string;
      /** Is Streaming */
      is_streaming: boolean;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Messages */
      messages: components['schemas']['ProjectMessage'][];
    };
    /**
     * ProjectRunFlag
     * @enum {string}
     */
    ProjectRunFlag: ProjectRunFlag;
    /** ProjectToolApproval */
    ProjectToolApproval: {
      /** Tool Name */
      tool_name: string;
      /**
       * Mode
       * @enum {string}
       */
      mode: ProjectToolApprovalMode;
    };
    /** PromoteTeamWorkflowRequest */
    PromoteTeamWorkflowRequest: {
      /** Source Recording Id */
      source_recording_id: string;
      /** Name */
      name: string;
    };
    /** PromptConfigurationCreateRequest */
    PromptConfigurationCreateRequest: {
      language_code: components['schemas']['LanguageCode'];
    };
    /** PromptConfigurationResponse */
    PromptConfigurationResponse: {
      /** Description */
      description?: string | null;
      /** Specialty Note Structure Id */
      specialty_note_structure_id?: string | null;
      /** Preset Templates */
      preset_templates: string[];
      /** Onboarding Script Prompt Id */
      onboarding_script_prompt_id?: string | null;
      /** Generate Template Suggestions */
      generate_template_suggestions: string[];
      /** Generate Template With Ai Prompt Id */
      generate_template_with_ai_prompt_id?: string | null;
      /** Is Live */
      is_live: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** PromptConfigurationUpdateRequest */
    PromptConfigurationUpdateRequest: {
      language_code: components['schemas']['LanguageCode'];
      /** Description */
      description?: string | null;
      /** Specialty Note Structure Id */
      specialty_note_structure_id?: string | null;
      /**
       * Preset Templates
       * @default []
       */
      preset_templates: string[];
      /** Onboarding Script Prompt Id */
      onboarding_script_prompt_id?: string | null;
      /**
       * Generate Template Suggestions
       * @default []
       */
      generate_template_suggestions: string[];
      /** Generate Template With Ai Prompt Id */
      generate_template_with_ai_prompt_id?: string | null;
      /**
       * Is Live
       * @default false
       */
      is_live: boolean;
    };
    /**
     * PromptContextFailureRecord
     * @description Persisted prompt-context failure diagnostic for FE hydration.
     */
    PromptContextFailureRecord: {
      /** Event Id */
      event_id: string;
      /** Agent Run Id */
      agent_run_id: string;
      /** Turn Id */
      turn_id?: string | null;
      /** Prompt Variable Key */
      prompt_variable_key: string;
      /**
       * Failure Mode
       * @enum {string}
       */
      failure_mode: PromptContextFailureRecordFailure_mode;
      /**
       * Status
       * @enum {string}
       */
      status: PromptContextFailureRecordStatus;
      /**
       * Reason
       * @default
       */
      reason: string;
      /** Provider Name */
      provider_name?: string | null;
      /** Source Ids */
      source_ids?: {
        [key: string]: string;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** PromptResponse */
    PromptResponse: {
      /** Name */
      name?: string | null;
      /** Prompt */
      prompt?: string | null;
    };
    /** PromptTeamsBranchSchema */
    PromptTeamsBranchSchema: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** PromptTeamsPromptListResponse */
    PromptTeamsPromptListResponse: {
      /** Branch Id */
      branch_id: string;
      /** Prompts */
      prompts: components['schemas']['PromptTeamsPromptSchema'][];
    };
    /** PromptTeamsPromptSchema */
    PromptTeamsPromptSchema: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Template */
      template: string;
      /** Version */
      version?: string | null;
    };
    /** PromptTeamsRepoListResponse */
    PromptTeamsRepoListResponse: {
      /** Repos */
      repos: components['schemas']['PromptTeamsRepoSchema'][];
    };
    /** PromptTeamsRepoSchema */
    PromptTeamsRepoSchema: {
      /** Name */
      name: string;
      /** Branches */
      branches: components['schemas']['PromptTeamsBranchSchema'][];
    };
    /**
     * PromptVariableBinding
     * @description One enabled prompt variable, with optional per-variable config.
     */
    PromptVariableBinding: {
      /** Key */
      key: string;
      /** Config */
      config?: {
        [key: string]: unknown;
      };
    };
    /**
     * PromptVariableDefinition
     * @description Metadata surfaced to the IA frontend for variable selection.
     */
    PromptVariableDefinition: {
      /** Key */
      key: string;
      /** Label */
      label: string;
      /** Description */
      description: string;
      /**
       * Kind
       * @default pure
       * @enum {string}
       */
      kind: PromptVariableDefinitionKind;
      /**
       * Default Enabled
       * @default false
       */
      default_enabled: boolean;
      /** Config Schema */
      config_schema?: {
        [key: string]: unknown;
      } | null;
      /** Context Provider Name */
      context_provider_name?: string | null;
      /**
       * Failure Mode
       * @default best_effort
       * @enum {string}
       */
      failure_mode: PromptVariableDefinitionFailure_mode;
      /**
       * Runtime Requirements
       * @default []
       */
      runtime_requirements: string[];
      /** Default Token Budget */
      default_token_budget?: number | null;
      /**
       * Data Classification
       * @default none
       * @enum {string}
       */
      data_classification: PromptVariableDefinitionData_classification;
    };
    /** PromptVariableSchema */
    PromptVariableSchema: {
      /** Key */
      key: string;
      /** Description */
      description: string;
      /** Source */
      source: string;
      /** Required */
      required: boolean;
    };
    /**
     * ProtocolDeleteResponse
     * @description Response for protocol deletion.
     */
    ProtocolDeleteResponse: {
      /** Success */
      success: boolean;
    };
    /**
     * ProtocolDraft
     * @description Current protocol field values (for edit mode).
     */
    ProtocolDraft: {
      /** Name */
      name?: string | null;
      /** Shorthand */
      shorthand?: string | null;
      /** Description */
      description?: string | null;
      /** Standard Operating Procedure */
      standard_operating_procedure?: string | null;
    };
    /**
     * ProtocolListResponse
     * @description Response containing lists of protocols.
     */
    ProtocolListResponse: {
      /** System Protocols */
      system_protocols: components['schemas']['ProtocolResponse'][];
      /** User Protocols */
      user_protocols: components['schemas']['ProtocolResponse'][];
    };
    /** ProtocolListView */
    ProtocolListView: {
      /** Protocols */
      protocols: components['schemas']['ProtocolSummaryView'][];
    };
    /** ProtocolModel */
    ProtocolModel: {
      /** Schema Version */
      schema_version: string;
      /** Protocol Id */
      protocol_id: string;
      /** Display Name */
      display_name: string;
      /** Summary */
      summary?: string | null;
      /** Version */
      version: string;
      /**
       * Status
       * @enum {string}
       */
      status: ProtocolModelStatus;
      tenant_scope: components['schemas']['TenantScopeModel'];
      source_artifact: components['schemas']['SourceArtifactModel'];
      /** Clinical Sign Off */
      clinical_sign_off: components['schemas']['ClinicalSignOffModel'][];
      /** Classifier Summary */
      classifier_summary: string;
      /**
       * Confidence Threshold
       * @default 0.75
       */
      confidence_threshold: number;
      /** Eval Scenarios Ref */
      eval_scenarios_ref: string;
      /** Trigger Phrases */
      trigger_phrases?: string[] | null;
      /** Sections */
      sections: components['schemas']['SectionModel'][];
      /** Special Notes */
      special_notes?: components['schemas']['SpecialNoteModel'][];
    };
    /**
     * ProtocolResponse
     * @description Single protocol response.
     */
    ProtocolResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Shorthand */
      shorthand: string;
      /** Description */
      description: string;
      /** Standard Operating Procedure */
      standard_operating_procedure: string;
      /** Output Template Id */
      output_template_id: string | null;
      /** Reference Document Keys */
      reference_document_keys: string[];
      /** Connector Ids */
      connector_ids: string[];
      /** Required Capability Slugs */
      required_capability_slugs: string[];
      /** Is Active */
      is_active: boolean;
      /** Is System */
      is_system: boolean;
      /** Icon */
      icon?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * ProtocolSummaryView
     * @description Lightweight entry for the "All protocols" browse list.
     */
    ProtocolSummaryView: {
      /** Protocol Id */
      protocol_id: string;
      /** Display Name */
      display_name: string;
      /** Summary */
      summary?: string | null;
      /** Version */
      version: string;
    };
    /**
     * ProtocolTestCaseModel
     * @description A bench test case: a transcript snippet plus whether this protocol SHOULD fire.
     *
     *     Drives the dashboard test-bench ("X/N passed") and, for safety-critical protocols, the
     *     non-vacuous firing-rate floor. PHI note: test transcripts live only on the protocol
     *     document — never in the code index or analytics.
     */
    ProtocolTestCaseModel: {
      /** Case Id */
      case_id: string;
      /** Transcript */
      transcript: string;
      /**
       * Expect
       * @enum {string}
       */
      expect: ProtocolTestCaseModelExpect;
      /** Note */
      note?: string | null;
      /**
       * Safety Critical
       * @default false
       */
      safety_critical: boolean;
    };
    /** Provenance */
    Provenance: {
      /** Items */
      items: components['schemas']['ProvenanceItem'][];
    };
    /** ProvenanceItem */
    ProvenanceItem: {
      /** Spans */
      spans: components['schemas']['ProvenanceSpan'][];
    };
    /**
     * ProvenanceSpan
     * @description A transcript excerpt linked to a generated value.
     */
    ProvenanceSpan: {
      /** Text */
      text: string;
      /** Speaker */
      speaker?: string | null;
    };
    /**
     * ProviderModelOption
     * @description One selectable model for a provider.
     *
     *     ``id`` is the exact string to send back as ``AgentConfig.model`` — it
     *     is passed straight to the provider SDK by
     *     ``ToolCallingLLMAdapterFactory.create_adapter``. ``label`` is a UI hint
     *     only.
     */
    ProviderModelOption: {
      /** Id */
      id: string;
      /** Label */
      label: string;
    };
    /**
     * ProviderModels
     * @description Selectable models for a single provider.
     */
    ProviderModels: {
      /** Provider */
      provider: string;
      /** Label */
      label: string;
      /** Models */
      models: components['schemas']['ProviderModelOption'][];
    };
    /**
     * ProviderRetirementResult
     * @description Per-provider outcome of a retire-provider-identities call.
     *
     *     Mirrors ServiceMigrationResult shape in change_provider_regions but kept
     *     local to the user-to-user migration namespace so the two flows can diverge
     *     without coupling.
     *
     *     Note: hard failures from IB / Kinde become HTTP 500, so this model only
     *     represents the two success-path outcomes (deleted | skipped). A failed
     *     provider does not appear in retired_data — the entire response is replaced
     *     by the 500 error.
     */
    ProviderRetirementResult: {
      /**
       * Provider
       * @description Third-party provider name
       * @enum {string}
       */
      provider: ProviderRetirementResultProvider;
      /**
       * Status
       * @description Outcome of the retirement attempt for this provider
       * @enum {string}
       */
      status: ProviderRetirementResultStatus;
      /**
       * Reason
       * @description Explanation for skipped status
       */
      reason?: string | null;
    };
    /**
     * Providers
     * @enum {string}
     */
    Providers: Providers;
    /** ProvisionFromRootTeamRequest */
    ProvisionFromRootTeamRequest: {
      /**
       * Root Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      root_team_id: string;
    };
    /** ProvisionFromRootTeamResponse */
    ProvisionFromRootTeamResponse: {
      /**
       * Workspace Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      workspace_id: string;
      /** Workspace Created */
      workspace_created: boolean;
      /** Memberships Created */
      memberships_created: number;
      /** Total Memberships */
      total_memberships: number;
    };
    /** ProvisionFromUserRequest */
    ProvisionFromUserRequest: {
      /** User Ref Id */
      user_ref_id: string;
    };
    /** ProvisionFromUserResponse */
    ProvisionFromUserResponse: {
      /**
       * Workspace Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      workspace_id: string;
    };
    /** ProvisionWalletRequest */
    ProvisionWalletRequest: {
      /** Workspace Id */
      workspace_id: string;
      /** Billing Account Id */
      billing_account_id?: string | null;
    };
    /** PublicDraftOrderLineItem */
    PublicDraftOrderLineItem: {
      /** Product */
      product: string;
      /** Quantity */
      quantity: number;
    };
    /**
     * PublicDraftOrderResponse
     * @description Safe, allow-listed projection of a guest-checkout draft order.
     *
     *     Deliberately built field-by-field from the `Order` rather than dumping the
     *     model: it carries only what the guest checkout / confirmation pages need
     *     (line items, currency, normalized shipping, status) and never payment
     *     internals (Stripe ids) or internal ops fields (reason, created_by, ERP
     *     errors).
     */
    PublicDraftOrderResponse: {
      /** Order Id */
      order_id: string;
      status: components['schemas']['PublicDraftOrderStatus'];
      /** Currency */
      currency: string;
      /** Line Items */
      line_items: components['schemas']['PublicDraftOrderLineItem'][];
      shipping: components['schemas']['PublicDraftOrderShipping'] | null;
    };
    /**
     * PublicDraftOrderShipping
     * @description Allow-listed shipping projection for the public draft read.
     *
     *     A dedicated DTO rather than the domain `ShippingDetails` so a field later
     *     added to the domain model cannot silently widen this public contract.
     */
    PublicDraftOrderShipping: {
      /** Contact Name */
      contact_name?: string | null;
      /** Contact Email */
      contact_email?: string | null;
      /** Contact Phone */
      contact_phone?: string | null;
      /** Street Address */
      street_address?: string | null;
      /** City */
      city?: string | null;
      /** State */
      state?: string | null;
      /** Postcode */
      postcode?: string | null;
      /** Country */
      country?: string | null;
    };
    /**
     * PublicDraftOrderStatus
     * @description Customer-facing status of a guest-checkout draft.
     *
     *     A stable, minimal vocabulary covering only the draft lifecycle the guest
     *     checkout pages care about — pre-payment, paid confirmation, and abandoned
     *     (expired) — so the public contract stays decoupled from the wider internal
     *     `OrderStatus` enum. Any order outside these states is not exposed here.
     * @enum {string}
     */
    PublicDraftOrderStatus: PublicDraftOrderStatus;
    /**
     * PublicOrderStatusResponse
     * @example {
     *       "erp_order_id": "GLOBAL-123456",
     *       "fulfillment_stage": "shipped",
     *       "placed_at": "2026-05-01T12:00:00",
     *       "tracking_url": "https://www.track123.com/track?trackNos=ABC123"
     *     }
     */
    PublicOrderStatusResponse: {
      /** Erp Order Id */
      erp_order_id: string;
      /**
       * Placed At
       * Format: date-time
       */
      placed_at: string;
      fulfillment_stage: components['schemas']['FulfillmentStage'];
      /** Tracking Url */
      tracking_url?: string | null;
    };
    /**
     * PublicRunUsageSummary
     * @description Subject-safe aggregate token usage for a run.
     */
    PublicRunUsageSummary: {
      /**
       * Total Input Tokens
       * @default 0
       */
      total_input_tokens: number;
      /**
       * Total Output Tokens
       * @default 0
       */
      total_output_tokens: number;
      /**
       * Total Cache Creation Input Tokens
       * @default 0
       */
      total_cache_creation_input_tokens: number;
      /**
       * Total Cache Read Input Tokens
       * @default 0
       */
      total_cache_read_input_tokens: number;
      /**
       * Total Thinking Tokens
       * @default 0
       */
      total_thinking_tokens: number;
    };
    /**
     * PublicationStatus
     * @description The lifecycle status of an artifact.
     *
     *     https://hl7.org/fhir/R4/valueset-publication-status.html
     * @enum {string}
     */
    PublicationStatus: PublicationStatus;
    /** PublishDraftResponse */
    PublishDraftResponse: {
      /** Draft Id */
      draft_id: string;
      /** Status */
      status: string;
      /** Published Answer Id */
      published_answer_id: string | null;
      /** Message */
      message: string;
    };
    /**
     * PublishProtocolRequest
     * @description Single-manager publish (pilot — no four-eyes, audit-logged). The server stamps
     *     ``version_signed`` = the protocol's current version.
     */
    PublishProtocolRequest: {
      /** Reviewer */
      reviewer: string;
      /** Reviewer Role */
      reviewer_role: string;
      /** Signature */
      signature?: string | null;
    };
    /**
     * PublishRateCardVersionRequest
     * @description The full row set of the next version — a publish is a whole-card
     *     replacement, never a patch over the version in effect.
     */
    PublishRateCardVersionRequest: {
      /** Entries */
      entries: components['schemas']['RateCardEntryInput'][];
    };
    /**
     * PushCodesResponse
     * @description Response for POST /sessions/{session_id}/problems/push-codes.
     */
    PushCodesResponse: {
      /** Success */
      success: boolean;
      /**
       * Diagnoses Pushed
       * @description Number of ICD-10 diagnoses written to encounter
       */
      diagnoses_pushed: number;
      /**
       * Problems Created
       * @description Number of new problems added to patient chart
       */
      problems_created: number;
      /**
       * Message
       * @description Success or error message
       * @default
       */
      message: string;
    };
    /**
     * QaResult
     * @description The verdict an operator records for a QA run.
     * @enum {string}
     */
    QaResult: QaResult;
    /**
     * Quantity
     * @description A measured amount (or an amount that can potentially be measured).
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Quantity
     */
    Quantity: {
      /**
       * Numerical value (with implicit precision)
       * @description The value of the measured amount. The value includes an implicit precision in the presentation of the value.
       */
      value?: number | null;
      /**
       * < | <= | >= | > - how to understand the value
       * @description How the value should be understood and represented - whether the actual value is greater or less than the stated value due to measurement issues; e.g. if the comparator is '<', then the real value is < stated value.
       */
      comparator?: string | null;
      /**
       * Unit representation
       * @description A human-readable form of the unit.
       */
      unit?: string | null;
      /**
       * System that defines coded unit form
       * @description The identification of the system that provides the coded form of the unit.
       */
      system?: string | null;
      /**
       * Coded form of the unit
       * @description A computer processable form of the unit in some unit representation system.
       */
      code?: string | null;
    };
    /** QueryWorkflowRequest */
    QueryWorkflowRequest: {
      /** Query Name */
      query_name: string;
      /**
       * Args
       * @default []
       */
      args: unknown[];
    };
    /** QueryWorkflowResponse */
    QueryWorkflowResponse: {
      /** Result */
      result: unknown;
    };
    /** Question */
    Question: {
      /** Questionid */
      questionId: string;
      /** Question */
      question: string;
      /** Dateformat */
      dateFormat?: string | null;
      /** Answertype */
      answerType: string;
      /** Answeroptions */
      answerOptions?: components['schemas']['AnswerOption'][] | null;
      /** Description */
      description?: string | null;
      /** Repeatable */
      repeatable: boolean;
      /** Childquestions */
      childQuestions?: components['schemas']['Question'][];
    };
    /** QuestionAnswer */
    QuestionAnswer: {
      /** Questionid */
      questionId: string;
      /** Question */
      question: string;
      /** Answertype */
      answerType: string;
      /** Answeroptions */
      answerOptions?: components['schemas']['AnswerOption'][] | null;
      /** Answer */
      answer?: components['schemas']['Answer'][] | null;
      /** Dateformat */
      dateFormat?: string | null;
      /** Repeatable */
      repeatable: boolean;
      /** Childquestions */
      childQuestions?: components['schemas']['QuestionAnswer'][];
    };
    /** QuestionAnswerPair */
    QuestionAnswerPair: {
      /** Question Id */
      question_id: string;
      /** Question */
      question: string;
      /** Answer Type */
      answer_type: string;
      /** Answer Options */
      answer_options: string[];
      /** Answer */
      answer: string[];
      /** Date Format */
      date_format?: string | null;
    };
    /**
     * QuestionnaireItemAnswerOption
     * @description Permitted answer for a choice or open-choice question.
     *
     *     https://hl7.org/fhir/R4/questionnaire-definitions.html#Questionnaire.item.answerOption
     */
    QuestionnaireItemAnswerOption: {
      /**
       * Answer value
       * @description A potential answer that's allowed as the answer to this question.
       */
      valueInteger?: number | null;
      /**
       * Answer value
       * @description A potential answer that's allowed as the answer to this question.
       */
      valueDate?: string | null;
      /**
       * Answer value
       * @description A potential answer that's allowed as the answer to this question.
       */
      valueTime?: string | null;
      /**
       * Answer value
       * @description A potential answer that's allowed as the answer to this question.
       */
      valueString?: string | null;
      /**
       * Answer value
       * @description A potential answer that's allowed as the answer to this question.
       */
      valueCoding?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding']
        | null;
      /**
       * Answer value
       * @description A potential answer that's allowed as the answer to this question.
       */
      valueReference?: components['schemas']['Reference'] | null;
      /**
       * Whether option is selected by default
       * @description Indicates whether the answer value is selected when the list of possible answers is initially shown.
       */
      initialSelected?: boolean | null;
    };
    /**
     * QuestionnaireItemEnableBehavior
     * @description Controls how multiple enableWhen values are interpreted.
     *
     *     https://hl7.org/fhir/R4/valueset-enable-when-behavior.html
     * @enum {string}
     */
    QuestionnaireItemEnableBehavior: QuestionnaireItemEnableBehavior;
    /**
     * QuestionnaireItemEnableWhen
     * @description Constraint indicating when a questionnaire item should be enabled.
     *
     *     https://hl7.org/fhir/R4/questionnaire-definitions.html#Questionnaire.item.enableWhen
     */
    QuestionnaireItemEnableWhen: {
      /**
       * Question that determines whether item is enabled
       * @description The linkId for the question whose answer (or lack of answer) governs whether this item is enabled.
       */
      question: string;
      /**
       * exists | = | != | > | < | >= | <=
       * @description Specifies the criteria by which the question is enabled.
       */
      operator: components['schemas']['QuestionnaireItemEnableWhenOperator'];
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerBoolean?: boolean | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerDecimal?: number | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerInteger?: number | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerDate?: string | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerDateTime?: string | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerTime?: string | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerString?: string | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerCoding?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding']
        | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Value for question comparison based on operator
       * @description A value that the referenced question is tested using the specified operator in order for the item to be enabled.
       */
      answerReference?: components['schemas']['Reference'] | null;
    };
    /**
     * QuestionnaireItemEnableWhenOperator
     * @description Operator for questionnaire item enableWhen conditions.
     *
     *     https://hl7.org/fhir/R4/valueset-questionnaire-enable-operator.html
     * @enum {string}
     */
    QuestionnaireItemEnableWhenOperator: QuestionnaireItemEnableWhenOperator;
    /**
     * QuestionnaireItemInitial
     * @description Initial value when a questionnaire item is first rendered.
     *
     *     https://hl7.org/fhir/R4/questionnaire-definitions.html#Questionnaire.item.initial
     */
    QuestionnaireItemInitial: {
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueBoolean?: boolean | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueDecimal?: number | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueInteger?: number | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueDate?: string | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueDateTime?: string | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueTime?: string | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueString?: string | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueUri?: string | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueAttachment?: components['schemas']['Attachment'] | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueCoding?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding']
        | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Actual value for initializing the question
       * @description The actual value to for an initial answer.
       */
      valueReference?: components['schemas']['Reference'] | null;
    };
    /**
     * QuestionnaireItemType
     * @description Type of questionnaire item.
     *
     *     https://hl7.org/fhir/R4/valueset-item-type.html
     * @enum {string}
     */
    QuestionnaireItemType: QuestionnaireItemType;
    /**
     * QuestionnaireResponse
     * @description A structured set of questions and their answers.
     *
     *     https://hl7.org/fhir/R4/questionnaireresponse-definitions.html
     */
    QuestionnaireResponse: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Unique id for this set of answers
       * @description A business identifier assigned to a particular completed (or partially completed) questionnaire.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * Request fulfilled by this QuestionnaireResponse
       * @description The order, proposal or plan that is fulfilled in whole or in part by this QuestionnaireResponse.
       */
      basedOn?: components['schemas']['Reference'][] | null;
      /**
       * Part of this action
       * @description A procedure or observation that this questionnaire was performed as part of the execution of.
       */
      partOf?: components['schemas']['Reference'][] | null;
      /**
       * Form being answered
       * @description The Questionnaire that defines and organizes the questions for which answers are being provided.
       */
      questionnaire?: string | null;
      /**
       * in-progress | completed | amended | entered-in-error | stopped
       * @description The position of the questionnaire response within its overall lifecycle.
       */
      status: components['schemas']['QuestionnaireResponseStatus'];
      /**
       * The subject of the questions
       * @description The subject of the questionnaire response. This is who/what the answers apply to, but is not necessarily the source of information.
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * Encounter created as part of
       * @description The Encounter during which this questionnaire response was created or to which the creation of this record is tightly associated.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * Date the answers were gathered
       * @description The date and/or time that this set of answers were last changed.
       */
      authored?: string | null;
      /**
       * Person who received and recorded the answers
       * @description Person who received the answers to the questions in the QuestionnaireResponse and recorded them in the system.
       */
      author?: components['schemas']['Reference'] | null;
      /**
       * The person who answered the questions
       * @description The person who answered the questions about the subject.
       */
      source?: components['schemas']['Reference'] | null;
      /**
       * Groups and questions
       * @description A group or question item from the original questionnaire for which answers are provided.
       */
      item?: components['schemas']['QuestionnaireResponseItem'][] | null;
    };
    /**
     * QuestionnaireResponseItem
     * @description A group or question item from the original questionnaire with answers.
     *
     *     https://hl7.org/fhir/R4/questionnaireresponse-definitions.html#QuestionnaireResponse.item
     */
    QuestionnaireResponseItem: {
      /**
       * Pointer to specific item from Questionnaire
       * @description The item from the Questionnaire that corresponds to this item in the QuestionnaireResponse resource.
       */
      linkId: string;
      /**
       * ElementDefinition - details for the item
       * @description A reference to an ElementDefinition that provides the details for the item.
       */
      definition?: string | null;
      /**
       * Name for group or question text
       * @description Text that is displayed above the contents of the group or as the text of the question being answered.
       */
      text?: string | null;
      /**
       * The response(s) to the question
       * @description The respondent's answer(s) to the question.
       */
      answer?: components['schemas']['QuestionnaireResponseItemAnswer'][] | null;
      /**
       * Nested questionnaire response items
       * @description Questions or sub-groups nested beneath a question or group.
       */
      item?: components['schemas']['QuestionnaireResponseItem'][] | null;
    };
    /**
     * QuestionnaireResponseItemAnswer
     * @description The respondent's answer(s) to a question.
     *
     *     https://hl7.org/fhir/R4/questionnaireresponse-definitions.html#QuestionnaireResponse.item.answer
     */
    QuestionnaireResponseItemAnswer: {
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueBoolean?: boolean | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueDecimal?: number | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueInteger?: number | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueDate?: string | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueDateTime?: string | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueTime?: string | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueString?: string | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueUri?: string | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueAttachment?: components['schemas']['Attachment'] | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueCoding?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding']
        | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Single-valued answer to the question
       * @description The answer (or one of the answers) provided by the respondent to the question.
       */
      valueReference?: components['schemas']['Reference'] | null;
      /**
       * Nested groups and questions
       * @description Nested groups and/or questions found within this particular answer.
       */
      item?: components['schemas']['QuestionnaireResponseItem'][] | null;
    };
    /**
     * QuestionnaireResponseStatus
     * @description Lifecycle status of a questionnaire response.
     *
     *     https://hl7.org/fhir/R4/valueset-questionnaire-answers-status.html
     * @enum {string}
     */
    QuestionnaireResponseStatus: QuestionnaireResponseStatus;
    /**
     * QuestionnaireStatus
     * @description Publication status of a questionnaire.
     *
     *     https://hl7.org/fhir/R4/valueset-publication-status.html
     * @enum {string}
     */
    QuestionnaireStatus: QuestionnaireStatus;
    /**
     * Quota
     * @description User-quota counters.
     *
     *     Reset monthly by UserRepo.reset_user_quota, except for
     *     clinical_code_auto_gen (manual) and evidence_usage.in_session
     *     (weekly, lazy — see EvidenceUsage).
     */
    Quota: {
      /**
       * Long Consult
       * @default 3
       */
      long_consult: number;
      /**
       * Ai Template
       * @default 10
       */
      ai_template: number;
      /**
       * Sectional Note
       * @default 100
       */
      sectional_note: number;
      /**
       * Ask Ai
       * @default 10
       */
      ask_ai: number;
      /**
       * Clinical Code Auto Gen
       * @default 10
       */
      clinical_code_auto_gen: number;
      /** Unlimited Quota Until */
      unlimited_quota_until?: string | null;
      /**
       * Evidence Patient Or Session Linked
       * @default 10
       */
      evidence_patient_or_session_linked: number;
    };
    /**
     * Range
     * @description A set of ordered Quantities defined by a low and high limit.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Range
     */
    Range: {
      /**
       * Low limit
       * @description The low limit. The boundary is inclusive.
       */
      low?: components['schemas']['Quantity'] | null;
      /**
       * High limit
       * @description The high limit. The boundary is inclusive.
       */
      high?: components['schemas']['Quantity'] | null;
    };
    /**
     * RateCardEntryInput
     * @description A card's pricing for one catalog product.
     *
     *     `aggregation_mode` and `sum_field` are absent on purpose — the catalog
     *     states how a product is measured and the entry copies it.
     */
    RateCardEntryInput: {
      /** Product Key */
      product_key: string;
      /** Priced On */
      priced_on?: string[];
      /** Rates */
      rates: components['schemas']['RateRowInput'][];
    };
    /**
     * RateCardEntryResponse
     * @description One product's pricing. The measurement fields are what this version
     *     copied when it was published, not what the catalog says today.
     */
    RateCardEntryResponse: {
      /** Product Key */
      product_key: string;
      /**
       * Aggregation Mode
       * @enum {string}
       */
      aggregation_mode: RateCardEntryResponseAggregation_mode;
      /** Sum Field */
      sum_field: RateCardEntryResponseSum_fieldAnyOf0 | null;
      /** Priced On */
      priced_on: string[];
      /** Rates */
      rates: components['schemas']['RateRowResponse'][];
    };
    /**
     * RateCardResponse
     * @description One immutable card version.
     *
     *     `entries` is a list here though the document stores a product-keyed map, so
     *     the read lines up with the write on the parts an admin authors
     *     (`product_key`, `priced_on`, `rates`). It is not a body that can be posted
     *     straight back: the two measurement fields it also carries are catalog-owned
     *     and a write that sends them is rejected.
     */
    RateCardResponse: {
      /** Rate Card Key */
      rate_card_key: string;
      /** Version */
      version: number;
      /** Is Active */
      is_active: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Entries */
      entries: components['schemas']['RateCardEntryResponse'][];
    };
    /**
     * RateCardSummaryResponse
     * @description One card version as the version history sees it — no rows; read a
     *     version for those.
     */
    RateCardSummaryResponse: {
      /** Rate Card Key */
      rate_card_key: string;
      /** Version */
      version: number;
      /** Is Active */
      is_active: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * RateCardWriteResponse
     * @description A written version plus anything the admin should see but that did not
     *     block the write — today, an entry priced in more than one currency.
     */
    RateCardWriteResponse: {
      /** Rate Card Key */
      rate_card_key: string;
      /** Version */
      version: number;
      /** Is Active */
      is_active: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Entries */
      entries: components['schemas']['RateCardEntryResponse'][];
      /** Warnings */
      warnings?: string[];
    };
    /**
     * RateRowInput
     * @description One priced dimension combination.
     *
     *     Send `rate` as a JSON **string**. A JSON number is parsed here without
     *     going through a float, so it is accepted and exact — but a JavaScript
     *     client has already put the value through a float64 by the time it
     *     serializes, and that is where a rate like 0.1 + 0.2 stops being the number
     *     the admin typed. The string is what makes the round trip the client's
     *     problem rather than a silent one.
     */
    RateRowInput: {
      /** Values */
      values?: {
        [key: string]: string;
      };
      /** Rate */
      rate: number | string;
      /** Currency */
      currency: string;
    };
    /** RateRowResponse */
    RateRowResponse: {
      /** Values */
      values: {
        [key: string]: string;
      };
      /** Rate */
      rate: number | string;
      /** Currency */
      currency: string;
    };
    /**
     * Ratio
     * @description A relationship of two Quantity values - expressed as a numerator and a denominator.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Ratio
     */
    Ratio: {
      /**
       * Numerator value
       * @description The value of the numerator.
       */
      numerator?: components['schemas']['Quantity'] | null;
      /**
       * Denominator value
       * @description The value of the denominator.
       */
      denominator?: components['schemas']['Quantity'] | null;
    };
    /** ReadOnlyField */
    ReadOnlyField: {
      field_name: components['schemas']['OrganizationOverrideTeamSettingField'];
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /** ReanalyzeRpaRecordingRequest */
    ReanalyzeRpaRecordingRequest: {
      /** Analysis Model */
      analysis_model?: string | null;
      /** Synthesis Model */
      synthesis_model?: string | null;
    };
    /**
     * RebindUserEmailRequest
     * @description Request schema for the rebind-user-email endpoint (MUL-2559).
     *
     *     Used by identity broker after it has rebound
     *     ``IdentityProfile.email`` (e.g. post-Apple-migration on the Auth0
     *     side). Identifier travels in the body, RPC-style, matching the
     *     broker's own request DTOs.
     */
    RebindUserEmailRequest: {
      /**
       * User Ref Id
       * @description UUID identifier of the user whose email should be rebound.
       * @example 01912345-6789-7abc-def0-123456789abc
       */
      user_ref_id: string;
      /**
       * New Email
       * Format: email
       * @description New email to bind. Server normalises to lower-case before any downstream use; callers should pre-normalise too.
       * @example user@privaterelay.appleid.com
       */
      new_email: string;
    };
    /**
     * RebindUserEmailResponse
     * @description Response envelope for the rebind-user-email endpoint.
     *
     *     Discriminated by ``status``. ``user_ref_id`` is always echoed back
     *     so callers correlate without keeping local state. The
     *     per-status email fields are populated only on the corresponding
     *     branch.
     */
    RebindUserEmailResponse: {
      /**
       * Status
       * @description Outcome of the rebind. ``completed`` ran the full fan-out; ``unchanged`` short-circuited because the supplied email already matched ``User.email``; ``user_not_found`` means no regional ``User`` exists for the supplied ``user_ref_id`` (treated as a soft outcome by the broker).
       * @enum {string}
       */
      status: RebindUserEmailResponseStatus;
      /**
       * User Ref Id
       * @description Echoes the supplied user_ref_id.
       */
      user_ref_id: string;
      /**
       * Previous Email
       * @description Set on ``completed`` — the email value prior to rebind.
       */
      previous_email?: string | null;
      /**
       * New Email
       * @description Set on ``completed`` — the normalised new email value.
       */
      new_email?: string | null;
      /**
       * Current Email
       * @description Set on ``unchanged`` — the stored email value that already matched the supplied one.
       */
      current_email?: string | null;
    };
    /**
     * RecipientSearchResponse
     * @description API response for a letter recipient search.
     */
    RecipientSearchResponse: {
      /**
       * Results
       * @description Recipient search hits eligible for letter delivery.
       */
      results?: (
        | components['schemas']['SealedMessageDeliveryRecipientSearchResultResponse']
        | components['schemas']['DirectoryRecipientSearchResultResponse']
      )[];
    };
    /** RecommendAgentConfigRequest */
    RecommendAgentConfigRequest: {
      /**
       * Description
       * @description Free-text brief of the agent the operator wants to build. May be keywords, a sentence, or a short paragraph. MUST NOT contain PHI — the text is forwarded to the planner LLM provider (via the agent harness) and recorded on the planner run. Describe the *shape* of the agent, not specific patient data.
       */
      description: string;
    };
    /** RecommendAgentConfigResponse */
    RecommendAgentConfigResponse: {
      suggested_config: components['schemas']['pkg__agent_harness__core__config__AgentConfig'];
      /**
       * Rationale
       * @default
       */
      rationale: string;
      /** Notes */
      notes?: string[];
      /**
       * Agent Run Id
       * @description ID of the planner run that produced this recommendation. Surfaced so operators can deep-link into the Runs UI and inspect the planner's tool calls / thinking.
       */
      agent_run_id?: string | null;
    };
    /**
     * RecommendedSource
     * @description A single recommended evidence source.
     */
    RecommendedSource: {
      /**
       * Domain
       * @description Source domain (e.g., 'aafp.org')
       */
      domain: string;
      /**
       * Display Name
       * @description Abbreviated display name for UI
       */
      display_name: string;
      /**
       * Website Name
       * @description Full website name
       */
      website_name: string | string[];
      /**
       * Specialty
       * @description Source specialty categories
       */
      specialty: string[];
      /**
       * Regions
       * @description Source region coverage
       */
      regions: string[];
      /**
       * Website Type
       * @description Source type classifications
       */
      website_type: string[];
      /**
       * Authoritativeness Score
       * @description Authority score (0-100)
       */
      authoritativeness_score?: number | null;
      /**
       * Impact Factor
       * @description Journal impact factor
       */
      impact_factor?: number | null;
      /**
       * Is Anchor
       * @description True for the curated set of always-include sources returned to every user regardless of country or specialty. The UI can use this flag to render anchors as a separate section.
       * @default false
       */
      is_anchor: boolean;
    };
    /**
     * RecompileRequest
     * @description Request model for recompiling agent system_instruction via prompt compiler.
     */
    RecompileRequest: {
      /** Goal */
      goal: string;
      /** Context */
      context?: string | null;
      /**
       * Direction
       * @default inbound
       */
      direction: string | null;
      /**
       * Source
       * @default onboarding
       */
      source: string | null;
    };
    /** RecordHintPlacement */
    RecordHintPlacement: {
      /** Section Heading */
      section_heading: string;
      /** Ui Targets */
      ui_targets?: string[] | null;
      mapping?: components['schemas']['StructuredMapping'] | null;
      /** Verified */
      verified?: boolean | null;
    };
    /**
     * RecordModalViewRequest
     * @description Request schema for recording that a user has seen a modal
     */
    RecordModalViewRequest: {
      /** @description Unique identifier for the modal */
      modal_id: components['schemas']['ModalId'];
      /**
       * Increment Count
       * @description If True, increments view count for repeat views. If False, only records first view. Defaults to True. Ignored when action is provided.
       * @default true
       */
      increment_count: boolean;
      /** @description Explicit action type. 'dismiss' increments consecutive_dismiss_count; 'engage' resets it and tracks engagement. When provided, takes precedence over increment_count. */
      action?: components['schemas']['ModalViewAction'] | null;
      /**
       * Hide Forever
       * @description If True, permanently dismisses this modal ("Don't show again"). Only applied when provided; pass null to leave unchanged.
       */
      hide_forever?: boolean | null;
    };
    /** RecordNotePushHintsRequest */
    RecordNotePushHintsRequest: {
      /** Template Id */
      template_id: string;
      /** App Name */
      app_name: string;
      /**
       * Source
       * @default screen_verified
       * @enum {string}
       */
      source: RecordNotePushHintsRequestSource;
      /** Placements */
      placements: components['schemas']['RecordHintPlacement'][];
      /** Session Id */
      session_id?: string | null;
      /**
       * Confirm Replacement
       * @default false
       */
      confirm_replacement: boolean;
    };
    /**
     * RecordPatientSummaryDismissalRequest
     * @description Body for POST /user/patient-summary-turn-off-prompt:record-dismissal.
     *
     *     Records ONE dismissal of the queued patient summary, keyed by the session
     *     it was dismissed in. Same-session retries dedupe server-side. `session_id`
     *     is bounded like the stored `last_dismissed_session_id` (session IDs are
     *     UUID-shaped, ~36 chars).
     */
    RecordPatientSummaryDismissalRequest: {
      /** Session Id */
      session_id: string;
    };
    /**
     * RecordPatientSummaryDismissalResponse
     * @description Response for POST /user/patient-summary-turn-off-prompt:record-dismissal.
     *
     *     Returns the resulting tracking state plus `should_prompt` — whether the FE
     *     should now surface the one-time "turn off automatic patient summaries"
     *     prompt (dismissals crossed the threshold and the prompt is unanswered).
     */
    RecordPatientSummaryDismissalResponse: {
      patient_summary_turn_off_prompt: components['schemas']['PatientSummaryTurnOffPrompt'];
      /** Should Prompt */
      should_prompt: boolean;
    };
    /** RecordPilotOutcomeRequest */
    RecordPilotOutcomeRequest: {
      /** Outcome Notes */
      outcome_notes: string;
    };
    /** RecordPilotOutcomeResponse */
    RecordPilotOutcomeResponse: {
      /** Order Id */
      order_id: string;
      pilot_status?: components['schemas']['PilotStatus'] | null;
      /** Pilot Ended At */
      pilot_ended_at?: string | null;
      /** Pilot Outcome Notes */
      pilot_outcome_notes?: string | null;
      /** Pilot Outcome Recorded By */
      pilot_outcome_recorded_by?: string | null;
      /** Pilot Outcome Recorded At */
      pilot_outcome_recorded_at?: string | null;
    };
    /** RecordSuggestionFeedbackRequest */
    RecordSuggestionFeedbackRequest: {
      feedback: components['schemas']['SuggestionFeedback'];
    };
    /** RecordSuggestionFeedbackResponse */
    RecordSuggestionFeedbackResponse: {
      /** Suggestion Id */
      suggestion_id: string;
      feedback: components['schemas']['SuggestionFeedback'];
      /**
       * Feedback At
       * Format: date-time
       */
      feedback_at: string;
    };
    /** RecordingAudioChunks */
    RecordingAudioChunks: {
      /** Recording Id */
      recording_id: string;
      /** Last Chunk Index */
      last_chunk_index?: number | null;
      /** Chunks */
      chunks?: components['schemas']['StoredAudioChunk'][];
      /** Missing Chunk Indices */
      missing_chunk_indices?: number[];
    };
    /** RecordingBackupChunkStatus */
    RecordingBackupChunkStatus: {
      /** Recording Id */
      recording_id: string;
      /** Chunk Count */
      chunk_count: number;
      /** Expected Chunk Count */
      expected_chunk_count?: number | null;
      /** Missing Chunk Indices */
      missing_chunk_indices: number[];
      /** Total Size Bytes */
      total_size_bytes: number;
      /** Estimated Duration Ms */
      estimated_duration_ms?: number | null;
      /**
       * First Chunk Stored At
       * Format: date-time
       */
      first_chunk_stored_at: string;
      /**
       * Last Chunk Stored At
       * Format: date-time
       */
      last_chunk_stored_at: string;
      /**
       * Expires At
       * Format: date-time
       */
      expires_at: string;
      /** Chunks */
      chunks: components['schemas']['BackupChunkObject'][];
    };
    /**
     * RecordingIngestRequest
     * @description Comms -> scribe push payload for a finished call recording.
     *
     *     ``heidi_user_id`` is the id comms knows the user by (our ``user_ref_id``);
     *     ownership of the session is re-verified server-side, never trusted from the
     *     payload. ``telehealth_call_id`` feeds a deterministic S3 filename and the
     *     idempotency receipt, so its charset is pinned here (422 on anything else)
     *     rather than sanitized later.
     */
    RecordingIngestRequest: {
      /**
       * Session Id
       * @description Heidi session to attach to
       */
      session_id: string;
      /**
       * Heidi User Id
       * @description Owner claimed by comms (user_ref_id)
       */
      heidi_user_id: string;
      /**
       * Telehealth Call Id
       * @description Comms call id; ingest is idempotent per id
       */
      telehealth_call_id: string;
      /**
       * Recording Url
       * @description Presigned, time-limited download URL for the WAV
       */
      recording_url: string;
      /**
       * Content Type
       * @description MIME type of the recording (default audio/wav)
       */
      content_type?: string | null;
      /**
       * Duration Seconds
       * @description Recording duration when comms knows it
       */
      duration_seconds?: number | null;
      /**
       * Source Region
       * @description Region of the comms cell that recorded the call (e.g. 'au'). In prod it must match this cell's SERVER_REGION or the ingest is refused with 403, so a mispaired MLSCRIBE_BASE_URL cannot move audio cross-region.
       */
      source_region?: string | null;
    };
    /** RecordingIngestResponse */
    RecordingIngestResponse: {
      /**
       * Status
       * @enum {string}
       */
      status: RecordingIngestResponseStatus;
      /** Session Id */
      session_id: string;
      /** Telehealth Call Id */
      telehealth_call_id: string;
    };
    /**
     * RecordingMode
     * @enum {string}
     */
    RecordingMode: RecordingMode;
    /**
     * RecordingStatus
     * @description Represents the current status of the recording session.
     * @enum {string}
     */
    RecordingStatus: RecordingStatus;
    /** Recordings */
    Recordings: {
      /** Uploaded Audios */
      uploaded_audios: components['schemas']['AccessRestrictedUserUploadedAudio'][];
      /** Backup Audios */
      backup_audios: components['schemas']['AccessRestrictedBackupAudio'][];
    };
    /**
     * RecurrencePattern
     * @description Recurrence pattern for competitions.
     * @enum {string}
     */
    RecurrencePattern: RecurrencePattern;
    /**
     * Reference
     * @description A reference from one resource to another.
     *
     *     The ``reference`` field stores a ``ResourceReferenceValue`` internally
     *     but accepts plain strings (``"Patient/123"``) on input and serializes
     *     back to a FHIR-compliant ``"Type/id"`` string.
     *
     *     https://hl7.org/fhir/R4/references-definitions.html#Reference
     */
    Reference: {
      /**
       * Literal reference, Relative, internal or absolute URL
       * @description A reference to a location at which the other resource is found. The reference may be a relative reference, in which case it is relative to the service base URL, or an absolute URL that resolves to the location where the resource is found. The reference may be version specific or not. If the reference is not to a FHIR RESTful server, then it should be assumed to be version specific. Internal fragment references (start with '#') refer to contained resources.
       */
      reference?: components['schemas']['ResourceReferenceValue'] | null;
      /**
       * Type the reference refers to (e.g. "Patient")
       * @description The expected type of the target of the reference. If both Reference.type and Reference.reference are populated and Reference.reference is a FHIR URL, both SHALL be consistent. The type is the Canonical URL of Resource Definition that is the type this reference refers to.
       */
      type?: string | null;
      /**
       * Logical reference, when literal reference is not known
       * @description An identifier for the target resource. This is used when there is no way to reference the other resource directly, either because the entity it represents is not available through a FHIR server, or because there is no way for the author of the resource to convert a known identifier to an actual location.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * Text alternative for the resource
       * @description Plain text narrative that identifies the resource in addition to the resource reference.
       */
      display?: string | null;
    };
    /**
     * ReferralCampaign
     * @description Campaign types for referral tracking.
     * @enum {string}
     */
    ReferralCampaign: ReferralCampaign;
    /**
     * ReferralInfo
     * @description Info about a referred user.
     */
    ReferralInfo: {
      /** First Name */
      first_name: string;
      /** Last Initial */
      last_initial: string;
      /** Email Preview */
      email_preview: string;
      /** Referred At */
      referred_at: string;
    };
    /**
     * ReferralLinkResponse
     * @description Response when generating a referral link.
     */
    ReferralLinkResponse: {
      /** Referral Code */
      referral_code: string;
      /** Referral Url */
      referral_url: string;
      /** User Ref Id */
      user_ref_id: string;
    };
    /**
     * ReferralProfile
     * @description https://developers.rewardful.com/rest-api/affiliates/object
     */
    ReferralProfile: {
      /** Affiliate Id */
      affiliate_id: string;
      /** Referral Link */
      referral_link: string;
      /** Paypal Email */
      paypal_email: string;
      /** Campaign Id */
      campaign_id?: string | null;
    };
    /**
     * RefreshAppointmentTypesResponse
     * @description Response model for refreshing appointment types.
     */
    RefreshAppointmentTypesResponse: {
      /** Success */
      success: boolean;
      /** Appointment Types */
      appointment_types: components['schemas']['EHRAppointmentType'][];
      /** Refreshed At */
      refreshed_at: string;
    };
    /**
     * RefreshCliniciansResponse
     * @description Response model for refreshing clinicians.
     */
    RefreshCliniciansResponse: {
      /** Success */
      success: boolean;
      /** Clinicians */
      clinicians: components['schemas']['EHRClinician'][];
      /** Refreshed At */
      refreshed_at: string;
    };
    /**
     * RefreshClinicsResponse
     * @description Response model for refreshing clinics.
     */
    RefreshClinicsResponse: {
      /** Success */
      success: boolean;
      /** Clinics */
      clinics: components['schemas']['EHRClinic'][];
      /** Refreshed At */
      refreshed_at: string;
    };
    /**
     * RegenerateProblemsResponse
     * @description Response for POST /sessions/{session_id}/problems/regenerate.
     */
    RegenerateProblemsResponse: {
      /** Success */
      success: boolean;
      /**
       * Problem Count
       * @description Number of problems extracted from edited note
       */
      problem_count: number;
      /**
       * Message
       * @description Status message
       * @default
       */
      message: string;
    };
    /**
     * Region
     * @enum {string}
     */
    Region: Region;
    /**
     * RegionMigrationPreviewResponse
     * @description Per-domain counts for a region migration, surfaced before commit
     *     (DEV-12215 dry-run/preview). ``counts`` is an open string→int map so new
     *     entity types can be added without a schema break for the Airflow caller.
     */
    RegionMigrationPreviewResponse: {
      /** User Ref Id */
      user_ref_id: string;
      /** Counts */
      counts?: {
        [key: string]: number;
      };
    };
    /**
     * RegionPreflightResponse
     * @description Report-mode result of every region-migration precondition (HTTP 200).
     */
    RegionPreflightResponse: {
      /** Ok */
      ok: boolean;
      /** Checks */
      checks: components['schemas']['PreflightCheck'][];
    };
    /**
     * RegionWorkspaceRealignRequest
     * @description Start the target-region workspace re-tag after all imports land.
     *
     *     ``run_key`` scopes workflow-id idempotency to one migration run (the DAG
     *     passes its Airflow run id): retries within a run dedupe, while a later
     *     re-migration of the same user gets a fresh workflow.
     */
    RegionWorkspaceRealignRequest: {
      /** User Ref Id */
      user_ref_id: string;
      /** Run Key */
      run_key: string;
    };
    /** RegisterDeviceRequest */
    RegisterDeviceRequest: {
      /** Device Token */
      device_token: string;
    };
    /**
     * RejectDraftRequest
     * @description Body for `POST /drafts/{draft_id}:reject`.
     *
     *     Declines a draft whose source question is fundamentally broken so it
     *     leaves the active review queue without being published. Terminal -
     *     there is no in-app un-reject. `reason` is required (min length 1);
     *     `rejected_by` is validated as an email at deserialization via
     *     Pydantic's `EmailStr`.
     */
    RejectDraftRequest: {
      /** Reason */
      reason: string;
      /**
       * Rejected By
       * Format: email
       */
      rejected_by: string;
    };
    /** RejectDraftResponse */
    RejectDraftResponse: {
      /** Draft Id */
      draft_id: string;
      /** Status */
      status: string;
      /**
       * Message
       * @default Draft rejected
       */
      message: string;
    };
    /**
     * RejectMKCustomTemplateRequestBody
     * @description Request body for rejecting an MK custom template request
     */
    RejectMKCustomTemplateRequestBody: Record<string, never>;
    /**
     * Reminder
     * @description A short instruction re-injected into context every N inferences.
     */
    Reminder: {
      /**
       * Kind
       * @default every_n_inferences
       * @constant
       */
      kind: 'every_n_inferences';
      /** Text */
      text: string;
      /** Every N Inferences */
      every_n_inferences: number;
    };
    /** ReminderConfigView */
    ReminderConfigView: {
      /** Id */
      id: string;
      /** User Id */
      user_id: string;
      /** Name */
      name: string;
      /** Appointment Type */
      appointment_type?: string | null;
      /** Days Offset */
      days_offset: number;
      /** Time Of Day */
      time_of_day: string;
      /** Send Sms */
      send_sms: boolean;
      /** Send Email */
      send_email: boolean;
      /** Sms Template */
      sms_template?: string | null;
      /** Email Subject Template */
      email_subject_template?: string | null;
      /** Email Body Template */
      email_body_template?: string | null;
      /**
       * Enable Magic Link
       * @default false
       */
      enable_magic_link: boolean;
      /** Magic Link Agent */
      magic_link_agent?: string | null;
      /**
       * Magic Link Expires Days
       * @default 7
       */
      magic_link_expires_days: number;
      /** Enabled */
      enabled: boolean;
      /** Days Before */
      days_before?: number | null;
      /** Channel */
      channel?: string | null;
      /** Agent Name */
      agent_name?: string | null;
      /** Message Template */
      message_template?: string | null;
    };
    /** ReminderRecordView */
    ReminderRecordView: {
      /** Config Id */
      config_id: string;
      /** Config Name */
      config_name: string;
      /** Status */
      status: string;
      /** Channel */
      channel?: string | null;
      /** Sent At */
      sent_at?: string | null;
      /** Error */
      error?: string | null;
    };
    /** RemoteApp */
    RemoteApp: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RemoteAppType;
    };
    /**
     * RemoteToolResultAttachment
     * @description One base64 file submitted by a remote tool executor.
     */
    RemoteToolResultAttachment: {
      /** Filename */
      filename: string;
      /** Media Type */
      media_type: string;
      /** Base64 Data */
      base64_data: string;
    };
    /**
     * RemoveHealthPathwaysResponse
     * @description Response after removing the user's HealthPathways zone config.
     */
    RemoveHealthPathwaysResponse: {
      /** Success */
      success: boolean;
    };
    /**
     * RenameChatRequest
     * @description Request schema for renaming a chat.
     */
    RenameChatRequest: {
      /**
       * Title
       * @description New chat title (whitespace-trimmed, 1–255 chars)
       */
      title: string;
    };
    /** RenderAgentConfigPythonRequest */
    RenderAgentConfigPythonRequest: {
      agent: components['schemas']['pkg__agent_harness__core__config__AgentConfig'];
    };
    /** RenderAgentConfigPythonResponse */
    RenderAgentConfigPythonResponse: {
      /** Snippet */
      snippet: string;
    };
    /** ReorderSlidesRequest */
    ReorderSlidesRequest: {
      /** Slide Ids */
      slide_ids: string[];
    };
    /** RepeatAiOutputResponse */
    RepeatAiOutputResponse: {
      /**
       * Decision
       * @enum {string}
       */
      decision: RepeatAiOutputResponseDecision;
      /** Justification */
      justification: string;
      /** Additionaltests */
      additionalTests: string[];
      /** References */
      references: components['schemas']['RepeatAiReferenceResponse'][];
    };
    /** RepeatAiReferenceResponse */
    RepeatAiReferenceResponse: {
      /** Id */
      id: number;
      /** Title */
      title: string;
      /** Source */
      source: string;
      /** Year */
      year: number;
      /** Url */
      url?: string | null;
    };
    /** RepeatChatMessageResponse */
    RepeatChatMessageResponse: {
      /**
       * Role
       * @enum {string}
       */
      role: RepeatChatMessageResponseRole;
      /** Content */
      content: string;
      /** Timestamp */
      timestamp: string;
    };
    /** RepeatPatientPreviewResponse */
    RepeatPatientPreviewResponse: {
      /** Name */
      name: string;
      /** Age */
      age?: number | null;
      /** Sex */
      sex?: string | null;
      /** Dob */
      dob: string;
      /** Nhsnumber */
      nhsNumber?: string | null;
    };
    /** RepeatRequestPreviewResponse */
    RepeatRequestPreviewResponse: {
      /** Id */
      id: string;
      patient: components['schemas']['RepeatPatientPreviewResponse'];
      /** Medication */
      medication: string;
      /** Dose */
      dose: string;
      /** Indication */
      indication: string;
      /** Requestedat */
      requestedAt: string;
      /**
       * Status
       * @default pending_review
       * @constant
       */
      status: 'pending_review';
      /** Aiwarning */
      aiWarning?: string | null;
      aiOutput: components['schemas']['RepeatAiOutputResponse'];
      /** Actionedat */
      actionedAt?: string | null;
      /** Actionedby */
      actionedBy?: string | null;
      /** Chathistory */
      chatHistory: components['schemas']['RepeatChatMessageResponse'][];
    };
    /** RepeatReviewAiOutputView */
    RepeatReviewAiOutputView: {
      /**
       * Decision
       * @enum {string}
       */
      decision: RepeatReviewAiOutputViewDecision;
      /** Justification */
      justification: string;
      /** Additionaltests */
      additionalTests?: string[];
      /** References */
      references?: components['schemas']['RepeatReviewReferenceView'][];
    };
    /** RepeatReviewChatMessageView */
    RepeatReviewChatMessageView: {
      /**
       * Role
       * @enum {string}
       */
      role: RepeatReviewChatMessageViewRole;
      /** Content */
      content: string;
      /** Timestamp */
      timestamp: string;
    };
    /** RepeatReviewListResponse */
    RepeatReviewListResponse: {
      /** Requests */
      requests: components['schemas']['RepeatReviewView'][];
    };
    /** RepeatReviewPatientView */
    RepeatReviewPatientView: {
      /** Name */
      name: string;
      /** Age */
      age?: number | null;
      /** Sex */
      sex?: string | null;
      /** Dob */
      dob: string;
      /** Nhsnumber */
      nhsNumber?: string | null;
    };
    /** RepeatReviewReferenceView */
    RepeatReviewReferenceView: {
      /** Id */
      id: number;
      /** Title */
      title: string;
      /** Source */
      source: string;
      /** Year */
      year: number;
      /** Url */
      url?: string | null;
    };
    /** RepeatReviewView */
    RepeatReviewView: {
      /** Id */
      id: string;
      /** Taskid */
      taskId?: string | null;
      patient: components['schemas']['RepeatReviewPatientView'];
      /** Medication */
      medication: string;
      /** Dose */
      dose: string;
      /** Indication */
      indication: string;
      /** Requestedat */
      requestedAt: string;
      /**
       * Status
       * @enum {string}
       */
      status: RepeatReviewViewStatus;
      /** Aiwarning */
      aiWarning?: string | null;
      aiOutput: components['schemas']['RepeatReviewAiOutputView'];
      /** Actionedat */
      actionedAt?: string | null;
      /** Actionedby */
      actionedBy?: string | null;
      /** Chathistory */
      chatHistory?: components['schemas']['RepeatReviewChatMessageView'][];
    };
    /** RepeatScriptsClinicianRequest */
    RepeatScriptsClinicianRequest: {
      /** Doctor Name */
      doctor_name?: string | null;
      /** Doctor Id */
      doctor_id?: string | null;
    };
    /** RepeatScriptsCollectedHistoryRequest */
    RepeatScriptsCollectedHistoryRequest: {
      /**
       * Summary
       * @default
       */
      summary: string;
      /** Answers */
      answers?: {
        [key: string]: string;
      };
      /** Flags */
      flags?: string[];
      /** Unanswered */
      unanswered?: string[];
    };
    /** RepeatScriptsMedicationRequest */
    RepeatScriptsMedicationRequest: {
      /** Medication Name */
      medication_name: string;
      /** Dose */
      dose?: string | null;
      /** Frequency */
      frequency?: string | null;
      /** Quantity */
      quantity?: string | null;
      /** Prescribed By Practice */
      prescribed_by_practice?: boolean | null;
    };
    /** RepeatScriptsPatientRequest */
    RepeatScriptsPatientRequest: {
      /** Patient Name */
      patient_name: string;
      /** Patient Id */
      patient_id?: string | null;
      /** Dob Raw */
      dob_raw: string;
    };
    /** RepeatScriptsPayloadRequest */
    RepeatScriptsPayloadRequest: {
      patient: components['schemas']['RepeatScriptsPatientRequest'];
      requesting_clinician?: components['schemas']['RepeatScriptsClinicianRequest'];
      /** Medications */
      medications: components['schemas']['RepeatScriptsMedicationRequest'][];
      pharmacy?: components['schemas']['RepeatScriptsPharmacyRequest'];
      /** Additional Notes */
      additional_notes?: string | null;
      collected_history?: components['schemas']['RepeatScriptsCollectedHistoryRequest'];
      /** Required Topics Status */
      required_topics_status?: {
        [key: string]: string;
      };
    };
    /** RepeatScriptsPharmacyRequest */
    RepeatScriptsPharmacyRequest: {
      /** Pharmacy Name */
      pharmacy_name?: string | null;
    };
    /** RepeatScriptsProcessingRequirementsRequest */
    RepeatScriptsProcessingRequirementsRequest: {
      /**
       * Needs Evidence Review
       * @default true
       */
      needs_evidence_review: boolean;
      /**
       * Needs Clinician Review
       * @default true
       */
      needs_clinician_review: boolean;
    };
    /**
     * RepeatScriptsRequest
     * @description Inbound repeat-scripts handoff (HTTP or Temporal).
     *
     *     ``handoff_user_id`` is optional: HTTP uses JWT-derived user id; Temporal
     *     comms passes the scribe/comms user id in the payload when available.
     */
    RepeatScriptsRequest: {
      /** Request Id */
      request_id: string;
      /** Source System */
      source_system: string;
      /**
       * Channel
       * @default unknown
       * @enum {string}
       */
      channel: RepeatScriptsRequestChannel;
      /** Comms Session Id */
      comms_session_id?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Workflow Type
       * @default repeat_scripts
       * @constant
       */
      workflow_type: 'repeat_scripts';
      payload: components['schemas']['RepeatScriptsPayloadRequest'];
      processing_requirements?: components['schemas']['RepeatScriptsProcessingRequirementsRequest'];
      /**
       * Handoff User Id
       * @description Scribe/comms user id for Temporal handoffs without JWT.
       */
      handoff_user_id?: string | null;
    };
    /** RepeatScriptsResponse */
    RepeatScriptsResponse: {
      /** Request Id */
      request_id: string;
      /**
       * Status
       * @default queued_for_review
       * @constant
       */
      status: 'queued_for_review';
      /** Next Step */
      next_step: string;
      /**
       * Review Required
       * @default true
       */
      review_required: boolean;
      /**
       * Workflow Backend
       * @default ml-scribe
       * @constant
       */
      workflow_backend: 'ml-scribe';
      /** Workflow Id */
      workflow_id?: string | null;
      /** Message */
      message: string;
      medication_review_task: components['schemas']['MedicationReviewTaskResponse'];
      repeat_request_preview: components['schemas']['RepeatRequestPreviewResponse'];
    };
    /** ReplaceTemplateSectionMappingRequest */
    ReplaceTemplateSectionMappingRequest: {
      /** Template Id */
      template_id: string;
      /** Section Mappings */
      section_mappings: components['schemas']['SectionLink'][];
    };
    /**
     * RequestEmailChangeRequest
     * @description Request schema for initiating email change.
     *
     *     The nonce and timestamp from the current email verification step are reused
     *     to ensure the entire flow must complete within 15 minutes of starting.
     */
    RequestEmailChangeRequest: {
      /**
       * New Email
       * Format: email
       */
      new_email: string;
      /** Nonce */
      nonce: string;
      /** Timestamp */
      timestamp: string;
      /** Current Email Code */
      current_email_code: string;
    };
    /**
     * RequestEmailChangeResponse
     * @description Response schema for email change request.
     *
     *     Returns the same nonce/timestamp for use in the confirm step.
     *     The expiration is based on the original timestamp from step 1.
     */
    RequestEmailChangeResponse: {
      /** Status */
      status: string;
      /** Nonce */
      nonce: string;
      /** Timestamp */
      timestamp: string;
      /** Expires At */
      expires_at: string;
    };
    /** RequestEvidenceAccessRequest */
    RequestEvidenceAccessRequest: {
      /** Message */
      message?: string | null;
    };
    /**
     * RequestEvidenceAccessResponse
     * @description Result of notifying team admins of an Evidence access request.
     */
    RequestEvidenceAccessResponse: {
      /**
       * Adminnotificationssent
       * @description Number of team admins emailed successfully.
       */
      adminNotificationsSent: number;
    };
    /** RequestOTPRequest */
    RequestOTPRequest: {
      /**
       * Email
       * Format: email
       */
      email: string;
    };
    /** RequestOTPResponse */
    RequestOTPResponse: {
      /** Nonce */
      nonce: string;
      /** Timestamp */
      timestamp: string;
      /** Expires At */
      expires_at: string;
    };
    /**
     * RequestPriority
     * @description Identifies the level of importance to be assigned to actioning the request.
     *
     *     https://hl7.org/fhir/R4/valueset-request-priority.html
     * @enum {string}
     */
    RequestPriority: RequestPriority;
    /** RequestSubscriptionUpgradeRequest */
    RequestSubscriptionUpgradeRequest: {
      target_plan: components['schemas']['SubscriptionTier'];
      /** Message */
      message?: string | null;
    };
    /**
     * RequestSubscriptionUpgradeResponse
     * @description Result of notifying team admins of a subscription upgrade request.
     */
    RequestSubscriptionUpgradeResponse: {
      /**
       * Adminnotificationssent
       * @description Number of team admins emailed successfully.
       */
      adminNotificationsSent: number;
    };
    /** ResendInvitationResponse */
    ResendInvitationResponse: {
      /** Invitation Link */
      invitation_link: string;
    };
    /** ResendInvitationsResultItem */
    ResendInvitationsResultItem: {
      /** Invitation Id */
      invitation_id: string;
      /** Email */
      email: string;
      /**
       * Status
       * @enum {string}
       */
      status: ResendInvitationsResultItemStatus;
      /** Error */
      error?: string | null;
    };
    /**
     * ResetEligibilityAction
     * @description Clear trial history so user can start a fresh trial.
     */
    ResetEligibilityAction: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      action: ResetEligibilityActionAction;
    };
    /**
     * ResetUserQuotaRequest
     * @description Request schema for resetting a user's quota.
     */
    ResetUserQuotaRequest: {
      /**
       * User Mongo Id
       * @description The MongoDB ObjectId of the user (as string)
       * @example 681751f4aea0234d7d2f93d4
       */
      user_mongo_id: string;
    };
    /**
     * ResetUserQuotaResponse
     * @description Response schema for reset user quota operation.
     */
    ResetUserQuotaResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
      /** User Mongo Id */
      user_mongo_id: string;
    };
    /**
     * ResolveApprovalRequest
     * @description Operator input for approving or denying a pending tool call.
     *
     *     ``resolved_by`` is NOT exposed — it is set from the authenticated
     *     ``X-User-Id`` header in the router.
     */
    ResolveApprovalRequest: {
      /**
       * Verdict
       * @enum {string}
       */
      verdict: ResolveApprovalRequestVerdict;
      /** Modified Input */
      modified_input?: {
        [key: string]: unknown;
      } | null;
      /**
       * Reason
       * @default
       */
      reason: string;
      /**
       * Override Scope
       * @default once
       * @enum {string}
       */
      override_scope: ResolveApprovalRequestOverride_scope;
    };
    /** ResolveApprovalResponse */
    ResolveApprovalResponse: {
      /** Approval Id */
      approval_id: string;
      /**
       * Verdict
       * @enum {string}
       */
      verdict: ResolveApprovalResponseVerdict;
      /**
       * Accepted
       * @default true
       */
      accepted: boolean;
    };
    /** ResolveDesktopTargetRunRequest */
    ResolveDesktopTargetRunRequest: {
      /**
       * Outcome
       * @enum {string}
       */
      outcome: ResolveDesktopTargetRunRequestOutcome;
      failure_code?: components['schemas']['DesktopTargetFailureCode'] | null;
    };
    /** ResolveDesktopTargetRunResponse */
    ResolveDesktopTargetRunResponse: {
      /** Target Id */
      target_id: string;
      /** Agent Run Id */
      agent_run_id: string;
      status: components['schemas']['DesktopTargetAssignmentStatus'];
    };
    /**
     * ResolveErrorReason
     * @description Why a key failed to resolve in a bulk read.
     * @enum {string}
     */
    ResolveErrorReason: ResolveErrorReason;
    /**
     * ResolveFrontendEventRequest
     * @description Approval verdict for a frontend event.
     *
     *     Posted by the FE when it has rendered the approval UI and the user
     *     has clicked approve / deny. The ``resolved_by`` field is NOT exposed
     *     — it is set from the authenticated run subject in the router.
     */
    ResolveFrontendEventRequest: {
      /**
       * Verdict
       * @enum {string}
       */
      verdict: ResolveFrontendEventRequestVerdict;
      /** Reason */
      reason?: string | null;
    };
    /**
     * ResolveToolApprovalRequest
     * @description Approve or deny a generic harness tool approval.
     */
    ResolveToolApprovalRequest: {
      /**
       * Verdict
       * @enum {string}
       */
      verdict: ResolveToolApprovalRequestVerdict;
      /** Response */
      response?: {
        [key: string]: unknown;
      } | null;
      /** Modified Input */
      modified_input?: {
        [key: string]: unknown;
      } | null;
      /**
       * Reason
       * @default
       */
      reason: string;
      /**
       * Override Scope
       * @default once
       * @enum {string}
       */
      override_scope: ResolveToolApprovalRequestOverride_scope;
    };
    /** ResolveToolApprovalResponse */
    ResolveToolApprovalResponse: {
      /** Approval Id */
      approval_id: string;
      /**
       * Verdict
       * @enum {string}
       */
      verdict: ResolveToolApprovalResponseVerdict;
      /**
       * Accepted
       * @default true
       */
      accepted: boolean;
    };
    /**
     * ResolveWaitRequest
     * @description Accept or deny a generic durable wait.
     */
    ResolveWaitRequest: {
      verdict: components['schemas']['WaitVerdict'];
      /** Response */
      response?: {
        [key: string]: unknown;
      } | null;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /** ResolveWaitResponse */
    ResolveWaitResponse: {
      /** Wait Id */
      wait_id: string;
      verdict: components['schemas']['WaitVerdict'];
      /**
       * Accepted
       * @default true
       */
      accepted: boolean;
    };
    /**
     * ResolvedSettingResponse
     * @description One resolved setting's effective value, its type schema, and provenance.
     */
    ResolvedSettingResponse: {
      value: components['schemas']['JsonValue'];
      /** Value Type */
      value_type: {
        [key: string]: components['schemas']['JsonValue'];
      };
      /** Source */
      source: string;
      /** Locked */
      locked: boolean;
      own_value: components['schemas']['JsonValue'];
    };
    /**
     * ResolvedSubject
     * @description Outcome of a self-resolve call.
     *
     *     ``subject_user_ids`` is a list because one IA email can map to zero,
     *     one, or several Scribe accounts. Callers (e.g. the FE picker for
     *     "run as") disambiguate based on the length.
     */
    ResolvedSubject: {
      /** Subject User Ids */
      subject_user_ids: string[];
      /** Resolution Source */
      resolution_source: string;
      /**
       * Resolved At
       * Format: date-time
       */
      resolved_at: string;
    };
    /**
     * ResourceReferenceValue
     * @description A parsed FHIR resource reference containing the extracted ID.
     */
    ResourceReferenceValue: {
      /** Id */
      id: string;
      /** Resource */
      resource: unknown;
    };
    /**
     * RestfulCapabilityMode
     * @description The mode of a RESTful capability statement.
     *
     *     https://hl7.org/fhir/R4/valueset-restful-capability-mode.html
     * @enum {string}
     */
    RestfulCapabilityMode: RestfulCapabilityMode;
    /**
     * RetentionSettings
     * @description Shared shape for time-based deletion policies.
     *
     *     Used by session retention (``session_retention_settings``), patient
     *     retention (``patient_retention_settings``), and comms-session retention
     *     (``comms_session_retention_settings``). These surfaces
     *     are independent at the BE level; this type just captures their
     *     identical structure: ``enabled`` + ``retention_days`` with the
     *     invariant that ``enabled`` implies ``retention_days > 0``.
     *
     *     The invariant is self-healing rather than fatal. If construction
     *     encounters ``(enabled=True, retention_days=None|<=0)`` from any
     *     source (legacy Mongo data predating the validator, a backfill
     *     script, a write path that bypassed validation), coerce to
     *     ``(enabled=False, retention_days=None)`` and emit a structured
     *     warning. Coercing rather than raising is deliberate: the BE
     *     deserializes ``RetentionSettings`` on every read of a Team, Org,
     *     or User document, and a raise here would translate to a 500 on
     *     any code path that loads the affected doc. The FE / request
     *     boundary still rejects invalid combos at the schema level via
     *     pydantic field types and the consuming form's own validation.
     */
    RetentionSettings: {
      /**
       * Enabled
       * @default false
       */
      enabled: boolean;
      /** Retention Days */
      retention_days?: number | null;
      /** Enabled At */
      enabled_at?: string | null;
    };
    /** RetireProviderIdentitiesRequest */
    RetireProviderIdentitiesRequest: {
      /** Delete Reason */
      delete_reason?: string | null;
    };
    /** RetireProviderIdentitiesResponse */
    RetireProviderIdentitiesResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
      /** Retired Data */
      retired_data?: components['schemas']['ProviderRetirementResult'][];
    };
    /** RetranscribeAudioSourceRequest */
    RetranscribeAudioSourceRequest: {
      /** Languages */
      languages?: string[] | null;
    };
    /** RetryAcceptedResponse */
    RetryAcceptedResponse: {
      /** Retry Job Ref Id */
      retry_job_ref_id: string;
    };
    /** RetryBatchFailedResponse */
    RetryBatchFailedResponse: {
      /** Batch Id */
      batch_id: string;
      /** Retried Count */
      retried_count: number;
      /**
       * Message
       * @default Failed drafts have been queued for retry
       */
      message: string;
    };
    /** RetryDraftResponse */
    RetryDraftResponse: {
      /** Draft Id */
      draft_id: string;
      /** Status */
      status: string;
      /**
       * Message
       * @default Draft has been reset to processing
       */
      message: string;
    };
    /** RetryReminderResponse */
    RetryReminderResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
    };
    /**
     * RevenueCatStore
     * @enum {string}
     */
    RevenueCatStore: RevenueCatStore;
    /**
     * RevertConsultNoteRequest
     * @description Each field is individually optional to support two revert strategies:
     *     target_note_id reverts to the start of a prior consult note,
     *     target_edit_id reverts to a specific edit in the history.
     *     Providing both reverts to a specific edit in a prior consult note.
     *     At least one must be provided.
     */
    RevertConsultNoteRequest: {
      /** Target Note Id */
      target_note_id?: string | null;
      /** Target Edit Id */
      target_edit_id?: string | null;
    };
    /**
     * RevokeAuth0SessionsRequest
     * @description Request DTO for revoking all Auth0 sessions + refresh tokens for a user.
     */
    RevokeAuth0SessionsRequest: {
      /**
       * User Ref Id
       * @description Internal stable user reference ID whose Auth0 sessions and refresh tokens should be revoked.
       */
      user_ref_id: string;
    };
    /**
     * RevokeAuth0SessionsResponse
     * @description Empty success body for the revoke Auth0 sessions endpoint.
     *
     *     A 200 OK with this empty body means both Auth0 surfaces (sessions and
     *     refresh tokens) were revoked or did not exist. Any failure surfaces as
     *     a non-2xx HTTP response.
     */
    RevokeAuth0SessionsResponse: Record<string, never>;
    /** RevokeIntegrationAgentResponse */
    RevokeIntegrationAgentResponse: {
      /** Revoked */
      revoked: boolean;
    };
    /**
     * RevokeSessionShareResponse
     * @description Response for revoke session share.
     */
    RevokeSessionShareResponse: {
      /**
       * Success
       * @default true
       */
      success: boolean;
      /**
       * Message
       * @description Status message
       * @default Share revoked successfully
       */
      message: string;
    };
    /**
     * Role
     * @enum {string}
     */
    Role: Role;
    /**
     * RoleCategory
     * @enum {string}
     */
    RoleCategory: RoleCategory;
    /** RoleConfigValue */
    RoleConfigValue: {
      /**
       * Billable
       * @default false
       */
      billable: boolean;
    };
    /** RoleDescription */
    RoleDescription: {
      /** Able */
      able?: string[] | null;
      /** Disable */
      disable?: string[] | null;
      /** Summary */
      summary?: string | null;
    };
    /** RoleDescriptionValue */
    RoleDescriptionValue: {
      /** Able */
      able?: string[] | null;
      /** Disable */
      disable?: string[] | null;
      /** Summary */
      summary?: string | null;
    };
    /** RoleModel */
    RoleModel: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Description */
      description: string | null;
      desc: components['schemas']['RoleDescriptionValue'] | null;
      /** Team */
      team: string | null;
      category: components['schemas']['RoleCategory'];
      /** Permissions */
      permissions: components['schemas']['PermissionValue'][];
      config: components['schemas']['RoleConfigValue'];
      /**
       * Is Deleted
       * @default false
       */
      is_deleted: boolean;
      /**
       * Is Default
       * @default false
       */
      is_default: boolean;
      /**
       * Is Belong To System
       * @default false
       */
      is_belong_to_system: boolean;
    };
    /**
     * RollbackProtocolRequest
     * @description Re-point the live version at an earlier published version (instant supersede; the working
     *     draft is untouched).
     */
    RollbackProtocolRequest: {
      /** Version */
      version: number;
    };
    /** RollbackRequest */
    RollbackRequest: {
      /** Target Version */
      target_version: number;
    };
    /** RpaAnalysisStageUsageResponse */
    RpaAnalysisStageUsageResponse: {
      /** Model */
      model?: string | null;
      /** Input Tokens */
      input_tokens: number;
      /** Output Tokens */
      output_tokens: number;
      /** Cache Read Input Tokens */
      cache_read_input_tokens: number;
      /** Cache Creation Input Tokens */
      cache_creation_input_tokens: number;
    };
    /** RpaAnalysisUsageResponse */
    RpaAnalysisUsageResponse: {
      /** Input Tokens */
      input_tokens: number;
      /** Output Tokens */
      output_tokens: number;
      /** Cache Read Input Tokens */
      cache_read_input_tokens: number;
      /** Cache Creation Input Tokens */
      cache_creation_input_tokens: number;
      /** Estimated Cost Usd */
      estimated_cost_usd: number | null;
      analysis?: components['schemas']['RpaAnalysisStageUsageResponse'] | null;
      synthesis?: components['schemas']['RpaAnalysisStageUsageResponse'] | null;
    };
    /**
     * RpaArtifactKind
     * @enum {string}
     */
    RpaArtifactKind: RpaArtifactKind;
    /**
     * RpaArtifactStage
     * @enum {string}
     */
    RpaArtifactStage: RpaArtifactStage;
    /** RpaRecordingArtifactDownloadUrlResponse */
    RpaRecordingArtifactDownloadUrlResponse: {
      /** Artifact Id */
      artifact_id: string;
      stage: components['schemas']['RpaArtifactStage'];
      kind: components['schemas']['RpaArtifactKind'];
      /** Size Bytes */
      size_bytes: number;
      /** Url */
      url: string;
      /** Expires In Seconds */
      expires_in_seconds: number;
      /**
       * Content Disposition
       * @enum {string}
       */
      content_disposition: RpaRecordingArtifactDownloadUrlResponseContent_disposition;
    };
    /** RpaRecordingArtifactInventoryItem */
    RpaRecordingArtifactInventoryItem: {
      /** Artifact Id */
      artifact_id: string;
      stage: components['schemas']['RpaArtifactStage'];
      kind: components['schemas']['RpaArtifactKind'];
      /** Size Bytes */
      size_bytes: number;
      /** Last Modified */
      last_modified?: string | null;
      /** Previewable */
      previewable: boolean;
      /** Downloadable */
      downloadable: boolean;
    };
    /** RpaRecordingArtifactInventoryResponse */
    RpaRecordingArtifactInventoryResponse: {
      /** Recording Id */
      recording_id: string;
      /** Source */
      source: string;
      /** Items */
      items: components['schemas']['RpaRecordingArtifactInventoryItem'][];
      /** Next Cursor */
      next_cursor?: string | null;
    };
    /** RpaRecordingArtifactPreviewResponse */
    RpaRecordingArtifactPreviewResponse: {
      /** Artifact Id */
      artifact_id: string;
      stage: components['schemas']['RpaArtifactStage'];
      kind: components['schemas']['RpaArtifactKind'];
      /** Size Bytes */
      size_bytes: number;
      /** Content */
      content: string;
      /** Truncated */
      truncated: boolean;
    };
    /** RpaRecordingStatusResponse */
    RpaRecordingStatusResponse: {
      /** Recording Id */
      recording_id: string;
      /** Name */
      name: string;
      /**
       * Status
       * @enum {string}
       */
      status: RpaRecordingStatusResponseStatus;
      workflow_data?: components['schemas']['WorkflowDataResponse'] | null;
      /** Completed At */
      completed_at?: string | null;
      /** Error Code */
      error_code?: string | null;
      /** Error Message */
      error_message?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** RpaRecordingSummaryResponse */
    RpaRecordingSummaryResponse: {
      /** Recording Id */
      recording_id: string;
      /** Skill Id */
      skill_id: string;
      /**
       * Source
       * @default personal
       * @enum {string}
       */
      source: RpaRecordingSummaryResponseSource;
      /** Name */
      name: string;
      /** Workflow Name */
      workflow_name?: string | null;
      /**
       * Status
       * @enum {string}
       */
      status: RpaRecordingSummaryResponseStatus;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Completed At */
      completed_at?: string | null;
      /** Error Code */
      error_code?: string | null;
    };
    /** RpaRecordingUploadResponse */
    RpaRecordingUploadResponse: {
      /** Recording Id */
      recording_id: string;
      /** Name */
      name: string;
      /**
       * Status
       * @enum {string}
       */
      status: RpaRecordingUploadResponseStatus;
      /** Status Url */
      status_url?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** RpaSegmentedTask */
    RpaSegmentedTask: {
      /** Segments */
      segments: (
        | components['schemas']['RpaTextTaskSegment']
        | components['schemas']['RpaSkillRefTaskSegment']
      )[];
    };
    /** RpaSkillRefTaskSegment */
    RpaSkillRefTaskSegment: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: RpaSkillRefTaskSegmentKind;
      /** Skill Id */
      skill_id: string;
      /** Slug */
      slug?: string | null;
      /** Parameters */
      parameters?: {
        [key: string]: string;
      };
    };
    /** RpaTextTaskSegment */
    RpaTextTaskSegment: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: RpaTextTaskSegmentKind;
      /** Text */
      text: string;
    };
    /** RpaUserWorkflowsResponse */
    RpaUserWorkflowsResponse: {
      /** Personal Recordings */
      personal_recordings: components['schemas']['RpaRecordingSummaryResponse'][];
      /** Team Workflows */
      team_workflows?: {
        [key: string]: unknown;
      }[];
    };
    /** RunAgenticPersonalisationBatchWorkflowRequest */
    RunAgenticPersonalisationBatchWorkflowRequest: {
      /** @default agent_extracted_word_substitutions */
      memory_type: components['schemas']['MemoryType'];
      /**
       * Target User Ids
       * @description Optional explicit users. Omit to let the workflow list enrolled users. Explicit targets pass the same consent AND flag membership gate as the scheduled cohort; non-members are skipped and logged.
       */
      target_user_ids?: string[] | null;
      /**
       * Force Ignore Consent
       * @description Build the explicit targets WITHOUT the consent gate. Mining a user who has not consented to adaptive learning is a consent bypass — set only for deliberate operations (smoke tests, cohorts whose consent is handled elsewhere). The target ids are logged when set.
       * @default false
       */
      force_ignore_consent: boolean;
      /**
       * Max Concurrent Users
       * @default 10
       */
      max_concurrent_users: number;
      /**
       * Persist Build Trace
       * @default true
       */
      persist_build_trace: boolean;
      /**
       * Explorer Model
       * @description Model-spec name for the explorer (see domains/agentic_personalisation/model_specs.py). Omit for the per-user Flagsmith variant / default; overrides both when set.
       */
      explorer_model?: string | null;
      /**
       * Committer Model
       * @description Model-spec name for the committer. Same semantics as explorer_model.
       */
      committer_model?: string | null;
    };
    /** RunAgenticPersonalisationBatchWorkflowResponse */
    RunAgenticPersonalisationBatchWorkflowResponse: {
      /** Workflow Id */
      workflow_id: string;
      memory_type: components['schemas']['MemoryType'];
      /** Target User Ids */
      target_user_ids?: string[] | null;
      /** Max Concurrent Users */
      max_concurrent_users: number;
      /** Persist Build Trace */
      persist_build_trace: boolean;
      /** Explorer Model */
      explorer_model?: string | null;
      /** Committer Model */
      committer_model?: string | null;
    };
    /**
     * RunCreditGrantReconcilerRequest
     * @description HTTP body for the on-demand reconcile trigger.
     *
     *     Omit ``user_ref_id`` for a full sweep over every metered-enrolled customer;
     *     supply one to scope the run to a single customer (e.g. to grant a mid-cycle
     *     enrolment immediately, or re-grant after a config fix). The run is
     *     idempotent, so it is safe alongside the daily scheduled tick.
     *
     *     Note: idempotency keys on cycle identity (price set + cycle), not the grant
     *     amount — a cycle already granted short-circuits. To correct a *wrong*
     *     allowance mid-cycle, void the stale grant in Stripe first, then re-run;
     *     otherwise a second grant would stack on the first (grants are additive).
     */
    RunCreditGrantReconcilerRequest: {
      /** User Ref Id */
      user_ref_id?: string | null;
    };
    /**
     * RunCreditGrantReconcilerResponse
     * @description Outcome of an on-demand reconcile trigger.
     *
     *     The endpoint runs the reconciler synchronously in-process and returns its
     *     full summary inline. ``scope`` echoes what was run (``all`` or
     *     ``user:<user_ref_id>``); ``summary`` carries the human ``message``, the
     *     granted / already-granted / skipped / failed counts, and the per-customer
     *     results.
     */
    RunCreditGrantReconcilerResponse: {
      /** Scope */
      scope: string;
      summary: components['schemas']['CreditGrantRunSummary'];
    };
    /** RunDetailsResponse */
    RunDetailsResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Title */
      title?: string | null;
      /** Actor User Id */
      actor_user_id: string;
      /** Subject User Id */
      subject_user_id: string;
      /** Parent Agent Run Id */
      parent_agent_run_id?: string | null;
      /**
       * Status
       * @enum {string}
       */
      status: RunDetailsResponseStatus;
      /** Kind */
      kind?: string | null;
      agent_config_snapshot: components['schemas']['pkg__agent_harness__core__config__AgentConfig'];
      /** Source Config Id */
      source_config_id?: string | null;
      /** Source Config Version */
      source_config_version?: number | null;
      /** Source Schedule Id */
      source_schedule_id?: string | null;
      trigger_ref?: components['schemas']['WorkflowTriggerRef'] | null;
      /** Latest Turn Id */
      latest_turn_id?: string | null;
      approval_mode?: components['schemas']['ApprovalMode'] | null;
      /**
       * Input State
       * @enum {string}
       */
      input_state: RunDetailsResponseInput_state;
      /** Can Submit */
      can_submit: boolean;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Temporal Workflow Url */
      temporal_workflow_url?: string | null;
      usage?: components['schemas']['RunUsageSummary'] | null;
      /** Messages */
      messages: components['schemas']['ConversationMessageView'][];
      /** Stream Cursor */
      stream_cursor?: string | null;
      /** Approvals */
      approvals: components['schemas']['ApprovalResponse'][];
      /** Waits */
      waits?: components['schemas']['ToolWaitRecord'][];
      /** Prompt Context Failures */
      prompt_context_failures?: components['schemas']['PromptContextFailureRecord'][];
    };
    /** RunEgressRequest */
    RunEgressRequest: {
      /**
       * Lookback Days
       * @default 3
       */
      lookback_days: number;
      /**
       * Include Breakdown
       * @default false
       */
      include_breakdown: boolean;
    };
    /** RunEgressResponse */
    RunEgressResponse: {
      /** Summary */
      summary: string;
      /** Lookback Days */
      lookback_days: number;
      /** Meters Emitted */
      meters_emitted: number;
      /** Meters Skipped Inactive */
      meters_skipped_inactive: number;
      /** Days Skipped Too Far */
      days_skipped_too_far: number;
      /** Events Pushed */
      events_pushed: number;
      /** Already Emitted */
      already_emitted: number;
      /** Customers Processed */
      customers_processed: number;
      /** Skipped No Customer */
      skipped_no_customer: number;
      /** Skipped Not Enrolled */
      skipped_not_enrolled: number;
      /** Skipped Zero Value */
      skipped_zero_value: number;
      /** Rejected Timestamp Too Far */
      rejected_timestamp_too_far: number;
      /** Rejected Other */
      rejected_other: number;
      /** Breakdown */
      breakdown?: {
        [key: string]: unknown;
      }[];
      /**
       * Breakdown Truncated
       * @default false
       */
      breakdown_truncated: boolean;
    };
    /** RunPrechartResponse */
    RunPrechartResponse: {
      /** Queued Count */
      queued_count: number;
    };
    /**
     * RunUsageSummary
     * @description Aggregate token usage for a run. Included on both list and detail.
     */
    RunUsageSummary: {
      /**
       * Total Input Tokens
       * @default 0
       */
      total_input_tokens: number;
      /**
       * Total Output Tokens
       * @default 0
       */
      total_output_tokens: number;
      /**
       * Total Cache Creation Input Tokens
       * @default 0
       */
      total_cache_creation_input_tokens: number;
      /**
       * Total Cache Read Input Tokens
       * @default 0
       */
      total_cache_read_input_tokens: number;
      /**
       * Total Thinking Tokens
       * @default 0
       */
      total_thinking_tokens: number;
      /** Estimated Cost Usd */
      estimated_cost_usd?: number | null;
      /** Descendant Estimated Cost Usd */
      descendant_estimated_cost_usd?: number | null;
      /** Total Estimated Cost Usd */
      total_estimated_cost_usd?: number | null;
      /**
       * Descendant Count
       * @default 0
       */
      descendant_count: number;
      /** Turns */
      turns?: components['schemas']['TurnUsageSummary'][] | null;
    };
    /** RunWorkflowRequest */
    RunWorkflowRequest: {
      /** Parameter Values */
      parameter_values?: {
        [key: string]: string;
      };
      /** @description Screen dimensions + scaling from the desktop client. When provided, the executor uses accurate coordinates for the user's actual screen. Falls back to default 1920×1080 @2x when omitted (schedule/event triggers). */
      client_capabilities?: components['schemas']['ClientCapabilities'] | null;
      /**
       * Target Id
       * @description Opaque id of a same-user registered desktop target to route this run's computer-use work to. Validated as a canonical lowercase-hyphenated UUID v7. When supplied with the desktop-target flag on, target routing wins and client_capabilities are ignored. When omitted, a desktop client may still send client_capabilities to execute locally (legacy triggering-client mode).
       */
      target_id?: string | null;
    };
    /** RunWorkflowResponse */
    RunWorkflowResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /**
       * Project Id
       * @default
       */
      project_id: string;
    };
    /**
     * S3PresignedUrlMethod
     * @enum {string}
     */
    S3PresignedUrlMethod: S3PresignedUrlMethod;
    /** SNOMEDCodeConcept */
    SNOMEDCodeConcept: {
      /** Code */
      code: string;
      /** Code Name */
      code_name: string;
      /** Metadata */
      metadata: {
        [key: string]: unknown;
      };
      /** Score */
      score?: number | null;
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
    };
    /**
     * SSOConnection
     * @description SSO connection model for auth platform agnostic representation.
     */
    SSOConnection: {
      /** Id */
      id: string;
      provider: components['schemas']['SSOProvider'];
      /** Name */
      name?: string | null;
      /** Display Name */
      display_name?: string | null;
    };
    /**
     * SSOConnectionListResponse
     * @description Response DTO for listing SSO connections.
     */
    SSOConnectionListResponse: {
      /** Connections */
      connections: components['schemas']['SSOConnectionResponse'][];
    };
    /**
     * SSOConnectionResponse
     * @description Response DTO for a single SSO connection.
     */
    SSOConnectionResponse: {
      /** Connection Name */
      connection_name: string;
      /** Display Name */
      display_name: string;
      /** Domains */
      domains: string[];
      sso_state: components['schemas']['SSOState'];
      /** Region */
      region: string;
      /** Testing Emails */
      testing_emails?: string[];
      setup_ticket?: components['schemas']['SetupTicketDTO'] | null;
      secret_expiry?: components['schemas']['SecretExpiryDTO'] | null;
      /** Workspaces */
      workspaces?: components['schemas']['LinkedWorkspaceDTO'][];
      /**
       * Enforce Linked Workspaces
       * @default false
       */
      enforce_linked_workspaces: boolean;
      /** Created At */
      created_at: string;
      /** Updated At */
      updated_at: string;
    };
    /**
     * SSOProvider
     * @enum {string}
     */
    SSOProvider: SSOProvider;
    /**
     * SSOState
     * @description SSO connection lifecycle states.
     * @enum {string}
     */
    SSOState: SSOState;
    /** SafetyIssueTicketRequest */
    SafetyIssueTicketRequest: {
      /** Description */
      description: string;
    };
    /** SafetyIssueTicketResponse */
    SafetyIssueTicketResponse: {
      /** Ticket Reference */
      ticket_reference: string;
    };
    /**
     * SalesBookingFormName
     * @description Canonical names of sales-booking forms exposed to clients.
     * @enum {string}
     */
    SalesBookingFormName: SalesBookingFormName;
    /**
     * SalesBookingFormSubmission
     * @description Tracks when a user last submitted a sales-booking HubSpot form.
     */
    SalesBookingFormSubmission: {
      /**
       * Last Submitted At
       * Format: date-time
       * @description When the user last successfully submitted this form
       */
      last_submitted_at: string;
      /**
       * Submit Count
       * @description Total successful submissions for this form
       * @default 1
       */
      submit_count: number;
    };
    /**
     * SalesBookingSubmissionRequest
     * @description Body for ``POST /sales-booking/{form_name}``.
     *
     *     The HubSpot form id and portal id are held server-side; the caller only
     *     supplies the form fields and optional tracking context. ``form_name``
     *     is a path param that maps to the registered HubSpot form id and
     *     post-submit handler.
     */
    SalesBookingSubmissionRequest: {
      /** Fields */
      fields?: components['schemas']['HubSpotFormField'][];
      context?: components['schemas']['HubSpotFormSubmissionContext'] | null;
    };
    /**
     * SalesBookingSubmissionResponse
     * @description Response after a sales-booking form is successfully submitted.
     *
     *     ``result`` is form-specific. For ``clinician_trial_upgrade`` it always
     *     contains the pair (``trial_extended``, ``new_trial_end_date``):
     *
     *     - ``{"trial_extended": True,  "new_trial_end_date": "<ISO 8601>"}``
     *       when the team owner's clinician trial was extended.
     *     - ``{"trial_extended": False, "new_trial_end_date": None}`` when the
     *       one-shot extension had already been used and the sales call was
     *       booked without mutating billing.
     *
     *     Forms with no post-submit side effects return ``result == None``.
     */
    SalesBookingSubmissionResponse: {
      /** Success */
      success: boolean;
      /** Form Name */
      form_name: string;
      /** Message */
      message: string;
      /** Result */
      result?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * SampledData
     * @description A series of measurements taken by a device.
     *
     *     Data that comes from a series of measurements taken by a device, with upper
     *     and lower limits. There may be more than one dimension in the data.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#SampledData
     */
    SampledData: {
      /**
       * Zero value and units
       * @description The base quantity that a measured value of zero represents. In addition, this provides the units of the entire measurement series. Per FHIR SimpleQuantity constraint, comparator SHALL NOT be present.
       */
      origin: components['schemas']['Quantity'];
      /**
       * Number of milliseconds between samples
       * @description The length of time between sampling times, measured in milliseconds.
       */
      period: number;
      /**
       * Multiply data by this before adding to origin
       * @description A correction factor that is applied to the sampled data points before they are added to the origin.
       */
      factor?: number | null;
      /**
       * Lower limit of detection
       * @description The lower limit of detection of the measured points. This is needed if any of the data points have the value "L" (lower than detection limit).
       */
      lowerLimit?: number | null;
      /**
       * Upper limit of detection
       * @description The upper limit of detection of the measured points. This is needed if any of the data points have the value "U" (higher than detection limit).
       */
      upperLimit?: number | null;
      /**
       * Number of sample points at each time point
       * @description The number of sample points at each time point. If this value is greater than one, then the dimensions will be interlaced - all the sample points for a point in time will be recorded at once.
       */
      dimensions: number;
      /**
       * Decimal values with spaces, or "E" | "U" | "L"
       * @description A series of data points which are decimal values separated by a single space (character u20). The special values "E" (error), "L" (below detection limit) and "U" (above detection limit) can also be used in place of a decimal value.
       */
      data?: string | null;
    };
    /** SaveClientGeneratedBackupTranscriptRequestV2 */
    SaveClientGeneratedBackupTranscriptRequestV2: {
      /** Transcript */
      transcript: string;
    };
    /** SaveClientGeneratedBackupTranscriptResponseV2 */
    SaveClientGeneratedBackupTranscriptResponseV2: {
      /** Transcript */
      transcript: string;
    };
    /**
     * SaveIdentityProfileRequestDTO
     * @description Request DTO for saving identity profile.
     *
     *     Used by IdP actions to create or update user identity profiles
     *     during signup and login flows.
     * @example {
     *       "auth0_id": "auth0|123456789",
     *       "email": "user@example.com",
     *       "email_verified": true,
     *       "identities": [
     *         {
     *           "connection": "Username-Password-Authentication",
     *           "email": "user@example.com",
     *           "is_social": false,
     *           "provider": "auth0",
     *           "user_id": "auth0|123456789"
     *         }
     *       ],
     *       "password": "SecurePassword123!"
     *     }
     * @example {
     *       "email": "user@example.com",
     *       "email_verified": true,
     *       "identities": [
     *         {
     *           "connection": "email",
     *           "email": "user@example.com",
     *           "is_social": false,
     *           "provider": "kinde",
     *           "user_id": "kp_123456789"
     *         }
     *       ],
     *       "kinde_id": "kp_123456789",
     *       "region": "us"
     *     }
     */
    SaveIdentityProfileRequestDTO: {
      /**
       * Email
       * Format: email
       * @description User email address
       */
      email: string;
      /**
       * Auth0 Id
       * @description Optional Auth0 user ID if already known by the caller.
       */
      auth0_id?: string | null;
      /**
       * Kinde Id
       * @description Optional Kinde user ID if already known by the caller.
       */
      kinde_id?: string | null;
      /**
       * Identities
       * @description List of user identities
       */
      identities: components['schemas']['Identity'][];
      /**
       * Email Verified
       * @description Whether email is verified
       * @default false
       */
      email_verified: boolean;
      /**
       * Password
       * @description User password for Auth0 DB signup (optional for social/SSO)
       */
      password?: string | null;
      /**
       * Region
       * @description Optional region code (e.g. US, EU, AU). When provided, stored on the identity profile and synced to the other vendor (Kinde or Auth0).
       */
      region?: string | null;
      /**
       * Metadata
       * @description Extensible key-value metadata for operational and business data (e.g. backfill tracking).
       */
      metadata?: {
        [key: string]: unknown;
      } | null;
      /**
       * First Name
       * @description User's first name. When provided, saved on the profile and synced to the other vendor.
       */
      first_name?: string | null;
      /**
       * Last Name
       * @description User's last name. When provided, saved on the profile and synced to the other vendor.
       */
      last_name?: string | null;
      /**
       * Skip Auth0 Provisioning
       * @description When True, skip Auth0 user provisioning entirely and record auth0_sync_state=IDENTITY_SKIPPED_JIT. Used for SSO users whose Auth0 account will be JIT-provisioned on first SSO login.
       * @default false
       */
      skip_auth0_provisioning: boolean;
    };
    /**
     * SaveIdentityProfileResponse
     * @description Wrapper response for save identity profile endpoint.
     *
     *     This wrapper allows for future expansion with metadata, pagination, etc.
     * @example {
     *       "identity_profile": {
     *         "auth0_id": "auth0|123456789",
     *         "auth0_sync_state": "pending",
     *         "created_at": "2024-01-15T10:30:00Z",
     *         "email": "user@example.com",
     *         "email_verified": true,
     *         "identities": [
     *           {
     *             "connection": "Username-Password-Authentication",
     *             "is_social": false,
     *             "provider": "auth0",
     *             "user_id": "auth0|123456789"
     *           }
     *         ],
     *         "kinde_sync_state": "pending",
     *         "last_routed_vendor": "auth0",
     *         "profile_source": "auth0",
     *         "updated_at": "2024-01-15T10:30:00Z",
     *         "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *       }
     *     }
     */
    SaveIdentityProfileResponse: {
      /** @description The saved identity profile data */
      identity_profile: components['schemas']['SaveIdentityProfileResponseDTO'];
    };
    /**
     * SaveIdentityProfileResponseDTO
     * @description Response DTO for save identity profile.
     *
     *     Returns the complete identity profile after creation or update.
     * @example {
     *       "auth0_id": "auth0|123456789",
     *       "auth0_sync_state": "pending",
     *       "created_at": "2024-01-15T10:30:00Z",
     *       "email": "user@example.com",
     *       "email_verified": true,
     *       "identities": [
     *         {
     *           "connection": "Username-Password-Authentication",
     *           "is_social": false,
     *           "provider": "auth0",
     *           "user_id": "auth0|123456789"
     *         }
     *       ],
     *       "kinde_sync_state": "pending",
     *       "last_routed_vendor": "auth0",
     *       "profile_source": "auth0",
     *       "region": "us",
     *       "updated_at": "2024-01-15T10:30:00Z",
     *       "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *     }
     */
    SaveIdentityProfileResponseDTO: {
      /**
       * User Ref Id
       * @description Global unique identifier (UUID7)
       */
      user_ref_id: string;
      /**
       * Email
       * @description Normalized email address
       */
      email: string;
      /**
       * Email Verified
       * @description Whether email is verified
       */
      email_verified: boolean;
      /**
       * Auth0 Id
       * @description Auth0 user ID if Auth0 identity exists
       */
      auth0_id?: string | null;
      /**
       * Kinde Id
       * @description Kinde user ID if Kinde identity exists
       */
      kinde_id?: string | null;
      /**
       * Identities
       * @description List of user identities
       */
      identities: components['schemas']['Identity'][];
      /** @description Original creating vendor */
      profile_source: components['schemas']['AuthVendor'];
      /** @description Last vendor user was routed to */
      last_routed_vendor?: components['schemas']['AuthVendor'] | null;
      /** @description Auth0 sync status */
      auth0_sync_state: components['schemas']['IdentityProviderSyncState'];
      /** @description Kinde sync status */
      kinde_sync_state: components['schemas']['IdentityProviderSyncState'];
      /**
       * Region
       * @description User's region
       */
      region?: string | null;
      /**
       * First Name
       * @description User's first name
       */
      first_name?: string | null;
      /**
       * Last Name
       * @description User's last name
       */
      last_name?: string | null;
      /**
       * Metadata
       * @description Extensible key-value metadata
       */
      metadata?: {
        [key: string]: unknown;
      } | null;
      /**
       * Created At
       * Format: date-time
       * @description Creation timestamp
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Last update timestamp
       */
      updated_at: string;
    };
    /** SccAccessContextJWKPublic */
    SccAccessContextJWKPublic: {
      /**
       * Kty
       * @default RSA
       */
      kty: string;
      /**
       * Use
       * @default sig
       */
      use: string;
      /**
       * Alg
       * @default RS256
       */
      alg: string;
      /** Kid */
      kid: string;
      /** N */
      n: number;
      /** E */
      e: number;
    };
    /** SccAccessContextJWKSet */
    SccAccessContextJWKSet: {
      /** Keys */
      keys: components['schemas']['SccAccessContextJWKPublic'][];
    };
    /**
     * Schedule
     * @description A container for slots of time that may be available for booking appointments.
     *
     *     https://hl7.org/fhir/R4/schedule-definitions.html
     */
    Schedule: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * External Ids for this item
       * @description External Ids for this item.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Whether this schedule is in active use
       * @description Whether this schedule record is in active use or should not be used (such as was entered in error).
       */
      active?: boolean | null;
      /**
       * High-level category
       * @description A broad categorization of the service that is to be performed during this appointment.
       */
      serviceCategory?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Specific service
       * @description The specific service that is to be performed during this appointment.
       */
      serviceType?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Type of specialty needed
       * @description The specialty of a practitioner that would be required to perform the service requested in this appointment.
       */
      specialty?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Resource(s) that availability information is being provided for
       * @description Slots that reference this schedule resource provide the availability details to these referenced resource(s).
       */
      actor: components['schemas']['Reference'][];
      /**
       * Period of time covered by schedule
       * @description The period of time that the slots that reference this Schedule resource cover (even if none exist). These cover the amount of time that an organization's planning horizon; the interval for which they are currently accepting appointments.
       */
      planningHorizon?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Comments on availability
       * @description Comments on the availability to describe any extended information. Such as custom constraints on the slots that may be associated.
       */
      comment?: string | null;
    };
    /** ScheduleDetailsResponse */
    ScheduleDetailsResponse: {
      /** Schedule Id */
      schedule_id: string;
      /** Temporal Schedule Id */
      temporal_schedule_id: string;
      /** Actor User Id */
      actor_user_id: string;
      /** Subject User Id */
      subject_user_id: string;
      dispatch_action: components['schemas']['ScheduleDispatchActionResponse'];
      target_context?: components['schemas']['AgentTargetContext'] | null;
      /** Display Name */
      display_name: string;
      /** Description */
      description: string;
      spec: components['schemas']['ScheduleSpecModel'];
      /** Paused */
      paused: boolean;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Temporal Schedule Url */
      temporal_schedule_url?: string | null;
      latest_run?: components['schemas']['LatestRunSummaryResponse'] | null;
      /** Workflow Id */
      workflow_id?: string | null;
      /** Workflow Display Name */
      workflow_display_name?: string | null;
      /** Product Surface */
      product_surface?: string | null;
      runtime?: components['schemas']['ScheduleRuntimeResponse'] | null;
    };
    /**
     * ScheduleDispatchActionResponse
     * @description Workflow dispatch target attached to a schedule.
     */
    ScheduleDispatchActionResponse: {
      /** Workflow Name */
      workflow_name: string;
      /** Payload */
      payload?: {
        [key: string]: unknown;
      };
    };
    /**
     * ScheduleItemAppointment
     * @description Appointment for schedule items with optional session information.
     */
    ScheduleItemAppointment: {
      provider_details: components['schemas']['IntegrationAppointmentProviderDetails'];
      /**
       * Start
       * Format: date-time
       */
      start: string;
      /**
       * End
       * Format: date-time
       */
      end: string;
      status?: components['schemas']['AppointmentStatus'] | null;
      /**
       * Display Facets
       * @description Provider-agnostic schedule facets. Omitted when the adaptor has none; when present the list is non-empty.
       *
       *     FE must be dynamic — do not hardcode ``facet`` string checks. Row labels: facets with ``show_in_row: true``, text = ``display`` if set else ``value``. Filter UI: collect unique ``(facet, value, display)`` tuples from the schedule response; send ``filter={facet}:{value}`` when filtering.
       *
       *     Example Athena row (``East Clinic · Group One`` inline; provider hidden because ``show_in_row: false``)::
       *
       *         display_facets: [
       *           {facet: department, value: "196", display: "East Clinic", show_in_row: true},
       *           {facet: provider_group, value: "1", display: "Group One", show_in_row: true},
       *           {facet: provider, value: "123", show_in_row: false}
       *         ]
       */
      display_facets?: components['schemas']['IntegrationDisplayFacet'][] | null;
      session?: components['schemas']['ScheduleItemAppointmentSession'] | null;
    };
    /** ScheduleItemAppointmentSession */
    ScheduleItemAppointmentSession: {
      /** Session Id */
      session_id: string;
    };
    /** ScheduleResponse */
    ScheduleResponse: {
      /** Schedule Id */
      schedule_id: string;
      /** Display Name */
      display_name: string;
      /** Description */
      description: string;
      spec: components['schemas']['ScheduleSpecModel'];
      /** Workflow Id */
      workflow_id: string | null;
      /** Paused */
      paused: boolean;
      /** Created At */
      created_at: string | null;
      /** Updated At */
      updated_at: string | null;
    };
    /** ScheduleRuntimeResponse */
    ScheduleRuntimeResponse: {
      /** Paused */
      paused: boolean;
      /** Next Action Times */
      next_action_times?: string[];
      /** Recent Action Times */
      recent_action_times?: string[];
      /** Running Workflow Ids */
      running_workflow_ids?: string[];
      /** Remaining Actions */
      remaining_actions?: number | null;
      /** Note */
      note?: string | null;
    };
    /**
     * ScheduleSpecModel
     * @description Product-layer schedule specification.
     *
     *     Translated to Temporal primitives by ``to_temporal_schedule_spec``.
     *     All cadences — including hourly/daily/weekly — are compiled to
     *     ``ScheduleCalendarSpec`` anchored to the wall-clock of ``start_at``
     *     in ``timezone``, so every frequency kind is DST-aware.
     */
    ScheduleSpecModel: {
      /**
       * Start At
       * Format: date-time
       */
      start_at: string;
      /**
       * Timezone
       * @default UTC
       */
      timezone: string;
      /** Frequency */
      frequency:
        | components['schemas']['HourlyFrequency']
        | components['schemas']['DailyFrequency']
        | components['schemas']['WeeklyFrequency']
        | components['schemas']['CronFrequency'];
      /** End */
      end?:
        | components['schemas']['NeverEnd']
        | components['schemas']['EndAt']
        | components['schemas']['EndAfterN'];
    };
    /**
     * ScheduleUploadErrorCode
     * @enum {string}
     */
    ScheduleUploadErrorCode: ScheduleUploadErrorCode;
    /** ScheduleUploadView */
    ScheduleUploadView: {
      /**
       * Sessions
       * @default []
       */
      sessions: components['schemas']['ScheduledSessionDraftView'][];
      error?: components['schemas']['ScheduleUploadErrorCode'] | null;
    };
    /** ScheduledSessionDraftView */
    ScheduledSessionDraftView: {
      /** Patient Name */
      patient_name: string;
      /** Datetime */
      datetime: string | null;
      /**
       * Errors
       * @default []
       */
      errors: components['schemas']['ScheduleUploadErrorCode'][];
      /**
       * Context
       * @description Pre-session context extracted from the upload; FE round-trips into BulkCreateSessionParams.context.
       */
      context?: string | null;
    };
    /**
     * ScreenHint
     * @description UI screen hints for frontend routing.
     * @enum {string}
     */
    ScreenHint: ScreenHint;
    /** ScribeChangedEvent */
    ScribeChangedEvent: {
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Consult Note Id */
      consult_note_id: string;
      /** User Name */
      user_name?: string | null;
      /** Template Name */
      template_name?: string | null;
      /** Original Note */
      original_note: string;
      /** Patches */
      patches?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      brain?: components['schemas']['Brain'] | null;
      /**
       * Type
       * @default scribe_changed
       * @constant
       */
      type: 'scribe_changed';
    };
    /**
     * ScribeCoreMergeResponse
     * @description Per-entity re-key counts for the user-to-user scribe-core merge step
     *     (DEV-12207). Each value is the number of documents repointed from the
     *     source user to the target user.
     */
    ScribeCoreMergeResponse: {
      /**
       * Clinical Tasks Modified
       * @default 0
       */
      clinical_tasks_modified: number;
      /**
       * Consult Note Edits Modified
       * @default 0
       */
      consult_note_edits_modified: number;
      /**
       * Consult Note Reverts Modified
       * @default 0
       */
      consult_note_reverts_modified: number;
      /**
       * Note Suggestions Modified
       * @default 0
       */
      note_suggestions_modified: number;
      /**
       * Session Shares Modified
       * @default 0
       */
      session_shares_modified: number;
    };
    /**
     * SealedMessageDeliveryRecipientSearchResultResponse
     * @description API representation of an SMD recipient search hit.
     */
    SealedMessageDeliveryRecipientSearchResultResponse: {
      /**
       * Practitioner Display
       * @description Display name of the practitioner.
       */
      practitioner_display: string;
      /**
       * Organization Display
       * @description Display name of the practitioner's organization.
       */
      organization_display?: string | null;
      /**
       * Specialty Display
       * @description Display text of the practitioner's first specialty.
       */
      specialty_display?: string | null;
      /**
       * Location Display
       * @description City and state of the practitioner's first location (e.g. 'Flemington, VIC').
       */
      location_display?: string | null;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: SealedMessageDeliveryRecipientSearchResultResponseType;
      /**
       * Provider
       * @description Integration provider that supplied this result (e.g. 'healthlink'). Used for UI labelling and provider-specific SMD constraints.
       */
      provider: string;
      /**
       * Endpoint Id
       * @description FHIR Endpoint resource ID for SMD delivery.
       */
      endpoint_id: string;
      /**
       * Practitioner Role Id
       * @description FHIR PractitionerRole resource ID.
       */
      practitioner_role_id?: string | null;
      /**
       * Practitioner Provider Number
       * @description Recipient practitioner's Medicare provider number from the directory search.
       */
      practitioner_provider_number?: string | null;
    };
    /** SearchAppointmentResponse */
    SearchAppointmentResponse: {
      /** Appointments */
      appointments: components['schemas']['EHRAppointment'][];
    };
    /** SearchClinicalCodesResponse */
    SearchClinicalCodesResponse: {
      /** Codes */
      codes: (
        | components['schemas']['SNOMEDCodeConcept']
        | components['schemas']['ICD10CodeConcept']
        | components['schemas']['MBSAUCodeConcept']
        | components['schemas']['CPTCodeConcept']
        | components['schemas']['ICD10UKCodeConcept']
        | components['schemas']['ICD9CMCodeConcept']
        | components['schemas']['ICD9CACodeConcept']
        | components['schemas']['OPCS410CodeConcept']
        | components['schemas']['ICD10AMCodeConcept']
        | components['schemas']['ACHI13AUCodeConcept']
        | components['schemas']['ICD10GMCodeConcept']
        | components['schemas']['CIM10FRCodeConcept']
        | components['schemas']['CIE10ESCodeConcept']
        | components['schemas']['ICD10ZACodeConcept']
        | components['schemas']['OrphaCodeConcept']
        | components['schemas']['CIM10MCCodeConcept']
        | components['schemas']['CIM10SCPCodeConcept']
        | components['schemas']['OHIPDXCodeConcept']
        | components['schemas']['CPTQACodeConcept']
        | components['schemas']['ICD10QACodeConcept']
        | components['schemas']['ICD10ITCodeConcept']
        | components['schemas']['BaseCodeConcept']
      )[];
    };
    /**
     * SearchClinicsRequest
     * @description Request model for searching clinics by name.
     */
    SearchClinicsRequest: {
      /** Clinic Name */
      clinic_name: string;
      /** Region */
      region?: string | null;
    };
    /**
     * SearchClinicsResponse
     * @description Response model for clinic search.
     */
    SearchClinicsResponse: {
      /** Clinics */
      clinics: components['schemas']['ClinicInfo'][];
    };
    /** SearchGUIDResponse */
    SearchGUIDResponse: {
      /** Guid */
      guid: string;
      /** Practice Management Name */
      practice_management_name: string;
      /** Status */
      status: string;
      /** Authoritative */
      authoritative: boolean | null;
    };
    /** SearchIntegrationOnboardingSessionsResponse */
    SearchIntegrationOnboardingSessionsResponse: {
      /**
       * Sessions
       * @description List of onboarding sessions matching the search criteria
       */
      sessions: components['schemas']['CreateIntegrationOnboardingSessionResponse'][];
    };
    /**
     * SearchIntegrationPatientsRequestBody
     * @description Explicit filters for live EHR patient search.
     */
    SearchIntegrationPatientsRequestBody: {
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Dob */
      dob?: string | null;
      /** Nhs Number */
      nhs_number?: string | null;
      /**
       * Page Size
       * @default 5
       */
      page_size: number;
    };
    /** SearchIntegrationPatientsResponse */
    SearchIntegrationPatientsResponse: {
      /** Patients */
      patients: components['schemas']['SearchIntegrationPatientsResultItem'][];
    };
    /** SearchIntegrationPatientsResultItem */
    SearchIntegrationPatientsResultItem: {
      /** Patient Id */
      patient_id: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Dob */
      dob?: string | null;
      /** Nhs Number */
      nhs_number?: string | null;
      /** Sex */
      sex?: string | null;
    };
    /** SearchIntegrationSessionLinkResponse */
    SearchIntegrationSessionLinkResponse: {
      /** Id */
      id: string;
      /** Session Id */
      session_id: string;
      provider_appointment_details: components['schemas']['IntegrationAppointmentProviderDetails'];
      /** Provider Unique Identifier */
      provider_unique_identifier: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Updated At */
      updated_at?: string | null;
    };
    /**
     * SearchMembersResponse
     * @description Response schema for organization member search results.
     */
    SearchMembersResponse: {
      /** Org Id */
      org_id?: string | null;
      /** Org Name */
      org_name?: string | null;
      /** Members */
      members: components['schemas']['MemberSearchResult'][];
    };
    /**
     * SearchPatientProfilesRequest
     * @description Live patient-profile search request body.
     *
     *     POST (not GET) because `q` carries patient-name PHI — keeping it
     *     out of URL access logs is a HIPAA requirement.
     *
     *     `min_length=2` rejects single-character queries at the HTTP layer
     *     so we don't run a 5-field regex scan across the user's full
     *     profile list at every keystroke.
     *
     *     `limit` is bounded at the HTTP layer too so the OpenAPI schema
     *     advertises the cap and clients get a 422 (instead of silent
     *     server-side clamping) for out-of-range requests.
     */
    SearchPatientProfilesRequest: {
      /** Q */
      q: string;
      /**
       * Limit
       * @default 10
       */
      limit: number;
    };
    /** SearchPatientProfilesResponse */
    SearchPatientProfilesResponse: {
      /** Data */
      data: components['schemas']['PatientProfileSearchResult'][];
    };
    /** SearchResponse[AllergyIntolerance] */
    SearchResponse_AllergyIntolerance_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_AllergyIntolerance_'][];
    };
    /** SearchResponse[Appointment] */
    SearchResponse_Appointment_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Appointment_'][];
    };
    /** SearchResponse[Composition] */
    SearchResponse_Composition_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Composition_'][];
    };
    /** SearchResponse[DocumentReference] */
    SearchResponse_DocumentReference_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_DocumentReference_'][];
    };
    /** SearchResponse[Encounter] */
    SearchResponse_Encounter_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Encounter_'][];
    };
    /** SearchResponse[FamilyMemberHistory] */
    SearchResponse_FamilyMemberHistory_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_FamilyMemberHistory_'][];
    };
    /** SearchResponse[HealthcareService] */
    SearchResponse_HealthcareService_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_HealthcareService_'][];
    };
    /** SearchResponse[Immunization] */
    SearchResponse_Immunization_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Immunization_'][];
    };
    /** SearchResponse[Location] */
    SearchResponse_Location_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Location_'][];
    };
    /** SearchResponse[MedicationRequest] */
    SearchResponse_MedicationRequest_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_MedicationRequest_'][];
    };
    /** SearchResponse[MedicationStatement] */
    SearchResponse_MedicationStatement_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_MedicationStatement_'][];
    };
    /** SearchResponse[Observation] */
    SearchResponse_Observation_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Observation_'][];
    };
    /** SearchResponse[Patient] */
    SearchResponse_Patient_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Patient_'][];
    };
    /** SearchResponse[PractitionerRole] */
    SearchResponse_PractitionerRole_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_PractitionerRole_'][];
    };
    /** SearchResponse[Practitioner] */
    SearchResponse_Practitioner_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Practitioner_'][];
    };
    /** SearchResponse[QuestionnaireResponse] */
    SearchResponse_QuestionnaireResponse_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_QuestionnaireResponse_'][];
    };
    /** SearchResponse[Schedule] */
    SearchResponse_Schedule_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Schedule_'][];
    };
    /** SearchResponse[Slot] */
    SearchResponse_Slot_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Slot_'][];
    };
    /** SearchResponse[Task] */
    SearchResponse_Task_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_Task_'][];
    };
    /** SearchStaffByNameResponse */
    SearchStaffByNameResponse: {
      /** User Id */
      user_id: string;
      /** Last Name */
      last_name: string;
      /** First Name */
      first_name: string;
      /** Registration Number */
      registration_number?: string | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Location Id */
      location_id?: string | null;
    };
    /** SearchTeamPatientsRequest */
    SearchTeamPatientsRequest: {
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /**
       * Workspace Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      workspace_id: string;
      demographics: components['schemas']['MatchDemographics'];
      /** Active Provider */
      active_provider?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
    };
    /**
     * SearchTemplatesResponse
     * @description Response schema for template search endpoint.
     */
    SearchTemplatesResponse: {
      /**
       * Items
       * @description The list of template objects for the current page
       */
      items: components['schemas']['TemplateResponseV2'][];
      /**
       * Total
       * @description The total number of templates matching the search criteria
       */
      total: number;
      /**
       * Page
       * @description The current page number
       */
      page: number;
      /**
       * Creators
       * @description A map of all unique creator kinde user IDs to their names, for all templates the user can access
       */
      creators: {
        [key: string]: string;
      };
    };
    /**
     * SecretExpiryDTO
     * @description Client-secret expiry info (absolute date or relative duration).
     */
    SecretExpiryDTO: {
      /** Expires At */
      expires_at?: string | null;
      /** Duration Months */
      duration_months?: number | null;
      /** Anchored At */
      anchored_at?: string | null;
    };
    /** SectionLink */
    SectionLink: {
      /** Section Heading */
      section_heading: string;
      /**
       * Linked Ehr Section Id
       * @default
       */
      linked_ehr_section_id: string;
    };
    /** SectionMappingRequest */
    SectionMappingRequest: {
      /** Section Heading */
      section_heading: string;
      /** Linked Ehr Section Id */
      linked_ehr_section_id: string;
    };
    /** SectionModel */
    SectionModel: {
      /** Section Id */
      section_id: string;
      /** Label */
      label: string;
      /** Items */
      items: (
        | components['schemas']['CheckItem']
        | components['schemas']['InfoItem']
        | components['schemas']['ChoiceItem']
        | components['schemas']['CondItem']
        | components['schemas']['ForkItem']
        | components['schemas']['BranchItem']
      )[];
    };
    /** SectionalNote */
    SectionalNote: {
      /** Heading */
      heading: string;
      /** Note */
      note: string;
    };
    /**
     * SectionalNoteSection
     * @enum {string}
     */
    SectionalNoteSection: SectionalNoteSection;
    /**
     * SeedProtocolsResponse
     * @description Result of seeding the file-catalogue protocols into the caller's org (idempotent).
     *     ``created``/``skipped`` drive the confirmation toast; ``protocols`` is the org's full list
     *     after seeding so the dashboard can refresh without a second round-trip.
     */
    SeedProtocolsResponse: {
      /** Created */
      created: number;
      /** Skipped */
      skipped: number;
      /** Protocols */
      protocols: components['schemas']['NudgeProtocolResponse'][];
    };
    /**
     * SelfOnboardRequest
     * @description Request model for self-onboarding with optional parameters.
     */
    SelfOnboardRequest: {
      /** Team Id */
      team_id?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Specialty Id */
      specialty_id?: string | null;
    };
    /**
     * SelfOnboardResponse
     * @description Response model for self-onboarding.
     */
    SelfOnboardResponse: {
      team?: components['schemas']['SimpleTeam'] | null;
      /** Errors */
      errors?: {
        [key: string]: string;
      } | null;
    };
    /** SemanticCondition */
    SemanticCondition: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: SemanticConditionKind;
      config: components['schemas']['SemanticConditionConfig'];
    };
    /** SemanticConditionConfig */
    SemanticConditionConfig: {
      /** Rule */
      rule: string;
      /**
       * Min Confidence
       * @default 0.7
       */
      min_confidence: number;
      /**
       * Evaluator
       * @default generic_nl
       */
      evaluator: string;
    };
    /**
     * SendBatchForReviewRequest
     * @description Body for `POST /batches/{batch_id}:send-for-review`.
     *
     *     `draft_ids` follows the bulk-publish/bulk-signoff pattern: omit/null
     *     targets every `ready_for_review` draft in the batch; a list scopes
     *     to that subset. Ids in other batches/statuses are silently skipped.
     *     Server-side dedupes `reviewer_emails` and skips invalid ones.
     */
    SendBatchForReviewRequest: {
      /** Reviewer Emails */
      reviewer_emails?: string[];
      /** Draft Ids */
      draft_ids?: string[] | null;
      /** Requested By */
      requested_by?: string | null;
    };
    /**
     * SendEmailRequestBody
     * @description FE-shaped body — mirror ``SendPatientSummaryEmailRequest`` in
     *     ``scribe-fe-v2/src/types/patient-summary.types.ts``.
     *
     *     A linked patient profile is NOT required — the clinician can send to any
     *     recipient by supplying ``last_name`` + ``birth_date`` inline (these derive
     *     the PDF password). When a profile IS linked it's pure autofill convenience:
     *     the FE prefills these fields from it and back-fills it afterwards.
     */
    SendEmailRequestBody: {
      /**
       * Document Id
       * @description Patient summary document ID. Supply exactly one of this or ``session_id``.
       */
      document_id?: string | null;
      /**
       * Session Id
       * @description Session ID to send that session's consult note instead of a saved document. Supply exactly one of this or ``document_id``.
       */
      session_id?: string | null;
      /**
       * Patient Profile Id
       * @description Linked patient profile ID, when the session has one. Optional — when present, the send is cross-checked against the session's patient; when absent, an ad-hoc send proceeds on the inline last_name + birth_date.
       */
      patient_profile_id?: string | null;
      /**
       * Delivery Email
       * @description Recipient patient email address.
       */
      delivery_email: string;
      /**
       * Last Name
       * @description Patient last name — half of the DOB-derived PDF password. Required to send (the clinician types it inline or it's autofilled from a linked profile).
       */
      last_name?: string | null;
      /**
       * Birth Date
       * @description Patient date of birth, ISO yyyy-mm-dd — the other half of the PDF password. Required to send.
       */
      birth_date?: string | null;
      /**
       * Document Type
       * @description Patient-facing document TYPE for the email subject + body (e.g. 'visit summary', 'document'). Deliberately not the file name (PHI risk) — the service clamps this to an allowlist and defaults to 'document'.
       */
      document_type?: string | null;
      /**
       * Patient Message
       * @description Optional clinician-authored intro (currently unused by email).
       */
      patient_message?: string | null;
    };
    /**
     * SendEmailResponseBody
     * @description FE-shaped result of the email send — keep in sync with
     *     ``SendPatientSummaryEmailResponse``.
     */
    SendEmailResponseBody: {
      /** Success */
      success: boolean;
      /** Delivery Email */
      delivery_email: string;
      /** Patient Name */
      patient_name: string;
      /** Clinician Name */
      clinician_name: string;
      /** Download Url */
      download_url: string;
      /** Error */
      error?: string | null;
      /** Error Reason */
      error_reason?: string | null;
    };
    /**
     * SendLetterRequest
     * @description Multipart form request for sending a rendered letter PDF.
     */
    SendLetterRequest: {
      /**
       * File
       * Format: binary
       * @description Frontend-rendered letter PDF to send.
       */
      file: string;
    };
    /**
     * SendLetterResponse
     * @description API response for sending a letter.
     */
    SendLetterResponse: {
      /**
       * Letter Id
       * @description Letter ID serialized as a string.
       */
      letter_id: string;
      /** @description Letter editability after the send attempt. */
      editable_status: components['schemas']['LetterEditableStatus'];
      /** @description Latest overall delivery state after the send attempt: SENT, PARTIALLY_SENT, FAILED, or null before any persisted attempt. */
      delivery_status: components['schemas']['LetterDeliveryStatus'] | null;
      /** @description Latest persisted delivery state details, or null before any send attempt. Partial retries carry forward previously delivered recipients without sending them again. */
      delivery_details?: components['schemas']['LetterDeliveryDetails'] | null;
    };
    /** SendMessageRequest */
    SendMessageRequest: {
      /**
       * Message
       * @default
       */
      message: string;
      /**
       * Internal Note
       * @default false
       */
      internal_note: boolean;
      /** Media Urls */
      media_urls?: string[] | null;
      /** Media Metadata */
      media_metadata?:
        | {
            [key: string]: unknown;
          }[]
        | null;
    };
    /**
     * SendOutDeviceView
     * @description Compact projection of a unit included in a send-out.
     */
    SendOutDeviceView: {
      /** Uuid */
      uuid: string;
      status: components['schemas']['StockItemStatus'];
      /** Device Id */
      device_id?: string | null;
      /** Label */
      label?: string | null;
    };
    /**
     * SendOutRecipientDetails
     * @description Recipient address for a CUSTOMER_RESEND send-out.
     *
     *     Recipient name and street address are required; the rest are optional.
     *     Country is normalised to ISO alpha-2.
     */
    SendOutRecipientDetails: {
      /** Contact Name */
      contact_name: string;
      /** Street Address */
      street_address: string;
      /** Contact Email */
      contact_email?: string | null;
      /** Contact Phone */
      contact_phone?: string | null;
      /** City */
      city?: string | null;
      /** State */
      state?: string | null;
      /** Postcode */
      postcode?: string | null;
      /** Country */
      country?: string | null;
    };
    /** SendOutRecipientView */
    SendOutRecipientView: {
      /** Contact Name */
      contact_name?: string | null;
      /** Contact Email */
      contact_email?: string | null;
      /** Contact Phone */
      contact_phone?: string | null;
      /** Street Address */
      street_address?: string | null;
      /** City */
      city?: string | null;
      /** State */
      state?: string | null;
      /** Postcode */
      postcode?: string | null;
      /** Country */
      country?: string | null;
    };
    /**
     * SendOutStatus
     * @description Approval lifecycle of an office-stock send-out.
     *
     *     Carried in a field rather than the order status enum so the approval flow
     *     never touches the public/mobile fulfilment-status contract. REQUESTED on
     *     creation; a super admin moves it to APPROVED or REJECTED; an approved
     *     send-out becomes FULFILLED once its units are dispatched.
     * @enum {string}
     */
    SendOutStatus: SendOutStatus;
    /**
     * SendOutType
     * @description What an office-stock send-out is for.
     *
     *     CUSTOMER_RESEND ships a unit to a recipient (recorded via the order's
     *     shipping details + a tracking number). INTERNAL_USE hands a unit to a
     *     staff member for internal use (recorded via taken_by + purpose).
     * @enum {string}
     */
    SendOutType: SendOutType;
    /**
     * SendOutView
     * @description Internal-admin projection of a single send-out and its units.
     */
    SendOutView: {
      /** Order Id */
      order_id: string;
      send_out_status: components['schemas']['SendOutStatus'];
      send_out_type: components['schemas']['SendOutType'];
      /** Devices */
      devices: components['schemas']['SendOutDeviceView'][];
      /** Stock Item Uuids */
      stock_item_uuids: string[];
      recipient?: components['schemas']['SendOutRecipientView'] | null;
      /** Tracking Number */
      tracking_number?: string | null;
      /** Tracking Url */
      tracking_url?: string | null;
      /** Taken By */
      taken_by?: string | null;
      /** Purpose */
      purpose?: string | null;
      /** Created By */
      created_by?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Approved By */
      approved_by?: string | null;
      /** Approved At */
      approved_at?: string | null;
      /** Rejected By */
      rejected_by?: string | null;
      /** Rejected At */
      rejected_at?: string | null;
    };
    /** SendOutgoingCorrespondenceWithLetterTemplateRequest */
    SendOutgoingCorrespondenceWithLetterTemplateRequest: {
      /** Template Id */
      template_id: string;
      /** @default consult_note */
      correspondence_content_type: components['schemas']['CorrespondenceContentType'];
      /** Document Id */
      document_id?: string | null;
    };
    /** SendOutgoingCorrespondenceWithLetterTemplateResponse */
    SendOutgoingCorrespondenceWithLetterTemplateResponse: {
      /** Correspondence Id */
      correspondence_id: string;
    };
    /**
     * SendResponseBody
     * @description FE-shaped result of the dispatch round-trip.
     *
     *     The FE distinguishes ``success`` paths (toast + close dialog) from
     *     deterministic failures (toast + leave dialog open with retry) via the
     *     boolean. Twilio confirmation fields (``message_sid``, ``status``) are
     *     only populated on the success path; ``error`` / ``error_reason`` only
     *     on the failure path.
     */
    SendResponseBody: {
      /** Success */
      success: boolean;
      /** Delivery Phone */
      delivery_phone: string;
      /** Patient Name */
      patient_name: string;
      /** Clinician Name */
      clinician_name: string;
      /** Password */
      password: string | null;
      /** Password Hint */
      password_hint: string;
      /** Download Url */
      download_url: string;
      /** Sms Body */
      sms_body: string;
      /** Message Sid */
      message_sid?: string | null;
      /** Status */
      status?: string | null;
      /** Error */
      error?: string | null;
      /** Error Reason */
      error_reason?: string | null;
    };
    /** SendTextChatMessageRequest */
    SendTextChatMessageRequest: {
      /** Text */
      text: string;
    };
    /**
     * SensitiveActionRevocationAuditEvent
     * @description Automatic session revocations triggered by a sensitive account action.
     *
     *     Distinct from :attr:`UserSelfServiceAuditEvent.USER_SELF_LOGOUT_EVERYWHERE`
     *     (the manual "log out everywhere" button) so the audit trail attributes each
     *     revocation to the action that triggered it. ``Actor.type`` is ``"User"`` for
     *     user-initiated actions (email change, MFA enable) and ``"System"`` for
     *     platform-driven actions (password reset, the Airflow-driven region
     *     migration).
     * @enum {string}
     */
    SensitiveActionRevocationAuditEvent: SensitiveActionRevocationAuditEvent;
    /**
     * ServiceActionOption
     * @description One supported `(product, feature)` action the admin UI can offer as a
     *     single picker choice (served by `GET /service-meter-bindings/options`).
     */
    ServiceActionOption: {
      /** Product */
      product: string;
      /** Feature */
      feature: string;
      /** Label */
      label: string;
    };
    /** ServiceMeterBindingResponse */
    ServiceMeterBindingResponse: {
      /** Id */
      id: string;
      /** Product */
      product: string;
      /** Feature */
      feature: string;
      /** Metric Keys */
      metric_keys: string[];
      /** Description */
      description: string | null;
      /** Created By */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** ServiceMigrationResult */
    ServiceMigrationResult: {
      /**
       * Service
       * @description Service name: identity_broker, auth0, stripe, kinde
       * @enum {string}
       */
      service: ServiceMigrationResultService;
      /**
       * Status
       * @description Result: updated, skipped, or failed
       * @enum {string}
       */
      status: ServiceMigrationResultStatus;
      /**
       * Reason
       * @description Explanation for skipped or failed status
       */
      reason?: string | null;
    };
    /** SessionAudioChunksResponse */
    SessionAudioChunksResponse: {
      /** Session Id */
      session_id: string;
      /** Recordings */
      recordings?: components['schemas']['RecordingAudioChunks'][];
      /** Expires In Seconds */
      expires_in_seconds: number;
    };
    /** SessionAudioFileItem */
    SessionAudioFileItem: {
      /** Id */
      id: string;
      /** Source */
      source: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Starttime */
      starttime?: string | null;
      /** Endtime */
      endtime?: string | null;
      /** Content Type */
      content_type?: string | null;
      /** Size Bytes */
      size_bytes?: number | null;
      /** Status */
      status: string;
      /** Retained In S3 */
      retained_in_s3: boolean;
      /** Access Url */
      access_url?: string | null;
    };
    /** SessionAudioFilesResponse */
    SessionAudioFilesResponse: {
      /** Session Id */
      session_id: string;
      /** Audio Files */
      audio_files: components['schemas']['SessionAudioFileItem'][];
      /** Expires In Seconds */
      expires_in_seconds: number;
    };
    /** SessionBackupChunkStatusResponse */
    SessionBackupChunkStatusResponse: {
      /** Session Id */
      session_id: string;
      /** Chunks Exist */
      chunks_exist: boolean;
      /** Total Chunk Count */
      total_chunk_count: number;
      /** Total Size Bytes */
      total_size_bytes: number;
      /** Estimated Total Duration Ms */
      estimated_total_duration_ms?: number | null;
      /** Earliest Expires At */
      earliest_expires_at?: string | null;
      /** Recordings */
      recordings: components['schemas']['RecordingBackupChunkStatus'][];
      /** Session Languages */
      session_languages: string[];
      session_sources: components['schemas']['SessionTranscriptSources'];
    };
    /** SessionClinicalCodeResponse */
    SessionClinicalCodeResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /**
       * Consult Note Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      consult_note_id: string;
      /** Clinical Entities */
      clinical_entities: components['schemas']['CodedClinicalEntity'][];
      /** Collections Used */
      collections_used?: {
        [key: string]: string;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Generation Completed At */
      generation_completed_at?: string | null;
      feedback?: components['schemas']['Feedback'] | null;
      em_level?: components['schemas']['SessionEmLevelResponse'] | null;
    };
    /** SessionClinicalCodeResponseWithSuccess */
    SessionClinicalCodeResponseWithSuccess: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /**
       * Consult Note Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      consult_note_id: string;
      /** Clinical Entities */
      clinical_entities: components['schemas']['CodedClinicalEntity'][];
      /** Collections Used */
      collections_used?: {
        [key: string]: string;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Generation Completed At */
      generation_completed_at?: string | null;
      feedback?: components['schemas']['Feedback'] | null;
      em_level?: components['schemas']['SessionEmLevelResponse'] | null;
      /** Success */
      success: boolean[];
    };
    /** SessionContextDocumentMetaData */
    SessionContextDocumentMetaData: {
      /** Name */
      name?: string | null;
      /** Date */
      date?: string | null;
      /** Additional Context */
      additional_context?: string | null;
      /** Unstructured */
      unstructured?: boolean | null;
    };
    /** SessionContextDocumentView */
    SessionContextDocumentView: {
      /** Id */
      id: string;
      /** User Id */
      user_id: string;
      /** Session Id */
      session_id: string;
      /** Name */
      name: string;
      /** Date */
      date?: string | null;
      type?: components['schemas']['DocumentType'] | null;
      /** Content */
      content?: string | null;
      status?: components['schemas']['ContextDocumentStatus'] | null;
      /** Additional Context */
      additional_context?: string | null;
      /** Unstructured */
      unstructured?: boolean | null;
    };
    /**
     * SessionContextInfo
     * @description Session context information returned with chat.
     */
    SessionContextInfo: {
      /** Session Id */
      session_id: string;
      /** Name */
      name?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      /** Created At */
      created_at?: string | null;
    };
    /** SessionDataFieldSchema */
    SessionDataFieldSchema: {
      /** Key */
      key: string;
      /** Description */
      description: string;
      /** Database Path */
      database_path: string;
      /** Category */
      category: string;
    };
    /** SessionDetailsResponse */
    SessionDetailsResponse: {
      session: components['schemas']['DetailedSessionView'];
    };
    /** SessionEmLevel */
    SessionEmLevel: {
      /** Summary */
      summary?: string | null;
      problem: components['schemas']['EmMdmElement'];
      data: components['schemas']['EmMdmElement'];
      risk: components['schemas']['EmMdmElement'];
      mdm_level?: components['schemas']['MdmComplexityLevel'] | null;
      /** New Patient Em Code */
      new_patient_em_code?: string | null;
      /** Established Patient Em Code */
      established_patient_em_code?: string | null;
      confirmed?: components['schemas']['SessionEmLevelConfirmed'] | null;
      /** Patient Type */
      patient_type?: string | null;
      /** Em Code */
      em_code?: string | null;
      /** Modifier */
      modifier?: SessionEmLevelModifierAnyOf0 | null;
    };
    /** SessionEmLevelConfirmed */
    SessionEmLevelConfirmed: {
      /** Patient Type */
      patient_type: string;
      /** Code */
      code: string;
      /** Code System */
      code_system: string;
      /** Collection Used */
      collection_used: string;
      /** Determination Method */
      determination_method?: string | null;
      /**
       * Confirmed At
       * Format: date-time
       */
      confirmed_at: string;
    };
    /** SessionEmLevelResponse */
    SessionEmLevelResponse: {
      mdm: components['schemas']['EmMdmResponse'];
      suggested_em_codes: components['schemas']['SuggestedEmCodesResponse'];
      /** Available Em Codes */
      available_em_codes: components['schemas']['EmCodeOption'][];
      confirmed?: components['schemas']['SessionEmLevelConfirmed'] | null;
    };
    /**
     * SessionEventResponse
     * @description Response model for session events
     */
    SessionEventResponse: {
      /** Id */
      _id: string;
      /** Session Id */
      session_id: string;
      /** User Id */
      user_id: string;
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp: string;
      /** Region */
      region: string;
      /** Event Type */
      event_type: string;
      /** Details */
      details: {
        [key: string]: unknown;
      };
    };
    /**
     * SessionEventsResponse
     * @description Response model for list of session events
     */
    SessionEventsResponse: {
      /** Events */
      events: components['schemas']['SessionEventResponse'][];
      /** Count */
      count: number;
    };
    /** SessionExpiringRequest */
    SessionExpiringRequest: {
      /** Expiring Sessions */
      expiring_sessions: {
        [key: string]: string[];
      };
    };
    /**
     * SessionGroupStatus
     * @description A session's grouping lifecycle position (Session Group Remake).
     *
     *     One mutually-exclusive value per session, persisted so the front-end
     *     clients render grouping UI from a single field. Structural role
     *     (container vs member vs nested group) is read from ``is_group`` /
     *     ``merged_into_session_id`` — ``GROUPED`` is role-agnostic so future
     *     group-into-group nesting needs no new value. Freshness is a separate
     *     axis (``GroupFreshnessService.is_group_stale``), not encoded here.
     * @enum {string}
     */
    SessionGroupStatus: SessionGroupStatus;
    /** SessionListItemView */
    SessionListItemView: {
      /** Session Id */
      session_id: string;
      /** Kinde Gp Id */
      kinde_gp_id: string;
      /** Clinician Name */
      clinician_name?: string | null;
      /** Session Name */
      session_name?: string | null;
      patient: components['schemas']['SessionListPatient'];
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      /**
       * Patient Profile Name
       * @description Patient display name. Precedence: demographic_string (age-refreshed) > "first last" > null, matching the session detail header (MUL-3137). Null when no profile is linked OR profile-resolve service was unavailable (graceful degrade).
       */
      patient_profile_name?: string | null;
      /** @default EMPTY */
      session_status: components['schemas']['SessionStatus'] | null;
      /**
       * Is Urgent
       * @default false
       */
      is_urgent: boolean;
      /** Duration */
      duration: number;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Created Time Local */
      created_time_local?: string | null;
      patient_profile_appointment_candidates?:
        | components['schemas']['PatientProfileAppointmentCandidates']
        | null;
      /** Creation Platform */
      creation_platform?:
        | (
            | components['schemas']['WebApp']
            | components['schemas']['DesktopApp']
            | components['schemas']['IOSApp']
            | components['schemas']['AndroidApp']
            | components['schemas']['RemoteApp']
          )
        | null;
      patient_link_status?: components['schemas']['PatientLinkStatus'] | null;
      /** @default no_action */
      session_group_status: components['schemas']['SessionGroupStatus'];
      session_merge_group?: components['schemas']['MergeableSessions'];
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
    };
    /**
     * SessionListLatencyResponse
     * @description Latency + page metrics for a replayed v2.2 session-list query.
     *
     *     Deliberately carries no session content: only the resolved internal
     *     identifiers, the echoed shape of the query, and the measurement. The
     *     filter *values* (`q`, patient/clinician/status filters, dates) are not
     *     echoed back — they can contain PII.
     *
     *     Latency is split into the two consecutive I/O phases a real request pays,
     *     so a slow replay can be attributed rather than guessed at:
     *
     *     - `context_setup_ms` — deriving the target user's flag-evaluation context
     *       (a Mongo team-hierarchy fetch plus a Redis-cached, on-miss remote
     *       Flagsmith identity fetch). Every real user-facing request pays this
     *       before the query, so it's part of end-to-end latency even though it
     *       isn't the DB query itself.
     *     - `elapsed_ms` — the `SessionManager.list_sessions` DB query alone.
     */
    SessionListLatencyResponse: {
      /** User Ref Id */
      user_ref_id: string | null;
      /** Kinde User Id */
      kinde_user_id: string;
      scope: components['schemas']['SessionScope'];
      /** Page Size */
      page_size: number;
      sort_by: components['schemas']['SessionSortBy'];
      sort_order: components['schemas']['shared__enums__enums__SortOrder'];
      /** Context Setup Ms */
      context_setup_ms: number;
      /** Elapsed Ms */
      elapsed_ms: number;
      /** Page Count */
      page_count: number;
      /** Has Next Page */
      has_next_page: boolean;
      /** Timed Out */
      timed_out: boolean;
    };
    /** SessionListPatient */
    SessionListPatient: {
      /** Name */
      name?: string | null;
    };
    /** SessionListResponse */
    SessionListResponse: {
      /**
       * Sessions
       * @description Page of session items
       */
      sessions: components['schemas']['SessionListItemView'][];
      /**
       * Next Cursor
       * @description Opaque cursor for the next page. Null when there are no more pages.
       */
      next_cursor?: string | null;
    };
    /**
     * SessionMergeGroupMember
     * @description A session's group membership plus the fields clients display for it.
     *
     *     ``created_time_local`` is normalised to UTC on write; see
     *     :func:`_member_snapshot_fields`.
     */
    SessionMergeGroupMember: {
      /** Session Id */
      session_id: string;
      /** @default merged */
      link_status: components['schemas']['SessionMergeStatus'];
      /** Created Time Local */
      created_time_local?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Session Gist */
      session_gist?: string | null;
      /** Session Name */
      session_name?: string | null;
    };
    /** SessionMergeGroupResponse */
    SessionMergeGroupResponse: {
      /** Primary Session Id */
      primary_session_id: string;
      /**
       * Session Ids
       * @description Primary first, then merged member ids from session_merge_group
       */
      session_ids: string[];
    };
    /**
     * SessionMergeStatus
     * @enum {string}
     */
    SessionMergeStatus: SessionMergeStatus;
    /**
     * SessionMergeTimeframe
     * @description Window for grouping sessions when auto-merging after patient match.
     * @enum {string}
     */
    SessionMergeTimeframe: SessionMergeTimeframe;
    /**
     * SessionOverviewConsultNoteInfo
     * @description Consult note information without actual content (non-PII)
     */
    SessionOverviewConsultNoteInfo: {
      /** Session Id */
      session_id: string;
      status?: components['schemas']['ConsultNoteStatus'] | null;
      /**
       * Revision Id
       * @description Revision ID from Beanie revision support
       */
      revision_id?: string | null;
      /** Model */
      model?: string | string[] | null;
      brain?: components['schemas']['Brain'] | null;
      /** Voice Style */
      voice_style?: string | null;
      generation_method?: components['schemas']['GenerationMethod'] | null;
      /** Template Id */
      template_id?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Ehr Note Id */
      ehr_note_id?: string | null;
      /** Third Party Template */
      third_party_template?: string | null;
      feedback?: components['schemas']['Feedback'] | null;
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      /** Content Type */
      content_type?: string | null;
      /** Request Metadata */
      request_metadata?: {
        [key: string]: unknown;
      } | null;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Generation Time */
      generation_time?: string | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Is Alternative Generation */
      is_alternative_generation?: boolean | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
      /** Original Note Word Count */
      original_note_word_count?: number | null;
      /** Current Note Word Count */
      current_note_word_count?: number | null;
    };
    /**
     * SessionOverviewDocumentInfo
     * @description Document information without actual content (non-PII)
     */
    SessionOverviewDocumentInfo: {
      /** Session Id */
      session_id: string;
      /** Creator Kinde Id */
      creator_kinde_id?: string | null;
      /** Template Id */
      template_id?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Deleted At */
      deleted_at?: string | null;
      generation_type?: components['schemas']['DocumentGenType'] | null;
      brain?: components['schemas']['Brain'] | null;
      feedback?: components['schemas']['Feedback'] | null;
      /** Voice Style */
      voice_style?: string | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Content Type */
      content_type?: string | null;
      /** Generation Time */
      generation_time?: string | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
      /** Has Deducted Quota */
      has_deducted_quota?: boolean | null;
      /**
       * Document Original Word Count
       * @description Word count of document original_content
       */
      document_original_word_count?: number | null;
      /**
       * Document Content Word Count
       * @description Word count of document content
       */
      document_content_word_count?: number | null;
    };
    /**
     * SessionOverviewResponse
     * @description Session Overview for support without revealing PII.
     *     SUP-7503: Contains metadata useful for debugging without exposing patient information.
     *     Combines functionality of:
     *     - GET /api/v1/ml-scribe/internal-admin/sessions/{session_id}
     *     - GET /api/v2/ml-scribe/internal-admin/sessions/{session_id}/document/
     *     - GET /api/v1/ml-scribe/internal-admin/sessions/{session_id}/transcript
     *     - GET /api/v1/ml-scribe/internal-admin/session-events?session_id={session_id}
     */
    SessionOverviewResponse: {
      /** Session Id */
      session_id: string;
      /** Kinde Gp Id */
      kinde_gp_id: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Creator Kinde Id */
      creator_kinde_id?: string | null;
      /** Creation Platform */
      creation_platform?:
        | (
            | components['schemas']['WebApp']
            | components['schemas']['DesktopApp']
            | components['schemas']['IOSApp']
            | components['schemas']['AndroidApp']
            | components['schemas']['RemoteApp']
          )
        | null;
      language_code: components['schemas']['LanguageCode'];
      /** Language Code List */
      language_code_list?: components['schemas']['LanguageCode'][];
      output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Organisation Id */
      organisation_id?: string | null;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      status: components['schemas']['BaseStatus'];
      session_status?: components['schemas']['SessionStatus'] | null;
      /** Duration */
      duration: number;
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Ehr Appt Contact Id */
      ehr_appt_contact_id?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Encounter Id */
      ehr_encounter_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Is Ehr Deprecated */
      is_ehr_deprecated: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Is Consent */
      is_consent?: boolean | null;
      transcribe_mode?: components['schemas']['TranscribeMode'] | null;
      /** Is Tab Sharing */
      is_tab_sharing: boolean;
      /** Is Demo */
      is_demo: boolean;
      /** Is Consumed Quota */
      is_consumed_quota: boolean;
      /** Is Consumed Ai Quota */
      is_consumed_ai_quota: boolean;
      /** Is Consumed Sectional Note Gen Quota */
      is_consumed_sectional_note_gen_quota: boolean;
      /** Is Reviewed */
      is_reviewed: boolean;
      /** Is Transcript Ready */
      is_transcript_ready: boolean;
      /** Is Open Api Session */
      is_open_api_session: boolean;
      /** Do Recording Playback */
      do_recording_playback: boolean;
      /** Timezone */
      timezone?: string | null;
      /** Created Time Local */
      created_time_local?: string | null;
      /** Start Time Local */
      start_time_local?: string | null;
      /** Generate Output Without Recording */
      generate_output_without_recording?: boolean | null;
      recording_status: components['schemas']['RecordingStatus'];
      /** Transcript In Use */
      transcript_in_use?: string | null;
      /**
       * Transcript Deleted At
       * @description The deletion time once the transcript has been hard-deleted; None otherwise.
       */
      transcript_deleted_at?: string | null;
      transcript_feedback?: components['schemas']['Feedback'] | null;
      /** Linked Sessions For Context */
      linked_sessions_for_context?: string[];
      /**
       * Transcript Word Count
       * @description Word count of session transcript (calculated)
       */
      transcript_word_count?: number | null;
      /**
       * Live Transcripts Audio Duration
       * @description Total audio duration from live_transcripts (sum of recording_duration fields)
       */
      live_transcripts_audio_duration?: number | null;
      /**
       * Events Audio Duration
       * @description Total audio duration from transcription service events (sum of audio_info.duration from chunk events, in milliseconds converted to seconds)
       */
      events_audio_duration?: number | null;
      /**
       * Total Received Audio Duration
       * @description Total received audio duration (live_transcripts + events, in seconds). Can be compared with session.duration
       */
      total_received_audio_duration?: number | null;
      consult_note?: components['schemas']['SessionOverviewConsultNoteInfo'] | null;
      /** Documents */
      documents?: components['schemas']['SessionOverviewDocumentInfo'][];
      session_events?: components['schemas']['SessionEventsResponse'] | null;
      /**
       * Audio Chunks Overview
       * @description Array of audio chunk information for analyzing transcription patterns, gaps, failures, etc. (no transcript content/PII)
       */
      audio_chunks_overview?: components['schemas']['AudioChunkOverviewInfo'][];
      /**
       * Audio Recordings
       * @description Backup and hardware audio recordings with status and availability (no transcript content/PII)
       */
      audio_recordings?: components['schemas']['AudioRecordingOverviewInfo'][];
    };
    /**
     * SessionOwner
     * @description The owner of a session.
     */
    SessionOwner: {
      /**
       * User Ref Id
       * @description User reference ID
       */
      user_ref_id: string;
      /**
       * Email
       * @description User email
       */
      email?: string | null;
      /**
       * First Name
       * @description User first name
       */
      first_name?: string | null;
      /**
       * Last Name
       * @description User last name
       */
      last_name?: string | null;
      /**
       * Level
       * @description Owner permission level
       * @default owner
       * @constant
       */
      level: 'owner';
    };
    /**
     * SessionPages
     * @enum {string}
     */
    SessionPages: SessionPages;
    /**
     * SessionPatientDocumentLinkListResponse
     * @description All patient-document links currently active on a session.
     */
    SessionPatientDocumentLinkListResponse: {
      /** Items */
      items: components['schemas']['SessionPatientDocumentLinkResponse'][];
    };
    /**
     * SessionPatientDocumentLinkResponse
     * @description One linked patient document, with embedded patient-document metadata.
     *
     *     The embedded fields are denormalised on read for FE convenience — they
     *     let the FE render the row (filename, mime type, size) without a second
     *     query to the patient-document endpoint.
     */
    SessionPatientDocumentLinkResponse: {
      /** Id */
      id: string;
      /** Session Id */
      session_id: string;
      /** Patient Document Id */
      patient_document_id: string;
      /** Patient Profile Id */
      patient_profile_id: string;
      /** Linked By */
      linked_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** File Name */
      file_name?: string | null;
      /** Mime Type */
      mime_type?: string | null;
      /** Size Bytes */
      size_bytes?: number | null;
      /** Description */
      description?: string | null;
      /** Summary */
      summary?: string | null;
    };
    /** SessionPermissionsRequest */
    SessionPermissionsRequest: {
      /** Session Id */
      session_id: string;
      /** User Id */
      user_id: string;
    };
    /**
     * SessionProblemResponse
     * @description Session problem for frontend display.
     *
     *     Extends base SessionProblem with clinical codes and relevance.
     */
    SessionProblemResponse: {
      /** Problem Id */
      problem_id: string;
      /** Name */
      name: string;
      /** Ehr Problem Id */
      ehr_problem_id?: string | null;
      /** Problem Description */
      problem_description?: string | null;
      /** Icd10 Codes */
      icd10_codes?: components['schemas']['ICD10Code'][];
      /**
       * Relevance
       * @description Problem relevance: HIGH, MEDIUM, or LOW
       * @default MEDIUM
       */
      relevance: string;
      /**
       * Assessment Text
       * @description Assessment text for problem
       * @default
       */
      assessment_text: string;
      /**
       * Plan Text
       * @description Plan text for problem
       * @default
       */
      plan_text: string;
      /**
       * Evidence Links
       * @description Evidence excerpts linking this problem to source documentation
       */
      evidence_links?: components['schemas']['EvidenceLinkResponse'][];
      /**
       * Not In Note
       * @description True if problem appears only in transcript/context, not in the note
       * @default false
       */
      not_in_note: boolean;
    };
    /**
     * SessionProblemsResponse
     * @description Response for GET /sessions/{session_id}/problems.
     */
    SessionProblemsResponse: {
      /** Session Id */
      session_id: string;
      /** Problems */
      problems: components['schemas']['SessionProblemResponse'][];
      /**
       * Cpt Codes
       * @description Session-level CPT codes (not problem-specific)
       */
      cpt_codes?: components['schemas']['CPTCode'][];
      /** Updated At */
      updated_at: string;
      /**
       * Problems Stale
       * @description True if note has been modified since problems were last generated
       * @default false
       */
      problems_stale: boolean;
    };
    /** SessionRecordsResponse */
    SessionRecordsResponse: {
      /** Session Records */
      session_records: components['schemas']['SimpleSessionRecord'][];
      /** Total Count */
      total_count: number;
    };
    /** SessionResearchMetadata */
    SessionResearchMetadata: {
      /** Consultation Environment */
      consultation_environment?: string | null;
      /** Recording Device */
      recording_device?: string | null;
      /** Microphone Model */
      microphone_model?: string | null;
      /** Note Capture Method */
      note_capture_method?: string | null;
      /** People Present */
      people_present?: number | null;
    };
    /**
     * SessionResponse
     * @description Session representation returned to the frontend.
     */
    SessionResponse: {
      /** Id */
      id: string;
      /** Title */
      title: string;
      /** Patientlanguage */
      patientLanguage: string;
      /** Clinicianlanguage */
      clinicianLanguage: string;
      patient?: components['schemas']['PatientDetailsResponse'] | null;
      /** Reasonforvisit */
      reasonForVisit?: string | null;
      patientOnboardingStatus?: components['schemas']['OnboardingStatus'] | null;
      /**
       * Createdat
       * Format: date-time
       */
      createdAt: string;
      /** Lastactivityat */
      lastActivityAt?: string | null;
      /** Evaluatorname */
      evaluatorName?: string | null;
      /** Evaluationcomments */
      evaluationComments?: string | null;
      overallAssessment?: components['schemas']['OverallAssessment'] | null;
    };
    /** SessionResponseV2 */
    SessionResponseV2: {
      /** Sessions */
      sessions: components['schemas']['SimpleSessionViewV2'][];
      /** Count */
      count: number;
      /** Total Count */
      total_count?: number | null;
      /**
       * Next Page
       * @deprecated
       */
      next_page?: number | null;
      /** Has Next Page */
      has_next_page: boolean;
    };
    /**
     * SessionScope
     * @enum {string}
     */
    SessionScope: SessionScope;
    /**
     * SessionSearchResponse
     * @description Response schema for session search endpoint.
     */
    SessionSearchResponse: {
      /**
       * Sessions
       * @description List of sessions matching the search criteria
       */
      sessions: components['schemas']['SimpleSessionViewV2'][];
      /**
       * Count
       * @description Number of sessions returned in this page
       */
      count: number;
      /**
       * Total Match Count
       * @description Total number of sessions matching the search criteria. Returns 0 if include_total_count=false
       */
      total_match_count: number;
      /**
       * Page
       * @description Current page number (1-indexed)
       */
      page: number;
      /**
       * Page Size
       * @description Number of items per page
       */
      page_size: number;
      /**
       * Has Next Page
       * @description Whether there are more results available
       */
      has_next_page: boolean;
    };
    /** SessionSettingsRequest */
    SessionSettingsRequest: {
      /** Is Consent Pop Up */
      is_consent_pop_up?: boolean | null;
      /** Is Review Modal Required */
      is_review_modal_required?: boolean | null;
      /** Is Mini Mode Enabled */
      is_mini_mode_enabled?: boolean | null;
      consult_storage_days?: components['schemas']['ConsultStorageDays'] | null;
      /** Session Storage Days */
      session_storage_days?: number | null;
      /** Chat Retention Days */
      chat_retention_days?: number | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      /** Is Recording Selection Prompt Pop Up */
      is_recording_selection_prompt_pop_up?: boolean | null;
      default_template_id?: components['schemas']['TemplateId'] | null;
      /** Default Template Is System Template */
      default_template_is_system_template?: boolean | null;
      default_voice_style?: components['schemas']['VoiceStyle'] | null;
      default_custom_style?: components['schemas']['CustomStyle'] | null;
      /** Default Telehealth Mode */
      default_telehealth_mode?: boolean | null;
      default_input_language_code?: components['schemas']['LanguageCode'] | null;
      /** Default Input Language Code List */
      default_input_language_code_list?: components['schemas']['LanguageCode'][] | null;
      default_output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Do Not Ask Languages */
      do_not_ask_languages?: components['schemas']['LanguageCode'][] | null;
      default_dictation_cleanup_mode?:
        | components['schemas']['DictationCleanupModes']
        | null;
      brain?: components['schemas']['Brain'] | null;
      last_recording_mode?: components['schemas']['TranscribeMode'] | null;
      /** Is Live Transcription Split View */
      is_live_transcription_split_view?: boolean | null;
      default_new_session_tab?: components['schemas']['SessionTabType'] | null;
      /** Do Dictation Playback */
      do_dictation_playback?: boolean | null;
      date_format?: components['schemas']['DateFormat'] | null;
      /** Warn Pro Action */
      warn_pro_action?: boolean | null;
      /** User Word Library */
      user_word_library?: {
        [key: string]: string;
      } | null;
      de_identified_data_use_settings?:
        | components['schemas']['DeidentifiedDataUseSettingsRequest']
        | null;
      default_copy_type?: components['schemas']['CopyType'] | null;
      copy_settings?: components['schemas']['CopySettings'] | null;
      spelling_preference?: components['schemas']['SpellingPreference'] | null;
      /** Opted In Experimental */
      opted_in_experimental?: boolean | null;
      /** Labs Feature Overrides */
      labs_feature_overrides?: {
        [key: string]: boolean;
      } | null;
      /** Refer Patient */
      refer_patient?: string | null;
      /** Refer Clinician */
      refer_clinician?: string | null;
      /** Allowed Domains */
      allowed_domains?: string[] | null;
      default_side_panel_state?: components['schemas']['SidePanelState'] | null;
      /** Generate Tasks */
      generate_tasks?: boolean | null;
      /** Generate Patient Summary */
      generate_patient_summary?: boolean | null;
      /** Auto Download Filled Forms */
      auto_download_filled_forms?: boolean | null;
      /** Default Apply Personalization Insights */
      default_apply_personalization_insights?: boolean | null;
      /** Personalization Opted In */
      personalization_opted_in?: boolean | null;
      /** Do Not Ask Existing Patient Profile Confirmation */
      do_not_ask_existing_patient_profile_confirmation?: boolean | null;
      /** Hide Branding From Exports */
      hide_branding_from_exports?: boolean | null;
      organization_branding?: components['schemas']['OrganizationBranding'] | null;
      /** Enable Export Header */
      enable_export_header?: boolean | null;
      export_header_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /** Enable Export Footer */
      enable_export_footer?: boolean | null;
      export_footer_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /** Apply Header Footer To Evidence */
      apply_header_footer_to_evidence?: boolean | null;
      /** Default Export Font */
      default_export_font?: string | null;
      /** Default Export Font Size */
      default_export_font_size?: number | null;
      /** Default Form Field Font Size */
      default_form_field_font_size?: number | null;
      /** Show Verified Highlights */
      show_verified_highlights?: boolean | null;
      /** Show Issue Highlights */
      show_issue_highlights?: boolean | null;
      /** Enable Auto Session Merge */
      enable_auto_session_merge?: boolean | null;
      session_merge_timeframe?: components['schemas']['SessionMergeTimeframe'] | null;
      /** Session Merge Custom Days */
      session_merge_custom_days?: number | null;
      /** Connected Apps Provider */
      connected_apps_provider?: SessionSettingsRequestConnected_apps_providerAnyOf0 | null;
    };
    /** SessionSettingsResponse */
    SessionSettingsResponse: {
      /** Is Consent Pop Up */
      is_consent_pop_up: boolean;
      /**
       * Is Consent Pop Up Managed By Team
       * @default false
       */
      is_consent_pop_up_managed_by_team: boolean;
      /**
       * Hide Remember Consent Checkbox
       * @default false
       */
      hide_remember_consent_checkbox: boolean;
      /**
       * Is Review Modal Required
       * @default false
       */
      is_review_modal_required: boolean;
      /**
       * Is Review Modal Managed By Team
       * @default false
       */
      is_review_modal_managed_by_team: boolean;
      /**
       * Is Mini Mode Enabled
       * @default true
       */
      is_mini_mode_enabled: boolean;
      consult_storage_days: components['schemas']['ConsultStorageDays'];
      /** Session Storage Days */
      session_storage_days: number | null;
      /**
       * Session Storage Days Managed By Team
       * @default false
       */
      session_storage_days_managed_by_team: boolean;
      /** Chat Retention Days */
      chat_retention_days?: number | null;
      /**
       * Chat Retention Managed By Team
       * @default false
       */
      chat_retention_managed_by_team: boolean;
      /**
       * @default {
       *       "enabled": false
       *     }
       */
      patient_retention_settings: components['schemas']['RetentionSettings'];
      /**
       * Patient Retention Settings Managed By Team
       * @default false
       */
      patient_retention_settings_managed_by_team: boolean;
      /**
       * @default {
       *       "enabled": false
       *     }
       */
      transcript_retention_settings: components['schemas']['RetentionSettings'];
      /**
       * Transcript Retention Settings Managed By Team
       * @default false
       */
      transcript_retention_settings_managed_by_team: boolean;
      /** Is Recording Selection Prompt Pop Up */
      is_recording_selection_prompt_pop_up: boolean;
      brain: components['schemas']['Brain'];
      default_template_id?: components['schemas']['TemplateId'] | null;
      /** Default Template Is System Template */
      default_template_is_system_template?: boolean | null;
      default_voice_style: components['schemas']['VoiceStyle'];
      default_custom_style?: components['schemas']['CustomStyle'] | null;
      /** Default Telehealth Mode */
      default_telehealth_mode: boolean;
      default_input_language_code: components['schemas']['LanguageCode'];
      /** Default Input Language Code List */
      default_input_language_code_list: components['schemas']['LanguageCode'][];
      default_output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Do Not Ask Languages */
      do_not_ask_languages?: components['schemas']['LanguageCode'][];
      default_dictation_cleanup_mode:
        | components['schemas']['DictationCleanupModes']
        | null;
      last_recording_mode: components['schemas']['TranscribeMode'];
      /** Is Live Transcription Split View */
      is_live_transcription_split_view: boolean;
      default_new_session_tab: components['schemas']['SessionTabType'];
      /** Do Dictation Playback */
      do_dictation_playback: boolean;
      date_format?: components['schemas']['DateFormat'] | null;
      /** User Word Library */
      user_word_library?: {
        [key: string]: string;
      } | null;
      de_identified_data_use_settings: components['schemas']['DeidentifiedDataUseSettingsResponse'];
      /** @default COPY_WITH_FORMATTING_WITHOUT_LISTS */
      default_copy_type: components['schemas']['CopyType'] | null;
      copy_settings: components['schemas']['CopySettings'];
      spelling_preference?: components['schemas']['SpellingPreference'] | null;
      /** Opted In Experimental */
      opted_in_experimental: boolean;
      /** Labs Feature Overrides */
      labs_feature_overrides?: {
        [key: string]: boolean;
      };
      /** Refer Patient */
      refer_patient?: string | null;
      /** Refer Clinician */
      refer_clinician?: string | null;
      /** @default TASKS */
      default_side_panel_state: components['schemas']['SidePanelState'] | null;
      /**
       * Generate Tasks
       * @default true
       */
      generate_tasks: boolean | null;
      /**
       * Generate Patient Summary
       * @default true
       */
      generate_patient_summary: boolean | null;
      /**
       * Generate Patient Summary Managed By Team
       * @default false
       */
      generate_patient_summary_managed_by_team: boolean;
      /**
       * Auto Download Filled Forms
       * @default false
       */
      auto_download_filled_forms: boolean | null;
      /** Default Apply Personalization Insights */
      default_apply_personalization_insights?: boolean | null;
      /**
       * Personalization Opted In
       * @default false
       */
      personalization_opted_in: boolean;
      /** Do Not Ask Existing Patient Profile Confirmation */
      do_not_ask_existing_patient_profile_confirmation?: boolean | null;
      /** Allowed Domains */
      allowed_domains?: string[] | null;
      /**
       * Hide Branding From Exports
       * @default true
       */
      hide_branding_from_exports: boolean;
      organization_branding?: components['schemas']['OrganizationBranding'] | null;
      /**
       * Enable Export Header
       * @default false
       */
      enable_export_header: boolean;
      export_header_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /**
       * Enable Export Footer
       * @default false
       */
      enable_export_footer: boolean;
      export_footer_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /**
       * Apply Header Footer To Evidence
       * @default true
       */
      apply_header_footer_to_evidence: boolean;
      /** Default Export Font */
      default_export_font?: string | null;
      /** Default Export Font Size */
      default_export_font_size?: number | null;
      /** Default Form Field Font Size */
      default_form_field_font_size?: number | null;
      /** Custom Consent Text */
      custom_consent_text?: string | null;
      /**
       * Show Verified Highlights
       * @default false
       */
      show_verified_highlights: boolean;
      /**
       * Show Issue Highlights
       * @default true
       */
      show_issue_highlights: boolean;
      /**
       * Enable Auto Session Merge
       * @default false
       */
      enable_auto_session_merge: boolean;
      /** @default same_day */
      session_merge_timeframe: components['schemas']['SessionMergeTimeframe'];
      /** Session Merge Custom Days */
      session_merge_custom_days?: number | null;
      /**
       * Intends To Auto Link Sessions
       * @default false
       */
      intends_to_auto_link_sessions: boolean;
      /**
       * Intends To Auto Extract Patient Context
       * @default true
       */
      intends_to_auto_extract_patient_context: boolean;
      /**
       * Auto Extract Managed By Team
       * @default false
       */
      auto_extract_managed_by_team: boolean;
      /** Connected Apps Provider */
      connected_apps_provider?: SessionSettingsResponseConnected_apps_providerAnyOf0 | null;
    };
    /**
     * SessionShareItem
     * @description A single share item in the request.
     */
    SessionShareItem: {
      /**
       * User Ref Id
       * @description User reference ID to share with
       */
      user_ref_id: string;
      /** @description Permission level */
      level: components['schemas']['ShareLevel'];
    };
    /**
     * SessionSortBy
     * @description Sort options for session search - matches frontend SortOption.
     * @enum {string}
     */
    SessionSortBy: SessionSortBy;
    /**
     * SessionStatus
     * @description Represents the review workflow status of a session's letter/document.
     * @enum {string}
     */
    SessionStatus: SessionStatus;
    /**
     * SessionStatusCountResponse
     * @description Response schema for session status count endpoint.
     */
    SessionStatusCountResponse: {
      /** @description The queried session status */
      session_status: components['schemas']['SessionStatus'];
      /**
       * Count
       * @description Number of sessions with this status
       */
      count: number;
    };
    /** SessionStatusCountsResponse */
    SessionStatusCountsResponse: {
      /**
       * Counts
       * @description Number of sessions per status within the requested scope. Every SessionStatus is present; a status with no sessions is 0, not omitted.
       */
      counts: {
        [key: string]: number;
      };
    };
    /** SessionStorageDaysResponse */
    SessionStorageDaysResponse: {
      /** Session Storage Days */
      session_storage_days: number | null;
    };
    /**
     * SessionTabType
     * @enum {string}
     */
    SessionTabType: SessionTabType;
    /** SessionTeamIdAuditResponse */
    SessionTeamIdAuditResponse: {
      /** User Ref Id */
      user_ref_id: string | null;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Current Team Id */
      current_team_id: string | null;
      /** Current Team Root Id */
      current_team_root_id: string | null;
      /** Has Active Team */
      has_active_team: boolean;
      /** Sessions Total */
      sessions_total: number;
      /** Sessions Unstamped */
      sessions_unstamped: number;
      /** Sessions Stamped Correct Org */
      sessions_stamped_correct_org: number;
      /** Sessions Stamped Cross Org */
      sessions_stamped_cross_org: number;
      /** Sample Unstamped Session Ids */
      sample_unstamped_session_ids: string[];
      /** Sample Cross Org Session Ids */
      sample_cross_org_session_ids: string[];
      /** Coverage Complete */
      coverage_complete: boolean;
      /** Cross Org Clean */
      cross_org_clean: boolean;
      /** Current Team Root Resolved */
      current_team_root_resolved: boolean;
    };
    /**
     * SessionTimeoutInfo
     * @description Domain-level session-timeout value object.
     *
     *     Lives in the dataclass layer so both the domain layer
     *     (`OrganizationModel`, `UpdateOrganizationContext`) and the persistence
     *     layer (`User`, `TeamDO`) can reference it without the domain layer
     *     depending on `database.mongo.*`. Mirrors the `TeamMFAInfo` precedent in
     *     `dataclass/mfa.py`.
     */
    SessionTimeoutInfo: {
      /** Minutes */
      minutes: number;
      set_by: components['schemas']['SessionTimeoutSetBY'];
      scope: components['schemas']['SessionTimeoutScope'];
    };
    /**
     * SessionTimeoutScope
     * @enum {string}
     */
    SessionTimeoutScope: SessionTimeoutScope;
    /**
     * SessionTimeoutSetBY
     * @enum {string}
     */
    SessionTimeoutSetBY: SessionTimeoutSetBY;
    /** SessionTranscriptResponse */
    SessionTranscriptResponse: {
      /** Transcript */
      transcript?: string | null;
    };
    /**
     * SessionTranscriptSources
     * @description Which other transcript/audio sources exist for the session.
     *
     *     Recovery only replaces the transcription-service (external) portion of
     *     the merged transcript; sup-eng needs to see what else would still be
     *     concatenated in (ml-scribe live/backup copies, hardware audio, uploaded
     *     audio). Counts split stored-vs-transcribed so an empty or errored entry
     *     doesn't read as contributing text. Caveats mirroring the read-time merge
     *     (ValidatedTranscript.transcript): live and backup are mutually exclusive,
     *     and hardware audio is time-merged into the backup slot.
     */
    SessionTranscriptSources: {
      /** Transcript In Use */
      transcript_in_use?: string | null;
      live_transcripts: components['schemas']['SourceAvailability'];
      backup_audio: components['schemas']['SourceAvailability'];
      hardware_audio: components['schemas']['SourceAvailability'];
      uploaded_audio: components['schemas']['SourceAvailability'];
    };
    /** SessionTranscriptsResponse */
    SessionTranscriptsResponse: {
      /** Transcripts */
      transcripts: components['schemas']['ExternalOrganizationSessionView'][];
      /** Invalid User Emails */
      invalid_user_emails: string[];
    };
    /** SessionUpdate */
    SessionUpdate: {
      language_code?: components['schemas']['LanguageCode'] | null;
      /** Language Code List */
      language_code_list?: components['schemas']['LanguageCode'][] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
      patient?: components['schemas']['PatientUpdate'] | null;
      /** Clinician Notes */
      clinician_notes?: string[] | null;
      consult_note?: components['schemas']['ConsultNoteModel'] | null;
      /** Duration */
      duration?: number | null;
      /** Is Consent */
      is_consent?: boolean | null;
      /** Is Review Modal Confirmed */
      is_review_modal_confirmed?: boolean | null;
      /** Transcript */
      transcript?: string | null;
      transcript_service_details?:
        | components['schemas']['TranscriptServiceDetails']
        | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      transcribe_mode?: components['schemas']['TranscribeMode'] | null;
      /** Is Tab Sharing */
      is_tab_sharing?: boolean | null;
      /** Is Long Consult */
      is_long_consult?: boolean | null;
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Ehr Appt Contact Id */
      ehr_appt_contact_id?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Encounter Id */
      ehr_encounter_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Had Ws Recording Failure */
      had_ws_recording_failure?: boolean | null;
      /** Latest Consult Note Id */
      latest_consult_note_id?: string | null;
      /** Find And Replace */
      find_and_replace?: {
        [key: string]: string;
      } | null;
      find_and_replace_scope?: components['schemas']['FindandReplaceScope'] | null;
      /** Find And Replace Ignore Case */
      find_and_replace_ignore_case?: boolean | null;
      /** Find And Replace Partial Match */
      find_and_replace_partial_match?: boolean | null;
      /** Start Time Local */
      start_time_local?: string | null;
      /** Created Time Local */
      created_time_local?: string | null;
      /** Generate Output Without Recording */
      generate_output_without_recording?: boolean | null;
      recording_status?: components['schemas']['RecordingStatus'] | null;
      session_status?: components['schemas']['SessionStatus'] | null;
      /** Is Urgent */
      is_urgent?: boolean | null;
      /** Session Gist */
      session_gist?: string | null;
      transcript_feedback?: components['schemas']['Feedback'] | null;
      /** Linked Sessions For Context */
      linked_sessions_for_context?: string[] | null;
      /** Linked Sessions For Context Fallback */
      linked_sessions_for_context_fallback?: boolean | null;
      /** Past Ehr Notes */
      past_ehr_notes?: components['schemas']['EHRNote'][] | null;
      extracted_patient_context?:
        | components['schemas']['PatientContextLLMResponse']
        | null;
      research_metadata?: components['schemas']['SessionResearchMetadata'] | null;
      /** Research Clinician Note */
      research_clinician_note?: string | null;
    };
    /** SessionsResponse */
    SessionsResponse: {
      /** Sessions */
      sessions: components['schemas']['SimpleSessionViewV2'][];
      /** Count */
      count: number;
      /** Total Count */
      total_count?: number | null;
      /**
       * Next Page
       * @deprecated
       */
      next_page?: number | null;
      /** Has Next Page */
      has_next_page: boolean;
    };
    /** SessionsResponseWithFeedback */
    SessionsResponseWithFeedback: {
      /** Sessions */
      sessions: components['schemas']['SimpleSessionViewWithFeedback'][];
      /** Count */
      count: number;
      /** Total Count */
      total_count?: number | null;
      /**
       * Next Page
       * @deprecated
       */
      next_page?: number | null;
      /** Has Next Page */
      has_next_page: boolean;
    };
    /**
     * SessionsResponseWithoutPII
     * @description Response type for sessions with PII excluded but EHR identifiers retained.
     *
     *     EHR identifiers (ehr_appt_id, ehr_appt_contact_id, ehr_provider,
     *     ehr_encounter_id, ehr_patient_id) are PHI under HIPAA; this type does
     *     NOT provide full PHI exclusion. Use for non-super-admin session lists.
     */
    SessionsResponseWithoutPII: {
      /** Sessions */
      sessions: components['schemas']['SimpleSessionViewWithoutPII'][];
      /** Count */
      count: number;
      /** Total Count */
      total_count?: number | null;
      /**
       * Next Page
       * @deprecated
       */
      next_page?: number | null;
      /** Has Next Page */
      has_next_page: boolean;
    };
    /**
     * SetDictationCategoryToneRequest
     * @description Set the signed-in user's tone for a category (per-user overlay).
     */
    SetDictationCategoryToneRequest: {
      tone: components['schemas']['DictationTone'];
    };
    /** SetOnboardingCompleteRequest */
    SetOnboardingCompleteRequest: {
      patient?: components['schemas']['PatientDetailsRequest'] | null;
      /** Patientlanguage */
      patientLanguage?: string | null;
      /** Clinicianlanguage */
      clinicianLanguage?: string | null;
      /** Reasonforvisit */
      reasonForVisit?: string | null;
      outcome?: components['schemas']['OnboardingOutcome'] | null;
      /** Durationms */
      durationMs?: number | null;
    };
    /**
     * SetOrganizationSessionTimeoutRequest
     * @description Body for PATCH /organization/{organization_id}/session-timeout.
     *
     *     Bounds validation (1 ≤ minutes ≤ 720) is enforced server-side at the
     *     service layer via ``InvalidSessionTimeoutMinutesError`` so the error
     *     code and HTTP mapping stay consistent with the user-level write path
     *     (``PATCH /user/session-timeout``).
     */
    SetOrganizationSessionTimeoutRequest: {
      /** Minutes */
      minutes: number;
    };
    /**
     * SetPseudonymRequest
     * @description Request to set or regenerate a user's pseudonym.
     */
    SetPseudonymRequest: {
      /** Pseudonym */
      pseudonym?: string | null;
    };
    /**
     * SetPseudonymResponse
     * @description Response after setting a user's pseudonym.
     */
    SetPseudonymResponse: {
      /** Success */
      success: boolean;
      /** User Ref Id */
      user_ref_id: string;
      /** New Pseudonym */
      new_pseudonym: string;
      /** Message */
      message: string;
    };
    /** SetScheduleRequest */
    SetScheduleRequest: {
      spec: components['schemas']['ScheduleSpecModel'];
      /** Display Name */
      display_name?: string | null;
      /** Description */
      description?: string | null;
    };
    /**
     * SetSecretExpiryRequest
     * @description Request to record a connection's IdP client-secret expiry.
     *
     *     The caller supplies exactly one of an absolute date (``expires_at``) or a
     *     relative duration (``duration_months``, measured from ``anchored_at``).
     */
    SetSecretExpiryRequest: {
      /**
       * Expires At
       * @description Absolute expiry date (ISO 8601).
       */
      expires_at?: string | null;
      /**
       * Duration Months
       * @description Validity duration in months, measured from anchored_at.
       */
      duration_months?: number | null;
      /**
       * Anchored At
       * @description ISO 8601 date the duration is measured from (duration mode).
       */
      anchored_at?: string | null;
    };
    /**
     * SetSessionTimeoutRequest
     * @description Body for PATCH /user/session-timeout.
     *
     *     Bounds validation (1 ≤ minutes ≤ 720) is enforced server-side at the
     *     service layer via ``InvalidSessionTimeoutMinutesError`` so the error
     *     code and HTTP mapping stay consistent across user-level and org-level
     *     write paths.
     */
    SetSessionTimeoutRequest: {
      /** Minutes */
      minutes: number;
    };
    /** SetSuspensionRequest */
    SetSuspensionRequest: {
      /**
       * User Ref Id
       * @description Heidi user_ref_id
       */
      user_ref_id: string;
      /**
       * Suspend
       * @description True to suspend, False to restore
       */
      suspend: boolean;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /**
     * SettingsCollectionResponse
     * @description A bulk read's resolved settings and per-key resolution errors.
     */
    SettingsCollectionResponse: {
      /** Settings */
      settings: {
        [key: string]: components['schemas']['ResolvedSettingResponse'];
      };
      /** Errors */
      errors: {
        [key: string]: components['schemas']['ResolveErrorReason'];
      };
    };
    /**
     * SettingsWriteRequest
     * @description A three-state write body keyed by setting key (absent / value / null).
     */
    SettingsWriteRequest: {
      [key: string]: components['schemas']['JsonValue'];
    };
    /**
     * SetupHealthPathwaysRequest
     * @description Request to resolve and store a HealthPathways zone for the user.
     */
    SetupHealthPathwaysRequest: {
      /**
       * Country Code
       * @description ISO 3166-1 alpha-2 country code (e.g., 'au', 'nz', 'gb', 'ca')
       */
      country_code: string;
      /**
       * Postcode
       * @description User's postcode
       */
      postcode: string;
      /**
       * Zone Type
       * @description Healthcare setting: 'hospital' or 'community'
       */
      zone_type: string;
    };
    /**
     * SetupHealthPathwaysResponse
     * @description Response after successfully resolving a HealthPathways zone.
     */
    SetupHealthPathwaysResponse: {
      /** Success */
      success: boolean;
      /** Zone Id */
      zone_id: string;
      /** Country Code */
      country_code: string;
      /** Postcode */
      postcode: string;
      /** Zone Type */
      zone_type: string;
    };
    /**
     * SetupTicketDTO
     * @description Setup ticket info.
     */
    SetupTicketDTO: {
      /** Url */
      url: string;
      /** Expiry */
      expiry: string;
    };
    /** SgimedLaunchErrorResponse */
    SgimedLaunchErrorResponse: {
      /** Code */
      code: string;
      /** Message */
      message: string;
      /** Step Id */
      step_id?: string | null;
    };
    /**
     * SgimedLaunchResponse
     * @description Successful SGIMED context launch.
     */
    SgimedLaunchResponse: {
      /** Access Token */
      access_token?: string | null;
      /** Provider */
      provider: string;
      /** Session Id */
      session_id: string;
      /** Onboarding Session Id */
      onboarding_session_id: string;
    };
    /**
     * ShareChatResponse
     * @description Response model for sharing a chat.
     */
    ShareChatResponse: {
      /** Share Token */
      share_token: string;
      /** Share Url */
      share_url: string;
      /** Preview Question */
      preview_question: string;
      /** Preview Response */
      preview_response: string;
      /** Chat Title */
      chat_title: string;
    };
    /** ShareConsultNoteRequest */
    ShareConsultNoteRequest: {
      /** To Email */
      to_email?: string | null;
      /** Recipients */
      recipients?: string[] | null;
      /** Content */
      content?: string | null;
    };
    /** ShareConsultNotesResponse */
    ShareConsultNotesResponse: {
      /** Is Success */
      is_success: boolean;
      /** Sent Recipients */
      sent_recipients?: string[] | null;
      /** Failed Recipients */
      failed_recipients?: string[] | null;
    };
    /**
     * ShareDocumentEmailRequest
     * @description Request model for sharing a document via email.
     */
    ShareDocumentEmailRequest: {
      /**
       * To Email
       * Format: email
       */
      to_email: string;
    };
    /**
     * ShareDocumentEmailResponse
     * @description Response model for sharing a document via email.
     */
    ShareDocumentEmailResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /** ShareDocumentResponseV2 */
    ShareDocumentResponseV2: {
      /** Is Success */
      is_success: boolean;
      /** Sent Recipients */
      sent_recipients?: string[] | null;
      /** Failed Recipients */
      failed_recipients?: string[] | null;
    };
    /** ShareDocumentThroughEmailRequestV2 */
    ShareDocumentThroughEmailRequestV2: {
      /** To Email */
      to_email?: string | null;
      /** Recipients */
      recipients?: string[] | null;
      /** Content */
      content?: string | null;
    };
    /**
     * ShareLevel
     * @enum {string}
     */
    ShareLevel: ShareLevel;
    /**
     * SharePointOAuthCallbackResponse
     * @description Response returned after code exchange in callback endpoint.
     */
    SharePointOAuthCallbackResponse: {
      /** Setup Session Id */
      setup_session_id: string;
      /** Expires In */
      expires_in?: number | null;
      /** Scope */
      scope?: string | null;
      /** Tenant Hint */
      tenant_hint?: string | null;
      sync_config?: components['schemas']['SharePointSyncConfigResponse'] | null;
    };
    /**
     * SharePointOAuthStartResponse
     * @description Response containing Microsoft OAuth consent redirect URL.
     */
    SharePointOAuthStartResponse: {
      /** Redirect Url */
      redirect_url: string;
    };
    /** SharePointSiteContentItem */
    SharePointSiteContentItem: {
      /** Item Id */
      item_id: string;
      /** Name */
      name?: string | null;
      /** Web Url */
      web_url?: string | null;
      /** Size */
      size?: number | null;
      /**
       * Is Folder
       * @default false
       */
      is_folder: boolean;
    };
    /** SharePointSiteContentsResponse */
    SharePointSiteContentsResponse: {
      /** Items */
      items: components['schemas']['SharePointSiteContentItem'][];
    };
    /** SharePointSiteInfo */
    SharePointSiteInfo: {
      /** Site Id */
      site_id: string;
      /** Name */
      name?: string | null;
      /** Web Url */
      web_url?: string | null;
    };
    /** SharePointSitesResponse */
    SharePointSitesResponse: {
      /** Sites */
      sites: components['schemas']['SharePointSiteInfo'][];
    };
    /** SharePointSyncConfigResponse */
    SharePointSyncConfigResponse: {
      /** Connected Microsoft Email */
      connected_microsoft_email?: string | null;
      /** First Connected At */
      first_connected_at?: string | null;
      /** Source Link */
      source_link?: string | null;
      /** Sites */
      sites?: components['schemas']['SharePointSyncSiteConfig'][];
    };
    /** SharePointSyncConfigUpdateRequest */
    SharePointSyncConfigUpdateRequest: {
      /** Sites */
      sites?: components['schemas']['SharePointSyncSiteSelection'][];
    };
    /** SharePointSyncFolderConfig */
    SharePointSyncFolderConfig: {
      /** Folder Id */
      folder_id: string;
      /** Name */
      name?: string | null;
      /** Web Url */
      web_url?: string | null;
      /**
       * Is Enabled
       * @default true
       */
      is_enabled: boolean;
      /**
       * Document Count
       * @default 0
       */
      document_count: number;
      /** Last Synced At */
      last_synced_at?: string | null;
    };
    /** SharePointSyncFolderSelection */
    SharePointSyncFolderSelection: {
      /** Folder Id */
      folder_id: string;
      /**
       * Is Enabled
       * @default true
       */
      is_enabled: boolean;
    };
    /** SharePointSyncSiteConfig */
    SharePointSyncSiteConfig: {
      /** Site Id */
      site_id: string;
      /** Name */
      name?: string | null;
      /** Web Url */
      web_url?: string | null;
      /**
       * Is Enabled
       * @default true
       */
      is_enabled: boolean;
      /**
       * Document Count
       * @default 0
       */
      document_count: number;
      /** Last Synced At */
      last_synced_at?: string | null;
      /** Folders */
      folders?: components['schemas']['SharePointSyncFolderConfig'][];
    };
    /** SharePointSyncSiteSelection */
    SharePointSyncSiteSelection: {
      /** Site Id */
      site_id: string;
      /**
       * Is Enabled
       * @default true
       */
      is_enabled: boolean;
      /** Folders */
      folders?: components['schemas']['SharePointSyncFolderSelection'][];
    };
    /**
     * ShareTemplateEmailRequest
     * @description Request schema for sending a template sharing email.
     */
    ShareTemplateEmailRequest: {
      /**
       * To Emails
       * @description List of recipient email addresses (1-10 emails)
       */
      to_emails: string[];
      /**
       * Template Name
       * @description The name of the template being shared
       */
      template_name: string;
      /**
       * Template Url
       * @description The URL to access the shared template
       */
      template_url: string;
      /**
       * Personal Message
       * @description Optional personal message from the sender
       */
      personal_message?: string | null;
    };
    /**
     * ShareTemplateEmailResponse
     * @description Response schema for the template sharing email endpoint.
     */
    ShareTemplateEmailResponse: {
      /**
       * Success
       * @description Whether all emails were sent successfully (true if at least one succeeded)
       */
      success: boolean;
      /**
       * Message
       * @description A message describing the overall result
       */
      message: string;
      /**
       * Results
       * @description Individual results for each email address
       */
      results: components['schemas']['ShareTemplateEmailResult'][];
      /**
       * Successful Count
       * @description Number of emails sent successfully
       */
      successful_count: number;
      /**
       * Failed Count
       * @description Number of emails that failed to send
       */
      failed_count: number;
    };
    /**
     * ShareTemplateEmailResult
     * @description Result for a single email send attempt.
     */
    ShareTemplateEmailResult: {
      /**
       * Email
       * @description The recipient's email address
       */
      email: string;
      /**
       * Success
       * @description Whether the email was sent successfully
       */
      success: boolean;
      /**
       * Error
       * @description Error message if the send failed
       */
      error?: string | null;
    };
    /**
     * ShareWorkflowRequest
     * @description Share an owned workflow with teams / a workspace / the organization.
     */
    ShareWorkflowRequest: {
      /** Team Ids */
      team_ids?: string[];
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Organization
       * @default false
       */
      organization: boolean;
    };
    /**
     * SharedChatCopyMessage
     * @description A single message for cross-region shared chat copy creation.
     *
     *     Mirrors ChatMessageResponse but uses role: str to accept any role value
     *     from the origin region's response without validation failures.
     */
    SharedChatCopyMessage: {
      /** Role */
      role: string;
      /** Content */
      content: string;
      /** Message Id */
      message_id?: string | null;
      /** Timestamp */
      timestamp?: string | null;
      metadata?: components['schemas']['ChatMessageMetadataResponse'] | null;
      mode?: components['schemas']['ChatMode'] | null;
      original_mode?: components['schemas']['ChatMode'] | null;
      /** Attachments */
      attachments?: components['schemas']['ChatMessageAttachmentResponse'][] | null;
    };
    /**
     * SharedChatCopyRequest
     * @description Request body for creating a cross-region copy of a shared chat.
     *
     *     Used when the viewer's local region doesn't have the shared chat record
     *     (i.e. the sharer is in a different region). The frontend fetches the chat
     *     data from the origin region and sends it here to create a local copy.
     */
    SharedChatCopyRequest: {
      /** Title */
      title: string;
      mode: components['schemas']['ChatMode'];
      /** Messages */
      messages: components['schemas']['SharedChatCopyMessage'][];
    };
    /**
     * SharedChatResponse
     * @description Response model for fetching a shared chat (creates a copy for recipient).
     *
     *     The recipient gets a copy of the original chat that they can continue independently.
     *     When create_copy=False, copied_chat_id is None (no copy created in this region).
     */
    SharedChatResponse: {
      /** Copied Chat Id */
      copied_chat_id?: string | null;
      /** Title */
      title: string;
      /**
       * Messages
       * @default []
       */
      messages: components['schemas']['ChatMessageResponse'][];
      mode: components['schemas']['ChatMode'];
      /** Created At */
      created_at: string;
      /** Temp User Id */
      temp_user_id?: string | null;
    };
    /**
     * SharedMember
     * @description A user who has direct sharing access to a session.
     */
    SharedMember: {
      /**
       * User Ref Id
       * @description User reference ID
       */
      user_ref_id: string;
      /**
       * Email
       * @description User email
       */
      email?: string | null;
      /**
       * First Name
       * @description User first name
       */
      first_name?: string | null;
      /**
       * Last Name
       * @description User last name
       */
      last_name?: string | null;
      /** @description Permission level */
      level: components['schemas']['ShareLevel'];
    };
    /**
     * SharedSessionScope
     * @enum {string}
     */
    SharedSessionScope: SharedSessionScope;
    /**
     * SideBySideConsultNoteConfirmRequest
     * @description Request for confirming a selected consult note as the final note for the session.
     *
     *     Backward compatible: Only consult_note_id is required. All other fields are optional.
     */
    SideBySideConsultNoteConfirmRequest: {
      /**
       * Consult Note Id
       * @description ID of the selected consult note
       * @example 5eb7cf5a86d9755df3a6c593
       */
      consult_note_id: string;
      /**
       * Displayed At
       * @description The starting time of showing notes to users
       */
      displayed_at?: string | null;
      /**
       * Selected At
       * @description Timestamp when the selection was made
       */
      selected_at?: string | null;
    };
    /**
     * SideBySideConsultNoteConfirmResponse
     * @description Response schema for note selection confirmation.
     */
    SideBySideConsultNoteConfirmResponse: {
      /**
       * Promote Free Trial
       * @description Whether to trigger the promoted free trial workflow
       * @default false
       */
      promote_free_trial: boolean;
      /**
       * Available Promoted Free Trial Days
       * @description Number of days available for promoted free trial
       * @default 0
       */
      available_promoted_free_trial_days: number;
      /**
       * Promoted Free Trial Token
       * @description Token to activate the promoted free trial
       */
      promoted_free_trial_token?: string | null;
      /**
       * Used Experimental Transcript
       * @description Whether the experimental transcript was used for the selected note. Frontend may need to fetch transcript from external transcription service directly.
       */
      used_experimental_transcript?: boolean | null;
    };
    /**
     * SideBySideConsultNoteGenerationRequest
     * @description Request for side by side consult note generation. One consult note will be generated and streamed back to the client at one time.
     */
    SideBySideConsultNoteGenerationRequest: {
      /**
       * Ignore Backup
       * @default false
       */
      ignore_backup: boolean;
      /**
       * Consult Note Id
       * @description ID of the consult note to generate
       * @example 5eb7cf5a86d9755df3a6c593
       */
      consult_note_id: string;
      /**
       * Demo Mode
       * @description Analytics tag for demo notes (e.g. 'shortened'); None for normal generations
       */
      demo_mode?: string | null;
      /** Client Capabilities */
      client_capabilities?: string[];
    };
    /**
     * SideBySideConsultNoteSetupRequest
     * @description Request for side by side consult note pre-check, inheriting from GenerateConsultNoteRequest.
     *     To trigger side by side consult note generation, platform and window_width have to be passed in, otherwise will just fallback to normal generation.
     */
    SideBySideConsultNoteSetupRequest: {
      generation_method: components['schemas']['GenerationMethod'];
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      /**
       * Addition
       * @default
       */
      addition: string;
      voice_style: components['schemas']['VoiceStyle'];
      /** @default LEFT */
      brain: components['schemas']['Brain'];
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      content_type?: components['schemas']['ContentType'] | null;
      platform?: components['schemas']['HeidiPlatforms'] | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
      generation_mode?: components['schemas']['GenerationMode'] | null;
      /**
       * Ignore Backup
       * @default false
       */
      ignore_backup: boolean;
      /** Demo Mode */
      demo_mode?: string | null;
      /** Client Capabilities */
      client_capabilities?: string[];
      /**
       * Window Width
       * @description Width of the window for UI rendering
       */
      window_width?: number | null;
    };
    /**
     * SideBySideConsultNoteSetupResponse
     * @description Response for side by side consult note pre-check.
     */
    SideBySideConsultNoteSetupResponse: {
      /**
       * Consult Note List
       * @description List of consult notes to be generated
       */
      consult_note_list: components['schemas']['SideBySideConsultNoteSimpleView'][];
      /**
       * Generation Mode
       * @description Generation mode: free2paid, model_comparison, etc.
       * @default normal
       */
      generation_mode: string;
    };
    /**
     * SideBySideConsultNoteSimpleView
     * @description Data class for side by side consult note view.
     */
    SideBySideConsultNoteSimpleView: {
      /**
       * Consult Note Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      consult_note_id: string;
      /** Is Default Consult Note */
      is_default_consult_note: boolean;
    };
    /**
     * SidePanelState
     * @enum {string}
     */
    SidePanelState: SidePanelState;
    /**
     * SignLetterRequest
     * @description Request object for applying a signature to a letter.
     */
    SignLetterRequest: {
      /** @description Signature variant to apply. Currently only electronically_signed is supported. */
      signature_type: components['schemas']['LetterSignatureType'];
    };
    /** SignalWorkflowRequest */
    SignalWorkflowRequest: {
      /** Signal Name */
      signal_name: string;
      /**
       * Args
       * @default []
       */
      args: unknown[];
    };
    /**
     * SignupSource
     * @enum {string}
     */
    SignupSource: SignupSource;
    /** SimpleConsultNoteView */
    SimpleConsultNoteView: {
      /** @default CREATED */
      status: components['schemas']['ConsultNoteStatus'];
      /** Result */
      result?: string | null;
      /**
       * Heading
       * @default Note
       */
      heading: string;
      /** @default LEFT */
      brain: components['schemas']['Brain'];
      voice_style?: components['schemas']['VoiceStyle'] | null;
      generation_method: components['schemas']['GenerationMethod'];
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      feedback?: components['schemas']['Feedback'] | null;
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      content_type?: components['schemas']['ContentType'] | null;
      /**
       * Should Retry
       * @default false
       */
      should_retry: boolean;
      failure_reason?: components['schemas']['UserFriendlyNoteFailedReason'] | null;
      /** Generation Time */
      generation_time?: string | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
      /** Is Personalization Applied */
      is_personalization_applied?: boolean | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Used Experimental Transcript */
      used_experimental_transcript?: boolean | null;
      /** Section Mappings */
      section_mappings?: components['schemas']['SectionLink'][];
    };
    /**
     * SimpleSessionRecord
     * @description Session record returned by internal admin endpoints. Contains PHI.
     */
    SimpleSessionRecord: {
      /** Session Id */
      session_id: string;
      /**
       * Consult Note
       * @description Raw clinical consultation note text — direct PHI under HIPAA.
       */
      consult_note?: string | null;
      transcribe_mode?: components['schemas']['TranscribeMode'] | null;
    };
    /** SimpleSessionViewV2 */
    SimpleSessionViewV2: {
      /** Session Id */
      session_id: string;
      /** Kinde Gp Id */
      kinde_gp_id: string;
      /** Session Name */
      session_name?: string | null;
      /** Session Gist */
      session_gist?: string | null;
      patient: components['schemas']['PatientModel'];
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Ehr Appt Contact Id */
      ehr_appt_contact_id?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Encounter Id */
      ehr_encounter_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** @default CREATED */
      status: components['schemas']['BaseStatus'];
      /** @default EMPTY */
      session_status: components['schemas']['SessionStatus'] | null;
      /**
       * Is Urgent
       * @default false
       */
      is_urgent: boolean;
      /** Duration */
      duration: number;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /**
       * Is Consent
       * @default false
       */
      is_consent: boolean | null;
      patient_profile?: components['schemas']['PatientProfileModel'] | null;
      /** Created Time Local */
      created_time_local?: string | null;
      /** Created Time Local With Offset */
      created_time_local_with_offset?: string | null;
      /** Display Time */
      display_time?: string | null;
      patient_profile_appointment_candidates?:
        | components['schemas']['PatientProfileAppointmentCandidates']
        | null;
      /** Creation Platform */
      creation_platform?:
        | (
            | components['schemas']['WebApp']
            | components['schemas']['DesktopApp']
            | components['schemas']['IOSApp']
            | components['schemas']['AndroidApp']
            | components['schemas']['RemoteApp']
          )
        | null;
      patient_link_status?: components['schemas']['PatientLinkStatus'] | null;
      /** @default no_action */
      session_group_status: components['schemas']['SessionGroupStatus'];
      session_merge_group?: components['schemas']['MergeableSessions'];
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /** SimpleSessionViewWithFeedback */
    SimpleSessionViewWithFeedback: {
      /** Session Id */
      session_id: string;
      /** Kinde Gp Id */
      kinde_gp_id: string;
      /** Session Name */
      session_name?: string | null;
      /** Session Gist */
      session_gist?: string | null;
      patient: components['schemas']['PatientModel'];
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Ehr Appt Contact Id */
      ehr_appt_contact_id?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Encounter Id */
      ehr_encounter_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** @default CREATED */
      status: components['schemas']['BaseStatus'];
      /** @default EMPTY */
      session_status: components['schemas']['SessionStatus'] | null;
      /**
       * Is Urgent
       * @default false
       */
      is_urgent: boolean;
      /** Duration */
      duration: number;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /**
       * Is Consent
       * @default false
       */
      is_consent: boolean | null;
      patient_profile?: components['schemas']['PatientProfileModel'] | null;
      /** Created Time Local */
      created_time_local?: string | null;
      /** Created Time Local With Offset */
      created_time_local_with_offset?: string | null;
      /** Display Time */
      display_time?: string | null;
      patient_profile_appointment_candidates?:
        | components['schemas']['PatientProfileAppointmentCandidates']
        | null;
      /** Creation Platform */
      creation_platform?:
        | (
            | components['schemas']['WebApp']
            | components['schemas']['DesktopApp']
            | components['schemas']['IOSApp']
            | components['schemas']['AndroidApp']
            | components['schemas']['RemoteApp']
          )
        | null;
      patient_link_status?: components['schemas']['PatientLinkStatus'] | null;
      /** @default no_action */
      session_group_status: components['schemas']['SessionGroupStatus'];
      session_merge_group?: components['schemas']['MergeableSessions'];
      /** Workspace Id */
      workspace_id?: string | null;
      /** Feedbacks */
      feedbacks: components['schemas']['Feedback'][];
    };
    /**
     * SimpleSessionViewWithoutPII
     * @description A version of SimpleSessionViewV2 that excludes PII/PHI data.
     *     This type explicitly includes only non-sensitive fields to ensure
     *     that any new PII fields added to SimpleSessionViewV2 are not
     *     accidentally exposed.
     *
     *     PII fields are included but with empty/null values for frontend compatibility:
     *     - session_name: None (may contain patient name/info)
     *     - session_gist: None (may contain patient context)
     *     - patient: Empty PatientModel (all fields None) - included for frontend compatibility
     *     - patient_profile: None (PatientProfileModel with first_name, last_name, phone, email, etc.)
     *
     *     Note: The patient field is included as an empty object (all fields None) to prevent
     *     frontend crashes when accessing session.patient.name, while still ensuring no PII
     *     data is exposed.
     */
    SimpleSessionViewWithoutPII: {
      /** Session Id */
      session_id: string;
      /** Kinde Gp Id */
      kinde_gp_id: string;
      /** Session Name */
      session_name?: string | null;
      /** Session Gist */
      session_gist?: string | null;
      patient: components['schemas']['PatientModel'];
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Ehr Appt Contact Id */
      ehr_appt_contact_id?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Encounter Id */
      ehr_encounter_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** @default CREATED */
      status: components['schemas']['BaseStatus'];
      /** @default EMPTY */
      session_status: components['schemas']['SessionStatus'] | null;
      /**
       * Is Urgent
       * @default false
       */
      is_urgent: boolean;
      /** Duration */
      duration: number;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /**
       * Is Consent
       * @default false
       */
      is_consent: boolean | null;
      patient_profile?: components['schemas']['PatientProfileModel'] | null;
      /** Created Time Local */
      created_time_local?: string | null;
      /** Created Time Local With Offset */
      created_time_local_with_offset?: string | null;
      /** Display Time */
      display_time?: string | null;
      /** Creation Platform */
      creation_platform?:
        | (
            | components['schemas']['WebApp']
            | components['schemas']['DesktopApp']
            | components['schemas']['IOSApp']
            | components['schemas']['AndroidApp']
            | components['schemas']['RemoteApp']
          )
        | null;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /** SimpleTeam */
    SimpleTeam: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Country */
      country: string;
      /** Owner Kinde Id */
      owner_kinde_id?: string | null;
      /** Kinde Org Code */
      kinde_org_code?: string | null;
      mfa_info?: components['schemas']['TeamMFAInfo'] | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Custom Consent Text */
      custom_consent_text?: string | null;
      /** Hide Remember Consent Checkbox */
      hide_remember_consent_checkbox?: boolean | null;
      /** Require Review Confirmation */
      require_review_confirmation?: boolean | null;
      /**
       * Enable Patient Summary Generation
       * @default true
       */
      enable_patient_summary_generation: boolean;
      /**
       * Disable Auto Extract
       * @default false
       */
      disable_auto_extract: boolean;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      /** Onboarding Free Text */
      onboarding_free_text?: string | null;
      /** Go Live Time Stamp */
      go_live_time_stamp?: string | null;
      /** Parent Id */
      parent_id?: string | null;
      /** Org Id */
      org_id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Org Override Fields */
      org_override_fields?:
        | components['schemas']['OrganizationOverrideTeamSettingField'][]
        | null;
      /**
       * Is Stripe Managed
       * @default true
       */
      is_stripe_managed: boolean;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[];
      /**
       * Enable Export Header
       * @default false
       */
      enable_export_header: boolean;
      export_header_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /**
       * Enable Export Footer
       * @default false
       */
      enable_export_footer: boolean;
      export_footer_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /** @default FREE */
      evidence_tier: components['schemas']['EvidenceSubscriptionTier'];
      /**
       * Evidence Is Stripe Managed
       * @default false
       */
      evidence_is_stripe_managed: boolean;
      /** Evidence Plan End Date */
      evidence_plan_end_date?: string | null;
      /**
       * Evidence Access
       * @default false
       */
      evidence_access: boolean;
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
    };
    /** SimpleTeamResponse */
    SimpleTeamResponse: {
      team: components['schemas']['SimpleTeam'];
    };
    /** SimpleTeamView */
    SimpleTeamView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Country */
      country: string;
      mfa_info?: components['schemas']['TeamMFAInfo'] | null;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Hide Remember Consent Checkbox */
      hide_remember_consent_checkbox?: boolean | null;
      /** Require Review Confirmation */
      require_review_confirmation?: boolean | null;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      /** Onboarding Free Text */
      onboarding_free_text?: string | null;
      /** Go Live Time Stamp */
      go_live_time_stamp?: string | null;
      /** Parent Id */
      parent_id?: string | null;
      /** Org Id */
      org_id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[];
    };
    /** SingleSnippetResponse */
    SingleSnippetResponse: {
      snippet: components['schemas']['SnippetView'];
    };
    /** SlideResponse */
    SlideResponse: {
      /** Id */
      id: string;
      /** Index */
      index: number;
      /** Title */
      title: string;
      /** Image Url */
      image_url?: string | null;
      /** Notes */
      notes?: string | null;
      /** Source */
      source?: string | null;
      /** Extracted Text */
      extracted_text?: string | null;
      /** Shape Map */
      shape_map?: unknown[] | null;
    };
    /**
     * Slot
     * @description A slot of time on a schedule that may be available for booking appointments.
     *
     *     https://hl7.org/fhir/R4/slot-definitions.html
     */
    Slot: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * External Ids for this item
       * @description External Ids for this item.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * A broad categorization of the service that is to be performed during this appointment
       * @description A broad categorization of the service that is to be performed during this appointment.
       */
      serviceCategory?: components['schemas']['CodeableConcept'][] | null;
      /**
       * The type of appointments that can be booked into this slot
       * @description The type of appointments that can be booked into this slot (ideally this would be an identifiable service - which is at a location, rather than the location itself). If provided then this overrides the value provided on the availability resource.
       */
      serviceType?: components['schemas']['CodeableConcept'][] | null;
      /**
       * The specialty of a practitioner that would be required to perform the service requested in this appointment
       * @description The specialty of a practitioner that would be required to perform the service requested in this appointment.
       */
      specialty?: components['schemas']['CodeableConcept'][] | null;
      /**
       * The style of appointment or patient that may be booked in the slot
       * @description The style of appointment or patient that may be booked in the slot (not service type).
       */
      appointmentType?: components['schemas']['CodeableConcept'] | null;
      /**
       * The schedule resource that this slot defines an interval of status information
       * @description The schedule resource that this slot defines an interval of status information.
       */
      schedule: components['schemas']['Reference'];
      /**
       * busy | free | busy-unavailable | busy-tentative | entered-in-error
       * @description busy | free | busy-unavailable | busy-tentative | entered-in-error.
       */
      status: components['schemas']['SlotStatus'];
      /**
       * Date/Time that the slot is to begin
       * @description Date/Time that the slot is to begin.
       */
      start: string;
      /**
       * Date/Time that the slot is to conclude
       * @description Date/Time that the slot is to conclude.
       */
      end: string;
      /**
       * This slot has already been overbooked
       * @description This slot has already been overbooked, appointments are unlikely to be accepted for this time.
       */
      overbooked?: boolean | null;
      /**
       * Comments on the slot to describe any extended information
       * @description Comments on the slot to describe any extended information. Such as custom constraints on the slot.
       */
      comment?: string | null;
    };
    /**
     * SlotStatus
     * @description Values and descriptions are sourced from
     *     https://hl7.org/fhir/R4/codesystem-slotstatus.html
     * @enum {string}
     */
    SlotStatus: SlotStatus;
    /** SnippetUploadResult */
    SnippetUploadResult: {
      /** Valid Rows */
      valid_rows?: components['schemas']['FileUploadRow'][];
      /** Error Rows */
      error_rows?: components['schemas']['FileUploadRow'][];
    };
    /** SnippetView */
    SnippetView: {
      /** Id */
      id: string;
      /** Shorthand */
      shorthand: string;
      /** Content */
      content: string;
      /** Trigger Phrase */
      trigger_phrase?: string | null;
      /**
       * Is Verbal Trigger
       * @default false
       */
      is_verbal_trigger: boolean | null;
      /**
       * Is Default
       * @default false
       */
      is_default: boolean;
      /**
       * Description
       * @default
       */
      description: string;
    };
    /** SnippetsResponse */
    SnippetsResponse: {
      /** Snippets */
      snippets: components['schemas']['SnippetView'][];
    };
    /**
     * SnoozeEvidenceFeedbackResponse
     * @description Response schema for snoozing evidence experience feedback.
     */
    SnoozeEvidenceFeedbackResponse: {
      /**
       * Success
       * @description Whether the snooze was recorded successfully
       */
      success: boolean;
      /**
       * Snooze Count
       * @description Updated snooze count (1-3, after 3 the nudge is permanently dismissed)
       */
      snooze_count: number;
    };
    /**
     * SnoozeUsabilityFeedbackResponse
     * @description Response schema for snoozing usability feedback.
     */
    SnoozeUsabilityFeedbackResponse: {
      /**
       * Success
       * @description Whether the snooze was recorded successfully
       */
      success: boolean;
      /**
       * Snooze Count
       * @description Updated snooze count for this user + feature
       */
      snooze_count: number;
    };
    /** SourceArtifactModel */
    SourceArtifactModel: {
      /**
       * Kind
       * @enum {string}
       */
      kind: SourceArtifactModelKind;
      /** Uri */
      uri: string;
      /** Sha256 */
      sha256: string;
      /** Page Refs */
      page_refs?: string[];
    };
    /** SourceAvailability */
    SourceAvailability: {
      /** Count */
      count: number;
      /** Transcribed Count */
      transcribed_count: number;
    };
    /**
     * SourceCatalogResponse
     * @description Response for browsing evidence source catalog entries.
     *
     *     Unlike source recommendations, catalog browsing treats country as a filter
     *     and returns the total match count before the response limit is applied.
     */
    SourceCatalogResponse: {
      /**
       * Sources
       * @description Catalog sources matching the requested filters
       */
      sources: components['schemas']['RecommendedSource'][];
      /**
       * Total Matched
       * @description Number of sources matching the filters before limiting
       */
      total_matched: number;
      /**
       * Applied Country
       * @description Country filter applied to the catalog
       */
      applied_country?: string | null;
      /**
       * Applied Specialty Id
       * @description Specialty ID filter applied to the catalog
       */
      applied_specialty_id?: string | null;
    };
    /**
     * SourceItem
     * @description Model for a single source item.
     *
     *     ``regions`` and ``website_type`` are typed as ``list[str]`` rather than
     *     enums because the upstream pipeline ships values that intentionally
     *     out-pace any static enum (e.g., region codes like ``"World#001"``,
     *     historically-recent additions like ``"Türkiye"``, ``"Southern Europe"``,
     *     or new website types like ``"Clinical Decision Support Tool"``). The
     *     ``SourceWebsiteType`` enum below is kept as typed constants for
     *     downstream code that wants to refer to canonical values, but data
     *     ingest no longer enforces enum membership.
     *
     *     ``regions`` retains the upstream ``name#code`` tags (e.g.
     *     ``"Australia#036"``, ``"World#001"``, ``"California#US-CA"``) for
     *     code-based matching in ``source_region_matching``.
     */
    SourceItem: {
      /** Domain */
      domain: string;
      /**
       * Regions
       * @default []
       */
      regions: string[];
      /**
       * Website Type
       * @default []
       */
      website_type: string[];
      /**
       * Specialty
       * @default []
       */
      specialty: string[];
      /**
       * Website Name
       * @default
       */
      website_name: string | string[];
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Display Name
       * @default
       */
      display_name: string;
      /** Trusted */
      trusted?: boolean | null;
      /** Authoritativeness Score */
      authoritativeness_score?: number | null;
      /** Impact Factor */
      impact_factor?: number | null;
      /**
       * Specialist Ids
       * @default []
       */
      specialist_ids: {
        [key: string]: unknown;
      }[];
      /**
       * Is Anchor
       * @default false
       */
      is_anchor: boolean;
      /**
       * Primary Domains
       * @default []
       */
      primary_domains: string[];
      /**
       * Secondary Domains
       * @default []
       */
      secondary_domains: string[];
    };
    /**
     * SourceListResponse
     * @description Response model for a source list.
     */
    SourceListResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Domains */
      domains: string[];
      /** User Id */
      user_id: string;
      /** Team Id */
      team_id?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * SourceRecommendationsResponse
     * @description Response for GET /evidence/source-recommendations.
     *
     *     Ordering: anchors first (by ``authoritativeness_score`` desc), then
     *     specialty matches whose regions include the user's country (by
     *     ``authoritativeness_score`` desc), then specialty matches that do not
     *     cover the user's country (by ``authoritativeness_score`` desc).
     */
    SourceRecommendationsResponse: {
      /**
       * Sources
       * @description Recommended sources for the user
       */
      sources: components['schemas']['RecommendedSource'][];
      /**
       * Matched Country
       * @description Country used for matching
       */
      matched_country: string;
      /**
       * Matched Specialty Id
       * @description Specialty ID used for matching
       */
      matched_specialty_id?: string | null;
    };
    /**
     * SourceRefSchema
     * @description Schema for a library-grounding source reference (FDE-8).
     *
     *     ``page_number`` is optional because today's ``LLMDocExtractor`` pipeline
     *     flattens PDFs to a single blob, so chunk→page mapping is not populated.
     *     The FE treats ``None`` as "open the inline preview at page 1" and the
     *     clinician Ctrl-Fs the excerpt. When page-aware chunking lands (deferred
     *     Phase 2) this field will be populated and the FE deep-links to the page.
     */
    SourceRefSchema: {
      /**
       * Id
       * @description Stable id referenced by chip.source_ref_ids
       */
      id: string;
      /**
       * Document Id
       * @description UserDocument id backing this source
       */
      document_id: string;
      /**
       * Filename
       * @description Original filename of the source document
       */
      filename: string;
      /**
       * Excerpt
       * @description Matched chunk text shown in the preview drawer
       */
      excerpt: string;
      /**
       * Chunk Index
       * @description Ordinal chunk index inside the document
       */
      chunk_index: number;
      /**
       * Score
       * @description Vector similarity score of this chunk for the query
       */
      score?: number | null;
      /**
       * Page Number
       * @description Optional 1-indexed PDF page for deep-linking. Null in Phase 1 (page-aware chunking is a deferred Phase 2 follow-up).
       */
      page_number?: number | null;
    };
    /**
     * SourceView
     * @description User-facing view of a source.
     */
    SourceView: {
      source: components['schemas']['domains__access_entitlements__schemas__SourceType'];
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /**
     * Speaker
     * @enum {string}
     */
    Speaker: Speaker;
    /** SpecialNoteModel */
    SpecialNoteModel: {
      /**
       * Kind
       * @enum {string}
       */
      kind: SpecialNoteModelKind;
      /** Text */
      text: string;
      /**
       * Position
       * @enum {string}
       */
      position: SpecialNoteModelPosition;
    };
    /** SpecialNoteView */
    SpecialNoteView: {
      /** Kind */
      kind: string;
      /** Text */
      text: string;
      /** Position */
      position: string;
    };
    /**
     * SpecialtiesGroupedByGroupResponse
     * @description Response containing specialties organized by their specialty groups.
     *
     *     Note: A specialty can appear in multiple groups if it belongs to multiple groups.
     *     Ungrouped specialties appear in a group with group=null.
     */
    SpecialtiesGroupedByGroupResponse: {
      /** Groups */
      groups: components['schemas']['SpecialtyGroupWithSpecialties'][];
      /** Total Groups */
      total_groups: number;
      /** Total Specialties */
      total_specialties: number;
    };
    /** Specialty */
    Specialty: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Name */
      name: string;
      /**
       * Is Live
       * @default false
       */
      is_live: boolean;
      /** Default Note Structure Id */
      default_note_structure_id?: string | null;
      /** Onboarding Script Prompt Id */
      onboarding_script_prompt_id?: string | null;
      /**
       * Preset Templates
       * @default []
       */
      preset_templates: string[];
      /** Generate Template With Ai Prompt Id */
      generate_template_with_ai_prompt_id?: string | null;
      /** Specialty Group Id */
      specialty_group_id?: string | null;
      /** Specialty Groups */
      specialty_groups?: string[];
      /** Country Codes */
      country_codes?: components['schemas']['CountryCode'][];
      /** Translations */
      translations?: {
        [
          key: string
        ]: components['schemas']['domains__specialty__models__specialty__SpecialtyTranslation'];
      };
    };
    /** SpecialtyBatchUpdateData */
    SpecialtyBatchUpdateData: {
      /**
       * Is Live
       * @default false
       */
      is_live: boolean;
      /** Default Note Structure Id */
      default_note_structure_id?: string | null;
      /** Onboarding Script Prompt Id */
      onboarding_script_prompt_id?: string | null;
      /** Generate Template With Ai Prompt Id */
      generate_template_with_ai_prompt_id?: string | null;
      /**
       * Add Preset Templates
       * @description preset template ids to add, will skip if already exist
       */
      add_preset_templates?: string[];
      /** Group Id */
      group_id?: string | null;
      /**
       * Group Ids
       * @description List of specialty group IDs. Takes precedence over group_id when provided.
       */
      group_ids?: string[] | null;
    };
    /** SpecialtyBatchUpdateRequest */
    SpecialtyBatchUpdateRequest: {
      /** Specialty Ids */
      specialty_ids?: string[];
      data: components['schemas']['SpecialtyBatchUpdateData'];
    };
    /** SpecialtyCreateRequest */
    SpecialtyCreateRequest: {
      /** Name */
      name: string;
      /** Group Id */
      group_id?: string | null;
      /** Country Codes */
      country_codes?: components['schemas']['CountryCode'][];
    };
    /** SpecialtyGroupCreateRequest */
    SpecialtyGroupCreateRequest: {
      /** Name */
      name: string;
    };
    /** SpecialtyGroupInfo */
    SpecialtyGroupInfo: {
      /** Id */
      id: string;
      /** Name */
      name: string;
    };
    /** SpecialtyGroupResponse */
    SpecialtyGroupResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Specialties */
      specialties: string[];
      /** Created At */
      created_at: string;
      /** Updated At */
      updated_at: string;
    };
    /** SpecialtyGroupUpdateRequest */
    SpecialtyGroupUpdateRequest: {
      /** Name */
      name: string;
    };
    /**
     * SpecialtyGroupWithSpecialties
     * @description A specialty group with its associated specialties.
     */
    SpecialtyGroupWithSpecialties: {
      group?: components['schemas']['SpecialtyGroupInfo'] | null;
      /** Specialties */
      specialties: components['schemas']['AdminSimpleSpecialtyResponse'][];
    };
    /** SpecialtyGroupsResponse */
    SpecialtyGroupsResponse: {
      /** Groups */
      groups: components['schemas']['SpecialtyGroupResponse'][];
      /** Total */
      total: number;
    };
    /** SpecialtyResponse */
    SpecialtyResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Is Live */
      is_live: boolean;
      /** Name */
      name: string;
      /** Default Note Structure Id */
      default_note_structure_id?: string | null;
      /** Onboarding Script Prompt Id */
      onboarding_script_prompt_id?: string | null;
      /** Preset Templates */
      preset_templates: string[];
      /** Generate Template With Ai Prompt Id */
      generate_template_with_ai_prompt_id?: string | null;
      /** Groups */
      groups?: components['schemas']['SpecialtyGroupInfo'][];
      /** Country Codes */
      country_codes?: components['schemas']['CountryCode'][];
    };
    /** SpecialtyTranscriptResponse */
    SpecialtyTranscriptResponse: {
      /** Transcript */
      transcript: string;
      /** Caption */
      caption: string;
    };
    /** SpecialtyUpdateRequest */
    SpecialtyUpdateRequest: {
      /** Name */
      name?: string | null;
      /**
       * Is Live
       * @default false
       */
      is_live: boolean;
      /** Default Note Structure Id */
      default_note_structure_id?: string | null;
      /** Onboarding Script Prompt Id */
      onboarding_script_prompt_id?: string | null;
      /**
       * Preset Templates
       * @default []
       */
      preset_templates: string[];
      /** Generate Template With Ai Prompt Id */
      generate_template_with_ai_prompt_id?: string | null;
      /** Group Id */
      group_id?: string | null;
      /** Group Ids */
      group_ids?: string[] | null;
      /** Country Codes */
      country_codes?: components['schemas']['CountryCode'][] | null;
    };
    /**
     * SpellingPreference
     * @enum {string}
     */
    SpellingPreference: SpellingPreference;
    /** StandAloneLaunchAuthorizeEndpointResponse */
    StandAloneLaunchAuthorizeEndpointResponse: {
      /** Authorize Endpoint */
      authorize_endpoint: string;
    };
    /** StandAloneLaunchExchangeAccessTokenRequest */
    StandAloneLaunchExchangeAccessTokenRequest: {
      /** Auth Code */
      auth_code: string;
      /** State */
      state: string;
    };
    /** StandAloneLaunchExchangeAccessTokenResponse */
    StandAloneLaunchExchangeAccessTokenResponse: {
      /** Access Token */
      access_token: string;
      /** Token Type */
      token_type: string;
      /** Expires In */
      expires_in: number;
      /** Scope */
      scope: string;
      /** Refresh Token */
      refresh_token: string;
      /** Id Token */
      id_token: string;
    };
    /**
     * StandardCernerSection
     * @description Standard component section using predefined Cerner codes.
     *
     *     According to Cerner API documentation: https://app.swaggerhub.com/apis-docs/RedRover/RedRoverAPIs/2.0#/documents/post-component-documentation
     *     The following standard component concepts are supported with text visible only to the specified author:
     *         * AP: Assessment and Plan
     *         * HPI: History of Present Illness
     *         * PE: Physical Examination
     *         * ROS: Review of Systems
     *     The following standard component concepts are supported with text visible to all users viewing the encounter:
     *         * CC: Chief Complaint
     *         * HC: Hospital Course
     *         * PI: Patient Instructions
     */
    StandardCernerSection: {
      /** @default standard */
      section_type: components['schemas']['CernerSectionType'];
      section: components['schemas']['SectionalNoteSection'];
      /** Display Name */
      display_name: string;
      /** Observation Type Code */
      observation_type_code?: string | null;
      /**
       * Codes
       * @default []
       */
      codes: components['schemas']['CernerObservationCode'][];
      /** Component Code */
      component_code: string;
    };
    /**
     * StandardizedSectionalNote
     * @description Model for standardized sectional notes using SectionalNoteSection enum values as keys
     */
    StandardizedSectionalNote: {
      /**
       * Content
       * @description The actual content of the section
       */
      content: string;
      /** @description The section ID of the section */
      linked_ehr_section_id: components['schemas']['SectionalNoteSection'];
    };
    /**
     * StartAgentMakerRunRequest
     * @description Start the first-class IA Agent Maker.
     *
     *     The saved config id is server-owned. The run is internal-admin scoped:
     *     the authenticated IA uid is both the run owner and the tool execution
     *     identity for this surface.
     */
    StartAgentMakerRunRequest: {
      /** Agent Run Id */
      agent_run_id?: string | null;
      initial_turn?:
        | components['schemas']['apis__v2__internal_admin__agent_harness__SubmitTurnRequest']
        | null;
      /**
       * Close After Initial Turn
       * @default false
       */
      close_after_initial_turn: boolean;
    };
    /**
     * StartAutoVerificationResponse
     * @description Response schema for POST /{session_id}/entity-verification/auto-start.
     *
     *     Returned immediately after the auto pipeline is scheduled; the caller is
     *     expected to poll GET /{session_id}/entity-verification/ for progress
     *     until ``status`` becomes terminal (`completed` or `failed`).
     */
    StartAutoVerificationResponse: {
      /** Analysis Id */
      analysis_id: string;
      /** Session Id */
      session_id: string;
      status: components['schemas']['AnalysisStatus'];
      /** @default auto */
      source: components['schemas']['AnalysisSource'];
    };
    /** StartRunResponse */
    StartRunResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Workflow Id */
      workflow_id: string;
      /** Temporal Workflow Url */
      temporal_workflow_url?: string | null;
      initial_turn?:
        | components['schemas']['apis__v2__internal_admin__agent_harness__SubmitTurnResponse']
        | null;
    };
    /** StartWorkflowRequest */
    StartWorkflowRequest: {
      /** Workflow Type */
      workflow_type: string;
      /** Workflow Id */
      workflow_id: string;
      /**
       * Input
       * @description Single positional workflow argument, as a JSON object.
       */
      input: {
        [key: string]: unknown;
      };
    };
    /** StartWorkflowResponse */
    StartWorkflowResponse: {
      /** Workflow Id */
      workflow_id: string;
      /** Run Id */
      run_id: string | null;
      /** Task Queue */
      task_queue: string;
      /** Namespace */
      namespace: string;
    };
    /**
     * StartWorkspaceRealignResponse
     * @description Result of starting a workspace re-tag (merge or region migration).
     *
     *     ``status`` is ``running`` once the ``MigrateToWorkspaceWorkflow`` is started
     *     (``workflow_id`` set, poll it for completion), or ``noop`` when there is
     *     nothing to realign (merge only: source and target resolve to the same
     *     workspace — the region variant always runs).
     */
    StartWorkspaceRealignResponse: {
      /** Workflow Id */
      workflow_id?: string | null;
      /**
       * Status
       * @enum {string}
       */
      status: StartWorkspaceRealignResponseStatus;
    };
    /**
     * StatusUpdateRequest
     * @description Request to update competition status.
     */
    StatusUpdateRequest: {
      status: components['schemas']['CompetitionStatus'];
    };
    /**
     * StepExecutionStatus
     * @description Execution status for an onboarding step.
     * @enum {string}
     */
    StepExecutionStatus: StepExecutionStatus;
    /**
     * StepType
     * @description Types of onboarding steps available.
     * @enum {string}
     */
    StepType: StepType;
    /**
     * StockItemStatus
     * @description Lifecycle of a single office-stock device (a returned / refurbished unit).
     *
     *     A unit is RECEIVED back into the office and goes through QA (IN_QA →
     *     QA_PASSED / QA_FAILED); the QA phase is reopenable — a QA_PASSED or
     *     QA_FAILED unit may return to IN_QA for re-testing. Good stock is then
     *     ALLOCATED to a send-out and DISPATCHED. CONSUMED and SCRAPPED are terminal:
     *     CONSUMED is the happy end (the unit reached and is in use by a recipient);
     *     SCRAPPED is a write-off.
     * @enum {string}
     */
    StockItemStatus: StockItemStatus;
    /**
     * StockItemView
     * @description Internal-admin projection of a single office-stock item.
     */
    StockItemView: {
      /** Uuid */
      uuid: string;
      status: components['schemas']['StockItemStatus'];
      /** Source Order Id */
      source_order_id?: string | null;
      /** Send Out Order Id */
      send_out_order_id?: string | null;
      /** Device Id */
      device_id?: string | null;
      /** Label */
      label?: string | null;
      /** Notes */
      notes?: string | null;
      /** Qa By */
      qa_by?: string | null;
      /** Qa At */
      qa_at?: string | null;
      /** Qa Notes */
      qa_notes?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Created By */
      created_by?: string | null;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Voided By */
      voided_by?: string | null;
      /** Void Reason */
      void_reason?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
    };
    /** StopConsultNoteGenerationRequest */
    StopConsultNoteGenerationRequest: {
      /**
       * Content
       * @description The content of the FE, FE will update the content of the consult-note, to make sure both FE and BE are in sync
       * @default
       */
      content: string;
    };
    /** StopDocumentGenerationRequest */
    StopDocumentGenerationRequest: {
      /**
       * Content
       * @description The content of the FE, FE will update the content of the document, to make sure both FE and BE are in sync
       * @default
       */
      content: string;
    };
    /**
     * StoreChatsFromLocalStorageRequest
     * @description Request to store chats from client localStorage after signup.
     */
    StoreChatsFromLocalStorageRequest: {
      /** Chats */
      chats: components['schemas']['LocalStorageChatRequest'][];
    };
    /**
     * StoreChatsFromLocalStorageResponse
     * @description Response after storing chats from localStorage.
     */
    StoreChatsFromLocalStorageResponse: {
      /**
       * Chat Ids
       * @description IDs of created chats (same order as request)
       */
      chat_ids?: string[];
    };
    /** StoredAudioChunk */
    StoredAudioChunk: {
      /** Chunk Index */
      chunk_index: number;
      /** Key */
      key: string;
      /** Size Bytes */
      size_bytes?: number | null;
      /** Presigned Url */
      presigned_url: string;
    };
    /**
     * StripeFreeTrialDays
     * @enum {integer}
     */
    StripeFreeTrialDays: StripeFreeTrialDays;
    /**
     * StructuredCitation
     * @description Structured citation with full metadata.
     *
     *     For web_search: url is set, title is page title
     *     For attachment: url is None, title=file_name (PDFs and other files)
     *     For image: url is None, title=file_name (JPEG, PNG, GIF, WEBP)
     *     For user_document: url is None, has document_id for deep-linking
     *     For integration_partner: url may be set, has partner_type and partner_item_id
     */
    StructuredCitation: {
      /** Url */
      url?: string | null;
      /** Title */
      title?: string | null;
      /** Cited Text */
      cited_text?: string | null;
      /** Display Summary */
      display_summary?: string | null;
      /** Page Age */
      page_age?: string | null;
      /** Position */
      position?: number | null;
      /**
       * Source Type
       * @default web_search
       * @enum {string}
       */
      source_type: StructuredCitationSource_type;
      /** File Name */
      file_name?: string | null;
      /** File Key */
      file_key?: string | null;
      /** Attachment Id */
      attachment_id?: string | null;
      /** Document Id */
      document_id?: string | null;
      /** Partner Type */
      partner_type?: string | null;
      /** Partner Item Id */
      partner_item_id?: string | null;
      /** Parent Item Id */
      parent_item_id?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Display Name */
      display_name?: string | null;
      /** Domain */
      domain?: string | null;
      /** Website Name */
      website_name?: string | null;
      /** Logo Url */
      logo_url?: string | null;
      /**
       * Brand Color
       * @description Per-result hex colour for citation rendering. Must be 6-digit hex with leading '#'. FE concatenates alpha suffixes directly, so any other format silently breaks the chip tint.
       */
      brand_color?: string | null;
      /** Embed */
      embed?: {
        [key: string]: unknown;
      } | null;
      /** Source Category */
      source_category?: StructuredCitationSource_categoryAnyOf0 | null;
      /** Authoritativeness Score */
      authoritativeness_score?: number | null;
      /** Impact Factor */
      impact_factor?: number | null;
      /** Website Type */
      website_type?: string[] | null;
      /** Regions */
      regions?: string[] | null;
      /** Specialty */
      specialty?: string[] | null;
      /** Regional Relevance */
      regional_relevance?: StructuredCitationRegional_relevanceAnyOf0 | null;
    };
    /**
     * StructuredCitationResponse
     * @description Citation response with fresh presigned URL for attachment/image types.
     *
     *     For web_search: url is the original HTTP URL
     *     For attachment/image: url is a fresh presigned S3 URL (regenerated on fetch)
     *     For user_document: url is None, use document_id for deep-linking
     *     For integration_partner: url may be set, has partner_type and partner_item_id
     */
    StructuredCitationResponse: {
      /** Url */
      url?: string | null;
      /** Title */
      title?: string | null;
      /** Cited Text */
      cited_text?: string | null;
      /** Display Summary */
      display_summary?: string | null;
      /** Page Age */
      page_age?: string | null;
      /**
       * Source Type
       * @default web_search
       */
      source_type: string;
      /** File Name */
      file_name?: string | null;
      /** Attachment Id */
      attachment_id?: string | null;
      /** Document Id */
      document_id?: string | null;
      /** Partner Type */
      partner_type?: string | null;
      /** Partner Item Id */
      partner_item_id?: string | null;
      /** Parent Item Id */
      parent_item_id?: string | null;
      /** Display Name */
      display_name?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Source Id */
      source_id?: string | null;
      /** Domain */
      domain?: string | null;
      /** Website Name */
      website_name?: string | null;
      /** Logo Url */
      logo_url?: string | null;
      /**
       * Brand Color
       * @description Per-result hex colour for citation rendering. Must be 6-digit hex with leading '#'. FE concatenates alpha suffixes directly, so any other format silently breaks the chip tint.
       */
      brand_color?: string | null;
      /** Embed */
      embed?: {
        [key: string]: unknown;
      } | null;
      /** Authoritativeness Score */
      authoritativeness_score?: number | null;
      /** Impact Factor */
      impact_factor?: number | null;
      /** Website Type */
      website_type?: string[] | null;
      /** Regions */
      regions?: string[] | null;
      /** Specialty */
      specialty?: string[] | null;
      /**
       * Regional Relevance
       * @description Backend-classified relevance of the citation's region tags to the user's country/jurisdiction. ``in_region`` = source matches at subdivision/country/sub-region/region level (in-jurisdiction); ``global`` = no in-region match but ``World#001`` is tagged; ``out_of_region`` = a country tag is present and none match the user. Omitted when the citation has no region tags or the user's location can't be resolved. Computed via pycountry + UN M49 in ``domains/chat/service/source_region_matching.py``; the FE should prefer this field over re-classifying citations client-side.
       */
      regional_relevance?: StructuredCitationResponseRegional_relevanceAnyOf0 | null;
    };
    /**
     * SubAgentBinding
     * @description Pre-bound child agent exposed as a tool alias.
     *
     *     Exactly one of ``agent`` / ``config_id`` must be set. The binding's
     *     ``name`` is the LLM-facing tool name. ``description`` overrides the
     *     child's own saved-config description when set; if ``None`` and
     *     ``config_id`` is used, the public freeze path fills it in from
     *     ``SavedAgentConfig.description`` at parent run ingress.
     *
     *     Runtime identity (``event_id``, ``workflow_id``, ``CompletionEventRef``)
     *     is synthesized by the harness at invocation time and intentionally
     *     never appears on the binding.
     */
    SubAgentBinding: {
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      agent?:
        | components['schemas']['pkg__agent_harness__core__config__AgentConfig']
        | null;
      /** Config Id */
      config_id?: string | null;
      /** Version */
      version?: number | null;
      tool_policy?: components['schemas']['AgentToolPolicy'];
      /** Wait Timeout Seconds */
      wait_timeout_seconds?: number | null;
      /** Waiting Phase Timeout Seconds */
      waiting_phase_timeout_seconds?: number | null;
      /** Max Turn End Hook Continuations */
      max_turn_end_hook_continuations?: number | null;
      /**
       * Persistent
       * @default false
       */
      persistent: boolean;
      /**
       * Inherit Target
       * @default true
       */
      inherit_target: boolean;
      auto_compaction?: components['schemas']['AutoCompactionConfig'] | null;
      attachment_projection?: components['schemas']['AttachmentProjectionConfig'] | null;
      /** Input Schema */
      input_schema?: {
        [key: string]: unknown;
      } | null;
      /** Fixed Input */
      fixed_input?: {
        [key: string]: unknown;
      };
      /** Input Compiler */
      input_compiler?: string | null;
      /** Max Tool Iterations */
      max_tool_iterations?: number | null;
      /** Consecutive Tool Failure Limit */
      consecutive_tool_failure_limit?: number | null;
      /** Consecutive Tool Failure Exemption Limit */
      consecutive_tool_failure_exemption_limit?: number | null;
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      };
    };
    /** SubjectRunListResponse */
    SubjectRunListResponse: {
      /** Runs */
      runs: components['schemas']['SubjectRunSummaryItem'][];
      /** Total */
      total: number;
    };
    /**
     * SubjectRunSummaryItem
     * @description Slim row for subject-owned run listing (no config snapshot).
     */
    SubjectRunSummaryItem: {
      /** Agent Run Id */
      agent_run_id: string;
      /**
       * Status
       * @enum {string}
       */
      status: SubjectRunSummaryItemStatus;
      /** Kind */
      kind?: string | null;
      /** Parent Agent Run Id */
      parent_agent_run_id?: string | null;
      /** Title */
      title?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Project Id */
      project_id?: string | null;
    };
    /**
     * SubmitAgentRunTurnRequest
     * @description Subject-owned follow-up turn body.
     */
    SubmitAgentRunTurnRequest: {
      /** Messages */
      messages: components['schemas']['pkg__agent_harness__core__llm_contracts__Message'][];
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      };
      /** Turn Id */
      turn_id?: string | null;
    };
    /** SubmitAgentRunTurnResponse */
    SubmitAgentRunTurnResponse: {
      /** Turn Id */
      turn_id: string;
      /** User Message Ids */
      user_message_ids?: string[];
    };
    /** SubmitClinicalCodeFeedbackRequest */
    SubmitClinicalCodeFeedbackRequest: {
      feedback: components['schemas']['FeedbackFormRequest'];
    };
    /** SubmitConsultNoteFeedbackRequest */
    SubmitConsultNoteFeedbackRequest: {
      feedback: components['schemas']['FeedbackFormRequest'];
    };
    /** SubmitDocumentFeedbackRequest */
    SubmitDocumentFeedbackRequest: {
      feedback: components['schemas']['FeedbackFormRequest'];
    };
    /**
     * SubmitEntityFeedbackRequest
     * @description Request schema for submitting entity verification feedback.
     */
    SubmitEntityFeedbackRequest: {
      /** Analysis Id */
      analysis_id: string;
      entity_source: components['schemas']['EntitySource'];
      /** Entity Index */
      entity_index: number;
      /** Analysis Marked Correct */
      analysis_marked_correct: boolean;
      /** Qualitative Feedback */
      qualitative_feedback?: string | null;
    };
    /**
     * SubmitEntityFeedbackResponse
     * @description Response schema for submitting entity verification feedback.
     */
    SubmitEntityFeedbackResponse: {
      feedback: components['schemas']['EntityVerificationFeedbackView'];
    };
    /**
     * SubmitFeedbackRequest
     * @description A rating, optionally detailed by whichever feedback form collected it.
     *
     *     A thumb-down carries no detail when the rater only wanted to signal a
     *     quality problem — detail is optional and can arrive in a later submission.
     *     ``categories`` belongs to the flat form and ``errors`` to the rubric one, so
     *     the two cannot be combined; rubric raters normally build the error log an
     *     entry at a time through the ``feedback-errors`` sub-resource instead.
     *     ``evaluation_ui_variant`` is nullable for clients that predate it.
     */
    SubmitFeedbackRequest: {
      rating: components['schemas']['FeedbackRating'] | null;
      /** Errors */
      errors?: components['schemas']['TranslatorEvaluationErrorPayload'][] | null;
      /** Categories */
      categories?: components['schemas']['FeedbackCategory'][] | null;
      /** Text */
      text?: string | null;
      evaluationUiVariant?: components['schemas']['EvaluationUiVariant'] | null;
    };
    /**
     * SubmitFeedbackRequestV2
     * @description Request schema for submitting FeedbackV2
     */
    SubmitFeedbackRequestV2: {
      target_type: components['schemas']['FeedbackTargetType'];
      /**
       * Target Id
       * @description Target ID for the feedback. Can be None for clinical code feedback, since it's tied to session level. For Evidence feedback, this is the chat ID.
       */
      target_id?: string | null;
      /** Content Snapshot */
      content_snapshot?: string | null;
      /** @description FeedbackV2 rating with thumb up or down */
      feedback: components['schemas']['FeedbackV2'];
    };
    /**
     * SubmitFeedbackResponse
     * @description Response model for submitting feedback
     */
    SubmitFeedbackResponse: {
      /**
       * Success
       * @default true
       */
      success: boolean;
      mdc_classification?: components['schemas']['MDCClassification'] | null;
    };
    /**
     * SubmitOverallFeedbackRequest
     * @description Request schema for submitting overall verification feedback.
     */
    SubmitOverallFeedbackRequest: {
      /** Analysis Id */
      analysis_id: string;
      rating: components['schemas']['ThumbRating'];
      /** Qualitative Feedback */
      qualitative_feedback?: string | null;
      /** Reasons */
      reasons?: components['schemas']['FeedbackRatingReason'][];
    };
    /**
     * SubmitOverallFeedbackResponse
     * @description Response schema for submitting overall verification feedback.
     */
    SubmitOverallFeedbackResponse: {
      feedback: components['schemas']['OverallFeedbackView'];
    };
    /**
     * SubmitQaResultRequest
     * @description Body for recording a QA outcome on a stock item.
     *
     *     `result` (the pass/fail verdict, mapped to the QA_PASSED / QA_FAILED status)
     *     and `qa_notes` (this run's findings) are part of the QA record and always
     *     applied — an omitted `qa_notes` clears any note from a prior run. `label` /
     *     `device_id` are sticky unit attributes: omitting one leaves the stored value
     *     unchanged.
     */
    SubmitQaResultRequest: {
      result: components['schemas']['QaResult'];
      /** Label */
      label?: string | null;
      /** Device Id */
      device_id?: string | null;
      /** Qa Notes */
      qa_notes?: string | null;
    };
    /**
     * SubmitRemoteToolResultRequest
     * @description Result payload for harness remote-executed tools.
     *
     *     Computer-use clients still own coordinate scaling. PNG screenshots may be
     *     posted at original resolution; bounded generic files may be posted through
     *     ``attachments``. The harness persists original bytes and prepares normalized
     *     image copies when provider limits require it.
     *
     *     ``error_code`` is an opaque classifier the harness never branches on but
     *     does persist into Temporal history and run artifacts, so send a machine
     *     token only — never PHI/PII. ``failure_behavior="stop_turn"`` ends the turn
     *     on this single failure instead of letting the model retry (see
     *     ``shared.agent_harness.core.events.ToolStopRequestedPropagation``).
     */
    SubmitRemoteToolResultRequest: {
      /** Tool Call Id */
      tool_call_id: string;
      /** Output */
      output?: string | null;
      /** Error */
      error?: string | null;
      /** Error Code */
      error_code?: string | null;
      /**
       * Failure Behavior
       * @default continue
       * @enum {string}
       */
      failure_behavior: SubmitRemoteToolResultRequestFailure_behavior;
      /** Base64 Image */
      base64_image?: string | string[] | null;
      /** Attachments */
      attachments?: components['schemas']['RemoteToolResultAttachment'][] | null;
    };
    /** SubmitTranscriptRequest */
    SubmitTranscriptRequest: {
      /** Transcript */
      transcript: string;
      /** @default TRANSCRIBE */
      transcribe_mode: components['schemas']['TranscribeMode'] | null;
    };
    /**
     * SubmitUsabilityFeedbackRequest
     * @description Request schema for submitting usability feedback (UMUX-Lite).
     */
    SubmitUsabilityFeedbackRequest: {
      /**
       * Ease Stars
       * @description Ease rating (UMUX-Lite) from 1 to 5
       */
      ease_stars: number;
      /**
       * Usefulness Stars
       * @description Usefulness rating (UMUX-Lite) from 1 to 5
       */
      usefulness_stars: number;
      /**
       * Feedback
       * @description Optional free-text comment from the user
       */
      feedback?: string | null;
    };
    /**
     * SubmitUsabilityFeedbackResponse
     * @description Response schema for submitting usability feedback.
     */
    SubmitUsabilityFeedbackResponse: {
      /**
       * Success
       * @description Whether the feedback was saved successfully
       */
      success: boolean;
      /**
       * Feedback Id
       * @description UUID of the created feedback record
       */
      feedback_id: string;
      /**
       * Feedback Count
       * @description Total feedback submissions by this user for this feature
       */
      feedback_count: number;
    };
    /**
     * SubscriptionStatus
     * @enum {string}
     */
    SubscriptionStatus: SubscriptionStatus;
    /**
     * SubscriptionTier
     * @enum {string}
     */
    SubscriptionTier: SubscriptionTier;
    /** SuggestRequestSchema */
    SuggestRequestSchema: {
      /** Transcript Chunk */
      transcript_chunk: string;
      /** Visit Summary */
      visit_summary?: string | null;
    };
    /**
     * SuggestedChipCategory
     * @description Categories for suggested query chips.
     * @enum {string}
     */
    SuggestedChipCategory: SuggestedChipCategory;
    /**
     * SuggestedChipSchema
     * @description Schema for a suggested query chip.
     */
    SuggestedChipSchema: {
      /**
       * Id
       * @description Unique identifier for the chip
       */
      id: string;
      /**
       * Query
       * @description The full query to send to Evidence
       */
      query: string;
      /**
       * Label
       * @description Short label to display on the chip
       */
      label: string;
      /** @description Category of the suggestion */
      category: components['schemas']['SuggestedChipCategory'];
      /**
       * Patient Question
       * @description FDE-8: when library-grounded, an alternative patient-directed phrasing (e.g. 'Ask about …', 'Check for …'). Null on the ungrounded path.
       */
      patient_question?: string | null;
      /**
       * Source Ref Ids
       * @description FDE-8: ids of entries in TranscriptChipsResponseSchema.source_refs that grounded this chip. Empty on the ungrounded path.
       */
      source_ref_ids?: string[];
    };
    /** SuggestedEmCodesResponse */
    SuggestedEmCodesResponse: {
      new_patient?: components['schemas']['EmCodeDetail'] | null;
      established_patient?: components['schemas']['EmCodeDetail'] | null;
    };
    /**
     * SuggestionFeedback
     * @enum {string}
     */
    SuggestionFeedback: SuggestionFeedback;
    /**
     * SuggestionsRequest
     * @description Request model for generating suggestions.
     */
    SuggestionsRequest: {
      /**
       * Text
       * @description Current text typed by user (can be empty)
       */
      text?: string | null;
      /**
       * Specialty
       * @description User's medical specialty for context
       */
      specialty?: string | null;
      /**
       * Patient Profile Id
       * @description Patient profile ID to generate patient-specific suggestions
       */
      patient_profile_id?: string | null;
      /**
       * Session Id
       * @description Active consult session ID, when suggestions are typed inside a session. Used only for span tagging (heidi.session_id); no effect on suggestion generation. Optional. Stamped only for authenticated, non-temp users.
       */
      session_id?: string | null;
    };
    /**
     * SuggestionsResponse
     * @description Response model for suggestions.
     */
    SuggestionsResponse: {
      /**
       * Suggestions
       * @description List of suggested queries
       */
      suggestions?: string[];
    };
    /**
     * SummaryConfig
     * @description Per-agent post-call summary delivery configuration (email fields).
     *
     *     Mirrors the email-side of ``SummaryConfig`` on ai-receptionist-be. Only the
     *     fields exposed to Scribe FE are typed here; staff-SMS fields
     *     (``send_sms``/``send_sms_to``/``send_sms_threshold``) pass through via
     *     ``extra = "allow"`` so an agent read that carries them round-trips cleanly.
     *
     *     Nested under ``Agent`` / ``AgentConfig`` on the *read* path
     *     (``Agent(**a)`` in list/get/seed), so this model must not raise on
     *     incomplete or out-of-range upstream data — same passthrough convention
     *     as ``AgentVoiceSpec.provider``. Write-time checks
     *     (``send_email`` ⇒ ``send_email_to``, email format, threshold bounds)
     *     live on Calls BE and the FE save form — not here. Do not add raising
     *     format validators on ``send_email_to``; that belongs on a write-only
     *     request model (cf. ``UpdateEHRClinicRequest.email_override``).
     *
     *     Recipient resolution when ``send_email`` is true:
     *       * ``send_email_to_clinic`` false → deliver to ``send_email_to``.
     *       * ``send_email_to_clinic`` true → deliver to the resolved clinic email
     *         (``email_override`` or EHR-synced ``email``), falling back to
     *         ``send_email_to`` when no clinic can be resolved for the call, the
     *         resolved clinic is disabled, or the clinic has no email.
     */
    SummaryConfig: {
      /**
       * Send Email
       * @default false
       */
      send_email: boolean;
      /**
       * Send Email To
       * @description Practice-wide destination for the per-call admin summary email. Calls BE requires a non-blank value when ``send_email`` is true; used as fallback when ``send_email_to_clinic`` is true but no clinic email resolves.
       */
      send_email_to?: string | null;
      /**
       * Send Email Threshold
       * @description Optional score gate (0-100). When set, the summary email is only sent if the post-call send score is >= this value. When unset, every call with a summary produces an email. Bounds are enforced on write by Calls BE; this read model does not constrain them.
       */
      send_email_threshold?: number | null;
      /**
       * Send Email To Clinic
       * @description Route the per-call summary email to the resolved clinic's email (admin ``email_override`` or EHR-synced ``email``). Falls back to ``send_email_to`` when no clinic can be resolved, the resolved clinic is disabled, or the clinic has no email. Calls BE still requires ``send_email_to`` as the practice-wide default when ``send_email`` is true.
       * @default false
       */
      send_email_to_clinic: boolean;
    } & {
      [key: string]: unknown;
    };
    /**
     * SummaryParameter
     * @description FHIR _summary parameter values.
     *
     *     https://hl7.org/fhir/R4/search.html#summary
     * @enum {string}
     */
    SummaryParameter: SummaryParameter;
    /**
     * SurfacingConfigModel
     * @description Per-protocol, dashboard-tunable surfacing parameters.
     *
     *     ``include_terms`` — transcript keyword signals appended to the fact query before
     *     embedding and boosted at the map/rerank stage (pull toward this protocol).
     *
     *     ``avoid_terms`` — negative context handed to the rerank stage to REDUCE association (a
     *     soft repeller). They are never a veto and never drop a candidate on their own; the
     *     safety rail is avoid-blind.
     *
     *     ``sensitivity`` — post-rerank relevance cutoff in [0, 1]. Higher fires on weaker evidence
     *     (more sensitive); lower is more conservative. The mapping to a concrete cutoff lives in
     *     the engine; this just stores the knob.
     */
    SurfacingConfigModel: {
      /** Include Terms */
      include_terms?: string[];
      /** Avoid Terms */
      avoid_terms?: string[];
      /**
       * Sensitivity
       * @default 0.5
       */
      sensitivity: number;
    };
    /** SuspendedStatusResponse */
    SuspendedStatusResponse: {
      /** Is Suspended */
      is_suspended: boolean;
      /** Suspended At */
      suspended_at?: string | null;
      /** Reason */
      reason?: string | null;
      /** Suspended By */
      suspended_by?: string | null;
    };
    /** SuspendedUsersListResponse */
    SuspendedUsersListResponse: {
      /** Users */
      users: components['schemas']['SuspensionStateResponse'][];
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
      /** Has More */
      has_more: boolean;
    };
    /**
     * SuspensionAction
     * @enum {string}
     */
    SuspensionAction: SuspensionAction;
    /** SuspensionLogListResponse */
    SuspensionLogListResponse: {
      /** Logs */
      logs: components['schemas']['SuspensionLogRecord'][];
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
      /** Has More */
      has_more: boolean;
    };
    /** SuspensionLogRecord */
    SuspensionLogRecord: {
      /** Identifier Type */
      identifier_type: string;
      /** Identifier */
      identifier: string;
      action: components['schemas']['SuspensionAction'];
      /** Admin Id */
      admin_id: string;
      /** Admin Email */
      admin_email?: string | null;
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp: string;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /** SuspensionStateResponse */
    SuspensionStateResponse: {
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** Email */
      email?: string | null;
      /** Full Name */
      full_name?: string | null;
      suspended_status: components['schemas']['SuspendedStatusResponse'];
    };
    /** SyncConsultNoteRequest */
    SyncConsultNoteRequest: {
      /** Access Token */
      access_token: string;
      /** @default Epic Systems */
      ehr_provider: components['schemas']['EHRProvider'];
      /** @default preliminary */
      doc_status: components['schemas']['FhirClinicalDocStatus'];
      /** @default Progress Note */
      note_type: components['schemas']['FhirClinicalNoteTypes'];
      /** Profile Name */
      profile_name?: string | null;
    };
    /** SyncConsultNoteResponse */
    SyncConsultNoteResponse: {
      /** Note Id */
      note_id: string;
    };
    SyncDocumentOptionId: string;
    /**
     * SyncDocumentRequest
     * @description Request body for syncing a Heidi document to an EHR destination.
     *
     *     When the options endpoint returns options, the client sends the selected
     *     option's ``option_id`` here. When the options endpoint returns an empty list,
     *     omit ``option_id`` to perform a direct default sync.
     *     ``onboarding_session_id`` is required only when the Heidi session has no
     *     integration appointment link and the service must resolve the provider from
     *     the completed onboarding session.
     */
    SyncDocumentRequest: {
      /** Onboarding Session Id */
      onboarding_session_id?: string | null;
      option_id?: components['schemas']['SyncDocumentOptionId'] | null;
    };
    /**
     * SyncDocumentResponse
     * @description Response for a successful document sync.
     *
     *     ``external_document_id`` is the generic EHR-side identifier returned by the
     *     provider when available. The framework does not persist this in v1; providers
     *     that later need update or deduplication behavior should add a dedicated
     *     document-link model rather than overloading consult-note links.
     */
    SyncDocumentResponse: {
      /** External Document Id */
      external_document_id?: string | null;
    };
    /**
     * SyncNotesRequest
     * @description Request schema for syncing notes to an integration.
     */
    SyncNotesRequest: {
      /** Onboarding Session Id */
      onboarding_session_id?: string | null;
      cerner_note_type?: components['schemas']['CernerNoteType'] | null;
    };
    /** SyncNotesResponse */
    SyncNotesResponse: Record<string, never>;
    /** SyncNotesToEHRAPIRequest */
    SyncNotesToEHRAPIRequest: {
      /** Assessment Note */
      assessment_note?: string | null;
      /** Hpi Note */
      hpi_note?: string | null;
      /** Physical Exam Note */
      physical_exam_note?: string | null;
      /** Review Of Systems Note */
      review_of_systems_note?: string | null;
      /** Note Content */
      note_content?: string | null;
    };
    /** SyncNotesToEHRResponse */
    SyncNotesToEHRResponse: {
      /** Is Success */
      is_success: boolean;
      /** Message */
      message?: string | null;
    };
    /**
     * SyncNotesWithOptionRequest
     * @description Request body for syncing a consult note with a selected destination option.
     */
    SyncNotesWithOptionRequest: {
      option_id: components['schemas']['NoteOptionEhrId'];
    };
    /**
     * SyncNotesWithOptionsResponse
     * @description Response for a successful note sync with a selected option.
     */
    SyncNotesWithOptionsResponse: Record<string, never>;
    /**
     * SyncPasswordRequestDTO
     * @description Request DTO for syncing password from Kinde to Auth0.
     *
     *     Conditional validation rules:
     *     - When status=new_profile: kinde_user_id and user_ref_id MUST be null
     *     - When status=existing_profile: kinde_user_id and user_ref_id are REQUIRED
     */
    SyncPasswordRequestDTO: {
      /**
       * Email
       * Format: email
       */
      email: string;
      /**
       * Password
       * @description User password (minimum 8 characters)
       */
      password: string;
      status: components['schemas']['KindeProfileStatus'];
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** User Ref Id */
      user_ref_id?: string | null;
    };
    /**
     * SyncPasswordResponse
     * @description Response wrapper for sync password API.
     */
    SyncPasswordResponse: {
      identity_profile: components['schemas']['SaveIdentityProfileResponseDTO'];
    };
    /** SyncRunListResponse */
    SyncRunListResponse: {
      /** Runs */
      runs: components['schemas']['SyncRunResponse'][];
      /** Total */
      total: number;
      /** Limit */
      limit: number;
      /** Has More */
      has_more: boolean;
    };
    /** SyncRunResponse */
    SyncRunResponse: {
      /** Execution Id */
      execution_id: string;
      /** Script Name */
      script_name: string;
      /** Partner */
      partner: string | null;
      /** Triggered By */
      triggered_by: string;
      /** Params */
      params: {
        [key: string]: unknown;
      };
      /** Target Db */
      target_db: string;
      /**
       * Status
       * @enum {string}
       */
      status: SyncRunResponseStatus;
      /**
       * Started At
       * Format: date-time
       */
      started_at: string;
      /** Completed At */
      completed_at: string | null;
      /** Result Summary */
      result_summary: {
        [key: string]: unknown;
      } | null;
      /** Error Message */
      error_message: string | null;
    };
    /**
     * SyncSectionalNotesResponse
     * @description Response model for successful sectional sync operations.
     */
    SyncSectionalNotesResponse: Record<string, never>;
    /**
     * SyncSubscriptionRequest
     * @description Request body for POST /internal-admin/billings/sync-subscription.
     *
     *     Exactly one of ``user_ref_id`` or ``team_id`` must be supplied. The endpoint
     *     re-fetches the target's current Stripe subscription and writes the
     *     refreshed fields back to the internal-admin billing record.
     */
    SyncSubscriptionRequest: {
      /** User Ref Id */
      user_ref_id?: string | null;
      /** Team Id */
      team_id?: string | null;
    };
    /**
     * SyncSubscriptionResponse
     * @description Response for POST /internal-admin/billings/sync-subscription.
     */
    SyncSubscriptionResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
      billing_account?: components['schemas']['InternalAdminBillingAccountView'] | null;
    };
    /** SyncTriggerResponse */
    SyncTriggerResponse: {
      /** Job Ref Id */
      job_ref_id: string;
    };
    /**
     * SystemTemplateFieldUpdates
     * @description Dataclass for non-tag field updates in batch operations.
     */
    SystemTemplateFieldUpdates: {
      template_category?: components['schemas']['TemplateCategory'] | null;
      /** Should Deduct Quota */
      should_deduct_quota?: boolean | null;
      /** Prompteams Id */
      prompteams_id?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** List Order Priority */
      list_order_priority?: number | null;
    };
    /**
     * T2medAckFailure
     * @description Desktop reports a failed local FHIR write.
     */
    T2medAckFailure: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: T2medAckFailureStatus;
      /**
       * Error Code
       * @description Machine-readable error tag (e.g. ``profile_not_supported``, ``invalid_kontext``, ``network``). Free-form to allow future growth without ml-scribe redeploys. Terminal codes (``invalid_kontext``, ``profile_not_supported``) stop the writeback from being re-served; anything else stays retryable.
       */
      error_code: string;
      /**
       * Error Message
       * @description Short operator-facing failure summary. Cap at 500 chars; do not include patient identifiers or full FHIR diagnostic text.
       */
      error_message: string;
      /**
       * Operation Outcome
       * @description Raw FHIR ``OperationOutcome`` returned by the APS, if any.
       */
      operation_outcome?: {
        [key: string]: unknown;
      } | null;
      /**
       * Writeback Generation
       * @description Echo of ``writeback_generation`` from the polled item — same fencing semantics as the success ACK (stale → 409).
       * @default 0
       */
      writeback_generation: number;
    };
    /**
     * T2medAckResponse
     * @description Echo of the recorded state after ACK.
     */
    T2medAckResponse: {
      /** Consult Note Link Id */
      consult_note_link_id: string;
      /** Document Reference Id */
      document_reference_id?: string | null;
      /**
       * Condition Ids
       * @default []
       */
      condition_ids: string[];
      /**
       * Section Resource Ids
       * @default {}
       */
      section_resource_ids: {
        [key: string]: string;
      };
      /**
       * Last Synced At
       * Format: date-time
       */
      last_synced_at: string;
    };
    /**
     * T2medAckSuccess
     * @description Desktop reports a successful local FHIR write.
     */
    T2medAckSuccess: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      status: T2medAckSuccessStatus;
      /**
       * Document Reference Id
       * @description FHIR ``DocumentReference.id`` returned by the APS after a whole-note ``DocumentReference.create`` succeeded. Omit for purely sectional writes (per-section ids go in ``section_resource_ids`` instead).
       */
      document_reference_id?: string | null;
      /**
       * Section Resource Ids
       * @description FHIR resource id per written section, keyed by the polled item's ``sections[].section_id`` (``anamnese`` / ``befund`` / ``therapie`` / ``freitext``). Empty for whole-note writes.
       */
      section_resource_ids?: {
        [key: string]: string;
      };
      /**
       * Condition Ids
       * @description FHIR ``Condition.id`` for each ICD-10-GM diagnosis written. Empty list is fine if no diagnoses were extracted by Heidi.
       */
      condition_ids?: string[];
      /**
       * Writeback Generation
       * @description Echo of ``writeback_generation`` from the polled item. The ACK only completes that exact queued version — if the note was re-synced after the poll, the ACK is rejected with 409 ``stale_writeback_ack`` and the newer version stays queued.
       * @default 0
       */
      writeback_generation: number;
    };
    /**
     * T2medLaunchErrorResponse
     * @description Error response for a failed T2med launch.
     */
    T2medLaunchErrorResponse: {
      /** Code */
      code: string;
      /** Message */
      message: string;
      /** Step Id */
      step_id?: string | null;
    };
    /**
     * T2medLaunchRequest
     * @description Request body for ``POST /api/v2/integrations/launch/t2med``.
     *
     *     The desktop app submits the deep-link fields it needs the cloud to persist
     *     (``kontextId``, ``fhirBasisUrl``). ``oAuthToken`` must not be included.
     */
    T2medLaunchRequest: {
      /**
       * Provider
       * @description Must be 'T2med'.
       * @default T2med
       */
      provider: string;
      /**
       * Payload
       * @description Deep-link payload parsed from the APS URI. Must contain ``kontextId`` and ``fhirBasisUrl``. Do not include ``oAuthToken``.
       */
      payload: {
        [key: string]: unknown;
      };
    };
    /**
     * T2medLaunchResponse
     * @description Response for a successful T2med launch.
     */
    T2medLaunchResponse: {
      /**
       * Provider
       * @default T2med
       */
      provider: string;
      /** Onboarding Session Id */
      onboarding_session_id: string;
      /**
       * Session Id
       * @description Heidi session id — either freshly created or resumed from a prior launch with the same ``kontextId``.
       */
      session_id: string;
      /**
       * Resumed
       * @description True if this launch resumed an existing Heidi session.
       */
      resumed: boolean;
      /**
       * Context Id
       * @description Launch context id (echo of ``kontextId``) so the desktop can correlate the response.
       */
      context_id: string;
      /**
       * Api Key
       * @description Per-product ``X-API-Key`` (T2med's third-party product key) provisioned by T2med GmbH for the Heidi product, resolved from the user's own onboarded ``EHRLaunchProfile``. The desktop sends it on every local FHIR call and should hold it in memory only — do not persist to disk. ``None`` means the profile has no key provisioned yet: the session still works for scribing, but FHIR write-backs will fail until Heidi provisions the profile.
       */
      api_key?: string | null;
    };
    /** T2medPatientContextErrorResponse */
    T2medPatientContextErrorResponse: {
      /** Code */
      code: string;
      /** Message */
      message: string;
    };
    /**
     * T2medPatientContextRequest
     * @description Body of ``POST /sessions/{session_id}/patient-context``.
     *
     *     All demographic fields are optional — the desktop reports what it has
     *     from the FHIR Patient resource. The only required field is
     *     ``patient_fhir_id``.
     */
    T2medPatientContextRequest: {
      /**
       * Patient Fhir Id
       * @description FHIR ``Patient.id`` returned by the local APS server.
       */
      patient_fhir_id: string;
      /**
       * Given Names
       * @description ``Patient.name[0].given`` from FHIR (one or more given names).
       */
      given_names?: string[] | null;
      /**
       * Family Name
       * @description ``Patient.name[0].family`` from FHIR.
       */
      family_name?: string | null;
      /**
       * Birth Date
       * @description ``Patient.birthDate`` (ISO date) from FHIR.
       */
      birth_date?: string | null;
      /** @description ``Patient.gender`` from FHIR (``male`` / ``female`` / ``other``). */
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
    };
    /**
     * T2medPatientContextResponse
     * @description Response: linked patient profile id.
     */
    T2medPatientContextResponse: {
      /**
       * Patient Profile Id
       * @description Heidi ``PatientProfile.id`` linked to this session.
       */
      patient_profile_id: string;
      /** Patient Fhir Id */
      patient_fhir_id: string;
      /** Session Id */
      session_id: string;
    };
    /**
     * T2medPendingWritebacksResponse
     * @description List wrapper so the response shape stays additive (we can grow it).
     */
    T2medPendingWritebacksResponse: {
      /** Items */
      items: components['schemas']['PendingWriteback'][];
    };
    /** Tags */
    Tags: {
      /** Countries */
      countries?: components['schemas']['Country'][];
      /** Languages */
      languages?: components['schemas']['LanguageCode'][];
      /** Specialty Ids */
      specialty_ids?: string[];
      /** Tiers */
      tiers?: components['schemas']['SubscriptionTier'][];
      /** Regions */
      regions?: components['schemas']['Region'][];
    };
    /** TagsResponse */
    TagsResponse: {
      /** Countries */
      countries?: components['schemas']['Country'][];
      /** Languages */
      languages?: components['schemas']['LanguageCode'][];
      /** Specialty Ids */
      specialty_ids?: string[];
      /** Tiers */
      tiers?: components['schemas']['SubscriptionTier'][];
      /** Regions */
      regions?: components['schemas']['Region'][];
    };
    /**
     * Task
     * @description A task to be performed.
     *
     *     https://hl7.org/fhir/R4/task-definitions.html
     */
    Task: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Task Instance Identifier
       * @description Business identifiers assigned to this task.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Formal definition of task
       * @description The URL pointing to a FHIR-defined protocol, guideline, orderset or other definition that is adhered to in whole or in part by this Task.
       */
      instantiatesCanonical?: string | null;
      /**
       * Formal definition of task
       * @description The URL pointing to an externally maintained protocol, guideline, orderset or other definition that is adhered to in whole or in part by this Task.
       */
      instantiatesUri?: string | null;
      /**
       * Request fulfilled by this task
       * @description BasedOn refers to a higher-level authorization that triggered the creation of the task.
       */
      basedOn?: components['schemas']['Reference'][] | null;
      /**
       * Requisition or grouper id
       * @description An identifier that links together multiple tasks and other requests that were created in the same context.
       */
      groupIdentifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * Composite task
       * @description Task that this particular task is part of.
       */
      partOf?: components['schemas']['Reference'][] | null;
      /**
       * draft | requested | received | accepted | rejected | ready | cancelled | in-progress | on-hold | failed | completed | entered-in-error
       * @description The current status of the task.
       */
      status: components['schemas']['TaskStatus'];
      /**
       * Reason for current status
       * @description An explanation as to why this task is held, failed, was refused, etc.
       */
      statusReason?: components['schemas']['CodeableConcept'] | null;
      /**
       * E.g. 'Specimen collected', 'IV prepped'
       * @description Contains business-specific nuances of the business state.
       */
      businessStatus?: components['schemas']['CodeableConcept'] | null;
      /**
       * unknown | proposal | plan | order | original-order | reflex-order | filler-order | instance-order | option
       * @description Indicates the level of actionability associated with the task.
       */
      intent: components['schemas']['TaskIntent'];
      /**
       * routine | urgent | asap | stat
       * @description How quickly the task should be addressed.
       */
      priority?: components['schemas']['RequestPriority'] | null;
      /**
       * Task Type
       * @description A name or code briefly describing what the task involves.
       */
      code?: components['schemas']['CodeableConcept'] | null;
      /**
       * Human-readable explanation of task
       * @description A free-text description of what is to be performed.
       */
      description?: string | null;
      /**
       * What task is acting on
       * @description The request being actioned or the resource being manipulated by this task.
       */
      focus?: components['schemas']['Reference'] | null;
      /**
       * Beneficiary of the Task
       * @description The entity who benefits from the task, such as the patient.
       */
      for?: components['schemas']['Reference'] | null;
      /**
       * Healthcare event during which this task originated
       * @description The healthcare event during which this task was created.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * Start and end time of execution
       * @description Identifies the time action was first taken against the task and/or the time final action was taken.
       */
      executionPeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Task Creation Date
       * @description The date and time this task was created.
       */
      authoredOn?: string | null;
      /**
       * Task Last Modified Date
       * @description The date and time of last modification to this task.
       */
      lastModified?: string | null;
      /**
       * Who is asking for task to be done
       * @description The creator of the task.
       */
      requester?: components['schemas']['Reference'] | null;
      /**
       * Requested performer
       * @description The kind of participant that should perform the task.
       */
      performerType?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Responsible individual
       * @description The individual or organization responsible for task execution.
       */
      owner?: components['schemas']['Reference'] | null;
      /**
       * Where task occurs
       * @description Principal physical location where this task is performed.
       */
      location?: components['schemas']['Reference'] | null;
      /**
       * Why task is needed
       * @description A description or code indicating why this task needs to be performed.
       */
      reasonCode?: components['schemas']['CodeableConcept'] | null;
      /**
       * Why task is needed
       * @description A resource reference indicating why this task needs to be performed.
       */
      reasonReference?: components['schemas']['Reference'] | null;
      /**
       * Associated insurance coverage
       * @description Insurance plans, coverage extensions, pre-authorizations and/or pre-determinations that may be relevant to the Task.
       */
      insurance?: components['schemas']['Reference'][] | null;
      /**
       * Comments made about the task
       * @description Free-text information captured about the task.
       */
      note?: components['schemas']['Annotation'][] | null;
      /**
       * Key events in history of the Task
       * @description Links to Provenance records for past versions of this Task that identify key state transitions or updates.
       */
      relevantHistory?: components['schemas']['Reference'][] | null;
      /**
       * Constraints on fulfillment tasks
       * @description If the Task.focus is a request resource and the task is seeking fulfillment, this element identifies any limitations.
       */
      restriction?: components['schemas']['TaskRestriction'] | null;
      /**
       * Information used to perform task
       * @description Additional information that may be needed in the execution of the task.
       */
      input?: components['schemas']['TaskInput'][] | null;
      /**
       * Information produced as part of task
       * @description Outputs produced by the Task.
       */
      output?: components['schemas']['TaskOutput'][] | null;
    };
    /**
     * TaskIcon
     * @description Icon identifiers for task display in the frontend.
     * @enum {string}
     */
    TaskIcon: TaskIcon;
    /**
     * TaskInput
     * @description Information used to perform the task.
     *
     *     https://hl7.org/fhir/R4/task-definitions.html#Task.input
     */
    TaskInput: {
      /**
       * Label for the input
       * @description A code or description indicating how the input is intended to be used as part of the task execution.
       */
      type: components['schemas']['CodeableConcept'];
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueBase64Binary?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueBoolean?: boolean | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueCanonical?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueCode?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueDate?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueDateTime?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueDecimal?: number | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueId?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueInstant?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueInteger?: number | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueMarkdown?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueOid?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valuePositiveInt?: number | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueString?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueTime?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueUnsignedInt?: number | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueUri?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueUrl?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueUuid?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueAddress?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueAge?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueAnnotation?: components['schemas']['Annotation'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueAttachment?: components['schemas']['Attachment'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueCoding?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueContactPoint?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueCount?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueDistance?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueDuration?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueHumanName?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__human_name__HumanName']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueIdentifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueMoney?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valuePeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueRange?: components['schemas']['Range'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueRatio?: components['schemas']['Ratio'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueReference?: components['schemas']['Reference'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueSampledData?: components['schemas']['SampledData'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueSignature?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueTiming?: components['schemas']['Timing'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueContactDetail?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueContributor?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueDataRequirement?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueExpression?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueParameterDefinition?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueRelatedArtifact?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueTriggerDefinition?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueUsageContext?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a SpecialPurposeDataType.
       */
      valueDosage?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a SpecialPurposeDataType.
       */
      valueMeta?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * TaskIntent
     * @description FHIR Task intent codes.
     *
     *     https://hl7.org/fhir/R4/valueset-task-intent.html
     * @enum {string}
     */
    TaskIntent: TaskIntent;
    /**
     * TaskOutput
     * @description Outputs produced by the task.
     *
     *     https://hl7.org/fhir/R4/task-definitions.html#Task.output
     */
    TaskOutput: {
      /**
       * Label for the input
       * @description A code or description indicating how the input is intended to be used as part of the task execution.
       */
      type: components['schemas']['CodeableConcept'];
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueBase64Binary?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueBoolean?: boolean | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueCanonical?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueCode?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueDate?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueDateTime?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueDecimal?: number | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueId?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueInstant?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueInteger?: number | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueMarkdown?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueOid?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valuePositiveInt?: number | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueString?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueTime?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueUnsignedInt?: number | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueUri?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueUrl?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a basic type.
       */
      valueUuid?: string | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueAddress?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueAge?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueAnnotation?: components['schemas']['Annotation'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueAttachment?: components['schemas']['Attachment'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueCoding?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueContactPoint?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__contact_point__ContactPoint']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueCount?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueDistance?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueDuration?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueHumanName?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__human_name__HumanName']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueIdentifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueMoney?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valuePeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueRange?: components['schemas']['Range'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueRatio?: components['schemas']['Ratio'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueReference?: components['schemas']['Reference'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueSampledData?: components['schemas']['SampledData'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueSignature?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a DataType.
       */
      valueTiming?: components['schemas']['Timing'] | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueContactDetail?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueContributor?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueDataRequirement?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueExpression?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueParameterDefinition?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueRelatedArtifact?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueTriggerDefinition?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a MetaDataType.
       */
      valueUsageContext?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a SpecialPurposeDataType.
       */
      valueDosage?: {
        [key: string]: unknown;
      } | null;
      /**
       * Content to use in performing the task
       * @description The value of the input parameter as a SpecialPurposeDataType.
       */
      valueMeta?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * TaskRestriction
     * @description Constraints on fulfillment tasks.
     *
     *     https://hl7.org/fhir/R4/task-definitions.html#Task.restriction
     */
    TaskRestriction: {
      /**
       * How many times to repeat
       * @description Indicates the number of times the requested action should occur.
       */
      repetitions?: number | null;
      /**
       * When fulfillment is sought
       * @description Over what time-period is fulfillment sought.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * For whom is fulfillment sought?
       * @description For requests that are targeted to more than one potential recipient/target, for whom is fulfillment sought?
       */
      recipient?: components['schemas']['Reference'][] | null;
    };
    /**
     * TaskStatus
     * @description FHIR Task status codes.
     *
     *     https://hl7.org/fhir/R4/valueset-task-status.html
     * @enum {string}
     */
    TaskStatus: TaskStatus;
    /**
     * TaskType
     * @description Type of task field in GamifyTrialExtensionProgress.
     * @enum {string}
     */
    TaskType: TaskType;
    /**
     * TeamAddMemberMethod
     * @enum {string}
     */
    TeamAddMemberMethod: TeamAddMemberMethod;
    /** TeamAssignmentRequest */
    TeamAssignmentRequest: {
      /** User Ref Id */
      user_ref_id: string;
      /** Team Id */
      team_id: string;
      /** Role Ids */
      role_ids: string[];
    };
    /** TeamAssignmentResponse */
    TeamAssignmentResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
    };
    /** TeamBillingResponse */
    TeamBillingResponse: {
      team_billing_info: components['schemas']['BillingInfo'];
    };
    /**
     * TeamCollectionCreate
     * @description Request model for creating a collection within a team context.
     *
     *     The team_id comes from the path parameter, not from this schema.
     */
    TeamCollectionCreate: {
      /**
       * Name
       * @description Collection name
       */
      name: string;
      /**
       * Description
       * @description Collection description
       */
      description?: string | null;
      /**
       * Icon
       * @description Collection icon (emoji or icon name)
       */
      icon?: string | null;
      /**
       * Owner Id
       * @description Kinde user ID of the owner. Defaults to team owner if omitted.
       */
      owner_id?: string | null;
      /**
       * Domains
       * @description URL domain filters for web search (e.g., ['uptodate.com'])
       */
      domains?: string[] | null;
    };
    /** TeamConsentUpdateRequest */
    TeamConsentUpdateRequest: {
      /** Require Patient Consent */
      require_patient_consent: boolean;
      /** Custom Consent Text */
      custom_consent_text?: string | null;
    };
    /**
     * TeamCreateSourceListRequest
     * @description Request model for creating a source list within a team context.
     *
     *     The team_id comes from the path parameter, not from this schema.
     */
    TeamCreateSourceListRequest: {
      /** Name */
      name: string;
      /** Domains */
      domains?: string[];
      /**
       * Owner Id
       * @description Kinde user ID of the owner. Defaults to team owner if omitted.
       */
      owner_id?: string | null;
    };
    /** TeamDisclaimerFooter */
    TeamDisclaimerFooter: {
      /**
       * Text
       * @description Plain text disclaimer footer, maximum 500 characters
       */
      text?: string | null;
      /**
       * Enabled
       * @default false
       */
      enabled: boolean;
      /** Scope */
      scope?: components['schemas']['TeamDisclaimerFooterScope'][];
    };
    /**
     * TeamDisclaimerFooterScope
     * @enum {string}
     */
    TeamDisclaimerFooterScope: TeamDisclaimerFooterScope;
    /**
     * TeamEvidenceAccessMode
     * @description How team evidence access is scoped (roles vs individual members).
     * @enum {string}
     */
    TeamEvidenceAccessMode: TeamEvidenceAccessMode;
    /**
     * TeamEvidenceSettings
     * @description Team-level evidence settings for enforcing source control, collection policies,
     *     and regional settings across all team members.
     */
    TeamEvidenceSettings: {
      source_control_config?:
        | components['schemas']['TeamEvidenceSourceControlConfig']
        | null;
      /**
       * Allow Team Collection Creation
       * @default false
       */
      allow_team_collection_creation: boolean;
      /** Evidence Country */
      evidence_country?: string | null;
      /** Evidence Jurisdiction */
      evidence_jurisdiction?: string | null;
      /**
       * Enforce Evidence Country
       * @default false
       */
      enforce_evidence_country: boolean;
      /**
       * Enforce Evidence Jurisdiction
       * @default false
       */
      enforce_evidence_jurisdiction: boolean;
      /**
       * Enforce Clinical Suggestions
       * @default false
       */
      enforce_clinical_suggestions: boolean;
      /**
       * Hide Suggestions
       * @default false
       */
      hide_suggestions: boolean;
      /**
       * Default Library Enabled
       * @default false
       */
      default_library_enabled: boolean;
      /**
       * Chat Retention Enabled
       * @default false
       */
      chat_retention_enabled: boolean;
      /** Chat Retention Days */
      chat_retention_days?: number | null;
      /**
       * Enforce Chat Retention
       * @default false
       */
      enforce_chat_retention: boolean;
      /** Role Ids Can Access Evidence */
      role_ids_can_access_evidence?: string[];
      /** @default by_role */
      access_mode: components['schemas']['TeamEvidenceAccessMode'];
      /**
       * Library Grounded Chips Enabled
       * @description FDE-8: Team opt-in for library-grounded clinical suggestion chips. When True, team members on the Flagsmith release-ml-scribe-library-grounded-chips gate may receive chip suggestions grounded on vector search over the team's Evidence Library (with source_refs for inline PDF preview). When False (default), team members stay on today's ungrounded LLM-only chips regardless of the release flag. Complements the per-user AutoEvidenceConfig.library_grounding_enabled opt-in.
       * @default false
       */
      library_grounded_chips_enabled: boolean;
    };
    /**
     * TeamEvidenceSourceControlConfig
     * @description Configuration for which evidence source controls are available to team members.
     *
     *     The four ``*_enabled`` source toggles below are tri-state (``bool | None``)
     *     so callers can distinguish "team has never set this" (``None``) from "team
     *     explicitly disabled it" (``False``). This matters under an org cascade in
     *     the ``managed`` state (org enabled a source but did not force it): the
     *     backend deliberately does not write the org's value into the child team's
     *     config (EVI-2116), so a team whose admin never touched the toggle carries
     *     ``None`` and the FE seeds the displayed value from the org floor; a team
     *     whose admin saved ``False`` carries ``False`` and the FE respects it across
     *     reloads. Readers MUST treat ``None`` as fail-open (enabled), matching the
     *     pre-tri-state ``bool = True`` default — see ``evidence_enforcement.py`` and
     *     ``evidence_source_guardrails.py``.
     */
    TeamEvidenceSourceControlConfig: {
      /** Local Guidelines Enabled */
      local_guidelines_enabled?: boolean | null;
      /**
       * Local Guidelines Changeable
       * @default true
       */
      local_guidelines_changeable: boolean;
      /** Primary Evidence Enabled */
      primary_evidence_enabled?: boolean | null;
      /**
       * Primary Evidence Changeable
       * @default true
       */
      primary_evidence_changeable: boolean;
      /**
       * Library Enabled
       * @default true
       */
      library_enabled: boolean;
      /**
       * Library Changeable
       * @default true
       */
      library_changeable: boolean;
      /** Enforced Library Collection Ids */
      enforced_library_collection_ids?: string[] | null;
      /** Optional Library Collection Ids */
      optional_library_collection_ids?: string[] | null;
      /**
       * Library Collection Ids Changeable
       * @default true
       */
      library_collection_ids_changeable: boolean;
      /** Web Collections Enabled */
      web_collections_enabled?: boolean | null;
      /**
       * Web Collections Changeable
       * @default true
       */
      web_collections_changeable: boolean;
      /** Enforced Web Collection Ids */
      enforced_web_collection_ids?: string[] | null;
      /**
       * Web Collection Ids Changeable
       * @default true
       */
      web_collection_ids_changeable: boolean;
      /** Integration Partners Enabled */
      integration_partners_enabled?: boolean | null;
      /**
       * Integration Partners Changeable
       * @default true
       */
      integration_partners_changeable: boolean;
    };
    /**
     * TeamLevelAccessEntitlementsResponse
     * @description Effective team-level entitlements (team + parent org) for team admin listing.
     */
    TeamLevelAccessEntitlementsResponse: {
      /** Team Entitlements */
      team_entitlements: components['schemas']['UserEntitlementView'][];
    };
    /** TeamMFAInfo */
    TeamMFAInfo: {
      /** Org Id */
      org_id: string;
      set_by: components['schemas']['MFASetBY'];
      scope: components['schemas']['MFAScope'];
      method?: components['schemas']['MFAMethod'] | null;
    };
    /** TeamMFARequest */
    TeamMFARequest: {
      /** Enable Mfa */
      enable_mfa: boolean;
      mfa_method?: components['schemas']['MFAMethod'] | null;
    };
    /** TeamMember */
    TeamMember: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Name */
      name: string;
      /** Email */
      email: string | null;
      tier: components['schemas']['SubscriptionTier'] | null;
      /** Specialty */
      specialty: string;
      /** Specialty Id */
      specialty_id: string | null;
      user_role: components['schemas']['UserRole'];
      /** Invitation Accepted */
      invitation_accepted: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** User Ref Id */
      user_ref_id?: string | null;
      /** Invitation Expire At */
      invitation_expire_at?: string | null;
      display_language?: components['schemas']['LanguageCode'] | null;
      /** Invitation Id */
      invitation_id?: string | null;
      /** User Role List */
      user_role_list?: components['schemas']['RoleModel'][] | null;
    };
    /**
     * TeamMemberAccessEntitlementsListResponse
     * @description Per joined member effective entitlements (user + team + org merge).
     */
    TeamMemberAccessEntitlementsListResponse: {
      /** Members */
      members: components['schemas']['TeamMemberEntitlementsItem'][];
    };
    /**
     * TeamMemberEntitlementsItem
     * @description Entitlements for one joined team member (user + team + org merge, same as GET /access-entitlements).
     */
    TeamMemberEntitlementsItem: {
      /** User Ref Id */
      user_ref_id: string;
      /** Name */
      name: string;
      /** Email */
      email?: string | null;
      /** Entitlements */
      entitlements: components['schemas']['UserEntitlementView'][];
    };
    /** TeamMemberRelation */
    TeamMemberRelation: {
      team_member: components['schemas']['TeamMember'];
    };
    /** TeamMemberRelationsResponse */
    TeamMemberRelationsResponse: {
      /** Team Member Relations */
      team_member_relations: components['schemas']['TeamMemberRelation'][];
    };
    /** TeamMembersResponse */
    TeamMembersResponse: {
      /** Team Members */
      team_members: components['schemas']['MinimalTeamMember'][];
    };
    /**
     * TeamMembershipRole
     * @description Team-level ownership role for provisioning.
     * @enum {string}
     */
    TeamMembershipRole: TeamMembershipRole;
    /**
     * TeamModel
     * @description billing info should inherit info from User collection
     */
    TeamModel: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Kinde Org Code */
      kinde_org_code: string | null;
      /** Owner Kinde Id */
      owner_kinde_id: string | null;
      /** Country */
      country: string;
      /** Is Subscribed */
      is_subscribed: boolean;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Is Stripe Managed */
      is_stripe_managed: boolean;
      /** Charge Future Members */
      charge_future_members: boolean;
      /** Allow To Add Team Members */
      allow_to_add_team_members: boolean;
      /** Admin Session Review Toggle */
      admin_session_review_toggle: boolean;
      session_configuration: components['schemas']['TeamSessionConfiguration'];
      subscribed_plan: components['schemas']['SubscriptionTier'];
      tier: components['schemas']['SubscriptionTier'];
      plan_cycle?: components['schemas']['shared__enums__enums__Period'] | null;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      mfa_info?: components['schemas']['TeamMFAInfo'] | null;
      /** Team Members */
      team_members?: components['schemas']['TeamMember'][];
      /** Joined Team Members */
      joined_team_members?: components['schemas']['TeamMember'][];
      /**
       * Require Patient Consent
       * @default false
       */
      require_patient_consent: boolean;
      /** Custom Consent Text */
      custom_consent_text?: string | null;
      /**
       * Hide Remember Consent Checkbox
       * @default false
       */
      hide_remember_consent_checkbox: boolean;
      /**
       * Require Review Confirmation
       * @default false
       */
      require_review_confirmation: boolean;
      /**
       * Enable Patient Summary Generation
       * @default true
       */
      enable_patient_summary_generation: boolean;
      /**
       * Disable Auto Extract
       * @default false
       */
      disable_auto_extract: boolean;
      /**
       * Allow Direct Session Sharing
       * @description When False, direct session sharing is disabled for this team or organization; share creation is rejected. For teams inside an organization, the organization value applies.
       * @default true
       */
      allow_direct_session_sharing: boolean;
      /**
       * Allow Session Link Sharing
       * @description When False, session link sharing is disabled for this team; link share creation is rejected. For teams inside an organization, the organization value applies.
       * @default true
       */
      allow_session_link_sharing: boolean;
      /**
       * Session Sharing Locked By Org
       * @description True when the team sits inside an organization: the two sharing fields above then carry the organization's values and the team cannot change them.
       * @default false
       */
      session_sharing_locked_by_org: boolean;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      /** Onboarding Free Text */
      onboarding_free_text?: string | null;
      /** Go Live Time Stamp */
      go_live_time_stamp?: string | null;
      type?: components['schemas']['TeamType'] | null;
      /** Parent Id */
      parent_id?: string | null;
      /** Readonly Fields */
      readonly_fields?: components['schemas']['ReadOnlyField'][];
      /** Org Id */
      org_id?: string | null;
      /** Org Name */
      org_name?: string | null;
      /**
       * Workspace Id
       * @description Workspace this team belongs to. None until the workspace pointer is backfilled; for root teams the workspace id equals the team id (workspace_id == root_team_id).
       */
      workspace_id?: string | null;
      /** Disclaimer Text */
      disclaimer_text?: string | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      /** Is Pilot */
      is_pilot?: boolean | null;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[];
      /** External Sources */
      external_sources?: components['schemas']['ExternalSource'][];
      /**
       * Enable Export Header
       * @default false
       */
      enable_export_header: boolean;
      export_header_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /**
       * Enable Export Footer
       * @default false
       */
      enable_export_footer: boolean;
      export_footer_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /** @default FREE */
      evidence_tier: components['schemas']['EvidenceSubscriptionTier'];
      /**
       * Evidence Is Stripe Managed
       * @default false
       */
      evidence_is_stripe_managed: boolean;
      /** Evidence Plan End Date */
      evidence_plan_end_date?: string | null;
      /**
       * Evidence Access
       * @default false
       */
      evidence_access: boolean;
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
      org_team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
      new_product_tier?: components['schemas']['SubscriptionTier'] | null;
    };
    /**
     * TeamOrderBy
     * @description Allowed fields for ordering teams.
     *
     *     Only fields stored on the team document are sortable. ``owner_email`` and
     *     ``member_count`` are derived during response assembly, so they are not
     *     offered as sort options.
     * @enum {string}
     */
    TeamOrderBy: TeamOrderBy;
    /** TeamPatientRetentionUpdateRequest */
    TeamPatientRetentionUpdateRequest: {
      /**
       * @default {
       *       "enabled": false
       *     }
       */
      patient_retention_settings: components['schemas']['RetentionSettings'];
    };
    /** TeamRelationExport */
    TeamRelationExport: {
      /** Team Id */
      team_id: string;
      /** Role Ids */
      role_ids: string[];
    };
    /** TeamResponse */
    TeamResponse: {
      team: components['schemas']['TeamModel'];
      /** Onboarding Email Status */
      onboarding_email_status?: string | null;
      /**
       * Has Regulation Locked Member
       * @default false
       */
      has_regulation_locked_member: boolean;
    };
    /** TeamReviewConfirmationUpdateRequest */
    TeamReviewConfirmationUpdateRequest: {
      /** Require Review Confirmation */
      require_review_confirmation: boolean;
    };
    /** TeamSessionConfiguration */
    TeamSessionConfiguration: {
      /**
       * Allow View Others Sessions
       * @default true
       */
      allow_view_others_sessions: boolean;
      /** Roles Can View Others Sessions */
      roles_can_view_others_sessions?: components['schemas']['UserRole'][];
      /** Role Ids Can View Others Sessions */
      role_ids_can_view_others_sessions?: string[];
    };
    /** TeamSessionRetentionUpdateRequest */
    TeamSessionRetentionUpdateRequest: {
      /**
       * @default {
       *       "enabled": false
       *     }
       */
      session_retention_settings: components['schemas']['RetentionSettings'];
    };
    /**
     * TeamShortcutSchema
     * @description Response schema for a single team shortcut.
     */
    TeamShortcutSchema: {
      /**
       * Id
       * @description Shortcut id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Team Id
       * @description Team id this shortcut belongs to
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /**
       * Label
       * @description Short display label
       */
      label: string;
      /**
       * Query
       * @description Query sent to Evidence
       */
      query: string;
      /**
       * Description
       * @description Optional longer description (UI only; not sent as the query)
       */
      description?: string | null;
      /**
       * Created Time
       * Format: date-time
       * @description Creation timestamp (UTC)
       */
      created_time: string;
      /**
       * Updated Time
       * Format: date-time
       * @description Last update timestamp (UTC)
       */
      updated_time: string;
    };
    /** TeamTranscriptRetentionUpdateRequest */
    TeamTranscriptRetentionUpdateRequest: {
      /**
       * @default {
       *       "enabled": false
       *     }
       */
      transcript_retention_settings: components['schemas']['RetentionSettings'];
    };
    /**
     * TeamType
     * @enum {string}
     */
    TeamType: TeamType;
    /** TeamWorkflowListResponse */
    TeamWorkflowListResponse: {
      /** Workflows */
      workflows?: components['schemas']['TeamWorkflowSummaryResponse'][];
    };
    /** TeamWorkflowResponse */
    TeamWorkflowResponse: {
      /** Recording Id */
      recording_id: string;
      /** Team Id */
      team_id: string;
      /** Name */
      name: string;
      /** Workflow Name */
      workflow_name: string;
      /** Source Recording Id */
      source_recording_id: string;
      /** Created By */
      created_by: string;
      /** Promoted By */
      promoted_by: string;
      /**
       * Promoted At
       * Format: date-time
       */
      promoted_at: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      workflow_data: components['schemas']['WorkflowDataResponse'];
      /** Warnings */
      warnings?: components['schemas']['WorkflowDataWarning'][] | null;
    };
    /** TeamWorkflowSummaryResponse */
    TeamWorkflowSummaryResponse: {
      /** Recording Id */
      recording_id: string;
      /** Team Id */
      team_id: string;
      /** Name */
      name: string;
      /** Workflow Name */
      workflow_name: string;
      /** Source Recording Id */
      source_recording_id: string;
      /** Created By */
      created_by: string;
      /** Promoted By */
      promoted_by: string;
      /**
       * Promoted At
       * Format: date-time
       */
      promoted_at: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** TeamWorkspaceResponse */
    TeamWorkspaceResponse: {
      /** Team Id */
      team_id: string;
      /** Workspace Id */
      workspace_id: string;
    };
    /**
     * TemplateAuthorGroup
     * @enum {string}
     */
    TemplateAuthorGroup: TemplateAuthorGroup;
    /**
     * TemplateCategory
     * @enum {string}
     */
    TemplateCategory: TemplateCategory;
    /** TemplateChangedEvent */
    TemplateChangedEvent: {
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Consult Note Id */
      consult_note_id: string;
      /** User Name */
      user_name?: string | null;
      /** Template Name */
      template_name?: string | null;
      /** Original Note */
      original_note: string;
      /** Patches */
      patches?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      brain?: components['schemas']['Brain'] | null;
      /**
       * Type
       * @default template_changed
       * @constant
       */
      type: 'template_changed';
    };
    /** TemplateCreationRecordResponse */
    TemplateCreationRecordResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** User Ref Id */
      user_ref_id: string;
      /** Request */
      request?: string | null;
      trigger?: components['schemas']['CreateTemplateCreationRecordTrigger'] | null;
      /** Template Id */
      template_id: string | null;
      /** Selected Version Control Id */
      selected_version_control_id: string | null;
      /** Template Name */
      template_name?: string | null;
      /** Transcript */
      transcript: string | null;
      /** Transcript Session Id */
      transcript_session_id?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * TemplateCreationRecordSettingsRequest
     * @description Request schema for template creation record settings.
     */
    TemplateCreationRecordSettingsRequest: {
      preferred_tab?: components['schemas']['TemplateCreationRecordTab'] | null;
    };
    /**
     * TemplateCreationRecordSettingsResponse
     * @description Response schema for template creation record settings.
     */
    TemplateCreationRecordSettingsResponse: {
      /** @default example */
      preferred_tab: components['schemas']['TemplateCreationRecordTab'];
    };
    /**
     * TemplateCreationRecordTab
     * @description Preferred tab in template creation record editor.
     * @enum {string}
     */
    TemplateCreationRecordTab: TemplateCreationRecordTab;
    TemplateId: string | components['schemas']['AutoModeSentinel'];
    /** TemplateListResponse */
    TemplateListResponse: {
      /** Templates */
      templates: components['schemas']['TemplateResponse'][];
      /** Total Count */
      total_count?: number | null;
      /** Page */
      page: number;
      /** Page Size */
      page_size: number;
      /** Has More */
      has_more: boolean;
    };
    /** TemplateMappingResponse */
    TemplateMappingResponse: {
      /** Id */
      id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Template Id */
      template_id: string;
      /** Section Mappings */
      section_mappings: components['schemas']['SectionMappingRequest'][];
      /** Deleted At */
      deleted_at?: string | null;
      /** Created At */
      created_at: string;
      /** Updated At */
      updated_at: string;
    };
    /**
     * TemplateMatchType
     * @enum {string}
     */
    TemplateMatchType: TemplateMatchType;
    /**
     * TemplatePages
     * @enum {string}
     */
    TemplatePages: TemplatePages;
    /** TemplateResponse */
    TemplateResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Content */
      content: components['schemas']['VersionedTemplateContentResponse'][];
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      template_category: components['schemas']['TemplateCategory'];
      tags?: components['schemas']['TagsResponse'];
      /** Template Families */
      template_families: string[];
      pinned_for_tags?: components['schemas']['TagsResponse'];
      highlighted_for_tags?: components['schemas']['TagsResponse'];
      featured_for_tags?: components['schemas']['TagsResponse'];
      auto_generated_for_tags?: components['schemas']['TagsResponse'];
      /** Deleted At */
      deleted_at?: string | null;
      /**
       * Should Deduct Quota
       * @default false
       */
      should_deduct_quota: boolean;
      /** Prompteams Id */
      prompteams_id?: string | null;
      /** List Order Priority */
      list_order_priority?: number | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /** TemplateResponseV2 */
    TemplateResponseV2: {
      /**
       * Is Private
       * @default true
       */
      is_private: boolean;
      /** Team Id */
      team_id?: string | null;
      /** @default User */
      template_author_group: components['schemas']['TemplateAuthorGroup'] | null;
      /** @default User */
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Source Template Id */
      source_template_id?: string | null;
      /**
       * Template Gallery Sharing Preference Show Name
       * @default true
       */
      template_gallery_sharing_preference_show_name: boolean;
      /**
       * Template Gallery Sharing Preference Show Clinic
       * @default true
       */
      template_gallery_sharing_preference_show_clinic: boolean;
      /**
       * Template Gallery Sharing Preference Show Profile Picture
       * @default true
       */
      template_gallery_sharing_preference_show_profile_picture: boolean;
      /**
       * Shared Team Ids
       * @description An array of team_ids that the template is shared with
       */
      shared_team_ids?: string[] | null;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Created Time */
      created_time?: string | null;
      /** Updated Time */
      updated_time?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      /** Template Gallery Url Path */
      template_gallery_url_path?: string | null;
      /**
       * Is Structured Template
       * @default false
       */
      is_structured_template: boolean;
      /**
       * Global Last Used
       * @description Last time the template was used by any user (global usage timestamp)
       */
      global_last_used?: string | null;
      /**
       * Global Usage
       * @description Total number of times the template has been used across all users (global usage counter)
       * @default 0
       */
      global_usage: number;
      /** Last Modified Ia Feedback Loop */
      last_modified_ia_feedback_loop?: string | null;
      /** Name */
      name: string;
      /**
       * Structure Template
       * @default
       */
      structure_template: string;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** @default pdf */
      form_format: components['schemas']['FormFormat'];
      /** Xml Source */
      xml_source?: string | null;
      /** Json Source */
      json_source?: string | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /** List Order Priority */
      list_order_priority?: number | null;
      /**
       * Should Deduct Quota
       * @default true
       */
      should_deduct_quota: boolean;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Organization Id
       * @description The organization_id the template belongs to
       */
      organization_id?: string | null;
      /**
       * Workspace Id
       * @description The workspace_id the template belongs to
       */
      workspace_id?: string | null;
      /** Is Well Formatted */
      is_well_formatted?: boolean | null;
      /** Llm Eval */
      llm_eval?: string | null;
      id: components['schemas']['TemplateId'];
      /**
       * Usage
       * @default 0
       */
      usage: number;
      /**
       * Is Favorite
       * @default false
       */
      is_favorite: boolean;
      /** Added To Favorite At */
      added_to_favorite_at?: string | null;
      /**
       * Is Pinned
       * @default false
       */
      is_pinned: boolean;
      /** Added To Pinned At */
      added_to_pinned_at?: string | null;
      /** Pinned Sort Order */
      pinned_sort_order?: number | null;
      /** Last Used */
      last_used?: string | null;
      /**
       * Is Editable
       * @default false
       */
      is_editable: boolean;
      /**
       * Is Publishable
       * @default false
       */
      is_publishable: boolean;
      /**
       * Author Name
       * @default
       */
      author_name: string;
      review_status?: components['schemas']['TemplateReviewStatus'] | null;
      /**
       * Internal
       * @default false
       */
      internal: boolean;
      /**
       * Pdf Url
       * @description Presigned URL to access the PDF file for form templates. Valid for 1 hour.
       */
      pdf_url?: string | null;
      /**
       * Creator Name
       * @description User full name of the creator of the template; difference with author_name: author_name sometimes is the name of the team who created the template, creator_name is the name of the user who created the template
       */
      creator_name?: string | null;
    };
    /**
     * TemplateReviewStatus
     * @enum {string}
     */
    TemplateReviewStatus: TemplateReviewStatus;
    /**
     * TemplateSearchFilterMetadataResponse
     * @description Response schema for template search filter metadata endpoint.
     */
    TemplateSearchFilterMetadataResponse: {
      /**
       * Creators
       * @description A map of creator user IDs to their display names
       */
      creators: {
        [key: string]: string;
      };
      /**
       * Teams
       * @description A map of team IDs to their team names, including org team it self
       */
      teams: {
        [key: string]: string;
      };
    };
    /** TemplateSectionMappingResponse */
    TemplateSectionMappingResponse: {
      /** Template Id */
      template_id: string;
      /** Section Mappings */
      section_mappings: components['schemas']['SectionLink'][];
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * TemplateSortBy
     * @enum {string}
     */
    TemplateSortBy: TemplateSortBy;
    /**
     * TemplateType
     * @enum {string}
     */
    TemplateType: TemplateType;
    /** TemplateVersionControlResponse */
    TemplateVersionControlResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Template Creation Record Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_creation_record_id: string;
      /** Template Structure */
      template_structure: string;
      /** Chat Query */
      chat_query: string | null;
      /** Example Note */
      example_note: string | null;
      /** Use Sections */
      use_sections?: boolean | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /** TemplateVersionSummariesRequest */
    TemplateVersionSummariesRequest: {
      /** Template Ids */
      template_ids: string[];
    };
    /** TemplateVersionSummariesResponse */
    TemplateVersionSummariesResponse: {
      /** Summaries */
      summaries: components['schemas']['TemplateVersionSummaryItem'][];
    };
    /** TemplateVersionSummaryItem */
    TemplateVersionSummaryItem: {
      /** Template Id */
      template_id: string;
      /** Active Version Number */
      active_version_number?: number | null;
      /**
       * Version Count
       * @default 0
       */
      version_count: number;
    };
    /** TemplateVersionSummaryResponse */
    TemplateVersionSummaryResponse: {
      /** Active Version Number */
      active_version_number?: number | null;
      /**
       * Version Count
       * @default 0
       */
      version_count: number;
    };
    /**
     * TemplateVisibility
     * @enum {string}
     */
    TemplateVisibility: TemplateVisibility;
    /** TenantScopeModel */
    TenantScopeModel: {
      /**
       * Kind
       * @enum {string}
       */
      kind: TenantScopeModelKind;
      /** Id */
      id?: string | null;
    };
    /**
     * TestCasesUpdateRequest
     * @description Update ONLY a protocol's bench test cases. Test cases are validation evidence, not firing
     *     behaviour, and like every edit this writes the working draft only — the live version is
     *     untouched. The safety floor (a safety-critical protocol needs a safety-positive 'fire' case)
     *     is enforced at publish, on the would-be live snapshot.
     */
    TestCasesUpdateRequest: {
      /** Test Cases */
      test_cases?: components['schemas']['ProtocolTestCaseModel'][];
    };
    /**
     * TextBlock
     * @description Plain assistant or user text content.
     */
    TextBlock: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: TextBlockKind;
      /** Text */
      text: string;
      /** Provider Metadata */
      provider_metadata?: {
        [key: string]: unknown;
      };
    };
    /**
     * Theme
     * @enum {string}
     */
    Theme: Theme;
    /**
     * ThinkingBlock
     * @description Provider-emitted reasoning/thinking content (Anthropic / Gemini).
     */
    ThinkingBlock: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: ThinkingBlockKind;
      /** Text */
      text: string;
      /** Provider Metadata */
      provider_metadata?: {
        [key: string]: unknown;
      };
    };
    /** ThirdPartyLicenceDetails */
    ThirdPartyLicenceDetails: {
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Free Trial Days */
      free_trial_days?: number | null;
      /** Trial End Date */
      trial_end_date?: string | null;
      /** @default PRO_PLUS */
      latest_tier: components['schemas']['SubscriptionTier'] | null;
      /** @default FREE */
      evidence_tier: components['schemas']['EvidenceSubscriptionTier'];
    };
    /**
     * ThirdPartyLicenseMetadata
     * @description Type-specific metadata for THIRD_PARTY_LICENSE subscriptions.
     */
    ThirdPartyLicenseMetadata: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: ThirdPartyLicenseMetadataKind;
      /** Ehr Provider */
      ehr_provider?: string | null;
    };
    /** ThirdPartyLicenseResponse */
    ThirdPartyLicenseResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /**
     * ThumbRating
     * @enum {string}
     */
    ThumbRating: ThumbRating;
    /**
     * TicketAttributeValue
     * @description A single ticket attribute (Intercom custom field) for display.
     */
    TicketAttributeValue: {
      /** Label */
      label: string;
      /** Value */
      value: string;
    };
    /**
     * TicketDetail
     * @description Full ticket detail returned when opening a ticket modal.
     */
    TicketDetail: {
      /** Id */
      id: string;
      /** Platform */
      platform: string;
      /** Platform Url */
      platform_url?: string | null;
      /** Title */
      title: string;
      /** Description */
      description?: string | null;
      /** Status */
      status: string;
      /** Team */
      team?: string | null;
      /** Assignee */
      assignee?: string | null;
      /** Created At */
      created_at: string;
      /** Ticket Type */
      ticket_type: string;
      /**
       * Messages
       * @default []
       */
      messages: components['schemas']['TicketMessage'][];
      /**
       * Ticket Attributes
       * @default []
       */
      ticket_attributes: components['schemas']['TicketAttributeValue'][];
    };
    /**
     * TicketField
     * @description Unified form field descriptor - platform agnostic.
     */
    TicketField: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Data Type */
      data_type: string;
      /**
       * Required
       * @default false
       */
      required: boolean;
      /** Default Value */
      default_value?: string | boolean | null;
      /** Description */
      description?: string | null;
      /**
       * Order
       * @default 0
       */
      order: number;
      /** Options */
      options?: components['schemas']['TicketFieldOption'][] | null;
      /** Hubspot Entity Type */
      hubspot_entity_type?: string | null;
      /**
       * Conditions
       * @default []
       */
      conditions: components['schemas']['TicketFieldCondition'][];
      /** Auto Populate From */
      auto_populate_from?: string | null;
      /** Placeholder */
      placeholder?: string | null;
    };
    /**
     * TicketFieldCondition
     * @description A single show-if condition on a ticket field.
     *
     *     A field is visible when ALL of its conditions evaluate to true.
     *     Each condition checks that another field (identified by ``field_id``)
     *     currently has one of ``values``.
     */
    TicketFieldCondition: {
      /** Field Id */
      field_id: string;
      /** Values */
      values: string[];
    };
    /** TicketFieldOption */
    TicketFieldOption: {
      /** Id */
      id: string;
      /** Label */
      label: string;
    };
    /**
     * TicketFormat
     * @description A normalized ticket template the frontend can render.
     */
    TicketFormat: {
      /** Slug */
      slug: string;
      /** Name */
      name: string;
      /** Description */
      description?: string | null;
      /** Use When */
      use_when?: string | null;
      /**
       * Examples
       * @default []
       */
      examples: string[];
      /**
       * Not For
       * @default []
       */
      not_for: string[];
      /** Platform */
      platform: string;
      /** Warning Banner */
      warning_banner?: string | null;
      /** Cc Message */
      cc_message?: string | null;
      /** Fields */
      fields: components['schemas']['TicketField'][];
      /**
       * Platform Metadata
       * @default {}
       */
      platform_metadata: {
        [key: string]: unknown;
      };
    };
    /**
     * TicketMessage
     * @description A single message/note/comment in a ticket conversation thread.
     */
    TicketMessage: {
      /** Id */
      id: string;
      /** Author Name */
      author_name: string;
      /** Author Email */
      author_email?: string | null;
      /** Body */
      body: string;
      /** Created At */
      created_at: string;
      /** Message Type */
      message_type: string;
    };
    /**
     * TicketSummary
     * @description Unified ticket view for My Tickets / Customer Tickets tabs.
     */
    TicketSummary: {
      /** Id */
      id: string;
      /** Platform */
      platform: string;
      /** Platform Url */
      platform_url?: string | null;
      /** Title */
      title: string;
      /** Status */
      status: string;
      /** Team */
      team?: string | null;
      /** Assignee */
      assignee?: string | null;
      /** Created At */
      created_at: string;
      /** Ticket Type */
      ticket_type: string;
      /** Created By */
      created_by?: string | null;
    };
    /**
     * TimeZones
     * @enum {string}
     */
    TimeZones: TimeZones;
    /** TimestampedTranscript */
    TimestampedTranscript: {
      /** Start */
      start: string;
      /** End */
      end: string;
      /** Words */
      words: string;
    };
    /**
     * Timing
     * @description Specifies an event that may occur multiple times.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Timing
     */
    Timing: {
      /**
       * When the event occurs
       * @description Identifies specific times when the event occurs.
       */
      event?: string[] | null;
      /**
       * When the event is to occur
       * @description A set of rules that describe when the event is scheduled.
       */
      repeat?: components['schemas']['TimingRepeat'] | null;
      /**
       * BID | TID | QID | AM | PM | QD | QOD | +
       * @description A code for the timing schedule (or just text in code.text). A repeat should always be defined except for the common codes BID, TID, QID, AM and PM, which all systems are required to understand.
       */
      code?: components['schemas']['CodeableConcept'] | null;
    };
    /**
     * TimingRepeat
     * @description A set of rules that describe when the event is scheduled.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Timing.repeat
     */
    TimingRepeat: {
      /**
       * Length/Range of lengths, or (Start and/or end) limits
       * @description Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
       */
      boundsDuration?: components['schemas']['Duration'] | null;
      /**
       * Length/Range of lengths, or (Start and/or end) limits
       * @description Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
       */
      boundsRange?: components['schemas']['Range'] | null;
      /**
       * Length/Range of lengths, or (Start and/or end) limits
       * @description Either a duration for the length of the timing schedule, a range of possible length, or outer bounds for start and/or end limits of the timing schedule.
       */
      boundsPeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Number of times to repeat
       * @description A total count of the desired number of repetitions across the duration of the entire timing specification.
       */
      count?: number | null;
      /**
       * Maximum number of times to repeat
       * @description If present, indicates that the count is a range - so to perform the action between [count] and [countMax] times.
       */
      countMax?: number | null;
      /**
       * How long when it happens
       * @description How long this thing happens for when it happens. If durationMax is present, this element indicates the lower bound of the allowed range of the duration.
       */
      duration?: number | null;
      /**
       * How long when it happens (Max)
       * @description If present, indicates that the duration is a range - so to perform the action between [duration] and [durationMax] time length.
       */
      durationMax?: number | null;
      /**
       * s | min | h | d | wk | mo | a - unit of time (UCUM)
       * @description The units of time for the duration, in UCUM units.
       */
      durationUnit?: components['schemas']['UnitsOfTime'] | null;
      /**
       * Event occurs frequency times per period
       * @description The number of times to repeat the action within the specified period. If frequencyMax is present, this element indicates the lower bound of the allowed range of the frequency.
       */
      frequency?: number | null;
      /**
       * Event occurs up to frequencyMax times per period
       * @description If present, indicates that the frequency is a range - so to repeat between [frequency] and [frequencyMax] times within the period or period range.
       */
      frequencyMax?: number | null;
      /**
       * Event occurs frequency times per period
       * @description Indicates the duration of time over which repetitions are to occur; e.g. to express '3 times per day', 3 would be the frequency and '1 day' would be the period. If periodMax is present, this element indicates the lower bound of the allowed range of the period length.
       */
      period?: number | null;
      /**
       * Upper limit of period (3-4 hours)
       * @description If present, indicates that the period is a range from [period] to [periodMax], allowing expressing concepts such as 'do this once every 3-5 days.'
       */
      periodMax?: number | null;
      /**
       * s | min | h | d | wk | mo | a - unit of time (UCUM)
       * @description The units of time for the period in UCUM units.
       */
      periodUnit?: components['schemas']['UnitsOfTime'] | null;
      /**
       * mon | tue | wed | thu | fri | sat | sun
       * @description If one or more days of week is provided, then the action happens only on the specified day(s).
       */
      dayOfWeek?: components['schemas']['DayOfWeek'][] | null;
      /**
       * Time of day for action
       * @description Specified time of day for action to take place.
       */
      timeOfDay?: string[] | null;
      /**
       * Code for time period of occurrence
       * @description An approximate time period during the day, potentially linked to an event of daily living that indicates when the action should occur.
       */
      when?: components['schemas']['EventTiming'][] | null;
      /**
       * Minutes from event (before or after)
       * @description The number of minutes from the event. If the event code does not indicate whether the minutes is before or after the event, then the offset is assumed to be after the event.
       */
      offset?: number | null;
    };
    /**
     * TitleCode
     * @enum {string}
     */
    TitleCode: TitleCode;
    /**
     * TogglePersonalizationInsightRequest
     * @description Request to toggle a single personalization insight.
     */
    TogglePersonalizationInsightRequest: {
      category: components['schemas']['PersonalizationCategory'];
      /** Rule */
      rule: string;
      /** Should Use */
      should_use: boolean;
    };
    /** TogglePrechartingResponse */
    TogglePrechartingResponse: {
      /** Is Precharting Enabled */
      is_precharting_enabled: boolean;
    };
    /**
     * TokenInfo
     * @description Token claims extracted from Kinde and Auth0 Scribe access tokens.
     *
     *     This model is used exclusively for the main Scribe application user authentication
     *     flow. It is NOT used for:
     *     - Internal admin tokens (see InternalAdminTokenClaims)
     *     - EHR/Open API tokens (see EHRTokenInfo)
     *
     *     Note: when adding new critical additional field, remember to consider updating the merge_token_info_and_properties function.
     *
     *     PII discipline: `email`, `first_name`, and `last_name` are sensitive
     *     healthcare-provider identifiers under HIPAA. The model_config below
     *     redacts them from Pydantic's ValidationError messages so a stray
     *     validation failure doesn't dump them into logs / Sentry breadcrumbs.
     *     Do NOT call `token_info.model_dump()` (or any `repr()`) inside a log
     *     line, exception trace, or telemetry attribute — use
     *     `token_info_log_extra(token_info)` (see `service.auth.observability`)
     *     which projects to non-PII fields only.
     */
    TokenInfo: {
      /** Kinde User Id */
      kinde_user_id: string;
      /** User Ref Id */
      user_ref_id?: string | null;
      /** Org Code */
      org_code: string;
      /** Expiration Timestamp */
      expiration_timestamp: number;
      /** Sso Connection Id */
      sso_connection_id?: string | null;
      /** Epic User Id */
      epic_user_id?: string | null;
      /** Sso Groups */
      sso_groups?: string[] | null;
      /** Region */
      region?: string | null;
      /** Is Social Login */
      is_social_login?: boolean | null;
      /** Email */
      email?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Ent Workspaces */
      ent_workspaces?: string[] | null;
      /** Ent Only */
      ent_only?: boolean | null;
    };
    /**
     * TokenRequest
     * @description ``POST /webhooks/token`` request body.
     *
     *     Used when credentials are provided in the JSON body rather than
     *     via HTTP Basic Auth.
     */
    TokenRequest: {
      /** Client Id */
      client_id: string;
      /** Client Secret */
      client_secret: string;
      /**
       * Grant Type
       * @description Must be 'client_credentials'.
       * @default client_credentials
       * @constant
       */
      grant_type: 'client_credentials';
    };
    /** TokenResponse */
    TokenResponse: {
      /** Access Token */
      access_token: string;
      /**
       * Token Type
       * @default Bearer
       * @constant
       */
      token_type: 'Bearer';
      /** Expires In */
      expires_in: number;
    };
    /**
     * TokenUsage
     * @description Provider-normalized token usage for a single LLM turn.
     *
     *     ``cache_creation_input_tokens`` is the Anthropic aggregate write count.
     *     When the provider reports a TTL split, ``cache_creation_5m_input_tokens``
     *     / ``cache_creation_1h_input_tokens`` hold that breakdown for list-price
     *     write billing (1.25x vs 2x).
     */
    TokenUsage: {
      /**
       * Input Tokens
       * @default 0
       */
      input_tokens: number;
      /**
       * Output Tokens
       * @default 0
       */
      output_tokens: number;
      /**
       * Cache Creation Input Tokens
       * @default 0
       */
      cache_creation_input_tokens: number;
      /**
       * Cache Creation 5M Input Tokens
       * @default 0
       */
      cache_creation_5m_input_tokens: number;
      /**
       * Cache Creation 1H Input Tokens
       * @default 0
       */
      cache_creation_1h_input_tokens: number;
      /**
       * Cache Read Input Tokens
       * @default 0
       */
      cache_read_input_tokens: number;
      /**
       * Thinking Tokens
       * @default 0
       */
      thinking_tokens: number;
    };
    /**
     * ToolApprovalRequestPublic
     * @description Subject-safe projection of a generic harness tool approval.
     */
    ToolApprovalRequestPublic: {
      /** Approval Id */
      approval_id: string;
      /** Agent Run Id */
      agent_run_id: string;
      /** Turn Id */
      turn_id: string;
      /** Tool Call Id */
      tool_call_id: string;
      /** Tool Name */
      tool_name: string;
      /** Tool Input */
      tool_input: {
        [key: string]: unknown;
      };
      /** Redacted Tool Input Keys */
      redacted_tool_input_keys?: string[];
      /** Status */
      status: string;
      /** Reason */
      reason: string;
      /** Modified Input */
      modified_input?: {
        [key: string]: unknown;
      } | null;
      /**
       * Approval Kind
       * @default default
       */
      approval_kind: string;
      /**
       * Available Override Scopes
       * @description Override scopes the client may send on :resolve. 'session' = allow this tool for the rest of the run; absent for clarifications.
       */
      available_override_scopes?: ToolApprovalRequestPublicAvailable_override_scopes[];
      /**
       * Context
       * @description Server-authored metadata for approval UI rendering. Always contains 'tool_call_display' ({title: str, detail?: str}): the persisted display when available, otherwise a server-humanized fallback derived from tool_name — clients should render this instead of deriving display names from the raw tool_name.
       */
      context?: {
        [key: string]: unknown;
      };
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Resolved At */
      resolved_at?: string | null;
      /** Resolved By */
      resolved_by?: string | null;
    };
    /**
     * ToolCallBlock
     * @description A tool call proposed by the assistant in canonical form.
     */
    ToolCallBlock: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: ToolCallBlockKind;
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Input */
      input?: {
        [key: string]: unknown;
      };
      input_merge?: components['schemas']['ToolInputMerge'] | null;
      /** Provider Metadata */
      provider_metadata?: {
        [key: string]: unknown;
      };
    };
    /**
     * ToolCallBlockView
     * @description ``tool_call`` block plus the proposing assistant artefact's timestamp.
     */
    ToolCallBlockView: {
      /** Created At */
      created_at?: string | null;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: ToolCallBlockViewKind;
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Input */
      input?: {
        [key: string]: unknown;
      };
      input_merge?: components['schemas']['ToolInputMerge'] | null;
      /** Provider Metadata */
      provider_metadata?: {
        [key: string]: unknown;
      };
    };
    /**
     * ToolCallDisplay
     * @description Small display object authored by the model for a tool invocation.
     */
    ToolCallDisplay: {
      /** Title */
      title: string;
      /** Detail */
      detail?: string | null;
    };
    /**
     * ToolInputMerge
     * @description Top-level provenance for effective tool input.
     *
     *     ``source_by_key`` tells the FE which top-level keys came from the LLM
     *     versus operator-configured ``AgentToolConfig.fixed_input`` bindings.
     *     ``llm_input`` preserves the model's raw values so the FE can render a
     *     diff for keys an operator-bound config overwrote.
     *
     *     The raw ``fixed_input`` bindings are intentionally not carried here:
     *     operator-configured values can hold credentials or internal identifiers
     *     (they are deliberately stripped from the LLM's ``input_schema`` for the
     *     same reason). The effective input on the parent ``ToolCallBlock.input``
     *     already carries the merged values the tool ran with — anything beyond
     *     that would re-expose admin-bound config to the browser via the SSE
     *     stream and to long-term storage via the persisted transcript.
     */
    ToolInputMerge: {
      /** Llm Input */
      llm_input?: {
        [key: string]: unknown;
      };
      /** Source By Key */
      source_by_key?: {
        [key: string]: ToolInputMergeSource_by_key;
      };
    };
    /**
     * ToolResultBlock
     * @description The result of executing a tool call, attached to a user message.
     */
    ToolResultBlock: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: ToolResultBlockKind;
      /** Tool Call Id */
      tool_call_id: string;
      /** Content */
      content?: unknown | null;
      /** Attachments */
      attachments?: components['schemas']['AttachmentBlock'][];
      /**
       * Is Error
       * @default false
       */
      is_error: boolean;
      /** Provider Metadata */
      provider_metadata?: {
        [key: string]: unknown;
      };
    };
    /**
     * ToolResultBlockView
     * @description ``tool_result`` block plus the tool-execution artefact's timestamp.
     */
    ToolResultBlockView: {
      /** Created At */
      created_at?: string | null;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: ToolResultBlockViewKind;
      /** Tool Call Id */
      tool_call_id: string;
      /** Content */
      content?: unknown | null;
      /** Attachments */
      attachments?: components['schemas']['AttachmentBlock'][];
      /**
       * Is Error
       * @default false
       */
      is_error: boolean;
      /** Provider Metadata */
      provider_metadata?: {
        [key: string]: unknown;
      };
    };
    /** ToolSpecResponse */
    ToolSpecResponse: {
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Risk */
      risk: string;
      /** Requires Confirmation */
      requires_confirmation: boolean;
      /** Confirmation Policy */
      confirmation_policy?: string | null;
      /** Tags */
      tags: string[];
      /** Input Schema */
      input_schema: {
        [key: string]: unknown;
      };
      /** Presetable Fields */
      presetable_fields: string[];
    };
    /**
     * ToolWaitRecord
     * @description Durable, FE-visible state for a workflow-owned tool wait.
     */
    ToolWaitRecord: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Turn Id */
      turn_id: string;
      /** Iteration */
      iteration: number;
      /** Tool Call Id */
      tool_call_id: string;
      /** Tool Name */
      tool_name: string;
      /** Event Id */
      event_id: string;
      /**
       * Kind
       * @default tool
       */
      kind: string;
      /**
       * Status
       * @default pending
       * @enum {string}
       */
      status: ToolWaitRecordStatus;
      /**
       * Description
       * @default
       */
      description: string;
      /** Allowed Kinds */
      allowed_kinds?: string[];
      /** Deadline */
      deadline?: string | null;
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      };
      /** Result Fingerprint */
      result_fingerprint?: string | null;
      /** Result Dispatched At */
      result_dispatched_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Resolved At */
      resolved_at?: string | null;
    };
    /** TopupRequest */
    TopupRequest: {
      /** Workspace Id */
      workspace_id: string;
      /** Amount */
      amount: number | string;
      /**
       * Currency
       * @default heidi_credit
       */
      currency: string;
    };
    /** TrackBulkUploadRequest */
    TrackBulkUploadRequest: {
      /** Bulkuploadid */
      bulkUploadId: string;
      /** Success */
      success: boolean;
      /**
       * Segmentcount
       * @default 0
       */
      segmentCount: number;
      /**
       * Persistedmessagecount
       * @default 0
       */
      persistedMessageCount: number;
      /**
       * Failedsegmentcount
       * @default 0
       */
      failedSegmentCount: number;
      failedStage?: components['schemas']['BulkUploadFailedStage'] | null;
      errorCode?: components['schemas']['BulkUploadErrorCode'] | null;
      /** Filemimetype */
      fileMimeType?: string | null;
      /** Filesizebytes */
      fileSizeBytes?: number | null;
      /** Audiodurationseconds */
      audioDurationSeconds?: number | null;
      /** Totaldurationms */
      totalDurationMs?: number | null;
    };
    /**
     * TrackSignInRequestDTO
     * @description Request DTO for track sign-in endpoint.
     *
     *     Called by Auth0 post-login Actions to record a successful sign-in event.
     * @example {
     *       "auth_type": "email",
     *       "kinde_user_id": "kp_abc123"
     *     }
     */
    TrackSignInRequestDTO: {
      /**
       * Kinde User Id
       * @description The user's Kinde user ID
       */
      kinde_user_id: string;
      /**
       * Auth Type
       * @description Authentication method used (e.g. 'email', 'google-oauth2', 'sso', 'passwordless')
       */
      auth_type?: string | null;
    };
    /**
     * TranScriptServerHost
     * @enum {string}
     */
    TranScriptServerHost: TranScriptServerHost;
    /**
     * TransactionSource
     * @description Why a movement happened — the origin category the direction alone can't
     *     carry.
     *
     *     `initial` seeds a wallet; `topup` is a purchase; `scheduled`/`reset` come
     *     from the recurring cycle; `refund`/`clawback`/`adjust` are admin actions;
     *     `expire` lapses credit; `consumption` is a metered burn.
     * @enum {string}
     */
    TransactionSource: TransactionSource;
    /**
     * TransactionType
     * @description A ledger movement's direction. `amount` is always a positive magnitude;
     *     this enum carries the direction (CREDIT raises the balance, DEBIT lowers it)
     *     and `WalletTransaction.signed_amount` derives the signed value.
     * @enum {string}
     */
    TransactionType: TransactionType;
    /** TranscribeChunkResponse */
    TranscribeChunkResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /**
     * TranscribeMode
     * @enum {string}
     */
    TranscribeMode: TranscribeMode;
    /**
     * TranscriberConfigForInternalAdmin
     * @enum {string}
     */
    TranscriberConfigForInternalAdmin: TranscriberConfigForInternalAdmin;
    /**
     * Transcript
     * @description Transcript data with speaker turns.
     *
     *     Turn ``start_time``/``end_time`` are ``hh:mm:ss`` offsets from
     *     ``start_date_time``. Serialisation to the Epic wire format
     *     (ISO-8601 / ``hh:mm:ss`` strings) is handled at the API layer.
     */
    Transcript: {
      /** Startdatetime */
      startDateTime?: string | null;
      /** Speakercount */
      speakerCount?: string | null;
      /** Turns */
      turns: components['schemas']['Turn'][];
    };
    /**
     * TranscriptChipsRequestSchema
     * @description Request schema for generating suggested chips.
     */
    TranscriptChipsRequestSchema: {
      /**
       * Session Id
       * @description Session ID for the consultation
       */
      session_id: string;
      /**
       * Transcript Chunk
       * @description New transcript content since last request
       */
      transcript_chunk: string;
      /**
       * Full Transcript
       * @description Full transcript for context (optional)
       */
      full_transcript?: string | null;
      /**
       * Previous Chips Hash
       * @description Hash of previous chips for diff detection
       */
      previous_chips_hash?: string | null;
      /**
       * Enabled Categories
       * @description Filter to specific categories (all if not provided)
       */
      enabled_categories?: components['schemas']['SuggestedChipCategory'][] | null;
      /**
       * Max Chips
       * @description Maximum number of chips to return
       * @default 5
       */
      max_chips: number;
      /**
       * Is Page Refresh
       * @description Set to true when refreshing page on existing session. Allows empty transcript_chunk and uses full_transcript instead.
       * @default false
       */
      is_page_refresh: boolean;
      /**
       * Patient Profile Id
       * @description Patient profile ID for patient-context chips when no transcript is available.
       */
      patient_profile_id?: string | null;
    };
    /**
     * TranscriptChipsResponseSchema
     * @description Response schema containing suggested chips.
     */
    TranscriptChipsResponseSchema: {
      /**
       * Chips
       * @description List of suggested query chips
       */
      chips?: components['schemas']['SuggestedChipSchema'][];
      /**
       * Has Update
       * @description True if chips differ from previous response
       * @default false
       */
      has_update: boolean;
      /**
       * Chips Hash
       * @description Hash of current chips for deduplication
       */
      chips_hash?: string | null;
      /**
       * Source Refs
       * @description FDE-8: library-grounding source references. Chip ``source_ref_ids`` index into this list. Empty on the ungrounded fallback path.
       */
      source_refs?: components['schemas']['SourceRefSchema'][];
      /**
       * Is Library Grounded
       * @description FDE-8: true when chips were grounded on a library vector search. False for ungrounded / graceful-fallback responses.
       * @default false
       */
      is_library_grounded: boolean;
    };
    /**
     * TranscriptInUse
     * @description Audio source for transcription
     * @enum {string}
     */
    TranscriptInUse: TranscriptInUse;
    /** TranscriptReference */
    TranscriptReference: {
      /** Transcript Text */
      transcript_text: string;
      location_in_transcript: components['schemas']['InTextLocation'];
    };
    /** TranscriptResponse */
    TranscriptResponse: {
      /**
       * Timestamped Transcript
       * @default []
       */
      timestamped_transcript: components['schemas']['TimestampedTranscript'][];
    };
    /** TranscriptServiceDetails */
    TranscriptServiceDetails: {
      service_provider?: components['schemas']['TranscriptServiceProvider'] | null;
      server_host?: components['schemas']['TranScriptServerHost'] | null;
      source?: components['schemas']['TranscriptSource'] | null;
    };
    /**
     * TranscriptServiceProvider
     * @enum {string}
     */
    TranscriptServiceProvider: TranscriptServiceProvider;
    /**
     * TranscriptSource
     * @enum {string}
     */
    TranscriptSource: TranscriptSource;
    /** TranscriptStorageDaysResponse */
    TranscriptStorageDaysResponse: {
      /** Transcript Storage Days */
      transcript_storage_days: number | null;
    };
    /** TranscriptTurnView */
    TranscriptTurnView: {
      /** Role */
      role: string;
      /** Content */
      content: string;
      /** Start Time */
      start_time?: number | null;
    };
    /**
     * TranscriptionFeedbackStatus
     * @description Status of transcription feedback sent to FE live during recording
     * @enum {string}
     */
    TranscriptionFeedbackStatus: TranscriptionFeedbackStatus;
    /**
     * TransitionParam
     * @enum {string}
     */
    TransitionParam: TransitionParam;
    /**
     * TranslationModel
     * @enum {string}
     */
    TranslationModel: TranslationModel;
    /**
     * TranslatorAudioKind
     * @description Origin of an audio blob tracked by ``TranslatorAudioRecording``.
     * @enum {string}
     */
    TranslatorAudioKind: TranslatorAudioKind;
    /**
     * TranslatorEvaluationErrorPayload
     * @description Wire representation of one translator evaluation error.
     *
     *     Unknown fields are ignored rather than rejected, like every other request
     *     schema here: the rater's frontend and this service deploy separately, so a
     *     field added ahead of the backend must not fail the whole submission.
     */
    TranslatorEvaluationErrorPayload: {
      stage: components['schemas']['EvaluationErrorStage'];
      /** Errortypes */
      errorTypes: components['schemas']['EvaluationErrorType'][];
      severity: components['schemas']['EvaluationErrorSeverity'];
      /** Isclinical */
      isClinical: boolean;
      /** Note */
      note?: string | null;
    };
    /** TriageChatMessageView */
    TriageChatMessageView: {
      /** Role */
      role: string;
      /** Content */
      content: string;
      /** Timestamp */
      timestamp: string;
      /** Tool Name */
      tool_name?: string | null;
      /** Status */
      status?: string | null;
    };
    /**
     * TriageReviewListResponse
     * @description Paginated list of the caller's triage reviews.
     *
     *     ``requests`` is the load-bearing key the FE reads (``data.requests``); it
     *     is never renamed or restructured. ``next_cursor``/``has_more`` are OPTIONAL
     *     additive pagination hints: pass ``next_cursor`` back as the ``cursor`` query
     *     param to fetch the next page. Both are absent/false when the list is
     *     exhausted, so a client that ignores them keeps working as before.
     */
    TriageReviewListResponse: {
      /** Requests */
      requests: components['schemas']['TriageReviewView'][];
      /** Next Cursor */
      next_cursor?: string | null;
      /**
       * Has More
       * @default false
       */
      has_more: boolean;
    };
    /**
     * TriageReviewView
     * @description Wire shape for one triage_review document.
     *
     *     Top-level metadata is typed; the rich payload (``request_payload``,
     *     ``evidence_summary``, ``synthesized_ai_output``) is returned as opaque
     *     dicts so the FE adapter does the field-level mapping. Keeps the schema
     *     thin and forward-compatible with new keys the harness adds.
     */
    TriageReviewView: {
      /** Id */
      id: string;
      /** Request Id */
      request_id: string;
      /** User Id */
      user_id: string;
      /** Source System */
      source_system: string;
      /** Channel */
      channel: string;
      /** Comms Session Id */
      comms_session_id?: string | null;
      /** Workflow Type */
      workflow_type: string;
      /** Workflow Status */
      workflow_status: string;
      /** Created At */
      created_at: string;
      /** Updated At */
      updated_at: string;
      /** Request Created At */
      request_created_at: string;
      /** Actioned At */
      actioned_at?: string | null;
      /** Actioned By */
      actioned_by?: string | null;
      /** Linked Clinical Task Id */
      linked_clinical_task_id?: string | null;
      /** Request Payload */
      request_payload?: {
        [key: string]: unknown;
      };
      /** Evidence Summary */
      evidence_summary?: {
        [key: string]: unknown;
      };
      /** References */
      references?: {
        [key: string]: unknown;
      }[];
      /** Chat History */
      chat_history?: components['schemas']['TriageChatMessageView'][];
      /** Synthesized Ai Output */
      synthesized_ai_output?: {
        [key: string]: unknown;
      } | null;
      /** Synthesized Ai Warning */
      synthesized_ai_warning?: string | null;
      /** Synthesized Chat History */
      synthesized_chat_history?: components['schemas']['TriageChatMessageView'][] | null;
    };
    /**
     * TrialRecord
     * @description Record of a trial for a specific product subscription type.
     */
    TrialRecord: {
      /**
       * Trial End
       * Format: date-time
       */
      trial_end: string;
      /**
       * Ended By User
       * @default false
       */
      ended_by_user: boolean;
    };
    /** TriggerBackupRecoveryRequest */
    TriggerBackupRecoveryRequest: {
      /** Languages */
      languages: string[];
      /** Model */
      model?: string | null;
      /** Recording Ids */
      recording_ids?: string[] | null;
    };
    /**
     * TriggerConditionsUpdateRequest
     * @description Tune WHAT/WHEN a protocol fires — triggering codes, confusable neighbours, and the
     *     surfacing knobs (include/avoid terms, sensitivity) — without touching clinical content.
     *     Writes the working draft only; the live version keeps firing unchanged until re-publish.
     */
    TriggerConditionsUpdateRequest: {
      /** Triggering Codes */
      triggering_codes?: components['schemas']['TriggeringCodeModel'][];
      /** Confusable With */
      confusable_with?: string[];
      surfacing_config?: components['schemas']['SurfacingConfigModel'];
    };
    /** TriggerMigrationResponse */
    TriggerMigrationResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
      /** Dag Run Id */
      dag_run_id?: string | null;
      /** Dag Id */
      dag_id?: string | null;
      /** Workflow Id */
      workflow_id?: string | null;
      /**
       * Engine
       * @default airflow
       * @enum {string}
       */
      engine: TriggerMigrationResponseEngine;
    };
    /** TriggerQuoteView */
    TriggerQuoteView: {
      /** Text */
      text: string;
    };
    /** TriggerUserRegionMigrationRequest */
    TriggerUserRegionMigrationRequest: {
      /** User Ref Id */
      user_ref_id: string;
      from_region: components['schemas']['Region'];
      to_region: components['schemas']['Region'];
      /**
       * Use Temporal
       * @default false
       */
      use_temporal: boolean;
    };
    /** TriggerUserToUserMigrationRequest */
    TriggerUserToUserMigrationRequest: {
      /** From User Ref Id */
      from_user_ref_id: string;
      /** To User Ref Id */
      to_user_ref_id: string;
      /**
       * Use Temporal
       * @default false
       */
      use_temporal: boolean;
    };
    /**
     * TriggerView
     * @description Why a protocol surfaced: named signal chips + verbatim transcript quotes.
     *
     *     The FE maps each quote back to its transcript line (and timestamp) for the
     *     jump/flash affordance. Empty for manually-added cards.
     */
    TriggerView: {
      /** Matched */
      matched?: string[];
      /** Quotes */
      quotes?: components['schemas']['TriggerQuoteView'][];
    };
    /**
     * TriggeringCodeModel
     * @description A clinical code that routes a transcript candidate to this protocol.
     *
     *     The code-mediated engine searches the shared clinical-coding index over the full
     *     SNOMED/ICD-10 corpus ("search broad"), then maps a matched code back to the protocol(s)
     *     that declare it here ("fire narrow"). A protocol is mapped from the union of its
     *     triggering codes — it is never embedded itself.
     *
     *     ``author_acuity_hint`` is advisory metadata only and is NOT a runtime gate: codes carry
     *     no clean acuity field (ICD-10 encodes acuity in the code itself, e.g. I50.21 acute vs
     *     I50.22 chronic), so the acute-vs-historical decision stays the LLM rerank's job at detect
     *     time. The hint just records the author's intent for the seed/UI.
     */
    TriggeringCodeModel: {
      code_system: components['schemas']['domains__coding__pkg__enums__CodeSystem'];
      /** Code */
      code: string;
      /** Display */
      display?: string | null;
      /** Author Acuity Hint */
      author_acuity_hint?: TriggeringCodeModelAuthor_acuity_hintAnyOf0 | null;
    };
    /**
     * Turn
     * @description A chunk of transcript spoken by one speaker.
     */
    Turn: {
      /** Index */
      index?: number | null;
      /** Speaker */
      speaker?: string | null;
      /** Text */
      text?: string | null;
      /** Starttime */
      startTime?: string | null;
      /** Endtime */
      endTime?: string | null;
    };
    /**
     * TurnUsageSummary
     * @description Aggregated token usage across all LLM iterations in a single turn.
     */
    TurnUsageSummary: {
      /** Iterations */
      iterations?: components['schemas']['IterationUsage'][];
      /**
       * Total Input Tokens
       * @default 0
       */
      total_input_tokens: number;
      /**
       * Total Output Tokens
       * @default 0
       */
      total_output_tokens: number;
      /**
       * Total Cache Creation Input Tokens
       * @default 0
       */
      total_cache_creation_input_tokens: number;
      /**
       * Total Cache Creation 5M Input Tokens
       * @default 0
       */
      total_cache_creation_5m_input_tokens: number;
      /**
       * Total Cache Creation 1H Input Tokens
       * @default 0
       */
      total_cache_creation_1h_input_tokens: number;
      /**
       * Total Cache Read Input Tokens
       * @default 0
       */
      total_cache_read_input_tokens: number;
      /**
       * Total Thinking Tokens
       * @default 0
       */
      total_thinking_tokens: number;
    };
    /**
     * TutorialSteps
     * @enum {string}
     */
    TutorialSteps: TutorialSteps;
    /**
     * TypeRestfulInteraction
     * @description Operations supported by REST at the type or instance level.
     *
     *     https://hl7.org/fhir/R4/valueset-type-restful-interaction.html
     * @enum {string}
     */
    TypeRestfulInteraction: TypeRestfulInteraction;
    /**
     * UCUMTimeUnit
     * @example s
     * @example min
     * @example h
     * @example d
     * @example wk
     * @example mo
     * @example a
     */
    UCUMTimeUnit: string;
    /** UnconfirmClinicalCodeRequest */
    UnconfirmClinicalCodeRequest: {
      /** Entity Ids */
      entity_ids: string[];
    };
    /**
     * UnitsOfTime
     * @description A unit of time (units from UCUM).
     *
     *     https://hl7.org/fhir/R4/valueset-units-of-time.html
     * @enum {string}
     */
    UnitsOfTime: UnitsOfTime;
    /** UnlinkClinicalTaskRequest */
    UnlinkClinicalTaskRequest: {
      link: components['schemas']['ClinicalTaskLink'];
    };
    /** UnlinkClinicalTaskResponse */
    UnlinkClinicalTaskResponse: {
      task: components['schemas']['ClinicalTaskView'];
      link_info: components['schemas']['ClinicalTaskLinkInfo'];
    };
    /** UnlinkHardwareDeviceResponse */
    UnlinkHardwareDeviceResponse: {
      /** Id */
      id: string;
      /**
       * Device Id
       * Format: uuid
       * @deprecated
       */
      device_id: string;
      /**
       * Unlinked At
       * Format: date-time
       */
      unlinked_at: string;
    };
    /** UnlinkHeidiAccountResponse */
    UnlinkHeidiAccountResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /** UnlinkMergedSessionsRequest */
    UnlinkMergedSessionsRequest: {
      /**
       * Session Ids
       * @description Session ids to mark as unlinked in the merge group
       */
      session_ids: string[];
    };
    /** UnlinkMergedSessionsResponse */
    UnlinkMergedSessionsResponse: {
      /** Data */
      data: components['schemas']['MinimumSessionView'][];
      /** @description Updated merge group on the primary session */
      session_merge_group?: components['schemas']['MergeableSessions'];
    };
    /** UnlinkOpenAPIUserRequest */
    UnlinkOpenAPIUserRequest: {
      /** Ehr Provider */
      ehr_provider: string;
      /** Ehr User Id */
      ehr_user_id: string;
      /** Ehr Email */
      ehr_email: string;
    };
    /** UnlinkOpenAPIUserResponse */
    UnlinkOpenAPIUserResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /** UnlinkPatientSessionsRequest */
    UnlinkPatientSessionsRequest: {
      /** Session Ids */
      session_ids: string[];
    };
    /** UnlinkPatientSessionsResponse */
    UnlinkPatientSessionsResponse: {
      /** Data */
      data: components['schemas']['MinimumSessionView'][];
    };
    /** UnmatchedRulePreview */
    UnmatchedRulePreview: {
      /** Rule Id */
      rule_id: string;
      /** Description */
      description: string;
      /** Reason */
      reason: string;
    };
    /**
     * UnpublishDraftRequest
     * @description Body for `POST /drafts/{draft_id}:unpublish`.
     *
     *     `unpublished_by` is required so the audit trail records which
     *     admin pulled the published answer down. Validated as an email at
     *     deserialization time via Pydantic's `EmailStr`; we deliberately
     *     do NOT gate it on template-gallery's reviewer allowlist -
     *     unpublish is a safety lever and shouldn't be blocked just because
     *     the admin happens not to be on the publish-side allowlist.
     */
    UnpublishDraftRequest: {
      /**
       * Unpublished By
       * Format: email
       */
      unpublished_by: string;
    };
    /** UnpublishDraftResponse */
    UnpublishDraftResponse: {
      /** Draft Id */
      draft_id: string;
      /** Status */
      status: string;
      /** Published Answer Id */
      published_answer_id: string | null;
      /**
       * Message
       * @default Unpublished from template-gallery
       */
      message: string;
    };
    /** UnshareWorkflowRequest */
    UnshareWorkflowRequest: {
      /** Team Ids */
      team_ids?: string[];
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Organization
       * @default false
       */
      organization: boolean;
    };
    /**
     * UnwatchLinearIssueRequest
     * @description Unsubscribe an internal user from a Linear issue.
     */
    UnwatchLinearIssueRequest: {
      /** Linear Issue Identifier */
      linear_issue_identifier: string;
      /**
       * Submitting User Email
       * Format: email
       */
      submitting_user_email: string;
    };
    /** UpdateAccessEntitlementRequest */
    UpdateAccessEntitlementRequest: {
      /**
       * Enabled
       * @description Whether this entitlement should be enabled
       */
      enabled?: boolean | null;
    };
    /**
     * UpdateActionsRequest
     * @description Request to update enabled actions.
     */
    UpdateActionsRequest: {
      /**
       * Enabled Action Slugs
       * @description List of action slugs to enable
       */
      enabled_action_slugs: string[];
    };
    /**
     * UpdateAdCampaignRequest
     * @description Partial update; only fields explicitly present in the body are applied.
     *
     *     Lifecycle status is not editable here — use the transition actions.
     *     Edits are allowed in DRAFT / SCHEDULED / PAUSED; ACTIVE campaigns must be
     *     paused first.
     */
    UpdateAdCampaignRequest: {
      /**
       * Name
       * @description Campaign / flight name.
       */
      name?: string | null;
      /**
       * Description
       * @description Internal description for ads operations; pass null to clear it.
       */
      description?: string | null;
      /**
       * Start At
       * @description Inclusive start of the flight window (timezone-aware, UTC).
       */
      start_at?: string | null;
      /**
       * End At
       * @description End of the flight window; must be strictly after start_at.
       */
      end_at?: string | null;
      /** @description Heidi product surface; pass null to clear it (only valid while DRAFT). */
      target_product?: components['schemas']['AdTargetProduct'] | null;
      /**
       * Criteria
       * @description Full replacement audience match map; pass null or {} to clear all audience restrictions.
       */
      criteria?: {
        [key: string]: string[];
      } | null;
      /**
       * Resource Id
       * @description Bound creative resource; must belong to the same advertiser. Pass null to unbind.
       */
      resource_id?: string | null;
    };
    /**
     * UpdateAdResourceRequest
     * @description Partial update; only fields explicitly present in the body are applied.
     *
     *     Lifecycle status is deliberately absent — it moves only through the
     *     approve/archive/restore actions, or through an automatic demotion when a
     *     material field changes here.
     */
    UpdateAdResourceRequest: {
      /**
       * Name
       * @description Operator-facing resource name. Cannot be cleared: omit it to leave the stored name alone.
       * @default
       */
      name: string;
      /**
       * Description
       * @description Internal description for ads operations; pass null to clear it.
       */
      description?: string | null;
      /**
       * Link
       * @description Click-through landing URL; pass null to clear it. Material — changing it returns an APPROVED resource to DRAFT for re-review.
       */
      link?: string | null;
      /** @description Placement this creative is built for; pass null to unclassify. Material — changing it returns an APPROVED resource to DRAFT. */
      ad_format?: components['schemas']['AdFormat'] | null;
    };
    /**
     * UpdateAdvertiserRequest
     * @description Partial update; only fields explicitly present in the body are applied.
     *
     *     Lifecycle status is not editable here — use the archive/restore actions.
     */
    UpdateAdvertiserRequest: {
      /**
       * Name
       * @description Display / ops name for the advertiser.
       */
      name?: string | null;
      /** @description HOUSE (Heidi-owned) vs EXTERNAL sponsor; pass null to clear the classification. */
      kind?: components['schemas']['AdvertiserKind'] | null;
      /**
       * Description
       * @description Internal description for ads operations; pass null to clear it.
       */
      description?: string | null;
      /**
       * Contacts
       * @description Full replacement list of advertiser contacts.
       */
      contacts?: components['schemas']['AdvertiserContact'][] | null;
    };
    /** UpdateAgentConfigRequest */
    UpdateAgentConfigRequest: {
      agent: components['schemas']['pkg__agent_harness__core__config__AgentConfig'];
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Change Message
       * @default
       */
      change_message: string;
    };
    /** UpdateAgentMemoryRequest */
    UpdateAgentMemoryRequest: {
      /** Applies When */
      applies_when?: string | null;
      /** Not Applies When */
      not_applies_when?: string | null;
      /** Content */
      content?:
        | string
        | {
            [key: string]: unknown;
          }
        | null;
      /** Examples */
      examples?: string[] | null;
    };
    /**
     * UpdateAgentRequest
     * @description Request model for updating agents.
     */
    UpdateAgentRequest: {
      /** Name */
      name?: string | null;
      /** Display Name */
      display_name?: string | null;
      /** Description */
      description?: string | null;
      /** Direction */
      direction?: string | null;
      /** Objective */
      objective?: string | null;
      /** Config */
      config?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * UpdateAutoExtractIntentRequest
     * @description Body for PATCH /user/auto-extract-intent.
     *
     *     Bidirectional: ``true`` keeps the post-session patient-context auto-extract
     *     popup running, ``false`` records an opt-out. Field name matches the
     *     underlying ``user.session_settings`` field so the FE payload reads as a
     *     literal description of what the BE writes.
     */
    UpdateAutoExtractIntentRequest: {
      /** Intends To Auto Extract Patient Context */
      intends_to_auto_extract_patient_context: boolean;
    };
    /**
     * UpdateAutoLinkIntentRequest
     * @description Body for PATCH /user/auto-link-intent.
     *
     *     Bidirectional: ``true`` records opt-in, ``false`` records opt-out. Field
     *     name matches the underlying ``user.session_settings`` field so the FE
     *     payload reads as a literal description of what the BE writes.
     */
    UpdateAutoLinkIntentRequest: {
      /** Intends To Auto Link Sessions */
      intends_to_auto_link_sessions: boolean;
    };
    /**
     * UpdateCatalogProductRequest
     * @description Partial update. Only the fields present in the request body are applied,
     *     so `sum_field: null` clears it while omitting `sum_field` leaves it alone.
     *
     *     `product_key` is absent by design — it is the identity a card entry is keyed
     *     by, so it cannot be renamed. `extra="forbid"` is what makes that a refusal
     *     rather than a silent no-op: without it pydantic drops the unknown field, the
     *     service sees an empty update, and an admin who submitted a rename gets a 200
     *     and believes it happened. Deactivation is `is_active: false`.
     */
    UpdateCatalogProductRequest: {
      /** Aggregation Mode */
      aggregation_mode?: UpdateCatalogProductRequestAggregation_modeAnyOf0 | null;
      /** Sum Field */
      sum_field?: UpdateCatalogProductRequestSum_fieldAnyOf0 | null;
      /** Dimensions */
      dimensions?: string[] | null;
      /** Is Active */
      is_active?: boolean | null;
    };
    /** UpdateClinicalTaskRequest */
    UpdateClinicalTaskRequest: {
      /** Title */
      title?: string | null;
      /** Short Title */
      short_title?: string | null;
      /** Doc Suggestion Cta */
      doc_suggestion_cta?: string | null;
      /** Chip Label */
      chip_label?: string | null;
      /** Is Suggestion Dismissed */
      is_suggestion_dismissed?: boolean | null;
      /** Description */
      description?: string | null;
      category?: components['schemas']['ClinicalTaskCategory'] | null;
      status?: components['schemas']['ClinicalTaskStatus'] | null;
      /** Due Date */
      due_date?: string | null;
    };
    /**
     * UpdateCompetitionRequest
     * @description Request to update an existing competition.
     */
    UpdateCompetitionRequest: {
      /** Name */
      name?: string | null;
      /** Description */
      description?: string | null;
      /** Start Date */
      start_date?: string | null;
      /** End Date */
      end_date?: string | null;
      status?: components['schemas']['CompetitionStatus'] | null;
      /** Regions */
      regions?: string[] | null;
      /** Countries */
      countries?: string[] | null;
      /** Campaigns */
      campaigns?: string[] | null;
    };
    /**
     * UpdateConnectionRequest
     * @description Request to update an SSO connection's status, testing emails, or home realm domains.
     */
    UpdateConnectionRequest: {
      /** @description New SSO state to transition to */
      sso_state?: components['schemas']['SSOState'] | null;
      /**
       * Testing Emails
       * @description Updated testing email addresses (max 10)
       */
      testing_emails?: string[] | null;
      /**
       * Domains
       * @description Replacement list of email domains for SSO Home Realm Discovery routing. Only editable once the Auth0 connection has been provisioned (i.e. not in SETUP state).
       */
      domains?: string[] | null;
      /**
       * Workspaces
       * @description Replacement list of linked workspaces. Omit to leave unchanged, send an empty list to clear.
       */
      workspaces?: components['schemas']['LinkedWorkspaceRequest'][] | null;
      /**
       * Enforce Linked Workspaces
       * @description Restrict this connection's users to the linked workspaces only
       */
      enforce_linked_workspaces?: boolean | null;
    };
    /** UpdateConsultNoteRequest */
    UpdateConsultNoteRequest: {
      /** Edited Note */
      edited_note?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      generation_method?: components['schemas']['GenerationMethod'] | null;
      brain?: components['schemas']['Brain'] | null;
      /** Template Id */
      template_id?: string | null;
      /** Ai Command Id */
      ai_command_id?: string | null;
      /** Ai Command Text */
      ai_command_text?: string | null;
      dictation_cleanup_mode?: components['schemas']['DictationCleanupModes'] | null;
      find_and_replace?: components['schemas']['FindandReplaceRequest'] | null;
      content_type?: components['schemas']['ContentType'] | null;
      custom_style?: components['schemas']['CustomStyle'] | null;
    };
    /** UpdateConsultNoteResponse */
    UpdateConsultNoteResponse: {
      consult_note: components['schemas']['ConsultNoteResponseV2'];
      /**
       * Total Replacement Count
       * @default 0
       */
      total_replacement_count: number;
    };
    /**
     * UpdateConsultNoteSectionLinkRequest
     * @description Request model for linking consult note sections with EHR section IDs
     */
    UpdateConsultNoteSectionLinkRequest: {
      /** Section Heading */
      section_heading: string;
      /** Linked Ehr Section Id */
      linked_ehr_section_id: string;
    };
    /** UpdateConsultNoteSectionLinkResponse */
    UpdateConsultNoteSectionLinkResponse: {
      consult_note: components['schemas']['ConsultNoteResponseV2'];
    };
    /** UpdateConversationRequest */
    UpdateConversationRequest: {
      /** Status */
      status?: UpdateConversationRequestStatusAnyOf0 | null;
      /** Mode */
      mode?: UpdateConversationRequestModeAnyOf0 | null;
    };
    /** UpdateDefaultLanguageResponse */
    UpdateDefaultLanguageResponse: {
      /** Is Success */
      is_success: boolean;
    };
    /** UpdateDocumentIndexRequest */
    UpdateDocumentIndexRequest: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Index */
      index?: number | null;
    };
    /** UpdateDocumentListRequest */
    UpdateDocumentListRequest: {
      /** Documents */
      documents: components['schemas']['UpdateDocumentIndexRequest'][];
      /** Find And Replace */
      find_and_replace?: {
        [key: string]: string;
      } | null;
      /** Find And Replace Ignore Case */
      find_and_replace_ignore_case?: boolean | null;
      /** Find And Replace Partial Match */
      find_and_replace_partial_match?: boolean | null;
    };
    /** UpdateDocumentListResponse */
    UpdateDocumentListResponse: {
      /** Documents */
      documents: components['schemas']['DocumentView'][];
      /** Total Replacement Count */
      total_replacement_count: number;
    };
    /** UpdateDocumentRequest */
    UpdateDocumentRequest: {
      /** Content */
      content?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      generation_type?: components['schemas']['DocumentGenType'] | null;
      /** Name */
      name?: string | null;
      content_type?: components['schemas']['ContentType'] | null;
    };
    /** UpdateDraftReviewRequest */
    UpdateDraftReviewRequest: {
      /** General Comment */
      general_comment?: string | null;
      /** Edited Content */
      edited_content?: string | null;
      /** Global Signoff */
      global_signoff?: boolean | null;
      /** Reviewed By */
      reviewed_by?: string | null;
    };
    /**
     * UpdateEHRClinicRequest
     * @description Clinic PATCH body — adds summary-email override on top of the shared fields.
     *
     *     Empty string clears the override so routing falls back to the EHR-synced
     *     ``email`` (or ``send_email_to`` if no clinic email is set).
     */
    UpdateEHRClinicRequest: {
      /** Enabled */
      enabled?: boolean | null;
      /** Additional Info */
      additional_info?: string | null;
      /**
       * Email Override
       * @description Set a non-empty address to override the EHR-synced clinic email; send an empty string to clear the override.
       */
      email_override?: string | null;
    };
    /**
     * UpdateEHRItemRequest
     * @description Shared PATCH body for clinician / appointment-type / clinic enabled notes.
     */
    UpdateEHRItemRequest: {
      /** Enabled */
      enabled?: boolean | null;
      /** Additional Info */
      additional_info?: string | null;
    };
    /** UpdateEHRLaunchProfileInput */
    UpdateEHRLaunchProfileInput: {
      /** Authorization Endpoint */
      authorization_endpoint?: string | null;
      /** Token Endpoint */
      token_endpoint?: string | null;
      /** Base Url */
      base_url?: string | null;
      /** Client Id */
      client_id?: string | null;
      /** Client Secret */
      client_secret?: string | null;
      /** Password */
      password?: string | null;
      /** Iss */
      iss?: string | null;
      /** Refresh Token Endpoint */
      refresh_token_endpoint?: string | null;
      ehrlaunch_app?: components['schemas']['EHRLaunchApp'] | null;
      /** Connection Id */
      connection_id?: string | null;
      /** Jwks Uri */
      jwks_uri?: string | null;
      /** Issuer */
      issuer?: string | null;
      /** Callback Url */
      callback_url?: string | null;
      /** Scope */
      scope?: string | null;
      additional_details?: components['schemas']['AdditionalDetailsType'];
      timezone?: components['schemas']['TimeZones'] | null;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /** UpdateEventRuleRequest */
    UpdateEventRuleRequest: {
      event_type?: components['schemas']['EventType'] | null;
      /** Filters */
      filters?: {
        [key: string]: string;
      } | null;
      /** Workflow Id */
      workflow_id?: string | null;
      /** Delay Seconds */
      delay_seconds?: number | null;
      /** Enabled */
      enabled?: boolean | null;
      /** Description */
      description?: string | null;
      /** Conditions */
      conditions?:
        | (
            | components['schemas']['PayloadCondition']
            | components['schemas']['SemanticCondition']
          )[]
        | null;
      delivery_policy?: components['schemas']['DeliveryPolicy'] | null;
    };
    /** UpdateExperimentRequest */
    UpdateExperimentRequest: {
      /** Name */
      name?: string | null;
      /** Description */
      description?: string | null;
      /** Experiment Type */
      experiment_type?: string | null;
      /** Workflow */
      workflow?: {
        [key: string]: unknown;
      } | null;
      /** Config */
      config?: {
        [key: string]: unknown;
      } | null;
      /** Status */
      status?: string | null;
    };
    /**
     * UpdateGalleryTemplateRequest
     * @description Request to update a template in the gallery.
     */
    UpdateGalleryTemplateRequest: {
      template_category?: components['schemas']['GalleryTemplateCategory'] | null;
      /** Specialty */
      specialty?: string | null;
      /** Country */
      country?: string | null;
      /** Author Name */
      author_name?: string | null;
      /** Preference Show Name */
      preference_show_name?: boolean | null;
      /** Preference Show Clinic */
      preference_show_clinic?: boolean | null;
      /** Preference Show Profile Picture */
      preference_show_profile_picture?: boolean | null;
      /** Author Profile Picture */
      author_profile_picture?: string | null;
      /** Url Path */
      url_path?: string | null;
      /** Title */
      title?: string | null;
      /** Description */
      description?: string | null;
      /** Structure */
      structure?: string | null;
      /** Html */
      html?: string | null;
      /** Tone */
      tone?: string | null;
      /** Example Output */
      example_output?: string | null;
      /** S3 Object Key */
      s3_object_key?: string | null;
      /** Form Fields */
      form_fields?: components['schemas']['FormField'][] | null;
      template_content?: components['schemas']['GalleryTemplateContentPayload'] | null;
      /** Searching Text */
      searching_text?: string | null;
    };
    /** UpdateHardwareDeviceRequest */
    UpdateHardwareDeviceRequest: {
      /** Device Name */
      device_name?: string | null;
      /** Firmware Version */
      firmware_version?: string | null;
    };
    /**
     * UpdateIdentityProfileEmailRequest
     * @description Request DTO for updating an identity profile's email (and Auth0 user email).
     *
     *     Used by regional ml-scribe when changing a user's email (e.g. internal admin
     *     change-email flow). The broker looks up the profile by user_ref_id (preferred)
     *     or by current/old email if user_ref_id is not available. It then updates the
     *     Auth0 user's email if the profile has auth0_id, and updates the stored profile email.
     * @example {
     *       "email_verified": true,
     *       "new_email": "newemail@example.com",
     *       "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *     }
     * @example {
     *       "email": "old@example.com",
     *       "email_verified": true,
     *       "new_email": "newemail@example.com"
     *     }
     */
    UpdateIdentityProfileEmailRequest: {
      /**
       * User Ref Id
       * @description User reference ID whose identity profile email should be updated (preferred lookup key)
       */
      user_ref_id?: string | null;
      /**
       * Email
       * @description Current/old email to look up the identity profile when user_ref_id is not available
       */
      email?: string | null;
      /**
       * New Email
       * Format: email
       * @description New email address to set in Auth0 and on the identity profile
       */
      new_email: string;
      /**
       * Email Verified
       * @description Whether the new email is considered verified (default True for admin changes)
       * @default true
       */
      email_verified: boolean;
    };
    /**
     * UpdateIdentityProfileEmailResponse
     * @description Response payload for update identity profile email operation.
     * @example {
     *       "message": "Identity profile and Auth0 email updated",
     *       "success": true
     *     }
     * @example {
     *       "message": "Identity profile not found for user_ref_id",
     *       "reason": "profile_not_found",
     *       "success": false
     *     }
     */
    UpdateIdentityProfileEmailResponse: {
      /**
       * Success
       * @description True if the email was updated in Auth0 and/or profile; False if profile not found or Auth0 update failed
       */
      success: boolean;
      /**
       * Message
       * @description Optional human-readable message for diagnostics (non-sensitive)
       */
      message?: string | null;
      /**
       * Reason
       * @description Machine-readable failure reason when success is False (e.g., 'profile_not_found')
       */
      reason?: string | null;
    };
    /**
     * UpdateIdentityProfileNameRequest
     * @description Request DTO for updating an identity profile's name (and Kinde / Auth0 user names).
     *
     *     Used by regional ml-scribe when a user updates their first_name / last_name (e.g. v1
     *     users PATCH /name flow). The broker looks up the profile by user_ref_id (preferred),
     *     then kinde_user_id, then email. It updates the stored profile name and propagates the
     *     change to Kinde and (when auth0_id is set on the profile) Auth0.
     * @example {
     *       "first_name": "Alice",
     *       "last_name": "Smith",
     *       "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *     }
     * @example {
     *       "first_name": "Bob",
     *       "kinde_user_id": "kp_abc123"
     *     }
     */
    UpdateIdentityProfileNameRequest: {
      /**
       * User Ref Id
       * @description User reference ID whose identity profile name should be updated (preferred lookup key)
       */
      user_ref_id?: string | null;
      /**
       * Kinde User Id
       * @description Kinde user ID to look up the identity profile when user_ref_id is not available
       */
      kinde_user_id?: string | null;
      /**
       * Email
       * @description Email to look up the identity profile when neither user_ref_id nor kinde_user_id is available
       */
      email?: string | null;
      /**
       * First Name
       * @description New first name (given name). At least one of first_name / last_name must be provided.
       */
      first_name?: string | null;
      /**
       * Last Name
       * @description New last name (family name). At least one of first_name / last_name must be provided.
       */
      last_name?: string | null;
    };
    /**
     * UpdateIdentityProfileNameResponse
     * @description Response payload for update identity profile name operation.
     *
     *     ``success`` reflects whether the stored identity profile was updated. Downstream
     *     IdP sync results are surfaced per-vendor so the caller can decide whether to retry
     *     or alert: a partial failure (e.g. Kinde ok, Auth0 failed) is reported with
     *     ``success=True, kinde_synced=True, auth0_synced=False``.
     * @example {
     *       "auth0_synced": true,
     *       "kinde_synced": true,
     *       "message": "Identity profile, Kinde, and Auth0 names updated",
     *       "success": true
     *     }
     * @example {
     *       "auth0_synced": false,
     *       "kinde_synced": true,
     *       "message": "Profile updated; Auth0 sync failed",
     *       "reason": "auth0_sync_failed",
     *       "success": true
     *     }
     * @example {
     *       "auth0_synced": false,
     *       "kinde_synced": false,
     *       "message": "Identity profile not found",
     *       "reason": "profile_not_found",
     *       "success": false
     *     }
     */
    UpdateIdentityProfileNameResponse: {
      /**
       * Success
       * @description True if the identity profile name was updated. Partial IdP failures are reported via kinde_synced / auth0_synced.
       */
      success: boolean;
      /**
       * Kinde Synced
       * @description True if the Kinde user name was updated. False if Kinde sync was skipped (no kinde_id) or failed.
       * @default false
       */
      kinde_synced: boolean;
      /**
       * Auth0 Synced
       * @description True if the Auth0 user name was updated. False if Auth0 sync was skipped (no auth0_id) or failed.
       * @default false
       */
      auth0_synced: boolean;
      /**
       * Message
       * @description Optional human-readable message for diagnostics (non-sensitive)
       */
      message?: string | null;
      /**
       * Reason
       * @description Machine-readable failure reason when success is False (e.g., 'profile_not_found')
       */
      reason?: string | null;
    };
    /**
     * UpdateIntegrationDetails
     * @description Only allows updating widget_note_push_limit, ehr_provider cannot be changed
     */
    UpdateIntegrationDetails: {
      /** Widget Note Push Limit */
      widget_note_push_limit?: number | null;
    };
    /** UpdateJudgeTemplateRequest */
    UpdateJudgeTemplateRequest: {
      /** Name */
      name?: string | null;
      /** Description */
      description?: string | null;
      /** Prompt Template */
      prompt_template?: string | null;
      /** Model */
      model?: string | null;
      /** Output Schema */
      output_schema?: {
        [key: string]: unknown;
      } | null;
      /** Is Shared */
      is_shared?: boolean | null;
    };
    /**
     * UpdateLeaderboardSettingsRequest
     * @description Request to update leaderboard settings.
     */
    UpdateLeaderboardSettingsRequest: {
      visibility: components['schemas']['LeaderboardVisibility'];
    };
    /**
     * UpdateLeaderboardSettingsResponse
     * @description Response after updating leaderboard settings.
     */
    UpdateLeaderboardSettingsResponse: {
      visibility: components['schemas']['LeaderboardVisibility'];
      /** Pseudonym */
      pseudonym: string | null;
      /** Message */
      message: string;
    };
    /**
     * UpdateLetterRequest
     * @description Request object for updating patchable letter fields.
     *
     *     PATCH semantics are based on field presence, not truthiness or non-nullness:
     *     omitted fields are not updated, while explicit ``null`` values are validated
     *     field-by-field. ``name``, ``subject_line`` and ``primary_recipient`` accept
     *     explicit ``null`` to clear the persisted value. ``message_body`` also accepts
     *     explicit ``null`` to clear the persisted email message body. Other patchable
     *     fields reject explicit ``null``. ``copy_recipients`` is cleared with ``[]``
     *     rather than ``null`` because the persisted field is always a list.
     */
    UpdateLetterRequest: {
      /**
       * Name
       * @description Updated editable letter display name. Empty string is allowed; null clears/deletes the name.
       */
      name?: string | null;
      /**
       * Body Content
       * @description Updated editable letter body content. Empty string is allowed; null is not.
       */
      body_content?: string | null;
      /**
       * Subject Line
       * @description Updated editable letter subject line. Empty string is allowed; null clears/deletes the subject line.
       */
      subject_line?: string | null;
      /**
       * Message Body
       * @description Updated editable message body sent with the letter. Currently only supported for email sending. Empty string is allowed; null clears the message body.
       */
      message_body?: string | null;
      /** @description Updated stored body format. Currently only HTML updates are supported; null is not. */
      content_type?: components['schemas']['LetterContentType'] | null;
      /**
       * Primary Recipient
       * @description Updated primary recipient configuration. Null clears the primary recipient. Omit to leave unchanged.
       */
      primary_recipient?:
        | (
            | components['schemas']['LetterSealedMessageDeliveryRecipient']
            | components['schemas']['LetterEmailRecipient']
            | components['schemas']['LetterDirectoryRecipient']
            | components['schemas']['LetterFaxRecipient']
          )
        | null;
      /**
       * Copy Recipients
       * @description Updated copy recipients. Empty list clears all copy recipients. Null is rejected because the persisted field is always a list. Capped at 50 entries; the limit is an arbitrary first-implementation safety cap, not a product-backed requirement.
       */
      copy_recipients?:
        | (
            | components['schemas']['LetterSealedMessageDeliveryRecipient']
            | components['schemas']['LetterEmailRecipient']
            | components['schemas']['LetterDirectoryRecipient']
            | components['schemas']['LetterFaxRecipient']
          )[]
        | null;
    };
    /**
     * UpdateLimitAssignmentRequest
     * @description HTTP body for `PATCH /assignments/{id}`.
     *
     *     Only the mutable fields. `scope_type` / `scope_id` / `limit_key`
     *     identify the row and cannot be changed — delete and recreate to
     *     re-target (and `metric_key` is derived from `limit_key`, never set
     *     directly).
     */
    UpdateLimitAssignmentRequest: {
      /** Mode */
      mode?: UpdateLimitAssignmentRequestModeAnyOf0 | null;
      /** Starts At */
      starts_at?: string | null;
      /** Expires At */
      expires_at?: string | null;
      /** Is Active */
      is_active?: boolean | null;
      /** Reason */
      reason?: string | null;
    };
    /**
     * UpdateLinkShareRecipientRequest
     * @description Request body for updating an individual recipient.
     */
    UpdateLinkShareRecipientRequest: {
      scope_override?: components['schemas']['SharedSessionScope'] | null;
    };
    /**
     * UpdateLinkShareSettingsRequest
     * @description Request body for updating session-level link share settings.
     */
    UpdateLinkShareSettingsRequest: {
      default_scope?: components['schemas']['SharedSessionScope'] | null;
      /** Expires At */
      expires_at?: string | null;
    };
    /** UpdateManyResponse */
    UpdateManyResponse: {
      /** Matched Count */
      matched_count: number;
      /** Modified Count */
      modified_count: number;
    };
    /** UpdateMessageRequest */
    UpdateMessageRequest: {
      /** Originaltext */
      originalText?: string | null;
      /** Translatedtext */
      translatedText?: string | null;
    };
    /**
     * UpdateMeterBindingRequest
     * @description HTTP body for `PATCH /metrics/{metric_key}/meter` — the kill-switch.
     *
     *     The only mutable field on a binding is `is_active`, and only `False` is
     *     accepted: it flips the binding off so the egress job stops emitting for
     *     this meter. The Stripe meter is **left untouched** — product owns its
     *     lifecycle in the dashboard. **Re-activation is not supported** — the
     *     endpoint rejects `is_active=true`; to re-bind, create a new binding via
     *     POST.
     */
    UpdateMeterBindingRequest: {
      /** Is Active */
      is_active: boolean;
    };
    /** UpdateOpenAPIOrgRequest */
    UpdateOpenAPIOrgRequest: {
      /** Key */
      key: string;
      /**
       * Is Reseller Model
       * @default false
       */
      is_reseller_model: boolean;
      /**
       * Is Reseller Org Requires Link Account
       * @default false
       */
      is_reseller_org_requires_link_account: boolean;
      /**
       * Is Freemium Model
       * @default false
       */
      is_freemium_model: boolean;
      /**
       * Is Widget Enabled
       * @default false
       */
      is_widget_enabled: boolean;
      /**
       * Is Open Api Enabled
       * @default false
       */
      is_open_api_enabled: boolean;
      /**
       * Is Link With Email Enabled
       * @default false
       */
      is_link_with_email_enabled: boolean;
      /** Description */
      description?: string | null;
      /** Contact Email */
      contact_email?: string | null;
    };
    /**
     * UpdateOrganizationRequest
     * @description Request schema for updating an organization.
     */
    UpdateOrganizationRequest: {
      /** Name */
      name?: string | null;
      mfa?: components['schemas']['OrganizationMFARequest'] | null;
      /** Admin Session Review Toggle */
      admin_session_review_toggle?: boolean | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      /** Custom Consent Text */
      custom_consent_text?: string | null;
      /** Require Review Confirmation */
      require_review_confirmation?: boolean | null;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      patient_retention_settings?: components['schemas']['RetentionSettings'] | null;
      transcript_retention_settings?: components['schemas']['RetentionSettings'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      /** Allow Direct Session Sharing */
      allow_direct_session_sharing?: boolean | null;
      /** Allow Session Link Sharing */
      allow_session_link_sharing?: boolean | null;
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
      /** Disable Auto Extract */
      disable_auto_extract?: boolean | null;
    };
    /**
     * UpdatePatientProfileMetadata
     * @description Metadata fields for tracking updates - not part of the profile model.
     */
    UpdatePatientProfileMetadata: {
      /** Changed By */
      changed_by?: string | null;
      /** Session Id */
      session_id?: string | null;
      source?: components['schemas']['PatientProfileUpdateSource'] | null;
    };
    /** UpdatePatientProfileRequest */
    UpdatePatientProfileRequest: {
      /** Birth Date */
      birth_date?: string | null;
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Phone */
      phone?: string | null;
      /** Email */
      email?: string | null;
      /** Demographic String */
      demographic_string?: string | null;
      /** Remember Consent */
      remember_consent?: boolean | null;
      /** Additional Context */
      additional_context?: string | null;
      /** An Acc Class */
      an_acc_class?: string | null;
      /** Current Medications */
      current_medications?: string | null;
      /** Allergies */
      allergies?: string | null;
      /** Past Medical History */
      past_medical_history?: string | null;
      /** Ethnicity */
      ethnicity?: string | null;
      /** First Language */
      first_language?: string | null;
      /** Accent */
      accent?: string | null;
      /** Postcode Prefix */
      postcode_prefix?: string | null;
      /** Use In Doc And Note Gen */
      use_in_doc_and_note_gen?: boolean | null;
      metadata?: components['schemas']['UpdatePatientProfileMetadata'] | null;
    };
    /** UpdatePatientProfileResponse */
    UpdatePatientProfileResponse: {
      data: components['schemas']['PatientProfileModel'];
    };
    /**
     * UpdatePdfFieldsRequest
     * @description Request body for PATCH /pdf-document/{document_id}/fields.
     */
    UpdatePdfFieldsRequest: {
      /**
       * Fields
       * @description Array of field updates
       */
      fields: components['schemas']['FieldUpdate'][];
    };
    /**
     * UpdatePdfFieldsResponse
     * @description Response for PATCH /pdf-document/{document_id}/fields.
     */
    UpdatePdfFieldsResponse: {
      /**
       * Success
       * @description Whether the update succeeded
       */
      success: boolean;
      /**
       * Message
       * @description Human-readable status message
       */
      message: string;
      /**
       * Pdf Url
       * @description New presigned URL for the regenerated PDF
       */
      pdf_url: string;
      /**
       * Updated Fields
       * @description Confirmed field updates
       */
      updated_fields?: components['schemas']['FieldUpdate'][];
    };
    /** UpdatePinnedTemplateOrderRequest */
    UpdatePinnedTemplateOrderRequest: {
      /**
       * Template Ids
       * @description Ordered list of pinned template IDs. Position in list determines display order.
       */
      template_ids: string[];
    };
    /** UpdatePrechartInstructionsRequest */
    UpdatePrechartInstructionsRequest: {
      /** Rules Text */
      rules_text: string;
      /**
       * Used Ai Assist
       * @default false
       */
      used_ai_assist: boolean;
    };
    /** UpdatePreferencesRequest */
    UpdatePreferencesRequest: {
      recordingMode?: components['schemas']['RecordingMode'] | null;
      patientType?: components['schemas']['PatientType'] | null;
      /** Clinicianlanguage */
      clinicianLanguage?: string | null;
      clinicianGender?:
        | components['schemas']['domains__translator__models__enums__Gender']
        | null;
      translationModel?: components['schemas']['TranslationModel'] | null;
      /** Autoreadtranslations */
      autoReadTranslations?: boolean | null;
    };
    /**
     * UpdatePrescriptionRequest
     * @description Request object for patching prescription fields.
     *
     *     PATCH semantics are based on field presence, not truthiness: omitted fields
     *     are not updated. The non-nullable fields (``drug``, ``dose``,
     *     ``frequency``, ``duration``, ``route``, ``allergy_checked``) are
     *     non-nullable on the persisted document, so an explicit ``null`` is rejected
     *     field-by-field to avoid writing ``null`` into a non-nullable field (which
     *     would make the document permanently unreadable). The optional fields
     *     (``indication``, ``formulation``, ``brand_name``, ``n_repeats``,
     *     ``quantity``) accept explicit ``null`` to clear them.
     */
    UpdatePrescriptionRequest: {
      /** Drug */
      drug?: string | null;
      /** Dose */
      dose?: string | null;
      /** Frequency */
      frequency?: string | null;
      /** Duration */
      duration?: string | null;
      /** Route */
      route?: string | null;
      /** Indication */
      indication?: string | null;
      /** Formulation */
      formulation?: string | null;
      /** Brand Name */
      brand_name?: string | null;
      /** N Repeats */
      n_repeats?: number | null;
      /** Quantity */
      quantity?: string | null;
      /** Allergy Checked */
      allergy_checked?: boolean | null;
    };
    /** UpdatePresentationRequest */
    UpdatePresentationRequest: {
      /** Title */
      title?: string | null;
    };
    /**
     * UpdateProfileGroupRequest
     * @description Add and/or remove EHR launch profiles from a group.
     */
    UpdateProfileGroupRequest: {
      /** Add Profile Names */
      add_profile_names?: string[];
      /** Remove Profile Names */
      remove_profile_names?: string[];
    };
    /** UpdateProfileGroupResponse */
    UpdateProfileGroupResponse: {
      /** Profile Group */
      profile_group: string;
      /** Profiles */
      profiles: components['schemas']['EHRLaunchProfile'][];
    };
    /** UpdateProjectRequest */
    UpdateProjectRequest: {
      /** Title */
      title?: string | null;
      /** Description */
      description?: string | null;
      /** Is Saved */
      is_saved?: boolean | null;
      /** Tool Approvals */
      tool_approvals?: components['schemas']['ProjectToolApproval'][] | null;
    };
    /**
     * UpdateProtocolRequest
     * @description Request to update a protocol. All fields are optional.
     */
    UpdateProtocolRequest: {
      /** Name */
      name?: string | null;
      /** Shorthand */
      shorthand?: string | null;
      /** Description */
      description?: string | null;
      /** Standard Operating Procedure */
      standard_operating_procedure?: string | null;
      /** Output Template Id */
      output_template_id?: string | null;
      /** Connector Ids */
      connector_ids?: string[] | null;
      /** Is Active */
      is_active?: boolean | null;
    };
    /** UpdateReminderConfigRequest */
    UpdateReminderConfigRequest: {
      /** Name */
      name?: string | null;
      /** Appointment Type */
      appointment_type?: string | null;
      /** Days Offset */
      days_offset?: number | null;
      /** Time Of Day */
      time_of_day?: string | null;
      /** Send Sms */
      send_sms?: boolean | null;
      /** Send Email */
      send_email?: boolean | null;
      /** Sms Template */
      sms_template?: string | null;
      /** Email Subject Template */
      email_subject_template?: string | null;
      /** Email Body Template */
      email_body_template?: string | null;
      /** Enabled */
      enabled?: boolean | null;
    };
    /** UpdateRepeatReviewStatusRequest */
    UpdateRepeatReviewStatusRequest: {
      /**
       * Status
       * @enum {string}
       */
      status: UpdateRepeatReviewStatusRequestStatus;
      /** Actioned By */
      actioned_by?: string | null;
    };
    /** UpdateRoleRequest */
    UpdateRoleRequest: {
      desc?: components['schemas']['RoleDescription'] | null;
      category?: components['schemas']['RoleCategory'] | null;
      /** Permission Codes */
      permission_codes?: string[] | null;
    };
    /** UpdateRpaRecordingRequest */
    UpdateRpaRecordingRequest: {
      /** Name */
      name?: string | null;
      /** Pending Team Id */
      pending_team_id?: string | null;
    };
    /**
     * UpdateScheduleRequest
     * @description Partial update for an existing schedule. Omitted fields are left untouched.
     */
    UpdateScheduleRequest: {
      /** Display Name */
      display_name?: string | null;
      /** Description */
      description?: string | null;
      spec?: components['schemas']['ScheduleSpecModel'] | null;
    };
    /**
     * UpdateServiceMeterBindingRequest
     * @description HTTP body for `PATCH /service-meter-bindings/{id}`.
     *
     *     Only the mutable fields. `product` / `feature` identify the row and
     *     cannot be changed — delete and recreate to re-target. A supplied
     *     `metric_keys` **replaces** the list wholesale (≥1 enforced).
     */
    UpdateServiceMeterBindingRequest: {
      /** Metric Keys */
      metric_keys?: string[] | null;
      /** Description */
      description?: string | null;
    };
    /** UpdateSessionContextDocumentsRequest */
    UpdateSessionContextDocumentsRequest: {
      /** Context Documents */
      context_documents: components['schemas']['UpdateSingleSessionContextDocument'][];
    };
    /**
     * UpdateSessionRequest
     * @description Partial update for session fields.
     */
    UpdateSessionRequest: {
      /** Title */
      title?: string | null;
      /** Patientlanguage */
      patientLanguage?: string | null;
      /** Clinicianlanguage */
      clinicianLanguage?: string | null;
      patient?: components['schemas']['PatientDetailsRequest'] | null;
    };
    /** UpdateSingleSessionContextDocument */
    UpdateSingleSessionContextDocument: {
      /** Id */
      id: string;
      /** Name */
      name?: string | null;
      /** Date */
      date?: string | null;
      /** Additional Context */
      additional_context?: string | null;
    };
    /**
     * UpdateSingleSnippetRequest
     * @description update existing shorthand -- {"new_shorthand": "XXX"}
     *     update existing content -- {"new_content": "XXX"}
     *     update existing shorthand and content -- {"new_shorthand": "XXX", "new_content": "XXX"}
     */
    UpdateSingleSnippetRequest: {
      /** New Shorthand */
      new_shorthand?: string | null;
      /** New Content */
      new_content?: string | null;
      /** New Trigger Phrase */
      new_trigger_phrase?: string | null;
      /** New Is Verbal Trigger */
      new_is_verbal_trigger?: boolean | null;
    };
    /** UpdateSlideRequest */
    UpdateSlideRequest: {
      /** Title */
      title?: string | null;
      /** Notes */
      notes?: string | null;
    };
    /**
     * UpdateSourceListRequest
     * @description Request to update a source list.
     */
    UpdateSourceListRequest: {
      /** Name */
      name?: string | null;
      /** Domains */
      domains?: string[] | null;
    };
    /**
     * UpdateStructureFromExampleRequest
     * @description Request body for updating an existing version control's structure from an edited example note.
     */
    UpdateStructureFromExampleRequest: {
      /**
       * Base Template Version Control Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      base_template_version_control_id: string;
      /** Current Template Structure */
      current_template_structure: string;
      /** Edited Example Note */
      edited_example_note: string;
      /** User Request */
      user_request?: string | null;
    };
    /**
     * UpdateStructureViaChatRequest
     * @description Request body for updating template structure via chat.
     *     Always uses STRUCTURE source (no example editing).
     */
    UpdateStructureViaChatRequest: {
      /**
       * Base Template Version Control Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      base_template_version_control_id: string;
      /** User Prompt */
      user_prompt: string;
      /** Current Template Structure */
      current_template_structure: string;
      /**
       * Verify Compliance
       * @default false
       */
      verify_compliance: boolean;
    };
    /**
     * UpdateSubscriptionResponse
     * @description Response with updated state for immediate verification.
     */
    UpdateSubscriptionResponse: {
      /**
       * Success
       * @default true
       */
      success: boolean;
      /** Message */
      message: string;
      /** User Ref Id */
      user_ref_id: string;
      new_state: components['schemas']['EvidenceSubscriptionState'];
      evidence_billing?: components['schemas']['EvidenceBillingSnapshot'] | null;
    };
    /** UpdateTeamMemberRequest */
    UpdateTeamMemberRequest: {
      /** Role Ids */
      role_ids?: string[] | null;
    };
    /** UpdateTeamMemberSessionRequest */
    UpdateTeamMemberSessionRequest: {
      language_code?: components['schemas']['LanguageCode'] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
      patient?: components['schemas']['PatientUpdate'] | null;
      /** Clinician Notes */
      clinician_notes?: string[] | null;
      /** Created Time Local */
      created_time_local?: string | null;
      extracted_patient_context?:
        | components['schemas']['PatientContextLLMResponse']
        | null;
      /** Linked Sessions For Context */
      linked_sessions_for_context?: string[] | null;
      /** Linked Sessions For Context Fallback */
      linked_sessions_for_context_fallback?: boolean | null;
      session_status?: components['schemas']['SessionStatus'] | null;
      /** Is Urgent */
      is_urgent?: boolean | null;
    };
    /** UpdateTeamRequest */
    UpdateTeamRequest: {
      /** Name */
      name?: string | null;
      /** Require Patient Consent */
      require_patient_consent?: boolean | null;
      session_retention_settings?: components['schemas']['RetentionSettings'] | null;
      mfa_info?: components['schemas']['TeamMFARequest'] | null;
      session_configuration?: components['schemas']['TeamSessionConfiguration'] | null;
      disclaimer_footer?: components['schemas']['TeamDisclaimerFooter'] | null;
      /** Enable Patient Summary Generation */
      enable_patient_summary_generation?: boolean | null;
      /** Disable Auto Extract */
      disable_auto_extract?: boolean | null;
      /** Allow Direct Session Sharing */
      allow_direct_session_sharing?: boolean | null;
      /** Allow Session Link Sharing */
      allow_session_link_sharing?: boolean | null;
      /** Enable Export Header */
      enable_export_header?: boolean | null;
      export_header_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /** Enable Export Footer */
      enable_export_footer?: boolean | null;
      export_footer_content?: components['schemas']['ExportHeaderFooterContent'] | null;
      /** Evidence Access */
      evidence_access?: boolean | null;
      team_evidence_settings?: components['schemas']['TeamEvidenceSettings'] | null;
    };
    /**
     * UpdateTeamShortcutRequest
     * @description Request schema for partial updates to a team shortcut.
     *
     *     All fields optional. Only fields explicitly set on the request are
     *     forwarded to the service (via ``model_dump(exclude_unset=True)``).
     */
    UpdateTeamShortcutRequest: {
      /**
       * Label
       * @description Short display label
       */
      label?: string | null;
      /**
       * Query
       * @description Query sent to Evidence
       */
      query?: string | null;
      /**
       * Description
       * @description Optional longer description
       */
      description?: string | null;
    };
    /** UpdateTeamWorkflowRequest */
    UpdateTeamWorkflowRequest: {
      /** Name */
      name: string;
    };
    /** UpdateTemplateCreationRecordRequest */
    UpdateTemplateCreationRecordRequest: {
      /** Request */
      request?: string | null;
      /** Transcript */
      transcript?: string | null;
      /** Transcript Session Id */
      transcript_session_id?: string | null;
      /** Template Name */
      template_name?: string | null;
      /** Selected Version Control Id */
      selected_version_control_id?: string | null;
      /** Template Id */
      template_id?: string | null;
    };
    /** UpdateTemplateFavoriteStatusRequest */
    UpdateTemplateFavoriteStatusRequest: {
      /** Is Favorite */
      is_favorite: boolean;
      /**
       * Is System Template
       * @default false
       */
      is_system_template: boolean;
    };
    /** UpdateTemplatePinnedStatusRequest */
    UpdateTemplatePinnedStatusRequest: {
      /** Is Pinned */
      is_pinned: boolean;
      /**
       * Is System Template
       * @default false
       */
      is_system_template: boolean;
    };
    /**
     * UpdateTemplateRequest
     * @example {
     *       "content": "Updated template content with improvements",
     *       "name": "Updated Template Name",
     *       "tags": {
     *         "countries": [
     *           "AUSTRALIA"
     *         ],
     *         "languages": [
     *           "en"
     *         ],
     *         "region": [
     *           "AU"
     *         ],
     *         "specialty_ids": [
     *           "specialty_id_1"
     *         ],
     *         "tier": [
     *           "PRO"
     *         ]
     *       },
     *       "version_type": "minor"
     *     }
     */
    UpdateTemplateRequest: {
      /** Name */
      name?: string | null;
      /** Content */
      content?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /**
       * @description Version bump type when content is updated: major (breaking changes), minor (new features), patch (bug fixes)
       * @default PATCH
       */
      version_type: components['schemas']['VersionType'] | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      /** Should Deduct Quota */
      should_deduct_quota?: boolean | null;
      tags?: components['schemas']['Tags'] | null;
      /** Template Families */
      template_families?: string[] | null;
      pinned_for_tags?: components['schemas']['Tags'] | null;
      highlighted_for_tags?: components['schemas']['Tags'] | null;
      featured_for_tags?: components['schemas']['Tags'] | null;
      auto_generated_for_tags?: components['schemas']['Tags'] | null;
      /** Prompteams Id */
      prompteams_id?: string | null;
      /** List Order Priority */
      list_order_priority?: number | null;
    };
    /** UpdateTemplateRequestV2 */
    UpdateTemplateRequestV2: {
      /** Name */
      name?: string | null;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** Description */
      description?: string | null;
      template_category?: components['schemas']['TemplateCategory'] | null;
      template_visibility?: components['schemas']['TemplateVisibility'] | null;
      /** Team Id */
      team_id?: string | null;
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Problem Based Charting Enabled */
      problem_based_charting_enabled?: boolean | null;
      /** Use Sections */
      use_sections?: boolean | null;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Form Fields
       * @description Form fields for form templates. Used to update field labels, types, and positions.
       */
      form_fields?: components['schemas']['FormField'][] | null;
      /**
       * Xml Source
       * @description Replacement XML source for an XML form template; form fields are re-extracted and validated server-side.
       */
      xml_source?: string | null;
      /**
       * Json Source
       * @description Replacement JSON source for a JSON form template; form fields are re-extracted and validated server-side.
       */
      json_source?: string | null;
    };
    /** UpdateTemplateVersionControlRequest */
    UpdateTemplateVersionControlRequest: {
      /** Template Structure */
      template_structure?: string | null;
      /** Chat Query */
      chat_query?: string | null;
      /** Example Note */
      example_note?: string | null;
    };
    /** UpdateThirdPartyLicenseRequest */
    UpdateThirdPartyLicenseRequest: {
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** @default PRO_PLUS */
      latest_tier: components['schemas']['SubscriptionTier'];
      evidence_tier?: components['schemas']['EvidenceSubscriptionTier'] | null;
    };
    /**
     * UpdateUserAccessEntitlementRequest
     * @description Update ``enabled`` on a user's direct entitlement (team-admin web API).
     */
    UpdateUserAccessEntitlementRequest: {
      /**
       * Entitlement Type Id
       * @description ID of the AccessEntitlementType to update. If both id and name are sent, id is used to resolve the type.
       */
      entitlement_type_id?: string | null;
      /**
       * Entitlement Type Name
       * @description Unique name of the AccessEntitlementType. Used when entitlement_type_id is omitted or empty.
       */
      entitlement_type_name?: string | null;
      /**
       * Enabled
       * @description Whether this user attachment should be enabled
       */
      enabled: boolean;
    };
    /** UpdateUserEHRLaunchProfileResponse */
    UpdateUserEHRLaunchProfileResponse: {
      user_ehr_launch_profile: components['schemas']['UserEHRLaunchProfile'];
    };
    /** UpdateUserEHRLaunchProfilesResponse */
    UpdateUserEHRLaunchProfilesResponse: {
      /** User Ehr Launch Profiles */
      user_ehr_launch_profiles?: components['schemas']['UserEHRLaunchProfile'][];
    };
    /** UpdateUserNameRequest */
    UpdateUserNameRequest: {
      /** First Name */
      first_name: string;
      /** Last Name */
      last_name: string;
    };
    /** UpdateUserRegionRequest */
    UpdateUserRegionRequest: {
      region: components['schemas']['Region'];
    };
    /** UpdateUserRequest */
    UpdateUserRequest: {
      /** Country */
      country?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      /** Practitioner Type */
      practitioner_type?: string | null;
      /** Specialty Id */
      specialty_id?: string | null;
      default_note_structure?: components['schemas']['NoteStructure'] | null;
      writing_style?: components['schemas']['VoiceStyle'] | null;
      /** Phone Number */
      phone_number?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Journey */
      journey?: {
        [key: string]: components['schemas']['JourneyStatus'];
      } | null;
      /** Is Demo On Desktop Completed */
      is_demo_on_desktop_completed?: boolean | null;
      default_language_code?: components['schemas']['LanguageCode'] | null;
      /** Other Specialty */
      other_specialty?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      title?: components['schemas']['TitleCode'] | null;
      session_settings?: components['schemas']['SessionSettingsRequest'] | null;
      dictation?: components['schemas']['DictationSettingsRequest'] | null;
      organisation_info?: components['schemas']['OrganisationInfo'] | null;
      research_profile?: components['schemas']['ClinicianResearchProfile'] | null;
      /** Should Hide Sensitive Info From Sidebar */
      should_hide_sensitive_info_from_sidebar?: boolean | null;
      /** Is Ask Heidi Disclaimer Showed */
      is_ask_heidi_disclaimer_showed?: boolean | null;
      /** Is Default Note Warning Off */
      is_default_note_warning_off?: boolean | null;
      /** Unsubscribed Notification Channels */
      unsubscribed_notification_channels?:
        | components['schemas']['NotificationChannel'][]
        | null;
      /** Notification Preferences */
      notification_preferences?: {
        [key: string]: components['schemas']['NotificationChannel'][];
      } | null;
      /** Is Tutorial Pane Opened */
      is_tutorial_pane_opened?: boolean | null;
      /** Enabled Code Systems */
      enabled_code_systems?:
        | components['schemas']['domains__coding__pkg__enums__CodeSystem'][]
        | null;
      /** Show Hcc Badges */
      show_hcc_badges?: boolean | null;
      /** Has Shown Codes Warning */
      has_shown_codes_warning?: boolean | null;
      /** Has Shown Sectional Note Info Modal */
      has_shown_sectional_note_info_modal?: boolean | null;
      /** Has Shown Push Sectional Note Instruction */
      has_shown_push_sectional_note_instruction?: boolean | null;
      /** Should Show Section Highlight In Template */
      should_show_section_highlight_in_template?: boolean | null;
      /** Has Seen Live Transcription Split View Modal */
      has_seen_live_transcription_split_view_modal?: boolean | null;
      /** Is Live Transcription Split View */
      is_live_transcription_split_view?: boolean | null;
      /** Has Seen Bbe Modal */
      has_seen_bbe_modal?: boolean | null;
      /** Is Bbe Enabled */
      is_bbe_enabled?: boolean | null;
      /** Has Seen Research Tooltip */
      has_seen_research_tooltip?: boolean | null;
      /** Hide Clinical Task Gen Doc Nux Tooltip */
      hide_clinical_task_gen_doc_nux_tooltip?: boolean | null;
      /** Default Export Email */
      default_export_email?: string | null;
      /** Self Defined Disclaimer */
      self_defined_disclaimer?: string | null;
      language_time_settings?: components['schemas']['LanguageTimeSettings'] | null;
      /** Has Shown New Brain Setting */
      has_shown_new_brain_setting?: boolean | null;
      /** Practice Name */
      practice_name?: string | null;
      /** Practice Address */
      practice_address?: string | null;
      practice_country?: components['schemas']['CallsAvailableCountry'] | null;
      /** Handoff Phone */
      handoff_phone?: string | null;
      /** Calls Terms Agreed On */
      calls_terms_agreed_on?: string | null;
      /** Work Research Terms Agreed On */
      work_research_terms_agreed_on?: string | null;
      /** Labs Experimental Terms Agreed On */
      labs_experimental_terms_agreed_on?: string | null;
      /** Do Not Show Telehealth Sharing Tab Modal */
      do_not_show_telehealth_sharing_tab_modal?: boolean | null;
      /** Has Seen Create From Context Tooltip */
      has_seen_create_from_context_tooltip?: boolean | null;
      /** Has Seen Sessionless Evidence */
      has_seen_sessionless_evidence?: boolean | null;
      /** Has Seen Sessionless Evidence Reminder Tooltip */
      has_seen_sessionless_evidence_reminder_tooltip?: boolean | null;
      /** Has Seen Evidence Onboarding For Scribe */
      has_seen_evidence_onboarding_for_scribe?: boolean | null;
      /** Has Used Evidence In Session */
      has_used_evidence_in_session?: boolean | null;
      /** Has Seen Try Source Control During Trial Banner */
      has_seen_try_source_control_during_trial_banner?: boolean | null;
      /** Has Seen Evidence Source Control Coachmark */
      has_seen_evidence_source_control_coachmark?: boolean | null;
      /** Has Seen Billing Plan Renamed Banner */
      has_seen_billing_plan_renamed_banner?: boolean | null;
      /** Should Show Try Scribe Tooltip */
      should_show_try_scribe_tooltip?: boolean | null;
      /** Evidence Discovery Modal Seen At */
      evidence_discovery_modal_seen_at?: string | null;
      /** Calls Send Summary Email */
      calls_send_summary_email?: string | null;
      /** Calls Send Summary Email Enabled */
      calls_send_summary_email_enabled?: boolean | null;
      comms_session_retention_settings?:
        | components['schemas']['RetentionSettings']
        | null;
      /** Default Consult Note Edit Display */
      default_consult_note_edit_display?: boolean | null;
      /** Is Auto Verify Enabled */
      is_auto_verify_enabled?: boolean | null;
      /** Auto Verify Preference Set */
      auto_verify_preference_set?: boolean | null;
      /** Is Auto Verify Lite Enabled */
      is_auto_verify_lite_enabled?: boolean | null;
      /** Auto Verify Lite Preference Set */
      auto_verify_lite_preference_set?: boolean | null;
      theme?: components['schemas']['Theme'] | null;
      /** Affiliate Code */
      affiliate_code?: string | null;
      /** Ref Code */
      ref_code?: string | null;
      referral_campaign?: components['schemas']['ReferralCampaign'] | null;
      signup_source?: components['schemas']['SignupSource'] | null;
      /** Is New User After Evidence Launch */
      is_new_user_after_evidence_launch?: boolean | null;
      evidence_settings?: components['schemas']['EvidenceSettingsRequest'] | null;
      template_creation_record?:
        | components['schemas']['TemplateCreationRecordSettingsRequest']
        | null;
      patient_summary_turn_off_prompt?:
        | components['schemas']['PatientSummaryTurnOffPromptRequest']
        | null;
      /**
       * Hardware Device Binding Code
       * @description Code used to authenticate to hardware devices during bluetooth binding
       */
      hardware_device_binding_code?: string | null;
    };
    /** UpdateUserRolesRequest */
    UpdateUserRolesRequest: {
      /** Target User Kinde Id */
      target_user_kinde_id: string;
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /** Role Ids */
      role_ids: string[];
    };
    /** UpdateUserRolesResponse */
    UpdateUserRolesResponse: {
      /** Updated Ids */
      updated_ids: string[];
      /** Updated Count */
      updated_count: number;
    };
    /** UpdateWorkflowEvalProfileRequest */
    UpdateWorkflowEvalProfileRequest: {
      /** Metrics */
      metrics?: components['schemas']['WorkflowEvalMetric'][];
      /**
       * Admin Notes
       * @default
       */
      admin_notes: string;
    };
    /**
     * UpdateWorkflowRequest
     * @description Heidi Work update — agent / product_surface are Studio-only (admin API).
     */
    UpdateWorkflowRequest: {
      /** Name */
      name?: string | null;
      /** Description */
      description?: string | null;
      /** Instructions */
      instructions?: string | null;
      /** Enabled */
      enabled?: boolean | null;
      /** Setup Values */
      setup_values?: {
        [key: string]: string;
      } | null;
      /** Artifact Refs */
      artifact_refs?: components['schemas']['WorkflowArtifactRef'][] | null;
      /** Shortcut */
      shortcut?: string | null;
    };
    /**
     * UpdatedDetailedSessionView
     * @description legacy view design. total_replacement_count is only used in update session API
     */
    UpdatedDetailedSessionView: {
      /** Session Id */
      session_id: string;
      /** Kinde Gp Id */
      kinde_gp_id: string;
      /**
       * Clinician Name
       * @description Full name of the session owner (the user behind kinde_gp_id), not the caller. Empty when the owner has no name on file; null when the owner user cannot be found.
       */
      clinician_name?: string | null;
      /** Session Name */
      session_name?: string | null;
      /** Session Gist */
      session_gist?: string | null;
      patient?: components['schemas']['PatientModel'] | null;
      /** Audio */
      audio?: components['schemas']['AudioResponse'][] | null;
      /** Clinician Notes */
      clinician_notes: string[];
      /**
       * Duration
       * @default 0
       */
      duration: number;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /**
       * Is Consent
       * @default false
       */
      is_consent: boolean | null;
      /**
       * Is Review Modal Confirmed
       * @default false
       */
      is_review_modal_confirmed: boolean;
      language_code?: components['schemas']['LanguageCode'] | null;
      /** Language Code List */
      language_code_list?: components['schemas']['LanguageCode'][] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Documents */
      documents?: components['schemas']['DocumentView'][] | null;
      transcribe_mode?: components['schemas']['TranscribeMode'] | null;
      /** Is Tab Sharing */
      is_tab_sharing?: boolean | null;
      /** Transcript */
      transcript?: string | null;
      /**
       * Transcript Deleted At
       * @description The deletion time once the transcript has been hard-deleted; None otherwise.
       */
      transcript_deleted_at?: string | null;
      /** Updated Dictation */
      updated_dictation?: string | null;
      /** Is Reviewed */
      is_reviewed?: boolean | null;
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      /** Ehr Appt Contact Id */
      ehr_appt_contact_id?: string | null;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Encounter Id */
      ehr_encounter_id?: string | null;
      /** Ehr Patient Id */
      ehr_patient_id?: string | null;
      /** Is Demo */
      is_demo: boolean;
      /** Is Consumed Quota */
      is_consumed_quota: boolean;
      /** Had Ws Recording Failure */
      had_ws_recording_failure: boolean;
      /** Latest Consult Note Id */
      latest_consult_note_id?: string | null;
      /** Client Customized Qa Template Answer */
      client_customized_qa_template_answer?: string | null;
      /**
       * Do Recording Playback
       * @default false
       */
      do_recording_playback: boolean;
      /** Created Time Local */
      created_time_local?: string | null;
      /** Created Time Local With Offset */
      created_time_local_with_offset?: string | null;
      /** @default EMPTY */
      session_status: components['schemas']['SessionStatus'] | null;
      /**
       * Is Urgent
       * @default false
       */
      is_urgent: boolean;
      patient_profile?: components['schemas']['PatientProfileModel'] | null;
      consult_note: components['schemas']['SimpleConsultNoteView'];
      language: components['schemas']['LanguageView'];
      /** Languages */
      languages: components['schemas']['LanguageView'][];
      /**
       * Generate Output Without Recording
       * @default false
       */
      generate_output_without_recording: boolean | null;
      recording_status?: components['schemas']['RecordingStatus'] | null;
      /** Linked Sessions For Context */
      linked_sessions_for_context?: string[];
      /** Linked Sessions For Context Fallback */
      linked_sessions_for_context_fallback?: boolean | null;
      /** Past Ehr Notes */
      past_ehr_notes?: components['schemas']['EHRNote'][];
      extracted_patient_context?: components['schemas']['PatientContextResponse'] | null;
      /** Used Experimental Transcript */
      used_experimental_transcript?: boolean | null;
      research_metadata?: components['schemas']['SessionResearchMetadata'] | null;
      /** Research Clinician Note */
      research_clinician_note?: string | null;
      patient_profile_appointment_candidates?:
        | components['schemas']['PatientProfileAppointmentCandidates']
        | null;
      /** Creation Platform */
      creation_platform?:
        | (
            | components['schemas']['WebApp']
            | components['schemas']['DesktopApp']
            | components['schemas']['IOSApp']
            | components['schemas']['AndroidApp']
            | components['schemas']['RemoteApp']
          )
        | null;
      patient_link_status?: components['schemas']['PatientLinkStatus'] | null;
      /** @default no_action */
      session_group_status: components['schemas']['SessionGroupStatus'];
      session_merge_group?: components['schemas']['MergeableSessions'];
      /** Needs Resync */
      needs_resync?: boolean | null;
      /**
       * Total Replacement Count
       * @default 0
       */
      total_replacement_count: number;
    };
    /** UploadAudioResponse */
    UploadAudioResponse: {
      uploaded_audio: components['schemas']['AccessRestrictedUploadedAudio'];
    };
    /** UploadFileResponse */
    UploadFileResponse: {
      /** Record Id */
      record_id?: string | null;
    };
    /**
     * UploadPatientDocumentResponse
     * @description Response for a successful upload — metadata echoed back to the client.
     */
    UploadPatientDocumentResponse: {
      /** Id */
      id: string;
      /** Patient Profile Id */
      patient_profile_id: string;
      /** Uploaded By */
      uploaded_by: string;
      /** File Name */
      file_name: string;
      /** Mime Type */
      mime_type: string;
      /** Size Bytes */
      size_bytes: number;
      /** Description */
      description: string | null;
      /** Session Id */
      session_id: string | null;
      /** Summary */
      summary: string | null;
      /** Is Ready */
      is_ready: boolean;
      /** Failure Reason */
      failure_reason: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * UploadPdfResponse
     * @description Response for PDF upload with extracted form fields.
     */
    UploadPdfResponse: {
      /** S3 Object Key */
      s3_object_key: string;
      /** Form Fields */
      form_fields: components['schemas']['FormField'][];
    };
    /** UploadUrlRequest */
    UploadUrlRequest: {
      /** Chatsessionid */
      chatSessionId: string;
    };
    /** UploadUrlResponse */
    UploadUrlResponse: {
      /** Storageid */
      storageId: string;
      /** Uploadurl */
      uploadUrl: string;
    };
    /**
     * UploadedDocumentStatus
     * @enum {string}
     */
    UploadedDocumentStatus: UploadedDocumentStatus;
    /** UploadedFileResponse */
    UploadedFileResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** File Name */
      file_name: string;
      status: components['schemas']['UploadedDocumentStatus'];
    };
    /** UpsertCollectionRequest */
    UpsertCollectionRequest: {
      collection_type: components['schemas']['ValidRegionSyncCollectionTypes'];
      /** Data */
      data: unknown[];
    };
    /** UpsertCollectionResponse */
    UpsertCollectionResponse: {
      collection_type: components['schemas']['ValidRegionSyncCollectionTypes'];
      /** Upserted Count */
      upserted_count: number;
      /** Skipped Count */
      skipped_count: number;
      /** Skipped Identical Count */
      skipped_identical_count: number;
      /** Skipped Error Count */
      skipped_error_count: number;
      /** Errors */
      errors: string[];
    };
    /** UpsertDesktopTargetRequest */
    UpsertDesktopTargetRequest: {
      /** Display Name */
      display_name: string;
      /** App Version */
      app_version: string;
      capabilities: components['schemas']['ClientCapabilities'];
    };
    /**
     * UpsertSessionSharesRequest
     * @description Request body for upserting session shares.
     */
    UpsertSessionSharesRequest: {
      /**
       * Shares
       * @description List of shares to upsert
       */
      shares: components['schemas']['SessionShareItem'][];
    };
    /**
     * UpsertSessionSharesResponse
     * @description Response for upsert session shares.
     */
    UpsertSessionSharesResponse: {
      /**
       * Success
       * @default true
       */
      success: boolean;
      /**
       * Processed Count
       * @description Number of shares processed
       */
      processed_count: number;
    };
    /**
     * UsageBreakdownEntry
     * @description Per-member slice in the admin breakdown response.
     *
     *     Shape mirrors the top-level entitlement fields so client UIs can
     *     render a breakdown row with the same component as the headline
     *     figure. Every member of a team shares the requester's tier (and
     *     therefore the same per-seat limit) — the service does not look up
     *     per-member tiers, avoiding an N+1 against the user collection.
     */
    UsageBreakdownEntry: {
      /** User Id */
      user_id: string;
      /** Subscription Tier */
      subscription_tier: string;
      /** Usage */
      usage: number;
      /** Limit */
      limit: number | null;
      /** Remaining */
      remaining: number | null;
      /** Is Over Limit */
      is_over_limit: boolean;
    };
    /**
     * UsageContext
     * @description Describes the context of use for a conformance or knowledge resource.
     *
     *     https://hl7.org/fhir/R4/metadatatypes-definitions.html#UsageContext
     */
    UsageContext: {
      /**
       * Type of context being specified
       * @description A code that identifies the type of context being specified by this usage context.
       */
      code: components['schemas']['pkg__integrations__fhir__models__data_types__coding__Coding'];
      /**
       * Value that defines the context
       * @description A value that defines the context specified in this context of use. The interpretation of the value is defined by the code.
       */
      valueCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Value that defines the context
       * @description A value that defines the context specified in this context of use. The interpretation of the value is defined by the code.
       */
      valueQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Value that defines the context
       * @description A value that defines the context specified in this context of use. The interpretation of the value is defined by the code.
       */
      valueRange?: components['schemas']['Range'] | null;
      /**
       * Value that defines the context
       * @description A value that defines the context specified in this context of use. The interpretation of the value is defined by the code.
       */
      valueReference?: components['schemas']['Reference'] | null;
    };
    /**
     * UsageMergeResponse
     * @description Merge is a deliberate no-op for usage/gamification (DROP policy).
     */
    UsageMergeResponse: {
      /**
       * Skipped
       * @default true
       */
      skipped: boolean;
      /**
       * Message
       * @default Usage/gamification records are dropped on merge (not transferred).
       */
      message: string;
    };
    /**
     * UsageOutcome
     * @description Outcome of the billable action a usage event records.
     *
     *     Stored as a plain string (``StrEnum``) so meter ``filter_groups`` match on it
     *     directly; credit rating burns only on ``SUCCESS``. Its own vocabulary,
     *     distinct from the note-generation tracking enum ``NoteGenerationStatus``
     *     (which uses ``FAILED``) — this is the billing outcome and spans non-note
     *     surfaces (nudges, evidence tokens).
     *
     *     Foundation only: no callsite stamps this yet, so every emit currently records
     *     ``None``. The members below are the contract the wiring will populate
     *     (``INCOMPLETE`` = completed but produced nothing billable).
     * @enum {string}
     */
    UsageOutcome: UsageOutcome;
    /** UseWidgetUserQuotaRequest */
    UseWidgetUserQuotaRequest: {
      quota_type: components['schemas']['WidgetQuotaType'];
    };
    /**
     * UserActionResponse
     * @description Response after modifying a user's leaderboard settings.
     */
    UserActionResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
      /** User Ref Id */
      user_ref_id: string;
    };
    /**
     * UserActivityAction
     * @description User actions tracked for journey progress and analytics.
     * @enum {string}
     */
    UserActivityAction: UserActivityAction;
    /**
     * UserCapabilityConfigResponse
     * @description User's capability configuration response.
     */
    UserCapabilityConfigResponse: {
      /** Id */
      id: string;
      /** Capability Slug */
      capability_slug: string;
      /** Is Connected */
      is_connected: boolean;
      /** Enabled Action Slugs */
      enabled_action_slugs: string[];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** UserContext */
    UserContext: {
      /** @description Returns the care context of the ambient session */
      careContext: components['schemas']['CareContext'];
    };
    /** UserContextRequest */
    UserContextRequest: {
      careContext?: components['schemas']['NebulaCareContext'] | null;
    };
    /**
     * UserData
     * @description User data returned from the get-user endpoint.
     */
    UserData: {
      /**
       * User Ref Id
       * @description Global unique identifier for the user (UUID7)
       * @example 01912345-6789-7abc-def0-123456789abc
       */
      user_ref_id: string;
      /**
       * Email
       * @description User's email address
       */
      email?: string | null;
    };
    /**
     * UserDeleteReason
     * @enum {string}
     */
    UserDeleteReason: UserDeleteReason;
    /**
     * UserDocumentListResponse
     * @description Response model for listing documents.
     */
    UserDocumentListResponse: {
      /** Documents */
      documents: components['schemas']['UserDocumentResponse'][];
      /** Total */
      total: number;
    };
    /**
     * UserDocumentResponse
     * @description Response model for a user document.
     */
    UserDocumentResponse: {
      /** Document Id */
      document_id: string;
      /** Filename */
      filename: string;
      scope: components['schemas']['DocumentScope'];
      /** Workspace Id */
      workspace_id?: string | null;
      /** Team Id */
      team_id?: string | null;
      /** File Type */
      file_type: string;
      /** File Size Bytes */
      file_size_bytes: number;
      /** Chunk Count */
      chunk_count: number;
      /** Uploaded By */
      uploaded_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Source
       * @description Origin of this document. `user` for direct uploads (default), `sharepoint` for files ingested via the SharePoint integration.
       * @default user
       * @enum {string}
       */
      source: UserDocumentResponseSource;
      /**
       * Document Kind
       * @description Library role of this document. `input` for uploads and curated sources (default); `artifact` for agent-generated work outputs; `workflow_context` for reusable workflow skill/context files (hidden from Evidence Library UI and clinical RAG).
       * @default input
       * @enum {string}
       */
      document_kind: UserDocumentResponseDocument_kind;
      /** @description Extracted document metadata (title, author, etc.) */
      document_metadata?: components['schemas']['DocumentMetadataResponse'] | null;
    };
    /**
     * UserDocumentUpdateRequest
     * @description Request model for updating a document's properties.
     *
     *     All fields are optional - only provided fields will be updated.
     */
    UserDocumentUpdateRequest: {
      /** @description New scope: 'user' (personal) or 'team' (shared) */
      scope?: components['schemas']['DocumentScope'] | null;
      /**
       * Filename
       * @description New display filename for the document
       */
      filename?: string | null;
    };
    /**
     * UserDocumentsAndJobsResponse
     * @description Combined response with both active jobs and completed documents.
     */
    UserDocumentsAndJobsResponse: {
      /** Jobs */
      jobs: components['schemas']['JobResponse'][];
      /** Documents */
      documents: components['schemas']['UserDocumentResponse'][];
    };
    /**
     * UserEHRLaunchProfile
     * @description User EHR launch profile to store configuration for linking ID Token in EHR Launch mode.
     */
    UserEHRLaunchProfile: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      ehr_provider: components['schemas']['EHRProvider'];
      /** Internal Id */
      internal_id: string;
      /** Known Internal Ids */
      known_internal_ids?: string[];
      /** User Id */
      user_id: string;
      /** Profile Name */
      profile_name: string;
      /**
       * Is Auto Created
       * @default false
       */
      is_auto_created: boolean;
      /** Deleted At */
      deleted_at?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at?: string;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /** UserEHRLaunchProfileListResponse */
    UserEHRLaunchProfileListResponse: {
      /** Profiles */
      profiles: components['schemas']['UserEHRLaunchProfile'][];
      /** Total Pages */
      total_pages: number;
    };
    /** UserEHRLaunchProfileResponse */
    UserEHRLaunchProfileResponse: {
      profile: components['schemas']['UserEHRLaunchProfile'];
    };
    /**
     * UserEntitlementView
     * @description User-facing view of an entitlement.
     */
    UserEntitlementView: {
      /** Id */
      id: string;
      /** Display Name */
      display_name: string;
      /** Name */
      name: string;
      /** Enabled */
      enabled: boolean;
      source?: components['schemas']['SourceView'] | null;
    };
    /**
     * UserFeedbackDetail
     * @description Thumbs-feedback detail for the admin dialog.
     *
     *     Same PHI stance as the list item: metadata + optional free-text comment
     *     only — no content snapshot.
     */
    UserFeedbackDetail: {
      /** Id */
      id: string;
      /** Session Id */
      session_id: string;
      /** User Id */
      user_id: string;
      target_type: components['schemas']['FeedbackTargetType'];
      /** Target Id */
      target_id?: string | null;
      /** Message Id */
      message_id?: string | null;
      rating: components['schemas']['ThumbRating'];
      /** User Feedback */
      user_feedback?: string | null;
      /** Llm Call Ids */
      llm_call_ids?: string[];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * UserFeedbackListItem
     * @description One thumbs-feedback row for the Internal Admin table.
     *
     *     Intentionally omits ``content_snapshot`` — that field can hold clinical
     *     content and is not needed to triage thumbs ratings / free-text comments.
     */
    UserFeedbackListItem: {
      /** Id */
      id: string;
      /** Session Id */
      session_id: string;
      /** User Id */
      user_id: string;
      target_type: components['schemas']['FeedbackTargetType'];
      /** Target Id */
      target_id?: string | null;
      /** Message Id */
      message_id?: string | null;
      rating: components['schemas']['ThumbRating'];
      /** User Feedback */
      user_feedback?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** UserFeedbackListMeta */
    UserFeedbackListMeta: {
      /** Total */
      total: number;
      /** Offset */
      offset: number;
      /** Limit */
      limit: number;
    };
    /** UserFeedbackListResponse */
    UserFeedbackListResponse: {
      /** Data */
      data: components['schemas']['UserFeedbackListItem'][];
      meta: components['schemas']['UserFeedbackListMeta'];
    };
    /**
     * UserFeedbackView
     * @description Response model for getting UserFeedback
     */
    UserFeedbackView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Session Id */
      session_id: string;
      /** User Id */
      user_id: string;
      target_type: components['schemas']['FeedbackTargetType'];
      /** Target Id */
      target_id?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      rating: components['schemas']['ThumbRating'];
      /** Allowed Ratings */
      allowed_ratings: components['schemas']['ThumbRating'][];
    };
    /**
     * UserFriendlyNoteFailedReason
     * @description UX/UI friendly reason why note generation failed
     * @enum {string}
     */
    UserFriendlyNoteFailedReason: UserFriendlyNoteFailedReason;
    /** UserInmailResponse */
    UserInmailResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Notification Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      notification_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Title */
      title: string;
      /** Content */
      content: string;
      /** Notification Name */
      notification_name: string;
      notification_group: components['schemas']['NotificationGroup'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      status: components['schemas']['NotificationStatus'];
      /** Action Link */
      action_link?: string | null;
    };
    /**
     * UserJourney
     * @enum {string}
     */
    UserJourney: UserJourney;
    /** UserKindePropertiesResponse */
    UserKindePropertiesResponse: {
      /** Properties */
      properties: components['schemas']['UserKindePropertyResponse'][];
    };
    /** UserKindePropertyResponse */
    UserKindePropertyResponse: {
      /** Id */
      id: string;
      /** Key */
      key: string;
      /** Value */
      value?: string | null;
      /** Name */
      name?: string | null;
      /** Description */
      description?: string | null;
    };
    /**
     * UserLeaderboardStats
     * @description A user's statistics on the leaderboard.
     */
    UserLeaderboardStats: {
      /** Evidence Query Count */
      evidence_query_count: number;
      /** Referral Signup Count */
      referral_signup_count: number;
      /** Query Rank */
      query_rank: number | null;
      /** Referral Rank */
      referral_rank: number | null;
      /** Period */
      period: string;
      /** Region */
      region: string;
      /** Campaign */
      campaign?: string | null;
      /** Opted Out */
      opted_out: boolean;
      /** Pseudonym */
      pseudonym?: string | null;
      /** Visibility */
      visibility?: string | null;
    };
    /**
     * UserLinkedAccountResponse
     * @description Response model for user's linked EHR account via Open API integration.
     */
    UserLinkedAccountResponse: {
      /** Ehr Provider */
      ehr_provider: string;
      /** Ehr Email */
      ehr_email: string;
      /** Ehr User Id */
      ehr_user_id: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * UserMFAConfigData
     * @description MFA configuration data returned from the get-user-mfa-config endpoint.
     *
     *     This excludes org_id which is not needed by Identity Broker.
     */
    UserMFAConfigData: {
      /** @description Who set the MFA configuration */
      set_by: components['schemas']['MFASetBY'];
      /** @description Scope of MFA (user, team, or region level) */
      scope: components['schemas']['MFAScope'];
      /**
       * Is Mfa Enabled
       * @description Whether MFA is currently enabled for the user
       */
      is_mfa_enabled: boolean;
      /**
       * Is Mfa Editable By User
       * @description Whether the user can edit their MFA settings (false if team/organization enforced)
       */
      is_mfa_editable_by_user: boolean;
      /** @description MFA method if enabled, null if MFA disabled */
      method?: components['schemas']['MFAMethod'] | null;
    };
    /** UserMFAInfo */
    UserMFAInfo: {
      /** Org Id */
      org_id: string;
      set_by: components['schemas']['MFASetBY'];
      scope: components['schemas']['MFAScope'];
      /** Is Mfa Enabled */
      is_mfa_enabled: boolean;
      /** Is Mfa Editable By User */
      is_mfa_editable_by_user: boolean;
      method?: components['schemas']['MFAMethod'] | null;
    };
    /** UserMFARequest */
    UserMFARequest: {
      /** Enable Mfa */
      enable_mfa: boolean;
      mfa_method?: components['schemas']['MFAMethod'] | null;
    };
    /** UserNotificationPreference */
    UserNotificationPreference: {
      /**
       * Notification Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      notification_id: string;
      /** Name */
      name: string;
      group: components['schemas']['NotificationGroup'];
      /** Subscribable Channels */
      subscribable_channels: components['schemas']['NotificationChannel'][];
      /** Subscribed Channels */
      subscribed_channels: components['schemas']['NotificationChannel'][];
    };
    /**
     * UserOrderBy
     * @description Allowed fields for ordering users.
     * @enum {string}
     */
    UserOrderBy: UserOrderBy;
    /** UserRefBanCreateRequest */
    UserRefBanCreateRequest: {
      /**
       * User Ref Id
       * @description Heidi user_ref_id
       */
      user_ref_id: string;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /** UserRefBanListResponse */
    UserRefBanListResponse: {
      /** Bans */
      bans: components['schemas']['UserRefBanRecord'][];
    };
    /** UserRefBanLookupResponse */
    UserRefBanLookupResponse: {
      /** Email */
      email?: string | null;
      /** Full Name */
      full_name?: string | null;
      /** Country */
      country?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      /** Billing Plan */
      billing_plan?: string | null;
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
    };
    /** UserRefBanRecord */
    UserRefBanRecord: {
      /** User Ref Id */
      user_ref_id: string;
      /** Reason */
      reason: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Kinde User Id */
      kinde_user_id?: string | null;
      /** Full Name */
      full_name?: string | null;
      /** Email */
      email?: string | null;
    };
    /** UserRefBanRevokeRequest */
    UserRefBanRevokeRequest: {
      /**
       * User Ref Id
       * @description Heidi user_ref_id
       */
      user_ref_id: string;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /** UserResponse */
    UserResponse: {
      /** User Ref Id */
      user_ref_id: string;
      /**
       * User Id
       * @deprecated
       * @default
       */
      user_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Is Newly Created
       * @default false
       */
      is_newly_created: boolean;
      /** Stripe Customer Id */
      stripe_customer_id: string;
      /**
       * Had Free Trial
       * @default false
       */
      had_free_trial: boolean | null;
      default_language_code?: components['schemas']['LanguageCode'] | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Is In Free Trial */
      is_in_free_trial: boolean;
      /**
       * Is In Reverse Free Trial
       * @default false
       */
      is_in_reverse_free_trial: boolean;
      /** Trial End Date */
      trial_end_date?: string | null;
      tier: components['schemas']['SubscriptionTier'];
      scribe_access?: components['schemas']['AccessTier'] | null;
      evidence_access?: components['schemas']['AccessTier'] | null;
      new_product_tier?: components['schemas']['SubscriptionTier'] | null;
      plan_cycle?: components['schemas']['shared__enums__enums__Period'] | null;
      /** Next Billing Date */
      next_billing_date?: string | null;
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /** Redeemed Discounts */
      redeemed_discounts?: components['schemas']['AvailableDiscounts'][];
      /** Plan Upgradable */
      plan_upgradable?: boolean | null;
      /** Is Allowed */
      is_allowed?: boolean | null;
      /** Country */
      country?: string | null;
      /** Jurisdiction */
      jurisdiction?: string | null;
      /** Practitioner Type */
      practitioner_type?: string | null;
      /** Onboarding Email Status */
      onboarding_email_status?: string | null;
      /** Specialty Id */
      specialty_id?: string | null;
      /** Other Specialty */
      other_specialty?: string | null;
      default_note_structure?: components['schemas']['NoteStructure'] | null;
      writing_style?: components['schemas']['VoiceStyle'] | null;
      /** Has Phone Number */
      has_phone_number?: boolean | null;
      /** Phone Number */
      phone_number?: string | null;
      /** Journey */
      journey?: {
        [key: string]: components['schemas']['JourneyStatus'];
      } | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      title?: components['schemas']['TitleCode'] | null;
      session_settings?: components['schemas']['SessionSettingsResponse'] | null;
      dictation?: components['schemas']['DictationSettingsResponse'] | null;
      quota: components['schemas']['Quota'];
      evidence_usage?: components['schemas']['EvidenceUsageResponse'] | null;
      /** Currency */
      currency: string;
      /** Is Subscribed */
      is_subscribed: boolean;
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Is Demo On Desktop Completed */
      is_demo_on_desktop_completed?: boolean | null;
      /** User Activity */
      user_activity?: {
        [key: string]: number;
      } | null;
      /** Integration Requests */
      integration_requests?:
        | components['schemas']['database__mongo__base__IntegrationRequest'][]
        | null;
      referral_profile?: components['schemas']['ReferralProfile'] | null;
      organisation_info?: components['schemas']['OrganisationInfo'] | null;
      research_profile?: components['schemas']['ClinicianResearchProfile'] | null;
      /** Revenuecat User Id */
      revenuecat_user_id?: string | null;
      billing_managed_by?: components['schemas']['RevenueCatStore'] | null;
      /** Revenuecat Entitlement Id */
      revenuecat_entitlement_id?: string | null;
      /**
       * Admin Session Review Toggle
       * @default false
       */
      admin_session_review_toggle: boolean;
      /** Created At */
      created_at?: string | null;
      /** Deleted At */
      deleted_at?: string | null;
      user_mfa_info?: components['schemas']['UserMFAInfo'] | null;
      session_timeout?: components['schemas']['EffectiveSessionTimeout'] | null;
      /** Warn Pro Action */
      warn_pro_action: boolean;
      /**
       * Free Trial History Tiers
       * @default []
       */
      free_trial_history_tiers: components['schemas']['SubscriptionTier'][];
      /**
       * Should Hide Sensitive Info From Sidebar
       * @default false
       */
      should_hide_sensitive_info_from_sidebar: boolean;
      /**
       * Is Ask Heidi Disclaimer Showed
       * @default false
       */
      is_ask_heidi_disclaimer_showed: boolean;
      /**
       * Is Default Note Warning Off
       * @default false
       */
      is_default_note_warning_off: boolean;
      /**
       * Pending Onboarding Tasks
       * @default [
       *       "find_template",
       *       "start_session",
       *       "review_note",
       *       "create_document",
       *       "create_template"
       *     ]
       */
      pending_onboarding_tasks: components['schemas']['OnboardingTask'][];
      current_onboarding_sub_task?: components['schemas']['PendingSubStep'] | null;
      /** Onboarding Tasks Completed At */
      onboarding_tasks_completed_at?: string | null;
      /**
       * Post Note Quality Completed Tasks
       * @description Completed task ids for the post-note quality 'Improve your notes' panel
       */
      post_note_quality_completed_tasks?: components['schemas']['PostNoteQualityTask'][];
      /** Post Note Quality Panel Dismissed At */
      post_note_quality_panel_dismissed_at?: string | null;
      /**
       * Post Note Quality Reward Milestones Granted
       * @description Task-count milestones for which the post-note quality trial-day reward was granted
       */
      post_note_quality_reward_milestones_granted?: number[];
      /**
       * Has Seen Improve Notes Panel
       * @default false
       */
      has_seen_improve_notes_panel: boolean;
      /**
       * Is Tutorial Pane Opened
       * @default false
       */
      is_tutorial_pane_opened: boolean;
      /** Email */
      email?: string | null;
      /**
       * Enabled Code Systems
       * @default []
       */
      enabled_code_systems: components['schemas']['CodeSystemPreference'][];
      /**
       * Show Hcc Badges
       * @default false
       */
      show_hcc_badges: boolean;
      /**
       * Has Shown Codes Warning
       * @default false
       */
      has_shown_codes_warning: boolean;
      /**
       * Has Shown Sectional Note Info Modal
       * @default false
       */
      has_shown_sectional_note_info_modal: boolean;
      /**
       * Has Shown Push Sectional Note Instruction
       * @default false
       */
      has_shown_push_sectional_note_instruction: boolean;
      /**
       * Should Show Section Highlight In Template
       * @default false
       */
      should_show_section_highlight_in_template: boolean;
      /**
       * Has Seen Live Transcription Split View Modal
       * @default false
       */
      has_seen_live_transcription_split_view_modal: boolean;
      /**
       * Do Not Show Telehealth Sharing Tab Modal
       * @default false
       */
      do_not_show_telehealth_sharing_tab_modal: boolean;
      /**
       * Has Seen Create From Context Tooltip
       * @default false
       */
      has_seen_create_from_context_tooltip: boolean;
      /**
       * Should Show Try Scribe Tooltip
       * @default true
       */
      should_show_try_scribe_tooltip: boolean;
      /** Evidence Discovery Modal Seen At */
      evidence_discovery_modal_seen_at?: string | null;
      /**
       * Is Live Transcription Split View
       * @default true
       */
      is_live_transcription_split_view: boolean;
      /**
       * Has Seen Bbe Modal
       * @default false
       */
      has_seen_bbe_modal: boolean;
      /**
       * Is Bbe Enabled
       * @default true
       */
      is_bbe_enabled: boolean;
      /**
       * Has Seen Research Tooltip
       * @default false
       */
      has_seen_research_tooltip: boolean;
      /**
       * Has Seen Sessionless Evidence
       * @default false
       */
      has_seen_sessionless_evidence: boolean;
      /**
       * Has Seen Sessionless Evidence Reminder Tooltip
       * @default false
       */
      has_seen_sessionless_evidence_reminder_tooltip: boolean;
      /**
       * Has Seen Evidence Onboarding For Scribe
       * @default false
       */
      has_seen_evidence_onboarding_for_scribe: boolean;
      /**
       * Has Used Evidence In Session
       * @default false
       */
      has_used_evidence_in_session: boolean;
      /**
       * Has Seen Try Source Control During Trial Banner
       * @default false
       */
      has_seen_try_source_control_during_trial_banner: boolean;
      /**
       * Has Seen Evidence Source Control Coachmark
       * @default false
       */
      has_seen_evidence_source_control_coachmark: boolean;
      /**
       * Has Seen Billing Plan Renamed Banner
       * @default false
       */
      has_seen_billing_plan_renamed_banner: boolean;
      /**
       * Hide Clinical Task Gen Doc Nux Tooltip
       * @default false
       */
      hide_clinical_task_gen_doc_nux_tooltip: boolean;
      /**
       * Direct Integration Attempts Count
       * @default 0
       */
      direct_integration_attempts_count: number;
      /**
       * Has Created Template
       * @default true
       */
      has_created_template: boolean;
      /** Default Export Email */
      default_export_email?: string | null;
      /** Self Defined Disclaimer */
      self_defined_disclaimer?: string | null;
      language_time_settings?: components['schemas']['LanguageTimeSettings'] | null;
      /** Profile Picture Url */
      profile_picture_url?: string | null;
      /**
       * Has Shown New Brain Setting
       * @default false
       */
      has_shown_new_brain_setting: boolean;
      /**
       * Can Self Onboard Team
       * @default false
       */
      can_self_onboard_team: boolean;
      /**
       * Contacted Admin For Subscription Upgrade Team Ids
       * @description Team IDs for which this user has already triggered the subscription upgrade admin email flow
       */
      contacted_admin_for_subscription_upgrade_team_ids?: string[];
      /**
       * Is Promoted Free Trial
       * @default false
       */
      is_promoted_free_trial: boolean;
      /** Practice Name */
      practice_name?: string | null;
      /** Practice Address */
      practice_address?: string | null;
      practice_country?: components['schemas']['CallsAvailableCountry'] | null;
      /** Handoff Phone */
      handoff_phone?: string | null;
      /** Calls Terms Agreed On */
      calls_terms_agreed_on?: string | null;
      /** Work Research Terms Agreed On */
      work_research_terms_agreed_on?: string | null;
      /** Labs Experimental Terms Agreed On */
      labs_experimental_terms_agreed_on?: string | null;
      /** Calls Send Summary Email */
      calls_send_summary_email?: string | null;
      /**
       * Calls Send Summary Email Enabled
       * @default false
       */
      calls_send_summary_email_enabled: boolean;
      /**
       * @default {
       *       "enabled": false
       *     }
       */
      comms_session_retention_settings: components['schemas']['RetentionSettings'];
      /**
       * Default Consult Note Edit Display
       * @default false
       */
      default_consult_note_edit_display: boolean;
      /**
       * Is Auto Verify Enabled
       * @default false
       */
      is_auto_verify_enabled: boolean;
      /**
       * Auto Verify Preference Set
       * @default false
       */
      auto_verify_preference_set: boolean;
      /**
       * Is Auto Verify Lite Enabled
       * @default false
       */
      is_auto_verify_lite_enabled: boolean;
      /**
       * Auto Verify Lite Preference Set
       * @default false
       */
      auto_verify_lite_preference_set: boolean;
      /** @default light */
      theme: components['schemas']['Theme'] | null;
      /**
       * Scribe Session Page V2 Enabled
       * @default false
       */
      scribe_session_page_v2_enabled: boolean;
      /** Intercom User Id */
      intercom_user_id?: string | null;
      /** Intercom User Hash */
      intercom_user_hash?: string | null;
      /** Intercom User Jwt */
      intercom_user_jwt?: string | null;
      /**
       * Seen Modals
       * @description Tracks which modals the user has seen, keyed by modal_id
       */
      seen_modals?: {
        [key: string]: components['schemas']['ModalView'];
      };
      /**
       * Sales Booking Forms Submitted
       * @description Tracks successful sales-booking form submissions per form_name
       */
      sales_booking_forms_submitted?: {
        [key: string]: components['schemas']['SalesBookingFormSubmission'];
      };
      /** Affiliate Signup Code */
      affiliate_signup_code?: string | null;
      signup_source?: components['schemas']['SignupSource'] | null;
      /**
       * Is New User After Evidence Launch
       * @default false
       */
      is_new_user_after_evidence_launch: boolean;
      evidence_billing?: components['schemas']['EvidenceBillingInfoResponseView'] | null;
      evidence_settings?: components['schemas']['EvidenceSettingsResponse'];
      /** Heidi Referral Code */
      heidi_referral_code?: string | null;
      /** Heidi Referred By Code */
      heidi_referred_by_code?: string | null;
      /**
       * Heidi 2 Access Requested Workspace Ids
       * @description Workspace IDs for which this user has already asked the workspace admins for Heidi 2.0
       */
      heidi_2_access_requested_workspace_ids?: string[];
      /**
       * Heidi Leaderboard Opt Out
       * @default false
       */
      heidi_leaderboard_opt_out: boolean;
      /** Leaderboard Pseudonym */
      leaderboard_pseudonym?: string | null;
      /** @default pseudonym */
      leaderboard_visibility: components['schemas']['LeaderboardVisibility'];
      template_creation_record?: components['schemas']['TemplateCreationRecordSettingsResponse'];
      patient_summary_turn_off_prompt?: components['schemas']['PatientSummaryTurnOffPrompt'];
      /** Chats Migrated Count */
      chats_migrated_count?: number | null;
      /** Last Migrated Chat Id */
      last_migrated_chat_id?: string | null;
      /** Hardware Device Binding Code */
      hardware_device_binding_code?: string | null;
      /** Is Sso Login */
      is_sso_login?: boolean | null;
      /** Is Social Login */
      is_social_login?: boolean | null;
      /**
       * Is Managed
       * @default false
       */
      is_managed: boolean;
      /**
       * Is Evidence Activated
       * @default false
       */
      is_evidence_activated: boolean;
    };
    /**
     * UserRole
     * @enum {string}
     */
    UserRole: UserRole;
    /**
     * UserSelfServiceAuditEvent
     * @description Events triggered by an authenticated end user acting on their own
     *     account (not by internal admins or platform/system actors).
     *
     *     ``Actor.type`` is ``"User"`` and ``Actor.id`` is the caller's
     *     ``user_ref_id`` (i.e. the end user, not an admin).
     * @enum {string}
     */
    UserSelfServiceAuditEvent: UserSelfServiceAuditEvent;
    /** UserToUserMigrateRequest */
    UserToUserMigrateRequest: {
      /** From User Ref Id */
      from_user_ref_id: string;
      /** To User Ref Id */
      to_user_ref_id: string;
    };
    /** UserToUserMigrateTeamRelationRequest */
    UserToUserMigrateTeamRelationRequest: {
      /** From User Ref Id */
      from_user_ref_id: string;
      /** To User Ref Id */
      to_user_ref_id: string;
    };
    /** ValidCollectionResponse */
    ValidCollectionResponse: {
      collection_type: components['schemas']['ValidRegionSyncCollectionTypes'];
      /** Description */
      description: string;
      /** Total Count */
      total_count: number;
    };
    /** ValidCollectionsResponse */
    ValidCollectionsResponse: {
      /** Collections */
      collections: components['schemas']['ValidCollectionResponse'][];
    };
    /**
     * ValidRegionSyncCollectionTypes
     * @enum {string}
     */
    ValidRegionSyncCollectionTypes: ValidRegionSyncCollectionTypes;
    /** ValidateOpenAPIAccessResponse */
    ValidateOpenAPIAccessResponse: {
      /** Is Valid */
      is_valid: boolean;
      /** Is Linked */
      is_linked: boolean;
      account?: components['schemas']['OpenAPILinkedAccount'] | null;
      /** Heidi Email */
      heidi_email?: string | null;
      /** Free Trail End Date */
      free_trail_end_date?: string | null;
      /** Free Trial End Date */
      free_trial_end_date?: string | null;
      linked_account_plan?: components['schemas']['SubscriptionTier'] | null;
      linked_account_conceptual_tier?: components['schemas']['SubscriptionTier'] | null;
      /**
       * Is Reseller Org
       * @default false
       */
      is_reseller_org: boolean;
      /**
       * Is Reseller Org Requires Link Account
       * @default false
       */
      is_reseller_org_requires_link_account: boolean;
      /**
       * Is Freemium Model
       * @default false
       */
      is_freemium_model: boolean;
      third_party_licence_details?:
        | components['schemas']['ThirdPartyLicenceDetails']
        | null;
      /**
       * Is Using Team Billing
       * @default false
       */
      is_using_team_billing: boolean | null;
      /**
       * Is Support Role Only
       * @default false
       */
      is_support_role_only: boolean;
      /**
       * User Roles
       * @default []
       */
      user_roles: string[];
      /**
       * Add On Billing Infos
       * @default []
       */
      add_on_billing_infos: components['schemas']['AddOnBillingInfoResponseView'][];
    };
    /** ValidateOpenAPIJWTResponse */
    ValidateOpenAPIJWTResponse: {
      /** Is Valid */
      is_valid: boolean;
    };
    /** ValidationError */
    ValidationError: {
      /** Location */
      loc: (string | number)[];
      /** Message */
      msg: string;
      /** Error Type */
      type: string;
    };
    /**
     * ValueBP
     * @description Blood pressure value with systolic and diastolic components.
     */
    ValueBP: {
      /** Systolic */
      systolic: string;
      /** Diastolic */
      diastolic: string;
    };
    /** VendorProduct */
    VendorProduct: {
      /** Product Id */
      product_id: string;
      /** Price Id */
      price_id: string;
      period: components['schemas']['shared__enums__enums__Period'];
      vendor: components['schemas']['PaymentVendor'];
      /** Type */
      type: string;
      /** Currency Options */
      currency_options: components['schemas']['CurrencyOption'][];
      /**
       * Last Refresh
       * Format: date-time
       */
      last_refresh?: string;
    };
    /**
     * VendorProductPair
     * @description Represents a product_id and price_id pair for vendor products
     */
    VendorProductPair: {
      /** Product Id */
      product_id: string;
      /** Price Id */
      price_id: string;
    };
    /** VeradigmCreateAdaptorRequest */
    VeradigmCreateAdaptorRequest: {
      /**
       * Ehr Provider
       * @default Veradigm EHR
       * @constant
       */
      ehr_provider: 'Veradigm EHR';
      /**
       * Unity Base Url
       * Format: uri
       */
      unity_base_url: string;
      /** User Id */
      user_id: string;
      /** Password */
      password: string;
      /** Ubiquity Id */
      ubiquity_id?: string | null;
    };
    /** VeradigmEHRLaunchProfileAdditionalDetails */
    VeradigmEHRLaunchProfileAdditionalDetails: {
      /** Ubiquity Id */
      ubiquity_id: string;
    };
    /**
     * VeradigmLaunchErrorResponse
     * @description Error response for failed Veradigm launch verification.
     */
    VeradigmLaunchErrorResponse: {
      /** Code */
      code: string;
      /** Message */
      message: string;
      /** Step Id */
      step_id?: string | null;
    };
    /**
     * VeradigmLaunchResponse
     * @description Response for successful Veradigm SSO launch verification.
     */
    VeradigmLaunchResponse: {
      /** Access Token */
      access_token?: string | null;
      /** Provider */
      provider: string;
      /** Onboarding Session Id */
      onboarding_session_id: string;
      /** Patient Id */
      patient_id: string;
      /** Encounter Id */
      encounter_id: string;
    };
    /**
     * VerbalCommandsLanguagesResponse
     * @description Public catalog response: languages that support dictation verbal commands.
     */
    VerbalCommandsLanguagesResponse: {
      /** Languages */
      languages?: string[];
    };
    /**
     * VerificationSummaryView
     * @description Summary statistics for the entity verification.
     */
    VerificationSummaryView: {
      /** Total Entities Checked */
      total_entities_checked: number;
      /** Entities Present */
      entities_present: number;
      /** Entities Missing */
      entities_missing: number;
      /** Entities High Relevance Missing */
      entities_high_relevance_missing: number;
      /** Entities Medium Relevance Missing */
      entities_medium_relevance_missing: number;
      /** Entities Low Relevance Missing */
      entities_low_relevance_missing: number;
      /** Entities Inaccurate */
      entities_inaccurate: number;
      /** Coverage Percentage */
      coverage_percentage: number;
      /** Potential Hallucinations */
      potential_hallucinations: number;
      /** Potential High Severity Hallucinations */
      potential_high_severity_hallucinations: number;
      /** Potential Medium Severity Hallucinations */
      potential_medium_severity_hallucinations: number;
      /** Potential Low Severity Hallucinations */
      potential_low_severity_hallucinations: number;
      /** Supported Inferences */
      supported_inferences: number;
    };
    /** VerifiedNumber */
    VerifiedNumber: {
      /** Phone Number */
      phone_number: string;
      /** Verification Method */
      verification_method?: string | null;
      /** Verified At */
      verified_at?: string | null;
    };
    /** VerifiedNumbersResponse */
    VerifiedNumbersResponse: {
      /** Numbers */
      numbers: components['schemas']['VerifiedNumber'][];
    };
    /**
     * VerifyCurrentEmailResponse
     * @description Response schema for current email verification request.
     *
     *     The nonce and timestamp should be stored by the client and reused
     *     throughout the entire email change flow.
     */
    VerifyCurrentEmailResponse: {
      /** Status */
      status: string;
      /** Nonce */
      nonce: string;
      /** Timestamp */
      timestamp: string;
      /** Expires At */
      expires_at: string;
    };
    /** VerifyNumberConfirmRequest */
    VerifyNumberConfirmRequest: {
      /**
       * Phone Number
       * @description E.164 number
       */
      phone_number: string;
      /**
       * Verification Code
       * @description Numeric OTP
       */
      verification_code: string;
      /** Verification Method */
      verification_method?: VerifyNumberConfirmRequestVerification_methodAnyOf0 | null;
    };
    /** VerifyNumberResponse */
    VerifyNumberResponse: {
      /** Phone Number */
      phone_number: string;
      /**
       * Verified
       * @description Only meaningful on confirm; the start step always returns false because the OTP has merely been sent.
       * @default false
       */
      verified: boolean;
    };
    /** VerifyNumberStartRequest */
    VerifyNumberStartRequest: {
      /**
       * Phone Number
       * @description E.164 number
       */
      phone_number: string;
      /**
       * Verification Method
       * @default call
       * @enum {string}
       */
      verification_method: VerifyNumberStartRequestVerification_method;
    };
    /** VerifyOTPRequest */
    VerifyOTPRequest: {
      /**
       * Email
       * Format: email
       */
      email: string;
      /** Code */
      code: string;
      /** Nonce */
      nonce: string;
      /** Timestamp */
      timestamp: string;
    };
    /** VerifyOTPResponse */
    VerifyOTPResponse: {
      /** Access Token */
      access_token: string;
      /**
       * Expires At
       * Format: date-time
       */
      expires_at: string;
      scope: components['schemas']['SharedSessionScope'];
    };
    /**
     * VerifyPatientResponse
     * @description Whether the expected patient is the active chart patient on screen.
     */
    VerifyPatientResponse: {
      /** Verified */
      verified: boolean;
      /** Matched Name */
      matched_name?: string | null;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /**
     * VersionType
     * @description Version bump types for semantic versioning.
     * @enum {string}
     */
    VersionType: VersionType;
    /**
     * VersionedTemplateContentResponse
     * @description Response model for versioned template content
     */
    VersionedTemplateContentResponse: {
      /** Content */
      content: string;
      /** Version */
      version: string;
      /**
       * Is Active
       * @default false
       */
      is_active: boolean;
      /** Created At */
      created_at?: string | null;
      /** Created By */
      created_by?: string | null;
    };
    /** VoiceChangedEvent */
    VoiceChangedEvent: {
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Consult Note Id */
      consult_note_id: string;
      /** User Name */
      user_name?: string | null;
      /** Template Name */
      template_name?: string | null;
      /** Original Note */
      original_note: string;
      /** Patches */
      patches?: string | null;
      voice_style?: components['schemas']['VoiceStyle'] | null;
      brain?: components['schemas']['Brain'] | null;
      /**
       * Type
       * @default voice_changed
       * @constant
       */
      type: 'voice_changed';
    };
    /**
     * VoiceOptionView
     * @description A single selectable voice. Agents pin by ``voice_id`` (not label).
     */
    VoiceOptionView: {
      /**
       * Provider
       * @default cartesia
       */
      provider: string;
      /** Voice Id */
      voice_id: string;
      /** Label */
      label: string;
      /** Model Id */
      model_id: string;
      /** Accent */
      accent?: string | null;
    } & {
      [key: string]: unknown;
    };
    /**
     * VoicePreviewRequest
     * @description Request body for ``POST /calls/voices/preview``.
     *
     *     Bounds mirror the upstream ``VoicePreviewRequest`` so a malformed request
     *     fails fast at the BFF instead of after a network hop.
     *
     *     Deliberately omits the upstream ``text`` field: the customer-facing picker
     *     only previews catalog voices, so we never accept free-form text here. The
     *     upstream falls back to its server-side per-language sample, which keeps
     *     customer-supplied (potentially PHI-bearing) text from reaching the TTS
     *     vendor through this path. Free-text previews remain available to the
     *     Internal Admin Lab, which calls ai-receptionist-be directly.
     */
    VoicePreviewRequest: {
      /** Voice Id */
      voice_id: string;
      /**
       * Language
       * @default en
       */
      language: string;
      /** Speed */
      speed?: number | null;
    };
    /**
     * VoiceStyle
     * @description was called writing style
     * @enum {string}
     */
    VoiceStyle: VoiceStyle;
    /**
     * VoicesCatalogView
     * @description Catalog grouped by language. Doubles as the supported-language list.
     */
    VoicesCatalogView: {
      /** Languages */
      languages: components['schemas']['LanguageVoicesView'][];
    };
    /**
     * VoidStockItemRequest
     * @description Body for voiding (soft-deleting) a stock item.
     *
     *     The reason is required and recorded for the audit trail alongside the acting
     *     admin, so a voided unit always carries why it was removed.
     */
    VoidStockItemRequest: {
      /**
       * Reason
       * @description Why this unit is being voided (recorded for the audit trail).
       */
      reason: string;
    };
    /**
     * WaitVerdict
     * @description Caller-submitted decision vocabulary for human-resolved waits.
     * @enum {string}
     */
    WaitVerdict: WaitVerdict;
    /**
     * WalletSummaryResponse
     * @description A wallet's identity plus its per-currency materialized balances.
     */
    WalletSummaryResponse: {
      /** Workspace Id */
      workspace_id: string;
      /** Active */
      active: boolean;
      /** Balances */
      balances: {
        [key: string]: number | string;
      };
    };
    /**
     * WalletTransactionResponse
     * @description One immutable ledger row, projected for the admin history view.
     *
     *     Carries the consumption stamp, so a burn explains itself here rather than
     *     only in the database: which product and dimension combination priced it,
     *     against which pinned card version, at what rate, over what quantity, and
     *     whose usage it was. Without those a row reads as a bare amount, and the only
     *     way to answer "why was this charged" is a Mongo query. Every stamp field is
     *     null on a grant or an adjustment — they exist only on a metered burn.
     *
     *     `quantity` is the RATED quantity and `sum_field` names the source event
     *     field it was totalled from — so `sum_field: "quantity"` reads as "the
     *     rated quantity is the sum of the event's own quantity field".
     */
    WalletTransactionResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      transaction_type: components['schemas']['TransactionType'];
      transaction_source: components['schemas']['TransactionSource'];
      /** Amount */
      amount: number | string;
      /** Currency */
      currency: string;
      /** Source Ref */
      source_ref: string | null;
      /** Actor */
      actor: string | null;
      /** Reason */
      reason: string | null;
      /**
       * Effective At
       * Format: date-time
       */
      effective_at: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Product Key */
      product_key?: string | null;
      /** Dimension Values */
      dimension_values?: {
        [key: string]: string;
      } | null;
      /** Rate Used */
      rate_used?: number | string | null;
      /** Quantity */
      quantity?: number | null;
      /** Aggregation Mode */
      aggregation_mode?: WalletTransactionResponseAggregation_modeAnyOf0 | null;
      /** Sum Field */
      sum_field?: WalletTransactionResponseSum_fieldAnyOf0 | null;
      /** Rate Card Key */
      rate_card_key?: string | null;
      /** Rate Card Version */
      rate_card_version?: number | null;
      /** User Ref Id */
      user_ref_id?: string | null;
    };
    /**
     * WatchLinearIssueRequest
     * @description Subscribe an internal user to a Linear issue and optionally file HubSpot context.
     */
    WatchLinearIssueRequest: {
      /** Linear Issue Identifier */
      linear_issue_identifier: string;
      /**
       * Submitting User Email
       * Format: email
       */
      submitting_user_email: string;
      /** Hubspot Company Id */
      hubspot_company_id?: string | null;
    };
    /** WebApp */
    WebApp: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: WebAppType;
      /** @default Native */
      recording_source: components['schemas']['AppRecordingSource'];
    };
    /**
     * WebSearchGroupRecord
     * @description Record of a web search group execution.
     */
    WebSearchGroupRecord: {
      /**
       * Label
       * @description Group label: 'Local Guidelines', 'Primary Evidence', 'Web Collections', 'Web Search'
       */
      label: string;
      /**
       * Domains
       * @description Restricted domains (None = unrestricted)
       */
      domains?: string[] | null;
      /**
       * Results Returned
       * @default 0
       */
      results_returned: number;
      /**
       * Results Cited
       * @default 0
       */
      results_cited: number;
    };
    /** WeeklyFrequency */
    WeeklyFrequency: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: WeeklyFrequencyKind;
    };
    /**
     * WidgetQuotaType
     * @enum {string}
     */
    WidgetQuotaType: WidgetQuotaType;
    /** WidgetUserQuotaResponse */
    WidgetUserQuotaResponse: {
      note_push_quota: components['schemas']['NotePushQuotaView'];
    };
    /**
     * WorkflowArtifactRef
     * @description A durable artifact the workflow should use on every run.
     *
     *     Stored separately from free-text ``instructions`` so the builder can offer
     *     typed pickers (templates, form templates, …) and dispatch can inject stable
     *     ids into the seed turn.
     */
    WorkflowArtifactRef: {
      /**
       * Type
       * @enum {string}
       */
      type: WorkflowArtifactRefType;
      /** Id */
      id: string;
      /**
       * Label
       * @default
       */
      label: string;
    };
    /** WorkflowDataResponse */
    WorkflowDataResponse: {
      /** Workflow Name */
      workflow_name: string;
      /** Workflow Description */
      workflow_description: string;
      /** Prerequisites */
      prerequisites?: string[];
      /** Parameters */
      parameters?: components['schemas']['WorkflowParameterResponse'][];
      /** Steps */
      steps?: components['schemas']['WorkflowStepResponse'][];
      /** Notes */
      notes?: string[];
    };
    /** WorkflowDataUpdateRequest */
    WorkflowDataUpdateRequest: {
      /**
       * Schema Version
       * @default 1
       */
      schema_version: number;
      /** Workflow Name */
      workflow_name?: string | null;
      /** Workflow Description */
      workflow_description: string;
      /** Prerequisites */
      prerequisites?: string[];
      /** Notes */
      notes?: string[];
      /** Parameters */
      parameters?: components['schemas']['WorkflowParameterUpdateRequest'][];
      /** Steps */
      steps: components['schemas']['WorkflowStepUpdateRequest'][];
    };
    /** WorkflowDataWarning */
    WorkflowDataWarning: {
      /** Code */
      code: string;
      /** Step Number */
      step_number?: number | null;
      /** Ref */
      ref?: string | null;
    };
    /**
     * WorkflowEvalMetric
     * @description One measurable dimension on a routine's eval scorecard.
     */
    WorkflowEvalMetric: {
      /** Metric Id */
      metric_id: string;
      /** Label */
      label: string;
      /**
       * Unit
       * @default percent
       * @enum {string}
       */
      unit: WorkflowEvalMetricUnit;
      /** Threshold */
      threshold: number;
      /**
       * Enabled
       * @default true
       */
      enabled: boolean;
      /**
       * Source
       * @default system
       * @enum {string}
       */
      source: WorkflowEvalMetricSource;
      /**
       * Description
       * @default
       */
      description: string;
    };
    /**
     * WorkflowEvalProfile
     * @description Scorecard definition attached to a workflow.
     *
     *     Empty ``metrics`` means "use system defaults" at read time. Authors and
     *     Internal Admin can enable/disable system rows or append custom metrics.
     */
    WorkflowEvalProfile: {
      /** Metrics */
      metrics?: components['schemas']['WorkflowEvalMetric'][];
      /**
       * Admin Notes
       * @default
       */
      admin_notes: string;
    };
    /** WorkflowEvalProfileResponse */
    WorkflowEvalProfileResponse: {
      /** Metrics */
      metrics?: components['schemas']['WorkflowEvalMetric'][];
      /**
       * Admin Notes
       * @default
       */
      admin_notes: string;
    };
    /** WorkflowListResponse */
    WorkflowListResponse: {
      /** Workflows */
      workflows: components['schemas']['WorkflowResponse'][];
      /** Total */
      total: number;
    };
    /** WorkflowParameterResponse */
    WorkflowParameterResponse: {
      /** Name */
      name: string;
      /** Type */
      type: string;
      /** Description */
      description: string;
      /** Example */
      example: string;
      /** Required */
      required: boolean;
      /** Default Value */
      default_value?: string | null;
    };
    /** WorkflowParameterUpdateRequest */
    WorkflowParameterUpdateRequest: {
      /** Name */
      name: string;
      /** Type */
      type: string;
      /** Description */
      description: string;
      /** Example */
      example: string;
      /** Required */
      required: boolean;
      /** Default Value */
      default_value?: string | null;
    };
    /** WorkflowResponse */
    WorkflowResponse: {
      /** Workflow Id */
      workflow_id: string;
      /** Owner User Id */
      owner_user_id: string;
      /** Name */
      name: string;
      /** Slug */
      slug: string;
      /** Description */
      description: string;
      /** Instructions */
      instructions: string;
      /**
       * Source
       * @enum {string}
       */
      source: WorkflowResponseSource;
      /** Source Recording Id */
      source_recording_id: string | null;
      /** Source Template Id */
      source_template_id: string | null;
      /** Source Template Version */
      source_template_version: string | null;
      /** Requires Desktop */
      requires_desktop: boolean;
      /** Setup Values */
      setup_values?: {
        [key: string]: string;
      };
      /** Artifact Refs */
      artifact_refs?: components['schemas']['WorkflowArtifactRef'][];
      /** Shortcut */
      shortcut: string | null;
      /** Enabled */
      enabled: boolean;
      /** Agent Config Id */
      agent_config_id?: string | null;
      /** Agent Config Version */
      agent_config_version?: number | null;
      /**
       * Product Surface
       * @default work
       * @enum {string}
       */
      product_surface: WorkflowResponseProduct_surface;
      /**
       * Visibility
       * @default User
       */
      visibility: string;
      /** Team Id */
      team_id?: string | null;
      /** Shared Team Ids */
      shared_team_ids?: string[];
      /** Organization Id */
      organization_id?: string | null;
      /** Workspace Id */
      workspace_id?: string | null;
      /**
       * Hidden
       * @default false
       */
      hidden: boolean;
      /** Connectors */
      connectors?: string[];
      /**
       * Can Edit
       * @default false
       */
      can_edit: boolean;
      /**
       * Can Run
       * @default false
       */
      can_run: boolean;
      /**
       * Can Schedule
       * @default false
       */
      can_schedule: boolean;
      eval_profile?: components['schemas']['WorkflowEvalProfile'] | null;
      /** Created At */
      created_at: string | null;
      /** Updated At */
      updated_at: string | null;
    };
    /** WorkflowResultResponse */
    WorkflowResultResponse: {
      /** Status */
      status: string;
      /** Result */
      result: unknown;
      /** Failure */
      failure?: string | null;
    };
    /** WorkflowRunDayOfWeekBucket */
    WorkflowRunDayOfWeekBucket: {
      /**
       * Day
       * @enum {string}
       */
      day: WorkflowRunDayOfWeekBucketDay;
      /** Count */
      count: number;
    };
    /** WorkflowRunDurationByOutcome */
    WorkflowRunDurationByOutcome: {
      /**
       * Outcome
       * @enum {string}
       */
      outcome: WorkflowRunDurationByOutcomeOutcome;
      /** Average Duration Seconds */
      average_duration_seconds?: number | null;
    };
    /** WorkflowRunHistoryPoint */
    WorkflowRunHistoryPoint: {
      /** Date */
      date: string;
      /**
       * Success
       * @default 0
       */
      success: number;
      /**
       * Failed
       * @default 0
       */
      failed: number;
      /**
       * Running
       * @default 0
       */
      running: number;
    };
    /** WorkflowRunListResponse */
    WorkflowRunListResponse: {
      /** Runs */
      runs: components['schemas']['WorkflowRunResponse'][];
      /** Total */
      total: number;
    };
    /** WorkflowRunOutcomeBucket */
    WorkflowRunOutcomeBucket: {
      /**
       * Outcome
       * @enum {string}
       */
      outcome: WorkflowRunOutcomeBucketOutcome;
      /** Count */
      count: number;
    };
    /** WorkflowRunResponse */
    WorkflowRunResponse: {
      /** Project Id */
      project_id: string;
      /** Title */
      title: string | null;
      /** Source Workflow Id */
      source_workflow_id: string | null;
      /** Agent Run Id */
      agent_run_id?: string | null;
      /** Session Id */
      session_id?: string | null;
      /** Created At */
      created_at: string | null;
      /** Updated At */
      updated_at: string | null;
      /** Status */
      status?: WorkflowRunResponseStatusAnyOf0 | null;
      /** Outcome */
      outcome?: WorkflowRunResponseOutcomeAnyOf0 | null;
      /** Failure Reason */
      failure_reason?: string | null;
      /** Duration Seconds */
      duration_seconds?: number | null;
      /** Trigger Type */
      trigger_type?: WorkflowRunResponseTrigger_typeAnyOf0 | null;
      /** Actor User Id */
      actor_user_id?: string | null;
    };
    /** WorkflowRunStatsResponse */
    WorkflowRunStatsResponse: {
      /**
       * Total Runs
       * @default 0
       */
      total_runs: number;
      /** Average Duration Seconds */
      average_duration_seconds?: number | null;
      /** Total Duration Seconds */
      total_duration_seconds?: number | null;
      /** Success Rate */
      success_rate?: number | null;
      /** Outcome Distribution */
      outcome_distribution?: components['schemas']['WorkflowRunOutcomeBucket'][];
      /** Duration By Outcome */
      duration_by_outcome?: components['schemas']['WorkflowRunDurationByOutcome'][];
      /** History */
      history?: components['schemas']['WorkflowRunHistoryPoint'][];
      /** Runs By Day Of Week */
      runs_by_day_of_week?: components['schemas']['WorkflowRunDayOfWeekBucket'][];
    };
    /**
     * WorkflowSetupField
     * @description A per-user setup question the FE collects when installing a preset.
     */
    WorkflowSetupField: {
      /** Key */
      key: string;
      /** Label */
      label: string;
      /**
       * Placeholder
       * @default
       */
      placeholder: string;
      /**
       * Help Text
       * @default
       */
      help_text: string;
      /**
       * Required
       * @default false
       */
      required: boolean;
      /**
       * Multiline
       * @default false
       */
      multiline: boolean;
      /**
       * Kind
       * @default text
       * @enum {string}
       */
      kind: WorkflowSetupFieldKind;
      /** Options */
      options?: string[];
      /** Visible When Field */
      visible_when_field?: string | null;
      /** Visible When Value */
      visible_when_value?: string | null;
      /** Recommended Option */
      recommended_option?: string | null;
      /** Recommended Options */
      recommended_options?: string[];
    };
    /** WorkflowStepResponse */
    WorkflowStepResponse: {
      /** Step Number */
      step_number: number;
      /** Action Description */
      action_description: string;
      /** Step Type */
      step_type: string;
      /** Target Visual Description */
      target_visual_description: string;
      /** Target Location */
      target_location: string;
      /** Nearby Landmarks */
      nearby_landmarks: string;
      /** Details */
      details: string;
      /** Expected Result */
      expected_result: string;
      /**
       * Wait After Seconds
       * @default 0
       */
      wait_after_seconds: number;
      /** Parameter Refs */
      parameter_refs?: string[];
    };
    /** WorkflowStepUpdateRequest */
    WorkflowStepUpdateRequest: {
      /** Step Number */
      step_number: number;
      /** Action Description */
      action_description: string;
      /** Step Type */
      step_type: string;
      /**
       * Target Visual Description
       * @default
       */
      target_visual_description: string;
      /**
       * Target Location
       * @default
       */
      target_location: string;
      /**
       * Nearby Landmarks
       * @default
       */
      nearby_landmarks: string;
      /**
       * Details
       * @default
       */
      details: string;
      /** Expected Result */
      expected_result: string;
      /**
       * Wait After Seconds
       * @default 0
       */
      wait_after_seconds: number;
      /** Parameter Refs */
      parameter_refs?: string[];
    };
    /** WorkflowSummary */
    WorkflowSummary: {
      /** Workflow Id */
      workflow_id: string;
      /** Run Id */
      run_id: string;
      /** Workflow Type */
      workflow_type: string;
      /** Status */
      status: string;
      /**
       * Start Time
       * Format: date-time
       */
      start_time: string;
      /** Close Time */
      close_time?: string | null;
    };
    /** WorkflowTemplateListResponse */
    WorkflowTemplateListResponse: {
      /** Templates */
      templates: components['schemas']['WorkflowTemplateResponse'][];
      /** Total */
      total: number;
    };
    /**
     * WorkflowTemplateResponse
     * @description A catalog preset — presentation lives here, not on forked workflows.
     */
    WorkflowTemplateResponse: {
      /** Template Id */
      template_id: string;
      /** Version */
      version: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Instructions */
      instructions: string;
      /**
       * Source
       * @enum {string}
       */
      source: WorkflowTemplateResponseSource;
      /** Requires Desktop */
      requires_desktop: boolean;
      /** Category */
      category: string;
      /** Icon */
      icon: string;
      /** Highlights */
      highlights: string[];
      /** Suggested Cadence */
      suggested_cadence: string | null;
      /** Suggested Event Types */
      suggested_event_types: string[];
      /** Suggested Shortcut */
      suggested_shortcut?: string | null;
      /** Setup Fields */
      setup_fields?: components['schemas']['WorkflowSetupField'][];
      /**
       * Hidden
       * @default false
       */
      hidden: boolean;
      /** Connectors */
      connectors?: string[];
      /**
       * Integration Primary
       * @default false
       */
      integration_primary: boolean;
      /** Skills */
      skills?: string[];
    };
    /**
     * WorkflowTriggerRef
     * @description Durable trigger identity stamped at dispatch time.
     */
    WorkflowTriggerRef: {
      /**
       * Type
       * @enum {string}
       */
      type: WorkflowTriggerRefType;
      /**
       * Id
       * @default
       */
      id: string;
    };
    /**
     * WorkspaceAdminView
     * @description A role=ADMIN member of a workspace.
     */
    WorkspaceAdminView: {
      /** User Ref Id */
      user_ref_id: string;
      /** Display Name */
      display_name?: string | null;
    };
    /**
     * WorkspaceArtifactContext
     * @description Id-only projection of the artifact open in the FE chat canvas.
     *
     *     Mirrors ``scribe-fe-v2`` ``WorkspaceOpenArtifact``. ``type`` and
     *     ``active_tab`` are intentionally plain (bounded) strings rather than
     *     enums: this is an additive, FE-driven channel and a new canvas
     *     artifact / tab kind must not 422 an older backend (mobile/web
     *     contract discipline — enums are breaking-prone). Only IDs and
     *     system-derived labels travel here; never PHI.
     */
    WorkspaceArtifactContext: {
      /** Type */
      type: string;
      /** Session Id */
      session_id?: string | null;
      /** Patient Id */
      patient_id?: string | null;
      /** Document Id */
      document_id?: string | null;
      /** Template Id */
      template_id?: string | null;
      /** Presentation Id */
      presentation_id?: string | null;
      /** Memory Id */
      memory_id?: string | null;
      /** Workflow Id */
      workflow_id?: string | null;
      /** Active Tab */
      active_tab?: string | null;
    };
    /**
     * WorkspaceContext
     * @description Read-only snapshot of the FE chat canvas, sent per turn.
     *
     *     Gives the Projects parent agent situational awareness of what the
     *     user is looking at (``open_artifact``) and a recording
     *     reconciliation signal (``recording``) so it can correct a stale
     *     belief — e.g. it called ``start_transcribing`` and the user then
     *     refreshed or stopped recording in the UI. Serialised into the
     *     ``[CONTEXT]`` preamble (see ``serialize_run_context_preamble``), which
     *     the agent treats as an untrusted channel.
     */
    WorkspaceContext: {
      /**
       * V
       * @default 1
       * @constant
       */
      v: 1;
      open_artifact?: components['schemas']['WorkspaceArtifactContext'] | null;
      recording?: components['schemas']['WorkspaceRecordingContext'] | null;
    };
    /**
     * WorkspaceDetailResponse
     * @description Detail view of a single workspace — one list row plus its teams.
     */
    WorkspaceDetailResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Admins */
      admins?: components['schemas']['WorkspaceAdminView'][];
      /** Member Count */
      member_count: number;
      /**
       * Is Managed
       * @default false
       */
      is_managed: boolean;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[];
      /** Teams */
      teams?: components['schemas']['SimpleTeamView'][];
      /**
       * Organization Id
       * @description Set when this workspace belongs to an organization (the org's id); null for a plain workspace. A team created here must be Enterprise when this is set.
       */
      organization_id?: string | null;
    };
    /** WorkspaceDetailsResponse */
    WorkspaceDetailsResponse: {
      workspace: components['schemas']['WorkspaceDetailsView'];
    };
    /**
     * WorkspaceDetailsView
     * @description Detail-endpoint payload for a single workspace.
     *
     *     Carries the workspace identity plus every team that points at the
     *     workspace via ``team.workspace_id``. Covers all team-shapes
     *     uniformly: org-attached root + descendants, orphan root + descendants,
     *     personal workspaces with no attached team (``teams=[]``), and
     *     personal workspaces that later gained an attached team.
     */
    WorkspaceDetailsView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Teams */
      teams?: components['schemas']['SimpleTeamView'][];
    };
    /**
     * WorkspaceInvitationView
     * @description One pending invitation, surfaced as the workspace the user would
     *     join.
     *
     *     Invitations are team-scoped (``TeamInvitation``); there is no
     *     workspace-invitation primitive. ``team_id`` is the hidden handle the
     *     client passes back to the existing accept endpoint. ``workspace_id``
     *     is nullable for the rare invite whose team can't be resolved to a
     *     workspace, in which case ``workspace_name`` falls back to the team
     *     name. ``icon_url`` mirrors ``JoinedWorkspaceRelation`` — a
     *     reserved-shape field that always returns ``null`` until the icon
     *     flow lands.
     */
    WorkspaceInvitationView: {
      /**
       * Invitation Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      invitation_id: string;
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      /** Workspace Id */
      workspace_id?: string | null;
      /** Workspace Name */
      workspace_name: string;
      /** Icon Url */
      icon_url?: string | null;
      /**
       * Expire At
       * Format: date-time
       */
      expire_at: string;
    };
    /**
     * WorkspaceListView
     * @description One workspace row in the internal-admin list response.
     */
    WorkspaceListView: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Admins */
      admins?: components['schemas']['WorkspaceAdminView'][];
      /** Member Count */
      member_count: number;
      /**
       * Is Managed
       * @default false
       */
      is_managed: boolean;
      /**
       * Organization Id
       * @description Set when this workspace belongs to an organization (the org's id); null for a plain workspace. A team created here must be Enterprise when this is set.
       */
      organization_id?: string | null;
    };
    /**
     * WorkspaceMemberTeamView
     * @description A team the member belongs to within the workspace.
     */
    WorkspaceMemberTeamView: {
      /** Team Id */
      team_id: string;
      /** Team Name */
      team_name: string;
    };
    /**
     * WorkspaceMemberView
     * @description One member of a workspace in the members list response.
     */
    WorkspaceMemberView: {
      /** User Ref Id */
      user_ref_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** Display Name */
      display_name?: string | null;
      /** Role */
      role: string;
      /** Teams */
      teams?: components['schemas']['WorkspaceMemberTeamView'][];
    };
    /**
     * WorkspaceOrderBy
     * @description Allowed fields for ordering workspaces.
     * @enum {string}
     */
    WorkspaceOrderBy: WorkspaceOrderBy;
    /**
     * WorkspaceRealignStatusResponse
     * @description Status of a workspace re-tag, read straight from Temporal.
     *
     *     ``running`` is non-terminal; the rest are terminal. The DAG blocks until a
     *     terminal status and fails unless it is ``succeeded``.
     */
    WorkspaceRealignStatusResponse: {
      /** Workflow Id */
      workflow_id: string;
      /**
       * Status
       * @enum {string}
       */
      status: WorkspaceRealignStatusResponseStatus;
    };
    /**
     * WorkspaceRecordingContext
     * @description Reconciled recording lifecycle for the subject session.
     *
     *     ``state`` is a small, stable set so it stays a ``Literal``. ``mode``
     *     is left a bounded string for the same forward-compat reason as
     *     ``WorkspaceArtifactContext`` fields.
     */
    WorkspaceRecordingContext: {
      /**
       * State
       * @enum {string}
       */
      state: WorkspaceRecordingContextState;
      /** Session Id */
      session_id?: string | null;
      /** Mode */
      mode?: string | null;
    };
    /**
     * WorkspaceRole
     * @enum {string}
     */
    WorkspaceRole: WorkspaceRole;
    /** AttachmentDownloadUrlResponse */
    apis__v2__agent_events__AttachmentDownloadUrlResponse: {
      /** Url */
      url: string;
    };
    /** CreateSessionRequest */
    apis__v2__calls__agent_builder__CreateSessionRequest: {
      /** Agent Config Id */
      agent_config_id: string;
      /** Update Field */
      update_field?: 'agent_config' | null;
    };
    /** CallDetailView */
    apis__v2__calls__inbox_schemas__CallDetailView: {
      /** Session Id */
      session_id: string;
      /** Duration Seconds */
      duration_seconds: number;
      /** Summary */
      summary?: string | null;
      /** Transcript */
      transcript?: string | null;
      /** Turns Transcript */
      turns_transcript?: components['schemas']['TranscriptTurnView'][] | null;
      /** Recording Url */
      recording_url?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Qa Score */
      qa_score?: number | null;
      /** Language Codes */
      language_codes?: string[] | null;
    };
    /** CallDetailView */
    apis__v2__calls__schemas__CallDetailView: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      patient?: components['schemas']['CallPatient'] | null;
      status: components['schemas']['CallStatus'];
      /** Scheduled Time */
      scheduled_time: string | null;
      call_direction: components['schemas']['CallDirection'];
      /** Agent Name */
      agent_name: string | null;
      channel?: components['schemas']['CallChannel'] | null;
      /** Call Date */
      call_date: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Read
       * @default false
       */
      read: boolean;
      /** Summary Header */
      summary_header?: string | null;
      call_classification?: components['schemas']['CallClassification'] | null;
      /**
       * @description Inbox grouping derived from status + read + classification outcome. Drives the Needs Attention / In Progress / Resolved groupings on the frontend. Always present in responses.
       * @default needs_attention
       */
      bucket: components['schemas']['CallBucket'];
      /** Summary */
      summary?: string | null;
      /** Transcript */
      transcript?: components['schemas']['domainmodel__calls__models__Message'][] | null;
      /** Audio Url */
      audio_url?: string | null;
      /** Duration Seconds */
      duration_seconds?: number | null;
      /** Failure Reason */
      failure_reason?: string | null;
    };
    /** AvailableStandardizedSection */
    apis__v2__ehr__uploader_schema__AvailableStandardizedSection: {
      section_id: components['schemas']['SectionalNoteSection'];
      /**
       * Name
       * @description The name of the section
       * @example History of Present Illness
       */
      readonly name: string;
    };
    /** AvailableStandardizedSectionsResponse */
    apis__v2__ehr__uploader_schema__AvailableStandardizedSectionsResponse: {
      /** Available Sections */
      available_sections: components['schemas']['apis__v2__ehr__uploader_schema__AvailableStandardizedSection'][];
    };
    /** IDType */
    apis__v2__ehrlaunch__mobile__avr__avr_schema__haiku__models__IDType: {
      /**
       * Id
       * @description The ID of the object.
       */
      ID: string;
      /**
       * Type
       * @description Type of ID. 'EXTERNAL', 'INTERNAL', 'FHIR', 'FHIR STU3', 'MRN', and 'CSN' are expected types.
       */
      Type: components['schemas']['IDTypes'] | string;
    };
    /** UpdateUserEHRLaunchProfileRequest */
    apis__v2__ehrlaunch__onboarding_schema__UpdateUserEHRLaunchProfileRequest: {
      /** Internal Id */
      internal_id: string;
    };
    /**
     * SubmitTurnRequest
     * @description Turn body — messages and metadata only.
     *
     *     The agent (provider, model, system prompt, tools) is configured at run
     *     start via ``StartRunRequest.agent``. Per-turn agent overrides are out
     *     of scope.
     *
     *     Note: ``AgentTurnInput`` carries dispatcher-owned fields
     *     (``submitted_by_hook``, ``hook_lineage_depth``) that must never be set
     *     from an operator HTTP body. Unknown keys arriving via the wire are
     *     dropped; dispatcher-owned keys are logged at WARN, others at INFO.
     */
    apis__v2__internal_admin__agent_harness__SubmitTurnRequest: {
      /** Messages */
      messages: components['schemas']['pkg__agent_harness__core__llm_contracts__Message'][];
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      };
    };
    /** SubmitTurnResponse */
    apis__v2__internal_admin__agent_harness__SubmitTurnResponse: {
      /** Turn Id */
      turn_id: string;
    };
    /**
     * SortOrder
     * @enum {string}
     */
    apis__v2__internal_admin__orders__orders_schema__SortOrder: Apis__v2__internal_admin__orders__orders_schema__SortOrder;
    /** UpdateUserEHRLaunchProfileRequest */
    apis__v2__internal_admin__user_ehr_launch_profile__schema__UpdateUserEHRLaunchProfileRequest: {
      /** Internal Id */
      internal_id?: string | null;
      /** Profile Name */
      profile_name?: string | null;
      /** Known Internal Ids */
      known_internal_ids?: string[] | null;
    };
    /** SimpleSpecialtyResponse */
    apis__v2__open_api__specialty__specialty_schema__SimpleSpecialtyResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
    };
    /** SpecialtiesResponse */
    apis__v2__open_api__specialty__specialty_schema__SpecialtiesResponse: {
      /** Specialties */
      specialties: components['schemas']['apis__v2__open_api__specialty__specialty_schema__SimpleSpecialtyResponse'][];
      /** Total */
      total: number;
    };
    /** ImportPatientProfilesResponse */
    apis__v2__patientprofile__patient_profile_schema__ImportPatientProfilesResponse: {
      /** Created Count */
      created_count: number;
      /** Skipped Count */
      skipped_count: number;
      /** Created Ids */
      created_ids: string[];
      /** Skipped */
      skipped: components['schemas']['ImportPatientProfilesSkippedRow'][];
      /** Error */
      error?: string | null;
    };
    /** SubmitTurnRequest */
    apis__v2__projects__schema__SubmitTurnRequest: {
      /**
       * Prompt
       * @default
       */
      prompt: string;
      /**
       * Routine Name
       * @description Routine name for server-owned chat titling.
       */
      routine_name?: string | null;
      /**
       * Attachment Ids
       * @description IDs of attachments uploaded via ``POST /projects/{project_id}/attachments``. The harness appends them as ``AttachmentBlock``s on the user message. Per-turn cap mirrors ``AGENT_ATTACHMENT_MAX_PER_TURN``.
       */
      attachment_ids?: string[] | null;
      /**
       * Session Id
       * @description Heidi clinical session ID linked to this turn. The parent surfaces it to ``lookup_evidence`` / ``answer_with_evidence`` so the Evidence subagent can ground its synthesis in the session's transcript + patient context (without ever sending PHI to Tavily).
       */
      session_id?: string | null;
      /**
       * Patient Profile Id
       * @description Heidi patient profile ID. Forwarded to the Evidence subagent so its retrieval is patient-aware. Use this when the user has picked a patient without a specific session.
       */
      patient_profile_id?: string | null;
      /**
       * Jurisdiction
       * @description ISO-style country / region code (``UK``, ``US``, ``AU``, ``NZ``, ``CA``, ``IE``, ``EU``). Forwarded to Evidence as ``user_country_code`` so guideline retrieval prefers the right jurisdiction.
       */
      jurisdiction?: string | null;
      /**
       * Library Collection Ids
       * @description User document collection IDs to scope Evidence library search to. Equivalent to picking specific collections in the standalone Evidence chat sidebar.
       */
      library_collection_ids?: string[] | null;
      /** @description Rendering hint forwarded to the desktop computer-use executor (platform, screen geometry). NOT an entitlement: tool gates are enforced by tool_profile + tool_approval_overrides + FGA, never by these caps. Send on desktop builds when a turn may invoke a seeded skill tool or other remote computer-use sub-agent. */
      client_capabilities?: components['schemas']['ClientCapabilities'] | null;
      /**
       * Target Id
       * @description Opaque id of a same-user registered desktop target to route this turn's computer-use work to. Validated as a canonical lowercase-hyphenated UUID v7 (the spelling the backend generates when a desktop target registers). The Project's primary run snapshot freezes whether target routing is enabled: target-mode runs ignore request client_capabilities, while legacy-mode runs reject a non-null target_id.
       */
      target_id?: string | null;
      /** @description FE-injected structured RPA skill (a segmented task carrying a ``skill_ref`` segment) to expose as a run-scoped tool on this turn. The skill identity is structured, but parameter values must come from the user's free-text prompt/text segments and be authored by the parent agent's tool call. Submitted ``skill_ref.parameters`` are rejected. Absent on web/headless turns. */
      computer_use_skill?: components['schemas']['RpaSegmentedTask'] | null;
      /** @description Read-only snapshot of what the FE chat canvas currently shows (open artifact + recording lifecycle). Folded into the ``[CONTEXT]`` preamble so the parent has situational awareness and can reconcile a stale recording belief. IDs + enum labels only — never PHI. Absent on non-canvas surfaces (e.g. the Cmd+Shift+H overlay). */
      workspace?: components['schemas']['WorkspaceContext'] | null;
      /** @description FE-authored canonical note-push plan, sent when the user confirms a section->EMR-field mapping. Carries flow identity (workspace / session / app / template) and exactly one confirmed selector per section — NO clinical content (the note is fetched server-side by session id). The backend validates it against the run's frozen workspace + session, compiles the write, and exposes a run-scoped ``push_confirmed_note`` tool the parent calls to execute it. An identity mismatch or an incomplete mapping is rejected with a 4xx (the latter routes the user back to discovery). Desktop only. */
      note_push_plan?: components['schemas']['NotePushExecutionPlan'] | null;
      /** @description Run-scoped approval mode the composer toggle is showing as this turn is sent. ``manual`` keeps the run's per-tool approval gates; ``auto`` relaxes the ones marked bypassable. Seeds the run when this turn starts one, otherwise flips the live run's recorded mode before the turn runs. Omitted leaves the run's mode untouched. Run-wide — distinct from the per-tool project setting ``ProjectToolApproval.mode``. */
      approval_mode?: components['schemas']['ApprovalMode'] | null;
      /**
       * Turn Id
       * @description Client-minted turn id. Supplying it makes the POST idempotent: an identical retry re-signals without re-persisting, and a retry with a different payload is rejected with 409. Omitted mints one server-side (the pre-existing behaviour).
       */
      turn_id?: string | null;
    };
    /** SubmitTurnResponse */
    apis__v2__projects__schema__SubmitTurnResponse: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Turn Id */
      turn_id: string;
      /** User Message Ids */
      user_message_ids?: string[];
    };
    /**
     * SessionPermissionsResponse
     * @description Hierarchical permission structure for session resources.
     *
     *     Only includes resources the user has permission to access.
     */
    apis__v2__sessions__sessions_schema__SessionPermissionsResponse: {
      /** Session Id */
      session_id: string;
      /** Session Permissions */
      session_permissions: string[];
      /** Documents */
      documents?: components['schemas']['DocumentPermissions'][];
      /** Consult Notes */
      consult_notes?: components['schemas']['ConsultNotePermissions'][];
    };
    /** EventRuleResponse */
    apis__v2__workflows__schema__EventRuleResponse: {
      /** Rule Id */
      rule_id: string;
      event_type: components['schemas']['EventType'];
      /** Filters */
      filters?: {
        [key: string]: unknown;
      };
      /** Workflow Id */
      workflow_id: string | null;
      /** Delay Seconds */
      delay_seconds: number | null;
      /** Enabled */
      enabled: boolean;
      /** Created At */
      created_at: string | null;
      /** Updated At */
      updated_at: string | null;
      /** Conditions */
      conditions?: {
        [key: string]: unknown;
      }[];
      /** Delivery Policy */
      delivery_policy?: {
        [key: string]: unknown;
      } | null;
    };
    /** IntegrationRequest */
    database__mongo__base__IntegrationRequest: {
      /** @deprecated */
      integration?: components['schemas']['IntegrationOption'] | null;
      /** Ehr Provider */
      ehr_provider?: components['schemas']['EHRProvider'] | string | null;
      /** Other Integration */
      other_integration?: string | null;
      /**
       * Email
       * @default
       */
      email: string;
      /**
       * Is Clinician Decision Maker
       * @default false
       */
      is_clinician_decision_maker: boolean;
    };
    /** IntegrationRequest */
    database__mongo__models__integrations__integration_request__IntegrationRequest: {
      /**
       * Id
       * @description MongoDB document ObjectID
       */
      _id?: string | null;
      /** Integration Name */
      integration_name: string;
      /** Email */
      email: string;
      /**
       * Is Clinician Decision Maker
       * @default false
       */
      is_clinician_decision_maker: boolean;
      /** Workspace Id */
      workspace_id?: string | null;
      /** User Id */
      user_id: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at?: string;
    };
    /**
     * CodeSystem
     * @example http://loinc.org
     */
    dataclass__nebula_session__generated_data__common__CodeSystem: string;
    /**
     * Coding
     * @description A coded value with optional system and display text.
     */
    dataclass__nebula_session__generated_data__common__Coding: {
      /** Code */
      code: string;
      codeSystem?:
        | components['schemas']['dataclass__nebula_session__generated_data__common__CodeSystem']
        | null;
      /** Display */
      display?: string | null;
    };
    /**
     * Observation
     * @description A value for a single non-duplicable flowsheet row on a template.
     */
    dataclass__nebula_session__generated_data__flowsheet__Observation: {
      context: components['schemas']['ObservationContext'];
      /** Templateid */
      templateId?: string | null;
      /** Value */
      value?: string | components['schemas']['ValueBP'] | null;
      /** Valueunit */
      valueUnit?: string | null;
      provenance?: components['schemas']['Provenance'] | null;
    };
    /**
     * NoteSection
     * @description A generated note section (e.g. HPI, A&P).
     */
    dataclass__nebula_session__generated_data__note_section__NoteSection: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: Dataclass__nebula_session__generated_data__note_section__NoteSectionType;
      /** Uid */
      uid: string;
      /** Codes */
      codes: components['schemas']['NoteSectionCoding'][];
      /** Text */
      text: string;
    };
    /**
     * IDType
     * @description Typed identifier used for user, patient, and encounter IDs.
     *
     *     ``category`` discriminates the ID system. Expected values are members
     *     of ``NebulaIDCategory`` but unknown values are accepted at runtime.
     */
    dataclass__nebula_session__models__IDType: {
      /** Id */
      id: string;
      category: components['schemas']['NebulaIDCategory'];
    };
    /** Identifier */
    dataclass__patient_profile__Identifier: {
      /** System */
      system: components['schemas']['EHRProvider'] | string;
      /** Value */
      value: string;
    };
    /** Message */
    domainmodel__calls__models__Message: {
      /** Speaker */
      speaker: string;
      /** Start Time */
      start_time?: number | string | null;
      /** Text */
      text: string;
    };
    /**
     * EvidenceBillingInfoResponseView
     * @description Response view for evidence billing information.
     */
    domains__billing__api__billing_schema__EvidenceBillingInfoResponseView: {
      tier: components['schemas']['EvidenceSubscriptionTier'];
      source: components['schemas']['EvidenceBillingSource'];
      /** Stripe Subscription Id */
      stripe_subscription_id?: string | null;
      /** Plan Start Date */
      plan_start_date?: string | null;
      /** Plan End Date */
      plan_end_date?: string | null;
      /** Trial End Date */
      trial_end_date?: string | null;
      /** Next Billing Date */
      next_billing_date?: string | null;
      /**
       * Is In Free Trial
       * @default false
       */
      is_in_free_trial: boolean;
      plan_cycle?: components['schemas']['shared__enums__enums__Period'] | null;
      /** @deprecated */
      third_party_license?: components['schemas']['ThirdPartyLicenceDetails'] | null;
      /** Canceled At */
      canceled_at?: string | null;
      /**
       * Is Stripe Managed
       * @default true
       */
      is_stripe_managed: boolean;
      cancellation_intent?:
        | components['schemas']['CancellationIntentResponseView']
        | null;
    };
    /**
     * CodeSystem
     * @enum {string}
     */
    domains__coding__pkg__enums__CodeSystem: Domains__coding__pkg__enums__CodeSystem;
    /** CreateSessionRequest */
    domains__sessions__schemas__CreateSessionRequest: {
      /** Timezone */
      timezone?: string | null;
      /**
       * Is Auto Mode
       * @default false
       */
      is_auto_mode: boolean;
      /** Patient Profile Id */
      patient_profile_id?: string | null;
      /** Ehr Appointment Id */
      ehr_appointment_id?: string | null;
      /** Created Time Local */
      created_time_local?: string | null;
      session_status?: components['schemas']['SessionStatus'] | null;
      /** Creation Platform */
      creation_platform?:
        | (
            | components['schemas']['WebApp']
            | components['schemas']['DesktopApp']
            | components['schemas']['IOSApp']
            | components['schemas']['AndroidApp']
            | components['schemas']['RemoteApp']
          )
        | null;
      language_code?: components['schemas']['LanguageCode'] | null;
      /** Language Code List */
      language_code_list?: components['schemas']['LanguageCode'][] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
    };
    /** CreateSessionResponse */
    domains__sessions__schemas__CreateSessionResponse: {
      /** Session Id */
      session_id: string;
      /**
       * Is Consent
       * @default false
       */
      is_consent: boolean | null;
    };
    /** DownloadUrlResponse */
    domains__translator__api__schemas__audio__DownloadUrlResponse: {
      /** Downloadurl */
      downloadUrl: string;
    };
    /** CreateSessionRequest */
    domains__translator__api__schemas__sessions__CreateSessionRequest: {
      /** Title */
      title: string;
      /** Patientlanguage */
      patientLanguage: string;
      /** Clinicianlanguage */
      clinicianLanguage: string;
      patient?: components['schemas']['PatientDetailsRequest'] | null;
      /** Reasonforvisit */
      reasonForVisit?: string | null;
      patientOnboardingStatus?: components['schemas']['OnboardingStatus'] | null;
    };
    /** CreateSessionResponse */
    domains__translator__api__schemas__sessions__CreateSessionResponse: {
      /** Id */
      id: string;
    };
    /**
     * Gender
     * @enum {string}
     */
    domains__translator__models__enums__Gender: Domains__translator__models__enums__Gender;
    /** ImportPatientProfilesResponse */
    domains__workspace__api__internal_admin__migration__schemas__ImportPatientProfilesResponse: {
      /** Inserted Count */
      inserted_count: number;
      /** Skipped Count */
      skipped_count: number;
      /**
       * Patient Documents Inserted
       * @default 0
       */
      patient_documents_inserted: number;
      /**
       * Patient Documents Skipped
       * @default 0
       */
      patient_documents_skipped: number;
    };
    /**
     * ListWorkspacesResponse
     * @description Response schema for the internal-admin workspace list.
     */
    domains__workspace__api__internal_admin__workspaces__workspaces_schema__ListWorkspacesResponse: {
      /** Workspaces */
      workspaces?: components['schemas']['WorkspaceListView'][];
      /**
       * Total
       * @description Total workspaces matching the filters
       * @default 0
       */
      total: number;
      /**
       * Page
       * @description Current page number
       * @default 1
       */
      page: number;
      /**
       * Page Size
       * @description Number of workspaces per page
       * @default 20
       */
      page_size: number;
    };
    /**
     * DownloadUrlResponse
     * @description Response containing a presigned S3 download URL.
     */
    evidence__models__user_document__DownloadUrlResponse: {
      /**
       * Url
       * @description Presigned S3 URL for downloading the file
       */
      url: string;
      /**
       * Expires At
       * Format: date-time
       * @description When the URL expires
       */
      expires_at: string;
      /**
       * Filename
       * @description Original filename for Content-Disposition
       */
      filename: string;
    };
    /**
     * ContactPoint
     * @description Disclaimer: Any field name ends with ``__ext`` doesn't part of
     *     Resource StructureDefinition, instead used to enable Extensibility feature
     *     for FHIR Primitive Data Types.
     *
     *     Details of a Technology mediated contact point (phone, fax, email, etc.).
     *     Details for all kinds of technology mediated contact points for a person or
     *     organization, including telephone, email, etc.
     */
    fhir__resources__contactpoint__ContactPoint: {
      /** Fhir Comments */
      fhir_comments?: string | string[] | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the element. To make the use of extensions safe and managable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?: unknown[] | null;
      /**
       * Unique id for inter-element referencing
       * @description Unique id for the element within a resource (for internal references). This may be any string value that does not contain spaces.
       */
      id?: string | null;
      /** Time period when the contact point was/is in use */
      period?: unknown | null;
      /**
       * Specify preferred order of use (1 = highest)
       * @description Specifies a preferred order in which to use a set of contacts. ContactPoints with lower rank values are more preferred than those with higher rank values.
       */
      rank?: number | null;
      /** Extension field for ``rank``. */
      _rank?: unknown | null;
      /**
       * phone | fax | email | pager | url | sms | other
       * @description Telecommunications form for contact point - what communications system is required to make use of the contact.
       */
      system?: string | null;
      /** Extension field for ``system``. */
      _system?: unknown | null;
      /**
       * home | work | temp | old | mobile - purpose of this contact point
       * @description Identifies the purpose for the contact point.
       */
      use?: string | null;
      /** Extension field for ``use``. */
      _use?: unknown | null;
      /**
       * The actual contact point details
       * @description The actual contact point details, in a form that is meaningful to the designated communication system (i.e. phone number or email address).
       */
      value?: string | null;
      /** Extension field for ``value``. */
      _value?: unknown | null;
    };
    /**
     * HumanName
     * @description Disclaimer: Any field name ends with ``__ext`` doesn't part of
     *     Resource StructureDefinition, instead used to enable Extensibility feature
     *     for FHIR Primitive Data Types.
     *
     *     Name of a human or other living entity - parts and usage.
     *     A name, normally of a human, that can be used for other living entities
     *     (e.g. animals but not organizations) that have been assigned names by a
     *     human and may need the use of name parts or the need for usage information.
     */
    fhir__resources__humanname__HumanName: {
      /** Fhir Comments */
      fhir_comments?: string | string[] | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the element. To make the use of extensions safe and managable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?: unknown[] | null;
      /**
       * Unique id for inter-element referencing
       * @description Unique id for the element within a resource (for internal references). This may be any string value that does not contain spaces.
       */
      id?: string | null;
      /**
       * Family name (often called 'Surname')
       * @description The part of a name that links to the genealogy. In some cultures (e.g. Eritrea) the family name of a son is the first name of his father.
       */
      family?: string | null;
      /** Extension field for ``family``. */
      _family?: unknown | null;
      /**
       * Given names (not always 'first'). Includes middle names
       * @description Given name.
       */
      given?: (string | null)[] | null;
      /** Extension field for ``given``. */
      _given?: (unknown | null)[] | null;
      /**
       * Time period when name was/is in use
       * @description Indicates the period of time when this name was valid for the named person.
       */
      period?: unknown | null;
      /**
       * Parts that come before the name
       * @description Part of the name that is acquired as a title due to academic, legal, employment or nobility status, etc. and that appears at the start of the name.
       */
      prefix?: (string | null)[] | null;
      /** Extension field for ``prefix``. */
      _prefix?: (unknown | null)[] | null;
      /**
       * Parts that come after the name
       * @description Part of the name that is acquired as a title due to academic, legal, employment or nobility status, etc. and that appears at the end of the name.
       */
      suffix?: (string | null)[] | null;
      /** Extension field for ``suffix``. */
      _suffix?: (unknown | null)[] | null;
      /**
       * Text representation of the full name
       * @description Specifies the entire name as it should be displayed e.g. on an application UI. This may be provided instead of or as well as the specific parts.
       */
      text?: string | null;
      /** Extension field for ``text``. */
      _text?: unknown | null;
      /**
       * usual | official | temp | nickname | anonymous | old | maiden
       * @description Identifies the purpose for this name.
       */
      use?: string | null;
      /** Extension field for ``use``. */
      _use?: unknown | null;
    };
    /**
     * AgentConfig
     * @description The primary public configuration surface for an agent run.
     *
     *     Callers declare tools by registered name plus optional ``as_name`` aliases.
     *     The registry resolves tool names against its catalog of registered
     *     ``ToolSpec`` instances and produces a replay-safe ``ResolvedAgentConfig``.
     *     ``max_tokens_per_turn`` caps generated output for one LLM turn when set;
     *     ``None`` defers to the provider/model default resolved by the LLM layer.
     *     ``max_tool_result_attachments_per_turn`` caps tool-result attachments
     *     such as remote screenshots when set. ``None`` leaves the agent config
     *     uncapped; product services that need a domain default should pass one
     *     explicitly when constructing the config.
     *
     *     ``sub_agents`` declares pre-bound child agents that the LLM can invoke
     *     as tools. Each binding projects into a synthesized tool at resolve
     *     time; the runtime path is the same generic ``invoke_agent`` primitive
     *     used for dynamic invocations. Bindings with ``config_id`` are resolved
     *     and frozen at parent run ingress so the child config is stable for
     *     the life of the parent run. Dynamic invocation (an entry with name
     *     ``"invoke_agent"`` in ``tools[]``) resolves its child config at
     *     invocation time instead.
     */
    pkg__agent_harness__core__config__AgentConfig: {
      /** Name */
      name: string;
      /** Provider */
      provider: string;
      /** Model */
      model: string;
      /**
       * System Prompt
       * @default
       */
      system_prompt: string;
      /** System Prompt Variables */
      system_prompt_variables?: components['schemas']['PromptVariableBinding'][] | null;
      /** Provider Extra Headers */
      provider_extra_headers?: {
        [key: string]: string;
      };
      /** Provider Extra Body */
      provider_extra_body?: {
        [key: string]: unknown;
      };
      /**
       * Fast Mode
       * @default false
       */
      fast_mode: boolean;
      /** Max Tokens Per Turn */
      max_tokens_per_turn?: number | null;
      /** Max Tool Result Attachments Per Turn */
      max_tool_result_attachments_per_turn?: number | null;
      /**
       * Llm Determined Success
       * @default false
       */
      llm_determined_success: boolean;
      llm?: components['schemas']['LLMConfig'];
      /** Fallback Llms */
      fallback_llms?: components['schemas']['LLMConfig'][];
      /** Thinking Budget Tokens */
      thinking_budget_tokens?: number | null;
      /**
       * Adaptive Thinking
       * @default false
       */
      adaptive_thinking: boolean;
      /** Reasoning Effort */
      reasoning_effort?: Pkg__agent_harness__core__config__AgentConfigReasoning_effortAnyOf0 | null;
      /**
       * Cache Strategy
       * @default off
       * @enum {string}
       */
      cache_strategy: Pkg__agent_harness__core__config__AgentConfigCache_strategy;
      /** Tools */
      tools?: components['schemas']['AgentToolConfig'][];
      /** Sub Agents */
      sub_agents?: components['schemas']['SubAgentBinding'][];
      /** Hooks */
      hooks?: components['schemas']['HookBinding'][];
      /** Managed Run Lifecycle */
      managed_run_lifecycle?: components['schemas']['ManagedRunLifecycleBinding'][];
      /**
       * Allow Manual Close Sub Agent
       * @default true
       */
      allow_manual_close_sub_agent: boolean;
      /** Reminders */
      reminders?: components['schemas']['Reminder'][];
      /** Kind */
      kind?: string | null;
      /** Metadata */
      metadata?: {
        [key: string]: unknown;
      };
    };
    /**
     * Message
     * @description Canonical conversational message.
     *
     *     ``role`` is restricted to ``user`` / ``assistant``; system prompts live on
     *     ``LLMCallRequest.system_prompt``, not here.
     */
    pkg__agent_harness__core__llm_contracts__Message: {
      /**
       * Role
       * @enum {string}
       */
      role: Pkg__agent_harness__core__llm_contracts__MessageRole;
      /** Blocks */
      blocks?: (
        | components['schemas']['TextBlock']
        | components['schemas']['ThinkingBlock']
        | components['schemas']['ToolCallBlock']
        | components['schemas']['ToolResultBlock']
        | components['schemas']['AttachmentBlock']
      )[];
      /** Event Type */
      event_type?: string | null;
      /** System Generated */
      system_generated?: boolean | null;
    };
    /**
     * AgentConfig
     * @description Configuration model for agent settings.
     */
    pkg__calls__models__AgentConfig: {
      /** System Instruction */
      system_instruction?: string | null;
      /** Knowledge Base */
      knowledge_base?: string | null;
      /** Appointment Rules */
      appointment_rules?: string | null;
      /**
       * Escalation Rules
       * @description Transfer conditions governing when the agent should hand a call to a human or direct the caller to emergency services. Must not contain clinical decision logic or patient-identifiable content; upstream guardrails enforce this.
       */
      escalation_rules?: string | null;
      /** User Input */
      user_input?: string | null;
      /** User Input Json */
      user_input_json?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /** Greeting Text */
      greeting_text?: string | null;
      /** Redirect Phone Number */
      redirect_phone_number?: string | null;
      /** Summary Email To */
      summary_email_to?: string | null;
      /** @description Post-call summary delivery configuration (email fields typed for the FE; SMS knobs pass through via ``extra = 'allow'``). See ``SummaryConfig`` for recipient-resolution semantics. */
      summary_config?: components['schemas']['SummaryConfig'] | null;
      /** Tools */
      tools?: components['schemas']['CallToolConfig'][] | null;
      /** @default not_required */
      ehr_integration_status: components['schemas']['EHRIntegrationStatus'];
      /** Ehr Provider */
      ehr_provider?: string | null;
      /** Ehr Write Permissions */
      ehr_write_permissions?: boolean | null;
      /** Heidi Schedule */
      heidi_schedule?: {
        [key: string]: unknown;
      } | null;
      /** Agent Schedule */
      agent_schedule?: {
        [key: string]: unknown;
      } | null;
      /**
       * Default Language Code
       * @description Effective language code for the language the call starts in — mostly ISO 639-1, plus regional variants such as 'pt-BR'/'pt-PT' (Brazilian and European Portuguese are separate languages; bare 'pt' is rejected upstream). Defaults to 'en' upstream when unset. The set of languages the agent can switch to is derived from this plus voices_by_language keys.
       */
      default_language_code?: string | null;
      /**
       * Voices By Language
       * @description Per-language voice overrides keyed by effective language code (ISO 639-1, plus regional variants such as 'pt-BR'/'pt-PT'). Set NON-ENGLISH voices here. English ('en') is owned by the legacy cartesia_voice_id / eleven_labs_voice_id scalars below — upstream re-derives voices_by_language['en'] from the matching scalar on every save, so a directly-written 'en' entry is ignored.
       */
      voices_by_language?: {
        [key: string]: components['schemas']['AgentVoiceSpec'];
      } | null;
      /**
       * Cartesia Voice Id
       * @description English Cartesia voice id (write target for English on Cartesia agents).
       */
      cartesia_voice_id?: string | null;
      /**
       * Cartesia Voice Speed
       * @description English Cartesia voice speed (Cartesia range ~[0.6, 1.5]).
       */
      cartesia_voice_speed?: number | null;
      /**
       * Eleven Labs Voice Id
       * @description English ElevenLabs voice id (write target for English on ElevenLabs agents).
       */
      eleven_labs_voice_id?: string | null;
    } & {
      [key: string]: unknown;
    };
    /**
     * NoteSection
     * @description Haiku-specific note section identifiers (LOINC codes).
     *
     *     This enum is used for validating incoming Haiku data.
     *     Human-readable names are handled by HaikuAmbientAdaptor.
     * @enum {string}
     */
    pkg__ehr__third_party_ambient_audio__haiku__models__note_sections__NoteSection: Pkg__ehr__third_party_ambient_audio__haiku__models__note_sections__NoteSection;
    /** EventRuleResponse */
    pkg__event_triggers__schemas__EventRuleResponse: {
      /** Rule Id */
      rule_id: string;
      /**
       * Scope Type
       * @enum {string}
       */
      scope_type: Pkg__event_triggers__schemas__EventRuleResponseScope_type;
      /** Scope Id */
      scope_id: string;
      event_type: components['schemas']['EventType'];
      /** Filters */
      filters?: {
        [key: string]: unknown;
      };
      /** Workflow Id */
      workflow_id: string;
      /** Delay Seconds */
      delay_seconds?: number | null;
      /** Enabled */
      enabled: boolean;
      /**
       * Description
       * @default
       */
      description: string;
      /**
       * Created By
       * @default
       */
      created_by: string;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
      /** Conditions */
      conditions?: {
        [key: string]: unknown;
      }[];
      /** Delivery Policy */
      delivery_policy?: {
        [key: string]: unknown;
      } | null;
      /** Workflow Display Name */
      workflow_display_name?: string | null;
      /** Product Surface */
      product_surface?: string | null;
    };
    /**
     * Coding
     * @description A reference to a code defined by a terminology system.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Coding
     */
    pkg__integrations__fhir__models__data_types__coding__Coding: {
      /**
       * Identity of the terminology system
       * @description The identification of the code system that defines the meaning of the symbol in the code.
       */
      system?: string | null;
      /**
       * Version of the system - if relevant
       * @description The version of the code system which was used when choosing this code. Note that a well-maintained code system does not need the version reported, because the meaning of codes is consistent across versions. However this cannot consistently be assured, and when the meaning is not guaranteed to be consistent, the version SHOULD be exchanged.
       */
      version?: string | null;
      /**
       * Symbol in syntax defined by the system
       * @description A symbol in syntax defined by the system. The symbol may be a predefined code or an expression in a syntax defined by the coding system (e.g. post-coordination).
       */
      code?: string | null;
      /**
       * Representation defined by the system
       * @description A representation of the meaning of the code in the system, following the rules of the system.
       */
      display?: string | null;
      /**
       * If this coding was chosen directly by the user
       * @description Indicates that this coding was chosen by a user directly - e.g. off a pick list of available items (codes or displays).
       */
      userSelected?: boolean | null;
    };
    /**
     * ContactPoint
     * @description Details of a Technology mediated contact point (phone, fax, email, etc.).
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#ContactPoint
     */
    pkg__integrations__fhir__models__data_types__contact_point__ContactPoint: {
      /**
       * phone | fax | email | pager | url | sms | other
       * @description Telecommunications form for contact point - what communications system is required to make use of the contact.
       */
      system?: components['schemas']['ContactPointSystem'] | null;
      /**
       * The actual contact point details
       * @description The actual contact point details, in a form that is meaningful to the designated communication system (i.e. phone number or email address).
       */
      value?: string | null;
      /**
       * home | work | temp | old | mobile - purpose of this contact point
       * @description Identifies the purpose for the contact point.
       */
      use?: components['schemas']['ContactPointUse'] | null;
      /**
       * Specify preferred order of use (1 = highest)
       * @description Specifies a preferred order in which to use a set of contacts. ContactPoints with lower rank values are more preferred than those with higher rank values.
       */
      rank?: number | null;
      /** Time period when the contact point was/is in use */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
    };
    /**
     * HumanName
     * @description Name of a human - parts and usage.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#HumanName
     */
    pkg__integrations__fhir__models__data_types__human_name__HumanName: {
      /**
       * usual | official | temp | nickname | anonymous | old | maiden
       * @description Identifies the purpose for this name.
       */
      use?: components['schemas']['HumanNameUse'] | null;
      /**
       * Text representation of the full name
       * @description Specifies the entire name as it should be displayed e.g. on an application UI. This may be provided instead of or as well as the specific parts.
       */
      text?: string | null;
      /**
       * Family name (often called 'Surname')
       * @description The part of a name that links to the genealogy. In some cultures (e.g. Eritrea) the family name of a son is the first name of his father.
       */
      family?: string | null;
      /**
       * Given names (not always 'first'). Includes middle names
       * @description Given name.
       */
      given?: string[] | null;
      /**
       * Parts that come before the name
       * @description Part of the name that is acquired as a title due to academic, legal, employment or nobility status, etc. and that appears at the start of the name.
       */
      prefix?: string[] | null;
      /**
       * Parts that come after the name
       * @description Part of the name that is acquired as a title due to academic, legal, employment or nobility status, etc. and that appears at the end of the name.
       */
      suffix?: string[] | null;
      /**
       * Time period when name was/is in use
       * @description Indicates the period of time when this name was valid for the named person.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
    };
    /**
     * Identifier
     * @description An identifier intended for computation.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Identifier
     */
    pkg__integrations__fhir__models__data_types__identifier__Identifier: {
      /**
       * usual | official | temp | secondary | old (If known)
       * @description The purpose of this identifier.
       */
      use?: components['schemas']['IdentifierUse'] | null;
      /**
       * Description of identifier
       * @description A coded type for the identifier that can be used to determine which identifier to use for a specific purpose.
       */
      type?: components['schemas']['CodeableConcept'] | null;
      /**
       * The namespace for the identifier value
       * @description Establishes the namespace for the value - that is, a URL that describes a set values that are unique.
       */
      system?: string | null;
      /**
       * The value that is unique
       * @description The portion of the identifier typically relevant to the user and which is unique within the context of the system.
       */
      value?: string | null;
      /**
       * Time period when id is/was valid for use
       * @description Time period during which identifier is/was valid for use.
       */
      period?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Organization that issued id (may be just text)
       * @description Organization that issued/manages the identifier.
       */
      assigner?: components['schemas']['Reference'] | null;
    };
    /**
     * Period
     * @description Time range defined by start and end date/time.
     *
     *     https://hl7.org/fhir/R4/datatypes-definitions.html#Period
     */
    pkg__integrations__fhir__models__data_types__period__Period: {
      /**
       * Starting time with inclusive boundary
       * @description The start of the period. The boundary is inclusive.
       */
      start?: string | null;
      /**
       * End time with inclusive boundary, if not ongoing
       * @description The end of the period. If the end of the period is missing, it means no end was known or planned at the time the instance was created. The start may be in the past, and the end date in the future, which means that period is expected/planned to end at that time.
       */
      end?: string | null;
    };
    /**
     * Observation
     * @description Measurements and simple assertions made about a patient, device or other subject.
     *
     *     Observations are a central element in healthcare, used to support diagnosis,
     *     monitor progress, determine baselines and patterns and even capture demographic
     *     characteristics.
     *
     *     https://hl7.org/fhir/R4/observation-definitions.html
     */
    pkg__integrations__fhir__models__observation__Observation: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Business Identifier for observation
       * @description A unique identifier assigned to this observation.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Fulfills plan, proposal or order
       * @description A plan, proposal or order that is fulfilled in whole or in part by this event. For example, a MedicationRequest may require a patient to have laboratory test performed before it is dispensed.
       */
      basedOn?: components['schemas']['Reference'][] | null;
      /**
       * Part of referenced event
       * @description A larger event of which this particular Observation is a component or step. For example, an observation as part of a procedure.
       */
      partOf?: components['schemas']['Reference'][] | null;
      /**
       * registered | preliminary | final | amended +
       * @description The status of the result value.
       */
      status: components['schemas']['ObservationStatus'];
      /**
       * Classification of type of observation
       * @description A code that classifies the general type of observation being made.
       */
      category?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Type of observation (code / type)
       * @description Describes what was observed. Sometimes this is called the observation "name".
       */
      code: components['schemas']['CodeableConcept'];
      /**
       * Who and/or what the observation is about
       * @description The patient, or group of patients, location, or device this observation is about and into whose record the observation is placed.
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * What the observation is about, when it is not about the subject of record
       * @description The actual focus of an observation when it is not the patient of record representing something or someone associated with the patient such as a spouse, parent, fetus, or donor.
       */
      focus?: components['schemas']['Reference'][] | null;
      /**
       * Healthcare event during which this observation is made
       * @description The healthcare event (e.g. a patient and healthcare provider interaction) during which this observation is made.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * Clinically relevant time/time-period for observation
       * @description The time or time-period the observed value is asserted as being true. For biological subjects - e.g. human patients - this is usually called the "physiologically relevant time".
       */
      effectiveDateTime?: string | null;
      /**
       * Clinically relevant time/time-period for observation
       * @description The time or time-period the observed value is asserted as being true. For biological subjects - e.g. human patients - this is usually called the "physiologically relevant time".
       */
      effectivePeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Clinically relevant time/time-period for observation
       * @description The time or time-period the observed value is asserted as being true. For biological subjects - e.g. human patients - this is usually called the "physiologically relevant time".
       */
      effectiveTiming?: components['schemas']['Timing'] | null;
      /**
       * Clinically relevant time/time-period for observation
       * @description The time or time-period the observed value is asserted as being true. For biological subjects - e.g. human patients - this is usually called the "physiologically relevant time".
       */
      effectiveInstant?: string | null;
      /**
       * Date/Time this version was made available
       * @description The date and time this version of the observation was made available to providers, typically after the results have been reviewed and verified.
       */
      issued?: string | null;
      /**
       * Who is responsible for the observation
       * @description Who was responsible for asserting the observed value as "true".
       */
      performer?: components['schemas']['Reference'][] | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueString?: string | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueBoolean?: boolean | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueInteger?: number | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueRange?: components['schemas']['Range'] | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueRatio?: components['schemas']['Ratio'] | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueSampledData?: components['schemas']['SampledData'] | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueTime?: string | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valueDateTime?: string | null;
      /**
       * Actual result
       * @description The information determined as a result of making the observation, if the information has a simple value.
       */
      valuePeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * Why the result is missing
       * @description Provides a reason why the expected value in the element Observation.value[x] is missing.
       */
      dataAbsentReason?: components['schemas']['CodeableConcept'] | null;
      /**
       * High, low, normal, etc.
       * @description A categorical assessment of an observation value. For example, high, low, normal.
       */
      interpretation?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Comments about the observation
       * @description Comments about the observation or the results.
       */
      note?: components['schemas']['Annotation'][] | null;
      /**
       * Observed body part
       * @description Indicates the site on the subject's body where the observation was made (i.e. the target site).
       */
      bodySite?: components['schemas']['CodeableConcept'] | null;
      /**
       * How it was done
       * @description Indicates the mechanism used to perform the observation.
       */
      method?: components['schemas']['CodeableConcept'] | null;
      /**
       * Specimen used for this observation
       * @description The specimen that was used when this observation was made.
       */
      specimen?: components['schemas']['Reference'] | null;
      /**
       * (Measurement) Device
       * @description The device used to generate the observation data.
       */
      device?: components['schemas']['Reference'] | null;
      /**
       * Provides guide for interpretation
       * @description Guidance on how to interpret the value by comparison to a normal or recommended range. Multiple reference ranges are interpreted as an "OR".
       */
      referenceRange?: components['schemas']['ObservationReferenceRange'][] | null;
      /**
       * Related resource that belongs to the Observation group
       * @description This observation is a group observation (e.g. a battery, a panel of tests, a set of vital sign measurements) that includes the target as a member of the group.
       */
      hasMember?: components['schemas']['Reference'][] | null;
      /**
       * Related measurements the observation is made from
       * @description The target resource that represents a measurement from which this observation value is derived. For example, a calculated anion gap or a fetal measurement based on an ultrasound image.
       */
      derivedFrom?: components['schemas']['Reference'][] | null;
      /**
       * Component results
       * @description Some observations have multiple component observations. These component observations are expressed as separate code value pairs that share the same attributes. Examples include systolic and diastolic component observations for blood pressure measurement.
       */
      component?: components['schemas']['ObservationComponent'][] | null;
    };
    /** SimpleSpecialtyResponse */
    schemas__response__SimpleSpecialtyResponse: {
      /** Id */
      id: string;
      /** Name */
      name: string;
      /** Localized Name */
      localized_name: string;
      /** Groups */
      groups?: components['schemas']['SpecialtyGroupInfo'][];
      /** Template Count */
      template_count?: number | null;
      /** Pinned Template Count */
      pinned_template_count?: number | null;
    };
    /** SpecialtiesResponse */
    schemas__response__SpecialtiesResponse: {
      /** Specialties */
      specialties: components['schemas']['schemas__response__SimpleSpecialtyResponse'][];
      /** Total */
      total: number;
    };
    /** SessionPermissionsResponse */
    service__permission__schema__SessionPermissionsResponse: {
      /** Authorized */
      authorized: boolean;
      /** Session Id */
      session_id: string;
      /** User Id */
      user_id: string;
      /** Reason */
      reason: string;
    };
    /**
     * AdResourceLiveCampaignSummary
     * @description Live campaign binding surfaced on the resource detail view.
     */
    AdResourceLiveCampaignSummary: {
      /**
       * Id
       * @description Campaign record ID.
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /**
       * Name
       * @description Campaign name.
       */
      name: string;
    };
    /** AdvanceRetentionLineageCampaignRequest */
    AdvanceRetentionLineageCampaignRequest: {
      /**
       * Limit
       * @default 500
       */
      limit: number;
    };
    /**
     * AgentEvalBindingDescriptorResponse
     * @description What one binding of this experiment was, beside its fingerprint.
     */
    AgentEvalBindingDescriptorResponse: {
      /** Binding Index */
      binding_index: number;
      /**
       * Kind
       * @enum {string}
       */
      kind: AgentEvalBindingDescriptorResponseKind;
      /** Label */
      label: string;
      /** Fingerprint */
      fingerprint: string;
      /** Config Id */
      config_id?: string | null;
      /** Config Version */
      config_version?: number | null;
      /** Workflow Id */
      workflow_id?: string | null;
    };
    /** AgentEvalBindingReportResponse */
    AgentEvalBindingReportResponse: {
      /** Binding Index */
      binding_index: number;
      /** Stats */
      stats: components['schemas']['AgentEvalScorerStatsResponse'][];
    };
    /**
     * AgentEvalBindingResponse
     * @description One agent under test, summarised.
     *
     *     The config itself is not returned: a system prompt is the bulk of it and
     *     the only question an operator asks of it here is whether it is still the
     *     one they reviewed, which ``system_prompt_sha256`` answers.
     */
    AgentEvalBindingResponse: {
      /** Binding Index */
      binding_index: number;
      /** Fingerprint */
      fingerprint: string;
      /** Agent Name */
      agent_name: string;
      /** Provider */
      provider: string;
      /** Model */
      model: string;
      /** System Prompt Sha256 */
      system_prompt_sha256: string;
      run_overrides?: components['schemas']['AgentEvalRunOverridesResponse'] | null;
    };
    /** AgentEvalBundleMetricResponse */
    AgentEvalBundleMetricResponse: {
      /** Scorer Name */
      scorer_name: string;
      /**
       * Applicability
       * @enum {string}
       */
      applicability: AgentEvalBundleMetricResponseApplicability;
    };
    /** AgentEvalBundleResponse */
    AgentEvalBundleResponse: {
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Metrics */
      metrics: components['schemas']['AgentEvalBundleMetricResponse'][];
    };
    /**
     * AgentEvalCaseResponse
     * @description One authored case, as the suite declares it.
     *
     *     ``scorer_names`` are the case's additions to the suite's scorers, not the
     *     full set that runs against it.
     */
    AgentEvalCaseResponse: {
      /** Case Id */
      case_id: string;
      /** Question */
      question: string;
      /** Metadata */
      metadata: {
        [key: string]: string;
      };
      reference?: components['schemas']['AgentEvalReferenceResponse'] | null;
      /** Scorer Names */
      scorer_names: string[];
      /** Scripted Turns */
      scripted_turns: components['schemas']['AgentEvalScriptedTurnResponse'][];
    };
    /** AgentEvalCoverageResponse */
    AgentEvalCoverageResponse: {
      /** Planned Units */
      planned_units: number;
      /** Complete */
      complete: number;
      /** Runner Failed */
      runner_failed: number;
      /** Unaccounted */
      unaccounted: number;
      /** Coverage */
      coverage: number;
    };
    /** AgentEvalDatasetDetailResponse */
    AgentEvalDatasetDetailResponse: {
      /** Dataset Id */
      dataset_id: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Item Count */
      item_count: number;
      provenance: components['schemas']['DatasetProvenanceDoc'];
      /** Items */
      items: components['schemas']['DatasetItemDoc'][];
    };
    /** AgentEvalDatasetSummaryResponse */
    AgentEvalDatasetSummaryResponse: {
      /** Dataset Id */
      dataset_id: string;
      /** Name */
      name: string;
      /** Description */
      description: string;
      /** Item Count */
      item_count: number;
      provenance: components['schemas']['DatasetProvenanceDoc'];
    };
    /**
     * AgentEvalDestinationExpectationResponse
     * @description Where a case says the work should have been sent.
     */
    AgentEvalDestinationExpectationResponse: {
      /** Tool Name */
      tool_name: string;
      /**
       * Arguments
       * @default {}
       */
      arguments: {
        [key: string]: string;
      };
    };
    /** AgentEvalExperimentDetailResponse */
    AgentEvalExperimentDetailResponse: {
      /** Experiment Id */
      experiment_id: string;
      /** Suite Name */
      suite_name: string;
      /**
       * Status
       * @enum {string}
       */
      status: AgentEvalExperimentDetailResponseStatus;
      /** Planned Units */
      planned_units: number;
      /** Primary Metric */
      primary_metric?: string | null;
      /** Code Version */
      code_version: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Completed At */
      completed_at?: string | null;
      units: components['schemas']['AgentEvalUnitCountsResponse'];
      /**
       * Binding Descriptors
       * @default []
       */
      binding_descriptors: components['schemas']['AgentEvalBindingDescriptorResponse'][];
      /**
       * Job Ref Ids
       * @description Every batch run of this experiment, newest last. Empty while the first run is still in flight, when a no-body ``:retry-failed`` 404s and the caller passes the id ``:run`` returned.
       * @default []
       */
      job_ref_ids: string[];
    };
    /** AgentEvalExperimentReportResponse */
    AgentEvalExperimentReportResponse: {
      /** Experiment Id */
      experiment_id: string;
      /** Suite Name */
      suite_name: string;
      /** Primary Metric */
      primary_metric?: string | null;
      /** Best Binding Index */
      best_binding_index?: number | null;
      coverage: components['schemas']['AgentEvalCoverageResponse'];
      /** Bindings */
      bindings: components['schemas']['AgentEvalBindingReportResponse'][];
      manifest: components['schemas']['AgentEvalManifestResponse'];
      /** Rows Per Code Version */
      rows_per_code_version: {
        [key: string]: number;
      };
      /**
       * Mixed Versions
       * @description The rows were not all produced by one build, or not by the build the manifest was frozen on — the numbers do not all describe the same code.
       */
      mixed_versions: boolean;
      /**
       * Binding Descriptors
       * @default []
       */
      binding_descriptors: components['schemas']['AgentEvalBindingDescriptorResponse'][];
      /** Completed At */
      completed_at?: string | null;
    };
    /** AgentEvalExperimentSummaryResponse */
    AgentEvalExperimentSummaryResponse: {
      /** Experiment Id */
      experiment_id: string;
      /** Suite Name */
      suite_name: string;
      /**
       * Status
       * @enum {string}
       */
      status: AgentEvalExperimentSummaryResponseStatus;
      /** Planned Units */
      planned_units: number;
      /** Primary Metric */
      primary_metric?: string | null;
      /** Code Version */
      code_version: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Completed At */
      completed_at?: string | null;
      coverage?: components['schemas']['AgentEvalCoverageResponse'] | null;
    };
    /**
     * AgentEvalJudgeIdentityResponse
     * @description The ensemble that graded one metric, as the plan froze it.
     */
    AgentEvalJudgeIdentityResponse: {
      /**
       * Models
       * @description Every judge model in the ensemble, version-pinned. A member sharing the run's own model family sits out that run and is recorded on the score's judge pin, so this is the ensemble as configured, not necessarily the one that voted.
       */
      models: string[];
      /**
       * Model Efforts
       * @description Per-member reasoning effort. A member absent here judged at its provider's own default.
       * @default {}
       */
      model_efforts: {
        [key: string]: string;
      };
      /**
       * Reducer Method
       * @description How the usable members' scores collapsed into one value.
       */
      reducer_method: string;
      /**
       * Reducer Quorum
       * @description How many usable members a score needed; below it the metric errored rather than being scored on a thin ensemble.
       */
      reducer_quorum: number;
      /**
       * Rubric Version
       * @description The rubric revision the ensemble graded against. The rubric digest itself is pinned on every individual score.
       */
      rubric_version: string;
      /**
       * Visibility
       * @description What evidence the judge's prompt carried — the routine's instructions, the run's tool activity, how much of the conversation, and the agent's system prompt.
       */
      visibility?: {
        [key: string]: unknown;
      } | null;
    };
    /**
     * AgentEvalManifestResponse
     * @description The definition the statistics were computed against, frozen at plan time.
     */
    AgentEvalManifestResponse: {
      /** Suite Fingerprint */
      suite_fingerprint: string;
      /** Binding Fingerprints */
      binding_fingerprints: string[];
      /** Scorer Versions */
      scorer_versions: {
        [key: string]: string;
      };
      /**
       * Scorers
       * @description Every scorer the experiment was planned with. ``applicability`` and ``pass_when`` are the bundle's plan-time declarations, absent for a scorer a case added on its own. ``pass_when`` is definition only — no verdict is rendered from it.
       * @default {}
       */
      scorers: {
        [key: string]: components['schemas']['AgentEvalScorerManifestEntryResponse'];
      };
      /** Code Version */
      code_version: string;
      /** Bundle Name */
      bundle_name?: string | null;
      /**
       * Bundle Fingerprint
       * @description The bundle digest as frozen at plan time, not the live suite's — absent on experiments planned before suites composed a bundle.
       */
      bundle_fingerprint?: string | null;
    };
    /** AgentEvalPassWhenResponse */
    AgentEvalPassWhenResponse: {
      /**
       * Op
       * @enum {string}
       */
      op: AgentEvalPassWhenResponseOp;
      /** Threshold */
      threshold: number;
    };
    /**
     * AgentEvalReferenceResponse
     * @description The ground truth a case authored for the scorers that require one.
     */
    AgentEvalReferenceResponse: {
      /** Expected */
      expected?: string | null;
      /** Success Criteria */
      success_criteria?: string | null;
      expected_destination?:
        | components['schemas']['AgentEvalDestinationExpectationResponse']
        | null;
      /**
       * Declared Constraints
       * @default []
       */
      declared_constraints: string[];
    };
    /**
     * AgentEvalRunOverridesResponse
     * @description The workflow budgets one binding tunes, absent when it tunes none.
     */
    AgentEvalRunOverridesResponse: {
      /** Turn Activity Timeout Seconds */
      turn_activity_timeout_seconds?: number | null;
      /** Llm Start To Close Timeout Seconds */
      llm_start_to_close_timeout_seconds?: number | null;
      /** Max Tool Iterations */
      max_tool_iterations?: number | null;
    };
    /**
     * AgentEvalScorerManifestEntryResponse
     * @description One scorer's declaration, as the plan froze it.
     */
    AgentEvalScorerManifestEntryResponse: {
      /** Scorer Version */
      scorer_version: string;
      /** Applicability */
      applicability?: AgentEvalScorerManifestEntryResponseApplicabilityAnyOf0 | null;
      pass_when?: components['schemas']['AgentEvalPassWhenResponse'] | null;
      /** @description Which models judged this metric. Absent for a deterministic scorer, and for experiments planned before judge identity was frozen into the manifest. */
      judge?: components['schemas']['AgentEvalJudgeIdentityResponse'] | null;
    };
    /** AgentEvalScorerStatsResponse */
    AgentEvalScorerStatsResponse: {
      /** Scorer Name */
      scorer_name: string;
      /** Mean */
      mean?: number | null;
      /** Variance */
      variance?: number | null;
      /** Ci Low */
      ci_low?: number | null;
      /** Ci High */
      ci_high?: number | null;
      /** N Scored */
      n_scored: number;
      /** N Scored Cases */
      n_scored_cases: number;
      /** N Error */
      n_error: number;
      /** N Not Applicable */
      n_not_applicable: number;
      /** N Missing Reference */
      n_missing_reference: number;
    };
    /** AgentEvalScriptedTurnResponse */
    AgentEvalScriptedTurnResponse: {
      /** Message */
      message: string;
    };
    /**
     * AgentEvalSuiteDetailResponse
     * @description One registered suite, all the way down to its cases.
     *
     *     This is the definition *this build* carries. An experiment is tied to the
     *     definition it actually ran by the fingerprints on its stored manifest, so
     *     a suite edited since then reads differently here on purpose.
     */
    AgentEvalSuiteDetailResponse: {
      /** Name */
      name: string;
      /** Binding Count */
      binding_count: number;
      /** Case Count */
      case_count: number;
      /** Trials */
      trials: number;
      /**
       * Planned Units
       * @description bindings x cases x trials — the number of agent runs one experiment over this suite plans.
       */
      planned_units: number;
      /**
       * Scorers
       * @description The metric bundle's scorers, in the order it declares them.
       */
      scorers: string[];
      /** Bundle Name */
      bundle_name: string;
      /** Bundle Fingerprint */
      bundle_fingerprint: string;
      /** Primary Metric */
      primary_metric?: string | null;
      /** Suite Fingerprint */
      suite_fingerprint: string;
      /** Binding Fingerprints */
      binding_fingerprints: string[];
      /** Bindings */
      bindings: components['schemas']['AgentEvalBindingResponse'][];
      /** Cases */
      cases: components['schemas']['AgentEvalCaseResponse'][];
    };
    /**
     * AgentEvalSuiteResponse
     * @description One registered suite, and what running it would cost.
     */
    AgentEvalSuiteResponse: {
      /** Name */
      name: string;
      /** Binding Count */
      binding_count: number;
      /** Case Count */
      case_count: number;
      /** Trials */
      trials: number;
      /**
       * Planned Units
       * @description bindings x cases x trials — the number of agent runs one experiment over this suite plans.
       */
      planned_units: number;
      /**
       * Scorers
       * @description The metric bundle's scorers, in the order it declares them.
       */
      scorers: string[];
      /** Bundle Name */
      bundle_name: string;
      /** Bundle Fingerprint */
      bundle_fingerprint: string;
      /** Primary Metric */
      primary_metric?: string | null;
      /** Suite Fingerprint */
      suite_fingerprint: string;
      /** Binding Fingerprints */
      binding_fingerprints: string[];
    };
    /**
     * AgentEvalUnitCountsResponse
     * @description The result ledger, per unit state.
     *
     *     ``total`` counts rows, not planned units: a unit nothing has claimed yet
     *     has no row, so ``total`` trails ``planned_units`` while a job is running.
     */
    AgentEvalUnitCountsResponse: {
      /** Claimed */
      claimed: number;
      /** Run Started */
      run_started: number;
      /** Complete */
      complete: number;
      /** Runner Failed */
      runner_failed: number;
      /** Total */
      total: number;
    };
    /** AgentRunScoreResponse */
    AgentRunScoreResponse: {
      /**
       * Source Kind
       * @enum {string}
       */
      source_kind: AgentRunScoreResponseSource_kind;
      /**
       * Suite Id
       * @description The suite that graded this run, on dataset-run and rolling-sweep rows. Absent on an experiment row, which names an experiment instead.
       */
      suite_id?: string | null;
      /**
       * Experiment Id
       * @description The experiment that graded this run, if any.
       */
      experiment_id?: string | null;
      /**
       * Pass Id
       * @description The scoring pass, on dataset-run rows only. Scoring a dataset appends a pass rather than retiring the previous one, so a run can carry several.
       */
      pass_id?: string | null;
      /** Bundle Name */
      bundle_name: string;
      /** Bundle Fingerprint */
      bundle_fingerprint: string;
      /**
       * Scored At
       * Format: date-time
       */
      scored_at: string;
    };
    /**
     * AgentTodoItemPayload
     * @description One todo item as rendered to clients.
     */
    AgentTodoItemPayload: {
      /** Id */
      id: number;
      /** Title */
      title: string;
      /**
       * Notes
       * @default
       */
      notes: string;
      /** Status */
      status: string;
    };
    /**
     * AgentTodoStatePayload
     * @description The run's todo list as rendered to clients.
     *
     *     Structured twin of the model-facing ``<task_list>`` XML: the FE plan card
     *     reads this instead of parsing the tool result text. Top-level items only —
     *     the store models one subtask level that neither todo tool can create today,
     *     and the card renders a flat plan.
     */
    AgentTodoStatePayload: {
      /** Plan Title */
      plan_title?: string | null;
      /** Items */
      items?: components['schemas']['AgentTodoItemPayload'][];
    };
    /**
     * AllowancePeriod
     * @enum {string}
     */
    AllowancePeriod: AllowancePeriod;
    /** AllowancePolicyResponse */
    AllowancePolicyResponse: {
      /** Policy Id */
      policy_id: string;
      /** Workspace Id */
      workspace_id: string | null;
      subscription_tier: components['schemas']['SubscriptionTier'];
      /** Seat Type */
      seat_type: string | null;
      period: components['schemas']['AllowancePeriod'];
      /** Default Member Limit */
      default_member_limit: number;
      /** Enabled */
      enabled: boolean;
    };
    /**
     * ApplyRequest
     * @description Request body for POST /{template_id}/apply.
     *
     *     The client sends the final headered ``structure_template_after`` body
     *     (produced by applying the suggest insertion points to the
     *     ``WorkingTemplateDraft``), the ``mappings`` to replace (not merge) the
     *     section-heading → EHR-section-id sidecar, an optional ``snapshot_id``
     *     (string for Apply-from-review; null/omitted for direct-edit Save),
     *     the ``structure_template_hash`` echoed from the suggest/join response
     *     (concurrency precondition — mismatches return 409), and a
     *     client-generated ``attempt_id`` UUID for idempotency (unique index on
     *     ``template_migration_snapshot.attempt_id``).
     */
    ApplyRequest: {
      /**
       * Structure Template After
       * @description Final headered markdown body to write to CustomTemplate
       */
      structure_template_after: string;
      /**
       * Mappings
       * @description Section-heading → EHR-section-id mappings to replace (not merge)
       */
      mappings?: components['schemas']['TemplateMappingSchema'][];
      /**
       * Snapshot Id
       * @description Suggested snapshot ObjectId from the suggest response for Apply-from-review; null/omitted for direct-edit Save (apply creates its own pending snapshot either way)
       */
      snapshot_id?: string | null;
      /**
       * Structure Template Hash
       * @description Client-echoed SHA-256 of the stored structure_template (64 hex chars) — concurrency precondition; mismatch → 409
       */
      structure_template_hash: string;
      /**
       * Attempt Id
       * @description Client-generated UUID for idempotency — unique index on template_migration_snapshot.attempt_id prevents duplicate applies
       */
      attempt_id: string;
    };
    /**
     * ApplyResponse
     * @description Response for POST /{template_id}/apply.
     *
     *     On success: ``applied == true``, the ``snapshot_id`` of the applied
     *     snapshot, the ``applied_at`` ISO timestamp, and the ``audit_event_id``
     *     of the outcome audit record.
     *
     *     On hash mismatch: 409 ``template_modified_since_suggest`` — the template
     *     is NOT overwritten and the pending snapshot is removed (compensating
     *     rollback).
     */
    ApplyResponse: {
      /**
       * Applied
       * @description True when the template was successfully updated
       */
      applied: boolean;
      /**
       * Snapshot Id
       * @description Applied snapshot ObjectId as string
       */
      snapshot_id: string;
      /**
       * Applied At
       * Format: date-time
       * @description ISO timestamp of the apply
       */
      applied_at: string;
      /**
       * Audit Event Id
       * @description Outcome audit log event ObjectId as string
       */
      audit_event_id: string;
    };
    /**
     * ApprovalMode
     * @enum {string}
     */
    ApprovalMode: ApprovalMode;
    /**
     * ArtifactViewV1
     * @description One committed conversation artifact, self-describing.
     *
     *     ``artifact_id`` and ``parent_turn_id`` are opaque: clients join on them,
     *     never parse them. ``created_at`` is display-only — ``artifacts`` array
     *     order is the authoritative committed order.
     */
    ArtifactViewV1: {
      /**
       * Schema Version
       * @default 1
       * @constant
       */
      schema_version: 1;
      /** Artifact Id */
      artifact_id: string;
      /** Parent Turn Id */
      parent_turn_id: string;
      /**
       * Message Index
       * @default 0
       */
      message_index: number;
      /** Iteration */
      iteration?: number | null;
      /** Created At */
      created_at?: string | null;
      /** Payload */
      payload:
        | components['schemas']['UserMessageArtifactPayload']
        | components['schemas']['AssistantMessageArtifactPayload']
        | components['schemas']['ToolExecutionArtifactPayload']
        | components['schemas']['CompactionMarkerArtifactPayload']
        | components['schemas']['TurnTerminationArtifactPayload'];
    };
    /**
     * AsserterRole
     * @description Who made the assertion the fact records.
     * @enum {string}
     */
    AsserterRole: AsserterRole;
    /**
     * Assertion
     * @description What the source says about the concept.
     *
     *     ``POSSIBLE`` requires the source to explicitly express a differential,
     *     suspicion or uncertainty. Silence does not produce it, and R2 admits no
     *     ``uncertain`` value — the SDM fact store's fourth option is a contract
     *     violation, not prior art.
     * @enum {string}
     */
    Assertion: Assertion;
    /** AssistantMessageArtifactPayload */
    AssistantMessageArtifactPayload: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: AssistantMessageArtifactPayloadType;
      message: components['schemas']['pkg__agent_harness__core__llm_contracts__Message'];
      /** Stop Reason */
      stop_reason?: string | null;
    };
    /**
     * AutoLinkDecisionLabel
     * @description Auto-link outcome labels (non-PHI), shared by the note-gen write path's
     *     behavioural tracking and the internal-admin read path's recompute.
     *
     *     ``NOT_ENOUGH_EVIDENCE`` is the signal worth watching: a certain winner
     *     we deliberately withheld because its name was not corroborated to the extent
     *     both sides carry name data (e.g. a lone DOB match, a comparable name that
     *     disagreed, or a legacy candidate without corroboration/conflict detail).
     *     ``NO_MERGE_OPPORTUNITY`` means a certain, name-corroborated winner was
     *     withheld because nothing in the grouping window could merge with the
     *     session — auto-link exists to enable grouping, so the match stays a
     *     suggestion. ``AMBIGUOUS_TIE`` means multiple certain candidates with no
     *     evidence-weight winner clear of the runner-up margin. The companion ``certain_name_basis`` field
     *     (``full_name`` / ``first_name_only`` / ``last_name_only``) segments which
     *     name evidence backed a passing gate.
     * @enum {string}
     */
    AutoLinkDecisionLabel: AutoLinkDecisionLabel;
    /**
     * AutoLinkDecisionView
     * @description Auto-link decision recomputed from currently stored candidates.
     *
     *     Not a persisted historical record: stored candidates may have been
     *     re-ranked since the original decision (profile-create rematch overwrites
     *     in place; sub-0.7 candidates were never persisted). Datadog logs remain
     *     the historical record.
     */
    AutoLinkDecisionView: {
      decision: components['schemas']['AutoLinkDecisionLabel'];
      /**
       * Decision Source
       * @default recomputed
       * @constant
       */
      decision_source: 'recomputed';
      /** Top Confidence */
      top_confidence: number | null;
      /** Runner Up Margin */
      runner_up_margin: number | null;
      /** Certain Candidate Count */
      certain_candidate_count: number;
      /** Ranked Candidate Count */
      ranked_candidate_count: number;
      /** Certain Name Basis */
      certain_name_basis: string | null;
      /** Certain Patient Profile Id */
      certain_patient_profile_id: string | null;
      /** Certain Corroborated Field Names */
      certain_corroborated_field_names: string[] | null;
      /** Certain Evidence Weight */
      certain_evidence_weight: number | null;
      /** Clinical Contender Count */
      clinical_contender_count: number;
      /** Clinical Tiebreak Applied */
      clinical_tiebreak_applied: boolean;
      /** Has Merge Opportunity */
      has_merge_opportunity: boolean | null;
      thresholds: components['schemas']['AutoLinkThresholdsView'];
    };
    /**
     * AutoLinkThresholdsView
     * @description Threshold constants in effect when the decision was recomputed.
     */
    AutoLinkThresholdsView: {
      /** Certain Match Confidence */
      certain_match_confidence: number;
      /** High Confidence Threshold */
      high_confidence_threshold: number;
      /** Min Confidence Margin Over Runner Up */
      min_confidence_margin_over_runner_up: number;
      /** Min Candidate Confidence */
      min_candidate_confidence: number;
      /** Ambiguous Second Match Confidence */
      ambiguous_second_match_confidence: number;
    };
    /**
     * AxSelector
     * @description The shared AX predicate plus ``automationId`` and ``within`` — clinical
     *     forms repeat identical Yes/No controls, so role+name alone cannot tell two
     *     apart. Inherited ``extra="forbid"`` makes an unknown field a hard
     *     rejection, never a quiet loss.
     */
    AxSelector: {
      /** Role */
      role?: string | null;
      /** Name */
      name?: string | null;
      /**
       * Matchmode
       * @default exact
       * @enum {string}
       */
      matchMode: AxSelectorMatchMode;
      /**
       * Automationid
       * @description Exact-match anchor. When present it is the strongest anchor; a match is cross-validated against the stored role/name anchor.
       */
      automationId?: string | null;
      /** @description Nearest-ancestor scope (e.g. the labelled question group). */
      within?: components['schemas']['AxSelector'] | null;
    };
    /**
     * BillingSeatType
     * @enum {string}
     */
    BillingSeatType: BillingSeatType;
    /** Body_extract_form_fields_from_json_api_v2_ml_scribe_json_template_extract_fields_post */
    Body_extract_form_fields_from_json_api_v2_ml_scribe_json_template_extract_fields_post: {
      /**
       * Json File
       * Format: binary
       * @description JSON form file to extract fields from
       */
      json_file: string;
    };
    /** Body_extract_form_fields_from_xml_api_v2_ml_scribe_xml_template_extract_fields_post */
    Body_extract_form_fields_from_xml_api_v2_ml_scribe_xml_template_extract_fields_post: {
      /**
       * Xml File
       * Format: binary
       * @description XML file to extract fields from
       */
      xml_file: string;
    };
    /** Body_upload_content_translations_api_v2_ml_scribe_internal_admin_content_translations_upload_post */
    Body_upload_content_translations_api_v2_ml_scribe_internal_admin_content_translations_upload_post: {
      /**
       * File
       * Format: binary
       * @description translated locale files zip
       */
      file: string;
    };
    /**
     * BooleanValue
     * @description A stated yes or no.
     *
     *     Not a stand-in for absence: R2 keeps that on ``assertion``, and R4 keeps
     *     "the evidence supports neither" on its own ``unknown``. A boolean value is
     *     for a fact whose content is genuinely binary once it exists.
     */
    BooleanValue: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: BooleanValueType;
      /** Boolean */
      boolean: boolean;
    };
    /**
     * BoundedPatientState
     * @description What a consumer receives: the facts, the version, and the bounds.
     *
     *     The boundaries come back because R1 has the *view* declare them, not just
     *     the request. A consumer caching this holds the bounds its cache is valid
     *     under, which is what makes a later boundary change detectable rather than
     *     silent.
     *
     *     ``facts`` are ``PatientFact`` — the R2 contract type, unchanged. There is no
     *     separate wire model, and that is what satisfies R5.AC3 by construction: the
     *     contract stores locators into a pinned source revision and never the cited
     *     content, so there is no raw source document for a projection to forget to
     *     strip.
     */
    BoundedPatientState: {
      boundaries: components['schemas']['StateBoundaries'];
      /** State Version */
      state_version: number;
      /** Facts */
      facts: components['schemas']['PatientFact'][];
    };
    /** BulkAccessEntitlementRequest */
    BulkAccessEntitlementRequest: {
      /**
       * Target Type
       * @enum {string}
       */
      target_type: BulkAccessEntitlementRequestTarget_type;
      /** Identifiers */
      identifiers: string[];
      /** Entitlement Type Id */
      entitlement_type_id?: string | null;
      /** Entitlement Type Name */
      entitlement_type_name?: string | null;
      /** Enabled */
      enabled: boolean;
      /**
       * Execute
       * @default false
       */
      execute: boolean;
    };
    /** BulkAccessEntitlementResponse */
    BulkAccessEntitlementResponse: {
      /** Results */
      results: components['schemas']['BulkAccessEntitlementResult'][];
      /** Total */
      total: number;
      /** Succeeded */
      succeeded: number;
      /** Skipped */
      skipped: number;
      /** Failed */
      failed: number;
    };
    /** BulkAccessEntitlementResult */
    BulkAccessEntitlementResult: {
      /** Identifier */
      identifier: string;
      /**
       * Target Type
       * @enum {string}
       */
      target_type: BulkAccessEntitlementResultTarget_type;
      /**
       * Status
       * @enum {string}
       */
      status: BulkAccessEntitlementResultStatus;
      /** Detail */
      detail: string;
      /** Attachment Ids */
      attachment_ids?: string[] | null;
    };
    /** BulkLookupIdentityProfilesRequest */
    BulkLookupIdentityProfilesRequest: {
      /** User Ref Ids */
      user_ref_ids: string[];
    };
    /** BulkLookupIdentityProfilesResponse */
    BulkLookupIdentityProfilesResponse: {
      /** Identity Profiles */
      identity_profiles?: components['schemas']['domains__identity_broker__client__schema__IdentityProfileDTO'][];
      /** Not Found User Ref Ids */
      not_found_user_ref_ids?: string[];
    };
    /**
     * BulkLookupTeam
     * @description Primary joined team of a user (first of the joined set).
     */
    BulkLookupTeam: {
      /** Team Id */
      team_id: string;
      /** Team Name */
      team_name: string;
    };
    /**
     * BulkLookupWorkspace
     * @description One live workspace membership of a user.
     */
    BulkLookupWorkspace: {
      /** Workspace Id */
      workspace_id: string;
      /** Name */
      name?: string | null;
      /** Role */
      role: string;
    };
    /**
     * BulkUserLookupRequest
     * @description Request body for the bulk user lookup endpoint.
     *
     *     ``emails`` may contain duplicates or mixed case; the endpoint dedupes
     *     server-side (lowercased) and emits one result per requested position,
     *     so the response order mirrors the request order.
     */
    BulkUserLookupRequest: {
      /** Emails */
      emails: string[];
      /**
       * Include Mfa
       * @description MFA resolution touches per-user Mongo team-relation reads and a Flagsmith flag evaluation per user -- opt-in only; the fast default path omits mfa_enabled/mfa_method (both stay null).
       * @default false
       */
      include_mfa: boolean;
    };
    /**
     * BulkUserLookupResponse
     * @description Response body listing one entry per requested email, in request order.
     */
    BulkUserLookupResponse: {
      /** Results */
      results?: components['schemas']['BulkUserLookupResult'][];
    };
    /**
     * BulkUserLookupResult
     * @description Per-email entry of a bulk lookup response.
     *
     *     NOT-FOUND entries carry only ``email`` and ``exists: false``; every
     *     other field is ``None``. Found entries carry the enriched fields, each
     *     of which may still be ``None`` when its source is genuinely unavailable
     *     (per-user degradation — the endpoint never fabricates a value).
     */
    BulkUserLookupResult: {
      /** Email */
      email: string;
      /** Exists */
      exists: boolean;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** User Ref Id */
      user_ref_id?: string | null;
      /** Country */
      country?: string | null;
      team?: components['schemas']['BulkLookupTeam'] | null;
      /** Workspaces */
      workspaces?: components['schemas']['BulkLookupWorkspace'][];
      /** Billing Tier */
      billing_tier?: string | null;
      /** Specialty */
      specialty?: string | null;
      /** Display Language */
      display_language?: string | null;
      /** Input Languages */
      input_languages?: string[];
      /** Output Language */
      output_language?: string | null;
      /** Is Managed */
      is_managed?: boolean | null;
      /** Product Features */
      product_features?: string[] | null;
      /** Suspended */
      suspended?: boolean | null;
      /** Has Sso */
      has_sso?: boolean | null;
      /** Mfa Enabled */
      mfa_enabled?: boolean | null;
      /** Mfa Method */
      mfa_method?: string | null;
      /** Last Login Utc */
      last_login_utc?: string | null;
      /** Created At Utc */
      created_at_utc?: string | null;
      /** Ehr Integration */
      ehr_integration?: string | null;
      /** Notes */
      notes?: string | null;
    };
    /** BurnStreamProbeRequest */
    BurnStreamProbeRequest: {
      /**
       * Workspace Id
       * @default probe-workspace
       */
      workspace_id: string;
      /** Idempotency Source */
      idempotency_source?: string | null;
      /** Product */
      product: string;
      /** Model */
      model?: string | null;
      outcome?: components['schemas']['UsageOutcome'] | null;
      /**
       * Quantity
       * @default 1
       */
      quantity: number;
    };
    /**
     * BurnStreamProbeResponse
     * @description A read, plus what the emit that preceded it did — see the module docstring
     *     for why these are separate readings rather than one verdict.
     */
    BurnStreamProbeResponse: {
      /** Stage */
      stage: string;
      /** Stream Key */
      stream_key: string;
      /** Maxlen */
      maxlen: number;
      /** Stream Length */
      stream_length?: number | null;
      /** Latest Entries */
      latest_entries?: {
        [key: string]: unknown;
      }[];
      /** Redis Error */
      redis_error?: string | null;
      /** Usage Event Written */
      usage_event_written: boolean;
      /** Transaction Id */
      transaction_id?: string | null;
      /** Stream Length Before */
      stream_length_before?: number | null;
      /** Stream Grew By */
      stream_grew_by?: number | null;
    };
    /**
     * BurnStreamReading
     * @description What one read of the stream saw. Shared by both endpoints.
     */
    BurnStreamReading: {
      /** Stage */
      stage: string;
      /** Stream Key */
      stream_key: string;
      /** Maxlen */
      maxlen: number;
      /** Stream Length */
      stream_length?: number | null;
      /** Latest Entries */
      latest_entries?: {
        [key: string]: unknown;
      }[];
      /** Redis Error */
      redis_error?: string | null;
    };
    /**
     * CancellationIntent
     * @description Per-subscription cancel-flow state captured before Stripe handoff.
     */
    CancellationIntent: {
      /** Flow Id */
      flow_id: string;
      reason: components['schemas']['CancellationReason'];
      /**
       * Captured At
       * Format: date-time
       */
      captured_at?: string;
      offer_type?: components['schemas']['CancellationOfferType'] | null;
      offer_outcome?: components['schemas']['CancellationOfferOutcome'] | null;
      /** Other Reason Detail */
      other_reason_detail?: string | null;
    };
    /** CancellationIntentResponseView */
    CancellationIntentResponseView: {
      /** Flow Id */
      flow_id: string;
      reason: components['schemas']['CancellationReason'];
      /** Captured At */
      captured_at: string;
      offer_type?: components['schemas']['CancellationOfferType'] | null;
      offer_outcome?: components['schemas']['CancellationOfferOutcome'] | null;
      /** Other Reason Detail */
      other_reason_detail?: string | null;
    };
    /**
     * CancellationOfferOutcome
     * @enum {string}
     */
    CancellationOfferOutcome: CancellationOfferOutcome;
    /**
     * CancellationOfferType
     * @enum {string}
     */
    CancellationOfferType: CancellationOfferType;
    /**
     * CancellationReason
     * @description Stripe-aligned cancellation survey reasons.
     * @enum {string}
     */
    CancellationReason: CancellationReason;
    /**
     * CategoricalSource
     * @description Explicit cases only; evidence matching none of them writes nothing.
     */
    CategoricalSource: {
      /**
       * Kind
       * @default categorical
       * @constant
       */
      kind: 'categorical';
      /** Cases */
      cases: components['schemas']['SourceCase'][];
    };
    /**
     * CheckStatus
     * @description Record the outcome of one deterministic claim-attribute comparison.
     * @enum {string}
     */
    CheckStatus: CheckStatus;
    /** CheckboxState */
    CheckboxState: {
      /** Value */
      value: boolean;
    };
    /** CheckboxTarget */
    CheckboxTarget: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: CheckboxTargetKind;
      selector: components['schemas']['AxSelector'];
      /** States */
      states: {
        [key: string]: components['schemas']['CheckboxState'];
      };
    };
    /** CibaDeviceStatusResponse */
    CibaDeviceStatusResponse: {
      /** Enabled */
      enabled: boolean;
      /** Device Name */
      device_name?: string | null;
    };
    /**
     * ClientSemanticSetValueCapability
     * @description Desired-state ``set_value`` writes on structured controls.
     *
     *     ``control_kinds`` lists the control kinds (``checkbox`` / ``radio`` /
     *     ``dropdown``) the client can settle semantically; an empty list means the
     *     surface stays legacy. Mirrors the desktop's ``SemanticSetValueCapability``.
     */
    ClientSemanticSetValueCapability: {
      /**
       * Version
       * @default 1
       */
      version: number;
      /** Control Kinds */
      control_kinds?: string[];
    };
    /**
     * ClinicalComparisonVerdict
     * @description Whether one profile's stored clinical data agrees with one transcript.
     *
     *     ``no_data_to_compare`` is a third outcome rather than a weak
     *     ``contradicts``: conflating absence with disagreement is what let an empty
     *     profile out-score a populated one before this change.
     * @enum {string}
     */
    ClinicalComparisonVerdict: ClinicalComparisonVerdict;
    /**
     * ClinicalConcept
     * @description What the fact is about. R2: no concept, no fact.
     *
     *     ``system`` and ``code`` are absent unless the source supplied a code or the
     *     concept maps unambiguously under the terminology policy. A missing coding
     *     qualifier is never invented to produce a more specific code.
     */
    ClinicalConcept: {
      /** Name */
      name: string;
      system?: components['schemas']['TerminologySystem'] | null;
      /** Code */
      code?: string | null;
    };
    /** CodeDefinedDataset */
    CodeDefinedDataset: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: CodeDefinedDatasetKind;
      /** Case Set Name */
      case_set_name: string;
    };
    /**
     * CodedValue
     * @description A qualitative result, as a concept rather than as prose.
     *
     *     R2.AC5's case: "her potassium was high last week" carries ``high`` as a
     *     coded qualitative value and not as free text. ``ClinicalConcept`` is reused
     *     rather than paralleled because the rule it enforces is the one wanted here —
     *     a code needs its system, and a missing code is never invented to look more
     *     specific — and a second type carrying the same validator would eventually
     *     disagree with it.
     */
    CodedValue: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CodedValueType;
      concept: components['schemas']['ClinicalConcept'];
    };
    /** CompactionMarkerArtifactPayload */
    CompactionMarkerArtifactPayload: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: CompactionMarkerArtifactPayloadType;
      message: components['schemas']['pkg__agent_harness__core__llm_contracts__Message'];
    };
    /**
     * Comparator
     * @description That the true value lies beyond the number, not at it.
     *
     *     A lab that reports ``<0.01`` did not measure 0.01; it measured something it
     *     could not resolve below its detection limit. Storing the bare number asserts
     *     a measurement nobody made, and in the direction that matters — an
     *     undetectable troponin and a troponin of exactly 0.01 read the same to a
     *     consumer comparing against a threshold.
     *
     *     FHIR's ``Quantity.comparator``, restricted to the four that state a bound.
     * @enum {string}
     */
    Comparator: Comparator;
    /** CompleteCibaRequest */
    CompleteCibaRequest: {
      /**
       * Auth Req Id
       * @description The CIBA auth_req_id returned by Auth0 /bc-authorize. Bounded so an unauthenticated caller cannot mint unbounded Redis rate-limit keys by varying the value per request.
       */
      auth_req_id: string;
      /** Completion Token */
      completion_token: string;
    };
    /** CompleteCibaResponse */
    CompleteCibaResponse: {
      /** Status */
      status: string;
      /** Access Token */
      access_token?: string | null;
      /** Id Token */
      id_token?: string | null;
      /** Refresh Token */
      refresh_token?: string | null;
      /** Token Type */
      token_type?: string | null;
      /** Expires In */
      expires_in?: number | null;
      /** Detail */
      detail?: string | null;
    };
    /** CompleteRpaRecordingUploadRequest */
    CompleteRpaRecordingUploadRequest: {
      /** Parts */
      parts: components['schemas']['RpaRecordingCompletedPart'][];
    };
    /** ContentTranslationsUploadResponse */
    /**
     * ConfirmHcpRequest
     * @description Attest that the registry record returned for the identifier is yours.
     */
    ConfirmHcpRequest: {
      /**
       * Identifier
       * @description Registry-specific provider identifier to look up (an NPI for NPPES).
       */
      identifier: string;
      /** @description Registry to look up against. Omit to use the one that applies to your account; naming one that does not is rejected. */
      registry?: components['schemas']['VerificationRegistry'] | null;
    };
    ContentTranslationsUploadResponse: {
      /** Results */
      results: components['schemas']['ResourceImportResult'][];
      /** Failed Resources */
      failed_resources?: string[];
      /** Ignored Files */
      ignored_files?: string[];
    };
    /**
     * ContractResponse
     * @description One contract as the admin surface sees it.
     *
     *     Every timestamp is UTC-normalized on the way out. A contract just written
     *     still holds the offset-aware value the request parsed, while one read back
     *     from Mongo is offset-naive — serialized raw, the same contract leaves as
     *     `...T00:00:00Z` from a create and `...T00:00:00` from a list, and a client
     *     parsing the second as local time misreads when the term starts.
     */
    ContractResponse: {
      /** Contract Id */
      contract_id: string;
      /** Workspace Id */
      workspace_id: string;
      /** Rate Card Key */
      rate_card_key: string;
      /** Rate Card Version */
      rate_card_version: number;
      /**
       * Starts At
       * Format: date-time
       */
      starts_at: string;
      /** Ends At */
      ends_at: string | null;
      status: components['schemas']['ContractStatus'];
      /** Created By */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /**
     * ContractStatus
     * @description A contract's lifecycle state, one-way `ACTIVE -> ARCHIVED`.
     *
     *     `ARCHIVED` voids a contract that should never have applied — not one that
     *     ran its course, which needs no action because its window simply passes.
     *     Not a boolean, because a `False` would carry both meanings at once.
     * @enum {string}
     */
    ContractStatus: ContractStatus;
    /** CreateAllowancePolicyRequest */
    CreateAllowancePolicyRequest: {
      /** Policy Id */
      policy_id: string;
      /** Workspace Id */
      workspace_id?: string | null;
      subscription_tier: components['schemas']['SubscriptionTier'];
      /** Seat Type */
      seat_type?: string | null;
      /** @default monthly */
      period: components['schemas']['AllowancePeriod'];
      /** Default Member Limit */
      default_member_limit: number;
      /**
       * Enabled
       * @default false
       */
      enabled: boolean;
    };
    /** CreateTemplateFormFromJSON */
    CreateTemplateFormFromJSON: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default FORM_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Template Creation Record Id */
      template_creation_record_id?: string | null;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_json';
      /** Json Source */
      json_source: string;
      /**
       * Form Fields
       * @description Optional reviewed fields. If provided, these must be a subset of the fields extracted from json_source.
       */
      form_fields?: components['schemas']['FormField'][] | null;
    };
    /**
     * CreateContractRequest
     * @description Enrol a workspace on a rate card for a term.
     *
     *     `created_by` is absent by design — the acting admin comes from the caller's
     *     token, never the body, since it is the row's only record of who enrolled the
     *     workspace.
     */
    CreateContractRequest: {
      /** Workspace Id */
      workspace_id: string;
      /** Rate Card Key */
      rate_card_key: string;
      /** Rate Card Version */
      rate_card_version?: number | null;
      /**
       * Starts At
       * Format: date-time
       */
      starts_at: string;
      /** Ends At */
      ends_at?: string | null;
    };
    /** CreateTemplateFormFromXML */
    CreateTemplateFormFromXML: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template?: string | null;
      /** Template Html */
      template_html?: string | null;
      /** Template Json */
      template_json?: string | null;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default FORM_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
      template_visibility: components['schemas']['TemplateVisibility'];
      /** Template Gallery Sharing Preference Show Name */
      template_gallery_sharing_preference_show_name?: boolean | null;
      /** Template Gallery Sharing Preference Show Clinic */
      template_gallery_sharing_preference_show_clinic?: boolean | null;
      /** Template Gallery Sharing Preference Show Profile Picture */
      template_gallery_sharing_preference_show_profile_picture?: boolean | null;
      /** Team Id */
      team_id?: string | null;
      sectional_note_ehr_provider?: components['schemas']['EHRProvider'] | null;
      /** Version Control Id */
      version_control_id?: string | null;
      /** Original V1 Structure Template */
      original_v1_structure_template?: string | null;
      /**
       * Convert To Json
       * @default false
       */
      convert_to_json: boolean;
      /** Template Creation Record Id */
      template_creation_record_id?: string | null;
      /**
       * Problem Based Charting Enabled
       * @default false
       */
      problem_based_charting_enabled: boolean;
      /**
       * S3 Object Key
       * @description S3 key of the original XFA PDF, uploaded through the base PDF template URL. When set, the template is created as an XFA PDF form and xml_source must be the record extracted from that PDF.
       */
      s3_object_key?: string | null;
      /**
       * Use Sections
       * @default false
       */
      use_sections: boolean;
      /**
       * Shared Team Ids
       * @description List of team IDs to share the template with when visibility=team
       */
      shared_team_ids?: string[] | null;
      /**
       * Trigger
       * @constant
       */
      trigger: 'from_xml';
      /** Xml Source */
      xml_source: string;
      /**
       * Form Fields
       * @description Optional form fields reviewed in the client. If provided, these must be a subset of the fields extracted from xml_source.
       */
      form_fields?: components['schemas']['FormField'][] | null;
    };
    /**
     * CreateWorkExperienceFeedbackRequest
     * @description UMUX-Lite general feedback for the Work (projects) product surface.
     */
    CreateWorkExperienceFeedbackRequest: {
      /**
       * Ease Stars
       * @description Ease rating (UMUX-Lite) from 1 to 5
       */
      ease_stars?: number | null;
      /**
       * Usefulness Stars
       * @description Usefulness rating (UMUX-Lite) from 1 to 5
       */
      usefulness_stars?: number | null;
      /**
       * Stars
       * @description Legacy single star rating from 1 to 5
       */
      stars?: number | null;
      /**
       * Feedback
       * @description Optional text feedback from the user
       */
      feedback?: string | null;
    };
    /** CreateWorkExperienceFeedbackResponse */
    CreateWorkExperienceFeedbackResponse: {
      /**
       * Success
       * @description Whether the feedback was saved successfully
       */
      success: boolean;
      /**
       * Feedback Id
       * @description ID of the created feedback record
       */
      feedback_id: string;
      /**
       * Work General Feedback Count
       * @description Updated count of Work general feedback submissions for the user
       */
      work_general_feedback_count: number;
    };
    /**
     * CreditAllowanceResponse
     * @description ``limit``/``consumed``/``remaining`` are effective; ``display_limit`` is
     *     the plan's own limit, for rendering only. They differ only while a grant is
     *     laid over the member's cadence cycle.
     */
    CreditAllowanceResponse: {
      /** Limit */
      limit: string;
      /** Consumed */
      consumed: string;
      /** Remaining */
      remaining: string;
      /** Display Limit */
      display_limit: string;
      /**
       * Cycle Start
       * Format: date-time
       */
      cycle_start: string;
      /**
       * Cycle End
       * Format: date-time
       */
      cycle_end: string;
    };
    /** CuaCloudMachineResponse */
    CuaCloudMachineResponse: {
      /** Machine Id */
      machine_id: string;
      status: components['schemas']['CuaCloudMachineStatus'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * CuaCloudMachineStatus
     * @enum {string}
     */
    CuaCloudMachineStatus: CuaCloudMachineStatus;
    /** CuaCloudVncSessionResponse */
    CuaCloudVncSessionResponse: {
      /** Url */
      url: string;
      /**
       * Expires At
       * Format: date-time
       */
      expires_at: string;
    };
    /** DatasetItemDoc */
    DatasetItemDoc: {
      /** Agent Run Id */
      agent_run_id: string;
      /** Turn Boundary */
      turn_boundary: number;
      /** Note */
      note?: string | null;
      /**
       * Labels
       * @default []
       */
      labels: string[];
    };
    /** DatasetProvenanceDoc */
    DatasetProvenanceDoc: {
      policy: components['schemas']['SamplingPolicyDoc'];
      /** Sampling Fingerprint */
      sampling_fingerprint: string;
      /**
       * Window From
       * Format: date-time
       */
      window_from: string;
      /**
       * Window To
       * Format: date-time
       */
      window_to: string;
      /** Created By */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * DateValue
     * @description A date that is the fact's value, rather than when the fact applies.
     *
     *     Distinct from ``PatientFact.effective``, which is when the assertion holds.
     *     A date of birth is a value; the period a medication was taken is effective
     *     time. Conflating them puts a birth date in a field consumers filter on.
     *
     *     A ``date`` rather than a ``datetime``, and the reason is the same seam that
     *     ``_as_decimal`` exists for. Mongo stores a ``datetime`` as an instant in
     *     UTC, so a date of birth written as local midnight in Sydney is read back as
     *     the previous day — the value changes between write and read with nothing
     *     raising, which is the failure this whole model is built against. A ``date``
     *     has no offset to lose: Beanie encodes it as midnight and it returns as the
     *     day it went in. The type also refuses to carry a time-of-day, which a value
     *     that is a date should never have had.
     */
    DateValue: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: DateValueType;
      /**
       * Date
       * Format: date
       */
      date: string;
    };
    /**
     * DictationDetailAudioInfo
     * @description Audio metadata for diagnostic detail — never includes storage URL.
     */
    DictationDetailAudioInfo: {
      /** Mime Type */
      mime_type: string | null;
      /** Size */
      size: number | null;
      /** Duration */
      duration?: number | null;
    };
    /** DictationDetailFailedEvent */
    DictationDetailFailedEvent: {
      /** Chunk Index */
      chunk_index: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      event_type: DictationDetailFailedEventEvent_type;
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp: string;
      event_data: components['schemas']['DictationDetailFailedEventData'];
    };
    /** DictationDetailFailedEventData */
    DictationDetailFailedEventData: {
      /** Model */
      model: string;
      audio_info: components['schemas']['DictationDetailAudioInfo'];
      /** Error */
      error: string;
      /**
       * Attempted At
       * Format: date-time
       */
      attempted_at: string;
      /** Attempt Index */
      attempt_index: number;
    };
    /** DictationDetailLowConfidenceEvent */
    DictationDetailLowConfidenceEvent: {
      /** Chunk Index */
      chunk_index: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      event_type: DictationDetailLowConfidenceEventEvent_type;
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp: string;
      event_data: components['schemas']['DictationDetailLowConfidenceEventData'];
    };
    /** DictationDetailLowConfidenceEventData */
    DictationDetailLowConfidenceEventData: {
      /** Model */
      model: string;
      audio_info: components['schemas']['DictationDetailAudioInfo'];
      /** Error */
      error: string;
      /**
       * Attempted At
       * Format: date-time
       */
      attempted_at: string;
      /** Attempt Index */
      attempt_index: number;
      /** Text */
      text: string;
      /** Confidence */
      confidence: number;
    };
    /** DictationDetailRecording */
    DictationDetailRecording: {
      /** Recording Id */
      recording_id: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Start Date
       * Format: date-time
       */
      start_date: string;
      /** End Date */
      end_date: string | null;
      /** Duration Ms */
      duration_ms: number;
      /** Word Count */
      word_count: number | null;
      /** Last Chunk Index */
      last_chunk_index: number | null;
      /** Languages */
      languages: string[];
      /** Raw Transcript */
      raw_transcript: string | null;
      /** Post Processed Text */
      post_processed_text: string | null;
      /** Post Processing Model */
      post_processing_model?: string | null;
      /** Input Languages */
      input_languages?: string[] | null;
      /** Output Languages */
      output_languages?: string[];
      /** Events */
      events: (
        | components['schemas']['DictationDetailSuccessfulEvent']
        | components['schemas']['DictationDetailLowConfidenceEvent']
        | components['schemas']['DictationDetailFailedEvent']
      )[];
    };
    /**
     * DictationDetailResponse
     * @description Per-dictation diagnostic detail from transcription-service (SCR-6227).
     */
    DictationDetailResponse: {
      /** Dictation Id */
      dictation_id: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Start Date */
      start_date: string | null;
      /** Duration Ms */
      duration_ms: number;
      /** Word Count */
      word_count: number;
      /** Has Persisted Text */
      has_persisted_text: boolean;
      /** Is Max Duration Exceeded */
      is_max_duration_exceeded: boolean;
      /** Raw Transcript */
      raw_transcript: string | null;
      /** Post Processed Text */
      post_processed_text: string | null;
      /** Recordings */
      recordings: components['schemas']['DictationDetailRecording'][];
    };
    /** DictationDetailSuccessfulEvent */
    DictationDetailSuccessfulEvent: {
      /** Chunk Index */
      chunk_index: number;
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      event_type: DictationDetailSuccessfulEventEvent_type;
      /**
       * Timestamp
       * Format: date-time
       */
      timestamp: string;
      event_data: components['schemas']['DictationDetailSuccessfulEventData'];
    };
    /** DictationDetailSuccessfulEventData */
    DictationDetailSuccessfulEventData: {
      /** Model */
      model: string;
      audio_info: components['schemas']['DictationDetailAudioInfo'];
      /** Text */
      text: string;
      /** Confidence */
      confidence: number;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * DictationResponse
     * @description Single dictation row from transcription-service history/internal list APIs.
     */
    DictationResponse: {
      /** Dictation Id */
      dictation_id: string;
      /**
       * Start Date
       * Format: date-time
       */
      start_date: string;
      /** Duration Ms */
      duration_ms: number;
      /** Post Processed Text */
      post_processed_text: string | null;
      /** Match Count */
      match_count?: number | null;
      /** Highlights */
      highlights?: string[] | null;
    };
    /**
     * DictationsResponse
     * @description Cursor page of dictations from transcription-service.
     */
    DictationsResponse: {
      /** Dictations */
      dictations?: components['schemas']['DictationResponse'][];
      /** Next Cursor */
      next_cursor?: string | null;
      /** Total */
      total: number;
    };
    /**
     * DisplayLocale
     * @enum {string}
     */
    DisplayLocale: DisplayLocale;
    /**
     * DropdownState
     * @description Matched against a native option label at apply time.
     */
    DropdownState: {
      /** Value */
      value: string;
    };
    /** DropdownTarget */
    DropdownTarget: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: DropdownTargetKind;
      selector: components['schemas']['AxSelector'];
      /** States */
      states: {
        [key: string]: components['schemas']['DropdownState'];
      };
    };
    /**
     * EffectivePeriod
     * @description The date or period the fact applies to, as the source states it.
     *
     *     A period rather than an instant because sources say "last week". One bound
     *     may be open; both being absent would make the period meaningless, which is
     *     what the explicit ``UNSPECIFIED`` value is for instead.
     */
    EffectivePeriod: {
      /** Start */
      start?: string | null;
      /** End */
      end?: string | null;
    };
    /** EhrScenarioRequest */
    EhrScenarioRequest: {
      action: components['schemas']['ScenarioAction'];
      /** Integration */
      integration: string;
      /** Scenariokey */
      scenarioKey: string;
    };
    /** EhrScenarioResponse */
    EhrScenarioResponse: {
      /** Integration */
      integration: string;
      /** Scenario Key */
      scenario_key: string;
      action: components['schemas']['ScenarioAction'];
      status: components['schemas']['ScenarioLifecycleStatus'];
      /** Appointment Id */
      appointment_id?: string | null;
      /** Encounter Id */
      encounter_id?: string | null;
      /** Patient Id */
      patient_id?: string | null;
      /** Practice Id */
      practice_id?: string | null;
      /** Department Id */
      department_id?: string | null;
      /** Provider Id */
      provider_id?: string | null;
      /** Appointment Status */
      appointment_status?: string | null;
      /** Detail */
      detail?: string | null;
    };
    /** EnrollmentTicketResponse */
    EnrollmentTicketResponse: {
      /** Ticket Url */
      ticket_url: string;
    };
    /** Entry[MeasureReport] */
    Entry_MeasureReport_: {
      resource: components['schemas']['MeasureReport'];
    };
    /** Entry[ServiceRequest] */
    Entry_ServiceRequest_: {
      resource: components['schemas']['ServiceRequest'];
    };
    /**
     * EpisodeLifecycle
     * @description R1's four episode states.
     * @enum {string}
     */
    EpisodeLifecycle: EpisodeLifecycle;
    /**
     * EvidenceChatLineageCampaignOperation
     * @enum {string}
     */
    EvidenceChatLineageCampaignOperation: EvidenceChatLineageCampaignOperation;
    /**
     * EvidenceChatLineageCampaignPhase
     * @enum {string}
     */
    EvidenceChatLineageCampaignPhase: EvidenceChatLineageCampaignPhase;
    /**
     * EvidenceChatLineageCampaignStatus
     * @enum {string}
     */
    EvidenceChatLineageCampaignStatus: EvidenceChatLineageCampaignStatus;
    /**
     * EvidenceRef
     * @description Where in a source revision the assertion is supported.
     *
     *     The cited content is deliberately not stored. R3 has evidence reads return
     *     the stored source revision and its content, and R2 bars raw source material
     *     from patient state, so a locator into a pinned revision is both necessary and
     *     sufficient. ``locator`` is opaque and source-type specific: transcript
     *     offsets, a document page and span, a structured-record field path.
     */
    EvidenceRef: {
      source: components['schemas']['SourceRef'];
      /** Locator */
      locator: string;
    };
    /**
     * EvidenceState
     * @description Describe how one evidence span relates to the claim being checked.
     * @enum {string}
     */
    EvidenceState: EvidenceState;
    /**
     * ExampleOutputRequest
     * @description Request body for POST /example-output.
     *
     *     The ``structure_template`` is the **inline source of truth** — the
     *     server generates an example note from this string, NOT from a stored
     *     ``TemplateRevision`` or ``CustomTemplate``.  Optional ``template_id``
     *     and ``kinde_user_id`` enable a section-destination mapping join but
     *     do NOT load the template body from the DB.
     *
     *     When ``mappings`` is provided (including an empty list), it is the
     *     join source — used for draft destination links that may not yet be
     *     persisted.  When omitted (``None``), the server falls back to loading
     *     persisted mappings via ``template_id`` + ``kinde_user_id``.
     *
     *     Content policy: ``structure_template`` is forwarded verbatim to the
     *     LLM provider (as the shipped product path already forwards a stored
     *     revision's body).  Templates are structural; callers must not send
     *     real patient content.
     */
    ExampleOutputRequest: {
      /**
       * Structure Template
       * @description Inline markdown template body — the source of truth for generation.  Forwarded verbatim to the LLM provider: send structural template content only, never real patient data
       */
      structure_template: string;
      /**
       * Template Id
       * @description Optional template ObjectId for section-destination mapping join
       */
      template_id?: string | null;
      /**
       * Kinde User Id
       * @description Optional template owner kinde_user_id for mapping join
       */
      kinde_user_id?: string | null;
      /**
       * Mappings
       * @description Optional draft section mappings used as the join source. When provided, persisted DB mappings are not loaded.
       */
      mappings?: components['schemas']['TemplateMappingSchema'][] | null;
    };
    /**
     * ExampleOutputResponse
     * @description Response for POST /example-output.
     *
     *     Contains the generated example note and the parsed section
     *     destinations (heading → optional linked EHR section id).
     */
    ExampleOutputResponse: {
      /**
       * Example Note
       * @description Generated example note text
       */
      example_note: string;
      /**
       * Section Destinations
       * @description Parsed H1 headings with optional mapping join
       */
      section_destinations?: components['schemas']['SectionDestination'][];
    };
    /**
     * ExpectedSource
     * @description One named source instance the episode expects.
     *
     *     R6 makes this list load-bearing: a source that was declared and has not
     *     arrived is reportable as not received, and one that was never declared is
     *     not. So the list is a claim about what should exist, not a summary of what
     *     does.
     */
    ExpectedSource: {
      source_type: components['schemas']['domains__patient_digital_twin__sources__types__SourceType'];
      /** Source Id */
      source_id: string;
    };
    /**
     * ExtractJsonFormFieldsResponse
     * @description Fields extracted from an uploaded JSON form plus the normalised source.
     *
     *     The client sends ``json_source`` back when creating the template.
     */
    ExtractJsonFormFieldsResponse: {
      /** Success */
      success: boolean;
      /** Fields */
      fields: components['schemas']['FormField'][];
      /** Json Source */
      json_source: string;
    };
    /**
     * ExtractXmlFormFieldsResponse
     * @description Fields extracted from an uploaded XML form plus the normalised source.
     *
     *     ``layout`` is the sections/rows/cells structure of a form-DSL document so the
     *     client can render it like a form; ``None`` for generic XML.
     */
    ExtractXmlFormFieldsResponse: {
      /** Success */
      success: boolean;
      /** Fields */
      fields: components['schemas']['FormField'][];
      /** Xml Source */
      xml_source: string;
      layout?: components['schemas']['FormLayout'] | null;
    };
    /**
     * ExtractedFieldEvidenceView
     * @description One stored extraction row; values are verbatim clinical text (PHI).
     */
    ExtractedFieldEvidenceView: {
      /** Profile Attribute */
      profile_attribute: string;
      /** Profile Value */
      profile_value: string | null;
      /** Transcript Support */
      transcript_support: string | null;
    };
    /**
     * FactKind
     * @description The twenty fact kinds R2 allows. A candidate outside this set is rejected.
     * @enum {string}
     */
    FactKind: FactKind;
    /**
     * FactRelationship
     * @description A link to another fact, where meaning is lost without it.
     *
     *     R2.AC6 is the canonical case: one sentence about apixaban for atrial
     *     fibrillation produces two facts and an ``indication_for`` relationship, and
     *     no third fact expressing the pairing.
     */
    FactRelationship: {
      type: components['schemas']['RelationshipType'];
      /** Target Fact Id */
      target_fact_id: string;
    };
    /** FilledXmlField */
    FilledXmlField: {
      /**
       * Id
       * @description Stable field identifier (the XML leaf path)
       */
      id: string;
      /**
       * Field Name
       * @description Absolute XML leaf path
       */
      field_name: string;
      /**
       * Field Label
       * @description Human-readable label for display
       */
      field_label: string;
      /**
       * Field Type
       * @description Field type; always Text for XML forms
       */
      field_type: string;
      /**
       * Field Value
       * @description Current filled value
       */
      field_value: string;
      /**
       * Exclude From Fill
       * @description Field is locked: never auto-filled, and rejected by the update endpoint. Clients should render it read-only.
       * @default false
       */
      exclude_from_fill: boolean;
    };
    /**
     * FixStripeCustomerIdRequest
     * @description Request body for POST /internal-admin/billings/fix-stripe-customer-id.
     */
    FixStripeCustomerIdRequest: {
      /** User Ref Id */
      user_ref_id: string;
    };
    /**
     * FixStripeCustomerIdResponse
     * @description Response for POST /internal-admin/billings/fix-stripe-customer-id.
     *
     *     ``previous_stripe_customer_id`` is the value the account held before the
     *     repair, echoed back so the admin UI can show what was replaced and the
     *     change can be reversed by hand if it turns out the User record was the
     *     stale side.
     */
    FixStripeCustomerIdResponse: {
      /** Success */
      success: boolean;
      /** Message */
      message: string;
      /** Previous Stripe Customer Id */
      previous_stripe_customer_id?: string | null;
      billing_account?: components['schemas']['InternalAdminBillingAccountView'] | null;
    };
    /** FormCell */
    FormCell: {
      /** Type */
      type: string;
      /** Field */
      field?: string | null;
      /** Text */
      text?: string | null;
      /** Value */
      value?: string | null;
      /**
       * Checked
       * @default false
       */
      checked: boolean;
      /** Options */
      options?: components['schemas']['FormOption'][];
      /** Size */
      size?: string | null;
      /**
       * Req
       * @default false
       */
      req: boolean;
      /**
       * Num
       * @default false
       */
      num: boolean;
      /**
       * Mono
       * @default false
       */
      mono: boolean;
      /** Placeholder */
      placeholder?: string | null;
      /** Yes Text */
      yes_text?: string | null;
      /** No Text */
      no_text?: string | null;
    };
    /**
     * FormFormat
     * @enum {string}
     */
    FormFormat: FormFormat;
    /** FormLayout */
    FormLayout: {
      /** Id */
      id?: string | null;
      /** Title */
      title?: string | null;
      /** Subtitle */
      subtitle?: string | null;
      /** Locale */
      locale?: string | null;
      /** Guidance */
      guidance?: string[];
      /** Metadata Map */
      metadata_map?: {
        [key: string]: string;
      };
      /** Sections */
      sections?: components['schemas']['FormSection'][];
    };
    /** FormOption */
    FormOption: {
      /** Value */
      value?: string | null;
      /** Text */
      text: string;
      /**
       * Selected
       * @default false
       */
      selected: boolean;
      /**
       * Checked
       * @default false
       */
      checked: boolean;
    };
    /** FormRow */
    FormRow: {
      /** Cls */
      cls?: string | null;
      /** Cells */
      cells?: components['schemas']['FormCell'][];
    };
    /** FormSection */
    FormSection: {
      /** Title */
      title?: string | null;
      /** Rows */
      rows?: components['schemas']['FormRow'][];
    };
    /**
     * FrozenLlmTransport
     * @description Transport decision frozen into the run snapshot at run creation.
     *
     *     ``provider``/``model`` are the EFFECTIVE wire values (a Bedrock stamp
     *     carries the resolved CRIS id, not the canonical Anthropic id), unlike the
     *     ``LLMConfig`` routing fields, which keep the requested values so failover
     *     arms and telemetry can still derive the canonical model. ``None`` on
     *     ``LLMConfig.frozen_transport`` means the run predates transport freezing
     *     and the LLM activity falls back to per-call resolution.
     */
    FrozenLlmTransport: {
      /**
       * Provider
       * @enum {string}
       */
      provider: FrozenLlmTransportProvider;
      /** Model */
      model: string;
    };
    /**
     * GetConnectionWorkspacesRequest
     * @description Request DTO for resolving an SSO connection's workspaces for one user.
     *
     *     ``group_ids`` are the user's raw IdP group IDs, which the Auth0 `set token
     *     claims` action already extracts for its `groups` claim. The broker does the
     *     matching so the rule stays in Python where it is unit-testable, and so the
     *     response stays small enough to fit the access-token claim it feeds.
     */
    GetConnectionWorkspacesRequest: {
      /**
       * Connection Name
       * @description SSO connection name (the Auth0 connection name)
       */
      connection_name: string;
      /**
       * Group Ids
       * @description The user's IdP group IDs. Workspaces with no group restriction match regardless, so an empty list is valid.
       */
      group_ids?: string[];
    };
    /**
     * GetConnectionWorkspacesResponse
     * @description The workspaces an SSO connection grants the requesting user.
     *
     *     ``workspaces`` is already filtered against the request's ``group_ids`` and
     *     is a flat list of workspace IDs in link order. An empty list means the
     *     connection grants this user nothing: either it has no linked workspaces yet
     *     (migration is manual, so that is expected) or none of them match the user's
     *     groups. A connection that does not exist raises
     *     ``SSOConnectionNotFoundError`` (404).
     */
    GetConnectionWorkspacesResponse: {
      /**
       * Workspaces
       * @description Workspace IDs this user may self-onboard into
       */
      workspaces?: string[];
      /**
       * Enforce Linked Workspaces
       * @description Restrict this connection's users to the linked workspaces only
       * @default false
       */
      enforce_linked_workspaces: boolean;
    };
    /** GetFilledXmlFieldsResponse */
    GetFilledXmlFieldsResponse: {
      /**
       * Document Id
       * @description Document ID
       */
      document_id: string;
      /**
       * Template Id
       * @description Template ID
       */
      template_id: string;
      /**
       * Fields
       * @description Filled XML fields
       */
      fields: components['schemas']['FilledXmlField'][];
      /** @description Form layout (sections/rows/cells) for form-DSL templates; null for generic XML */
      layout?: components['schemas']['FormLayout'] | null;
    };
    HcpLookupResponse: {
      /** @description Registry that answered the lookup. */
      registry: components['schemas']['VerificationRegistry'];
      /**
       * Identifier
       * @description Identifier that was looked up.
       */
      identifier: string;
      /** @description What the registry held for the identifier. */
      outcome: components['schemas']['RegistryLookupOutcome'];
      /**
       * Matched Name
       * @description Individual name the registry returned; null when it held no individual name.
       */
      matched_name: string | null;
      /**
       * Is Organisational
       * @description Whether the registry record describes an organisation; null when the registry held no record.
       */
      is_organisational: boolean | null;
      /**
       * Organisational Name
       * @description Organisation name when the record is organisational.
       */
      organisational_name: string | null;
      /**
       * Primary Specialty
       * @description Primary classification description from the registry.
       */
      primary_specialty: string | null;
      /**
       * Classifications
       * @description The registry's classification list as it sent it, unmapped to Heidi's specialty catalogue.
       */
      classifications: {
        [key: string]: unknown;
      }[];
      /**
       * Can Confirm
       * @description Whether the user may confirm this identifier.
       */
      can_confirm: boolean;
    };
    /**
     * HcpVerificationStatusResponse
     * @description Chrome projection of the caller's current verification records.
     *
     *     Registry, identifier, classifications (including NPPES state licence
     *     numbers), matched name, specialty, review reason, confirmation time, and
     *     the derived review flag belong on ``HcpVerificationResponse`` — the
     *     settings read. This model is the badge fetch and must not grow into a
     *     second copy of that contract.
     */
    HcpVerificationStatusResponse: {
      /** @description The caller's status across every registry: VERIFIED over NEEDS_REVIEW over REJECTED. Null when the caller holds no record. */
      status: components['schemas']['HcpVerificationStatus'] | null;
      /**
       * Specialty Requires Verification
       * @description Whether Heidi expects clinicians in the caller's saved specialty to verify, read from the specialty the review request decides from. False means a review request stating no identifier, with no justification and no document, is granted without review. Null when no specialty resolves; treat it as true.
       */
      specialty_requires_verification?: boolean | null;
    };
    HcpVerificationResponse: {
      /** @description Registry that produced this record. */
      registry: components['schemas']['VerificationRegistry'];
      /**
       * Identifier
       * @description Identifier that was submitted.
       */
      identifier: string;
      /** @description Resolved verification outcome. */
      status: components['schemas']['HcpVerificationStatus'];
      /** @description Why the result was flagged. Set when status is NEEDS_REVIEW or REJECTED; null on a verified record. */
      review_reason: components['schemas']['ReviewReason'] | null;
      /**
       * Matched Name
       * @description Provider name the registry returned for the identifier; null when the registry held no individual name for it.
       */
      matched_name: string | null;
      /**
       * Primary Specialty
       * @description Primary classification description from the registry.
       */
      primary_specialty: string | null;
      /**
       * Classifications
       * @description The registry's classification list as it sent it, unmapped to Heidi's specialty catalogue.
       */
      classifications: {
        [key: string]: unknown;
      }[];
      /**
       * Confirmed At
       * @description When the user confirmed or requested review.
       */
      confirmed_at: string | null;
      /**
       * Needs Review
       * @description Whether the result is kept for review.
       */
      needs_review: boolean;
    };
    /**
     * HcpVerificationStatus
     * @description What a persisted verification record is.
     *
     *     ``REJECTED`` is reachable only through a reviewer's decision on the review
     *     surface: no lookup, confirmation or review request writes it. It is a
     *     status rather than a flag inside the review so a consumer reading only
     *     ``status`` cannot mistake a rejected applicant for one still pending.
     * @enum {string}
     */
    HcpVerificationStatus: HcpVerificationStatus;
    /**
     * HealthResponse
     * @description Scaffold health-check response for the template inspector.
     */
    HealthResponse: {
      /** Status */
      status: string;
      /** Region */
      region: string;
    };
    /**
     * HealthcareServiceAvailableTime
     * @description Times the Service Site is available.
     *
     *     A collection of times that the Service Site is available.
     *
     *     https://hl7.org/fhir/R4/healthcareservice-definitions.html#HealthcareService.availableTime
     */
    HealthcareServiceAvailableTime: {
      /**
       * mon | tue | wed | thu | fri | sat | sun
       * @description Indicates which days of the week are available between the start and end Times.
       */
      daysOfWeek?: components['schemas']['DaysOfWeek'][] | null;
      /**
       * Always available? e.g. 24 hour service
       * @description Is this always available? (hence times are irrelevant) e.g. 24 hour service.
       */
      allDay?: boolean | null;
      /**
       * Opening time of day (ignored if allDay = true)
       * @description The opening time of day. Note: If the AllDay flag is set, then this time is ignored.
       */
      availableStartTime?: string | null;
      /**
       * Closing time of day (ignored if allDay = true)
       * @description The closing time of day. Note: If the AllDay flag is set, then this time is ignored.
       */
      availableEndTime?: string | null;
    };
    /**
     * HealthcareServiceEligibility
     * @description Specific eligibility requirements required to use the service.
     *
     *     Does this service have specific eligibility requirements that need to be
     *     met in order to use the service?
     *
     *     https://hl7.org/fhir/R4/healthcareservice-definitions.html#HealthcareService.eligibility
     */
    HealthcareServiceEligibility: {
      /** Coded value for the eligibility */
      code?: components['schemas']['CodeableConcept'] | null;
      /** Describes the eligibility conditions for the service */
      comment?: string | null;
    };
    /**
     * HealthcareServiceNotAvailable
     * @description Not available during this time due to provided reason.
     *
     *     The HealthcareService is not available during this period of time due to
     *     the provided reason.
     *
     *     https://hl7.org/fhir/R4/healthcareservice-definitions.html#HealthcareService.notAvailable
     */
    HealthcareServiceNotAvailable: {
      /**
       * Reason presented to the user explaining why time not available
       * @description The reason that can be presented to the user as to why this time is not available.
       */
      description: string;
      /**
       * Service not available from this date
       * @description Service is not available (seasonally or for a public holiday) from this date.
       */
      during?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
    };
    /**
     * HistoryWindow
     * @description R1's "numerical start and end clinical times".
     *
     *     Clinical times, not processing times: the window bounds when a fact
     *     *applies*, so a discharge summary uploaded today and dated two years ago
     *     falls outside a one-year window. Both ends are inclusive, which R1.AC5
     *     fixes explicitly.
     */
    HistoryWindow: {
      /**
       * Start
       * Format: date-time
       */
      start: string;
      /**
       * End
       * Format: date-time
       */
      end: string;
    };
    /**
     * HumanResponseRef
     * @description The extra provenance R2 requires of a ``confirmed_human_input`` fact.
     *
     *     ``response_id`` is the immutable identifier R4 deduplicates on, which is why
     *     it is recorded on the fact and not only on the request that produced it.
     */
    HumanResponseRef: {
      /** Submitting Consumer */
      submitting_consumer: string;
      /** Response Id */
      response_id: string;
      /** Actor Id */
      actor_id: string;
      actor_role: components['schemas']['AsserterRole'];
      /** Target Fact Id */
      target_fact_id?: string | null;
      /** Target Field */
      target_field?: string | null;
    };
    /** InitiateCibaRequest */
    InitiateCibaRequest: {
      /**
       * Email
       * Format: email
       */
      email: string;
      /**
       * Binding Message
       * @deprecated
       * @description Ignored. The server composes binding_message itself from a server-generated match code. Kept for schema compatibility only.
       * @default Approve Heidi login
       */
      binding_message: string;
    };
    /** InitiateCibaResponse */
    InitiateCibaResponse: {
      /** Auth Req Id */
      auth_req_id: string;
      /** Completion Token */
      completion_token: string;
      /** Expires In */
      expires_in: number;
      /**
       * Interval
       * @default 5
       */
      interval: number;
      /** Match Code */
      match_code: string;
    };
    /** InitiateRpaRecordingUploadRequest */
    InitiateRpaRecordingUploadRequest: {
      /** Name */
      name: string;
      /** Size Bytes */
      size_bytes: number;
      /** App Version */
      app_version?: string | null;
    };
    /**
     * InsertionPoint
     * @description One heading insertion position returned by the suggest endpoint.
     *
     *     The LLM returns ``{line_index, heading_text}`` tuples — NOT a rewritten
     *     template body.  The client applies these positions to the
     *     ``WorkingTemplateDraft`` to produce the before/after diff.
     *
     *     Insertions are **pure**: ``heading_text`` is inserted before the line at
     *     ``line_index`` and no original line is removed or relocated.  That is what
     *     makes byte-preservation of the original body structurally checkable —
     *     stripping the inserted headings must restore the original exactly.
     */
    InsertionPoint: {
      /**
       * Line Index
       * @description Zero-based line index the heading is inserted before
       */
      line_index: number;
      /**
       * Heading Text
       * @description Heading text starting with '# '
       */
      heading_text: string;
    };
    /**
     * InspectorJoinResponse
     * @description Full join response for GET /{template_id}.
     *
     *     Combines the live ``CustomTemplate``, parser-computed sections,
     *     section mappings, the four-state status, a content hash for
     *     concurrency control, and the owner identity block.
     */
    InspectorJoinResponse: {
      /** @description Live CustomTemplate fields */
      template: components['schemas']['InspectorTemplateResponse'];
      /**
       * Sections
       * @description Parsed and non-parsed sections in document order
       */
      sections?: components['schemas']['InspectorSectionResponse'][];
      /** @description Overall migration status */
      status: components['schemas']['MigrationStatus'];
      /**
       * Has Lookalike Blocks
       * @description True when ≥1 section is a heading look-alike. Advisory — the status stays parser-computed and is not affected by this flag
       * @default false
       */
      has_lookalike_blocks: boolean;
      /**
       * Mappings
       * @description Section-heading → EHR-section-id mappings
       */
      mappings?: components['schemas']['TemplateMappingSchema'][];
      /**
       * Content Hash
       * @description SHA-256 hex of stored structure_template (64 chars)
       */
      content_hash: string;
      /** @description Template owner identity for tenancy assertions */
      owner: components['schemas']['InspectorOwnerResponse'];
    };
    /**
     * InspectorOwnerResponse
     * @description Template owner identity block for tenancy/region assertions.
     *
     *     Display fields (email, display_name, workspace_name) are best-effort —
     *     empty string when the directory has no entry. IDs remain the source of
     *     truth for navigation links.
     */
    InspectorOwnerResponse: {
      /**
       * Kinde User Id
       * @description Owner's Kinde user id
       */
      kinde_user_id: string;
      /**
       * User Ref Id
       * @description Owner's user_ref_id (UUID7), None when unavailable
       */
      user_ref_id?: string | null;
      /**
       * Workspace Id
       * @description Workspace id as string, or None
       */
      workspace_id?: string | null;
      /**
       * Email
       * @description Best-effort owner email (empty when unavailable)
       * @default
       */
      email: string;
      /**
       * Display Name
       * @description Best-effort owner display name (empty when unavailable)
       * @default
       */
      display_name: string;
      /**
       * Workspace Name
       * @description Best-effort workspace/org name (empty when unavailable)
       * @default
       */
      workspace_name: string;
    };
    /**
     * InspectorSectionResponse
     * @description One row in the join response's section list — parsed or non-parsed.
     *
     *     Extends the internal ``InspectorSection`` compute result with mapping
     *     provenance.
     *
     *     **On provenance:** ``SectionLink`` carries only ``section_heading`` and
     *     ``linked_ehr_section_id``, and the mapping row it lives in is keyed
     *     ``(kinde_user_id, template_id)`` — i.e. it belongs to *this* template.
     *     Nothing in the data model records whether a link was carried over from
     *     another template or authored directly here, so inheritance cannot be
     *     asserted.  ``inherited`` therefore stays ``False`` and
     *     ``inherited_from`` ``None`` until a real provenance marker exists on
     *     the mapping row; ``mapping_source`` reports the one thing that *is*
     *     verifiable — that the link came from this template's mapping sidecar.
     *
     *     Fields:
     *         heading: Heading text (normalized for parsed H1 sections, raw
     *             line text for non-parsed look-alike blocks).
     *         is_parsed_section: True for real H1 sections parsed by the
     *             production parser; False for look-alike blocks.
     *         destination_name: Human-readable title resolved from the
     *             SectionalNoteSection slug, or None when unlinked/invalid.
     *         linked_ehr_section_id: EHR section id from the mapping, or None.
     *         merge_target: For non-parsed look-alikes, the previous parsed
     *             section heading (or None).
     *         inherited: Whether this link was inherited from elsewhere.  Always
     *             False today — see the note above.
     *         inherited_from: Provenance text when ``inherited`` is True; always
     *             None today.
     *         mapping_source: Where the link came from — ``template_mapping``
     *             when this template's mapping sidecar supplied it, None when
     *             the section is unlinked.
     */
    InspectorSectionResponse: {
      /**
       * Heading
       * @description Heading text or raw look-alike line
       */
      heading: string;
      /**
       * Is Parsed Section
       * @description True for parsed H1 sections
       */
      is_parsed_section: boolean;
      /**
       * Destination Name
       * @description Human title from the slug→title map, or None
       */
      destination_name?: string | null;
      /**
       * Linked Ehr Section Id
       * @description EHR section id from the mapping, or None
       */
      linked_ehr_section_id?: string | null;
      /**
       * Merge Target
       * @description Previous parsed section heading for look-alike blocks
       */
      merge_target?: string | null;
      /**
       * Inherited
       * @description True when this link was inherited from another template. Always False until the mapping row carries a provenance marker
       * @default false
       */
      inherited: boolean;
      /**
       * Inherited From
       * @description Provenance text when inherited, or None
       */
      inherited_from?: string | null;
      /** @description Verifiable origin of the link — 'template_mapping' when this template's mapping sidecar supplied it, None when unlinked */
      mapping_source?: components['schemas']['MappingSource'] | null;
    };
    /**
     * InspectorTemplateResponse
     * @description The live ``CustomTemplate`` block in the join response.
     */
    InspectorTemplateResponse: {
      /**
       * Id
       * @description CustomTemplate ObjectId as string
       */
      id: string;
      /**
       * Name
       * @description Template display name
       */
      name: string;
      /**
       * Structure Template
       * @description Live markdown body
       */
      structure_template: string;
      /**
       * Template Json
       * @description JSON-format template (nullable for legacy rows)
       */
      template_json?: string | null;
      /**
       * Template Html
       * @description HTML-format template (nullable for legacy rows)
       */
      template_html?: string | null;
      /**
       * Updated At
       * @description Template updated_time (nullable for legacy rows)
       */
      updated_at?: string | null;
    };
    /** InternalAdminAxCaptureDetailResponse */
    InternalAdminAxCaptureDetailResponse: {
      capture: components['schemas']['InternalAdminAxCaptureRow'];
      /** Download Url */
      download_url: string;
      /** Download Url Expires In */
      download_url_expires_in: number;
    };
    /** InternalAdminAxCaptureListResponse */
    InternalAdminAxCaptureListResponse: {
      /** Captures */
      captures: components['schemas']['InternalAdminAxCaptureRow'][];
    };
    /** InternalAdminAxCaptureRow */
    InternalAdminAxCaptureRow: {
      /** Capture Id */
      capture_id: string;
      /** Owner User Ref Id */
      owner_user_ref_id: string;
      /** Phase */
      phase: string | null;
      /** Reason */
      reason: string | null;
      /** Size Bytes */
      size_bytes: number;
      /**
       * Captured At
       * Format: date-time
       */
      captured_at: string;
      /**
       * Expires At
       * Format: date-time
       */
      expires_at: string;
    };
    /** InternalAdminCreditAllowancePolicyResponse */
    InternalAdminCreditAllowancePolicyResponse: {
      /** Policy Id */
      policy_id: string;
      subscription_tier: components['schemas']['SubscriptionTier'];
    };
    /** InternalAdminCreditAllowanceResponse */
    InternalAdminCreditAllowanceResponse: {
      /** Workspace Id */
      workspace_id: string;
      /** User Ref Id */
      user_ref_id: string;
      /** Seat Type */
      seat_type: string | null;
      /** Limit */
      limit: number;
      /** Consumed */
      consumed: number;
      /** Remaining */
      remaining: number;
      /**
       * Cycle Start
       * Format: date-time
       */
      cycle_start: string;
      /**
       * Cycle End
       * Format: date-time
       */
      cycle_end: string;
      policy: components['schemas']['InternalAdminCreditAllowancePolicyResponse'];
    };
    /** InternalAdminInSessionEvidenceQuotaResponse */
    InternalAdminInSessionEvidenceQuotaResponse: {
      /**
       * Period
       * @default weekly
       * @constant
       */
      period: 'weekly';
      /** Current Period Start */
      current_period_start?: string | null;
      /** Current Period End */
      current_period_end?: string | null;
      basic: components['schemas']['InternalAdminQuotaUsageResponse'];
      advanced: components['schemas']['InternalAdminQuotaUsageResponse'];
    };
    /**
     * InternalAdminInvitationLinkResponse
     * @description Active team invitation link for a user (IA-102 copy-join-link).
     *
     *     ``invitation_link`` is the same URL shape the user received by email,
     *     regenerated via the team invitation service's ``_generate_invitation_link``.
     *     Returned only when an active (non-expired, non-accepted) invitation exists;
     *     the endpoint yields 404 otherwise so the frontend can hide the button.
     */
    InternalAdminInvitationLinkResponse: {
      /** Invitation Link */
      invitation_link: string;
      /**
       * Expire At
       * Format: date-time
       */
      expire_at: string;
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
    };
    /** InternalAdminQuotaUsageResponse */
    InternalAdminQuotaUsageResponse: {
      /** Used */
      used: number;
      /** Limit */
      limit?: number | null;
      /** Remaining */
      remaining?: number | null;
      /** Unlimited */
      unlimited: boolean;
    };
    /**
     * InternalAdminSendOnboardingEmailRequest
     * @description IA-97 request for sending onboarding emails to team members.
     */
    InternalAdminSendOnboardingEmailRequest: {
      /** User Emails */
      user_emails: string[];
      display_language?: components['schemas']['LanguageCode'] | null;
    };
    /** InternalAdminSendOnboardingEmailResponse */
    InternalAdminSendOnboardingEmailResponse: {
      /** Success Emails */
      success_emails: string[];
      /** Failed Emails Data */
      failed_emails_data: {
        [key: string]: string;
      };
    };
    /**
     * InternalAdminUpdateWorkspaceRequest
     * @description PATCH body for the workspace admin update.
     *
     *     Managed status + key contacts only for now — the surface's first
     *     write route. ``name`` is deliberately out of scope until its team
     *     dual-write story lands.
     *
     *     ``extra="forbid"`` is deliberate: with both fields optional, an
     *     unrecognised key (a rename, a camelCase slip from a client) would
     *     otherwise resolve to "change nothing" and return a 200 that looks
     *     like a successful managed-status change but wrote nothing.
     */
    InternalAdminUpdateWorkspaceRequest: {
      /** Is Managed */
      is_managed?: boolean | null;
      /** Managed Key Contact Emails */
      managed_key_contact_emails?: string[] | null;
    };
    /**
     * InternalTestCreateTeamTemplateRequest
     * @description Minimal team-template payload for E2E setup.
     */
    InternalTestCreateTeamTemplateRequest: {
      /** Name */
      name: string;
      /** Structure Template */
      structure_template: string;
      /** Description */
      description?: string | null;
      /** Tone Template */
      tone_template?: string | null;
      /** @default DOCUMENT_TEMPLATE */
      template_category: components['schemas']['TemplateCategory'];
    };
    /** InternalTestCreatedTemplateResponse */
    InternalTestCreatedTemplateResponse: {
      /**
       * Template Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      template_id: string;
      /** Template Name */
      template_name: string;
      /**
       * Team Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      team_id: string;
      template_visibility: components['schemas']['TemplateVisibility'];
    };
    /** JudgeMemberResultDoc */
    JudgeMemberResultDoc: {
      /** Intended Model */
      intended_model: string;
      /**
       * Outcome
       * @enum {string}
       */
      outcome: JudgeMemberResultDocOutcome;
      /** Returned Model */
      returned_model?: string | null;
      /** Returned Provider */
      returned_provider?: string | null;
      /** Verdict */
      verdict?: {
        [key: string]: unknown;
      } | null;
      /** Error */
      error?: string | null;
    };
    /** JudgePinDoc */
    JudgePinDoc: {
      /** Members */
      members: components['schemas']['JudgeMemberResultDoc'][];
      /** Rubric Version */
      rubric_version: string;
      /** Rubric Sha256 */
      rubric_sha256: string;
    };
    /**
     * LLMProviders
     * @enum {string}
     */
    LLMProviders: LLMProviders;
    /**
     * LanguageResponse
     * @description One catalogue language projected for client pickers.
     */
    LanguageResponse: {
      /** Code */
      code: string;
      /** Name */
      name: string;
      /** Nativename */
      nativeName: string;
      /** Ttsavailable */
      ttsAvailable: boolean;
      /** Variantof */
      variantOf?: string | null;
    };
    /**
     * LinkedWorkspaceDTO
     * @description A workspace linked to an SSO connection for self-onboarding.
     */
    LinkedWorkspaceDTO: {
      /** Workspace Id */
      workspace_id: string;
      /** Group Ids */
      group_ids?: string[];
    };
    /**
     * LinkedWorkspaceRequest
     * @description A workspace to link to an SSO connection for self-onboarding.
     */
    LinkedWorkspaceRequest: {
      /**
       * Workspace Id
       * @description Regional workspace._id (string form), in the connection's region
       */
      workspace_id: string;
      /**
       * Group Ids
       * @description IdP group IDs; empty means any user on this connection
       */
      group_ids?: string[];
    };
    /** ListAgentEvalBundlesResponse */
    ListAgentEvalBundlesResponse: {
      /** Bundles */
      bundles: components['schemas']['AgentEvalBundleResponse'][];
    };
    /** ListAgentEvalDatasetsResponse */
    ListAgentEvalDatasetsResponse: {
      /** Datasets */
      datasets: components['schemas']['AgentEvalDatasetSummaryResponse'][];
      /** Total */
      total: number;
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
    };
    /** ListAgentEvalExperimentsResponse */
    ListAgentEvalExperimentsResponse: {
      /** Experiments */
      experiments: components['schemas']['AgentEvalExperimentSummaryResponse'][];
      /** Total */
      total: number;
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
    };
    /** ListAgentEvalSuitesResponse */
    ListAgentEvalSuitesResponse: {
      /** Suites */
      suites: components['schemas']['AgentEvalSuiteResponse'][];
      /** Total */
      total: number;
    };
    /** ListAgentRunScoresResponse */
    ListAgentRunScoresResponse: {
      /**
       * Scores
       * @description Metadata only. No score values and no judge reasoning: reasoning quotes the real trajectory it graded, and is readable only through the PHI-gated suite results read.
       */
      scores: components['schemas']['AgentRunScoreResponse'][];
      /** Total */
      total: number;
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
    };
    /** ListSavedEvalSuiteScoresResponse */
    ListSavedEvalSuiteScoresResponse: {
      /** Scores */
      scores: components['schemas']['SavedEvalSuiteScoreResponse'][];
      /** Total */
      total: number;
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
    };
    /** ListSavedEvalSuitesResponse */
    ListSavedEvalSuitesResponse: {
      /** Suites */
      suites: components['schemas']['SavedEvalSuiteResponse'][];
      /** Total */
      total: number;
      /** Limit */
      limit: number;
      /** Offset */
      offset: number;
    };
    /** LocaleImportResult */
    LocaleImportResult: {
      /** Locale */
      locale: string;
      /** Updated */
      updated: number;
      /** Unchanged */
      unchanged: number;
      /** Skipped Keys */
      skipped_keys?: string[];
      /**
       * Skipped Empty
       * @default 0
       */
      skipped_empty: number;
    };
    /** LookupHcpRequest */
    LookupHcpRequest: {
      /**
       * Identifier
       * @description Registry-specific provider identifier to look up (an NPI for NPPES).
       */
      identifier: string;
      /** @description Registry to look up against. Omit to use the one that applies to your account; naming one that does not is rejected. */
      registry?: components['schemas']['VerificationRegistry'] | null;
    };
    /**
     * MachineCheck
     * @description Machine-check result for the suggest response.
     *
     *     ``passed`` is true when applying the insertion points as pure inserts
     *     and stripping those headings restores the original body byte-for-byte,
     *     with mapping IDs unchanged.
     */
    MachineCheck: {
      /**
       * Passed
       * @description True when the suggested inserts preserve the original body
       */
      passed: boolean;
    };
    /**
     * MappingSource
     * @description Where a section's EHR link came from.
     *
     *     Only one member exists today because only one origin is verifiable: the
     *     ``template_section_mapping`` row keyed ``(kinde_user_id, template_id)``,
     *     which belongs to the template being inspected.  An inherited-from-another-
     *     template origin would need a provenance marker on that row, which does not
     *     exist yet — so it is deliberately absent rather than guessed at.
     *
     *     Members:
     *         TEMPLATE_MAPPING: The link came from this template's mapping sidecar.
     * @enum {string}
     */
    MappingSource: MappingSource;
    /**
     * MatchCandidateView
     * @description One stored ranked candidate: scores and field *names*, plus the clinical
     *     verdict label. Everything here is non-PHI except ``clinical_verdict_reason``,
     *     which is free text the model wrote and may name a condition.
     */
    MatchCandidateView: {
      entity_type: components['schemas']['TranscriptMatchCandidateKind'];
      /** Target Id */
      target_id: string;
      /** Confidence */
      confidence: number;
      /** Evidence Weight */
      evidence_weight: number | null;
      /** Corroborated Field Names */
      corroborated_field_names: string[] | null;
      /** Conflicting Field Names */
      conflicting_field_names: string[] | null;
      clinical_verdict: components['schemas']['ClinicalComparisonVerdict'] | null;
      /** Clinical Verdict Field Names */
      clinical_verdict_field_names: string[] | null;
      /** Clinical Verdict Reason */
      clinical_verdict_reason: string | null;
    };
    /**
     * MeasureReport
     * @description The results of the calculation of a measure.
     *
     *     The MeasureReport resource contains the results of the calculation of a
     *     measure; and optionally a reference to the resources involved in that
     *     calculation.
     *
     *     https://hl7.org/fhir/R4/measurereport-definitions.html
     */
    MeasureReport: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional identifier for the MeasureReport
       * @description A formal identifier that is used to identify this MeasureReport when it is represented in other formats or referenced in a specification, model, design or an instance.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * complete | pending | error
       * @description The MeasureReport status. No data will be available until the MeasureReport status is complete. Required by FHIR R4.
       */
      status: components['schemas']['MeasureReportStatus'];
      /**
       * individual | subject-list | summary | data-collection
       * @description The type of measure report. This may be an individual report, which provides the score for the measure for an individual member of the population; a subject-listing, which returns the list of members that meet the various criteria in the measure; a summary report, which returns a population count for each of the criteria in the measure; or a data-collection, which enables the MeasureReport to be used to exchange the data-of-interest for a quality measure. Required by FHIR R4.
       */
      type: components['schemas']['MeasureReportType'];
      /**
       * What measure was calculated
       * @description A reference to the Measure that was calculated to produce this report. Required by FHIR R4.
       */
      measure: string;
      /**
       * What individual(s) the report is for
       * @description Optional subject identifying the individual or individuals the report is for.
       */
      subject?: components['schemas']['Reference'] | null;
      /**
       * When the report was generated
       * @description The date this measure report was generated.
       */
      date?: string | null;
      /**
       * Who is reporting the data
       * @description The individual, location, or organization that is reporting the data.
       */
      reporter?: components['schemas']['Reference'] | null;
      /**
       * What period the report covers
       * @description The reporting period for which the report was calculated. Required by FHIR R4.
       */
      period: components['schemas']['pkg__integrations__fhir__models__data_types__period__Period'];
      /**
       * increase | decrease
       * @description Whether improvement in the measure is noted by an increase or decrease in the measure score.
       */
      improvementNotation?: components['schemas']['CodeableConcept'] | null;
      /**
       * Measure results for each group
       * @description The results of the calculation, one for each population group in the measure.
       */
      group?: components['schemas']['MeasureReportGroup'][] | null;
      /**
       * What data was used to calculate the measure score
       * @description A reference to a Bundle containing the Resources that were used in the calculation of this measure.
       */
      evaluatedResource?: components['schemas']['Reference'][] | null;
    };
    /**
     * MeasureReportGroup
     * @description The results of the calculation, one for each population group in the measure.
     *
     *     https://hl7.org/fhir/R4/measurereport-definitions.html#MeasureReport.group
     */
    MeasureReportGroup: {
      /**
       * Meaning of the group
       * @description The meaning of the population group as defined in the measure definition.
       */
      code?: components['schemas']['CodeableConcept'] | null;
      /**
       * The populations in the group
       * @description The populations that make up the population group, one for each type of population appropriate for the measure.
       */
      population?: components['schemas']['MeasureReportGroupPopulation'][] | null;
      /**
       * What score this group achieved
       * @description The measure score for this population group, calculated as appropriate for the measure type and scoring method, and based on the contents of the populations defined in the group.
       */
      measureScore?: components['schemas']['Quantity'] | null;
      /**
       * Stratification results
       * @description When a measure includes multiple stratifiers, there will be a stratifier group for each stratifier defined by the measure.
       */
      stratifier?: components['schemas']['MeasureReportGroupStratifier'][] | null;
    };
    /**
     * MeasureReportGroupPopulation
     * @description The populations that make up a population group or stratum.
     *
     *     https://hl7.org/fhir/R4/measurereport-definitions.html#MeasureReport.group.population
     */
    MeasureReportGroupPopulation: {
      /**
       * Type of the population
       * @description The type of the population.
       */
      code?: components['schemas']['CodeableConcept'] | null;
      /**
       * Size of the population
       * @description The number of members of the population.
       */
      count?: number | null;
      /**
       * List of subject-level MeasureReports
       * @description This element refers to a List of subject level MeasureReport resources, one for each subject in this population.
       */
      subjectResults?: components['schemas']['Reference'] | null;
    };
    /**
     * MeasureReportGroupStratifier
     * @description A stratifier group for a measure that includes multiple stratifiers.
     *
     *     https://hl7.org/fhir/R4/measurereport-definitions.html#MeasureReport.group.stratifier
     */
    MeasureReportGroupStratifier: {
      /**
       * What stratifier of the group
       * @description The meaning of this stratifier, as defined in the measure definition.
       */
      code?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Stratum results, one for each unique value in the stratifier
       * @description This element contains the results for a single stratum within the stratifier. For example, when stratifying on administrative gender, there will be four strata, one for each possible gender value.
       */
      stratum?: components['schemas']['MeasureReportStratifierStratum'][] | null;
    };
    /**
     * MeasureReportStatus
     * @description The status of the measure report.
     *
     *     Used for ``MeasureReport.status`` (Required binding).
     *
     *     https://hl7.org/fhir/R4/valueset-measure-report-status.html
     * @enum {string}
     */
    MeasureReportStatus: MeasureReportStatus;
    /**
     * MeasureReportStratifierStratum
     * @description The results for a single stratum within a stratifier.
     *
     *     https://hl7.org/fhir/R4/measurereport-definitions.html#MeasureReport.group.stratifier.stratum
     */
    MeasureReportStratifierStratum: {
      /**
       * The stratum value
       * @description The value for this stratum, expressed as a CodeableConcept. When defining stratifiers on complex values, the value must be rendered such that the value for each stratum within the stratifier is unique.
       */
      value?: components['schemas']['CodeableConcept'] | null;
      /**
       * Stratifier component values
       * @description A stratifier component value.
       */
      component?: components['schemas']['MeasureReportStratumComponent'][] | null;
      /**
       * Populations in the stratum
       * @description The populations that make up the stratum, one for each type of population appropriate to the measure.
       */
      population?: components['schemas']['MeasureReportGroupPopulation'][] | null;
      /**
       * What score this stratum achieved
       * @description The measure score for this stratum, calculated as appropriate for the measure type and scoring method, and based on only the members of this stratum.
       */
      measureScore?: components['schemas']['Quantity'] | null;
    };
    /**
     * MeasureReportStratumComponent
     * @description A stratifier component value.
     *
     *     https://hl7.org/fhir/R4/measurereport-definitions.html#MeasureReport.group.stratifier.stratum.component
     */
    MeasureReportStratumComponent: {
      /**
       * What stratifier component of the group
       * @description The code for the stratum component value.
       */
      code: components['schemas']['CodeableConcept'];
      /**
       * The stratum component value
       * @description The stratum component value.
       */
      value: components['schemas']['CodeableConcept'];
    };
    /**
     * MeasureReportType
     * @description The type of the measure report.
     *
     *     Used for ``MeasureReport.type`` (Required binding).
     *
     *     https://hl7.org/fhir/R4/valueset-measure-report-type.html
     * @enum {string}
     */
    MeasureReportType: MeasureReportType;
    /**
     * MergeGroupMemberView
     * @description One stored membership row, snapshots as persisted plus live overlay.
     *
     *     Snapshot fields are returned exactly as stored — divergence between the
     *     snapshot and the live member is itself a diagnostic signal. ``live`` is
     *     null when the member's session document no longer exists.
     */
    MergeGroupMemberView: {
      /** Session Id */
      session_id: string;
      link_status: components['schemas']['SessionMergeStatus'];
      /** Created Time Local */
      created_time_local: string | null;
      /** Created At */
      created_at: string | null;
      /** Session Name */
      session_name: string | null;
      /** Session Gist */
      session_gist: string | null;
      live: components['schemas']['SessionMergeStateView'] | null;
    };
    /**
     * MergeGroupView
     * @description The group container's merge state and membership.
     */
    MergeGroupView: {
      /** Group Session Id */
      group_session_id: string;
      session_group_status: components['schemas']['SessionGroupStatus'];
      /** Last Synced At */
      last_synced_at: string | null;
      /** Is Stale */
      is_stale: boolean;
      /** Created Time Local */
      created_time_local: string | null;
      /** Duration */
      duration: number;
      /** Deleted At */
      deleted_at: string | null;
      /** Members */
      members: components['schemas']['MergeGroupMemberView'][];
    };
    /**
     * MigrationStatus
     * @description Migration status of a template section mapping.
     *
     *     Members:
     *         ready: The mapping is complete and usable.
     *         needs_headings: Section headings have not been extracted yet.
     *         needs_linking: Headings exist but are not linked to EHR section IDs.
     *         needs_engineering: Requires manual engineering intervention.
     * @enum {string}
     */
    MigrationStatus: MigrationStatus;
    /** OnboardingEmailSendResponse */
    OnboardingEmailSendResponse: {
      /** Success */
      success: boolean;
    };
    /** OnlineDataset */
    OnlineDataset: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: OnlineDatasetKind;
      policy: components['schemas']['SamplingPolicyDoc'];
      /** Max Items */
      max_items: number;
    };
    /**
     * OpenAPICreateSessionWorkflowRequest
     * @description Composite create-session request: ensure patient and session exist, linked.
     *
     *     Declarative "ensure" semantics: make this session exist for this patient.
     *     One flow, no branching: upsert patient (patient required) → resolve-or-create
     *     session (session optional) → link.
     *
     *     ``patient`` is required: the workflow endpoint is about ensuring a patient
     *     exists. A session-only call should use ``POST /open-api/sessions`` instead.
     *
     *     ``session`` is optional and all its fields are optional: omit it entirely
     *     or send an empty object for a session with no metadata overrides.
     *
     *     The request is rejected if ``created_time_local`` carries a UTC offset
     *     (tzinfo is not None) without a ``timezone`` field, or falls outside the
     *     accepted date window (it is a client-controlled sort key). Both rules are
     *     enforced via the shared helpers in ``sessions_schema.py`` so they cannot
     *     drift from the plain create-session schema; an unrecognized ``timezone``
     *     is rejected earlier still, by the field's ``TimeZones`` type.
     *
     *     Unknown fields are rejected at every level: both nested models forbid
     *     extras, and so does this root model — a typo like ``"sessions"`` must 422
     *     rather than silently dropping every session override onto the empty
     *     default.
     */
    OpenAPICreateSessionWorkflowRequest: {
      patient: components['schemas']['OpenAPIWorkflowPatientRequest'];
      session?: components['schemas']['OpenAPIWorkflowSessionRequest'];
    };
    /**
     * OpenAPICreateSessionWorkflowResponse
     * @description Response from the composite workflow endpoint.
     *
     *     ``session_id`` is always set.
     *
     *     ``patient_profile_id`` is nullable: present when the patient profile is linked
     *     to the session. For re-entered sessions that predate linking, this may be null.
     *
     *     ``patient_created`` is false when an existing profile was matched and
     *     refreshed; true when a new profile was created.
     *
     *     ``session_created`` is false when ``session.session_id`` matched an existing
     *     session; true when a new session was created. When false, the returned
     *     ``session_id`` is the matched session and no mutation occurred (template,
     *     timezone, and metadata remain unchanged from before the call).
     */
    OpenAPICreateSessionWorkflowResponse: {
      /** Session Id */
      session_id: string;
      /** Patient Profile Id */
      patient_profile_id: string | null;
      /** Patient Created */
      patient_created: boolean;
      /** Session Created */
      session_created: boolean;
    };
    /**
     * OpenAPIWorkflowPatientRequest
     * @description Patient demographic data for the composite workflow endpoint.
     *
     *     ``ehr_patient_id`` is required and the sole key for upsert: the workflow
     *     endpoint uses find-refresh-or-create semantics keyed on (managed_by,
     *     ehr_patient_id). A call without an EHR id has no key to deduplicate on,
     *     so requesting again would create a second profile — use ``POST /patient-profiles``
     *     instead, which is explicit about always inserting.
     *
     *     Demographics (name, birth date, gender, email, contact, demographic
     *     string) are optional and additive: a null/omitted value never clears a
     *     previously stored one, so partial payloads and manual edits survive a
     *     refresh. Additional context is preserved equally. Empty and
     *     whitespace-only strings carry no information either, so they are
     *     normalized to ``None`` at this boundary (see validator below) — an EHR
     *     with a blank name field must not blank a returning patient's stored name
     *     on every visit.
     *
     *     The provider (EHR system) is stamped from the OAuth token, not the request,
     *     so ``ehr_provider`` is never sent here.
     */
    OpenAPIWorkflowPatientRequest: {
      /**
       * Ehr Patient Id
       * @description Required: non-empty string uniquely identifying this patient in the EHR
       */
      ehr_patient_id: string;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Birth Date */
      birth_date?: string | null;
      gender?: components['schemas']['shared__enums__enums__Gender'] | null;
      /** Email */
      email?: string | null;
      /** Phone */
      phone?: string | null;
      /** Patient Sex Code */
      patient_sex_code?: number | null;
      /** Demographic String */
      demographic_string?: string | null;
      /** Additional Context */
      additional_context?: string | null;
    };
    /**
     * OpenAPIWorkflowSessionRequest
     * @description Session metadata for the composite workflow endpoint.
     *
     *     All fields are optional and additive. ``session_id`` is a Heidi session ID
     *     from a previous response: sending the same session_id re-enters an existing
     *     session (same ``session_id``, ``session_created=false``) without creating a
     *     second session. The session is returned unchanged; no mutation of template,
     *     timezone, or metadata occurs. The patient block still runs its upsert and
     *     demographics refresh as usual, but the returned session is not re-linked or
     *     re-patched. Omitting ``session_id`` is valid; every call creates a new
     *     session in that case.
     *
     *     A re-entry must name the same patient the session is linked to: pairing a
     *     ``session_id`` with a different patient's ``ehr_patient_id`` raises 400
     *     ``ErrSessionPatientMismatch`` instead of silently returning a session
     *     belonging to another chart (crossed wires must fail loudly — recording
     *     into it would misattribute the consult). Sessions with no stored patient
     *     link re-enter without this check; there is nothing to mismatch against.
     *
     *     A ``session_id`` the caller owns but has since deleted falls through to
     *     creating a new session (``session_created=true``), exactly as if no
     *     session_id had been sent. An unknown or not-owned ``session_id`` raises
     *     400 ``ErrSessionNotFound`` — identically in both cases, so the endpoint
     *     is not an existence oracle for other users' session ids.
     *
     *     ``ehr_appt_id`` is stored on the session. If
     *     ``ehr_patient_id`` is omitted, the workflow endpoint stamps it from the
     *     ``patient`` block so the session is discoverable via
     *     ``GET /open-api/sessions?ehr_patient_id=…`` without requiring the caller
     *     to repeat the id.
     *
     *     ``created_time_local`` is stored as a naive local wall-clock value. A
     *     tz-aware caller payload must carry a ``timezone`` field so the value can
     *     be converted and normalized; an offset without a timezone is rejected
     *     (see validator below).
     *
     *     ``timezone`` is typed as ``TimeZones``, so an unrecognized value is a 422
     *     here. ``POST /open-api/sessions`` takes it as a free string and tolerates
     *     an unparseable one by falling back to a user-level default — a partner
     *     typo there is silently answered with a session stamped in some other zone.
     *     This endpoint is unshipped, so it takes the stricter contract.
     *
     *     Template and language overrides are resolved identically to ``POST /open-api/sessions``
     *     (template ownership checks, language list normalization, etc.).
     */
    OpenAPIWorkflowSessionRequest: {
      /** Session Id */
      session_id?: string | null;
      /** Ehr Appt Id */
      ehr_appt_id?: string | null;
      timezone?: components['schemas']['TimeZones'] | null;
      /** Created Time Local */
      created_time_local?: string | null;
      language_code?: components['schemas']['LanguageCode'] | null;
      /** Language Code List */
      language_code_list?: components['schemas']['LanguageCode'][] | null;
      output_language_code?: components['schemas']['LanguageCode'] | null;
      /** Template Id */
      template_id?: string | 'AUTO_MODE' | null;
    };
    /**
     * OverallAssessment
     * @description Session-level NAATI CPI equivalence answer from the rubric header.
     *
     *     Maps to the spreadsheet answer cell (I6) next to the NAATI CPI question:
     *     ``Yes`` / ``No``. The full question text lives in the template at I5.
     * @enum {string}
     */
    OverallAssessment: OverallAssessment;
    /**
     * PatientFact
     * @description One self-contained clinical assertion, with the evidence supporting it.
     *
     *     The shape is R2's "every fact contains" list, minus the per-kind attributes
     *     noted in the module docstring. ``effective`` and ``value`` both carry R2's
     *     three-way distinction directly: a stated value, the explicit ``UNSPECIFIED``
     *     value when the kind requires one the source did not state, and absent when
     *     the kind requires none. R2 is emphatic that ``unspecified`` is "a distinct,
     *     named value in every schema and type definition" and never null or a missing
     *     key, which is why the middle case is spelled rather than folded into
     *     ``None``. Which kinds require a value is per-kind knowledge and arrives with
     *     the per-kind attributes.
     */
    PatientFact: {
      /** Fact Id */
      fact_id: string;
      kind: components['schemas']['FactKind'];
      subject?: components['schemas']['Subject'];
      concept: components['schemas']['ClinicalConcept'];
      assertion: components['schemas']['Assertion'];
      temporality: components['schemas']['Temporality'];
      /** Value */
      value?:
        | (
            | components['schemas']['QuantityValue']
            | components['schemas']['CodedValue']
            | components['schemas']['BooleanValue']
            | components['schemas']['DateValue']
            | components['schemas']['RangeValue']
            | components['schemas']['TextValue']
          )
        | 'unspecified'
        | null;
      /** Effective */
      effective?: components['schemas']['EffectivePeriod'] | 'unspecified' | null;
      /** Qualifiers */
      qualifiers?: {
        [key: string]: string;
      };
      /**
       * Relationships
       * @default []
       */
      relationships: components['schemas']['FactRelationship'][];
      source: components['schemas']['SourceRef'];
      /** Evidence */
      evidence: components['schemas']['EvidenceRef'][];
      asserter_role: components['schemas']['AsserterRole'];
      verification_state: components['schemas']['VerificationState'];
      /** @default active */
      record_state: components['schemas']['RecordState'];
      human_response?: components['schemas']['HumanResponseRef'] | null;
    };
    /**
     * PendingWritebackSection
     * @description One note section to write as its own FHIR resource.
     *
     *     The desktop resolves the ``section_id`` to the resource type + profile
     *     (e.g. T2med: ``anamnese``/``befund``/``freitext`` → Observation,
     *     ``therapie`` → Procedure); this payload is purely the data.
     */
    PendingWritebackSection: {
      /**
       * Section Id
       * @description Standardized section id (``SectionalNoteSection`` value) the user mapped this content to.
       */
      section_id: string;
      /**
       * Text
       * @description Plain-text content for the section. Multiple note headings mapped to the same section are already concatenated.
       */
      text: string;
      /**
       * Prior Fhir Id
       * @description FHIR resource id ACKed by a previous write of this section, if any. Present when the item was re-queued after an edit — the EHR-side copy is stale (T2med resources are create-only, so a re-write creates a new entry).
       */
      prior_fhir_id?: string | null;
    };
    /**
     * PrechartBySessionItem
     * @description One Prechart row reached from a Heidi session id.
     *
     *     ``adk_session_id`` is the Vertex AI Agent Engine session, i.e. the run whose raw
     *     EHR dump and per-stage output are visible in the GCP console Sessions tab.
     *     ``adk_session_ids`` holds every run for this row, so a regeneration is visible.
     */
    PrechartBySessionItem: {
      /** Prechart Id */
      prechart_id: string;
      /** Adk Session Id */
      adk_session_id?: string | null;
      /** Adk Session Ids */
      adk_session_ids?: string[];
      /** Prechart Status */
      prechart_status: string;
      /** Ehr Provider */
      ehr_provider: string;
      /** Clinic Id */
      clinic_id: string;
      /** Department Id */
      department_id: string;
      /** Provider Id */
      provider_id: string;
      /** Patient Id */
      patient_id: string;
      /** Appointment Id */
      appointment_id: string;
      /** Template Id */
      template_id?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Completed At */
      completed_at?: string | null;
    };
    /**
     * PrechartBySessionResponse
     * @description Debug lookup: Heidi session id in, pre-chart runs out.
     *
     *     The echoed fields make an empty ``precharts`` list diagnosable instead of merely
     *     empty: ``resolved_appointment_id`` tells you whether hop one (session to
     *     appointment) or hop two (appointment to pre-chart) is what failed.
     */
    PrechartBySessionResponse: {
      /** Session Id */
      session_id: string;
      /** Resolved Appointment Id */
      resolved_appointment_id?: string | null;
      /** Kinde Gp Id */
      kinde_gp_id?: string | null;
      /** Precharts */
      precharts?: components['schemas']['PrechartBySessionItem'][];
    };
    /**
     * PreviewRequest
     * @description Request body for POST /{template_id}/preview.
     *
     *     The ``structure_template`` is the **draft** body the client wants to
     *     recompute against — the inline source of truth for this preview call.
     *     The stored ``CustomTemplate`` is loaded only to establish existence /
     *     tenancy and to read the stored ``content_hash``; its body is NOT
     *     parsed.  ``mappings`` are the draft mappings the client wants to test
     *     — they are NOT flushed to the mapping sidecar.
     */
    PreviewRequest: {
      /**
       * Structure Template
       * @description Inline draft markdown body — the source of truth for this preview
       */
      structure_template: string;
      /**
       * Mappings
       * @description Draft section-heading → EHR-section-id mappings to test
       */
      mappings?: components['schemas']['TemplateMappingSchema'][];
    };
    /**
     * PreviewResponse
     * @description Response for POST /{template_id}/preview.
     *
     *     Contains the recomputed sections + status from the draft body, the
     *     STORED ``content_hash`` (not a hash of the draft), and the echoed
     *     draft mappings.
     *
     *     Readiness is carried by ``status`` alone (``ready`` == every parsed
     *     section resolves to a valid EHR destination); per-heading detail is
     *     carried by ``sections[].destination_name``.
     */
    PreviewResponse: {
      /**
       * Sections
       * @description Recomputed parsed and non-parsed sections from the draft body
       */
      sections?: components['schemas']['InspectorSectionResponse'][];
      /** @description Recomputed four-state migration status */
      status: components['schemas']['MigrationStatus'];
      /**
       * Has Lookalike Blocks
       * @description True when ≥1 recomputed section is a heading look-alike. Advisory — it does not affect the recomputed status
       * @default false
       */
      has_lookalike_blocks: boolean;
      /**
       * Mappings
       * @description Draft mappings echoed back unchanged
       */
      mappings?: components['schemas']['TemplateMappingSchema'][];
      /**
       * Content Hash
       * @description SHA-256 hex of the STORED structure_template (64 chars) — NOT a hash of the draft body
       */
      content_hash: string;
    };
    /**
     * ProjectSourceCitation
     * @description A verified source citation emitted by ``render_sources``.
     */
    ProjectSourceCitation: {
      /** Marker */
      marker: number;
      /**
       * Kind
       * @enum {string}
       */
      kind: ProjectSourceCitationKind;
      /** Label */
      label: string;
      /** Quote */
      quote: string;
      /** Session Id */
      session_id: string;
    };
    /**
     * Purpose
     * @description R1's V1 consumer purposes, and only those.
     *
     *     MS1 enables ``CLINICAL_NUDGE`` and MS2 validates the other two. All three
     *     are accepted here: which are *enabled* is a deployment question, and
     *     refusing a declared V1 purpose because a milestone has not landed would be
     *     a rule R1 does not state.
     * @enum {string}
     */
    Purpose: Purpose;
    /**
     * Qualifier
     * @description The clinically meaningful qualifiers R2 requires a fact to retain.
     *
     *     Keys are closed because R2 names them; values stay strings because R2 fixes
     *     the names and not their value types, and typing them individually needs a
     *     per-qualifier terminology decision that has not been taken. A structured key
     *     is what stops a qualifier being flattened into display text.
     * @enum {string}
     */
    Qualifier: Qualifier;
    /**
     * QuantityValue
     * @description A number, the unit that gives it meaning, and whether it is a bound.
     *
     *     ``unit`` is required, and that is the whole point of this class. R2 requires
     *     ``lab_or_vital`` to carry a "typed result (numeric or coded qualitative)",
     *     and a number whose scale is unstated is not a typed result — it is a value
     *     that reads correctly to a consumer holding the wrong scale. Optional-with-a-
     *     validator would express the same rule, and is rejected: the field being
     *     required is what makes the omission unrepresentable rather than merely
     *     caught, so no future construction path can reintroduce it.
     *
     *     **Required does not mean known.** ``FactUnit`` admits three answers and one
     *     of them is ``UNSPECIFIED``, for US Core's real and common case of a
     *     quantity with no unit at all — its own guidance publishes ``{"value":
     *     26.0}`` for it. Recording that with the unit explicitly marked unknown keeps
     *     the number the source did give while making the gap something a consumer can
     *     see and refuse. What stays unrepresentable is the *unmarked* absence, which
     *     is the actual defect: a silent one reads as whatever scale the reader
     *     assumes, and a marked one cannot.
     *
     *     ``comparator`` is absent when the number is the measurement. Present, it
     *     says the true value lies beyond the number — the ``<0.01`` a lab reports
     *     when it could not resolve lower.
     */
    QuantityValue: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: QuantityValueType;
      /** Number */
      number: number | string;
      /** Unit */
      unit:
        | components['schemas']['UcumUnit']
        | components['schemas']['UnitAsStated']
        | 'unspecified';
      comparator?: components['schemas']['Comparator'] | null;
    };
    /**
     * QueueItemResponse
     * @description One row in the queue/search response — a template with computed status.
     */
    QueueItemResponse: {
      /**
       * Template Id
       * @description CustomTemplate ObjectId as string
       */
      template_id: string;
      /**
       * Template Name
       * @description Template display name
       */
      template_name: string;
      /**
       * Workspace Id
       * @description Workspace ObjectId as string. Always populated in practice — workspace-less rows are excluded from the queue. Display only; not searchable (no leading workspace_id index).
       * @default
       */
      workspace_id: string;
      /**
       * Kinde User Id
       * @description Owner kinde user id. Searchable via exact equality.
       * @default
       */
      kinde_user_id: string;
      /**
       * Customer Name
       * @description Best-effort customer/org name for display (empty when unavailable). Not searchable.
       * @default
       */
      customer_name: string;
      /**
       * Workspace Name
       * @description Best-effort workspace name for display (empty when unavailable). Not searchable.
       * @default
       */
      workspace_name: string;
      /**
       * Clinician Email
       * @description Clinician email (best-effort, empty when unavailable). Searchable via exact equality on user.email_1.
       * @default
       */
      clinician_email: string;
      /** @description Page-local computed four-state migration status */
      status: components['schemas']['MigrationStatus'];
      /**
       * Has Lookalike Blocks
       * @description True when the template contains ≥1 heading look-alike block. Advisory badge only — it does not affect status
       * @default false
       */
      has_lookalike_blocks: boolean;
      /**
       * Updated At
       * @description Template updated_time (nullable for legacy rows)
       */
      updated_at?: string | null;
    };
    /**
     * QueueListResponse
     * @description Paginated queue/search response over a cohort, or the whole cell when
     *     no owner ids are supplied.
     */
    QueueListResponse: {
      /** Items */
      items?: components['schemas']['QueueItemResponse'][];
      /**
       * Total
       * @description Count of templates matching cohort and search in Mongo, pre-pagination. Does not reflect the page-local ?status= filter.
       */
      total: number;
      /**
       * Page
       * @description Current 1-indexed page number
       */
      page: number;
      /**
       * Pagesize
       * @description Requested page size
       */
      pageSize: number;
    };
    /**
     * RadioState
     * @description Select this option; the platform deselects siblings, so no value.
     */
    RadioState: {
      selector: components['schemas']['AxSelector'];
    };
    /**
     * RadioTarget
     * @description One selector per option, one group identity — selecting an option
     *     deselects its siblings, and a conflict is only detectable if the group
     *     token is stored.
     */
    RadioTarget: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: RadioTargetKind;
      /** Groupid */
      groupId: string;
      /** States */
      states: {
        [key: string]: components['schemas']['RadioState'];
      };
    };
    /**
     * RangeValue
     * @description A bounded interval, with a unit on each bound.
     *
     *     Bounds are ``QuantityValue`` rather than bare numbers so the unit rule is
     *     inherited rather than restated — there is no second place for it to be
     *     forgotten. They must agree on the unit: a range whose ends are in different
     *     scales is not wide, it is meaningless, and it is the failure this whole
     *     model exists to prevent wearing a different hat.
     *
     *     One bound may be open, as with an effective period, because "under 5" is a
     *     stated result. Both being absent would leave a range asserting nothing.
     *
     *     A bound may not carry a comparator. A range already says where the value
     *     stops, so a comparator on a bound is a second way to say the same thing and
     *     the two can disagree — a low of ``>4`` on a range starting at 4 is either
     *     redundant or a contradiction, and nothing downstream could tell which was
     *     meant. "Under 0.01" is a range with an open low bound, not a high bound
     *     wearing a ``<``.
     */
    RangeValue: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: RangeValueType;
      low?: components['schemas']['QuantityValue'] | null;
      high?: components['schemas']['QuantityValue'] | null;
    };
    /** RecordCancellationIntentRequest */
    RecordCancellationIntentRequest: {
      reason: components['schemas']['CancellationReason'];
      /** Flow Id */
      flow_id: string;
      /** Stripe Subscription Id */
      stripe_subscription_id: string;
      /** Other Reason Detail */
      other_reason_detail?: string | null;
    };
    /** RecordCancellationIntentResponse */
    RecordCancellationIntentResponse: {
      offer_type: components['schemas']['CancellationOfferType'];
      /** Discount Eligible */
      discount_eligible: boolean;
      /**
       * Product Type
       * @enum {string}
       */
      product_type: RecordCancellationIntentResponseProduct_type;
    };
    /**
     * RecordState
     * @description Whether the fact is current. R3 keeps only current facts indefinitely.
     * @enum {string}
     */
    RecordState: RecordState;
    /**
     * RegistryLookupOutcome
     * @description What a registry lookup found.
     *
     *     Reported on a preview so the user can decide whether the record is theirs;
     *     never persisted as a record's state. Not-found and deactivated live here
     *     rather than on ``HcpVerificationStatus`` because neither can be confirmed,
     *     so nothing would ever write them into a record.
     * @enum {string}
     */
    RegistryLookupOutcome: RegistryLookupOutcome;
    /**
     * RelationshipType
     * @description Relationships R2 names as identifiers.
     *
     *     Only ``INDICATION_FOR`` is named in the spec. R2 also requires causal and
     *     manifestation relationships to be retained but gives them no identifier and
     *     does not fix their direction, so they are an open question rather than an
     *     invented member.
     * @enum {string}
     */
    RelationshipType: RelationshipType;
    /** ReportCibaRequest */
    ReportCibaRequest: {
      /** Auth Req Id */
      auth_req_id?: string | null;
    };
    RequestHcpReviewRequest: {
      /** @description Why review is needed. Only NO_IDENTIFIER, NOT_FOUND and DEACTIVATED may be requested; IDENTIFIER_ALREADY_CLAIMED is assigned by the system. */
      reason: components['schemas']['ReviewReason'];
      /**
       * Identifier
       * @description The registry identifier the review concerns, or an alternative credential when no identifier is held.
       */
      identifier?: string | null;
      /** @description Registry the review concerns. Omit to use the one that applies to your account. */
      registry?: components['schemas']['VerificationRegistry'] | null;
      /**
       * Approval Justification
       * @description Written case for approval when no registry identifier is held.
       */
      approval_justification?: string | null;
    };
    /** RequestHeidi2AccessRequest */
    RequestHeidi2AccessRequest: {
      /** Message */
      message?: string | null;
    };
    /**
     * RequestHeidi2AccessResponse
     * @description Result of notifying workspace admins of a Heidi 2.0 access request.
     */
    RequestHeidi2AccessResponse: {
      /**
       * Adminnotificationssent
       * @description Number of workspace admins emailed successfully. Zero on a repeat request.
       */
      adminNotificationsSent: number;
    };
    /**
     * RequestIntent
     * @description Whether the request is a proposal, plan, an original order or a reflex order.
     *
     *     Used for ``ServiceRequest.intent`` (Required binding).
     *
     *     https://hl7.org/fhir/R4/valueset-request-intent.html
     * @enum {string}
     */
    RequestIntent: RequestIntent;
    /**
     * RequestStatus
     * @description Codes identifying the lifecycle stage of a request.
     *
     *     Used for ``ServiceRequest.status`` (Required binding).
     *
     *     https://hl7.org/fhir/R4/valueset-request-status.html
     * @enum {string}
     */
    RequestStatus: RequestStatus;
    /** ResourceImportResult */
    ResourceImportResult: {
      /** Resource */
      resource: string;
      /** Locales */
      locales: components['schemas']['LocaleImportResult'][];
    };
    /**
     * ResyncRateCardRequest
     * @description Move a contract onto a card's latest active version, server-chosen.
     *
     *     Omit `rate_card_key` to stay on the card the contract already names; supply
     *     one to cross to another card at *its* latest. There is no version field by
     *     design — naming a version is what `UpdateContractRequest` is for, and the
     *     whole point of this gesture is that the caller does not have to look one up.
     */
    ResyncRateCardRequest: {
      /** Rate Card Key */
      rate_card_key?: string | null;
    };
    /** RetentionLineageCampaignListResponse */
    RetentionLineageCampaignListResponse: {
      /** Items */
      items: components['schemas']['RetentionLineageCampaignMonitoringResponse'][];
      /** Total */
      total: number;
      /** Offset */
      offset: number;
      /** Limit */
      limit: number;
    };
    /** RetentionLineageCampaignMonitoringResponse */
    RetentionLineageCampaignMonitoringResponse: {
      /** Campaign Id */
      campaign_id: string;
      operation: components['schemas']['EvidenceChatLineageCampaignOperation'];
      /** Dry Run */
      dry_run: boolean;
      /** Orchestration Key */
      orchestration_key: string | null;
      phase: components['schemas']['EvidenceChatLineageCampaignPhase'] | null;
      /** Predecessor Campaign Id */
      predecessor_campaign_id: string | null;
      /** Snapshot Upper Id */
      snapshot_upper_id: string | null;
      /** After Id */
      after_id: string | null;
      status: components['schemas']['EvidenceChatLineageCampaignStatus'];
      /** Has More */
      has_more: boolean;
      /** Scan Complete */
      scan_complete: boolean;
      /** Counters */
      counters: {
        [key: string]: number;
      };
      /** Version */
      version: number;
      /** Requires Post Write Audit */
      requires_post_write_audit: boolean;
      /** Recoverable Complete */
      recoverable_complete: number | null;
      /** Recoverable Remaining */
      recoverable_remaining: number | null;
      /** Recoverable Completion Percent */
      recoverable_completion_percent: number | null;
      /** Converged */
      converged: boolean | null;
      /** Legacy Unknown Requires Disposition */
      legacy_unknown_requires_disposition: boolean | null;
      /** Ready For Phi Deletion */
      ready_for_phi_deletion: boolean | null;
      /** Error Message */
      error_message: string | null;
      /** Lease Expires At */
      lease_expires_at: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Completed At */
      completed_at: string | null;
    };
    /** RetentionLineageCampaignResponse */
    RetentionLineageCampaignResponse: {
      /** Campaign Id */
      campaign_id: string;
      operation: components['schemas']['EvidenceChatLineageCampaignOperation'];
      /** Dry Run */
      dry_run: boolean;
      /** Orchestration Key */
      orchestration_key: string | null;
      phase: components['schemas']['EvidenceChatLineageCampaignPhase'] | null;
      /** Predecessor Campaign Id */
      predecessor_campaign_id: string | null;
      /** Snapshot Upper Id */
      snapshot_upper_id: string | null;
      /** After Id */
      after_id: string | null;
      status: components['schemas']['EvidenceChatLineageCampaignStatus'];
      /** Has More */
      has_more: boolean;
      /** Scan Complete */
      scan_complete: boolean;
      /** Counters */
      counters: {
        [key: string]: number;
      };
      /** Version */
      version: number;
      /** Requires Post Write Audit */
      requires_post_write_audit: boolean;
      /** Recoverable Complete */
      recoverable_complete: number | null;
      /** Recoverable Remaining */
      recoverable_remaining: number | null;
      /** Recoverable Completion Percent */
      recoverable_completion_percent: number | null;
      /** Converged */
      converged: boolean | null;
      /** Legacy Unknown Requires Disposition */
      legacy_unknown_requires_disposition: boolean | null;
      /** Ready For Phi Deletion */
      ready_for_phi_deletion: boolean | null;
      /** Error Message */
      error_message: string | null;
      /** Lease Expires At */
      lease_expires_at: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Completed At */
      completed_at: string | null;
    };
    /** RetryFailedUnitsRequest */
    RetryFailedUnitsRequest: {
      /**
       * Job Ref Id
       * @description The batch job whose failed and never-ran units are re-run. Omitted, the newest run the experiment has recorded is used. Either way it is checked against the experiment in the path before anything re-runs.
       */
      job_ref_id?: string | null;
    };
    /** RetryFailedUnitsResponse */
    RetryFailedUnitsResponse: {
      /** Experiment Id */
      experiment_id: string;
      /** Parent Job Ref Id */
      parent_job_ref_id: string;
      /** Retry Job Ref Id */
      retry_job_ref_id: string;
    };
    /**
     * RevertRequest
     * @description Request body for POST /{template_id}/revert.
     */
    RevertRequest: {
      /**
       * Snapshot Id
       * @description The ObjectId of the applied snapshot to revert from.
       */
      snapshot_id: string;
      /**
       * Attempt Id
       * @description Client-generated UUID for idempotency.  Covered by the snapshot attempt_id unique index — replaying the same attempt_id returns 409 duplicate_attempt_id rather than reverting twice.  A retry after a failed attempt must use a fresh attempt_id.
       */
      attempt_id: string;
    };
    /**
     * RevertResponse
     * @description Response for POST /{template_id}/revert.
     *
     *     Contains ``reverted: true``, the ``revert_snapshot_id`` (a new snapshot
     *     recording the revert for audit trail), ``reverted_at`` (ISO timestamp),
     *     and ``audit_event_id`` (the enterprise audit log entry ID).
     */
    RevertResponse: {
      /**
       * Reverted
       * @description True when the revert succeeded
       */
      reverted: boolean;
      /**
       * Revert Snapshot Id
       * @description ObjectId of the new revert-snapshot record (audit trail)
       */
      revert_snapshot_id: string;
      /**
       * Reverted At
       * Format: date-time
       * @description ISO timestamp of the revert
       */
      reverted_at: string;
      /**
       * Audit Event Id
       * @description Enterprise audit log entry ID for the revert event
       */
      audit_event_id: string;
    };
    /** RpaRecordingCompletedPart */
    /**
     * ReviewReason
     * @description Why a ``NEEDS_REVIEW`` record was raised; ``None`` on a verified one.
     * @enum {string}
     */
    ReviewReason: ReviewReason;
    RpaRecordingCompletedPart: {
      /** Part Number */
      part_number: number;
      /** Etag */
      etag: string;
    };
    /** RpaRecordingPartUploadUrl */
    RpaRecordingPartUploadUrl: {
      /** Part Number */
      part_number: number;
      /** Url */
      url: string;
    };
    /** RpaRecordingPartUploadUrls */
    RpaRecordingPartUploadUrls: {
      /** Upload Id */
      upload_id: string;
      /** Parts */
      parts: components['schemas']['RpaRecordingPartUploadUrl'][];
    };
    /** RpaRecordingPartUrlsRequest */
    RpaRecordingPartUrlsRequest: {
      /** Part Numbers */
      part_numbers: number[];
    };
    /** RpaRecordingUploadInitiated */
    RpaRecordingUploadInitiated: {
      /** Upload Id */
      upload_id: string;
      /** Part Size Bytes */
      part_size_bytes: number;
      /** Part Count */
      part_count: number;
      /** Parts */
      parts: components['schemas']['RpaRecordingPartUploadUrl'][];
    };
    /**
     * RunAgentEvalRoutineBindingRequest
     * @description One routine (Heidi Work workflow) to measure, as a suite binding.
     *
     *     No version pin, because a routine has no versions: it is resolved at
     *     request time and frozen into the experiment.
     */
    RunAgentEvalRoutineBindingRequest: {
      /** Workflow Id */
      workflow_id: string;
      run_overrides?: components['schemas']['RunOverrides'] | null;
    };
    /**
     * RunAgentEvalSuiteBindingRequest
     * @description One saved agent config to measure, in place of a suite's own binding.
     */
    RunAgentEvalSuiteBindingRequest: {
      /** Config Id */
      config_id: string;
      /**
       * Version
       * @description The saved config version to measure. Required — this surface resolves no 'latest', because a binding that can move under a running experiment cannot be read back against what it measured.
       */
      version: number;
      run_overrides?: components['schemas']['RunOverrides'] | null;
    };
    /**
     * RunAgentEvalSuiteRequest
     * @description Who answers the suite's cases, when it should not be its coded agents.
     *
     *     Omitted or empty runs the suite exactly as authored. Its cases, scorers and
     *     trials are its own either way — only the agents under test move, which is
     *     what keeps a data-bound experiment comparable with the coded one.
     *
     *     ``bindings`` and ``routines`` may be combined; a binding index is a
     *     position in that concatenation, in that order.
     */
    RunAgentEvalSuiteRequest: {
      /**
       * Bindings
       * @default []
       */
      bindings: components['schemas']['RunAgentEvalSuiteBindingRequest'][];
      /**
       * Routines
       * @default []
       */
      routines: components['schemas']['RunAgentEvalRoutineBindingRequest'][];
    };
    /**
     * RunAgentEvalSuiteResponse
     * @description The two handles a started experiment leaves the operator with.
     *
     *     ``job_ref_id`` resolves only if this trigger started its own batch run; a
     *     trigger that coalesced into a job already running for the same experiment
     *     never gets a job document. ``experiment_id`` is the durable handle.
     */
    RunAgentEvalSuiteResponse: {
      /** Experiment Id */
      experiment_id: string;
      /** Job Ref Id */
      job_ref_id: string;
      /** Suite Name */
      suite_name: string;
    };
    /**
     * RunBurnRequest
     * @description Which window a manually-triggered metered burn should sweep.
     *
     *     The fields, the bounds and the both-or-neither rule come from the shared
     *     request, so the on-demand trigger and the schedule cannot disagree about what
     *     a window means. One thing is specific to running it over HTTP: an explicit
     *     range is capped by SPAN, not by recency. The sweep runs
     *     synchronously inside the request, so an unbounded range outlives the gateway;
     *     but capping how far BACK it may reach would defeat the catch-up this mode
     *     exists for, since a backdated contract can cover usage of any age. Bounding
     *     the span keeps `[60 days ago, 59 days ago]` perfectly legal while stopping a
     *     single request from sweeping all history — and a genuinely long catch-up
     *     is better split into several requests, or run outside the request path.
     */
    RunBurnRequest: {
      /**
       * Window Hours
       * @default 48
       */
      window_hours: number;
      /** Window Start */
      window_start?: string | null;
      /** Window End */
      window_end?: string | null;
    };
    /**
     * RunBurnResponse
     * @description What one run did.
     *
     *     `skipped` is keyed by reason, and a skip is a NORMAL outcome: most events in
     *     any window belong to workspaces with no wallet or no contract. Read it
     *     alongside `events_burned` rather than as a failure count.
     */
    RunBurnResponse: {
      /** Window Start */
      window_start: string | null;
      /** Window End */
      window_end: string | null;
      /** Events Scanned */
      events_scanned: number;
      /** Events Burned */
      events_burned: number;
      /** Events Failed */
      events_failed: number;
      /** Credits Burned */
      credits_burned: {
        [key: string]: number | string;
      };
      /** Skipped */
      skipped: {
        [key: string]: number;
      };
    };
    /**
     * RunOverrides
     * @description Per-binding workflow tuning, whitelisted field by field.
     *
     *     ``close_after_initial_turn`` is deliberately not overridable: close-mode
     *     follows from whether the case scripts follow-up turns, so the runner
     *     owns it and a binding must not be able to contradict it.
     *
     *     Every field here is a positive bound, hence ``gt=0``: a zero or negative
     *     budget does not tune a run, it makes one that cannot finish.
     */
    RunOverrides: {
      /** Turn Activity Timeout Seconds */
      turn_activity_timeout_seconds?: number | null;
      /** Llm Start To Close Timeout Seconds */
      llm_start_to_close_timeout_seconds?: number | null;
      /** Max Tool Iterations */
      max_tool_iterations?: number | null;
    };
    /** SamplingPolicyDoc */
    SamplingPolicyDoc: {
      /** Workflow Ids Include */
      workflow_ids_include?: string[] | null;
      /**
       * Workflow Ids Exclude
       * @default []
       */
      workflow_ids_exclude: string[];
      /**
       * Include Normal Chats
       * @default false
       */
      include_normal_chats: boolean;
      /** Organization Ids */
      organization_ids?: string[] | null;
      /** Team Ids */
      team_ids?: string[] | null;
      /** Subject User Ids */
      subject_user_ids?: string[] | null;
      /** Agent Run Ids */
      agent_run_ids?: string[] | null;
      /** Sample Ratio */
      sample_ratio: number;
    };
    /** SavedDataset */
    SavedDataset: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      kind: SavedDatasetKind;
      /** Dataset Id */
      dataset_id: string;
    };
    /** SavedEvalSuiteResponse */
    SavedEvalSuiteResponse: {
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      /** Bundle Name */
      bundle_name: string;
      /** Scorer Subset */
      scorer_subset?: string[] | null;
      /** Data */
      data:
        | components['schemas']['CodeDefinedDataset']
        | components['schemas']['SavedDataset']
        | components['schemas']['OnlineDataset'];
      /**
       * Ad Hoc
       * @default false
       */
      ad_hoc: boolean;
      /** Suite Id */
      suite_id: string;
      /** Enabled */
      enabled: boolean;
      /** Version */
      version: number;
      /** Job Ref Ids */
      job_ref_ids: string[];
      /** Created By */
      created_by: string;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** SavedEvalSuiteScoreResponse */
    SavedEvalSuiteScoreResponse: {
      /** Suite Id */
      suite_id: string;
      /** Suite Version */
      suite_version: number;
      /** Sampling Fingerprint */
      sampling_fingerprint: string;
      /** Dataset Id */
      dataset_id: string;
      /** Pass Id */
      pass_id: string;
      /** Bundle Name */
      bundle_name: string;
      /** Bundle Fingerprint */
      bundle_fingerprint: string;
      /** Agent Run Id */
      agent_run_id: string;
      /** Workflow Id */
      workflow_id: string | null;
      /** Subject User Id */
      subject_user_id: string;
      /** Actor User Id */
      actor_user_id: string;
      /** Workspace Id */
      workspace_id: string | null;
      /** Organization Id */
      organization_id: string | null;
      /** Team Id */
      team_id: string | null;
      /** Scored Turn Count */
      scored_turn_count: number;
      /** Run Created At */
      run_created_at: string | null;
      /**
       * Run Activity At
       * Format: date-time
       */
      run_activity_at: string;
      /** Code Version */
      code_version: string;
      /**
       * Scored At
       * Format: date-time
       */
      scored_at: string;
      score_set: components['schemas']['ScoreSetDoc'];
    };
    /** SavedEvalSuiteSummaryPoint */
    SavedEvalSuiteSummaryPoint: {
      /** Scorer Name */
      scorer_name: string;
      /** Dataset Id */
      dataset_id: string;
      /** Sampling Fingerprint */
      sampling_fingerprint: string;
      /** Bundle Fingerprint */
      bundle_fingerprint: string;
      /** Window From */
      window_from: string | null;
      /** Window To */
      window_to: string | null;
      /** Mean Value */
      mean_value: number | null;
      /** Scored */
      scored: number;
      /** Not Applicable */
      not_applicable: number;
      /** Error */
      error: number;
      /** Missing Reference */
      missing_reference: number;
    };
    /** SavedEvalSuiteSummaryResponse */
    SavedEvalSuiteSummaryResponse: {
      /** Suite Id */
      suite_id: string;
      /** Points */
      points: components['schemas']['SavedEvalSuiteSummaryPoint'][];
    };
    /**
     * ScenarioAction
     * @enum {string}
     */
    ScenarioAction: ScenarioAction;
    /**
     * ScenarioLifecycleStatus
     * @enum {string}
     */
    ScenarioLifecycleStatus: ScenarioLifecycleStatus;
    /** ScoreDoc */
    ScoreDoc: {
      /** Scorer Name */
      scorer_name: string;
      /** Scorer Version */
      scorer_version: string;
      /**
       * Outcome
       * @enum {string}
       */
      outcome: ScoreDocOutcome;
      /** Value */
      value?: number | boolean | null;
      /**
       * Evidence
       * @default []
       */
      evidence: components['schemas']['SpanRefDoc'][];
      /** Error */
      error?: string | null;
      /** Reason */
      reason?: string | null;
      judge_pin?: components['schemas']['JudgePinDoc'] | null;
    };
    /** ScoreSavedEvalSuiteResponse */
    ScoreSavedEvalSuiteResponse: {
      /** Suite Id */
      suite_id: string;
      /** Dataset Id */
      dataset_id: string;
      /** Job Ref Id */
      job_ref_id: string;
    };
    /** ScoreSetDoc */
    ScoreSetDoc: {
      /** Scores */
      scores: components['schemas']['ScoreDoc'][];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
    };
    /**
     * ScriptClassification
     * @description Operator-facing blast-radius label for a management script.
     */
    ScriptClassification: {
      /**
       * Scope
       * @enum {string}
       */
      scope: ScriptClassificationScope;
      /**
       * Description
       * @description One-line plain-language summary of what the script touches
       */
      description: string;
    };
    /** SearchResponse[MeasureReport] */
    SearchResponse_MeasureReport_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_MeasureReport_'][];
    };
    /** SearchResponse[ServiceRequest] */
    SearchResponse_ServiceRequest_: {
      /**
       * Resourcetype
       * @default Bundle
       * @constant
       */
      resourceType: 'Bundle';
      /**
       * Type
       * @default searchset
       * @constant
       */
      type: 'searchset';
      /** Entry */
      entry: components['schemas']['Entry_ServiceRequest_'][];
    };
    /**
     * SeatSummaryResponse
     * @description A team's paid seat capacity, partitioned by occupancy.
     *
     *     ``used``, ``pending`` and ``available`` partition ``total``. Unfunded and
     *     removed seats are excluded, matching ``SeatSummary`` — whose definitions the
     *     seat-limit 409's ``SeatInfo`` also mirrors, so the widget and the error
     *     cannot disagree.
     */
    SeatSummaryResponse: {
      /**
       * Total
       * @description Paid seats on the team's plan.
       */
      total: number;
      /**
       * Used
       * @description Seats occupied by a team member.
       */
      used: number;
      /**
       * Available
       * @description Seats free to claim right now.
       */
      available: number;
      /**
       * Pending
       * @description Seats held by an outstanding invitation.
       */
      pending: number;
      /**
       * At Capacity
       * @description Whether the next invite or role promotion will be rejected by seat capacity. False when seat management is not configured; otherwise true when available is 0, including when the whole shortfall is seats held by pending invitations rather than members.
       */
      at_capacity: boolean;
    };
    /**
     * SectionDestination
     * @description One parsed heading with its optional linked EHR section id.
     *
     *     Fields use the same wire names as the join response mappings:
     *     ``section_heading`` and ``linked_ehr_section_id`` (NOT ``ehr_section_id``).
     */
    SectionDestination: {
      /**
       * Section Heading
       * @description Parsed H1 heading text (normalized)
       */
      section_heading: string;
      /**
       * Linked Ehr Section Id
       * @description EHR section id from the mapping join, or None when unmapped
       */
      linked_ehr_section_id?: string | null;
    };
    /**
     * ServiceRequest
     * @description A record of a request for service such as diagnostic investigations, treatments, or operations to be performed.
     *
     *     https://hl7.org/fhir/R4/servicerequest-definitions.html
     */
    ServiceRequest: {
      /**
       * Resource type
       * @description The logical name of this resource as used in FHIR (JSON element resourceType). Coerced to the concrete class name via get_name().
       * @default
       */
      resourceType: string;
      /**
       * Logical id of this artifact
       * @description The logical id of the resource, as used in the URL for the resource. Once assigned, this value never changes.
       */
      id?: string | null;
      /**
       * Metadata about the resource
       * @description The metadata about the resource. This is content that is maintained by the infrastructure. Changes to the content might not always be associated with version changes to the resource.
       */
      meta?: components['schemas']['Meta'] | null;
      /**
       * A set of rules under which this content was created
       * @description A reference to a set of rules that were followed when the resource was constructed, and which must be understood when processing the content. Often, this is a reference to an implementation guide that defines the special rules along with other profiles etc.
       */
      implicitRules?: string | null;
      /**
       * Language of the resource content
       * @description The base language in which the resource is written.
       */
      language?: string | null;
      /**
       * Text summary of the resource, for human interpretation
       * @description A human-readable narrative that contains a summary of the resource and can be used to represent the content of the resource to a human. The narrative need not encode all the structured data, but is required to contain sufficient detail to make it "clinically safe" for a human to just read the narrative.
       */
      text?: components['schemas']['Narrative'] | null;
      /**
       * Contained, inline Resources
       * @description These resources do not have an independent existence apart from the resource that contains them - they cannot be identified independently, and nor can they have their own independent transaction scope.
       */
      contained?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Additional content defined by implementations
       * @description May be used to represent additional information that is not part of the basic definition of the resource. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer can define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension.
       */
      extension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Extensions that cannot be ignored
       * @description May be used to represent additional information that is not part of the basic definition of the resource and that modifies the understanding of the element that contains it and/or the understanding of the containing element's descendants. Usually modifier elements provide negation or qualification. To make the use of extensions safe and manageable, there is a strict set of governance applied to the definition and use of extensions. Though any implementer is allowed to define an extension, there is a set of requirements that SHALL be met as part of the definition of the extension. Applications processing a resource are required to check for modifier extensions.
       */
      modifierExtension?:
        | {
            [key: string]: unknown;
          }[]
        | null;
      /**
       * Identifiers assigned to this order
       * @description Identifiers assigned to this order instance by the orderer and/or the receiver and/or order fulfiller.
       */
      identifier?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier'][]
        | null;
      /**
       * Instantiates FHIR protocol or definition
       * @description The URL pointing to a FHIR-defined protocol, guideline, orderset or other definition that is adhered to in whole or in part by this ServiceRequest.
       */
      instantiatesCanonical?: string[] | null;
      /**
       * Instantiates external protocol or definition
       * @description The URL pointing to an externally maintained protocol, guideline, orderset or other definition that is adhered to in whole or in part by this ServiceRequest.
       */
      instantiatesUri?: string[] | null;
      /**
       * What request fulfills
       * @description Plan/proposal/order fulfilled by this request.
       */
      basedOn?: components['schemas']['Reference'][] | null;
      /**
       * What request replaces
       * @description The request takes the place of the referenced completed or terminated request(s).
       */
      replaces?: components['schemas']['Reference'][] | null;
      /**
       * Composite Request ID
       * @description A shared identifier common to all service requests that were authorized more or less simultaneously by a single author, representing the composite or group identifier.
       */
      requisition?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__identifier__Identifier']
        | null;
      /**
       * draft | active | on-hold | revoked | completed | entered-in-error | unknown
       * @description The status of the order. Required by FHIR R4.
       */
      status: components['schemas']['RequestStatus'];
      /**
       * proposal | plan | directive | order | original-order | reflex-order | filler-order | instance-order | option
       * @description Whether the request is a proposal, plan, an original order or a reflex order. Required by FHIR R4.
       */
      intent: components['schemas']['RequestIntent'];
      /**
       * Classification of service
       * @description A code that classifies the service for searching, sorting and display purposes (e.g. "Surgical Procedure").
       */
      category?: components['schemas']['CodeableConcept'][] | null;
      /**
       * routine | urgent | asap | stat
       * @description Indicates how quickly the ServiceRequest should be addressed with respect to other requests.
       */
      priority?: components['schemas']['RequestPriority'] | null;
      /**
       * True if service/procedure should not be performed
       * @description Set this to true if the record is saying that the service/procedure should NOT be performed.
       */
      doNotPerform?: boolean | null;
      /**
       * What is being requested/ordered
       * @description A code that identifies a particular service (i.e., procedure, diagnostic investigation, or panel of investigations) that have been requested.
       */
      code?: components['schemas']['CodeableConcept'] | null;
      /**
       * Additional order information
       * @description Additional details and instructions about the how the services are to be delivered.
       */
      orderDetail?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Service amount (quantity)
       * @description An amount of service being requested.
       */
      quantityQuantity?: components['schemas']['Quantity'] | null;
      /**
       * Service amount (ratio)
       * @description An amount of service being requested as a ratio.
       */
      quantityRatio?: components['schemas']['Ratio'] | null;
      /**
       * Service amount (range)
       * @description An amount of service being requested as a range.
       */
      quantityRange?: components['schemas']['Range'] | null;
      /**
       * Individual or Entity the service is ordered for
       * @description On whom or what the service is to be performed. This is usually a human patient, but can also be requested on animals, groups of humans or animals, devices such as dialysis machines, or even locations (typically for environmental scans). Required by FHIR R4.
       */
      subject: components['schemas']['Reference'];
      /**
       * Encounter in which the request was created
       * @description An encounter that provides additional information about the healthcare context in which this request is made.
       */
      encounter?: components['schemas']['Reference'] | null;
      /**
       * When service should occur (date/time)
       * @description The date/time at which the requested service should occur.
       */
      occurrenceDateTime?: string | null;
      /**
       * When service should occur (period)
       * @description The period during which the requested service should occur.
       */
      occurrencePeriod?:
        | components['schemas']['pkg__integrations__fhir__models__data_types__period__Period']
        | null;
      /**
       * When service should occur (timing)
       * @description The timing schedule for the requested service.
       */
      occurrenceTiming?: components['schemas']['Timing'] | null;
      /**
       * Preconditions for service (boolean)
       * @description If true, the service is to be performed only as needed.
       */
      asNeededBoolean?: boolean | null;
      /**
       * Preconditions for service (codeable concept)
       * @description If a CodeableConcept is present, it indicates the pre-condition for performing the service. For example "pain", "on flare-up", etc.
       */
      asNeededCodeableConcept?: components['schemas']['CodeableConcept'] | null;
      /**
       * Date request signed
       * @description When the request transitioned to being actionable.
       */
      authoredOn?: string | null;
      /**
       * Who/what is requesting service
       * @description The individual who initiated the request and has responsibility for its activation.
       */
      requester?: components['schemas']['Reference'] | null;
      /**
       * Performer role
       * @description Desired type of performer for doing the requested service.
       */
      performerType?: components['schemas']['CodeableConcept'] | null;
      /**
       * Requested performer
       * @description The desired performer for doing the requested service. For example, the surgeon, dermatopathologist, endoscopist, etc.
       */
      performer?: components['schemas']['Reference'][] | null;
      /**
       * Requested location
       * @description The preferred location(s) where the procedure should actually happen in coded or free text form. E.g. at home or nursing day care center.
       */
      locationCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Requested location
       * @description A reference to the the preferred location(s) where the procedure should actually happen. E.g. at home or nursing day care center.
       */
      locationReference?: components['schemas']['Reference'][] | null;
      /**
       * Explanation/Justification for procedure or service
       * @description An explanation or justification for why this service is being requested in coded or textual form. This is often for billing purposes.
       */
      reasonCode?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Explanation/Justification for service or service
       * @description Indicates another resource that provides a justification for why this service is being requested.
       */
      reasonReference?: components['schemas']['Reference'][] | null;
      /**
       * Associated insurance coverage
       * @description Insurance plans, coverage extensions, pre-authorizations and/or pre-determinations that may be needed for delivering the requested service.
       */
      insurance?: components['schemas']['Reference'][] | null;
      /**
       * Additional clinical information
       * @description Additional clinical information about the patient or specimen that may influence the services or their interpretations.
       */
      supportingInfo?: components['schemas']['Reference'][] | null;
      /**
       * Procedure Samples
       * @description One or more specimens that the laboratory procedure will use.
       */
      specimen?: components['schemas']['Reference'][] | null;
      /**
       * Location on Body
       * @description Anatomic location where the procedure should be performed. This is the target site.
       */
      bodySite?: components['schemas']['CodeableConcept'][] | null;
      /**
       * Comments
       * @description Any other notes and comments made about the service request. For example, internal billing notes.
       */
      note?: components['schemas']['Annotation'][] | null;
      /**
       * Patient or consumer-oriented instructions
       * @description Instructions in terms that are understood by the patient or consumer.
       */
      patientInstruction?: string | null;
      /**
       * Request provenance
       * @description Key events in the history of the request.
       */
      relevantHistory?: components['schemas']['Reference'][] | null;
    };
    /**
     * SessionEvaluationSummaryResponse
     * @description Rubric header fields and aggregate counts for the summary panel.
     *
     *     Scoped to what the panel renders. The session's own title, languages and
     *     created_at are left out because the client already holds them from
     *     ``SessionResponse``, and the error-log rows behind these counts stay
     *     server-side for the spreadsheet export.
     */
    SessionEvaluationSummaryResponse: {
      /** Sessionid */
      sessionId: string;
      /** Evaluatorname */
      evaluatorName?: string | null;
      /** Evaluationcomments */
      evaluationComments?: string | null;
      overallAssessment?: components['schemas']['OverallAssessment'] | null;
      nuhFeedback?: components['schemas']['NuhSessionFeedback'] | null;
      /** Messagecount */
      messageCount: number;
      /** Reviewedmessagecount */
      reviewedMessageCount: number;
      /** Errorcount */
      errorCount: number;
      /** Criticalerrorcount */
      criticalErrorCount: number;
      /** Clinicalerrorcount */
      clinicalErrorCount: number;
      /** Errorscore */
      errorScore: number;
      /** Scoreoutof10 */
      scoreOutOf10: number;
      /** Translatedwordcount */
      translatedWordCount: number;
    };
    /**
     * SessionMergeGroupInspection
     * @description Full inspector payload for one queried session id.
     */
    SessionMergeGroupInspection: {
      /** Session Id */
      session_id: string;
      /**
       * Role
       * @enum {string}
       */
      role: SessionMergeGroupInspectionRole;
      /**
       * Phi Redacted
       * @default false
       */
      phi_redacted: boolean;
      group: components['schemas']['MergeGroupView'] | null;
      session: components['schemas']['SessionMergeStateView'];
    };
    /**
     * SessionMergeStateView
     * @description One session's merge + patient-match state (live document fields).
     */
    SessionMergeStateView: {
      /** Session Id */
      session_id: string;
      session_group_status: components['schemas']['SessionGroupStatus'];
      patient_link_status: components['schemas']['PatientLinkStatus'] | null;
      /** Patient Profile Id */
      patient_profile_id: string | null;
      /** Is Group */
      is_group: boolean;
      /** Is Hidden By Merge */
      is_hidden_by_merge: boolean;
      /** Merged Into Session Id */
      merged_into_session_id: string | null;
      /** Deleted At */
      deleted_at: string | null;
      /** Patient Name */
      patient_name: string | null;
      /** Extracted Field Matches */
      extracted_field_matches: components['schemas']['ExtractedFieldEvidenceView'][];
      /** Candidates */
      candidates: components['schemas']['MatchCandidateView'][];
      auto_link_decision: components['schemas']['AutoLinkDecisionView'];
    };
    /** SnapshotAgentEvalDatasetRequest */
    SnapshotAgentEvalDatasetRequest: {
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      policy: components['schemas']['SamplingPolicyDoc'];
      /** Max Items */
      max_items: number;
      /**
       * Window From
       * Format: date-time
       */
      window_from: string;
      /**
       * Window To
       * Format: date-time
       */
      window_to: string;
    };
    /** SnapshotAgentEvalDatasetResponse */
    SnapshotAgentEvalDatasetResponse: {
      /** Dataset Id */
      dataset_id: string;
      /** Job Ref Id */
      job_ref_id: string;
    };
    /**
     * SnomedTraceVerdict
     * @description Summarise whether source material supports a note claim.
     * @enum {string}
     */
    SnomedTraceVerdict: SnomedTraceVerdict;
    /**
     * SnomedUkGpContext
     * @description Sidebar context for SNOMED UK GP rows on clinical-codes responses.
     *
     *     Set when the GP SNOMED pipeline produces the row; ``None`` otherwise.
     */
    SnomedUkGpContext: {
      /** Best Tier */
      best_tier?: number | null;
    };
    /** SnoozeWorkExperienceFeedbackResponse */
    SnoozeWorkExperienceFeedbackResponse: {
      /**
       * Success
       * @description Whether the snooze was recorded successfully
       */
      success: boolean;
      /**
       * Snooze Count
       * @description Updated snooze count (1-3, after 3 the nudge is permanently dismissed)
       */
      snooze_count: number;
    };
    /**
     * SourceCase
     * @description One explicit case: the id ``target.states`` keys on, and the label the
     *     desktop's deterministic match compares the note value against.
     */
    SourceCase: {
      /** Id */
      id: string;
      /** Label */
      label: string;
    };
    /**
     * SourceKind
     * @description Where a piece of source material came from, for evidence provenance.
     * @enum {string}
     */
    SourceKind: SourceKind;
    /**
     * SourceRef
     * @description Identifies one revision of one source object.
     *
     *     ``(source_id, revision)`` is the deduplication key R3 requires, and the pair a
     *     later revision is compared against so an older one can never overwrite a newer.
     *
     *     Frozen because it is an identity rather than a record: an evidence reference
     *     that could be edited after the fact it supports was accepted would break the
     *     provenance R3 relies on, and comparing references by value needs it hashable.
     */
    SourceRef: {
      source_type: components['schemas']['domains__patient_digital_twin__sources__types__SourceType'];
      /** Source Id */
      source_id: string;
      /** Revision */
      revision: number;
      /** As Of */
      as_of?: string | null;
    };
    /** SpanRefDoc */
    SpanRefDoc: {
      /** Turn Id */
      turn_id: string;
      /** Iteration */
      iteration: number;
      /** Tool Call Id */
      tool_call_id?: string | null;
    };
    /**
     * SpecialtyDetailsAdminResponse
     * @description Data for the Specialty details page in Scribe Admin.
     */
    SpecialtyDetailsAdminResponse: {
      /**
       * Id
       * @example 5eb7cf5a86d9755df3a6c593
       */
      id: string;
      /** Name */
      name: string;
      /** Is Live */
      is_live: boolean;
      /** Default Note Structure Id */
      default_note_structure_id?: string | null;
      /** Onboarding Script Prompt Id */
      onboarding_script_prompt_id?: string | null;
      /** Preset Templates */
      preset_templates: string[];
      /** Generate Template With Ai Prompt Id */
      generate_template_with_ai_prompt_id?: string | null;
      /** Groups */
      groups: components['schemas']['SpecialtyGroupAdminInfo'][];
      /** Country Codes */
      country_codes: components['schemas']['CountryCode'][];
      /** Translations */
      translations: {
        [
          key: string
        ]: components['schemas']['domains__specialty__api__internal_admin__schemas__SpecialtyTranslation'];
      };
    };
    /** SpecialtyGroupAdminInfo */
    SpecialtyGroupAdminInfo: {
      /** Id */
      id: string | null;
      /** Name */
      name: string;
    };
    /**
     * StartAutoVerifyLiteResponse
     * @description Returned by ``/auto-start`` so the FE has an id to poll.
     */
    StartAutoVerifyLiteResponse: {
      /** Analysis Id */
      analysis_id: string;
      /** Session Id */
      session_id: string;
      status: components['schemas']['VerifyLiteStatus'];
    };
    /** StartRetentionLineageCampaignRequest */
    StartRetentionLineageCampaignRequest: {
      operation: components['schemas']['EvidenceChatLineageCampaignOperation'];
      /**
       * Dry Run
       * @default true
       */
      dry_run: boolean;
      /** Snapshot Upper Id */
      snapshot_upper_id?: string | null;
      /** Orchestration Key */
      orchestration_key?: string | null;
      phase?: components['schemas']['EvidenceChatLineageCampaignPhase'] | null;
      /** Predecessor Campaign Id */
      predecessor_campaign_id?: string | null;
    };
    /**
     * StateBoundaries
     * @description The eight, declared together.
     *
     *     Together rather than as loose arguments because R1 treats them as a set:
     *     "declares and enforces these boundaries" is one obligation, and a caller
     *     that can pass seven is a caller that will.
     */
    StateBoundaries: {
      /** Patient */
      patient: string;
      /** Organization */
      organization: string;
      /** Care Episode */
      care_episode: string;
      history_window: components['schemas']['HistoryWindow'];
      purpose: components['schemas']['Purpose'];
      /** Sources */
      sources: components['schemas']['ExpectedSource'][];
      /** Fact Scope */
      fact_scope: string;
      lifecycle: components['schemas']['EpisodeLifecycle'];
    };
    /**
     * StructuredMapping
     * @description One section's structured mapping: the cases, and the state each wants.
     */
    StructuredMapping: {
      /**
       * Version
       * @default 1
       * @constant
       */
      version: 1;
      source: components['schemas']['CategoricalSource'];
      /** Target */
      target:
        | components['schemas']['CheckboxTarget']
        | components['schemas']['RadioTarget']
        | components['schemas']['DropdownTarget'];
    };
    /**
     * Subject
     * @description Who a fact is about.
     *
     *     The relative is part of the subject rather than a qualifier because R2 makes
     *     the family-history subject always distinguish facts: two relatives with the
     *     same condition are two facts, and identity is computed from the subject.
     */
    Subject: {
      /** @default patient */
      kind: components['schemas']['SubjectKind'];
      /** Relative */
      relative?: string | null;
    };
    /**
     * SubjectKind
     * @description R2 admits two subjects: the patient, or an identified relative.
     * @enum {string}
     */
    SubjectKind: SubjectKind;
    /**
     * SuggestRequest
     * @description Request body for POST /{template_id}/suggest.
     *
     *     The ``structure_template_hash`` is the client-echoed SHA-256 of the
     *     STORED ``structure_template`` (the same value as the join response
     *     ``content_hash``).  The server validates it against
     *     ``structure_content_hash(stored.structure_template)`` — mismatches
     *     return 409.  No ``structure_template`` body field in the request —
     *     the server reads the stored body, never a client-supplied body.
     */
    SuggestRequest: {
      /**
       * Structure Template Hash
       * @description Client-echoed SHA-256 of the stored structure_template (64 hex chars) — concurrency precondition
       */
      structure_template_hash: string;
    };
    /**
     * SuggestResponse
     * @description Response for POST /{template_id}/suggest.
     *
     *     Contains the heading insertion positions (NOT a rewritten template
     *     body), the machine-check result, the echoed ``structure_template_hash``
     *     for apply, and the ``snapshot_id`` of the suggested snapshot.
     */
    SuggestResponse: {
      /**
       * Insertion Points
       * @description Heading insertion positions ({line_index, heading_text})
       */
      insertion_points?: components['schemas']['InsertionPoint'][];
      /** @description Machine-check result for line-exact / mapping-ID preservation */
      machine_check: components['schemas']['MachineCheck'];
      /**
       * Structure Template Hash
       * @description SHA-256 hex of the stored structure_template (64 chars), echoed for apply — NOT a rewritten body
       */
      structure_template_hash: string;
      /**
       * Snapshot Id
       * @description Suggested snapshot ObjectId as string (status=suggested)
       */
      snapshot_id: string;
    };
    /** SuiteDefinition */
    SuiteDefinition: {
      /** Name */
      name: string;
      /**
       * Description
       * @default
       */
      description: string;
      /** Bundle Name */
      bundle_name: string;
      /** Scorer Subset */
      scorer_subset?: string[] | null;
      /** Data */
      data:
        | components['schemas']['CodeDefinedDataset']
        | components['schemas']['SavedDataset']
        | components['schemas']['OnlineDataset'];
      /**
       * Ad Hoc
       * @default false
       */
      ad_hoc: boolean;
    };
    /** TemplateJsonSourceResponse */
    TemplateJsonSourceResponse: {
      /** Json Source */
      json_source: string;
    };
    /**
     * TemplateMappingSchema
     * @description Shared mapping schema describing one template-section → EHR-section link.
     *
     *     Fields:
     *         section_heading: The human-readable heading from the template.
     *         linked_ehr_section_id: The EHR-side section identifier this heading
     *             maps to (or will map to once linked).
     *         migration_status: Current migration state of this mapping. Defaults
     *             to ``needs_headings`` when omitted.
     */
    TemplateMappingSchema: {
      /**
       * Section Heading
       * @description Template section heading text
       */
      section_heading: string;
      /**
       * Linked Ehr Section Id
       * @description EHR section identifier the heading maps to
       */
      linked_ehr_section_id?: string | null;
      /**
       * @description Current migration state of this mapping
       * @default needs_headings
       */
      migration_status: components['schemas']['MigrationStatus'];
    };
    /** TemplateXmlSourceResponse */
    TemplateXmlSourceResponse: {
      /** Xml Source */
      xml_source: string;
    };
    /**
     * Temporality
     * @description When the concept applies.
     *
     *     ``UNSPECIFIED`` is R2's named value for "the source did not say", and is not
     *     the same as SDM's ``unknown``.
     * @enum {string}
     */
    Temporality: Temporality;
    /**
     * TerminologySystem
     * @description The coding systems D9 selects, and only those.
     *
     *     CPT Category I describes what was performed, so it codes a ``procedure``
     *     observation. Category II encodes whether a quality measure was satisfied,
     *     which R2 bars from patient state — so it has no member here and cannot be
     *     stored.
     * @enum {string}
     */
    TerminologySystem: TerminologySystem;
    /**
     * TextValue
     * @description A stated value that no other member can carry without inventing content.
     *
     *     The last resort, and the one that has to be policed. A measurement written
     *     down as text is a measurement that lost its unit, so text that is nothing
     *     but a number is rejected — otherwise ``QuantityValue``'s required unit is a
     *     speed bump, since the same 106 goes through here unaccompanied. The rule is
     *     narrow on purpose: it catches a value that is *only* a number, and leaves
     *     "trace", "106 mg/dL" and "negative" alone.
     *
     *     This is not a hatch for raw source material. R2 bars that from patient state
     *     outright, and R3 keeps the wording in the source revision an ``EvidenceRef``
     *     points at.
     */
    TextValue: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: TextValueType;
      /** Text */
      text: string;
    };
    /** ToolExecutionArtifactPayload */
    ToolExecutionArtifactPayload: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: ToolExecutionArtifactPayloadType;
      /** Tool Call Id */
      tool_call_id: string;
      /** Tool Name */
      tool_name: string;
      /**
       * Status
       * @enum {string}
       */
      status: ToolExecutionArtifactPayloadStatus;
      /** Terminal Outcome */
      terminal_outcome?: ToolExecutionArtifactPayloadTerminal_outcomeAnyOf0 | null;
      result: components['schemas']['ToolResultViewV1'];
    };
    /**
     * ToolResultViewV1
     * @description API-owned projection of a persisted tool result.
     *
     *     Deliberately carries neither the provider-metadata bag (once public,
     *     clients depend on it) nor the raw diagnostic error string.
     */
    ToolResultViewV1: {
      /** Content */
      content?: unknown | null;
      /** Attachments */
      attachments?: components['schemas']['AttachmentBlock'][];
      /** Is Error */
      is_error: boolean;
    };
    /**
     * TranscriptMatchCandidateKind
     * @description Discriminator for transcript match ranking across Heidi profiles vs EHR appointments.
     * @enum {string}
     */
    TranscriptMatchCandidateKind: TranscriptMatchCandidateKind;
    /** TurnTerminationArtifactPayload */
    TurnTerminationArtifactPayload: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: TurnTerminationArtifactPayloadType;
      /**
       * Disposition
       * @enum {string}
       */
      disposition: TurnTerminationArtifactPayloadDisposition;
      message: components['schemas']['pkg__agent_harness__core__llm_contracts__Message'];
    };
    /**
     * UcumUnit
     * @description A unit the writer is claiming is a UCUM expression.
     *
     *     A model rather than the bare ``UcumCode`` so that the unit arms of
     *     ``FactUnit`` are shapes rather than strings. The cost is ``UcumUnit(code=
     *     "mg/dL")`` on the path that runs most often; what it buys is that a consumer
     *     ignoring the unknown-unit marker fails *here*, on attribute access, instead
     *     of carrying the string ``"unspecified"`` into a terminology lookup and
     *     failing somewhere with no view of the fact that produced it.
     */
    UcumUnit: {
      /** Code */
      code: string;
    };
    /**
     * UnitAsStated
     * @description A unit the source gave that nobody is claiming is UCUM.
     *
     *     US Core's middle case: a lab reports ``RR`` and no UCUM expression means it.
     *     The three source states are genuinely three — a UCUM code, an
     *     uninterpretable string, and nothing at all — and collapsing any two loses
     *     something a consumer needs. Folding this into ``UNSPECIFIED`` would discard
     *     what the source actually said; calling it a ``UcumCode`` would assert a
     *     resolvable unit and let a consumer's terminology lookup fail on a claim PDT
     *     invented. So it is its own shape.
     *
     *     A consumer reading this knows it must not compare scales, which is the
     *     difference between refusing and guessing.
     */
    UnitAsStated: {
      /** Stated */
      stated: string;
    };
    /** UpdateAllowancePolicyRequest */
    UpdateAllowancePolicyRequest: {
      /** Workspace Id */
      workspace_id?: string | null;
      subscription_tier?: components['schemas']['SubscriptionTier'] | null;
      /** Seat Type */
      seat_type?: string | null;
      period?: components['schemas']['AllowancePeriod'] | null;
      /** Default Member Limit */
      default_member_limit?: number | null;
    };
    /**
     * UpdateApprovalModeRequest
     * @description Subject-owned run approval-mode change.
     */
    UpdateApprovalModeRequest: {
      approval_mode: components['schemas']['ApprovalMode'];
    };
    /**
     * UpdateApprovalModeResponse
     * @description The mode now recorded for the run.
     *
     *     Recorded, not applied to a call already in flight: the change lands on the
     *     next tool call, and approvals already awaiting a human are untouched.
     */
    UpdateApprovalModeResponse: {
      approval_mode: components['schemas']['ApprovalMode'];
    };
    /**
     * UpdateContractRequest
     * @description Partial update: only fields present in the body are applied, so
     *     `ends_at: null` makes the term open-ended while omitting it changes nothing.
     *
     *     The pin moves only as a **pair**: send `rate_card_key` and
     *     `rate_card_version` together to re-pin, or neither to leave pricing alone.
     *     One without the other is rejected — completing the missing half from the
     *     stored contract is exactly how a form that dropped a field reprices a
     *     customer silently. Echoing the stored pair is a no-op; to take a card's
     *     latest without naming a version, use `:resync-rate-card`. See
     *     `ContractService.edit_contract`.
     *
     *     `workspace_id` is absent because a contract cannot be moved to another
     *     workspace — that is a new contract there and an archive here. `status` is
     *     absent because archiving has its own endpoint: a status field on a patch
     *     body invites the un-archive `ContractService.archive_contract` explains can
     *     never exist.
     */
    UpdateContractRequest: {
      /** Rate Card Key */
      rate_card_key?: string | null;
      /** Rate Card Version */
      rate_card_version?: number | null;
      /** Starts At */
      starts_at?: string | null;
      /** Ends At */
      ends_at?: string | null;
    };
    /** UpdateSavedEvalSuiteRequest */
    UpdateSavedEvalSuiteRequest: {
      /** Name */
      name?: string | null;
      /** Description */
      description?: string | null;
      /** Enabled */
      enabled?: boolean | null;
      /** Bundle Name */
      bundle_name?: string | null;
      /** Scorer Subset */
      scorer_subset?: string[] | null;
      /** Data */
      data?:
        | (
            | components['schemas']['CodeDefinedDataset']
            | components['schemas']['SavedDataset']
            | components['schemas']['OnlineDataset']
          )
        | null;
    };
    /**
     * NuhSessionFeedback
     * @description NUH post-session feedback for one session, as a draft or a submission.
     *
     *     The document is replaced whole on each save: omitting ``nuh_feedback`` from
     *     a session evaluation update leaves whatever was stored untouched, while
     *     sending it replaces the previous answers. A draft may omit areas or
     *     scores so the panel can autosave as the rater goes.
     *
     *     ``status=submitted`` is the rater saying they are done. Completeness of
     *     required areas is enforced on the evaluation PATCH, not here, so loading
     *     a stored form cannot fail after the question set changes. Unknown keys
     *     and area/prompt ids that are not in the current enums are dropped.
     */
    NuhSessionFeedback: {
      status: components['schemas']['NuhFeedbackStatus'];
      /** Areas */
      areas: components['schemas']['NuhSessionFeedbackArea'][];
      /** Prompts */
      prompts: components['schemas']['NuhSessionFeedbackPrompt'][];
    };
    /**
     * NuhSessionFeedbackArea
     * @description One area's score, with the example the rater optionally gave for it.
     */
    NuhSessionFeedbackArea: {
      area: components['schemas']['NuhFeedbackArea'];
      score: components['schemas']['NuhFeedbackScore'] | null;
      /** Comment */
      comment: string | null;
    };
    /**
     * NuhSessionFeedbackPrompt
     * @description One of the form's free-text prompts and its answer.
     */
    NuhSessionFeedbackPrompt: {
      prompt: components['schemas']['NuhFeedbackPrompt'];
      /** Answer */
      answer: string | null;
    };
    /**
     * UpdateSessionEvaluationRequest
     * @description Partial update for session-level evaluation fields.
     *
     *     ``nuh_feedback`` is the whole NUH form or nothing: omitting it leaves the
     *     stored answers alone, sending it replaces them, and explicit ``null``
     *     clears them. A draft may be incomplete; ``status=submitted`` is rejected
     *     unless every area is scored.
     */
    UpdateSessionEvaluationRequest: {
      /** Evaluatorname */
      evaluatorName?: string | null;
      /** Evaluationcomments */
      evaluationComments?: string | null;
      overallAssessment?: components['schemas']['OverallAssessment'] | null;
      nuhFeedback?: components['schemas']['NuhSessionFeedback'] | null;
    };
    /**
     * UpdateXmlFieldsRequest
     * @description Request body for PATCH /xml-document/{document_id}/fields.
     */
    UpdateXmlFieldsRequest: {
      /**
       * Fields
       * @description Array of field updates
       */
      fields: components['schemas']['XmlFieldUpdate'][];
    };
    /**
     * UpdateXmlFieldsResponse
     * @description Response for PATCH /xml-document/{document_id}/fields.
     */
    UpdateXmlFieldsResponse: {
      /**
       * Success
       * @description Whether the update succeeded
       */
      success: boolean;
      /**
       * Updated Fields
       * @description Confirmed field updates
       */
      updated_fields?: components['schemas']['XmlFieldUpdate'][];
    };
    /** UserMessageArtifactPayload */
    UserMessageArtifactPayload: {
      /**
       * @description discriminator enum property added by openapi-typescript
       * @enum {string}
       */
      type: UserMessageArtifactPayloadType;
      message: components['schemas']['pkg__agent_harness__core__llm_contracts__Message'];
    };
    /**
     * VerificationRegistry
     * @description Which registry a verification record concerns.
     *
     *     ``MANUAL_REVIEW`` names the absence of one: it has no adapter and is
     *     reachable only through the review-request path, never a lookup or a
     *     confirmation.
     * @enum {string}
     */
    VerificationRegistry: VerificationRegistry;
    /**
     * VerificationState
     * @description How far the fact has been through human verification.
     *
     *     R8 gates a high-risk evaluation on the verification states it declares, so
     *     this is a safety axis and not a quality score.
     *
     *     One clinician state, not two. ``clinician_reviewed`` means a clinician gave
     *     the fact their attention; whether they agreed with it or amended it is a
     *     property of the response, not of how far the fact has been verified. R5's
     *     change type (``confirmed`` versus ``superseded``) carries that distinction,
     *     and R3.AC4 puts the durable record of what the human did in the source/audit
     *     system, reachable from the ``response_id`` this fact retains. Giving one
     *     trust level two names put a response outcome on the trust axis, which made a
     *     split declaration expressible — an R8 evaluation allowing confirmations but
     *     not corrections would have withheld exactly the facts a clinician had
     *     already fixed.
     *
     *     Ordering comparison is refused rather than merely discouraged. ``StrEnum``
     *     would otherwise compare these alphabetically, and alphabetical order is not
     *     unrelated to evidential weight — it is inverted against it, because
     *     ``clinician_reviewed`` sorts below ``machine_extracted``. A plain ``min``
     *     over a fact's element states therefore reports a clinician review for a fact
     *     whose laterality no clinician saw, silently and with a plausible value.
     *     Collapsing the two clinician states does not fix this and was never expected
     *     to: every plausible name for the surviving state begins before ``m``. The
     *     rank lives in ``facts.verification`` because ordering is a policy of this
     *     contract version rather than a property of the type.
     * @enum {string}
     */
    VerificationState: VerificationState;
    /**
     * VerifyLiteAnalysisResponse
     * @description Native Verify Lite result: per-claim verdicts with evidence provenance.
     */
    VerifyLiteAnalysisResponse: {
      /** Id */
      id: string;
      /** Session Id */
      session_id: string;
      /** Note Id */
      note_id: string | null;
      status: components['schemas']['VerifyLiteStatus'];
      /** Failure Reason */
      failure_reason: string | null;
      /** Claims */
      claims: components['schemas']['VerifyLiteClaim'][];
      summary: components['schemas']['VerifyLiteSummary'];
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /** Completed At */
      completed_at: string | null;
    };
    /**
     * VerifyLiteCheck
     * @description One attribute check the pipeline ran on a claim (e.g. laterality, negation).
     *
     *     These are what make a verdict explainable - the per-attribute breakdown behind
     *     a needs_review or verified. Only the checks that actually ran on the claim are
     *     stored, so a claim with no medication carries no dosage check, etc.
     */
    VerifyLiteCheck: {
      /** Attribute */
      attribute: string;
      status: components['schemas']['CheckStatus'];
      /** Note Value */
      note_value?: string | null;
      /** Source Value */
      source_value?: string | null;
      /**
       * Reason
       * @default
       */
      reason: string;
    };
    /**
     * VerifyLiteClaim
     * @description One note claim's deterministic verdict.
     */
    VerifyLiteClaim: {
      /** Claim Id */
      claim_id: string;
      /** Text */
      text: string;
      /** Span Start */
      span_start: number;
      /** Span End */
      span_end: number;
      verdict: components['schemas']['SnomedTraceVerdict'];
      /**
       * Confidence
       * @default 0
       */
      confidence: number;
      /**
       * Reason
       * @default
       */
      reason: string;
      /**
       * Nli Cleared
       * @default false
       */
      nli_cleared: boolean;
      /** Nli Label */
      nli_label?: string | null;
      /** Nli Score */
      nli_score?: number | null;
      /** Checks */
      checks?: components['schemas']['VerifyLiteCheck'][];
      /** Evidence */
      evidence?: components['schemas']['VerifyLiteEvidence'][];
    };
    /**
     * VerifyLiteEvidence
     * @description A source span that backed a claim, with provenance.
     */
    VerifyLiteEvidence: {
      /** Text */
      text: string;
      source: components['schemas']['SourceKind'];
      /** Source Label */
      source_label?: string | null;
      /** Span Start */
      span_start: number;
      /** Span End */
      span_end: number;
      state?: components['schemas']['EvidenceState'] | null;
    };
    /**
     * VerifyLiteStatus
     * @description Lifecycle state of a VerifyLiteAnalysis document.
     *
     *     Manual runs insert at `complete` (one synchronous call yields a terminal
     *     document). Auto runs insert `pending`, then reach `complete` or `failed`.
     * @enum {string}
     */
    VerifyLiteStatus: VerifyLiteStatus;
    /** VerifyLiteSummary */
    VerifyLiteSummary: {
      /**
       * Total
       * @default 0
       */
      total: number;
      /**
       * Verified
       * @default 0
       */
      verified: number;
      /**
       * Needs Review
       * @default 0
       */
      needs_review: number;
      /**
       * Not Found
       * @default 0
       */
      not_found: number;
      /**
       * Conflicting
       * @default 0
       */
      conflicting: number;
      /**
       * Not Applicable
       * @default 0
       */
      not_applicable: number;
    };
    /** VoiceFeedbackRequest */
    VoiceFeedbackRequest: {
      /** @description ``thumb_up`` or ``thumb_down`` for the voice experience. */
      rating: components['schemas']['ThumbRating'];
      /**
       * Voice Session Id
       * @description Optional Talk-to-Heidi session id. Stored as ``session_id`` on the feedback record when present.
       */
      voice_session_id?: string | null;
      /**
       * User Feedback
       * @description Optional free-text comment accompanying the rating.
       */
      user_feedback?: string | null;
      /**
       * Content Snapshot
       * @description Snapshot of the rated content at the time of feedback.
       */
      content_snapshot?: string | null;
    };
    /** VoiceFeedbackResponse */
    VoiceFeedbackResponse: {
      /** Feedback Id */
      feedback_id: string;
    };
    /** VoiceSessionDetailResponse */
    VoiceSessionDetailResponse: {
      session: components['schemas']['VoiceSessionSummary'];
      /** Events */
      events: components['schemas']['VoiceSessionEventOut'][];
    };
    /** VoiceSessionEventOut */
    VoiceSessionEventOut: {
      /** Seq */
      seq: number;
      /**
       * At
       * Format: date-time
       */
      at: string;
      /** Direction */
      direction: string;
      /** Kind */
      kind: string;
      /** Payload */
      payload: {
        [key: string]: unknown;
      };
    };
    /** VoiceSessionListResponse */
    VoiceSessionListResponse: {
      /** Sessions */
      sessions: components['schemas']['VoiceSessionSummary'][];
    };
    /** VoiceSessionSummary */
    VoiceSessionSummary: {
      /** Voice Session Id */
      voice_session_id: string;
      /**
       * Started At
       * Format: date-time
       */
      started_at: string;
      /** Ended At */
      ended_at?: string | null;
      /** Close Reason */
      close_reason?: string | null;
      /** Surface */
      surface?: string | null;
      /**
       * Scribe Session Ids
       * @default []
       */
      scribe_session_ids: string[];
      /** Agent Run Id */
      agent_run_id?: string | null;
      /** Work Chat Id */
      work_chat_id?: string | null;
      /** Conversation Agent Run Id */
      conversation_agent_run_id?: string | null;
      /**
       * Event Count
       * @default 0
       */
      event_count: number;
      /**
       * Events Dropped
       * @default 0
       */
      events_dropped: number;
    };
    /** WorkExperienceFeedbackDetail */
    WorkExperienceFeedbackDetail: {
      /** Id */
      id: string;
      /**
       * User Id
       * @description User reference ID (user_ref_id)
       */
      user_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** User Email */
      user_email?: string | null;
      /** Ease Stars */
      ease_stars?: number | null;
      /** Usefulness Stars */
      usefulness_stars?: number | null;
      /** Stars */
      stars?: number | null;
      /** Feedback */
      feedback?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Workspace Id */
      workspace_id?: string | null;
    };
    /** WorkExperienceFeedbackListItem */
    WorkExperienceFeedbackListItem: {
      /** Id */
      id: string;
      /**
       * User Id
       * @description User reference ID (user_ref_id)
       */
      user_id: string;
      /** Kinde User Id */
      kinde_user_id: string;
      /** User Email */
      user_email?: string | null;
      /** Ease Stars */
      ease_stars?: number | null;
      /** Usefulness Stars */
      usefulness_stars?: number | null;
      /** Stars */
      stars?: number | null;
      /** Feedback */
      feedback?: string | null;
      /**
       * Created At
       * Format: date-time
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** WorkExperienceFeedbackListMeta */
    WorkExperienceFeedbackListMeta: {
      /** Total */
      total: number;
      /** Offset */
      offset: number;
      /** Limit */
      limit: number;
    };
    /** WorkExperienceFeedbackListResponse */
    WorkExperienceFeedbackListResponse: {
      /** Data */
      data: components['schemas']['WorkExperienceFeedbackListItem'][];
      meta: components['schemas']['WorkExperienceFeedbackListMeta'];
    };
    /** XmlFieldUpdate */
    XmlFieldUpdate: {
      /**
       * Id
       * @description Field id to update (the XML field key)
       */
      id: string;
      /**
       * Field Value
       * @description New value for the field
       */
      field_value: string;
    };
    /**
     * SourceType
     * @enum {string}
     */
    domains__access_entitlements__schemas__SourceType: Domains__access_entitlements__schemas__SourceType;
    /** IdentityProfileDTO */
    domains__identity_broker__client__schema__IdentityProfileDTO: {
      /** User Ref Id */
      user_ref_id: string;
      /** Email */
      email: string;
      /**
       * Email Verified
       * @default false
       */
      email_verified: boolean;
      /** Auth0 Id */
      auth0_id?: string | null;
      /** Kinde Id */
      kinde_id?: string | null;
      /** Identities */
      identities?: {
        [key: string]: unknown;
      }[];
      /** Profile Source */
      profile_source?: string | null;
      /** Last Routed Vendor */
      last_routed_vendor?: string | null;
      /** Auth0 Sync State */
      auth0_sync_state?: string | null;
      /** Kinde Sync State */
      kinde_sync_state?: string | null;
      /** Region */
      region?: string | null;
      /** First Name */
      first_name?: string | null;
      /** Last Name */
      last_name?: string | null;
      /** Created At */
      created_at?: string | null;
      /** Updated At */
      updated_at?: string | null;
    };
    /**
     * IdentityProfileDTO
     * @description DTO for identity profile retrieval.
     * @example {
     *       "auth0_id": "auth0|123456789",
     *       "auth0_sync_state": "identity_create_completed",
     *       "created_at": "2024-01-15T10:30:00Z",
     *       "email": "user@example.com",
     *       "email_verified": true,
     *       "identities": [
     *         {
     *           "connection": "Username-Password-Authentication",
     *           "is_social": false,
     *           "provider": "auth0",
     *           "user_id": "auth0|123456789"
     *         }
     *       ],
     *       "kinde_sync_state": "pending",
     *       "last_routed_vendor": "auth0",
     *       "profile_source": "auth0",
     *       "region": "us",
     *       "updated_at": "2024-01-15T10:30:00Z",
     *       "user_ref_id": "01912345-6789-7abc-def0-123456789abc"
     *     }
     */
    domains__identity_broker__dto__responses__identity_profile_dto__IdentityProfileDTO: {
      /**
       * User Ref Id
       * @description Global unique identifier (UUID7)
       */
      user_ref_id: string;
      /**
       * Email
       * @description Normalized email address
       */
      email: string;
      /**
       * Email Verified
       * @description Whether email is verified
       */
      email_verified: boolean;
      /**
       * Auth0 Id
       * @description Auth0 user ID if Auth0 identity exists
       */
      auth0_id?: string | null;
      /**
       * Kinde Id
       * @description Kinde user ID if Kinde identity exists
       */
      kinde_id?: string | null;
      /**
       * Identities
       * @description List of user identities
       */
      identities: components['schemas']['Identity'][];
      /** @description Original creating vendor */
      profile_source: components['schemas']['AuthVendor'];
      /** @description Last vendor user was routed to */
      last_routed_vendor?: components['schemas']['AuthVendor'] | null;
      /** @description Auth0 sync status */
      auth0_sync_state: components['schemas']['IdentityProviderSyncState'];
      /** @description Kinde sync status */
      kinde_sync_state: components['schemas']['IdentityProviderSyncState'];
      /**
       * Region
       * @description User's region
       */
      region?: string | null;
      /**
       * First Name
       * @description User's first name
       */
      first_name?: string | null;
      /**
       * Last Name
       * @description User's last name
       */
      last_name?: string | null;
      /**
       * Metadata
       * @description Extensible key-value metadata
       */
      metadata?: {
        [key: string]: unknown;
      } | null;
      /**
       * Created At
       * Format: date-time
       * @description Creation timestamp
       */
      created_at: string;
      /**
       * Updated At
       * Format: date-time
       * @description Last update timestamp
       */
      updated_at: string;
    };
    /** AvailableStandardizedSection */
    domains__integrations__api__v2__functionality__schemas__AvailableStandardizedSection: {
      section_id: components['schemas']['SectionalNoteSection'];
      /** Name */
      name?: string | null;
    };
    /** AvailableStandardizedSectionsResponse */
    domains__integrations__api__v2__functionality__schemas__AvailableStandardizedSectionsResponse: {
      /** Available Sections */
      available_sections: components['schemas']['domains__integrations__api__v2__functionality__schemas__AvailableStandardizedSection'][];
    };
    /** LaunchRequestPayload */
    domains__integrations__api__v2__launch__sgimed__LaunchRequestPayload: {
      /** Provider */
      provider: string;
      /** Payload */
      payload: {
        [key: string]: unknown;
      };
    };
    /** AvailableStandardizedSection */
    domains__integrations__standardized_sections__api__schemas__AvailableStandardizedSection: {
      /** Section Id */
      section_id: string;
      /** Name */
      name?: string | null;
    };
    /** AvailableStandardizedSectionsResponse */
    domains__integrations__standardized_sections__api__schemas__AvailableStandardizedSectionsResponse: {
      /** Available Sections */
      available_sections: components['schemas']['domains__integrations__standardized_sections__api__schemas__AvailableStandardizedSection'][];
    };
    /**
     * SourceType
     * @description The four source types R2 declares. Nothing else may enter patient state.
     * @enum {string}
     */
    domains__patient_digital_twin__sources__types__SourceType: Domains__patient_digital_twin__sources__types__SourceType;
    /** SpecialtyTranslation */
    domains__specialty__api__internal_admin__schemas__SpecialtyTranslation: {
      /** Name */
      name: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
    };
    /** SpecialtyTranslation */
    domains__specialty__models__specialty__SpecialtyTranslation: {
      /** Name */
      name: string;
      /**
       * Updated At
       * Format: date-time
       */
      updated_at: string;
      /** Updated By */
      updated_by: string;
    };
    /** ListWorkspacesResponse */
    domains__workspace__api__v2__workspaces__workspaces_schema__ListWorkspacesResponse: {
      /** Workspaces */
      workspaces: components['schemas']['JoinedWorkspaceRelation'][];
    };
    /**
     * Gender
     * @description gender that matches FHIR API
     * @enum {string}
     */
    shared__enums__enums__Gender: Shared__enums__enums__Gender;
    /**
     * Period
     * @enum {string}
     */
    shared__enums__enums__Period: Shared__enums__enums__Period;
    /**
     * SortOrder
     * @enum {string}
     */
    shared__enums__enums__SortOrder: Shared__enums__enums__SortOrder;
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
};
export type $defs = Record<string, never>;
export interface operations {
  get_device_status_api_v1_identity_broker_ciba_device_status_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CibaDeviceStatusResponse'];
        };
      };
    };
  };
  unregister_device_api_v1_identity_broker_ciba_device_register_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_enrollment_ticket_api_v1_identity_broker_ciba_device_enroll_ticket_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EnrollmentTicketResponse'];
        };
      };
    };
  };
  initiate_ciba_api_v1_identity_broker_ciba_initiate_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InitiateCibaRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InitiateCibaResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  complete_ciba_api_v1_identity_broker_ciba_complete_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CompleteCibaRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompleteCibaResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  report_ciba_api_v1_identity_broker_ciba_report_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ReportCibaRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  track_sign_in_endpoint_api_v1_identity_broker_record_auth0_sign_in_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TrackSignInRequestDTO'];
      };
    };
    responses: {
      /** @description Sign-in tracked successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  save_identity_profile_api_v1_identity_broker_save_identity_profile_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SaveIdentityProfileRequestDTO'];
      };
    };
    responses: {
      /** @description Identity profile saved successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SaveIdentityProfileResponse'];
        };
      };
      /** @description Bad Request - Invalid input data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  get_identity_profile_api_v1_identity_broker_get_identity_profile_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GetIdentityProfileRequestDTO'];
      };
    };
    responses: {
      /** @description Identity profile found */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetIdentityProfileResponse'];
        };
      };
      /** @description Bad Request - Invalid email format */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Not Found - Identity profile not found or user not found in regional server */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Service Unavailable - Regional server unavailable */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  lookup_identity_profile_api_v1_identity_broker_lookup_identity_profile_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LookupIdentityProfileRequest'];
      };
    };
    responses: {
      /** @description Identity profile found */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LookupIdentityProfileResponse'];
        };
      };
      /** @description Bad Request - invalid identifier */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Not Found - Identity profile not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  bulk_lookup_identity_profiles_api_v1_identity_broker_bulk_lookup_identity_profiles_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkLookupIdentityProfilesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkLookupIdentityProfilesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_connection_workspaces_api_v1_identity_broker_get_connection_workspaces_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GetConnectionWorkspacesRequest'];
      };
    };
    responses: {
      /** @description Workspaces resolved for the supplied groups */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetConnectionWorkspacesResponse'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Not Found - No SSO connection with that name */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unprocessable Entity - missing connection_name */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  finish_signup_api_v1_identity_broker_finish_signup_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FinishSignupRequestDTO'];
      };
    };
    responses: {
      /** @description Signup finished successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FinishSignupResponseDTO'];
        };
      };
      /** @description Bad Request - Invalid input data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  sync_password_from_kinde_to_auth0_api_v1_identity_broker_sync_password_from_kinde_to_auth0_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SyncPasswordRequestDTO'];
      };
    };
    responses: {
      /** @description Password synced successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncPasswordResponse'];
        };
      };
      /** @description Bad Request - Invalid input data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error - Conditional field requirements not met */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Service Unavailable - Auth0 rate limit exceeded */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  delete_identity_profile_api_v1_identity_broker_delete_identity_profile_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteIdentityProfileRequest'];
      };
    };
    responses: {
      /** @description Delete identity profile operation completed */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteIdentityProfileResponse'];
        };
      };
      /** @description Bad Request - Invalid input data or key mismatch */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  revoke_auth0_sessions_api_v1_identity_broker_revoke_auth0_sessions_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RevokeAuth0SessionsRequest'];
      };
    };
    responses: {
      /** @description Revoke Auth0 sessions operation completed */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RevokeAuth0SessionsResponse'];
        };
      };
      /** @description Bad Request - User has no Auth0 identity */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Not Found - Identity profile not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Service Unavailable - Auth0 client not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  update_identity_profile_email_api_v1_identity_broker_update_identity_profile_email_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateIdentityProfileEmailRequest'];
      };
    };
    responses: {
      /** @description Update identity profile email completed */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateIdentityProfileEmailResponse'];
        };
      };
      /** @description Bad Request - Invalid input data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  update_identity_profile_name_api_v1_identity_broker_update_identity_profile_name_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateIdentityProfileNameRequest'];
      };
    };
    responses: {
      /** @description Update identity profile name completed */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateIdentityProfileNameResponse'];
        };
      };
      /** @description Bad Request - Invalid input data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized - Missing or invalid API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  assign_apple_migration_ticket_api_v1_identity_broker_assign_apple_migration_ticket_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Apple migration status resolved */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AssignAppleMigrationTicketResponse'];
        };
      };
      /** @description Unauthorized - Missing or invalid bearer token */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  consume_apple_migration_ticket_api_v1_identity_broker_consume_apple_migration_ticket_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConsumeAppleMigrationTicketRequest'];
      };
    };
    responses: {
      /** @description Ticket consumed; profile migrated to Auth0 */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConsumeAppleMigrationTicketResponse'];
        };
      };
      /** @description Bad Request — ticket id not a valid UUIDv7, or ticket was never minted / expired in Redis / already consumed and deleted by another caller */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Unauthorized — missing or invalid X-API-Key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Not Found — data-integrity case: ticket references a kinde_user_id with no IdentityProfile */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Conflict — concurrent consume already won the race, or idempotent retry supplied a different auth0_id than the one recorded on the already-migrated profile */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  list_connections_api_v1_identity_broker_internal_admin_connections_get: {
    parameters: {
      query?: {
        /** @description Filter by region code */
        region?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SSOConnectionListResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_connection_api_v1_identity_broker_internal_admin_connections_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateConnectionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SSOConnectionResponse'];
        };
      };
      /** @description Conflict - connection name or domain already exists */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Service Unavailable - Auth0 not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  reissue_ticket_api_v1_identity_broker_internal_admin_connections__connection_name__reissue_ticket_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SSOConnectionResponse'];
        };
      };
      /** @description Bad Request - connection not in SETUP state */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_connection_api_v1_identity_broker_internal_admin_connections__connection_name__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteConnectionResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_connection_api_v1_identity_broker_internal_admin_connections__connection_name__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateConnectionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SSOConnectionResponse'];
        };
      };
      /** @description Bad Request - invalid state transition */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_secret_expiry_api_v1_identity_broker_internal_admin_connections__connection_name__secret_expiry_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetSecretExpiryRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SSOConnectionResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Invalid payload (must provide exactly one of expires_at or duration_months) */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  issue_secret_update_ticket_api_v1_identity_broker_internal_admin_connections__connection_name__secret_update_ticket_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connection_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SSOConnectionResponse'];
        };
      };
      /** @description Bad Request - connection is in SETUP state */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Service Unavailable - Auth0 not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  lookup_user_api_v1_identity_broker_internal_admin_users_lookup_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LookupIdentityProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__identity_broker__dto__responses__identity_profile_dto__IdentityProfileDTO'];
        };
      };
      /** @description Identity profile not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Invalid or ambiguous identifier */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  get_user_profile_api_v1_identity_broker_internal_admin_users__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__identity_broker__dto__responses__identity_profile_dto__IdentityProfileDTO'];
        };
      };
      /** @description Identity profile not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_auth0_view_api_v1_identity_broker_internal_admin_users__user_ref_id__auth0_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Auth0UserDiagnosticDTO'];
        };
      };
      /** @description Identity profile or Auth0 user not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Auth0 client not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  get_user_kinde_view_api_v1_identity_broker_internal_admin_users__user_ref_id__kinde_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['KindeUserDiagnosticDTO'];
        };
      };
      /** @description Identity profile or Kinde identity not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Kinde upstream error */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  get_user_login_routing_api_v1_identity_broker_internal_admin_users__user_ref_id__login_routing_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LoginRoutingDTO'];
        };
      };
      /** @description Identity profile not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reset_auth0_mfa_api_v1_identity_broker_internal_admin_users__user_ref_id__reset_mfa_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User or Auth0 identity not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description User has a passkey enrolled */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Auth0 client not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  unblock_auth0_user_api_v1_identity_broker_internal_admin_users__user_ref_id__login_brute_force_unblock_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Identity profile not found or no Auth0 identity */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Auth0 client not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  send_password_reset_api_v1_identity_broker_internal_admin_users__user_ref_id__send_password_reset_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description User is SSO-only (no password identity) */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description User or Auth0 identity not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description A password-reset email was recently sent to this user */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Auth0 client not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  log_events_endpoint_api_v1_identity_broker_auth_notifications_log_events_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LogEventEntry'][];
      };
    };
    responses: {
      /** @description Batch accepted for background dispatch. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LogEventsResponse'];
        };
      };
      /** @description Invalid or missing API key. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Malformed payload — not a JSON array of log events. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  login_from_new_device_endpoint_api_v1_identity_broker_auth_notifications_login_from_new_device_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LoginFromNewDeviceIngestionRequest'];
      };
    };
    responses: {
      /** @description Login processed; body carries the decision outcome. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LoginFromNewDeviceIngestionResponse'];
        };
      };
      /** @description Invalid or missing API key. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Malformed request body. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  determine_login_api_v1_identity_broker_determine_login_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DetermineLoginRequestDTO'];
      };
    };
    responses: {
      /** @description Login determination successful */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetermineLoginResponseDTO'];
        };
      };
      /** @description Bad Request - Invalid email format */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponseDTO'];
        };
      };
    };
  };
  create_inbox_clinical_task_api_internal_v1_ml_scribe_clinical_tasks_post: {
    parameters: {
      query?: never;
      header: {
        'Idempotency-Key': string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateInboxClinicalTaskRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateInboxClinicalTaskResponse'];
        };
      };
      /** @description user_id is not a member of workspace_id. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Unknown user_id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Idempotency-Key already in progress. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Idempotency-Key was reused with a different request body. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  send_session_expiring_notification_api_internal_v1_ml_scribe_notifications_session_expiring_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SessionExpiringRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_patient_expiring_notification_api_internal_v1_ml_scribe_notifications_patient_expiring_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PatientExpiringRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_delete_patient_profiles_api_internal_v1_ml_scribe_patient_profiles_bulk_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkDeletePatientProfilesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkDeletePatientProfilesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_team_patient_profiles_api_internal_v1_ml_scribe_patient_profiles_search_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SearchTeamPatientsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MatchResult'];
        };
      };
      /** @description Team does not belong to the supplied workspace. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Unknown team_id, or (exact-lookup mode) patient_profile_id not found in the team's roster. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_expired_comms_sessions_for_user_endpoint_api_internal_v1_ml_scribe_comms_sessions_delete_expired_for_user_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteExpiredForUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteExpiredForUserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  session_permissions_api_internal_v1_ml_scribe_permissions_session_permissions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SessionPermissionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['service__permission__schema__SessionPermissionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_repeat_scripts_review_api_internal_v1_ml_scribe_apollo_repeat_scripts_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RepeatScriptsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RepeatScriptsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  advance_harness_api_internal_v1_ml_scribe_apollo_harness_advance_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdvanceHarnessRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  dispatch_sessions_bulk_deleted_event_api_internal_v1_ml_scribe_sessions_bulk_deleted_event_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DispatchSessionsBulkDeletedEventRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_merge_group_api_internal_v1_ml_scribe_sessions__session_id__session_merge_merge_group_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionMergeGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_delete_session_transcripts_api_internal_v1_ml_scribe_sessions_bulk_transcript_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkDeleteSessionTranscriptsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkDeleteSessionTranscriptsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_members_api_internal_v1_ml_scribe_teams__team_id__members_get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamMembersResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_workspace_id_api_internal_v1_ml_scribe_teams__team_id__workspace_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamWorkspaceResponse'];
        };
      };
      /** @description Unknown team_id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Team's workspace could not be resolved to a structural root (broken/soft-deleted hierarchy); would violate workspace_id == root_team_id. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  notify_team_api_internal_v1_ml_scribe_teams__team_id__notifications_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NotifyTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotifyTeamResponse'];
        };
      };
      /** @description Team does not belong to the supplied workspace. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Unknown team_id. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ingest_usage_event_api_internal_v1_ml_scribe_usage_events_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IngestUsageEventRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_session_storage_days_api_internal_v1_ml_scribe_users__kinde_user_id__session_storage_days_get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        kinde_user_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionStorageDaysResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_patient_storage_days_api_internal_v1_ml_scribe_users__kinde_user_id__patient_storage_days_get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        kinde_user_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PatientStorageDaysResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_transcript_storage_days_api_internal_v1_ml_scribe_users__kinde_user_id__transcript_storage_days_get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        kinde_user_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TranscriptStorageDaysResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  extract_clinical_codes_api_internal_v1_ml_scribe_coding_extractions_post: {
    parameters: {
      query?: never;
      header: {
        'Idempotency-Key': string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ClinicalCodingExtractionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClinicalCodingExtractionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_files_by_user_api_v1_ml_scribe_form_files__get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadedFileResponse'][];
        };
      };
    };
  };
  upload_files_api_v1_ml_scribe_form_files__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_files_api_v1_ml_scribe_form_files__post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadedFileResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_file_by_id_api_v1_ml_scribe_form_files__file_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        file_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadedFileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_file_by_id_api_v1_ml_scribe_form_files__file_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        file_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_devices_api_v1_ml_scribe_hardware_device__get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HardwareDeviceResponse'][];
        };
      };
    };
  };
  link_device_api_v1_ml_scribe_hardware_device__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LinkHardwareDeviceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_device_api_v1_ml_scribe_hardware_device__id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_device_api_v1_ml_scribe_hardware_device__id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnlinkHardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_device_api_v1_ml_scribe_hardware_device__id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateHardwareDeviceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  openfeature_api_v1_ml_scribe_openfeature_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  healthcheck_api_v1_ml_scribe_healthcheck_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  get_auth_token_claims_api_v1_ml_scribe_auth_test_token_claims_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthTokenClaimsResponse'];
        };
      };
    };
  };
  get_language_list_api_v1_ml_scribe_language__get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageListResponse'];
        };
      };
    };
  };
  new_language_creation_api_v1_ml_scribe_language__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LanguageCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_language_api_v1_ml_scribe_language__patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LanguageUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_default_language_api_v1_ml_scribe_language_default_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DefaultLanguageUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateDefaultLanguageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_specialty_language_prompt_configuration_api_v1_ml_scribe_language_batch_prompt_configuration_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PromptConfigurationUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptConfigurationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_supported_languages_api_v1_ml_scribe_language_supported_languages_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageView'][];
        };
      };
    };
  };
  get_supported_output_languages_api_v1_ml_scribe_language_supported_output_languages_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageView'][];
        };
      };
    };
  };
  get_supported_input_languages_api_v1_ml_scribe_language_supported_input_languages_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageView'][];
        };
      };
    };
  };
  get_onboarding_options_api_v1_ml_scribe_onboarding_options_get: {
    parameters: {
      query?: {
        country?: components['schemas']['CountryCode'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OnboardingOptionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_document_by_id_api_v1_ml_scribe_sessions__session_id__document__document_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DocumentView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_document_api_v1_ml_scribe_sessions__session_id__document__document_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_document_api_v1_ml_scribe_sessions__session_id__document__document_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateDocumentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DocumentView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_documents_api_v1_ml_scribe_sessions__session_id__document__get: {
    parameters: {
      query?: {
        sort_by?: components['schemas']['DocumentSortBy'];
        sort_order?: components['schemas']['shared__enums__enums__SortOrder'];
        skip?: number;
        limit?: number | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetDocumentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_document_api_v1_ml_scribe_sessions__session_id__document_create_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateDocumentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DocumentView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_document_api_v1_ml_scribe_sessions__session_id__document_empty_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateDocumentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DocumentView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  extract_personalization_insights_from_document_api_v1_ml_scribe_sessions__session_id__document__document_id__generate_insights_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': boolean;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_sessions_api_v1_ml_scribe_sessions__get: {
    parameters: {
      query?: {
        page_size?: number | null;
        last_session_created_at?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_session_api_v1_ml_scribe_sessions__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['domains__sessions__schemas__CreateSessionRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__sessions__schemas__CreateSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_by_id_api_v1_ml_scribe_sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetailedSessionView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_api_v1_ml_scribe_sessions__session_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_session_api_v1_ml_scribe_sessions__session_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SessionUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdatedDetailedSessionView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_delete_sessions_api_v1_ml_scribe_sessions_batch_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchDeleteSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_transcript_api_v1_ml_scribe_sessions__session_id__transcript_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitTranscriptRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_transcript_api_v1_ml_scribe_sessions__session_id__transcript_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  share_consult_note_api_v1_ml_scribe_sessions__session_id__share_consult_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ShareConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ShareConsultNotesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_audio_api_v1_ml_scribe_sessions__session_id__upload_audio_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_audio_api_v1_ml_scribe_sessions__session_id__upload_audio_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': boolean;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_supported_languages_api_v1_ml_scribe_sessions__session_id__supported_languages_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  test_get_audio_duration_prod_api_v1_ml_scribe_sessions_test_duration_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_test_get_audio_duration_prod_api_v1_ml_scribe_sessions_test_duration_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': number;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_specialties_api_v1_ml_scribe_specialties_get: {
    parameters: {
      query?: {
        country?: components['schemas']['CountryCode'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['AdminSpecialtiesResponse']
            | components['schemas']['schemas__response__SpecialtiesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_new_specialty_api_v1_ml_scribe_specialties_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SpecialtyCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_specialty_api_v1_ml_scribe_specialties__specialty_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['SpecialtyResponse']
            | components['schemas']['schemas__response__SimpleSpecialtyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_specialty_by_id_api_v1_ml_scribe_specialties__specialty_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SpecialtyUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_update_specialty_api_v1_ml_scribe_specialties_batch_update_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SpecialtyBatchUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_supported_languages_api_v1_ml_scribe_specialties__specialty_id__supported_languages_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_specialty_prompt_configuration_api_v1_ml_scribe_specialties__specialty_id__prompt_configuration_get: {
    parameters: {
      query: {
        language_code: components['schemas']['LanguageCode'];
      };
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptConfigurationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_specialty_prompt_configuration_api_v1_ml_scribe_specialties__specialty_id__prompt_configuration_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PromptConfigurationCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptConfigurationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_specialty_prompt_configuration_api_v1_ml_scribe_specialties__specialty_id__prompt_configuration_patch: {
    parameters: {
      query: {
        language_code: components['schemas']['LanguageCode'];
      };
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PromptConfigurationUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptConfigurationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  onboarding_script_api_v1_ml_scribe_specialties__specialty_id__onboarding_script_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OnboardingScriptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_note_structure_options_api_v1_ml_scribe_specialties__specialty_id__note_structure_options_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NoteStructureOptionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_transcript_by_specialty_name_api_v1_ml_scribe_specialties_transcript_by_name__specialty_name__get: {
    parameters: {
      query?: {
        /** @description BCP-47 locale (e.g. en, en-AU). Loads transcripts/<locale>/*.md with fallback. */
        locale?: string | null;
      };
      header?: never;
      path: {
        specialty_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyTranscriptResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_onboarding_v2_assets_api_v1_ml_scribe_specialties__specialty_name__onboarding_v2_assets_get: {
    parameters: {
      query?: {
        /** @description BCP-47 locale (e.g. en, es-ES). Loads <locale>.json with fallback through shorter tags to en. */
        locale?: string | null;
      };
      header?: never;
      path: {
        specialty_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OnboardingV2AssetsResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_specialty_groups_api_v1_ml_scribe_specialty_groups_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyGroupsResponse'];
        };
      };
    };
  };
  create_specialty_group_api_v1_ml_scribe_specialty_groups_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SpecialtyGroupCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_specialty_group_api_v1_ml_scribe_specialty_groups__group_name__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        group_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_specialty_to_group_api_v1_ml_scribe_specialty_groups__group_name__specialties__specialty_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        group_name: string;
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_specialty_from_group_api_v1_ml_scribe_specialty_groups__group_name__specialties__specialty_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        group_name: string;
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_specialty_group_api_v1_ml_scribe_specialty_groups__group_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        group_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SpecialtyGroupUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_specialty_group_api_v1_ml_scribe_specialty_groups__group_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        group_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_or_create_user_api_v1_ml_scribe_user__get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  delete_user_api_v1_ml_scribe_user__delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description User already fully deleted */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['ErrorResponse']
            | components['schemas']['DeleteUserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_attributes_api_v1_ml_scribe_user__patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  record_patient_summary_dismissal_api_v1_ml_scribe_user_patient_summary_turn_off_prompt_record_dismissal_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecordPatientSummaryDismissalRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RecordPatientSummaryDismissalResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  extend_user_unlimited_quota_until_time_api_v1_ml_scribe_user_extend_unlimit_quota_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExtendFreeTrialRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_billing_portal_url_api_v1_ml_scribe_user_billing_portal_get: {
    parameters: {
      query?: {
        fe_endpoint?: string | null;
        /** @description If set, opens Stripe subscription update confirm for this tier; `period` defaults to the user's current plan cycle when omitted */
        tier?: components['schemas']['SubscriptionTier'] | null;
        /** @description Billing period for the target plan; defaults to `user.plan_cycle` when `tier` is set */
        period?: components['schemas']['shared__enums__enums__Period'] | null;
        /** @description Target price directly instead of deriving it from `tier`; accepted only for Clinician Max prices. Mutually exclusive with `tier`. */
        price_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BillingPortalSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  logout_user_api_v1_ml_scribe_user_logout_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': boolean;
        };
      };
    };
  };
  update_name_api_v1_ml_scribe_user_name_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateUserNameRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_integration_api_v1_ml_scribe_user_submit_integration_request_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['database__mongo__base__IntegrationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_idp_properties_api_v1_ml_scribe_user_kinde_properties_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserKindePropertiesResponse'];
        };
      };
    };
  };
  update_kinde_user_region_api_v1_ml_scribe_user_kinde_properties_region_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateUserRegionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  register_device_api_v1_ml_scribe_user_register_device_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RegisterDeviceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_onboarding_task_as_completed_api_v1_ml_scribe_user_onboarding_tasks__onboarding_task__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        onboarding_task: components['schemas']['OnboardingTask'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_current_onboarding_sub_task_api_v1_ml_scribe_user_onboarding_subtasks_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PendingSubStep'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_profile_picture_api_v1_ml_scribe_user_profile_picture_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_profile_picture_api_v1_ml_scribe_user_profile_picture_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': boolean;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_profile_picture_api_v1_ml_scribe_user_profile_picture_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': boolean;
        };
      };
    };
  };
  handle_all_events_api_v1_ml_scribe_stripe_webhook_all_events_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  password_changed_api_v1_ml_scribe_internal_auth_notifications_password_changed_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PasswordChangedRequest'];
      };
    };
    responses: {
      /** @description Event processed (sent), or skipped because the umbrella flag is off or the user has no recipient email. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PasswordChangedResponse'];
        };
      };
      /** @description Invalid or missing API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No User matches the forwarded user_ref_id */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Malformed request body — FastAPI/Pydantic validation failure. Detail is a list of per-field validation issues. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal M2M API not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  mfa_enrolled_api_v1_ml_scribe_internal_auth_notifications_mfa_enrolled_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MfaEnrolledRequest'];
      };
    };
    responses: {
      /** @description Event processed (sent), or skipped because the umbrella flag is off or the user has no recipient email. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MfaEnrolledResponse'];
        };
      };
      /** @description Invalid or missing API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No User matches the forwarded user_ref_id */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Malformed request body — FastAPI/Pydantic validation failure. Detail is a list of per-field validation issues. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal M2M API not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  mfa_unenrolled_api_v1_ml_scribe_internal_auth_notifications_mfa_unenrolled_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MfaUnenrolledRequest'];
      };
    };
    responses: {
      /** @description Event processed (sent), or skipped because the umbrella flag is off or the user has no recipient email. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MfaUnenrolledResponse'];
        };
      };
      /** @description Invalid or missing API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No User matches the forwarded user_ref_id */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Malformed request body — FastAPI/Pydantic validation failure. Detail is a list of per-field validation issues. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal M2M API not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  login_from_new_device_api_v1_ml_scribe_internal_auth_notifications_login_from_new_device_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LoginFromNewDeviceRequest'];
      };
    };
    responses: {
      /** @description Event processed (sent), or skipped because the umbrella flag is off or the user has no recipient email. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LoginFromNewDeviceResponse'];
        };
      };
      /** @description Invalid or missing API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No User matches the forwarded user_ref_id */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Malformed request body — FastAPI/Pydantic validation failure. Detail is a list of per-field validation issues. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal M2M API not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_user_api_v1_ml_scribe_internal_get_user_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GetUserRequest'];
      };
    };
    responses: {
      /** @description User lookup completed (user may be null if not found) */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetUserResponse'];
        };
      };
      /** @description Invalid or missing API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal M2M API not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  rebind_user_email_api_v1_ml_scribe_internal_rebind_user_email_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RebindUserEmailRequest'];
      };
    };
    responses: {
      /** @description Rebind processed (status discriminator distinguishes outcome). */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RebindUserEmailResponse'];
        };
      };
      /** @description Invalid or missing API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Another user already owns the supplied email */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid request format */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal M2M API not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_user_mfa_config_api_v1_ml_scribe_internal_get_user_mfa_config_post: {
    parameters: {
      query?: never;
      header?: {
        'X-API-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GetUserMFAConfigRequest'];
      };
    };
    responses: {
      /** @description Request completed (mfa_config is always present, is_mfa_enabled is False if user not found or MFA disabled) */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetUserMFAConfigResponse'];
        };
      };
      /** @description Invalid or missing API key */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid request format */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Internal M2M API not configured */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_user_details_api_v1_ml_scribe_internal_admin_user_get: {
    parameters: {
      query?: {
        kinde_user_id?: string | null;
        stripe_customer_id?: string | null;
        email?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_new_user_api_v1_ml_scribe_internal_admin_users_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_by_kinde_user_id_api_v1_ml_scribe_internal_admin_users__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_details_api_v1_ml_scribe_internal_admin_users__user_ref_id__patch: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_is_subscribed_status_api_v1_ml_scribe_internal_admin_users__user_ref_id__is_subscribed_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  change_user_email_api_v1_ml_scribe_internal_admin_users__user_ref_id__change_email_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ChangeUserEmailRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_sessions_api_v1_ml_scribe_internal_admin_sessions_get: {
    parameters: {
      query?: {
        kinde_user_id?: string | null;
        email?: string | null;
        start_time?: string | null;
        end_time?: string | null;
        /** @description Optional filter: return only sessions belonging to this workspace. Omitted: sessions across all of the user's workspaces (unchanged default). */
        workspace_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['SessionsResponse']
            | components['schemas']['SessionsResponseWithoutPII'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_by_id_api_v1_ml_scribe_internal_admin_sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_llm_call_records_by_task_api_v1_ml_scribe_internal_admin_users__user_ref_id__llm_call_records_by_task_get: {
    parameters: {
      query: {
        task: components['schemas']['LLMTask'];
        page_size?: number | null;
        page?: number | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LLMCallRecord'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  session_get_transcript_api_v1_ml_scribe_internal_admin_sessions__session_id__transcript_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalSessionTranscriptsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  session_gen_notes_api_v1_ml_scribe_internal_admin_sessions__session_id__generate_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_records_api_v1_ml_scribe_internal_admin_session_records_get: {
    parameters: {
      query?: {
        is_reviewed?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionRecordsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_prompt_by_prompt_id_api_v1_ml_scribe_internal_admin_prompts__prompt_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        prompt_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_prompt_by_prompt_id_api_v1_ml_scribe_internal_admin_prompt__prompt_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        prompt_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reload_prompts_api_v1_ml_scribe_internal_admin_prompts_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  get_session_events_api_v1_ml_scribe_internal_admin_session_events_get: {
    parameters: {
      query: {
        session_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionEventsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_roles_api_v2_ml_scribe_internal_admin_admins_roles_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminUserRolesResponse'];
        };
      };
    };
  };
  start_agent_maker_run_api_v2_ml_scribe_internal_admin_agent_maker_runs_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StartAgentMakerRunRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StartRunResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ama_suggested_questions_api_v2_ml_scribe_internal_admin_agent_maker_runs__agent_run_id__suggested_questions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Agent run id whose durable transcript grounds the suggestions */
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AmaSuggestedQuestionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FollowUpQuestionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resolve_self_subject_api_v2_ml_scribe_internal_admin_agent_harness_self_resolve_subject_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ResolvedSubject'];
        };
      };
    };
  };
  list_runs_api_v2_ml_scribe_internal_admin_agent_harness_runs_get: {
    parameters: {
      query?: {
        status?:
          | PathsApiV2MlScribeInternalAdminAgentHarnessRunsGetParametersQueryStatusAnyOf0[]
          | null;
        config_id?: string[] | null;
        actor_user_id?: string[] | null;
        config_owner_user_id?: string[] | null;
        subject_user_id?: string | null;
        organization_id?: string[] | null;
        team_id?: string[] | null;
        created_after?: string | null;
        created_before?: string | null;
        updated_after?: string | null;
        updated_before?: string | null;
        sort_by?: PathsApiV2MlScribeInternalAdminAgentHarnessRunsGetParametersQuerySort_by;
        sort_order?: PathsApiV2MlScribeInternalAdminAgentHarnessRunsGetParametersQuerySort_order;
        include_orphaned?: boolean;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListRunsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_run_api_v2_ml_scribe_internal_admin_agent_harness_runs_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StartRunResponse'];
        };
      };
    };
  };
  submit_turn_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__turns_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__internal_admin__agent_harness__SubmitTurnResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_attachment_download_url_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__attachments__attachment_id__download_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
        attachment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__agent_events__AttachmentDownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  internal_admin_agent_harness_run_scoped_stream_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__stream_get: {
    parameters: {
      query?: never;
      header?: {
        'Last-Event-ID'?: string | null;
      };
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  internal_admin_agent_harness_user_events_api_v2_ml_scribe_internal_admin_agent_harness_events_get: {
    parameters: {
      query?: {
        /** @description Optional pack subscription. Repeat per pack name (e.g. ?packs=bus&packs=ui). Empty / absent → all packs. */
        packs?: string[];
      };
      header?: {
        'Last-Event-ID'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  internal_admin_agent_harness_agent_events_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__events_get: {
    parameters: {
      query?: {
        /** @description Optional pack subscription. Repeat per pack name (e.g. ?packs=bus&packs=ui). Empty / absent → all packs. */
        packs?: string[];
      };
      header?: {
        'Last-Event-ID'?: string | null;
      };
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resolve_approval_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__approvals__approval_id__resolve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
        approval_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ResolveApprovalRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ResolveApprovalResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_event_resolutions_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__event_resolutions_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FrontendEventResolutionView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  close_run_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__close_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CloseRunResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  cancel_active_turn_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__cancel_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CancelTurnResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_configs_api_v2_ml_scribe_internal_admin_agent_harness_configs_get: {
    parameters: {
      query?: {
        owner_user_id?: string[] | null;
        name_contains?: string | null;
        created_after?: string | null;
        created_before?: string | null;
        updated_after?: string | null;
        updated_before?: string | null;
        sort_by?: PathsApiV2MlScribeInternalAdminAgentHarnessConfigsGetParametersQuerySort_by;
        sort_order?: PathsApiV2MlScribeInternalAdminAgentHarnessConfigsGetParametersQuerySort_order;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListConfigsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_config_api_v2_ml_scribe_internal_admin_agent_harness_configs_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateAgentConfigRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentConfigResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentConfigResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAgentConfigRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentConfigResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_config_versions_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__versions_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentConfigVersionResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_config_version_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__versions__version__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
        version: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentConfigResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  rollback_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__rollback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RollbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentConfigResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  render_config_python_api_v2_ml_scribe_internal_admin_agent_harness_configs_render_python_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RenderAgentConfigPythonRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RenderAgentConfigPythonResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_config_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__export_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentConfigExport'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_configs_api_v2_ml_scribe_internal_admin_agent_harness_configs_import_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AgentConfigExport'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportConfigResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  recommend_config_api_v2_ml_scribe_internal_admin_agent_harness_configs_recommend_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecommendAgentConfigRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RecommendAgentConfigResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_config_runs_api_v2_ml_scribe_internal_admin_agent_harness_configs__agent_id__runs_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListRunsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_prompt_variables_api_v2_ml_scribe_internal_admin_agent_harness_prompt_variables_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptVariableDefinition'][];
        };
      };
    };
  };
  list_tools_api_v2_ml_scribe_internal_admin_agent_harness_tools_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ToolSpecResponse'][];
        };
      };
    };
  };
  list_hooks_api_v2_ml_scribe_internal_admin_agent_harness_hooks_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HookSpecResponse'][];
        };
      };
    };
  };
  list_models_api_v2_ml_scribe_internal_admin_agent_harness_models_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProviderModels'][];
        };
      };
    };
  };
  get_run_details_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_run_conversation_page_api_v2_ml_scribe_internal_admin_agent_harness_runs__agent_run_id__conversation_get: {
    parameters: {
      query?: {
        offset?: number;
        limit?: number;
      };
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConversationPageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_schedules_api_v2_ml_scribe_internal_admin_agent_harness_schedules_get: {
    parameters: {
      query?: {
        paused?: boolean | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListSchedulesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        schedule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScheduleDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        schedule_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateScheduleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentScheduleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        schedule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  pause_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__pause_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        schedule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentScheduleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unpause_schedule_api_v2_ml_scribe_internal_admin_agent_harness_schedules__schedule_id__unpause_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        schedule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentScheduleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ia_list_inbox_items_api_v2_ml_scribe_internal_admin_agent_harness_inbox_items_get: {
    parameters: {
      query?: {
        /** @description Harness subject id to query inbox for (canonical user_ref_id; legacy Kinde uid accepted during migration) */
        subject_user_id?: string | null;
        status?: string[] | null;
        agent_run_id?: string | null;
        created_after?: string | null;
        created_before?: string | null;
        updated_after?: string | null;
        updated_before?: string | null;
        sort_by?: PathsApiV2MlScribeInternalAdminAgentHarnessInboxItemsGetParametersQuerySort_by;
        sort_order?: PathsApiV2MlScribeInternalAdminAgentHarnessInboxItemsGetParametersQuerySort_order;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InboxListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ia_get_inbox_item_api_v2_ml_scribe_internal_admin_agent_harness_inbox_items__approval_id__get: {
    parameters: {
      query: {
        /** @description Harness subject id (canonical user_ref_id; legacy Kinde uid accepted during migration) */
        subject_user_id: string;
      };
      header?: never;
      path: {
        approval_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InboxItem'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ia_get_inbox_count_api_v2_ml_scribe_internal_admin_agent_harness_inbox_count_get: {
    parameters: {
      query: {
        /** @description Harness subject id (canonical user_ref_id; legacy Kinde uid accepted during migration) */
        subject_user_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InboxCountResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ia_list_inbox_subjects_api_v2_ml_scribe_internal_admin_agent_harness_inbox_subjects_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InboxSubjectsResponse'];
        };
      };
    };
  };
  get_agent_harness_status_api_v2_ml_scribe_internal_admin_agent_harness_status_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentHarnessStatusResponse'];
        };
      };
    };
  };
  list_event_types_api_v2_ml_scribe_internal_admin_event_rules_event_types_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EventTypeInfo'][];
        };
      };
    };
  };
  list_filter_fields_api_v2_ml_scribe_internal_admin_event_rules_event_types__event_type__filter_fields_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        event_type: components['schemas']['EventType'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FilterFieldInfo'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_event_rules_api_v2_ml_scribe_internal_admin_event_rules_get: {
    parameters: {
      query?: {
        scope_type?: PathsApiV2MlScribeInternalAdminEventRulesGetParametersQueryScope_typeAnyOf0 | null;
        scope_id?: string | null;
        event_type?: string | null;
        enabled?: boolean | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListEventRulesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_event_rule_api_v2_ml_scribe_internal_admin_event_rules_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateEventRuleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['pkg__event_triggers__schemas__EventRuleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        rule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['pkg__event_triggers__schemas__EventRuleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        rule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        rule_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateEventRuleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['pkg__event_triggers__schemas__EventRuleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  enable_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__enable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        rule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['pkg__event_triggers__schemas__EventRuleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  disable_event_rule_api_v2_ml_scribe_internal_admin_event_rules__rule_id__disable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        rule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['pkg__event_triggers__schemas__EventRuleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_dispatch_api_v2_ml_scribe_internal_admin_event_rules_dispatch_preview_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DispatchEventRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DispatchPreviewResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_dispatch_api_v2_ml_scribe_internal_admin_event_rules_dispatch_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DispatchEventRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DispatchConfirmResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflows_api_v2_ml_scribe_internal_admin_workflows_get: {
    parameters: {
      query?: {
        owner_user_id?: string | null;
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
        product_surface?: PathsApiV2MlScribeInternalAdminWorkflowsGetParametersQueryProduct_surfaceAnyOf0 | null;
        agent_config_id?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_workflow_api_v2_ml_scribe_internal_admin_workflows_post: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminCreateWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_api_v2_ml_scribe_internal_admin_workflows__workflow_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_workflow_api_v2_ml_scribe_internal_admin_workflows__workflow_id__delete: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
      };
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_api_v2_ml_scribe_internal_admin_workflows__workflow_id__patch: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
      };
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdminUpdateWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_scoped_workflow_runs_api_v2_ml_scribe_internal_admin_workflows_runs_get: {
    parameters: {
      query?: {
        team_id?: string | null;
        organization_id?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListRunsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_eval_profile_api_v2_ml_scribe_internal_admin_workflows__workflow_id__eval_profile_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowEvalProfileResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_eval_profile_api_v2_ml_scribe_internal_admin_workflows__workflow_id__eval_profile_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateWorkflowEvalProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowEvalProfileResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflow_runs_api_v2_ml_scribe_internal_admin_workflows__workflow_id__runs_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListRunsResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  run_workflow_api_v2_ml_scribe_internal_admin_workflows__workflow_id__run_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunWorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_schedule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__schedule_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScheduleResponse'] | null;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_workflow_schedule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__schedule_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetScheduleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScheduleResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_workflow_schedule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__schedule_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflow_event_rules_api_v2_ml_scribe_internal_admin_workflows__workflow_id__event_rules_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EventRuleListResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_workflow_event_rule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__event_rules_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddEventRuleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__workflows__schema__EventRuleResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_workflow_event_rule_api_v2_ml_scribe_internal_admin_workflows__workflow_id__event_rules__rule_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
        rule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  snapshot_agent_eval_dataset_api_v2_ml_scribe_internal_admin_agents_evals_datasets_snapshot_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SnapshotAgentEvalDatasetRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SnapshotAgentEvalDatasetResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agent_eval_datasets_api_v2_ml_scribe_internal_admin_agents_evals_datasets_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAgentEvalDatasetsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agent_eval_dataset_api_v2_ml_scribe_internal_admin_agents_evals_datasets__dataset_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        dataset_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentEvalDatasetDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_saved_eval_suites_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites_get: {
    parameters: {
      query?: {
        bundle_name?: string | null;
        enabled?: boolean | null;
        created_after?: string | null;
        created_before?: string | null;
        include_ad_hoc?: boolean;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListSavedEvalSuitesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_saved_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SuiteDefinition'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SavedEvalSuiteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_saved_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        suite_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SavedEvalSuiteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_saved_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        suite_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSavedEvalSuiteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SavedEvalSuiteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  score_saved_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__score_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        suite_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScoreSavedEvalSuiteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_saved_eval_suite_results_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__results_get: {
    parameters: {
      query?: {
        dataset_id?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        suite_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListSavedEvalSuiteScoresResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_saved_eval_suite_summary_api_v2_ml_scribe_internal_admin_agents_evals_saved_suites__suite_id__summary_get: {
    parameters: {
      query?: {
        dataset_id?: string | null;
      };
      header?: never;
      path: {
        suite_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SavedEvalSuiteSummaryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agent_eval_suites_api_v2_ml_scribe_internal_admin_agents_evals_suites_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAgentEvalSuitesResponse'];
        };
      };
    };
  };
  get_agent_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_suites__suite_name__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        suite_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentEvalSuiteDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  run_agent_eval_suite_api_v2_ml_scribe_internal_admin_agents_evals_suites__suite_name__run_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        suite_name: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['RunAgentEvalSuiteRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunAgentEvalSuiteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agent_eval_bundles_api_v2_ml_scribe_internal_admin_agents_evals_bundles_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAgentEvalBundlesResponse'];
        };
      };
    };
  };
  list_agent_eval_experiments_api_v2_ml_scribe_internal_admin_agents_evals_experiments_get: {
    parameters: {
      query?: {
        suite_name?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAgentEvalExperimentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agent_eval_experiment_api_v2_ml_scribe_internal_admin_agents_evals_experiments__experiment_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentEvalExperimentDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agent_eval_experiment_report_api_v2_ml_scribe_internal_admin_agents_evals_experiments__experiment_id__report_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentEvalExperimentReportResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retry_failed_agent_eval_units_api_v2_ml_scribe_internal_admin_agents_evals_experiments__experiment_id__retry_failed_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['RetryFailedUnitsRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetryFailedUnitsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agent_run_scores_api_v2_ml_scribe_internal_admin_agents_evals_runs__agent_run_id__scores_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAgentRunScoresResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_api_status_check_logs_api_v2_ml_scribe_internal_admin_api_status_check_log_get: {
    parameters: {
      query?: {
        /** @description Optional. Repeat to filter by multiple Kinde user IDs (e.g. ?kinde_user_id=A&kinde_user_id=B). Omit to return all entries. */
        kinde_user_id?: string[] | null;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ApiStatusCheckLogListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_ref_bans_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_get: {
    parameters: {
      query?: {
        limit?: number;
        user_ref_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserRefBanListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_user_ref_ban_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserRefBanCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  lookup_user_ref_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_lookup_get: {
    parameters: {
      query: {
        user_ref_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserRefBanLookupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_ref_ban_logs_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_logs_get: {
    parameters: {
      query?: {
        user_ref_id?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AbuseBanLogListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revoke_user_ref_ban_api_v2_ml_scribe_internal_admin_abuse_user_ref_bans_revoke_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserRefBanRevokeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_email_bans_api_v2_ml_scribe_internal_admin_abuse_email_bans_get: {
    parameters: {
      query?: {
        limit?: number;
        email?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmailBanListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_email_ban_api_v2_ml_scribe_internal_admin_abuse_email_bans_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EmailBanCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  lookup_email_api_v2_ml_scribe_internal_admin_abuse_email_bans_lookup_get: {
    parameters: {
      query: {
        email: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmailBanLookupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_email_ban_logs_api_v2_ml_scribe_internal_admin_abuse_email_bans_logs_get: {
    parameters: {
      query?: {
        email?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AbuseBanLogListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revoke_email_ban_api_v2_ml_scribe_internal_admin_abuse_email_bans_revoke_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EmailBanRevokeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  query_audit_logs_by_entities_api_v2_ml_scribe_internal_admin_audit_log_entities_query_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AuditLogQueryRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuditLogResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_backup_chunks_api_v2_ml_scribe_internal_admin_sessions__session_id__backup_chunks_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionBackupChunkStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_session_backup_recoveries_api_v2_ml_scribe_internal_admin_sessions__session_id__backup_recoveries_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackupRecoveryListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  trigger_session_backup_recovery_api_v2_ml_scribe_internal_admin_sessions__session_id__backup_recoveries_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TriggerBackupRecoveryRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackupRecoveryAttemptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_backup_recovery_models_api_v2_ml_scribe_internal_admin_backup_recovery_models_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackupRecoveryModelsResponse'];
        };
      };
    };
  };
  retranscribe_uploaded_audio_api_v2_ml_scribe_internal_admin_sessions__session_id__uploaded_audio_retranscriptions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RetranscribeAudioSourceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AudioSourceRetranscriptionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retranscribe_hardware_audio_api_v2_ml_scribe_internal_admin_sessions__session_id__hardware_audio_retranscriptions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RetranscribeAudioSourceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AudioSourceRetranscriptionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retranscribe_backup_audio_api_v2_ml_scribe_internal_admin_sessions__session_id__backup_audio_retranscriptions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RetranscribeAudioSourceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AudioSourceRetranscriptionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  activate_clinician_trial_api_v2_ml_scribe_internal_admin_billings__user_ref_id__activate_clinician_trial_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ActivateClinicianTrialResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_billing_account_api_v2_ml_scribe_internal_admin_billings__user_ref_id__billing_account_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminBillingAccountResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_credit_allowance_api_v2_ml_scribe_internal_admin_billings__user_ref_id__credit_allowance_get: {
    parameters: {
      query: {
        /** @description One of the target user's workspaces. Membership is required. */
        workspace_id: string;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['InternalAdminCreditAllowanceResponse']
            | null;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_seat_summary_api_v2_ml_scribe_internal_admin_billings_teams__team_id__seats_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SeatSummaryResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_subscription_api_v2_ml_scribe_internal_admin_billings_sync_subscription_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SyncSubscriptionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncSubscriptionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Too Many Requests */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  fix_stripe_customer_id_api_v2_ml_scribe_internal_admin_billings_fix_stripe_customer_id_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FixStripeCustomerIdRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FixStripeCustomerIdResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_chats_api_v2_ml_scribe_internal_admin_chats_get: {
    parameters: {
      query?: {
        /** @description Filter chats by session ID */
        session_id?: string | null;
        /** @description Filter chats by user_ref_id */
        user_ref_id?: string | null;
        /** @description Filter chats by user email (searches users first) */
        user_email?: string | null;
        /** @description Filter by user authentication status (True=logged in, False=anonymous) */
        is_authenticated?: boolean | null;
        /** @description Page number */
        page?: number;
        /** @description Number of chats per page */
        page_size?: number;
        /** @description Field to order by */
        order_by?: components['schemas']['ChatOrderBy'];
        /** @description Sort order direction */
        order_direction?: components['schemas']['shared__enums__enums__SortOrder'];
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
        /** @description Include soft-deleted chats */
        include_deleted?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminChatListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_chat_api_v2_ml_scribe_internal_admin_chats__chat_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminChatResponse'];
        };
      };
      /** @description Chat not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_retention_lineage_campaign_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_campaigns_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StartRetentionLineageCampaignRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetentionLineageCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  advance_retention_lineage_campaign_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_campaigns__campaign_id__advance_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdvanceRetentionLineageCampaignRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetentionLineageCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_retention_lineage_campaign_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_campaigns__campaign_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetentionLineageCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_retention_lineage_campaigns_for_monitoring_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_monitoring_campaigns_get: {
    parameters: {
      query?: {
        orchestration_key?: string | null;
        phase?: components['schemas']['EvidenceChatLineageCampaignPhase'] | null;
        status?: components['schemas']['EvidenceChatLineageCampaignStatus'] | null;
        operation?: components['schemas']['EvidenceChatLineageCampaignOperation'] | null;
        dry_run?: boolean | null;
        created_from?: string | null;
        created_to?: string | null;
        offset?: number;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetentionLineageCampaignListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_retention_lineage_campaign_for_monitoring_api_v2_ml_scribe_internal_admin_evidence_chat_retention_lineage_monitoring_campaigns__campaign_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetentionLineageCampaignMonitoringResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_external_organization_api_v2_ml_scribe_internal_admin_external_org__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateExternalOrganizationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExternalOrganizationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_external_organization_api_v2_ml_scribe_internal_admin_external_org__org_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        org_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpdateExternalOrganizationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExternalOrganizationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_organizations_api_v2_ml_scribe_internal_admin_organizations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListOrganizationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_organization_api_v2_ml_scribe_internal_admin_organizations_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateOrganizationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAOrganizationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_organization_api_v2_ml_scribe_internal_admin_organizations__org_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        org_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAOrganizationWithTeamsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_organization_api_v2_ml_scribe_internal_admin_organizations__organization_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Organization successfully deleted */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_organization_api_v2_ml_scribe_internal_admin_organizations__organization_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpdateOrganizationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAOrganizationWithTeamsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_audio_files_api_v2_ml_scribe_internal_admin_sessions__session_id__audio_files_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionAudioFilesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_audio_chunks_api_v2_ml_scribe_internal_admin_sessions__session_id__audio_chunks_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionAudioChunksResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ai_command_api_v2_ml_scribe_internal_admin_sessions__session_id__ai_command__ai_command_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        ai_command_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminAICommandResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_documents_api_v2_ml_scribe_internal_admin_sessions__session_id__document__get: {
    parameters: {
      query?: {
        skip?: number;
        limit?: number | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminSessionDocumentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_api_v2_ml_scribe_internal_admin_sessions__session_id__template__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_csat_sessions_by_template_id_api_v2_ml_scribe_internal_admin_sessions_templates__template_id__csat_sessions_get: {
    parameters: {
      query?: {
        page?: number;
        page_size?: number;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionsResponseWithFeedback'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_overview_api_v2_ml_scribe_internal_admin_sessions__session_id__overview_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionOverviewResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_context_documents_api_v2_ml_scribe_internal_admin_sessions__session_id__context_documents_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminContextDocumentsListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_external_session_api_v2_ml_scribe_internal_admin_sessions__session_id__external_session_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExternalSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_merge_group_api_v2_ml_scribe_internal_admin_sessions__session_id__merge_group_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionMergeGroupInspection'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_team_id_audit_api_v2_ml_scribe_internal_admin_sessions_team_id_audit_get: {
    parameters: {
      query?: {
        user_ref_id?: string | null;
        kinde_user_id?: string | null;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionTeamIdAuditResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_list_latency_api_v2_ml_scribe_internal_admin_sessions_list_latency_get: {
    parameters: {
      query?: {
        user_ref_id?: string | null;
        kinde_user_id?: string | null;
        scope?: components['schemas']['SessionScope'];
        cursor?: string | null;
        page_size?: number;
        sort_by?: components['schemas']['SessionSortBy'];
        sort_order?: components['schemas']['shared__enums__enums__SortOrder'];
        session_status?: components['schemas']['SessionStatus'][] | null;
        date_from?: string | null;
        date_to?: string | null;
        patient_profile_ids?: string[] | null;
        clinician_ids?: string[] | null;
        q?: string | null;
        is_urgent?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionListLatencyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_custom_templates_api_v2_ml_scribe_internal_admin_templates__get: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
        kinde_user_id?: string | null;
        team_id?: string | null;
        organization_id?: string | null;
        template_category?: components['schemas']['TemplateCategory'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplatesResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_api_v2_ml_scribe_internal_admin_templates__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_api_v2_ml_scribe_internal_admin_templates__template_id__get: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
      };
      header?: never;
      path: {
        template_id: string | null;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_template_delete_api_v2_ml_scribe_internal_admin_templates__template_id__delete: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
      };
      header?: never;
      path: {
        template_id: string | null;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_api_v2_ml_scribe_internal_admin_templates__template_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string | null;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplateRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_versions_api_v2_ml_scribe_internal_admin_templates__template_id__versions_get: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
      };
      header?: never;
      path: {
        template_id: string | null;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplateCreationRecordResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_version_api_v2_ml_scribe_internal_admin_templates__template_id__versions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string | null;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLatestVersionControlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateVersionControlResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_version_summary_api_v2_ml_scribe_internal_admin_templates__template_id__version_summary_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string | null;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateVersionSummaryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_version_summaries_api_v2_ml_scribe_internal_admin_templates_version_summaries_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TemplateVersionSummariesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateVersionSummariesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_custom_form_template_with_pdf_api_v2_ml_scribe_internal_admin_templates_form_templates_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_create_custom_form_template_with_pdf_api_v2_ml_scribe_internal_admin_templates_form_templates_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates__get: {
    parameters: {
      query?: {
        /** @description Page number (1-indexed) */
        page?: number;
        /** @description Items per page (max 100) */
        page_size?: number;
        template_category?: components['schemas']['GalleryTemplateCategory'] | null;
        source_region?: components['schemas']['GalleryTemplateRegion'] | null;
        country?: string | null;
        specialty?: string | null;
        author_id?: string | null;
        include_deleted?: boolean;
        search?: string | null;
        /** @description Sort as field:order. Fields: created_at, updated_at, views_count, imports_count, title, template_category. Order: 1=asc, -1=desc */
        sort?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GalleryTemplateListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateGalleryTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GalleryTemplateBasicInfo'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_create_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchCreateGalleryTemplatesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchCreateResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_delete_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchDeleteGalleryTemplatesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchDeleteResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_update_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchUpdateTemplateItem'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchUpdateResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_gallery_template_pdf_api_v2_ml_scribe_internal_admin_gallery_templates_upload_pdf_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_gallery_template_pdf_api_v2_ml_scribe_internal_admin_gallery_templates_upload_pdf_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadPdfResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Request Entity Too Large */
      413: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GalleryTemplateDetail'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__template_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GalleryTemplateBasicInfo'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__template_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateGalleryTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GalleryTemplateBasicInfo'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  restore_gallery_template_api_v2_ml_scribe_internal_admin_gallery_templates__template_id__restore_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GalleryTemplateBasicInfo'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_upload_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_upload_post: {
    parameters: {
      query?: {
        /** @description If false, validate only. If true, create templates. */
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_batch_upload_gallery_templates_api_v2_ml_scribe_internal_admin_gallery_templates_batch_upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GalleryTemplateBatchUploadResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  regenerate_seo_context_api_v2_ml_scribe_internal_admin_form_seo__template_id__seo_context_regenerate_post: {
    parameters: {
      query?: {
        /** @description If false, generate and return seo_context only. If true, persist updates. */
        execute?: boolean;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRegenerateSeoContextResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  regenerate_seo_content_api_v2_ml_scribe_internal_admin_form_seo__template_id__seo_content_regenerate_post: {
    parameters: {
      query?: {
        /** @description If false, generate and return seo_content only. If true, persist updates. */
        execute?: boolean;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['InternalAdminRegenerateSeoContentRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRegenerateSeoContentResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_form_seo_api_v2_ml_scribe_internal_admin_form_seo__template_id__save_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminSaveFormSeoRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminSaveFormSeoResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_upload_seo_context_api_v2_ml_scribe_internal_admin_form_seo_seo_context_bulk_upload_post: {
    parameters: {
      query?: {
        /** @description If false, validate only. If true, write SEO field updates. */
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_bulk_upload_seo_context_api_v2_ml_scribe_internal_admin_form_seo_seo_context_bulk_upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminBulkUploadSeoContextResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_teams_api_v2_ml_scribe_internal_admin_teams__get: {
    parameters: {
      query?: {
        keyword?: string | null;
        /** @description Page number; omit to return all teams */
        page?: number | null;
        /** @description Teams per page; omit to return all teams */
        page_size?: number | null;
        /** @description Field to order by */
        order_by?: components['schemas']['TeamOrderBy'];
        /** @description Sort order direction */
        order_direction?: components['schemas']['shared__enums__enums__SortOrder'];
        is_managed?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminTeamsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_team_api_v2_ml_scribe_internal_admin_teams__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_onboarding_email_to_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_send_onboarding_email_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminSendOnboardingEmailRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminSendOnboardingEmailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_details_api_v2_ml_scribe_internal_admin_teams__team_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_api_v2_ml_scribe_internal_admin_teams__team_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_details_api_v2_ml_scribe_internal_admin_teams__team_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpdateTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_member_history_api_v2_ml_scribe_internal_admin_teams__team_id__member_history_get: {
    parameters: {
      query: {
        /** @description Range start (ISO 8601). */
        from: string;
        /** @description Range end (ISO 8601, inclusive). */
        to: string;
      };
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MemberHistoryResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_add_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_delete_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminBulkRemoveTeamMembersSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminBulkRemoveTeamMembersResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_member_api_v2_ml_scribe_internal_admin_teams__team_id__members__member_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_member_api_v2_ml_scribe_internal_admin_teams__team_id__members__member_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpdateTeamMemberSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_member_api_v2_ml_scribe_internal_admin_teams__team_id__member__member_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_move_team_members_api_v2_ml_scribe_internal_admin_teams__team_id__members_move_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminBulkMoveTeamMembersSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminBulkMoveTeamMembersResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resend_all_pending_team_invitations_api_v2_ml_scribe_internal_admin_teams__team_id__invitations_resend_all_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminResendInvitationsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resend_selected_team_invitations_api_v2_ml_scribe_internal_admin_teams__team_id__invitations_resend_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminResendSelectedInvitationsSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminResendInvitationsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_mfa_api_v2_ml_scribe_internal_admin_teams__team_id__mfa_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminTeamMFARequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SimpleTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_organization_user_team_mapping_api_v2_ml_scribe_internal_admin_teams_user_team_mapping_import_post: {
    parameters: {
      query?: {
        execute?: boolean;
        organization_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_import_organization_user_team_mapping_api_v2_ml_scribe_internal_admin_teams_user_team_mapping_import_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['FileUploadResult']
            | components['schemas']['FileValidateResult'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_organization_user_team_mapping_api_v2_ml_scribe_internal_admin_teams_user_team_mapping_export_get: {
    parameters: {
      query?: {
        organization_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IATeamAssignmentListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_user_api_v2_ml_scribe_internal_admin_users_create_user_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateUserRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_onboarding_email_api_v2_ml_scribe_internal_admin_users__user_ref_id__onboarding_email_send_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OnboardingEmailSendResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_details_api_v2_ml_scribe_internal_admin_users__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_joined_teams_api_v2_ml_scribe_internal_admin_users__user_ref_id__teams_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JoinedTeamsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_invitation_link_api_v2_ml_scribe_internal_admin_users__user_ref_id__invitation_link_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminInvitationLinkResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  change_user_name_api_v2_ml_scribe_internal_admin_users__user_ref_id__name_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminChangeUserNameRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  change_user_jurisdiction_api_v2_ml_scribe_internal_admin_users__user_ref_id__jurisdiction_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminChangeUserJurisdictionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_create_user_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_create_user_post: {
    parameters: {
      query?: {
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_bulk_create_user_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_create_user_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['BulkCreateUserCSVFileUploadResult']
            | components['schemas']['BulkCreateUserCSVFileValidateResult'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_and_data_permanently_api_v2_ml_scribe_internal_admin_users__user_ref_id__permanent_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['InternalAdminDeleteUserPermanentlyRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_update_user_identity_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_update_user_identity_patch: {
    parameters: {
      query?: {
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_bulk_update_user_identity_by_csv_api_v2_ml_scribe_internal_admin_users_bulk_update_user_identity_patch'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['BulkUpdateUserIdentityCSVFileValidateResult']
            | components['schemas']['BulkUpdateUserIdentityCSVFileUploadResult'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_lookup_users_api_v2_ml_scribe_internal_admin_users_bulk_lookup_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkUserLookupRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkUserLookupResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_users_api_v2_ml_scribe_internal_admin_users_get: {
    parameters: {
      query?: {
        keyword?: string | null;
        /** @description Page number */
        page?: number;
        /** @description Number of users per page */
        page_size?: number;
        /** @description Field to order by */
        order_by?: components['schemas']['UserOrderBy'];
        /** @description Sort order direction */
        order_direction?: components['schemas']['shared__enums__enums__SortOrder'];
        /** @description Filter by users with third party license (True/False/None) */
        has_third_party_license?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListUsersResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_personalization_profile_api_v2_ml_scribe_internal_admin_users__user_ref_id__personalization_profile_get: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PersonalizationDataResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_referral_profile_api_v2_ml_scribe_internal_admin_users__user_ref_id__referral_profile_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteReferralProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reset_user_mfa_api_v2_ml_scribe_internal_admin_users__user_id__reset_MFA_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_dictations_api_v2_ml_scribe_internal_admin_users__kinde_user_id__dictations_get: {
    parameters: {
      query?: {
        cursor?: string | null;
        limit?: number;
        from?: string | null;
        to?: string | null;
      };
      header?: never;
      path: {
        kinde_user_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DictationsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_dictation_detail_api_v2_ml_scribe_internal_admin_users__kinde_user_id__dictations__dictation_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        kinde_user_id: string;
        dictation_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DictationDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  trigger_user_to_user_migration_api_v2_ml_scribe_internal_admin_users_migrate_to_user_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TriggerUserToUserMigrationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TriggerMigrationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  trigger_user_region_migration_api_v2_ml_scribe_internal_admin_users_migrate_region_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TriggerUserRegionMigrationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TriggerMigrationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  admin_logout_user_everywhere_api_v2_ml_scribe_internal_admin_users__user_ref_id__logout_everywhere_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Sessions revoked */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLogoutEverywhereResponse'];
        };
      };
      /** @description Missing users:write permission */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Target user cannot be revoked (no user reference ID) */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Server error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_workspaces_api_v2_ml_scribe_internal_admin_workspaces_get: {
    parameters: {
      query?: {
        /** @description Match a workspace name (substring) OR its id */
        keyword?: string | null;
        /** @description Email or user ref — restrict to workspaces that include that user (any role) */
        member_query?: string | null;
        /** @description Minimum live member count (inclusive) */
        min_members?: number | null;
        /** @description Maximum live member count (inclusive) */
        max_members?: number | null;
        /** @description Page number */
        page?: number;
        /** @description Number of workspaces per page */
        page_size?: number;
        /** @description Field to order by */
        order_by?: components['schemas']['WorkspaceOrderBy'];
        /** @description Sort order direction */
        order_direction?: components['schemas']['shared__enums__enums__SortOrder'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__workspace__api__internal_admin__workspaces__workspaces_schema__ListWorkspacesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workspace_detail_api_v2_ml_scribe_internal_admin_workspaces__workspace_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkspaceDetailResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workspace_api_v2_ml_scribe_internal_admin_workspaces__workspace_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpdateWorkspaceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkspaceDetailResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  list_workspace_members_api_v2_ml_scribe_internal_admin_workspaces__workspace_id__members_get: {
    parameters: {
      query?: {
        /** @description Page number */
        page?: number;
        /** @description Number of members per page */
        page_size?: number;
        /** @description Filter members by name or email */
        keyword?: string | null;
        /** @description Filter members by role */
        role?: components['schemas']['WorkspaceRole'] | null;
      };
      header?: never;
      path: {
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListWorkspaceMembersResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_suspension_logs_api_v2_ml_scribe_internal_admin_user_suspension_logs_get: {
    parameters: {
      query?: {
        user_ref_id?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SuspensionLogListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_suspended_users_api_v2_ml_scribe_internal_admin_user_suspension_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SuspendedUsersListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_user_suspension_api_v2_ml_scribe_internal_admin_user_suspension_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetSuspensionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SuspensionStateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_suspension_state_api_v2_ml_scribe_internal_admin_user_suspension__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SuspensionStateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_latest_template_revisions_api_v2_ml_scribe_internal_admin_template_revisions_latest_get: {
    parameters: {
      query?: {
        review_status?: components['schemas']['TemplateReviewStatus'] | null;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminGetTemplateRevisionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_example_output_api_v2_ml_scribe_internal_admin_template_revisions__template_id__revisions__revision_number__example_output_and_description_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string | null;
        revision_number: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['InternalAdminGenerateTemplateExampleOutputAndDescriptionRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminGenerateTemplateExampleOutputAndDescriptionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  approve_template_revision_api_v2_ml_scribe_internal_admin_template_revisions__template_id__revisions__revision_number__review_status_approve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string | null;
        revision_number: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['InternalAdminApproveTemplateRevisionRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminUpdateTemplateRevisionReviewStatusResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reject_template_revision_api_v2_ml_scribe_internal_admin_template_revisions__template_id__revisions__revision_number__review_status_reject_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string | null;
        revision_number: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminUpdateTemplateRevisionReviewStatusResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  transcriber_comparison_api_v2_ml_scribe_internal_admin_transcriptions_comparison_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'multipart/form-data': components['schemas']['Body_transcriber_comparison_api_v2_ml_scribe_internal_admin_transcriptions_comparison_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminTranscriberComparisonResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_users_with_direct_integration_api_v2_ml_scribe_internal_admin_direct_integration_user_get: {
    parameters: {
      query: {
        ehr_provider: components['schemas']['EHRProvider'];
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListUsersWithDirectIntegrationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  list_direct_integration_sessions_by_user_api_v2_ml_scribe_internal_admin_direct_integration_sessions_get: {
    parameters: {
      query: {
        user_id: string;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListDirectIntegrationSessionsByUserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_roles_api_v2_ml_scribe_internal_admin_roles_get: {
    parameters: {
      query?: {
        team_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetRolesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_role_api_v2_ml_scribe_internal_admin_roles__role_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        role_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateRoleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        path: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        path: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        path: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        path: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  proxy_integrations_marketplace_api_v2_ml_scribe_internal_admin_integrations_marketplace__path__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        path: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_teams_to_organization_api_v2_ml_scribe_internal_admin_organizations__org_id__teams_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        org_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddTeamsToOrganizationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_team_from_organization_api_v2_ml_scribe_internal_admin_organizations__org_id__teams__team_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        org_id: string;
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehrlaunch_profiles_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__get: {
    parameters: {
      query?: {
        page?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRLaunchProfileListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_ehrlaunch_profile_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateEHRLaunchProfileInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRLaunchProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehrlaunch_profile_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__profile_name__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        profile_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRLaunchProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_ehrlaunch_profile_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__profile_name__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        profile_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRLaunchProfileDeleteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_ehrlaunch_profile_api_v2_ml_scribe_internal_admin_ehrlaunch_profile__profile_name__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        profile_name: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateEHRLaunchProfileInput'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRLaunchProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_profile_group_api_v2_ml_scribe_internal_admin_ehrlaunch_profile_group_profiles_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignProfileGroupRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AssignProfileGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_profile_groups_api_v2_ml_scribe_internal_admin_ehrlaunch_profile_group_profiles_list_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProfileGroupListResponse'];
        };
      };
    };
  };
  delete_profile_group_api_v2_ml_scribe_internal_admin_ehrlaunch_profile_group_profiles__profile_group__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        profile_group: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteProfileGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_profile_group_api_v2_ml_scribe_internal_admin_ehrlaunch_profile_group_profiles__profile_group__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        profile_group: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateProfileGroupRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateProfileGroupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_member_api_v2_ml_scribe_internal_admin_organizations__organization_id__teams__team_id__members__user_ref_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        organization_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTeamMemberRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationMembersView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_member_api_v2_ml_scribe_internal_admin_organizations__organization_id__teams__team_id__members__relation_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        relation_id: string;
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_global_admins_api_v2_ml_scribe_internal_admin_organizations__organization_id__global_admins_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IAAddGlobalAdminRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAAddOrganizationMembersResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_organization_members_api_v2_ml_scribe_internal_admin_organizations__organization_id__teams__team_id__members_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IAAddOrganizationMembersRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAAddOrganizationMembersResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_organization_members_api_v2_ml_scribe_internal_admin_organizations__organization_id__members_get: {
    parameters: {
      query?: {
        role_ids?: string[] | null;
        'role_ids[]'?: string[] | null;
        page?: number;
        page_size?: number;
        order_by?: components['schemas']['OrganizationMemberOrdering'];
        is_descending?: boolean;
        search?: string | null;
        team_ids?: string[] | null;
        'team_ids[]'?: string[] | null;
        specialty_ids?: string[] | null;
        'specialty_ids[]'?: string[] | null;
        show_pending_invitations_only?: boolean;
      };
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationMembersResponse'];
        };
      };
      /** @description Organization not found or user is not a member of the organization */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  move_member_between_teams_api_v2_ml_scribe_internal_admin_organizations__organization_id__teams__source_team_id__members__user_ref_id__move_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_team_id: string;
        organization_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MoveMemberToTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationMembersView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_add_on_products_api_v2_ml_scribe_internal_admin_product_add_on_get: {
    parameters: {
      query?: {
        page?: number;
        page_size?: number;
        ehr_provider?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminGetAddOnProductsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_add_on_product_api_v2_ml_scribe_internal_admin_product_add_on_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminCreateAddOnProductRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminCreateAddOnProductResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_add_on_product_api_v2_ml_scribe_internal_admin_product_add_on__add_on_product_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        add_on_product_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminUpdateAddOnProductRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminUpdateAddOnProductResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_delete_add_on_products_api_v2_ml_scribe_internal_admin_product_add_on_batch_delete_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminBatchDeleteAddOnProductRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_ehr_launch_profiles_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_get: {
    parameters: {
      query?: {
        kinde_user_id?: string | null;
        internal_id?: string | null;
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserEHRLaunchProfileListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_user_ehr_launch_profile_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateUserEHRLaunchProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserEHRLaunchProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_create_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_import_post: {
    parameters: {
      query?: {
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_bulk_create_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_import_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['FileValidateResult']
            | components['schemas']['FileUploadResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_delete_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_bulk_delete_post: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_bulk_delete_user_ehr_launch_profiles_by_import_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_bulk_delete_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['BulkDeleteUserEHRLaunchProfilesValidateResult']
            | components['schemas']['BulkDeleteUserEHRLaunchProfilesResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_ehr_launch_profile_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile__user_ehr_launch_profile_id__patch: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
      };
      header?: never;
      path: {
        user_ehr_launch_profile_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['apis__v2__internal_admin__user_ehr_launch_profile__schema__UpdateUserEHRLaunchProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserEHRLaunchProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_ehr_launch_profile_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_batch_delete_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchDeleteUserEHRLaunchProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_user_ehr_launch_profile_api_v2_ml_scribe_internal_admin_user_ehr_launch_profile_migration_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MigrateUserEHRLaunchProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MigrateUserEHRLaunchProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_sso_connections_api_v2_ml_scribe_internal_admin_sso_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListSSOResponse'];
        };
      };
    };
  };
  get_valid_collections_api_v2_ml_scribe_internal_admin_regional_sync_valid_collections_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ValidCollectionsResponse'];
        };
      };
    };
  };
  export_collection_api_v2_ml_scribe_internal_admin_regional_sync_export_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExportCollectionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportCollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upsert_collection_api_v2_ml_scribe_internal_admin_regional_sync_upsert_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpsertCollectionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpsertCollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  insert_collection_api_v2_ml_scribe_internal_admin_regional_sync_insert_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InsertCollectionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InsertCollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_api_v2_ml_scribe_internal_admin_system_template_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_api_v2_ml_scribe_internal_admin_system_template__template_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_templates_by_tags_api_v2_ml_scribe_internal_admin_system_template_by_tags_post: {
    parameters: {
      query?: {
        /** @description Search keyword for template names */
        keyword?: string | null;
        /** @description Page number */
        page?: number;
        /** @description Number of templates per page */
        page_size?: number;
        /** @description Field to order by (name, created_at, updated_at) */
        order_by?: string;
        /** @description Sort order direction (asc or desc) */
        order_direction?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GetTemplatesByUserAttributesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_delete_templates_by_ids_api_v2_ml_scribe_internal_admin_system_template_batch_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': string[];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_update_templates_by_ids_api_v2_ml_scribe_internal_admin_system_template_batch_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchUpdateTemplatesByIdRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchUpdateTemplatesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_active_template_version_api_v2_ml_scribe_internal_admin_system_template__template_id__versions__version__activate_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
        version: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_create_template_by_csv_api_v2_ml_scribe_internal_admin_system_template_bulk_create_template_post: {
    parameters: {
      query?: {
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_bulk_create_template_by_csv_api_v2_ml_scribe_internal_admin_system_template_bulk_create_template_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['BulkCreateTemplateCSVFileUploadResult']
            | components['schemas']['BulkCreateTemplateCSVFileValidateResult'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_form_system_template_api_v2_ml_scribe_internal_admin_system_template_form_templates_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_create_form_system_template_api_v2_ml_scribe_internal_admin_system_template_form_templates_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalTemplateResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_specialties_api_v2_ml_scribe_internal_admin_specialties_with_template_counts_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminSpecialtiesResponse'];
        };
      };
    };
  };
  get_specialties_by_group_api_v2_ml_scribe_internal_admin_specialties_by_group_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtiesGroupedByGroupResponse'];
        };
      };
    };
  };
  get_specialty_detail_api_v2_ml_scribe_internal_admin_specialties__specialty_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        specialty_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SpecialtyDetailsAdminResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_content_translations_api_v2_ml_scribe_internal_admin_content_translations_download_get: {
    parameters: {
      query?: {
        resources?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_content_translations_api_v2_ml_scribe_internal_admin_content_translations_upload_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_content_translations_api_v2_ml_scribe_internal_admin_content_translations_upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ContentTranslationsUploadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_mappings_api_v2_ml_scribe_internal_admin_template_mappings__get: {
    parameters: {
      query: {
        /** @description Filter by kinde user ID */
        kinde_user_id: string;
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateMappingResponse'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_mapping_api_v2_ml_scribe_internal_admin_template_mappings__post: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTemplateMappingRequest'];
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateMappingResponse'];
        };
      };
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateMappingResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_onboarding_sessions_api_v2_ml_scribe_internal_admin_integrations_onboarding_session_get: {
    parameters: {
      query?: {
        /** @description Optional user ID to filter sessions by. Omitted: list all. */
        kinde_user_id?: string | null;
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
        /** @description Optional status filter */
        status?: components['schemas']['OnboardingSessionStatus'] | null;
        /** @description Optional provider filter */
        provider?: string | null;
        /** @description Maximum number of sessions to return */
        limit?: number;
        /** @description Number of sessions to skip */
        skip?: number;
        /** @description Include soft-deleted sessions */
        include_deleted?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OnboardingSessionListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_onboarding_session_api_v2_ml_scribe_internal_admin_integrations_onboarding_session__onboarding_session_id__get: {
    parameters: {
      query?: {
        /** @description Include a soft-deleted session */
        include_deleted?: boolean;
      };
      header?: never;
      path: {
        onboarding_session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OnboardingSessionWithFunctionalityDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_onboarding_session_api_v2_ml_scribe_internal_admin_integrations_onboarding_session__onboarding_session_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        onboarding_session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OnboardingSessionDeleteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_providers_api_v2_ml_scribe_internal_admin_integrations_onboarding_session_providers_all_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string[];
        };
      };
    };
  };
  get_health_api_v2_ml_scribe_internal_admin_integrations_template_inspector_health_get: {
    parameters: {
      query: {
        region: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HealthResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_apply_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__apply_post: {
    parameters: {
      query: {
        region: string;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ApplyRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ApplyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_example_output_api_v2_ml_scribe_internal_admin_integrations_template_inspector_example_output_post: {
    parameters: {
      query: {
        region: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExampleOutputRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExampleOutputResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_join_inspector_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__get: {
    parameters: {
      query: {
        region: string;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InspectorJoinResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_draft_preview_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__preview_post: {
    parameters: {
      query: {
        region: string;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PreviewRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PreviewResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_inspector_queue_api_v2_ml_scribe_internal_admin_integrations_template_inspector_get: {
    parameters: {
      query: {
        region: string;
        /** @description Optional owner kinde user ids (comma-separated or repeated). */
        cohort_kinde_user_ids?: string[] | null;
        /** @description Indexed equality on template id, clinician kinde id, or exact clinician email. Names and workspace id are not searchable. */
        search?: string | null;
        /** @description Optional four-state status filter applied after page-local compute */
        status?: components['schemas']['MigrationStatus'] | null;
        /** @description 1-indexed page number */
        page?: number;
        /** @description Items per page (max 100) */
        pageSize?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['QueueListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_revert_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__revert_post: {
    parameters: {
      query: {
        region: string;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RevertRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RevertResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_suggest_api_v2_ml_scribe_internal_admin_integrations_template_inspector__template_id__suggest_post: {
    parameters: {
      query: {
        region: string;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SuggestRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SuggestResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_mk_template_requests_api_v2_ml_scribe_internal_admin_mk_template_requests__get: {
    parameters: {
      query?: {
        /** @description Filter by request status */
        status_filter?: components['schemas']['MKCustomTemplateRequestStatus'] | null;
        /** @description Search in template name and description */
        search_keyword?: string | null;
        /** @description Page number */
        page?: number;
        /** @description Items per page */
        page_size?: number;
        /** @description Field to sort by (created_at, updated_at, template_name, status) */
        order_by?: string;
        /** @description Sort direction (asc or desc) */
        order_direction?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedMKCustomTemplateRequestResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_mk_template_request_admin_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MKCustomTemplateRequestResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  soft_delete_mk_template_request_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MKCustomTemplateRequestResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  accept_mk_template_request_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__accept_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['AcceptMKCustomTemplateRequestBody']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MKCustomTemplateRequestResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  complete_mk_template_request_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__complete_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CompleteMKCustomTemplateRequestBody'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MKCustomTemplateRequestResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reject_mk_template_request_api_v2_ml_scribe_internal_admin_mk_template_requests__request_id__reject_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['RejectMKCustomTemplateRequestBody']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MKCustomTemplateRequestResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reset_user_quota_api_v2_ml_scribe_internal_admin_quota_reset_user_quota_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ResetUserQuotaRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ResetUserQuotaResponse'];
        };
      };
      /** @description Invalid user_mongo_id format */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reset_all_users_quota_api_v2_ml_scribe_internal_admin_quota_reset_all_users_quota_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkResetQuotaRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkResetQuotaResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_billable_metrics_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BillableMetricResponse'][];
        };
      };
    };
  };
  register_billable_metric_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateMetricRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BillableMetricResponse'];
        };
      };
      /** @description A metric with this metric_key already exists. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_billable_metric_options_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics_options_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MetricOptionsResponse'];
        };
      };
    };
  };
  list_metric_limits_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__limits_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LimitResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_metric_limit_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__limits_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLimitRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LimitResponse'];
        };
      };
      /** @description No metric with this metric_key. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description A limit with this limit_key already exists. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description metered_overage requested for a meter with no active binding. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_assignments_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments_get: {
    parameters: {
      query?: {
        scope_type?: PathsApiV2MlScribeInternalAdminUsageEntitlementsAssignmentsGetParametersQueryScope_typeAnyOf0 | null;
        scope_id?: string | null;
        limit_key?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LimitAssignmentResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_assignment_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLimitAssignmentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LimitAssignmentResponse'];
        };
      };
      /** @description Unknown limit_key. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description A limit is already assigned for this scope and meter. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description A metered_overage limit with a non-monthly period cannot be assigned (overage bills on the monthly/yearly invoice cycle). */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_assignment_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments__assignment_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        assignment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LimitAssignmentResponse'];
        };
      };
      /** @description Assignment not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_assignment_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments__assignment_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        assignment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Assignment not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_assignment_api_v2_ml_scribe_internal_admin_usage_entitlements_assignments__assignment_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        assignment_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLimitAssignmentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LimitAssignmentResponse'];
        };
      };
      /** @description Assignment not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_service_meter_bindings_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings_get: {
    parameters: {
      query?: {
        product?: string | null;
        feature?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ServiceMeterBindingResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_service_meter_binding_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateServiceMeterBindingRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ServiceMeterBindingResponse'];
        };
      };
      /** @description Unknown meter (metric_key). */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description A binding already exists for this (product, feature). */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_supported_service_actions_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings_options_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ServiceActionOption'][];
        };
      };
    };
  };
  get_service_meter_binding_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings__binding_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        binding_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ServiceMeterBindingResponse'];
        };
      };
      /** @description Binding not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_service_meter_binding_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings__binding_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        binding_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Binding not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_service_meter_binding_api_v2_ml_scribe_internal_admin_usage_entitlements_service_meter_bindings__binding_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        binding_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateServiceMeterBindingRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ServiceMeterBindingResponse'];
        };
      };
      /** @description Unknown meter (metric_key). */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Binding not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_metric_meter_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__meter_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MeterBindingResponse'];
        };
      };
      /** @description The meter has no active binding (not billable). */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_metric_meter_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__meter_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LinkMeterRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MeterBindingResponse'];
        };
      };
      /** @description No active meter with this metric_key. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The meter already has an active binding. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The Stripe meter failed link validation. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Retrieving the Stripe meter failed. */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  update_metric_meter_api_v2_ml_scribe_internal_admin_usage_entitlements_metrics__metric_key__meter_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateMeterBindingRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MeterBindingResponse'];
        };
      };
      /** @description Re-activation is not a toggle; bind a new meter. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The meter has no active binding. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description A metered_overage limit still references the meter; remove it before deactivating the binding. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  enrol_metered_billing_api_v2_ml_scribe_internal_admin_usage_entitlements_metered_billing_enrol_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EnrolMeteredBillingRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MeteredBillingProvisioningResponse'];
        };
      };
      /** @description The metric is not billable, the supplied price is invalid for its meter, or the scope addressing is invalid. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Retrieving the supplied Stripe price failed. */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_metered_billing_status_api_v2_ml_scribe_internal_admin_usage_entitlements_metered_billing_status_get: {
    parameters: {
      query: {
        metric_key: string;
        scope?: PathsApiV2MlScribeInternalAdminUsageEntitlementsMeteredBillingStatusGetParametersQueryScope;
        scope_id?: string | null;
        user_ref_id?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MeteredBillingProvisioningResponse'];
        };
      };
      /** @description The scope addressing is invalid. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  run_usage_meter_event_egress_api_v2_ml_scribe_internal_admin_usage_entitlements_metered_billing_egress_run_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RunEgressRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunEgressResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  run_credit_grant_reconciler_api_v2_ml_scribe_internal_admin_usage_entitlements_credit_grants_reconcile_run_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RunCreditGrantReconcilerRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunCreditGrantReconcilerResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_entitlement_api_v2_ml_scribe_internal_admin_usage_entitlements_users__kinde_user_id___metric_key__get: {
    parameters: {
      query?: {
        period_start?: string | null;
        period_end?: string | null;
        subscription_tier?: components['schemas']['SubscriptionTier'] | null;
        period?: PathsApiV2MlScribeInternalAdminUsageEntitlementsUsersKinde_user_idMetric_keyGetParametersQueryPeriod;
      };
      header?: never;
      path: {
        kinde_user_id: string;
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EntitlementResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_organization_entitlement_api_v2_ml_scribe_internal_admin_usage_entitlements_organizations__organization_id___metric_key__get: {
    parameters: {
      query?: {
        period_start?: string | null;
        period_end?: string | null;
        subscription_tier?: components['schemas']['SubscriptionTier'] | null;
        period?: PathsApiV2MlScribeInternalAdminUsageEntitlementsOrganizationsOrganization_idMetric_keyGetParametersQueryPeriod;
      };
      header?: never;
      path: {
        organization_id: string;
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EntitlementResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workspace_entitlement_api_v2_ml_scribe_internal_admin_usage_entitlements_workspaces__workspace_id___metric_key__get: {
    parameters: {
      query?: {
        period_start?: string | null;
        period_end?: string | null;
        subscription_tier?: components['schemas']['SubscriptionTier'] | null;
        period?: PathsApiV2MlScribeInternalAdminUsageEntitlementsWorkspacesWorkspace_idMetric_keyGetParametersQueryPeriod;
      };
      header?: never;
      path: {
        workspace_id: string;
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EntitlementResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_entitlement_history_api_v2_ml_scribe_internal_admin_usage_entitlements_users__kinde_user_id___metric_key__history_get: {
    parameters: {
      query?: {
        period_start?: string | null;
        period_end?: string | null;
        subscription_tier?: components['schemas']['SubscriptionTier'] | null;
        period?: PathsApiV2MlScribeInternalAdminUsageEntitlementsUsersKinde_user_idMetric_keyHistoryGetParametersQueryPeriod;
      };
      header?: never;
      path: {
        kinde_user_id: string;
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EntitlementHistoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_organization_entitlement_history_api_v2_ml_scribe_internal_admin_usage_entitlements_organizations__organization_id___metric_key__history_get: {
    parameters: {
      query?: {
        period_start?: string | null;
        period_end?: string | null;
        subscription_tier?: components['schemas']['SubscriptionTier'] | null;
        period?: PathsApiV2MlScribeInternalAdminUsageEntitlementsOrganizationsOrganization_idMetric_keyHistoryGetParametersQueryPeriod;
      };
      header?: never;
      path: {
        organization_id: string;
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EntitlementHistoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workspace_entitlement_history_api_v2_ml_scribe_internal_admin_usage_entitlements_workspaces__workspace_id___metric_key__history_get: {
    parameters: {
      query?: {
        period_start?: string | null;
        period_end?: string | null;
        subscription_tier?: components['schemas']['SubscriptionTier'] | null;
        period?: PathsApiV2MlScribeInternalAdminUsageEntitlementsWorkspacesWorkspace_idMetric_keyHistoryGetParametersQueryPeriod;
      };
      header?: never;
      path: {
        workspace_id: string;
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EntitlementHistoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  provision_wallet_api_v2_ml_scribe_internal_admin_wallet_provision_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ProvisionWalletRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WalletSummaryResponse'];
        };
      };
      /** @description Malformed workspace_id. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No such workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  topup_wallet_api_v2_ml_scribe_internal_admin_wallet_topup_post: {
    parameters: {
      query?: never;
      header: {
        'Idempotency-Key': string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TopupRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BalanceMovementResponse'];
        };
      };
      /** @description No wallet for this workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid top-up. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  adjust_wallet_api_v2_ml_scribe_internal_admin_wallet_adjust_post: {
    parameters: {
      query?: never;
      header: {
        'Idempotency-Key': string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AdjustRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BalanceMovementResponse'];
        };
      };
      /** @description No wallet for this workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid adjustment. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  run_metered_burn_api_v2_ml_scribe_internal_admin_wallet_burn_run_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RunBurnRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunBurnResponse'];
        };
      };
      /** @description Invalid window. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_wallet_balance_api_v2_ml_scribe_internal_admin_wallet__workspace_id__balance_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WalletSummaryResponse'];
        };
      };
      /** @description No wallet for this workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_wallet_transactions_api_v2_ml_scribe_internal_admin_wallet__workspace_id__transactions_get: {
    parameters: {
      query?: {
        currency?: string | null;
        /** @description Narrow to one kind of movement; `consumption` is the burns. */
        transaction_source?: components['schemas']['TransactionSource'] | null;
        /** @description One movement by its origin — for a burn, the usage event's own id. Send it together with `transaction_source`: the pair is an indexed point lookup, while `source_ref` alone has to walk the wallet's history. */
        source_ref?: string | null;
        /** @description Newest-first, so the default returns the most recent movements. */
        limit?: number;
        /** @description Offset paging, NOT a cursor: rows sharing a `created_at` instant have no guaranteed order between requests, so a deep page can repeat or miss one. Use `source_ref` when the answer must be exact. */
        offset?: number;
      };
      header?: never;
      path: {
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WalletTransactionResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  probe_burn_stream_api_v2_ml_scribe_internal_admin_wallet_burn_stream_probe_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BurnStreamProbeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BurnStreamProbeResponse'];
        };
      };
      /** @description Not a development deployment. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  peek_burn_stream_api_v2_ml_scribe_internal_admin_wallet_burn_stream_peek_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BurnStreamReading'];
        };
      };
    };
  };
  list_catalog_products_api_v2_ml_scribe_internal_admin_rating_catalog_products_get: {
    parameters: {
      query?: {
        include_inactive?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CatalogProductResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_catalog_product_api_v2_ml_scribe_internal_admin_rating_catalog_products_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateCatalogProductRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CatalogProductResponse'];
        };
      };
      /** @description product_key already in the catalog. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid aggregation / dimensions, or an unsupported field. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_catalog_product_options_api_v2_ml_scribe_internal_admin_rating_catalog_products_options_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CatalogProductOptionsResponse'];
        };
      };
    };
  };
  get_catalog_product_api_v2_ml_scribe_internal_admin_rating_catalog_products__product_key__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        product_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CatalogProductResponse'];
        };
      };
      /** @description Unknown product_key. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_catalog_product_api_v2_ml_scribe_internal_admin_rating_catalog_products__product_key__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        product_key: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateCatalogProductRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CatalogProductResponse'];
        };
      };
      /** @description Unknown product_key. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The merged product would violate an invariant, or the body carried an unsupported field (product_key is not renamable). */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_rate_cards_api_v2_ml_scribe_internal_admin_rating_rate_cards_get: {
    parameters: {
      query?: {
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RateCardResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_rate_card_api_v2_ml_scribe_internal_admin_rating_rate_cards_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateRateCardRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RateCardWriteResponse'];
        };
      };
      /** @description rate_card_key already exists — publish a version. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid entries, an unknown or inactive catalog product, or an unsupported field. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_rate_card_versions_api_v2_ml_scribe_internal_admin_rating_rate_cards__rate_card_key__versions_get: {
    parameters: {
      query?: {
        limit?: number;
      };
      header?: never;
      path: {
        rate_card_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RateCardSummaryResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  publish_rate_card_version_api_v2_ml_scribe_internal_admin_rating_rate_cards__rate_card_key__versions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        rate_card_key: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PublishRateCardVersionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RateCardWriteResponse'];
        };
      };
      /** @description Unknown rate_card_key. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The same version was published concurrently; retry. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid entries, an unknown or inactive catalog product, or an unsupported field. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_latest_rate_card_api_v2_ml_scribe_internal_admin_rating_rate_cards__rate_card_key__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        rate_card_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RateCardResponse'];
        };
      };
      /** @description Unknown rate_card_key, or no active version. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_rate_card_version_api_v2_ml_scribe_internal_admin_rating_rate_cards__rate_card_key__versions__version__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        rate_card_key: string;
        version: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RateCardResponse'];
        };
      };
      /** @description Unknown rate_card_key/version. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_contracts_api_v2_ml_scribe_internal_admin_contracts_get: {
    parameters: {
      query?: {
        workspace_id?: string | null;
        rate_card_key?: string | null;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ContractResponse'][];
        };
      };
      /** @description Neither or both filters were given. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_contract_api_v2_ml_scribe_internal_admin_contracts_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateContractRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ContractResponse'];
        };
      };
      /** @description Malformed workspace_id. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No such workspace. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The window overlaps an active contract, the rate_card_key names no card with an active version, or the window is invalid. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  edit_contract_api_v2_ml_scribe_internal_admin_contracts__contract_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        contract_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateContractRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ContractResponse'];
        };
      };
      /** @description Malformed contract_id. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No such contract. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Only one half of the rate-card pin was sent, the merged window overlaps an active contract, the pin names no such active card version, the merged contract violates an invariant, the contract is archived, or the body carried an unsupported field. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  resync_rate_card_api_v2_ml_scribe_internal_admin_contracts__contract_id__resync_rate_card_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        contract_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['ResyncRateCardRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ContractResponse'];
        };
      };
      /** @description Malformed contract_id. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No such contract. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The contract is archived, or the target card has no active version. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  archive_contract_api_v2_ml_scribe_internal_admin_contracts__contract_id__archive_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        contract_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ContractResponse'];
        };
      };
      /** @description Malformed contract_id. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description No such contract. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description The contract is already archived. */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_allowance_policies_api_v2_ml_scribe_internal_admin_allowance_policies_get: {
    parameters: {
      query?: {
        workspace_id?: string | null;
        subscription_tier?: components['schemas']['SubscriptionTier'] | null;
        seat_type?: string | null;
        enabled?: boolean | null;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AllowancePolicyResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateAllowancePolicyRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AllowancePolicyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resolve_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies_resolve_get: {
    parameters: {
      query: {
        subscription_tier: components['schemas']['SubscriptionTier'];
        workspace_id?: string | null;
        seat_type?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AllowancePolicyResponse'] | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies__policy_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAllowancePolicyRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AllowancePolicyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  enable_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies__policy_id__enable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AllowancePolicyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  disable_allowance_policy_api_v2_ml_scribe_internal_admin_allowance_policies__policy_id__disable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        policy_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AllowancePolicyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_template_creation_records_api_v2_ml_scribe_internal_admin_template_creation_records_get: {
    parameters: {
      query: {
        /** @description User's ref_id (UUID) */
        user_ref_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateCreationRecordResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_creation_record_api_v2_ml_scribe_internal_admin_template_creation_records__record_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        record_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplateCreationRecordResponse'];
        };
      };
      /** @description Template creation record not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_cqc_practices_csv_api_v2_ml_scribe_internal_admin_cqc_practices_upload_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_cqc_practices_csv_api_v2_ml_scribe_internal_admin_cqc_practices_upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CQCPracticeUploadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_cqc_practices_stats_api_v2_ml_scribe_internal_admin_cqc_practices_stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CQCPracticeStats'];
        };
      };
    };
  };
  list_available_scripts_api_v2_ml_scribe_internal_admin_scripts_available_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AvailableScriptsResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  execute_script_api_v2_ml_scribe_internal_admin_scripts_execute_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExecuteScriptRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExecuteScriptResponse'];
        };
      };
      /** @description Accepted */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AsyncExecuteScriptResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  airflow_execute_script_api_v2_ml_scribe_internal_admin_scripts_airflow_execute_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExecuteScriptRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExecuteScriptResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_evidence_subscriptions_api_v2_ml_scribe_internal_admin_evidence_subscriptions_get: {
    parameters: {
      query?: {
        /** @description Filter by email (partial match) */
        email?: string | null;
        /** @description Filter by subscription state(s) */
        state?: components['schemas']['EvidenceSubscriptionState'][] | null;
        /** @description Filter users whose trial ends within N days */
        trial_ending_within_days?: number | null;
        /** @description Filter users created after this date */
        created_after?: string | null;
        /** @description Filter by whether user has evidence billing info */
        has_evidence_billing?: boolean | null;
        /** @description Page number */
        page?: number;
        /** @description Number of results per page */
        page_size?: number;
        /** @description Field to order by */
        order_by?: components['schemas']['EvidenceSubscriptionOrderBy'];
        /** @description Sort direction */
        order_direction?: components['schemas']['shared__enums__enums__SortOrder'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EvidenceSubscriptionListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_subscription_api_v2_ml_scribe_internal_admin_evidence_subscriptions__user_ref_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['GrantTrialAction']
          | components['schemas']['ExtendTrialAction']
          | components['schemas']['CancelAction']
          | components['schemas']['ResetEligibilityAction'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateSubscriptionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_internal_test_user_api_v2_ml_scribe_internal_admin_internal_test_users_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalTestCreateUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalTestUserCreatedResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_internal_test_user_api_v2_ml_scribe_internal_admin_internal_test_users__user_ref_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description User deleted successfully */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_internal_test_user_api_v2_ml_scribe_internal_admin_internal_test_users__user_ref_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalTestUpdateUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_internal_test_user_db_only_api_v2_ml_scribe_internal_admin_internal_test_users_db_only_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalTestCreateDbOnlyUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalTestDbOnlyUserCreatedResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  provision_test_environment_api_v2_ml_scribe_internal_admin_internal_test_provision_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalTestProvisionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalTestProvisionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  teardown_test_environment_api_v2_ml_scribe_internal_admin_internal_test_teardown_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalTestTeardownRequest'];
      };
    };
    responses: {
      /** @description Resources torn down successfully */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_internal_test_team_default_template_api_v2_ml_scribe_internal_admin_internal_test_teams__team_id__template_default_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalTestCreateTeamTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalTestCreatedTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ehr_scenario_api_v2_ml_scribe_internal_admin_internal_test_ehr_scenario_post: {
    parameters: {
      query?: never;
      header?: {
        'X-Api-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EhrScenarioRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EhrScenarioResponse'];
        };
      };
      /** @description Accepted */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EhrScenarioResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Not Implemented */
      501: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Bad Gateway */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Service Unavailable */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_intercom_user_hash_api_v2_ml_scribe_internal_admin_intercom_user_hash_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntercomUserHashResponse'];
        };
      };
    };
  };
  get_intercom_ticket_types_api_v2_ml_scribe_internal_admin_intercom_ticket_types_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
    };
  };
  get_intercom_ticket_type_api_v2_ml_scribe_internal_admin_intercom_ticket_types__ticket_type_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        ticket_type_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_quality_investigation_ticket_type_api_v2_ml_scribe_internal_admin_intercom_ticket_types_by_name_quality_investigation_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
    };
  };
  create_quality_investigation_ticket_api_v2_ml_scribe_internal_admin_intercom_tickets_quality_investigation_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateQualityInvestigationTicketRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_collections_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections_get: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_user_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections_post: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_documents_to_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddDocumentsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_document_from_collection_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__collections__collection_id__documents__document_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
        document_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_documents_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_get: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
        /** @description Filter by scope: 'all', 'user', or 'team' */
        scope?: PathsApiV2MlScribeInternalAdminEvidenceLibraryUser_ref_idDocumentsGetParametersQueryScopeAnyOf0 | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserDocumentListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_documents_and_jobs_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_and_jobs_get: {
    parameters: {
      query?: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id?: string | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserDocumentsAndJobsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_document_for_user_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_upload_post: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_document_for_user_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents_upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JobResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_document_download_url_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents__document_id__download_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['evidence__models__user_document__DownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_document_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__documents__document_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_job_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__jobs__job_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        job_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_source_lists_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_user_source_list_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists_post: {
    parameters: {
      query: {
        /** @description Scope this call to one of the target user's workspaces. Omitted: the user's default workspace is inferred. */
        workspace_id: string | null;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSourceListRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_source_list_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists__source_list_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_list_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_source_list_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists__source_list_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_list_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSourceListRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_source_list_api_v2_ml_scribe_internal_admin_evidence_library__user_ref_id__source_lists__source_list_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_list_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteSourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_partner_sync_status_api_v2_ml_scribe_internal_admin_evidence_sync_status_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PartnerSyncStatusListResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  list_partner_sync_runs_api_v2_ml_scribe_internal_admin_evidence_sync_runs_get: {
    parameters: {
      query?: {
        /** @description Filter by partner key */
        partner?: string | null;
        /** @description Only runs started at or after this timestamp (UTC). */
        since?: string | null;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncRunListResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_partner_sync_run_api_v2_ml_scribe_internal_admin_evidence_sync_runs__execution_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        execution_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncRunResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_migration_summary_api_v2_ml_scribe_internal_admin_migration_user_to_user_summary_post: {
    parameters: {
      query: {
        user_ref_id: string;
      };
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MigrationSummaryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_sessions_api_v2_ml_scribe_internal_admin_migration_user_to_user_sessions_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserToUserMigrateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateManyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_templates_api_v2_ml_scribe_internal_admin_migration_user_to_user_templates_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserToUserMigrateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateManyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_patient_profiles_api_v2_ml_scribe_internal_admin_migration_user_to_user_patient_profiles_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserToUserMigrateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateManyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_snippets_api_v2_ml_scribe_internal_admin_migration_user_to_user_snippets_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserToUserMigrateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MigrateSnippetsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_scribe_core_api_v2_ml_scribe_internal_admin_migration_user_to_user_scribe_core_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserToUserMigrateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScribeCoreMergeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_team_relation_api_v2_ml_scribe_internal_admin_migration_user_to_user_team_relation_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserToUserMigrateTeamRelationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MigrateTeamRelationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_user_deleted_api_v2_ml_scribe_internal_admin_migration_user_to_user_user__user_ref_id__mark_deleted_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MarkUserDeletedRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MarkUserDeletedResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retire_provider_identities_api_v2_ml_scribe_internal_admin_migration_user_to_user_user__user_ref_id__retire_provider_identities_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['RetireProviderIdentitiesRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetireProviderIdentitiesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preflight_user_to_user_migration_api_v2_ml_scribe_internal_admin_migration_user_to_user_preflight_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserToUserMigrateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MergePreflightResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_realign_workspace_api_v2_ml_scribe_internal_admin_migration_user_to_user_realign_workspace_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserToUserMigrateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StartWorkspaceRealignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_realign_workspace_status_api_v2_ml_scribe_internal_admin_migration_user_to_user_realign_workspace_status_get: {
    parameters: {
      query: {
        workflow_id: string;
      };
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkspaceRealignStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_region_realign_workspace_api_v2_ml_scribe_internal_admin_migration_user_region_realign_workspace_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RegionWorkspaceRealignRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StartWorkspaceRealignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_region_realign_workspace_status_api_v2_ml_scribe_internal_admin_migration_user_region_realign_workspace_status_get: {
    parameters: {
      query: {
        workflow_id: string;
      };
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkspaceRealignStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_user_api_v2_ml_scribe_internal_admin_migration_user_region_user__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportUserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_session_ids_api_v2_ml_scribe_internal_admin_migration_user_region_session_ids__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportSessionIdsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_templates_api_v2_ml_scribe_internal_admin_migration_user_region_templates__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportTemplatesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_patient_profiles_api_v2_ml_scribe_internal_admin_migration_user_region_patient_profiles__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportPatientProfilesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_snippets_api_v2_ml_scribe_internal_admin_migration_user_region_snippets__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportSnippetsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_personalization_profile_api_v2_ml_scribe_internal_admin_migration_user_region_personalization_profile__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportPersonalizationProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_team_relations_api_v2_ml_scribe_internal_admin_migration_user_region_team_relations__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportTeamRelationsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_sessions_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_sessions_export_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExportSessionsChunkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportSessionsChunkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_region_migration_api_v2_ml_scribe_internal_admin_migration_user_region_preview__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RegionMigrationPreviewResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preflight_region_migration_api_v2_ml_scribe_internal_admin_migration_user_region_preflight__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RegionPreflightResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_sessions_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_sessions_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteSessionsChunkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteSessionsChunkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_user_deleted_api_v2_ml_scribe_internal_admin_migration_user_region_user__user_ref_id__mark_deleted_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MarkUserDeletedRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MarkUserDeletedResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_user_api_v2_ml_scribe_internal_admin_migration_user_region_user_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportUserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_templates_api_v2_ml_scribe_internal_admin_migration_user_region_templates_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportTemplatesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportTemplatesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_patient_profiles_api_v2_ml_scribe_internal_admin_migration_user_region_patient_profiles_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportPatientProfilesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__workspace__api__internal_admin__migration__schemas__ImportPatientProfilesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_snippets_api_v2_ml_scribe_internal_admin_migration_user_region_snippets_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportSnippetsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportSnippetsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_personalization_profile_api_v2_ml_scribe_internal_admin_migration_user_region_personalization_profile_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportPersonalizationProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportPersonalizationProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_sessions_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_sessions_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportSessionsChunkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportSessionsChunkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_user_to_team_api_v2_ml_scribe_internal_admin_migration_user_region_team_assignment_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamAssignmentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamAssignmentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_evidence_api_v2_ml_scribe_internal_admin_migration_user_region_evidence__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportEvidenceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_user_documents_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_evidence_user_documents_export_chunk_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExportRawChunkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportRawChunkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_user_embeddings_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_evidence_user_embeddings_export_chunk_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExportRawChunkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportRawChunkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_evidence_api_v2_ml_scribe_internal_admin_migration_user_region_evidence_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportEvidenceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportEvidenceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_evidence_api_v2_ml_scribe_internal_admin_migration_user_region_evidence_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteEvidenceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteEvidenceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_evidence_api_v2_ml_scribe_internal_admin_migration_user_to_user_evidence_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MigrateEvidenceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MigrateEvidenceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_chat_ids_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_chat_ids__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportChatIdsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_chats_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_chats_export_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExportChatsChunkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportChatsChunkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_calls_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_calls__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportCallsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_chats_chunk_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_chats_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportChatsChunkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportChatsChunkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_calls_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_calls_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportCallsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportCallsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_ask_heidi_api_v2_ml_scribe_internal_admin_migration_user_region_ask_heidi_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteAskHeidiRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteAskHeidiResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_ask_heidi_api_v2_ml_scribe_internal_admin_migration_user_to_user_ask_heidi_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MigrateAskHeidiRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MigrateAskHeidiResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_cpd_api_v2_ml_scribe_internal_admin_migration_user_region_cpd__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportCPDResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_cpd_api_v2_ml_scribe_internal_admin_migration_user_region_cpd_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ImportCPDRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportCPDResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_cpd_api_v2_ml_scribe_internal_admin_migration_user_region_cpd_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteCPDRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteCPDResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  migrate_cpd_api_v2_ml_scribe_internal_admin_migration_user_to_user_cpd_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MigrateCPDRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MigrateCPDResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_settings_api_v2_ml_scribe_internal_admin_migration_user_region_settings__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionExportResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_settings_api_v2_ml_scribe_internal_admin_migration_user_region_settings_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionImportRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionImportResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_settings_api_v2_ml_scribe_internal_admin_migration_user_region_settings_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionDeleteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionDeleteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  merge_settings_api_v2_ml_scribe_internal_admin_migration_user_to_user_settings_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionMergeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionMergeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_usage_api_v2_ml_scribe_internal_admin_migration_user_region_usage__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionExportResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_usage_api_v2_ml_scribe_internal_admin_migration_user_region_usage_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionImportRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionImportResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_usage_api_v2_ml_scribe_internal_admin_migration_user_region_usage_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionDeleteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionDeleteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  merge_usage_api_v2_ml_scribe_internal_admin_migration_user_to_user_usage_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionMergeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UsageMergeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_integrations_api_v2_ml_scribe_internal_admin_migration_user_region_integrations__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionExportResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_integrations_api_v2_ml_scribe_internal_admin_migration_user_region_integrations_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionImportRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionImportResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_integrations_api_v2_ml_scribe_internal_admin_migration_user_region_integrations_delete_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionDeleteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionDeleteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  merge_integrations_api_v2_ml_scribe_internal_admin_migration_user_to_user_integrations_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionMergeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionMergeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  change_provider_regions_api_v2_ml_scribe_internal_admin_migration_user_region_change_provider_regions_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ChangeProviderRegionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChangeProviderRegionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflows_api_v2_ml_scribe_internal_admin_temporal_control_workflows_get: {
    parameters: {
      query: {
        workflow_type: string;
        status?: PathsApiV2MlScribeInternalAdminTemporalControlWorkflowsGetParametersQueryStatusAnyOf0 | null;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListWorkflowsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StartWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StartWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  describe_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowSummary'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  signal_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__signal_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SignalWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  cancel_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__cancel_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  query_workflow_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__query_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['QueryWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['QueryWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  workflow_result_api_v2_ml_scribe_internal_admin_temporal_control_workflows__workflow_id__result_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResultResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  provision_from_root_team_api_v2_ml_scribe_internal_admin_workspace_provisioning_from_root_team_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ProvisionFromRootTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProvisionFromRootTeamResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  provision_from_user_api_v2_ml_scribe_internal_admin_workspace_provisioning_from_user_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ProvisionFromUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProvisionFromUserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_all_competitions_api_v2_ml_scribe_internal_admin_competitions_get: {
    parameters: {
      query?: {
        /** @description Filter by status (draft, active, completed, archived) */
        status?: components['schemas']['CompetitionStatus'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompetitionResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_competition_api_v2_ml_scribe_internal_admin_competitions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateCompetitionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompetitionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_available_metrics_api_v2_ml_scribe_internal_admin_competitions_metrics_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AvailableMetricsResponse'];
        };
      };
    };
  };
  get_competition_api_v2_ml_scribe_internal_admin_competitions__competition_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        competition_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompetitionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  archive_competition_api_v2_ml_scribe_internal_admin_competitions__competition_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        competition_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompetitionActionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_competition_api_v2_ml_scribe_internal_admin_competitions__competition_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        competition_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateCompetitionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompetitionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_competition_status_api_v2_ml_scribe_internal_admin_competitions__competition_id__status_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        competition_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StatusUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompetitionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_admin_leaderboard_api_v2_ml_scribe_internal_admin_competitions__competition_id__leaderboard_get: {
    parameters: {
      query?: {
        limit?: number;
        page?: number;
        /** @description Search by email, name, or pseudonym (case-insensitive) */
        search?: string | null;
      };
      header?: never;
      path: {
        competition_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminLeaderboardResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_competition_exclusions_api_v2_ml_scribe_internal_admin_competitions__competition_id__exclusions_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        competition_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExclusionsListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  exclude_user_api_v2_ml_scribe_internal_admin_competitions__competition_id__exclusions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        competition_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateExclusionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExclusionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_exclusion_api_v2_ml_scribe_internal_admin_competitions__competition_id__exclusions__user_ref_id__delete: {
    parameters: {
      query?: {
        /** @description Scope of exclusion to remove */
        scope?: components['schemas']['ExclusionScope'];
      };
      header?: never;
      path: {
        competition_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExclusionActionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_user_pseudonym_api_v2_ml_scribe_internal_admin_competitions_users__user_ref_id__pseudonym_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetPseudonymRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SetPseudonymResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_visibility_api_v2_ml_scribe_internal_admin_competitions_users__user_ref_id__visibility_patch: {
    parameters: {
      query: {
        visibility: components['schemas']['LeaderboardVisibility'];
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserActionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_stats_api_v2_ml_scribe_internal_admin_competitions_users__user_ref_id__stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminUserStatsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_managed_user_rules_api_v2_ml_scribe_internal_admin_managed_user_rules_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ManagedUserRulesResponse'];
        };
      };
    };
  };
  add_managed_user_rule_api_v2_ml_scribe_internal_admin_managed_user_rules_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ManagedUserRuleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ManagedUserRulesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_managed_user_rule_api_v2_ml_scribe_internal_admin_managed_user_rules_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ManagedUserRuleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ManagedUserRulesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_all_devices_api_v2_ml_scribe_internal_admin_hardware_devices_get: {
    parameters: {
      query?: {
        /** @description Filter by user ID */
        user_id?: string | null;
        /** @description Filter by device status */
        status?: components['schemas']['HardwareDeviceStatus'] | null;
        /** @description Filter by serial number (partial match) */
        serial_number?: string | null;
        /** @description Filter by device model */
        device_model?: string | null;
        /** @description Maximum results */
        limit?: number;
        /** @description Results to skip */
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAPaginatedDevicesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_all_devices_api_v2_ml_scribe_internal_admin_hardware_devices_export_get: {
    parameters: {
      query?: {
        /** @description Filter by user ID */
        user_id?: string | null;
        /** @description Filter by device status */
        status?: components['schemas']['HardwareDeviceStatus'] | null;
        /** @description Filter by serial number (partial match) */
        serial_number?: string | null;
        /** @description Filter by device model */
        device_model?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_device_by_id_api_v2_ml_scribe_internal_admin_hardware_devices__device_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        device_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAHardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_device_by_id_api_v2_ml_scribe_internal_admin_hardware_devices__device_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        device_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAUnlinkDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_device_by_id_api_v2_ml_scribe_internal_admin_hardware_devices__device_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        device_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IAUpdateDeviceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAHardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_device_by_id_api_v2_ml_scribe_internal_admin_hardware_devices__device_id__delete_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        device_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IADeleteDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_devices_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices_get: {
    parameters: {
      query?: {
        /** @description Include unlinked devices in the response */
        include_unlinked?: boolean;
      };
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAListDevicesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_user_device_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IALinkDeviceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAHardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_device_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices__device_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        device_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAHardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_user_device_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices__device_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        device_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAUnlinkDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_device_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_devices__device_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        device_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IAUpdateDeviceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IAHardwareDeviceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_binding_code_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_device_binding_code_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IABindingCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_binding_code_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_device_binding_code_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['IAUpdateBindingCodeRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IABindingCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  clear_user_binding_code_api_v2_ml_scribe_internal_admin_users__user_ref_id__hardware_device_binding_code_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_team_source_lists_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_team_source_list_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamCreateSourceListRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_source_list_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists__source_list_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        source_list_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_source_list_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists__source_list_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        source_list_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteSourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_source_list_api_v2_ml_scribe_internal_admin_teams__team_id__source_lists__source_list_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        source_list_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSourceListRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_team_collections_api_v2_ml_scribe_internal_admin_teams__team_id__collections_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamCollectionCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        collection_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        collection_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        collection_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_documents_to_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        collection_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddDocumentsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_document_from_team_collection_api_v2_ml_scribe_internal_admin_teams__team_id__collections__collection_id__documents__document_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        collection_id: string;
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_team_documents_api_v2_ml_scribe_internal_admin_teams__team_id__documents_get: {
    parameters: {
      query?: {
        /** @description Exclude documents already in this collection */
        exclude_collection_id?: string | null;
      };
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserDocumentListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_team_workflows_api_v2_ml_scribe_internal_admin_teams__team_id__workflows_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamWorkflowListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_workflow_api_v2_ml_scribe_internal_admin_teams__team_id__workflows__recording_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_workflow_api_v2_ml_scribe_internal_admin_teams__team_id__workflows__recording_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteTeamWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  rename_team_workflow_api_v2_ml_scribe_internal_admin_teams__team_id__workflows__recording_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTeamWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  promote_team_workflow_api_v2_ml_scribe_internal_admin_teams__team_id__workflows_promote_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PromoteTeamWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  replace_team_workflow_data_api_v2_ml_scribe_internal_admin_teams__team_id__workflows__recording_id__data_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowDataUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_team_shortcuts_admin_api_v2_ml_scribe_internal_admin_teams__team_id__shortcuts_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListTeamShortcutsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_team_shortcut_admin_api_v2_ml_scribe_internal_admin_teams__team_id__shortcuts_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTeamShortcutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamShortcutSchema'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_vidal_monographs_api_v2_ml_scribe_internal_admin_vidal_upload_monographs_post: {
    parameters: {
      query: {
        /** @description Language code: fr, de, or es */
        language: PathsApiV2MlScribeInternalAdminVidalUploadMonographsPostParametersQueryLanguage;
        /** @description Validate and count files only (no parsing/storage) */
        dry_run?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_vidal_monographs_api_v2_ml_scribe_internal_admin_vidal_upload_monographs_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_emg_portfolio_api_v2_ml_scribe_internal_admin_emg_upload_portfolio_post: {
    parameters: {
      query: {
        /** @description Portfolio name: 'drugs' or 'guidelines' */
        portfolio: PathsApiV2MlScribeInternalAdminEmgUploadPortfolioPostParametersQueryPortfolio;
        /** @description Target evidence DB ('regional' or 'global') */
        target_db?: PathsApiV2MlScribeInternalAdminEmgUploadPortfolioPostParametersQueryTarget_db;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_emg_portfolio_api_v2_ml_scribe_internal_admin_emg_upload_portfolio_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ticket_formats_api_v2_ml_scribe_internal_admin_ticket_portal_formats_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TicketFormat'][];
        };
      };
    };
  };
  create_ticket_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTicketRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_linear_issues_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_linear_search_get: {
    parameters: {
      query: {
        /** @description Search term: identifier, partial number, or title keywords */
        q: string;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinearIssueLookup'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  lookup_linear_issue_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_linear_lookup_get: {
    parameters: {
      query: {
        /** @description Linear ticket identifier (e.g. DEV-1234) */
        identifier: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinearIssueLookup'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  check_duplicates_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_check_duplicates_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DuplicateCheckRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DuplicateCheckResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  watch_linear_issue_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_watch_issue_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WatchLinearIssueRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unwatch_linear_issue_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_unwatch_issue_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnwatchLinearIssueRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_my_tickets_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_mine_get: {
    parameters: {
      query: {
        /** @description Email of the user to fetch tickets for */
        email: string;
        /** @description ISO 8601 datetime to filter tickets created after. Pass 'all' to fetch all tickets regardless of date. Defaults to 3 months ago if not provided. */
        since?: string | null;
        /** @description Max results per page */
        limit?: number;
        /** @description Number of results to skip */
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedTicketResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_customer_tickets_api_v2_ml_scribe_internal_admin_ticket_portal_tickets_customer_get: {
    parameters: {
      query?: {
        /** @description Universal search term (email domain, name, etc.) */
        q?: string | null;
        /** @description Customer or org name */
        customer_name?: string | null;
        /** @description Customer email (exact) */
        email?: string | null;
        /** @description Email domain, e.g. acme.com */
        email_domain?: string | null;
        hubspot_company_id?: string | null;
        hubspot_contact_id?: string | null;
        hubspot_deal_id?: string | null;
        /** @description Status values to include */
        status_filter?: string[];
        /** @description Max results per page */
        limit?: number;
        /** @description Number of results to skip */
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedTicketResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_hubspot_api_v2_ml_scribe_internal_admin_ticket_portal_hubspot_search_get: {
    parameters: {
      query: {
        /** @description Search query string */
        q: string;
        /** @description HubSpot entity type: 'company' | 'contact' | 'deal' */
        entity_type: PathsApiV2MlScribeInternalAdminTicketPortalHubspotSearchGetParametersQueryEntity_type;
        /** @description Max results to return */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HubSpotSearchResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_hubspot_company_arr_api_v2_ml_scribe_internal_admin_ticket_portal_hubspot_company__company_id__arr_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        company_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HubSpotCompanyArrResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ticket_detail_api_v2_ml_scribe_internal_admin_ticket_portal_tickets__platform___ticket_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        platform: PathsApiV2MlScribeInternalAdminTicketPortalTicketsPlatformTicket_idGetParametersPathPlatform;
        ticket_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TicketDetail'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_ticket_note_api_v2_ml_scribe_internal_admin_ticket_portal_tickets__platform___ticket_id__notes_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        platform: PathsApiV2MlScribeInternalAdminTicketPortalTicketsPlatformTicket_idNotesPostParametersPathPlatform;
        ticket_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TicketMessage'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_orders_api_v2_ml_scribe_internal_admin_orders_get: {
    parameters: {
      query?: {
        /** @description Filter by order status */
        status?: components['schemas']['OrderStatus'] | null;
        /** @description Filter by order source */
        source?: components['schemas']['OrderSource'] | null;
        /** @description Filter by billing system (exact match) */
        billing_system?: string | null;
        /** @description Filter by internal-order reason category */
        reason_category?: components['schemas']['InternalOrderReasonCategory'] | null;
        /** @description Filter by HubSpot deal category (exact match). Pass 'Remote Pilot' for the pilots list — that value returns every order classified as a pilot, including the zero-amount ones that carry a different category or none at all */
        deal_category?: string | null;
        /** @description Filter orders created at or after this time (ISO 8601 with timezone) */
        created_at_from?: string | null;
        /** @description Filter orders created at or before this time (ISO 8601 with timezone) */
        created_at_to?: string | null;
        /** @description Search across order_id, customer_name, buyer_email and erp_order_id (case-insensitive substring) */
        q?: string | null;
        /** @description Sort direction for created_at (asc or desc) */
        sort_order?: components['schemas']['apis__v2__internal_admin__orders__orders_schema__SortOrder'];
        /** @description Number of records to skip */
        offset?: number;
        /** @description Max results (hard cap 100) */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListOrdersResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_internal_order_api_v2_ml_scribe_internal_admin_orders_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateInternalOrderRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrderListItem'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_order_api_v2_ml_scribe_internal_admin_orders__order_id__confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConfirmOrderResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  edit_order_api_v2_ml_scribe_internal_admin_orders__order_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EditOrderRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EditOrderResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  cancel_order_api_v2_ml_scribe_internal_admin_orders__order_id__cancel_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CancelOrderRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CancelOrderResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  record_pilot_outcome_api_v2_ml_scribe_internal_admin_orders__order_id__pilot_outcome_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecordPilotOutcomeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RecordPilotOutcomeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  poll_order_status_api_v2_ml_scribe_internal_admin_orders_poll_status_post: {
    parameters: {
      query: {
        /** @description Target transition: prepared or shipped */
        transition: components['schemas']['TransitionParam'];
      };
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PollOrderStatusResponse'];
        };
      };
      /** @description Invalid transition parameter */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  lookup_device_order_status_api_v2_ml_scribe_internal_admin_orders_status_get: {
    parameters: {
      query: {
        /** @description Customer email, name, or order ID (case-insensitive). */
        q: string;
        /** @description Max results (hard cap 50). */
        limit?: number;
      };
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeviceOrderStatusLookupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_send_outs_api_v2_ml_scribe_internal_admin_office_stock_send_outs_get: {
    parameters: {
      query?: {
        /** @description Filter by send-out approval status */
        send_out_status?: components['schemas']['SendOutStatus'] | null;
        /** @description Filter by send-out type */
        send_out_type?: components['schemas']['SendOutType'] | null;
        /** @description Search across order_id and tracking_number (case-insensitive) */
        q?: string | null;
        /** @description Number of records to skip */
        offset?: number;
        /** @description Max results (hard cap 100) */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListSendOutsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSendOutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendOutView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs__order_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendOutView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  approve_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs__order_id__approve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendOutView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reject_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs__order_id__reject_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendOutView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  fulfil_send_out_api_v2_ml_scribe_internal_admin_office_stock_send_outs__order_id__fulfil_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FulfilSendOutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendOutView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_stock_items_api_v2_ml_scribe_internal_admin_office_stock_get: {
    parameters: {
      query?: {
        /** @description Filter by stock item status */
        status?: components['schemas']['StockItemStatus'] | null;
        /** @description Search across uuid, source_order_id and device_id (case-insensitive substring) */
        q?: string | null;
        /** @description Number of records to skip */
        offset?: number;
        /** @description Max results (hard cap 100) */
        limit?: number;
        /** @description Include voided (soft-deleted) units, for audit. Excluded by default. */
        include_voided?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListStockItemsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_stock_api_v2_ml_scribe_internal_admin_office_stock_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddStockRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AddStockResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_stock_item_api_v2_ml_scribe_internal_admin_office_stock__stock_item_uuid__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        stock_item_uuid: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StockItemView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  void_stock_item_api_v2_ml_scribe_internal_admin_office_stock__stock_item_uuid__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        stock_item_uuid: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['VoidStockItemRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StockItemView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_qa_result_api_v2_ml_scribe_internal_admin_office_stock__stock_item_uuid__qa_result_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        stock_item_uuid: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitQaResultRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StockItemView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_feedback_api_v2_ml_scribe_internal_admin_user_feedback_get: {
    parameters: {
      query?: {
        /** @description Filter by target type (e.g. PROJECT, EVIDENCE). */
        target_type?: components['schemas']['FeedbackTargetType'] | null;
        /** @description Filter by thumb rating. */
        rating?: components['schemas']['ThumbRating'] | null;
        /** @description Kinde user ID of the submitter. */
        user_id?: string | null;
        /** @description Session ID. Project thumbs are stored with an empty string — filter by target_type=PROJECT and/or target_id instead. */
        session_id?: string | null;
        /** @description Target document ID (project id when target_type=PROJECT). */
        target_id?: string | null;
        /** @description Chat / transcript message id (Evidence / projects). */
        message_id?: string | null;
        /** @description Number of records to skip */
        offset?: number;
        /** @description Max results (hard cap 100) */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserFeedbackListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_feedback_api_v2_ml_scribe_internal_admin_user_feedback__feedback_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        feedback_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserFeedbackDetail'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_work_experience_feedback_api_v2_ml_scribe_internal_admin_work_experience_feedback_get: {
    parameters: {
      query?: {
        /** @description Filter by user email (exact match, case-insensitive). */
        email?: string | null;
        /** @description Filter by user_ref_id. */
        user_ref_id?: string | null;
        /** @description Filter by Kinde user ID. */
        kinde_user_id?: string | null;
        /** @description Number of records to skip */
        offset?: number;
        /** @description Max results (hard cap 100) */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkExperienceFeedbackListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_work_experience_feedback_api_v2_ml_scribe_internal_admin_work_experience_feedback__feedback_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        feedback_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkExperienceFeedbackDetail'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_access_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_bulk_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkAccessEntitlementResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_entitlement_types_api_v2_ml_scribe_internal_admin_access_entitlements_types_get: {
    parameters: {
      query?: {
        is_active?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementTypeListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_all_calculated_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_users__user_ref_id__calculated_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_user_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_users__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_user_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements_users__user_ref_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Entitlement already assigned to this user */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_team_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_teams__team_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_team_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements_teams__team_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Entitlement already assigned to this team */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_org_entitlements_api_v2_ml_scribe_internal_admin_access_entitlements_organisations__org_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        org_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_org_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements_organisations__org_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        org_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Entitlement already assigned to this organisation */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements__entitlement_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        entitlement_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteAccessEntitlementResponse'];
        };
      };
      /** @description Entitlement not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_entitlement_api_v2_ml_scribe_internal_admin_access_entitlements__entitlement_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        entitlement_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Entitlement not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_advertisers_api_v2_ml_scribe_internal_admin_advertisers_get: {
    parameters: {
      query?: {
        /** @description Filter by lifecycle status. */
        status?: components['schemas']['AdvertiserStatus'] | null;
        /** @description Case-insensitive contains match on advertiser name. */
        q?: string | null;
        /** @description Page number (1-based). */
        page?: number;
        /** @description Advertisers per page. */
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAdvertisersResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_advertiser_api_v2_ml_scribe_internal_admin_advertisers_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateAdvertiserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdvertiserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_advertiser_api_v2_ml_scribe_internal_admin_advertisers__advertiser_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        advertiser_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdvertiserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_advertiser_api_v2_ml_scribe_internal_admin_advertisers__advertiser_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        advertiser_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAdvertiserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdvertiserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  archive_advertiser_api_v2_ml_scribe_internal_admin_advertisers__advertiser_id__archive_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        advertiser_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdvertiserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  restore_advertiser_api_v2_ml_scribe_internal_admin_advertisers__advertiser_id__restore_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        advertiser_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdvertiserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_ad_campaigns_api_v2_ml_scribe_internal_admin_ad_campaigns_get: {
    parameters: {
      query?: {
        /** @description Restrict to one advertiser's campaigns. */
        advertiser_id?: string | null;
        /** @description Filter by lifecycle status. */
        status?: components['schemas']['AdCampaignStatus'] | null;
        /** @description Case-insensitive contains match on campaign name. */
        q?: string | null;
        /** @description Include ARCHIVED campaigns when no status is given. */
        include_archived?: boolean;
        /** @description Page number (1-based). */
        page?: number;
        /** @description Campaigns per page. */
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAdCampaignsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateAdCampaignRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAdCampaignRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  schedule_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__schedule_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  activate_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__activate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  pause_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__pause_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  complete_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__complete_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  archive_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__archive_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  restore_ad_campaign_api_v2_ml_scribe_internal_admin_ad_campaigns__campaign_id__restore_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        campaign_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdCampaignResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_ad_resources_api_v2_ml_scribe_internal_admin_ad_resources_get: {
    parameters: {
      query?: {
        /** @description Restrict to one advertiser's creatives. */
        advertiser_id?: string | null;
        /** @description Restrict to one lifecycle status. */
        status?: components['schemas']['AdResourceStatus'] | null;
        /** @description Case-insensitive contains match on resource name. */
        q?: string | null;
        /** @description Include archived resources when no status is given. */
        include_archived?: boolean;
        /** @description Page number (1-based). */
        page?: number;
        /** @description Ad resources per page. */
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAdResourcesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['CreateAdResourceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdResourceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdResourceDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAdResourceRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdResourceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  approve_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__approve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdResourceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  archive_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__archive_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdResourceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  restore_ad_resource_api_v2_ml_scribe_internal_admin_ad_resources__resource_id__restore_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdResourceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_directories_api_v2_ml_scribe_internal_admin_directories_get: {
    parameters: {
      query: {
        /** @description Organization to filter directories by. */
        organization_id: string;
        include_archived?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DirectoryListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_directory_api_v2_ml_scribe_internal_admin_directories_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['CreateDirectoryRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DirectoryUploadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_directory_api_v2_ml_scribe_internal_admin_directories__directory_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        directory_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DirectoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  activate_directory_api_v2_ml_scribe_internal_admin_directories__directory_id__activate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        directory_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DirectoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  deactivate_directory_api_v2_ml_scribe_internal_admin_directories__directory_id__deactivate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        directory_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DirectoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  archive_directory_api_v2_ml_scribe_internal_admin_directories__directory_id__archive_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        directory_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DirectoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_org_letterheads_api_v2_ml_scribe_internal_admin_letterheads_get: {
    parameters: {
      query: {
        /** @description Organization to filter letterheads by. */
        organization_id: string;
        include_archived?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterheadListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['CreateOrgLetterheadRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterheadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        letterhead_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterheadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_org_letterhead_preview_url_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__preview_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        letterhead_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterheadPreviewUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  activate_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__activate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        letterhead_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterheadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  deactivate_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__deactivate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        letterhead_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterheadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  archive_org_letterhead_api_v2_ml_scribe_internal_admin_letterheads__letterhead_id__archive_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        letterhead_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterheadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  process_batch_api_v2_ml_scribe_internal_admin_heidi_answers_process_post: {
    parameters: {
      query?: {
        set_name?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_process_batch_api_v2_ml_scribe_internal_admin_heidi_answers_process_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProcessBatchResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_batches_api_v2_ml_scribe_internal_admin_heidi_answers_batches_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchListResponse'];
        };
      };
    };
  };
  get_batch_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchSummaryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_drafts_in_batch_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__drafts_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DraftListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DraftDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateDraftReviewRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DraftDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_reviewers_api_v2_ml_scribe_internal_admin_heidi_answers_reviewers_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ApprovedReviewerListResponse'];
        };
      };
    };
  };
  send_batch_for_review_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__send_for_review_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SendBatchForReviewRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MarkSentForReviewResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  publish_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__publish_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PublishDraftResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_publish_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_publish_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['BulkPublishDraftsRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkPublishDraftsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_signoff_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_signoff_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkSignoffDraftsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkSignoffDraftsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_reset_to_ready_for_review_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_reset_to_ready_for_review_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['BulkResetToReadyForReviewRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkResetToReadyForReviewResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reject_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__reject_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RejectDraftRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RejectDraftResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_reject_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_reject_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkRejectDraftsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkRejectDraftsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unpublish_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__unpublish_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnpublishDraftRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnpublishDraftResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_unpublish_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_unpublish_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkUnpublishDraftsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkUnpublishDraftsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__delete_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteDraftRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteDraftResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_delete_drafts_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__bulk_delete_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkDeleteDraftsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkDeleteDraftsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retry_draft_api_v2_ml_scribe_internal_admin_heidi_answers_drafts__draft_id__retry_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetryDraftResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retry_failed_drafts_in_batch_api_v2_ml_scribe_internal_admin_heidi_answers_batches__batch_id__retry_failed_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        batch_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetryBatchFailedResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  backfill_agent_chat_user_ref_api_v2_ml_scribe_internal_admin_agent_chat_user_ref_backfill_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AgentChatBackfillRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentChatBackfillResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  backfill_agent_harness_user_ref_api_v2_ml_scribe_internal_admin_agent_harness_user_ref_backfill_post: {
    parameters: {
      query?: never;
      header?: {
        'x-airflow-dag'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AgentHarnessBackfillRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentHarnessBackfillResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_machine_api_v2_ml_scribe_internal_admin_rpa_recordings_cua_cloud_users__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CuaCloudMachineResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_all_recordings_api_v2_ml_scribe_internal_admin_rpa_recordings_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRpaRecordingCrossUserListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_recording_detail_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRpaRecordingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_recording_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateRpaRecordingRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRpaRecordingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_recording_artifacts_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__artifacts_get: {
    parameters: {
      query?: {
        stage?: components['schemas']['RpaArtifactStage'] | null;
        limit?: number;
        cursor?: string | null;
      };
      header?: never;
      path: {
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaRecordingArtifactInventoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_recording_artifact_preview_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__artifacts__artifact_id__preview_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
        artifact_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaRecordingArtifactPreviewResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_recording_artifact_download_url_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__artifacts__artifact_id__download_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
        artifact_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaRecordingArtifactDownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_recordings_by_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRpaRecordingListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_all_workflows_for_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__all_workflows_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminUserWorkflowsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_recording_workflow_data_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__data_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['WorkflowDataUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRpaRecordingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_recording_for_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__upload_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_recording_for_user_api_v2_ml_scribe_internal_admin_rpa_recordings_users__user_ref_id__upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRpaRecordingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reanalyze_recording_api_v2_ml_scribe_internal_admin_rpa_recordings__recording_id__reanalyze_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ReanalyzeRpaRecordingRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminRpaRecordingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_ax_captures_api_v2_ml_scribe_internal_admin_rpa_ax_captures_get: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminAxCaptureListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ax_capture_api_v2_ml_scribe_internal_admin_rpa_ax_captures__capture_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        capture_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminAxCaptureDetailResponse'];
        };
      };
      /** @description The capture or capture blob does not exist. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  run_evidence_chat_api_v2_ml_scribe_internal_admin_agent_tooling_evidence_chat_run_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminEvidenceChatRunRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  run_agentic_personalisation_batch_workflow_api_v2_ml_scribe_internal_admin_agentic_personalisation_batch_workflows_run_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RunAgenticPersonalisationBatchWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunAgenticPersonalisationBatchWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_agentic_personalisation_batch_scope_api_v2_ml_scribe_internal_admin_agentic_personalisation_batch_workflows_preview_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PreviewBatchScopeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PreviewBatchScopeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  clear_agentic_personalisation_memory_api_v2_ml_scribe_internal_admin_agentic_personalisation_memory_clear_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ClearMemoryRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClearMemoryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integration_agents_api_v2_ml_scribe_internal_admin_integration_agent_agents_get: {
    parameters: {
      query?: {
        org_id?: string | null;
        team_id?: string | null;
        ehr_system?: components['schemas']['IntegrationAgentProvider'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListIntegrationAgentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_integration_agent_api_v2_ml_scribe_internal_admin_integration_agent_agents_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateIntegrationAgentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateIntegrationAgentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revoke_integration_agent_api_v2_ml_scribe_internal_admin_integration_agent_agents__agent_id__revoke_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RevokeIntegrationAgentResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_sessions_api_v2_ml_scribe_internal_admin_translator_sessions_get: {
    parameters: {
      query?: {
        skip?: number;
        limit?: number;
        user_ref_id?: string | null;
        pinned?: boolean | null;
        date_from?: string | null;
        date_to?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminSessionListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_sessions_api_v2_ml_scribe_internal_admin_translator_sessions_search_get: {
    parameters: {
      query: {
        q: string;
        skip?: number;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminSessionResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_stats_api_v2_ml_scribe_internal_admin_translator_sessions_stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminSessionStatsResponse'];
        };
      };
    };
  };
  get_session_detail_api_v2_ml_scribe_internal_admin_translator_sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminSessionDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  toggle_pinned_api_v2_ml_scribe_internal_admin_translator_sessions__session_id__toggle_pinned_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_audio_recordings_api_v2_ml_scribe_internal_admin_translator_sessions__session_id__audio_recordings_get: {
    parameters: {
      query?: {
        skip?: number;
        limit?: number;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdminAudioRecordingListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_models_api_v2_ml_scribe_internal_admin_evaluations_registry_models_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ModelRegistryResponse'];
        };
      };
    };
  };
  health_check_models_api_v2_ml_scribe_internal_admin_evaluations_registry_models_health_check_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': string[] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ModelHealthCheckResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_features_api_v2_ml_scribe_internal_admin_evaluations_registry_features_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FeatureRegistryResponse'];
        };
      };
    };
  };
  list_experiments_api_v2_ml_scribe_internal_admin_evaluations_experiments__get: {
    parameters: {
      query?: {
        experiment_status?: string | null;
        skip?: number;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExperimentListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateExperimentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExperimentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  debug_variables_api_v2_ml_scribe_internal_admin_evaluations_experiments_debug_variables_get: {
    parameters: {
      query: {
        /** @description Comma-separated session IDs to inspect */
        session_ids: string;
        /** @description Feature ID for variable enrichment */
        feature_id?: string;
        /** @description Truncate long values for readability */
        truncate?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExperimentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateExperimentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExperimentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  execute_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__execute_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExecuteExperimentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_log_full_value_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__log_full_value_get: {
    parameters: {
      query: {
        /** @description Index of the log entry */
        entry_index: number;
        /** @description Run index (-1 = latest) */
        run_index?: number;
      };
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LogFullValueResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  abort_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__abort_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExperimentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  inspector_features_api_v2_ml_scribe_internal_admin_evaluations_experiments_inspector_features_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  inspector_me_api_v2_ml_scribe_internal_admin_evaluations_experiments_inspector_me_get: {
    parameters: {
      query?: {
        /** @description Optional email override — bypasses admin UID resolution */
        email?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  inspector_sessions_api_v2_ml_scribe_internal_admin_evaluations_experiments_inspector_sessions_get: {
    parameters: {
      query: {
        /** @description Kinde user ID (auto-resolved from /inspector/me) */
        kinde_user_id: string;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  inspector_inspect_api_v2_ml_scribe_internal_admin_evaluations_experiments_inspector_inspect_get: {
    parameters: {
      query: {
        /** @description Session ID to inspect */
        session_id: string;
        /** @description Feature to inspect variables for */
        feature_id?: string;
        /** @description Truncate long values for readability */
        truncate?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_judge_templates_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__get: {
    parameters: {
      query?: {
        include_shared?: boolean;
        skip?: number;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JudgeTemplateListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_judge_template_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateJudgeTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JudgeTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_judge_template_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JudgeTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_judge_template_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__template_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_judge_template_api_v2_ml_scribe_internal_admin_evaluations_judge_templates__template_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateJudgeTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JudgeTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_prompteams_repos_api_v2_ml_scribe_internal_admin_evaluations_prompteams_repos_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptTeamsRepoListResponse'];
        };
      };
    };
  };
  list_prompteams_prompts_api_v2_ml_scribe_internal_admin_evaluations_prompteams_prompts_get: {
    parameters: {
      query?: {
        branch_id?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PromptTeamsPromptListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_chat_history_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__chat_history_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  chat_with_experiment_api_v2_ml_scribe_internal_admin_evaluations_experiments__experiment_id__chat__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        experiment_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ChatMessageRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_sample_count_api_v2_ml_scribe_internal_admin_evaluations_sample_count_get: {
    parameters: {
      query: {
        feature_id: string;
        start_date?: string | null;
        end_date?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PreviewSampleCountResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_judge_prompt_api_v2_ml_scribe_internal_admin_evaluations_generate_judge_prompt_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateJudgePromptRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateJudgePromptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_output_schema_api_v2_ml_scribe_internal_admin_evaluations_generate_output_schema_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateOutputSchemaRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateOutputSchemaResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integration_clients_api_v2_ml_scribe_internal_admin_integration_clients_get: {
    parameters: {
      query?: {
        provider?: string | null;
        status?: components['schemas']['IntegrationClientStatus'] | null;
        skip?: number;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationClientResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_integration_client_api_v2_ml_scribe_internal_admin_integration_clients_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateIntegrationClientRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationClientCreatedResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revoke_integration_client_api_v2_ml_scribe_internal_admin_integration_clients__client_id__revoke_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        client_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationClientResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  disable_integration_client_api_v2_ml_scribe_internal_admin_integration_clients__client_id__disable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        client_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationClientResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_patient_summary_api_v2_ml_scribe_p__download_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Opaque token minted by ``prepare_delivery``. */
        download_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Redirect to the presigned S3 URL. */
      302: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Token unknown or expired (also returned on transient Redis failures, deliberately, so the patient gets a consistent next step). */
      410: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Token resolved but the underlying S3 object could not be presigned. */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  healthcheck_api_v2_ml_scribe_open_api_healthcheck_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HealthcheckResponse'];
        };
      };
    };
  };
  generate_jwt_api_v2_ml_scribe_open_api_jwt_get: {
    parameters: {
      query: {
        email: string;
        third_party_internal_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateJWTResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  validate_open_api_jwt_api_v2_ml_scribe_open_api_jwt_validate_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ValidateOpenAPIJWTResponse'];
        };
      };
    };
  };
  create_open_api_access_api_v2_ml_scribe_open_api_internal_admin_org_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateOpenAPIRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_open_api_org_access_api_v2_ml_scribe_open_api_internal_admin_org_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateOpenAPIOrgRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_open_api_organizations_api_v2_ml_scribe_open_api_internal_admin_orgs_get: {
    parameters: {
      query?: {
        api_key?: string | null;
        ehr_provider?: string | null;
        kinde_user_id?: string | null;
        is_active?: boolean;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListOpenAPIOrgnizationsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_open_api_org_api_v2_ml_scribe_open_api_internal_admin_orgs_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteOpenAPIOrgsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_linked_users_api_v2_ml_scribe_open_api_internal_admin_linked_user_get: {
    parameters: {
      query?: {
        kinde_user_id?: string | null;
        ehr_provider?: string | null;
        ehr_email?: string | null;
        ehr_user_id?: string | null;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListOpenAPILinkedUsersResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_open_api_user_api_v2_ml_scribe_open_api_internal_admin_unlink_user_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnlinkOpenAPIUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnlinkOpenAPIUserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_active_users_usage_by_ehr_provider_api_v2_ml_scribe_open_api_internal_admin_active_user_usages_get: {
    parameters: {
      query: {
        third_party: string;
        page?: number;
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListActiveUserUsageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_s3_presigned_url_api_v2_ml_scribe_open_api_internal_admin_get_public_s3_presigned_url_get: {
    parameters: {
      query: {
        method: components['schemas']['S3PresignedUrlMethod'];
        expiration_seconds?: number;
        object_name: string;
        content_type: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_chat_export_presigned_url_api_v2_ml_scribe_open_api_internal_admin_chat_export_url_get: {
    parameters: {
      query: {
        /** @description S3 file key for a chat export (PDF, CSV, Word, Excel) */
        file_key: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChatExportUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_user_to_heidi_account_api_v2_ml_scribe_open_api_internal_admin_link_user_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InternalAdminLinkUserToHeidiAccountRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalAdminLinkUserToHeidiAccountResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_integration_partner_admins_api_v2_ml_scribe_open_api_internal_admin_integration_partner_admin_get: {
    parameters: {
      query?: {
        page?: number;
        page_size?: number;
        ehr_provider?: string | null;
        ehr_email?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListIntegrationPartnerAdminResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_integration_partner_admin_api_v2_ml_scribe_open_api_internal_admin_integration_partner_admin_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateIntegrationPartnerAdminRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateIntegrationPartnerAdminResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_integration_partner_admin_api_v2_ml_scribe_open_api_internal_admin_integration_partner_admin__admin_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        admin_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteIntegrationPartnerAdminResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_open_api_session_permissions_api_v2_ml_scribe_open_api_sessions__session_id__permissions_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__sessions__sessions_schema__SessionPermissionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_sessions_by_ehr_patient_id_and_patient_profile_id_api_v2_ml_scribe_open_api_sessions_get: {
    parameters: {
      query?: {
        ehr_patient_id?: string | null;
        patient_profile_id?: string | null;
        page_size?: number | null;
        last_session_created_at?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_session_api_v2_ml_scribe_open_api_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['OpenAPICreateSessionRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPICreateSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_linked_user_sessions_api_v2_ml_scribe_open_api_sessions_linked_user_get: {
    parameters: {
      query?: {
        page_size?: number | null;
        last_session_created_at?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_details_api_v2_ml_scribe_open_api_sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_by_session_id_api_v2_ml_scribe_open_api_sessions__session_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIDeleteSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_session_api_v2_ml_scribe_open_api_sessions__session_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUpdateSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_delete_sessions_api_v2_ml_scribe_open_api_sessions_batch_delete_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIBatchDeleteSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIDeleteSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_consult_note_api_v2_ml_scribe_open_api_sessions__session_id__consult_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIGenerateConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_latest_consult_note_api_v2_ml_scribe_open_api_sessions__session_id__consult_note_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateConsultNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_consult_note_section_link_api_v2_ml_scribe_open_api_sessions__session_id__consult_note_link_section_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUpdateConsultNoteSectionLinkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIUpdateConsultNoteSectionLinkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  convert_plain_text_note_to_sectional_note_api_v2_ml_scribe_open_api_sessions__session_id__consult_note_sectional_note_conversion_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIConvertPlainTextNoteToSectionalNoteResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_client_customised_qa_template_answer_api_v2_ml_scribe_open_api_sessions__session_id__client_customised_qa_template_answers_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ClientCustomisedQATemplateAnswerRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClientCustomisedQATemplateAnswerResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_documents_api_v2_ml_scribe_open_api_sessions__session_id__documents_get: {
    parameters: {
      query?: {
        sort_by?: components['schemas']['DocumentSortBy'];
        sort_order?: components['schemas']['shared__enums__enums__SortOrder'];
        skip?: number;
        limit?: number | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetDocumentsResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_empty_document_api_v2_ml_scribe_open_api_sessions__session_id__documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIGenerateDocumentContentRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreatedDocumentView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ask_ai_api_v2_ml_scribe_open_api_sessions__session_id__ask_ai_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIAskAIRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_transcript_api_v2_ml_scribe_open_api_sessions__session_id__transcript_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionTranscriptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_transcript_live_api_v2_ml_scribe_open_api_sessions__session_id__transcript_live_get: {
    parameters: {
      query?: {
        recording_status?: components['schemas']['LiveRecordingStatus'];
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetSessionLiveTranscriptResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_clinical_codes_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_get: {
    parameters: {
      query?: {
        enabled_code_systems?:
          | components['schemas']['domains__coding__pkg__enums__CodeSystem'][]
          | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionClinicalCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_clinical_code_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIConfirmClinicalCodeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionClinicalCodeResponseWithSuccess'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unconfirm_clinical_code_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_unconfirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUnconfirmClinicalCodeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionClinicalCodeResponseWithSuccess'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reject_clinical_code_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes__entity_id__reject_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        entity_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionClinicalCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_clinical_codes_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_search_get: {
    parameters: {
      query: {
        /** @description The query to search for clinical codes */
        query: string;
        code_systems?:
          | components['schemas']['domains__coding__pkg__enums__CodeSystem'][]
          | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISearchClinicalCodesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_new_code_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_add_new_code_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIAddNewCodeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionClinicalCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_clinical_code_feedback_api_v2_ml_scribe_open_api_sessions__session_id__clinical_codes_feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPISubmitClinicalCodeFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionClinicalCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_consult_note_templates_api_v2_ml_scribe_open_api_templates_consult_note_templates_get: {
    parameters: {
      query?: {
        specialty_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetTemplatesResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_document_templates_api_v2_ml_scribe_open_api_templates_document_templates_get: {
    parameters: {
      query?: {
        specialty_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetTemplatesResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_api_v2_ml_scribe_open_api_templates__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPITemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_shared_template_api_v2_ml_scribe_open_api_templates_shared__shared_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        shared_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetSharedTemplateResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_specialties_api_v2_ml_scribe_open_api_specialties_get: {
    parameters: {
      query?: {
        country?: components['schemas']['CountryCode'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__open_api__specialty__specialty_schema__SpecialtiesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_backup_audio_api_v2_ml_scribe_open_api_sessions__session_id__backup_audios__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_backup_audio_api_v2_ml_scribe_open_api_sessions__session_id__backup_audios__post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackupAudioResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  upload_audio_api_v2_ml_scribe_open_api_sessions__session_id__upload_audio__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_audio_api_v2_ml_scribe_open_api_sessions__session_id__upload_audio__post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadAudioResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_restful_segment_transcription_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPICreateLiveTranscriptionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  transcribe_segment_recording_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_transcribe_segment_recording_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPITranscribeChunkResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  finish_restful_segment_transcription_api_v2_ml_scribe_open_api_sessions__session_id__restful_segment_transcription__recording_id__finish_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIFinishRecordingResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_open_api_client_customised_template_response_api_v2_ml_scribe_open_api_sessions__session_id__client_customised_template_response_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CustomisedTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CustomisedTemplateResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  generate_live_dictation_api_v2_ml_scribe_open_api__session_id__dictate_live_dictation_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LiveDictationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  validate_open_api_access_api_v2_ml_scribe_open_api_users_linked_account_access_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ValidateOpenAPIAccessResponse'];
        };
      };
    };
  };
  link_heidi_account_api_v2_ml_scribe_open_api_users_linked_account_post: {
    parameters: {
      query?: never;
      header?: {
        'X-Auth-Token'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LinkHeidiAccountRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinkHeidiAccountResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_open_api_user_api_v2_ml_scribe_open_api_users_linked_account_unlink_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnlinkHeidiAccountResponse'];
        };
      };
    };
  };
  client_admin_link_heidi_account_api_v2_ml_scribe_open_api_users_linked_account_client_admin_creation_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ClientAdminLinkHeidiAccountRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinkHeidiAccountResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_checkout_session_api_v2_ml_scribe_open_api_payments_checkout_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPICreateCheckoutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPICreateCheckoutSessionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  change_subscribed_plan_api_v2_ml_scribe_open_api_payments_change_plan_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIChangeSubscriptionPlanRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  append_add_on_product_subscription_api_v2_ml_scribe_open_api_payments_add_on_product__add_on_product_internal_id__update_subscription_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        add_on_product_internal_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  open_api_list_document_suggested_ai_commands_api_v2_ml_scribe_open_api_sessions__session_id__documents_ai_commands_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIDocumentAICommandsResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  open_api_generate_document_content_api_v2_ml_scribe_open_api_sessions__session_id__documents__document_id__content_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['OpenAPIGenerateDocumentContentRequestV2']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_document_by_id_api_v2_ml_scribe_open_api_sessions__session_id__documents__document_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIDocumentView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_document_api_v2_ml_scribe_open_api_sessions__session_id__documents__document_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIDeleteDocumentResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_document_api_v2_ml_scribe_open_api_sessions__session_id__documents__document_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUpdateDocumentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIDocumentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_consult_note_api_v2_ml_scribe_open_api_third_party_sessions__session_id__consult_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_third_party_license_api_v2_ml_scribe_open_api_users_third_party_license_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateThirdPartyLicenseRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ThirdPartyLicenseResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_open_api_user_api_v2_ml_scribe_open_api_users_third_party_license_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateThirdPartyLicenseRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ThirdPartyLicenseResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionContextDocumentView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionContextDocumentView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIDeleteSessionContextDocumentsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIDeleteSessionContextDocumentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_session_context_documents_api_v2_ml_scribe_open_api_sessions__session_id__context_documents_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUpdateSessionContextDocumentsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionContextDocumentView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_do_not_ask_language_api_v2_ml_scribe_open_api_users_do_not_ask_languages_put: {
    parameters: {
      query: {
        language: components['schemas']['LanguageCode'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIAddDoNotAskLanguageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_supported_languages_api_v2_ml_scribe_open_api_users_supported_languages_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetSupportedLanguageResponse'];
        };
      };
    };
  };
  get_user_details_api_v2_ml_scribe_open_api_user_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
    };
  };
  update_user_attributes_api_v2_ml_scribe_open_api_user_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUpdateUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_widget_user_quota_api_v2_ml_scribe_open_api_user_quota_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WidgetUserQuotaResponse'];
        };
      };
    };
  };
  use_widget_quota_api_v2_ml_scribe_open_api_user_quota_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UseWidgetUserQuotaRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WidgetUserQuotaResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_products_api_v2_ml_scribe_open_api_products_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetAllProductsResponse'];
        };
      };
    };
  };
  get_add_on_product_api_v2_ml_scribe_open_api_products_add_on_get: {
    parameters: {
      query?: {
        page?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetAddOnProductsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_profiles_api_v2_ml_scribe_open_api_patient_profiles_get: {
    parameters: {
      query?: {
        ehr_provider?: components['schemas']['EHRProvider'] | null;
        ehr_patient_id?: string | null;
        page?: number | null;
        page_size?: number | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetPatientProfilesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_patient_profile_api_v2_ml_scribe_open_api_patient_profiles_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPICreatePatientProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPICreatePatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_profile_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetPatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_patient_profile_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_patient_profile_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUpdatePatientProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIUpdatePatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_patient_sessions_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPILinkPatientSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPILinkPatientSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_patient_sessions_api_v2_ml_scribe_open_api_patient_profiles__patient_profile_id__sessions_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUnlinkPatientSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIUnlinkPatientSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_patient_profiles_api_v2_ml_scribe_open_api_patient_profiles_batch_delete_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIDeletePatientProfilesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_joined_teams_api_v2_ml_scribe_open_api_team_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIJoinedTeamsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_team_details_api_v2_ml_scribe_open_api_team__team_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_member_sessions_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions_get: {
    parameters: {
      query?: {
        page_size?: number | null;
        last_session_created_at?: string | null;
        ehr_provider?: string | null;
        ehr_patient_id?: string | null;
        patient_profile_id?: string | null;
        ehr_encounter_id?: string | null;
      };
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPISessionResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_team_member_session_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['domains__sessions__schemas__CreateSessionRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPICreateSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_member_session_by_id_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_member_session_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions__session_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUpdateSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_member_session_transcript_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__sessions__session_id__transcript_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionTranscriptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_profiles_for_team_member_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles_get: {
    parameters: {
      query?: {
        ehr_provider?: string | null;
        ehr_patient_id?: string | null;
        page?: number | null;
        page_size?: number | null;
      };
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetPatientProfilesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_patient_profile_for_team_member_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPICreatePatientProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPICreatePatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_profile_for_team_member_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles__patient_profile_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        patient_profile_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIGetPatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_patient_profile_for_team_member_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles__patient_profile_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        patient_profile_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUpdatePatientProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIUpdatePatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_sessions_to_team_member_patient_profile_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles__patient_profile_id__sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        patient_profile_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPILinkPatientSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPILinkPatientSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_sessions_from_team_member_patient_profile_api_v2_ml_scribe_open_api_teams__team_id__members__member_id__patient_profiles__patient_profile_id__sessions_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        patient_profile_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPIUnlinkPatientSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIUnlinkPatientSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  client_admin_create_team_api_v2_ml_scribe_open_api_client_admin_teams_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ClientAdminCreateTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClientAdminCreateTeamResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  client_admin_list_roles_api_v2_ml_scribe_open_api_client_admin_teams__team_id__roles_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClientAdminListRolesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  client_admin_add_member_api_v2_ml_scribe_open_api_client_admin_teams__team_id__members_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ClientAdminAddMemberRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClientAdminAddMemberResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  client_admin_assign_roles_api_v2_ml_scribe_open_api_client_admin_teams__team_id__members__member_kinde_user_id__roles_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_kinde_user_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ClientAdminAssignRolesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClientAdminAssignRolesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_organization_members_api_v2_ml_scribe_open_api_organization__organization_id__members_get: {
    parameters: {
      query?: {
        role_ids?: string[] | null;
        'role_ids[]'?: string[] | null;
        page?: number;
        page_size?: number;
        order_by?: components['schemas']['OrganizationMemberOrdering'];
        is_descending?: boolean;
        search?: string | null;
        team_ids?: string[] | null;
        'team_ids[]'?: string[] | null;
        specialty_ids?: string[] | null;
        'specialty_ids[]'?: string[] | null;
        show_pending_invitations_only?: boolean;
      };
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPIOrganizationMembersResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_active_competitions_api_v2_ml_scribe_open_api_competitions_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompetitionResponse'][];
        };
      };
    };
  };
  get_competition_by_slug_api_v2_ml_scribe_open_api_competitions__slug__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CompetitionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_competition_leaderboard_api_v2_ml_scribe_open_api_competitions__slug__leaderboard_get: {
    parameters: {
      query?: {
        /** @description Maximum number of entries to return per page. */
        limit?: number;
        /** @description Page number for pagination. */
        page?: number;
      };
      header?: never;
      path: {
        slug: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LeaderboardResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_period_leaderboard_api_v2_ml_scribe_open_api_competitions_periods__period__get: {
    parameters: {
      query?: {
        /** @description Type of leaderboard (evidence_queries or referrals). */
        type?: components['schemas']['LeaderboardType'];
        /** @description Filter by region (AU, UK, US, CA, EU). If not provided, returns global leaderboard. */
        region?: components['schemas']['Region'] | null;
        /** @description Filter by campaign (e.g., 'evidence'). If not provided, returns all campaigns. */
        campaign?: components['schemas']['ReferralCampaign'] | null;
        /** @description Filter by country (e.g., 'Australia'). If not provided, returns all countries. */
        country?: string | null;
        /** @description Maximum number of entries to return. */
        limit?: number;
      };
      header?: never;
      path: {
        period: components['schemas']['LeaderboardPeriodType'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PeriodLeaderboardResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_session_workflow_api_v2_ml_scribe_open_api_workflows_session_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['OpenAPICreateSessionWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenAPICreateSessionWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_access_entitlements_api_v2_ml_scribe_access_entitlements_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementsResponse'];
        };
      };
    };
  };
  list_team_member_access_entitlements_api_v2_ml_scribe_access_entitlements_team__team_id__members_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamMemberAccessEntitlementsListResponse'];
        };
      };
      /** @description Caller is not a team admin for this team */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Team not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_team_access_entitlements_api_v2_ml_scribe_access_entitlements_team__team_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamLevelAccessEntitlementsResponse'];
        };
      };
      /** @description Caller is not a team admin for this team */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Team not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upsert_team_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_team__team_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Caller is not a team admin, or type is not team-admin manageable */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Team or entitlement type not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_team_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_team__team_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Caller is not a team admin, or type is not team-admin manageable */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Team or entitlement type not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Entitlement already assigned to this team */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_team__team_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteUserAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteAccessEntitlementResponse'];
        };
      };
      /** @description Caller is not a team admin, or type is not team-admin manageable */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Team, entitlement type, or team entitlement attachment not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_assign_user_entitlements_as_team_admin_api_v2_ml_scribe_access_entitlements_users_batch_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkAssignAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkAssignUserEntitlementsResponse'];
        };
      };
      /** @description Not a team member, not a team admin, or bulk not permitted */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Entitlement type not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_delete_user_entitlements_as_team_admin_api_v2_ml_scribe_access_entitlements_users_batch_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkDeleteUserAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkDeleteUserEntitlementsResponse'];
        };
      };
      /** @description Caller has no team, or is not a team admin */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Entitlement type not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upsert_user_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_users__user_ref_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Not a team member, not a team admin, or target not in team */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User or entitlement type not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_user_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_users__user_ref_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Not a team member, not a team admin, or target not in team */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User or entitlement type not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Entitlement already assigned to this user */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_users__user_ref_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteUserAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteAccessEntitlementResponse'];
        };
      };
      /** @description Not a team member, not a team admin, or target not in team */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User, entitlement type, or user entitlement attachment not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_entitlement_as_team_admin_api_v2_ml_scribe_access_entitlements_users__user_ref_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateUserAccessEntitlementRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessEntitlementView'];
        };
      };
      /** @description Not a team member, not a team admin, or target not in team */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User, entitlement type, or user entitlement attachment not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mint_coding_case_access_context_api_v2_ml_scribe_coding_cases_access_context_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MintAccessContextResponse'];
        };
      };
    };
  };
  scc_access_context_jwks_api_v2_ml_scribe__well_known_scc_access_context_jwks_json_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SccAccessContextJWKSet'];
        };
      };
    };
  };
  ml_scribe_agents_notifications_stream_api_v2_ml_scribe_agents_notifications_get: {
    parameters: {
      query?: never;
      header?: {
        'Last-Event-ID'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agents_events_resolve_api_v2_ml_scribe_agents_events__event_id__resolve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        event_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ResolveFrontendEventRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FrontendEventLifecycleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agents_events_ack_api_v2_ml_scribe_agents_events__event_id__ack_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        event_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AckFrontendEventRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FrontendEventLifecycleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agent_runs_list_api_v2_ml_scribe_agents_runs_get: {
    parameters: {
      query?: {
        status?: PathsApiV2MlScribeAgentsRunsGetParametersQueryStatusAnyOf0[] | null;
        kind?: string[] | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SubjectRunListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agent_runs_details_api_v2_ml_scribe_agents_runs__agent_run_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentRunDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agent_runs_submit_turn_api_v2_ml_scribe_agents_runs__agent_run_id__turns_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitAgentRunTurnRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SubmitAgentRunTurnResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agent_runs_attachment_download_url_api_v2_ml_scribe_agents_runs__agent_run_id__attachments__attachment_id__download_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
        attachment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__agent_events__AttachmentDownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agent_runs_stream_api_v2_ml_scribe_agents_runs__agent_run_id__stream_get: {
    parameters: {
      query?: {
        follow?: boolean;
      };
      header?: {
        'Last-Event-ID'?: string | null;
        Authorization?: string | null;
        'Heidi-Api-Key'?: string | null;
      };
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agents_runs_agent_run_id_events_stream_api_v2_ml_scribe_agents_runs__agent_run_id__events_get: {
    parameters: {
      query?: never;
      header?: {
        'Last-Event-ID'?: string | null;
        Authorization?: string | null;
        'Heidi-Api-Key'?: string | null;
      };
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agent_run_approvals_api_v2_ml_scribe_agents_runs__agent_run_id__approvals_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListToolApprovalsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resolve_agent_run_approval_api_v2_ml_scribe_agents_runs__agent_run_id__approvals__approval_id__resolve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
        approval_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ResolveToolApprovalRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ResolveToolApprovalResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resolve_agent_run_wait_api_v2_ml_scribe_agents_runs__agent_run_id__waits__wait_id__resolve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
        wait_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ResolveWaitRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ResolveWaitResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_agent_tool_result_api_v2_ml_scribe_agents_runs__agent_run_id__tool_result_post: {
    parameters: {
      query?: never;
      header?: {
        Authorization?: string | null;
        'Heidi-Api-Key'?: string | null;
      };
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitRemoteToolResultRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  cancel_agent_run_api_v2_ml_scribe_agents_runs__agent_run_id__cancel_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_agent_runs_set_approval_mode_api_v2_ml_scribe_agents_runs__agent_run_id__approval_mode_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateApprovalModeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateApprovalModeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  close_agent_run_api_v2_ml_scribe_agents_runs__agent_run_id__close_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_inbox_items_api_v2_ml_scribe_inbox_items_get: {
    parameters: {
      query?: {
        /** @description Filter by inbox item status. Repeat for multiple. */
        status?: string[] | null;
        /** @description Filter by approval kind. Repeat for multiple. */
        kind?: string[] | null;
        agent_run_id?: string | null;
        /** @description Scope to a thread's whole subtree: the root run plus every sub-agent clarification beneath it. */
        root_agent_run_id?: string | null;
        /** @description ISO 8601 lower bound. */
        since?: string | null;
        /** @description ISO 8601 upper bound. */
        before?: string | null;
        limit?: number;
        offset?: number;
        sort_by?: PathsApiV2MlScribeInboxItemsGetParametersQuerySort_by;
        sort_order?: PathsApiV2MlScribeInboxItemsGetParametersQuerySort_order;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InboxListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_inbox_item_detail_api_v2_ml_scribe_inbox_items__approval_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        approval_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InboxItem'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_inbox_count_api_v2_ml_scribe_inbox_count_get: {
    parameters: {
      query?: {
        /** @description Filter by approval kind. Repeat for multiple. */
        kind?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InboxCountResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_inbox_bulk_resolve_api_v2_ml_scribe_inbox_items_bulk_resolve_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkResolveRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkResolveResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  log_api_status_check_api_v2_ml_scribe_api_status_check_log_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LogApiStatusCheckRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LogApiStatusCheckResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  log_diagnostics_api_v2_ml_scribe_diagnostics_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LogDiagnosticsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LogDiagnosticsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_adaptive_learning_popover_api_v2_ml_scribe_note_suggestions_adaptive_learning_popover_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdaptiveLearningPopoverResponse'];
        };
      };
    };
  };
  get_adaptive_learning_availability_api_v2_ml_scribe_note_suggestions_adaptive_learning_availability_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AdaptiveLearningAvailabilityResponse'];
        };
      };
    };
  };
  record_suggestion_feedback_api_v2_ml_scribe_note_suggestions__suggestion_id__feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        suggestion_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecordSuggestionFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RecordSuggestionFeedbackResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  graduate_note_suggestion_api_v2_ml_scribe_note_suggestions__suggestion_id__graduate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        suggestion_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GraduateSuggestionResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_note_push_hints_api_v2_ml_scribe_note_push_targets_get: {
    parameters: {
      query: {
        template_id: string;
        app_name?: string | null;
        include_structured?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotePushHintsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  record_note_push_hints_api_v2_ml_scribe_note_push_targets_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecordNotePushHintsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotePushHintsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  verify_token_api_v2_ml_scribe_authentication_validate_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AuthenticationResponse'];
        };
      };
    };
  };
  get_billing_info_api_v2_ml_scribe_billings_get: {
    parameters: {
      query?: {
        team_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BillingInfoResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_add_on_billing_info_api_v2_ml_scribe_billings_add_on_products_get: {
    parameters: {
      query?: {
        including_expired_subscription?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AddOnBillingInfoResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  activate_clinician_trial_api_v2_ml_scribe_billings_activate_clinician_trial_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ActivateClinicianTrialResponse'];
        };
      };
    };
  };
  cancel_reverse_trial_api_v2_ml_scribe_billings_cancel_reverse_trial_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CancelReverseTrialResponse'];
        };
      };
    };
  };
  apply_subscription_discount_api_v2_ml_scribe_billings_apply_discount_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ApplySubscriptionDiscountRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ApplySubscriptionDiscountResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  record_cancellation_intent_api_v2_ml_scribe_billings_cancellation_intent_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecordCancellationIntentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RecordCancellationIntentResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_credit_allowance_api_v2_ml_scribe_credit_allowance_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreditAllowanceResponse'] | null;
        };
      };
    };
  };
  request_heidi_2_access_api_v2_ml_scribe_billings_request_heidi_2_access_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RequestHeidi2AccessRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequestHeidi2AccessResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  list_calculators_api_v2_ml_scribe_calculators_get: {
    parameters: {
      query?: {
        /** @description Filter by category */
        category?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CalculatorListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_calculators_api_v2_ml_scribe_calculators_search_get: {
    parameters: {
      query: {
        /** @description Search query */
        q: string;
        max_results?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CalculatorSearchResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_calculator_api_v2_ml_scribe_calculators__calculator_key__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        calculator_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CalculatorDetail'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  execute_calculator_api_v2_ml_scribe_calculators__calculator_key__execute_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        calculator_key: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExecuteCalculatorRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExecuteCalculatorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_capabilities_api_v2_ml_scribe_capabilities_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CapabilityListResponse'];
        };
      };
    };
  };
  get_user_capabilities_api_v2_ml_scribe_capabilities_me_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CapabilityWithUserConfigListResponse'];
        };
      };
    };
  };
  update_capability_actions_api_v2_ml_scribe_capabilities__slug__actions_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateActionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserCapabilityConfigResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_capability_autocomplete_api_v2_ml_scribe_capabilities_autocomplete_get: {
    parameters: {
      query?: {
        /** @description Search query */
        q?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CapabilityAutocompleteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_chat_export_api_v2_ml_scribe_chat_exports_download_get: {
    parameters: {
      query: {
        /** @description S3 object key of a chat export */
        key: string;
        /** @description HMAC signature of the key with embedded expiry */
        token: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  setup_evidence_sbs_api_v2_ml_scribe_chat_sbs_setup_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EvidenceSBSSetupRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EvidenceSBSSetupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_evidence_sbs_api_v2_ml_scribe_chat_sbs_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EvidenceSBSConfirmRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EvidenceSBSConfirmResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  skip_evidence_sbs_api_v2_ml_scribe_chat_sbs_skip_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EvidenceSBSSkipRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EvidenceSBSSkipResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_tasks_api_v2_ml_scribe_clinical_tasks_get: {
    parameters: {
      query?: {
        session_id?: string | null;
        search?: string | null;
        status?: components['schemas']['ClinicalTaskStatus'] | null;
        category?: components['schemas']['ClinicalTaskCategory'] | null;
        date_from?: string | null;
        date_to?: string | null;
        due_date_from?: string | null;
        due_date_to?: string | null;
        assignment_filter?: components['schemas']['AssignmentFilter'] | null;
        link_type?: components['schemas']['ClinicalTaskLinkType'] | null;
        link_id?: string | null;
        skip?: number;
        limit?: number;
        sort_by?: string;
        sort_order?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetClinicalTasksResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_task_api_v2_ml_scribe_clinical_tasks_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateClinicalTaskRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClinicalTaskResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_delete_api_v2_ml_scribe_clinical_tasks_bulk_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkDeleteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkDeleteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_update_status_api_v2_ml_scribe_clinical_tasks_bulk_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkUpdateStatusRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkUpdateStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  assign_task_api_v2_ml_scribe_clinical_tasks__task_id__assign_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AssignTaskRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClinicalTaskResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unassign_task_api_v2_ml_scribe_clinical_tasks__task_id__unassign_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClinicalTaskResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_api_v2_ml_scribe_clinical_tasks__task_id__link_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LinkClinicalTaskRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinkClinicalTaskResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_api_v2_ml_scribe_clinical_tasks__task_id__unlink_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnlinkClinicalTaskRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnlinkClinicalTaskResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_task_api_v2_ml_scribe_clinical_tasks__task_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClinicalTaskResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_task_api_v2_ml_scribe_clinical_tasks__task_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateClinicalTaskRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClinicalTaskResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_task_api_v2_ml_scribe_clinical_tasks__task_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_session_tasks_api_v2_ml_scribe_clinical_tasks_session__session_id__generate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetClinicalTasksResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_cpd_homepage_api_v2_ml_scribe_cpd_homepage_get: {
    parameters: {
      query?: {
        /** @description Max items per section */
        limit?: number;
        /** @description Filter sources by read status. None returns all, True returns only read, False returns only unread. */
        is_read?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDHomepageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_activities_api_v2_ml_scribe_cpd_activities_get: {
    parameters: {
      query?: {
        /** @description Start date (ISO format) */
        start_date?: string | null;
        /** @description End date (ISO format) */
        end_date?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDActivitiesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_journals_api_v2_ml_scribe_cpd_journals_get: {
    parameters: {
      query?: {
        /** @description Search in journal name */
        search?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDJournalListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_cpd_stats_api_v2_ml_scribe_cpd_stats_get: {
    parameters: {
      query?: {
        /** @description Filter stats from this date (ISO 8601) */
        start_date?: string | null;
        /** @description Filter stats to this date (ISO 8601) */
        end_date?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDStatsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_cpd_sources_api_v2_ml_scribe_cpd_sources_get: {
    parameters: {
      query?: {
        /** @description Page number (1-indexed) */
        page?: number;
        /** @description Results per page */
        page_size?: number;
        /** @description Filter by first_accessed_at >= date */
        start_date?: string | null;
        /** @description Filter by first_accessed_at <= date */
        end_date?: string | null;
        /** @description Search in title, source_name, domain */
        search?: string | null;
        /** @description Exact URL match for source lookup */
        url?: string | null;
        /** @description Filter by specialty */
        specialty?: string | null;
        /** @description Filter by exact source_name (journal filter) */
        source_name?: string | null;
        /** @description Sort field: last_accessed_at, access_count, total_estimated_time_minutes, title */
        sort_by?: string;
        /** @description Sort order: asc or desc */
        sort_order?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_cpd_source_api_v2_ml_scribe_cpd_sources__source_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSourceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_cpd_log_api_v2_ml_scribe_cpd_export_get: {
    parameters: {
      query: {
        /** @description Start date (ISO 8601, required) */
        start_date: string;
        /** @description End date (ISO 8601, required) */
        end_date: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDExportResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_cpd_settings_api_v2_ml_scribe_cpd_settings_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSettingsResponse'];
        };
      };
    };
  };
  update_cpd_settings_api_v2_ml_scribe_cpd_settings_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CPDSettingsUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSettingsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_source_as_read_api_v2_ml_scribe_cpd_sources__source_id__read_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['CPDMarkAsReadRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDMarkAsReadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_source_as_unread_api_v2_ml_scribe_cpd_sources__source_id__read_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDMarkAsUnreadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_cpd_activity_api_v2_ml_scribe_cpd_activities__chat_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDDeleteActivityResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_source_read_status_api_v2_ml_scribe_cpd_sources__source_id__read_status_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDReadStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_source_api_v2_ml_scribe_cpd_sources__source_id__save_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSaveSourceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unsave_source_api_v2_ml_scribe_cpd_sources__source_id__save_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDUnsaveSourceResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_source_by_url_api_v2_ml_scribe_cpd_sources_save_by_url_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CPDSaveSourceByUrlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSaveSourceByUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_source_by_url_api_v2_ml_scribe_cpd_sources_read_by_url_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CPDReadSourceByUrlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDReadSourceByUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_saved_sources_api_v2_ml_scribe_cpd_saved_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSavedSourceListResponse'];
        };
      };
    };
  };
  list_drafts_api_v2_ml_scribe_cpd_drafts_get: {
    parameters: {
      query?: {
        /** @description Lookup a single draft by ID */
        draft_id?: string | null;
        /** @description Filter by start date (ISO date, e.g. 2026-01-01) */
        start_date?: string | null;
        /** @description Filter by end date (ISO date, e.g. 2026-03-31) */
        end_date?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDDraftResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_draft_api_v2_ml_scribe_cpd_drafts_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CPDDraftCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDDraftResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_draft_api_v2_ml_scribe_cpd_drafts__draft_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CPDDraftUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDDraftResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_draft_api_v2_ml_scribe_cpd_drafts__draft_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_draft_api_v2_ml_scribe_cpd_drafts__draft_id__submit_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        draft_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CPDDraftSubmitRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSubmissionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_submission_api_v2_ml_scribe_cpd_submissions__submission_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        submission_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_submissions_api_v2_ml_scribe_cpd_submissions_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CPDSubmissionResponse'][];
        };
      };
    };
  };
  download_activity_log_pdf_api_v2_ml_scribe_cpd_submissions__submission_id__pdf_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        submission_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Activity log PDF */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
          'application/pdf': unknown;
        };
      };
      /** @description Feature not enabled for this user */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Submission not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_cqc_practices_api_v2_ml_scribe_cqc_practices_search_get: {
    parameters: {
      query: {
        /** @description Search query (minimum 2 characters) */
        q: string;
        /** @description Maximum number of results (max 30) */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CQCPracticeSearchResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_process_desktop_dictation_api_v2_ml_scribe_dictation_post_processing_desktop_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DesktopDictationPostProcessingRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DictationPostProcessingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_dictation_context_api_v2_ml_scribe_dictation_post_processing_context_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DictationContextResponse'];
        };
      };
    };
  };
  live_dictation_for_template_creation_api_v2_ml_scribe_template_creation_record_dictate_live_dictation_post: {
    parameters: {
      query?: {
        mode?: components['schemas']['DictationCleanupModes'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_verbal_commands_languages_api_v2_ml_scribe_dictation_verbal_commands_languages_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerbalCommandsLanguagesResponse'];
        };
      };
    };
  };
  get_dictation_app_categories_api_v2_ml_scribe_dictation_app_categories_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DictationAppCategoriesResponse'];
        };
      };
    };
  };
  set_dictation_app_category_tone_api_v2_ml_scribe_dictation_app_categories__category_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        category_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetDictationCategoryToneRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EffectiveDictationCategory'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  register_api_v2_ml_scribe_integration_agent_register_post: {
    parameters: {
      query?: never;
      header: {
        'Heidi-Api-Key': string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IntegrationAgentRegisterRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationAgentRegisterResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_api_v2_ml_scribe_integration_agent_sync_post: {
    parameters: {
      query?: never;
      header: {
        'Heidi-Api-Key': string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IntegrationAgentSyncRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationAgentSyncResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  post_command_result_api_v2_ml_scribe_integration_agent_commands__request_id__result_post: {
    parameters: {
      query?: never;
      header: {
        'Heidi-Api-Key': string;
      };
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IntegrationAgentCommandResultRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationAgentCommandResultResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agent_status_api_v2_ml_scribe_integration_agent_agents_status_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationAgentStatusResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  list_accessible_agents_api_v2_ml_scribe_integration_agent_agents_get: {
    parameters: {
      query?: {
        /** @description Filter to (true) or exclude (false) RPA target instances. */
        rpa_target?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationAgentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_launch_authorization_url_api_v2_ml_scribe_ehr_launch_authentication_authorization_url_get: {
    parameters: {
      query?: {
        profile_name?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetEHRLaunchAuthorizationURLResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_launch_access_token_with_authorization_code_api_v2_ml_scribe_ehr_launch_authentication_access_token_get: {
    parameters: {
      query: {
        authorization_code: string;
        redirect_uri: string | null;
        internal_id?: string | null;
        code_verifier?: string | null;
        profile_name?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetEHRLaunchAccessTokenDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_launch_access_token_api_v2_ml_scribe_ehr_launch_authentication_get: {
    parameters: {
      query: {
        launch_token: string;
        iss: string;
        internal_id?: string | null;
        profile_name?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetEHRLaunchAccessTokenDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_launch_access_token_with_authorization_code_v2_api_v2_ml_scribe_ehr_launch_authentication_access_token_v2_get: {
    parameters: {
      query: {
        authorization_code: string;
        redirect_uri: string;
        internal_id?: string | null;
        profile_name?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetEHRLaunchAccessTokenDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_launch_patient_details_api_v2_ml_scribe_ehr_launch_patient_get: {
    parameters: {
      query: {
        patient_identifier: string;
        access_token?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetEHRLaunchPatientDetailsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_consult_note_to_ehr_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_post: {
    parameters: {
      query?: {
        access_token?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncConsultNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_sectional_note_to_ehr_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_sectional_post: {
    parameters: {
      query?: {
        access_token?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncConsultNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_standardized_sectional_note_to_ehr_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_sectional_standardized_post: {
    parameters: {
      query?: {
        access_token?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncConsultNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_latest_note_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_ehr_latest_get: {
    parameters: {
      query?: {
        access_token?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetEHRLatestNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_past_ehr_notes_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_past_ehr_notes_get: {
    parameters: {
      query?: {
        /** @description Page number */
        page?: number | null;
        /** @description Number of notes per page */
        page_size?: number;
        /** @description Epic cursor next page URL returned by previous response */
        next_page_url?: string | null;
        access_token?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPastEHRNotesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_past_ehr_notes_with_common_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_past_ehr_notes_with_common_get: {
    parameters: {
      query?: {
        /** @description Page number */
        page?: number;
        /** @description Number of notes per page */
        page_size?: number;
        access_token?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPastEHRNotesWithCommonlyUsedResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_commonly_used_past_ehr_notes_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_commonly_used_past_ehr_notes_get: {
    parameters: {
      query?: {
        access_token?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetCommonlyUsedPastEHRNotesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_past_ehr_note_binary_detail_api_v2_ml_scribe_ehr_launch_sessions__session_id__consult_note_past_ehr_note_binary_details_get: {
    parameters: {
      query: {
        binary_id: string;
        access_token?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPastEHRNoteBinaryDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_or_update_user_ehr_launch_profile_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetUserEHRLaunchProfileResponse'];
        };
      };
    };
  };
  create_user_ehr_launch_profile_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateUserEHRLaunchProfileAPIRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateUserEHRLaunchProfileAPIResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_ehr_launch_profile_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  update_user_ehr_launch_profile_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['apis__v2__ehrlaunch__onboarding_schema__UpdateUserEHRLaunchProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateUserEHRLaunchProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_ehr_launch_profiles_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_v2_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetUserEHRLaunchProfileV2Response'];
        };
      };
    };
  };
  create_user_ehr_launch_profiles_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile_v2_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateUserEHRLaunchProfileAPIV2Request'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateUserEHRLaunchProfileAPIV2Response'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_ehr_launch_profile_by_profile_name_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile__ehr_provider__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        ehr_provider: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['apis__v2__ehrlaunch__onboarding_schema__UpdateUserEHRLaunchProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateUserEHRLaunchProfilesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_ehr_launch_profile_by_profile_name_api_v2_ml_scribe_ehr_launch_onboarding_user_ehr_launch_profile__profile_name__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        profile_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ambient_session_begin_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__AmbientSessionBegin_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': unknown;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuAmbientSessionBeginResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ambient_session_complete_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__AmbientSessionComplete_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': unknown;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuGenericResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  documentation_updated_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__DocumentationUpdated_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['HaikuDocumentationUpdatedRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuGenericResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  documentation_feedback_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__DocumentationFeedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['HaikuDocumentationFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuGenericResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__DeleteSession_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['HaikuDeleteSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuGenericResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  recording_available_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__RecordingAvailable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['HaikuRecordingAvailableRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuGenericResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  recording_chunk_available_api_v2_ml_scribe_ehr_launch_mobile_avr__provider__RecordingChunkAvailable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['HaikuRecordingChunkAvailableRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuGenericResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  haiku_smart_on_fhir_endpoint_api_v2_ml_scribe_ehr_launch_mobile_avr__provider___external_session_id__get: {
    parameters: {
      query: {
        launch_token: string;
        iss: string;
      };
      header?: never;
      path: {
        external_session_id: string;
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['HaikuAmbientSessionBeginRequest']
          | components['schemas']['HaikuAmbientSessionCompleteRequest']
          | components['schemas']['HaikuDocumentationUpdatedRequest']
          | components['schemas']['HaikuDocumentationFeedbackRequest']
          | components['schemas']['HaikuDeleteSessionRequest']
          | components['schemas']['HaikuRecordingChunkAvailableRequest']
          | components['schemas']['HaikuRecordingAvailableRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuTokenResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  push_note_api_v2_ml_scribe_ehr_launch_mobile_avr__provider___external_session_id__push_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['HaikuAmbientSessionBeginRequest']
          | components['schemas']['HaikuAmbientSessionCompleteRequest']
          | components['schemas']['HaikuDocumentationUpdatedRequest']
          | components['schemas']['HaikuDocumentationFeedbackRequest']
          | components['schemas']['HaikuDeleteSessionRequest']
          | components['schemas']['HaikuRecordingChunkAvailableRequest']
          | components['schemas']['HaikuRecordingAvailableRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuGenericResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  latest_finalized_recording_api_v2_ml_scribe_ehr_launch_mobile_avr__provider___external_session_id__latest_finalized_recording_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HaikuLatestFinalizedRecordingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_haiku_available_sections_api_v2_ml_scribe_ehr_launch_mobile_avr__provider___external_session_id__available_sections_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: components['schemas']['MobileProvider'];
        external_session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__integrations__api__v2__functionality__schemas__AvailableStandardizedSectionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_export_asset_presigned_url_api_v2_ml_scribe_export_assets_presigned_url_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExportAssetUrlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportAssetUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_export_asset_download_url_api_v2_ml_scribe_export_assets_presigned_url_download_post: {
    parameters: {
      query: {
        object_key: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportAssetUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_docx_api_v2_ml_scribe_export_docx_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExportDocxRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_pdf_api_v2_ml_scribe_export_pdf_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExportPdfRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_org_latest_session_transcripts_api_v2_ml_scribe_external_org_sessions_transcripts_get: {
    parameters: {
      query?: {
        email_list?: string | null;
        num_days?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionTranscriptsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_jwt_api_v2_ml_scribe_external_org_jwt_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExternalOrgGenerateJWTResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_all_feature_flags_api_v2_ml_scribe_feature_flag_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetAllFeatureFlagsResponse'];
        };
      };
    };
  };
  get_available_integrations_api_v2_ml_scribe_integrations_available_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string[];
        };
      };
    };
  };
  get_integration_capabilities_api_v2_ml_scribe_integrations_capabilities__provider__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        provider: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationCapabilities'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_allergy_intolerance_api_v2_ml_scribe_integrations_fhir_allergy_intolerances_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Who the sensitivity is for */
        patient?: string | null;
        /** @description active | inactive | resolved */
        clinical_status?:
          | components['schemas']['AllergyIntoleranceClinicalStatusCodes']
          | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_AllergyIntolerance_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_appointment_api_v2_ml_scribe_integrations_fhir_appointments_get: {
    parameters: {
      query: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Appointment date/time. Use eq for a single day, or ge + le together for a bounded range. Unbounded ranges (lone ge or le) are not allowed. */
        date: string[];
        /** @description One of the individuals of the appointment is this patient */
        patient?: string | null;
        /** @description One of the individuals of the appointment is this practitioner */
        practitioner?: string | null;
        /** @description The overall status of the appointment */
        status?: components['schemas']['AppointmentStatus'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Appointment_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_appointment_api_v2_ml_scribe_integrations_fhir_appointments_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Appointment'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Appointment'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_appointment_api_v2_ml_scribe_integrations_fhir_appointments__resource_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Appointment'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_appointment_api_v2_ml_scribe_integrations_fhir_appointments__resource_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_appointment_api_v2_ml_scribe_integrations_fhir_appointments__resource_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchOperation'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Appointment'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_communication_api_v2_ml_scribe_integrations_fhir_communications_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Communication'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Communication'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_composition_api_v2_ml_scribe_integrations_fhir_compositions_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Who and/or what the composition is about (if patient) */
        patient?: string | null;
        /** @description Categorization of the composition */
        category?: components['schemas']['LoincDocumentCategoryClassCode'] | null;
        /** @description Composition editing time. Use eq for a single day, or ge + le together for a bounded range. */
        date?: string[] | null;
        /** @description Context of the composition */
        encounter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Composition_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_condition_api_v2_ml_scribe_integrations_fhir_conditions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Condition'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Condition'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_condition_api_v2_ml_scribe_integrations_fhir_conditions__resource_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_condition_api_v2_ml_scribe_integrations_fhir_conditions__resource_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchOperation'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Condition'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_document_reference_api_v2_ml_scribe_integrations_fhir_document_references_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Who/what is the subject of the document */
        patient?: string | null;
        /** @description Context of the document content */
        encounter?: string | null;
        /** @description When this document reference was created */
        date?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_DocumentReference_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_encounter_api_v2_ml_scribe_integrations_fhir_encounters_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description The resource identity */
        resource_id?: string | null;
        /** @description The patient or group present at the encounter */
        patient?: string | null;
        /** @description Persons involved in the encounter other than the patient */
        practitioner?: string | null;
        /** @description planned | arrived | triaged | in-progress | onleave | finished | cancelled | entered-in-error | unknown */
        status?: components['schemas']['EncounterStatus'] | null;
        /** @description A date within the period the Encounter lasted */
        date?: string[] | null;
        /** @description The appointment that scheduled this encounter */
        appointment?: string | null;
        /** @description FHIR _include parameter for Encounter search. Captured so providers can detect and reject unsupported _include targets (e.g. eCW). */
        _include?: string[] | string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Encounter_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_family_member_history_api_v2_ml_scribe_integrations_fhir_family_member_histories_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description The identity of a subject to list family member history items for */
        patient?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_FamilyMemberHistory_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_healthcare_service_api_v2_ml_scribe_integrations_fhir_healthcare_services_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description A portion of the healthcare service's name (case-insensitive substring match) */
        name?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_HealthcareService_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_immunization_api_v2_ml_scribe_integrations_fhir_immunizations_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Vaccination administration date. Use eq for a single day, or ge + le together for a bounded range. */
        date?: string[] | null;
        /** @description The patient for the vaccination record */
        patient?: string | null;
        /** @description completed | entered-in-error | not-done */
        status?: components['schemas']['ImmunizationStatus'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Immunization_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_location_api_v2_ml_scribe_integrations_fhir_locations_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description A portion of the location's name or alias (case-insensitive substring match) */
        name?: string | null;
        /** @description A (part of the) address of the location — matches against street, city, and postal code (case-insensitive substring match) */
        address?: string | null;
        /** @description A city specified in an address (case-insensitive substring match) */
        address_city?: string | null;
        /** @description A state specified in an address (case-insensitive substring match) */
        address_state?: string | null;
        /** @description A postal code specified in an address (case-insensitive substring match) */
        address_postalcode?: string | null;
        /** @description A country specified in an address (case-insensitive substring match) */
        address_country?: string | null;
        /** @description Searches for locations with a specific kind of status (exact token match) */
        status?: components['schemas']['LocationStatus'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Location_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_measure_report_api_v2_ml_scribe_integrations_fhir_measure_reports_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description When the measure report was generated. Use eq for a single day, or ge + le together for a bounded range. */
        date?: string[] | null;
        /** @description The individual or individuals the report is for (if patient) */
        patient?: string | null;
        /** @description The reporting period for which the report was calculated. Use eq for a single day, or ge + le together for a bounded range. */
        period?: string[] | null;
        /** @description complete | pending | error */
        status?: components['schemas']['MeasureReportStatus'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_MeasureReport_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_medication_request_api_v2_ml_scribe_integrations_fhir_medication_requests_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Returns prescriptions for a specific patient */
        patient?: string | null;
        /** @description active | on-hold | cancelled | completed | entered-in-error | stopped | draft | unknown */
        status?: components['schemas']['MedicationRequestStatus'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_MedicationRequest_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_medication_statement_api_v2_ml_scribe_integrations_fhir_medication_statements_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Returns statements for a specific patient. */
        patient?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_MedicationStatement_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_capability_statement_api_v2_ml_scribe_integrations_fhir_metadata_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CapabilityStatement'];
        };
      };
    };
  };
  search_observation_api_v2_ml_scribe_integrations_fhir_observations_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description The subject that the observation is about (if patient) */
        patient?: string | null;
        /** @description The classification of the type of observation */
        category?: components['schemas']['ObservationCategory'] | null;
        /** @description Obtained date/time. If the obtained element is a period, a date that falls in the period. Use eq for a single day, or ge + le together for a bounded range. */
        date?: string[] | null;
        /** @description The code of the observation type */
        code?: string | null;
        /** @description Encounter related to the observation */
        encounter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Observation_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_patient_api_v2_ml_scribe_integrations_fhir_patients_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description The patient's family name */
        family?: string | null;
        /** @description The patient's given name */
        given?: string | null;
        /** @description The patient's date of birth */
        birth_date?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Patient_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_patient_api_v2_ml_scribe_integrations_fhir_patients_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Patient'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Patient'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_patient_api_v2_ml_scribe_integrations_fhir_patients__resource_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Patient'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_practitioner_role_api_v2_ml_scribe_integrations_fhir_practitioner_roles_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Practitioner that is able to provide the defined services for the organization, or chained ``practitioner.*`` search (e.g. ``practitioner.name``). */
        practitioner?: components['schemas']['PractitionerParams'] | string | null;
        /** @description One of the locations at which this practitioner provides care, or chained ``location.*`` search (e.g. ``location.address-city``). */
        location?: components['schemas']['LocationParams'] | string | null;
        /** @description Technical endpoints providing access to services operated for the practitioner with this role, or chained ``endpoint.*`` search (e.g. ``endpoint.connection-type``). */
        endpoint?: components['schemas']['EndpointParams'] | string | null;
        /** @description FHIR _include parameter scoped to PractitionerRole include values. */
        _include?: components['schemas']['PractitionerRoleIncludeParam'];
        /** @description Whether this practitioner role record is in active use */
        active?: boolean | null;
        /** @description The period during which the practitioner is authorized to perform in these role(s) */
        date?: string[] | null;
        /** @description A value in an email contact */
        email?: string | null;
        /** @description A practitioner's Identifier */
        identifier?: string | null;
        /** @description The identity of the organization the practitioner represents / acts on behalf of */
        organization?: string | null;
        /** @description A value in a phone contact */
        phone?: string | null;
        /** @description The practitioner can perform this role for the organization (FHIR name: role) */
        role?: string | null;
        /** @description The list of healthcare services that this worker provides for this role's Organization/Location(s) */
        service?: string | null;
        /** @description The practitioner has this specialty at an organization */
        specialty?: string | null;
        /** @description The value in any kind of contact */
        telecom?: string | null;
        /** @description Zero-based provider pagination index. */
        page?: number;
        /** @description Maximum number of results requested from the provider. */
        size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_PractitionerRole_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_practitioner_api_v2_ml_scribe_integrations_fhir_practitioners_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description The practitioner's family name */
        family?: string | null;
        /** @description The practitioner's given name */
        given?: string | null;
        /** @description A server defined search that may match any of the string fields in the HumanName */
        name?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Practitioner_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_practitioner_api_v2_ml_scribe_integrations_fhir_practitioners__resource_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        resource_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Practitioner'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_questionnaire_response_api_v2_ml_scribe_integrations_fhir_questionnaire_responses_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description When the questionnaire response was last changed. Use eq for a single day, or ge + le together for a bounded range. */
        authored?: string[] | null;
        /** @description Encounter associated with the questionnaire response */
        encounter?: string | null;
        /** @description The patient that is the subject of the questionnaire response */
        patient?: string | null;
        /** @description in-progress | completed | amended | entered-in-error | stopped */
        status?: components['schemas']['QuestionnaireResponseStatus'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_QuestionnaireResponse_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_schedule_api_v2_ml_scribe_integrations_fhir_schedules_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description The Practitioner to find a Schedule for */
        actor?: string | null;
        /** @description Search for Schedule resources that have a period that contains this date specified. Use eq for a single day, or ge + le together for a bounded range. */
        date?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Schedule_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_service_request_api_v2_ml_scribe_integrations_fhir_service_requests_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Date the request was signed (transitioned to actionable). Use eq for a single day, or ge + le together for a bounded range. */
        authored?: string[] | null;
        /** @description An encounter in which this request is made */
        encounter?: string | null;
        /** @description When the requested service should occur. Use eq for a single day, or ge + le together for a bounded range. */
        occurrence?: string[] | null;
        /** @description Search by subject - a patient */
        patient?: string | null;
        /** @description routine | urgent | asap | stat */
        priority?: components['schemas']['RequestPriority'] | null;
        /** @description draft | active | on-hold | revoked | completed | entered-in-error | unknown */
        status?: components['schemas']['RequestStatus'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_ServiceRequest_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_slot_api_v2_ml_scribe_integrations_fhir_slots_get: {
    parameters: {
      query: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Slot start date/time. Use eq for a single day, or ge + le together for a bounded range. */
        start: string[];
        /** @description The free/busy status of the slot */
        status?: components['schemas']['SlotStatus'] | null;
        /** @description The Schedule Resource that we are seeking a slot within */
        schedule?: string | null;
        /** @description The style of appointment or patient that may be booked in the slot */
        appointment_type?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Slot_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_task_api_v2_ml_scribe_integrations_fhir_tasks_get: {
    parameters: {
      query?: {
        /** @description FHIR _elements parameter - comma-separated or repeated list of base element names to include in each returned resource. https://hl7.org/fhir/R4/search.html#elements */
        _elements?: string[] | string | null;
        /** @description FHIR _summary parameter - controls how much of each resource is returned. https://hl7.org/fhir/R4/search.html#summary */
        _summary?: components['schemas']['SummaryParameter'] | null;
        /** @description Search for tasks for a subject (patient) when the task is patient-scoped. */
        patient?: string | null;
        /** @description Task status filter. Parses bare FHIR task-status codes only. */
        status?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchResponse_Task_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_task_api_v2_ml_scribe_integrations_fhir_tasks_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Task'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Task'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_schedule_api_v2_ml_scribe_integrations_schedule_get: {
    parameters: {
      query: {
        start_date: string;
        end_date: string;
        onboarding_session_id?: string | null;
        /** @description Repeatable appointment display-facet filters in facet:value form (e.g. provider_group:1, department:196). AND across dimensions, OR within a dimension. Omit to return the unfiltered schedule. */
        filter?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetScheduleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_integration_patients_api_v2_ml_scribe_integrations_patients_search_post: {
    parameters: {
      query?: {
        onboarding_session_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SearchIntegrationPatientsRequestBody'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchIntegrationPatientsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_notes_deprecated_api_v2_ml_scribe_integrations__session_id__notes_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncNotesRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncNotesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_notes_api_v2_ml_scribe_integrations_session__session_id__notes_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncNotesRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncNotesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_sectional_notes_api_v2_ml_scribe_integrations_session__session_id__sectional_notes_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncNotesRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncSectionalNotesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  audit_note_api_v2_ml_scribe_integrations__session_id__notes_audit_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncNotesRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_standardized_sections_api_v2_ml_scribe_integrations_standardized_sections_get: {
    parameters: {
      query: {
        /** @description The onboarding session ID */
        onboarding_session_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__integrations__api__v2__functionality__schemas__AvailableStandardizedSectionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_third_party_auth_api_v2_ml_scribe_integrations_third_party_auth_post: {
    parameters: {
      query?: {
        /** @description The onboarding session ID */
        onboarding_session_id?: string | null;
        /** @description Invalidate any cached token and mint a fresh one. Set this when a previously-issued token is being rejected by the widget so the stale entry is dropped instead of re-served. */
        force_refresh?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetThirdPartyAuthResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_sync_document_options_api_v2_ml_scribe_integrations_documents__document_id__sync_options_get: {
    parameters: {
      query?: {
        onboarding_session_id?: string | null;
      };
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetSyncDocumentOptionsResponse_BaseSyncDocumentOption_'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_document_api_v2_ml_scribe_integrations_documents__document_id__sync_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SyncDocumentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncDocumentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_note_options_api_v2_ml_scribe_integrations_session__session_id__note_options_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncNotesRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetNoteOptionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_notes_with_option_api_v2_ml_scribe_integrations_session__session_id__notes_with_option_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SyncNotesWithOptionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncNotesWithOptionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_file_api_v2_ml_scribe_integrations_session__session_id__file_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncNotesRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadFileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_cerner_note_types_api_v2_ml_scribe_integrations_session__session_id__cerner_note_types_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncNotesRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CernerNoteTypesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_registration_questionnaire_api_v2_ml_scribe_integrations_healthnz_questionnaire_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HealthNzAcc45Questionnaire'];
        };
      };
    };
  };
  request_integration_api_v2_ml_scribe_integrations_integration_request_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IntegrationRequestBase'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateNewIntegrationRequestResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_contact_sales_request_api_v2_ml_scribe_integrations_integration_request_contact_sales_get: {
    parameters: {
      query: {
        integration_name: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetContactSalesRequestResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_contact_sales_request_api_v2_ml_scribe_integrations_integration_request_contact_sales_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ContactSalesRequestBase'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateContactSalesRequestResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  medtech_launch_api_v2_ml_scribe_integrations_launch_medtech_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['domains__integrations__api__v2__launch__sgimed__LaunchRequestPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MedtechLaunchResponse'];
        };
      };
      /** @description Invalid request payload */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MedtechLaunchErrorResponse'];
        };
      };
      /** @description Authentication failed */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MedtechLaunchErrorResponse'];
        };
      };
      /** @description Authorization failed */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MedtechLaunchErrorResponse'];
        };
      };
      /** @description Context resolution failed */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MedtechLaunchErrorResponse'];
        };
      };
    };
  };
  veradigm_launch_api_v2_ml_scribe_integrations_launch_veradigm_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['domains__integrations__api__v2__launch__sgimed__LaunchRequestPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VeradigmLaunchResponse'];
        };
      };
      /** @description Invalid request payload */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VeradigmLaunchErrorResponse'];
        };
      };
      /** @description Authentication failed */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VeradigmLaunchErrorResponse'];
        };
      };
      /** @description Authorization failed */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VeradigmLaunchErrorResponse'];
        };
      };
      /** @description Context resolution failed */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VeradigmLaunchErrorResponse'];
        };
      };
    };
  };
  sgimed_launch_api_v2_ml_scribe_integrations_launch_sgimed_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['domains__integrations__api__v2__launch__sgimed__LaunchRequestPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SgimedLaunchResponse'];
        };
      };
      /** @description Invalid request payload */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SgimedLaunchErrorResponse'];
        };
      };
      /** @description Authentication failed */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SgimedLaunchErrorResponse'];
        };
      };
      /** @description Authorization failed */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SgimedLaunchErrorResponse'];
        };
      };
      /** @description Context resolution failed */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SgimedLaunchErrorResponse'];
        };
      };
    };
  };
  t2med_launch_api_v2_ml_scribe_integrations_launch_t2med_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['T2medLaunchRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medLaunchResponse'];
        };
      };
      /** @description Invalid launch payload */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medLaunchErrorResponse'];
        };
      };
      /** @description Missing or invalid Heidi JWT */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medLaunchErrorResponse'];
        };
      };
      /** @description Integration disabled or not authorized */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medLaunchErrorResponse'];
        };
      };
      /** @description No completed T2med onboarding session */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medLaunchErrorResponse'];
        };
      };
    };
  };
  search_integration_session_link_api_v2_ml_scribe_integrations_links_sessions_get: {
    parameters: {
      query?: {
        session_id?: string | null;
        provider_unique_identifier?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchIntegrationSessionLinkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_session_link_api_v2_ml_scribe_integrations_links_sessions__session_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchSessionLinkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchIntegrationSessionLinkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_consult_note_link_api_v2_ml_scribe_integrations_links_consult_note_link_get: {
    parameters: {
      query: {
        /** @description The consult note ID to look up */
        consult_note_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationConsultNoteLinkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_merge_link_token_api_v2_ml_scribe_integrations_merge_agent_handler_link_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['MergeLinkTokenRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MergeLinkTokenResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_merge_connections_api_v2_ml_scribe_integrations_merge_agent_handler_connections_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MergeConnectionsResponse'];
        };
      };
    };
  };
  delete_merge_connection_api_v2_ml_scribe_integrations_merge_agent_handler_connections__connector__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        connector: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_nango_connect_session_api_v2_ml_scribe_integrations_nango_connect_session_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['NangoConnectSessionRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NangoConnectSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_nango_connections_api_v2_ml_scribe_integrations_nango_connections_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NangoConnectionsResponse'];
        };
      };
    };
  };
  delete_nango_connection_api_v2_ml_scribe_integrations_nango_connections__connection_id__delete: {
    parameters: {
      query: {
        provider_config_key: string;
      };
      header?: never;
      path: {
        connection_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  openid_configuration_endpoint_api_v2_ml_scribe_integrations_nebula__well_known_openid_configuration_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OpenIDProviderMetadata'];
        };
      };
    };
  };
  token_endpoint_api_v2_ml_scribe_integrations_nebula_v1_auth_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaAccessTokenResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OAuthErrorResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OAuthErrorResponse'];
        };
      };
    };
  };
  create_session_api_v2_ml_scribe_integrations_nebula_v1_session_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NebulaSessionCreateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionEmptyResponse'];
        };
      };
      /** @description User in the request is not authorized. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully deleted the session. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionEmptyResponse'];
        };
      };
      /** @description Session not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionNotFoundResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_session_data_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__data_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NebulaGenerateDataRequest'];
      };
    };
    responses: {
      /** @description Generate-Data request accepted. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionEmptyResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  edit_session_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__edited_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NebulaSessionEditedRequest'];
      };
    };
    responses: {
      /** @description Successfully accepted the data event. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionEmptyResponse'];
        };
      };
      /** @description Session not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionNotFoundResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  finalize_session_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__finalized_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NebulaSessionFinalizedRequest'];
      };
    };
    responses: {
      /** @description Successfully accepted the data event. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionEmptyResponse'];
        };
      };
      /** @description Session not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionNotFoundResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  feedback_session_api_v2_ml_scribe_integrations_nebula_v1_session__session_id__feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NebulaSessionFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successfully accepted the data event. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionEmptyResponse'];
        };
      };
      /** @description Session not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionNotFoundResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retrieve_data_api_v2_ml_scribe_integrations_nebula_v1_data__event_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        event_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the data event. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaRetrieveDataResponse'];
        };
      };
      /** @description Data event not found. Re-uses the spec-mandated `{"title": "Session not found."}` body shape so an attacker cannot distinguish missing-event from cross-org-event. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionNotFoundResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  receive_audio_event_api_v2_ml_scribe_integrations_nebula_v1_audio__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['NebulaAudioChunkReadyEnvelope']
          | components['schemas']['NebulaAudioReadyEnvelope'];
      };
    };
    responses: {
      /** @description Event accepted (or idempotent replay). */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionEmptyResponse'];
        };
      };
      /** @description Session not found. Re-uses the spec-mandated `{"title": "Session not found."}` body shape so an attacker cannot distinguish missing-session from cross-org-session. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NebulaSessionNotFoundResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_sessions_api_v2_ml_scribe_integrations_onboardings_sessions_get: {
    parameters: {
      query?: {
        /** @description Filter by session status */
        status?: components['schemas']['OnboardingSessionStatus'] | null;
        /** @description Filter by EHR provider */
        provider?: string | null;
        /** @description Field to sort by (created_at, updated_at) */
        sort_by?: components['schemas']['OnboardingSessionSortBy'];
        /** @description Sort direction (ASC, DESC) */
        sort_order?: components['schemas']['shared__enums__enums__SortOrder'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchIntegrationOnboardingSessionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_session_api_v2_ml_scribe_integrations_onboardings_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateIntegrationOnboardingSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateIntegrationOnboardingSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_api_v2_ml_scribe_integrations_onboardings_sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateIntegrationOnboardingSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_api_v2_ml_scribe_integrations_onboardings_sessions__session_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  execute_step_api_v2_ml_scribe_integrations_onboardings_sessions__session_id__step_executions__step_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        step_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IntegrationOnboardingStepExecutionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationOnboardingStepExecutionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  init_smart_on_fhir_launch_api_v2_ml_scribe_integrations_smart_on_fhir_ehr_launch_init_get: {
    parameters: {
      query: {
        launch: string;
        iss: string;
        redirect_uri?: string | null;
        state?: string | null;
        profile_name?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      302: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  smart_on_fhir_launch_callback_api_v2_ml_scribe_integrations_smart_on_fhir_ehr_launch_callback_get: {
    parameters: {
      query?: {
        code?: string | null;
        error?: string | null;
        error_description?: string | null;
        error_uri?: string | null;
        profile_name?: string | null;
        redirect_uri?: string | null;
        state?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      302: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  report_t2med_patient_context_api_v2_ml_scribe_integrations_t2med_sessions__session_id__patient_context_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['T2medPatientContextRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medPatientContextResponse'];
        };
      };
      /** @description No T2med session link for this session/user. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medPatientContextErrorResponse'];
        };
      };
      /** @description Session link belongs to a different provider — cannot attach T2med patient context. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medPatientContextErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_t2med_pending_writebacks_api_v2_ml_scribe_integrations_t2med_pending_writebacks_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medPendingWritebacksResponse'];
        };
      };
    };
  };
  ack_t2med_writeback_api_v2_ml_scribe_integrations_t2med_writebacks__consult_note_link_id__ack_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        consult_note_link_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['T2medAckSuccess']
          | components['schemas']['T2medAckFailure'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['T2medAckResponse'];
        };
      };
      /** @description No matching consult-note link for this id/user. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Link exists but belongs to a different provider (``provider_mismatch``), or the ACK's ``writeback_generation`` no longer matches the queued item (``stale_writeback_ack``) — the note was re-synced after this poll; discard the ACK, the newer version stays queued. */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  replace_template_section_mapping_api_v2_ml_scribe_integrations_template_section_mappings_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ReplaceTemplateSectionMappingRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateSectionMappingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_section_mapping_api_v2_ml_scribe_integrations_template_section_mappings__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateSectionMappingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_template_section_mapping_api_v2_ml_scribe_integrations_template_section_mappings__template_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  token_endpoint_api_v2_ml_scribe_integrations_webhooks_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['TokenRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TokenResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  receive_healthlink_ack_api_v2_ml_scribe_integrations_webhooks_healthlink_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: string;
          };
        };
      };
    };
  };
  create_session_api_v2_ml_scribe_integrations_workflows_session_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSessionWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateSessionWorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  jwks_endpoint_api_v2_ml_scribe__well_known_jwks_json_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HeidiJWKSet'];
        };
      };
    };
  };
  list_letters_for_session_api_v2_ml_scribe_sessions__session_id__letters_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_letter_from_document_api_v2_ml_scribe_sessions__session_id__letters_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLetterFromDocumentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_recipients_api_v2_ml_scribe_sessions__session_id__letters_search_recipients_get: {
    parameters: {
      query?: {
        /** @description Practitioner name to search for. */
        name?: string | null;
        /** @description Location city to search for. */
        city?: string | null;
        /** @description Location postal code to search for. */
        postcode?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RecipientSearchResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLetterRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_letter_timeline_events_api_v2_ml_scribe_sessions__session_id__letters__letter_id__timeline_events_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterTimelineEventListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_letter_attachments_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterAttachmentListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_letter_attachment_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_letter_attachment_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterAttachmentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_letter_attachment_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments__attachment_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
        attachment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_letter_attachment_download_url_api_v2_ml_scribe_sessions__session_id__letters__letter_id__attachments__attachment_id__download_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
        attachment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterAttachmentDownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sign_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__sign_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SignLetterRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__send_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['SendLetterRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendLetterResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_letterhead_preview_for_letter_api_v2_ml_scribe_sessions__session_id__letters__letter_id__letterhead_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        letter_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LetterheadPreviewResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_prescription_api_v2_ml_scribe_prescriptions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreatePrescriptionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PrescriptionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_prescription_api_v2_ml_scribe_prescriptions__prescription_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        prescription_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PrescriptionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_prescription_api_v2_ml_scribe_prescriptions__prescription_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        prescription_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_prescription_api_v2_ml_scribe_prescriptions__prescription_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        prescription_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePrescriptionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PrescriptionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_mk_template_request_api_v2_ml_scribe_mk_template_requests__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_create_mk_template_request_api_v2_ml_scribe_mk_template_requests__post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MKCustomTemplateRequestResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_my_mk_template_requests_api_v2_ml_scribe_mk_template_requests_my_requests_get: {
    parameters: {
      query?: {
        /** @description Page number */
        page?: number;
        /** @description Items per page */
        page_size?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PaginatedMKCustomTemplateRequestResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_mk_template_request_api_v2_ml_scribe_mk_template_requests__request_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MKCustomTemplateRequestResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_inmails_by_user_api_v2_ml_scribe_notifications_inmails_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetInmailsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_inmail_by_id_api_v2_ml_scribe_notifications_inmails__inmail_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        inmail_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserInmailResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_inmail_as_deleted_api_v2_ml_scribe_notifications_inmails__inmail_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        inmail_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_all_unread_inmails_as_read_api_v2_ml_scribe_notifications_inmails_read_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  mark_inmail_as_read_api_v2_ml_scribe_notifications_inmails__inmail_id__read_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        inmail_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_inmail_as_unread_api_v2_ml_scribe_notifications_inmails__inmail_id__unread_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        inmail_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_inmail_api_v2_ml_scribe_notifications_inmails__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateUserInmailRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserInmailResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_all_inmails_as_deleted_api_v2_ml_scribe_notifications_inmails_all_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  mark_all_read_inmails_as_deleted_api_v2_ml_scribe_notifications_inmails_read_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_notification_preference_api_v2_ml_scribe_notifications_preferences_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetUserNotificationPreferencesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_patient_summary_api_v2_ml_scribe_orchestration__patient_profile_id__patient_summary_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetOrchestrationPatientSummaryResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  logout_members_api_v2_ml_scribe_organization__organization_id__users_logout_everywhere_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LogoutMembersRequest'];
      };
    };
    responses: {
      /** @description Job accepted */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LogoutMembersResponse'];
        };
      };
      /** @description Invalid request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Non-Auth0 caller or insufficient permission */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Organization not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Server error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_logout_job_api_v2_ml_scribe_organization__organization_id__users_logout_everywhere_jobs__job_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
        job_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LogoutJobStatusResponse'];
        };
      };
      /** @description Job belongs to another organization */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Job not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  logout_all_matching_members_api_v2_ml_scribe_organization__organization_id__users_logout_everywhere_all_matching_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LogoutAllMatchingRequest'];
      };
    };
    responses: {
      /** @description Job accepted */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LogoutAllMatchingResponse'];
        };
      };
      /** @description Caller token missing user_ref_id */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Non-Auth0 caller or insufficient permission */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Organization not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_logout_eligible_count_api_v2_ml_scribe_organization__organization_id__users_logout_everywhere_eligible_count_get: {
    parameters: {
      query?: {
        search?: string | null;
        teamIds?: string[] | null;
        'teamIds[]'?: string[] | null;
        roleIds?: string[] | null;
        'roleIds[]'?: string[] | null;
        specialtyIds?: string[] | null;
        'specialtyIds[]'?: string[] | null;
        excludedUserRefIds?: string[] | null;
        'excludedUserRefIds[]'?: string[] | null;
      };
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EligibleCountResponse'];
        };
      };
      /** @description Caller token missing user_ref_id */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Non-Auth0 caller or insufficient permission */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Organization not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_organization_members_api_v2_ml_scribe_organization__organization_id__members_get: {
    parameters: {
      query?: {
        role_ids?: string[] | null;
        'role_ids[]'?: string[] | null;
        page?: number;
        page_size?: number;
        order_by?: components['schemas']['OrganizationMemberOrdering'];
        is_descending?: boolean;
        search?: string | null;
        team_ids?: string[] | null;
        'team_ids[]'?: string[] | null;
        specialty_ids?: string[] | null;
        'specialty_ids[]'?: string[] | null;
        show_pending_invitations_only?: boolean;
      };
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationMembersResponse'];
        };
      };
      /** @description Organization not found or user is not a member of the organization */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_joined_organizations_api_v2_ml_scribe_organization_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JoinedOrganizationsResponse'];
        };
      };
    };
  };
  search_organization_members_api_v2_ml_scribe_organization_members_search_get: {
    parameters: {
      query?: {
        /** @description Search term for email, first name, or last name. Empty string returns all members. */
        q?: string;
        /** @description Maximum number of results to return (default: 10, max: 20) */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchMembersResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_organization_api_v2_ml_scribe_organization__organization_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationWithTeamsResponse'];
        };
      };
      /** @description organization not found or user is not a member of the organization */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_organization_api_v2_ml_scribe_organization__organization_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateOrganizationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationResponse'];
        };
      };
      /** @description user is not a team admin of the organization */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_organization_teams_api_v2_ml_scribe_organization__organization_id__teams_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationTeamsResponse'];
        };
      };
      /** @description organization not found or user is not a member of the organization */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  clear_organization_session_timeout_api_v2_ml_scribe_organization__organization_id__session_timeout_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description The organisation-level override has been cleared (or was already absent). Members fall through to their own user override or the cohort default at resolve time. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description caller is not an admin of the organisation */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_organization_session_timeout_api_v2_ml_scribe_organization__organization_id__session_timeout_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetOrganizationSessionTimeoutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionTimeoutInfo'];
        };
      };
      /** @description caller is not an admin of the organisation */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  update_team_member_api_v2_ml_scribe_organization__organization_id__teams__team_id__members__user_ref_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
        team_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTeamMemberRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationMembersView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_member_api_v2_ml_scribe_organization__organization_id__teams__team_id__members__relation_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
        team_id: string;
        relation_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  invite_users_to_team_api_v2_ml_scribe_organization__organization_id__invitations_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InviteUsersToOrgTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InviteUsersToOrgTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  move_member_between_teams_api_v2_ml_scribe_organization__organization_id__teams__source_team_id__members__user_ref_id__move_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
        source_team_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MoveMemberToTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OrganizationMembersView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_org_analytics_dashboard_api_v2_ml_scribe_organization__organization_id__analytics_dashboard_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AnalyticsDashboardResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_profiles_api_v2_ml_scribe_patient_profiles__get: {
    parameters: {
      query?: {
        ehr_provider?: components['schemas']['EHRProvider'] | null;
        ehr_patient_id?: string | null;
        page?: number | null;
        page_size?: number | null;
        patient_profile_id?: string | null;
        session_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPatientProfilesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_patient_profile_api_v2_ml_scribe_patient_profiles__post: {
    parameters: {
      query?: {
        patient_profile_id?: string | null;
        session_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreatePatientProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreatePatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_patient_profiles_api_v2_ml_scribe_patient_profiles_search_post: {
    parameters: {
      query?: {
        patient_profile_id?: string | null;
        session_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SearchPatientProfilesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchPatientProfilesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_patient_profiles_api_v2_ml_scribe_patient_profiles_import_post: {
    parameters: {
      query?: {
        patient_profile_id?: string | null;
        session_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_import_patient_profiles_api_v2_ml_scribe_patient_profiles_import_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__patientprofile__patient_profile_schema__ImportPatientProfilesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Request Entity Too Large */
      413: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_profile_api_v2_ml_scribe_patient_profiles__patient_profile_id__get: {
    parameters: {
      query?: {
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_patient_profile_api_v2_ml_scribe_patient_profiles__patient_profile_id__delete: {
    parameters: {
      query?: {
        delete_linked_sessions?: boolean;
      };
      header?: never;
      path: {
        patient_profile_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_patient_profile_api_v2_ml_scribe_patient_profiles__patient_profile_id__patch: {
    parameters: {
      query?: {
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePatientProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdatePatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_patient_sessions_api_v2_ml_scribe_patient_profiles__patient_profile_id__sessions_post: {
    parameters: {
      query?: {
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LinkPatientSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinkPatientSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_patient_sessions_api_v2_ml_scribe_patient_profiles__patient_profile_id__sessions_delete: {
    parameters: {
      query?: {
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnlinkPatientSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnlinkPatientSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_patient_profiles_api_v2_ml_scribe_patient_profiles_batch_delete_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeletePatientProfilesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  merge_patient_profiles_api_v2_ml_scribe_patient_profiles_merge_profiles_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MergePatientProfilesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MergePatientProfilesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_profile_recap_api_v2_ml_scribe_patient_profiles__patient_profile_id__recap_get: {
    parameters: {
      query?: {
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPatientProfileRecapResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_patient_documents_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents_get: {
    parameters: {
      query?: {
        page?: number;
        page_size?: number;
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PatientDocumentListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents_post: {
    parameters: {
      query?: {
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadPatientDocumentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents__document_id__get: {
    parameters: {
      query?: {
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PatientDocumentWithDownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_patient_document_api_v2_ml_scribe_patient_profiles__patient_profile_id__documents__document_id__delete: {
    parameters: {
      query?: {
        session_id?: string | null;
      };
      header?: never;
      path: {
        patient_profile_id: string | null;
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_patient_state_view_api_v2_ml_scribe_patient_state_views_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': {
          /**
           * StateBoundaries
           * @description The eight, declared together.
           *
           *     Together rather than as loose arguments because R1 treats them as a set:
           *     "declares and enforces these boundaries" is one obligation, and a caller
           *     that can pass seven is a caller that will.
           */
          boundaries: {
            /** Patient */
            patient: string;
            /** Organization */
            organization: string;
            /** Care Episode */
            care_episode: string;
            /**
             * HistoryWindow
             * @description R1's "numerical start and end clinical times".
             *
             *     Clinical times, not processing times: the window bounds when a fact
             *     *applies*, so a discharge summary uploaded today and dated two years ago
             *     falls outside a one-year window. Both ends are inclusive, which R1.AC5
             *     fixes explicitly.
             */
            history_window: {
              /**
               * Start
               * Format: date-time
               */
              start: string;
              /**
               * End
               * Format: date-time
               */
              end: string;
            };
            /**
             * Purpose
             * @description R1's V1 consumer purposes, and only those.
             *
             *     MS1 enables ``CLINICAL_NUDGE`` and MS2 validates the other two. All three
             *     are accepted here: which are *enabled* is a deployment question, and
             *     refusing a declared V1 purpose because a milestone has not landed would be
             *     a rule R1 does not state.
             * @enum {string}
             */
            purpose: PathsApiV2MlScribePatientStateViewsPostRequestBodyContentApplicationJsonBoundariesPurpose;
            /** Sources */
            sources: {
              /**
               * SourceType
               * @description The four source types R2 declares. Nothing else may enter patient state.
               * @enum {string}
               */
              source_type: PathsApiV2MlScribePatientStateViewsPostRequestBodyContentApplicationJsonBoundariesSourcesSource_type;
              /** Source Id */
              source_id: string;
            }[];
            /** Fact Scope */
            fact_scope: string;
            /**
             * EpisodeLifecycle
             * @description R1's four episode states.
             * @enum {string}
             */
            lifecycle: PathsApiV2MlScribePatientStateViewsPostRequestBodyContentApplicationJsonBoundariesLifecycle;
          };
          /** State Version */
          state_version: number | 'current';
        };
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BoundedPatientState'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_filled_pdf_fields_api_v2_ml_scribe_pdf_document__document_id__fields_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetFilledPdfFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_pdf_fields_api_v2_ml_scribe_pdf_document__document_id__fields_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePdfFieldsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdatePdfFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_base_pdf_template_url_api_v2_ml_scribe_pdf_template_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PDFTemplateUrlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  extract_form_fields_from_pdf_api_v2_ml_scribe_pdf_template_extract_fields_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_extract_form_fields_from_pdf_api_v2_ml_scribe_pdf_template_extract_fields_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExtractFormFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_filled_pdf_template_url_api_v2_ml_scribe_pdf_template__document_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_filled_pdf_template_as_docx_api_v2_ml_scribe_pdf_template__document_id__export_docx_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  extract_form_fields_from_xml_api_v2_ml_scribe_xml_template_extract_fields_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_extract_form_fields_from_xml_api_v2_ml_scribe_xml_template_extract_fields_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExtractXmlFormFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_filled_xml_fields_api_v2_ml_scribe_xml_document__document_id__fields_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetFilledXmlFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_xml_fields_api_v2_ml_scribe_xml_document__document_id__fields_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateXmlFieldsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateXmlFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_filled_xfa_pdf_api_v2_ml_scribe_xfa_document__document_id__download_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_filled_xfa_fields_api_v2_ml_scribe_xfa_document__document_id__fields_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetFilledXmlFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_xfa_fields_api_v2_ml_scribe_xfa_document__document_id__fields_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateXmlFieldsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateXmlFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_filled_xml_api_v2_ml_scribe_xml_document__document_id__download_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  extract_form_fields_from_json_api_v2_ml_scribe_json_template_extract_fields_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_extract_form_fields_from_json_api_v2_ml_scribe_json_template_extract_fields_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExtractJsonFormFieldsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_filled_json_api_v2_ml_scribe_json_document__document_id__download_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_personalization_profile_api_v2_ml_scribe_personalizations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PersonalizationDataResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  delete_personalization_insight_api_v2_ml_scribe_personalizations_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeletePersonalizationInsightRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PersonalizationDataResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  toggle_personalization_insight_api_v2_ml_scribe_personalizations_toggle_insight_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TogglePersonalizationInsightRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PersonalizationDataResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  mark_as_read_api_v2_ml_scribe_personalizations_mark_as_read_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PersonalizationDataResponse'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  list_nudges_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeListView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_available_protocols_api_v2_ml_scribe_in_session_guidance_sessions__session_id__protocols_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolListView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  detect_nudges_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_detect_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DetectRequestSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeListView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_nudge_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_add_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddCardRequestSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeCardView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_card_status_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges__protocol_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        protocol_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchCardStatusSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeCardView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  patch_item_checked_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges__protocol_id__items__item_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        protocol_id: string;
        item_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PatchItemCheckedSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeCardView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_orders_applied_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_applied_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MarkAppliedSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  incorporate_orders_into_note_api_v2_ml_scribe_in_session_guidance_sessions__session_id__note_incorporate_orders_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['IncorporateOrdersSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IncorporateOrdersResponseSchema'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  suggest_nudge_items_api_v2_ml_scribe_in_session_guidance_sessions__session_id__nudges_suggest_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SuggestRequestSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeListView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_tasks_excluding_completed_api_v2_ml_scribe_in_session_guidance_sessions__session_id__tasks_generate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_protocols_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolListResponse'];
        };
      };
    };
  };
  create_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NudgeProtocolUpsertRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  seed_protocols_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_seed_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SeedProtocolsResponse'];
        };
      };
    };
  };
  get_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['NudgeProtocolUpsertRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_trigger_conditions_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__trigger_conditions_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TriggerConditionsUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_test_cases_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__test_cases_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TestCasesUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revert_protocol_to_draft_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__revert_to_draft_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  publish_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__publish_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PublishProtocolRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_protocol_versions_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__versions_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolVersionListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  rollback_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__rollback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RollbackProtocolRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NudgeProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  parse_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_parse_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ParseProtocolRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ParseProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  parse_protocol_outline_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_parse_outline_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ParseOutlineRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ParseOutlineResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  edit_protocol_outline_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols_edit_outline_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EditOutlineRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EditOutlineResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bench_protocol_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__bench_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BenchResultResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  derive_triggering_codes_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__triggering_codes_derive_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeriveTriggeringCodesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  derive_confusable_api_v2_ml_scribe_in_session_guidance_nudge_settings_protocols__doc_id__confusable_derive_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeriveConfusableResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflows_api_v2_ml_scribe_workflows_get: {
    parameters: {
      query?: {
        /** @description Filter by source type */
        source?: PathsApiV2MlScribeWorkflowsGetParametersQuerySourceAnyOf0 | null;
        /** @description When true, include workflows shared with the caller's teams/org. Default is owner-only so existing clients do not treat shared rows as editable; use can_edit / can_run / can_schedule on each item. */
        include_shared?: boolean;
        /** @description When true, include integration-owned / system installs that are hidden from Your routines. Pair with ``connector`` for the Connected-apps panel. */
        include_hidden?: boolean;
        /** @description When set, only workflows stamped with this Connected-apps provider key. Implies include_hidden for that connector's panel. */
        connector?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_workflow_api_v2_ml_scribe_workflows_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  share_workflow_api_v2_ml_scribe_workflows__workflow_id__share_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ShareWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unshare_workflow_api_v2_ml_scribe_workflows__workflow_id__unshare_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnshareWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_all_workflow_runs_api_v2_ml_scribe_workflows_runs_get: {
    parameters: {
      query?: {
        /** @description Filter to a single workflow */
        workflow_id?: string | null;
        /** @description Filter to runs linked to a session */
        session_id?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowRunListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_schedules_batch_api_v2_ml_scribe_workflows_schedules_batch_get: {
    parameters: {
      query: {
        /** @description Workflow IDs to fetch schedules for */
        workflow_ids: string[];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchScheduleResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_api_v2_ml_scribe_workflows__workflow_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_workflow_api_v2_ml_scribe_workflows__workflow_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_api_v2_ml_scribe_workflows__workflow_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  run_workflow_api_v2_ml_scribe_workflows__workflow_id__run_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RunWorkflowRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunWorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_run_stats_api_v2_ml_scribe_workflows__workflow_id__run_stats_get: {
    parameters: {
      query?: {
        limit?: number;
      };
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowRunStatsResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_eval_profile_api_v2_ml_scribe_workflows__workflow_id__eval_profile_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowEvalProfileResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_workflow_eval_profile_api_v2_ml_scribe_workflows__workflow_id__eval_profile_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateWorkflowEvalProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowEvalProfileResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflow_runs_api_v2_ml_scribe_workflows__workflow_id__runs_get: {
    parameters: {
      query?: {
        /** @description Filter to runs linked to a session */
        session_id?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowRunListResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScheduleResponse'] | null;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetScheduleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScheduleResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  pause_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_pause_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScheduleResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resume_workflow_schedule_api_v2_ml_scribe_workflows__workflow_id__schedule_resume_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScheduleResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_event_rules_api_v2_ml_scribe_workflows__workflow_id__event_rules_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EventRuleListResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_event_rule_api_v2_ml_scribe_workflows__workflow_id__event_rules_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddEventRuleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__workflows__schema__EventRuleResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_event_rule_api_v2_ml_scribe_workflows__workflow_id__event_rules__rule_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workflow_id: string;
        rule_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workflow_presets_api_v2_ml_scribe_workflow_presets_get: {
    parameters: {
      query?: {
        /** @description When set, return presets bound to this Connected-apps provider key (including hidden integration presets) for the panel. */
        connector?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowTemplateListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  install_primary_presets_for_connector_api_v2_ml_scribe_workflow_presets_install_for_connector__connector__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Connected-apps provider key (Nango unique key or Merge slug). */
        connector: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  install_workflow_preset_api_v2_ml_scribe_workflow_presets__template_id__install_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkflowResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_settings_api_v2_ml_scribe_settings_get: {
    parameters: {
      query?: {
        keys?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SettingsCollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  write_settings_api_v2_ml_scribe_settings_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SettingsWriteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SettingsCollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  read_setting_api_v2_ml_scribe_settings__key__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ResolvedSettingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_presentations_api_v2_ml_scribe_presentations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationListItem'][];
        };
      };
    };
  };
  create_presentation_api_v2_ml_scribe_presentations_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreatePresentationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_presentation_by_chat_api_v2_ml_scribe_presentations_by_chat__chat_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_presentation_api_v2_ml_scribe_presentations__presentation_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        presentation_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_presentation_api_v2_ml_scribe_presentations__presentation_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        presentation_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_presentation_api_v2_ml_scribe_presentations__presentation_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        presentation_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePresentationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_slide_api_v2_ml_scribe_presentations__presentation_id__slides_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        presentation_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSlideRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_slide_api_v2_ml_scribe_presentations__presentation_id__slides__slide_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        presentation_id: string;
        slide_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_slide_api_v2_ml_scribe_presentations__presentation_id__slides__slide_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        presentation_id: string;
        slide_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSlideRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reorder_slides_api_v2_ml_scribe_presentations__presentation_id__slides_reorder_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        presentation_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ReorderSlidesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_presentation_api_v2_ml_scribe_presentations__presentation_id__export_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        presentation_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['ExportPresentationRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExportPresentationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_projects_api_v2_ml_scribe_projects_get: {
    parameters: {
      query?: {
        /** @description Filter by save state. ``all`` (default) returns every active project; ``only`` returns just saved projects; ``exclude`` returns just un-saved projects. Sort order is always ``is_saved DESC, updated_at DESC``, so ``all`` puts saved items at the top of the page. */
        saved?: PathsApiV2MlScribeProjectsGetParametersQuerySaved;
        /** @description Case-insensitive substring match against ``title`` and ``description``. Regex metacharacters are escaped — this is a plain contains-search. */
        q?: string | null;
        /** @description Return only projects linked to this Heidi clinical session id at create time (the same ``session_id`` accepted by ``POST /projects``). Omit for the unfiltered list across every session. */
        session_id?: string | null;
        /** @description Page size (1–200). Defaults to 50. */
        limit?: number;
        /** @description ``next_cursor`` from the previous page. Pass it back to fetch the next page; omit to start from the top of the list. */
        cursor?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_project_api_v2_ml_scribe_projects_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateProjectRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectDetail'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  list_saved_projects_api_v2_ml_scribe_projects_saved_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectListResponse'];
        };
      };
    };
  };
  get_project_api_v2_ml_scribe_projects__project_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectDetail'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_project_api_v2_ml_scribe_projects__project_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_project_api_v2_ml_scribe_projects__project_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateProjectRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectDetail'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_project_api_v2_ml_scribe_projects__project_id__save_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectDetail'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unsave_project_api_v2_ml_scribe_projects__project_id__unsave_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectDetail'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_project_turn_api_v2_ml_scribe_projects__project_id__turns_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['apis__v2__projects__schema__SubmitTurnRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__projects__schema__SubmitTurnResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_work_experience_feedback_api_v2_ml_scribe_projects_experience_feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateWorkExperienceFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateWorkExperienceFeedbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  snooze_work_experience_feedback_api_v2_ml_scribe_projects_experience_feedback_snooze_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SnoozeWorkExperienceFeedbackResponse'];
        };
      };
    };
  };
  submit_project_feedback_api_v2_ml_scribe_projects__project_id__feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ProjectFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectFeedbackResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_project_follow_up_questions_api_v2_ml_scribe_projects__project_id__follow_up_questions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ProjectFollowUpQuestionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FollowUpQuestionsResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_project_attachment_api_v2_ml_scribe_projects__project_id__attachments_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_project_attachment_api_v2_ml_scribe_projects__project_id__attachments_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectAttachmentResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_project_attachment_api_v2_ml_scribe_projects__project_id__attachments__attachment_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
        attachment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_project_attachment_download_url_api_v2_ml_scribe_projects__project_id__attachments__attachment_id__download_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
        attachment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectAttachmentDownloadUrlResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_project_messages_api_v2_ml_scribe_projects__project_id__messages_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProjectMessagesResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_protocols_api_v2_ml_scribe_protocols_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolListResponse'];
        };
      };
    };
  };
  create_protocol_api_v2_ml_scribe_protocols_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateProtocolRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_protocol_by_shorthand_api_v2_ml_scribe_protocols_by_shorthand__shorthand__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        shorthand: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_protocol_fields_api_v2_ml_scribe_protocols_generate_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateProtocolRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_available_connectors_api_v2_ml_scribe_protocols_connectors_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConnectorListResponse'];
        };
      };
    };
  };
  get_protocol_api_v2_ml_scribe_protocols__protocol_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        protocol_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_protocol_api_v2_ml_scribe_protocols__protocol_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        protocol_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolDeleteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_protocol_api_v2_ml_scribe_protocols__protocol_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        protocol_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateProtocolRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_protocol_document_api_v2_ml_scribe_protocols__protocol_id__documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        protocol_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_protocol_document_api_v2_ml_scribe_protocols__protocol_id__documents_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_protocol_document_api_v2_ml_scribe_protocols__protocol_id__documents__document_key__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        protocol_id: string;
        document_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProtocolResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  clear_session_active_protocol_api_v2_ml_scribe_protocols_sessions__session_id__active_protocol_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_repeat_reviews_api_v2_ml_scribe_repeat_reviews_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RepeatReviewListResponse'];
        };
      };
    };
  };
  get_repeat_review_api_v2_ml_scribe_repeat_reviews__request_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RepeatReviewView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_repeat_review_status_api_v2_ml_scribe_repeat_reviews__request_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateRepeatReviewStatusRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RepeatReviewView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_triage_reviews_api_v2_ml_scribe_triage_reviews_get: {
    parameters: {
      query?: {
        /** @description Page size (1–200). Defaults to 50. */
        limit?: number;
        /** @description ``next_cursor`` from the previous page. Pass it back to fetch the next page; omit to start from the most recent request. */
        cursor?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TriageReviewListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_triage_review_api_v2_ml_scribe_triage_reviews__request_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        request_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TriageReviewView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_roles_api_v2_ml_scribe_roles_get: {
    parameters: {
      query?: {
        team_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetRolesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_roles_api_v2_ml_scribe_roles_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateUserRolesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateUserRolesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_clinical_codes_api_v2_ml_scribe_sessions__session_id__clinical_codes_get: {
    parameters: {
      query?: {
        force_regenerate?: boolean;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionClinicalCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_clinical_code_api_v2_ml_scribe_sessions__session_id__clinical_codes_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConfirmClinicalCodeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionClinicalCodeResponseWithSuccess'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unconfirm_clinical_code_api_v2_ml_scribe_sessions__session_id__clinical_codes_unconfirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnconfirmClinicalCodeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionClinicalCodeResponseWithSuccess'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reject_clinical_codes_api_v2_ml_scribe_sessions__session_id__clinical_codes__entity_id__reject_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        entity_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionClinicalCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_clinical_codes_api_v2_ml_scribe_sessions__session_id__clinical_codes_search_get: {
    parameters: {
      query: {
        /** @description The query to search for clinical codes */
        query: string;
        code_systems?:
          | components['schemas']['domains__coding__pkg__enums__CodeSystem'][]
          | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchClinicalCodesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_new_code_api_v2_ml_scribe_sessions__session_id__clinical_codes_add_new_code_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddNewCodeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionClinicalCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_clinical_code_feedback_api_v2_ml_scribe_sessions__session_id__clinical_codes_feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitClinicalCodeFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionClinicalCodeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_em_level_api_v2_ml_scribe_sessions__session_id__em_level_determinator_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConfirmEmLevelRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionEmLevelResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_em_level_api_v2_ml_scribe_sessions__session_id__em_level_determinator_remove_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionEmLevelResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_note_gen_ai_commands_api_v2_ml_scribe_sessions__session_id__consult_note_ai_commands_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConsultNoteAICommandsResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_consult_notes_api_v2_ml_scribe_sessions__session_id__consult_note_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetConsultNotesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_latest_consult_note_api_v2_ml_scribe_sessions__session_id__consult_note_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateConsultNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_consult_note_api_v2_ml_scribe_sessions__session_id__consult_note__note_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        note_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetConsultNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revert_consult_note_to_edit_api_v2_ml_scribe_sessions__session_id__consult_note__note_id__revert_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        note_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RevertConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetConsultNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_consult_note_feedback_api_v2_ml_scribe_sessions__session_id__consult_note__consult_note_id__feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        consult_note_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitConsultNoteFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConsultNoteResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  replace_consult_note_section_links_api_v2_ml_scribe_sessions__session_id__consult_note_link_section_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateConsultNoteSectionLinkRequest'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateConsultNoteSectionLinkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_consult_note_section_link_api_v2_ml_scribe_sessions__session_id__consult_note_link_section_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateConsultNoteSectionLinkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateConsultNoteSectionLinkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_empty_document_api_v2_ml_scribe_sessions__session_id__documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateDocumentContentRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreatedDocumentView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_documents_api_v2_ml_scribe_sessions__session_id__documents_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateDocumentListRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateDocumentListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_document_suggested_ai_commands_api_v2_ml_scribe_sessions__session_id__documents_ai_commands_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DocumentAICommandsResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_dictation_cleanup_modes_api_v2_ml_scribe_sessions__session_id__documents_dictation_cleanup_modes_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DictationCleanupModeListReponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  share_document_through_email_api_v2_ml_scribe_sessions__session_id__documents__document_id__shares_email_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ShareDocumentThroughEmailRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ShareDocumentResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_document_feedback_api_v2_ml_scribe_sessions__session_id__documents__document_id__feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitDocumentFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DocumentView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_document_from_pdf_api_v2_ml_scribe_sessions__session_id__documents_pdf_document_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateDocumentContentRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreatedDocumentView'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_transcript_api_v2_ml_scribe_sessions__session_id__transcript_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateTranscriptResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_session_backup_transcript_api_v2_ml_scribe_sessions__session_id__transcript_backup_transcript_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateBackupTranscriptResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_client_generated_backup_transcript_api_v2_ml_scribe_sessions__session_id__transcript_client_transcript_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SaveClientGeneratedBackupTranscriptRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SaveClientGeneratedBackupTranscriptResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_transcript_live_api_v2_ml_scribe_sessions__session_id__transcript_live_get: {
    parameters: {
      query?: {
        status?: components['schemas']['LiveRecordingStatus'];
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetSessionLiveTranscriptResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_backup_audio_api_v2_ml_scribe_sessions__session_id__backup_audios__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_backup_audio_api_v2_ml_scribe_sessions__session_id__backup_audios__post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BackupAudioResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_backup_audios_api_v2_ml_scribe_sessions__session_id__backup_audios_get: {
    parameters: {
      query?: {
        expiry?: number;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListBackupAudiosResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  transcribe_hardware_audio_api_v2_ml_scribe_sessions__session_id__hardware_audio_transcription_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_transcribe_hardware_audio_api_v2_ml_scribe_sessions__session_id__hardware_audio_transcription_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HardwareAudioTranscriptionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_restful_segment_transcription_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateLiveTranscriptionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  transcribe_segment_recording_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_transcribe_segment_recording_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription__recording_id__transcribe_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TranscribeChunkResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  finish_restful_segment_transcription_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription__recording_id__finish_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FinishRecordingResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  transcribe_context_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription_transcribe_context_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_transcribe_context_api_v2_ml_scribe_sessions__session_id__restful_segment_transcription_transcribe_context_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  search_sessions_api_v2_ml_scribe_sessions_search_get: {
    parameters: {
      query?: {
        /** @description Search keyword (minimum 1 character). Optional - when not provided, returns all sessions matching filters. */
        q?: string | null;
        /** @description Page number (1-indexed) */
        page?: number;
        /** @description Number of results per page */
        page_size?: number;
        /** @description Filter by session status */
        session_status?: components['schemas']['SessionStatus'][] | null;
        /** @description Filter sessions created after this date */
        date_from?: string | null;
        /** @description Filter sessions created before this date */
        date_to?: string | null;
        /** @description Filter by patient profile IDs (supports multiple) */
        patient_profile_ids?: string[] | null;
        /** @description Localized 'Untitled session' text from frontend i18n. When provided and the search query contains this text, sessions with empty titles will also be matched. */
        untitled_text?: string | null;
        /** @description Whether to include total_match_count in response. Set to false for better performance when only paginating. */
        include_total_count?: boolean;
        /** @description Filter by urgency. true=only urgent, false=only non-urgent. Omit=no filter. */
        is_urgent?: boolean | null;
        /** @description Field to sort by (created_at, updated_at, name, status) */
        sort_by?: components['schemas']['SessionSortBy'];
        /** @description Sort direction (ASC, DESC) */
        sort_order?: components['schemas']['shared__enums__enums__SortOrder'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionSearchResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Rate limit exceeded */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_sessions_api_v2_ml_scribe_sessions__get: {
    parameters: {
      query?: {
        ehr_provider?: string | null;
        ehr_patient_id?: string | null;
        page_size?: number | null;
        last_session_created_at?: string | null;
        patient_profile_id?: string | null;
        ehr_encounter_id?: string | null;
        ehr_appointment_id?: string | null;
        ehr_appointment_contact_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_session_v2_api_v2_ml_scribe_sessions__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['domains__sessions__schemas__CreateSessionRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetailedSessionView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_all_sessions_for_user_api_v2_ml_scribe_sessions__delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  get_session_status_count_api_v2_ml_scribe_sessions_status_count_get: {
    parameters: {
      query: {
        /** @description Session status to count */
        session_status: components['schemas']['SessionStatus'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionStatusCountResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_empty_sessions_api_v2_ml_scribe_sessions_delete_empty_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteEmptySessionsResponse'];
        };
      };
    };
  };
  upload_session_schedule_api_v2_ml_scribe_sessions_upload_schedule_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_session_schedule_api_v2_ml_scribe_sessions_upload_schedule_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ScheduleUploadView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_create_sessions_api_v2_ml_scribe_sessions_batch_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkCreateSessionParams'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetailedSessionView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  extract_patient_context_api_v2_ml_scribe_sessions__session_id__patient_context_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PatientContextResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_consult_note_timeline_api_v2_ml_scribe_sessions__session_id__consult_note_timeline_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetConsultNoteTimelineResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_permissions_api_v2_ml_scribe_sessions__session_id__permissions_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__sessions__sessions_schema__SessionPermissionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_uploaded_audio_api_v2_ml_scribe_sessions__session_id__upload_audios_get: {
    parameters: {
      query?: {
        expiry?: number;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AccessRestrictedUserUploadedAudioList'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_recordings_api_v2_ml_scribe_sessions__session_id__recordings_get: {
    parameters: {
      query?: {
        expiry?: number;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetRecordingsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionContextDocumentView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionContextDocumentView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['DeleteSessionContextDocumentsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteSessionContextDocumentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_session_context_documents_api_v2_ml_scribe_sessions__session_id__context_documents_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSessionContextDocumentsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionContextDocumentView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_context_document_file_api_v2_ml_scribe_sessions__session_id__context_documents__context_document_id__file_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        context_document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_session_patient_document_links_api_v2_ml_scribe_sessions__session_id__patient_documents_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionPatientDocumentLinkListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_patient_documents_to_session_api_v2_ml_scribe_sessions__session_id__patient_documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSessionPatientDocumentLinksRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionPatientDocumentLinkListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_patient_document_from_session_api_v2_ml_scribe_sessions__session_id__patient_documents__patient_document_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_safety_issue_ticket_endpoint_api_v2_ml_scribe_sessions__session_id__safety_issue_ticket_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SafetyIssueTicketRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SafetyIssueTicketResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Bad Gateway */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  generate_live_dictation_api_v2_ml_scribe_sessions__session_id__dictate_live_dictation_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LiveDictationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_feedback_v2_api_v2_ml_scribe_sessions__session_id__feedback_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetUserFeedbackListResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_feedback_v2_api_v2_ml_scribe_sessions__session_id__feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitFeedbackRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SubmitFeedbackResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_shares_api_v2_ml_scribe_sessions__session_id__shares_get: {
    parameters: {
      query?: {
        /** @description Maximum number of users to return (default: 10, max: 20) */
        limit?: number;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetSessionSharesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upsert_session_shares_api_v2_ml_scribe_sessions__session_id__shares_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpsertSessionSharesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpsertSessionSharesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revoke_session_share_api_v2_ml_scribe_sessions__session_id__shares__user_ref_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        user_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RevokeSessionShareResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_link_shares_api_v2_ml_scribe_sessions__session_id__link_shares_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetLinkSharesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_link_share_recipients_api_v2_ml_scribe_sessions__session_id__link_shares_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddLinkShareRecipientsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AddLinkShareRecipientsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_link_share_settings_api_v2_ml_scribe_sessions__session_id__link_shares_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLinkShareSettingsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: boolean;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revoke_link_share_recipient_api_v2_ml_scribe_sessions__session_id__link_shares_recipients__share_token__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        share_token: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: boolean | string;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_link_share_recipient_api_v2_ml_scribe_sessions__session_id__link_shares_recipients__share_token__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        share_token: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLinkShareRecipientRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: boolean;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  disable_link_sharing_api_v2_ml_scribe_sessions__session_id__link_shares_disable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: boolean;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  enable_link_sharing_api_v2_ml_scribe_sessions__session_id__link_shares_enable_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: boolean;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_mergeable_sessions_api_v2_ml_scribe_sessions__session_id__merged_sessions_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MergeableSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  merge_sessions_api_v2_ml_scribe_sessions__session_id__merged_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['MergeSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MergeSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_and_merge_sessions_to_patient_profile_api_v2_ml_scribe_sessions__session_id__merged_sessions_patient_profile__patient_profile_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        patient_profile_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MergeSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_patient_link_review_api_v2_ml_scribe_sessions__session_id__merged_sessions_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_merged_sessions_api_v2_ml_scribe_sessions__session_id__merged_sessions_link_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LinkMergedSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinkMergedSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_merged_sessions_api_v2_ml_scribe_sessions__session_id__merged_sessions_unlink_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnlinkMergedSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnlinkMergedSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  discard_session_group_suggestion_api_v2_ml_scribe_sessions__session_id__merged_sessions_discard_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  request_otp_api_v2_ml_scribe_sessions_shared__share_token__request_otp_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        share_token: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RequestOTPRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequestOTPResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  verify_otp_api_v2_ml_scribe_sessions_shared__share_token__verify_otp_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        share_token: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['VerifyOTPRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerifyOTPResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_link_shared_session_api_v2_ml_scribe_sessions_shared__share_token__get: {
    parameters: {
      query?: never;
      header: {
        authorization: string;
      };
      path: {
        share_token: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinkSharedSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_link_shared_documents_api_v2_ml_scribe_sessions_shared__share_token__documents_get: {
    parameters: {
      query?: never;
      header: {
        authorization: string;
      };
      path: {
        share_token: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinkSharedDocumentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  analyze_session_note_api_v2_ml_scribe_sessions__session_id__entity_verification_analyze_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AnalyzeNoteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_auto_verification_api_v2_ml_scribe_sessions__session_id__entity_verification_auto_start_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StartAutoVerificationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_analysis_api_v2_ml_scribe_sessions__session_id__entity_verification__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['ClinicalNotesAnalysisResponse']
            | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_entity_feedback_api_v2_ml_scribe_sessions__session_id__entity_verification_feedback_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetEntityFeedbackListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_entity_feedback_api_v2_ml_scribe_sessions__session_id__entity_verification_feedback_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitEntityFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SubmitEntityFeedbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_overall_feedback_api_v2_ml_scribe_sessions__session_id__entity_verification_overall_feedback_get: {
    parameters: {
      query?: {
        /** @description When set, return feedback for this clinical_notes_analysis id; otherwise latest ENTITY_VERIFICATION row for the session. */
        analysis_id?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetOverallFeedbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_overall_feedback_api_v2_ml_scribe_sessions__session_id__entity_verification_overall_feedback_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitOverallFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SubmitOverallFeedbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  analyze_session_note_api_v2_ml_scribe_sessions__session_id__verify_lite_analyze_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerifyLiteAnalysisResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_auto_verify_lite_api_v2_ml_scribe_sessions__session_id__verify_lite_auto_start_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StartAutoVerifyLiteResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_analysis_api_v2_ml_scribe_sessions__session_id__verify_lite__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerifyLiteAnalysisResponse'] | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  stream_session_problems_api_v2_ml_scribe_sessions__session_id__problems_stream_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_problems_api_v2_ml_scribe_sessions__session_id__problems_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionProblemsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_session_problems_api_v2_ml_scribe_sessions__session_id__problems_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConfirmProblemsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConfirmProblemResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  push_codes_to_ehr_api_v2_ml_scribe_sessions__session_id__problems_push_codes_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PushCodesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  regenerate_session_problems_api_v2_ml_scribe_sessions__session_id__problems_regenerate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RegenerateProblemsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_snippets_api_v2_ml_scribe_snippets_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SnippetsResponse'];
        };
      };
    };
  };
  create_user_snippet_api_v2_ml_scribe_snippets_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSnippetRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SingleSnippetResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_user_snippets_batch_api_v2_ml_scribe_snippets_batch_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSnippetsBatchRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SnippetsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_snippets_csv_api_v2_ml_scribe_snippets_batch_upload_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_snippets_csv_api_v2_ml_scribe_snippets_batch_upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SnippetUploadResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_user_snippet_api_v2_ml_scribe_snippets__snippet_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        snippet_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteSnippetResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_user_snippet_api_v2_ml_scribe_snippets__snippet_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        snippet_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSingleSnippetRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SingleSnippetResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_source_lists_api_v2_ml_scribe_source_lists__get: {
    parameters: {
      query?: {
        unmigrated_only?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_source_list_api_v2_ml_scribe_source_lists__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSourceListRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_source_list_api_v2_ml_scribe_source_lists__source_list_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_list_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_source_list_api_v2_ml_scribe_source_lists__source_list_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_list_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSourceListRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_source_list_api_v2_ml_scribe_source_lists__source_list_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_list_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteSourceListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_stand_alone_launch_authorize_endpoint_api_v2_ml_scribe_stand_alone_launch_authentication_endpoint_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EpicCreateStandAloneLaunchAdaptorRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StandAloneLaunchAuthorizeEndpointResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  exchange_stand_alone_launch_auth_code_for_access_token_api_v2_ml_scribe_stand_alone_launch_authentication_access_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Body_exchange_stand_alone_launch_auth_code_for_access_token_api_v2_ml_scribe_stand_alone_launch_authentication_access_token_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StandAloneLaunchExchangeAccessTokenResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_api_v2_ml_scribe_system_template_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_api_v2_ml_scribe_system_template__template_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_templates_by_tags_api_v2_ml_scribe_system_template_by_tags_post: {
    parameters: {
      query?: {
        /** @description Search keyword for template names */
        keyword?: string | null;
        /** @description Page number */
        page?: number;
        /** @description Number of templates per page */
        page_size?: number;
        /** @description Field to order by (name, created_at, updated_at) */
        order_by?: string;
        /** @description Sort order direction (asc or desc) */
        order_direction?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GetTemplatesByUserAttributesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_delete_templates_by_ids_api_v2_ml_scribe_system_template_batch_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': string[];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  batch_update_templates_by_ids_api_v2_ml_scribe_system_template_batch_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BatchUpdateTemplatesByIdRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchUpdateTemplatesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_active_template_version_api_v2_ml_scribe_system_template__template_id__versions__version__activate_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
        version: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_create_template_by_csv_api_v2_ml_scribe_system_template_bulk_create_template_post: {
    parameters: {
      query?: {
        execute?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_bulk_create_template_by_csv_api_v2_ml_scribe_system_template_bulk_create_template_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['BulkCreateTemplateCSVFileUploadResult']
            | components['schemas']['BulkCreateTemplateCSVFileValidateResult'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_form_system_template_api_v2_ml_scribe_system_template_form_templates_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_create_form_system_template_api_v2_ml_scribe_system_template_form_templates_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalTemplateResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_joined_teams_api_v2_ml_scribe_teams__get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JoinedTeamsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_team_api_v2_ml_scribe_teams__post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_details_api_v2_ml_scribe_teams__team_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['TeamResponse']
            | components['schemas']['SimpleTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_api_v2_ml_scribe_teams__team_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_members_with_relationship_api_v2_ml_scribe_teams__team_id__members_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamMemberRelationsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_billing_info_api_v2_ml_scribe_teams__team_id__billing_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamBillingResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_member_api_v2_ml_scribe_teams__team_id__member__member_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_invitation_api_v2_ml_scribe_teams__team_id__invitations_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateInvitationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateInvitationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resend_invitation_api_v2_ml_scribe_teams__team_id__invitations__invitation_id__resend_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        invitation_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ResendInvitationResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  accept_invitation_api_v2_ml_scribe_teams__team_id__invitations_accept_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_mfa_api_v2_ml_scribe_teams__team_id__mfa_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamMFARequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SimpleTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_consent_api_v2_ml_scribe_teams__team_id__consent_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamConsentUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SimpleTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_review_confirmation_api_v2_ml_scribe_teams__team_id__review_confirmation_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamReviewConfirmationUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SimpleTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_session_retention_api_v2_ml_scribe_teams__team_id__session_retention_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamSessionRetentionUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SimpleTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_patient_retention_api_v2_ml_scribe_teams__team_id__patient_retention_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamPatientRetentionUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SimpleTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_transcript_retention_api_v2_ml_scribe_teams__team_id__transcript_retention_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TeamTranscriptRetentionUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SimpleTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  reset_and_delete_team_api_v2_ml_scribe_teams__team_id__reset_and_delete_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_analytics_dashboard_api_v2_ml_scribe_teams__team_id__analytics_dashboard_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AnalyticsDashboardResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  request_evidence_access_from_team_admins_api_v2_ml_scribe_teams__team_id__request_evidence_access_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RequestEvidenceAccessRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequestEvidenceAccessResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  request_subscription_upgrade_from_team_admins_api_v2_ml_scribe_teams__team_id__request_plan_upgrade_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RequestSubscriptionUpgradeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequestSubscriptionUpgradeResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_team_member_sessions_api_v2_ml_scribe_teams__team_id__members__member_id__sessions_get: {
    parameters: {
      query?: {
        page_size?: number | null;
        last_session_created_at?: string | null;
        ehr_provider?: string | null;
        ehr_patient_id?: string | null;
        patient_profile_id?: string | null;
        ehr_encounter_id?: string | null;
      };
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_new_session_for_team_member_api_v2_ml_scribe_teams__team_id__members__member_id__sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['domains__sessions__schemas__CreateSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__sessions__schemas__CreateSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_member_session_status_count_api_v2_ml_scribe_teams__team_id__members__member_id__sessions_status_count_get: {
    parameters: {
      query: {
        /** @description Session status to count */
        session_status: components['schemas']['SessionStatus'];
      };
      header?: never;
      path: {
        member_id: string;
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionStatusCountResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_member_session_by_id_api_v2_ml_scribe_teams__team_id__members__member_id__sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetailedSessionView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_member_session_api_v2_ml_scribe_teams__team_id__members__member_id__sessions__session_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTeamMemberSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdatedDetailedSessionView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_create_sessions_for_team_member_api_v2_ml_scribe_teams__team_id__members__member_id__sessions_batch_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkCreateSessionParams'][];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DetailedSessionView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_profiles_for_team_member_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPatientProfilesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_patient_profile_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreatePatientProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreatePatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_patient_profile_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__patient_profile_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        patient_profile_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_patient_profile_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__patient_profile_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePatientProfileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdatePatientProfileResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  link_patient_sessions_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__patient_profile_id__sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LinkPatientSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LinkPatientSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlink_patient_sessions_api_v2_ml_scribe_teams__team_id__members__member_id__patient_profiles__patient_profile_id__sessions_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_profile_id: string;
        member_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UnlinkPatientSessionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UnlinkPatientSessionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_team_seat_summary_api_v2_ml_scribe_teams__team_id__seats_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SeatSummaryResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_team_shortcuts_api_v2_ml_scribe_teams__team_id__shortcuts_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListTeamShortcutsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_team_shortcut_api_v2_ml_scribe_teams__team_id__shortcuts_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTeamShortcutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamShortcutSchema'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_team_shortcut_api_v2_ml_scribe_teams__team_id__shortcuts__shortcut_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        shortcut_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_team_shortcut_api_v2_ml_scribe_teams__team_id__shortcuts__shortcut_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
        shortcut_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTeamShortcutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TeamShortcutSchema'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_consult_note_templates_api_v2_ml_scribe_templates_consult_note_templates_get: {
    parameters: {
      query?: {
        specialty_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplatesResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_document_templates_api_v2_ml_scribe_templates_document_templates_get: {
    parameters: {
      query?: {
        specialty_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplatesResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_pinned_templates_api_v2_ml_scribe_templates_pinned_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplatesResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  update_pinned_template_order_api_v2_ml_scribe_templates_pinned_order_put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePinnedTemplateOrderRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplatesResponseV2'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_templates_api_v2_ml_scribe_templates_search_get: {
    parameters: {
      query: {
        /** @description Search query for template names */
        keyword?: string | null;
        /** @description Field to sort by */
        sort_by?: components['schemas']['TemplateSortBy'];
        /** @description Sort order */
        order?: components['schemas']['shared__enums__enums__SortOrder'];
        /** @description Page number for pagination */
        page?: number;
        /** @description Number of items per page */
        page_size?: number;
        organization_id: string;
        /** @description List of visibility to filter by */
        'visibilities[]'?: components['schemas']['TemplateVisibility'][] | null;
        /** @description List of template categories to filter by */
        'types[]'?: components['schemas']['TemplateType'][] | null;
        /** @description List of creator IDs to filter by */
        'creator_user_ids[]'?: string[] | null;
        /** @description List of shared team IDs to filter by */
        'shared_team_ids[]'?: string[] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchTemplatesResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_search_filter_metadata_api_v2_ml_scribe_templates_search_filter_metadata_get: {
    parameters: {
      query: {
        organization_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateSearchFilterMetadataResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_initial_pinned_templates_api_v2_ml_scribe_templates_initial_pinned_templates_get: {
    parameters: {
      query?: {
        /** @description Maximum templates to return (used when unauthenticated) */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_recommended_templates_api_v2_ml_scribe_templates_recommended_templates_get: {
    parameters: {
      query?: {
        /** @description Specialty ObjectId */
        specialty_id?: string | null;
        /** @description Language code (e.g. 'en') */
        language?: string | null;
        /** @description Country name (e.g. 'Australia') */
        country?: string | null;
        /** @description Maximum templates to return */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplatesResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_api_v2_ml_scribe_templates__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: components['schemas']['TemplateId'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_template_delete_api_v2_ml_scribe_templates__template_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_api_v2_ml_scribe_templates__template_id__patch: {
    parameters: {
      query?: {
        save_anyway?: boolean | null;
      };
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplateRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_xml_source_api_v2_ml_scribe_templates__template_id__xml_source_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: components['schemas']['TemplateId'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateXmlSourceResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_json_source_api_v2_ml_scribe_templates__template_id__json_source_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: components['schemas']['TemplateId'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateJsonSourceResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_system_template_api_v2_ml_scribe_templates_system__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: components['schemas']['TemplateId'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_templates_api_v2_ml_scribe_templates__get: {
    parameters: {
      query?: {
        specialty_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplatesResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_api_v2_ml_scribe_templates__post: {
    parameters: {
      query?: {
        save_anyway?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['CreateTemplateFromScratchRequest']
          | components['schemas']['CreateTemplateFromAICommandRequest']
          | components['schemas']['CreateTemplateFromDocumentRequest']
          | components['schemas']['CreateTemplateFromExistingTemplateRequest']
          | components['schemas']['CreateTemplateFromTemplateGalleryRequest']
          | components['schemas']['CreateTemplateFormFromPDF']
          | components['schemas']['CreateTemplateFormFromXML']
          | components['schemas']['CreateTemplateFormFromJSON'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_favorite_status_api_v2_ml_scribe_templates__template_id__favour_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplateFavoriteStatusRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_pinned_status_api_v2_ml_scribe_templates__template_id__pin_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplatePinnedStatusRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateResponseV2'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Too Many Requests */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  set_initial_pinned_templates_api_v2_ml_scribe_templates_set_initial_pinned_templates_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  send_share_template_email_api_v2_ml_scribe_templates_share_email_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ShareTemplateEmailRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ShareTemplateEmailResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  live_dictation_for_template_creation_api_v2_ml_scribe_templates_template_creation_record_dictate_live_dictation_post: {
    parameters: {
      query?: {
        mode?: components['schemas']['DictationCleanupModes'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_creation_record_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplateCreationRecordResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_creation_record_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplateCreationRecordRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateCreationRecordResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_creation_record_by_template_id_api_v2_ml_scribe_templates_template_creation_record_template__template_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplateCreationRecordResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_creation_record_by_template_id_api_v2_ml_scribe_templates_template_creation_record_template__template_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplateCreationRecordResponse'];
        };
      };
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetTemplateCreationRecordResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_creation_record_api_v2_ml_scribe_templates_template_creation_record_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json':
          | components['schemas']['CreateTemplateCreationRecordFromChatRequest']
          | components['schemas']['CreateTemplateCreationRecordFromFileUploadRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateCreationRecordResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_initial_template_structure_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__generate_initial_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_initial_template_structure_to_version_control_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control__target_version_control_id__generate_initial_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
        target_version_control_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_version_control_via_example_note_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control_example_note_structure_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateVersionControlFromExampleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_example_note_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id___version_control_id__example_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
        version_control_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_version_control_via_chat_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control__target_version_control_id__chat_structure_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
        target_version_control_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateStructureViaChatRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_example_via_chat_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control__target_version_control_id__chat_example_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
        target_version_control_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateExampleViaChatRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_template_version_control_via_structure_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control_structure_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTemplateVersionControlManualRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateVersionControlResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_structure_from_note_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control__target_version_control_id__example_note_structure_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
        target_version_control_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateStructureFromExampleRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_latest_version_control_api_v2_ml_scribe_templates_template_creation_record__template_creation_record_id__version_control_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_creation_record_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateLatestVersionControlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateVersionControlResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_suggestions_api_v2_ml_scribe_templates_template_creation_record_suggestions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTemplateSuggestionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateTemplateSuggestionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_public_template_suggestions_api_v2_ml_scribe_templates_template_creation_record_suggestions_public_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreatePublicTemplateSuggestionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateTemplateSuggestionsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_template_public_api_v2_ml_scribe_templates_template_creation_record_generate_public_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateTemplatePublicRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateTemplatePublicResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  edit_template_public_api_v2_ml_scribe_templates_template_creation_record_edit_public_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EditTemplatePublicRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EditTemplatePublicResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_example_note_public_api_v2_ml_scribe_templates_template_creation_record_example_note_public_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateExampleNotePublicRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateExampleNotePublicResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  process_uploaded_document_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_process_uploaded_document_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProcessUploadedDocumentResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  process_uploaded_document_public_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_public_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_process_uploaded_document_public_api_v2_ml_scribe_templates_template_creation_record_process_uploaded_document_public_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProcessUploadedDocumentResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_template_version_control_by_id_api_v2_ml_scribe_templates_template_creation_record_version_control__version_control_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        version_control_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateVersionControlResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_template_version_control_api_v2_ml_scribe_templates_template_creation_record_version_control__version_control_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        version_control_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_template_version_control_api_v2_ml_scribe_templates_template_creation_record_version_control__version_control_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        version_control_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateTemplateVersionControlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TemplateVersionControlResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_shared_template_api_v2_ml_scribe_templates_shared_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateSharedTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateSharedTemplateResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  request_upload_url_api_v2_ml_scribe_translator_audio_upload_url_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UploadUrlRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UploadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_download_url_api_v2_ml_scribe_translator_audio__storage_id__download_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        storage_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__translator__api__schemas__audio__DownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  log_debug_event_api_v2_ml_scribe_translator_debug_events_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LogDebugEventRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_languages_api_v2_ml_scribe_translator_languages_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LanguageResponse'][];
        };
      };
    };
  };
  list_sessions_api_v2_ml_scribe_translator_sessions_get: {
    parameters: {
      query?: {
        limit?: number;
        skip?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_session_api_v2_ml_scribe_translator_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['domains__translator__api__schemas__sessions__CreateSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__translator__api__schemas__sessions__CreateSessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_evaluation_summary_api_v2_ml_scribe_translator_sessions__session_id__evaluation_summary_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionEvaluationSummaryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_evaluation_api_v2_ml_scribe_translator_sessions__session_id__evaluation_patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSessionEvaluationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionEvaluationSummaryResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  export_evaluation_api_v2_ml_scribe_translator_sessions__session_id__evaluation_export_get: {
    parameters: {
      query?: {
        /** @description IANA timezone for Date Evaluated (download day) / error-log timestamps (e.g. Australia/Melbourne). Defaults to UTC when omitted or unrecognized. */
        timezone?: string | null;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_session_api_v2_ml_scribe_translator_sessions__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_session_api_v2_ml_scribe_translator_sessions__session_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_session_api_v2_ml_scribe_translator_sessions__session_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  set_onboarding_complete_api_v2_ml_scribe_translator_sessions__session_id__onboarding_complete_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetOnboardingCompleteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  track_bulk_upload_api_v2_ml_scribe_translator_sessions__session_id__track_bulk_upload_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TrackBulkUploadRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_messages_api_v2_ml_scribe_translator_sessions__session_id__messages_get: {
    parameters: {
      query?: {
        limit?: number;
        skip?: number;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MessageResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_message_api_v2_ml_scribe_translator_sessions__session_id__messages_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddMessageRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MessageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_message_api_v2_ml_scribe_translator_messages__message_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        message_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_message_api_v2_ml_scribe_translator_messages__message_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        message_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateMessageRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MessageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_feedback_api_v2_ml_scribe_translator_messages__message_id__submit_feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        message_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MessageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  log_evaluation_error_api_v2_ml_scribe_translator_messages__message_id__feedback_errors_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        message_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TranslatorEvaluationErrorPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MessageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_evaluation_error_api_v2_ml_scribe_translator_messages__message_id__feedback_errors__stage__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        message_id: string;
        stage: components['schemas']['EvaluationErrorStage'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MessageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_autoplayed_api_v2_ml_scribe_translator_messages__message_id__mark_autoplayed_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        message_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MessageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  track_audio_playback_api_v2_ml_scribe_translator_messages__message_id__track_audio_playback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        message_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['OkResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_preferences_api_v2_ml_scribe_translator_users_preferences_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PreferencesResponse'];
        };
      };
    };
  };
  update_preferences_api_v2_ml_scribe_translator_users_preferences_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePreferencesRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PreferencesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  suggest_chips_api_v2_ml_scribe_transcript_chips_suggest_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['TranscriptChipsRequestSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TranscriptChipsResponseSchema'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  clear_session_context_api_v2_ml_scribe_transcript_chips_session__session_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_auto_evidence_config_api_v2_ml_scribe_transcript_chips_config_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AutoEvidenceConfigSchema'];
        };
      };
    };
  };
  update_auto_evidence_config_api_v2_ml_scribe_transcript_chips_config_put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AutoEvidenceConfigUpdateSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AutoEvidenceConfigSchema'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_usability_feedback_api_v2_ml_scribe_usability_feedback__feature__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        feature: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SubmitUsabilityFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SubmitUsabilityFeedbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  snooze_usability_feedback_api_v2_ml_scribe_usability_feedback__feature__snooze_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        feature: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SnoozeUsabilityFeedbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_usage_entitlement_api_v2_ml_scribe_usage_entitlements__metric_key__get: {
    parameters: {
      query?: {
        scope?: PathsApiV2MlScribeUsageEntitlementsMetric_keyGetParametersQueryScope;
        period?: PathsApiV2MlScribeUsageEntitlementsMetric_keyGetParametersQueryPeriod;
      };
      header?: never;
      path: {
        metric_key: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EntitlementResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  verify_current_email_request_api_v2_ml_scribe_user_email_change_verify_current_email_request_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerifyCurrentEmailResponse'];
        };
      };
      /** @description Feature flag disabled or SSO user */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User has no email address */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description System error (email sending failed or service misconfigured) */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  verify_current_email_check_api_v2_ml_scribe_user_email_change_verify_current_email_check_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CheckCurrentEmailRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CheckCurrentEmailResponse'];
        };
      };
      /** @description Invalid or expired code, or invalid timestamp format */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Feature flag disabled */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User has no email address */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description System error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  request_email_change_api_v2_ml_scribe_user_email_change_request_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RequestEmailChangeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RequestEmailChangeResponse'];
        };
      };
      /** @description Invalid email format, duplicate email, same as current, or invalid current email code */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Feature flag disabled */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User has no email address */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description System error (email sending failed) */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  confirm_email_change_api_v2_ml_scribe_user_email_change_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConfirmEmailChangeRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConfirmEmailChangeResponse'];
        };
      };
      /** @description Invalid or expired code, or invalid timestamp format */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Feature flag disabled */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Email already registered to another user (race condition) */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description User has no email address */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description System error (Kinde, MongoDB, or Stripe update failed) */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_gamify_trial_extension_progress_api_v2_ml_scribe_user_gamify_trial_extension_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GamifyTrialExtensionResponse'];
        };
      };
    };
  };
  record_template_selected_api_v2_ml_scribe_user_gamify_trial_extension_record_template_selected_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  record_source_control_used_api_v2_ml_scribe_user_gamify_trial_extension_record_source_control_used_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_ehr_profile_api_v2_ml_scribe_user_ehr_profile_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRProfileResponse'];
        };
      };
    };
  };
  create_ehr_profile_api_v2_ml_scribe_user_ehr_profile_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateEHRProfileAPIRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRProfileResponse'] | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_ehr_profile_api_v2_ml_scribe_user_ehr_profile_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRProfileResponse'];
        };
      };
    };
  };
  update_ehr_profile_api_v2_ml_scribe_user_ehr_profile_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateEHRProfileAPIRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRProfileResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_user_linked_account_api_v2_ml_scribe_user_linked_account_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserLinkedAccountResponse'];
        };
      };
    };
  };
  get_joinable_teams_api_v2_ml_scribe_user_self_onboard_joinable_teams_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetJoinableTeamsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_joinable_teams_api_v2_ml_scribe_user_self_onboard_candidate_teams_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetJoinableTeamsResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  self_onboard_api_v2_ml_scribe_user_self_onboard_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SelfOnboardRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SelfOnboardResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  update_user_mfa_api_v2_ml_scribe_user_mfa_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserMFARequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_post_note_quality_task_completed_api_v2_ml_scribe_user_post_note_quality_tasks__task_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        task_id: components['schemas']['PostNoteQualityTask'];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  dismiss_post_note_quality_panel_api_v2_ml_scribe_user_post_note_quality_dismiss_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  mark_post_note_quality_panel_seen_api_v2_ml_scribe_user_post_note_quality_mark_seen_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  extend_reverse_trial_api_v2_ml_scribe_user_extend_reverse_trial_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ExtendReverseTrialRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  revert_reverse_trial_api_v2_ml_scribe_user_revert_reverse_trial_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  reset_clinical_code_auto_gen_quota_api_v2_ml_scribe_user_quota_clinical_code_auto_gen_reset_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
    };
  };
  logout_everywhere_api_v2_ml_scribe_user_session_revocation_logout_everywhere_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Sessions revoked */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LogoutEverywhereResponse'];
        };
      };
      /** @description Non-Auth0 account */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Server error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_user_api_v2_ml_scribe_user_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_user_api_v2_ml_scribe_user_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateUserRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  record_modal_view_api_v2_ml_scribe_user_modal_view_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecordModalViewRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_auto_link_intent_api_v2_ml_scribe_user_auto_link_intent_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAutoLinkIntentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_auto_extract_intent_api_v2_ml_scribe_user_auto_extract_intent_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAutoExtractIntentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  disable_session_timeout_api_v2_ml_scribe_user_session_timeout_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Session timeout disabled for the caller. Resolver will now return `USER_DISABLED` (or `ORGANIZATION` if an admin later sets an org-level override). */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  set_session_timeout_api_v2_ml_scribe_user_session_timeout_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetSessionTimeoutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EffectiveSessionTimeout'] | null;
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  send_get_mobile_email_api_v2_ml_scribe_user_get_mobile_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GetMobileRequest'];
      };
    };
    responses: {
      /** @description Email sent successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_evidence_usage_stats_api_v2_ml_scribe_user_activity_evidence_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EvidenceUsageStatsResponse'];
        };
      };
    };
  };
  get_team_evidence_usage_stats_api_v2_ml_scribe_user_activity_team__team_id__evidence_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EvidenceUsageStatsResponse'];
        };
      };
      /** @description Caller is not a team admin for this team. Returned uniformly for non-admin callers regardless of whether the team exists, to avoid leaking team-id existence to non-members. */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_workspaces_api_v2_ml_scribe_workspaces_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__workspace__api__v2__workspaces__workspaces_schema__ListWorkspacesResponse'];
        };
      };
    };
  };
  list_workspace_invitations_api_v2_ml_scribe_workspaces_invitations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListWorkspaceInvitationsResponse'];
        };
      };
    };
  };
  get_workspace_api_v2_ml_scribe_workspaces__workspace_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        workspace_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['WorkspaceDetailsResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_partner_upload_configuration_api_v2_ml_scribe_integrations_partner_content_sync_configuration_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PartnerUploadConfigurationResponse'];
        };
      };
    };
  };
  create_upload_url_api_v2_ml_scribe_integrations_partner_content_sync_upload_url_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PresignRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PresignedUploadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  trigger_partner_sync_api_v2_ml_scribe_integrations_partner_content_sync_sync_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncTriggerResponse'];
        };
      };
    };
  };
  get_sync_job_api_v2_ml_scribe_integrations_partner_content_sync_sync_jobs__job_ref_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        job_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchJobProgress'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_sync_job_failures_api_v2_ml_scribe_integrations_partner_content_sync_sync_jobs__job_ref_id__failed_tasks_get: {
    parameters: {
      query?: {
        limit?: number;
      };
      header?: never;
      path: {
        job_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FailedTaskItem'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retry_sync_job_api_v2_ml_scribe_integrations_partner_content_sync_sync_jobs__job_ref_id__retry_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        job_ref_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetryAcceptedResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_guid_api_v2_ml_scribe_ehr_onboarding_guid_get: {
    parameters: {
      query: {
        site_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchGUIDResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_and_compare_guid_api_v2_ml_scribe_ehr_onboarding_guid_matching_get: {
    parameters: {
      query: {
        site_id: string;
        guid: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchGUIDResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  pair_bp_site_api_v2_ml_scribe_ehr_onboarding_bp_pair_site_get: {
    parameters: {
      query: {
        site_id: string;
        pairing_code: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchGUIDResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_cliniko_practitioner_details_api_v2_ml_scribe_ehr_onboarding_cliniko_get: {
    parameters: {
      query: {
        api_key: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ClinikoPractitionerDetails'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_magentus_tenant_id_api_v2_ml_scribe_ehr_onboarding_pairing_code_get: {
    parameters: {
      query?: {
        pairing_code?: string | null;
        tenant_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MagentusOnboardingTenantDetails'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  check_mindbody_site_access_api_v2_ml_scribe_ehr_onboarding_mindbody_site_access_get: {
    parameters: {
      query: {
        site_id: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MindbodySiteAccessResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_ehr_internal_user_by_name_api_v2_ml_scribe_ehr_users_get: {
    parameters: {
      query: {
        first_name: string;
        last_name: string;
        ehr_provider?: components['schemas']['EHRProvider'] | null;
        guid?: string | null;
        clinic_id?: string | null;
        api_key?: string | null;
        username?: string | null;
        password?: string | null;
        unity_base_url?: string | null;
        ubiquity_id?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchStaffByNameResponse'][] | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_staff_endpoint_api_v2_ml_scribe_ehr_users_v2_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['Body_search_staff_endpoint_api_v2_ml_scribe_ehr_users_v2_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchStaffByNameResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_appointments_api_v2_ml_scribe_ehr_appointments_get: {
    parameters: {
      query: {
        selected_date: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchAppointmentResponse'] | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sync_notes_to_ehr_api_v2_ml_scribe_ehr_uploader__session_id__notes_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['SyncNotesToEHRAPIRequest'] | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SyncNotesToEHRResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_available_sections_api_v2_ml_scribe_ehr_uploader_available_sections_get: {
    parameters: {
      query: {
        provider: components['schemas']['EHRProvider'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AvailableSectionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_available_standardized_sections_api_v2_ml_scribe_ehr_uploader_available_standardized_sections_get: {
    parameters: {
      query: {
        provider: components['schemas']['EHRProvider'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__ehr__uploader_schema__AvailableStandardizedSectionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_letter_templates_api_v2_ml_scribe_ehr_letter_templates_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListLetterTemplatesResponse'];
        };
      };
    };
  };
  send_outgoing_correspondence_with_letter_template_api_v2_ml_scribe_ehr_letter_session__session_id__outgoing_correspondence_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SendOutgoingCorrespondenceWithLetterTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendOutgoingCorrespondenceWithLetterTemplateResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  handle_hubspot_webhook_api_v2_ml_scribe_hubspot_webhook_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: string;
          };
        };
      };
    };
  };
  handle_hubspot_deal_paid_webhook_api_v2_ml_scribe_hubspot_webhook_deal_paid_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: string;
          };
        };
      };
    };
  };
  handle_hubspot_deal_intake_webhook_api_v2_ml_scribe_hubspot_webhook_smb_deal_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: string;
          };
        };
      };
    };
  };
  create_checkout_session_api_v2_ml_scribe_payments_checkout_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateCheckoutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateCheckoutSessionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  change_subscribed_plan_api_v2_ml_scribe_payments_change_plan_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ChangeSubscriptionPlanRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_add_on_checkout_session_api_v2_ml_scribe_payments_add_on_product_checkout__add_on_product_internal_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        add_on_product_internal_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateAddOnCheckoutRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateCheckoutSessionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  append_add_on_product_subscription_api_v2_ml_scribe_payments_add_on_product__add_on_product_internal_id__update_subscription_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        add_on_product_internal_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  activate_promoted_free_trial_api_v2_ml_scribe_payments_activate_promoted_free_trial_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ActivatePromotedFreeTrialRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  deactivate_promoted_free_trial_api_v2_ml_scribe_payments_deactivate_promoted_free_trial_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_draft_order_api_v2_ml_scribe_orders_draft_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateDraftOrderRequest'];
      };
    };
    responses: {
      /** @description Existing draft replayed for a repeated order id. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateDraftOrderResponse'];
        };
      };
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateDraftOrderResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_draft_order_api_v2_ml_scribe_orders_draft__order_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        order_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PublicDraftOrderResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_public_order_status_api_v2_ml_scribe_orders_status__erp_order_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        erp_order_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PublicOrderStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_products_api_v2_ml_scribe_products_get: {
    parameters: {
      query?: {
        new_product_tiers?: components['schemas']['SubscriptionTier'][] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetAllProductsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_products_api_v3_ml_scribe_products_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetHeidi2ProductsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_add_on_products_api_v2_ml_scribe_products_add_on_products_get: {
    parameters: {
      query?: {
        page?: number;
        page_size?: number;
        ehr_provider?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetAddOnProductsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  lookup_nav_graph_api_v2_ml_scribe_rpa_nav_graphs_lookup_get: {
    parameters: {
      query: {
        /** @description Bridge-reported app identity: frontmost app name, omnibox host, or process name — never a window title. */
        term: string;
      };
      header?: {
        'if-none-match'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_rpa_recording_api_v2_ml_scribe_rpa_recordings_post: {
    parameters: {
      query?: never;
      header?: {
        'Idempotency-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_rpa_recording_api_v2_ml_scribe_rpa_recordings_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaRecordingUploadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_rpa_recording_workflows_api_v2_ml_scribe_rpa_recordings_all_workflows_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaUserWorkflowsResponse'];
        };
      };
    };
  };
  get_rpa_recording_status_api_v2_ml_scribe_rpa_recordings__recording_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaRecordingStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_rpa_recording_api_v2_ml_scribe_rpa_recordings__recording_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        recording_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteRpaRecordingResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  initiate_rpa_recording_upload_api_v2_ml_scribe_rpa_recordings_upload_post: {
    parameters: {
      query?: never;
      header?: {
        'Idempotency-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InitiateRpaRecordingUploadRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaRecordingUploadInitiated'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_rpa_recording_part_urls_api_v2_ml_scribe_rpa_recordings_upload__upload_id__parts_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        upload_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RpaRecordingPartUrlsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaRecordingPartUploadUrls'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  complete_rpa_recording_upload_api_v2_ml_scribe_rpa_recordings_upload__upload_id__complete_post: {
    parameters: {
      query?: never;
      header?: {
        'Idempotency-Key'?: string | null;
      };
      path: {
        upload_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CompleteRpaRecordingUploadRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      202: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RpaRecordingUploadResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upsert_desktop_target_api_v2_ml_scribe_rpa_desktop_targets__instance_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        instance_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpsertDesktopTargetRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DesktopTargetResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_desktop_targets_api_v2_ml_scribe_rpa_desktop_targets_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DesktopTargetListResponse'];
        };
      };
    };
  };
  resolve_desktop_target_run_api_v2_ml_scribe_rpa_desktop_targets__target_id__runs__agent_run_id__resolve_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        target_id: string;
        agent_run_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ResolveDesktopTargetRunRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ResolveDesktopTargetRunResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_machine_api_v2_ml_scribe_rpa_cua_cloud_machine_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CuaCloudMachineResponse'];
        };
      };
    };
  };
  ensure_machine_api_v2_ml_scribe_rpa_cua_cloud_machine_put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CuaCloudMachineResponse'];
        };
      };
    };
  };
  create_vnc_session_api_v2_ml_scribe_rpa_cua_cloud_machine_vnc_session_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CuaCloudVncSessionResponse'];
        };
      };
    };
  };
  rpa_ax_assist_api_v2_ml_scribe_rpa_ax_assist_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AxAssistRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json':
            | components['schemas']['ExtractScheduleResponse']
            | components['schemas']['VerifyPatientResponse']
            | components['schemas']['ParseNoteSectionsResponse']
            | components['schemas']['ExtractChartContextResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_sales_booking_form_api_v2_ml_scribe_sales_booking__form_name__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        form_name: components['schemas']['SalesBookingFormName'];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SalesBookingSubmissionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SalesBookingSubmissionResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Bad Gateway */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  kinde_authenticate_api_v2_ml_scribe_kinde_webhook_authenticate_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  list_agent_memories_api_v2_ml_scribe_agent_memories_get: {
    parameters: {
      query?: {
        status?: components['schemas']['AgentMemoryStatus'];
        domains?: string[] | null;
        skip?: number;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ListAgentMemoriesResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agent_memory_api_v2_ml_scribe_agent_memories__memory_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        memory_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentMemoryView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_agent_memory_api_v2_ml_scribe_agent_memories__memory_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        memory_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_agent_memory_api_v2_ml_scribe_agent_memories__memory_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        memory_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAgentMemoryRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentMemoryView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  prepare_patient_summary_delivery_api_v2_ml_scribe_patient_summary_delivery_prepare_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PrepareRequestBody'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PrepareResponseBody'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_patient_summary_delivery_api_v2_ml_scribe_patient_summary_delivery_send_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PrepareRequestBody'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendResponseBody'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_patient_summary_email_api_v2_ml_scribe_patient_summary_delivery_send_email_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SendEmailRequestBody'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SendEmailResponseBody'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_patient_summary_pdf_api_v2_ml_scribe_patient_summary_delivery__document_id__preview_pdf_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Patient summary document ID. */
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
          'application/pdf': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_patient_summary_note_pdf_api_v2_ml_scribe_patient_summary_delivery_note__session_id__preview_pdf_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description Session ID owning the consult note. */
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
          'application/pdf': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_patient_summary_email_api_v2_ml_scribe_patient_summary_delivery__document_id__email_preview_get: {
    parameters: {
      query?: {
        /** @description Patient-facing document TYPE (e.g. 'visit summary'). Clamped to an allowlist server-side; defaults to 'document'. Mirrors the value the FE sends to /send-email so the preview matches the sent email. */
        document_type?: string | null;
      };
      header?: never;
      path: {
        /** @description Patient summary document ID. */
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmailPreviewResponseBody'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  preview_patient_summary_note_email_api_v2_ml_scribe_patient_summary_delivery_note__session_id__email_preview_get: {
    parameters: {
      query?: {
        /** @description Patient-facing document TYPE (e.g. 'visit summary'). Clamped to an allowlist server-side; defaults to 'document'. */
        document_type?: string | null;
      };
      header?: never;
      path: {
        /** @description Session ID owning the consult note. */
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EmailPreviewResponseBody'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  run_prechart_api_v2_ml_scribe_prechart_airflow_trigger_enqueue_post: {
    parameters: {
      query?: never;
      header?: {
        'X-Api-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunPrechartResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  trigger_enqueue_by_user_api_v2_ml_scribe_prechart_trigger_enqueue_by_user_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RunPrechartResponse'];
        };
      };
    };
  };
  toggle_is_precharting_enabled_api_v2_ml_scribe_prechart_toggle_is_precharting_enabled_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TogglePrechartingResponse'];
        };
      };
    };
  };
  is_precharting_enabled_api_v2_ml_scribe_prechart_is_precharting_enabled_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['TogglePrechartingResponse'];
        };
      };
    };
  };
  get_prechart_instructions_api_v2_ml_scribe_prechart_instructions_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPrechartInstructionsResponse'];
        };
      };
    };
  };
  update_prechart_instructions_api_v2_ml_scribe_prechart_instructions_put: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdatePrechartInstructionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPrechartInstructionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  edit_prechart_instructions_api_v2_ml_scribe_prechart_instructions_edit_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EditPrechartInstructionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EditPrechartInstructionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_prechart_api_v2_ml_scribe_prechart__session_id__prechart_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GeneratePrechartRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GetPrechartResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_prechart_document_api_v2_ml_scribe_prechart__session_id__generate_prechart_document_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['GeneratePrechartDocumentRequest']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GeneratePrechartDocumentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_prechart_feedback_api_v2_ml_scribe_prechart__session_id__feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PrechartFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_prechart_admin_stats_api_v2_ml_scribe_prechart_admin_stats_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PrechartStatsResponse'];
        };
      };
    };
  };
  get_precharts_by_session_api_v2_ml_scribe_prechart_admin_by_session__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PrechartBySessionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  enable_prechart_for_user_api_v2_ml_scribe_prechart_admin_enable_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['PrechartAdminEnableRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PrechartAdminEnableResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  voice_health_api_v2_ml_scribe_voice_health_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: boolean;
          };
        };
      };
    };
  };
  submit_voice_feedback_api_v2_ml_scribe_voice_feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['VoiceFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VoiceFeedbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_voice_sessions_api_v2_ml_scribe_voice_sessions_get: {
    parameters: {
      query?: {
        limit?: number;
        before?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VoiceSessionListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_voice_session_api_v2_ml_scribe_voice_sessions__voice_session_id__get: {
    parameters: {
      query?: {
        after_seq?: number;
        limit?: number;
      };
      header?: never;
      path: {
        voice_session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VoiceSessionDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_chat_api_v2_ml_scribe_chat_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateChatRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateChatResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  continue_chat_api_v2_ml_scribe_chat__chat_id__continue_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ContinueChatResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  store_chats_from_local_storage_api_v2_ml_scribe_chat_migrate_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StoreChatsFromLocalStorageRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['StoreChatsFromLocalStorageResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_chat_attachment_api_v2_ml_scribe_chat_attachments_post: {
    parameters: {
      query?: {
        /** @description Optional chat ID for organizing files */
        chatId?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_chat_attachment_api_v2_ml_scribe_chat_attachments_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PendingChatAttachmentResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description File too large */
      413: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_chat_attachment_api_v2_ml_scribe_chat_attachments_delete: {
    parameters: {
      query: {
        /** @description The attachment ID to delete */
        attachmentId: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Attachment deleted successfully */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  completions_api_v2_ml_scribe_chat_completions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  list_chats_api_v2_ml_scribe_chat_chats_get: {
    parameters: {
      query?: {
        /** @description Page number */
        page?: number;
        /** @description Number of chats per page */
        page_size?: number;
        /** @description When true, omit chats created by a routine run (source_workflow_id set). Evidence and ad-hoc Work chats stay. */
        exclude_workflow_runs?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChatListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_session_chats_api_v2_ml_scribe_chat_sessions__session_id__chats_get: {
    parameters: {
      query?: {
        /** @description Page number */
        page?: number;
        /** @description Number of chats per page */
        page_size?: number;
      };
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChatListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_standalone_chats_api_v2_ml_scribe_chat_chats_search_get: {
    parameters: {
      query: {
        /** @description Search term for out-of-session chat queries */
        q: string;
        /** @description Page number */
        page?: number;
        /** @description Number of chats per page */
        page_size?: number;
        /** @description When true, omit chats created by a routine run (source_workflow_id set). Evidence and ad-hoc Work chats stay. */
        exclude_workflow_runs?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChatListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_saved_chats_api_v2_ml_scribe_chat_chats_saved_get: {
    parameters: {
      query?: {
        /** @description Page number */
        page?: number;
        /** @description Number of chats per page */
        page_size?: number;
        /** @description When true, omit chats created by a routine run (source_workflow_id set). Evidence and ad-hoc Work chats stay. */
        exclude_workflow_runs?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChatListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_chat_api_v2_ml_scribe_chat_chats__chat_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChatResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  rename_chat_api_v2_ml_scribe_chat_chats__chat_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RenameChatRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ChatResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  save_chat_api_v2_ml_scribe_chat_chats__chat_id__save_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Chat saved successfully */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unsave_chat_api_v2_ml_scribe_chat_chats__chat_id__save_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Chat unsaved successfully */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_delete_chats_api_v2_ml_scribe_chat_chats_bulk_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkDeleteChatsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkDeleteChatsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_chat_api_v2_ml_scribe_chat__chat_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_sources_api_v2_ml_scribe_chat_sources_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceItem'][];
        };
      };
    };
  };
  get_blocked_domains_api_v2_ml_scribe_chat_blocked_domains_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BlockedDomainsResponse'];
        };
      };
    };
  };
  get_jurisdictions_api_v2_ml_scribe_chat_jurisdictions_get: {
    parameters: {
      query: {
        /** @description Country name, e.g. South Africa */
        country: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JurisdictionOptionResponse'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_follow_up_questions_api_v2_ml_scribe_chat_follow_up_questions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FollowUpQuestionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FollowUpQuestionsResponse'];
        };
      };
      /** @description Bad request or prompt injection detected */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation error (e.g. field too long) */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Rate limit exceeded */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  get_suggestions_api_v2_ml_scribe_chat_suggestions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SuggestionsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SuggestionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Rate limit exceeded */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  personalized_evidence_suggestions_api_v2_ml_scribe_chat_personalized_suggestions_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PersonalizedEvidenceSuggestionsResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Rate limit exceeded */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Personalized suggestions unavailable (e.g. LLM or parse failure) */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  exp_document_export_suggestions_api_v2_ml_scribe_chat_document_export_suggestions_get: {
    parameters: {
      query: {
        /** @description Session containing the document */
        session_id: string;
        /** @description MongoDB document id in this session */
        document_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DocumentExportSuggestionResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not allowed to access this session */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Session or document not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Invalid document_id query parameter */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Rate limit exceeded */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  share_chat_api_v2_ml_scribe_chat_chats__chat_id__share_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        chat_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ShareChatResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_shared_chat_api_v2_ml_scribe_chat_shared__share_token__get: {
    parameters: {
      query?: {
        /** @description Whether to create a copy of the chat for the recipient. Set to false when the viewer is in a different region — the frontend will fetch the data here and create the copy via their local backend. */
        create_copy?: boolean;
      };
      header?: never;
      path: {
        share_token: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharedChatResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_shared_chat_copy_api_v2_ml_scribe_chat_shared__share_token__copy_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        share_token: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SharedChatCopyRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharedChatResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  submit_evidence_feedback_api_v2_ml_scribe_chat_feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EvidenceFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EvidenceFeedbackResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_documents_api_v2_ml_scribe_evidence_user_documents_get: {
    parameters: {
      query?: {
        scope?: string | null;
        source?: string | null;
        document_kind?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserDocumentListResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_document_api_v2_ml_scribe_evidence_user_documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_document_api_v2_ml_scribe_evidence_user_documents_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JobResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_jobs_api_v2_ml_scribe_evidence_user_documents_jobs_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JobListResponse'];
        };
      };
    };
  };
  get_job_status_api_v2_ml_scribe_evidence_user_documents_jobs__job_id__status_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        job_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JobStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_job_api_v2_ml_scribe_evidence_user_documents_jobs__job_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        job_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retry_job_api_v2_ml_scribe_evidence_user_documents_jobs__job_id__retry_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        job_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['JobResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_documents_and_jobs_api_v2_ml_scribe_evidence_user_documents_all_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserDocumentsAndJobsResponse'];
        };
      };
    };
  };
  get_download_url_api_v2_ml_scribe_evidence_user_documents__document_id__download_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['evidence__models__user_document__DownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_preview_url_api_v2_ml_scribe_evidence_user_documents__document_id__preview_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['evidence__models__user_document__DownloadUrlResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  share_document_via_email_api_v2_ml_scribe_evidence_user_documents__document_id__share_email_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ShareDocumentEmailRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ShareDocumentEmailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_document_api_v2_ml_scribe_evidence_user_documents__document_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_document_api_v2_ml_scribe_evidence_user_documents__document_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UserDocumentUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserDocumentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_collections_api_v2_ml_scribe_evidence_collections_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionListResponse'];
        };
      };
    };
  };
  create_collection_api_v2_ml_scribe_evidence_collections_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_collection_api_v2_ml_scribe_evidence_collections__collection_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_collection_api_v2_ml_scribe_evidence_collections__collection_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_collection_api_v2_ml_scribe_evidence_collections__collection_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CollectionUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  add_documents_api_v2_ml_scribe_evidence_collections__collection_id__documents_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AddDocumentsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_document_api_v2_ml_scribe_evidence_collections__collection_id__documents__document_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        collection_id: string;
        document_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  import_source_list_api_v2_ml_scribe_evidence_collections_import_source_list__source_list_id__post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        source_list_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CollectionDetailResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  start_sharepoint_oauth_url_api_v2_ml_scribe_evidence_sharepoint_oauth_start_get: {
    parameters: {
      query?: {
        tenant?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharePointOAuthStartResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  sharepoint_oauth_callback_api_v2_ml_scribe_evidence_sharepoint_oauth_callback_get: {
    parameters: {
      query?: {
        code?: string | null;
        state?: string | null;
        error?: string | null;
        error_description?: string | null;
        tenant?: string | null;
        include_sync_config?: boolean;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharePointOAuthCallbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_sharepoint_sync_config_api_v2_ml_scribe_evidence_sharepoint_config_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharePointSyncConfigResponse'];
        };
      };
    };
  };
  delete_sharepoint_config_api_v2_ml_scribe_evidence_sharepoint_config_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  update_sharepoint_sync_config_api_v2_ml_scribe_evidence_sharepoint_config_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SharePointSyncConfigUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharePointSyncConfigResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  resync_sharepoint_sync_config_api_v2_ml_scribe_evidence_sharepoint_config_resync_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharePointSyncConfigResponse'];
        };
      };
    };
  };
  list_sharepoint_sites_api_v2_ml_scribe_evidence_sharepoint_sites_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharePointSitesResponse'];
        };
      };
    };
  };
  list_sharepoint_site_contents_api_v2_ml_scribe_evidence_sharepoint_site_contents_get: {
    parameters: {
      query: {
        site_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharePointSiteContentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_sharepoint_site_folder_contents_api_v2_ml_scribe_evidence_sharepoint_site_folder_contents_get: {
    parameters: {
      query: {
        site_id: string;
        folder_path: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SharePointSiteContentsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  download_sharepoint_site_file_content_api_v2_ml_scribe_evidence_sharepoint_site_file_content_get: {
    parameters: {
      query: {
        site_id: string;
        item_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_source_recommendations_api_v2_ml_scribe_evidence_source_recommendations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceRecommendationsResponse'];
        };
      };
    };
  };
  browse_source_catalog_api_v2_ml_scribe_evidence_source_recommendations_catalog_get: {
    parameters: {
      query?: {
        /** @description Optional specialty ObjectId used to filter catalog sources */
        specialty_id?: string | null;
        /** @description Optional country used to filter source regions */
        country?: components['schemas']['Country'] | null;
        /** @description Optional text query over source domain and display names */
        q?: string | null;
        /** @description Maximum number of catalog sources to return */
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SourceCatalogResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_evidence_summary_suggestion_api_v2_ml_scribe_evidence__session_id__summary_suggestion_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EvidenceSummarySuggestionResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_partner_html_api_v2_ml_scribe_evidence_integration_partners__partner___content_id__html_get: {
    parameters: {
      query?: never;
      header?: {
        'If-None-Match'?: string | null;
      };
      path: {
        partner: string;
        content_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_integrations_api_v2_ml_scribe_evidence_integrations_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['IntegrationsListResponse'];
        };
      };
    };
  };
  create_evidence_feedback_api_v2_ml_scribe_evidence_feedback_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateEvidenceFeedbackRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateEvidenceFeedbackResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  snooze_evidence_feedback_api_v2_ml_scribe_evidence_feedback_snooze_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SnoozeEvidenceFeedbackResponse'];
        };
      };
    };
  };
  setup_healthpathways_api_v2_ml_scribe_evidence_healthpathways_setup_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SetupHealthPathwaysRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SetupHealthPathwaysResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  remove_healthpathways_api_v2_ml_scribe_evidence_healthpathways_setup_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RemoveHealthPathwaysResponse'];
        };
      };
    };
  };
  get_g2_review_url_api_v2_ml_scribe_evidence_referrals_g2_review_url_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['G2ReviewUrlResponse'];
        };
      };
    };
  };
  generate_referral_link_api_v2_ml_scribe_evidence_referrals_link_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ReferralLinkResponse'];
        };
      };
    };
  };
  get_my_referrals_api_v2_ml_scribe_evidence_referrals_my_referrals_get: {
    parameters: {
      query?: {
        limit?: number;
        skip?: number;
        /** @description Filter by campaign (e.g., 'evidence'). If not provided, returns all campaigns. */
        campaign?: components['schemas']['ReferralCampaign'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MyReferralsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_my_stats_api_v2_ml_scribe_evidence_referrals_stats_get: {
    parameters: {
      query?: {
        /** @description Time period for stats (daily, weekly, monthly, all_time). */
        period?: components['schemas']['LeaderboardPeriodType'];
        /** @description Filter by campaign (e.g., 'evidence'). If not provided, returns all campaigns. */
        campaign?: components['schemas']['ReferralCampaign'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserLeaderboardStats'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_leaderboard_settings_api_v2_ml_scribe_evidence_referrals_settings_patch: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateLeaderboardSettingsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UpdateLeaderboardSettingsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  fill_form_from_upload_api_v2_ml_scribe_pdf_template_demo_fill_form_from_upload_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_fill_form_from_upload_api_v2_ml_scribe_pdf_template_demo_fill_form_from_upload_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FillFormDemoResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Request Entity Too Large */
      413: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Too Many Requests */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  fill_form_api_v2_ml_scribe_pdf_template_demo_fill_form_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['FillFormDemoRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['FillFormDemoResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Request Entity Too Large */
      413: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Too Many Requests */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  create_referral_link_api_v2_ml_scribe_referrals_referral_links_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateReferralLinkRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateReferralLinkResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_batch_like_status_api_v2_ml_scribe_template_gallery_templates_likes_batch_get: {
    parameters: {
      query: {
        /** @description List of template IDs */
        template_ids: string[];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchLikeStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_like_status_api_v2_ml_scribe_template_gallery_templates__template_id__like_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LikeStatusResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  like_template_api_v2_ml_scribe_template_gallery_templates__template_id__like_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LikeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  unlike_template_api_v2_ml_scribe_template_gallery_templates__template_id__like_delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        template_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['LikeResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  proxy_argmax_request_api_v2_ml_scribe_argmax_v1_proxy_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ArgmaxProxyRequestSchema'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ArgmaxProxyResponseSchema'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_agents_api_v2_ml_scribe_calls_agents_get: {
    parameters: {
      query?: {
        search?: string | null;
        skip?: number;
        limit?: number;
        sort_by?: string | null;
        sort_direction?: components['schemas']['shared__enums__enums__SortOrder'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agent_api_v2_ml_scribe_calls_agents__agent_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Agent'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_agent_api_v2_ml_scribe_calls_agents__agent_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_agent_api_v2_ml_scribe_calls_agents__agent_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateAgentRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Agent'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  purchase_agent_phone_number_api_v2_ml_scribe_calls_agents__agent_id__phone_number_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Agent'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_webrtc_token_api_v2_ml_scribe_calls_agents__agent_id__webrtc_token_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['Body_get_webrtc_token_api_v2_ml_scribe_calls_agents__agent_id__webrtc_token_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_predicted_parameters_api_v2_ml_scribe_calls_agents__agent_id__predicted_parameters_get: {
    parameters: {
      query: {
        /** @description Clinical task id to derive predicted parameters from */
        task_id: string;
      };
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CallContextValues'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  check_guardrail_api_v2_ml_scribe_calls_agents_guardrails_check_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GuardrailCheckRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GuardrailCheckResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  recompile_agent_api_v2_ml_scribe_calls_agents__agent_id__recompile_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecompileRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Agent'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  check_guardrail_v2_api_v2_ml_scribe_calls_agents_v2_guardrails_check_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GuardrailCheckRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GuardrailCheckResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  check_guardrail_batch_v2_api_v2_ml_scribe_calls_agents_v2_guardrails_check_batch_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GuardrailCheckBatchRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GuardrailCheckResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  commit_agent_api_v2_ml_scribe_calls_agents_commit_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CommitRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Agent'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  seed_agents_api_v2_ml_scribe_calls_agents_seed_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['AgentResponse'];
        };
      };
    };
  };
  create_session_api_v2_ml_scribe_calls_agent_builder_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['apis__v2__calls__agent_builder__CreateSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_chat_message_api_v2_ml_scribe_calls_agent_builder_sessions__session_id__chat_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ChatRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_latest_session_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__latest_session_get: {
    parameters: {
      query?: {
        update_field?: 'agent_config' | null;
      };
      header?: never;
      path: {
        agent_config_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  refresh_agent_scenarios_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__scenarios_refresh_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_config_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  run_agent_qa_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__qa_run_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_config_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_agent_qa_run_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__qa_runs__run_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_config_id: string;
        run_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_agent_preview_api_v2_ml_scribe_calls_agent_builder_agents__agent_config_id__preview_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_config_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GeneratePreviewRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_blocked_numbers_api_v2_ml_scribe_calls_blocked_numbers_get: {
    parameters: {
      query?: {
        search?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BlockedNumberListView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_blocked_number_api_v2_ml_scribe_calls_blocked_numbers_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateBlockedNumberRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CreateBlockedNumberView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  check_blocked_api_v2_ml_scribe_calls_blocked_numbers_check_get: {
    parameters: {
      query: {
        phone: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CheckBlockedView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bulk_create_blocked_numbers_api_v2_ml_scribe_calls_blocked_numbers_bulk_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkCreateBlockedNumberRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkCreateBlockedNumberView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_blocked_number_api_v2_ml_scribe_calls_blocked_numbers__doc_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        doc_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DeleteBlockedNumberView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_greeting_api_v2_ml_scribe_calls_chat_agents__agent_name__greeting_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_name: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_session_api_v2_ml_scribe_calls_chat_sessions_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateTextChatSessionRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_message_api_v2_ml_scribe_calls_chat_sessions__session_id__messages_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SendTextChatMessageRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_appointment_types_api_v2_ml_scribe_calls_ehr_appointment_types_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRAppointmentTypesResponse'];
        };
      };
    };
  };
  refresh_ehr_appointment_types_api_v2_ml_scribe_calls_ehr_appointment_types_refresh_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RefreshAppointmentTypesResponse'];
        };
      };
    };
  };
  update_appointment_type_api_v2_ml_scribe_calls_ehr_appointment_types__ehr_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        ehr_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateEHRItemRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_clinicians_api_v2_ml_scribe_calls_ehr_clinicians_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRCliniciansResponse'];
        };
      };
    };
  };
  refresh_ehr_clinicians_api_v2_ml_scribe_calls_ehr_clinicians_refresh_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RefreshCliniciansResponse'];
        };
      };
    };
  };
  update_clinician_api_v2_ml_scribe_calls_ehr_clinicians__ehr_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        ehr_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateEHRItemRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_clinics_api_v2_ml_scribe_calls_ehr_clinics_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRClinicsResponse'];
        };
      };
    };
  };
  refresh_ehr_clinics_api_v2_ml_scribe_calls_ehr_clinics_refresh_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RefreshClinicsResponse'];
        };
      };
    };
  };
  update_clinic_api_v2_ml_scribe_calls_ehr_clinics__ehr_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        ehr_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateEHRClinicRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_ehr_credentials_api_v2_ml_scribe_calls_ehr_credentials_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRCredentialsResponse'];
        };
      };
    };
  };
  create_ehr_credentials_api_v2_ml_scribe_calls_ehr_credentials_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['EHRCredentialsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['EHRCredentialsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_ehr_credentials_api_v2_ml_scribe_calls_ehr_credentials_delete: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
    };
  };
  list_conversations_api_v2_ml_scribe_calls_inbox_get: {
    parameters: {
      query?: {
        status?: string | null;
        search?: string | null;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConversationListView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_conversation_detail_api_v2_ml_scribe_calls_inbox_by_id__patient_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConversationDetailView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_call_detail_api_v2_ml_scribe_calls_inbox_calls__session_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__calls__inbox_schemas__CallDetailView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_call_translation_api_v2_ml_scribe_calls_inbox_calls__session_id__translations__language_code__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
        language_code: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CallTranslationView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  send_message_api_v2_ml_scribe_calls_inbox__phone_number__messages_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        phone_number: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SendMessageRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_conversation_api_v2_ml_scribe_calls_inbox__phone_number__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        phone_number: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateConversationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mark_conversation_read_api_v2_ml_scribe_calls_inbox__patient_id__read_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_media_api_v2_ml_scribe_calls_inbox__phone_number__media_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        phone_number: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_upload_media_api_v2_ml_scribe_calls_inbox__phone_number__media_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MediaUploadView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  mint_inbox_ws_ticket_http_api_v2_ml_scribe_calls_inbox_ws_ticket_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InboxWebSocketTicketView'];
        };
      };
    };
  };
  list_patients_api_v2_ml_scribe_calls_patients_get: {
    parameters: {
      query?: {
        search?: string | null;
        limit?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PatientView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_patient_appointments_api_v2_ml_scribe_calls_patients__patient_id__appointments_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PatientAppointmentView'][];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_patient_api_v2_ml_scribe_calls_patients__patient_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        patient_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  upload_csv_api_v2_ml_scribe_calls_patients_upload_csv_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CsvUploadRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CsvUploadResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_reminder_configs_api_v2_ml_scribe_calls_reminders_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ReminderConfigView'][];
        };
      };
    };
  };
  create_reminder_config_api_v2_ml_scribe_calls_reminders_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CreateReminderConfigRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ReminderConfigView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_reminder_config_api_v2_ml_scribe_calls_reminders__config_id__put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        config_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['UpdateReminderConfigRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ReminderConfigView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_reminder_config_api_v2_ml_scribe_calls_reminders__config_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        config_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  toggle_reminder_config_api_v2_ml_scribe_calls_reminders__config_id__toggle_put: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        config_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  retry_reminder_api_v2_ml_scribe_calls_reminders_appointments__appointment_id__retry_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        appointment_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RetryReminderResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  process_reminders_api_v2_ml_scribe_calls_reminders_process_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ProcessRemindersResponse'];
        };
      };
    };
  };
  operational_summary_api_v2_ml_scribe_calls_stats_operational_summary_get: {
    parameters: {
      query?: {
        days?: number;
        start_date?: string | null;
        end_date?: string | null;
        channel?: string | null;
        integration_filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  operational_breakdowns_api_v2_ml_scribe_calls_stats_operational_breakdowns_get: {
    parameters: {
      query?: {
        days?: number;
        start_date?: string | null;
        end_date?: string | null;
        channel?: string | null;
        integration_filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  operational_daily_api_v2_ml_scribe_calls_stats_operational_daily_get: {
    parameters: {
      query?: {
        days?: number;
        start_date?: string | null;
        end_date?: string | null;
        channel?: string | null;
        integration_filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  operational_flow_api_v2_ml_scribe_calls_stats_operational_flow_get: {
    parameters: {
      query?: {
        days?: number;
        start_date?: string | null;
        end_date?: string | null;
        channel?: string | null;
        integration_filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  operational_tool_analysis_api_v2_ml_scribe_calls_stats_operational_tool_analysis_get: {
    parameters: {
      query?: {
        days?: number;
        start_date?: string | null;
        end_date?: string | null;
        channel?: string | null;
        integration_filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  operational_calls_api_v2_ml_scribe_calls_stats_operational_calls_post: {
    parameters: {
      query?: {
        days?: number;
        start_date?: string | null;
        end_date?: string | null;
        channel?: string | null;
        integration_filter?: string | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': {
          [key: string]: unknown;
        };
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_voice_catalog_api_v2_ml_scribe_calls_voices_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VoicesCatalogView'];
        };
      };
    };
  };
  preview_voice_api_v2_ml_scribe_calls_voices_preview_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['VoicePreviewRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'audio/wav': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_calls_api_v2_ml_scribe_calls_get: {
    parameters: {
      query?: {
        search?: string | null;
        skip?: number;
        limit?: number;
        sort_by?: string | null;
        sort_direction?: components['schemas']['shared__enums__enums__SortOrder'];
        status?: components['schemas']['CallStatus'] | null;
        call_direction?: components['schemas']['CallDirection'] | null;
        channel?: components['schemas']['CallChannel'] | null;
        read?: string | null;
        intent?: components['schemas']['CallIntent'] | null;
        outcome?: components['schemas']['CallOutcome'] | null;
        outcome_reason?: components['schemas']['CallOutcomeReason'] | null;
        bucket?: components['schemas']['CallBucket'] | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['CallViewPaginated'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_call_api_v2_ml_scribe_calls_create_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CallCreate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  create_calls_api_v2_ml_scribe_calls_bulk_create_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BulkCreateCallPayload'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkCreateCallResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_call_by_reference_id_api_v2_ml_scribe_calls_by_reference__call_reference_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        call_reference_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__calls__schemas__CallDetailView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_call_by_id_api_v2_ml_scribe_calls__call_id__get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        call_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__calls__schemas__CallDetailView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  delete_call_api_v2_ml_scribe_calls__call_id__delete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        call_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_call_api_v2_ml_scribe_calls__call_id__patch: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        call_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CallUpdateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['apis__v2__calls__schemas__CallDetailView'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  update_webhook_api_v2_ml_scribe_calls_webhook_post: {
    parameters: {
      query?: never;
      header?: {
        'X-Api-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['CallWebhookUpdate'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_knowledge_base_from_url_api_v2_ml_scribe_calls_knowledge_base_generate_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateKnowledgeBaseRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateKnowledgeBaseResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_calls_simulate_agent_api_v2_ml_scribe_calls_agents__agent_id__simulate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': {
          [key: string]: unknown;
        } | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_calls_get_last_agent_simulation_run_api_v2_ml_scribe_calls_agents__agent_id__runs_last_get: {
    parameters: {
      query: {
        persona_name: string;
      };
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          } | null;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_calls_regenerate_agent_scenarios_api_v2_ml_scribe_calls_agents__agent_id__scenarios_regenerate_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_calls_add_custom_agent_scenario_api_v2_ml_scribe_calls_agents__agent_id__scenarios_custom_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': {
          [key: string]: unknown;
        };
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  ml_scribe_calls_list_agent_scenarios_api_v2_ml_scribe_calls_agents__agent_id__scenarios_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        agent_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': {
            [key: string]: unknown;
          };
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  search_clinics_by_name_api_v2_ml_scribe_calls_knowledge_base_search_clinics_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SearchClinicsRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SearchClinicsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_config_learning_status_api_v2_ml_scribe_comms_objectives_config_learning_status_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConfigLearningStatusResult'];
        };
      };
    };
  };
  run_config_learning_scan_api_v2_ml_scribe_comms_objectives_config_learning_scan_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConfigLearningScanResult'];
        };
      };
    };
  };
  preview_config_learning_api_v2_ml_scribe_comms_objectives_config_learning_preview_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConfigLearningPreviewRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConfigLearningPreviewResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  apply_config_learning_api_v2_ml_scribe_comms_objectives_config_learning_apply_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConfigLearningApplyResult'];
        };
      };
    };
  };
  discard_config_learning_preview_api_v2_ml_scribe_comms_objectives_config_learning_preview_discard_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  dismiss_config_learning_gaps_api_v2_ml_scribe_comms_objectives_config_learning_dismiss_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConfigLearningDismissRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConfigLearningDismissResult'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  bootstrap_telehealth_call_api_v2_ml_scribe_telehealth_calls_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BootstrapCallRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BootstrapCallResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Conflict */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Too Many Requests */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Bad Gateway */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  ingest_telehealth_recording_api_v2_ml_scribe_telehealth_recordings_ingest_post: {
    parameters: {
      query?: never;
      header?: {
        'X-Api-Key'?: string | null;
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RecordingIngestRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RecordingIngestResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Request Entity Too Large */
      413: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Bad Gateway */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  start_number_verification_api_v2_ml_scribe_telehealth_verify_number_start_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['VerifyNumberStartRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerifyNumberResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Too Many Requests */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Bad Gateway */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  confirm_number_verification_api_v2_ml_scribe_telehealth_verify_number_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['VerifyNumberConfirmRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerifyNumberResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
      /** @description Too Many Requests */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Bad Gateway */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  list_verified_numbers_api_v2_ml_scribe_telehealth_verified_numbers_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VerifiedNumbersResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Too Many Requests */
      429: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Bad Gateway */
      502: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  lookup_hcp_verification_api_v2_ml_scribe_hcp_verifications_lookup_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['LookupHcpRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HcpLookupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_hcp_verifications_api_v2_ml_scribe_hcp_verifications_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HcpVerificationResponse'][];
        };
      };
    };
  };
  confirm_hcp_verification_api_v2_ml_scribe_hcp_verifications_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['ConfirmHcpRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HcpVerificationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  request_hcp_review_api_v2_ml_scribe_hcp_verifications_request_review_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['RequestHcpReviewRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HcpVerificationResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_hcp_verification_status_api_v2_ml_scribe_hcp_verifications_status_get: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HcpVerificationStatusResponse'];
        };
      };
    };
  };
  ask_ai_api_v2_1_ml_scribe_sessions__session_id__ask_ai_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['AskAIRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_note_gen_ai_commands_v2_api_v2_1_ml_scribe_sessions__session_id__consult_note_ai_commands_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConsultNoteAICommandsResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_consult_note_api_v2_1_ml_scribe_sessions__session_id__consult_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  regenerate_consult_note_api_v2_1_ml_scribe_sessions__session_id__consult_note__note_id__regenerate_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        note_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_sectional_note_api_v2_1_ml_scribe_sessions__session_id__consult_note__consult_note_id__sectional_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        consult_note_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['GenerateSectionalNoteResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  stop_consult_note_generation_api_v2_1_ml_scribe_sessions__session_id__consult_note_stop_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StopConsultNoteGenerationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_insights_api_v2_1_ml_scribe_sessions__session_id__consult_note_generate_insights_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': boolean;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  convert_plain_text_note_to_sectional_note_api_v2_1_ml_scribe_sessions__session_id__consult_note_sectional_note_conversion_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConvertPlainTextNoteToSectionalNoteResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_markdown_or_sectional_note_api_v2_1_ml_scribe_sessions__session_id__consult_note_generate_markdown_or_sectional_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateConsultNoteRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ConvertPlainTextNoteToSectionalNoteResponse'];
          /** @example data: {"data": "<markdown chunk>"} */
          'text/event-stream': string;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_document_suggested_ai_commands_v2_api_v2_1_ml_scribe_sessions__session_id__documents_ai_commands_get: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['DocumentAICommandsResponseV2'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_document_content_api_v2_1_ml_scribe_sessions__session_id__documents__document_id__content_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json':
          | components['schemas']['GenerateDocumentContentRequestV2']
          | null;
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  stop_document_content_generation_api_v2_1_ml_scribe_sessions__session_id__documents__document_id__stop_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: string;
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['StopDocumentGenerationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  invite_users_to_team_api_v2_1_ml_scribe_teams__team_id__invitations_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        team_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['InviteUsersToTeamRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InviteUsersToTeamResponse'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_template_content_using_ai_api_v2_1_ml_scribe_templates_ai_gen_content_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['GenerateTemplateContentUsingAIRequestV2'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  build_consult_template_from_document_api_v2_1_ml_scribe_templates_build_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['BuildCustomTemplateRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  extract_content_from_document_api_v2_1_ml_scribe_templates_doc_extract_post: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        'multipart/form-data': components['schemas']['Body_extract_content_from_document_api_v2_1_ml_scribe_templates_doc_extract_post'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ExtractDocumentContentResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  get_standardized_sections_api_v2_1_ml_scribe_integrations_standardized_sections_get: {
    parameters: {
      query: {
        /** @description The onboarding session ID */
        onboarding_session_id: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['domains__integrations__standardized_sections__api__schemas__AvailableStandardizedSectionsResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  setup_consult_note_generation_api_v2_2_ml_scribe_sessions__session_id__consult_note_setup_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SideBySideConsultNoteSetupRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SideBySideConsultNoteSetupResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  generate_consult_note_api_v2_2_ml_scribe_sessions__session_id__consult_note_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SideBySideConsultNoteGenerationRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown;
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  confirm_note_selection_api_v2_2_ml_scribe_sessions__session_id__consult_note_confirm_post: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        session_id: string;
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        'application/json': components['schemas']['SideBySideConsultNoteConfirmRequest'];
      };
    };
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SideBySideConsultNoteConfirmResponse'];
        };
      };
      /** @description Validation Error */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['HTTPValidationError'];
        };
      };
    };
  };
  list_sessions_api_v2_2_ml_scribe_sessions_get: {
    parameters: {
      query?: {
        /** @description Visibility scope. me=own only, team=team members' sessions including your own (requires team session sharing enabled), direct_share=directly shared to me, all=me+team+shared. */
        scope?: components['schemas']['SessionScope'];
        /** @description Opaque cursor from next_cursor in the previous response. Null for first page. */
        cursor?: string | null;
        /** @description Number of sessions per page. Max 200. */
        page_size?: number;
        /** @description Field to sort sessions by. Allowed: created_at, updated_at, name. */
        sort_by?: components['schemas']['SessionSortBy'];
        /** @description Sort direction. */
        sort_order?: components['schemas']['shared__enums__enums__SortOrder'];
        /** @description Filter by one or more session statuses. */
        session_status?: components['schemas']['SessionStatus'][] | null;
        /** @description Filter sessions created on or after this datetime (UTC). */
        date_from?: string | null;
        /** @description Filter sessions created on or before this datetime (UTC). */
        date_to?: string | null;
        /** @description Filter sessions by patient profile IDs. */
        patient_profile_ids?: string[] | null;
        /** @description Filter sessions by clinician user id, including your own. Repeatable. Applies to scope=team, scope=direct_share, scope=all. Not applicable to scope=me (returns 422). Unknown ids the caller cannot view return 422. */
        clinician_ids?: string[] | null;
        /** @description Search keyword (optional). Searches session_name, session_gist, patient.name, patient.demographic_details. */
        q?: string | null;
        /** @description Filter by urgency. true=only urgent, false=only non-urgent. Omit=no filter. */
        is_urgent?: boolean | null;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionListResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Forbidden */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Session list temporarily unavailable */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Search timed out */
      504: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
  get_session_status_counts_api_v2_2_ml_scribe_sessions_status_counts_get: {
    parameters: {
      query?: {
        /** @description Visibility scope. Only 'all' is currently supported. */
        scope?: components['schemas']['SessionScope'];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successful Response */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SessionStatusCountsResponse'];
        };
      };
      /** @description Unauthorized */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Unprocessable Entity */
      422: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
      /** @description Session list temporarily unavailable */
      503: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ErrorResponse'];
        };
      };
    };
  };
}
export enum PathsApiV2MlScribeInternalAdminAgentHarnessRunsGetParametersQueryStatusAnyOf0 {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum PathsApiV2MlScribeInternalAdminAgentHarnessRunsGetParametersQuerySort_by {
  created_at = 'created_at',
  updated_at = 'updated_at',
}
export enum PathsApiV2MlScribeInternalAdminAgentHarnessRunsGetParametersQuerySort_order {
  asc = 'asc',
  desc = 'desc',
}
export enum PathsApiV2MlScribeInternalAdminAgentHarnessConfigsGetParametersQuerySort_by {
  created_at = 'created_at',
  updated_at = 'updated_at',
}
export enum PathsApiV2MlScribeInternalAdminAgentHarnessConfigsGetParametersQuerySort_order {
  asc = 'asc',
  desc = 'desc',
}
export enum PathsApiV2MlScribeInternalAdminAgentHarnessInboxItemsGetParametersQuerySort_by {
  created_at = 'created_at',
  updated_at = 'updated_at',
}
export enum PathsApiV2MlScribeInternalAdminAgentHarnessInboxItemsGetParametersQuerySort_order {
  asc = 'asc',
  desc = 'desc',
}
export enum PathsApiV2MlScribeInternalAdminEventRulesGetParametersQueryScope_typeAnyOf0 {
  user = 'user',
  team = 'team',
  org = 'org',
}
export enum PathsApiV2MlScribeInternalAdminWorkflowsGetParametersQueryProduct_surfaceAnyOf0 {
  work = 'work',
  studio = 'studio',
}
export enum PathsApiV2MlScribeInternalAdminUsageEntitlementsAssignmentsGetParametersQueryScope_typeAnyOf0 {
  user = 'user',
  organization = 'organization',
  global = 'global',
}
export enum PathsApiV2MlScribeInternalAdminUsageEntitlementsMeteredBillingStatusGetParametersQueryScope {
  user = 'user',
  organization = 'organization',
  workspace = 'workspace',
}
export enum PathsApiV2MlScribeInternalAdminUsageEntitlementsUsersKinde_user_idMetric_keyGetParametersQueryPeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum PathsApiV2MlScribeInternalAdminUsageEntitlementsOrganizationsOrganization_idMetric_keyGetParametersQueryPeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum PathsApiV2MlScribeInternalAdminUsageEntitlementsWorkspacesWorkspace_idMetric_keyGetParametersQueryPeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum PathsApiV2MlScribeInternalAdminUsageEntitlementsUsersKinde_user_idMetric_keyHistoryGetParametersQueryPeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum PathsApiV2MlScribeInternalAdminUsageEntitlementsOrganizationsOrganization_idMetric_keyHistoryGetParametersQueryPeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum PathsApiV2MlScribeInternalAdminUsageEntitlementsWorkspacesWorkspace_idMetric_keyHistoryGetParametersQueryPeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum PathsApiV2MlScribeInternalAdminEvidenceLibraryUser_ref_idDocumentsGetParametersQueryScopeAnyOf0 {
  all = 'all',
  user = 'user',
  team = 'team',
}
export enum PathsApiV2MlScribeInternalAdminTemporalControlWorkflowsGetParametersQueryStatusAnyOf0 {
  Running = 'Running',
  Completed = 'Completed',
  Failed = 'Failed',
  Canceled = 'Canceled',
  Terminated = 'Terminated',
  TimedOut = 'TimedOut',
  ContinuedAsNew = 'ContinuedAsNew',
}
export enum PathsApiV2MlScribeInternalAdminVidalUploadMonographsPostParametersQueryLanguage {
  fr = 'fr',
  de = 'de',
  es = 'es',
}
export enum PathsApiV2MlScribeInternalAdminEmgUploadPortfolioPostParametersQueryPortfolio {
  drugs = 'drugs',
  guidelines = 'guidelines',
}
export enum PathsApiV2MlScribeInternalAdminEmgUploadPortfolioPostParametersQueryTarget_db {
  regional = 'regional',
  global = 'global',
}
export enum PathsApiV2MlScribeInternalAdminTicketPortalHubspotSearchGetParametersQueryEntity_type {
  company = 'company',
  contact = 'contact',
  deal = 'deal',
}
export enum PathsApiV2MlScribeInternalAdminTicketPortalTicketsPlatformTicket_idGetParametersPathPlatform {
  intercom = 'intercom',
  linear = 'linear',
}
export enum PathsApiV2MlScribeInternalAdminTicketPortalTicketsPlatformTicket_idNotesPostParametersPathPlatform {
  intercom = 'intercom',
  linear = 'linear',
}
export enum PathsApiV2MlScribeAgentsRunsGetParametersQueryStatusAnyOf0 {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum PathsApiV2MlScribeInboxItemsGetParametersQuerySort_by {
  created_at = 'created_at',
  updated_at = 'updated_at',
}
export enum PathsApiV2MlScribeInboxItemsGetParametersQuerySort_order {
  asc = 'asc',
  desc = 'desc',
}
export enum PathsApiV2MlScribePatientStateViewsPostRequestBodyContentApplicationJsonBoundariesPurpose {
  clinical_nudge = 'clinical_nudge',
  form_filling = 'form_filling',
  coding_cdi = 'coding_cdi',
}
export enum PathsApiV2MlScribePatientStateViewsPostRequestBodyContentApplicationJsonBoundariesSourcesSource_type {
  transcript = 'transcript',
  structured_record = 'structured_record',
  context_document = 'context_document',
  confirmed_human_input = 'confirmed_human_input',
}
export enum PathsApiV2MlScribePatientStateViewsPostRequestBodyContentApplicationJsonBoundariesLifecycle {
  open = 'open',
  review = 'review',
  closed = 'closed',
  expired = 'expired',
}
export enum PathsApiV2MlScribeWorkflowsGetParametersQuerySourceAnyOf0 {
  instructed = 'instructed',
  recorded = 'recorded',
}
export enum PathsApiV2MlScribeProjectsGetParametersQuerySaved {
  all = 'all',
  only = 'only',
  exclude = 'exclude',
}
export enum PathsApiV2MlScribeUsageEntitlementsMetric_keyGetParametersQueryScope {
  user = 'user',
  team = 'team',
}
export enum PathsApiV2MlScribeUsageEntitlementsMetric_keyGetParametersQueryPeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum AbuseBanAction {
  ban_created = 'ban_created',
  ban_revoked = 'ban_revoked',
}
export enum Acc45RegistrationLinkId {
  p01_vendor_details = 'p01-vendor-details',
  p01_g01_q03_hpi_facility_identifier = 'p01-g01-q03-hpi-facility-identifier',
  p02_provider_details = 'p02-provider-details',
  p02_g01_q01_provider_type = 'p02-g01-q01-provider-type',
  p02_patient_details = 'p02-patient-details',
  p02_patient_q01_first_name = 'p02-patient-q01-first-name',
  p02_patient_q02_last_name = 'p02-patient-q02-last-name',
  p02_patient_q03_date_of_birth = 'p02-patient-q03-date-of-birth',
  p02_patient_q04_ethnicity = 'p02-patient-q04-ethnicity',
  p02_patient_q05_gender = 'p02-patient-q05-gender',
  p02_patient_q06_nhi = 'p02-patient-q06-nhi',
  p02_patient_q07_middle_name = 'p02-patient-q07-middle-name',
  p02_patient_q08_occupation_code = 'p02-patient-q08-occupation-code',
  p02_patient_q09_email_address = 'p02-patient-q09-email-address',
  p02_patient_q10_mobile_phone = 'p02-patient-q10-mobile-phone',
  p02_patient_q11_home_phone = 'p02-patient-q11-home-phone',
  p02_patient_q12_work_phone = 'p02-patient-q12-work-phone',
  p03_employment_details = 'p03-employment-details',
  p03_g01_employer_details = 'p03-g01-employer-details',
  p03_g01_q01_employer_name = 'p03-g01-q01-employer-name',
  p03_g01_q02_employer_address = 'p03-g01-q02-employer-address',
  p03_g01_q01_address_type = 'p03-g01-q01-address-type',
  p03_g01_q02_address_line_1 = 'p03-g01-q02-address-line-1',
  p03_g01_q03_address_line_2 = 'p03-g01-q03-address-line-2',
  p03_g01_q04_suburb = 'p03-g01-q04-suburb',
  p03_g01_q05_city = 'p03-g01-q05-city',
  p03_g01_q06_post_code = 'p03-g01-q06-post-code',
  p03_g01_q07_country = 'p03-g01-q07-country',
  p03_g02_q01_in_paid_employment = 'p03-g02-q01-in-paid-employment',
  p03_g02_q02_employment_status_code = 'p03-g02-q02-employment-status-code',
  p03_g02_q03_other_employment = 'p03-g02-q03-other-employment',
  p03_g02_q04_work_type_code = 'p03-g02-q04-work-type-code',
  p03_g02_q05_patients_occupation = 'p03-g02-q05-patients-occupation',
  p04_injury_details = 'p04-injury-details',
  p04_g01_q01_accident_date = 'p04-g01-q01-accident-date',
  p04_g01_q02_accident_location_code = 'p04-g01-q02-accident-location-code',
  p04_g01_q03_accident_scene_code = 'p04-g01-q03-accident-scene-code',
  p04_g01_q04_cause_of_accident = 'p04-g01-q04-cause-of-accident',
  p04_g01_q05_involves_vehicle = 'p04-g01-q05-involves-vehicle',
  p04_g01_q06_medical_treatment_injury = 'p04-g01-q06-medical-treatment-injury',
  p04_g01_q07_work_injury = 'p04-g01-q07-work-injury',
  p04_g01_q08_sporting_injury = 'p04-g01-q08-sporting-injury',
  p04_g01_q09_sport_name_code = 'p04-g01-q09-sport-name-code',
  p04_g01_q10_gradual_process_injury = 'p04-g01-q10-gradual-process-injury',
  p04_g01_q11_admitted_to_hospital = 'p04-g01-q11-admitted-to-hospital',
  p04_g01_q12_injury_comments = 'p04-g01-q12-injury-comments',
  p04_g01_q13_assistance_required = 'p04-g01-q13-assistance-required',
  p04_g01_q14_acc_contact_provider = 'p04-g01-q14-acc-contact-provider',
  p05_diagnosis = 'p05-diagnosis',
  p05_g01_q01_diagnosis_code = 'p05-g01-q01-diagnosis-code',
  p05_g01_q02_diagnosis_side = 'p05-g01-q02-diagnosis-side',
  p06_work_capacity = 'p06-work-capacity',
  p06_g01_incapacity = 'p06-g01-incapacity',
  p06_g01_q01_incapacity_type = 'p06-g01-q01-incapacity-type',
  p06_g01_q02_physical_restrictions = 'p06-g01-q02-physical-restrictions',
  p06_g01_q01_restriction = 'p06-g01-q01-restriction',
  p06_g01_q02_restricted_hours_per_day = 'p06-g01-q02-restricted-hours-per-day',
  p06_g01_q03_restriction_comment = 'p06-g01-q03-restriction-comment',
  p06_g01_q03_incapacity_date_range = 'p06-g01-q03-incapacity-date-range',
  p06_g01_q01_from_date = 'p06-g01-q01-from-date',
  p06_g01_q02_to_date = 'p06-g01-q02-to-date',
  p06_g01_q04_selected_alternative_work = 'p06-g01-q04-selected-alternative-work',
  p06_g01_q01_alternative_work_type_code = 'p06-g01-q01-alternative-work-type-code',
  p06_g02_q01_can_resume_normal_work = 'p06-g02-q01-can-resume-normal-work',
  p06_g02_q02_return_to_normal_work_date = 'p06-g02-q02-return-to-normal-work-date',
  p07_referrals = 'p07-referrals',
  p07_g01_q01_provider_type_code = 'p07-g01-q01-provider-type-code',
  p07_g01_q02_referral_reason = 'p07-g01-q02-referral-reason',
  p08_declaration = 'p08-declaration',
  p08_g01_q01_the_information_provided_by_me_is_true_and_correct = 'p08-g01-q01-the-information-provided-by-me-is-true-and-correct',
  p08_g01_q02_provider_declaration_date = 'p08-g01-q02-provider-declaration-date',
}
export enum AccessTier {
  FREE = 'FREE',
  PRO = 'PRO',
  PRACTICE = 'PRACTICE',
  ENTERPRISE = 'ENTERPRISE',
  NOACCESS = 'NOACCESS',
  REVOKED = 'REVOKED',
}
export enum AckFrontendEventRequestOutcome {
  executed = 'executed',
  failed = 'failed',
}
export enum ActionType {
  route = 'route',
  link = 'link',
}
export enum ActorType {
  User = 'User',
  System = 'System',
}
export enum AdCampaignStatus {
  DRAFT = 'DRAFT',
  SCHEDULED = 'SCHEDULED',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
  ARCHIVED = 'ARCHIVED',
}
export enum AdFormat {
  scribe_banner = 'scribe-banner',
  evidence_banner = 'evidence-banner',
}
export enum AdResourceStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  ARCHIVED = 'ARCHIVED',
}
export enum AdResourceType {
  image = 'image',
}
export enum AdTargetProduct {
  evidence = 'evidence',
  scribe = 'scribe',
}
export enum AdaptiveThinkingKind {
  adaptive = 'adaptive',
}
export enum AdaptiveThinkingEffortAnyOf0 {
  low = 'low',
  medium = 'medium',
  high = 'high',
  xhigh = 'xhigh',
  max = 'max',
}
export enum AddOnCategory {
  integration = 'integration',
}
export enum AddOnMetadataKind {
  addon = 'addon',
}
export enum AddOnProductStatus {
  TESTING = 'TESTING',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
}
export enum AddressType {
  postal = 'postal',
  physical = 'physical',
  both = 'both',
}
export enum AddressUse {
  home = 'home',
  work = 'work',
  temp = 'temp',
  old = 'old',
  billing = 'billing',
}
export enum AdminCreateWorkflowRequestSource {
  instructed = 'instructed',
  recorded = 'recorded',
}
export enum AdminCreateWorkflowRequestProduct_surface {
  work = 'work',
  studio = 'studio',
}
export enum AdminUpdateWorkflowRequestProduct_surfaceAnyOf0 {
  work = 'work',
  studio = 'studio',
}
export enum AdministrativeGender {
  male = 'male',
  female = 'female',
  other = 'other',
  unknown = 'unknown',
}
export enum AdvertiserContactRole {
  COMMERCIAL = 'COMMERCIAL',
}
export enum AdvertiserKind {
  HOUSE = 'HOUSE',
  EXTERNAL = 'EXTERNAL',
}
export enum AdvertiserStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
export enum AgentMemoryStatus {
  proposed = 'proposed',
  active = 'active',
  flagged = 'flagged',
  retired = 'retired',
}
export enum AgentRunDetailsResponseStatus {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum AgentRunDetailsResponseInput_state {
  ready = 'ready',
  turn_running = 'turn_running',
  approval_required = 'approval_required',
  closed = 'closed',
  failed = 'failed',
}
export enum AgentRunResponseStatus {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum AgentRunResponseInput_state {
  ready = 'ready',
  turn_running = 'turn_running',
  approval_required = 'approval_required',
  closed = 'closed',
  failed = 'failed',
}
export enum AgentToolPolicyApproval_mode {
  inherit = 'inherit',
  auto = 'auto',
  require = 'require',
}
export enum AllergyIntoleranceCategory {
  food = 'food',
  medication = 'medication',
  environment = 'environment',
  biologic = 'biologic',
}
export enum AllergyIntoleranceClinicalStatusCodes {
  active = 'active',
  inactive = 'inactive',
  resolved = 'resolved',
}
export enum AllergyIntoleranceCriticality {
  low = 'low',
  high = 'high',
  unable_to_assess = 'unable-to-assess',
}
export enum AllergyIntoleranceSeverity {
  mild = 'mild',
  moderate = 'moderate',
  severe = 'severe',
}
export enum AllergyIntoleranceType {
  allergy = 'allergy',
  intolerance = 'intolerance',
}
export enum AnalysisSource {
  manual = 'manual',
  auto = 'auto',
}
export enum AnalysisStatus {
  pending = 'pending',
  extracting = 'extracting',
  awaiting_note = 'awaiting_note',
  verifying = 'verifying',
  completed = 'completed',
  failed = 'failed',
}
export enum AndroidAppType {
  AndroidApp = 'AndroidApp',
}
export enum AppRecordingSource {
  Native = 'Native',
  Remote = 'Remote',
}
export enum AppleMigrationStatus {
  ticket_created = 'ticket_created',
  ticket_refreshed = 'ticket_refreshed',
  already_migrated = 'already_migrated',
  migration_in_progress = 'migration_in_progress',
  migration_failed = 'migration_failed',
  no_migration_needed = 'no_migration_needed',
}
export enum AppointmentStatus {
  proposed = 'proposed',
  pending = 'pending',
  booked = 'booked',
  arrived = 'arrived',
  fulfilled = 'fulfilled',
  cancelled = 'cancelled',
  noshow = 'noshow',
  entered_in_error = 'entered-in-error',
  checked_in = 'checked-in',
  waitlist = 'waitlist',
}
export enum AppointmentTranscriptMatchEntity_type {
  appointment = 'appointment',
}
export enum ApprovalResponseStatus {
  pending = 'pending',
  approved = 'approved',
  denied = 'denied',
  timed_out = 'timed_out',
  cancelled = 'cancelled',
}
export enum ApprovalResponseAvailable_override_scopes {
  once = 'once',
  session = 'session',
}
export enum AssigneeType {
  user = 'user',
  team = 'team',
}
export enum AssignmentFilter {
  all = 'all',
  assigned_to_me = 'assigned_to_me',
  assigned_to_team = 'assigned_to_team',
  created_by_me = 'created_by_me',
}
export enum AttachmentBlockKind {
  attachment = 'attachment',
}
export enum AttachmentBlockAttachment_type {
  image = 'image',
  document = 'document',
  file = 'file',
}
export enum AudioSourceRetranscriptionResponseSource {
  uploaded_audio = 'uploaded_audio',
  hardware_audio = 'hardware_audio',
  backup_audio = 'backup_audio',
}
export enum AuditEntityType {
  User = 'User',
  Session = 'Session',
  Team = 'Team',
  Organization = 'Organization',
  ManagedUserRule = 'ManagedUserRule',
  EntitlementType = 'EntitlementType',
  Entitlement = 'Entitlement',
  AgentRun = 'AgentRun',
  AgentSchedule = 'AgentSchedule',
  Workspace = 'Workspace',
  RpaRecording = 'RpaRecording',
  RpaAxDebugCapture = 'RpaAxDebugCapture',
  CatalogProduct = 'CatalogProduct',
  RateCard = 'RateCard',
  AllowancePolicy = 'AllowancePolicy',
  Advertiser = 'Advertiser',
  AdCampaign = 'AdCampaign',
  AdResource = 'AdResource',
  SystemJob = 'SystemJob',
  MonitoredDocument = 'MonitoredDocument',
  Template = 'Template',
}
export enum AuthVendor {
  kinde = 'kinde',
  auth0 = 'auth0',
  internal_admin = 'internal-admin',
  unknown = 'unknown',
}
export enum AuthenticationFailedReason {
  request_invalid = 'request_invalid',
  user_not_found = 'user_not_found',
  user_deleted = 'user_deleted',
}
export enum AuthenticationMethod {
  SSO = 'SSO',
  DB = 'DB',
  NON_SSO = 'NON_SSO',
}
export enum AuthorKind {
  INTERNAL_ADMIN = 'INTERNAL_ADMIN',
  ADVERTISER_USER = 'ADVERTISER_USER',
}
export enum AuthoringMode {
  manual = 'manual',
  llm_generated_candidate = 'llm_generated_candidate',
}
export enum AvailableDiscounts {
  downgrade_retention = 'downgrade_retention',
}
export enum AxAssistRequestTask {
  extract_schedule = 'extract_schedule',
  verify_patient = 'verify_patient',
  parse_note_sections = 'parse_note_sections',
  extract_chart_context = 'extract_chart_context',
}
export enum BackupAudioTranscriptionStatus {
  INITIALIZED = 'INITIALIZED',
  UPLOADING = 'UPLOADING',
  READY_TO_TRANSCRIBE = 'READY_TO_TRANSCRIBE',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
  NOT_FOUND = 'NOT_FOUND',
}
export enum BaseStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
export enum BatchJobStatus {
  running = 'running',
  completed = 'completed',
  completed_with_errors = 'completed_with_errors',
  failed = 'failed',
  cancelled = 'cancelled',
}
export enum BatchTemplateUpdateType {
  OVERWRITE = 'OVERWRITE',
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}
export enum BillableEventType {
  prechart_workflow_executed = 'prechart.workflow_executed',
  scribe_session_completed = 'scribe.session_completed',
  dictate_dictation_completed = 'dictate.dictation_completed',
  scribe_nudge_surfaced = 'scribe.nudge_surfaced',
  evidence_query_submitted = 'evidence.query_submitted',
  evidence_response_returned = 'evidence.response_returned',
  comms_message_sent = 'comms.message_sent',
  coding_agent_outcome = 'coding.agent_outcome',
  agent_turn_completed = 'agent.turn_completed',
  agent_iteration_completed = 'agent.iteration_completed',
  evidence_llm_token_usage = 'evidence.llm_token_usage',
}
export enum BillableMetricResponseAggregation_mode {
  sum = 'sum',
  tally = 'tally',
}
export enum BillableMetricResponseSum_fieldAnyOf0 {
  quantity = 'quantity',
  token_count = 'token_count',
}
export enum BillingPaymentVendor {
  stripe = 'stripe',
  internal = 'internal',
  third_party_license = 'third_party_license',
}
export enum BillingSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  TRIALING = 'TRIALING',
  PAST_DUE = 'PAST_DUE',
  CANCELED = 'CANCELED',
}
export enum BirthSex {
  A = 'A',
  F = 'F',
  M = 'M',
  NI = 'NI',
  UN = 'UN',
  OT = 'OT',
}
export enum BlockedNumberViewBlocked_via {
  settings_ui = 'settings_ui',
  call_log_menu = 'call_log_menu',
  admin = 'admin',
  import = 'import',
}
export enum Body_fill_form_from_upload_api_v2_ml_scribe_pdf_template_demo_fill_form_from_upload_postSource {
  audio = 'audio',
  document = 'document',
}
export enum Brain {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  FREE = 'FREE',
  PRO = 'PRO',
  REASONING = 'REASONING',
}
export enum BranchItemKind {
  branch = 'branch',
}
export enum BudgetThinkingKind {
  budget = 'budget',
}
export enum BulkAssignUserEntitlementFailureCode {
  user_not_found = 'user_not_found',
  not_in_team = 'not_in_team',
  assign_failed = 'assign_failed',
}
export enum BulkAssignUserEntitlementSuccessAction {
  created = 'created',
  updated = 'updated',
}
export enum BulkDeleteUserEntitlementFailureCode {
  user_not_found = 'user_not_found',
  not_in_team = 'not_in_team',
  no_active_entitlement = 'no_active_entitlement',
}
export enum BulkMoveMemberResultStatus {
  moved = 'moved',
  skipped_owner = 'skipped_owner',
  failed = 'failed',
  rolled_back = 'rolled_back',
  rollback_failed = 'rollback_failed',
}
export enum BulkRemoveMemberResultStatus {
  removed = 'removed',
  skipped_owner = 'skipped_owner',
  failed = 'failed',
}
export enum BulkUploadErrorCode {
  no_speech_detected = 'no_speech_detected',
  recording_too_short = 'recording_too_short',
  unsupported_format = 'unsupported_format',
  message_persist_failed = 'message_persist_failed',
  unknown = 'unknown',
}
export enum BulkUploadFailedStage {
  diarization = 'diarization',
  audio_split = 'audio_split',
  processing = 'processing',
}
export enum CPDGoalModeResponse {
  goal = 'goal',
  count_up = 'count_up',
}
export enum CPDTimeCalculationMethodResponse {
  content_based = 'content_based',
  response_based = 'response_based',
  fixed_per_activity = 'fixed_per_activity',
  fixed_per_source = 'fixed_per_source',
  actual_read_time = 'actual_read_time',
}
export enum CSATRating {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}
export enum CallBucket {
  needs_attention = 'needs_attention',
  in_progress = 'in_progress',
  resolved = 'resolved',
}
export enum CallChannel {
  voice = 'voice',
  web = 'web',
  sms = 'sms',
}
export enum CallDirection {
  inbound = 'inbound',
  outbound = 'outbound',
}
export enum CallIntent {
  book_appointment = 'book_appointment',
  reschedule = 'reschedule',
  cancel = 'cancel',
  prescription_refill = 'prescription_refill',
  faq = 'faq',
  escalate_to_human = 'escalate_to_human',
  admin_request = 'admin_request',
  other = 'other',
}
export enum CallOutcome {
  met = 'met',
  partially_met = 'partially_met',
  not_met = 'not_met',
}
export enum CallOutcomeReason {
  resolved = 'resolved',
  partially_resolved = 'partially_resolved',
  unresolved = 'unresolved',
  unanswered = 'unanswered',
  escalated = 'escalated',
  abandoned = 'abandoned',
}
export enum CallStatus {
  scheduled = 'scheduled',
  in_progress = 'in_progress',
  completed = 'completed',
  failed = 'failed',
  machine_detected = 'machine_detected',
}
export enum CallsAvailableCountry {
  AU = 'AU',
  CA = 'CA',
  NZ = 'NZ',
  UK = 'UK',
  US = 'US',
}
export enum CancelActionAction {
  cancel = 'cancel',
}
export enum CancellationReasonCategory {
  customer_request = 'customer_request',
  duplicate = 'duplicate',
  wrong_address = 'wrong_address',
  fraud_suspected = 'fraud_suspected',
  out_of_stock = 'out_of_stock',
  other = 'other',
}
export enum CapabilityStatementKind {
  instance = 'instance',
  capability = 'capability',
  requirements = 'requirements',
}
export enum CapacityStatus {
  ok = 'ok',
  warning = 'warning',
  critical = 'critical',
  exceeded = 'exceeded',
}
export enum CareContext {
  Value1 = '1',
  Value2 = '2',
  Value3 = '3',
  Value4 = '4',
  Value5 = '5',
}
export enum CatalogProductResponseAggregation_mode {
  sum = 'sum',
  tally = 'tally',
}
export enum CatalogProductResponseSum_fieldAnyOf0 {
  quantity = 'quantity',
  token_count = 'token_count',
}
export enum CernerSectionType {
  standard = 'standard',
  custom = 'custom',
}
export enum CernerWritebackTarget {
  power_chart = 'power_chart',
  power_note = 'power_note',
}
export enum ChartContextNextTargetPurpose {
  history = 'history',
  medications = 'medications',
  allergies = 'allergies',
  other = 'other',
}
export enum ChatEvidenceSubscriptionTier {
  free = 'free',
  pro = 'pro',
}
export enum ChatListItemVersion {
  Value1 = 1,
  Value2 = 2,
}
export enum ChatMessageSourceEntry_methodAnyOf0 {
  typed = 'typed',
  follow_up_chip = 'follow_up_chip',
  suggestion_chip = 'suggestion_chip',
  shortcut_chip = 'shortcut_chip',
  document_suggestion_banner = 'document_suggestion_banner',
  document_suggestion_chip = 'document_suggestion_chip',
  auto_query = 'auto_query',
  check_other_sources = 'check_other_sources',
  selection_action = 'selection_action',
}
export enum ChatMessageSourceOriginAnyOf0 {
  default = 'default',
  library = 'library',
  custom = 'custom',
}
export enum ChatMessageSourceSurfaceAnyOf0 {
  slash_menu = 'slash_menu',
  suggestion_bar = 'suggestion_bar',
  peek_sheet = 'peek_sheet',
  floating_input = 'floating_input',
  document_suggestion_banner = 'document_suggestion_banner',
  clinical_tasks_panel = 'clinical_tasks_panel',
  selection_menu = 'selection_menu',
}
export enum ChatMode {
  evidence = 'evidence',
  legacy = 'legacy',
  auto = 'auto',
}
export enum ChatOrderBy {
  created_at = 'created_at',
  updated_at = 'updated_at',
}
export enum CheckItemKind {
  check = 'check',
}
export enum ChildRunSummaryStatus {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum ChipShowPhase {
  before_session = 'before_session',
  in_session = 'in_session',
  after_session = 'after_session',
}
export enum ChoiceItemKind {
  choice = 'choice',
}
export enum ChoiceTag {
  first_line = 'first_line',
  alternative = 'alternative',
}
export enum CibaAuditEvent {
  ciba_login_reported = 'ciba_login_reported',
  ciba_denial_streak_detected = 'ciba_denial_streak_detected',
}
export enum ClearMode {
  reset = 'reset',
  delete = 'delete',
}
export enum ClientBuildDiagnosticsPlatform {
  desktop = 'desktop',
  web = 'web',
}
export enum ClientPlatformSystem {
  darwin = 'darwin',
  win32 = 'win32',
  linux = 'linux',
}
export enum ClinicIdType {
  org = 'org',
  team = 'team',
}
export enum ClinicalCodingExtractionCodeRelevance {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}
export enum ClinicalCodingExtractionErrorType {
  InvalidDocumentInput = 'InvalidDocumentInput',
  LLMExtractionFailed = 'LLMExtractionFailed',
  ExtractionTimeout = 'ExtractionTimeout',
  InternalError = 'InternalError',
  UnsupportedCodeSystem = 'UnsupportedCodeSystem',
}
export enum ClinicalNoteTypeCodingSystem {
  Value11506_3 = '11506-3',
  Value11488_4 = '11488-4',
  Value28570_0 = '28570-0',
  Value34117_2 = '34117-2',
  Value18842_5 = '18842-5',
  Value34111_5 = '34111-5',
  Value69730_0 = '69730-0',
  Value34746_8 = '34746-8',
}
export enum ClinicalTaskCategory {
  order = 'order',
  coordinate = 'coordinate',
  communicate = 'communicate',
  document = 'document',
  action = 'action',
  prescription = 'prescription',
}
export enum ClinicalTaskCompletedBy {
  Clinician = 'Clinician',
  Heidi = 'Heidi',
  Ai = 'Ai',
}
export enum ClinicalTaskLinkOutcome {
  linked = 'linked',
  already_linked = 'already_linked',
  unlinked = 'unlinked',
  not_linked = 'not_linked',
}
export enum ClinicalTaskLinkType {
  LETTER = 'LETTER',
  PRESCRIPTION = 'PRESCRIPTION',
  INBOX_MESSAGE = 'INBOX_MESSAGE',
}
export enum ClinicalTaskOrigin {
  user = 'user',
  model = 'model',
}
export enum ClinicalTaskStatus {
  todo = 'todo',
  in_progress = 'in_progress',
  done = 'done',
  archived = 'archived',
}
export enum CodedClinicalEntityRelevance {
  IRRELEVANT = 'IRRELEVANT',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}
export enum CodedClinicalEntityStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
}
export enum CollectionDetailResponseSource {
  user = 'user',
  sharepoint = 'sharepoint',
}
export enum CollectionDetailResponseKind {
  input = 'input',
  artifacts = 'artifacts',
}
export enum CollectionResponseSource {
  user = 'user',
  sharepoint = 'sharepoint',
}
export enum CollectionResponseKind {
  input = 'input',
  artifacts = 'artifacts',
}
export enum CompetitionStatus {
  draft = 'draft',
  active = 'active',
  completed = 'completed',
  archived = 'archived',
}
export enum CompositionAttestationMode {
  personal = 'personal',
  professional = 'professional',
  legal = 'legal',
  official = 'official',
}
export enum CompositionStatus {
  preliminary = 'preliminary',
  final = 'final',
  amended = 'amended',
  entered_in_error = 'entered-in-error',
}
export enum CondItemKind {
  cond = 'cond',
}
export enum CondItemWhen {
  yes = 'yes',
  no = 'no',
}
export enum ConfidentialityClassification {
  U = 'U',
  L = 'L',
  M = 'M',
  N = 'N',
  R = 'R',
  V = 'V',
}
export enum ConsultNoteStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
export enum ConsultStorageDays {
  Value1_day = '1 day',
  Value3_days = '3 days',
  Value7_days = '7 days',
  Value21_days = '21 days',
  Value90_days = '90 days',
  Never_Delete = 'Never Delete',
}
export enum ContactPointSystem {
  phone = 'phone',
  fax = 'fax',
  email = 'email',
  pager = 'pager',
  url = 'url',
  sms = 'sms',
  other = 'other',
}
export enum ContactPointUse {
  home = 'home',
  work = 'work',
  temp = 'temp',
  old = 'old',
  mobile = 'mobile',
}
export enum ContentType {
  MARKDOWN = 'MARKDOWN',
  HTML = 'HTML',
  JSON = 'JSON',
}
export enum ContextDocumentStatus {
  OVERSIZED = 'OVERSIZED',
  FAIL_TO_UPLOAD = 'FAIL_TO_UPLOAD',
  PARSING = 'PARSING',
  FAIL_TO_EXTRACT_CONTENT = 'FAIL_TO_EXTRACT_CONTENT',
  READY = 'READY',
  READY_WITH_HIGH_TOKEN_COUNT = 'READY_WITH_HIGH_TOKEN_COUNT',
}
export enum ConversationDetailViewMode {
  ai = 'ai',
  staff = 'staff',
}
export enum ConversationDetailViewStatus {
  open = 'open',
  resolved = 'resolved',
}
export enum ConversationMessageViewRole {
  user = 'user',
  assistant = 'assistant',
}
export enum ConversationSummaryViewMode {
  ai = 'ai',
  staff = 'staff',
}
export enum ConversationSummaryViewStatus {
  open = 'open',
  resolved = 'resolved',
}
export enum CopyType {
  COPY_WITH_PLAIN_TEXT = 'COPY_WITH_PLAIN_TEXT',
  COPY_WITH_FORMATTING_WITHOUT_LISTS = 'COPY_WITH_FORMATTING_WITHOUT_LISTS',
  COPY_WITH_FORMATTING_WITH_LISTS = 'COPY_WITH_FORMATTING_WITH_LISTS',
}
export enum CorrespondenceContentType {
  consult_note = 'consult_note',
  document = 'document',
}
export enum Country {
  Australia = 'Australia',
  Australia_Enterprise_ = 'Australia (Enterprise)',
  Afghanistan = 'Afghanistan',
  Albania = 'Albania',
  Algeria = 'Algeria',
  American_Samoa = 'American Samoa',
  Andorra = 'Andorra',
  Angola = 'Angola',
  Anguilla = 'Anguilla',
  Antarctica = 'Antarctica',
  Antigua_and_Barbuda = 'Antigua and Barbuda',
  Argentina = 'Argentina',
  Armenia = 'Armenia',
  Aruba = 'Aruba',
  Austria = 'Austria',
  Azerbaijan = 'Azerbaijan',
  Bahamas = 'Bahamas',
  Bahrain = 'Bahrain',
  Bangladesh = 'Bangladesh',
  Barbados = 'Barbados',
  Belarus = 'Belarus',
  Belgium = 'Belgium',
  Belize = 'Belize',
  Benin = 'Benin',
  Bermuda = 'Bermuda',
  Bhutan = 'Bhutan',
  Bolivia = 'Bolivia',
  Bosnia_and_Herzegovina = 'Bosnia and Herzegovina',
  Botswana = 'Botswana',
  Brazil = 'Brazil',
  British_Indian_Ocean_Territory = 'British Indian Ocean Territory',
  Brunei_Darussalam = 'Brunei Darussalam',
  Bulgaria = 'Bulgaria',
  Burkina_Faso = 'Burkina Faso',
  Burundi = 'Burundi',
  Cambodia = 'Cambodia',
  Cameroon = 'Cameroon',
  Canada = 'Canada',
  Cape_Verde = 'Cape Verde',
  Cayman_Islands = 'Cayman Islands',
  Central_African_Republic = 'Central African Republic',
  Chad = 'Chad',
  Chile = 'Chile',
  China = 'China',
  Christmas_Island = 'Christmas Island',
  Cocos_Keeling_Islands = 'Cocos (Keeling) Islands',
  Colombia = 'Colombia',
  Comoros = 'Comoros',
  Congo_Democratic_Republic_of_the = 'Congo, Democratic Republic of the',
  Congo_Republic_of_the = 'Congo, Republic of the',
  Cook_Islands = 'Cook Islands',
  Costa_Rica = 'Costa Rica',
  Cote_d_Ivoire = "Cote d'Ivoire",
  Croatia = 'Croatia',
  Cuba = 'Cuba',
  Curacao = 'Curacao',
  Cyprus = 'Cyprus',
  Czech_Republic = 'Czech Republic',
  Denmark = 'Denmark',
  Djibouti = 'Djibouti',
  Dominica = 'Dominica',
  Dominican_Republic = 'Dominican Republic',
  Ecuador = 'Ecuador',
  Egypt = 'Egypt',
  El_Salvador = 'El Salvador',
  Equatorial_Guinea = 'Equatorial Guinea',
  Eritrea = 'Eritrea',
  Estonia = 'Estonia',
  Ethiopia = 'Ethiopia',
  Falkland_Islands_Malvinas_ = 'Falkland Islands (Malvinas)',
  Faroe_Islands = 'Faroe Islands',
  Fiji = 'Fiji',
  Finland = 'Finland',
  France = 'France',
  French_Guiana = 'French Guiana',
  French_Southern_Territories = 'French Southern Territories',
  Gabon = 'Gabon',
  Gambia = 'Gambia',
  Georgia = 'Georgia',
  Germany = 'Germany',
  Ghana = 'Ghana',
  Gibraltar = 'Gibraltar',
  Greece = 'Greece',
  Greenland = 'Greenland',
  Grenada = 'Grenada',
  Guadeloupe = 'Guadeloupe',
  Guam = 'Guam',
  Guatemala = 'Guatemala',
  Guernsey = 'Guernsey',
  Guinea = 'Guinea',
  Guinea_Bissau = 'Guinea-Bissau',
  Guyana = 'Guyana',
  Haiti = 'Haiti',
  Holy_See_Vatican_City_State_ = 'Holy See (Vatican City State)',
  Honduras = 'Honduras',
  Hong_Kong = 'Hong Kong',
  Hungary = 'Hungary',
  Iceland = 'Iceland',
  India = 'India',
  Indonesia = 'Indonesia',
  Iran_Islamic_Republic_of = 'Iran, Islamic Republic of',
  Iraq = 'Iraq',
  Ireland = 'Ireland',
  Isle_of_Man = 'Isle of Man',
  Israel = 'Israel',
  Italy = 'Italy',
  Jamaica = 'Jamaica',
  Japan = 'Japan',
  Japan_Enterprise_ = 'Japan (Enterprise)',
  Jersey = 'Jersey',
  Jordan = 'Jordan',
  Kazakhstan = 'Kazakhstan',
  Kenya = 'Kenya',
  Kiribati = 'Kiribati',
  Korea_Democratic_People_s_Republic_of = "Korea, Democratic People's Republic of",
  Korea_Republic_of = 'Korea, Republic of',
  Kuwait = 'Kuwait',
  Kyrgyzstan = 'Kyrgyzstan',
  Lao_People_s_Democratic_Republic = "Lao People's Democratic Republic",
  Latvia = 'Latvia',
  Lebanon = 'Lebanon',
  Lesotho = 'Lesotho',
  Liberia = 'Liberia',
  Libya = 'Libya',
  Liechtenstein = 'Liechtenstein',
  Lithuania = 'Lithuania',
  Luxembourg = 'Luxembourg',
  Macao = 'Macao',
  Macedonia_the_Former_Yugoslav_Republic_of = 'Macedonia, the Former Yugoslav Republic of',
  Madagascar = 'Madagascar',
  Malawi = 'Malawi',
  Malaysia = 'Malaysia',
  Maldives = 'Maldives',
  Mali = 'Mali',
  Malta = 'Malta',
  Marshall_Islands = 'Marshall Islands',
  Martinique = 'Martinique',
  Mauritania = 'Mauritania',
  Mauritius = 'Mauritius',
  Mayotte = 'Mayotte',
  Mexico = 'Mexico',
  Micronesia_Federated_States_of = 'Micronesia, Federated States of',
  Moldova_Republic_of = 'Moldova, Republic of',
  Monaco = 'Monaco',
  Mongolia = 'Mongolia',
  Montenegro = 'Montenegro',
  Montserrat = 'Montserrat',
  Morocco = 'Morocco',
  Mozambique = 'Mozambique',
  Myanmar = 'Myanmar',
  Namibia = 'Namibia',
  Nauru = 'Nauru',
  Nepal = 'Nepal',
  Netherlands = 'Netherlands',
  New_Caledonia = 'New Caledonia',
  New_Zealand = 'New Zealand',
  Nicaragua = 'Nicaragua',
  Niger = 'Niger',
  Nigeria = 'Nigeria',
  Niue = 'Niue',
  Norfolk_Island = 'Norfolk Island',
  Northern_Mariana_Islands = 'Northern Mariana Islands',
  Norway = 'Norway',
  Oman = 'Oman',
  Pakistan = 'Pakistan',
  Palau = 'Palau',
  Palestine_State_of = 'Palestine, State of',
  Panama = 'Panama',
  Papua_New_Guinea = 'Papua New Guinea',
  Paraguay = 'Paraguay',
  Peru = 'Peru',
  Philippines = 'Philippines',
  Pitcairn = 'Pitcairn',
  Poland = 'Poland',
  Portugal = 'Portugal',
  Puerto_Rico = 'Puerto Rico',
  Qatar = 'Qatar',
  Qatar_Enterprise_ = 'Qatar (Enterprise)',
  Reunion = 'Reunion',
  Romania = 'Romania',
  Russian_Federation = 'Russian Federation',
  Rwanda = 'Rwanda',
  Saint_Barthelemy = 'Saint Barthelemy',
  Saint_Helena = 'Saint Helena',
  Saint_Kitts_and_Nevis = 'Saint Kitts and Nevis',
  Saint_Lucia = 'Saint Lucia',
  Saint_Martin_French_part_ = 'Saint Martin (French part)',
  Saint_Pierre_and_Miquelon = 'Saint Pierre and Miquelon',
  Saint_Vincent_and_the_Grenadines = 'Saint Vincent and the Grenadines',
  Samoa = 'Samoa',
  San_Marino = 'San Marino',
  Sao_Tome_and_Principe = 'Sao Tome and Principe',
  Saudi_Arabia = 'Saudi Arabia',
  Senegal = 'Senegal',
  Serbia = 'Serbia',
  Seychelles = 'Seychelles',
  Sierra_Leone = 'Sierra Leone',
  Singapore = 'Singapore',
  Sint_Maarten_Dutch_part_ = 'Sint Maarten (Dutch part)',
  Slovakia = 'Slovakia',
  Slovenia = 'Slovenia',
  Solomon_Islands = 'Solomon Islands',
  Somalia = 'Somalia',
  South_Africa = 'South Africa',
  South_Georgia_and_the_South_Sandwich_Islands = 'South Georgia and the South Sandwich Islands',
  South_Sudan = 'South Sudan',
  Spain = 'Spain',
  Sri_Lanka = 'Sri Lanka',
  Sudan = 'Sudan',
  Suriname = 'Suriname',
  Svalbard_and_Jan_Mayen = 'Svalbard and Jan Mayen',
  Swaziland = 'Swaziland',
  Sweden = 'Sweden',
  Sweden_Enterprise_ = 'Sweden (Enterprise)',
  Switzerland = 'Switzerland',
  Syrian_Arab_Republic = 'Syrian Arab Republic',
  Taiwan_Province_of_China = 'Taiwan, Province of China',
  Tajikistan = 'Tajikistan',
  Tanzania_United_Republic_of = 'Tanzania, United Republic of',
  Thailand = 'Thailand',
  Timor_Leste = 'Timor-Leste',
  Togo = 'Togo',
  Tokelau = 'Tokelau',
  Tonga = 'Tonga',
  Trinidad_and_Tobago = 'Trinidad and Tobago',
  Tunisia = 'Tunisia',
  Turkey = 'Turkey',
  Turkmenistan = 'Turkmenistan',
  Turks_and_Caicos_Islands = 'Turks and Caicos Islands',
  Tuvalu = 'Tuvalu',
  Uganda = 'Uganda',
  Ukraine = 'Ukraine',
  United_Arab_Emirates = 'United Arab Emirates',
  United_Arab_Emirates_Enterprise_ = 'United Arab Emirates (Enterprise)',
  United_Kingdom = 'United Kingdom',
  United_States = 'United States',
  United_States_Enterprise_ = 'United States (Enterprise)',
  Uruguay = 'Uruguay',
  Uzbekistan = 'Uzbekistan',
  Vanuatu = 'Vanuatu',
  Venezuela = 'Venezuela',
  Vietnam = 'Vietnam',
  Virgin_Islands_British = 'Virgin Islands, British',
  Virgin_Islands_U_S_ = 'Virgin Islands, U.S.',
  Wallis_and_Futuna = 'Wallis and Futuna',
  Western_Sahara = 'Western Sahara',
  Yemen = 'Yemen',
  Zambia = 'Zambia',
  Zimbabwe = 'Zimbabwe',
  others = 'others',
}
export enum CountryCode {
  AF = 'AF',
  AX = 'AX',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BA = 'BA',
  BW = 'BW',
  BV = 'BV',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  CV = 'CV',
  KY = 'KY',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CN = 'CN',
  CX = 'CX',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  CD = 'CD',
  CG = 'CG',
  CK = 'CK',
  CR = 'CR',
  CI = 'CI',
  HR = 'HR',
  CU = 'CU',
  CW = 'CW',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  FI = 'FI',
  FR = 'FR',
  GF = 'GF',
  PF = 'PF',
  TF = 'TF',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  DE = 'DE',
  GH = 'GH',
  GI = 'GI',
  GR = 'GR',
  GL = 'GL',
  GD = 'GD',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  VA = 'VA',
  HN = 'HN',
  HK = 'HK',
  HU = 'HU',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IE = 'IE',
  IM = 'IM',
  IL = 'IL',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  JE = 'JE',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KR = 'KR',
  XK = 'XK',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MO = 'MO',
  MK = 'MK',
  MG = 'MG',
  MW = 'MW',
  MY = 'MY',
  MV = 'MV',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NL = 'NL',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  NF = 'NF',
  MP = 'MP',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  BL = 'BL',
  SH = 'SH',
  KN = 'KN',
  LC = 'LC',
  MF = 'MF',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  SG = 'SG',
  SX = 'SX',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  ZA = 'ZA',
  GS = 'GS',
  SS = 'SS',
  ES = 'ES',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SZ = 'SZ',
  SE = 'SE',
  CH = 'CH',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TH = 'TH',
  TL = 'TL',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  GB = 'GB',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  EH = 'EH',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW',
  XX = 'XX',
}
export enum CreateBlockedNumberRequestBlocked_viaAnyOf0 {
  settings_ui = 'settings_ui',
  call_log_menu = 'call_log_menu',
  admin = 'admin',
  import = 'import',
}
export enum CreateCatalogProductRequestAggregation_mode {
  sum = 'sum',
  tally = 'tally',
}
export enum CreateCatalogProductRequestSum_fieldAnyOf0 {
  quantity = 'quantity',
  token_count = 'token_count',
}
export enum CreateDocumentPages {
  CREATE_DOCUMENT = 'CREATE_DOCUMENT',
  SELECT_DOCUMENT = 'SELECT_DOCUMENT',
}
export enum CreateEventRuleRequestScope_type {
  user = 'user',
  team = 'team',
  org = 'org',
}
export enum CreateLimitAssignmentRequestScope_type {
  user = 'user',
  organization = 'organization',
  global = 'global',
}
export enum CreateLimitAssignmentRequestMode {
  enroll = 'enroll',
  exclude = 'exclude',
}
export enum CreateLimitRequestPeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum CreateLimitRequestEnforcement_mode {
  hard_cap = 'hard_cap',
  metered_overage = 'metered_overage',
}
export enum CreateMetricRequestAggregation_mode {
  sum = 'sum',
  tally = 'tally',
}
export enum CreateMetricRequestSum_fieldAnyOf0 {
  quantity = 'quantity',
  token_count = 'token_count',
}
export enum CreateProjectRequestTool_profile {
  clinician_desktop = 'clinician_desktop',
  evidence_only = 'evidence_only',
}
export enum CreateTemplateCreationRecordTrigger {
  from_chat = 'from_chat',
  from_file_upload = 'from_file_upload',
  from_existing_template = 'from_existing_template',
}
export enum CreateTemplatePages {
  CREATE_CUSTOM_TEMPLATE = 'CREATE_CUSTOM_TEMPLATE',
  PROMPT_HEIDI_TO_GENERATE_YOUR_PERFECT_TEMPLATE = 'PROMPT_HEIDI_TO_GENERATE_YOUR_PERFECT_TEMPLATE',
  SAVE_TEMPLATE = 'SAVE_TEMPLATE',
}
export enum CreateWorkflowRequestSource {
  instructed = 'instructed',
  recorded = 'recorded',
}
export enum CreditGrantStatus {
  granted = 'granted',
  already_granted = 'already_granted',
  failed = 'failed',
  skipped_no_metered_item = 'skipped_no_metered_item',
  skipped_no_billing_identity = 'skipped_no_billing_identity',
  skipped_not_overage = 'skipped_not_overage',
  skipped_no_price = 'skipped_no_price',
  skipped_unlimited_allowance = 'skipped_unlimited_allowance',
  skipped_no_billing_period = 'skipped_no_billing_period',
  skipped_period_mismatch = 'skipped_period_mismatch',
}
export enum CronFrequencyKind {
  cron = 'cron',
}
export enum Currency {
  usd = 'usd',
  aud = 'aud',
  cad = 'cad',
  chf = 'chf',
  cny = 'cny',
  eur = 'eur',
  gbp = 'gbp',
  hkd = 'hkd',
  idr = 'idr',
  inr = 'inr',
  jpy = 'jpy',
  krw = 'krw',
  myr = 'myr',
  nzd = 'nzd',
  php = 'php',
  pkr = 'pkr',
  pln = 'pln',
  sar = 'sar',
  sgd = 'sgd',
  zar = 'zar',
}
export enum DailyFrequencyKind {
  daily = 'daily',
}
export enum DatadogDiagnosticsTransport_probe {
  reachable = 'reachable',
  failed = 'failed',
  not_attempted = 'not_attempted',
}
export enum DateFormat {
  DAY_MONTH_YEAR = 'DD/MM/YYYY',
  DAY_MONTH_YEAR_ABBR = 'D MMM YYYY',
  DAY_MONTH_YEAR_DOT = 'DD.MM.YYYY',
  DAY_MONTH_YEAR_DOT_SHORT = 'DD.MM.YY',
  MONTH_DAY_YEAR = 'MM/DD/YYYY',
  MONTH_DAY_YEAR_SHORT = 'MM/DD/YY',
  MONTH_FULL_DAY_YEAR = 'MMMM DD YYYY',
  MONTH_ABBR_DAY_YEAR = 'MMM DD YYYY',
  YEAR_MONTH_DAY = 'YYYY/MM/DD',
}
export enum DateParameterOperator {
  eq = 'eq',
  ne = 'ne',
  gt = 'gt',
  lt = 'lt',
  ge = 'ge',
  le = 'le',
  sa = 'sa',
  eb = 'eb',
  ap = 'ap',
}
export enum DayOfWeek {
  mon = 'mon',
  tue = 'tue',
  wed = 'wed',
  thu = 'thu',
  fri = 'fri',
  sat = 'sat',
  sun = 'sun',
}
export enum DaysOfWeek {
  mon = 'mon',
  tue = 'tue',
  wed = 'wed',
  thu = 'thu',
  fri = 'fri',
  sat = 'sat',
  sun = 'sun',
}
export enum DebugEventSeverity {
  info = 'info',
  warning = 'warning',
  error = 'error',
}
export enum DebugEventType {
  stt_error = 'stt_error',
  stt_retry = 'stt_retry',
  stt_language_mismatch = 'stt_language_mismatch',
  translation_error = 'translation_error',
  translation_fallback = 'translation_fallback',
  unsupported_script = 'unsupported_script',
  tts_error = 'tts_error',
  stt_non_verbal = 'stt_non_verbal',
  general_error = 'general_error',
}
export enum DeliveryPolicyFailure_behavior {
  skip = 'skip',
  degraded_card = 'degraded_card',
}
export enum DesktopAppType {
  Desktop = 'Desktop',
}
export enum DesktopTargetAssignmentStatus {
  pending = 'pending',
  accepted = 'accepted',
  failed = 'failed',
}
export enum DesktopTargetFailureCode {
  target_locked = 'target_locked',
  executor_busy = 'executor_busy',
  executor_start_failed = 'executor_start_failed',
  acceptance_unconfirmed = 'acceptance_unconfirmed',
}
export enum DiagnosisType {
  diagnosis = 'diagnosis',
}
export enum DictationCleanupModes {
  SMART = 'SMART',
  WORD_FOR_WORD = 'WORD_FOR_WORD',
}
export enum DictationTone {
  formal = 'formal',
  conversational = 'conversational',
  casual = 'casual',
}
export enum DirectoryRecipientSearchResultResponseType {
  directory = 'directory',
}
export enum DirectoryStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
export enum DocumentGenType {
  TEMPLATE = 'TEMPLATE',
  ASK_AI = 'ASK_AI',
  DICTATION = 'DICTATION',
  PRESET_AI_COMMAND = 'PRESET_AI_COMMAND',
  LIVE_DICTATION = 'LIVE_DICTATION',
  PDF = 'PDF',
  INTERNAL_TEMPLATE = 'INTERNAL_TEMPLATE',
  GPCCMP = 'GPCCMP',
  BLANK = 'BLANK',
}
export enum DocumentReferenceRelatesToCode {
  replaces = 'replaces',
  transforms = 'transforms',
  signs = 'signs',
  appends = 'appends',
}
export enum DocumentReferenceStatus {
  current = 'current',
  superseded = 'superseded',
  entered_in_error = 'entered-in-error',
}
export enum DocumentRelationshipType {
  replaces = 'replaces',
  transforms = 'transforms',
  signs = 'signs',
  appends = 'appends',
}
export enum DocumentScope {
  user = 'user',
  team = 'team',
}
export enum DocumentSortBy {
  created_at = 'created_at',
  index = 'index',
}
export enum DocumentTabType {
  DOCUMENT = 'DOCUMENT',
  DICTATION = 'DICTATION',
  PDF = 'PDF',
  PRECHART = 'PRECHART',
  PATIENT_SUMMARY = 'PATIENT_SUMMARY',
  CARE_PATH = 'CARE_PATH',
}
export enum DocumentType {
  word = 'word',
  pdf = 'pdf',
  image = 'image',
}
export enum EHRIntegrationStatus {
  not_required = 'not_required',
  needs_credentials = 'needs_credentials',
  ready = 'ready',
}
export enum EHRLaunchApp {
  epic_vendorservices = 'epic_vendorservices',
  epic_fhir = 'epic_fhir',
  cerner_fhir = 'cerner_fhir',
}
export enum EHRProvider {
  Access_Rio = 'Access Rio',
  Accuro = 'Accuro',
  Adoreal = 'Adoreal',
  AdvancedMD = 'AdvancedMD',
  Airrosti = 'Airrosti',
  Akute_Health = 'Akute Health',
  Alaya_Care = 'Alaya Care',
  ALBIS = 'ALBIS',
  Allscripts = 'Allscripts',
  AmazingCharts = 'AmazingCharts',
  Anderes_System = 'Anderes System',
  Aprima = 'Aprima',
  ARZT_2000 = 'ARZT 2000',
  athenahealth = 'athenahealth',
  Automated_Medical_Assistant = 'Automated Medical Assistant',
  Avaros = 'Avaros',
  Avelios = 'Avelios',
  AxiSant_ = 'AxiSant\u00E9',
  Best_Practice = 'Best Practice',
  Better_Clinics = 'Better Clinics',
  Big_Picture_Medical = 'Big Picture Medical',
  BIH = 'BIH',
  Biocanic = 'Biocanic',
  BlueprintOMS = 'BlueprintOMS',
  Blueprint_Solutions = 'Blueprint Solutions',
  BodySite = 'BodySite',
  Carebit = 'Carebit',
  CareCloud = 'CareCloud',
  CareStack = 'CareStack',
  Cegedim_Crossway_Maiia_M_decin_ = 'Cegedim (Crossway/Maiia M\u00E9decin)',
  Cerbo = 'Cerbo',
  Cerner = 'Cerner',
  Cerner_EHR_Launch = 'Cerner EHR Launch',
  CGM_CLINICAL = 'CGM CLINICAL',
  CGM_M1_PRO = 'CGM M1 PRO',
  CGM_MEDICO = 'CGM MEDICO',
  CGM_MEDISTAR = 'CGM MEDISTAR',
  Charm = 'Charm',
  ChartLogic = 'ChartLogic',
  ClaimPower = 'ClaimPower',
  Client_Care = 'Client Care',
  ClinicCentre = 'ClinicCentre',
  ClinicCentre_Billing = 'ClinicCentre Billing',
  Clinic_to_Cloud = 'Clinic to Cloud',
  Cliniko = 'Cliniko',
  Compulink = 'Compulink',
  Cornerstone = 'Cornerstone',
  Counselear = 'Counselear',
  Counsol = 'Counsol',
  CureMD = 'CureMD',
  Data_AL = 'Data-AL',
  Dental4Windows = 'Dental4Windows',
  Doctolib = 'Doctolib',
  Doctorly = 'Doctorly',
  DrChrono = 'DrChrono',
  DrSant_ = 'DrSant\u00E9',
  DURIA = 'DURIA',
  DURIA2 = 'DURIA2',
  DxCare = 'DxCare',
  Easily = 'Easily',
  EasternHealth = 'EasternHealth',
  eClinicalWorks = 'eClinicalWorks',
  eClinicalWorks_EHR_Launch = 'eClinicalWorks EHR Launch',
  Elation = 'Elation',
  Elefant = 'Elefant',
  Elixir = 'Elixir',
  EMIS = 'EMIS',
  e_MDS = 'e-MDS',
  Epikur = 'Epikur',
  Epic_Systems = 'Epic Systems',
  esQlab_online = 'esQlab.online',
  EVA = 'EVA',
  EVIDENT = 'EVIDENT',
  FIDUS = 'FIDUS',
  Follow = 'Follow',
  Galaxy = 'Galaxy',
  Galeon = 'Galeon',
  Genie = 'Genie',
  Genie_Web = 'Genie Web',
  Genius = 'Genius',
  Gensolve = 'Gensolve',
  Gentu = 'Gentu',
  Google_Calendar = 'Google Calendar',
  Greenway_Health = 'Greenway Health',
  Halaxy = 'Halaxy',
  Headway = 'Headway',
  Healthie = 'Healthie',
  HealthQuest = 'HealthQuest',
  Hefficient = 'Hefficient',
  Helix = 'Helix',
  HelloDoc = 'HelloDoc',
  Hero_Health = 'Hero Health',
  Hopital_Manager = 'Hopital Manager',
  iaptus_by_Mayden = 'iaptus by Mayden',
  IMedOne = 'IMedOne',
  IMP_System = 'IMP::System',
  Indici = 'Indici',
  Innowell_EHR_Launch = 'Innowell EHR Launch',
  inSuite = 'inSuite',
  InstantScripts = 'InstantScripts',
  IntakeQ = 'IntakeQ',
  InterARZT = 'InterARZT',
  InterSystems = 'InterSystems',
  JunoOscar = 'JunoOscar',
  Kareo = 'Kareo',
  Keiser = 'Keiser',
  Keyreply = 'Keyreply',
  KFSH = 'KFSH',
  KiWi = 'KiWi',
  Magentus = 'Magentus',
  Magentus_Genie_ = 'Magentus Genie\u00AE',
  Maincare = 'Maincare',
  MDLand = 'MDLand',
  medatixx = 'medatixx',
  MEDAVIS_RIS = 'MEDAVIS RIS',
  Medical_Director = 'Medical Director',
  MedicalMinded = 'MedicalMinded',
  Medical_Office = 'Medical Office',
  Mediclinic = 'Mediclinic',
  medico = 'medico',
  MediOffice = 'MediOffice',
  MediRecords = 'MediRecords',
  Medistory = 'Medistory',
  Meditech_Expanse = 'Meditech Expanse',
  MedServ_RPM = 'MedServ RPM',
  Medtech = 'Medtech',
  MEDYS = 'MEDYS',
  Micro_Quest = 'Micro Quest',
  Midex_Pro = 'Midex Pro',
  Mindbody = 'Mindbody',
  M_KIS = 'M-KIS',
  Modernizing_Medicine = 'Modernizing Medicine',
  MyOsteopathy = 'MyOsteopathy',
  MyOutcomes = 'MyOutcomes',
  MyVirtualCare = 'MyVirtualCare',
  nCAS_EHR_Launch = 'nCAS EHR Launch',
  Heidi_Mock_EHR_SOF = 'Heidi Mock EHR SOF',
  Nephro = 'Nephro',
  Nephro7 = 'Nephro7',
  Nexsoft = 'Nexsoft',
  NEXUS_KIS = 'NEXUS / KIS',
  Nextech = 'Nextech',
  NextGen_Healthcare = 'NextGen Healthcare',
  Nookal = 'Nookal',
  Notability = 'Notability',
  Odaiji = 'Odaiji',
  Optimantra = 'Optimantra',
  ORBIS = 'ORBIS',
  ORBIS_U = 'ORBIS U',
  Orion_Health = 'Orion Health',
  Oscar_Pro = 'Oscar Pro',
  Osiris = 'Osiris',
  Osmind = 'Osmind',
  Outsmart = 'Outsmart',
  Owl = 'Owl',
  Pabau = 'Pabau',
  Patient_Now = 'Patient Now',
  PegaMed = 'PegaMed',
  Power_Diary = 'Power Diary',
  PPMS = 'PPMS',
  Pracsoft = 'Pracsoft',
  PracSuite = 'PracSuite',
  Practice_Better = 'Practice Better',
  Practice_Fusion = 'Practice Fusion',
  Practice_Hub = 'Practice Hub',
  PracticeQ = 'PracticeQ',
  Praxis = 'Praxis',
  Praxis_Programm = 'Praxis-Programm',
  Prognocis = 'Prognocis',
  PROFIMED = 'PROFIMED',
  Pro_Medico = 'Pro_Medico',
  PsychoDat = 'PsychoDat',
  psyprax = 'psyprax',
  PsyPrax_KIS = 'PsyPrax KIS',
  QUINCY_WIN = 'QUINCY WIN',
  RED_Medical = 'RED Medical',
  Renesan = 'Renesan',
  Renvio = 'Renvio',
  RescuePro = 'RescuePro',
  RevolutionEHR = 'RevolutionEHR',
  Rx = 'Rx',
  S3_Win = 'S3-Win',
  SAP_IS_H_i_s_h_med = 'SAP IS-H + i.s.h.med',
  Sandwell = 'Sandwell',
  Semble = 'Semble',
  Shexie = 'Shexie',
  SGIMED = 'SGIMED',
  Sillage = 'Sillage',
  SimplePractice = 'SimplePractice',
  SMARTY = 'SMARTY',
  Sound_Business = 'Sound Business',
  Splose = 'Splose',
  StrongroomAI = 'StrongroomAI',
  Suvera = 'Suvera',
  TalkNow = 'TalkNow',
  T2med = 'T2med',
  Telus = 'Telus',
  Telus_CHR_EHR_Launch = 'Telus CHR EHR Launch',
  TextFlow = 'TextFlow',
  Therabill = 'Therabill',
  Therabyte = 'Therabyte',
  Therapymate = 'Therapymate',
  TheraNest = 'TheraNest',
  TherapyNotes = 'TherapyNotes',
  Timely = 'Timely',
  tomedo = 'tomedo',
  TouchWorks = 'TouchWorks',
  TPP_SystmOne = 'TPP SystmOne',
  TURBOMED = 'TURBOMED',
  Unified_Practice = 'Unified Practice',
  UroChart_EHR = 'UroChart EHR',
  USW = 'USW',
  Veradigm_EHR = 'Veradigm EHR',
  vianova_KIS = 'vianova KIS',
  VIP = 'VIP',
  Vision_Health = 'Vision Health',
  WebPT = 'WebPT',
  Weda = 'Weda',
  Weva = 'Weva',
  WriteUpp = 'WriteUpp',
  WRS = 'WRS',
  xyCare = 'xyCare',
  XCare = 'XCare',
  x_comfort = 'x.comfort',
  x_concept = 'x.concept',
  xentro = 'xentro',
  Xestro = 'Xestro',
  x_isynet = 'x.isynet',
  x_vianova = 'x.vianova',
  Zedmed = 'Zedmed',
  ZHealthEHR = 'ZHealthEHR',
  zollsoft_tomedo = 'zollsoft_tomedo',
  Other = 'Other',
  Heidi = 'Heidi',
  Vim = 'Vim',
  Healthdirect = 'Healthdirect',
}
export enum EditOutlineChatMessageRole {
  user = 'user',
  assistant = 'assistant',
}
export enum EditSource {
  manual = 'manual',
  note_suggestion_auto = 'note_suggestion_auto',
}
export enum EffectivePinnedQuerySchemaOrigin {
  default = 'default',
  library = 'library',
  custom = 'custom',
}
export enum EffectiveSessionTimeoutSource {
  ORGANIZATION = 'ORGANIZATION',
  USER = 'USER',
  COHORT_DEFAULT = 'COHORT_DEFAULT',
  OPT_IN_AVAILABLE = 'OPT_IN_AVAILABLE',
  USER_DISABLED = 'USER_DISABLED',
}
export enum EmDeterminationMethod {
  mdm = 'mdm',
  time = 'time',
}
export enum EmMdmResponseModifierAnyOf0 {
  Value25 = '25',
  Value24 = '24',
}
export enum EmPatientType {
  new_patient = 'new_patient',
  established_patient = 'established_patient',
}
export enum EncounterLocationStatus {
  planned = 'planned',
  active = 'active',
  reserved = 'reserved',
  completed = 'completed',
}
export enum EncounterStatus {
  planned = 'planned',
  arrived = 'arrived',
  triaged = 'triaged',
  in_progress = 'in-progress',
  onleave = 'onleave',
  finished = 'finished',
  cancelled = 'cancelled',
  entered_in_error = 'entered-in-error',
  unknown = 'unknown',
}
export enum EndAfterNKind {
  after_n = 'after_n',
}
export enum EndAtKind {
  at = 'at',
}
export enum EnrolMeteredBillingRequestScope {
  user = 'user',
  organization = 'organization',
  workspace = 'workspace',
}
export enum EntitlementHistoryResponseTeam_scopeAnyOf0 {
  organization_id = 'organization_id',
  workspace_id = 'workspace_id',
}
export enum EntitlementHistoryResponseSource {
  usage_event = 'usage_event',
  metronome = 'metronome',
}
export enum EntitlementResponseTeam_scopeAnyOf0 {
  organization_id = 'organization_id',
  workspace_id = 'workspace_id',
}
export enum EntitlementResponseSource {
  usage_event = 'usage_event',
  metronome = 'metronome',
}
export enum EntitlementTypeAvailability {
  heidi_staff_only = 'heidi_staff_only',
  team_admins = 'team_admins',
}
export enum EntitySource {
  entity_verification = 'entity_verification',
  additional_information = 'additional_information',
}
export enum EvaluationErrorSeverity {
  minor = 'minor',
  major = 'major',
  critical = 'critical',
}
export enum EvaluationErrorStage {
  recording = 'recording',
  speech_to_text = 'speech_to_text',
  translation = 'translation',
  text_to_speech = 'text_to_speech',
}
export enum EvaluationErrorType {
  poor_audio_quality = 'poor_audio_quality',
  background_noise = 'background_noise',
  overlapping_voices = 'overlapping_voices',
  incorrect_speaker_attributed = 'incorrect_speaker_attributed',
  clipped_audio = 'clipped_audio',
  stt_incorrect_transcription = 'stt_incorrect_transcription',
  stt_omission = 'stt_omission',
  stt_addition = 'stt_addition',
  mistranslation = 'mistranslation',
  translation_omission = 'translation_omission',
  translation_addition = 'translation_addition',
  repetition = 'repetition',
  inappropriate_word_choice = 'inappropriate_word_choice',
  unidiomatic_lote = 'unidiomatic_lote',
  tts_mispronunciation = 'tts_mispronunciation',
  tts_omission = 'tts_omission',
  tts_addition = 'tts_addition',
  tts_inappropriate_accent = 'tts_inappropriate_accent',
}
export enum EvaluationUiVariant {
  simple_categories = 'simple_categories',
  monash_rubric = 'monash_rubric',
}
export enum EventStatus {
  preparation = 'preparation',
  in_progress = 'in-progress',
  not_done = 'not-done',
  on_hold = 'on-hold',
  stopped = 'stopped',
  completed = 'completed',
  entered_in_error = 'entered-in-error',
  unknown = 'unknown',
}
export enum EventTiming {
  MORN = 'MORN',
  MORN_early = 'MORN.early',
  MORN_late = 'MORN.late',
  NOON = 'NOON',
  AFT = 'AFT',
  AFT_early = 'AFT.early',
  AFT_late = 'AFT.late',
  EVE = 'EVE',
  EVE_early = 'EVE.early',
  EVE_late = 'EVE.late',
  NIGHT = 'NIGHT',
  PHS = 'PHS',
  HS = 'HS',
  WAKE = 'WAKE',
  C = 'C',
  CM = 'CM',
  CD = 'CD',
  CV = 'CV',
  AC = 'AC',
  ACM = 'ACM',
  ACD = 'ACD',
  ACV = 'ACV',
  PC = 'PC',
  PCM = 'PCM',
  PCD = 'PCD',
  PCV = 'PCV',
}
export enum EventType {
  note_generated = 'note_generated',
  session_created = 'session_created',
  document_created = 'document_created',
  document_generated = 'document_generated',
  session_transcribing = 'session_transcribing',
  session_transcribing_stopped = 'session_transcribing_stopped',
  patient_created = 'patient_created',
  patient_linked = 'patient_linked',
}
export enum EvidenceBillingSource {
  user = 'user',
  team = 'team',
}
export enum EvidenceSBSCandidatePosition {
  A = 'A',
  B = 'B',
}
export enum EvidenceSBSSkipReason {
  skip = 'skip',
  midstream_selection = 'midstream_selection',
}
export enum EvidenceSourceControlSelectionsLibrary_mode {
  all = 'all',
  collections = 'collections',
}
export enum EvidenceSourceControlSelectionsWeb_collections_mode {
  all = 'all',
  collections = 'collections',
}
export enum EvidenceSourceFilter {
  local_guidelines = 'local_guidelines',
  primary_evidence = 'primary_evidence',
}
export enum EvidenceSubscriptionOrderBy {
  email = 'email',
  created_at = 'created_at',
  evidence_billing_trial_end_date = 'evidence_billing.trial_end_date',
  evidence_billing_plan_end_date = 'evidence_billing.plan_end_date',
}
export enum EvidenceSubscriptionState {
  never_used = 'never_used',
  in_trial = 'in_trial',
  trial_expired = 'trial_expired',
  active_paid = 'active_paid',
  canceled_grace = 'canceled_grace',
  churned = 'churned',
}
export enum EvidenceSubscriptionTier {
  FREE = 'FREE',
  PRACTICE = 'PRACTICE',
  PRO = 'PRO',
}
export enum EvidenceTriggerLocation {
  in_session = 'in_session',
  out_of_session = 'out_of_session',
  unauthenticated = 'unauthenticated',
}
export enum ExclusionScope {
  competition = 'competition',
  series = 'series',
  global = 'global',
}
export enum ExportAssetType {
  header_logo = 'header_logo',
  footer_logo = 'footer_logo',
  signature = 'signature',
}
export enum ExportDocumentCtaCategory {
  referral_letter = 'referral_letter',
  patient_handout = 'patient_handout',
  medical_certificate = 'medical_certificate',
  insurance_workers_comp = 'insurance_workers_comp',
  ndis_legal_capacity = 'ndis_legal_capacity',
  discharge_summary = 'discharge_summary',
  specialist_letter_to_gp = 'specialist_letter_to_gp',
  other = 'other',
}
export enum ExportHeaderFooterContentLogo_alignmentAnyOf0 {
  left = 'left',
  center = 'center',
  right = 'right',
}
export enum ExportHeaderFooterContentText_alignmentAnyOf0 {
  left = 'left',
  center = 'center',
  right = 'right',
}
export enum ExportHeaderFooterContentSignature_alignmentAnyOf0 {
  left = 'left',
  center = 'center',
  right = 'right',
}
export enum ExportHeaderFooterContentSignature_fontAnyOf0 {
  dancing_script = 'dancing-script',
  great_vibes = 'great-vibes',
  allura = 'allura',
  pacifico = 'pacifico',
  satisfy = 'satisfy',
}
export enum ExportLayoutBlockType {
  image = 'image',
  text = 'text',
  signature = 'signature',
  spacer = 'spacer',
}
export enum ExportLayoutBlockAlignAnyOf0 {
  left = 'left',
  center = 'center',
  right = 'right',
}
export enum ExportLayoutBlockFontAnyOf0 {
  dancing_script = 'dancing-script',
  great_vibes = 'great-vibes',
  allura = 'allura',
  pacifico = 'pacifico',
  satisfy = 'satisfy',
}
export enum ExportLayoutRowVertical_alignAnyOf0 {
  top = 'top',
  middle = 'middle',
  bottom = 'bottom',
}
export enum ExtendFreeTrialHours {
  Value1 = 1,
  Value2 = 2,
  Value4 = 4,
  Value6 = 6,
  Value12 = 12,
  Value24 = 24,
}
export enum ExtendTrialActionAction {
  extend_trial = 'extend_trial',
}
export enum ExtensionTaskId {
  invite_team_member = 'invite_team_member',
  select_note_template = 'select_note_template',
  create_custom_template = 'create_custom_template',
  create_notes = 'create_notes',
  submit_evidence_queries = 'submit_evidence_queries',
  use_source_control = 'use_source_control',
  upload_personal_guideline = 'upload_personal_guideline',
  download_desktop_app = 'download_desktop_app',
  ask_heidi_tasks = 'ask_heidi_tasks',
}
export enum ExternalSourceName {
  HUBSPOT = 'HUBSPOT',
}
export enum FHIRVersion {
  Value0_01 = '0.01',
  Value0_05 = '0.05',
  Value0_06 = '0.06',
  Value0_11 = '0.11',
  Value0_0_80 = '0.0.80',
  Value0_0_81 = '0.0.81',
  Value0_0_82 = '0.0.82',
  Value0_4_0 = '0.4.0',
  Value0_5_0 = '0.5.0',
  Value1_0_0 = '1.0.0',
  Value1_0_1 = '1.0.1',
  Value1_0_2 = '1.0.2',
  Value1_1_0 = '1.1.0',
  Value1_4_0 = '1.4.0',
  Value1_6_0 = '1.6.0',
  Value1_8_0 = '1.8.0',
  Value3_0_0 = '3.0.0',
  Value3_0_1 = '3.0.1',
  Value3_3_0 = '3.3.0',
  Value3_5_0 = '3.5.0',
  Value4_0_0 = '4.0.0',
  Value4_0_1 = '4.0.1',
}
export enum FamilyHistoryStatus {
  partial = 'partial',
  completed = 'completed',
  entered_in_error = 'entered-in-error',
  health_unknown = 'health-unknown',
}
export enum FeatureFlagKey {
  release_sso_logout = 'release-sso-logout',
}
export enum FeedbackCategory {
  word_choices = 'word_choices',
  content = 'content',
  omission = 'omission',
  bad_voice = 'bad_voice',
  distorted_meaning = 'distorted_meaning',
  unidiomatic_language = 'unidiomatic_language',
}
export enum FeedbackRating {
  thumb_up = 'thumb_up',
  thumb_down = 'thumb_down',
}
export enum FeedbackTargetType {
  CONSULT_NOTE = 'CONSULT_NOTE',
  DOCUMENT = 'DOCUMENT',
  CLINICAL_CODE = 'CLINICAL_CODE',
  TRANSCRIPT = 'TRANSCRIPT',
  ASK_AI = 'ASK_AI',
  EVIDENCE = 'EVIDENCE',
  ENTITY_VERIFICATION = 'ENTITY_VERIFICATION',
  PROJECT = 'PROJECT',
  VOICE = 'VOICE',
}
export enum FeedbackV2ModeAnyOf0 {
  legacy = 'legacy',
  evidence = 'evidence',
}
export enum FhirClinicalDocStatus {
  preliminary = 'preliminary',
  final = 'final',
  amended = 'amended',
}
export enum FhirClinicalNoteTypes {
  Progress_Note = 'Progress Note',
  Consult_Note = 'Consult Note',
  Procedure_Note = 'Procedure Note',
  H_P_Note = 'H&P Note',
  Discharge_Summary = 'Discharge Summary',
  ED_Note = 'ED Note',
  Patient_Instructions = 'Patient Instructions',
  Nursing_Note = 'Nursing Note',
}
export enum FieldStatus {
  pending = 'pending',
  rejected = 'rejected',
  approved = 'approved',
  modified = 'modified',
}
export enum FindandReplaceScope {
  THIS_NOTE = 'THIS_NOTE',
  ALL_TABS = 'ALL_TABS',
  EVERYWHERE_FOREVER = 'EVERYWHERE_FOREVER',
}
export enum FlowsheetType {
  flowsheet = 'flowsheet',
}
export enum FlowsheetFeedbackType {
  flowsheetfeedback = 'flowsheetfeedback',
}
export enum FlowsheetSessionStatus {
  failed = 'failed',
}
export enum FlowsheetUpdatedType {
  flowsheetupdated = 'flowsheetupdated',
}
export enum ForkItemKind {
  fork = 'fork',
}
export enum Format {
  xml = 'xml',
  json = 'json',
}
export enum FulfillmentStage {
  processing = 'processing',
  confirmed = 'confirmed',
  preparing = 'preparing',
  shipped = 'shipped',
  canceled = 'canceled',
}
export enum GalleryTemplateCategory {
  CONSULT_NOTE_TEMPLATE = 'CONSULT_NOTE_TEMPLATE',
  DOCUMENT_TEMPLATE = 'DOCUMENT_TEMPLATE',
  FORM_TEMPLATE = 'FORM_TEMPLATE',
}
export enum GalleryTemplateRegion {
  UK = 'UK',
  CA = 'CA',
  US = 'US',
  AU = 'AU',
  EU = 'EU',
}
export enum GenderIdentity {
  M = 'M',
  F = 'F',
  TM = 'TM',
  TF = 'TF',
  GQ = 'GQ',
  SE = 'SE',
  MU = 'MU',
  DC = 'DC',
  NI = 'NI',
  UN = 'UN',
  OT = 'OT',
}
export enum GenerationMethod {
  PRESET_AI_COMMAND = 'PRESET_AI_COMMAND',
  AI_COMMAND_TEXT = 'AI_COMMAND_TEXT',
  ASK_AI = 'ASK_AI',
  TEMPLATE = 'TEMPLATE',
  INTERNAL_TEMPLATE = 'INTERNAL_TEMPLATE',
  DICTATION = 'DICTATION',
  THIRD_PARTY_TEMPLATE = 'THIRD_PARTY_TEMPLATE',
  LIVE_DICTATION = 'LIVE_DICTATION',
  PDF = 'PDF',
  GPCCMP = 'GPCCMP',
  AUTO_MODE = 'AUTO_MODE',
  BLANK = 'BLANK',
}
export enum GenerationMode {
  normal = 'normal',
  free2paid = 'free2paid',
  model_comparison = 'model_comparison',
  transcription_comparison = 'transcription_comparison',
  AUTO = 'AUTO',
  diarised_vs_non = 'diarised_vs_non',
}
export enum GenerationUse {
  NOTE_GENERATION = 'NOTE_GENERATION',
  DOCUMENT_GENERATION = 'DOCUMENT_GENERATION',
}
export enum GrantTrialActionAction {
  grant_trial = 'grant_trial',
}
export enum HardwareDeviceStatus {
  linked = 'linked',
  unlinked = 'unlinked',
}
export enum HarnessBackfillResource {
  agent_run = 'agent_run',
  approval = 'approval',
  schedule = 'schedule',
  event_resolution = 'event_resolution',
  agent_config = 'agent_config',
  agent_config_snapshot = 'agent_config_snapshot',
}
export enum HealthAccId {
  health_acc_45_v1 = 'health-acc-45-v1',
}
export enum HeidiPlatforms {
  Mobile = 'Mobile',
  Desktop = 'Desktop',
  Web = 'Web',
  Widget = 'Widget',
  OpenAPI = 'OpenAPI',
  MobileWeb = 'MobileWeb',
  ChromeExtension = 'ChromeExtension',
  SDK = 'SDK',
  InternalAdmin = 'InternalAdmin',
}
export enum HeidiVersion {
  Value1 = 1,
  Value2 = 2,
}
export enum HourlyFrequencyKind {
  hourly = 'hourly',
}
export enum HubSpotEntityEntity_type {
  company = 'company',
  contact = 'contact',
  deal = 'deal',
}
export enum HumanNameUse {
  usual = 'usual',
  official = 'official',
  temp = 'temp',
  nickname = 'nickname',
  anonymous = 'anonymous',
  old = 'old',
  maiden = 'maiden',
}
export enum IDTypes {
  FHIR = 'FHIR',
  FHIR_STU3 = 'FHIR STU3',
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
  MRN = 'MRN',
  CSN = 'CSN',
}
export enum IOSAppType {
  iOSApp = 'iOSApp',
}
export enum IdentifierUse {
  usual = 'usual',
  official = 'official',
  temp = 'temp',
  secondary = 'secondary',
  old = 'old',
}
export enum IdentityProviderSyncState {
  pending = 'pending',
  identity_sync_initiated = 'identity_sync_initiated',
  identity_sync_completed = 'identity_sync_completed',
  identity_sync_failed = 'identity_sync_failed',
  region_sync_initiated = 'region_sync_initiated',
  region_sync_completed = 'region_sync_completed',
  region_sync_failed = 'region_sync_failed',
  identity_create_initiated = 'identity_create_initiated',
  identity_create_completed = 'identity_create_completed',
  identity_create_failed = 'identity_create_failed',
  identity_skipped_jit = 'identity_skipped_jit',
  signup_finish_initiated = 'signup_finish_initiated',
  signup_finish_completed = 'signup_finish_completed',
  signup_finish_failed = 'signup_finish_failed',
  apple_migration_needed = 'apple_migration_needed',
  apple_migration_ticket_created = 'apple_migration_ticket_created',
  apple_migration_ticket_refreshed = 'apple_migration_ticket_refreshed',
  apple_migration_initiated = 'apple_migration_initiated',
  apple_migration_completed = 'apple_migration_completed',
  apple_migration_failed = 'apple_migration_failed',
}
export enum ImmunizationFunction {
  OP = 'OP',
  AP = 'AP',
}
export enum ImmunizationStatus {
  completed = 'completed',
  entered_in_error = 'entered-in-error',
  not_done = 'not-done',
}
export enum InboxItemActionsAvailable_override_scopes {
  once = 'once',
  session = 'session',
}
export enum InboxItemStatus {
  pending = 'pending',
  approved = 'approved',
  denied = 'denied',
  expired = 'expired',
  cancelled = 'cancelled',
}
export enum InboxRenderContextRisk {
  read = 'read',
  compute = 'compute',
  draft = 'draft',
  write = 'write',
  external = 'external',
  destructive = 'destructive',
}
export enum InfoItemKind {
  info = 'info',
}
export enum IntegrationAgentCommandResultStatus {
  completed = 'completed',
  failed = 'failed',
}
export enum IntegrationAgentOnlineStatus {
  online = 'online',
  offline = 'offline',
}
export enum IntegrationAgentProvider {
  genie_web = 'genie web',
  emis = 'emis',
}
export enum IntegrationAgentStatus {
  active = 'active',
  revoked = 'revoked',
}
export enum IntegrationClientAuthType {
  BEARER = 'BEARER',
}
export enum IntegrationClientStatus {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
  DISABLED = 'DISABLED',
}
export enum IntegrationInfoKey {
  cks = 'cks',
  vidal = 'vidal',
  mims = 'mims',
  mims_nz = 'mims_nz',
  emguidance = 'emguidance',
  elsevier = 'elsevier',
  wiley = 'wiley',
  clinicalkey_ai = 'clinicalkey_ai',
  healthpathways = 'healthpathways',
  bmj = 'bmj',
  emc = 'emc',
  nejm = 'nejm',
  sharepoint = 'sharepoint',
  atropos = 'atropos',
  nice = 'nice',
  has = 'has',
  guiasalud = 'guiasalud',
  cdc = 'cdc',
  cwc = 'cwc',
  jama = 'jama',
  cochrane = 'cochrane',
  springer_nature = 'springer_nature',
  nature = 'nature',
}
export enum IntegrationOption {
  Best_Practice = 'Best Practice',
  MediRecords = 'MediRecords',
  Medical_Director = 'Medical Director',
  Zedmed = 'Zedmed',
  Genie = 'Genie',
  Genie_Web = 'Genie Web',
  Pracsoft = 'Pracsoft',
  Medtech = 'Medtech',
  Clinic_to_Cloud = 'Clinic to Cloud',
  MedicalMinded = 'MedicalMinded',
  Epic_Systems = 'Epic Systems',
  Cerner = 'Cerner',
  athenahealth = 'athenahealth',
  eClinicalWorks = 'eClinicalWorks',
  Allscripts = 'Allscripts',
  NextGen_Healthcare = 'NextGen Healthcare',
  DrChrono = 'DrChrono',
  Greenway_Health = 'Greenway Health',
  CureMD = 'CureMD',
  Kareo = 'Kareo',
  AdvancedMD = 'AdvancedMD',
  Practice_Fusion = 'Practice Fusion',
  Aprima = 'Aprima',
  AmazingCharts = 'AmazingCharts',
  ChartLogic = 'ChartLogic',
  Modernizing_Medicine = 'Modernizing Medicine',
  Compulink = 'Compulink',
  Nextech = 'Nextech',
  RevolutionEHR = 'RevolutionEHR',
  CareCloud = 'CareCloud',
  EMIS = 'EMIS',
  TPP_SystmOne = 'TPP SystmOne',
  Vision_Health = 'Vision Health',
  Shexie = 'Shexie',
  IntakeQ = 'IntakeQ',
  Mediclinic = 'Mediclinic',
  Power_Diary = 'Power Diary',
  Cliniko = 'Cliniko',
  TherapyNotes = 'TherapyNotes',
  SimplePractice = 'SimplePractice',
  MyOutcomes = 'MyOutcomes',
  Nookal = 'Nookal',
  TheraNest = 'TheraNest',
  Magentus_Genie_ = 'Magentus Genie\u00AE',
  Orion_Health = 'Orion Health',
  InterSystems = 'InterSystems',
  Access_Rio = 'Access Rio',
  iaptus_by_Mayden = 'iaptus by Mayden',
  Meditech_Expanse = 'Meditech Expanse',
  WebPT = 'WebPT',
  Assisted_Living = 'Assisted Living',
  Avaros = 'Avaros',
  BlueprintOMS = 'BlueprintOMS',
  BodySite = 'BodySite',
  Carebit = 'Carebit',
  Charm = 'Charm',
  Client_Care = 'Client Care',
  Cornerstone = 'Cornerstone',
  Counselear = 'Counselear',
  Counsol = 'Counsol',
  e_MDS = 'e-MDS',
  Elation = 'Elation',
  Galaxy = 'Galaxy',
  Gensolve = 'Gensolve',
  Gentu = 'Gentu',
  Halaxy = 'Halaxy',
  Headway = 'Headway',
  Healthie = 'Healthie',
  HealthQuest = 'HealthQuest',
  Helix = 'Helix',
  Indici = 'Indici',
  JunoOscar = 'JunoOscar',
  MDLand = 'MDLand',
  MedServ_RPM = 'MedServ RPM',
  Micro_Quest = 'Micro Quest',
  Midex_Pro = 'Midex Pro',
  MyOsteopathy = 'MyOsteopathy',
  MyVirtualCare = 'MyVirtualCare',
  nCAS_EHR_Launch = 'nCAS EHR Launch',
  Notability = 'Notability',
  Optimantra = 'Optimantra',
  Oscar_Pro = 'Oscar Pro',
  Osmind = 'Osmind',
  Outsmart = 'Outsmart',
  Owl = 'Owl',
  Pabau = 'Pabau',
  Patient_Now = 'Patient Now',
  PPMS = 'PPMS',
  PracSuite = 'PracSuite',
  Practice_Better = 'Practice Better',
  Praxis = 'Praxis',
  Prognocis = 'Prognocis',
  Renesan = 'Renesan',
  Rx = 'Rx',
  Semble = 'Semble',
  Splose = 'Splose',
  Telus = 'Telus',
  TextFlow = 'TextFlow',
  Therabill = 'Therabill',
  Therabyte = 'Therabyte',
  Therapymate = 'Therapymate',
  Timely = 'Timely',
  Unified_Practice = 'Unified Practice',
  UroChart_EHR = 'UroChart EHR',
  Veradigm_EHR = 'Veradigm EHR',
  VIP = 'VIP',
  Vim = 'Vim',
  WriteUpp = 'WriteUpp',
  Xestro = 'Xestro',
  ZHealthEHR = 'ZHealthEHR',
  Elixir = 'Elixir',
  Other = 'Other',
}
export enum IntegrationPartnerConfigPartner {
  cks = 'cks',
  vidal = 'vidal',
  mims = 'mims',
  mims_nz = 'mims_nz',
  emguidance = 'emguidance',
  elsevier = 'elsevier',
  wiley = 'wiley',
  clinicalkey_ai = 'clinicalkey_ai',
  healthpathways = 'healthpathways',
  bmj = 'bmj',
  emc = 'emc',
  nejm = 'nejm',
  atropos = 'atropos',
  nice = 'nice',
  has = 'has',
  guiasalud = 'guiasalud',
  cdc = 'cdc',
  cwc = 'cwc',
  jama = 'jama',
  cochrane = 'cochrane',
  springer_nature = 'springer_nature',
  nature = 'nature',
}
export enum InternalAdminAuditEvent {
  user_created = 'user_created',
  user_updated = 'user_updated',
  user_email_changed = 'user_email_changed',
  user_name_changed = 'user_name_changed',
  user_jurisdiction_changed = 'user_jurisdiction_changed',
  user_permanently_deleted = 'user_permanently_deleted',
  user_referral_profile_deleted = 'user_referral_profile_deleted',
  user_mfa_reset = 'user_mfa_reset',
  user_logout_everywhere = 'user_logout_everywhere',
  user_logout_everywhere_failed = 'user_logout_everywhere_failed',
  user_auth0_unblocked = 'user_auth0_unblocked',
  user_password_reset_triggered = 'user_password_reset_triggered',
  user_to_user_migration_triggered = 'user_to_user_migration_triggered',
  user_region_migration_triggered = 'user_region_migration_triggered',
  users_bulk_created = 'users_bulk_created',
  users_bulk_identity_updated = 'users_bulk_identity_updated',
  user_invitation_link_viewed = 'user_invitation_link_viewed',
  users_bulk_looked_up = 'users_bulk_looked_up',
  user_onboarding_email_sent = 'user_onboarding_email_sent',
  session_backup_recovery_triggered = 'session_backup_recovery_triggered',
  session_uploaded_audio_retranscription_triggered = 'session_uploaded_audio_retranscription_triggered',
  session_hardware_audio_retranscription_triggered = 'session_hardware_audio_retranscription_triggered',
  session_backup_audio_retranscription_triggered = 'session_backup_audio_retranscription_triggered',
  team_created = 'team_created',
  team_updated = 'team_updated',
  team_deleted = 'team_deleted',
  team_members_added = 'team_members_added',
  team_member_role_updated = 'team_member_role_updated',
  team_member_removed = 'team_member_removed',
  team_member_moved = 'team_member_moved',
  team_invitations_resent = 'team_invitations_resent',
  team_onboarding_email_sent = 'team_onboarding_email_sent',
  team_mfa_updated = 'team_mfa_updated',
  team_user_mapping_imported = 'team_user_mapping_imported',
  team_member_history_exported = 'team_member_history_exported',
  organization_created = 'organization_created',
  organization_updated = 'organization_updated',
  organization_deleted = 'organization_deleted',
  organization_teams_added = 'organization_teams_added',
  organization_team_removed = 'organization_team_removed',
  org_team_member_role_updated = 'org_team_member_role_updated',
  org_team_member_removed = 'org_team_member_removed',
  org_global_admins_added = 'org_global_admins_added',
  org_team_members_added = 'org_team_members_added',
  org_member_moved_between_teams = 'org_member_moved_between_teams',
  managed_user_rule_added = 'managed_user_rule_added',
  managed_user_rule_deleted = 'managed_user_rule_deleted',
  entitlement_type_created = 'entitlement_type_created',
  entitlement_type_updated = 'entitlement_type_updated',
  entitlement_type_deleted = 'entitlement_type_deleted',
  entitlement_assigned = 'entitlement_assigned',
  entitlement_updated = 'entitlement_updated',
  entitlement_deleted = 'entitlement_deleted',
  metered_billing_enrolled = 'metered_billing_enrolled',
  metered_billing_status_viewed = 'metered_billing_status_viewed',
  billing_subscription_synced = 'billing_subscription_synced',
  billing_stripe_customer_id_repaired = 'billing_stripe_customer_id_repaired',
  wallet_provisioned = 'wallet_provisioned',
  wallet_topped_up = 'wallet_topped_up',
  wallet_adjusted = 'wallet_adjusted',
  wallet_burn_run = 'wallet_burn_run',
  catalog_product_created = 'catalog_product_created',
  catalog_product_updated = 'catalog_product_updated',
  rate_card_created = 'rate_card_created',
  rate_card_version_published = 'rate_card_version_published',
  contract_created = 'contract_created',
  contract_updated = 'contract_updated',
  contract_archived = 'contract_archived',
  contract_rate_card_resynced = 'contract_rate_card_resynced',
  allowance_policy_created = 'allowance_policy_created',
  allowance_policy_updated = 'allowance_policy_updated',
  allowance_policy_enabled = 'allowance_policy_enabled',
  allowance_policy_disabled = 'allowance_policy_disabled',
  agent_run_viewed = 'agent_run_viewed',
  agent_run_attachment_downloaded = 'agent_run_attachment_downloaded',
  agent_runs_listed = 'agent_runs_listed',
  agent_config_runs_listed = 'agent_config_runs_listed',
  agent_run_cancelled = 'agent_run_cancelled',
  agent_run_cancellation_failed = 'agent_run_cancellation_failed',
  agent_turn_cancelled = 'agent_turn_cancelled',
  agent_turn_cancellation_failed = 'agent_turn_cancellation_failed',
  agent_run_agent_events_stream_opened = 'agent_run_agent_events_stream_opened',
  agent_run_remote_tool_result_submitted = 'agent_run_remote_tool_result_submitted',
  agent_run_file_write_dispatched = 'agent_run_file_write_dispatched',
  agent_run_file_write_confirmed = 'agent_run_file_write_confirmed',
  agent_run_desktop_target_resolved = 'agent_run_desktop_target_resolved',
  agent_schedule_viewed = 'agent_schedule_viewed',
  agent_schedules_listed = 'agent_schedules_listed',
  approval_resolved = 'approval_resolved',
  wait_resolved = 'wait_resolved',
  inbox_bulk_resolve = 'inbox_bulk_resolve',
  session_audio_files_accessed = 'session_audio_files_accessed',
  session_audio_chunks_accessed = 'session_audio_chunks_accessed',
  dictation_logs_accessed = 'dictation_logs_accessed',
  rpa_recording_artifact_previewed = 'rpa_recording_artifact_previewed',
  rpa_recording_artifact_download_url_created = 'rpa_recording_artifact_download_url_created',
  rpa_ax_debug_capture_download_url_created = 'rpa_ax_debug_capture_download_url_created',
  rpa_ax_debug_captures_listed = 'rpa_ax_debug_captures_listed',
  advertiser_created = 'advertiser_created',
  advertiser_updated = 'advertiser_updated',
  advertiser_archived = 'advertiser_archived',
  advertiser_restored = 'advertiser_restored',
  ad_campaign_created = 'ad_campaign_created',
  ad_campaign_updated = 'ad_campaign_updated',
  ad_campaign_status_changed = 'ad_campaign_status_changed',
  ad_resource_created = 'ad_resource_created',
  ad_resource_updated = 'ad_resource_updated',
  ad_resource_approved = 'ad_resource_approved',
  ad_resource_archived = 'ad_resource_archived',
  ad_resource_restored = 'ad_resource_restored',
  workspace_created = 'workspace_created',
  workspace_updated = 'workspace_updated',
  workspace_migration_resource_tagged = 'workspace_migration_resource_tagged',
  monitored_document_changed = 'monitored_document_changed',
  template_migration_applied = 'template_migration_applied',
}
export enum InternalAdminRpaRecordingCrossUserSummaryState {
  processing = 'processing',
  ready = 'ready',
  failed = 'failed',
}
export enum InternalAdminRpaRecordingResponseState {
  processing = 'processing',
  ready = 'ready',
  failed = 'failed',
}
export enum InternalAdminRpaRecordingSummaryState {
  processing = 'processing',
  ready = 'ready',
  failed = 'failed',
}
export enum InternalAdminUserRoles {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  SUPPORT_LEAD = 'SUPPORT_LEAD',
  AUDIO_REVIEWER = 'AUDIO_REVIEWER',
  ADS_ADMIN = 'ADS_ADMIN',
}
export enum InternalOrderReasonCategory {
  replacement = 'replacement',
  comp_goodwill = 'comp_goodwill',
  staff_internal = 'staff_internal',
  manual_sale = 'manual_sale',
  demo_event = 'demo_event',
  other = 'other',
}
export enum JobStatus {
  pending = 'pending',
  extracting = 'extracting',
  chunking = 'chunking',
  embedding = 'embedding',
  completed = 'completed',
  failed = 'failed',
}
export enum JourneyStatus {
  TODO = 'TODO',
  DONE = 'DONE',
}
export enum KindeProfileStatus {
  new_profile = 'new_profile',
  existing_profile = 'existing_profile',
}
export enum KindeUserStatus {
  active = 'active',
  suspended = 'suspended',
  blocked = 'blocked',
}
export enum LLMConfigCache_strategy {
  off = 'off',
  system_and_tools = 'system_and_tools',
}
export enum LLMMessageRole {
  system = 'system',
  user = 'user',
  assistant = 'assistant',
  developer = 'developer',
}
export enum LLMModels {
  gpt_4o_2024_05_13 = 'gpt-4o-2024-05-13',
  gpt_4o_2024_08_06 = 'gpt-4o-2024-08-06',
  gpt_4_1_2025_04_14 = 'gpt-4.1-2025-04-14',
  o3_2025_04_16 = 'o3-2025-04-16',
  gpt_5_mini_2025_08_07 = 'gpt-5-mini-2025-08-07',
  gpt_5_1_2025_11_13 = 'gpt-5.1-2025-11-13',
  gpt_5_4_2026_03_05 = 'gpt-5.4-2026-03-05',
  gpt_5_5 = 'gpt-5.5',
  gpt_5_6_sol = 'gpt-5.6-sol',
  gpt_5_6_terra = 'gpt-5.6-terra',
  gpt_5_6_luna = 'gpt-5.6-luna',
  claude_3_opus_20240229 = 'claude-3-opus-20240229',
  claude_3_5_sonnet_20240620 = 'claude-3-5-sonnet-20240620',
  claude_3_5_sonnet_20241022 = 'claude-3-5-sonnet-20241022',
  claude_3_7_sonnet_20250219 = 'claude-3-7-sonnet-20250219',
  claude_sonnet_4_20250514 = 'claude-sonnet-4-20250514',
  claude_opus_4_20250514 = 'claude-opus-4-20250514',
  claude_sonnet_4_5_20250929 = 'claude-sonnet-4-5-20250929',
  claude_sonnet_4_6 = 'claude-sonnet-4-6',
  claude_sonnet_4_7 = 'claude-sonnet-4-7',
  claude_sonnet_5 = 'claude-sonnet-5',
  claude_opus_4_5_20251101 = 'claude-opus-4-5-20251101',
  claude_opus_4_6 = 'claude-opus-4-6',
  claude_opus_4_7 = 'claude-opus-4-7',
  claude_opus_4_8 = 'claude-opus-4-8',
  claude_opus_5 = 'claude-opus-5',
  claude_haiku_4_5_20251001 = 'claude-haiku-4-5-20251001',
  gemini_1_5_pro_002 = 'gemini-1.5-pro-002',
  gemini_1_5_flash_002 = 'gemini-1.5-flash-002',
  gemini_2_0_flash_001 = 'gemini-2.0-flash-001',
  gemini_2_0_flash_lite_001 = 'gemini-2.0-flash-lite-001',
  gemini_2_5_flash_preview_05_20 = 'gemini-2.5-flash-preview-05-20',
  gemini_2_5_flash = 'gemini-2.5-flash',
  gemini_2_5_flash_lite = 'gemini-2.5-flash-lite',
  gemini_flash_latest = 'gemini-flash-latest',
  gemini_2_5_pro_preview_06_05 = 'gemini-2.5-pro-preview-06-05',
  gemini_2_5_pro = 'gemini-2.5-pro',
  gemini_2_5_pro_payg = 'gemini-2.5-pro:payg',
  gemini_3_pro_preview_payg = 'gemini-3-pro-preview:payg',
  gemini_3_5_flash = 'gemini-3.5-flash',
  gemini_3_1_pro_preview_payg = 'gemini-3.1-pro-preview:payg',
  gemini_3_1_flash_lite = 'gemini-3.1-flash-lite',
  gemini_3_1_flash_lite_payg = 'gemini-3.1-flash-lite:payg',
  gcp_claude_3_5_sonnet_20240620 = 'gcp:claude-3-5-sonnet@20240620',
  gcp_claude_3_5_sonnet_20240620_payg = 'gcp:claude-3-5-sonnet@20240620:payg',
  gcp_claude_3_7_sonnet_20250219 = 'gcp:claude-3-7-sonnet@20250219',
  gcp_claude_3_7_sonnet_20250219_payg = 'gcp:claude-3-7-sonnet@20250219:payg',
  gcp_claude_sonnet_4_20250514 = 'gcp:claude-sonnet-4@20250514',
  gcp_claude_sonnet_4_20250514_payg = 'gcp:claude-sonnet-4@20250514:payg',
  gcp_claude_opus_4_20250514 = 'gcp:claude-opus-4@20250514',
  gcp_claude_opus_4_20250514_payg = 'gcp:claude-opus-4@20250514:payg',
  gcp_claude_sonnet_4_5_20250929 = 'gcp:claude-sonnet-4-5@20250929',
  gcp_claude_sonnet_4_5_20250929_payg = 'gcp:claude-sonnet-4-5@20250929:payg',
  gcp_claude_haiku_4_5_20251001_payg = 'gcp:claude-haiku-4-5@20251001:payg',
  gcp_claude_opus_4_5_20251101_payg = 'gcp:claude-opus-4-5@20251101:payg',
  gcp_claude_opus_4_6_payg = 'gcp:claude-opus-4-6:payg',
  gcp_claude_sonnet_4_6_payg = 'gcp:claude-sonnet-4-6:payg',
  gcp_claude_opus_4_8_payg = 'gcp:claude-opus-4-8:payg',
  TUNED_LLAMA_70B = 'TUNED_LLAMA_70B',
  TUNED_LLAMA_70B_MIXED_100K = 'TUNED_LLAMA_70B_MIXED_100K',
  TUNED_DEEPSEEK_V3_0324 = 'TUNED_DEEPSEEK_V3_0324',
  TUNED_DEEPSEEK_R1_0528 = 'TUNED_DEEPSEEK_R1_0528',
  TUNED_KIMI_K2_0905 = 'TUNED_KIMI_K2_0905',
  KIMI_K2P5 = 'KIMI_K2P5',
  KIMI_K2P6 = 'KIMI_K2P6',
  TUNED_EVIDENCE_V2 = 'TUNED_EVIDENCE_V2',
  TUNED_PRO_LEFT = 'TUNED_PRO_LEFT',
  TUNED_PRO_RIGHT = 'TUNED_PRO_RIGHT',
  HEIDI_TUNED_REASONING_1 = 'HEIDI_TUNED_REASONING_1',
  HEIDI_TUNED_REASONING_2 = 'HEIDI_TUNED_REASONING_2',
  HEIDI_TUNED_REASONING_3 = 'HEIDI_TUNED_REASONING_3',
  HEIDI_TUNED_DOC_GEN = 'HEIDI_TUNED_DOC_GEN',
  HEIDI_TUNED_DOC_GEN_V2_FIREWORKS = 'HEIDI_TUNED_DOC_GEN_V2_FIREWORKS',
  HEIDI_TUNED_DOC_GEN_V2_BASETEN = 'HEIDI_TUNED_DOC_GEN_V2_BASETEN',
  HEIDI_TUNED_DOC_GEN_MODAL = 'HEIDI_TUNED_DOC_GEN_MODAL',
  HEIDI_TUNED_NOTE_GEN_MODAL = 'HEIDI_TUNED_NOTE_GEN_MODAL',
  HEIDI_TUNED_A = 'HEIDI_TUNED_A',
  HEIDI_TUNED_B = 'HEIDI_TUNED_B',
  HEIDI_TUNED_C = 'HEIDI_TUNED_C',
  HEIDI_TUNED_D = 'HEIDI_TUNED_D',
  HEIDI_TUNED_E = 'HEIDI_TUNED_E',
  HEIDI_TUNED_F = 'HEIDI_TUNED_F',
  HEIDI_TUNED_G = 'HEIDI_TUNED_G',
  HEIDI_TUNED_H = 'HEIDI_TUNED_H',
  HEIDI_TUNED_I = 'HEIDI_TUNED_I',
  HEIDI_TUNED_J = 'HEIDI_TUNED_J',
  HEIDI_TUNED_K = 'HEIDI_TUNED_K',
  HEIDI_TUNED_L = 'HEIDI_TUNED_L',
  HEIDI_TUNED_M = 'HEIDI_TUNED_M',
  HEIDI_TUNED_N = 'HEIDI_TUNED_N',
  HEIDI_TUNED_O = 'HEIDI_TUNED_O',
  HEIDI_TUNED_P = 'HEIDI_TUNED_P',
  HEIDI_TUNED_Q = 'HEIDI_TUNED_Q',
  HEIDI_TUNED_R = 'HEIDI_TUNED_R',
  HEIDI_TUNED_S = 'HEIDI_TUNED_S',
  HEIDI_TUNED_T = 'HEIDI_TUNED_T',
  accounts_heidihealth_deployments_svxj49lo = 'accounts/heidihealth/deployments/svxj49lo',
  accounts_heidihealth_deployments_hlytu7a4 = 'accounts/heidihealth/deployments/hlytu7a4',
  TUNED_NOTE_QUALITY_CHECK = 'TUNED_NOTE_QUALITY_CHECK',
  PARSED_BASE = 'PARSED_BASE',
  Value6774747547169718272 = '6774747547169718272',
  grok_4_fast_non_reasoning = 'grok-4-fast-non-reasoning',
  TUNED_LLAMA_70B_BASETEN_BF16 = 'TUNED_LLAMA_70B_BASETEN_BF16',
  TUNED_LLAMA_70B_BASETEN_FP8 = 'TUNED_LLAMA_70B_BASETEN_FP8',
  TUNED_DEEPSEEK_V3_0324_BASETEN = 'TUNED_DEEPSEEK_V3_0324_BASETEN',
  TUNED_DEEPSEEK_V3_0324_BASETEN_NVFP4 = 'TUNED_DEEPSEEK_V3_0324_BASETEN_NVFP4',
  TUNED_QWEN_BASETEN_NVFP4 = 'TUNED_QWEN_BASETEN_NVFP4',
  TUNED_GLM_5_2_BASETEN = 'TUNED_GLM_5_2_BASETEN',
  TUNED_PRO_LEFT_BASETEN = 'TUNED_PRO_LEFT_BASETEN',
  TUNED_PRO_RIGHT_BASETEN = 'TUNED_PRO_RIGHT_BASETEN',
  DEEPSEEK_V4_FLASH_0731_BASETEN = 'DEEPSEEK_V4_FLASH_0731_BASETEN',
}
export enum LLMTask {
  generate_ai_command = 'generate_ai_command',
  other = 'other',
  core = 'core',
  evaluate = 'evaluate',
  template_builder = 'template_builder',
  evidence_chat = 'evidence_chat',
}
export enum LLMTaskName {
  note_generation = 'note generation',
  doc_generation = 'doc generation',
  template_builder = 'template builder',
  template_builder_initial_structure_generation = 'template builder_initial_structure_generation',
  template_builder_create_from_chat = 'template builder_create_from_chat',
  template_builder_create_from_note = 'template builder_create_from_note',
  template_builder_suggestion = 'template builder_suggestion',
  template_builder_create_from_file = 'template builder_create_from_file',
  template_builder_create_from_existing_template = 'template builder_create_from_existing_template',
  template_builder_deidentify_example_note = 'template builder_deidentify_example_note',
  template_builder_generate_example_note = 'template builder_generate_example_note',
  template_builder_generate_example_note_public = 'template builder_generate_example_note_public',
  template_builder_update_example_via_chat = 'template builder_update_example_via_chat',
  template_builder_generate_version_metadata = 'template builder_generate_version_metadata',
  template_builder_generate_template_category = 'template builder_generate_template_category',
  template_builder_generate_transcript = 'template builder_generate_transcript',
  template_builder_generate_title = 'template builder_generate_title',
  evidence_chat_suggestion = 'evidence_chat_suggestion',
  entity_extraction = 'entity extraction',
  entity_verification = 'entity verification',
  anacc_assessment = 'anacc assessment',
  mdc_classification = 'mdc classification',
  profile_transcript_ehr_match = 'profile transcript ehr match',
  profile_clinical_comparison = 'profile clinical comparison',
  personalisation_note_suggestion = 'personalisation note suggestion',
}
export enum LanguageCode {
  ar_SA = 'ar-SA',
  ar_AE = 'ar-AE',
  auto = 'auto',
  bg = 'bg',
  ca = 'ca',
  zh = 'zh',
  zh_Hant = 'zh-Hant',
  zh_HK = 'zh-HK',
  cs = 'cs',
  da = 'da',
  da_DK = 'da-DK',
  nl = 'nl',
  en = 'en',
  en_US = 'en-US',
  en_AU = 'en-AU',
  en_GB = 'en-GB',
  en_NZ = 'en-NZ',
  en_IN = 'en-IN',
  et = 'et',
  fi = 'fi',
  nl_BE = 'nl-BE',
  fr = 'fr',
  fr_CA = 'fr-CA',
  de = 'de',
  de_CH = 'de-CH',
  el = 'el',
  hi = 'hi',
  hi_Latn = 'hi-Latn',
  hu = 'hu',
  id = 'id',
  it = 'it',
  ja = 'ja',
  ko = 'ko',
  ko_KR = 'ko-KR',
  lv = 'lv',
  lt = 'lt',
  ms = 'ms',
  no = 'no',
  pl = 'pl',
  pt = 'pt',
  pt_BR = 'pt-BR',
  ro = 'ro',
  ru = 'ru',
  sk = 'sk',
  es = 'es',
  es_419 = 'es-419',
  sv = 'sv',
  sv_SE = 'sv-SE',
  th = 'th',
  th_TH = 'th-TH',
  tr = 'tr',
  uk = 'uk',
  vi = 'vi',
  multi = 'multi',
  ar = 'ar',
  bn = 'bn',
  hr = 'hr',
  iw = 'iw',
  sr = 'sr',
  sl = 'sl',
  sw = 'sw',
  af = 'af',
  am = 'am',
  as = 'as',
  az = 'az',
  be = 'be',
  bs = 'bs',
  ceb = 'ceb',
  co = 'co',
  cy = 'cy',
  dv = 'dv',
  eo = 'eo',
  eu = 'eu',
  fa = 'fa',
  fil = 'fil',
  fy = 'fy',
  ga = 'ga',
  gd = 'gd',
  gl = 'gl',
  gu = 'gu',
  ha = 'ha',
  haw = 'haw',
  hmn = 'hmn',
  ht = 'ht',
  hy = 'hy',
  ig = 'ig',
  is = 'is',
  jv = 'jv',
  ka = 'ka',
  kk = 'kk',
  km = 'km',
  kn = 'kn',
  kri = 'kri',
  ku = 'ku',
  ky = 'ky',
  la = 'la',
  lb = 'lb',
  lo = 'lo',
  mg = 'mg',
  mi = 'mi',
  mk = 'mk',
  ml = 'ml',
  mn = 'mn',
  mni_Mtei = 'mni-Mtei',
  mr = 'mr',
  mt = 'mt',
  my = 'my',
  ne = 'ne',
  ny = 'ny',
  or = 'or',
  pa = 'pa',
  ps = 'ps',
  sd = 'sd',
  si = 'si',
  sm = 'sm',
  sn = 'sn',
  so = 'so',
  sq = 'sq',
  st = 'st',
  su = 'su',
  ta = 'ta',
  te = 'te',
  to = 'to',
  tg = 'tg',
  ug = 'ug',
  ur = 'ur',
  uz = 'uz',
  xh = 'xh',
  yi = 'yi',
  yo = 'yo',
  zu = 'zu',
  tkl = 'tkl',
  tvl = 'tvl',
  rar = 'rar',
  fij = 'fij',
  hif = 'hif',
  rtm = 'rtm',
}
export enum LastMessageViewDirection {
  inbound = 'inbound',
  outbound = 'outbound',
}
export enum LastMessageViewSender_type {
  ai = 'ai',
  staff = 'staff',
  patient = 'patient',
  system = 'system',
}
export enum LatestRunSummaryResponseStatus {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum LeaderboardPeriodType {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  all_time = 'all_time',
}
export enum LeaderboardType {
  evidence_queries = 'evidence_queries',
  referrals = 'referrals',
}
export enum LeaderboardVisibility {
  pseudonym = 'pseudonym',
  opt_out = 'opt_out',
  name_only = 'name_only',
  name_and_clinic = 'name_and_clinic',
}
export enum LetterAttachmentMimeType {
  application_pdf = 'application/pdf',
}
export enum LetterContentSnapshotTimelineEventResponseType {
  content_snapshot = 'content_snapshot',
}
export enum LetterContentType {
  MARKDOWN = 'MARKDOWN',
  HTML = 'HTML',
}
export enum LetterDeliveryStatus {
  SENT = 'SENT',
  PARTIALLY_SENT = 'PARTIALLY_SENT',
  FAILED = 'FAILED',
}
export enum LetterDirectoryRecipientType {
  directory = 'directory',
}
export enum LetterEditableStatus {
  FREE = 'FREE',
  LOCKED = 'LOCKED',
}
export enum LetterElectronicallySignedSignatureType {
  electronically_signed = 'electronically_signed',
}
export enum LetterEmailRecipientType {
  email = 'email',
}
export enum LetterFaxRecipientType {
  fax = 'fax',
}
export enum LetterSealedMessageDeliveryRecipientType {
  sealed_message_delivery = 'sealed_message_delivery',
}
export enum LetterSendRecipientDeliveryStatus {
  SENT = 'SENT',
  FAILED = 'FAILED',
  NOT_ATTEMPTED = 'NOT_ATTEMPTED',
}
export enum LetterSendRecipientRole {
  PRIMARY = 'PRIMARY',
  COPY = 'COPY',
}
export enum LetterSendTimelineEventResponseType {
  letter_send = 'letter_send',
}
export enum LetterSignatureType {
  electronically_signed = 'electronically_signed',
}
export enum LetterheadStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
export enum LevelOfDetail {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}
export enum LimitAssignmentResponseScope_type {
  user = 'user',
  organization = 'organization',
  global = 'global',
}
export enum LimitAssignmentResponseMode {
  enroll = 'enroll',
  exclude = 'exclude',
}
export enum LimitResponsePeriod {
  weekly = 'weekly',
  monthly = 'monthly',
}
export enum LimitResponseEnforcement_mode {
  hard_cap = 'hard_cap',
  metered_overage = 'metered_overage',
}
export enum LinkShareRecipientStatus {
  active = 'active',
  revoked = 'revoked',
}
export enum LinkShareTTL {
  Value1h = '1h',
  Value24h = '24h',
  Value7d = '7d',
  Value14d = '14d',
  Value30d = '30d',
}
export enum LinkType {
  replaced_by = 'replaced-by',
  replaces = 'replaces',
  refer = 'refer',
  seealso = 'seealso',
}
export enum ListMode {
  working = 'working',
  snapshot = 'snapshot',
  changes = 'changes',
}
export enum LiveRecordingStatus {
  complete = 'complete',
  in_progress = 'in_progress',
}
export enum LocalStorageChatMessageRequestRole {
  user = 'user',
  assistant = 'assistant',
}
export enum LocationMode {
  instance = 'instance',
  kind = 'kind',
}
export enum LocationStatus {
  active = 'active',
  suspended = 'suspended',
  inactive = 'inactive',
}
export enum LoginFromNewDeviceResponseStatus {
  sent = 'sent',
  skipped_flag_off = 'skipped_flag_off',
  skipped_no_recipient = 'skipped_no_recipient',
}
export enum LogoutJobStatus {
  pending = 'pending',
  running = 'running',
  completed = 'completed',
  partial_failure = 'partial_failure',
  interrupted = 'interrupted',
}
export enum LoincDocumentCategoryClassCode {
  Value11502_2 = '11502-2',
  Value11369_6 = '11369-6',
  Value11485_0 = '11485-0',
  Value11486_8 = '11486-8',
  Value11488_4 = '11488-4',
  Value11506_3 = '11506-3',
  Value11543_6 = '11543-6',
  Value15508_5 = '15508-5',
  Value18726_0 = '18726-0',
  Value18761_7 = '18761-7',
  Value18842_5 = '18842-5',
  Value26436_6 = '26436-6',
  Value26441_6 = '26441-6',
  Value26442_4 = '26442-4',
  Value27895_2 = '27895-2',
  Value27896_0 = '27896-0',
  Value27897_8 = '27897-8',
  Value27898_6 = '27898-6',
  Value28570_0 = '28570-0',
  Value28619_5 = '28619-5',
  Value28634_4 = '28634-4',
  Value29749_9 = '29749-9',
  Value29750_7 = '29750-7',
  Value29751_5 = '29751-5',
  Value29752_3 = '29752-3',
  Value34109_9 = '34109-9',
  Value34117_2 = '34117-2',
  Value34121_4 = '34121-4',
  Value34122_2 = '34122-2',
  Value34133_9 = '34133-9',
  Value34140_4 = '34140-4',
  Value34748_4 = '34748-4',
  Value34775_7 = '34775-7',
  Value47039_3 = '47039-3',
  Value47042_7 = '47042-7',
  Value47045_0 = '47045-0',
  Value47046_8 = '47046-8',
  Value47049_2 = '47049-2',
  Value57017_6 = '57017-6',
  Value57016_8 = '57016-8',
  Value56445_0 = '56445-0',
  Value53576_5 = '53576-5',
  Value56447_6 = '56447-6',
  Value18748_4 = '18748-4',
  Value11504_8 = '11504-8',
  Value57133_1 = '57133-1',
  Value51848_0 = '51848-0',
}
export enum MFAMethod {
  MFA_SMS_EMAIL = 'MFA_SMS_EMAIL',
  MFA_SMS = 'MFA_SMS',
}
export enum MFAScope {
  USER = 'USER',
  TEAM = 'TEAM',
  REGION = 'REGION',
}
export enum MFASetBY {
  USER = 'USER',
  TEAM_ADMIN = 'TEAM_ADMIN',
  HEIDI_ADMIN = 'HEIDI_ADMIN',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  REGULATION = 'REGULATION',
}
export enum MKCustomTemplateRequestStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
}
export enum MatchConfidence {
  definite = 'definite',
  probable = 'probable',
  possible = 'possible',
}
export enum MatchType {
  profile_link = 'profile_link',
  email = 'email',
  namePlusdob = 'name+dob',
  dob_name = 'dob_name',
  birth_date = 'birth_date',
  last_name = 'last_name',
}
export enum MdmComplexityLevel {
  straightforward = 'straightforward',
  low = 'low',
  moderate = 'moderate',
  high = 'high',
}
export enum MedicationType {
  medication = 'medication',
}
export enum MedicationRequestIntent {
  proposal = 'proposal',
  plan = 'plan',
  order = 'order',
  original_order = 'original-order',
  reflex_order = 'reflex-order',
  filler_order = 'filler-order',
  instance_order = 'instance-order',
  option = 'option',
}
export enum MedicationRequestPriority {
  routine = 'routine',
  urgent = 'urgent',
  asap = 'asap',
  stat = 'stat',
}
export enum MedicationRequestStatus {
  active = 'active',
  on_hold = 'on-hold',
  cancelled = 'cancelled',
  completed = 'completed',
  entered_in_error = 'entered-in-error',
  stopped = 'stopped',
  draft = 'draft',
  unknown = 'unknown',
}
export enum MedicationStatementStatus {
  active = 'active',
  completed = 'completed',
  entered_in_error = 'entered-in-error',
  intended = 'intended',
  stopped = 'stopped',
  on_hold = 'on-hold',
  unknown = 'unknown',
  not_taken = 'not-taken',
}
export enum MemoryType {
  top_style_edit = 'top_style_edit',
  word_replacement_preferences = 'word_replacement_preferences',
  scoped_word_replacements = 'scoped_word_replacements',
  agent_extracted_word_substitutions = 'agent_extracted_word_substitutions',
}
export enum MergePreflightResponseTarget_workspace_statusAnyOf0 {
  resolvable = 'resolvable',
  missing_provisionable = 'missing_provisionable',
  missing_blocked = 'missing_blocked',
}
export enum MessageSource {
  live = 'live',
  bulk_upload = 'bulk_upload',
  onboarding = 'onboarding',
}
export enum MessageViewDirection {
  inbound = 'inbound',
  outbound = 'outbound',
}
export enum MessageViewSender_type {
  ai = 'ai',
  staff = 'staff',
  patient = 'patient',
  system = 'system',
}
export enum MessageViewChannel {
  sms = 'sms',
  voice = 'voice',
  email = 'email',
}
export enum MeterMetadataKind {
  meter = 'meter',
}
export enum MeterMetadataBilling_periodAnyOf0 {
  monthly = 'monthly',
  yearly = 'yearly',
}
export enum MeteredBillingProvisioningResponseScope {
  user = 'user',
  organization = 'organization',
  workspace = 'workspace',
}
export enum MeteredProvisioningStatus {
  provisioned = 'provisioned',
  already_provisioned = 'already_provisioned',
  failed = 'failed',
  not_provisioned = 'not_provisioned',
  skipped_no_subscription = 'skipped_no_subscription',
  skipped_not_billable = 'skipped_not_billable',
  skipped_currency_mismatch = 'skipped_currency_mismatch',
}
export enum MetricConfigSort_order {
  desc = 'desc',
  asc = 'asc',
}
export enum MfaEnrolledResponseStatus {
  sent = 'sent',
  skipped_flag_off = 'skipped_flag_off',
  skipped_no_recipient = 'skipped_no_recipient',
}
export enum MfaUnenrolledResponseStatus {
  sent = 'sent',
  skipped_flag_off = 'skipped_flag_off',
  skipped_no_recipient = 'skipped_no_recipient',
}
export enum MobileProvider {
  haiku = 'haiku',
  nebula = 'nebula',
}
export enum ModalId {
  FREE_TRIAL = 'FREE_TRIAL',
  PRACTICE_TRIAL = 'PRACTICE_TRIAL',
  PRACTICE_INVITE_TEAM = 'PRACTICE_INVITE_TEAM',
  TEMPLATE_STARTER_PACK = 'TEMPLATE_STARTER_PACK',
  AFFILIATE_LINK = 'AFFILIATE_LINK',
  PINNING_TOOLTIP = 'PINNING_TOOLTIP',
  DISCOVER_UPLOAD_SCHEDULE = 'DISCOVER_UPLOAD_SCHEDULE',
  TEMPLATE_BUILDER_ONBOARDING = 'TEMPLATE_BUILDER_ONBOARDING',
  TEMPLATE_BUILDER_FILE_UPLOAD_ONBOARDING = 'TEMPLATE_BUILDER_FILE_UPLOAD_ONBOARDING',
  CUSTOM_TEMPLATE_ONBOARDING = 'CUSTOM_TEMPLATE_ONBOARDING',
  USER_SELF_ONBOARDING = 'USER_SELF_ONBOARDING',
  TEMPLATE_BUILDER_EXAMPLE_HELPER = 'TEMPLATE_BUILDER_EXAMPLE_HELPER',
  CLINICIAN_TRIAL = 'CLINICIAN_TRIAL',
  EVIDENCE_PRO_TRIAL = 'EVIDENCE_PRO_TRIAL',
  SCRIBE_ONBOARDING = 'SCRIBE_ONBOARDING',
  SCRIBE_ONBOARDING_DICTATE = 'SCRIBE_ONBOARDING_DICTATE',
  EVIDENCE_DISCOVERY = 'EVIDENCE_DISCOVERY',
  TRIAL_END_PLAN_SELECTION = 'TRIAL_END_PLAN_SELECTION',
  TRIAL_ENDING_SOON_REMINDER = 'TRIAL_ENDING_SOON_REMINDER',
  NINETY_DAY_TRIAL_ENDING_SOON_REMINDER_POPUP = 'NINETY_DAY_TRIAL_ENDING_SOON_REMINDER_POPUP',
  NEW_PRACTICE_TRIAL = 'NEW_PRACTICE_TRIAL',
  DICTATION_ONBOARDING = 'DICTATION_ONBOARDING',
  UNIVERSAL_DICTATION_ONBOARDING_MODAL = 'UNIVERSAL_DICTATION_ONBOARDING_MODAL',
  CURSOR_DICTATION_ONBOARDING_MODAL = 'CURSOR_DICTATION_ONBOARDING_MODAL',
  DICTATE_ONBOARDING_TOUR_MODAL = 'DICTATE_ONBOARDING_TOUR_MODAL',
  DICTATE_PAGE_TOUR_BANNER = 'DICTATE_PAGE_TOUR_BANNER',
  MENU_COACHMARK_TOUR = 'MENU_COACHMARK_TOUR',
  MENU_PIN_REMINDER = 'MENU_PIN_REMINDER',
  DEMO_COACHMARK_TOUR = 'DEMO_COACHMARK_TOUR',
  SOURCE_RECOMMENDATION_BANNER = 'SOURCE_RECOMMENDATION_BANNER',
  SOURCE_RECOMMENDATION_APPLY_BANNER = 'SOURCE_RECOMMENDATION_APPLY_BANNER',
  EVIDENCE_SUMMARY_SUGGESTION = 'EVIDENCE_SUMMARY_SUGGESTION',
  DARK_MODE_SPOTLIGHT = 'DARK_MODE_SPOTLIGHT',
  FILE_UPLOAD_SPOTLIGHT = 'FILE_UPLOAD_SPOTLIGHT',
  SHARE_SESSION_INTRO_SPOTLIGHT = 'SHARE_SESSION_INTRO_SPOTLIGHT',
  SHARE_SESSION_ANNOUNCE_SPOTLIGHT = 'SHARE_SESSION_ANNOUNCE_SPOTLIGHT',
  INTENDS_TO_AUTO_LINK_SESSIONS = 'INTENDS_TO_AUTO_LINK_SESSIONS',
  LINKED_SESSIONS_CONFIRMATION_SPOTLIGHT = 'LINKED_SESSIONS_CONFIRMATION_SPOTLIGHT',
  INTENDS_TO_AUTO_EXTRACT_PATIENT_CONTEXT = 'INTENDS_TO_AUTO_EXTRACT_PATIENT_CONTEXT',
  SESSIONLESS_EVIDENCE_AWARENESS = 'SESSIONLESS_EVIDENCE_AWARENESS',
  EVIDENCE_DOCUMENT_SUGGESTION_BANNER = 'EVIDENCE_DOCUMENT_SUGGESTION_BANNER',
  HEIDI_VERIFY_SPOTLIGHT = 'HEIDI_VERIFY_SPOTLIGHT',
  EVIDENCE_DOCUMENT_EXPORT_BANNER = 'EVIDENCE_DOCUMENT_EXPORT_BANNER',
  EVIDENCE_POST_UPGRADE_WELCOME_POPUP = 'EVIDENCE_POST_UPGRADE_WELCOME_POPUP',
  NINETY_DAY_TRIAL_END_MODAL = 'NINETY_DAY_TRIAL_END_MODAL',
  NINETY_DAY_TRIAL_END_DISCREET_POPUP = 'NINETY_DAY_TRIAL_END_DISCREET_POPUP',
  TRIAL_EXTENSION_AWARENESS_CARD = 'TRIAL_EXTENSION_AWARENESS_CARD',
  SCRIBE_LAYOUT_V2_INVITE = 'SCRIBE_LAYOUT_V2_INVITE',
  SCRIBE_LAYOUT_V2_TOUR = 'SCRIBE_LAYOUT_V2_TOUR',
  CUSTOM_AUDIENCE_SCRIBE_LAYOUT_V2_TOUR_BANNER = 'CUSTOM_AUDIENCE_SCRIBE_LAYOUT_V2_TOUR_BANNER',
  T5_CUSTOM_AUDIENCE_SCRIBE_LAYOUT_CSAT_POPOVER = 'T5_CUSTOM_AUDIENCE_SCRIBE_LAYOUT_CSAT_POPOVER',
  REMOTE_INTRO_PROMO = 'REMOTE_INTRO_PROMO',
  EVIDENCE_REMINDER_SPOTLIGHT = 'EVIDENCE_REMINDER_SPOTLIGHT',
  PATIENT_LIST_INTRODUCTION = 'PATIENT_LIST_INTRODUCTION',
  PATIENT_LIST_NAV_SPOTLIGHT = 'PATIENT_LIST_NAV_SPOTLIGHT',
  DICTATION_LOGS_SPOTLIGHT = 'DICTATION_LOGS_SPOTLIGHT',
  PRECHART_BETA_INTRO_MODAL = 'PRECHART_BETA_INTRO_MODAL',
  PRECHART_BETA_TAB_SPOTLIGHT = 'PRECHART_BETA_TAB_SPOTLIGHT',
  SCRIBE_CROSS_SELL_SPOTLIGHT = 'SCRIBE_CROSS_SELL_SPOTLIGHT',
  NEW_SESSION_UPLOAD_SPOTLIGHT = 'NEW_SESSION_UPLOAD_SPOTLIGHT',
  TASKS_NAV_INTRO_SPOTLIGHT = 'TASKS_NAV_INTRO_SPOTLIGHT',
  DICTATION_NEW_IN_RELEASE_CARD = 'DICTATION_NEW_IN_RELEASE_CARD',
  ACTION_COPY_SETTINGS_COACHMARK = 'ACTION_COPY_SETTINGS_COACHMARK',
  ACTION_COPY_FORMATTING_LOSS_POPOVER = 'ACTION_COPY_FORMATTING_LOSS_POPOVER',
  ACTION_DICTATED_GENERAL_REENGAGEMENT_POPOVER = 'ACTION_DICTATED_GENERAL_REENGAGEMENT_POPOVER',
  ACTION_DICTAPHONE_CONNECTED_DEVICE_SETUP_POPOVER = 'ACTION_DICTAPHONE_CONNECTED_DEVICE_SETUP_POPOVER',
  ACTION_DICTAPHONE_CONNECTED_DEVICE_SETUP_V2_POPOVER = 'ACTION_DICTAPHONE_CONNECTED_DEVICE_SETUP_V2_POPOVER',
  SESSION_MERGE_ONBOARDING = 'SESSION_MERGE_ONBOARDING',
  SESSION_MERGE_ONBOARDING_SETTINGS = 'SESSION_MERGE_ONBOARDING_SETTINGS',
  SESSION_MERGE_EDUCATION = 'SESSION_MERGE_EDUCATION',
  SESSION_MERGE_TAB_COACHMARK = 'SESSION_MERGE_TAB_COACHMARK',
  PATIENT_SUMMARY_TAB_COACHMARK = 'PATIENT_SUMMARY_TAB_COACHMARK',
  T3_CUSTOM_AUDIENCE_CLINICIAN_MAX_CREDIT_USAGE_POPOVER = 'T3_CUSTOM_AUDIENCE_CLINICIAN_MAX_CREDIT_USAGE_POPOVER',
  T4_CUSTOM_AUDIENCE_LEARNINGS_APPLIED_POPOVER = 'T4_CUSTOM_AUDIENCE_LEARNINGS_APPLIED_POPOVER',
  CUSTOM_AUDIENCE_HEALTH_NZ_MIGRATION_MODAL = 'CUSTOM_AUDIENCE_HEALTH_NZ_MIGRATION_MODAL',
  CUSTOM_AUDIENCE_HCP_VERIFICATION_REMINDER_MODAL = 'CUSTOM_AUDIENCE_HCP_VERIFICATION_REMINDER_MODAL',
  T4_CUSTOM_AUDIENCE_ADAPTIVE_LEARNING_OPTIN_POPOVER = 'T4_CUSTOM_AUDIENCE_ADAPTIVE_LEARNING_OPTIN_POPOVER',
  T4_CUSTOM_AUDIENCE_ROUTINES_ONBOARDING_SPOTLIGHT = 'T4_CUSTOM_AUDIENCE_ROUTINES_ONBOARDING_SPOTLIGHT',
  T4_CUSTOM_AUDIENCE_HEIDI_2_OPT_IN_BANNER = 'T4_CUSTOM_AUDIENCE_HEIDI_2_OPT_IN_BANNER',
  T4_CUSTOM_AUDIENCE_HEIDI_2_HOME_CHANGEBOARDING_BANNER = 'T4_CUSTOM_AUDIENCE_HEIDI_2_HOME_CHANGEBOARDING_BANNER',
  T4_CUSTOM_AUDIENCE_HEIDI_2_REQUEST_ACCESS_BANNER = 'T4_CUSTOM_AUDIENCE_HEIDI_2_REQUEST_ACCESS_BANNER',
  T4_TEAM_ADMINS_HEIDI_2_CONFIRM_ACCESS_MODAL = 'T4_TEAM_ADMINS_HEIDI_2_CONFIRM_ACCESS_MODAL',
  T1_NETWORK_FIREWALL_ERROR_MODAL = 'T1_NETWORK_FIREWALL_ERROR_MODAL',
  GETTING_STARTED_TUTORIAL_WIDGET = 'GETTING_STARTED_TUTORIAL_WIDGET',
  T0_TEAM_MEMBER_REQUIRE_SPECIALTY_MODAL = 'T0_TEAM_MEMBER_REQUIRE_SPECIALTY_MODAL',
}
export enum ModalViewAction {
  dismiss = 'dismiss',
  engage = 'engage',
}
export enum NarrativeStatus {
  generated = 'generated',
  extensions = 'extensions',
  additional = 'additional',
  empty = 'empty',
}
export enum NebulaAudioChunkReadyEnvelopeType {
  com_epic_ambient_audiochunkready = 'com.epic.ambient.audiochunkready',
}
export enum NebulaAudioReadyEnvelopeType {
  com_epic_ambient_audioready = 'com.epic.ambient.audioready',
}
export enum NeverEndKind {
  never = 'never',
}
/**
 * NuhFeedbackArea
 * @description Areas scored by the NUH post-session feedback form, in template order.
 *
 *     Values match the ids the form already ships with in the frontend's
 *     ``features/chat/constants/nuhSessionFeedback.ts``, so the question set has
 *     one spelling on both sides of the wire.
 */
export enum NuhFeedbackArea {
  ACCURACY = 'accuracy',
  CLINICAL_SAFETY = 'clinical_safety',
  COMPLETENESS = 'completeness',
  USABILITY_AND_WORKFLOW_FIT = 'usability_and_workflow_fit',
  PATIENT_AND_LANGUAGE_SUITABILITY = 'patient_and_language_suitability',
  OVERALL_CONFIDENCE = 'overall_confidence',
}
/**
 * NuhFeedbackPrompt
 * @description The NUH form's free-text "Top 3 feedback points".
 */
export enum NuhFeedbackPrompt {
  WORKED_WELL = 'worked_well',
  NEEDS_IMPROVEMENT = 'needs_improvement',
  CONCERNS = 'concerns',
}
/**
 * NuhFeedbackStatus
 * @description Whether the rater has finished the NUH post-session form.
 *
 *     ``draft`` is an in-progress save and may omit scores. ``submitted`` is the
 *     rater's explicit "I'm done" signal; the evaluation PATCH requires every
 *     current area to be scored. Completeness is not inferred from the scores
 *     being filled in: a rater can score every area and still be writing comments.
 */
export enum NuhFeedbackStatus {
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
}
export enum NoMetadataKind {
  none = 'none',
}
export enum NotePages {
  REVIEW_NOTE = 'REVIEW_NOTE',
  HELP_HEIDI = 'HELP_HEIDI',
  ASK_HEIDI_FOR_HELP = 'ASK_HEIDI_FOR_HELP',
}
export enum NoteStructure {
  HOPC = 'HOPC',
  HOPC_ISSUES_LIST_ = 'HOPC (ISSUES LIST)',
  SOAP = 'SOAP',
  SOAP_ISSUES_LIST_ = 'SOAP (ISSUES LIST)',
  ISSUES_LIST = 'ISSUES LIST',
  MY_STRUCTURE = 'MY_STRUCTURE',
  DEFAULT = 'DEFAULT',
}
export enum NotificationChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  INMAIL = 'INMAIL',
}
export enum NotificationGroup {
  SESSION = 'SESSION',
  TEMPLATE = 'TEMPLATE',
  TEAM = 'TEAM',
  BILLING = 'BILLING',
  GENERAL = 'GENERAL',
  TASK = 'TASK',
  INBOX = 'INBOX',
}
export enum NotificationStatus {
  UNREAD = 'UNREAD',
  READ = 'READ',
  FAILED = 'FAILED',
}
export enum ObservationCategory {
  social_history = 'social-history',
  vital_signs = 'vital-signs',
  imaging = 'imaging',
  laboratory = 'laboratory',
  procedure = 'procedure',
  survey = 'survey',
  exam = 'exam',
  therapy = 'therapy',
  activity = 'activity',
}
export enum ObservationStatus {
  registered = 'registered',
  preliminary = 'preliminary',
  final = 'final',
  amended = 'amended',
  corrected = 'corrected',
  cancelled = 'cancelled',
  entered_in_error = 'entered-in-error',
  unknown = 'unknown',
}
export enum OcrQualityResponseLabel {
  ok = 'ok',
  warning = 'warning',
  error = 'error',
}
export enum OnboardingOutcome {
  completed = 'completed',
  skipped = 'skipped',
  not_required = 'not_required',
}
export enum OnboardingSessionSortBy {
  created_at = 'created_at',
  updated_at = 'updated_at',
}
export enum OnboardingSessionStatus {
  in_progress = 'in_progress',
  expired = 'expired',
  completed = 'completed',
}
export enum OnboardingStatus {
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
}
export enum OnboardingTask {
  find_template = 'find_template',
  start_session = 'start_session',
  review_note = 'review_note',
  create_document = 'create_document',
  create_template = 'create_template',
}
export enum OrderType {
  genorder = 'genorder',
}
export enum OrderSource {
  stripe = 'stripe',
  hubspot = 'hubspot',
  internal_admin = 'internal_admin',
  internal_stock = 'internal_stock',
}
export enum OrderStatus {
  pending_payment = 'pending_payment',
  payment_expired = 'payment_expired',
  paid = 'paid',
  deal_closed_won = 'deal_closed_won',
  internal_order_created = 'internal_order_created',
  erp_order_created = 'erp_order_created',
  erp_order_failed = 'erp_order_failed',
  erp_order_prepared = 'erp_order_prepared',
  erp_order_shipped = 'erp_order_shipped',
  erp_order_canceled = 'erp_order_canceled',
  internal_stock_order = 'internal_stock_order',
}
export enum OrgAdminAuditEvent {
  org_admin_logout_everywhere = 'org_admin_logout_everywhere',
  org_admin_logout_everywhere_job_completed = 'org_admin_logout_everywhere_job_completed',
}
export enum OrganisationRole {
  INDIVIDUAL_CLINICIAN = 'INDIVIDUAL_CLINICIAN',
  LEAD = 'LEAD',
  EXECUTIVE_TEAM = 'EXECUTIVE_TEAM',
  OWNER_OR_PRACTICE_MANAGER = 'OWNER_OR_PRACTICE_MANAGER',
}
export enum OrganisationSize {
  JUST_ME = 'JUST_ME',
  TWO_TO_FIVE = 'TWO_TO_FIVE',
  SIX_TO_TWENTY = 'SIX_TO_TWENTY',
  TWENTY_ONE_TO_FIFTY = 'TWENTY_ONE_TO_FIFTY',
  FIFTY_ONE_PLUS = 'FIFTY_ONE_PLUS',
}
export enum OrganizationMemberOrdering {
  name = 'name',
  email = 'email',
  specialty = 'specialty',
  role = 'role',
  team = 'team',
}
export enum OrganizationOverrideTeamSettingField {
  require_patient_consent = 'require_patient_consent',
  custom_consent_text = 'custom_consent_text',
  require_review_confirmation = 'require_review_confirmation',
  mfa_info = 'mfa_info',
  session_retention_settings = 'session_retention_settings',
  patient_retention_settings = 'patient_retention_settings',
  transcript_retention_settings = 'transcript_retention_settings',
  disclaimer_footer = 'disclaimer_footer',
  is_pilot = 'is_pilot',
  session_configuration = 'session_configuration',
  hide_remember_consent_checkbox = 'hide_remember_consent_checkbox',
  team_evidence_settings = 'team_evidence_settings',
  disable_auto_extract = 'disable_auto_extract',
}
export enum OwnerType {
  USER = 'USER',
  TEAM = 'TEAM',
}
export enum ParticipantRequired {
  required = 'required',
  optional = 'optional',
  information_only = 'information-only',
}
export enum ParticipationStatus {
  accepted = 'accepted',
  declined = 'declined',
  tentative = 'tentative',
  needs_action = 'needs-action',
}
export enum PasswordChangedResponseStatus {
  sent = 'sent',
  skipped_flag_off = 'skipped_flag_off',
  skipped_no_recipient = 'skipped_no_recipient',
}
export enum PatchCardStatusSchemaStatus {
  surfaced = 'surfaced',
  dismissed = 'dismissed',
}
export enum PatchOp {
  add = 'add',
  replace = 'replace',
  remove = 'remove',
}
export enum PatientLinkStatus {
  manually_linked = 'manually_linked',
  auto_linked = 'auto_linked',
  pending_manual_link = 'pending_manual_link',
  pending_user_review = 'pending_user_review',
  user_reverted_session_merge = 'user_reverted_session_merge',
}
export enum PatientMatchViewConfidence {
  high = 'high',
  medium = 'medium',
  low = 'low',
}
export enum PatientProfileMatchableField {
  first_name = 'first_name',
  last_name = 'last_name',
  birth_date = 'birth_date',
  gender = 'gender',
  phone = 'phone',
  email = 'email',
  ehr_patient_id = 'ehr_patient_id',
  allergies = 'allergies',
  current_medications = 'current_medications',
  past_medical_history = 'past_medical_history',
  additional_context = 'additional_context',
}
export enum PatientProfileUpdateSource {
  ai_extraction = 'ai_extraction',
  manual_edit = 'manual_edit',
  ehr_integration = 'ehr_integration',
  system = 'system',
  agent_tool = 'agent_tool',
}
export enum PatientSource {
  EHR = 'EHR',
  HEIDI = 'HEIDI',
}
export enum PatientTranscriptMatchEntity_type {
  patient_profile = 'patient_profile',
}
export enum PatientType {
  new = 'new',
  returning = 'returning',
}
export enum PayloadConditionKind {
  payload = 'payload',
}
export enum PaymentVendor {
  stripe = 'stripe',
  revenuecat = 'revenuecat',
}
export enum PdfFieldType {
  Text = 'Text',
  Button = 'Button',
  CheckBox = 'CheckBox',
  ComboBox = 'ComboBox',
  ListBox = 'ListBox',
  RadioButton = 'RadioButton',
  Signature = 'Signature',
  Date = 'Date',
  Number = 'Number',
}
export enum PersonalizationCategory {
  language_tone = 'language_tone',
  syntax_grammar = 'syntax_grammar',
  content_phrasing = 'content_phrasing',
  medical_terms = 'medical_terms',
  format_layout = 'format_layout',
}
export enum PersonalizationProfileGeneratingStatus {
  pending = 'pending',
  completed = 'completed',
}
export enum PersonalizedEvidenceSuggestionCategory {
  research = 'research',
  planning = 'planning',
  documentation = 'documentation',
  reflection = 'reflection',
}
export enum PilotStatus {
  active = 'active',
  ended = 'ended',
}
export enum PinnedQuerySchemaOriginAnyOf0 {
  library = 'library',
  custom = 'custom',
}
export enum PostNoteQualityTask {
  create_note = 'create-note',
  add_context = 'add-context',
  customise = 'customise',
  ask_heidi = 'ask-heidi',
  replace_words = 'replace-words',
}
export enum PractitionerRoleInclude {
  PractitionerRole_endpoint = 'PractitionerRole:endpoint',
  PractitionerRole_practitioner = 'PractitionerRole:practitioner',
  PractitionerRole_organization = 'PractitionerRole:organization',
  PractitionerRole_location = 'PractitionerRole:location',
}
export enum PrechartFeedbackRating {
  positive = 'positive',
  negative = 'negative',
}
export enum ProcessStatus {
  INITIALIZED = 'INITIALIZED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
}
export enum ProductSubscriptionType {
  CLINICIAN = 'CLINICIAN',
  CLINICIAN_MAX = 'CLINICIAN_MAX',
  CLINICIAN_PLUS = 'CLINICIAN_PLUS',
  SCRIBE = 'SCRIBE',
  SCRIBE_PLUS = 'SCRIBE_PLUS',
  EVIDENCE = 'EVIDENCE',
  EVIDENCE_PLUS = 'EVIDENCE_PLUS',
  ENTERPRISE = 'ENTERPRISE',
  CLINICIAN_ENTERPRISE = 'CLINICIAN_ENTERPRISE',
  ADDON_INTEGRATION = 'ADDON_INTEGRATION',
  METERED = 'METERED',
}
export enum ProductType {
  scribe = 'scribe',
  evidence = 'evidence',
}
export enum ProjectDetailTool_profile {
  clinician_desktop = 'clinician_desktop',
  evidence_only = 'evidence_only',
}
export enum ProjectMessageRole {
  user = 'user',
  assistant = 'assistant',
}
export enum ProjectMessageBlockKind {
  text = 'text',
  thinking = 'thinking',
  tool_call = 'tool_call',
  tool_result = 'tool_result',
  attachment = 'attachment',
}
export enum ProjectMessageBlockAttachment_typeAnyOf0 {
  image = 'image',
  document = 'document',
  file = 'file',
}
export enum ProjectRunFlag {
  opus_4_8_fast = 'opus_4_8_fast',
}
export enum ProjectToolApprovalMode {
  auto = 'auto',
  manual = 'manual',
}
export enum PromptContextFailureRecordFailure_mode {
  required = 'required',
  best_effort = 'best_effort',
}
export enum PromptContextFailureRecordStatus {
  missing_context = 'missing_context',
  access_denied = 'access_denied',
  failed = 'failed',
}
export enum PromptVariableDefinitionKind {
  pure = 'pure',
  context_provider = 'context_provider',
}
export enum PromptVariableDefinitionFailure_mode {
  required = 'required',
  best_effort = 'best_effort',
}
export enum PromptVariableDefinitionData_classification {
  none = 'none',
  user = 'user',
  phi = 'phi',
}
export enum ProtocolModelStatus {
  draft = 'draft',
  published = 'published',
  superseded = 'superseded',
}
export enum ProtocolTestCaseModelExpect {
  fire = 'fire',
  no_fire = 'no_fire',
}
export enum ProviderRetirementResultProvider {
  identity_broker = 'identity_broker',
  auth0 = 'auth0',
  kinde = 'kinde',
}
export enum ProviderRetirementResultStatus {
  deleted = 'deleted',
  skipped = 'skipped',
}
export enum Providers {
  Deepgram = 'Deepgram',
  GCP = 'GCP',
  Whisper = 'Whisper',
  Gemini = 'Gemini',
  HF = 'HF',
  Fireworks = 'Fireworks',
  Baseten = 'Baseten',
  ElevenLabs = 'ElevenLabs',
  External = 'External',
}
export enum PublicDraftOrderStatus {
  pending_payment = 'pending_payment',
  paid = 'paid',
  payment_expired = 'payment_expired',
}
export enum PublicationStatus {
  draft = 'draft',
  active = 'active',
  retired = 'retired',
  unknown = 'unknown',
}
export enum QaResult {
  pass = 'pass',
  fail = 'fail',
}
export enum QuestionnaireItemEnableBehavior {
  all = 'all',
  any = 'any',
}
export enum QuestionnaireItemEnableWhenOperator {
  exists = 'exists',
  '=' = '=',
  '!=' = '!=',
  '>' = '>',
  '<' = '<',
  '>=' = '>=',
  '<=' = '<=',
}
export enum QuestionnaireItemType {
  group = 'group',
  display = 'display',
  boolean = 'boolean',
  decimal = 'decimal',
  integer = 'integer',
  date = 'date',
  dateTime = 'dateTime',
  time = 'time',
  string = 'string',
  text = 'text',
  url = 'url',
  choice = 'choice',
  open_choice = 'open-choice',
  attachment = 'attachment',
  reference = 'reference',
  quantity = 'quantity',
}
export enum QuestionnaireResponseStatus {
  in_progress = 'in-progress',
  completed = 'completed',
  amended = 'amended',
  entered_in_error = 'entered-in-error',
  stopped = 'stopped',
}
export enum QuestionnaireStatus {
  draft = 'draft',
  active = 'active',
  retired = 'retired',
  unknown = 'unknown',
}
export enum RateCardEntryResponseAggregation_mode {
  sum = 'sum',
  tally = 'tally',
}
export enum RateCardEntryResponseSum_fieldAnyOf0 {
  quantity = 'quantity',
  token_count = 'token_count',
}
export enum RebindUserEmailResponseStatus {
  completed = 'completed',
  unchanged = 'unchanged',
  user_not_found = 'user_not_found',
}
export enum RecordNotePushHintsRequestSource {
  screen_verified = 'screen_verified',
  clinician = 'clinician',
}
export enum RecordingIngestResponseStatus {
  ingested = 'ingested',
  already_ingested = 'already_ingested',
}
export enum RecordingMode {
  ACCURATE = 'ACCURATE',
  HANDS_FREE = 'HANDS_FREE',
}
export enum RecordingStatus {
  IDLE = 'IDLE',
  PAUSED = 'PAUSED',
  RECORDING = 'RECORDING',
}
export enum RecurrencePattern {
  none = 'none',
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  yearly = 'yearly',
}
export enum ReferralCampaign {
  evidence = 'evidence',
}
export enum Region {
  UK = 'UK',
  CA = 'CA',
  US = 'US',
  AU = 'AU',
  EU = 'EU',
  CH = 'CH',
  JP_AZ1 = 'JP-AZ1',
  AU_AZ1 = 'AU-AZ1',
  UAE_AZ1 = 'UAE-AZ1',
  US_AZ1 = 'US-AZ1',
  QAT_AZ1 = 'QAT-AZ1',
  SE_AZ1 = 'SE-AZ1',
}
export enum RemoteAppType {
  Remote = 'Remote',
}
export enum RepeatAiOutputResponseDecision {
  Continue = 'Continue',
  Do_not_continue = 'Do not continue',
  Escalate = 'Escalate',
  Requires_clinician_review = 'Requires clinician review',
}
export enum RepeatChatMessageResponseRole {
  assistant = 'assistant',
  patient = 'patient',
}
export enum RepeatReviewAiOutputViewDecision {
  Continue = 'Continue',
  Do_not_continue = 'Do not continue',
  Escalate = 'Escalate',
  Requires_clinician_review = 'Requires clinician review',
}
export enum RepeatReviewChatMessageViewRole {
  assistant = 'assistant',
  patient = 'patient',
}
export enum RepeatReviewViewStatus {
  pending_review = 'pending_review',
  processing = 'processing',
  approved = 'approved',
  blocked = 'blocked',
}
export enum RepeatScriptsRequestChannel {
  web = 'web',
  sms = 'sms',
  voice = 'voice',
  unknown = 'unknown',
}
export enum RequestPriority {
  routine = 'routine',
  urgent = 'urgent',
  asap = 'asap',
  stat = 'stat',
}
export enum ResendInvitationsResultItemStatus {
  sent = 'sent',
  failed = 'failed',
}
export enum ResetEligibilityActionAction {
  reset_eligibility = 'reset_eligibility',
}
export enum ResolveApprovalRequestVerdict {
  approve = 'approve',
  deny = 'deny',
}
export enum ResolveApprovalRequestOverride_scope {
  once = 'once',
  session = 'session',
}
export enum ResolveApprovalResponseVerdict {
  approve = 'approve',
  deny = 'deny',
}
export enum ResolveDesktopTargetRunRequestOutcome {
  accepted = 'accepted',
  failed = 'failed',
}
export enum ResolveErrorReason {
  unknown_setting = 'unknown_setting',
  resolution_error = 'resolution_error',
}
export enum ResolveFrontendEventRequestVerdict {
  approved = 'approved',
  denied = 'denied',
}
export enum ResolveToolApprovalRequestVerdict {
  approve = 'approve',
  deny = 'deny',
}
export enum ResolveToolApprovalRequestOverride_scope {
  once = 'once',
  session = 'session',
}
export enum ResolveToolApprovalResponseVerdict {
  approve = 'approve',
  deny = 'deny',
}
export enum RestfulCapabilityMode {
  client = 'client',
  server = 'server',
}
export enum RevenueCatStore {
  AMAZON = 'AMAZON',
  APP_STORE = 'APP_STORE',
  MAC_APP_STORE = 'MAC_APP_STORE',
  PLAY_STORE = 'PLAY_STORE',
  PROMOTIONAL = 'PROMOTIONAL',
  STRIPE = 'STRIPE',
}
export enum Role {
  Administrator = 'Administrator',
  Clinician = 'Clinician',
  Account_Owner = 'Account Owner',
  Dictate_Only = 'Dictate Only',
  Compliance = 'Compliance',
  Coder = 'Coder',
  Assistant = 'Assistant',
  Template_Manager = 'Template Manager',
}
export enum RoleCategory {
  Admin = 'Admin',
  Clinician = 'Clinician',
  Management = 'Management',
  Support = 'Support',
  View_Only = 'View-Only',
}
export enum RpaArtifactKind {
  archive = 'archive',
  json = 'json',
  jsonl = 'jsonl',
  image = 'image',
  text = 'text',
  binary = 'binary',
}
export enum RpaArtifactStage {
  raw = 'raw',
  extracted = 'extracted',
  workflow = 'workflow',
}
export enum RpaRecordingArtifactDownloadUrlResponseContent_disposition {
  inline = 'inline',
  attachment = 'attachment',
}
export enum RpaRecordingStatusResponseStatus {
  processing = 'processing',
  ready = 'ready',
  failed = 'failed',
}
export enum RpaRecordingSummaryResponseSource {
  personal = 'personal',
  team = 'team',
  public = 'public',
}
export enum RpaRecordingSummaryResponseStatus {
  processing = 'processing',
  ready = 'ready',
  failed = 'failed',
}
export enum RpaRecordingUploadResponseStatus {
  processing = 'processing',
  ready = 'ready',
  failed = 'failed',
}
export enum RpaSkillRefTaskSegmentKind {
  skill_ref = 'skill_ref',
}
export enum RpaTextTaskSegmentKind {
  text = 'text',
}
export enum RunDetailsResponseStatus {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum RunDetailsResponseInput_state {
  ready = 'ready',
  turn_running = 'turn_running',
  approval_required = 'approval_required',
  closed = 'closed',
  failed = 'failed',
}
export enum S3PresignedUrlMethod {
  get_object = 'get_object',
  put_object = 'put_object',
}
export enum SSOProvider {
  KINDE = 'KINDE',
}
export enum SSOState {
  setup = 'setup',
  disabled = 'disabled',
  testing = 'testing',
  enforced = 'enforced',
}
export enum SalesBookingFormName {
  clinician_trial_upgrade = 'clinician_trial_upgrade',
}
export enum ScheduleUploadErrorCode {
  invalid_time = 'invalid_time',
  invalid_date = 'invalid_date',
  date_outside_range = 'date_outside_range',
  conflict_overlap = 'conflict_overlap',
  missing_date_format = 'missing_date_format',
  invalid_file = 'invalid_file',
  no_valid_sessions = 'no_valid_sessions',
  past_date = 'past_date',
  too_many_sessions = 'too_many_sessions',
}
export enum ScreenHint {
  signin = 'signin',
  signup = 'signup',
}
export enum SealedMessageDeliveryRecipientSearchResultResponseType {
  sealed_message_delivery = 'sealed_message_delivery',
}
export enum SectionalNoteSection {
  history_of_present_illness = 'history-of-present-illness',
  physical_exam = 'physical-exam',
  results = 'results',
  assessment_and_plan = 'assessment-and-plan',
  attestation = 'attestation',
  medical_decision_making = 'medical-decision-making',
  allergy = 'allergy',
  medical_history = 'medical-history',
  surgical_history = 'surgical-history',
  hospitalization = 'hospitalization',
  social_history = 'social-history',
  examination = 'examination',
  procedures = 'procedures',
  treatment = 'treatment',
  assessment = 'assessment',
  medication_history = 'medication-history',
  consultation_notes = 'consultation-notes',
  clinical_note = 'clinical-note',
  vitals = 'vitals',
  reason_for_visit = 'reason-for-visit',
  review_of_systems = 'review-of-systems',
  event_notes = 'event-notes',
  catch_all = 'catch-all',
  hospital_course = 'hospital-course',
  generic_dynamic_doc = 'generic-dynamic-doc',
  actions_for_gp = 'actions-for-gp',
  patient_instructions = 'patient-instructions',
  objective_narrative = 'objective-narrative',
  subjective_narrative = 'subjective-narrative',
  family_history = 'family-history',
  comment = 'comment',
  referral = 'referral',
  procedure = 'procedure',
  medication = 'medication',
  follow_up = 'follow-up',
  anamnese = 'anamnese',
  befund = 'befund',
  therapie = 'therapie',
  freitext = 'freitext',
}
export enum SemanticConditionKind {
  semantic = 'semantic',
}
export enum SendOutStatus {
  requested = 'requested',
  approved = 'approved',
  rejected = 'rejected',
  fulfilled = 'fulfilled',
}
export enum SendOutType {
  customer_resend = 'customer_resend',
  internal_use = 'internal_use',
}
export enum SensitiveActionRevocationAuditEvent {
  user_sessions_revoked_on_email_change = 'user_sessions_revoked_on_email_change',
  user_sessions_revoked_on_mfa_enable = 'user_sessions_revoked_on_mfa_enable',
  user_sessions_revoked_on_region_migration = 'user_sessions_revoked_on_region_migration',
  user_sessions_revoked_on_account_merge = 'user_sessions_revoked_on_account_merge',
  user_sessions_revoked_on_password_reset = 'user_sessions_revoked_on_password_reset',
}
export enum ServiceMigrationResultService {
  identity_broker = 'identity_broker',
  auth0 = 'auth0',
  stripe = 'stripe',
  kinde = 'kinde',
}
export enum ServiceMigrationResultStatus {
  updated = 'updated',
  skipped = 'skipped',
  failed = 'failed',
}
export enum SessionEmLevelModifierAnyOf0 {
  Value25 = '25',
  Value24 = '24',
}
export enum SessionGroupStatus {
  no_action = 'no_action',
  pending_patient_link = 'pending_patient_link',
  pending_user_review = 'pending_user_review',
  user_discarded = 'user_discarded',
  grouped = 'grouped',
}
export enum SessionMergeStatus {
  merged = 'merged',
  unmerged = 'unmerged',
}
export enum SessionMergeTimeframe {
  same_day = 'same_day',
  same_week = 'same_week',
  custom_days = 'custom_days',
}
export enum SessionPages {
  START_SESSION = 'START_SESSION',
  CHECK_MICROPHONE = 'CHECK_MICROPHONE',
  ADD_CONTEXT = 'ADD_CONTEXT',
  CHOOSE_TEMPLATE = 'CHOOSE_TEMPLATE',
  RUN_CONSULT = 'RUN_CONSULT',
  STOP_SESSION = 'STOP_SESSION',
}
export enum SessionScope {
  all = 'all',
  me = 'me',
  team = 'team',
  direct_share = 'direct_share',
}
export enum SessionSettingsRequestConnected_apps_providerAnyOf0 {
  nango = 'nango',
  merge = 'merge',
}
export enum SessionSettingsResponseConnected_apps_providerAnyOf0 {
  nango = 'nango',
  merge = 'merge',
}
export enum SessionSortBy {
  created_at = 'created_at',
  updated_at = 'updated_at',
  name = 'name',
  status = 'status',
}
export enum SessionStatus {
  EMPTY = 'EMPTY',
  DRAFT = 'DRAFT',
  FOR_ACTION = 'FOR_ACTION',
  REVIEWED = 'REVIEWED',
  APPROVED = 'APPROVED',
  SENT = 'SENT',
}
export enum SessionTabType {
  CONTEXT = 'CONTEXT',
  NOTE = 'NOTE',
  TRANSCRIPT = 'TRANSCRIPT',
}
export enum SessionTimeoutScope {
  USER = 'USER',
  ORGANIZATION = 'ORGANIZATION',
}
export enum SessionTimeoutSetBY {
  USER = 'USER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
}
export enum ShareLevel {
  view = 'view',
  edit = 'edit',
  full_access = 'full_access',
}
export enum SharedSessionScope {
  documents_only = 'documents_only',
  full_session = 'full_session',
  custom = 'custom',
}
export enum SidePanelState {
  TASKS = 'TASKS',
  EMBEDDINGS = 'EMBEDDINGS',
  CLOSED = 'CLOSED',
  PATIENT_CONTEXT = 'PATIENT_CONTEXT',
}
export enum SignupSource {
  scribe = 'scribe',
  evidence = 'evidence',
  practice = 'practice',
  scribe_plus = 'scribe_plus',
  dictate = 'dictate',
}
export enum SlotStatus {
  busy = 'busy',
  free = 'free',
  busy_unavailable = 'busy-unavailable',
  busy_tentative = 'busy-tentative',
  entered_in_error = 'entered-in-error',
}
export enum SourceArtifactModelKind {
  docx = 'docx',
  pdf = 'pdf',
  manual = 'manual',
  html = 'html',
}
export enum Speaker {
  patient = 'patient',
  clinician = 'clinician',
  heidi = 'heidi',
}
export enum SpecialNoteModelKind {
  info = 'info',
  warning = 'warning',
  rule = 'rule',
}
export enum SpecialNoteModelPosition {
  top = 'top',
  bottom = 'bottom',
}
export enum SpellingPreference {
  AU = 'AU',
  CA = 'CA',
  UK = 'UK',
  US = 'US',
}
export enum StartWorkspaceRealignResponseStatus {
  running = 'running',
  noop = 'noop',
}
export enum StepExecutionStatus {
  pending = 'pending',
  completed = 'completed',
  failed = 'failed',
}
export enum StepType {
  form = 'form',
  oauth_authorization_code_url = 'oauth_authorization_code_url',
  oauth_authorization_code_exchange = 'oauth_authorization_code_exchange',
  search_select = 'search_select',
  select = 'select',
  section_mapping = 'section_mapping',
}
export enum StockItemStatus {
  received = 'received',
  in_qa = 'in_qa',
  qa_passed = 'qa_passed',
  qa_failed = 'qa_failed',
  allocated = 'allocated',
  dispatched = 'dispatched',
  consumed = 'consumed',
  scrapped = 'scrapped',
}
export enum StripeFreeTrialDays {
  Value0 = 0,
  Value7 = 7,
  Value14 = 14,
  Value30 = 30,
}
export enum StructuredCitationSource_type {
  web_search = 'web_search',
  attachment = 'attachment',
  user_document = 'user_document',
  image = 'image',
  integration_partner = 'integration_partner',
}
export enum StructuredCitationSource_categoryAnyOf0 {
  primary = 'primary',
  local = 'local',
  web = 'web',
}
export enum StructuredCitationRegional_relevanceAnyOf0 {
  in_region = 'in_region',
  global = 'global',
  out_of_region = 'out_of_region',
}
export enum StructuredCitationResponseRegional_relevanceAnyOf0 {
  in_region = 'in_region',
  global = 'global',
  out_of_region = 'out_of_region',
}
export enum SubjectRunSummaryItemStatus {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum SubmitRemoteToolResultRequestFailure_behavior {
  continue = 'continue',
  stop_turn = 'stop_turn',
}
export enum SubscriptionStatus {
  FREE = 'FREE',
  PRO = 'PRO',
  PRO_PLUS = 'PRO_PLUS',
  PRO_TRIAL = 'PRO_TRIAL',
  PRO_PLUS_TRIAL = 'PRO_PLUS_TRIAL',
}
export enum SubscriptionTier {
  FREE = 'FREE',
  EVIDENCE = 'EVIDENCE',
  PRO = 'PRO',
  CLINICIAN_PRO = 'CLINICIAN_PRO',
  PRO_PLUS = 'PRO_PLUS',
  CLINICIAN_PRO_PLUS = 'CLINICIAN_PRO_PLUS',
  ENTERPRISE = 'ENTERPRISE',
  CLINICIAN_ENTERPRISE = 'CLINICIAN_ENTERPRISE',
  EVIDENCE_TEAM = 'EVIDENCE_TEAM',
}
export enum SuggestedChipCategory {
  suggested_question = 'suggested_question',
  examination = 'examination',
  investigation = 'investigation',
  condition = 'condition',
  symptom_exploration = 'symptom_exploration',
  plan = 'plan',
  red_flag = 'red_flag',
  clinical_review = 'clinical_review',
}
export enum SuggestionFeedback {
  accepted = 'accepted',
  rejected = 'rejected',
  skipped = 'skipped',
  skipped_edit = 'skipped_edit',
}
export enum SummaryParameter {
  true = 'true',
  false = 'false',
  text = 'text',
  data = 'data',
  count = 'count',
}
export enum SuspensionAction {
  suspended = 'suspended',
  restored = 'restored',
}
export enum SyncRunResponseStatus {
  running = 'running',
  completed = 'completed',
  failed = 'failed',
}
export enum T2medAckFailureStatus {
  failure = 'failure',
}
export enum T2medAckSuccessStatus {
  success = 'success',
}
export enum TaskIcon {
  user_round_plus = 'user-round-plus',
  blocks = 'blocks',
  pencil_line = 'pencil-line',
  flask_conical = 'flask-conical',
  microscope = 'microscope',
  text_search = 'text-search',
  library_big = 'library-big',
  download = 'download',
  audio_lines = 'audio-lines',
  message_square = 'message-square',
}
export enum TaskIntent {
  unknown = 'unknown',
  proposal = 'proposal',
  plan = 'plan',
  order = 'order',
  original_order = 'original-order',
  reflex_order = 'reflex-order',
  filler_order = 'filler-order',
  instance_order = 'instance-order',
  option = 'option',
}
export enum TaskStatus {
  draft = 'draft',
  requested = 'requested',
  received = 'received',
  accepted = 'accepted',
  rejected = 'rejected',
  ready = 'ready',
  cancelled = 'cancelled',
  in_progress = 'in-progress',
  on_hold = 'on-hold',
  failed = 'failed',
  completed = 'completed',
  entered_in_error = 'entered-in-error',
}
export enum TaskType {
  boolean = 'boolean',
  counter = 'counter',
}
export enum TeamAddMemberMethod {
  EMAIL_LINK = 'EMAIL_LINK',
  DIRECT_ADD = 'DIRECT_ADD',
}
export enum TeamDisclaimerFooterScope {
  NOTE = 'NOTE',
  DOCUMENT = 'DOCUMENT',
  PDF = 'PDF',
}
export enum TeamEvidenceAccessMode {
  BY_ROLE = 'by_role',
  BY_MEMBER = 'by_member',
}
export enum TeamMembershipRole {
  owner = 'owner',
  member = 'member',
}
export enum TeamOrderBy {
  id = 'id',
  name = 'name',
  is_managed = 'is_managed',
  country = 'country',
  created_at = 'created_at',
}
export enum TeamType {
  TEAM = 'TEAM',
  ORGANIZATION = 'ORGANIZATION',
}
export enum TemplateAuthorGroup {
  Heidi = 'Heidi',
  Community = 'Community',
  Team = 'Team',
  User = 'User',
}
export enum TemplateCategory {
  CONSULT_NOTE_TEMPLATE = 'CONSULT_NOTE_TEMPLATE',
  DOCUMENT_TEMPLATE = 'DOCUMENT_TEMPLATE',
  FORM_TEMPLATE = 'FORM_TEMPLATE',
  ASSESSMENT_TEMPLATE = 'ASSESSMENT_TEMPLATE',
  LETTER_TEMPLATE = 'LETTER_TEMPLATE',
  PRECHART_TEMPLATE = 'PRECHART_TEMPLATE',
  PATIENT_SUMMARY_TEMPLATE = 'PATIENT_SUMMARY_TEMPLATE',
}
export enum TemplateCreationRecordTab {
  structure = 'structure',
  example = 'example',
}
export enum TemplateMatchType {
  PARTIAL = 'PARTIAL',
  INCLUDE = 'INCLUDE',
  EXACT = 'EXACT',
}
export enum TemplatePages {
  GO_TO_TEMPLATE_COMMUNITY = 'GO_TO_TEMPLATE_COMMUNITY',
  BROWSE_TEMPLATES = 'BROWSE_TEMPLATES',
  ADD_TO_YOUR_LIBRARY = 'ADD_TO_YOUR_LIBRARY',
  NAVIGATE_BACK_TO_SESSION = 'NAVIGATE_BACK_TO_SESSION',
  SET_AS_DEFAULT_TEMPLATE = 'SET_AS_DEFAULT_TEMPLATE',
}
export enum TemplateReviewStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  UNNECESSARY = 'UNNECESSARY',
}
export enum TemplateSortBy {
  NAME = 'NAME',
  CREATED_TIME = 'CREATED_TIME',
  LAST_USED = 'LAST_USED',
  USAGE = 'USAGE',
  TYPE = 'TYPE',
  VISIBILITY = 'VISIBILITY',
}
export enum TemplateType {
  DOCUMENT = 'DOCUMENT',
  FORM = 'FORM',
  LETTER = 'LETTER',
  NOTE = 'NOTE',
  PRECHART = 'PRECHART',
  PATIENT_SUMMARY = 'PATIENT_SUMMARY',
}
export enum TemplateVisibility {
  Community = 'Community',
  Team = 'Team',
  User = 'User',
  Heidi = 'Heidi',
  Organization = 'Organization',
}
export enum TenantScopeModelKind {
  global = 'global',
  org = 'org',
  team = 'team',
}
export enum TextBlockKind {
  text = 'text',
}
export enum Theme {
  light = 'light',
  newBrand = 'newBrand',
  newBrandDark = 'newBrandDark',
}
export enum ThinkingBlockKind {
  thinking = 'thinking',
}
export enum ThirdPartyLicenseMetadataKind {
  tpl = 'tpl',
}
export enum ThumbRating {
  thumb_down = 'thumb_down',
  thumb_up = 'thumb_up',
}
export enum TimeZones {
  Africa_Abidjan = 'Africa/Abidjan',
  Africa_Accra = 'Africa/Accra',
  Africa_Addis_Ababa = 'Africa/Addis_Ababa',
  Africa_Algiers = 'Africa/Algiers',
  Africa_Asmara = 'Africa/Asmara',
  Africa_Asmera = 'Africa/Asmera',
  Africa_Bamako = 'Africa/Bamako',
  Africa_Bangui = 'Africa/Bangui',
  Africa_Banjul = 'Africa/Banjul',
  Africa_Bissau = 'Africa/Bissau',
  Africa_Blantyre = 'Africa/Blantyre',
  Africa_Brazzaville = 'Africa/Brazzaville',
  Africa_Bujumbura = 'Africa/Bujumbura',
  Africa_Cairo = 'Africa/Cairo',
  Africa_Casablanca = 'Africa/Casablanca',
  Africa_Ceuta = 'Africa/Ceuta',
  Africa_Conakry = 'Africa/Conakry',
  Africa_Dakar = 'Africa/Dakar',
  Africa_Dar_es_Salaam = 'Africa/Dar_es_Salaam',
  Africa_Djibouti = 'Africa/Djibouti',
  Africa_Douala = 'Africa/Douala',
  Africa_El_Aaiun = 'Africa/El_Aaiun',
  Africa_Freetown = 'Africa/Freetown',
  Africa_Gaborone = 'Africa/Gaborone',
  Africa_Harare = 'Africa/Harare',
  Africa_Johannesburg = 'Africa/Johannesburg',
  Africa_Juba = 'Africa/Juba',
  Africa_Kampala = 'Africa/Kampala',
  Africa_Khartoum = 'Africa/Khartoum',
  Africa_Kigali = 'Africa/Kigali',
  Africa_Kinshasa = 'Africa/Kinshasa',
  Africa_Lagos = 'Africa/Lagos',
  Africa_Libreville = 'Africa/Libreville',
  Africa_Lome = 'Africa/Lome',
  Africa_Luanda = 'Africa/Luanda',
  Africa_Lubumbashi = 'Africa/Lubumbashi',
  Africa_Lusaka = 'Africa/Lusaka',
  Africa_Malabo = 'Africa/Malabo',
  Africa_Maputo = 'Africa/Maputo',
  Africa_Maseru = 'Africa/Maseru',
  Africa_Mbabane = 'Africa/Mbabane',
  Africa_Mogadishu = 'Africa/Mogadishu',
  Africa_Monrovia = 'Africa/Monrovia',
  Africa_Nairobi = 'Africa/Nairobi',
  Africa_Ndjamena = 'Africa/Ndjamena',
  Africa_Niamey = 'Africa/Niamey',
  Africa_Nouakchott = 'Africa/Nouakchott',
  Africa_Ouagadougou = 'Africa/Ouagadougou',
  Africa_Porto_Novo = 'Africa/Porto-Novo',
  Africa_Sao_Tome = 'Africa/Sao_Tome',
  Africa_Timbuktu = 'Africa/Timbuktu',
  Africa_Tripoli = 'Africa/Tripoli',
  Africa_Tunis = 'Africa/Tunis',
  Africa_Windhoek = 'Africa/Windhoek',
  America_Adak = 'America/Adak',
  America_Anchorage = 'America/Anchorage',
  America_Anguilla = 'America/Anguilla',
  America_Antigua = 'America/Antigua',
  America_Araguaina = 'America/Araguaina',
  America_Argentina_Buenos_Aires = 'America/Argentina/Buenos_Aires',
  America_Argentina_Catamarca = 'America/Argentina/Catamarca',
  America_Argentina_ComodRivadavia = 'America/Argentina/ComodRivadavia',
  America_Argentina_Cordoba = 'America/Argentina/Cordoba',
  America_Argentina_Jujuy = 'America/Argentina/Jujuy',
  America_Argentina_La_Rioja = 'America/Argentina/La_Rioja',
  America_Argentina_Mendoza = 'America/Argentina/Mendoza',
  America_Argentina_Rio_Gallegos = 'America/Argentina/Rio_Gallegos',
  America_Argentina_Salta = 'America/Argentina/Salta',
  America_Argentina_San_Juan = 'America/Argentina/San_Juan',
  America_Argentina_San_Luis = 'America/Argentina/San_Luis',
  America_Argentina_Tucuman = 'America/Argentina/Tucuman',
  America_Argentina_Ushuaia = 'America/Argentina/Ushuaia',
  America_Aruba = 'America/Aruba',
  America_Asuncion = 'America/Asuncion',
  America_Atikokan = 'America/Atikokan',
  America_Atka = 'America/Atka',
  America_Bahia = 'America/Bahia',
  America_Bahia_Banderas = 'America/Bahia_Banderas',
  America_Barbados = 'America/Barbados',
  America_Belem = 'America/Belem',
  America_Belize = 'America/Belize',
  America_Blanc_Sablon = 'America/Blanc-Sablon',
  America_Boa_Vista = 'America/Boa_Vista',
  America_Bogota = 'America/Bogota',
  America_Boise = 'America/Boise',
  America_Buenos_Aires = 'America/Buenos_Aires',
  America_Cambridge_Bay = 'America/Cambridge_Bay',
  America_Campo_Grande = 'America/Campo_Grande',
  America_Cancun = 'America/Cancun',
  America_Caracas = 'America/Caracas',
  America_Catamarca = 'America/Catamarca',
  America_Cayenne = 'America/Cayenne',
  America_Cayman = 'America/Cayman',
  America_Chicago = 'America/Chicago',
  America_Chihuahua = 'America/Chihuahua',
  America_Ciudad_Juarez = 'America/Ciudad_Juarez',
  America_Coral_Harbour = 'America/Coral_Harbour',
  America_Cordoba = 'America/Cordoba',
  America_Costa_Rica = 'America/Costa_Rica',
  America_Creston = 'America/Creston',
  America_Cuiaba = 'America/Cuiaba',
  America_Curacao = 'America/Curacao',
  America_Danmarkshavn = 'America/Danmarkshavn',
  America_Dawson = 'America/Dawson',
  America_Dawson_Creek = 'America/Dawson_Creek',
  America_Denver = 'America/Denver',
  America_Detroit = 'America/Detroit',
  America_Dominica = 'America/Dominica',
  America_Edmonton = 'America/Edmonton',
  America_Eirunepe = 'America/Eirunepe',
  America_El_Salvador = 'America/El_Salvador',
  America_Ensenada = 'America/Ensenada',
  America_Fort_Nelson = 'America/Fort_Nelson',
  America_Fort_Wayne = 'America/Fort_Wayne',
  America_Fortaleza = 'America/Fortaleza',
  America_Glace_Bay = 'America/Glace_Bay',
  America_Godthab = 'America/Godthab',
  America_Goose_Bay = 'America/Goose_Bay',
  America_Grand_Turk = 'America/Grand_Turk',
  America_Grenada = 'America/Grenada',
  America_Guadeloupe = 'America/Guadeloupe',
  America_Guatemala = 'America/Guatemala',
  America_Guayaquil = 'America/Guayaquil',
  America_Guyana = 'America/Guyana',
  America_Halifax = 'America/Halifax',
  America_Havana = 'America/Havana',
  America_Hermosillo = 'America/Hermosillo',
  America_Indiana_Indianapolis = 'America/Indiana/Indianapolis',
  America_Indiana_Knox = 'America/Indiana/Knox',
  America_Indiana_Marengo = 'America/Indiana/Marengo',
  America_Indiana_Petersburg = 'America/Indiana/Petersburg',
  America_Indiana_Tell_City = 'America/Indiana/Tell_City',
  America_Indiana_Vevay = 'America/Indiana/Vevay',
  America_Indiana_Vincennes = 'America/Indiana/Vincennes',
  America_Indiana_Winamac = 'America/Indiana/Winamac',
  America_Indianapolis = 'America/Indianapolis',
  America_Inuvik = 'America/Inuvik',
  America_Iqaluit = 'America/Iqaluit',
  America_Jamaica = 'America/Jamaica',
  America_Jujuy = 'America/Jujuy',
  America_Juneau = 'America/Juneau',
  America_Kentucky_Louisville = 'America/Kentucky/Louisville',
  America_Kentucky_Monticello = 'America/Kentucky/Monticello',
  America_Knox_IN = 'America/Knox_IN',
  America_Kralendijk = 'America/Kralendijk',
  America_La_Paz = 'America/La_Paz',
  America_Lima = 'America/Lima',
  America_Los_Angeles = 'America/Los_Angeles',
  America_Louisville = 'America/Louisville',
  America_Maceio = 'America/Maceio',
  America_Manaus = 'America/Manaus',
  America_Martinique = 'America/Martinique',
  America_Matamoros = 'America/Matamoros',
  America_Mazatlan = 'America/Mazatlan',
  America_Mexico_City = 'America/Mexico_City',
  America_Miquelon = 'America/Miquelon',
  America_Montevideo = 'America/Montevideo',
  America_Montreal = 'America/Montreal',
  America_Nassau = 'America/Nassau',
  America_New_York = 'America/New_York',
  America_Nipigon = 'America/Nipigon',
  America_Nome = 'America/Nome',
  America_Noronha = 'America/Noronha',
  America_North_Dakota_New_Salem = 'America/North_Dakota/New_Salem',
  America_Ojinaga = 'America/Ojinaga',
  America_Panama = 'America/Panama',
  America_Phoenix = 'America/Phoenix',
  America_Port_au_Prince = 'America/Port-au-Prince',
  America_Puerto_Rico = 'America/Puerto_Rico',
  America_Rainy_River = 'America/Rainy_River',
  America_Rankin_Inlet = 'America/Rankin_Inlet',
  America_Rio_Branco = 'America/Rio_Branco',
  America_Santa_Isabel = 'America/Santa_Isabel',
  America_Santo_Domingo = 'America/Santo_Domingo',
  America_Sao_Paulo = 'America/Sao_Paulo',
  America_Scoresbysund = 'America/Scoresbysund',
  America_Sitka = 'America/Sitka',
  America_St_Barthelemy = 'America/St_Barthelemy',
  America_St_Johns = 'America/St_Johns',
  America_St_Kitts = 'America/St_Kitts',
  America_St_Lucia = 'America/St_Lucia',
  America_St_Thomas = 'America/St_Thomas',
  America_St_Vincent = 'America/St_Vincent',
  America_Tegucigalpa = 'America/Tegucigalpa',
  America_Thule = 'America/Thule',
  America_Toronto = 'America/Toronto',
  America_Vancouver = 'America/Vancouver',
  America_Virgin = 'America/Virgin',
  America_Winnipeg = 'America/Winnipeg',
  America_Yakutat = 'America/Yakutat',
  America_Yellowknife = 'America/Yellowknife',
  Antarctica_Davis = 'Antarctica/Davis',
  Antarctica_DumontDUrville = 'Antarctica/DumontDUrville',
  Antarctica_Macquarie = 'Antarctica/Macquarie',
  Antarctica_McMurdo = 'Antarctica/McMurdo',
  Antarctica_Palmer = 'Antarctica/Palmer',
  Antarctica_Rothera = 'Antarctica/Rothera',
  Antarctica_Syowa = 'Antarctica/Syowa',
  Antarctica_Troll = 'Antarctica/Troll',
  Antarctica_Vostok = 'Antarctica/Vostok',
  Arctic_Longyearbyen = 'Arctic/Longyearbyen',
  Asia_Aden = 'Asia/Aden',
  Asia_Almaty = 'Asia/Almaty',
  Asia_Amman = 'Asia/Amman',
  Asia_Anadyr = 'Asia/Anadyr',
  Asia_Aqtau = 'Asia/Aqtau',
  Asia_Aqtobe = 'Asia/Aqtobe',
  Asia_Ashgabat = 'Asia/Ashgabat',
  Asia_Atyrau = 'Asia/Atyrau',
  Asia_Baghdad = 'Asia/Baghdad',
  Asia_Bahrain = 'Asia/Bahrain',
  Asia_Baku = 'Asia/Baku',
  Asia_Bangkok = 'Asia/Bangkok',
  Asia_Bishkek = 'Asia/Bishkek',
  Asia_Chita = 'Asia/Chita',
  Asia_Choibalsan = 'Asia/Choibalsan',
  Asia_Colombo = 'Asia/Colombo',
  Asia_Damascus = 'Asia/Damascus',
  Asia_Dhaka = 'Asia/Dhaka',
  Asia_Dili = 'Asia/Dili',
  Asia_Dubai = 'Asia/Dubai',
  Asia_Dushanbe = 'Asia/Dushanbe',
  Asia_Famagusta = 'Asia/Famagusta',
  Asia_Gaza = 'Asia/Gaza',
  Asia_Hebron = 'Asia/Hebron',
  Asia_Ho_Chi_Minh = 'Asia/Ho_Chi_Minh',
  Asia_Hong_Kong = 'Asia/Hong_Kong',
  Asia_Hovd = 'Asia/Hovd',
  Asia_Istanbul = 'Asia/Istanbul',
  Asia_Jakarta = 'Asia/Jakarta',
  Asia_Jerusalem = 'Asia/Jerusalem',
  Asia_Kabul = 'Asia/Kabul',
  Asia_Kamchatka = 'Asia/Kamchatka',
  Asia_Karachi = 'Asia/Karachi',
  Asia_Kathmandu = 'Asia/Kathmandu',
  Asia_Kolkata = 'Asia/Kolkata',
  Asia_Krasnoyarsk = 'Asia/Krasnoyarsk',
  Asia_Macau = 'Asia/Macau',
  Asia_Magadan = 'Asia/Magadan',
  Asia_Makassar = 'Asia/Makassar',
  Asia_Manila = 'Asia/Manila',
  Asia_Nicosia = 'Asia/Nicosia',
  Asia_Novokuznetsk = 'Asia/Novokuznetsk',
  Asia_Novosibirsk = 'Asia/Novosibirsk',
  Asia_Omsk = 'Asia/Omsk',
  Asia_Oral = 'Asia/Oral',
  Asia_Pontianak = 'Asia/Pontianak',
  Asia_Pyongyang = 'Asia/Pyongyang',
  Asia_Qatar = 'Asia/Qatar',
  Asia_Qyzylorda = 'Asia/Qyzylorda',
  Asia_Riyadh = 'Asia/Riyadh',
  Asia_Sakhalin = 'Asia/Sakhalin',
  Asia_Samarkand = 'Asia/Samarkand',
  Asia_Seoul = 'Asia/Seoul',
  Asia_Shanghai = 'Asia/Shanghai',
  Asia_Singapore = 'Asia/Singapore',
  Asia_Taipei = 'Asia/Taipei',
  Asia_Tashkent = 'Asia/Tashkent',
  Asia_Tbilisi = 'Asia/Tbilisi',
  Asia_Tokyo = 'Asia/Tokyo',
  Asia_Tomsk = 'Asia/Tomsk',
  Asia_Ulaanbaatar = 'Asia/Ulaanbaatar',
  Asia_Ust_Nera = 'Asia/Ust-Nera',
  Asia_Vientiane = 'Asia/Vientiane',
  Asia_Vladivostok = 'Asia/Vladivostok',
  Asia_Yakutsk = 'Asia/Yakutsk',
  Asia_Yerevan = 'Asia/Yerevan',
  Atlantic_Azores = 'Atlantic/Azores',
  Atlantic_Bermuda = 'Atlantic/Bermuda',
  Atlantic_Canary = 'Atlantic/Canary',
  Atlantic_Cape_Verde = 'Atlantic/Cape_Verde',
  Atlantic_Faeroe = 'Atlantic/Faeroe',
  Atlantic_Faroe = 'Atlantic/Faroe',
  Atlantic_Madeira = 'Atlantic/Madeira',
  Atlantic_Reykjavik = 'Atlantic/Reykjavik',
  Atlantic_South_Georgia = 'Atlantic/South_Georgia',
  Atlantic_St_Helena = 'Atlantic/St_Helena',
  Australia_Adelaide = 'Australia/Adelaide',
  Australia_Brisbane = 'Australia/Brisbane',
  Australia_Broken_Hill = 'Australia/Broken_Hill',
  Australia_Canberra = 'Australia/Canberra',
  Australia_Currie = 'Australia/Currie',
  Australia_Darwin = 'Australia/Darwin',
  Australia_Hobart = 'Australia/Hobart',
  Australia_Lindeman = 'Australia/Lindeman',
  Australia_Lord_Howe = 'Australia/Lord_Howe',
  Australia_Melbourne = 'Australia/Melbourne',
  Australia_Perth = 'Australia/Perth',
  Australia_Sydney = 'Australia/Sydney',
  Australia_Tasmania = 'Australia/Tasmania',
  Australia_Queensland = 'Australia/Queensland',
  Australia_North = 'Australia/North',
  Australia_South = 'Australia/South',
  Australia_West = 'Australia/West',
  Brazil_Acre = 'Brazil/Acre',
  Canada_Atlantic = 'Canada/Atlantic',
  Canada_Central = 'Canada/Central',
  Canada_Eastern = 'Canada/Eastern',
  Canada_Mountain = 'Canada/Mountain',
  Canada_Pacific = 'Canada/Pacific',
  Canada_Saskatchewan = 'Canada/Saskatchewan',
  Canada_Yukon = 'Canada/Yukon',
  Chile_Continental = 'Chile/Continental',
  Cuba = 'Cuba',
  Europe_Amsterdam = 'Europe/Amsterdam',
  Europe_Andorra = 'Europe/Andorra',
  Europe_Athens = 'Europe/Athens',
  Europe_Belgrade = 'Europe/Belgrade',
  Europe_Berlin = 'Europe/Berlin',
  Europe_Bratislava = 'Europe/Bratislava',
  Europe_Brussels = 'Europe/Brussels',
  Europe_Bucharest = 'Europe/Bucharest',
  Europe_Budapest = 'Europe/Budapest',
  Europe_Chisinau = 'Europe/Chisinau',
  Europe_Copenhagen = 'Europe/Copenhagen',
  Europe_Dublin = 'Europe/Dublin',
  Europe_Gibraltar = 'Europe/Gibraltar',
  Europe_Helsinki = 'Europe/Helsinki',
  Europe_Istanbul = 'Europe/Istanbul',
  Europe_Kaliningrad = 'Europe/Kaliningrad',
  Europe_Kiev = 'Europe/Kiev',
  Europe_Lisbon = 'Europe/Lisbon',
  Europe_Ljubljana = 'Europe/Ljubljana',
  Europe_London = 'Europe/London',
  Europe_Luxembourg = 'Europe/Luxembourg',
  Europe_Madrid = 'Europe/Madrid',
  Europe_Malta = 'Europe/Malta',
  Europe_Minsk = 'Europe/Minsk',
  Europe_Nicosia = 'Europe/Nicosia',
  Europe_Oslo = 'Europe/Oslo',
  Europe_Paris = 'Europe/Paris',
  Europe_Prague = 'Europe/Prague',
  Europe_Riga = 'Europe/Riga',
  Europe_Rome = 'Europe/Rome',
  Europe_Samara = 'Europe/Samara',
  Europe_Sofia = 'Europe/Sofia',
  Europe_Stockholm = 'Europe/Stockholm',
  Europe_Tallinn = 'Europe/Tallinn',
  Europe_Tirane = 'Europe/Tirane',
  Europe_Uzhgorod = 'Europe/Uzhgorod',
  Europe_Vaduz = 'Europe/Vaduz',
  Europe_Vienna = 'Europe/Vienna',
  Europe_Warsaw = 'Europe/Warsaw',
  Europe_Zagreb = 'Europe/Zagreb',
  Europe_Zurich = 'Europe/Zurich',
  Pacific_Auckland = 'Pacific/Auckland',
  Pacific_Bougainville = 'Pacific/Bougainville',
  Pacific_Chatham = 'Pacific/Chatham',
  Pacific_Easter = 'Pacific/Easter',
  Pacific_Fiji = 'Pacific/Fiji',
  Pacific_Gambier = 'Pacific/Gambier',
  Pacific_Guadalcanal = 'Pacific/Guadalcanal',
  Pacific_Guam = 'Pacific/Guam',
  Pacific_Honolulu = 'Pacific/Honolulu',
  Pacific_Kwajalein = 'Pacific/Kwajalein',
  Pacific_Majuro = 'Pacific/Majuro',
  Pacific_Marquesas = 'Pacific/Marquesas',
  Pacific_Noumea = 'Pacific/Noumea',
  Pacific_Pago_Pago = 'Pacific/Pago_Pago',
  Pacific_Palau = 'Pacific/Palau',
  Pacific_Pitcairn = 'Pacific/Pitcairn',
  Pacific_Pohnpei = 'Pacific/Pohnpei',
  Pacific_Rarotonga = 'Pacific/Rarotonga',
  Pacific_Tahiti = 'Pacific/Tahiti',
  Pacific_Tarawa = 'Pacific/Tarawa',
  Pacific_Tongatapu = 'Pacific/Tongatapu',
  Pacific_Wallis = 'Pacific/Wallis',
  US_Alaska = 'US/Alaska',
  US_Aleutian = 'US/Aleutian',
  US_Arizona = 'US/Arizona',
  US_Central = 'US/Central',
  US_East_Indiana = 'US/East-Indiana',
  US_Eastern = 'US/Eastern',
  US_Hawaii = 'US/Hawaii',
  US_Indiana_Starke = 'US/Indiana-Starke',
  US_Michigan = 'US/Michigan',
  US_Mountain = 'US/Mountain',
  US_Pacific = 'US/Pacific',
  US_Samoa = 'US/Samoa',
  UTC = 'UTC',
  Universal = 'Universal',
  Zulu = 'Zulu',
  America_Lower_Princes = 'America/Lower_Princes',
  America_Managua = 'America/Managua',
  America_Marigot = 'America/Marigot',
  America_Mendoza = 'America/Mendoza',
  America_Menominee = 'America/Menominee',
  America_Merida = 'America/Merida',
  America_Metlakatla = 'America/Metlakatla',
  America_Moncton = 'America/Moncton',
  America_Monterrey = 'America/Monterrey',
  America_Montserrat = 'America/Montserrat',
  America_North_Dakota_Beulah = 'America/North_Dakota/Beulah',
  America_North_Dakota_Center = 'America/North_Dakota/Center',
  America_Nuuk = 'America/Nuuk',
  America_Pangnirtung = 'America/Pangnirtung',
  America_Paramaribo = 'America/Paramaribo',
  America_Port_of_Spain = 'America/Port_of_Spain',
  America_Porto_Acre = 'America/Porto_Acre',
  America_Porto_Velho = 'America/Porto_Velho',
  America_Punta_Arenas = 'America/Punta_Arenas',
  America_Recife = 'America/Recife',
  America_Regina = 'America/Regina',
  America_Resolute = 'America/Resolute',
  America_Rosario = 'America/Rosario',
  America_Santarem = 'America/Santarem',
  America_Santiago = 'America/Santiago',
  America_Shiprock = 'America/Shiprock',
  America_Swift_Current = 'America/Swift_Current',
  America_Thunder_Bay = 'America/Thunder_Bay',
  America_Tijuana = 'America/Tijuana',
  America_Tortola = 'America/Tortola',
  America_Whitehorse = 'America/Whitehorse',
  Antarctica_Casey = 'Antarctica/Casey',
  Antarctica_Mawson = 'Antarctica/Mawson',
  Antarctica_South_Pole = 'Antarctica/South_Pole',
  Asia_Ashkhabad = 'Asia/Ashkhabad',
  Asia_Barnaul = 'Asia/Barnaul',
  Asia_Beirut = 'Asia/Beirut',
  Asia_Brunei = 'Asia/Brunei',
  Asia_Calcutta = 'Asia/Calcutta',
  Asia_Chongqing = 'Asia/Chongqing',
  Asia_Chungking = 'Asia/Chungking',
  Asia_Dacca = 'Asia/Dacca',
  Asia_Harbin = 'Asia/Harbin',
  Asia_Irkutsk = 'Asia/Irkutsk',
  Asia_Jayapura = 'Asia/Jayapura',
  Asia_Kashgar = 'Asia/Kashgar',
  Asia_Katmandu = 'Asia/Katmandu',
  Asia_Khandyga = 'Asia/Khandyga',
  Asia_Kuala_Lumpur = 'Asia/Kuala_Lumpur',
  Asia_Kuching = 'Asia/Kuching',
  Asia_Kuwait = 'Asia/Kuwait',
  Asia_Macao = 'Asia/Macao',
  Asia_Muscat = 'Asia/Muscat',
  Asia_Phnom_Penh = 'Asia/Phnom_Penh',
  Asia_Qostanay = 'Asia/Qostanay',
  Asia_Rangoon = 'Asia/Rangoon',
  Asia_Saigon = 'Asia/Saigon',
  Asia_Srednekolymsk = 'Asia/Srednekolymsk',
  Asia_Tehran = 'Asia/Tehran',
  Asia_Tel_Aviv = 'Asia/Tel_Aviv',
  Asia_Thimbu = 'Asia/Thimbu',
  Asia_Thimphu = 'Asia/Thimphu',
  Asia_Ujung_Pandang = 'Asia/Ujung_Pandang',
  Asia_Ulan_Bator = 'Asia/Ulan_Bator',
  Asia_Urumqi = 'Asia/Urumqi',
  Asia_Yangon = 'Asia/Yangon',
  Asia_Yekaterinburg = 'Asia/Yekaterinburg',
  Atlantic_Jan_Mayen = 'Atlantic/Jan_Mayen',
  Atlantic_Stanley = 'Atlantic/Stanley',
  Australia_ACT = 'Australia/ACT',
  Australia_Eucla = 'Australia/Eucla',
  Australia_LHI = 'Australia/LHI',
  Australia_NSW = 'Australia/NSW',
  Australia_Victoria = 'Australia/Victoria',
  Australia_Yancowinna = 'Australia/Yancowinna',
  Brazil_DeNoronha = 'Brazil/DeNoronha',
  Brazil_East = 'Brazil/East',
  Brazil_West = 'Brazil/West',
  CET = 'CET',
  CST6CDT = 'CST6CDT',
  Canada_Newfoundland = 'Canada/Newfoundland',
  Chile_EasterIsland = 'Chile/EasterIsland',
  EET = 'EET',
  EST = 'EST',
  EST5EDT = 'EST5EDT',
  Egypt = 'Egypt',
  Eire = 'Eire',
  Etc_GMT = 'Etc/GMT',
  Etc_GMTPlus0 = 'Etc/GMT+0',
  Etc_GMTPlus1 = 'Etc/GMT+1',
  Etc_GMTPlus10 = 'Etc/GMT+10',
  Etc_GMTPlus11 = 'Etc/GMT+11',
  Etc_GMTPlus12 = 'Etc/GMT+12',
  Etc_GMTPlus2 = 'Etc/GMT+2',
  Etc_GMTPlus3 = 'Etc/GMT+3',
  Etc_GMTPlus4 = 'Etc/GMT+4',
  Etc_GMTPlus5 = 'Etc/GMT+5',
  Etc_GMTPlus6 = 'Etc/GMT+6',
  Etc_GMTPlus7 = 'Etc/GMT+7',
  Etc_GMTPlus8 = 'Etc/GMT+8',
  Etc_GMTPlus9 = 'Etc/GMT+9',
  Etc_GMT_0 = 'Etc/GMT-0',
  Etc_GMT_1 = 'Etc/GMT-1',
  Etc_GMT_10 = 'Etc/GMT-10',
  Etc_GMT_11 = 'Etc/GMT-11',
  Etc_GMT_12 = 'Etc/GMT-12',
  Etc_GMT_13 = 'Etc/GMT-13',
  Etc_GMT_14 = 'Etc/GMT-14',
  Etc_GMT_2 = 'Etc/GMT-2',
  Etc_GMT_3 = 'Etc/GMT-3',
  Etc_GMT_4 = 'Etc/GMT-4',
  Etc_GMT_5 = 'Etc/GMT-5',
  Etc_GMT_6 = 'Etc/GMT-6',
  Etc_GMT_7 = 'Etc/GMT-7',
  Etc_GMT_8 = 'Etc/GMT-8',
  Etc_GMT_9 = 'Etc/GMT-9',
  Etc_GMT0 = 'Etc/GMT0',
  Etc_Greenwich = 'Etc/Greenwich',
  Etc_UCT = 'Etc/UCT',
  Etc_UTC = 'Etc/UTC',
  Etc_Universal = 'Etc/Universal',
  Etc_Zulu = 'Etc/Zulu',
  Europe_Astrakhan = 'Europe/Astrakhan',
  Europe_Belfast = 'Europe/Belfast',
  Europe_Busingen = 'Europe/Busingen',
  Europe_Guernsey = 'Europe/Guernsey',
  Europe_Isle_of_Man = 'Europe/Isle_of_Man',
  Europe_Jersey = 'Europe/Jersey',
  Europe_Kirov = 'Europe/Kirov',
  Europe_Kyiv = 'Europe/Kyiv',
  Europe_Mariehamn = 'Europe/Mariehamn',
  Europe_Monaco = 'Europe/Monaco',
  Europe_Moscow = 'Europe/Moscow',
  Europe_Podgorica = 'Europe/Podgorica',
  Europe_San_Marino = 'Europe/San_Marino',
  Europe_Sarajevo = 'Europe/Sarajevo',
  Europe_Saratov = 'Europe/Saratov',
  Europe_Simferopol = 'Europe/Simferopol',
  Europe_Skopje = 'Europe/Skopje',
  Europe_Tiraspol = 'Europe/Tiraspol',
  Europe_Ulyanovsk = 'Europe/Ulyanovsk',
  Europe_Vatican = 'Europe/Vatican',
  Europe_Vilnius = 'Europe/Vilnius',
  Europe_Volgograd = 'Europe/Volgograd',
  Europe_Zaporozhye = 'Europe/Zaporozhye',
  GB = 'GB',
  GB_Eire = 'GB-Eire',
  GMT = 'GMT',
  GMTPlus0 = 'GMT+0',
  GMT_0 = 'GMT-0',
  GMT0 = 'GMT0',
  Greenwich = 'Greenwich',
  HST = 'HST',
  Hongkong = 'Hongkong',
  Iceland = 'Iceland',
  Indian_Antananarivo = 'Indian/Antananarivo',
  Indian_Chagos = 'Indian/Chagos',
  Indian_Christmas = 'Indian/Christmas',
  Indian_Cocos = 'Indian/Cocos',
  Indian_Comoro = 'Indian/Comoro',
  Indian_Kerguelen = 'Indian/Kerguelen',
  Indian_Mahe = 'Indian/Mahe',
  Indian_Maldives = 'Indian/Maldives',
  Indian_Mauritius = 'Indian/Mauritius',
  Indian_Mayotte = 'Indian/Mayotte',
  Indian_Reunion = 'Indian/Reunion',
  Iran = 'Iran',
  Israel = 'Israel',
  Jamaica = 'Jamaica',
  Japan = 'Japan',
  Kwajalein = 'Kwajalein',
  Libya = 'Libya',
  MET = 'MET',
  MST = 'MST',
  MST7MDT = 'MST7MDT',
  Mexico_BajaNorte = 'Mexico/BajaNorte',
  Mexico_BajaSur = 'Mexico/BajaSur',
  Mexico_General = 'Mexico/General',
  NZ = 'NZ',
  NZ_CHAT = 'NZ-CHAT',
  Navajo = 'Navajo',
  PRC = 'PRC',
  PST8PDT = 'PST8PDT',
  Pacific_Apia = 'Pacific/Apia',
  Pacific_Chuuk = 'Pacific/Chuuk',
  Pacific_Efate = 'Pacific/Efate',
  Pacific_Enderbury = 'Pacific/Enderbury',
  Pacific_Fakaofo = 'Pacific/Fakaofo',
  Pacific_Funafuti = 'Pacific/Funafuti',
  Pacific_Galapagos = 'Pacific/Galapagos',
  Pacific_Johnston = 'Pacific/Johnston',
  Pacific_Kanton = 'Pacific/Kanton',
  Pacific_Kiritimati = 'Pacific/Kiritimati',
  Pacific_Kosrae = 'Pacific/Kosrae',
  Pacific_Midway = 'Pacific/Midway',
  Pacific_Nauru = 'Pacific/Nauru',
  Pacific_Niue = 'Pacific/Niue',
  Pacific_Norfolk = 'Pacific/Norfolk',
  Pacific_Ponape = 'Pacific/Ponape',
  Pacific_Port_Moresby = 'Pacific/Port_Moresby',
  Pacific_Saipan = 'Pacific/Saipan',
  Pacific_Samoa = 'Pacific/Samoa',
  Pacific_Truk = 'Pacific/Truk',
  Pacific_Wake = 'Pacific/Wake',
  Pacific_Yap = 'Pacific/Yap',
  Poland = 'Poland',
  Portugal = 'Portugal',
  ROC = 'ROC',
  ROK = 'ROK',
  Singapore = 'Singapore',
  Turkey = 'Turkey',
  UCT = 'UCT',
  W_SU = 'W-SU',
  WET = 'WET',
}
export enum TitleCode {
  Mr_ = 'Mr.',
  Mrs_ = 'Mrs.',
  Ms_ = 'Ms.',
  Miss = 'Miss',
  Dr_ = 'Dr.',
  Prof_ = 'Prof.',
}
export enum ToolApprovalRequestPublicAvailable_override_scopes {
  once = 'once',
  session = 'session',
}
export enum ToolCallBlockKind {
  tool_call = 'tool_call',
}
export enum ToolCallBlockViewKind {
  tool_call = 'tool_call',
}
export enum ToolInputMergeSource_by_key {
  llm = 'llm',
  config = 'config',
}
export enum ToolResultBlockKind {
  tool_result = 'tool_result',
}
export enum ToolResultBlockViewKind {
  tool_result = 'tool_result',
}
export enum ToolWaitRecordStatus {
  pending = 'pending',
  resolved = 'resolved',
  timed_out = 'timed_out',
  failed = 'failed',
  cancelled = 'cancelled',
}
export enum TranScriptServerHost {
  CLOUD = 'CLOUD',
  ON_PREMISE = 'ON_PREMISE',
  SELF_HOSTED = 'SELF_HOSTED',
}
export enum TransactionSource {
  initial = 'initial',
  topup = 'topup',
  scheduled = 'scheduled',
  reset = 'reset',
  refund = 'refund',
  expire = 'expire',
  clawback = 'clawback',
  adjust = 'adjust',
  consumption = 'consumption',
}
export enum TransactionType {
  credit = 'credit',
  debit = 'debit',
}
export enum TranscribeMode {
  TRANSCRIBE = 'TRANSCRIBE',
  DICTATE = 'DICTATE',
  TELEHEALTH = 'TELEHEALTH',
}
export enum TranscriberConfigForInternalAdmin {
  Whisper_whisper_1 = 'Whisper:whisper-1',
  Gemini_flash_1_5 = 'Gemini:flash-1.5',
  Deepgram_nova_2_medical = 'Deepgram:nova-2-medical',
  Deepgram_nova_2_heidihealth_farfield_v4 = 'Deepgram:nova-2-heidihealth_farfield_v4',
  Deepgram_nova_2 = 'Deepgram:nova-2',
  Deepgram_nova_3 = 'Deepgram:nova-3',
}
export enum TranscriptInUse {
  user_uploaded = 'user_uploaded',
  live = 'live',
  backup = 'backup',
}
export enum TranscriptServiceProvider {
  AWS = 'AWS',
  DEEPGRAM = 'DEEPGRAM',
}
export enum TranscriptSource {
  STREAMING = 'STREAMING',
  PRERECORDED = 'PRERECORDED',
}
export enum TranscriptionFeedbackStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
  LOW_CONFIDENCE = 'LOW_CONFIDENCE',
}
export enum TransitionParam {
  prepared = 'prepared',
  shipped = 'shipped',
}
export enum TranslationModel {
  FAST = 'FAST',
  BEST = 'BEST',
}
export enum TranslatorAudioKind {
  mic = 'mic',
  tts = 'tts',
}
export enum TriggerMigrationResponseEngine {
  airflow = 'airflow',
  temporal = 'temporal',
}
export enum TriggeringCodeModelAuthor_acuity_hintAnyOf0 {
  acute = 'acute',
  chronic = 'chronic',
  unspecified = 'unspecified',
}
export enum TutorialSteps {
  SIGN_UP = 'SIGN_UP',
  ORGANISATION = 'ORGANISATION',
  SESSION = 'SESSION',
  NOTE = 'NOTE',
  TEMPLATE = 'TEMPLATE',
  DOCUMENT = 'DOCUMENT',
  CUSTOM_TEMPLATE = 'CUSTOM_TEMPLATE',
}
export enum TypeRestfulInteraction {
  read = 'read',
  vread = 'vread',
  update = 'update',
  patch = 'patch',
  delete = 'delete',
  history_instance = 'history-instance',
  history_type = 'history-type',
  create = 'create',
  search_type = 'search-type',
}
export enum UnitsOfTime {
  s = 's',
  min = 'min',
  h = 'h',
  d = 'd',
  wk = 'wk',
  mo = 'mo',
  a = 'a',
}
export enum UpdateCatalogProductRequestAggregation_modeAnyOf0 {
  sum = 'sum',
  tally = 'tally',
}
export enum UpdateCatalogProductRequestSum_fieldAnyOf0 {
  quantity = 'quantity',
  token_count = 'token_count',
}
export enum UpdateConversationRequestStatusAnyOf0 {
  open = 'open',
  resolved = 'resolved',
}
export enum UpdateConversationRequestModeAnyOf0 {
  ai = 'ai',
  staff = 'staff',
}
export enum UpdateLimitAssignmentRequestModeAnyOf0 {
  enroll = 'enroll',
  exclude = 'exclude',
}
export enum UpdateRepeatReviewStatusRequestStatus {
  pending_review = 'pending_review',
  processing = 'processing',
  approved = 'approved',
  blocked = 'blocked',
}
export enum UploadedDocumentStatus {
  PROCESSING = 'PROCESSING',
  READY_TO_USE = 'READY_TO_USE',
}
export enum UsageOutcome {
  success = 'success',
  incomplete = 'incomplete',
  failure = 'failure',
  terminated = 'terminated',
}
export enum UserActivityAction {
  consult_note_generated = 'consult_note_generated',
  custom_template_used = 'custom_template_used',
  evidence_chat_query = 'evidence_chat_query',
  evidence_source_control = 'evidence_source_control',
}
export enum UserDeleteReason {
  Leaving_current_role = 'Leaving current role',
  Switching_to_another_product = 'Switching to another product',
  No_longer_want_to_use_an_AI_scribe = 'No longer want to use an AI scribe',
  Too_expensive = 'Too expensive',
  Unsatisfied_with_the_experience = 'Unsatisfied with the experience',
  Other = 'Other',
}
export enum UserDocumentResponseSource {
  user = 'user',
  sharepoint = 'sharepoint',
}
export enum UserDocumentResponseDocument_kind {
  input = 'input',
  artifact = 'artifact',
  workflow_context = 'workflow_context',
}
export enum UserFriendlyNoteFailedReason {
  transcript_too_short = 'transcript_too_short',
  transcript_available_but_note_generation_failed = 'transcript_available_but_note_generation_failed',
  transcript_not_available = 'transcript_not_available',
  llm_errored_during_streaming = 'llm_errored_during_streaming',
  unexpected_error = 'unexpected_error',
}
export enum UserJourney {
  ONBOARDING = 'ONBOARDING',
}
export enum UserOrderBy {
  email = 'email',
  created_at = 'created_at',
}
export enum UserRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}
export enum UserSelfServiceAuditEvent {
  user_self_logout_everywhere = 'user_self_logout_everywhere',
}
export enum ValidRegionSyncCollectionTypes {
  specialty = 'specialty',
  system_template = 'system_template',
  language = 'language',
  SpecialtyGroup = 'SpecialtyGroup',
}
export enum VerifyNumberConfirmRequestVerification_methodAnyOf0 {
  call = 'call',
  sms = 'sms',
}
export enum VerifyNumberStartRequestVerification_method {
  call = 'call',
  sms = 'sms',
}
export enum VersionType {
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  PATCH = 'PATCH',
}
export enum VoiceStyle {
  BRIEF = 'BRIEF',
  GOLDILOCKS = 'GOLDILOCKS',
  DETAILED = 'DETAILED',
  MY_VOICE = 'MY_VOICE',
  SUPER_DETAILED = 'SUPER_DETAILED',
}
export enum WaitVerdict {
  accept = 'accept',
  deny = 'deny',
}
export enum WalletTransactionResponseAggregation_modeAnyOf0 {
  sum = 'sum',
  tally = 'tally',
}
export enum WalletTransactionResponseSum_fieldAnyOf0 {
  quantity = 'quantity',
  token_count = 'token_count',
}
export enum WebAppType {
  Web = 'Web',
}
export enum WeeklyFrequencyKind {
  weekly = 'weekly',
}
export enum WidgetQuotaType {
  NOTE_PUSH = 'NOTE_PUSH',
}
export enum WorkflowArtifactRefType {
  template = 'template',
  form_template = 'form_template',
  session = 'session',
  patient = 'patient',
  document = 'document',
}
export enum WorkflowEvalMetricUnit {
  count = 'count',
  percent = 'percent',
}
export enum WorkflowEvalMetricSource {
  system = 'system',
  custom = 'custom',
  admin = 'admin',
}
export enum WorkflowResponseSource {
  instructed = 'instructed',
  recorded = 'recorded',
}
export enum WorkflowResponseProduct_surface {
  work = 'work',
  studio = 'studio',
}
export enum WorkflowRunDayOfWeekBucketDay {
  mon = 'mon',
  tue = 'tue',
  wed = 'wed',
  thu = 'thu',
  fri = 'fri',
  sat = 'sat',
  sun = 'sun',
}
export enum WorkflowRunDurationByOutcomeOutcome {
  running = 'running',
  success = 'success',
  failed = 'failed',
}
export enum WorkflowRunOutcomeBucketOutcome {
  running = 'running',
  success = 'success',
  failed = 'failed',
}
export enum WorkflowRunResponseStatusAnyOf0 {
  running = 'running',
  closed = 'closed',
  failed = 'failed',
}
export enum WorkflowRunResponseOutcomeAnyOf0 {
  running = 'running',
  success = 'success',
  failed = 'failed',
}
export enum WorkflowRunResponseTrigger_typeAnyOf0 {
  on_demand = 'on_demand',
  schedule = 'schedule',
  event_rule = 'event_rule',
}
export enum WorkflowSetupFieldKind {
  text = 'text',
  select = 'select',
  multiselect = 'multiselect',
  template = 'template',
  templates = 'templates',
  form_template = 'form_template',
  form_templates = 'form_templates',
}
export enum WorkflowTemplateResponseSource {
  instructed = 'instructed',
  recorded = 'recorded',
}
export enum WorkflowTriggerRefType {
  on_demand = 'on_demand',
  schedule = 'schedule',
  event_rule = 'event_rule',
}
export enum WorkspaceOrderBy {
  member_count = 'member_count',
  name = 'name',
}
export enum WorkspaceRealignStatusResponseStatus {
  running = 'running',
  succeeded = 'succeeded',
  failed = 'failed',
  terminated = 'terminated',
  timed_out = 'timed_out',
}
export enum WorkspaceRecordingContextState {
  idle = 'idle',
  recording = 'recording',
  paused = 'paused',
}
export enum WorkspaceRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}
export enum Apis__v2__internal_admin__orders__orders_schema__SortOrder {
  asc = 'asc',
  desc = 'desc',
}
export enum Dataclass__nebula_session__generated_data__note_section__NoteSectionType {
  notesection = 'notesection',
}
export enum Domains__coding__pkg__enums__CodeSystem {
  snomed_uk = 'snomed_uk',
  icd_10_cm = 'icd_10_cm',
  icd_9_cm = 'icd_9_cm',
  icd_9_ca = 'icd_9_ca',
  icd_10_uk = 'icd_10_uk',
  mbs_au = 'mbs_au',
  opcs410_uk = 'opcs410_uk',
  icd_10_am = 'icd_10_am',
  achi_13_au = 'achi_13_au',
  cpt_2025 = 'cpt_2025',
  cpt_2026 = 'cpt_2026',
  icd_10_gm = 'icd_10_gm',
  cim_10_fr = 'cim_10_fr',
  cie_10_es = 'cie_10_es',
  icd_10_za = 'icd_10_za',
  orpha = 'orpha',
  cim_10_mc = 'cim_10_mc',
  cim_10_scp = 'cim_10_scp',
  ohip_dx = 'ohip_dx',
  cpt_qa = 'cpt_qa',
  icd_10_qa = 'icd_10_qa',
  icd_10_it = 'icd_10_it',
  e_m = 'e_m',
}
export enum Domains__translator__models__enums__Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
}
export enum Pkg__agent_harness__core__config__AgentConfigReasoning_effortAnyOf0 {
  low = 'low',
  medium = 'medium',
  high = 'high',
  xhigh = 'xhigh',
  max = 'max',
}
export enum Pkg__agent_harness__core__config__AgentConfigCache_strategy {
  off = 'off',
  system_and_tools = 'system_and_tools',
}
export enum Pkg__agent_harness__core__llm_contracts__MessageRole {
  user = 'user',
  assistant = 'assistant',
}
export enum Pkg__ehr__third_party_ambient_audio__haiku__models__note_sections__NoteSection {
  Value10164_2 = '10164-2',
  Value29545_1 = '29545-1',
  Value30954_2 = '30954-2',
  Value51847_2 = '51847-2',
  Value86467_8 = '86467-8',
  Value96335_5 = '96335-5',
}
export enum Pkg__event_triggers__schemas__EventRuleResponseScope_type {
  user = 'user',
  team = 'team',
  org = 'org',
}
export enum AgentEvalBindingDescriptorResponseKind {
  coded = 'coded',
  saved_config = 'saved_config',
  routine = 'routine',
}
export enum AgentEvalBundleMetricResponseApplicability {
  offline = 'offline',
  live = 'live',
  both = 'both',
}
export enum AgentEvalExperimentDetailResponseStatus {
  planned = 'planned',
  complete = 'complete',
}
export enum AgentEvalExperimentSummaryResponseStatus {
  planned = 'planned',
  complete = 'complete',
}
export enum AgentEvalPassWhenResponseOp {
  gte = 'gte',
  lte = 'lte',
}
export enum AgentEvalScorerManifestEntryResponseApplicabilityAnyOf0 {
  offline = 'offline',
  live = 'live',
  both = 'both',
}
export enum AgentRunScoreResponseSource_kind {
  experiment = 'experiment',
  dataset_run = 'dataset_run',
  rolling_sweep = 'rolling_sweep',
}
export enum AllowancePeriod {
  monthly = 'monthly',
}
export enum ApprovalMode {
  auto = 'auto',
  manual = 'manual',
}
export enum AsserterRole {
  patient = 'patient',
  clinician = 'clinician',
  staff = 'staff',
  caregiver = 'caregiver',
  external_record = 'external_record',
  unknown_speaker = 'unknown_speaker',
}
export enum Assertion {
  present = 'present',
  absent = 'absent',
  possible = 'possible',
}
export enum AssistantMessageArtifactPayloadType {
  assistant_message = 'assistant_message',
}
export enum AutoLinkDecisionLabel {
  skip_not_no_action = 'skip_not_no_action',
  auto_linked = 'auto_linked',
  no_merge_opportunity = 'no_merge_opportunity',
  not_enough_evidence = 'not_enough_evidence',
  ambiguous_tie = 'ambiguous_tie',
  ambiguous_second_match = 'ambiguous_second_match',
  pending_patient_link = 'pending_patient_link',
  no_candidates = 'no_candidates',
}
export enum AxSelectorMatchMode {
  exact = 'exact',
  contains = 'contains',
}
export enum BillingSeatType {
  STANDARD = 'STANDARD',
  MAX = 'MAX',
}
export enum BooleanValueType {
  boolean = 'boolean',
}
export enum BulkAccessEntitlementRequestTarget_type {
  user = 'user',
  team = 'team',
  organisation = 'organisation',
}
export enum BulkAccessEntitlementResultTarget_type {
  user = 'user',
  team = 'team',
  organisation = 'organisation',
}
export enum BulkAccessEntitlementResultStatus {
  preview = 'preview',
  succeeded = 'succeeded',
  skipped = 'skipped',
  failed = 'failed',
}
export enum CancellationOfferOutcome {
  accepted = 'accepted',
  declined = 'declined',
}
export enum CancellationOfferType {
  discount = 'discount',
  clinician_session = 'clinician_session',
}
export enum CancellationReason {
  too_expensive = 'too_expensive',
  need_more_features = 'need_more_features',
  found_alternative = 'found_alternative',
  no_longer_need = 'no_longer_need',
  other = 'other',
}
export enum CheckStatus {
  agrees = 'agrees',
  conflicts = 'conflicts',
  unknown = 'unknown',
  not_applicable = 'not_applicable',
}
export enum CheckboxTargetKind {
  checkbox = 'checkbox',
}
export enum ClinicalComparisonVerdict {
  agrees = 'agrees',
  contradicts = 'contradicts',
  no_data_to_compare = 'no_data_to_compare',
}
export enum CodeDefinedDatasetKind {
  code_defined = 'code_defined',
}
export enum CodedValueType {
  coded = 'coded',
}
export enum CompactionMarkerArtifactPayloadType {
  compaction_marker = 'compaction_marker',
}
export enum Comparator {
  '<' = '<',
  '<=' = '<=',
  '>=' = '>=',
  '>' = '>',
}
export enum ContractStatus {
  active = 'active',
  archived = 'archived',
}
export enum CuaCloudMachineStatus {
  provisioning = 'provisioning',
  ready = 'ready',
  failed = 'failed',
}
export enum DateValueType {
  date = 'date',
}
export enum DictationDetailFailedEventEvent_type {
  chunk_failed = 'chunk_failed',
}
export enum DictationDetailLowConfidenceEventEvent_type {
  chunk_low_confidence = 'chunk_low_confidence',
}
export enum DictationDetailSuccessfulEventEvent_type {
  chunk_transcribed = 'chunk_transcribed',
}
export enum DisplayLocale {
  en = 'en',
  ar_SA = 'ar-SA',
  ca_ES = 'ca-ES',
  da_DK = 'da-DK',
  de_DE = 'de-DE',
  es_ES = 'es-ES',
  fi_FI = 'fi-FI',
  fr_FR = 'fr-FR',
  it_IT = 'it-IT',
  ja_JP = 'ja-JP',
  ko_KR = 'ko-KR',
  nl_NL = 'nl-NL',
  nb_NO = 'nb-NO',
  pl_PL = 'pl-PL',
  pt_PT = 'pt-PT',
  sv_SE = 'sv-SE',
  zh_CN = 'zh-CN',
  zh_TW = 'zh-TW',
}
export enum DropdownTargetKind {
  dropdown = 'dropdown',
}
export enum EpisodeLifecycle {
  open = 'open',
  review = 'review',
  closed = 'closed',
  expired = 'expired',
}
export enum EvidenceChatLineageCampaignOperation {
  audit = 'audit',
  backfill = 'backfill',
}
export enum EvidenceChatLineageCampaignPhase {
  initial_audit = 'initial_audit',
  dry_run = 'dry_run',
  write = 'write',
  final_audit = 'final_audit',
}
export enum EvidenceChatLineageCampaignStatus {
  running = 'running',
  advancing = 'advancing',
  halted = 'halted',
  completed = 'completed',
  failed = 'failed',
}
export enum EvidenceState {
  supports = 'supports',
  ambiguous = 'ambiguous',
  conflicts = 'conflicts',
  rejected = 'rejected',
}
export enum FactKind {
  demographic = 'demographic',
  condition = 'condition',
  symptom = 'symptom',
  medication = 'medication',
  otc_or_supplement = 'otc_or_supplement',
  dispense_event = 'dispense_event',
  adherence_signal = 'adherence_signal',
  side_effect = 'side_effect',
  allergy = 'allergy',
  lab_or_vital = 'lab_or_vital',
  procedure = 'procedure',
  immunization = 'immunization',
  social_history = 'social_history',
  family_history = 'family_history',
  patient_goal = 'patient_goal',
  consent = 'consent',
  care_plan = 'care_plan',
  clinical_intervention = 'clinical_intervention',
  coverage = 'coverage',
  eligibility = 'eligibility',
}
export enum FormFormat {
  pdf = 'pdf',
  xml = 'xml',
  json = 'json',
  xfa_pdf = 'xfa_pdf',
}
export enum FrozenLlmTransportProvider {
  anthropic = 'anthropic',
  bedrock = 'bedrock',
}
export enum HcpVerificationStatus {
  VERIFIED = 'VERIFIED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  REJECTED = 'REJECTED',
}
export enum JudgeMemberResultDocOutcome {
  ok = 'ok',
  error = 'error',
  empty = 'empty',
  mismatch = 'mismatch',
  family_excluded = 'family_excluded',
}
export enum LLMProviders {
  openai = 'openai',
  azure = 'azure',
  anthropic = 'anthropic',
  gcp = 'gcp',
  self_finetuned = 'self_finetuned',
  parsed = 'parsed',
  grok = 'grok',
}
export enum MappingSource {
  template_mapping = 'template_mapping',
}
export enum MeasureReportStatus {
  complete = 'complete',
  pending = 'pending',
  error = 'error',
}
export enum MeasureReportType {
  individual = 'individual',
  subject_list = 'subject-list',
  summary = 'summary',
  data_collection = 'data-collection',
}
export enum MigrationStatus {
  ready = 'ready',
  needs_headings = 'needs_headings',
  needs_linking = 'needs_linking',
  needs_engineering = 'needs_engineering',
}
export enum OnlineDatasetKind {
  online = 'online',
}
export enum OverallAssessment {
  at_standard = 'at_standard',
  below_standard = 'below_standard',
}
export enum ProjectSourceCitationKind {
  consult_note = 'consult_note',
  transcript = 'transcript',
}
export enum Purpose {
  clinical_nudge = 'clinical_nudge',
  form_filling = 'form_filling',
  coding_cdi = 'coding_cdi',
}
export enum Qualifier {
  body_site = 'body_site',
  laterality = 'laterality',
  type_or_subtype = 'type_or_subtype',
  acuity = 'acuity',
  severity = 'severity',
  grade = 'grade',
  stage = 'stage',
  episode_of_care = 'episode_of_care',
  formulation = 'formulation',
  route = 'route',
  dose = 'dose',
  frequency = 'frequency',
  duration = 'duration',
  indication = 'indication',
  complication = 'complication',
}
export enum QuantityValueType {
  quantity = 'quantity',
}
export enum RadioTargetKind {
  radio = 'radio',
}
export enum RangeValueType {
  range = 'range',
}
export enum RecordCancellationIntentResponseProduct_type {
  scribe = 'scribe',
  evidence = 'evidence',
}
export enum RecordState {
  active = 'active',
  superseded = 'superseded',
  retracted = 'retracted',
}
export enum RegistryLookupOutcome {
  ACTIVE_INDIVIDUAL = 'ACTIVE_INDIVIDUAL',
  ACTIVE_ORGANISATION = 'ACTIVE_ORGANISATION',
  DEACTIVATED = 'DEACTIVATED',
  NOT_FOUND = 'NOT_FOUND',
}
export enum RelationshipType {
  indication_for = 'indication_for',
}
export enum RequestIntent {
  proposal = 'proposal',
  plan = 'plan',
  directive = 'directive',
  order = 'order',
  original_order = 'original-order',
  reflex_order = 'reflex-order',
  filler_order = 'filler-order',
  instance_order = 'instance-order',
  option = 'option',
}
export enum RequestStatus {
  draft = 'draft',
  active = 'active',
  on_hold = 'on-hold',
  revoked = 'revoked',
  completed = 'completed',
  entered_in_error = 'entered-in-error',
  unknown = 'unknown',
}
export enum ReviewReason {
  IDENTIFIER_ALREADY_CLAIMED = 'IDENTIFIER_ALREADY_CLAIMED',
  NO_IDENTIFIER = 'NO_IDENTIFIER',
  NOT_FOUND = 'NOT_FOUND',
  DEACTIVATED = 'DEACTIVATED',
}
export enum SavedDatasetKind {
  saved = 'saved',
}
export enum ScenarioAction {
  set = 'set',
  check = 'check',
  reset = 'reset',
}
export enum ScenarioLifecycleStatus {
  ABSENT = 'ABSENT',
  PENDING = 'PENDING',
  READY = 'READY',
  FAILED = 'FAILED',
}
export enum ScoreDocOutcome {
  scored = 'scored',
  error = 'error',
  not_applicable = 'not_applicable',
  missing_reference = 'missing_reference',
}
export enum ScriptClassificationScope {
  cross_workspace = 'cross-workspace',
  per_target = 'per-target',
}
export enum SessionMergeGroupInspectionRole {
  group = 'group',
  member = 'member',
  ungrouped = 'ungrouped',
}
export enum SnomedTraceVerdict {
  verified = 'verified',
  conflicting = 'conflicting',
  needs_review = 'needs_review',
  not_found = 'not_found',
  not_applicable = 'not_applicable',
}
export enum SourceKind {
  transcript = 'transcript',
  current_context = 'current_context',
  context_document = 'context_document',
  patient_document = 'patient_document',
  prior_note = 'prior_note',
  patient_info = 'patient_info',
  clinician_info = 'clinician_info',
  note = 'note',
}
export enum SubjectKind {
  patient = 'patient',
  relative = 'relative',
}
export enum Temporality {
  current = 'current',
  historical = 'historical',
  planned = 'planned',
  resolved = 'resolved',
  unspecified = 'unspecified',
}
export enum TerminologySystem {
  icd_10_cm = 'icd_10_cm',
  cpt_category_i = 'cpt_category_i',
  rxnorm = 'rxnorm',
  loinc = 'loinc',
  cvx = 'cvx',
  snomed_ct = 'snomed_ct',
}
export enum TextValueType {
  text = 'text',
}
export enum ToolExecutionArtifactPayloadType {
  tool_execution = 'tool_execution',
}
export enum ToolExecutionArtifactPayloadStatus {
  completed = 'completed',
  failed = 'failed',
  denied = 'denied',
  timed_out = 'timed_out',
  cancelled = 'cancelled',
}
export enum ToolExecutionArtifactPayloadTerminal_outcomeAnyOf0 {
  succeeded = 'succeeded',
  blocked = 'blocked',
  failed = 'failed',
}
export enum TranscriptMatchCandidateKind {
  patient_profile = 'patient_profile',
  appointment = 'appointment',
}
export enum TurnTerminationArtifactPayloadType {
  turn_termination = 'turn_termination',
}
export enum TurnTerminationArtifactPayloadDisposition {
  cancelled = 'cancelled',
  failed = 'failed',
}
export enum UserMessageArtifactPayloadType {
  user_message = 'user_message',
}
export enum VerificationRegistry {
  NPPES = 'NPPES',
  MANUAL_REVIEW = 'MANUAL_REVIEW',
}
export enum VerificationState {
  machine_extracted = 'machine_extracted',
  staff_entered = 'staff_entered',
  clinician_reviewed = 'clinician_reviewed',
}
export enum VerifyLiteStatus {
  pending = 'pending',
  complete = 'complete',
  failed = 'failed',
}
export enum Domains__access_entitlements__schemas__SourceType {
  organization = 'organization',
  team = 'team',
  user = 'user',
}
export enum Domains__patient_digital_twin__sources__types__SourceType {
  transcript = 'transcript',
  structured_record = 'structured_record',
  context_document = 'context_document',
  confirmed_human_input = 'confirmed_human_input',
}
export enum Shared__enums__enums__Gender {
  male = 'male',
  female = 'female',
  other = 'other',
  unknown = 'unknown',
}
export enum Shared__enums__enums__Period {
  ONE_MONTH = 'ONE_MONTH',
  ONE_QUARTER = 'ONE_QUARTER',
  ONE_YEAR = 'ONE_YEAR',
}
export enum Shared__enums__enums__SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
